export const dataApi = {
  nhits: 3923,
  parameters: {
    dataset: '244400404_collection-vegetale-nantes',
    timezone: 'UTC',
    rows: 3923,
    start: 0,
    format: 'json',
    facet: ['famille', 'genre', 'nom_du_site', 'espece'],
  },
  records: [
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '33ed6720a4fec83e401390ec5fb67d4ec7bdd9c4',
      fields: {
        espece: 'turbinata',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 176, 139, 1.00)',
            'rgba(82, 110, 65, 1.00)',
            'rgba(72, 97, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus turbinata/aesculus turbinata (18).jpg',
          width: 1024,
          id: '43df5293d7f66736828525a423199987',
          height: 683,
          thumbnail: true,
        },
        location: [47.270652, -1.580253],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580253, 47.270652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9e18db93a75100d87072127c092575ccd5f596f4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x carnea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 131, 96, 1.00)',
            'rgba(141, 116, 85, 1.00)',
            'rgba(89, 98, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus x carnea/aesculus x carnea (1).jpg',
          width: 576,
          id: '9e5db35a55a76501d88085a1261e94c2',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 131, 64, 1.00)',
            'rgba(113, 153, 77, 1.00)',
            'rgba(82, 111, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus x carnea/aesculus x carnea (2).jpg',
          width: 576,
          id: '052335433227cadbd7d38d049ec98dab',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 122, 99, 1.00)',
            'rgba(151, 115, 94, 1.00)',
            'rgba(132, 112, 90, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus x carnea/aesculus x carnea  (2).jpg',
          width: 576,
          id: '0d0fe1c4c1cb8615034fe9ca9aab9fc1',
          height: 768,
          thumbnail: true,
        },
        location: [47.269163, -1.582078],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582078, 47.269163] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1dd6ce6940832c70c97393180cab27720d32ce3b',
      fields: {
        espece: 'glabra',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 101, 155, 1.00)',
            'rgba(102, 126, 156, 1.00)',
            'rgba(92, 106, 104, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/aesculus [sapindaceae]/aesculus glabra/aesculus glabra (9).jpg',
          width: 1024,
          id: '8d7b4a33559c7292d240e2075d3a31d1',
          height: 683,
          thumbnail: true,
        },
        location: [47.261921, -1.534773],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534773, 47.261921] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '30c2a694daa08d7363cc06c975d1fc3494913398',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'bipinnata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(186, 172, 127, 1.00)',
            'rgba(104, 93, 35, 1.00)',
            'rgba(66, 62, 36, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/koelreuteria [sapindaceae]/koelreuteria bipinnata/koelreuteria bipinnata (23).jpg',
          width: 562,
          id: '8624013f766607a736534ae3616ef586',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 138, 122, 1.00)',
            'rgba(94, 89, 45, 1.00)',
            'rgba(62, 56, 34, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/koelreuteria [sapindaceae]/koelreuteria bipinnata/koelreuteria bipinnata (24).jpg',
          width: 589,
          id: '1d0072e25cb022f1c324c31e774affcc',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 164, 180, 1.00)',
            'rgba(108, 111, 71, 1.00)',
            'rgba(73, 72, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/koelreuteria [sapindaceae]/koelreuteria bipinnata/koelreuteria bipinnata (2).jpg',
          width: 1024,
          id: '27951b2c4fa63b493c2ea794a4365d8b',
          height: 683,
          thumbnail: true,
        },
        location: [47.270775, -1.580867],
        genre: 'Koelreuteria',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580867, 47.270775] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '770a3422810693f5ecf454fec5a8e17e68dd7cb0',
      fields: {
        origine: 'Arb.U.Seatlle (U.S.A.)',
        espece: 'menziesii Torr.& A.Gray.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Tolmeia',
        date_plantation: '2000',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '56bf3d1db7af5ac08a2afa65e26b85f4f57acee7',
      fields: {
        origine: 'JB.Yakut (Russie)',
        espece: 'crassifolia Fritsch',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Bergenia',
        date_plantation: '2006',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0b5a76b82b6a71f9b94640d4d37a20492e6000b1',
      fields: {
        espece: 'anisatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 128, 49, 1.00)',
            'rgba(110, 156, 48, 1.00)',
            'rgba(99, 142, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/illicium [schisandraceae]/illicium anisatum/illicium anisatum (4).jpg',
          width: 576,
          id: '525ef1600b649c2a81e20e013405eb35',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 123, 51, 1.00)',
            'rgba(89, 118, 51, 1.00)',
            'rgba(75, 117, 40, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/illicium [schisandraceae]/illicium anisatum/illicium anisatum (3).jpg',
          width: 576,
          id: 'e09095ba2acd079075add32a741895f9',
          height: 768,
          thumbnail: true,
        },
        location: [47.269938, -1.581792],
        genre: 'Illicium',
        famille: 'Schisandraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581792, 47.269938] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '76759d4d1fc1bc5f082c9ae8a62085dc3d80d913',
      fields: {
        espece: 'anisatum',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 132, 85, 1.00)',
            'rgba(116, 118, 51, 1.00)',
            'rgba(74, 84, 31, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/illicium [schisandraceae]/illicium anisatum/illicium anisatum (5).jpg',
          width: 1024,
          id: '73dd38c4fe49f036667dbf2c9d6a8a6a',
          height: 683,
          thumbnail: true,
        },
        location: [47.269989, -1.58162],
        genre: 'Illicium',
        famille: 'Schisandraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58162, 47.269989] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c80800796de38125dc371d30f24cb832ab6509f3',
      fields: {
        origine: 'R\u00e9colte nature (WLG-PF)',
        espece: 'umbrosa Dumort.',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Scrophularia',
        date_plantation: '2016',
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c86a7ca483b6ede359fa25c87f021b0a298dbc94',
      fields: {
        espece: 'giraldii',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Ailanthus',
        date_plantation: '1973',
        famille: 'Simaroubaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3ae1c705c8b6e85aeffcb2b92a2f8ea9e42a2f88',
      fields: {
        origine: "Particulier - Jardin \u00e0 l'\u00eele de la R\u00e9union",
        espece: 'mauritianum',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Solanum',
        date_plantation: '2014',
        famille: 'Solanaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '586ea7fd392daf585114643bf5e0e27329c7f4a9',
      fields: {
        espece: 'integrifolia Lam.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Jaborosa',
        date_plantation: '1973',
        famille: 'Solanaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd0aa7415ddaba01341115fb92f44ebc9fca9e246',
      fields: {
        espece: 'carolina  Monticola Group',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 122, 53, 1.00)',
            'rgba(133, 142, 66, 1.00)',
            'rgba(105, 105, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/halesia [styracaceae]/halesia carolina  monticola group/halesia carolina monticola group (2).jpg',
          width: 576,
          id: '0a9137869b24dfc94b26c9d3e2dbba7d',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 157, 44, 1.00)',
            'rgba(130, 156, 39, 1.00)',
            'rgba(130, 125, 71, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/halesia [styracaceae]/halesia carolina  monticola group/halesia carolina monticola group (1).jpg',
          width: 576,
          id: '8a9f8e16cc0e9ac1e01e966c3344afce',
          height: 768,
          thumbnail: true,
        },
        location: [47.270487, -1.58205],
        genre: 'Halesia',
        famille: 'Styracaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58205, 47.270487] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3faf21d2edb329ba40109b1a6b1ff128427b2ddc',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'diptera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 87, 39, 1.00)',
            'rgba(107, 118, 82, 1.00)',
            'rgba(84, 87, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/halesia [styracaceae]/halesia diptera/halesia diptera  (2).jpg',
          width: 1024,
          id: '5d8abb625e66f2eb1144ea17b126ea39',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 127, 83, 1.00)',
            'rgba(107, 120, 80, 1.00)',
            'rgba(86, 95, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/halesia [styracaceae]/halesia diptera/halesia diptera (2).jpg',
          width: 576,
          id: '8f0a62cccbb92c6a5c8fe3a50867c949',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 183, 151, 1.00)',
            'rgba(74, 96, 50, 1.00)',
            'rgba(49, 59, 29, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/halesia [styracaceae]/halesia diptera/halesia diptera  (1).jpg',
          width: 512,
          id: '966c6045e0c5e9328f809f2b96582f49',
          height: 768,
          thumbnail: true,
        },
        location: [47.270908, -1.582855],
        genre: 'Halesia',
        famille: 'Styracaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582855, 47.270908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6c3ea86e76c1685f085c4d576151394f5ea6b41d',
      fields: {
        espece: 'dasyanthus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 122, 62, 1.00)',
            'rgba(120, 131, 112, 1.00)',
            'rgba(117, 118, 117, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/styrax [styracaceae]/styrax dasyanthus/styrax dasyanthus (2).jpg',
          width: 576,
          id: '870dffa154df858dea602e51de6da7ec',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 137, 109, 1.00)',
            'rgba(117, 155, 92, 1.00)',
            'rgba(103, 144, 51, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/styrax [styracaceae]/styrax dasyanthus/styrax dasyanthus (1).jpg',
          width: 576,
          id: '09a947a7cdfd4f4f5efa05b3b547ce26',
          height: 768,
          thumbnail: true,
        },
        location: [47.270828, -1.584275],
        genre: 'Styrax',
        famille: 'Styracaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584275, 47.270828] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0b04525e4c45fc27d08e3cd772efe9e72f4e03c3',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 76, 64, 1.00)',
            'rgba(154, 93, 105, 1.00)',
            'rgba(115, 77, 81, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'leonard messel'/camellia 'leonard messel' (2).jpg",
          width: 835,
          id: 'd40e233ec5e86d8859b2f56df2c9d237',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 68, 87, 1.00)',
            'rgba(146, 73, 90, 1.00)',
            'rgba(135, 70, 93, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'leonard messel'/camellia 'leonard messel' (3).jpg",
          width: 1024,
          id: 'b086dfef443050ca1bead4f37ca7edc1',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 154, 139, 1.00)',
            'rgba(99, 97, 65, 1.00)',
            'rgba(106, 100, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'leonard messel'/camellia 'leonard messel' (1).jpg",
          width: 1024,
          id: 'da2d471d0223a6f1f8faefa2a567c398',
          height: 683,
          thumbnail: true,
        },
        location: [47.269522, -1.584488],
        genre: 'Camellia',
        cultivar: 'Leonard Messel',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584488, 47.269522] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '92ac603ed790b1e096c5efd256703fda80dd4625',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'chekiangoleosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 98, 90, 1.00)',
            'rgba(102, 110, 78, 1.00)',
            'rgba(76, 92, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia chekiangoleosa/camellia chekiangoleosa (2).jpg',
          width: 1024,
          id: 'a12ba37ff20236eb2aba8d2f5db5b0d6',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 108, 92, 1.00)',
            'rgba(106, 66, 63, 1.00)',
            'rgba(87, 53, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia chekiangoleosa/camellia chekiangoleosa (4).jpg',
          width: 1024,
          id: 'ae5ec615832042623d382ccd1b77e784',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 92, 84, 1.00)',
            'rgba(94, 105, 92, 1.00)',
            'rgba(80, 97, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia chekiangoleosa/camellia chekiangoleosa (1).jpg',
          width: 1024,
          id: '80cbb365f774a47d8ecc2e810b2562e1',
          height: 683,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd945fd81debe33a294e7c597fefa13b3f58ac47b',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 150, 152, 1.00)',
            'rgba(74, 76, 54, 1.00)',
            'rgba(102, 80, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'adolphe audusson'/camellia japonica 'adolphe audusson'.jpg",
          width: 512,
          id: 'f621ff2bef4764871d8a9e0f73646243',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 61, 51, 1.00)',
            'rgba(126, 52, 63, 1.00)',
            'rgba(93, 48, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'adolphe audusson'/camellia japonica 'adolphe audusson' (2).jpg",
          width: 1024,
          id: '5d8283ed92632d43e2ab3b73f2f02e56',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 72, 67, 1.00)',
            'rgba(104, 34, 45, 1.00)',
            'rgba(100, 46, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'adolphe audusson'/camellia japonica 'adolphe audusson' (1).jpg",
          width: 1024,
          id: '8382506a4fdbacdd847ba763af8a6031',
          height: 683,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Adolphe Audusson',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'eccf60b59b4396966fe81106c933cdaf269a91a3',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 86, 88, 1.00)',
            'rgba(141, 93, 112, 1.00)',
            'rgba(75, 64, 67, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'c. m. wilson'/camellia japonica 'c. m. wilson'.jpg",
          width: 1024,
          id: 'c39b9d3fbcef97ea9ce25168d27f8b2c',
          height: 683,
          thumbnail: true,
        },
        location: [47.269739, -1.58161],
        genre: 'Camellia',
        cultivar: 'C. M. Wilson',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58161, 47.269739] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'da84ddcae9a9c6bcb16e0d4ec91fea465b135f00',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 143, 124, 1.00)',
            'rgba(87, 99, 77, 1.00)',
            'rgba(86, 79, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'clotilde'/camellia japonica 'clotilde' (3).jpg",
          width: 1024,
          id: 'ce84719f382348bff41e318be735fc68',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 81, 63, 1.00)',
            'rgba(108, 90, 90, 1.00)',
            'rgba(86, 68, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'clotilde'/camellia japonica 'clotilde' (2).jpg",
          width: 1024,
          id: '94f1d83300ecf8edb7dad479be5198f8',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 145, 124, 1.00)',
            'rgba(106, 105, 89, 1.00)',
            'rgba(63, 66, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'clotilde'/camellia japonica 'clotilde' (1).jpg",
          width: 1024,
          id: '37aafb521322dc67c684115e61c288d7',
          height: 683,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Camellia',
        cultivar: 'Clotilde',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c2561ecf026ee93d5ab2c7a772c5495f5606a2c9',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(45, 49, 28, 1.00)',
            'rgba(113, 92, 84, 1.00)',
            'rgba(76, 65, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'clotilde'/camellia japonica 'clotilde'.jpg",
          width: 1024,
          id: 'bad8f0380e83d49beac1a113ad9c48eb',
          height: 683,
          thumbnail: true,
        },
        location: [47.27026, -1.586547],
        genre: 'Camellia',
        cultivar: 'Clotilde',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586547, 47.27026] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0ebc6db84c89ab9b2d2b09af8b8588d5a0ab530a',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 162, 140, 1.00)',
            'rgba(105, 104, 75, 1.00)',
            'rgba(118, 102, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'conte bouturlin'/camellia japonica 'conte bouturlin' (3).jpg",
          width: 576,
          id: '9fea7975fd3cc1180b3a7612d464eea0',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 137, 86, 1.00)',
            'rgba(110, 136, 82, 1.00)',
            'rgba(109, 114, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'conte bouturlin'/camellia japonica 'conte bouturlin' (2).jpg",
          width: 576,
          id: '230db36451afb58bdb4f02f6f25a3353',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 108, 84, 1.00)',
            'rgba(162, 97, 102, 1.00)',
            'rgba(104, 93, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'conte bouturlin'/camellia japonica 'conte bouturlin' (1).jpg",
          width: 576,
          id: '8b4fb752f9baca01b2a87b2c45b3b337',
          height: 768,
          thumbnail: true,
        },
        location: [47.270158, -1.581455],
        genre: 'Camellia',
        cultivar: 'Conte Bouturlin',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581455, 47.270158] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ed2ac6797931c711abe166cb16e3a9cb5e062b73',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 95, 102, 1.00)',
            'rgba(143, 68, 99, 1.00)',
            'rgba(111, 74, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'de bugny'/camellia japonica 'de bugny' (4).jpg",
          width: 1024,
          id: 'f98eef50aee1e18076ab24ce979e7a81',
          height: 705,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 91, 96, 1.00)',
            'rgba(141, 52, 70, 1.00)',
            'rgba(83, 48, 44, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'de bugny'/camellia japonica 'de bugny' (2).jpg",
          width: 1024,
          id: '7cac222624a52f4f26ce6d83f102d56f',
          height: 617,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 133, 119, 1.00)',
            'rgba(84, 93, 73, 1.00)',
            'rgba(77, 75, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'de bugny'/camellia japonica 'de bugny' (1).jpg",
          width: 512,
          id: 'a0e162530925ec4f8a7ea3987d45b318',
          height: 768,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Camellia',
        cultivar: 'De Bugny',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dccbbfc3fe20ab1e34804e317b131217043d8e19',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 92, 69, 1.00)',
            'rgba(133, 139, 123, 1.00)',
            'rgba(97, 101, 87, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'drouard gouillon'/camellia japonica 'drouard gouillon'.jpg",
          width: 1024,
          id: '7eb52b1a7d741658f074de5546b35473',
          height: 712,
          thumbnail: true,
        },
        location: [47.269538, -1.585169],
        genre: 'Camellia',
        cultivar: 'Drouard Gouillon',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585169, 47.269538] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '971fb83dd98064a9c5abf1aca2dae57fb6ab7e38',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 113, 108, 1.00)',
            'rgba(118, 126, 114, 1.00)',
            'rgba(95, 97, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'general leclerc'/camellia japonica 'general leclerc' (5).jpg",
          width: 1024,
          id: '71bf80c6dd23855482a5a4898be2aa43',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 83, 81, 1.00)',
            'rgba(152, 35, 54, 1.00)',
            'rgba(81, 41, 38, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'general leclerc'/camellia japonica 'general leclerc' (2).jpg",
          width: 948,
          id: '4f289ba26b3bfef15eefbcb1825311bb',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 72, 72, 1.00)',
            'rgba(148, 51, 71, 1.00)',
            'rgba(83, 57, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'general leclerc'/camellia japonica 'general leclerc' (1).jpg",
          width: 1024,
          id: '3ab50640a126dd62f4d76355547acc68',
          height: 683,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'G\u00e9n\u00e9ral Leclerc',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '53b867077dff3bb74759b57ab8fa3c6d75723be4',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(31, 25, 26, 1.00)',
            'rgba(118, 55, 87, 1.00)',
            'rgba(92, 50, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'gloire de nantes'/camellia japonica 'gloire de nantes'  (4).jpg",
          width: 1024,
          id: '23c48dea75a85b7deea0ce257d0c24e3',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(63, 37, 36, 1.00)',
            'rgba(123, 46, 61, 1.00)',
            'rgba(80, 43, 46, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'gloire de nantes'/camellia japonica 'gloire de nantes'  (3).jpg",
          width: 1024,
          id: '76f77012f30fa65f4fdd4bedda4133c7',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(61, 73, 54, 1.00)',
            'rgba(102, 116, 88, 1.00)',
            'rgba(87, 97, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'gloire de nantes'/camellia japonica 'gloire de nantes'  (2).jpg",
          width: 1024,
          id: '905155d7e39aa226c026577cd32caf84',
          height: 683,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Camellia',
        cultivar: 'Gloire de Nantes',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9266fa81e583eb74558a0dd1e017f4a2e7627fd2',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(55, 49, 36, 1.00)',
            'rgba(131, 64, 61, 1.00)',
            'rgba(86, 38, 33, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'guilio nuccio'/camellia japonica 'guilio nuccio' (3).jpg",
          width: 1024,
          id: '16e7645b282a9bb934d55730cb2b939a',
          height: 620,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(56, 74, 59, 1.00)',
            'rgba(124, 86, 86, 1.00)',
            'rgba(114, 74, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'guilio nuccio'/camellia japonica 'guilio nuccio' (2).jpg",
          width: 1024,
          id: '293281943bb862600ab38262b4007ecd',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 114, 98, 1.00)',
            'rgba(103, 112, 92, 1.00)',
            'rgba(96, 105, 84, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'guilio nuccio'/camellia japonica 'guilio nuccio' (1).jpg",
          width: 512,
          id: 'a4bc54de63894b5b980df93b5d563b2e',
          height: 768,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Camellia',
        cultivar: 'Guilio Nuccio',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4e9a943f4b95fcc4b259d93321f88db13fc330b6',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 109, 161, 1.00)',
            'rgba(80, 107, 146, 1.00)',
            'rgba(76, 95, 115, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'lazetta'/camellia japonica 'lazetta'.jpg",
          width: 1024,
          id: '92feb0207a816647077266c4c76906ba',
          height: 683,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Lazetta',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8b0993a399667f1b89362c280d40648b12e2ad97',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(50, 51, 29, 1.00)',
            'rgba(120, 106, 89, 1.00)',
            'rgba(83, 74, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'little michael'/camellia japonica 'little michael' (3).jpg",
          width: 1024,
          id: 'f48df9236258f383df8d01d3192747e1',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 146, 156, 1.00)',
            'rgba(187, 155, 147, 1.00)',
            'rgba(133, 118, 101, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'little michael'/camellia japonica 'little michael' (2).jpg",
          width: 574,
          id: '7bdfcf4e834f42f84937a2ff3920b698',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 109, 62, 1.00)',
            'rgba(104, 122, 82, 1.00)',
            'rgba(94, 106, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'little michael'/camellia japonica 'little michael' (1).jpg",
          width: 1024,
          id: '6232a13e4c8a7d31f9c4483111e29d8b',
          height: 683,
          thumbnail: true,
        },
        location: [47.26973, -1.583722],
        genre: 'Camellia',
        cultivar: 'Little Michael',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583722, 47.26973] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '668b5a3c4d49f0e727c684664a294ecba2beb65c',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 84, 77, 1.00)',
            'rgba(104, 103, 74, 1.00)',
            'rgba(59, 62, 33, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'madame lourmand'/camellia japonica 'madame lourmand'.jpg",
          width: 576,
          id: '57d75ed72976991e1aaac776bfbb2593',
          height: 768,
          thumbnail: true,
        },
        location: [47.269233, -1.584317],
        genre: 'Camellia',
        cultivar: 'Madame Lourmand',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584317, 47.269233] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c8922be774bc152b997f0f3168c3b237fbeb42c2',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 63, 63, 1.00)',
            'rgba(147, 83, 91, 1.00)',
            'rgba(117, 69, 90, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'mattie cole'/camellia japonica 'mattie cole'.jpg",
          width: 1024,
          id: '2c6c32e04bc78252aa206c55c280a828',
          height: 702,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 125, 96, 1.00)',
            'rgba(104, 107, 93, 1.00)',
            'rgba(110, 109, 100, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'mattie cole'/camellia japonica 'mattie cole' (2).jpg",
          width: 1024,
          id: '92e568c5458928a757f95c7587e34e29',
          height: 683,
          thumbnail: true,
        },
        location: [47.270572, -1.585613],
        genre: 'Camellia',
        cultivar: 'Mattie Cole',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585613, 47.270572] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2d000cb0fa276cb32bdbd84ac9fed38bf8c9a58d',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(69, 79, 74, 1.00)',
            'rgba(108, 94, 96, 1.00)',
            'rgba(73, 66, 71, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'my darling'/camellia japonica 'my darling' (3).jpg",
          width: 1024,
          id: '598c3c11dc789f80f5324fcd63963e1d',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(168, 176, 164, 1.00)',
            'rgba(106, 121, 110, 1.00)',
            'rgba(68, 87, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'my darling'/camellia japonica 'my darling' (2).jpg",
          width: 1024,
          id: '88a641e9ef705644aec39bbfb8c8a1b3',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 97, 88, 1.00)',
            'rgba(105, 96, 92, 1.00)',
            'rgba(52, 57, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'my darling'/camellia japonica 'my darling' (1).jpg",
          width: 1024,
          id: 'd22127fd6a3429c6bb67c733e54b3bb9',
          height: 683,
          thumbnail: true,
        },
        location: [47.271441, -1.582966],
        genre: 'Camellia',
        cultivar: 'My Darling',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582966, 47.271441] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5fdc8bf7e97825b227e9a14e35de3fde494e8157',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 80, 70, 1.00)',
            'rgba(84, 90, 78, 1.00)',
            'rgba(66, 74, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'nobilissima'/camellia japonica 'nobilissima'.jpg",
          width: 1024,
          id: 'f1d18b309500fcf26b6979328946b590',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 144, 129, 1.00)',
            'rgba(101, 113, 88, 1.00)',
            'rgba(58, 72, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'nobilissima'/camellia japonica 'nobilissima'  (2).jpg",
          width: 1024,
          id: '2de30583972a4f1e4164bfa40b21737f',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 153, 132, 1.00)',
            'rgba(98, 110, 78, 1.00)',
            'rgba(70, 78, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'nobilissima'/camellia japonica 'nobilissima'  (1).jpg",
          width: 1024,
          id: '72334895ba3b5928d3010fe9ae01c8d5',
          height: 683,
          thumbnail: true,
        },
        location: [47.269087, -1.5852],
        genre: 'Camellia',
        cultivar: 'Nobilissima',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5852, 47.269087] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2bcbd776e9457e9db4b0d5fa8d33137888ca8ab7',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 167, 155, 1.00)',
            'rgba(80, 96, 55, 1.00)',
            'rgba(99, 104, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'nuccio's cameo'/camellia japonica 'nuccio's cameo' (3).jpg",
          width: 576,
          id: '68296c2a41b9123480fa170d50b1bc34',
          height: 768,
          thumbnail: true,
        },
        location: [47.271145, -1.582603],
        genre: 'Camellia',
        cultivar: "Nuccio's Cameo",
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582603, 47.271145] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '337abdbd2612abeb5423afd1eed198ed2a2f4702',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(49, 58, 38, 1.00)',
            'rgba(119, 96, 98, 1.00)',
            'rgba(105, 84, 87, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'nuccio's jewel'/camellia japonica 'nuccio's jewel' (3).jpg",
          width: 1024,
          id: '78ac1054a9930387483d9e01eed99a4f',
          height: 683,
          thumbnail: true,
        },
        location: [47.269547, -1.585186],
        genre: 'Camellia',
        cultivar: "Nuccio's Jewel",
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585186, 47.269547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9c649deb6d591168f6079bb8f2cac81b15419193',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(55, 65, 44, 1.00)',
            'rgba(127, 92, 100, 1.00)',
            'rgba(99, 69, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'nuccio's jewel'/camellia japonica 'nuccio's jewel'.jpg",
          width: 1024,
          id: '6972086710bf8c95fdb36d82b3a331b6',
          height: 707,
          thumbnail: true,
        },
        location: [47.270097, -1.581472],
        genre: 'Camellia',
        cultivar: "Nuccio's Jewel",
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581472, 47.270097] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1aa4f5431ad4ad8020e92b557571d06e83782c4f',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 92, 62, 1.00)',
            'rgba(119, 94, 93, 1.00)',
            'rgba(80, 62, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'oo-la-la'/camellia japonica 'oo-la-la' (3).jpg",
          width: 1024,
          id: 'd2c07e7cead1542c5d2ac600b7ec5e98',
          height: 668,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 94, 70, 1.00)',
            'rgba(111, 83, 92, 1.00)',
            'rgba(64, 59, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'oo-la-la'/camellia japonica 'oo-la-la' (2).jpg",
          width: 1024,
          id: 'da6a9deb599cac1fa1f5935bf2a345ad',
          height: 660,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 116, 88, 1.00)',
            'rgba(154, 100, 96, 1.00)',
            'rgba(162, 85, 109, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'oo-la-la'/camellia japonica 'oo-la-la' (1).jpg",
          width: 1024,
          id: '55b5553f144a9e5d61f1e55add4191cf',
          height: 719,
          thumbnail: true,
        },
        location: [47.270538, -1.581312],
        genre: 'Camellia',
        cultivar: 'Oo-La-La',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581312, 47.270538] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '31521f04246499ad2de211fad83694bc62ff5b6c',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 50, 39, 1.00)',
            'rgba(140, 92, 87, 1.00)',
            'rgba(71, 65, 44, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'otome'/camellia japonica 'otome'.jpg",
          width: 1024,
          id: '4ade9081131365ea1684afc71c80a26c',
          height: 683,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Otome',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '50f1a652c9adeb0fd7b61a425c67402f9dfed79a',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 104, 79, 1.00)',
            'rgba(108, 76, 66, 1.00)',
            'rgba(83, 84, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'saint philibert'/camellia japonica 'saint philibert' (5).jpg",
          width: 1024,
          id: 'c0604b7f20c66e8121cb172299f230c2',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 143, 109, 1.00)',
            'rgba(102, 117, 84, 1.00)',
            'rgba(93, 97, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'saint philibert'/camellia japonica 'saint philibert' (4).jpg",
          width: 1024,
          id: 'c0993c87133a0c778a28f521c8b83164',
          height: 683,
          thumbnail: true,
        },
        location: [47.270372, -1.584061],
        genre: 'Camellia',
        cultivar: 'Saint Philibert',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584061, 47.270372] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8e32c3d0926bcc96250c587df3d93b7b0dbe4ef6',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 80, 69, 1.00)',
            'rgba(101, 80, 71, 1.00)',
            'rgba(102, 88, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'traversi'/camellia japonica 'traversi' (2).jpg",
          width: 1024,
          id: 'd7c3a7173f7d9aa8f37e212a9ac6977e',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 79, 79, 1.00)',
            'rgba(103, 84, 76, 1.00)',
            'rgba(116, 97, 84, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'traversi'/camellia japonica 'traversi' (1).jpg",
          width: 1024,
          id: '629010a1c2a3c75bee6fd3960a08b765',
          height: 683,
          thumbnail: true,
        },
        location: [47.27028, -1.585858],
        genre: 'Camellia',
        cultivar: 'Traversi',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585858, 47.27028] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '170db87f0476554b90752b71e0c54187b0627e71',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 142, 119, 1.00)',
            'rgba(130, 95, 97, 1.00)',
            'rgba(103, 107, 111, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'wildfire'/camellia japonica 'wildfire'.jpg",
          width: 1024,
          id: '54131235451d17009bc33ed78fca40d2',
          height: 610,
          thumbnail: true,
        },
        location: [47.270528, -1.581275],
        genre: 'Camellia',
        cultivar: 'Wildfire',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581275, 47.270528] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ed19fdd938b0b609a8115f1259381273e35d7f2b',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 89, 88, 1.00)',
            'rgba(91, 103, 107, 1.00)',
            'rgba(64, 75, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'jean may'/camellia sasanqua 'jean may' (4).jpg",
          width: 1024,
          id: 'a91a9814a9d23375f83ce255127291d2',
          height: 683,
          thumbnail: true,
        },
        espece: 'sasanqua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 86, 75, 1.00)',
            'rgba(104, 98, 113, 1.00)',
            'rgba(78, 86, 97, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'jean may'/camellia sasanqua 'jean may' (3).jpg",
          width: 1024,
          id: '51b356ead066175ea4f8d9d48c2f8f19',
          height: 741,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 127, 115, 1.00)',
            'rgba(104, 99, 110, 1.00)',
            'rgba(62, 67, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'jean may'/camellia sasanqua 'jean may' (1).jpg",
          width: 961,
          id: '6e8fdf8439ff60fa2207e87471db508b',
          height: 768,
          thumbnail: true,
        },
        location: [47.268883, -1.585189],
        genre: 'Camellia',
        cultivar: 'Jean May',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585189, 47.268883] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b79fa69dfdfadfcbd1caa1917dc0ad72e4a051ae',
      fields: {
        espece: 'sasanqua',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 108, 90, 1.00)',
            'rgba(114, 115, 90, 1.00)',
            'rgba(63, 73, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'rainbow'/camellia sasanqua 'rainbow' (1).jpg",
          width: 1024,
          id: '1a9bbb39cea38293b6cd96bb36e149ee',
          height: 683,
          thumbnail: true,
        },
        location: [47.269897, -1.582],
        genre: 'Camellia',
        cultivar: 'Rainbow',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582, 47.269897] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '733e8f0d2d417a55cc454e21994defd8160f959f',
      fields: {
        espece: 'sasanqua',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(56, 69, 43, 1.00)',
            'rgba(108, 112, 81, 1.00)',
            'rgba(47, 59, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'versicolor'/camellia sasanqua 'versicolor' .jpg",
          width: 1024,
          id: 'cc90a43c2e9205f4293d18916b16fc75',
          height: 683,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Camellia',
        cultivar: 'Versicolor',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd2f5c3edde9b796b5aee17b322b6dd51096b9b64',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(57, 64, 45, 1.00)',
            'rgba(104, 87, 90, 1.00)',
            'rgba(72, 68, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'gay time'/camellia x williamsii 'gay time' (3).jpg",
          width: 1024,
          id: '98e3fe3ad68bd9dd3f0870d3f00d80ac',
          height: 683,
          thumbnail: true,
        },
        espece: 'x williamsii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(62, 52, 43, 1.00)',
            'rgba(112, 67, 77, 1.00)',
            'rgba(68, 52, 42, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'gay time'/camellia x williamsii 'gay time' (2).jpg",
          width: 1024,
          id: '7f88c72750ee2a4aa324a44152063f46',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 137, 97, 1.00)',
            'rgba(111, 131, 84, 1.00)',
            'rgba(98, 112, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'gay time'/camellia x williamsii 'gay time' (1).jpg",
          width: 1024,
          id: 'f4292bc9026069b74defc5afe32b11db',
          height: 683,
          thumbnail: true,
        },
        location: [47.269592, -1.584683],
        genre: 'Camellia',
        cultivar: 'Gay Time',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584683, 47.269592] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b45ca077d146f521cc3bdf179b31322c5e3db9a0',
      fields: {
        espece: 'odora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 100, 76, 1.00)',
            'rgba(109, 112, 90, 1.00)',
            'rgba(91, 81, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/daphne [thymelaeaceae]/daphne odora 'aureomarginata'/daphne odora 'aureomarginata' (7).jpg",
          width: 1024,
          id: '441b92f90de61a405d39e086e9384f9c',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 116, 93, 1.00)',
            'rgba(109, 117, 102, 1.00)',
            'rgba(79, 92, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/daphne [thymelaeaceae]/daphne odora 'aureomarginata'/daphne odora 'aureomarginata' (1).jpg",
          width: 1024,
          id: 'f2eed582dfe4c9a6cb3668f7d772d071',
          height: 683,
          thumbnail: true,
        },
        location: [47.270842, -1.586142],
        genre: 'Daphne',
        cultivar: 'Aureomarginata',
        famille: 'Thymelaeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586142, 47.270842] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a160dc3bfd5190b05a17b96903a75561066ef4f7',
      fields: {
        espece: 'odora',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 129, 100, 1.00)',
            'rgba(122, 129, 95, 1.00)',
            'rgba(110, 113, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/daphne [thymelaeaceae]/daphne odora 'aureomarginata'/daphne odora 'aureomarginata' (5).jpg",
          width: 1024,
          id: 'd46e083402df55e7273ece1f97e0c748',
          height: 768,
          thumbnail: true,
        },
        location: [47.269333, -1.585245],
        genre: 'Daphne',
        cultivar: 'Aureomarginata',
        famille: 'Thymelaeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585245, 47.269333] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '22c9654a457069bc5306c8b596a5ffd1e028f12f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'Lut\u00e8ce (Nanguen)',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(173, 178, 176, 1.00)',
            'rgba(119, 104, 66, 1.00)',
            'rgba(96, 100, 39, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ulmus [ulmaceae]/ulmus lutece ('nanguen')/ulmus lutece ('nanguen') (2).jpg",
          width: 576,
          id: 'b82d8682e6baa326e0465756033cc59c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 153, 108, 1.00)',
            'rgba(143, 131, 79, 1.00)',
            'rgba(104, 103, 52, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ulmus [ulmaceae]/ulmus lutece ('nanguen')/ulmus lutece ('nanguen') (3).jpg",
          width: 576,
          id: '0f901ffd9dc2b7b4a71af9df84aa0bd0',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 127, 177, 1.00)',
            'rgba(143, 154, 171, 1.00)',
            'rgba(150, 145, 115, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ulmus [ulmaceae]/ulmus lutece ('nanguen')/ulmus lutece ('nanguen') (1).jpg",
          width: 576,
          id: 'ec47dcb403e30a2776927110dde8be84',
          height: 768,
          thumbnail: true,
        },
        location: [47.271838, -1.582758],
        genre: 'Ulmus',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582758, 47.271838] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4f12a4aad92d2a1be1249b6a294fe8fadbb535d2',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 154, 91, 1.00)',
            'rgba(127, 136, 87, 1.00)',
            'rgba(107, 111, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ulmus [ulmaceae]/ulmus parvifolia 'frosty'/ulmus parvifolia 'frosty' (1).jpg",
          width: 576,
          id: 'f99ee033ad10f118dd002adada8e0eeb',
          height: 768,
          thumbnail: true,
        },
        espece: 'parvifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 104, 59, 1.00)',
            'rgba(111, 105, 62, 1.00)',
            'rgba(86, 87, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ulmus [ulmaceae]/ulmus parvifolia 'frosty'/ulmus parvifolia 'frosty'  (2).jpg",
          width: 1024,
          id: '5b1ab2c67f30bf6441e853fcf834726e',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 145, 86, 1.00)',
            'rgba(122, 137, 82, 1.00)',
            'rgba(101, 108, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ulmus [ulmaceae]/ulmus parvifolia 'frosty'/ulmus parvifolia 'frosty'  (1).jpg",
          width: 569,
          id: '4fa0366e3415560a85fea3d0a5191fc9',
          height: 768,
          thumbnail: true,
        },
        location: [47.271088, -1.582245],
        genre: 'Ulmus',
        cultivar: 'Frosty',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582245, 47.271088] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '387bbf5eb8afd4229d8c66ab6ff322d49d4600f8',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 135, 78, 1.00)',
            'rgba(139, 127, 65, 1.00)',
            'rgba(68, 83, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/zelkova [ulmaceae]/zelkova serrata 'ogon'/zelkova serrata 'ogon' (1).jpg",
          width: 576,
          id: '6fb7e7cf8b871b77a0492452667f91f6',
          height: 768,
          thumbnail: true,
        },
        espece: 'serrata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 168, 193, 1.00)',
            'rgba(131, 104, 75, 1.00)',
            'rgba(96, 67, 24, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/zelkova [ulmaceae]/zelkova serrata 'ogon'/zelkova serrata 'ogon'  (2).jpg",
          width: 576,
          id: '91ac1ab218327c2ebe15734b0dc318bb',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(193, 158, 110, 1.00)',
            'rgba(158, 120, 76, 1.00)',
            'rgba(102, 74, 52, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/zelkova [ulmaceae]/zelkova serrata 'ogon'/zelkova serrata 'ogon'  (1).jpg",
          width: 1024,
          id: 'e64676c5a992088f67405b959fa0a333',
          height: 768,
          thumbnail: true,
        },
        location: [47.271708, -1.582488],
        genre: 'Zelkova',
        cultivar: 'Ogon',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582488, 47.271708] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '22030281a17bde724545be084f2b57f93a6bc1f9',
      fields: {
        espece: 'serrata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 149, 156, 1.00)',
            'rgba(102, 89, 55, 1.00)',
            'rgba(72, 74, 37, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/zelkova [ulmaceae]/zelkova serrata/zelkova serrata (2).jpg',
          width: 1024,
          id: '7ba5fa71f9d8381fc894ce4c8751f73b',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 98, 111, 1.00)',
            'rgba(104, 90, 90, 1.00)',
            'rgba(117, 82, 64, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/zelkova [ulmaceae]/zelkova serrata/zelkova serrata (1).jpg',
          width: 1024,
          id: '5ec6add5ede00f17f1ea92100fb9684c',
          height: 683,
          thumbnail: true,
        },
        location: [47.262374, -1.531166],
        genre: 'Zelkova',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531166, 47.262374] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f64d54cd89245a860ee6a83b6884d251df95e3f0',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes 71290 La Gen\u00eate',
        espece: 'japonica Miq.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Boehemeria',
        date_plantation: '2015',
        famille: 'Urticaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '34928aae271d27b608a312069bb95f09f7710712',
      fields: {
        origine: 'La boite \u00e0 graines (France)',
        espece: 'corsica DC.',
        localisation: 'C2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2194084, -1.5437532],
        genre: 'Viola',
        date_plantation: '2013',
        cultivar: 'ssp.corsica',
        famille: 'Violaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5437532, 47.2194084] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '03d20124b17e8322bd77a95eed72e2522bdbf339',
      fields: {
        origine: 'Emmanuel LEPAGE',
        espece: 'himalaicus Baker',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Eremurus',
        date_plantation: '2015',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c4464b984c2f5384f56ed6374b95275d7983bb09',
      fields: {
        origine: 'J. alpin la Ramberta, Montreux (Suisse)',
        espece: 'altissima Stout',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Hemerocallis',
        date_plantation: '2011',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b775ca4a0c68b86de7ada331b6901d78e652b466',
      fields: {
        origine: 'J.B.Edouard-Marie Heckel,Marseille,FR.',
        espece: 'narcissifolia Salm.Dyck',
        localisation: 'I2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185657, -1.5426599],
        genre: 'Bulbine',
        date_plantation: '2012',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426599, 47.2185657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '615bc6afc058a51f2ee4d96994cac7a7832dbb8c',
      fields: {
        origine: 'JB.Hokkaido (Japon)',
        espece: 'lilioasphodelus L.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Hemerocalis',
        date_plantation: '2009',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '177a58103cb49bbba2c859e9e8091e609bdd576f',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'caulescens Baker',
        localisation: 'G2A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2197208, -1.5414609],
        genre: 'Kniphofia',
        date_plantation: '2008',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5414609, 47.2197208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ed8b647fabaecd48e8c817e179a2afebfce0ad01',
      fields: {
        origine: 'JB.Turku (Finlande)',
        espece: 'dumortierii  C.Morr.',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Hemerocallis',
        date_plantation: '1998',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ff30a5d33d6ad44cc48cf4f23f228b9ec82a49f2',
      fields: {
        espece: 'cissifolium',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 153, 50, 1.00)',
            'rgba(96, 117, 29, 1.00)',
            'rgba(77, 102, 26, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/acer/acer cissifolium/acer cissifolium.jpg',
          width: 576,
          id: '6ff1312d051266e8a6b436051680bcad',
          height: 768,
          thumbnail: true,
        },
        location: [47.220453, -1.543958],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543958, 47.220453] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '501ba0a051c1356894274763da64ea16c5359bc0',
      fields: {
        espece: 'shirasawanum',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 159, 104, 1.00)',
            'rgba(111, 133, 80, 1.00)',
            'rgba(89, 94, 71, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer shirasawanum 'aureum'/acer shirasawanum 'aureum'.jpg",
          width: 576,
          id: '44b181da37c71109f58850d1551e471d',
          height: 768,
          thumbnail: true,
        },
        location: [47.222883, -1.579295],
        genre: 'Acer',
        cultivar: 'Aureum',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.579295, 47.222883] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'da45bee47400eec218c29acc7b692a15a9774cf9',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'tataricum subsp. ginnala',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 141, 55, 1.00)',
            'rgba(106, 133, 42, 1.00)',
            'rgba(113, 131, 47, 1.00)',
          ],
          filename:
            'ip parc de proce/acer/acer tataricum subsp. ginnala/acer tataricum subsp. ginnala  (2).jpg',
          width: 576,
          id: '83b91cdb47d2acb31950e033526d93be',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 142, 53, 1.00)',
            'rgba(119, 133, 50, 1.00)',
            'rgba(110, 126, 36, 1.00)',
          ],
          filename:
            'ip parc de proce/acer/acer tataricum subsp. ginnala/acer tataricum subsp. ginnala  (3).jpg',
          width: 576,
          id: 'de8d50cf5d77d7950bac73b888228a84',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 131, 139, 1.00)',
            'rgba(143, 137, 86, 1.00)',
            'rgba(118, 108, 62, 1.00)',
          ],
          filename:
            'ip parc de proce/acer/acer tataricum subsp. ginnala/acer tataricum subsp. ginnala  (1).jpg',
          width: 576,
          id: '2c133f29bccdb8994dc11e9e04c25b76',
          height: 768,
          thumbnail: true,
        },
        location: [47.225475, -1.58307],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58307, 47.225475] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '40dbfa38b77a193cb55b79256c57f280d10a91a6',
      fields: {
        espece: 'saccharinum',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(168, 174, 181, 1.00)',
            'rgba(153, 145, 121, 1.00)',
            'rgba(101, 93, 65, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/acer/acer saccharinum/acer saccharinum (3).jpg',
          width: 1024,
          id: 'aa38edb1d170f6edc13504cbac6d8ea2',
          height: 768,
          thumbnail: true,
        },
        location: [47.227317, -1.510258],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.510258, 47.227317] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2bd409b29f29c842922dae58e914a71245dcc4b5',
      fields: {
        espece: 'hippocastanum',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 204, 235, 1.00)',
            'rgba(123, 148, 116, 1.00)',
            'rgba(78, 89, 51, 1.00)',
          ],
          filename:
            'ip parc de proce/aesculus/aesculus hippocastanum/aesculus hippocastanum (3).jpg',
          width: 576,
          id: '3b116decf12e2558cdec5feb1c8f6159',
          height: 768,
          thumbnail: true,
        },
        location: [47.225737, -1.583037],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583037, 47.225737] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ce39da3f6f8fa8deef2dc851427e1791db5a21c7',
      fields: {
        nom_du_site: 'Autre site',
        espece: 'x andrachnoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 145, 120, 1.00)',
            'rgba(161, 127, 117, 1.00)',
            'rgba(145, 116, 96, 1.00)',
          ],
          filename:
            'ip ville de nantes/arbutus/arbutus x andrachnoides/arbutus x andrachnoides (2).jpg',
          width: 576,
          id: '0951bde740c7e88a654981eaf2bd4c5e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 105, 82, 1.00)',
            'rgba(149, 131, 116, 1.00)',
            'rgba(167, 164, 129, 1.00)',
          ],
          filename:
            'ip ville de nantes/arbutus/arbutus x andrachnoides/arbutus x andrachnoides (3).jpg',
          width: 576,
          id: 'fcac5e49f8ebea4db4f549d2c6df77eb',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(199, 200, 184, 1.00)',
            'rgba(116, 120, 94, 1.00)',
            'rgba(110, 103, 85, 1.00)',
          ],
          filename:
            'ip ville de nantes/arbutus/arbutus x andrachnoides/arbutus x andrachnoides (1).jpg',
          width: 1024,
          id: 'bbdac9644acfe04f505246d78dc89d72',
          height: 768,
          thumbnail: true,
        },
        location: [47.219363, -1.535483],
        genre: 'Arbutus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535483, 47.219363] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '37d5544681cb81cc2df63da50a52d918e922f499',
      fields: {
        espece: 'x andrachnoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 77, 67, 1.00)',
            'rgba(153, 134, 116, 1.00)',
            'rgba(144, 130, 101, 1.00)',
          ],
          filename:
            'ip ville de nantes/arbutus/arbutus x andrachnoides/arbutus x andrachnoides (6).jpg',
          width: 1024,
          id: 'ec62218f7445e273adf87ede9cfd205d',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 86, 70, 1.00)',
            'rgba(153, 101, 76, 1.00)',
            'rgba(153, 101, 76, 1.00)',
          ],
          filename:
            'ip ville de nantes/arbutus/arbutus x andrachnoides/arbutus x andrachnoides (5).jpg',
          width: 1024,
          id: 'e577892cc7f03d8d7e16ef59afe709c1',
          height: 683,
          thumbnail: true,
        },
        location: [47.219364, -1.535483],
        genre: 'Arbutus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535483, 47.219364] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f768901e0dc14ca790a5516fa03434ca8421c7ee',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'lenta',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 125, 93, 1.00)',
            'rgba(140, 155, 105, 1.00)',
            'rgba(72, 88, 40, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/betula/betula lenta/betula lenta (2).jpg',
          width: 1024,
          id: '9b927e269d15e22fb0c6095830b61050',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 110, 86, 1.00)',
            'rgba(111, 106, 72, 1.00)',
            'rgba(120, 112, 83, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/betula/betula lenta/betula lenta (3).jpg',
          width: 1024,
          id: '2ad2f6cfc965a80838f9458775ce5d85',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 112, 85, 1.00)',
            'rgba(105, 116, 77, 1.00)',
            'rgba(75, 90, 46, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/betula/betula lenta/betula lenta (1).jpg',
          width: 1024,
          id: '314120bf9a27528db63d12c0b1ea8c76',
          height: 683,
          thumbnail: true,
        },
        location: [47.262783, -1.52972],
        genre: 'Betula',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.52972, 47.262783] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '514a9432cd534931480292f9bf1635daff6842bc',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'papyrifera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 170, 194, 1.00)',
            'rgba(115, 117, 57, 1.00)',
            'rgba(101, 104, 74, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/broussonetia/broussonetia papyrifera/broussonetia papyrifera (2).jpg',
          width: 1024,
          id: '18fcae6291c1fdee8811e30b2f1f0d4a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(212, 219, 202, 1.00)',
            'rgba(95, 112, 65, 1.00)',
            'rgba(108, 114, 89, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/broussonetia/broussonetia papyrifera/broussonetia papyrifera.jpg',
          width: 1024,
          id: 'b8739a5a0a401e9bcc442c7a903bb4cd',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 137, 175, 1.00)',
            'rgba(123, 140, 118, 1.00)',
            'rgba(118, 136, 133, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/broussonetia/broussonetia papyrifera/broussonetia papyrifera (1).jpg',
          width: 576,
          id: 'd149de6a46694fef3032e18e8107cf07',
          height: 768,
          thumbnail: true,
        },
        location: [47.228855, -1.511945],
        genre: 'Broussonetia',
        famille: 'Moraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.511945, 47.228855] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cb587c7f7fb7dd9f6fa51973c13c716a2e21c96a',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'globosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 140, 66, 1.00)',
            'rgba(126, 112, 34, 1.00)',
            'rgba(115, 120, 35, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/buddleja/buddleja globosa/buddleja globosa (2).jpg',
          width: 576,
          id: 'fecac1bad2a16bf95f2093d15f7e30cb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 179, 134, 1.00)',
            'rgba(97, 110, 55, 1.00)',
            'rgba(86, 87, 53, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/buddleja/buddleja globosa/buddleja globosa .jpg',
          width: 576,
          id: 'e07cfc050ec5a0fbdefbb4a14e1b49c5',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 108, 59, 1.00)',
            'rgba(131, 140, 70, 1.00)',
            'rgba(118, 150, 54, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/buddleja/buddleja globosa/buddleja globosa (1).jpg',
          width: 576,
          id: 'e7c9348c7057947bc9518d2fa0a1dd3b',
          height: 768,
          thumbnail: true,
        },
        location: [47.220467, -1.542622],
        genre: 'Buddleja',
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542622, 47.220467] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd95d7bd4a3e5432d541290dcef53362481fd5c84',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'alternifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 111, 71, 1.00)',
            'rgba(84, 125, 70, 1.00)',
            'rgba(71, 108, 56, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/buddleja/buddleja alternifolia/buddleja alternifolia (2).jpg',
          width: 576,
          id: 'f1c1c35191d78e902a5beb1435209062',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 95, 71, 1.00)',
            'rgba(94, 111, 90, 1.00)',
            'rgba(81, 90, 68, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/buddleja/buddleja alternifolia/buddleja alternifolia (3).jpg',
          width: 576,
          id: 'd21cf0de6a6974320403596b5d12abe8',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 109, 67, 1.00)',
            'rgba(85, 104, 76, 1.00)',
            'rgba(67, 78, 56, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/buddleja/buddleja alternifolia/buddleja alternifolia (1).jpg',
          width: 576,
          id: '9829a7a3022a0a6c7735506b5480b038',
          height: 768,
          thumbnail: true,
        },
        location: [47.229188, -1.507388],
        genre: 'Buddleja',
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507388, 47.229188] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '062eee5908e876ecf5c6e030ba426f91d5a0cf33',
      fields: {
        espece: 'bodinieri var. giraldii',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 154, 155, 1.00)',
            'rgba(94, 90, 89, 1.00)',
            'rgba(73, 78, 56, 1.00)',
          ],
          filename:
            "ip parc de proce/callicarpa/callicarpa bodinieri var. giraldii 'profusion'/callicarpa bodinieri var. giraldii 'profusion'.jpg",
          width: 576,
          id: '8906bbfd3ad0704d161678f405bf8d19',
          height: 768,
          thumbnail: true,
        },
        location: [47.223113, -1.581272],
        genre: 'Callicarpa',
        cultivar: 'Profusion',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581272, 47.223113] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8f0616f1b93e9829f0626efde382dc4f796646c0',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'occidentalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 146, 52, 1.00)',
            'rgba(139, 142, 74, 1.00)',
            'rgba(107, 136, 52, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/calycanthus/calycanthus occidentalis/calycanthus occidentalis (2).jpg',
          width: 1024,
          id: '4c265f610ab738a20d9dde5a729e2428',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 179, 140, 1.00)',
            'rgba(99, 129, 57, 1.00)',
            'rgba(91, 120, 51, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/calycanthus/calycanthus occidentalis/calycanthus occidentalis.jpg',
          width: 1024,
          id: '60bc1c33e6ca551a2713511261505046',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 150, 102, 1.00)',
            'rgba(127, 148, 80, 1.00)',
            'rgba(119, 157, 66, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/calycanthus/calycanthus occidentalis/calycanthus occidentalis (1).jpg',
          width: 703,
          id: 'f5547bcb97545c3d6ce5a50f0a2242e5',
          height: 768,
          thumbnail: true,
        },
        location: [47.219703, -1.54282],
        genre: 'Calycanthus',
        famille: 'Calycanthaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54282, 47.219703] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0dc48bdd1e557c6d30f599cd8e44d2ed5ddc7d08',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'grijsii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 120, 87, 1.00)',
            'rgba(106, 128, 94, 1.00)',
            'rgba(99, 112, 80, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia grijsii/camellia grijsii (1).jpg',
          width: 576,
          id: 'ade42ce9327cc90dea1c3f8a8a144454',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(185, 189, 179, 1.00)',
            'rgba(93, 103, 82, 1.00)',
            'rgba(82, 78, 68, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia grijsii/camellia grijsii (2).jpg',
          width: 576,
          id: 'e97aae6038c24f770222d501c365d5bb',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 157, 125, 1.00)',
            'rgba(80, 91, 68, 1.00)',
            'rgba(68, 64, 54, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia grijsii/camellia grijsii  (2).jpg',
          width: 1024,
          id: 'e540e5da8b01ceaf55a9e1d99c862d09',
          height: 683,
          thumbnail: true,
        },
        location: [47.220247, -1.54168],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54168, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c8931cd8219f9946b896e28c4bbee53bb57fda62',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(64, 73, 61, 1.00)',
            'rgba(110, 84, 91, 1.00)',
            'rgba(69, 57, 56, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'elizabeth pink'/camellia japonica 'elizabeth pink'.jpg",
          width: 1024,
          id: 'd4cceb21bedd84922c427934abecd305',
          height: 683,
          thumbnail: true,
        },
        location: [47.219983, -1.543953],
        genre: 'Camellia',
        cultivar: 'Elizabeth Pink',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543953, 47.219983] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a25d6f572def76250dfbdcfcefdee342e2209dcf',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(63, 76, 65, 1.00)',
            'rgba(107, 91, 83, 1.00)',
            'rgba(67, 63, 61, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'tama-no-ura'/camellia japonica 'tama-no-ura' (2).jpg",
          width: 1024,
          id: 'be9bc85e85a19724044252c0ca29e84f',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 115, 104, 1.00)',
            'rgba(121, 127, 118, 1.00)',
            'rgba(98, 104, 97, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'tama-no-ura'/camellia japonica 'tama-no-ura' (1).jpg",
          width: 1024,
          id: '41016db3400d2078c7e460cf2f1f94e3',
          height: 683,
          thumbnail: true,
        },
        location: [47.220247, -1.54168],
        genre: 'Camellia',
        cultivar: 'Tama-no-ura',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54168, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '57f4059f180513e5b7f608b9cacb63e3a377baf1',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'lutchuensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 130, 114, 1.00)',
            'rgba(127, 133, 113, 1.00)',
            'rgba(96, 105, 84, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia lutchuensis/camellia lutchuensis  (3).jpg',
          width: 576,
          id: '661ffb24dbfdf573cb34b492b3559618',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 119, 76, 1.00)',
            'rgba(107, 120, 79, 1.00)',
            'rgba(49, 53, 31, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia lutchuensis/camellia lutchuensis (1).jpg',
          width: 576,
          id: '91f44168b082cad2687d5a7f7df299de',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 91, 64, 1.00)',
            'rgba(114, 120, 100, 1.00)',
            'rgba(76, 83, 61, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia lutchuensis/camellia lutchuensis  (2).jpg',
          width: 576,
          id: '10bf70b5aef3d5137f42628c89dd50b7',
          height: 768,
          thumbnail: true,
        },
        location: [47.220247, -1.54168],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54168, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3b0c5f09f00686e1fba23db638023c1d9439bbb2',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(37, 35, 28, 1.00)',
            'rgba(107, 79, 70, 1.00)',
            'rgba(83, 60, 60, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia sasanqua 'grady's egao'/camellia sasanqua 'grady's egao'.jpg",
          width: 1024,
          id: '8d4e371427c5dddf5b15867df051ae86',
          height: 683,
          thumbnail: true,
        },
        espece: 'sasanqua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 73, 73, 1.00)',
            'rgba(145, 102, 86, 1.00)',
            'rgba(122, 73, 65, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia sasanqua 'grady's egao'/camellia sasanqua 'grady's egao' (2).jpg",
          width: 1024,
          id: '0f2007513f00bbf4400a61a65be9de6d',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(38, 34, 27, 1.00)',
            'rgba(111, 83, 72, 1.00)',
            'rgba(53, 41, 39, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia sasanqua 'grady's egao'/camellia sasanqua 'grady's egao' (1).jpg",
          width: 1024,
          id: '95a3ad859e46f8f6594389f40cbe36e8',
          height: 683,
          thumbnail: true,
        },
        location: [47.220247, -1.54168],
        genre: 'Camellia',
        cultivar: "Grady's Egao",
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54168, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '663fa3d0f1208cb2c4a48d3195f695f87a1ba872',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'amplexicaulis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 164, 138, 1.00)',
            'rgba(103, 116, 84, 1.00)',
            'rgba(77, 100, 67, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/camellia/camellia amplexicaulis/camellia amplexicaulis (3).jpg',
          width: 612,
          id: '88388c6c67f3b0f0a1d3eb36556168fb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 113, 106, 1.00)',
            'rgba(153, 94, 117, 1.00)',
            'rgba(97, 90, 82, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/camellia/camellia amplexicaulis/camellia amplexicaulis (4).jpg',
          width: 628,
          id: 'ed5c1b5e99fd932898d0a9274447afe8',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 131, 122, 1.00)',
            'rgba(100, 119, 112, 1.00)',
            'rgba(102, 110, 94, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/camellia/camellia amplexicaulis/camellia amplexicaulis (2).jpg',
          width: 652,
          id: '2cb353b3ab5dd62079ea4681a53ff213',
          height: 768,
          thumbnail: true,
        },
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '284a7e5efeb3644e54133a43214e2303e1635247',
      fields: {
        espece: 'sasanqua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 154, 129, 1.00)',
            'rgba(94, 104, 79, 1.00)',
            'rgba(66, 69, 52, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/camellia/camellia sasanqua 'plantation pink'/camellia sasanqua 'plantation pink' (2).jpg",
          width: 1024,
          id: 'e50214dd693ec9dbb2241ddd647baf39',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 121, 105, 1.00)',
            'rgba(120, 97, 91, 1.00)',
            'rgba(60, 48, 48, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/camellia/camellia sasanqua 'plantation pink'/camellia sasanqua 'plantation pink' (1).jpg",
          width: 1024,
          id: 'e3d299fa4e410756040ad9b32dce615c',
          height: 694,
          thumbnail: true,
        },
        location: [47.262538, -1.531087],
        genre: 'Camellia',
        cultivar: 'Plantation Pink',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531087, 47.262538] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '24711dc95efbffbbbd9a9854dd85e59f6577b706',
      fields: {
        espece: 'californica',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 95, 67, 1.00)',
            'rgba(93, 99, 77, 1.00)',
            'rgba(53, 63, 43, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/carpenteria/carpenteria californica/carpenteria californica (2).jpg',
          width: 1024,
          id: '1cb4c418dc1bea7a23bccf22de7b19d4',
          height: 683,
          thumbnail: true,
        },
        location: [47.261692, -1.533358],
        genre: 'Carpenteria',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533358, 47.261692] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7489c01115dbe5a63996c43318b054081f7b42b2',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 141, 73, 1.00)',
            'rgba(101, 146, 70, 1.00)',
            'rgba(101, 146, 63, 1.00)',
          ],
          filename:
            "ip foyer des anciens/carpinus/carpinus betulus 'quercifolia'/carpinus betulus 'quercifolia' (3).jpg",
          width: 576,
          id: '18f6b4ada7996e061ef9f56507a7139c',
          height: 768,
          thumbnail: true,
        },
        espece: 'betulus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 182, 144, 1.00)',
            'rgba(81, 105, 61, 1.00)',
            'rgba(92, 115, 65, 1.00)',
          ],
          filename:
            "ip foyer des anciens/carpinus/carpinus betulus 'quercifolia'/carpinus betulus 'quercifolia' (2).jpg",
          width: 1024,
          id: 'e1c1f4786ea3b9e994bd53682ae156f7',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Foyer des Anciens',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 111, 61, 1.00)',
            'rgba(128, 143, 90, 1.00)',
            'rgba(106, 131, 65, 1.00)',
          ],
          filename:
            "ip foyer des anciens/carpinus/carpinus betulus 'quercifolia'/carpinus betulus 'quercifolia' (1).jpg",
          width: 576,
          id: '3a52ee60462cd84b2ad9115b2e1a3157',
          height: 768,
          thumbnail: true,
        },
        location: [47.231545, -1.582112],
        genre: 'Carpinus',
        cultivar: 'Quercifolia',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582112, 47.231545] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6f25078280fd4ee4a1c46e21209df90e8ed57784',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'caroliniana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 141, 119, 1.00)',
            'rgba(89, 99, 61, 1.00)',
            'rgba(97, 116, 62, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/carpinus/carpinus caroliniana/carpinus caroliniana (2).jpg',
          width: 576,
          id: '9dd506f69e7eaeb9f2a30a29d742969f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 127, 67, 1.00)',
            'rgba(136, 145, 77, 1.00)',
            'rgba(129, 142, 73, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/carpinus/carpinus caroliniana/carpinus caroliniana (3).jpg',
          width: 576,
          id: '40e65d2b0602f0aca428a34383b8a2cb',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 88, 43, 1.00)',
            'rgba(158, 117, 68, 1.00)',
            'rgba(113, 85, 38, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/carpinus/carpinus caroliniana/carpinus caroliniana (1).jpg',
          width: 576,
          id: '3c50eb52ddc443b1409693cd88e728ff',
          height: 768,
          thumbnail: true,
        },
        location: [47.218517, -1.542575],
        genre: 'Carpinus',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542575, 47.218517] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4f6a9b17492dcc11d984a57955e3aea69bd9f025',
      fields: {
        espece: 'betulus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 146, 117, 1.00)',
            'rgba(87, 103, 76, 1.00)',
            'rgba(96, 109, 84, 1.00)',
          ],
          filename:
            "ip parc de la gaudiniere/carpinus/carpinus betulus 'pendula'/carpinus betulus 'pendula' (2).jpg",
          width: 1024,
          id: '968e8713a6fc640685c964667be97ecc',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc de la Gaudini\u00e8re',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 154, 119, 1.00)',
            'rgba(98, 110, 85, 1.00)',
            'rgba(93, 106, 77, 1.00)',
          ],
          filename:
            "ip parc de la gaudiniere/carpinus/carpinus betulus 'pendula'/carpinus betulus 'pendula' (1).jpg",
          width: 1024,
          id: 'cb052dfa5e1fe20914c53a9a5c5c9519',
          height: 683,
          thumbnail: true,
        },
        location: [47.245192, -1.579358],
        genre: 'Carpinus',
        cultivar: 'Pendula',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.579358, 47.245192] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '958853826ff80fb7baf26403fbcdde0560382c87',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'occidentalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 105, 60, 1.00)',
            'rgba(114, 135, 66, 1.00)',
            'rgba(133, 151, 84, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cephalanthus/cephalanthus occidentalis/cephalanthus occidentalis  (2).jpg',
          width: 1024,
          id: '5f481bf9dbfebf20bcaca5ac9ac6fc60',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 127, 69, 1.00)',
            'rgba(118, 143, 67, 1.00)',
            'rgba(91, 124, 48, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cephalanthus/cephalanthus occidentalis/cephalanthus occidentalis (1).jpg',
          width: 988,
          id: '78af78619cb6317d5a11967bb6f3bb9a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 112, 63, 1.00)',
            'rgba(135, 158, 86, 1.00)',
            'rgba(111, 125, 61, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cephalanthus/cephalanthus occidentalis/cephalanthus occidentalis  (1).jpg',
          width: 1024,
          id: 'eb1049f6a7913ae725c1ddae1826a781',
          height: 768,
          thumbnail: true,
        },
        location: [47.219088, -1.543262],
        genre: 'Cephalanthus',
        famille: 'Rubiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543262, 47.219088] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7df9a07c81d0e1d020961105ad7ceff055737c89',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(178, 178, 179, 1.00)',
            'rgba(78, 80, 54, 1.00)',
            'rgba(71, 64, 52, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/chimonanthus/chimonanthus praecox 'luteus'/chimonanthus praecox 'luteus' (1).jpg",
          width: 576,
          id: '3050864ca2b31ecc79241e8583d28c9f',
          height: 768,
          thumbnail: true,
        },
        espece: 'praecox',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 131, 119, 1.00)',
            'rgba(122, 118, 77, 1.00)',
            'rgba(101, 98, 64, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/chimonanthus/chimonanthus praecox 'luteus'/chimonanthus praecox 'luteus'  (2).jpg",
          width: 1024,
          id: 'd8edbc98e1a7bfcfad357723c9b5e178',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 118, 140, 1.00)',
            'rgba(120, 120, 90, 1.00)',
            'rgba(60, 58, 29, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/chimonanthus/chimonanthus praecox 'luteus'/chimonanthus praecox 'luteus'  (1).jpg",
          width: 1024,
          id: 'cc2a90b4f7fc79d02f6e1614ffb0be09',
          height: 683,
          thumbnail: true,
        },
        location: [47.2197, -1.542778],
        genre: 'Chimonanthus',
        cultivar: 'Luteus',
        famille: 'Calycanthaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542778, 47.2197] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4e6b515833414b0a91ff655c4ffc0a64c47178ae',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'virginicus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 99, 58, 1.00)',
            'rgba(112, 131, 73, 1.00)',
            'rgba(44, 56, 26, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/chionanthus/chionanthus virginicus/chionanthus virginicus (11).jpg',
          width: 1024,
          id: '97a58894baf12c6b6f9842344fba423b',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(60, 71, 43, 1.00)',
            'rgba(100, 115, 70, 1.00)',
            'rgba(72, 80, 43, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/chionanthus/chionanthus virginicus/chionanthus virginicus (12).jpg',
          width: 1024,
          id: '0750cefa492cc1ca010373febe16e474',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 123, 74, 1.00)',
            'rgba(97, 124, 79, 1.00)',
            'rgba(71, 99, 57, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/chionanthus/chionanthus virginicus/chionanthus virginicus (10).jpg',
          width: 1024,
          id: '2443b29645e1bef83b836282d5daedf1',
          height: 683,
          thumbnail: true,
        },
        location: [47.261703, -1.529675],
        genre: 'Chionanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529675, 47.261703] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '88b841a920b787a5cf4ffcc05b29c575f3039d80',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 103, 59, 1.00)',
            'rgba(121, 136, 79, 1.00)',
            'rgba(117, 121, 88, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cleyera pentaphylacaceae/cleyera japonica 'fortunei'/cleyera japonica 'fortunei' (4).jpg",
          width: 1024,
          id: 'c5b1f34c4ab24845dc7e33e4509b2dea',
          height: 768,
          thumbnail: true,
        },
        location: [47.269978, -1.585787],
        genre: 'Cleyera',
        cultivar: 'Fortunei',
        famille: 'Pentaphylacaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585787, 47.269978] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f599a0cb05c978960ac6f4e5c781a90c434f91fb',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 137, 28, 1.00)',
            'rgba(125, 138, 50, 1.00)',
            'rgba(87, 102, 23, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cleyera pentaphylacaceae/cleyera japonica/cleyera japonica (4).jpg',
          width: 576,
          id: '332d3be911e7ae268ed2fbce47bef5ff',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 119, 66, 1.00)',
            'rgba(120, 137, 61, 1.00)',
            'rgba(133, 125, 83, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cleyera pentaphylacaceae/cleyera japonica/cleyera japonica (5).jpg',
          width: 1024,
          id: '4f13e605df2e6bbf466d2cc48afef9b7',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 141, 74, 1.00)',
            'rgba(151, 146, 64, 1.00)',
            'rgba(141, 147, 64, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cleyera pentaphylacaceae/cleyera japonica/cleyera japonica (1).jpg',
          width: 576,
          id: 'bc29301bd095b40a6cdc71685d60e688',
          height: 768,
          thumbnail: true,
        },
        location: [47.269495, -1.584862],
        genre: 'Cleyera',
        famille: 'Pentaphylacaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584862, 47.269495] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'acddf90b9c4f06867556af1998d686a965ca6d2e',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 85, 37, 1.00)',
            'rgba(129, 133, 92, 1.00)',
            'rgba(105, 107, 55, 1.00)',
          ],
          filename:
            "ip parc de proce/cornus/cornus florida 'clair de lune'/cornus florida 'clair de lune' (2).jpg",
          width: 1024,
          id: 'be9639c909950d24f85b87c84a21682f',
          height: 768,
          thumbnail: true,
        },
        espece: 'florida',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(53, 59, 16, 1.00)',
            'rgba(157, 160, 135, 1.00)',
            'rgba(110, 108, 69, 1.00)',
          ],
          filename:
            "ip parc de proce/cornus/cornus florida 'clair de lune'/cornus florida 'clair de lune' (1).jpg",
          width: 576,
          id: 'dcd6b7d0164ed46c982ec46d6fac45b3',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 114, 67, 1.00)',
            'rgba(105, 123, 47, 1.00)',
            'rgba(72, 98, 37, 1.00)',
          ],
          filename:
            "ip parc de proce/cornus/cornus florida 'clair de lune'/cornus florida 'clair de lune'  (2).jpg",
          width: 1024,
          id: '6d3f259c44c0e3cb99fb670c93d75d7d',
          height: 768,
          thumbnail: true,
        },
        location: [47.22552, -1.581608],
        genre: 'Cornus',
        cultivar: 'Clair de Lune',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581608, 47.22552] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '70cd3cdd7a9343dbf77f11da36b3d0a78de55b61',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'florida f. rubra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 98, 99, 1.00)',
            'rgba(170, 116, 132, 1.00)',
            'rgba(157, 116, 121, 1.00)',
          ],
          filename:
            'ip parc de proce/cornus/cornus florida f. rubra/cornus florida f. rubra (2).jpg',
          width: 576,
          id: '70ffaef09f2409a152f78da93e338101',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(180, 176, 174, 1.00)',
            'rgba(111, 103, 76, 1.00)',
            'rgba(122, 115, 82, 1.00)',
          ],
          filename:
            'ip parc de proce/cornus/cornus florida f. rubra/cornus florida f. rubra (3).jpg',
          width: 1024,
          id: '0f5f8e44cfb4b393c2f5815c2d96c19b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 107, 102, 1.00)',
            'rgba(170, 129, 126, 1.00)',
            'rgba(109, 91, 67, 1.00)',
          ],
          filename:
            'ip parc de proce/cornus/cornus florida f. rubra/cornus florida f. rubra (1).jpg',
          width: 1024,
          id: '9399bb89b08d35890c8b751a34c21e85',
          height: 768,
          thumbnail: true,
        },
        location: [47.225212, -1.582975],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582975, 47.225212] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f4c082a2dbcc94dd4ca6ec8ef9e4cb932de5fe06',
      fields: {
        espece: 'mas',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(207, 203, 193, 1.00)',
            'rgba(136, 134, 82, 1.00)',
            'rgba(87, 82, 48, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/cornus/cornus mas/cornus mas.jpg',
          width: 1024,
          id: 'd5fe599ef081d39ee428117fd2811bd8',
          height: 768,
          thumbnail: true,
        },
        location: [47.261717, -1.529953],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529953, 47.261717] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3161d2b8c18ea9b147867a178ffded27046f9c70',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 110, 67, 1.00)',
            'rgba(147, 138, 75, 1.00)',
            'rgba(128, 116, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylopsis hamamelidaceae/corylopsis pauciflora/corylopsis pauciflora (11).jpg',
          width: 576,
          id: '3d536098477613869508a44a981b4f07',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 86, 55, 1.00)',
            'rgba(150, 138, 85, 1.00)',
            'rgba(107, 89, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylopsis hamamelidaceae/corylopsis pauciflora/corylopsis pauciflora (10).jpg',
          width: 1024,
          id: '575dff02a513a966a3aa65e2bf20b6e1',
          height: 768,
          thumbnail: true,
        },
        location: [47.27165, -1.582255],
        genre: 'Corylopsis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582255, 47.27165] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6b011acc4a2dad732b1b6b89671cd56002d3ea5f',
      fields: {
        genre: 'Corylopsis',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(179, 178, 177, 1.00)',
            'rgba(137, 132, 86, 1.00)',
            'rgba(86, 79, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylopsis hamamelidaceae/corylopsis pauciflora/corylopsis pauciflora (5).jpg',
          width: 576,
          id: '18dcff202911056628cf3e4bd9ecd18f',
          height: 768,
          thumbnail: true,
        },
        location: [47.270945, -1.586588],
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586588, 47.270945] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'aa117015433d4843379d486f980ab8fc26758295',
      fields: {
        espece: 'avellana',
        nom_du_site: 'Foyer des Anciens',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 184, 149, 1.00)',
            'rgba(69, 93, 40, 1.00)',
            'rgba(110, 129, 74, 1.00)',
          ],
          filename:
            "ip foyer des anciens/corylus/corylus avellana 'contorta'/corylus avellana 'contorta'.jpg",
          width: 1024,
          id: '7cddbd83aae2b142dcfbb620b1ab3180',
          height: 768,
          thumbnail: true,
        },
        location: [47.231742, -1.582408],
        genre: 'Corylus',
        cultivar: 'Contorta',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582408, 47.231742] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b2c9cdd44ce81b1115f5ac1961c5e2cbb57e7798',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 157, 136, 1.00)',
            'rgba(123, 115, 77, 1.00)',
            'rgba(129, 109, 86, 1.00)',
          ],
          filename:
            "ip parc de proce/corylus/corylus avellana 'contorta'/corylus avellana 'contorta' (3).jpg",
          width: 576,
          id: '19526cebecd4687276d1fd8a70a33d75',
          height: 768,
          thumbnail: true,
        },
        espece: 'avellana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 164, 164, 1.00)',
            'rgba(123, 116, 91, 1.00)',
            'rgba(96, 84, 52, 1.00)',
          ],
          filename:
            "ip parc de proce/corylus/corylus avellana 'contorta'/corylus avellana 'contorta' (2).jpg",
          width: 1024,
          id: '5d4637c891b67cfde9bdf731a57d94a6',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 112, 76, 1.00)',
            'rgba(118, 106, 71, 1.00)',
            'rgba(125, 112, 76, 1.00)',
          ],
          filename:
            "ip parc de proce/corylus/corylus avellana 'contorta'/corylus avellana 'contorta' (1).jpg",
          width: 576,
          id: 'bb8d65f9ffa3abd30bf71b6e2a51eedb',
          height: 768,
          thumbnail: true,
        },
        location: [47.222792, -1.58072],
        genre: 'Corylus',
        cultivar: 'Contorta',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58072, 47.222792] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2b1494b8e088b5cbc30c78b259408a7e84b70c27',
      fields: {
        espece: 'coggygria',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(200, 189, 166, 1.00)',
            'rgba(116, 110, 80, 1.00)',
            'rgba(77, 89, 49, 1.00)',
          ],
          filename:
            "ip ville de nantes/cotinus/cotinus coggygria 'royal purple'/cotinus coggygria 'royal purple'.jpg",
          width: 1024,
          id: 'a51a9d877ec763092a8b02caa1ebd469',
          height: 768,
          thumbnail: true,
        },
        location: [47.2266, -1.581088],
        genre: 'Cotinus',
        cultivar: 'Royal Purple',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581088, 47.2266] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f123623cb9fabc89195b7abc2a1692ca8f12f3b4',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'patagua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 119, 61, 1.00)',
            'rgba(103, 139, 93, 1.00)',
            'rgba(127, 149, 122, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/crinodendron/crinodendron patagua/crinodendron patagua (2).jpg',
          width: 576,
          id: '125f616aab4006832dd94f9a00054906',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 149, 133, 1.00)',
            'rgba(127, 133, 119, 1.00)',
            'rgba(111, 114, 110, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/crinodendron/crinodendron patagua/crinodendron patagua (3).jpg',
          width: 576,
          id: 'd691832bca309bdc2b64feac49414d16',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(65, 88, 34, 1.00)',
            'rgba(95, 130, 93, 1.00)',
            'rgba(111, 131, 104, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/crinodendron/crinodendron patagua/crinodendron patagua (1).jpg',
          width: 576,
          id: '208121f6058daf91199ca1b1804e7275',
          height: 768,
          thumbnail: true,
        },
        location: [47.220255, -1.541853],
        genre: 'Crinodendron',
        famille: 'Elaeocarpaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541853, 47.220255] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ca7a0e84b344ad481f32c06d5fb5c8668bf7861f',
      fields: {
        espece: 'involucrata',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(216, 221, 202, 1.00)',
            'rgba(127, 138, 100, 1.00)',
            'rgba(98, 118, 54, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/davidia/davidia involucrata/davidia involucrata.jpg',
          width: 1024,
          id: '8c03aadc6e3b1f473ab8a0e6ca331056',
          height: 768,
          thumbnail: true,
        },
        location: [47.260755, -1.534],
        genre: 'Davidia',
        famille: 'Nyssaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534, 47.260755] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0802c82b342fc35bdd5054cac90c1998cb852f4f',
      fields: {
        nom_du_site: 'Autre site',
        espece: 'virginiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 149, 182, 1.00)',
            'rgba(93, 105, 76, 1.00)',
            'rgba(130, 135, 108, 1.00)',
          ],
          filename:
            'ip ville de nantes/diospyros/diospyros virginiana/diospyros virginiana (2).jpg',
          width: 576,
          id: 'be86163f4ec79dcceb3854db93bee9ae',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 99, 82, 1.00)',
            'rgba(135, 145, 104, 1.00)',
            'rgba(87, 101, 58, 1.00)',
          ],
          filename:
            'ip ville de nantes/diospyros/diospyros virginiana/diospyros virginiana (3).jpg',
          width: 576,
          id: 'e5b465e70bd4fcec74fbe3175f3a21ff',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 122, 119, 1.00)',
            'rgba(129, 128, 131, 1.00)',
            'rgba(143, 140, 147, 1.00)',
          ],
          filename:
            'ip ville de nantes/diospyros/diospyros virginiana/diospyros virginiana (1).jpg',
          width: 576,
          id: '7f07a778c0b6b1fc31177bb41ed71461',
          height: 768,
          thumbnail: true,
        },
        location: [47.196713, -1.536917],
        genre: 'Diospyros',
        famille: 'Ebenaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.536917, 47.196713] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6974a9807a077268786eed70283e729386e4e1ee',
      fields: {
        espece: 'myricoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 165, 131, 1.00)',
            'rgba(109, 142, 93, 1.00)',
            'rgba(73, 92, 52, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/distylium/distylium myricoides/distylium myricoides (2).jpg',
          width: 576,
          id: '9a1012212ef192b7493ad2f6d0229096',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 102, 95, 1.00)',
            'rgba(116, 132, 89, 1.00)',
            'rgba(110, 132, 86, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/distylium/distylium myricoides/distylium myricoides (1).jpg',
          width: 576,
          id: '0ca0f64f3d4d3bd2aaa6f30fe4cf2baa',
          height: 768,
          thumbnail: true,
        },
        location: [47.218833, -1.541203],
        genre: 'Distylium',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541203, 47.218833] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '80f9c837dbcbb8efb7287aadf4f1002afa57e2fb',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'chrysantha',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 112, 95, 1.00)',
            'rgba(133, 120, 112, 1.00)',
            'rgba(125, 111, 105, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/edgeworthia/edgeworthia chrysantha/edgeworthia chrysantha (1).jpg',
          width: 512,
          id: 'b399aee7c3f18a452bb2814e497359ee',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 113, 88, 1.00)',
            'rgba(138, 124, 91, 1.00)',
            'rgba(114, 86, 70, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/edgeworthia/edgeworthia chrysantha/edgeworthia chrysantha (2).jpg',
          width: 969,
          id: '1c6e18edf2dc7a678b19d1739a583727',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 128, 81, 1.00)',
            'rgba(97, 87, 37, 1.00)',
            'rgba(71, 59, 42, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/edgeworthia/edgeworthia chrysantha/edgeworthia chrysantha  (2).jpg',
          width: 1024,
          id: 'c792af02bb327811af8a49d1e532f01f',
          height: 721,
          thumbnail: true,
        },
        location: [47.22942, -1.507267],
        genre: 'Edgeworthia',
        famille: 'Thymelaeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507267, 47.22942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f0b083451aeb62929a6540e62012c3bb55e0b2aa',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'myoporoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 147, 145, 1.00)',
            'rgba(146, 151, 149, 1.00)',
            'rgba(94, 98, 92, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/eriostemon/eriostemon myoporoides/eriostemon myoporoides (2).jpg',
          width: 576,
          id: '4af14df563537c8f08cdd87b80ba8931',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 124, 119, 1.00)',
            'rgba(134, 133, 128, 1.00)',
            'rgba(106, 106, 103, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/eriostemon/eriostemon myoporoides/eriostemon myoporoides (3).jpg',
          width: 576,
          id: '2833a7442ff0b1baf2daf1d1bfb0c677',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 153, 151, 1.00)',
            'rgba(132, 145, 142, 1.00)',
            'rgba(101, 111, 103, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/eriostemon/eriostemon myoporoides/eriostemon myoporoides (1).jpg',
          width: 576,
          id: '62e2ae621ab9dc58ae4fff52068f7881',
          height: 768,
          thumbnail: true,
        },
        location: [47.21847, -1.542378],
        genre: 'Eriostemon',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542378, 47.21847] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1274be229003269c33c40560a93624fbaca82c22',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 119, 95, 1.00)',
            'rgba(123, 144, 105, 1.00)',
            'rgba(106, 135, 102, 1.00)',
          ],
          filename: 'ip parc de proce/eurya/eurya japonica/eurya japonica .jpg',
          width: 576,
          id: 'f61c30ed803bafd224933b9fbd93f60f',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 135, 119, 1.00)',
            'rgba(111, 116, 73, 1.00)',
            'rgba(127, 114, 76, 1.00)',
          ],
          filename:
            'ip parc de proce/eurya/eurya japonica/eurya japonica (2).jpg',
          width: 1024,
          id: '2d6917ad34f357ee299417f91d78284e',
          height: 768,
          thumbnail: true,
        },
        location: [47.224392, -1.581163],
        genre: 'Eurya',
        famille: 'Pentaphylacaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581163, 47.224392] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8fb383f79efc1536399ac2f26a6ff6d80f61035a',
      fields: {
        espece: 'sylvatica',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 145, 33, 1.00)',
            'rgba(132, 151, 46, 1.00)',
            'rgba(108, 107, 54, 1.00)',
          ],
          filename:
            "ip parc de proce/fagus/fagus sylvatica 'albovariegata'/fagus sylvatica 'albovariegata'.jpg",
          width: 576,
          id: '638bbf3463c7e4ee9a325fb01c87e782',
          height: 768,
          thumbnail: true,
        },
        location: [47.222772, -1.584978],
        genre: 'Fagus',
        cultivar: 'Albovariegata',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584978, 47.222772] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '056d1956e5807f9c15c5f8806008f155f234c5fb',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 114, 87, 1.00)',
            'rgba(167, 134, 100, 1.00)',
            'rgba(153, 153, 93, 1.00)',
          ],
          filename:
            "ip parc de proce/fagus/fagus sylvatica 'purpurea tricolor'/fagus sylvatica 'purpurea tricolor' (2).jpg",
          width: 576,
          id: '4b7f2041b2dbf1f0100cfd72a96337e3',
          height: 768,
          thumbnail: true,
        },
        espece: 'sylvatica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 113, 85, 1.00)',
            'rgba(159, 131, 103, 1.00)',
            'rgba(141, 139, 81, 1.00)',
          ],
          filename:
            "ip parc de proce/fagus/fagus sylvatica 'purpurea tricolor'/fagus sylvatica 'purpurea tricolor' (1).jpg",
          width: 576,
          id: '9152b9c31ee105eed80010c8345ce6f8',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 147, 129, 1.00)',
            'rgba(111, 112, 88, 1.00)',
            'rgba(83, 95, 63, 1.00)',
          ],
          filename:
            "ip parc de proce/fagus/fagus sylvatica 'purpurea tricolor'/fagus sylvatica 'purpurea tricolor'  (2).jpg",
          width: 1024,
          id: 'e24eb58fb20ce6bc88ed3b9a6a272762',
          height: 768,
          thumbnail: true,
        },
        location: [47.222655, -1.584878],
        genre: 'Fagus',
        cultivar: 'Purpurea Tricolor',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584878, 47.222655] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd02dda6444ae4b2807ce75f78b6960170b75cf88',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'chinensis subsp. rhynchophylla',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 166, 84, 1.00)',
            'rgba(100, 150, 57, 1.00)',
            'rgba(111, 130, 65, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/fraxinus/fraxinus chinensis subsp. rhynchophylla/fraxinus chinensis subsp. rhynchophylla (2).jpg',
          width: 576,
          id: '3b05ca5ef5df489c71756bd118cbb46a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 140, 90, 1.00)',
            'rgba(130, 156, 110, 1.00)',
            'rgba(98, 121, 64, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/fraxinus/fraxinus chinensis subsp. rhynchophylla/fraxinus chinensis subsp. rhynchophylla (3).jpg',
          width: 576,
          id: 'aba07b7ef7491484374a2aa5cac6ab59',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 141, 64, 1.00)',
            'rgba(119, 160, 82, 1.00)',
            'rgba(105, 142, 63, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/fraxinus/fraxinus chinensis subsp. rhynchophylla/fraxinus chinensis subsp. rhynchophylla (1).jpg',
          width: 576,
          id: '3fed455fd811e5c938d34a8996c1c85e',
          height: 768,
          thumbnail: true,
        },
        location: [47.220358, -1.544825],
        genre: 'Fraxinus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544825, 47.220358] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '29b55d39009dbf0d653f0c75ec3919d02c2e3b09',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'excelsior f. diversifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 151, 123, 1.00)',
            'rgba(113, 141, 97, 1.00)',
            'rgba(75, 102, 45, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/fraxinus/fraxinus excelsior f. diversifolia/fraxinus excelsior f. diversifolia (2).jpg',
          width: 576,
          id: 'e362dee6efe184a6a9ca97912a15f894',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 141, 109, 1.00)',
            'rgba(105, 135, 92, 1.00)',
            'rgba(67, 90, 39, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/fraxinus/fraxinus excelsior f. diversifolia/fraxinus excelsior f. diversifolia (3).jpg',
          width: 576,
          id: '2f124d4a9d87a961345a1343392004e4',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 162, 119, 1.00)',
            'rgba(116, 144, 61, 1.00)',
            'rgba(85, 116, 51, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/fraxinus/fraxinus excelsior f. diversifolia/fraxinus excelsior f. diversifolia (1).jpg',
          width: 576,
          id: '39a1bfbadc361d6108e14bc543fab540',
          height: 768,
          thumbnail: true,
        },
        location: [47.219233, -1.541747],
        genre: 'Fraxinus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541747, 47.219233] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '65404d16c1dce405c0cd654c2d496003a5ff47d2',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'griffithii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 136, 81, 1.00)',
            'rgba(92, 114, 68, 1.00)',
            'rgba(65, 89, 52, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/fraxinus/fraxinus griffithii/fraxinus griffithii (2).jpg',
          width: 1024,
          id: '9418717ab49a802eba7f8ed654ebbbff',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 128, 65, 1.00)',
            'rgba(111, 131, 74, 1.00)',
            'rgba(158, 176, 106, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/fraxinus/fraxinus griffithii/fraxinus griffithii (3).jpg',
          width: 576,
          id: '0061aca0b8596e36c0266bfd1d56cb08',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 180, 153, 1.00)',
            'rgba(93, 120, 50, 1.00)',
            'rgba(71, 93, 38, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/fraxinus/fraxinus griffithii/fraxinus griffithii (1).jpg',
          width: 576,
          id: 'c95e44d6fbcd8baf83ee9c40f2e0570c',
          height: 768,
          thumbnail: true,
        },
        location: [47.219163, -1.542842],
        genre: 'Fraxinus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542842, 47.219163] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0062522a5d3d9bf91fea6603809aca06f6c074bd',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'latifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 162, 89, 1.00)',
            'rgba(110, 153, 72, 1.00)',
            'rgba(87, 135, 47, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/fraxinus/fraxinus latifolia/fraxinus latifolia  (2).jpg',
          width: 576,
          id: '043148680ae1782307db8ba82dcdf9bf',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 159, 106, 1.00)',
            'rgba(101, 130, 76, 1.00)',
            'rgba(71, 99, 40, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/fraxinus/fraxinus latifolia/fraxinus latifolia  (3).jpg',
          width: 576,
          id: 'cd5009c354ae46de9a81c1c2489f1ff1',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 171, 136, 1.00)',
            'rgba(98, 122, 65, 1.00)',
            'rgba(78, 93, 48, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/fraxinus/fraxinus latifolia/fraxinus latifolia  (1).jpg',
          width: 1024,
          id: '1ac8a62917d166d17fdc53152ef61a4f',
          height: 768,
          thumbnail: true,
        },
        location: [47.219117, -1.542987],
        genre: 'Fraxinus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542987, 47.219117] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c0fa3de27beaa975c6791449bc92318fdd75d8b3',
      fields: {
        espece: 'biloba',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 149, 190, 1.00)',
            'rgba(138, 136, 133, 1.00)',
            'rgba(84, 71, 31, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ginkgo/ginkgo biloba/gingko biloba.jpg',
          width: 769,
          id: '5e0eb7ed4eb75baa2ee9e77d0e02e768',
          height: 768,
          thumbnail: true,
        },
        location: [47.219497, -1.541505],
        genre: 'Ginkgo',
        famille: 'Ginkgoaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541505, 47.219497] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd15f3ef2975053e932336a35262647299133cabe',
      fields: {
        espece: 'triacanthos f. inermis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 168, 153, 1.00)',
            'rgba(105, 122, 91, 1.00)',
            'rgba(62, 75, 47, 1.00)',
          ],
          filename:
            "ip parc de proce/gleditsia/gleditsia triacanthos f. inermis 'sunburst'/gleditsia triacanthos f. inermis 'sunburst'.jpg",
          width: 576,
          id: '6c262d697b50bcd3e8419a3c9892e551',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 175, 98, 1.00)',
            'rgba(98, 131, 46, 1.00)',
            'rgba(69, 95, 53, 1.00)',
          ],
          filename:
            "ip parc de proce/gleditsia/gleditsia triacanthos f. inermis 'sunburst'/gleditsia triacanthos f. inermis 'sunburst' (2).jpg",
          width: 607,
          id: '77c36dc7d5c0a7e463bc78bb73a5a0c5',
          height: 768,
          thumbnail: true,
        },
        location: [47.22325, -1.582975],
        genre: 'Gleditsia',
        cultivar: 'Sunburst',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582975, 47.22325] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'df5a3d25ae0a4ac607b73887ff07b01bfc656375',
      fields: {
        espece: 'triacanthos',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 189, 88, 1.00)',
            'rgba(101, 140, 29, 1.00)',
            'rgba(93, 128, 20, 1.00)',
          ],
          filename:
            'ip parc de proce/gleditsia/gleditsia triacanthos/gleditsia triacanthos  (5).jpg',
          width: 576,
          id: 'da4666358523b9deb57fb750a784beb9',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 133, 37, 1.00)',
            'rgba(103, 124, 47, 1.00)',
            'rgba(157, 180, 97, 1.00)',
          ],
          filename:
            'ip parc de proce/gleditsia/gleditsia triacanthos/gleditsia triacanthos  (4).jpg',
          width: 1024,
          id: '4268a16fdcff74ef2ca0368e0c56cbdd',
          height: 768,
          thumbnail: true,
        },
        location: [47.22493, -1.582937],
        genre: 'Gleditsia',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582937, 47.22493] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cc1535d7450a3860ce6d4361e362cc4834fd8927',
      fields: {
        espece: 'virginiana',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 155, 139, 1.00)',
            'rgba(104, 115, 77, 1.00)',
            'rgba(54, 59, 39, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/hamamelis/hamamelis virginiana/hamamelis virginiana (2).jpg',
          width: 576,
          id: 'fc2bf12023385c344ba95969243449d5',
          height: 768,
          thumbnail: true,
        },
        location: [47.219013, -1.541172],
        genre: 'Hamamelis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541172, 47.219013] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '05c25c2b00646ccad6b3fcda01f15b460e5b3db6',
      fields: {
        espece: 'angustifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 140, 91, 1.00)',
            'rgba(100, 136, 76, 1.00)',
            'rgba(80, 111, 52, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/hoheria/hoheria angustifolia/hoheria angustifolia (2).jpg',
          width: 576,
          id: 'fb32e3b708830a079e5fafa02ce1e180',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 100, 71, 1.00)',
            'rgba(105, 124, 82, 1.00)',
            'rgba(85, 102, 53, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/hoheria/hoheria angustifolia/hoheria angustifolia (1).jpg',
          width: 576,
          id: 'f4b9351a65c53ecce654e024f15f42c1',
          height: 768,
          thumbnail: true,
        },
        location: [47.261892, -1.534455],
        genre: 'Hoheria',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534455, 47.261892] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e571d0b230087ad4d434677f3e0b7eba02be54d8',
      fields: {
        espece: 'latifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 146, 137, 1.00)',
            'rgba(110, 121, 103, 1.00)',
            'rgba(73, 81, 59, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ilex/ilex latifolia/ilex latifolia (2).jpg',
          width: 512,
          id: '252ab1acd7fa575ff7bb02499fe4416c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 110, 67, 1.00)',
            'rgba(97, 116, 82, 1.00)',
            'rgba(84, 98, 65, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ilex/ilex latifolia/ilex latifolia (1).jpg',
          width: 1024,
          id: '1880eff1d067bacb7fe35d744ba90543',
          height: 683,
          thumbnail: true,
        },
        location: [47.219805, -1.541933],
        genre: 'Ilex',
        famille: 'Aquifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541933, 47.219805] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2daa5d08559bc5d23d9ddef34dcc627da85cb2d2',
      fields: {
        nom_du_site: 'Autre site',
        espece: 'nigra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 139, 155, 1.00)',
            'rgba(131, 112, 69, 1.00)',
            'rgba(74, 66, 44, 1.00)',
          ],
          filename:
            'ip ville de nantes/juglans/juglans nigra/juglans nigra (2).jpg',
          width: 546,
          id: 'd06e8a69011bf9095a526cd4f3665d5c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 137, 161, 1.00)',
            'rgba(123, 118, 100, 1.00)',
            'rgba(75, 68, 47, 1.00)',
          ],
          filename:
            'ip ville de nantes/juglans/juglans nigra/juglans nigra (3).jpg',
          width: 1024,
          id: 'b9bcc4b1cb3850e5055db3c8dc3b3249',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 132, 131, 1.00)',
            'rgba(137, 121, 81, 1.00)',
            'rgba(78, 66, 34, 1.00)',
          ],
          filename:
            'ip ville de nantes/juglans/juglans nigra/juglans nigra (1).jpg',
          width: 512,
          id: '2001fc082e1343f1df78c85c29c2f77a',
          height: 768,
          thumbnail: true,
        },
        location: [47.248075, -1.577122],
        genre: 'Juglans',
        famille: 'Juglandaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.577122, 47.248075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3deb65e7242cdef898dc7eb78194bc6081a64d1a',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(179, 122, 133, 1.00)',
            'rgba(200, 91, 137, 1.00)',
            'rgba(119, 73, 77, 1.00)',
          ],
          filename:
            "ip parc de proce/kalmia/kalmia latifolia 'olympic fire'/kalmia latifolia 'olympic fire'  (3).jpg",
          width: 576,
          id: '668f1fa92439040321eb9035d2eb2ce5',
          height: 768,
          thumbnail: true,
        },
        espece: 'latifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 108, 50, 1.00)',
            'rgba(149, 101, 108, 1.00)',
            'rgba(77, 72, 46, 1.00)',
          ],
          filename:
            "ip parc de proce/kalmia/kalmia latifolia 'olympic fire'/kalmia latifolia 'olympic fire'  (2).jpg",
          width: 576,
          id: 'a9749ffb1220136577be4481bd059ee6',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 120, 65, 1.00)',
            'rgba(102, 118, 67, 1.00)',
            'rgba(103, 113, 69, 1.00)',
          ],
          filename:
            "ip parc de proce/kalmia/kalmia latifolia 'olympic fire'/kalmia latifolia 'olympic fire'  (1).jpg",
          width: 576,
          id: 'fbe6f2de08968ceb0fe7b3284bcc678b',
          height: 768,
          thumbnail: true,
        },
        location: [47.22537, -1.58138],
        genre: 'Kalmia',
        cultivar: 'Olympic Fire',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58138, 47.22537] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2255e9f9b5cc7b23e7dadb51c8917e0d421cea45',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 76, 17, 1.00)',
            'rgba(147, 121, 14, 1.00)',
            'rgba(101, 86, 30, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/kerria/kerria japonica 'pleniflora'/kerria japonica 'pleniflora' (3).jpg",
          width: 576,
          id: 'd30e7014328e24b83fc7932713b57b66',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(205, 198, 178, 1.00)',
            'rgba(113, 105, 44, 1.00)',
            'rgba(78, 86, 60, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/kerria/kerria japonica 'pleniflora'/kerria japonica 'pleniflora' (2).jpg",
          width: 1024,
          id: '50dcc89a7a5564c418f071c508a2551b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(171, 168, 84, 1.00)',
            'rgba(128, 140, 64, 1.00)',
            'rgba(109, 125, 62, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/kerria/kerria japonica 'pleniflora'/kerria japonica 'pleniflora' (1).jpg",
          width: 576,
          id: '3baaf57ed95d10fa87bf94a0741614ed',
          height: 768,
          thumbnail: true,
        },
        location: [47.2203, -1.542955],
        genre: 'Kerria',
        cultivar: 'Pleniflora',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542955, 47.2203] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '78f256f4550835e189939a91f5dfa58438d57fd4',
      fields: {
        espece: 'paniculata',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 102, 46, 1.00)',
            'rgba(103, 114, 50, 1.00)',
            'rgba(96, 112, 48, 1.00)',
          ],
          filename:
            'ip ville de nantes/koelreuteria/koelreuteria paniculata/koelreuteria paniculata (2).jpg',
          width: 600,
          id: 'a9b7af8b4d395a1b20ca90c92b91d43b',
          height: 768,
          thumbnail: true,
        },
        location: [47.193672, -1.53238],
        genre: 'Koelreuteria',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53238, 47.193672] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '16436efa0a11fe72b76a7815b20ed2fe32acf62f',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 137, 73, 1.00)',
            'rgba(127, 131, 63, 1.00)',
            'rgba(89, 99, 37, 1.00)',
          ],
          filename:
            "ip ville de nantes/ligustrum/ligustrum lucidum 'aureomarginatum'/ligustrum lucidum 'aureomarginatum' (3).jpg",
          width: 576,
          id: '71af0877701cfc78dc43e5ac86e03f98',
          height: 768,
          thumbnail: true,
        },
        espece: 'lucidum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 170, 119, 1.00)',
            'rgba(128, 141, 54, 1.00)',
            'rgba(121, 127, 37, 1.00)',
          ],
          filename:
            "ip ville de nantes/ligustrum/ligustrum lucidum 'aureomarginatum'/ligustrum lucidum 'aureomarginatum' (2).jpg",
          width: 576,
          id: '47bf9214f6f4635b552eedc289a5862b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(196, 208, 211, 1.00)',
            'rgba(146, 147, 115, 1.00)',
            'rgba(118, 116, 96, 1.00)',
          ],
          filename:
            "ip ville de nantes/ligustrum/ligustrum lucidum 'aureomarginatum'/ligustrum lucidum 'aureomarginatum' (1).jpg",
          width: 1024,
          id: '5a9d3e003896048ce8c42227abe9f06d',
          height: 768,
          thumbnail: true,
        },
        location: [47.207475, -1.546512],
        genre: 'Ligustrum',
        cultivar: 'Aureomarginatum',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.546512, 47.207475] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '86411a6e74e28c16c32b500f715238cd37a81968',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 123, 97, 1.00)',
            'rgba(123, 126, 103, 1.00)',
            'rgba(128, 115, 112, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/liquidambar hamamelidaceae/liquidambar styraciflua/liquidambar styraciflua (2).jpg',
          width: 576,
          id: 'a20a32a44137b780e19cee77328df183',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(217, 219, 210, 1.00)',
            'rgba(138, 136, 71, 1.00)',
            'rgba(99, 93, 48, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/liquidambar hamamelidaceae/liquidambar styraciflua/liquidambar styraciflua (3).jpg',
          width: 576,
          id: '46e2d0dc7b3f5c3a23fde57407481cb5',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 142, 107, 1.00)',
            'rgba(135, 135, 65, 1.00)',
            'rgba(128, 124, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/liquidambar hamamelidaceae/liquidambar styraciflua/liquidambar styraciflua (1).jpg',
          width: 1024,
          id: '051fe2dec823b4c77ec5f70321573675',
          height: 768,
          thumbnail: true,
        },
        location: [47.2706, -1.586338],
        genre: 'Liquidambar',
        famille: 'Altingiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586338, 47.2706] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '15ea83375495548abe5a47d01ad8ba6c81cb4b37',
      fields: {
        espece: 'apiculata',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 90, 55, 1.00)',
            'rgba(100, 91, 56, 1.00)',
            'rgba(116, 107, 73, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/luma/luma apiculata/luma apiculata.jpg',
          width: 1024,
          id: '575167cb1f4ca7967d6e108a79d1cc6d',
          height: 683,
          thumbnail: true,
        },
        location: [47.219512, -1.542178],
        genre: 'Luma',
        famille: 'Myrtaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542178, 47.219512] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6f3dadcd6de73aa465e2048d50367a9f2ae5a384',
      fields: {
        espece: 'apiculata',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 97, 46, 1.00)',
            'rgba(114, 105, 63, 1.00)',
            'rgba(138, 116, 55, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/luma/luma apiculata/luma apiculata (2).jpg',
          width: 631,
          id: 'dff6367f8ee7e686ce7106b0a55b0d98',
          height: 768,
          thumbnail: true,
        },
        location: [47.263022, -1.5315],
        genre: 'Luma',
        famille: 'Myrtaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5315, 47.263022] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '605f5a1142a6fde9f37ffdf759f99bd41bb1db7e',
      fields: {
        espece: 'campbellii Alba Group',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 134, 154, 1.00)',
            'rgba(130, 134, 146, 1.00)',
            'rgba(111, 113, 120, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia campbellii alba group 'ethel hillier'/magnolia campbellii alba group 'ethel hillier' (8).jpg",
          width: 1024,
          id: '7d6322c5e56bd3f30790a2c944228b19',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 149, 148, 1.00)',
            'rgba(163, 159, 149, 1.00)',
            'rgba(149, 155, 135, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia campbellii alba group 'ethel hillier'/magnolia campbellii alba group 'ethel hillier' (7).jpg",
          width: 826,
          id: '1f46474a3490d802ed4c1359a8198043',
          height: 768,
          thumbnail: true,
        },
        location: [47.222538, -1.57973],
        genre: 'Magnolia',
        cultivar: 'Ethel Hillier',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.57973, 47.222538] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '849bc968313174eb7ba207bf684cd0de3d0600ba',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 111, 114, 1.00)',
            'rgba(118, 116, 100, 1.00)',
            'rgba(75, 70, 43, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia x loebneri 'moutiers'/magnolia x loebneri 'moutiers'.jpg",
          width: 576,
          id: '18112e7cfe0e9e230c81b60766e837fc',
          height: 768,
          thumbnail: true,
        },
        espece: 'x loebneri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 110, 98, 1.00)',
            'rgba(129, 130, 116, 1.00)',
            'rgba(130, 128, 108, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia x loebneri 'moutiers'/magnolia x loebneri 'moutiers' (2).jpg",
          width: 658,
          id: 'cfd0a1aa12eddcd8139098dc08958c56',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 155, 192, 1.00)',
            'rgba(117, 121, 116, 1.00)',
            'rgba(87, 89, 58, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia x loebneri 'moutiers'/magnolia x loebneri 'moutiers' (1).jpg",
          width: 576,
          id: '41eb37ecb91d3048507be3896b9322ee',
          height: 768,
          thumbnail: true,
        },
        location: [47.225325, -1.583087],
        genre: 'Magnolia',
        cultivar: 'Moutiers',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583087, 47.225325] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'de08910118e7db2caba897c849aa43589ebb1bc3',
      fields: {
        espece: 'x soulangeana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 99, 117, 1.00)',
            'rgba(169, 97, 120, 1.00)',
            'rgba(99, 66, 66, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia x soulangeana 'lennei'/magnolia x soulangeana 'lennei' (2).jpg",
          width: 576,
          id: '5f71dc1398d2a954e147e876f64717c9',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 140, 176, 1.00)',
            'rgba(132, 123, 125, 1.00)',
            'rgba(101, 98, 59, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia x soulangeana 'lennei'/magnolia x soulangeana 'lennei' (1).jpg",
          width: 1024,
          id: '4456ef2f2dce241ef14a61f452033a20',
          height: 768,
          thumbnail: true,
        },
        location: [47.222838, -1.582337],
        genre: 'Magnolia',
        cultivar: 'Lennei',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582337, 47.222838] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6b266c9ada097e57d9dc2082327454423b812f28',
      fields: {
        espece: 'sieboldii',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 124, 94, 1.00)',
            'rgba(86, 97, 73, 1.00)',
            'rgba(33, 46, 17, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/magnolia/magnolia sieboldii 'multipetaled'/magnolia sieboldii 'multipetaled'.jpg",
          width: 1024,
          id: '5acaee48ff4e063bbf0ec9f325462ac1',
          height: 683,
          thumbnail: true,
        },
        location: [47.227533, -1.508425],
        genre: 'Magnolia',
        cultivar: 'Multipetaled',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508425, 47.227533] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1b44e90636ac5efe4f016d0e161d69ea3f252b46',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 136, 152, 1.00)',
            'rgba(120, 125, 127, 1.00)',
            'rgba(102, 112, 120, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'albatross'/magnolia 'albatross' (2).jpg",
          width: 584,
          id: '001e18bb7ddba80a02938104e7a8ca30',
          height: 768,
          thumbnail: true,
        },
        location: [47.262508, -1.53265],
        genre: 'Magnolia',
        cultivar: 'Albatross',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53265, 47.262508] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2748153aed7666bd16c7f16fa6fd1d48bfd6f401',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 124, 124, 1.00)',
            'rgba(111, 111, 101, 1.00)',
            'rgba(48, 49, 31, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'alixeed'/magnolia 'alixeed' (2).jpg",
          width: 512,
          id: '1af526b59ab36ba4be3daef68a4c836a',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(175, 178, 180, 1.00)',
            'rgba(130, 131, 117, 1.00)',
            'rgba(56, 56, 33, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'alixeed'/magnolia 'alixeed' (1).jpg",
          width: 512,
          id: '0585b9e93337a0c151bddd22e32ec73b',
          height: 768,
          thumbnail: true,
        },
        location: [47.263375, -1.531613],
        genre: 'Magnolia',
        cultivar: 'Alixeed',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531613, 47.263375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '328bf0fb9eeb32e36bafa45f626f9bb6aad01eeb',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 160, 141, 1.00)',
            'rgba(72, 90, 52, 1.00)',
            'rgba(89, 103, 78, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'george henry kern'/magnolia 'george henry kern'  (2).jpg",
          width: 1024,
          id: '840bc7bf1aa4c55dead9c577d4c808cc',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 84, 61, 1.00)',
            'rgba(103, 116, 84, 1.00)',
            'rgba(54, 72, 26, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'george henry kern'/magnolia 'george henry kern'  (1).jpg",
          width: 1024,
          id: '8093a23891e981a8f971b64157677fcf',
          height: 683,
          thumbnail: true,
        },
        location: [47.261662, -1.53408],
        genre: 'Magnolia',
        cultivar: 'George Henry Kern',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53408, 47.261662] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4c12b8cf97d9a841b44e56f0dbe1dd9a80aa234e',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 109, 105, 1.00)',
            'rgba(81, 85, 58, 1.00)',
            'rgba(95, 90, 60, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'parson's clone'/magnolia 'parson's clone' (2).jpg",
          width: 1024,
          id: 'fce3a432c3418f82886836180873f341',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 89, 79, 1.00)',
            'rgba(113, 114, 93, 1.00)',
            'rgba(94, 95, 77, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'parson's clone'/magnolia 'parson's clone' (1).jpg",
          width: 1024,
          id: '8aac8c91b33e71fd61757660dd56cd28',
          height: 683,
          thumbnail: true,
        },
        location: [47.262717, -1.531203],
        genre: 'Magnolia',
        cultivar: "Parson's Clone",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531203, 47.262717] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c6c42037b71537eb768c3710e67ad3ee8f8af828',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 137, 131, 1.00)',
            'rgba(132, 108, 92, 1.00)',
            'rgba(64, 52, 31, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'pickard's stardust'/magnolia 'pickard's stardust'.jpg",
          width: 576,
          id: 'fc7ea150490321622e24c0d838bf52fd',
          height: 768,
          thumbnail: true,
        },
        location: [47.263375, -1.531613],
        genre: 'Magnolia',
        cultivar: "Pickard's Stardust",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531613, 47.263375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '85b8537a9e41e2dddd38b3d10b2805e4a4964b8f',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 110, 163, 1.00)',
            'rgba(98, 100, 144, 1.00)',
            'rgba(104, 130, 184, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'royal crown'/magnolia 'royal crown' (2).jpg",
          width: 1024,
          id: 'a37cebdfe92bc92233156a8a0c5236d9',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 137, 192, 1.00)',
            'rgba(112, 87, 90, 1.00)',
            'rgba(85, 85, 52, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'royal crown'/magnolia 'royal crown' (1).jpg",
          width: 1024,
          id: 'aab674cb44adfb3a9e057af734181078',
          height: 683,
          thumbnail: true,
        },
        location: [47.263128, -1.532803],
        genre: 'Magnolia',
        cultivar: 'Royal Crown',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532803, 47.263128] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '26cb69d988dd3742b9eea58147d14f3f64b405df',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 152, 200, 1.00)',
            'rgba(125, 110, 104, 1.00)',
            'rgba(74, 67, 34, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'star wars'/magnolia 'star wars'.jpg",
          width: 1024,
          id: 'af24307cce917e88de4318ebd9d0fac1',
          height: 683,
          thumbnail: true,
        },
        location: [47.263187, -1.53282],
        genre: 'Magnolia',
        cultivar: 'Star Wars',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53282, 47.263187] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c51831e9e8d7a89d5456307c05a886ac41a0c235',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 86, 42, 1.00)',
            'rgba(128, 136, 77, 1.00)',
            'rgba(108, 117, 30, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'sun ray'/magnolia 'sun ray' (2).jpg",
          width: 576,
          id: '4a9961ca2ca9d558c8e134305b85b820',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 71, 45, 1.00)',
            'rgba(125, 128, 90, 1.00)',
            'rgba(81, 89, 42, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'sun ray'/magnolia 'sun ray' (1).jpg",
          width: 576,
          id: 'd81d4e3256d57428b3a5eae410ce7226',
          height: 768,
          thumbnail: true,
        },
        location: [47.261228, -1.533947],
        genre: 'Magnolia',
        cultivar: 'Sun Ray',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533947, 47.261228] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '72c4bc2ed62a37754efe22660530d293747a5623',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 102, 118, 1.00)',
            'rgba(139, 89, 116, 1.00)',
            'rgba(94, 65, 67, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'susan'/magnolia 'susan' (2).jpg",
          width: 1024,
          id: 'f4f87b5312ccf18c6cbc7139859e3dbe',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 101, 116, 1.00)',
            'rgba(120, 87, 91, 1.00)',
            'rgba(94, 58, 69, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'susan'/magnolia 'susan' (3).jpg",
          width: 1024,
          id: '91943c2e75c38ab916ab815623e5ca00',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 142, 148, 1.00)',
            'rgba(119, 94, 90, 1.00)',
            'rgba(90, 76, 62, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'susan'/magnolia 'susan' (1).jpg",
          width: 1024,
          id: '27773733b7cfb9f3c1db5f2a80e57e4f',
          height: 675,
          thumbnail: true,
        },
        location: [47.262917, -1.536142],
        genre: 'Magnolia',
        cultivar: 'Susan',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.536142, 47.262917] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5d262b4de9774d6652756287f87f2f57a694b1d1',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 112, 118, 1.00)',
            'rgba(118, 107, 97, 1.00)',
            'rgba(83, 80, 58, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'tiffany'/magnolia 'tiffany' (3).jpg",
          width: 1024,
          id: 'cf5b5a5301297d1c3bcc6cc64a792c9b',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 153, 193, 1.00)',
            'rgba(104, 107, 108, 1.00)',
            'rgba(81, 83, 48, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'tiffany'/magnolia 'tiffany' (1).jpg",
          width: 1024,
          id: '76e60f9549564af548237cf35ac95414',
          height: 683,
          thumbnail: true,
        },
        location: [47.262013, -1.53158],
        genre: 'Magnolia',
        cultivar: 'Tiffany',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53158, 47.262013] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0ef7aab5ff60c390fecd84ab6f9c4b7863d1abaf',
      fields: {
        espece: 'acuminata',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 119, 89, 1.00)',
            'rgba(107, 115, 83, 1.00)',
            'rgba(72, 84, 56, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia acuminata 'large yellow'/magnolia acuminata 'large yellow'.jpg",
          width: 989,
          id: '3aa6da5e6ac7fbcd463d8d55b43121e5',
          height: 768,
          thumbnail: true,
        },
        location: [47.262397, -1.53238],
        genre: 'Magnolia',
        cultivar: 'Large Yellow',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53238, 47.262397] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '167fc01c4521b9bc23e759dea122b6d3f4142576',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'cylindrica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(182, 180, 157, 1.00)',
            'rgba(136, 123, 86, 1.00)',
            'rgba(100, 91, 53, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia cylindrica/magnolia cylindrica (4).jpg',
          width: 576,
          id: 'd8138b343d07cdaca2b42bab80a437c4',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 149, 198, 1.00)',
            'rgba(111, 117, 124, 1.00)',
            'rgba(65, 71, 38, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia cylindrica/magnolia cylindrica .jpg',
          width: 1024,
          id: '789b6d66cfd4800f22f4fad87301244c',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 157, 126, 1.00)',
            'rgba(156, 155, 119, 1.00)',
            'rgba(91, 84, 48, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia cylindrica/magnolia cylindrica (3).jpg',
          width: 576,
          id: 'd774ebbff4dbc89415ba7acdeb3186ca',
          height: 768,
          thumbnail: true,
        },
        location: [47.262758, -1.535033],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535033, 47.262758] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1591db12137507d5a7651c8ae9605f9e3cdfaeeb',
      fields: {
        espece: 'fraseri var. pyramidata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 161, 171, 1.00)',
            'rgba(140, 143, 132, 1.00)',
            'rgba(106, 110, 86, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia fraseri var. pyramidata/magnolia fraseri var. pyramidata (2).jpg',
          width: 576,
          id: 'f08e7578cecd70e03c8a5a81f65ea10e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(181, 205, 221, 1.00)',
            'rgba(124, 138, 112, 1.00)',
            'rgba(91, 98, 58, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia fraseri var. pyramidata/magnolia fraseri var. pyramidata (1).jpg',
          width: 1024,
          id: 'e6aaa4825d056ed8569fd0f31bf15abc',
          height: 768,
          thumbnail: true,
        },
        location: [47.261547, -1.535437],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535437, 47.261547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2ce46a74b23e4689c3f0b72e71a49932e8c79b58',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(171, 180, 149, 1.00)',
            'rgba(98, 110, 67, 1.00)',
            'rgba(87, 111, 50, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia grandiflora 'edith bogue'/magnolia grandiflora 'edith bogue' (3).jpg",
          width: 1024,
          id: '4d91c739d86b5c66ead7169391937181',
          height: 768,
          thumbnail: true,
        },
        espece: 'grandiflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 86, 40, 1.00)',
            'rgba(152, 126, 62, 1.00)',
            'rgba(118, 104, 44, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia grandiflora 'edith bogue'/magnolia grandiflora 'edith bogue' (2).jpg",
          width: 576,
          id: '144de63ad09d8235a8cefba2bc017f0b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 116, 56, 1.00)',
            'rgba(110, 136, 61, 1.00)',
            'rgba(116, 147, 76, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia grandiflora 'edith bogue'/magnolia grandiflora 'edith bogue' (1).jpg",
          width: 576,
          id: '172b9c670737c767fbec104a6cc4e475',
          height: 768,
          thumbnail: true,
        },
        location: [47.261688, -1.529578],
        genre: 'Magnolia',
        cultivar: 'Edith Bogue',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529578, 47.261688] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '398ebf030d851fdec567c8bbb89ba0f642a3ec4b',
      fields: {
        espece: 'grandiflora',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 116, 79, 1.00)',
            'rgba(98, 121, 61, 1.00)',
            'rgba(77, 108, 55, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia grandiflora 'variegata'/magnolia grandiflora 'variegata'.jpg",
          width: 1024,
          id: '86213650b1922d6a6c81632b9b4f8e58',
          height: 730,
          thumbnail: true,
        },
        location: [47.262317, -1.535827],
        genre: 'Magnolia',
        cultivar: 'Variegata',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535827, 47.262317] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4f629312ad7653b201a3d095380b1aa43aa8a4d8',
      fields: {
        espece: 'kobus',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(178, 202, 228, 1.00)',
            'rgba(138, 143, 144, 1.00)',
            'rgba(75, 72, 45, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia kobus/magnolia kobus (2).jpg',
          width: 1024,
          id: 'd77e38b6b2569547d36afa262ea9b24a',
          height: 768,
          thumbnail: true,
        },
        location: [47.2624, -1.531705],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531705, 47.2624] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a5b8e57d5827e8b728985a49471d578f81a0336b',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'macrophylla',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 87, 43, 1.00)',
            'rgba(93, 120, 66, 1.00)',
            'rgba(104, 129, 57, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia macrophylla/magnolia macrophylla (5).jpg',
          width: 1024,
          id: 'f34a3ab7a4c946b6d63c863b900769c9',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 84, 39, 1.00)',
            'rgba(88, 114, 64, 1.00)',
            'rgba(108, 126, 72, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia macrophylla/magnolia macrophylla (6).jpg',
          width: 1024,
          id: '8a331a1f9a8f711a18e5f2c48ba9e9d3',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 152, 162, 1.00)',
            'rgba(96, 117, 87, 1.00)',
            'rgba(72, 79, 45, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia macrophylla/magnolia macrophylla (4).jpg',
          width: 1024,
          id: '48cdd878c44338a259f6ecdf5c479dea',
          height: 683,
          thumbnail: true,
        },
        location: [47.261922, -1.52863],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.52863, 47.261922] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '45433c92f2b6aa4922975177128356e002c188a9',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 174, 217, 1.00)',
            'rgba(105, 91, 90, 1.00)',
            'rgba(65, 64, 40, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sargentiana 'caerhays'/magnolia sargentiana 'caerhays' (3).jpg",
          width: 1024,
          id: 'cf1ea55020708043195fc4060a4c147d',
          height: 683,
          thumbnail: true,
        },
        espece: 'sargentiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 107, 120, 1.00)',
            'rgba(142, 121, 139, 1.00)',
            'rgba(124, 105, 124, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sargentiana 'caerhays'/magnolia sargentiana 'caerhays' (2).jpg",
          width: 576,
          id: '5ff58228a55866aea47464ebb33afa33',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 177, 222, 1.00)',
            'rgba(128, 129, 139, 1.00)',
            'rgba(85, 84, 33, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sargentiana 'caerhays'/magnolia sargentiana 'caerhays' (1).jpg",
          width: 576,
          id: '2918c075e6178c6d7eb15a4958cf51f6',
          height: 768,
          thumbnail: true,
        },
        location: [47.262303, -1.53148],
        genre: 'Magnolia',
        cultivar: 'Caerhays',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53148, 47.262303] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '32b9ba1c3fa1e502214cba6d425bc3f0ba1017e1',
      fields: {
        espece: 'stellata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 88, 81, 1.00)',
            'rgba(149, 139, 135, 1.00)',
            'rgba(66, 56, 44, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'rosea king'/magnolia stellata 'rosea king' (2).jpg",
          width: 576,
          id: '660ab13f52ad6b53d7956419071c96af',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 156, 197, 1.00)',
            'rgba(148, 153, 153, 1.00)',
            'rgba(104, 86, 58, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'rosea king'/magnolia stellata 'rosea king' (1).jpg",
          width: 576,
          id: '24050ba42113247f797887d5d8968dbc',
          height: 768,
          thumbnail: true,
        },
        location: [47.262437, -1.533175],
        genre: 'Magnolia',
        cultivar: 'Rosea King',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533175, 47.262437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '14109ed7504b462142a57a01c4185a5d0c5e483b',
      fields: {
        espece: 'stellata',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 92, 75, 1.00)',
            'rgba(133, 126, 106, 1.00)',
            'rgba(78, 70, 45, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'waterlily'/magnolia stellata 'waterlily' (2).jpg",
          width: 576,
          id: 'aebcc4c9ab6aad6da917edd613b35e8e',
          height: 768,
          thumbnail: true,
        },
        location: [47.262295, -1.530792],
        genre: 'Magnolia',
        cultivar: 'Waterlily',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530792, 47.262295] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '08e80fb773e9be90b6df7fe643b85b0f104487a8',
      fields: {
        espece: 'stellata',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 116, 150, 1.00)',
            'rgba(97, 98, 94, 1.00)',
            'rgba(60, 59, 41, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'waterlily'/magnolia stellata 'waterlily'.jpg",
          width: 1024,
          id: '0465ba689dd5d424aee77062418a85da',
          height: 683,
          thumbnail: true,
        },
        location: [47.262292, -1.530787],
        genre: 'Magnolia',
        cultivar: 'Waterlily',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530787, 47.262292] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd028abae5743bc123a0dfb18cd7b98accfaf276b',
      fields: {
        espece: 'x brooklynensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 112, 44, 1.00)',
            'rgba(146, 137, 82, 1.00)',
            'rgba(80, 85, 21, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x brooklynensis 'woodsman'/magnolia x brooklynensis 'woodsman' (2).jpg",
          width: 576,
          id: '46ce242c9872aaeb5f9b56c3d8cc2d14',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(207, 211, 193, 1.00)',
            'rgba(103, 115, 63, 1.00)',
            'rgba(91, 99, 47, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x brooklynensis 'woodsman'/magnolia x brooklynensis 'woodsman' (1).jpg",
          width: 1024,
          id: '8bc77d9da380952d560fe09dacb01dba',
          height: 768,
          thumbnail: true,
        },
        location: [47.261083, -1.532988],
        genre: 'Magnolia',
        cultivar: 'Woodsman',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532988, 47.261083] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'db137c4be0c098da34a1e475e8a66016591e4d3e',
      fields: {
        espece: 'x soulangeana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(61, 71, 85, 1.00)',
            'rgba(110, 109, 105, 1.00)',
            'rgba(94, 97, 66, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'pickard's crystal'/magnolia x soulangeana 'pickard's crystal' (3).jpg",
          width: 1024,
          id: '89fca5d217d6d4b84589dbd5b9bbd61f',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 155, 200, 1.00)',
            'rgba(118, 125, 131, 1.00)',
            'rgba(65, 72, 38, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'pickard's crystal'/magnolia x soulangeana 'pickard's crystal' (2).jpg",
          width: 1024,
          id: 'd0d899ba4e20fc0583ad650d322ff4c1',
          height: 683,
          thumbnail: true,
        },
        location: [47.261687, -1.532067],
        genre: 'Magnolia',
        cultivar: "Pickard's Crystal",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532067, 47.261687] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e619dd3e5401887ced85b2f259081881912c70d0',
      fields: {
        espece: 'x soulangeana',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 132, 153, 1.00)',
            'rgba(148, 109, 124, 1.00)',
            'rgba(94, 77, 50, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'picture'/magnolia x soulangeana 'picture'.jpg",
          width: 576,
          id: 'f741ec3720e15c3d670dd2866c2c2d23',
          height: 768,
          thumbnail: true,
        },
        location: [47.262245, -1.528703],
        genre: 'Magnolia',
        cultivar: 'Picture',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.528703, 47.262245] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2b0fa22d5e012b7f3b7dc2cc4407cb49eed2b5ba',
      fields: {
        espece: 'hybrids/Magnolia',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 119, 129, 1.00)',
            'rgba(106, 100, 95, 1.00)',
            'rgba(81, 79, 56, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/unnamed hybrids/magnolia 'g 66-6' (gresham)/magnolia 'g 66-6' (gresham).jpg",
          width: 1024,
          id: '99a21a47c2126a664ba79754bbb91f9e',
          height: 683,
          thumbnail: true,
        },
        location: [47.262508, -1.529995],
        genre: 'Magnolia',
        cultivar: 'G 66-6 (Gresham)',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529995, 47.262508] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fa48f7be9ab586be51a3e350a10e18a6dad4312b',
      fields: {
        espece: 'glyptostroboides',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(209, 224, 236, 1.00)',
            'rgba(115, 127, 68, 1.00)',
            'rgba(77, 90, 21, 1.00)',
          ],
          filename:
            'ip parc de proce/metasequoia/metasequoia glyptostroboides/metasequoia glyptostroboides.jpg',
          width: 576,
          id: '584d9d5eb6fa6f38e9a466f0b948b942',
          height: 768,
          thumbnail: true,
        },
        location: [47.224288, -1.581755],
        genre: 'Metasequoia',
        famille: 'Cupressaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581755, 47.224288] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fec8d79609fc43e4ad0d7c28be6750f18b70c86d',
      fields: {
        espece: 'alba',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(204, 209, 199, 1.00)',
            'rgba(92, 101, 66, 1.00)',
            'rgba(92, 94, 62, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/morus/morus alba 'pendula'/morus alba 'pendula'.jpg",
          width: 1024,
          id: 'cbea49a9fddc91aa9ce0e0ce48ff0d7f',
          height: 768,
          thumbnail: true,
        },
        location: [47.2282, -1.510872],
        genre: 'Morus',
        cultivar: 'Pendula',
        famille: 'Moraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.510872, 47.2282] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f48ff0a51390befe597802929f9c890ef572fe75',
      fields: {
        espece: 'antarctica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 164, 118, 1.00)',
            'rgba(151, 137, 111, 1.00)',
            'rgba(137, 132, 95, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/nothofagus/nothofagus antarctica/nothofagus antarctica (2).jpg',
          width: 576,
          id: '699e853cd4ada61f75e41d8cd2a28f60',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 151, 111, 1.00)',
            'rgba(125, 154, 102, 1.00)',
            'rgba(132, 137, 102, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/nothofagus/nothofagus antarctica/nothofagus antarctica (1).jpg',
          width: 576,
          id: '668d6bfda780a291bb7886f660c671ab',
          height: 768,
          thumbnail: true,
        },
        location: [47.218505, -1.542088],
        genre: 'Nothofagus',
        famille: 'Nothofagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542088, 47.218505] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ebd042747249fa4888cb1e63fe6f6e27e7304802',
      fields: {
        espece: 'moorei',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 131, 65, 1.00)',
            'rgba(112, 130, 54, 1.00)',
            'rgba(135, 133, 73, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/nothofagus/nothofagus moorei/nothofagus moorei (2).jpg',
          width: 1024,
          id: '3a73be5e5272e38204de404c713d4c1e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 111, 51, 1.00)',
            'rgba(140, 150, 81, 1.00)',
            'rgba(160, 137, 103, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/nothofagus/nothofagus moorei/nothofagus moorei (1).jpg',
          width: 576,
          id: 'dbbd9b047264dc0c22715f8dbad67b12',
          height: 768,
          thumbnail: true,
        },
        location: [47.218545, -1.542103],
        genre: 'Nothofagus',
        famille: 'Nothofagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542103, 47.218545] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '77b35b331e50a594e0cf62de08a847175094f20f',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'sylvatica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 179, 210, 1.00)',
            'rgba(140, 91, 59, 1.00)',
            'rgba(76, 43, 23, 1.00)',
          ],
          filename:
            'ip parc de proce/nyssa/nyssa sylvatica/nyssa sylvatica (4).jpg',
          width: 512,
          id: '52237d3ded617c907aa68faebc29eb97',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 100, 157, 1.00)',
            'rgba(160, 65, 51, 1.00)',
            'rgba(131, 38, 11, 1.00)',
          ],
          filename:
            'ip parc de proce/nyssa/nyssa sylvatica/nyssa sylvatica (5).jpg',
          width: 538,
          id: 'f5ca7e20f2bbb415cd9162ee31c1fdf0',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 190, 198, 1.00)',
            'rgba(104, 126, 51, 1.00)',
            'rgba(79, 94, 36, 1.00)',
          ],
          filename:
            'ip parc de proce/nyssa/nyssa sylvatica/nyssa sylvatica (2).jpg',
          width: 576,
          id: '6307e2b5c1eeab9606235fd423c0d95b',
          height: 768,
          thumbnail: true,
        },
        location: [47.222662, -1.584022],
        genre: 'Nyssa',
        famille: 'Nyssaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584022, 47.222662] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '759f30061f67ce2b91d56d0dabb19fe411369bb2',
      fields: {
        espece: 'x burkwoodii',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 148, 134, 1.00)',
            'rgba(83, 97, 77, 1.00)',
            'rgba(64, 79, 62, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/osmanthus/osmanthus x burkwoodii/osmanthus x burkwoodii (2).jpg',
          width: 1024,
          id: '0ed62114e1f6577612e710c271538932',
          height: 729,
          thumbnail: true,
        },
        location: [47.261947, -1.532303],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532303, 47.261947] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e4a21a85dcc019e9c7992cc97e748ddd6209487b',
      fields: {
        espece: 'yunnanensis',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 153, 121, 1.00)',
            'rgba(112, 125, 82, 1.00)',
            'rgba(61, 75, 42, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/osmanthus/osmanthus yunnanensis/osmanthus yunnanensis.jpg',
          width: 1024,
          id: '758df51b9691194d865579e3e0542ed9',
          height: 683,
          thumbnail: true,
        },
        location: [47.262421, -1.529455],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529455, 47.262421] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '98f3bfe94ca9a05e22bb316ee94515ddcc13ac6e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 159, 106, 1.00)',
            'rgba(125, 123, 84, 1.00)',
            'rgba(123, 119, 84, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/parrotia hamamelidaceae/parrotia persica 'vanessa'/parrotia persica 'vanessa'.jpg",
          width: 576,
          id: 'b97b40c5652dcbfe60461fb469ba8263',
          height: 768,
          thumbnail: true,
        },
        location: [47.270013, -1.585925],
        genre: 'Parrotia',
        cultivar: 'Vanessa',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585925, 47.270013] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cce378e2755a2c45307b9884e63734f9b2288a14',
      fields: {
        espece: 'jacquemontiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 168, 150, 1.00)',
            'rgba(108, 108, 58, 1.00)',
            'rgba(107, 95, 73, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/parrotiopsis/parrotiopsis jacquemontiana/parrotiopsis jacquemontiana.jpg',
          width: 576,
          id: 'a1aa325035eba9fd29fbd27c2b5d8590',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 175, 140, 1.00)',
            'rgba(103, 121, 70, 1.00)',
            'rgba(76, 90, 47, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/parrotiopsis/parrotiopsis jacquemontiana/parrotiopsis jacquemontiana (2).jpg',
          width: 1024,
          id: '2d576c5b01637bdad77e3af2c3df7e66',
          height: 768,
          thumbnail: true,
        },
        location: [47.262528, -1.529088],
        genre: 'Parrotiopsis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529088, 47.262528] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '424657bf81dc419305b814bf732335c49ba7343d',
      fields: {
        espece: 'tomentosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(186, 196, 186, 1.00)',
            'rgba(109, 118, 78, 1.00)',
            'rgba(79, 93, 39, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/paulownia/paulownia tomentosa/paulownia tomentosa (2).jpg',
          width: 1024,
          id: '836fe8458b84725a542499b30f007352',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 134, 108, 1.00)',
            'rgba(123, 124, 109, 1.00)',
            'rgba(97, 97, 71, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/paulownia/paulownia tomentosa/paulownia tomentosa (1).jpg',
          width: 576,
          id: '204ca8ff6d2b664e3f113bc0cc2cef4a',
          height: 768,
          thumbnail: true,
        },
        location: [47.263238, -1.529047],
        genre: 'Paulownia',
        famille: 'Paulowniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529047, 47.263238] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e10ebc50221baabbbb2620e2cc31d4b2c3f66b85',
      fields: {
        espece: 'tomentosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 132, 111, 1.00)',
            'rgba(131, 132, 118, 1.00)',
            'rgba(104, 111, 73, 1.00)',
          ],
          filename:
            'ip ville de nantes/paulownia/paulownia tomentosa/paulownia tomentosa (2).jpg',
          width: 576,
          id: '39831eb7c3c427d693708c7a22496a57',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(231, 230, 231, 1.00)',
            'rgba(150, 148, 135, 1.00)',
            'rgba(71, 76, 41, 1.00)',
          ],
          filename:
            'ip ville de nantes/paulownia/paulownia tomentosa/paulownia tomentosa (1).jpg',
          width: 678,
          id: '52692fd4ad2fed9330696d48ccccb3e8',
          height: 768,
          thumbnail: true,
        },
        location: [47.247033, -1.554095],
        genre: 'Paulownia',
        famille: 'Paulowniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.554095, 47.247033] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bd73ef99ec9f82ca6a1d0f0ed66ece9d96a8396a',
      fields: {
        espece: 'coronarius',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 129, 64, 1.00)',
            'rgba(98, 133, 57, 1.00)',
            'rgba(112, 153, 66, 1.00)',
          ],
          filename:
            'ip parc de la gaudiniere/philadelphus/philadelphus coronarius/philadelphus coronarius (2).jpg',
          width: 1024,
          id: '990ae96ad1da8e9a0368e5f6000f33f0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de la Gaudini\u00e8re',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 119, 46, 1.00)',
            'rgba(102, 136, 68, 1.00)',
            'rgba(54, 90, 24, 1.00)',
          ],
          filename:
            'ip parc de la gaudiniere/philadelphus/philadelphus coronarius/philadelphus coronarius (1).jpg',
          width: 576,
          id: '52350041e389a1fe3c93aaa624896de3',
          height: 768,
          thumbnail: true,
        },
        location: [47.24403, -1.577438],
        genre: 'Philadelphus',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.577438, 47.24403] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '58de76f3322d9cd36db3bbe002393dedde69d08c',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'opulifolius',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 135, 55, 1.00)',
            'rgba(98, 141, 65, 1.00)',
            'rgba(117, 154, 78, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/physocarpus/physocarpus opulifolius/physocarpus opulifolius (2).jpg',
          width: 576,
          id: '4cd6bdc1fc7ba335dcad43f4d79de968',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 113, 68, 1.00)',
            'rgba(112, 132, 91, 1.00)',
            'rgba(50, 74, 26, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/physocarpus/physocarpus opulifolius/physocarpus opulifolius (3).jpg',
          width: 576,
          id: '9220977302d042d3138a28b2c963dbc5',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 186, 141, 1.00)',
            'rgba(103, 125, 70, 1.00)',
            'rgba(80, 101, 43, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/physocarpus/physocarpus opulifolius/physocarpus opulifolius (1).jpg',
          width: 1024,
          id: 'fb741a0c9c4ed4ef6bbd61aa864b3f1f',
          height: 768,
          thumbnail: true,
        },
        location: [47.220437, -1.54305],
        genre: 'Physocarpus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54305, 47.220437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '44d17d277f7a07c28b004f364597b109e0f629bb',
      fields: {
        espece: 'strobilacea',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 175, 168, 1.00)',
            'rgba(112, 135, 63, 1.00)',
            'rgba(84, 101, 46, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/platycarya/platycarya strobilacea/platycarya strobilacea.jpg',
          width: 576,
          id: '1b465d4cdf3cf234c1b6094c10431713',
          height: 768,
          thumbnail: true,
        },
        location: [47.2189, -1.541362],
        genre: 'Platycarya',
        famille: 'Juglandaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541362, 47.2189] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2a2c49b7d901423446f69e0e64824025f1b1fda1',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'microphylla',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 137, 53, 1.00)',
            'rgba(106, 154, 56, 1.00)',
            'rgba(115, 163, 68, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/premna/premna microphylla/premna microphylla (11).jpg',
          width: 576,
          id: 'eb366975be86f54377178b234f6b6eb1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 132, 52, 1.00)',
            'rgba(126, 153, 78, 1.00)',
            'rgba(67, 104, 29, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/premna/premna microphylla/premna microphylla (12).jpg',
          width: 723,
          id: 'ee0903174d03c35aee64013a2a8ae40d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 125, 48, 1.00)',
            'rgba(99, 133, 50, 1.00)',
            'rgba(87, 129, 48, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/premna/premna microphylla/premna microphylla (10).jpg',
          width: 576,
          id: 'bbe324366480e78bdfba45cb23d13454',
          height: 768,
          thumbnail: true,
        },
        location: [47.220042, -1.542555],
        genre: 'Premna',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542555, 47.220042] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2231626384cebcaef7c4cd21577d30f8357b2d60',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 122, 118, 1.00)',
            'rgba(130, 117, 96, 1.00)',
            'rgba(86, 78, 54, 1.00)',
          ],
          filename:
            "ip parc de proce/prunus/prunus 'kanzan'/prunus 'kanzan' (2).jpg",
          width: 576,
          id: 'ea2e2e217639a4dc10a379ebc836c7d4',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 123, 116, 1.00)',
            'rgba(150, 111, 95, 1.00)',
            'rgba(165, 125, 132, 1.00)',
          ],
          filename:
            "ip parc de proce/prunus/prunus 'kanzan'/prunus 'kanzan' (3).jpg",
          width: 576,
          id: 'f392009b7a966ed96f16a11d58b740ad',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 142, 156, 1.00)',
            'rgba(162, 118, 139, 1.00)',
            'rgba(109, 75, 76, 1.00)',
          ],
          filename:
            "ip parc de proce/prunus/prunus 'kanzan'/prunus 'kanzan' (1).jpg",
          width: 576,
          id: '23380380d5732d646ebec83652ae76d8',
          height: 768,
          thumbnail: true,
        },
        location: [47.223947, -1.583],
        genre: 'Prunus',
        cultivar: 'Kanzan',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583, 47.223947] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '36843ca24b66f4558a886c06aa9d7609d744db0e',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 61, 51, 1.00)',
            'rgba(91, 83, 69, 1.00)',
            'rgba(65, 49, 31, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/prunus/prunus x subhirtella 'autumnalis'/prunus x subhirtella 'autumnalis' (3).jpg",
          width: 576,
          id: 'b805a73dadec243ca7ef7c149e7c3c05',
          height: 768,
          thumbnail: true,
        },
        espece: 'x subhirtella',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 130, 116, 1.00)',
            'rgba(143, 85, 53, 1.00)',
            'rgba(93, 68, 45, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/prunus/prunus x subhirtella 'autumnalis'/prunus x subhirtella 'autumnalis' (2).jpg",
          width: 576,
          id: '396d97fe96b4c1314737d80f3f101394',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(185, 172, 155, 1.00)',
            'rgba(109, 94, 65, 1.00)',
            'rgba(96, 86, 59, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/prunus/prunus x subhirtella 'autumnalis'/prunus x subhirtella 'autumnalis' (1).jpg",
          width: 1024,
          id: '29c80d8fbd2d189a4bf21a44f7093d63',
          height: 768,
          thumbnail: true,
        },
        location: [47.226942, -1.509292],
        genre: 'Prunus',
        cultivar: 'Autumnalis',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.509292, 47.226942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '623e80fdc2279642dc1846efd679dea82966f4f2',
      fields: {
        espece: 'sinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 110, 97, 1.00)',
            'rgba(94, 86, 52, 1.00)',
            'rgba(71, 49, 25, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/pseudocydonia/pseudocydonia sinensis/pseudocydonia sinensis (4).jpg',
          width: 576,
          id: 'c3fcbe6d91cf42b5bd70a081ec91e365',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 107, 93, 1.00)',
            'rgba(105, 71, 53, 1.00)',
            'rgba(86, 61, 49, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/pseudocydonia/pseudocydonia sinensis/pseudocydonia sinensis (3).jpg',
          width: 679,
          id: '66fc14e13a01a52ec87330feccaf1e9a',
          height: 768,
          thumbnail: true,
        },
        location: [47.220587, -1.542087],
        genre: 'Pseudocydonia',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542087, 47.220587] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '76cadb4f19d288588aa97498fc95416919e578a6',
      fields: {
        espece: 'coccifera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 106, 90, 1.00)',
            'rgba(110, 117, 104, 1.00)',
            'rgba(90, 100, 88, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus coccifera/quercus coccifera.jpg',
          width: 1024,
          id: 'd7b03529ab8c22710cda677cc134a568',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 118, 68, 1.00)',
            'rgba(116, 141, 66, 1.00)',
            'rgba(98, 121, 41, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus coccifera/quercus coccifera (2).jpg',
          width: 576,
          id: '4a3a12a855abc4bf2f8500caeb270191',
          height: 768,
          thumbnail: true,
        },
        location: [47.261753, -1.534762],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534762, 47.261753] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd97f3575e828490621a48b8d0396c81679d272c3',
      fields: {
        espece: 'rubra',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 185, 120, 1.00)',
            'rgba(87, 104, 40, 1.00)',
            'rgba(43, 52, 28, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/quercus/quercus rubra 'aurea'/quercus rubra 'aurea'.jpg",
          width: 1024,
          id: '0eb920949718ac4b1c82136e0e9aa50f',
          height: 683,
          thumbnail: true,
        },
        location: [47.26177, -1.532913],
        genre: 'Quercus',
        cultivar: 'Aurea',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532913, 47.26177] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ac261d2d5934ea7b3763415f7ae4ad83d1f7f51f',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'umbellata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 162, 107, 1.00)',
            'rgba(122, 149, 63, 1.00)',
            'rgba(108, 136, 47, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/rhaphiolepis/rhaphiolepis umbellata/rhaphiolepis umbellata (2).jpg',
          width: 576,
          id: 'a69647fd1a7fb8acb95eb25b7622a52f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 163, 141, 1.00)',
            'rgba(107, 99, 58, 1.00)',
            'rgba(103, 103, 65, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/rhaphiolepis/rhaphiolepis umbellata/rhaphiolepis umbellata (3).jpg',
          width: 576,
          id: '95181447a77401612d43a1e739551538',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 106, 49, 1.00)',
            'rgba(119, 128, 93, 1.00)',
            'rgba(71, 74, 38, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/rhaphiolepis/rhaphiolepis umbellata/rhaphiolepis umbellata (1).jpg',
          width: 576,
          id: '49516a4cb0df2254867929e27534b1a1',
          height: 768,
          thumbnail: true,
        },
        location: [47.219212, -1.542828],
        genre: 'Rhaphiolepis',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542828, 47.219212] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ea5775f32fdce7e06b4011defb196b3f3517d537',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'parvipetala',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 129, 108, 1.00)',
            'rgba(108, 123, 101, 1.00)',
            'rgba(93, 91, 86, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/rhodoleia/rhodoleia parvipetala/rhodoleia parvipetala (2).jpg',
          width: 1024,
          id: '2682c1518d82c8d3ae8fdf3fde1dac1d',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 163, 129, 1.00)',
            'rgba(112, 147, 101, 1.00)',
            'rgba(111, 117, 91, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/rhodoleia/rhodoleia parvipetala/rhodoleia parvipetala (3).jpg',
          width: 561,
          id: 'e7f3177ecd6ffeb89d4beee43ca549d1',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 119, 89, 1.00)',
            'rgba(116, 133, 122, 1.00)',
            'rgba(98, 89, 92, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/rhodoleia/rhodoleia parvipetala/rhodoleia parvipetala (1).jpg',
          width: 512,
          id: 'cd6e314ae7dd06020658633190a68008',
          height: 768,
          thumbnail: true,
        },
        location: [47.218787, -1.541533],
        genre: 'Rhodoleia',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541533, 47.218787] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2dcc85e5aead6a56619de94ecd496a05b76588b8',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'laurifolium',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 145, 85, 1.00)',
            'rgba(119, 107, 91, 1.00)',
            'rgba(80, 88, 75, 1.00)',
          ],
          filename:
            'ip parc de proce/ribes/ribes laurifolium/ribes laurifolium (2).jpg',
          width: 512,
          id: '133ae7793cdcfa327461f893ca00c89f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 99, 90, 1.00)',
            'rgba(108, 123, 82, 1.00)',
            'rgba(98, 108, 87, 1.00)',
          ],
          filename:
            'ip parc de proce/ribes/ribes laurifolium/ribes laurifolium (3).jpg',
          width: 512,
          id: 'fdbd917a1614e9242aafdca519489f4e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 106, 95, 1.00)',
            'rgba(108, 124, 82, 1.00)',
            'rgba(104, 122, 69, 1.00)',
          ],
          filename:
            'ip parc de proce/ribes/ribes laurifolium/ribes laurifolium (1).jpg',
          width: 512,
          id: 'e48952910917371b8914a1184cd14a45',
          height: 768,
          thumbnail: true,
        },
        location: [47.224722, -1.581272],
        genre: 'Ribes',
        famille: 'Grossulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581272, 47.224722] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '646c5d7a08cc24124b062012f3b58e36f40c27e0',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'albidum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 160, 67, 1.00)',
            'rgba(112, 151, 59, 1.00)',
            'rgba(91, 119, 38, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/sassafras/sassafras albidum/sassafras albidum (2).jpg',
          width: 576,
          id: 'd3fdb220572fffcfacc1520d10a6c137',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 154, 64, 1.00)',
            'rgba(110, 154, 50, 1.00)',
            'rgba(84, 123, 31, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/sassafras/sassafras albidum/sassafras albidum (3).jpg',
          width: 576,
          id: '665d0536c314b2eabb4526d3d18d09b5',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 140, 77, 1.00)',
            'rgba(132, 118, 76, 1.00)',
            'rgba(161, 144, 103, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/sassafras/sassafras albidum/sassafras albidum (1).jpg',
          width: 576,
          id: 'e643f6ce87d951a637f3eca0b422304e',
          height: 768,
          thumbnail: true,
        },
        location: [47.219522, -1.544178],
        genre: 'Sassafras',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544178, 47.219522] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7933cd78e46c9f50d927decd7958b87e2c61a500',
      fields: {
        espece: 'microphylla',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 71, 53, 1.00)',
            'rgba(89, 87, 39, 1.00)',
            'rgba(52, 54, 29, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/sophora/sophora sun king ('hilsop')/sophora sun king ('hilsop') (2).jpg",
          width: 1024,
          id: '0069c69631fb273b1e4b16e4a0c5f92a',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(171, 176, 155, 1.00)',
            'rgba(110, 117, 92, 1.00)',
            'rgba(90, 89, 71, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/sophora/sophora sun king ('hilsop')/sophora sun king ('hilsop') (1).jpg",
          width: 1024,
          id: 'bd495c74425f9c7c9db5e85f12aba1de',
          height: 683,
          thumbnail: true,
        },
        location: [47.228283, -1.508288],
        genre: 'Sophora',
        cultivar: 'Sun King',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508288, 47.228283] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c707ba7222f7c9bf5b98331c1bfc51285e3a5d76',
      fields: {
        espece: 'praecox',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 111, 84, 1.00)',
            'rgba(112, 109, 72, 1.00)',
            'rgba(103, 101, 67, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/stachyurus/stachyurus praecox/stachyurus praecox (2).jpg',
          width: 1024,
          id: '557de5cd98f60a20610d19fc606ab448',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 95, 62, 1.00)',
            'rgba(93, 85, 56, 1.00)',
            'rgba(93, 89, 58, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/stachyurus/stachyurus praecox/stachyurus praecox (1).jpg',
          width: 1024,
          id: 'e732c70dcc5cf554ecb227def07aa307',
          height: 683,
          thumbnail: true,
        },
        location: [47.228142, -1.508155],
        genre: 'Stachyurus',
        famille: 'Stachyuraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508155, 47.228142] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fbcb2d0af35ad0f2e46932270d14d4da98a0c890',
      fields: {
        espece: 'japonicum',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(211, 216, 210, 1.00)',
            'rgba(125, 132, 102, 1.00)',
            'rgba(71, 72, 40, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/styphnolobium/styphnolobium japonicum/styphnolobium japonicum.jpg',
          width: 1024,
          id: '902f9f07357f6447164708d5a33e6fec',
          height: 768,
          thumbnail: true,
        },
        location: [47.2286, -1.511097],
        genre: 'Styphnolobium',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.511097, 47.2286] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '11c5c3f8bc84345fbe0da84301d7b23ffb1e3a2a',
      fields: {
        espece: 'gymnanthera',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 123, 90, 1.00)',
            'rgba(157, 141, 106, 1.00)',
            'rgba(121, 126, 77, 1.00)',
          ],
          filename:
            'ip parc de proce/ternstroemia/ternstroemia gymnanthera/ternstroemia gymnanthera.jpg',
          width: 576,
          id: '54fa310d728b18faac788fe3c4070fdf',
          height: 768,
          thumbnail: true,
        },
        location: [47.225325, -1.581192],
        genre: 'Ternstroemia',
        famille: 'Pentaphylacaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581192, 47.225325] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6af849580032db67a9593aeed1226f068082c653',
      fields: {
        espece: 'sebifera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 141, 82, 1.00)',
            'rgba(97, 122, 45, 1.00)',
            'rgba(85, 109, 35, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/triadica/triadica sebifera/triadica sebifera (2).jpg',
          width: 1024,
          id: '0c503a5514d1f238bd55a6d0d20c21ba',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 118, 114, 1.00)',
            'rgba(99, 127, 100, 1.00)',
            'rgba(79, 107, 61, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/triadica/triadica sebifera/triadica sebifera (1).jpg',
          width: 1024,
          id: '6ca2f6481ebf1c26e051117ffeb3fdf8',
          height: 683,
          thumbnail: true,
        },
        location: [47.229891, -1.507803],
        genre: 'Triadica',
        famille: 'Euphorbiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507803, 47.229891] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '716a19d9d677c07707e44864638107f26b9bbc58',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'nobilis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 128, 121, 1.00)',
            'rgba(113, 146, 135, 1.00)',
            'rgba(123, 146, 128, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/wollemia/wollemia nobilis/wollemia nobilis (2).jpg',
          width: 576,
          id: 'c7a52e38a97bc7d8034818e1d4589187',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 166, 154, 1.00)',
            'rgba(98, 117, 102, 1.00)',
            'rgba(93, 100, 100, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/wollemia/wollemia nobilis/wollemia nobilis (3).jpg',
          width: 576,
          id: '1a4484fdc6568e1a788268e6ead07eb5',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 128, 108, 1.00)',
            'rgba(109, 126, 104, 1.00)',
            'rgba(137, 146, 138, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/wollemia/wollemia nobilis/wollemia nobilis (1).jpg',
          width: 576,
          id: '4ca2451a118c65d2a7f9a76a5fe8aa90',
          height: 768,
          thumbnail: true,
        },
        location: [47.21848, -1.542417],
        genre: 'Wollemia',
        famille: 'Araucariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542417, 47.21848] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a745e80021c6a3322557b0ec14c1c9d757b40941',
      fields: {
        espece: 'semidecidua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 101, 68, 1.00)',
            'rgba(84, 105, 46, 1.00)',
            'rgba(90, 113, 51, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/x sycoparrotia/x sycoparrotia semidecidua/x sycoparrotia semidecidua (2).jpg',
          width: 1024,
          id: '9ea92ede53408d3dc57a3360e52230c6',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 97, 38, 1.00)',
            'rgba(93, 122, 47, 1.00)',
            'rgba(110, 133, 59, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/x sycoparrotia/x sycoparrotia semidecidua/x sycoparrotia semidecidua (1).jpg',
          width: 1024,
          id: '80e63c06ce3173d18efd4681ee0b5eea',
          height: 683,
          thumbnail: true,
        },
        location: [47.262195, -1.535105],
        genre: 'x Sycoparrotia',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535105, 47.262195] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8f456252c2a46a55d0fdc3fc27095d631f967eb3',
      fields: {
        espece: 'triflora',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(200, 207, 191, 1.00)',
            'rgba(99, 118, 64, 1.00)',
            'rgba(89, 99, 57, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/zabelia/zabelia triflora/zabelia triflora.jpg',
          width: 576,
          id: 'a82ef836877c577919b0da6a88404b88',
          height: 768,
          thumbnail: true,
        },
        location: [47.228328, -1.508372],
        genre: 'Zabelia',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508372, 47.228328] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '62893e43261ba99222738cf1c3d1fb46ab788411',
      fields: {
        origine: 'J.Alp.Paradisia Cogne (Italie)',
        espece: 'ochroleucum Chaix.',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Sedum',
        date_plantation: '1999',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '34b6e653b433d74797718a7e40aef4322b0d6141',
      fields: {
        origine: 'J.B.Klagenfurt(Autriche)',
        espece: 'schottii Baker',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Sempervivum',
        date_plantation: '2010',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3015042e5c1544b4275abd56b51dcf838985e1d3',
      fields: {
        origine: 'JBU.Berlin Dahlem (Allemagne)',
        espece: 'sediforme Pau',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Sedum',
        date_plantation: '1986',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e3b5b9a5b65d341a538639ac2100dcd986ee5487',
      fields: {
        origine: 'Ringve B.G. Trondheim (Norv\u00e8ge)',
        espece: 'rosea L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Rhodiola',
        date_plantation: '2014',
        cultivar: 'ssp.rosea',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0ee20b26dd3feb7d655cea0d6aecda8595361050',
      fields: {
        espece: 'verityi K.M.Nakai',
        localisation: 'A2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2208871, -1.5444631],
        genre: 'Dudleya',
        date_plantation: '1990',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444631, 47.2208871] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ddb2d3adae2ecdd9eb1694927dd6080d7e0a0b3f',
      fields: {
        origine: 'Jardin Botanique "Daniela Brescia" - Majella',
        espece: 'holoschoenus Sojak',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Scirpoides',
        date_plantation: '2010',
        famille: 'Cyperaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cd2486aea2cd348c53351456158c5f1cbbeb8d69',
      fields: {
        origine: 'JB.et conservatoire de la ville de Gen\u00e8ve',
        espece: 'atrata L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Carex',
        date_plantation: '2004',
        famille: 'Cyperaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '28e0820343e046bcf35c0f56907a0d6549dcb692',
      fields: {
        origine: 'JB.Montr\u00e9al (Canada)',
        espece: 'plantaginea Lam.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Carex',
        date_plantation: '2006',
        famille: 'Cyperaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '775058c7832745a58d83c2150b588e6bafa23c9b',
      fields: {
        origine: "jardins d'\u00e9coute s'il pleut",
        espece: 'lepidopoda Hayata',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Dryopteris',
        date_plantation: '2015',
        famille: 'Dryopteridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c710e67ddca664b674b1eb8291103da9b92e3b3d',
      fields: {
        origine: 'R\u00e9colte nature (WLG-PF)',
        espece: 'affinis Fraser-Jenk',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Dryopteris',
        date_plantation: '2016',
        famille: 'Dryopteridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '208a32ca538663a1990924f53163173b76009309',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'macrophylla',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 88, 83, 1.00)',
            'rgba(128, 143, 157, 1.00)',
            'rgba(90, 95, 93, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/elaeagnus [elaeagnaceae]/elaeagnus macrophylla/elaeagnus macrophylla (3).jpg',
          width: 576,
          id: '7babfc49a434cd31a59b38f8cf740ad7',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 156, 137, 1.00)',
            'rgba(85, 121, 104, 1.00)',
            'rgba(67, 104, 81, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/elaeagnus [elaeagnaceae]/elaeagnus macrophylla/elaeagnus macrophylla (4).jpg',
          width: 576,
          id: '75e45a99a13b18de55da03c1157bc6ae',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 112, 88, 1.00)',
            'rgba(99, 143, 125, 1.00)',
            'rgba(73, 113, 96, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/elaeagnus [elaeagnaceae]/elaeagnus macrophylla/elaeagnus macrophylla (2).jpg',
          width: 576,
          id: '3a30592db6d870c2e6247dee2ace0928',
          height: 768,
          thumbnail: true,
        },
        location: [47.27027, -1.584292],
        genre: 'Elaeagnus',
        famille: 'Elaeagnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584292, 47.27027] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '98681c00ea7089b85263ffd15297514dc068bd14',
      fields: {
        espece: 'sylvestris',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 173, 139, 1.00)',
            'rgba(89, 92, 34, 1.00)',
            'rgba(64, 62, 35, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/elaeocarpus [elaeocarpaceae]/elaeocarpus sylvestris/elaeocarpus sylvestris  (8).jpg',
          width: 632,
          id: '1a294421ab871bd2a3f1e69e9b9ee4b5',
          height: 768,
          thumbnail: true,
        },
        location: [47.271587, -1.584742],
        genre: 'Elaeocarpus',
        famille: 'Elaeocarpaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584742, 47.271587] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3a9b519f9eb771cccf3ae9fe65e458c686cf4cd5',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x andrachnoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 142, 122, 1.00)',
            'rgba(153, 130, 119, 1.00)',
            'rgba(137, 117, 97, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus x andrachnoides/arbutus x andrachnoides (15).jpg',
          width: 576,
          id: '21dbef43fd4c1dcacbbbd528df8c9fc6',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 125, 169, 1.00)',
            'rgba(113, 113, 112, 1.00)',
            'rgba(93, 82, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus x andrachnoides/arbutus x andrachnoides (17).jpg',
          width: 1024,
          id: '120ecb1846a193abf831eeac258cee11',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(183, 186, 162, 1.00)',
            'rgba(107, 102, 56, 1.00)',
            'rgba(98, 94, 47, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus x andrachnoides/arbutus x andrachnoides (10).jpg',
          width: 576,
          id: 'f6678461385cee6a3c2140fd89ef1285',
          height: 768,
          thumbnail: true,
        },
        location: [47.27042, -1.58245],
        genre: 'Arbutus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58245, 47.27042] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '281e9a7741d6a32182e06a29446cb5034799c5c8',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'campanulatus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 91, 56, 1.00)',
            'rgba(99, 141, 85, 1.00)',
            'rgba(87, 126, 77, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/enkianthus [ericaceae]/enkianthus campanulatus/enkianthus campanulatus (1).jpg',
          width: 576,
          id: 'da4339e5e483c5d14d7e9395d50ad509',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 102, 60, 1.00)',
            'rgba(161, 136, 66, 1.00)',
            'rgba(102, 93, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/enkianthus [ericaceae]/enkianthus campanulatus/enkianthus campanulatus (2).jpg',
          width: 576,
          id: '9c4afe26359383c2514834fa03c388c9',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 123, 70, 1.00)',
            'rgba(156, 139, 120, 1.00)',
            'rgba(117, 112, 80, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/enkianthus [ericaceae]/enkianthus campanulatus/enkianthus campanulatu.jpg',
          width: 1024,
          id: '7f9e037577e6606e20a90612d18eaee0',
          height: 768,
          thumbnail: true,
        },
        location: [47.269378, -1.582242],
        genre: 'Enkianthus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582242, 47.269378] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9ad4e934a88aa862d8f0f0452b0df48cb0ad97e7',
      fields: {
        espece: 'x obtusum',
        localisation: 'B2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201934, -1.5449557],
        genre: 'Rhododendron',
        date_plantation: '1973',
        cultivar: 'Christina',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449557, 47.2201934] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3130d0695676dd74651a75546a0be24c8f7d105e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'corymbosum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 73, 55, 1.00)',
            'rgba(116, 83, 51, 1.00)',
            'rgba(105, 72, 49, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/vaccinium [ericaceae]/vaccinium corymbosum/vaccinium corymbosum (2).jpg',
          width: 1024,
          id: '6bba099eb74888c71b98730d99791c8b',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 65, 40, 1.00)',
            'rgba(129, 77, 55, 1.00)',
            'rgba(139, 84, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/vaccinium [ericaceae]/vaccinium corymbosum/vaccinium corymbosum (3).jpg',
          width: 1024,
          id: '64b62c98e1bb83e01a4b057f1dde2ff5',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 88, 60, 1.00)',
            'rgba(117, 95, 64, 1.00)',
            'rgba(98, 82, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/vaccinium [ericaceae]/vaccinium corymbosum/vaccinium corymbosum (1).jpg',
          width: 644,
          id: '9db8d1c033510096bde2373b3c0be5b9',
          height: 768,
          thumbnail: true,
        },
        location: [47.269497, -1.584963],
        genre: 'Vaccinium',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584963, 47.269497] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '013e1bb31d9c25feec97eb703964aba333cd926f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'bifida',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 108, 48, 1.00)',
            'rgba(123, 136, 96, 1.00)',
            'rgba(83, 98, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/escallonia [escalloniaceae]/escallonia bifida/escallonia bifida (2).jpg',
          width: 576,
          id: 'd99dcb4661c8519b8979265738bb3db3',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 124, 52, 1.00)',
            'rgba(121, 157, 64, 1.00)',
            'rgba(125, 155, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/escallonia [escalloniaceae]/escallonia bifida/escallonia bifida (3).jpg',
          width: 576,
          id: '5f505fff94a91a417a090abe3e021876',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 132, 87, 1.00)',
            'rgba(133, 141, 98, 1.00)',
            'rgba(121, 129, 94, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/escallonia [escalloniaceae]/escallonia bifida/escallonia bifida (1).jpg',
          width: 576,
          id: '0863a1fb4e09fe87919ce569ff8d898b',
          height: 768,
          thumbnail: true,
        },
        location: [47.27098, -1.585058],
        genre: 'Escallonia',
        famille: 'Escalloniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585058, 47.27098] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '64d483d431a2de576cd4296a8be67ce7c780c446',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'laevis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 135, 84, 1.00)',
            'rgba(138, 123, 86, 1.00)',
            'rgba(73, 89, 33, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/escallonia [escalloniaceae]/escallonia laevis/escallonia laevis (2).jpg',
          width: 576,
          id: 'ca14244452f848cf5d08f1130f3e81c6',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 153, 109, 1.00)',
            'rgba(123, 162, 90, 1.00)',
            'rgba(81, 132, 40, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/escallonia [escalloniaceae]/escallonia laevis/escallonia laevis (3).jpg',
          width: 576,
          id: '75f4dff990070a338b4ebe24a7f6052e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 155, 96, 1.00)',
            'rgba(133, 132, 93, 1.00)',
            'rgba(95, 113, 69, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/escallonia [escalloniaceae]/escallonia laevis/escallonia laevis (1).jpg',
          width: 576,
          id: '809421ab2c59d7f17bacc850bb2708fe',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Escallonia',
        famille: 'Escalloniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '14041dfb87dd3f12965e0f72d0e6aac7477d6550',
      fields: {
        origine: 'JB de Nantes (Issu de 2008-417s)',
        espece: 'mellifera',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Euphorbia',
        date_plantation: '2014',
        famille: 'Euphorbiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '217473546d5cfb8ee9404cb266f380b1ea549d73',
      fields: {
        espece: 'milii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 159, 113, 1.00)',
            'rgba(112, 157, 82, 1.00)',
            'rgba(106, 128, 89, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/euphorbia [euphorbiaceae]/euphorbia milii/euphorbia milii (2).jpg",
          width: 576,
          id: '3cd6daf88e5561c5a2047cd24a7db0c8',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 148, 114, 1.00)',
            'rgba(115, 118, 69, 1.00)',
            'rgba(135, 131, 126, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/euphorbia [euphorbiaceae]/euphorbia milii/euphorbia milii (1).jpg",
          width: 576,
          id: '7bf653adee79433e73134be202e5109a',
          height: 768,
          thumbnail: true,
        },
        location: [47.22668, -1.512263],
        genre: 'Euphorbia',
        famille: 'Euphorbiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512263, 47.22668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '331022bec43db46deccd88286407a87a1c6b6ad1',
      fields: {
        origine: 'JB.Oslo (Norv\u00e8ge)',
        espece: 'alpinus L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Astragalus',
        date_plantation: '2006',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6e0184a7b3d64ce921136dcfeb0c411b360c80e6',
      fields: {
        origine: 'P\u00e9pini\u00e8re Arven',
        espece: 'canadensis',
        localisation: 'B7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198817, -1.5442188],
        genre: 'Cercis',
        date_plantation: '2018',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442188, 47.2198817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a805ea1eabb60aea6b7127510ccd11435072218f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'engleriana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 135, 113, 1.00)',
            'rgba(124, 119, 83, 1.00)',
            'rgba(119, 114, 80, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus engleriana/fagus engleriana (22).jpg',
          width: 1024,
          id: 'f41afb9e8a2ecc735922f9f5981e382a',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 151, 137, 1.00)',
            'rgba(103, 108, 91, 1.00)',
            'rgba(91, 100, 85, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus engleriana/fagus engleriana (25).jpg',
          width: 1024,
          id: '6d114d9ad84933a371974a4b01fb0f9b',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(175, 170, 155, 1.00)',
            'rgba(127, 121, 84, 1.00)',
            'rgba(79, 95, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus engleriana/fagus engleriana (21).jpg',
          width: 1024,
          id: '768cd9b225bf1c45aa73545b0a8ae725',
          height: 683,
          thumbnail: true,
        },
        location: [47.27065, -1.581713],
        genre: 'Fagus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581713, 47.27065] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cc408f7c1c75173b8dbaeb5cac1491e91d303137',
      fields: {
        espece: 'canariensis',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 143, 171, 1.00)',
            'rgba(116, 124, 120, 1.00)',
            'rgba(95, 85, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus canariensis/quercus canariensis (3).jpg',
          width: 1024,
          id: '7b52fc1f1ad8ac73a20b4bda09289d13',
          height: 683,
          thumbnail: true,
        },
        location: [47.271222, -1.584388],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584388, 47.271222] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1cc74ef4b729edcafda58a93a4881390d95df37a',
      fields: {
        espece: 'frainetto',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 156, 185, 1.00)',
            'rgba(107, 86, 51, 1.00)',
            'rgba(60, 53, 28, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus frainetto/quercus frainetto (6).jpg',
          width: 512,
          id: '9e0a8edb6f41d092470e8a2844460de4',
          height: 768,
          thumbnail: true,
        },
        location: [47.270438, -1.585638],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585638, 47.270438] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0e6858d58532f7a5be702390d2c64e10bf3641bf',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'myrsinifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 105, 95, 1.00)',
            'rgba(111, 114, 103, 1.00)',
            'rgba(85, 85, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus myrsinifolia/quercus myrsinifolia (3).jpg',
          width: 576,
          id: '0e478b3a3b54895cf0c60262e3119d04',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 111, 101, 1.00)',
            'rgba(128, 120, 112, 1.00)',
            'rgba(122, 117, 114, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus myrsinifolia/quercus myrsinifolia (4).jpg',
          width: 576,
          id: '37ca9058c741173ba275e060ff3bfd51',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 156, 120, 1.00)',
            'rgba(140, 149, 98, 1.00)',
            'rgba(75, 99, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus myrsinifolia/quercus myrsinifolia (2).jpg',
          width: 576,
          id: 'c835b69d30fc2118ac6e33b10e640215',
          height: 768,
          thumbnail: true,
        },
        location: [47.2706, -1.582428],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582428, 47.2706] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '05d9b27f212f7d6fcb7081bcae5439c64a13d22f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'phillyreoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 102, 73, 1.00)',
            'rgba(110, 117, 84, 1.00)',
            'rgba(106, 102, 83, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus phillyreoides/quercus phillyreoides (2).jpg',
          width: 512,
          id: '6c609ec3160f6abfa75d982db1c5b8ad',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 115, 101, 1.00)',
            'rgba(118, 118, 103, 1.00)',
            'rgba(102, 105, 90, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus phillyreoides/quercus phillyreoides (3).jpg',
          width: 512,
          id: 'e874a236c67872b7cc998ab8f38e8ec1',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 167, 161, 1.00)',
            'rgba(101, 104, 85, 1.00)',
            'rgba(91, 90, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus phillyreoides/quercus phillyreoides (1).jpg',
          width: 512,
          id: '94cb323c00ae370d5cf186635bfdf973',
          height: 768,
          thumbnail: true,
        },
        location: [47.269825, -1.58187],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58187, 47.269825] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a131080c2430db215b59dd3fa4ed3f35d9c8bd27',
      fields: {
        espece: 'robur',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 140, 156, 1.00)',
            'rgba(108, 95, 50, 1.00)',
            'rgba(69, 63, 31, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/quercus [fagaceae]/quercus robur 'fastigiata'/quercus robur 'fastigiata'.jpg",
          width: 512,
          id: '54fb0c6c2068eec9cc30457774bffa14',
          height: 768,
          thumbnail: true,
        },
        location: [47.270064, -1.584686],
        genre: 'Quercus',
        cultivar: 'Fastigiata',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584686, 47.270064] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '260dac6f46b124e2e6b7ccc03230902c0393ebf8',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 128, 174, 1.00)',
            'rgba(106, 87, 108, 1.00)',
            'rgba(97, 94, 120, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/quercus [fagaceae]/quercus robur 'purpurea'/quercus robur 'purpurea' (3).jpg",
          width: 512,
          id: 'c8906cfda0df7427e4a173b7b4bb5099',
          height: 768,
          thumbnail: true,
        },
        espece: 'robur',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 133, 159, 1.00)',
            'rgba(121, 87, 93, 1.00)',
            'rgba(99, 85, 98, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/quercus [fagaceae]/quercus robur 'purpurea'/quercus robur 'purpurea' (2).jpg",
          width: 1024,
          id: 'e5a9d93569f1faa902f74a729128af5a',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 127, 173, 1.00)',
            'rgba(98, 102, 101, 1.00)',
            'rgba(88, 89, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/quercus [fagaceae]/quercus robur 'purpurea'/quercus robur 'purpurea' (1).jpg",
          width: 512,
          id: '3ec69e7e4cd85f3471f7044689979b82',
          height: 768,
          thumbnail: true,
        },
        location: [47.271192, -1.58622],
        genre: 'Quercus',
        cultivar: 'Purpurea',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58622, 47.271192] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '85b179b8806390fee29ba039269ad96a47d97fd8',
      fields: {
        origine: 'Japon - Chiba - Matsudo',
        espece: 'polycarpa',
        localisation: 'A5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2207668, -1.5440149],
        genre: 'Idesia',
        date_plantation: '2005',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440149, 47.2207668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '64006aa4a63df7d3969961e67b528122aa206179',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 118, 75, 1.00)',
            'rgba(108, 114, 73, 1.00)',
            'rgba(113, 115, 88, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/xylosma [flacourtiaceae]/xylosma japonica/xylosma japonica  (2).jpg',
          width: 1024,
          id: 'c8665efab6337ce86a7d0f6f620d0018',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 119, 74, 1.00)',
            'rgba(103, 123, 82, 1.00)',
            'rgba(92, 99, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/xylosma [flacourtiaceae]/xylosma japonica/xylosma japonica  (3).jpg',
          width: 1024,
          id: '35aad540fca76c5c4d4c9c90ce46e633',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 118, 128, 1.00)',
            'rgba(92, 101, 85, 1.00)',
            'rgba(93, 90, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/xylosma [flacourtiaceae]/xylosma japonica/xylosma japonica  (1).jpg',
          width: 512,
          id: 'd91575594e43437e122be631c5b92a9a',
          height: 768,
          thumbnail: true,
        },
        location: [47.271453, -1.586072],
        genre: 'Xylosma',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586072, 47.271453] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'df6266eb76dc4337fcb0afa0278971664751e218',
      fields: {
        origine: 'JB.Lyon (France)',
        espece: 'bigelowii  A. Gray.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Gentiana',
        date_plantation: '2000',
        famille: 'Gentianaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0b1bd4f33ebc2f37ee62a5e701d866d30a976085',
      fields: {
        origine: 'Jardin botanique universit\u00e9 Kawauchi Sendai',
        espece: 'soboliferum Kom.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Geranium',
        date_plantation: '2010',
        famille: 'Geraniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ad460d22dd902f91bc192a2925918e66f426591a',
      fields: {
        origine: 'JBU.Hokkaido (Japon)',
        espece: 'yesoense Fanch. & Sav.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Geranium',
        date_plantation: '2006',
        famille: 'Geraniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '73e31aba278b80f4043fa7dc011b1bac6a578596',
      fields: {
        espece: 'biloba',
        localisation: 'B1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2204652, -1.544656],
        genre: 'Ginkgo',
        date_plantation: '1995',
        famille: 'Ginkgoaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544656, 47.2204652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fb1b9e6257645a08f8c6ccea017669df3b768014',
      fields: {
        espece: 'biloba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(186, 203, 215, 1.00)',
            'rgba(158, 144, 92, 1.00)',
            'rgba(72, 69, 24, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/ginkgo [ginkgoaceae]/ginkgo biloba/ginkgo biloba (2).jpg',
          width: 576,
          id: '1e852af7b007c51bc2e0e5dd8de2a9d3',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 143, 162, 1.00)',
            'rgba(147, 142, 114, 1.00)',
            'rgba(152, 126, 64, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/ginkgo [ginkgoaceae]/ginkgo biloba/ginkgo biloba (1).jpg',
          width: 576,
          id: '0b1632f176a56fdf7a21980bea693ebd',
          height: 768,
          thumbnail: true,
        },
        location: [47.26118, -1.534072],
        genre: 'Ginkgo',
        famille: 'Ginkgoaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534072, 47.26118] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '536458a0962ffbd63eb6deffc28f2c1782804583',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'littoralis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 148, 76, 1.00)',
            'rgba(118, 140, 45, 1.00)',
            'rgba(97, 118, 42, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/griselinia [griseliniaceae]/griselinia littoralis/griselinia littoralis (2).jpg',
          width: 1024,
          id: 'b409e07a88e7da5dbcfc2d5757d6b67d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 156, 72, 1.00)',
            'rgba(134, 152, 67, 1.00)',
            'rgba(102, 132, 30, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/griselinia [griseliniaceae]/griselinia littoralis/griselinia littoralis.jpg',
          width: 576,
          id: '25b48e047a56263eba32eb007b8636a9',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 137, 33, 1.00)',
            'rgba(126, 160, 51, 1.00)',
            'rgba(91, 120, 24, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/griselinia [griseliniaceae]/griselinia littoralis/griselinia littoralis (1).jpg',
          width: 576,
          id: '6e88d01e7a656d55b08fcc2691911b58',
          height: 768,
          thumbnail: true,
        },
        location: [47.271092, -1.584438],
        genre: 'Griselinia',
        famille: 'Griseliniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584438, 47.271092] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1faea04905ff1219ecab8a27e82d80f475e81611',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'odoratum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 114, 45, 1.00)',
            'rgba(130, 137, 35, 1.00)',
            'rgba(71, 83, 35, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ribes [grossulariaceae]/ribes odoratum/ribes odoratum (2).jpg',
          width: 576,
          id: 'd873c116a86bee79f660720f1472154d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 142, 81, 1.00)',
            'rgba(122, 155, 104, 1.00)',
            'rgba(124, 125, 102, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ribes [grossulariaceae]/ribes odoratum/ribes odoratum.jpg',
          width: 576,
          id: 'dc6814695b8ed751fe3812293641293c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(169, 180, 146, 1.00)',
            'rgba(117, 135, 73, 1.00)',
            'rgba(114, 119, 74, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ribes [grossulariaceae]/ribes odoratum/ribes odoratum (1).jpg',
          width: 892,
          id: '2c74beb72583b6f01cd286724de65ac5',
          height: 768,
          thumbnail: true,
        },
        location: [47.271333, -1.586395],
        genre: 'Ribes',
        famille: 'Grossulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586395, 47.271333] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd18ed848800025aea7a0a57f4fdcc07dbc38dc85',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'sanguineum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 139, 98, 1.00)',
            'rgba(132, 136, 69, 1.00)',
            'rgba(146, 147, 79, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ribes [grossulariaceae]/ribes sanguineum/ribes sanguineum (2).jpg',
          width: 576,
          id: '77de0f6e148c9732454416232312e07e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 134, 72, 1.00)',
            'rgba(158, 101, 86, 1.00)',
            'rgba(136, 113, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ribes [grossulariaceae]/ribes sanguineum/ribes sanguineum (3).jpg',
          width: 580,
          id: 'aac072b64a292a146afa8c7286005273',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(178, 175, 155, 1.00)',
            'rgba(155, 124, 121, 1.00)',
            'rgba(106, 79, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ribes [grossulariaceae]/ribes sanguineum/ribes sanguineum (1).jpg',
          width: 576,
          id: 'b5aeeadb0788f82e007ae56c48f5fb37',
          height: 768,
          thumbnail: true,
        },
        location: [47.269847, -1.581783],
        genre: 'Ribes',
        famille: 'Grossulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581783, 47.269847] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'aa4a555120d16fce65882691ddbc544ad1beeac9',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'aspera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 162, 98, 1.00)',
            'rgba(107, 154, 79, 1.00)',
            'rgba(97, 137, 69, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hydrangea [hydrangeaceae]/hydrangea aspera/hydrangea aspera (2).jpg',
          width: 576,
          id: '29bf5a31ecae735cb89b8d5a9b44133e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 145, 96, 1.00)',
            'rgba(131, 149, 114, 1.00)',
            'rgba(117, 141, 103, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hydrangea [hydrangeaceae]/hydrangea aspera/hydrangea aspera (3).jpg',
          width: 576,
          id: 'e4af88ad6f11670c5ac302e79b201fbf',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 128, 85, 1.00)',
            'rgba(125, 125, 132, 1.00)',
            'rgba(74, 88, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hydrangea [hydrangeaceae]/hydrangea aspera/hydrangea aspera (1).jpg',
          width: 576,
          id: '13ae6c6de8cd88d58d34cdf8df483c66',
          height: 768,
          thumbnail: true,
        },
        location: [47.27142, -1.580538],
        genre: 'Hydrangea',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580538, 47.27142] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1aa958773ed840c63b311a3752ab9f92658ddbd6',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'quercifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 80, 35, 1.00)',
            'rgba(122, 135, 98, 1.00)',
            'rgba(75, 86, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hydrangea [hydrangeaceae]/hydrangea quercifolia/hydrangea quercifolia (2).jpg',
          width: 1024,
          id: 'a2b8d0ce1ce428163f903bcfae59bfdd',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 150, 95, 1.00)',
            'rgba(106, 133, 84, 1.00)',
            'rgba(102, 106, 81, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hydrangea [hydrangeaceae]/hydrangea quercifolia/hydrangea quercifolia (6).jpg',
          width: 1024,
          id: '44c61234661b0aac2f4a8bb11675e02b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 123, 60, 1.00)',
            'rgba(108, 143, 65, 1.00)',
            'rgba(94, 111, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hydrangea [hydrangeaceae]/hydrangea quercifolia/hydrangea quercifolia (1).jpg',
          width: 1024,
          id: '6b0f68b5ca5c9ad6b20e26e553d8b3bb',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Hydrangea',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '130066468642b0f483d5b16c4772f7543374c88e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'versicolor',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 119, 71, 1.00)',
            'rgba(155, 159, 117, 1.00)',
            'rgba(106, 115, 67, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/x didrangea [hydrangeaceae]/x didrangea versicolor/x didrangea versicolor (2).jpg',
          width: 785,
          id: '1a559e703e5a448ded5b643bc0c128aa',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 144, 80, 1.00)',
            'rgba(126, 133, 88, 1.00)',
            'rgba(93, 108, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/x didrangea [hydrangeaceae]/x didrangea versicolor/x didrangea versicolor (3).jpg',
          width: 576,
          id: 'c2a0c1098e57f025363c813172109e75',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 148, 60, 1.00)',
            'rgba(131, 160, 60, 1.00)',
            'rgba(105, 126, 45, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/x didrangea [hydrangeaceae]/x didrangea versicolor/x didrangea versicolor (1).jpg',
          width: 576,
          id: '128ec43701edca4ffd9af9e98f628385',
          height: 768,
          thumbnail: true,
        },
        location: [47.271455, -1.586587],
        genre: 'x Didrangea',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586587, 47.271455] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '45c53d03c9a99390522d515e01218ccc8b5f0bcb',
      fields: {
        origine: 'Goteborg Botanical Garten,Goteborg,Su\u00e8de',
        espece: 'biflorus Mill.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Crocus',
        date_plantation: '2012',
        cultivar: 'ssp.adamii B.Mathew',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd98a13d374eae83b4102f8160e32e57e0a8646f9',
      fields: {
        origine: 'Goteborg Botanical Garten;Goteborg,Su\u00e8de',
        espece: 'biflorus Mill.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Crocus',
        date_plantation: '2012',
        cultivar: 'pulchricolor B.Mathew',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '306f010e43e75874d2c61e85433bd16a2beaa9f6',
      fields: {
        origine: 'J.Alp.Montreux (France)',
        espece: 'missouriensis Nutt.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Iris',
        date_plantation: '2008',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1bd4f6ef23f69a32d98535c2e4481e9f2074f84b',
      fields: {
        origine: 'JB.Graz (Autriche)',
        espece: 'sp.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Iris',
        date_plantation: '2009',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '81f71491ee2314f941833beac3f55abdc3f8f17f',
      fields: {
        origine: 'Palmen Garten, Frankfurt, Allemagne',
        espece: 'chilensis Gunckel',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Libertia',
        date_plantation: '2012',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ba77a6ecf184cc9962e1aa930985e025438545c2',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 165, 73, 1.00)',
            'rgba(92, 146, 45, 1.00)',
            'rgba(71, 125, 18, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/itea [iteaceae]/itea virginica 'henry's garnet'/itea virginica 'henry's garnet'  (4).jpg",
          width: 576,
          id: '5a5feb5ad12dd3b341b2b5f5bc377462',
          height: 768,
          thumbnail: true,
        },
        espece: 'virginica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 126, 48, 1.00)',
            'rgba(92, 127, 73, 1.00)',
            'rgba(81, 113, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/itea [iteaceae]/itea virginica 'henry's garnet'/itea virginica 'henry's garnet'  (2).jpg",
          width: 576,
          id: 'b555cee06866874acf097c9a5b28c0d3',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 123, 77, 1.00)',
            'rgba(112, 142, 82, 1.00)',
            'rgba(92, 104, 81, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/itea [iteaceae]/itea virginica 'henry's garnet'/itea virginica 'henry's garnet'  (1).jpg",
          width: 1024,
          id: '89329239cd3d5fdebc2f9a4c9f7a7ad0',
          height: 768,
          thumbnail: true,
        },
        location: [47.271083, -1.58442],
        genre: 'Itea',
        cultivar: "Henry's Garnet",
        famille: 'Iteaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58442, 47.271083] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '49566ab6a038dcde2e0b42c36018b7d35958ace9',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'illinoinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 137, 82, 1.00)',
            'rgba(119, 146, 91, 1.00)',
            'rgba(82, 99, 53, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/carya [juglandaceae]/carya illinoinensis/carya illinoinensis (2).jpg",
          width: 576,
          id: '69bae669167cf079aeb0c0c2dbd9e0df',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 127, 149, 1.00)',
            'rgba(118, 121, 86, 1.00)',
            'rgba(83, 87, 37, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/carya [juglandaceae]/carya illinoinensis/carya illinoinensis (3).jpg",
          width: 1024,
          id: '750633f7cecd5a9680f129db9db5aadc',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(169, 175, 155, 1.00)',
            'rgba(111, 123, 97, 1.00)',
            'rgba(48, 57, 32, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/carya [juglandaceae]/carya illinoinensis/carya illinoinensis (1).jpg",
          width: 576,
          id: 'ccb89a9ad7d552821336855113aca5ba',
          height: 768,
          thumbnail: true,
        },
        location: [47.226638, -1.512703],
        genre: 'Carya',
        famille: 'Juglandaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512703, 47.226638] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'abe610eaa56ab5dc7d138933bc68cedec53fc631',
      fields: {
        origine: 'JB.Brooklin (USA)',
        espece: 'marginatus  Rostk',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Juncus',
        date_plantation: '2008',
        famille: 'Juncaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bfcba929b0fe0c426dca92e3a657fe764bbcbb30',
      fields: {
        origine: 'Jardin botanique alpin Saussurea',
        espece: 'alpino-articulatus Chaix',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Juncus',
        date_plantation: '2010',
        famille: 'Juncaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bfa17f69045786a50199c4bde44553dc030396d6',
      fields: {
        origine: 'JB.et Conservatoire de Gen\u00e8ve (Suisse)',
        espece: 'nivea Baumg.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Luzula',
        date_plantation: '2006',
        famille: 'Juncaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3fcd78a85d22d08a6ab9925300530da7c0db1759',
      fields: {
        origine: 'JBU.Z\u00fcrich (Suisse)',
        espece: 'nivea DC.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Luzula',
        date_plantation: '2004',
        famille: 'Juncaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2900badb8ce0baa87956e5e4327701aa43bb4702',
      fields: {
        origine: 'Emmanuel LEPAGE',
        espece: 'govaniana Benth.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Nepeta',
        date_plantation: '2015',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4b58680d879e73a90d19c75ce182983e52aee160',
      fields: {
        origine: 'JB.National de Meise',
        espece: 'suaveolens Ehrh.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Mentha',
        date_plantation: '2003',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '14d8ff7ae3cd3c14340b99f1f1860b927201183b',
      fields: {
        origine: 'JB.Rostov ad Donum (Russie)',
        espece: 'verticillata L.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Salvia',
        date_plantation: '2009',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1d62a7caca727cbda746aa32f3f977ce199034b8',
      fields: {
        origine: 'Med.Herb.Garden of Washington',
        espece: 'thymbra L.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Satureja',
        date_plantation: '2015',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6316693143a591f27254757f799485bf0290a6a8',
      fields: {
        origine: 'P\u00e9pini\u00e8re Arven',
        espece: 'yagiharana Honshu',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Chelonopsis',
        date_plantation: '2015',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5d020261a968ae006950a3f89ea402a62c788da7',
      fields: {
        origine: 'Universit\u00e9 Giessen (Allemagne)',
        espece: 'pyrenaicum  Georgi',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Horminum',
        date_plantation: '2011',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '55ef56121d81bc421aef7243619c8e0d969c57bf',
      fields: {
        espece: 'kwangtungensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 114, 65, 1.00)',
            'rgba(87, 112, 47, 1.00)',
            'rgba(73, 101, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/callicarpa [lamiaceae]/callicarpa kwangtungensis/callicarpa kwangtungensis (2).jpg',
          width: 576,
          id: 'f1a1eb632f030e29f521bbf994da8709',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 99, 58, 1.00)',
            'rgba(99, 100, 68, 1.00)',
            'rgba(97, 102, 49, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/callicarpa [lamiaceae]/callicarpa kwangtungensis/callicarpa kwangtungensis (1).jpg',
          width: 576,
          id: '5160bab7243e972f14dc10f1a798041f',
          height: 768,
          thumbnail: true,
        },
        location: [47.271503, -1.586675],
        genre: 'Callicarpa',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586675, 47.271503] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '03aa7c279849321b5db27ae21304db703a947ff7',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'cuneata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 146, 90, 1.00)',
            'rgba(112, 135, 82, 1.00)',
            'rgba(97, 117, 70, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/prostanthera [lamiaceae]/prostanthera cuneata/prostanthera cuneata (2).jpg',
          width: 576,
          id: '930b04cdbe02b4ce6bfdd35b51044ffc',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 118, 97, 1.00)',
            'rgba(123, 120, 113, 1.00)',
            'rgba(106, 105, 82, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/prostanthera [lamiaceae]/prostanthera cuneata/prostanthera cuneata (4).jpg',
          width: 1024,
          id: 'c9b72a14ca6ff4d77d1662fbef62001a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 122, 92, 1.00)',
            'rgba(122, 136, 95, 1.00)',
            'rgba(128, 129, 97, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/prostanthera [lamiaceae]/prostanthera cuneata/prostanthera cuneata (1).jpg',
          width: 1024,
          id: '475fa8137fc2f3312c5103b212da9ec2',
          height: 768,
          thumbnail: true,
        },
        location: [47.271612, -1.582637],
        genre: 'Prostanthera',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582637, 47.271612] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '32cecc6bc3832a1f7d53e0f058bd289195749e9f',
      fields: {
        espece: 'agnus-castus f. alba',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 139, 167, 1.00)',
            'rgba(107, 108, 73, 1.00)',
            'rgba(69, 76, 35, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/vitex [lamiaceae]/vitex agnus-castus f. alba 'silver spire'/vitex agnus-castus f. alba 'silver spire'.jpg",
          width: 576,
          id: 'd1c9708a96d5b90ea5873bee0954d662',
          height: 768,
          thumbnail: true,
        },
        location: [47.271017, -1.582513],
        genre: 'Vitex',
        cultivar: 'Silver Spire',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582513, 47.271017] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9889d875a1dba5483c06d42c8f442b173270147c',
      fields: {
        espece: 'agnus-castus',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(186, 193, 169, 1.00)',
            'rgba(130, 143, 106, 1.00)',
            'rgba(92, 108, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/vitex [lamiaceae]/vitex agnus-castus/vitex agnus-castus .jpg',
          width: 1024,
          id: '6c5bf23fead1247a0cb78730dd22585e',
          height: 768,
          thumbnail: true,
        },
        location: [47.271317, -1.5869],
        genre: 'Vitex',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5869, 47.271317] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f967ec54d24f979e873b41548cea82239ab0257d',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'camphora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 135, 55, 1.00)',
            'rgba(117, 138, 55, 1.00)',
            'rgba(120, 132, 56, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/cinnamomum [lauraceae]/cinnamomum camphora/cinnamomum camphora (2).jpg",
          width: 576,
          id: '564c1ec9eff348a0dd730baf4f45b583',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 185, 143, 1.00)',
            'rgba(77, 107, 53, 1.00)',
            'rgba(95, 99, 77, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/cinnamomum [lauraceae]/cinnamomum camphora/cinnamomum camphora (3).jpg",
          width: 512,
          id: '096356e20b6fc7646d07c128309faba9',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 173, 87, 1.00)',
            'rgba(119, 132, 64, 1.00)',
            'rgba(98, 110, 41, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/cinnamomum [lauraceae]/cinnamomum camphora/cinnamomum camphora (1).jpg",
          width: 576,
          id: '614bdef3c51bdfcc159e4ec6a999a603',
          height: 768,
          thumbnail: true,
        },
        location: [47.226667, -1.512245],
        genre: 'Cinnamomum',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512245, 47.226667] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0fa55e80df361711655bc863235f780c6c818330',
      fields: {
        origine: 'J.Alpin des Rochers-de-Naye,Montreux,Suisse',
        espece: 'turkestanica Regel',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Tulipa',
        date_plantation: '2012',
        famille: 'Liliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ba6d15810aeb24487bca530190a38281faecc6ef',
      fields: {
        origine: 'JB.Matsudo (Japon)',
        espece: 'formosanum A.Wallace',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Lilium',
        date_plantation: '2009',
        famille: 'Liliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c6a570f06c8d6d25511bddc8b856c4fe40009f52',
      fields: {
        origine: 'P.Prieur - 72 Allonnes (Le Mans)',
        espece: 'salicifolia',
        localisation: 'A2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2208871, -1.5444631],
        genre: 'Heimia',
        date_plantation: '2016',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444631, 47.2208871] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ebb76ca59e50f6a84da7f4d85b25bf86a2c6055c',
      fields: {
        espece: 'granatum var. nana',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 93, 39, 1.00)',
            'rgba(110, 116, 42, 1.00)',
            'rgba(156, 145, 107, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/punica [lythraceae]/punica granatum var. nana/punica granatum var. nana.jpg',
          width: 1024,
          id: '557e7226f5323bbc7fb5779ca6391795',
          height: 768,
          thumbnail: true,
        },
        location: [47.269378, -1.583888],
        genre: 'Punica',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583888, 47.269378] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '90d4cc0f861545ab110475181d3f9cba8ad8cbf8',
      fields: {
        espece: 'tulipifera',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Liriodendron',
        date_plantation: '1973',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7c271d3028808d379e6874fa0b3f7b056c91a732',
      fields: {
        espece: 'tulipifera',
        localisation: 'B7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198817, -1.5442188],
        genre: 'Liriodendron',
        date_plantation: '1973',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442188, 47.2198817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2b5b13b926e814bb9e93a6ef35425177da2d0b3f',
      fields: {
        espece: 'virginiana',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Magnolia',
        date_plantation: '1973',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5bcbfbd0cfa711e17865cfbc5b921b254bd624cb',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(210, 132, 185, 1.00)',
            'rgba(176, 87, 140, 1.00)',
            'rgba(216, 161, 222, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'star wars'/magnolia 'star wars' (3).jpg",
          width: 576,
          id: '728096ec3b1d61490483e967c7c32171',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(182, 174, 169, 1.00)',
            'rgba(114, 106, 77, 1.00)',
            'rgba(95, 93, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'star wars'/magnolia 'star wars' (5).jpg",
          width: 1024,
          id: '0ac31cc4755cfa088be4c8d12bf2a3cd',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 98, 105, 1.00)',
            'rgba(169, 133, 158, 1.00)',
            'rgba(102, 82, 91, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'star wars'/magnolia 'star wars' (1).jpg",
          width: 583,
          id: 'e467d05b2c094b35af496d873e77ab35',
          height: 768,
          thumbnail: true,
        },
        location: [47.269288, -1.584097],
        genre: 'Magnolia',
        cultivar: 'Star Wars',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584097, 47.269288] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b9cc20d5395d97d9914e5213c975f45c45594fd4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 142, 182, 1.00)',
            'rgba(107, 120, 131, 1.00)',
            'rgba(97, 84, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'yellow lantern'/magnolia 'yellow lantern'  (2).jpg",
          width: 512,
          id: 'c64300918242f74ca0d264847205bf02',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 159, 168, 1.00)',
            'rgba(103, 103, 77, 1.00)',
            'rgba(67, 70, 39, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'yellow lantern'/magnolia 'yellow lantern'  (3).jpg",
          width: 1024,
          id: '32f8e850cb12c237e903431b21bb78ad',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 163, 186, 1.00)',
            'rgba(140, 144, 142, 1.00)',
            'rgba(68, 65, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'yellow lantern'/magnolia 'yellow lantern'  (1).jpg",
          width: 1024,
          id: '28403530764d38a9ac57ae33f92acd38',
          height: 683,
          thumbnail: true,
        },
        location: [47.271538, -1.586975],
        genre: 'Magnolia',
        cultivar: 'Yellow Lantern',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586975, 47.271538] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '566dadac01f9db8dcad6d96827d77111a1f1f625',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'Fairy Cream (MicJur02)',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 97, 81, 1.00)',
            'rgba(125, 123, 100, 1.00)',
            'rgba(87, 85, 67, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia fairy cream ('micjur02')/magnolia fairy cream ('micjur02') (2).jpg",
          width: 1024,
          id: 'c1d6a212f969d14ad0bd1dad95788832',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 97, 84, 1.00)',
            'rgba(108, 112, 98, 1.00)',
            'rgba(89, 85, 74, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia fairy cream ('micjur02')/magnolia fairy cream ('micjur02').jpg",
          width: 1024,
          id: 'bc3a773012a08ec8aec872d72469829f',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 87, 56, 1.00)',
            'rgba(114, 115, 82, 1.00)',
            'rgba(115, 116, 88, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia fairy cream ('micjur02')/magnolia fairy cream ('micjur02') (1).jpg",
          width: 1024,
          id: '36c2990c9534b814d5cec6ff15870d6d',
          height: 683,
          thumbnail: true,
        },
        location: [47.270688, -1.580897],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580897, 47.270688] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dc9bc35d53a9219ca8caff398670fe10a6c3c090',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 115, 123, 1.00)',
            'rgba(141, 139, 141, 1.00)',
            'rgba(89, 82, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia x loebneri 'leonard messel'/magnolia x loebneri 'leonard messel' (3).jpg",
          width: 576,
          id: '22f9c0cb235ff17ce7297d9f13e3b8c3',
          height: 768,
          thumbnail: true,
        },
        espece: 'x loebneri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 115, 89, 1.00)',
            'rgba(135, 131, 120, 1.00)',
            'rgba(72, 71, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia x loebneri 'leonard messel'/magnolia x loebneri 'leonard messel' (2).jpg",
          width: 576,
          id: '837f93741458196b2fd7799bf0cf7696',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 148, 149, 1.00)',
            'rgba(143, 130, 122, 1.00)',
            'rgba(135, 132, 134, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia x loebneri 'leonard messel'/magnolia x loebneri 'leonard messel' (1).jpg",
          width: 576,
          id: '5b4d2282652e84d6e73d4cc2b1ce82ce',
          height: 768,
          thumbnail: true,
        },
        location: [47.269942, -1.585805],
        genre: 'Magnolia',
        cultivar: 'Leonard Messel',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585805, 47.269942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6cfe657ddc3c451e9810df07e73882e6ece4d70e',
      fields: {
        espece: 'sexstylosa',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 188, 150, 1.00)',
            'rgba(82, 107, 56, 1.00)',
            'rgba(56, 73, 41, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hoheria [malvaceae]/hoheria sexstylosa 'stardust'/hoheria sexstylosa 'stardust'.jpg",
          width: 512,
          id: 'b852ec2692e82333922d16f621299cf0',
          height: 768,
          thumbnail: true,
        },
        location: [47.271233, -1.58468],
        genre: 'Hoheria',
        cultivar: 'Stardust',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58468, 47.271233] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '17ec0cecfa7c4ee9be7fccb81a24e475069b24f7',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'retusus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 85, 41, 1.00)',
            'rgba(117, 122, 99, 1.00)',
            'rgba(166, 159, 157, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chionanthus [oleaceae]/chionanthus retusus/chionanthus retusus (11).jpg',
          width: 1024,
          id: 'aa22b17d18a82f262113d3f886761236',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 174, 169, 1.00)',
            'rgba(79, 89, 67, 1.00)',
            'rgba(58, 61, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chionanthus [oleaceae]/chionanthus retusus/chionanthus retusus (12).jpg',
          width: 1024,
          id: '004f1b83e8035c02c3141971fd76531a',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 183, 177, 1.00)',
            'rgba(102, 113, 68, 1.00)',
            'rgba(54, 61, 35, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chionanthus [oleaceae]/chionanthus retusus/chionanthus retusus (1).jpg',
          width: 512,
          id: 'c865bedf22e71052ebfc54a86ca0caf5',
          height: 768,
          thumbnail: true,
        },
        location: [47.269488, -1.584895],
        genre: 'Chionanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584895, 47.269488] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e9b3d00835e69f79143f9d9b8d281a0a1f7067ff',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'decorus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 104, 48, 1.00)',
            'rgba(124, 133, 71, 1.00)',
            'rgba(77, 87, 30, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus decorus/osmanthus decorus (3).jpg',
          width: 576,
          id: 'ea62434a8ae688b552ccff539d727672',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 175, 142, 1.00)',
            'rgba(123, 131, 77, 1.00)',
            'rgba(107, 112, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus decorus/osmanthus decorus .jpg',
          width: 1024,
          id: '37dcd5f0c733102d37ee50e1c6a4a1f8',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 160, 105, 1.00)',
            'rgba(118, 139, 79, 1.00)',
            'rgba(119, 133, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus decorus/osmanthus decorus (1).jpg',
          width: 576,
          id: '1bbfe5b8a42148ff41576fcfddbe9517',
          height: 768,
          thumbnail: true,
        },
        location: [47.271108, -1.582353],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582353, 47.271108] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '869d97b7226e749321d6ea1db024520ce9dc3afc',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'suavis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 114, 72, 1.00)',
            'rgba(112, 117, 73, 1.00)',
            'rgba(111, 110, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus suavis/osmanthus suavis (2).jpg',
          width: 576,
          id: '5c57d8078433cbed66acdbed7c2002cf',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(180, 181, 183, 1.00)',
            'rgba(119, 131, 105, 1.00)',
            'rgba(108, 104, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus suavis/osmanthus suavis (3).jpg',
          width: 661,
          id: 'd8e4597e65c5140e2caffc5b33d78928',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 138, 115, 1.00)',
            'rgba(114, 133, 107, 1.00)',
            'rgba(98, 115, 83, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus suavis/osmanthus suavis (1).jpg',
          width: 576,
          id: '9d862343151c80a5d5824da0c0faf490',
          height: 768,
          thumbnail: true,
        },
        location: [47.271487, -1.584838],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584838, 47.271487] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '64609704b08b6f2f3854ab92f85f703c940a9b7e',
      fields: {
        origine: 'JB. Hongrois, V\u00e0cr\u00e0tot ( Hongrie)',
        espece: 'chicagoensis Renner',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Oenothera',
        date_plantation: '2011',
        famille: 'Onagraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c3d9c384a6276376cdfb5c0a006e14206fd764cc',
      fields: {
        espece: 'regalis L.',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Osmunda',
        date_plantation: '1973',
        famille: 'Osmundaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '55ee2436880f4255d2a09831932a08e4cbd2649b',
      fields: {
        origine: 'Giardino Botanico Daniella Brescia (Italie)',
        espece: 'officinalis NGPassal &bernardo',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Paeonia',
        date_plantation: '2013',
        cultivar: 'ssp.italica',
        famille: 'Paeoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '98653600bdc79c1deb6f3fe272269a68f9dfa14d',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'mlokosewitschi Lomak.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Paeonia',
        date_plantation: '1987',
        famille: 'Paeoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ddcfb521ef766fe4bba50f9c7a984d90307c98b8',
      fields: {
        origine: 'Les Ponts de C\u00e9_p\u00e9pini\u00e8re Lepage',
        espece: 'spectabilis Lam.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Dicentra',
        date_plantation: '2016',
        famille: 'Papaveraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f9f809682585ee7ca6e0a9264825f3e279098531',
      fields: {
        origine: 'Universit\u00e9 de Potsdam',
        espece: 'diphyllum Nutt.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Stylophorum',
        date_plantation: '2010',
        famille: 'Papaveraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7089ccb9bb812c356f63bb9ea1560cad26ad15e4',
      fields: {
        espece: 'kentukea',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 94, 83, 1.00)',
            'rgba(130, 109, 67, 1.00)',
            'rgba(126, 114, 83, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cladrastis [papilionaceae]/cladrastis kentukea/cladrastis kentukea (12).jpg',
          width: 512,
          id: 'a44bf1da3f7e49bbc932543cdfda3e18',
          height: 768,
          thumbnail: true,
        },
        location: [47.271278, -1.582512],
        genre: 'Cladrastis',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582512, 47.271278] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'da992a20a0a195952f59a26c3a34dab5d1947178',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'anagyroides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 123, 36, 1.00)',
            'rgba(115, 125, 22, 1.00)',
            'rgba(92, 110, 19, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/laburnum [papilionaceae]/laburnum anagyroides/laburnum anagyroides (2).jpg',
          width: 576,
          id: '80c1fd17fe093961c836611d04d09766',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 156, 57, 1.00)',
            'rgba(107, 149, 45, 1.00)',
            'rgba(116, 142, 25, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/laburnum [papilionaceae]/laburnum anagyroides/laburnum anagyroides (3).jpg',
          width: 576,
          id: '12c3cc2a3bbb788faa55ac9f5362aa80',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 143, 98, 1.00)',
            'rgba(113, 128, 61, 1.00)',
            'rgba(82, 92, 40, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/laburnum [papilionaceae]/laburnum anagyroides/laburnum anagyroides (1).jpg',
          width: 1024,
          id: '5d8b258f43ee7f667dcf142c8366d8f4',
          height: 768,
          thumbnail: true,
        },
        location: [47.271517, -1.582487],
        genre: 'Laburnum',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582487, 47.271517] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b0da6f21d327b2bf2c2f55eb5e9f62abff1f7255',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 144, 94, 1.00)',
            'rgba(121, 138, 91, 1.00)',
            'rgba(76, 96, 48, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/robinia [papilionaceae]/robinia pseudoacacia 'tortuosa'/robinia pseudoacacia 'tortuosa' (3).jpg",
          width: 576,
          id: 'b054ac6fc82230ab308eea528e952b4f',
          height: 768,
          thumbnail: true,
        },
        espece: 'pseudoacacia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(183, 204, 222, 1.00)',
            'rgba(133, 150, 127, 1.00)',
            'rgba(63, 74, 30, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/robinia [papilionaceae]/robinia pseudoacacia 'tortuosa'/robinia pseudoacacia 'tortuosa' (2).jpg",
          width: 1024,
          id: '87a5b3c5e05bbd53ecb85fa63d304706',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 192, 123, 1.00)',
            'rgba(91, 124, 44, 1.00)',
            'rgba(64, 97, 39, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/robinia [papilionaceae]/robinia pseudoacacia 'tortuosa'/robinia pseudoacacia 'tortuosa' (1).jpg",
          width: 576,
          id: '77d90ddad67064cf1280e04325126332',
          height: 768,
          thumbnail: true,
        },
        location: [47.270837, -1.582855],
        genre: 'Robinia',
        cultivar: 'Tortuosa',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582855, 47.270837] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd3a036b035fa95b9a9600f2d5077f91206d33173',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'jeffreyi',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 143, 168, 1.00)',
            'rgba(99, 113, 123, 1.00)',
            'rgba(102, 103, 96, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pinus [pinaceae]/pinus jeffreyi/pinus jeffreyi (2).jpg',
          width: 1024,
          id: '953ec1d449d63b3ea79c1cae9473bf70',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 168, 184, 1.00)',
            'rgba(91, 95, 81, 1.00)',
            'rgba(49, 45, 24, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pinus [pinaceae]/pinus jeffreyi/pinus jeffreyi (3).jpg',
          width: 512,
          id: '797e7abb701523b55ea25c8be9f98332',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 139, 175, 1.00)',
            'rgba(83, 110, 135, 1.00)',
            'rgba(85, 108, 126, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pinus [pinaceae]/pinus jeffreyi/pinus jeffreyi (1).jpg',
          width: 1024,
          id: '1bd934512c27e3f3e0e4e81cdb85ef25',
          height: 683,
          thumbnail: true,
        },
        location: [47.270154, -1.582108],
        genre: 'Pinus',
        famille: 'Pinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582108, 47.270154] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b6ce88f1418f2e106fd00733aa02650419b74093',
      fields: {
        espece: 'truncatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 134, 113, 1.00)',
            'rgba(132, 135, 102, 1.00)',
            'rgba(117, 105, 84, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/pittosporum [pittosporaceae]/pittosporum truncatum 'variegatum'/pittosporum truncatum 'variegata' (2).jpg",
          width: 576,
          id: '2aae70aafc5f0b02405375b7dd66c662',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 143, 109, 1.00)',
            'rgba(139, 145, 109, 1.00)',
            'rgba(119, 121, 90, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/pittosporum [pittosporaceae]/pittosporum truncatum 'variegatum'/pittosporum truncatum 'variegata' (1).jpg",
          width: 576,
          id: '671e4febb2c67e940beeda28dc161802',
          height: 768,
          thumbnail: true,
        },
        location: [47.27133, -1.586422],
        genre: 'Pittosporum',
        cultivar: 'Variegatum',
        famille: 'Pittosporaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586422, 47.27133] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '778b8370998e4411d5ddf65d134d7520ef448f8a',
      fields: {
        origine: 'B.G Munchen All.',
        espece: 'repens Lam.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Globularia',
        date_plantation: '2014',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ce9e8421f0d894ff6809d7d90d989006f59f54da',
      fields: {
        origine: 'Jardin des Plantes de Nantes,France',
        espece: 'parviflora Jack.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Digitalis',
        date_plantation: '2014',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6ea7549757c9b820473bdce79a9f7164d7962e16',
      fields: {
        origine: 'JB. De Frankfurt (Allemagne)',
        espece: 'grandiflora Mill.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Digitalis',
        date_plantation: '2011',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '36e3b7ab2fce1ce575f4de3bc83d6b39702a0c27',
      fields: {
        origine: 'JB.Meyrin (Suisse)',
        espece: 'alpinus  L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Erinus',
        date_plantation: '2008',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '39aa6457054db3e560f164d113ac09ae2369e386',
      fields: {
        origine: "Universita degli Studi dell'Aquila",
        espece: 'lutea L.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Digitalis',
        date_plantation: '2006',
        cultivar: 'australis Arcangeli',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4c147c2148294672f603dba8a6321c364750a598',
      fields: {
        origine: 'Conservatoire botanique de Gen\u00e8ve (Suisse)',
        espece: 'transmontana Lawrence',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Armeria',
        date_plantation: '2011',
        famille: 'Plumbaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2922be3911c98a013d06f29b8a1d529995c15cc9',
      fields: {
        origine: 'JB.Leipzig (Allemagne)',
        espece: 'eximium Boiss',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Goniolimon (Statice)',
        date_plantation: '2009',
        famille: 'Plumbaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5120135e588e8300f433f1809097aa29f74ed77f',
      fields: {
        origine: 'JB.T\u00e9h\u00e9ran (Iran)',
        espece: 'crinum-ursi',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Festuca',
        date_plantation: '2006',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1ff644abdf73e6a161b23f541996bab118fadd53',
      fields: {
        origine: 'JBU.Matsudo (Japon)',
        espece: 'sinensis Anderss.',
        localisation: 'D3D',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201668, -1.5418243],
        genre: 'Miscanthus',
        date_plantation: '1990',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418243, 47.2201668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '875bb9dd182a00cfa599cb952299774a07b1d816',
      fields: {
        origine: 'JBU.Oulou (Finlande)',
        espece: 'nutans L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Melica',
        date_plantation: '2003',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '40365109e9259fad5f5b8f47347165f0b6bc80ad',
      fields: {
        espece: 'latifolia Michx.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Uniola',
        date_plantation: '1973',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9c5a749f47c4e5cefc0e459d5ef8dcc7358b13bc',
      fields: {
        origine: 'Botanique garden univer. Agricultre - Batumi',
        espece: 'adzharicum Pobed.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Cyclamen',
        date_plantation: '2010',
        famille: 'Primulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '90770b0823191e8b2bdf1d5cd3be33011a4f9a04',
      fields: {
        origine: "Facult\u00e9 d'horticulture de Chiba,Japon",
        espece: 'clethroides Duby.',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Lysimachia',
        date_plantation: '2014',
        famille: 'Primulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8168479fd8d9fc7d2eacca02d1f3e77af685fe0b',
      fields: {
        origine: 'JB. Nitra (Slovaquie)',
        espece: 'clethroides Duby',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Lysimachia',
        date_plantation: '2011',
        famille: 'Primulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '141fb1d9f4d16f8ea5b794cb435e9b53e1d2e85c',
      fields: {
        origine: 'JB.The Kyoto (Japon)',
        espece: 'japonica A.Gray',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Primula',
        date_plantation: '2006',
        famille: 'Primulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '37a9a1ae751e8c5abfe3ae22996d2b1e262ec2e6',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'juniperina',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 135, 71, 1.00)',
            'rgba(133, 141, 89, 1.00)',
            'rgba(140, 151, 91, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/grevillea [proteaceae]/grevillea juniperina/grevillea juniperina (2).jpg',
          width: 576,
          id: '7940457d3a2bb7dec5c2011b283cf9a7',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 155, 105, 1.00)',
            'rgba(122, 130, 76, 1.00)',
            'rgba(145, 133, 94, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/grevillea [proteaceae]/grevillea juniperina/grevillea juniperina (3).jpg',
          width: 1024,
          id: 'd02e9639336882e98f54b0df6df1738e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 130, 72, 1.00)',
            'rgba(130, 151, 93, 1.00)',
            'rgba(136, 147, 100, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/grevillea [proteaceae]/grevillea juniperina/grevillea juniperina (1).jpg',
          width: 576,
          id: '5ff947047c9706c7e474d5a2e8059160',
          height: 768,
          thumbnail: true,
        },
        location: [47.271287, -1.582028],
        genre: 'Grevillea',
        famille: 'Proteaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582028, 47.271287] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '56695801d77a74f98be67bee4d7f1072892720a7',
      fields: {
        origine: 'Conservatoire et JB.de Gen\u00e8ve (Suisse)',
        espece: 'aquilegifolium L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Thalictrum',
        date_plantation: '2003',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c3c262120efa1c46abdc1d57a58f476e5194e041',
      fields: {
        origine: 'Goteborg Botanical Garden(Su\u00e8de)',
        espece: 'ranunculoides Hemsl.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Trollius',
        date_plantation: '2012',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c282aa1c9805a22b2b169a3aa8d4560b2fe84999',
      fields: {
        origine: 'Hortus botanicus Pietra Corva (Italie)',
        espece: 'atrata Koch',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Aquilegia',
        date_plantation: '2008',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2fe96e505ab02419f28730d1cf5cdece222a6600',
      fields: {
        origine: 'J.Alp.Paradisia Cogne (Italie)',
        espece: 'fetidum L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Thalictrum',
        date_plantation: '2006',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0a77611056ad99c3237e823496c94cb114a754ef',
      fields: {
        origine: 'J.Alp.Trento (Italie)',
        espece: 'narcissiflora L.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Anemone',
        date_plantation: '2006',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c84296d71bb479d45252df7e68c4b6b39a7eb76c',
      fields: {
        origine: 'JB.Chemnitz (Allemagne)',
        espece: 'virginiana Mill.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Anemone',
        date_plantation: '2006',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '48c8d217e4ff8ad80b86e5db6e94b8d6f8e9afa9',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'albana Bercht & Prest',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Pulsatilla',
        date_plantation: '2006',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8bcc755655d95ee45029df2cf876e7aaafd39ab9',
      fields: {
        origine: 'JB.Leipzig (Allemagne)',
        espece: 'gramineus L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Ranunculus',
        date_plantation: '2009',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f05aae071fad5385dbb4945e2b0110d68467370c',
      fields: {
        origine: 'JB.South Hadley (U.S.A.)',
        espece: 'pubescens Pursh',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Thalictrum',
        date_plantation: '2003',
        cultivar: 'saxatile Schinz. & Keller',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5995ea68821aa4b315f00065156d759b97e2dc57',
      fields: {
        origine: 'JBU.Z\u00fcrich (Suisse)',
        espece: 'atrata Koch',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Aquilegia',
        date_plantation: '2003',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dc470514deaacc9aa94141cd5cb6323820852e72',
      fields: {
        origine: 'P\u00e9pini\u00e8res E.Lepage',
        espece: 'palustris L.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Caltha',
        date_plantation: '2016',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a90c6af9dcbd97c91dcbeee6e84967d66567487f',
      fields: {
        origine: 'JB.W.J Beal Michigan (USA.)',
        espece: 'racemosa Nutt.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Cimicifuga',
        date_plantation: '1987',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'faf038d5fccdab915dada92cba290c99ca9b1fd0',
      fields: {
        origine: 'JB Univ. Delft (NL)',
        espece: 'saxatilis',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Rhamnus',
        date_plantation: '2012',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8a86a597d38d3202b7c09c6b19d85f0dc86ca4bd',
      fields: {
        origine: 'Origine sauvage\u00a0: \u00cele de Noirmoutier',
        espece: 'alaternus',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Rhamnus',
        date_plantation: '2014',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '75183be521ee3993cddde2ddd4e7f2db06543b89',
      fields: {
        origine: 'P\u00e9pini\u00e8re Arven',
        espece: 'ramosissimus',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Paliurus',
        date_plantation: '2018',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '04e19bab8807cb89b6ae6fe7b9f26614a777e714',
      fields: {
        origine: 'p\u00e9pini\u00e8res Ville de Nantes',
        espece: 'paradoxa',
        localisation: 'A2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2208871, -1.5444631],
        genre: 'Colletia',
        date_plantation: '2010',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444631, 47.2208871] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b22401bc4584a1015943edf225641f5e1f28b9b3',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 169, 117, 1.00)',
            'rgba(98, 144, 36, 1.00)',
            'rgba(81, 120, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus 'skylark'/ceanothus 'skylark' (2).jpg",
          width: 576,
          id: 'c73648e679f013326a6be83e9769e847',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 130, 91, 1.00)',
            'rgba(133, 136, 124, 1.00)',
            'rgba(104, 111, 74, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus 'skylark'/ceanothus 'skylark' (3).jpg",
          width: 576,
          id: '269e4ca9f48640ce1f760201112f694b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 180, 125, 1.00)',
            'rgba(111, 133, 87, 1.00)',
            'rgba(118, 141, 77, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus 'skylark'/ceanothus 'skylark' (1).jpg",
          width: 1024,
          id: 'd7f7e3d14c74cbc3aacd7bd1487282cf',
          height: 768,
          thumbnail: true,
        },
        location: [47.271658, -1.586975],
        genre: 'Ceanothus',
        cultivar: 'Skylark',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586975, 47.271658] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '39f9cc2f4a2e33bc7d16ed2ecaff2676ff2207d3',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'dulcis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 97, 34, 1.00)',
            'rgba(134, 147, 65, 1.00)',
            'rgba(99, 114, 37, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hovenia [rhamnaceae]/hovenia dulcis/hovenia dulcis (3).jpg',
          width: 576,
          id: '3abb27da9f49f694589c4f28e76258d7',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(210, 220, 188, 1.00)',
            'rgba(88, 110, 51, 1.00)',
            'rgba(65, 76, 45, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hovenia [rhamnaceae]/hovenia dulcis/hovenia dulcis (4).jpg',
          width: 971,
          id: '8a6dcf6640212952ec9503848ff001d0',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 137, 62, 1.00)',
            'rgba(101, 125, 75, 1.00)',
            'rgba(78, 100, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hovenia [rhamnaceae]/hovenia dulcis/hovenia dulcis (2).jpg',
          width: 576,
          id: '7467545060ee061e25e23940a7f73134',
          height: 768,
          thumbnail: true,
        },
        location: [47.270955, -1.581545],
        genre: 'Hovenia',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581545, 47.270955] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ada6e48965544d47256e0d8e4acf6572c4a75086',
      fields: {
        espece: 'dulcis',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 155, 196, 1.00)',
            'rgba(113, 115, 107, 1.00)',
            'rgba(64, 67, 24, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/hovenia [rhamnaceae]/hovenia dulcis/hovenia dulcis (2).jpg",
          width: 1024,
          id: '20be36181744a10a59ad9ceabc6a98b1',
          height: 683,
          thumbnail: true,
        },
        location: [47.227012, -1.512572],
        genre: 'Hovenia',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512572, 47.227012] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3db8f6aad84cad78f7f60808368717b02e789a92',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'japonica',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0fb062453978b8f74ae370ea184240e603017ad6',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'nervosa',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1d0e1cb2fd2cfcee55cc2b4ca36e4c78f8f433aa',
      fields: {
        origine: 'JB.Bratislava (Slovakie)',
        espece: 'vulgaris Rafin.',
        localisation: 'G2B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195522, -1.5413524],
        genre: 'Aruncus',
        date_plantation: '1984',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5413524, 47.2195522] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'beb04d570821d1a766b63d0c98fbe3dbe78d9197',
      fields: {
        origine: 'JB.Chemnitz (Allemagne)',
        espece: 'coccineum Sibth. & Sm.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Geum',
        date_plantation: '2006',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e861df311c68c2cba3bfd30bc1b79e03a17c526a',
      fields: {
        origine: 'JB.Dunedin (N-Z\u00e9lande)',
        espece: 'juvenca B.H.Macmillan',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Acaena',
        date_plantation: '2006',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5ed3e555f571905c02d2905954c5c23d7e3f0748',
      fields: {
        origine: 'JB.Tomsk (Russie)',
        espece: 'chrysantha Trev.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Potentilla',
        date_plantation: '2009',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3e0d9b904213638be7cebe92a9dd7b4c5cfcea16',
      fields: {
        origine: 'The Jerusalem Botanical Gardens',
        espece: 'spinosum',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Sarcopoterium',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9f7bcff6752e0e7a670edf175bc83645c8d8a6f5',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'canadensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 156, 180, 1.00)',
            'rgba(112, 106, 90, 1.00)',
            'rgba(77, 78, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/amelanchier [rosaceae]/amelanchier canadensis/amelanchier canadensis (3).jpg',
          width: 1024,
          id: '097d91a737e43d348a4b2f1e76493a4c',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 119, 131, 1.00)',
            'rgba(131, 130, 110, 1.00)',
            'rgba(102, 103, 71, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/amelanchier [rosaceae]/amelanchier canadensis/amelanchier canadensis (5).jpg',
          width: 576,
          id: '3e165895534604366cd8649f2ca21abe',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 149, 105, 1.00)',
            'rgba(135, 123, 67, 1.00)',
            'rgba(155, 146, 128, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/amelanchier [rosaceae]/amelanchier canadensis/amelanchier canadensis (2).jpg',
          width: 576,
          id: '64406d04894633e860a337307510fd41',
          height: 768,
          thumbnail: true,
        },
        location: [47.270753, -1.582758],
        genre: 'Amelanchier',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582758, 47.270753] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b1e4ee6f48dfb6b5ebfe21b167fcae831ec9e0a6',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 111, 67, 1.00)',
            'rgba(116, 119, 93, 1.00)',
            'rgba(67, 72, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/aronia [rosaceae]/aronia x prunifolia 'viking'/aronia x prunifolia 'viking' (4).jpg",
          width: 576,
          id: '60a7cb600545e2d55f4f2d059e72dedf',
          height: 768,
          thumbnail: true,
        },
        espece: 'x prunifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 128, 60, 1.00)',
            'rgba(125, 149, 83, 1.00)',
            'rgba(111, 126, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/aronia [rosaceae]/aronia x prunifolia 'viking'/aronia x prunifolia 'viking' (2).jpg",
          width: 576,
          id: '1f7508b2781acc4efb994f5c41049478',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(45, 63, 28, 1.00)',
            'rgba(96, 109, 79, 1.00)',
            'rgba(80, 97, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/aronia [rosaceae]/aronia x prunifolia 'viking'/aronia x prunifolia 'viking' (1).jpg",
          width: 576,
          id: '45780065b7fc2608794f942172b60c1a',
          height: 768,
          thumbnail: true,
        },
        location: [47.271553, -1.58435],
        genre: 'Aronia',
        cultivar: 'Viking',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58435, 47.271553] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dedde2c9663a092c5501478ce77f4b1e5ece1e43',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 131, 89, 1.00)',
            'rgba(178, 99, 72, 1.00)',
            'rgba(186, 129, 107, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chaenomeles [rosaceae]/chaenomeles japonica/chaenomeles japonica (2).jpg',
          width: 576,
          id: '532e3e5bba03614ff7a25edee40a1ed0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 159, 89, 1.00)',
            'rgba(121, 141, 63, 1.00)',
            'rgba(110, 116, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chaenomeles [rosaceae]/chaenomeles japonica/chaenomeles japonica (1).jpg',
          width: 576,
          id: 'c18be3d4ad3b3961f4ea71d6e58271a8',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Chaenomeles',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7f9ce33c3d6b97e9709b33f2194a4811852466a9',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 108, 88, 1.00)',
            'rgba(110, 105, 78, 1.00)',
            'rgba(149, 127, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/chaenomeles [rosaceae]/chaenomeles speciosa 'coquelicot'/chaenomeles speciosa 'coquelicot' (2).jpg",
          width: 576,
          id: '7fe68df9987dfcdc01f4e0ee45012c7e',
          height: 768,
          thumbnail: true,
        },
        espece: 'speciosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 87, 70, 1.00)',
            'rgba(128, 110, 55, 1.00)',
            'rgba(109, 96, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/chaenomeles [rosaceae]/chaenomeles speciosa 'coquelicot'/chaenomeles speciosa 'coquelicot' (1).jpg",
          width: 576,
          id: 'b5c21019eec1ce653a0946d7ff4dd2e1',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(176, 58, 55, 1.00)',
            'rgba(178, 75, 66, 1.00)',
            'rgba(140, 78, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/chaenomeles [rosaceae]/chaenomeles speciosa 'coquelicot'/chaenomeles speciosa 'coquelicot'  (1).jpg",
          width: 576,
          id: '4bf017c0c77db183a5d852c56d058a1d',
          height: 768,
          thumbnail: true,
        },
        location: [47.271087, -1.585005],
        genre: 'Chaenomeles',
        cultivar: 'Coquelicot',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585005, 47.271087] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cfb5e4e9c52291d75a885998dcba231b419c8b67',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 143, 110, 1.00)',
            'rgba(182, 87, 72, 1.00)',
            'rgba(159, 97, 84, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/chaenomeles [rosaceae]/chaenomeles x superba 'hollandia'/chaenomeles x superba 'hollandia' (3).jpg",
          width: 576,
          id: '602540c374e3e65bfee6e8fa7a236fe4',
          height: 768,
          thumbnail: true,
        },
        espece: 'x superba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(203, 197, 190, 1.00)',
            'rgba(125, 110, 82, 1.00)',
            'rgba(96, 97, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/chaenomeles [rosaceae]/chaenomeles x superba 'hollandia'/chaenomeles x superba 'hollandia' (2).jpg",
          width: 632,
          id: '905112f87e3eac0c24e6dd5fd0de2f06',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 120, 82, 1.00)',
            'rgba(128, 137, 91, 1.00)',
            'rgba(129, 132, 88, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/chaenomeles [rosaceae]/chaenomeles x superba 'hollandia'/chaenomeles x superba 'hollandia' (1).jpg",
          width: 576,
          id: 'b72507d5eb74190b15cd7cf78cd22ce8',
          height: 768,
          thumbnail: true,
        },
        location: [47.27102, -1.58415],
        genre: 'Chaenomeles',
        cultivar: 'Hollandia',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58415, 47.27102] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd67037f1c557402f512045f90b622d73438a031d',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'deflexa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(177, 160, 119, 1.00)',
            'rgba(167, 147, 110, 1.00)',
            'rgba(73, 62, 20, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/eriobotrya [rosaceae]/eriobotrya deflexa/eriobotrya deflexa  (4).jpg',
          width: 576,
          id: 'f4d28d7027d0d7fa45643566f79a00cb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 126, 118, 1.00)',
            'rgba(93, 110, 87, 1.00)',
            'rgba(79, 95, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/eriobotrya [rosaceae]/eriobotrya deflexa/eriobotrya deflexa (1).jpg',
          width: 576,
          id: '684f8baa3a87e9692754d89c39bcdc9a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 120, 70, 1.00)',
            'rgba(135, 126, 80, 1.00)',
            'rgba(61, 63, 18, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/eriobotrya [rosaceae]/eriobotrya deflexa/eriobotrya deflexa  (3).jpg',
          width: 768,
          id: 'ec4409c431b45c3af9785b14936ca5dd',
          height: 768,
          thumbnail: true,
        },
        location: [47.271713, -1.586408],
        genre: 'Eriobotrya',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586408, 47.271713] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '71329dca313421bf85af8c1638f7150bbc9971cc',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 98, 82, 1.00)',
            'rgba(121, 111, 101, 1.00)',
            'rgba(124, 115, 101, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/kerria [rosaceae]/kerria japonica 'kin kan'/kerria japonica 'kin kan' (8).jpg",
          width: 1024,
          id: '0196ac99270174bbbf5efd5a7af54ea1',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 103, 78, 1.00)',
            'rgba(109, 111, 88, 1.00)',
            'rgba(105, 90, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/kerria [rosaceae]/kerria japonica 'kin kan'/kerria japonica 'kin kan' (7).jpg",
          width: 1024,
          id: '5c6f9eef1b97f15aabb810f7d8155997',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 106, 77, 1.00)',
            'rgba(113, 114, 100, 1.00)',
            'rgba(109, 87, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/kerria [rosaceae]/kerria japonica 'kin kan'/kerria japonica 'kin kan' (6).jpg",
          width: 1024,
          id: '8d891aeedc7d55236c259cc59cbd5b36',
          height: 683,
          thumbnail: true,
        },
        location: [47.270842, -1.586142],
        genre: 'Kerria',
        cultivar: 'Kin Kan',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586142, 47.270842] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd6e1b2ad7595208547f1169dbf244a782d5bb0f2',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 171, 194, 1.00)',
            'rgba(145, 137, 135, 1.00)',
            'rgba(88, 70, 35, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'comtesse de paris'/malus 'comtesse de paris'  (2).jpg",
          width: 512,
          id: 'dfcfc6f3430fd578b3a77ace5f226051',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 162, 172, 1.00)',
            'rgba(120, 111, 83, 1.00)',
            'rgba(72, 64, 30, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'comtesse de paris'/malus 'comtesse de paris'  (1).jpg",
          width: 1024,
          id: 'adda98875ea3b18af8268023c124b783',
          height: 683,
          thumbnail: true,
        },
        location: [47.271392, -1.581742],
        genre: 'Malus',
        cultivar: 'Comtesse de Paris',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581742, 47.271392] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '18c2c53ddb89f691658376a839694f1febc54f43',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 100, 86, 1.00)',
            'rgba(159, 128, 149, 1.00)',
            'rgba(106, 86, 90, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'royalty'/malus 'royalty' (2).jpg",
          width: 576,
          id: '5576838fd143c0184cfe9cd5cebb47f3',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 143, 130, 1.00)',
            'rgba(149, 124, 119, 1.00)',
            'rgba(115, 118, 91, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'royalty'/malus 'royalty' (3).jpg",
          width: 576,
          id: 'e8364c4b7471e02a9acf70052ea606a6',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 136, 125, 1.00)',
            'rgba(144, 120, 128, 1.00)',
            'rgba(109, 98, 91, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'royalty'/malus 'royalty' (1).jpg",
          width: 576,
          id: '4e939a28bf38f92da6907f7b86e680ea',
          height: 768,
          thumbnail: true,
        },
        location: [47.27123, -1.587167],
        genre: 'Malus',
        cultivar: 'Royalty',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587167, 47.27123] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8a49a4f44156412b09af93622bd75125086e6a7e',
      fields: {
        espece: 'x fraseri',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(206, 215, 209, 1.00)',
            'rgba(106, 113, 83, 1.00)',
            'rgba(66, 74, 39, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/photinia [rosaceae]/photinia x fraseri 'red robin'/photinia x fraseri 'red robin'.jpg",
          width: 835,
          id: 'e0f9804ed59daa41a7974ca2cc48f79a',
          height: 768,
          thumbnail: true,
        },
        location: [47.269892, -1.58227],
        genre: 'Photinia',
        cultivar: 'Red Robin',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58227, 47.269892] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fcc21fd5d4c61077ace6154e63010b2fc4ab8c32',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 118, 103, 1.00)',
            'rgba(135, 116, 84, 1.00)',
            'rgba(141, 123, 106, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'shirofugen'/prunus 'shirofugen' (2).jpg",
          width: 576,
          id: 'fda81ca8a3003dd39fd8477b54f89d46',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 97, 149, 1.00)',
            'rgba(114, 105, 123, 1.00)',
            'rgba(111, 89, 90, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'shirofugen'/prunus 'shirofugen' (4).jpg",
          width: 1024,
          id: 'caea49f31a2ac1ddf53a1729518cc3e1',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 118, 105, 1.00)',
            'rgba(159, 133, 146, 1.00)',
            'rgba(84, 75, 71, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'shirofugen'/prunus 'shirofugen' (1).jpg",
          width: 576,
          id: '44eeb0612523895237de93c17ea3df4e',
          height: 768,
          thumbnail: true,
        },
        location: [47.27098, -1.584625],
        genre: 'Prunus',
        cultivar: 'Shirofugen',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584625, 47.27098] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '731496774f7ca85a08d2369d306252c51154893e',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(206, 206, 216, 1.00)',
            'rgba(132, 131, 140, 1.00)',
            'rgba(83, 76, 42, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'spire'/prunus 'spire' (4).jpg",
          width: 512,
          id: 'c9f3748d4cd4c83bc17ceba681bdd9f7',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 154, 175, 1.00)',
            'rgba(120, 116, 129, 1.00)',
            'rgba(118, 120, 135, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'spire'/prunus 'spire' (3).jpg",
          width: 512,
          id: '6031f82f2e1d17450a58f48b813bf100',
          height: 768,
          thumbnail: true,
        },
        location: [47.271612, -1.582637],
        genre: 'Prunus',
        cultivar: 'Spire',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582637, 47.271612] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e325406383d818bb959c029aee4a998cb956fdb9',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 92, 98, 1.00)',
            'rgba(132, 123, 108, 1.00)',
            'rgba(160, 153, 145, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'tai-haku'/prunus 'tai-haku' (10).jpg",
          width: 1024,
          id: '7daf7191e90843dd5d230d34773221ca',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 102, 97, 1.00)',
            'rgba(141, 136, 126, 1.00)',
            'rgba(101, 98, 81, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'tai-haku'/prunus 'tai-haku' (8).jpg",
          width: 1024,
          id: '8822f415a382f8b7b71c827bd6304572',
          height: 724,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 129, 154, 1.00)',
            'rgba(109, 108, 98, 1.00)',
            'rgba(72, 65, 33, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'tai-haku'/prunus 'tai-haku' (1).jpg",
          width: 1024,
          id: '93239f0109bee880eb69d0f446f0ca31',
          height: 683,
          thumbnail: true,
        },
        location: [47.270703, -1.584278],
        genre: 'Prunus',
        cultivar: 'Tai-haku',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584278, 47.270703] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fa183c124235bea4bd9aad9761787bb765a968b4',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 113, 79, 1.00)',
            'rgba(132, 140, 100, 1.00)',
            'rgba(95, 108, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea cantoniensis 'flore pleno'/spiraea cantoniensis 'flore pleno'.jpg",
          width: 1024,
          id: '62924b28d2f44fc99ec50c876a795266',
          height: 768,
          thumbnail: true,
        },
        espece: 'cantoniensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 104, 70, 1.00)',
            'rgba(127, 132, 117, 1.00)',
            'rgba(53, 61, 30, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea cantoniensis 'flore pleno'/spiraea cantoniensis 'flore pleno' (2).jpg",
          width: 629,
          id: 'f1e559d643fc965005083bd70b5e31b7',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 144, 74, 1.00)',
            'rgba(133, 140, 80, 1.00)',
            'rgba(111, 118, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea cantoniensis 'flore pleno'/spiraea cantoniensis 'flore pleno' (1).jpg",
          width: 576,
          id: '3fe52f608658b078d10460ffe6d2e8e1',
          height: 768,
          thumbnail: true,
        },
        location: [47.270742, -1.581392],
        genre: 'Spiraea',
        cultivar: 'Flore Pleno',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581392, 47.270742] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f37eed4abe14092f3a125670b2e2ec05a407ceea',
      fields: {
        espece: 'cantoniensis',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 126, 81, 1.00)',
            'rgba(119, 129, 91, 1.00)',
            'rgba(106, 108, 88, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea cantoniensis/spiraea cantoniensis  (1).jpg',
          width: 1024,
          id: '66f33af11cb63f69e4a5a896ab2fc88e',
          height: 768,
          thumbnail: true,
        },
        location: [47.27118, -1.58487],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58487, 47.27118] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fd7daba7f8bb7b7fc9788c9f6fd5ad1682154768',
      fields: {
        espece: 'cantoniensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 89, 61, 1.00)',
            'rgba(135, 139, 128, 1.00)',
            'rgba(65, 68, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea cantoniensis/spiraea cantoniensis (2).jpg',
          width: 576,
          id: 'c32e61f14a854b7c6cc21f8397fcc0a0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 133, 65, 1.00)',
            'rgba(104, 144, 65, 1.00)',
            'rgba(145, 158, 108, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea cantoniensis/spiraea cantoniensis  (2).jpg',
          width: 576,
          id: '8ae31a7e1223bec412ed92987c398b7f',
          height: 768,
          thumbnail: true,
        },
        location: [47.271183, -1.58487],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58487, 47.271183] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c2802b073c4a8c785fafbaaecc85b467d73475fd',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 137, 89, 1.00)',
            'rgba(113, 146, 91, 1.00)',
            'rgba(125, 137, 108, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea japonica 'anthony  waterer'/spiraea japonica 'anthony  waterer' (2).jpg",
          width: 576,
          id: '1347769215d0a0fe2a8d83b67a8cf117',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 158, 119, 1.00)',
            'rgba(151, 123, 116, 1.00)',
            'rgba(95, 118, 65, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea japonica 'anthony  waterer'/spiraea japonica 'anthony  waterer' (1).jpg",
          width: 576,
          id: 'bcde6aabab32f786014e5930742dac67',
          height: 768,
          thumbnail: true,
        },
        location: [47.270497, -1.585237],
        genre: 'Spiraea',
        cultivar: 'Anthony  Waterer',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585237, 47.270497] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ede0873f439303ec1e9a1bed6f9ddeb52955e66f',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 165, 128, 1.00)',
            'rgba(120, 116, 94, 1.00)',
            'rgba(120, 131, 117, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea japonica 'fastigiata'/spiraea japonica 'fastigiata'  (4).jpg",
          width: 576,
          id: '7b8dc1e86ca974aa01165faf82245adc',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 91, 54, 1.00)',
            'rgba(144, 141, 119, 1.00)',
            'rgba(61, 67, 44, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea japonica 'fastigiata'/spiraea japonica 'fastigiata'  (2).jpg",
          width: 576,
          id: 'f05aaa0f54a66de73646b2d7d65c2eaa',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 116, 71, 1.00)',
            'rgba(120, 132, 81, 1.00)',
            'rgba(101, 106, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea japonica 'fastigiata'/spiraea japonica 'fastigiata'  (1).jpg",
          width: 576,
          id: '5191395a93f9e4f684402c09da6fe4aa',
          height: 768,
          thumbnail: true,
        },
        location: [47.271708, -1.582772],
        genre: 'Spiraea',
        cultivar: 'Fastigiata',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582772, 47.271708] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '38bde73525456c22db8b72bc84d3d0d5de47fb50',
      fields: {
        espece: 'prunifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 81, 44, 1.00)',
            'rgba(76, 93, 45, 1.00)',
            'rgba(83, 94, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea prunifolia/spiraea prunifolia.jpg',
          width: 576,
          id: 'f9d3ff1100155a03282a61a3076e0a3c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 108, 94, 1.00)',
            'rgba(134, 136, 114, 1.00)',
            'rgba(92, 85, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea prunifolia/spiraea prunifolia  (1).jpg',
          width: 576,
          id: '8afd79529337309935d3e1d61e225bda',
          height: 768,
          thumbnail: true,
        },
        location: [47.269862, -1.58525],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58525, 47.269862] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '87762eb97df412c87534ac0dfe2b75508b2a197a',
      fields: {
        origine: 'Jardin botanique alpin "la Ja\u00ffsinia" : Samo\u00ebns',
        espece: 'corsica DC.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Ruta',
        date_plantation: '2010',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd72b95b34a96bc294a5e15d26c78a0d8d5bbc1fd',
      fields: {
        espece: 'ternata Sundance (Lich)',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 111, 63, 1.00)',
            'rgba(85, 90, 11, 1.00)',
            'rgba(77, 89, 12, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/choisya [rutaceae]/choisya ternata sundance ('lich')/choisya ternata sundance ('lich').jpg",
          width: 1024,
          id: 'ab0037e9ffaf9f63300ff0318604624d',
          height: 637,
          thumbnail: true,
        },
        location: [47.269639, -1.584519],
        genre: 'Choisya',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584519, 47.269639] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f90376af75360e0ef7e218726f4943a036a4be2d',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'ternata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(35, 52, 29, 1.00)',
            'rgba(80, 99, 73, 1.00)',
            'rgba(40, 63, 30, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/choisya [rutaceae]/choisya ternata/choisya ternata (2).jpg',
          width: 576,
          id: '9821ac834d708b58713870ff69282ccd',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 157, 110, 1.00)',
            'rgba(93, 154, 98, 1.00)',
            'rgba(50, 96, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/choisya [rutaceae]/choisya ternata/choisya ternata .jpg',
          width: 576,
          id: '8a3201bbfb9cd84e3e672e062c3ba1e7',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 124, 75, 1.00)',
            'rgba(90, 108, 73, 1.00)',
            'rgba(106, 128, 81, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/choisya [rutaceae]/choisya ternata/choisya ternata (1).jpg',
          width: 1024,
          id: '7d33117ba530edac8b0f7a62ef8497a9',
          height: 768,
          thumbnail: true,
        },
        location: [47.271108, -1.584212],
        genre: 'Choisya',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584212, 47.271108] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '15b93d102053fb0442de732dedd9b407e9ab6250',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 121, 41, 1.00)',
            'rgba(120, 149, 35, 1.00)',
            'rgba(115, 144, 32, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/orixa [rutaceae]/orixa japonica/orixa japonica (2).jpg',
          width: 576,
          id: '59562eaaf55b029cab4ce4fb20cfab8a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 172, 135, 1.00)',
            'rgba(100, 113, 41, 1.00)',
            'rgba(141, 132, 87, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/orixa [rutaceae]/orixa japonica/orixa japonica (3).jpg',
          width: 576,
          id: '6901bc0b4b860b7d40ac1a508add3175',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 151, 99, 1.00)',
            'rgba(116, 135, 41, 1.00)',
            'rgba(99, 121, 25, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/orixa [rutaceae]/orixa japonica/orixa japonica (1).jpg',
          width: 576,
          id: '4f302b1055f6371b04bf3a5f05bf2c5e',
          height: 768,
          thumbnail: true,
        },
        location: [47.27067, -1.582413],
        genre: 'Orixa',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582413, 47.27067] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '211ff8bf7ca8e2c44778f35f4016314a0af1bfce',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'daniellii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 112, 65, 1.00)',
            'rgba(118, 153, 73, 1.00)',
            'rgba(136, 153, 98, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tetradium [rutaceae]/tetradium daniellii/tetradium daniellii (10).jpg',
          width: 576,
          id: 'a9622d8f5c38bcfd48feee91f9ddbbb4',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 126, 99, 1.00)',
            'rgba(121, 141, 84, 1.00)',
            'rgba(96, 107, 70, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tetradium [rutaceae]/tetradium daniellii/tetradium daniellii (11).jpg',
          width: 576,
          id: '8f74a59a371c06179f81cc6d494749c9',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 145, 123, 1.00)',
            'rgba(107, 96, 75, 1.00)',
            'rgba(93, 113, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tetradium [rutaceae]/tetradium daniellii/tetradium daniellii (1).jpg',
          width: 701,
          id: '79a91edd00efdbf4e00f8645287e9ab8',
          height: 768,
          thumbnail: true,
        },
        location: [47.270038, -1.582522],
        genre: 'Tetradium',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582522, 47.270038] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '845032c3fb13249000e4a14cf3dd5e425c91f933',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'simulans',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(199, 196, 201, 1.00)',
            'rgba(122, 119, 96, 1.00)',
            'rgba(101, 97, 49, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/zanthoxylum [rutaceae]/zanthoxylum simulans/zanthoxylum simulans (2).jpg',
          width: 576,
          id: 'e416d9cddf2ecd334af740247a735d4c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 148, 198, 1.00)',
            'rgba(106, 111, 103, 1.00)',
            'rgba(69, 73, 31, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/zanthoxylum [rutaceae]/zanthoxylum simulans/zanthoxylum simulans (3).jpg',
          width: 512,
          id: '6b67a20d83af1de25b53b4154e18fbe7',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 123, 86, 1.00)',
            'rgba(134, 128, 74, 1.00)',
            'rgba(155, 134, 81, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/zanthoxylum [rutaceae]/zanthoxylum simulans/zanthoxylum simulans (1).jpg',
          width: 576,
          id: 'e4a26caedb1121cd387e877cb1815e4c',
          height: 768,
          thumbnail: true,
        },
        location: [47.230247, -1.507747],
        genre: 'Zanthoxylum',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507747, 47.230247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b7cb874e79e156c78e71e38b3e9a4dd4d60fdc72',
      fields: {
        origine: 'JaponChibaMatsudo',
        espece: 'polycarpa',
        localisation: 'A5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2207668, -1.5440149],
        genre: 'Idesia',
        date_plantation: '2005',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440149, 47.2207668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0d7db3ba27a034bb6c60ea941823d925b8860344',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'sinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 92, 78, 1.00)',
            'rgba(84, 96, 51, 1.00)',
            'rgba(61, 76, 20, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/poliothyrsis [salicaceae]/poliothyrsis sinensis/poliothyrsis sinensis (10).jpg",
          width: 1024,
          id: 'aa95a5a82eec6eb2be1d6a7c5dfe0e26',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 114, 160, 1.00)',
            'rgba(96, 104, 126, 1.00)',
            'rgba(96, 98, 112, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/poliothyrsis [salicaceae]/poliothyrsis sinensis/poliothyrsis sinensis (4).jpg",
          width: 512,
          id: 'bb6cf72ff3321e0527098257e4c04840',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 124, 158, 1.00)',
            'rgba(126, 129, 137, 1.00)',
            'rgba(63, 63, 47, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/poliothyrsis [salicaceae]/poliothyrsis sinensis/poliothyrsis sinensis (1).jpg",
          width: 568,
          id: 'adc82ceea1f736ec006e57d59956e0ea',
          height: 768,
          thumbnail: true,
        },
        location: [47.22688, -1.512788],
        genre: 'Poliothyrsis',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512788, 47.22688] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '01236f254768744ec9df68332d66edee1df3cc73',
      fields: {
        origine: 'JB.Hangzhou (Chine)',
        espece: 'henryi',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Acer',
        date_plantation: '1996',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e1bb8d257779641429356e14cb761bebb53254da',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes',
        espece: 'carpinifolium',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Acer',
        date_plantation: '2015',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8f057c945a8254dbb1c85d0519d567bc6b7c7357',
      fields: {
        origine: "P\u00e9pini\u00e8res Val d'Erdre",
        espece: 'davidii',
        localisation: 'A5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2207668, -1.5440149],
        genre: 'Acer',
        date_plantation: '2014',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440149, 47.2207668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a36cabc27efbe7c1cf5084fec0e3c646e4caeece',
      fields: {
        espece: 'palmatum',
        localisation: 'B5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202019, -1.5440256],
        genre: 'Acer',
        cultivar: 'Dissectum',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440256, 47.2202019] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6f1b66ebfde209cd44faa04a945badb4128815ac',
      fields: {
        espece: 'pseudoplatanus',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Acer',
        date_plantation: '1973',
        cultivar: 'Nizettii',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '93e03898c7388bb6010a1f518aaffdfb200bf6c1',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'campestre',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 92, 43, 1.00)',
            'rgba(115, 138, 84, 1.00)',
            'rgba(141, 146, 127, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer campestre/acer campestre (2).jpg',
          width: 576,
          id: '165101323aff66e9e87bf4bd31f902c1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 174, 104, 1.00)',
            'rgba(92, 117, 51, 1.00)',
            'rgba(111, 108, 83, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer campestre/acer campestre (3).jpg',
          width: 576,
          id: 'c9c08a5024cb9927f70955d02643d083',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 147, 141, 1.00)',
            'rgba(122, 127, 119, 1.00)',
            'rgba(104, 107, 101, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer campestre/acer campestre (1).jpg',
          width: 576,
          id: 'f77e768773b4c51cac52b6409cb2d376',
          height: 768,
          thumbnail: true,
        },
        location: [47.271033, -1.58177],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58177, 47.271033] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'feb4c010fc91e7b15ca57807a2cda7a01fbc7f1e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'pensylvanicum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 141, 44, 1.00)',
            'rgba(122, 158, 52, 1.00)',
            'rgba(94, 138, 28, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer pensylvanicum/acer pensylvanicum (2).jpg',
          width: 576,
          id: '12287afbe846de1bf5b7c73433623ff6',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 132, 114, 1.00)',
            'rgba(112, 157, 87, 1.00)',
            'rgba(81, 109, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer pensylvanicum/acer pensylvanicum (3).jpg',
          width: 576,
          id: '7e429644685428e3f3c6da9c7089c536',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 89, 82, 1.00)',
            'rgba(128, 126, 119, 1.00)',
            'rgba(121, 118, 111, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer pensylvanicum/acer pensylvanicum (1).jpg',
          width: 576,
          id: '9c4c217464543515195d16eb8a2a8594',
          height: 768,
          thumbnail: true,
        },
        location: [47.270653, -1.584133],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584133, 47.270653] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c6bab5c805ea3e3ca79805b4f0d846ceb89817da',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 108, 85, 1.00)',
            'rgba(120, 116, 103, 1.00)',
            'rgba(125, 127, 115, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer pseudoplatanus 'atropurpureum'/acer pseudoplatanus 'atropurpureum' (3).jpg",
          width: 576,
          id: '6c6e0d75d6fe6972d9077d82605319b6',
          height: 768,
          thumbnail: true,
        },
        espece: 'pseudoplatanus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 140, 125, 1.00)',
            'rgba(148, 136, 141, 1.00)',
            'rgba(122, 130, 112, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer pseudoplatanus 'atropurpureum'/acer pseudoplatanus 'atropurpureum' (2).jpg",
          width: 576,
          id: '98dde3d8a0107364d6e36e9e1f302eb9',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 145, 141, 1.00)',
            'rgba(110, 121, 92, 1.00)',
            'rgba(107, 116, 95, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer pseudoplatanus 'atropurpureum'/acer pseudoplatanus 'atropurpureum' (1).jpg",
          width: 576,
          id: 'cff38d0b11c684184a4f8c7126aff2eb',
          height: 768,
          thumbnail: true,
        },
        location: [47.270287, -1.58117],
        genre: 'Acer',
        cultivar: 'Atropurpureum',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58117, 47.270287] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f2d1a5739cdf9f87d32aef96355829b1ccd928c0',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'saccharinum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 129, 78, 1.00)',
            'rgba(106, 99, 58, 1.00)',
            'rgba(69, 66, 36, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer saccharinum/acer saccharinum (10).jpg',
          width: 1024,
          id: '866dac654ca3d9b720e8017015fc5643',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 132, 79, 1.00)',
            'rgba(123, 113, 67, 1.00)',
            'rgba(69, 66, 40, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer saccharinum/acer saccharinum (9).jpg',
          width: 512,
          id: 'ec4fdfcddca391b2866841d08edad704',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 148, 154, 1.00)',
            'rgba(128, 117, 79, 1.00)',
            'rgba(64, 59, 36, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer saccharinum/acer saccharinum (1).jpg',
          width: 512,
          id: '9ae8f8bd085ff549248d15e8e6d4389c',
          height: 768,
          thumbnail: true,
        },
        location: [47.27045, -1.586094],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586094, 47.27045] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e002cbdaccfb90aecb061b98b7c33dc259f92902',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'tataricum ssp. ginnala',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 125, 110, 1.00)',
            'rgba(116, 115, 48, 1.00)',
            'rgba(79, 86, 26, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer tataricum ssp. ginnala/acer tataricum ssp. ginnala (1).jpg',
          width: 576,
          id: 'b2bb0b62d2d1c9ded8ef469a1059e652',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(180, 194, 198, 1.00)',
            'rgba(89, 90, 67, 1.00)',
            'rgba(84, 88, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer tataricum ssp. ginnala/acer tataricum ssp. ginnala (2).jpg',
          width: 576,
          id: 'ae435394440d283642b68306a6ce9498',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(205, 207, 202, 1.00)',
            'rgba(102, 109, 67, 1.00)',
            'rgba(86, 94, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer tataricum ssp. ginnala/acer tataricum ssp. ginnala  (1).jpg',
          width: 576,
          id: 'b50184526e944d5827eb49b117581444',
          height: 768,
          thumbnail: true,
        },
        location: [47.271433, -1.580308],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580308, 47.271433] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '711c19076b69aa34bed06e7f0505910a092cc7ef',
      fields: {
        espece: 'saccharinum',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 147, 146, 1.00)',
            'rgba(149, 139, 131, 1.00)',
            'rgba(113, 105, 101, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/acer [sapindaceae]/acer saccharinum 'laciniatum wieri'/acer saccharinum 'laciniatum wieri' (2).jpg",
          width: 576,
          id: '69c022ad543154a2ffa00dd7428910da',
          height: 768,
          thumbnail: true,
        },
        location: [47.262562, -1.531728],
        genre: 'Acer',
        cultivar: 'Laciniatum Wieri',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531728, 47.262562] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'af351e16602df5635844cb51541437108ec40bba',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'hippocastanum f. laciniata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 138, 179, 1.00)',
            'rgba(145, 146, 155, 1.00)',
            'rgba(131, 124, 95, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus hippocastanum f. laciniata/aesculus hippocastanum f. laciniata (2).jpg',
          width: 576,
          id: 'e94b64f125253de67e9ff23d1713d992',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 165, 181, 1.00)',
            'rgba(101, 112, 54, 1.00)',
            'rgba(101, 109, 37, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus hippocastanum f. laciniata/aesculus hippocastanum f. laciniata (3).jpg',
          width: 632,
          id: 'ecbcb139ad8257c48dcadc6d509c61cc',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(183, 191, 185, 1.00)',
            'rgba(117, 107, 61, 1.00)',
            'rgba(132, 114, 84, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus hippocastanum f. laciniata/aesculus hippocastanum f. laciniata (1).jpg',
          width: 576,
          id: '4380a271ad11804aee9ed8acd5eee2c6',
          height: 768,
          thumbnail: true,
        },
        location: [47.270753, -1.582237],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582237, 47.270753] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c88538557900a6729f44a479bbec8cfdd5c7b25b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 94, 56, 1.00)',
            'rgba(131, 140, 119, 1.00)',
            'rgba(59, 65, 38, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum 'chesapeake'/viburnum 'chesapeake' (2).jpg",
          width: 576,
          id: '0e86ee6146902a83c9206a6b1780f69a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 137, 90, 1.00)',
            'rgba(134, 146, 97, 1.00)',
            'rgba(109, 116, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum 'chesapeake'/viburnum 'chesapeake' .jpg",
          width: 832,
          id: 'e48d0178f7955dfa577e1827e8cd9a0c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 149, 78, 1.00)',
            'rgba(102, 137, 56, 1.00)',
            'rgba(133, 147, 98, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum 'chesapeake'/viburnum 'chesapeake' (1).jpg",
          width: 576,
          id: '4ae98c9bfd9e2705b5c9cead4817fb6b',
          height: 768,
          thumbnail: true,
        },
        location: [47.270188, -1.586137],
        genre: 'Viburnum',
        cultivar: 'Chesapeake',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586137, 47.270188] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '723c23627fc8d567bf69c10692655eafd05d107e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'odoratissimum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 124, 81, 1.00)',
            'rgba(133, 141, 89, 1.00)',
            'rgba(74, 93, 40, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum odoratissimum/viburnum odoratissimum (2).jpg',
          width: 576,
          id: '898347b6e15bbb464358d60349a736a5',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 122, 35, 1.00)',
            'rgba(98, 151, 38, 1.00)',
            'rgba(105, 149, 45, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum odoratissimum/viburnum odoratissimum (3).jpg',
          width: 576,
          id: 'c988f9a972df8eba5772383ab1380e83',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(61, 78, 42, 1.00)',
            'rgba(102, 120, 64, 1.00)',
            'rgba(96, 117, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum odoratissimum/viburnum odoratissimum (1).jpg',
          width: 576,
          id: '8f4cf80d45a93c7955bd3c29791d2cb9',
          height: 768,
          thumbnail: true,
        },
        location: [47.270662, -1.584453],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584453, 47.270662] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3ece306e4d0e1298bb551290c2fe407f5694909b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'opulus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 94, 31, 1.00)',
            'rgba(136, 149, 106, 1.00)',
            'rgba(102, 118, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum opulus/viburnum opulus (2).jpg',
          width: 576,
          id: 'a6629344d8caca54728705d0abb0f8e8',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 147, 86, 1.00)',
            'rgba(128, 161, 49, 1.00)',
            'rgba(116, 150, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum opulus/viburnum opulus (3).jpg',
          width: 576,
          id: 'dbfe39ff31f70e69fc2aba20f23770cd',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 176, 83, 1.00)',
            'rgba(118, 151, 37, 1.00)',
            'rgba(99, 124, 25, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum opulus/viburnum opulus (1).jpg',
          width: 576,
          id: 'a0b22d1487805e581aa5aaf57f0e672d',
          height: 768,
          thumbnail: true,
        },
        location: [47.2714, -1.58492],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58492, 47.2714] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '52b7fc444361e47051a3b6c800582f0a42d42787',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'prunifolium',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 122, 49, 1.00)',
            'rgba(126, 149, 36, 1.00)',
            'rgba(153, 166, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum prunifolium/viburnum prunifolium (14).jpg',
          width: 576,
          id: 'c9d98f4535daa176a5b387d035e97456',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 112, 110, 1.00)',
            'rgba(137, 119, 128, 1.00)',
            'rgba(92, 87, 78, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum prunifolium/viburnum prunifolium (15).jpg',
          width: 576,
          id: '489294069e3713f39bce764555bdf238',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 88, 42, 1.00)',
            'rgba(134, 146, 107, 1.00)',
            'rgba(43, 61, 11, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum prunifolium/viburnum prunifolium (13).jpg',
          width: 576,
          id: 'b6334cafdf65338d0f2cfc58c89395d4',
          height: 768,
          thumbnail: true,
        },
        location: [47.271613, -1.586497],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586497, 47.271613] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5742ce7b1b7cecfb67b4939d20d52fc9e4dacf7b',
      fields: {
        espece: 'rufidulum',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 188, 158, 1.00)',
            'rgba(131, 135, 96, 1.00)',
            'rgba(98, 111, 71, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum rufidulum 'royal guard'/viburnum rufidulum 'royal guard'.jpg",
          width: 576,
          id: 'cd365701859cfded71ca7f6379318de3',
          height: 768,
          thumbnail: true,
        },
        location: [47.271505, -1.581155],
        genre: 'Viburnum',
        cultivar: 'Royal Guard',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581155, 47.271505] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b0e69d0211d8c9c2f94852a4b38e6b8c69431bbc',
      fields: {
        espece: 'tinus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 136, 114, 1.00)',
            'rgba(103, 125, 103, 1.00)',
            'rgba(111, 134, 112, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum tinus 'port of nice'/viburnum tinus 'port of nice' (4).jpg",
          width: 583,
          id: '9d39446a7a3ffda65dcbc0994a9c8a52',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 143, 111, 1.00)',
            'rgba(108, 123, 106, 1.00)',
            'rgba(105, 112, 99, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum tinus 'port of nice'/viburnum tinus 'port of nice' (1).jpg",
          width: 464,
          id: '2f7a579242f5fcc156ccd06b24dd10b1',
          height: 768,
          thumbnail: true,
        },
        location: [47.27025, -1.582305],
        genre: 'Viburnum',
        cultivar: 'Port of Nice',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582305, 47.27025] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '29ea1908fd946287744de951f51bae7d41ca5a98',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x burkwoodii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 66, 20, 1.00)',
            'rgba(120, 91, 31, 1.00)',
            'rgba(115, 81, 25, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x burkwoodii/viburnum x burkwoodii (7).jpg',
          width: 1024,
          id: '69589fe518f4035126561c3f2601bd93',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(59, 89, 141, 1.00)',
            'rgba(117, 90, 76, 1.00)',
            'rgba(110, 74, 34, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x burkwoodii/viburnum x burkwoodii (8).jpg',
          width: 512,
          id: '80332e672d66ea38f9e98ec942c533f0',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 124, 45, 1.00)',
            'rgba(106, 103, 35, 1.00)',
            'rgba(55, 60, 20, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x burkwoodii/viburnum x burkwoodii (6).jpg',
          width: 1024,
          id: 'd819dbd7026fa25144a9ceade0feaa75',
          height: 683,
          thumbnail: true,
        },
        location: [47.27093, -1.584603],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584603, 47.27093] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0bf9f7f3685b2b3a3b1e21c820e53a9cda608f82',
      fields: {
        origine: 'JB.Niagara Parks (Canada)',
        espece: 'cooperi L.',
        localisation: 'A2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2208871, -1.5444631],
        genre: 'Delosperma',
        date_plantation: '1998',
        famille: 'Aizoaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444631, 47.2208871] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c603c8ed66a6444a1fbc6bbba47bf1e6829f2715',
      fields: {
        origine: 'J.Alp.Graz (Autriche)',
        espece: 'assoanus Dufour',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Narcissus',
        date_plantation: '2006',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fbf4d5baf5a3b28a20da53adaed6b4deabe96d9a',
      fields: {
        origine: 'J.B. de Lyon,France',
        espece: 'tazetta L.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Narcissus',
        date_plantation: '2012',
        cultivar: 'ssp.bertolonii Baker',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6810df7254ef6c8352c8e02aa41e2ddcc05ee2a1',
      fields: {
        origine: 'JB Goteborg-Suede',
        espece: 'sicculum Auct.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Nectaroscordum',
        date_plantation: '2008',
        cultivar: 'ssp.bulgaricum Stearn',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1ffec65cf8cc4c1d733e44a82f1095030dc83f02',
      fields: {
        origine: 'JB. Kiel (Allemagne)',
        espece: 'caeruleum Pall.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Allium',
        date_plantation: '2010',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4b4fb3cb36402073242cce5ec88c6c4fbdd7bcdf',
      fields: {
        origine: 'JB.Aschgabat (Turkm\u00e9nistan)',
        espece: 'altissimum',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Allium',
        date_plantation: '2006',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ae771aee8a2ff49362a0778e971ab3e1ddeaad67',
      fields: {
        origine: 'JB.et Museum de Berolino-Dahlem (Allemagne)',
        espece: 'angulosum L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Allium',
        date_plantation: '2006',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fbfcb1c12ef3f7b7c4459fb11b8a484885068a22',
      fields: {
        origine: 'JB.Tomsk (Russie)',
        espece: 'ledebourianum Schuftes',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Allium',
        date_plantation: '2009',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e14dec160471110fd79f81c6242fbb94b9c3cb57',
      fields: {
        origine: 'JBU.Besan\u00e7on (France)',
        espece: 'schoenoprasum L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Allium',
        date_plantation: '1992',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c1930b5304f77bf76b4e348bfdc087ba5587c530',
      fields: {
        origine: 'JBU.Besan\u00e7on (France)',
        espece: 'senescens L .',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Allium',
        date_plantation: '1998',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6974fe6748aff314587751a5561e0e4e3b9438e2',
      fields: {
        origine: 'B.G. Rostock (All.)',
        espece: 'gummosa Boiss.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Ferula',
        date_plantation: '1955',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5a169c6f7784390c4dd07698542e5866bc9b126e',
      fields: {
        origine: 'Botanischer Garten,Universitat Rostock, Rostock, Allemagne',
        espece: 'gummiferum Pall.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Seseli',
        date_plantation: '2012',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '86722eb553c005a6bdf81f3e29f73d9d68583971',
      fields: {
        origine: 'Chelsea physic Garden Londre (Angl.)',
        espece: 'tingitana L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Ferula',
        date_plantation: '2015',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '84cbb8f779ae8f43149c4baabba2ecc12afafbd0',
      fields: {
        origine: 'Jardin alpin la Jaysignia - Samo\u00ebns',
        espece: 'vestina A.Kern',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Athamanta',
        date_plantation: '2010',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '75ce41d6355b56f267aa8a3b413c537172db8028',
      fields: {
        origine: 'JB.Voronozh (Russie)',
        espece: 'carvi  L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Carum',
        date_plantation: '2008',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '96680523bfaa1e671916728101ab3a1a16234afd',
      fields: {
        origine: 'Sichtungs garten Weinheim (Allemagne)',
        espece: 'eburneum Decne.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Eryngium',
        date_plantation: '2011',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2b41436938c8c3dad2098328e9c19ecf35e9fb7e',
      fields: {
        origine: 'JB. Osterr-garten, Graz (Autriche)',
        espece: 'illustris Woodson',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Amsonia',
        date_plantation: '2011',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8dc000b44fd134d64821b1a83b53bcbbfa0ed596',
      fields: {
        origine: 'JB.Kyoto (Japon)',
        espece: 'tabernaemontana Walt.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Amsonia',
        date_plantation: '1995',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f97b337a06fd21246dbbbd1fe9434bdd510aa36f',
      fields: {
        origine: 'JB.Montpellier (France)',
        espece: 'hirundinaria Medik.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Vincetoxicum',
        date_plantation: '2006',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e13a5948217b9283ce1978f3688739df7aba205e',
      fields: {
        origine: 'JB.The Kyoto (Japon)',
        espece: 'tabernaemontana Walt.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Amsonia',
        date_plantation: '2006',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ac19432c371559ac017e63e8852ef74c21c923f3',
      fields: {
        origine: 'JBU.Cracovie',
        espece: 'acutum Linr.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Cynanchum',
        date_plantation: '1988',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd6aaf7fb2ef3288e786a45391faf25627fb90606',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(55, 60, 46, 1.00)',
            'rgba(99, 97, 77, 1.00)',
            'rgba(96, 94, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/nerium [apocynaceae]/nerium oleander 'mme barre'/nerium oleander 'mme barre' (3).jpg",
          width: 1024,
          id: '65d55a9b8cb57f3092baee866c91ce52',
          height: 683,
          thumbnail: true,
        },
        espece: 'oleander',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 131, 121, 1.00)',
            'rgba(110, 104, 76, 1.00)',
            'rgba(92, 81, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/nerium [apocynaceae]/nerium oleander 'mme barre'/nerium oleander 'mme barre' (2).jpg",
          width: 1024,
          id: 'd8eb9c537891d6874c140795a6810203',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 163, 172, 1.00)',
            'rgba(78, 70, 49, 1.00)',
            'rgba(71, 67, 43, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/nerium [apocynaceae]/nerium oleander 'mme barre'/nerium oleander 'mme barre' (1).jpg",
          width: 1024,
          id: '45e802f90bd8ce75a498285131e420e9',
          height: 683,
          thumbnail: true,
        },
        location: [47.271158, -1.582487],
        genre: 'Nerium',
        cultivar: 'Mme Barr\u00e9',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582487, 47.271158] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '23da383886dcf26f7972c1c6316caba0710fe82a',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 121, 113, 1.00)',
            'rgba(108, 107, 88, 1.00)',
            'rgba(91, 87, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ilex [aquifoliaceae]/ilex x altaclerensis 'lawsoniana'/ilex x altaclerensis 'lawsoniana' (3).jpg",
          width: 1024,
          id: 'bc2717e2069acd1e179706a03ee71c87',
          height: 683,
          thumbnail: true,
        },
        espece: 'x altaclerensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 93, 43, 1.00)',
            'rgba(101, 114, 41, 1.00)',
            'rgba(107, 114, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ilex [aquifoliaceae]/ilex x altaclerensis 'lawsoniana'/ilex x altaclerensis 'lawsoniana' (2).jpg",
          width: 1024,
          id: '2789c4da243211d083417aa1f007fd1a',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 110, 57, 1.00)',
            'rgba(102, 97, 33, 1.00)',
            'rgba(85, 88, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ilex [aquifoliaceae]/ilex x altaclerensis 'lawsoniana'/ilex x altaclerensis 'lawsoniana' (1).jpg",
          width: 1024,
          id: '06aa6da19f712a106821d557446f7715',
          height: 683,
          thumbnail: true,
        },
        location: [47.269961, -1.584342],
        genre: 'Ilex',
        cultivar: 'Lawsoniana',
        famille: 'Aquifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584342, 47.269961] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8549585b381363b1795c67a4b9ffd0ffba6b5762',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 178, 186, 1.00)',
            'rgba(94, 98, 66, 1.00)',
            'rgba(75, 68, 28, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ilex [aquifoliaceae]/ilex x koehneana 'chestnut leaf'/ilex x koehneana 'chestnut leaf'.jpg",
          width: 512,
          id: '61ef58828913e12bba095b4c82e97ce1',
          height: 768,
          thumbnail: true,
        },
        espece: 'x koehneana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 93, 51, 1.00)',
            'rgba(98, 97, 54, 1.00)',
            'rgba(84, 87, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ilex [aquifoliaceae]/ilex x koehneana 'chestnut leaf'/ilex x koehneana 'chestnut leaf' (2).jpg",
          width: 1024,
          id: '73d91774a146180cb7bb42c527c27677',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 104, 64, 1.00)',
            'rgba(117, 95, 53, 1.00)',
            'rgba(90, 88, 46, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ilex [aquifoliaceae]/ilex x koehneana 'chestnut leaf'/ilex x koehneana 'chestnut leaf' (1).jpg",
          width: 1024,
          id: '13e79c9a3712779c4386631253e4a6e5',
          height: 683,
          thumbnail: true,
        },
        location: [47.270933, -1.584345],
        genre: 'Ilex',
        cultivar: 'Chestnut Leaf',
        famille: 'Aquifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584345, 47.270933] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fb195b8b32709318aee32814cf4a747b1ac894ec',
      fields: {
        origine:
          'Botanischer Garten der Justus-Liebig-Universit\u00e4t, Giessen, Allemagne',
        espece: 'ciliatum H.Li',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Arisaema',
        date_plantation: '2013',
        famille: 'Araceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '02c8c72f6a12cdd53e0778ce796b39c622719406',
      fields: {
        origine:
          'Botanischer Garten der Universitat, Erlangen-Nurnberg, Allemagne',
        espece: 'ciliatum H.Li',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Arisaema',
        date_plantation: '2012',
        famille: 'Araceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'eb91fc39891534d6f40e280a4781f830a25600fa',
      fields: {
        origine: 'JBU.Berkeley (USA)',
        espece: 'californica S. Wats.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Aralia',
        date_plantation: '1998',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1f1ca42951948527f8919d80902dafea40f72b17',
      fields: {
        espece: 'japonica',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Fatsia',
        date_plantation: '1973',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fb0b39318d728b405ef57a5c4167ec5cdf4b65f2',
      fields: {
        origine: 'Botanischer Garten St.Gallen,St.Gallen,Autriche',
        espece: 'neglectum Guss.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Muscari',
        date_plantation: '2013',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '536aaf570253adcc296aa3c181895ebbbe57da5e',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes 71290 La Gen\u00eate',
        espece: 'malcolmsonii Royle',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Ophiopogon',
        date_plantation: '2015',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8e3650a7189b45d94551bd7eedef9a859d9a512f',
      fields: {
        origine: 'Takeda Garden,Kyoto,Japon',
        espece: 'japonica Roth',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Rohdea',
        date_plantation: '2014',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '595bf1dc92f8d3ec4d9a94313376a5cd22d9f808',
      fields: {
        espece: 'reverchonii Degen et Hervier',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Scilla',
        date_plantation: '1986',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '831cf991c4543d52b9786720ad9a977c62dd6ce7',
      fields: {
        origine: 'Arboretum North Baldwin (USA.Californie)',
        espece: 'tomentosus L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Elephantopus',
        date_plantation: '2003',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5733a9e3d20266af4d2cdd6527bc81a19afb6dd6',
      fields: {
        origine: 'Ets.Lepage',
        espece: 'przewalskii Diels.',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Ligularia',
        date_plantation: '1986',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd5a81fae206aa394b2aa445bd3be583fc45c192b',
      fields: {
        origine: 'Hermann-Shof Weinheim (Allemagne)',
        espece: 'umbellata Ness',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Doellingeria',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '224f6f4a19199761cee3ff3cbc5b3dbf3d4cfc37',
      fields: {
        origine:
          'Honorable Municipalidad de Cochabamba - origine nature\u00a0: Camino \u00e0 Vacas CBB, alt. 3245M',
        espece: 'dracunculifolia',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Baccharis',
        date_plantation: '2013',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c62886f22fb965a5b2387ffb00752fdbad017f04',
      fields: {
        origine: 'JB. Utrecht (Pays-Bas)',
        espece: 'foliaceus Lindl.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Aster',
        date_plantation: '2010',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8404e37c4a6b4657169cf91d02151827a0546640',
      fields: {
        origine: 'JB.Bern (Suisse)',
        espece: 'plumieri Kirschleger',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Cicerbita',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3ccada0f8224e4cfc96535f50c30a8fd1237ba60',
      fields: {
        origine: 'JB.Bern (Suisse)',
        espece: 'staticifolium All.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Hieracium',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '78d018322a00eeb78185ff11c410e3214dc848df',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'macrocephala Muss.Puschk.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Grossheimia',
        date_plantation: '2009',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '20bf2603d98b6a3a8981503afbd0e38c301840a7',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'marginata  Tausch',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Serratula',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a81367e46b264f775352ccd2555c853f465d2245',
      fields: {
        origine: 'JB.Lublin (Pologne)',
        espece: 'rivulare All.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Cirsium',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f6854f7e892b262f3e32b901beb958ae104b2a58',
      fields: {
        origine: 'JB.Montpellier (France)',
        espece: 'ritro L.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Echinops',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3677eebd3c3666952db02328ace2ae763e1b0879',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'alba L.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Centaurea',
        date_plantation: '2009',
        cultivar: 'tenoreana Dost.',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6e3a169e9dc1b1e51f01f774b4723684c8712b01',
      fields: {
        origine: 'JB.Porto (Portugal)',
        espece: 'aristata  Benth.et Hook.F.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Centaurea',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b7e1f2ac5b711f5d28bf726eee1a378242a7992a',
      fields: {
        origine: 'JB.Reykjavik (Islande)',
        espece: 'sparsifolium Lindb.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Hieracium',
        date_plantation: '2009',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e577af8e15c48ac5b592ad92a83b0ed0f129a7b4',
      fields: {
        origine: 'JB.Smentausch Graz (Autriche)',
        espece: 'virgaurea Bigel.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Solidago',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '81b5b573fb78c201dcf508c589a491d242e3b231',
      fields: {
        origine: 'JB.Yeomjii (Cor\u00e9e)',
        espece: 'japonica  Kitam.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Solidago',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '824175f0403cf2969c7c54f483e3a3eefd954454',
      fields: {
        origine: 'JBU.Graz (Autriche)',
        espece: 'afer Greuter',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Ptilostemon',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a34b39efd251f272749c4305f45f1a0fa31fe0c7',
      fields: {
        origine: 'JBU.Kosice (Slovaquie)',
        espece: 'rohacsense Kit.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Hieracium',
        date_plantation: '2004',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f28db1c4d2a5c517e3d737a9f6c45f6a1b4de0a7',
      fields: {
        origine: "R\u00e9serve Bowman's Hill (U.S.A.)",
        espece: 'macrophyllus L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Aster',
        date_plantation: '1990',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bcd1b024e20d8160dbdbc5402f44fd5a5cd1d4c4',
      fields: {
        origine: 'Universit\u00e9e de Lublin (Pologne)',
        espece: 'ludoviciana Nutt.',
        localisation: 'C6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195286, -1.542453],
        genre: 'Artemisia',
        date_plantation: '2009',
        cultivar: 'candicans Keck.',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542453, 47.2195286] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'aa8d5dfc1cf620214b648b6d8fe6442cddc06197',
      fields: {
        origine: 'Zoological and B.G. Plzen (Rep. Tch\u00e8que)',
        espece: 'purpurea Mast.',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Berkheya',
        date_plantation: '2014',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b209b89f83bd54c2dc03ec1bebbc6834cd1f0e1c',
      fields: {
        espece: 'x media',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 98, 32, 1.00)',
            'rgba(114, 142, 69, 1.00)',
            'rgba(111, 137, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/mahonia [berberidaceae]/mahonia x media 'charity'/mahonia x media 'charity' .jpg",
          width: 1024,
          id: 'c3f197c005c6ad3b199d9659c3735685',
          height: 683,
          thumbnail: true,
        },
        location: [47.271233, -1.585597],
        genre: 'Mahonia',
        cultivar: 'Charity',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585597, 47.271233] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ca21c53b641c949c193e33d7fafc1d1c8edf3121',
      fields: {
        espece: 'domestica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 107, 100, 1.00)',
            'rgba(130, 79, 69, 1.00)',
            'rgba(100, 78, 64, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/nandina [berberidaceae]/nandina domestica/nandina domestica.jpg',
          width: 512,
          id: 'e6d3fcc1752c9535c9361df108a6f65d',
          height: 768,
          thumbnail: true,
        },
        location: [47.2712, -1.585345],
        genre: 'Nandina',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585345, 47.2712] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a369c71044eadb67c881a64d048b925db03850bf',
      fields: {
        origine: 'P\u00e9pini\u00e8re Jaulin paysage',
        espece: 'nigra',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Betula',
        date_plantation: '2017',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4163f5cc8903c75d9fad3c5687393c5046f79f0e',
      fields: {
        origine: 'P\u00e9pini\u00e8re Ville de Nantes',
        espece: 'maximowicziana',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Betula',
        date_plantation: '2017',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f0930aafb73c174a41e9e67a69d07a9241e58aee',
      fields: {
        espece: 'pendula',
        localisation: 'B1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2204652, -1.544656],
        genre: 'Betula',
        date_plantation: '1973',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544656, 47.2204652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4f794f6dc7e61482163028c2bbe8c63abf182192',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'utilis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 148, 126, 1.00)',
            'rgba(119, 141, 105, 1.00)',
            'rgba(123, 138, 112, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/betula [betulaceae]/betula utilis/betula utilis (2).jpg',
          width: 576,
          id: '3947e098f8e79873c477dc8a14683fda',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 176, 135, 1.00)',
            'rgba(96, 129, 68, 1.00)',
            'rgba(73, 102, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/betula [betulaceae]/betula utilis/betula utilis (3).jpg',
          width: 576,
          id: '9cd41651d3e6c1691c1058327f4f661c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 117, 109, 1.00)',
            'rgba(125, 126, 119, 1.00)',
            'rgba(111, 109, 104, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/betula [betulaceae]/betula utilis/betula utilis (1).jpg',
          width: 576,
          id: '09c74888e6bef59d3647264da71b82da',
          height: 768,
          thumbnail: true,
        },
        location: [47.271433, -1.58093],
        genre: 'Betula',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58093, 47.271433] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9dc2fe566d5dafbb1ae789156cab0110a1a122f6',
      fields: {
        espece: 'carpinifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 139, 88, 1.00)',
            'rgba(115, 140, 100, 1.00)',
            'rgba(90, 101, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ostrya [betulaceae]/ostrya carpinifolia 'pendula'/ostrya carpinifolia 'pendula' (2).jpg",
          width: 576,
          id: '55d4357389a9899930f959e176099e0e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 180, 149, 1.00)',
            'rgba(102, 112, 35, 1.00)',
            'rgba(83, 101, 15, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ostrya [betulaceae]/ostrya carpinifolia 'pendula'/ostrya carpinifolia 'pendula' (1).jpg",
          width: 576,
          id: 'c998551f89c13d1bf7fff511b245ac42',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Ostrya',
        cultivar: 'Pendula',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'aa8f30094d1f1b9be3fe857baaf987a00dd3d6b2',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'carpinifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 166, 172, 1.00)',
            'rgba(105, 108, 90, 1.00)',
            'rgba(54, 53, 31, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ostrya [betulaceae]/ostrya carpinifolia/ostrya carpinifolia (4).jpg',
          width: 605,
          id: 'bebb17bcb216176e61b13186da6c2698',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 160, 175, 1.00)',
            'rgba(115, 119, 114, 1.00)',
            'rgba(48, 49, 30, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ostrya [betulaceae]/ostrya carpinifolia/ostrya carpinifolia (5).jpg',
          width: 545,
          id: 'b6d875f70b2237eacca32c992c4b69f7',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 133, 103, 1.00)',
            'rgba(102, 102, 76, 1.00)',
            'rgba(65, 66, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ostrya [betulaceae]/ostrya carpinifolia/ostrya carpinifolia (3).jpg',
          width: 512,
          id: '633c4d306943177ab94e1e3a228267bb',
          height: 768,
          thumbnail: true,
        },
        location: [47.270956, -1.586714],
        genre: 'Ostrya',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586714, 47.270956] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '95289fad446fb9ffce0ece15496092950a62ce73',
      fields: {
        origine: 'J.B.ST.Andrews,Ecosse',
        espece: 'stellulata Waldst.& Kit.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Onosma',
        date_plantation: '2014',
        famille: 'Boraginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2edb9cbdf6b12d1b6802aea6b65b4e8b30519fd4',
      fields: {
        origine: 'JB.Alpin la Jaysinia Samoens (France)',
        espece: 'tornensis Jav.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Onosma',
        date_plantation: '2010',
        famille: 'Boraginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0a6cbedd51da40f9b33971fd1689c53af7a3e545',
      fields: {
        origine: 'JB.Alpin la Jaysinia Samoens (France)',
        espece: 'tornensis Javorka',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Onosma',
        date_plantation: '2011',
        famille: 'Boraginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '95b88934b757b8e0c4c853f2b885919ae73f6e05',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'acuminata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 156, 125, 1.00)',
            'rgba(132, 137, 88, 1.00)',
            'rgba(106, 112, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ehretia [boraginaceae]/ehretia acuminata/ehretia acuminata (11).jpg',
          width: 576,
          id: '657f0f291fffc757e7fddc1dc0b9e349',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 159, 107, 1.00)',
            'rgba(136, 147, 85, 1.00)',
            'rgba(99, 113, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ehretia [boraginaceae]/ehretia acuminata/ehretia acuminata (3).jpg',
          width: 576,
          id: '39dec0ce313239ea5d7ff6c46358293e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 127, 114, 1.00)',
            'rgba(139, 133, 115, 1.00)',
            'rgba(132, 131, 106, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ehretia [boraginaceae]/ehretia acuminata/ehretia acuminata (10).jpg',
          width: 576,
          id: '6e205eb3f76a4d12e7c8ee4bea427a83',
          height: 768,
          thumbnail: true,
        },
        location: [47.270363, -1.58647],
        genre: 'Ehretia',
        famille: 'Boraginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58647, 47.270363] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2e312727762dfa36fb0259ffcfd6fe1af657a293',
      fields: {
        origine: 'Utrecht University Botanic Gardens, Utrecht, Pays Bas',
        espece: 'thessala H.Boissieu',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Aubrieta',
        date_plantation: '2012',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '68dc4cce65066f8c6b99c6338af8800d62e76e16',
      fields: {
        origine: 'JB Munich',
        espece: 'pinardi Boiss.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Aubrieta',
        date_plantation: '2010',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '613555bdfed2bbef40bdddbf02aa7bb3295373f2',
      fields: {
        origine: 'JB.Akureyri (Islande)',
        espece: 'soyeri Reut. & Huet',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Arabis',
        date_plantation: '1997',
        cultivar: 'jacquinii',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5f5b7c9fedc6460c9283e45e104792b1e4c9abd1',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'gracilis Spruner',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Aubrieta',
        date_plantation: '2006',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c1c15cb7ae60958834eba2ae5f8851a01bc77e4a',
      fields: {
        espece: 'comosus',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 173, 135, 1.00)',
            'rgba(120, 113, 84, 1.00)',
            'rgba(95, 101, 79, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/ananas [bromeliaceae]/ananas comosus/ananas comosus.jpg",
          width: 576,
          id: 'e77485032dd7b7018610e08cf161b326',
          height: 768,
          thumbnail: true,
        },
        location: [47.2269, -1.511953],
        genre: 'Ananas',
        famille: 'Bromeliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.511953, 47.2269] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b217664f904f2a0b43c11652f1a7b3883b6c08c1',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'griffithii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 113, 57, 1.00)',
            'rgba(123, 114, 79, 1.00)',
            'rgba(127, 132, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cercis [caesalpiniaceae]/cercis griffithii/cercis griffithii  (2).jpg',
          width: 576,
          id: 'd5bc243dab4e10fc8b65796b24d18058',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 136, 51, 1.00)',
            'rgba(141, 154, 49, 1.00)',
            'rgba(141, 127, 80, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cercis [caesalpiniaceae]/cercis griffithii/cercis griffithii (2).jpg',
          width: 576,
          id: '0a7a078689c09c3688dc6c2db6080e90',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 188, 220, 1.00)',
            'rgba(107, 121, 77, 1.00)',
            'rgba(98, 112, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cercis [caesalpiniaceae]/cercis griffithii/cercis griffithii  (1).jpg',
          width: 576,
          id: 'e431adaf76091ea6081a62ed42037626',
          height: 768,
          thumbnail: true,
        },
        location: [47.271572, -1.586313],
        genre: 'Cercis',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586313, 47.271572] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6df49ea35dff6c73aa87008b6ae94c216da384ba',
      fields: {
        espece: 'triacanthos',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 158, 145, 1.00)',
            'rgba(134, 133, 99, 1.00)',
            'rgba(82, 85, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/gleditsia [caesalpiniaceae]/gleditsia triacanthos 'moraine'/gleditsia triacanthos 'moraine' (2).jpg",
          width: 1024,
          id: '275f381a31c95538070968cb2042c226',
          height: 768,
          thumbnail: true,
        },
        location: [47.269797, -1.58243],
        genre: 'Gleditsia',
        cultivar: 'Moraine',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58243, 47.269797] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1778e88d0131803ae4377b07b40e669ccf9a3f2c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'praecox',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 122, 81, 1.00)',
            'rgba(136, 133, 92, 1.00)',
            'rgba(124, 117, 88, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chimonanthus [calycanthaceae]/chimonanthus praecox/chimonanthus praecox (3).jpg',
          width: 611,
          id: '9390aee48b0a0ba5ee47df36412b2cb6',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 110, 62, 1.00)',
            'rgba(150, 141, 69, 1.00)',
            'rgba(95, 93, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chimonanthus [calycanthaceae]/chimonanthus praecox/chimonanthus praecox (4).jpg',
          width: 576,
          id: '7c5d0035706f8e427f9fade0e0d306dd',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 119, 88, 1.00)',
            'rgba(120, 103, 56, 1.00)',
            'rgba(98, 80, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chimonanthus [calycanthaceae]/chimonanthus praecox/chimonanthus praecox (1).jpg',
          width: 576,
          id: '683d4da39036926b21a196ff4dc72054',
          height: 768,
          thumbnail: true,
        },
        location: [47.269587, -1.582313],
        genre: 'Chimonanthus',
        famille: 'Calycanthaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582313, 47.269587] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c07528dc081452798a337ce5649ed4f9e35f3a46',
      fields: {
        origine: 'Botanic Garden of Siauliai University, Siauliai, Lituanie',
        espece: 'clematidea C.B.Clarke',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Codonopsis',
        date_plantation: '2012',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e3a18a079c2cd0cada0ab31ab5830c4cc2519cde',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'nikoensis  Franch.et Sav.',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Adenophora',
        date_plantation: '2008',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0adafd901740b7f7e9f8ac7dda4b42e1b57edf3c',
      fields: {
        origine: 'JB.Oslo (Norv\u00e8ge)',
        espece: 'rotundifolia L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Campanula',
        date_plantation: '2006',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '53bcec4843209d276247d6f3143ea27fea8e97ce',
      fields: {
        origine: 'JB.St Gallen',
        espece: 'cochlearifolia Lam.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Campanula',
        date_plantation: '2004',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f1ba2fd2e6ea4c04ab184d89e8510ddac501f9ea',
      fields: {
        origine: 'JB.Zagreb (Croatie)',
        espece: 'lingulata W.Kit.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Campanula',
        date_plantation: '2009',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5e6d0aff3c8a52486e90b04e26165f4447fdb724',
      fields: {
        origine: 'JBU.G\u00f6ethe de Frankf\u00fcrt am Main (Allemagne)',
        espece: 'speciosa Gilib.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Campanula',
        date_plantation: '2006',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '369eb058cb953ad08c92e82d9b4332cf4cbdc27b',
      fields: {
        origine: 'Kyoto Takeda Herbal Garden',
        espece: 'punctata Lam.',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Campanula',
        date_plantation: '2003',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '864ff7a40687df9e5e022900fad29e0333b1bd83',
      fields: {
        origine: 'Les Ponts de C\u00e9_p\u00e9pini\u00e8re Lepage',
        espece: 'takesimana Nakai',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Campanula',
        date_plantation: '2016',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3e79588425823a3bb6f935b41fc08e9cfae875e9',
      fields: {
        origine: 'JBU.G\u00f6ethe de Frankf\u00fcrt am Main (Allemagne)',
        espece: 'pumilio A.DC.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Edraianthus',
        date_plantation: '1996',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '38d6dd23ac9bd311358a944d7ade8e54a0f3e923',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'spinosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 113, 70, 1.00)',
            'rgba(113, 152, 110, 1.00)',
            'rgba(101, 129, 84, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/capparis [capparaceae]/capparis spinosa/capparis spinosa (2).jpg",
          width: 576,
          id: 'c81e8b6bd1efa3608b096d969a1fab44',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(27, 39, 18, 1.00)',
            'rgba(101, 104, 100, 1.00)',
            'rgba(83, 90, 70, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/capparis [capparaceae]/capparis spinosa/capparis spinosa (3).jpg",
          width: 576,
          id: 'c3eb0ea60be9c1454e7405e01dcf5464',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 160, 108, 1.00)',
            'rgba(118, 140, 92, 1.00)',
            'rgba(95, 120, 72, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/capparis [capparaceae]/capparis spinosa/capparis spinosa (1).jpg",
          width: 576,
          id: 'b97ee76bcae04c799b127980978d9feb',
          height: 768,
          thumbnail: true,
        },
        location: [47.226683, -1.512705],
        genre: 'Capparis',
        famille: 'Capparaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512705, 47.226683] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd4781ee0df9e5ef971ee8b285a54a0d61af2ac8c',
      fields: {
        origine: 'Giardino Botanico Daniella Brescia (Italie)',
        espece: 'silenifolia Waldst.& Kit.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Scabiosa',
        date_plantation: '2014',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c746ccd7d9b85ca6b745e76e5ec7e834ed8c65d7',
      fields: {
        origine: 'JB.Alp.Kirovsk (Russie)',
        espece: 'tiliaefolia Troitzky',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Valeriana',
        date_plantation: '1990',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6928877e7d638a3fb7a110842d0bad53f6c47fff',
      fields: {
        origine: 'JB.Cogne (Italie)',
        espece: 'sambucifolia  Eichw.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Valeriana',
        date_plantation: '2008',
        cultivar: 'sambucifolia',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4d5ecaea4d2aeacfd6422e45745f1175cf917dcd',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes',
        espece: 'macrantha',
        localisation: 'A11',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2211256, -1.5428042],
        genre: 'Lonicera',
        date_plantation: '2015',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428042, 47.2211256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f88ff3eb6835935ca59e306f6cab13b22a34b9ff',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'miconioides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 116, 104, 1.00)',
            'rgba(102, 93, 68, 1.00)',
            'rgba(111, 101, 75, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/heptacodium [caprifoliaceae]/heptacodium miconioides/heptacodium miconioides  (2).jpg',
          width: 1024,
          id: '432f04a61465297bced26a9881b09065',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 97, 81, 1.00)',
            'rgba(109, 97, 63, 1.00)',
            'rgba(111, 94, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/heptacodium [caprifoliaceae]/heptacodium miconioides/heptacodium miconioides  (3).jpg',
          width: 1024,
          id: '4cb86405de20f9af8f38267692534742',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 127, 114, 1.00)',
            'rgba(124, 111, 85, 1.00)',
            'rgba(117, 105, 84, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/heptacodium [caprifoliaceae]/heptacodium miconioides/heptacodium miconioides  (1).jpg',
          width: 512,
          id: '40c6cab238708649056a64e5ca33fe38',
          height: 768,
          thumbnail: true,
        },
        location: [47.271267, -1.586367],
        genre: 'Heptacodium',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586367, 47.271267] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '691e1a968dcdd1e3b813c9f49ac1b50cc9f94804',
      fields: {
        espece: 'miconioides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 130, 118, 1.00)',
            'rgba(117, 145, 112, 1.00)',
            'rgba(60, 101, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/heptacodium [caprifoliaceae]/heptacodium miconioides/heptacodium miconioides  (6).jpg',
          width: 512,
          id: '68802d6b6bdd36e5e7928348b5f6bd64',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 123, 111, 1.00)',
            'rgba(110, 140, 104, 1.00)',
            'rgba(55, 93, 48, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/heptacodium [caprifoliaceae]/heptacodium miconioides/heptacodium miconioides  (5).jpg',
          width: 512,
          id: '367ec8887c4225f2c1c494cb360ecfaf',
          height: 768,
          thumbnail: true,
        },
        location: [47.271437, -1.584333],
        genre: 'Heptacodium',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584333, 47.271437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '19b7452b7f8e699ac501bc46170f7429b6f6ec8e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'maackii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 130, 113, 1.00)',
            'rgba(121, 130, 115, 1.00)',
            'rgba(99, 106, 90, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera maackii/lonicera maackii (1).jpg',
          width: 576,
          id: '3343b53c83c00e48f11824248e0407c0',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 119, 66, 1.00)',
            'rgba(106, 130, 82, 1.00)',
            'rgba(60, 84, 26, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera maackii/lonicera maackii (5).jpg',
          width: 576,
          id: '054f67246ffe8d7b3df00856d27a308a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 143, 93, 1.00)',
            'rgba(81, 114, 64, 1.00)',
            'rgba(62, 92, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera maackii/lonicera maackii  (2).jpg',
          width: 1024,
          id: 'd159702d32a3db0756c38e450162baf6',
          height: 683,
          thumbnail: true,
        },
        location: [47.271133, -1.586387],
        genre: 'Lonicera',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586387, 47.271133] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f8912f2625c801592fc3b861f9b9997da7386d0d',
      fields: {
        origine: 'B.G.Klagenfurt',
        espece: 'rupestre Oxelman',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Atocion',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ec55e3f0fdbfb1f69fb9668e6a6cd660308c2524',
      fields: {
        origine: 'Botanische Garten Bonn (All.)',
        espece: 'chungtienensis W.W.Sm.',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Silene',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e2fa93497d333c0cb85b67c4c5b5c824d11914cb',
      fields: {
        origine: 'Botanischer Garten,Stuttgart,Allemagne',
        espece: 'paniculata L.',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Gypsophila',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dc2ba36f0f374c2b96059fd66cb79b714634bf16',
      fields: {
        origine: 'Jardin botanique de Munich',
        espece: 'zawadskii Hort.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Silene',
        date_plantation: '2010',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f48607fac063f9c48c4e09f6b6517148153b80f4',
      fields: {
        origine: 'JB.Karelia (Russie)',
        espece: 'viscaria Raf.=viscaria L.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Steris= Lychnis',
        date_plantation: '2009',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '30554c18eb525be5b68c7b1814db65d92c4ea1a0',
      fields: {
        origine: 'JB.Klagenf\u00fcrt (Autriche)',
        espece: 'subacaulis Vill.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Dianthus',
        date_plantation: '2006',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9555109d42d6f98357f08078933b5d4549f53cdc',
      fields: {
        origine: 'JB.Vienne (Autriche)',
        espece: 'giganteus Urv.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Dianthus',
        date_plantation: '2008',
        cultivar: 'banaticus Tutin',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fb51343b95389596b2f6f355f03961af0b7f3d0d',
      fields: {
        origine: 'JB.Zagreb (Croatie)',
        espece: 'petraeus Waldst & Kit.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Dianthus',
        date_plantation: '2006',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ba26b63abcb123db74d2d27700677ae1197de194',
      fields: {
        origine: 'JBU.Hokkaido (Japon)',
        espece: 'superbus L.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Dianthus',
        date_plantation: '2006',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '525b0ae6ccfed47e4dc5a14e874cb6d650c58d13',
      fields: {
        origine: 'JBU.Utrecht (Hollande)',
        espece: 'boissieri Gren.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Cerastium',
        date_plantation: '2003',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1763cc4ca1ff9f7b2acae0e8da2633e780a4f120',
      fields: {
        origine: 'K\u00e4rntner Botanikzentrum, Klagenfurt, Autriche',
        espece: 'saxifraga Link',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Petrorhagia',
        date_plantation: '2012',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '83a450c286ad6916216dfcf5997e5f48b390083f',
      fields: {
        espece: 'scadens',
        localisation: 'A11',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2211256, -1.5428042],
        genre: 'Celastrus',
        date_plantation: '1973',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428042, 47.2211256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fad84d78bfe18949179e8fdb4a710a0d8176f7a4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'alatus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 165, 98, 1.00)',
            'rgba(107, 134, 51, 1.00)',
            'rgba(113, 128, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus alatus/euonymus alatus (2).jpg',
          width: 1024,
          id: '2cc2eeb31b1409be16f40beed5d3f53f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 115, 77, 1.00)',
            'rgba(145, 110, 88, 1.00)',
            'rgba(112, 94, 92, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus alatus/euonymus alatus (3).jpg',
          width: 576,
          id: '024a207310395165bc4c5c7a33516991',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(213, 177, 155, 1.00)',
            'rgba(152, 111, 96, 1.00)',
            'rgba(121, 77, 75, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus alatus/euonymus alatus (1).jpg',
          width: 576,
          id: '66ddb95b13de474f48f02c5938d7fa1b',
          height: 768,
          thumbnail: true,
        },
        location: [47.271262, -1.58175],
        genre: 'Euonymus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58175, 47.271262] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6d8936a0eb3704deb5a9859c61be64bba90f833b',
      fields: {
        espece: 'grandiflorus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 91, 99, 1.00)',
            'rgba(161, 101, 106, 1.00)',
            'rgba(154, 89, 87, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus grandiflorus 'select'/euonymus grandiflorus 'select' (2).jpg",
          width: 576,
          id: '72a4f3852a6e86e1c34a19de7166d2be',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(182, 150, 152, 1.00)',
            'rgba(146, 115, 93, 1.00)',
            'rgba(154, 132, 126, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus grandiflorus 'select'/euonymus grandiflorus 'select' (1).jpg",
          width: 576,
          id: '5a8157cc7dd5d4494002e0b8fe65ee6a',
          height: 768,
          thumbnail: true,
        },
        location: [47.269645, -1.583925],
        genre: 'Euonymus',
        cultivar: 'Select',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583925, 47.269645] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1796d5d5e92082f69ed301b2fb56f55882af5f73',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'sacrosanctus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 159, 72, 1.00)',
            'rgba(119, 154, 50, 1.00)',
            'rgba(106, 140, 29, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus sacrosanctus/euonymus sacrosanctus  (2).jpg',
          width: 576,
          id: '46d4b8d5acf654c6bfa6297a9bb5c99d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 158, 93, 1.00)',
            'rgba(122, 153, 66, 1.00)',
            'rgba(89, 116, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus sacrosanctus/euonymus sacrosanctus  (3).jpg',
          width: 576,
          id: 'a1204f16a7c3d62f5d125aeaf621712e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 156, 59, 1.00)',
            'rgba(117, 156, 58, 1.00)',
            'rgba(91, 126, 32, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus sacrosanctus/euonymus sacrosanctus  (1).jpg',
          width: 576,
          id: '8201100e3ba1565097294218989bec34',
          height: 768,
          thumbnail: true,
        },
        location: [47.271583, -1.587058],
        genre: 'Euonymus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587058, 47.271583] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7e31a8e31ceb188251b3f8e8b81e14d9a8201ac5',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 112, 67, 1.00)',
            'rgba(128, 147, 100, 1.00)',
            'rgba(123, 136, 95, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus alba ivory halo 'bailhalo'/cornus alba ivory halo 'bailhalo' (5).jpg",
          width: 1024,
          id: 'abab2501ab05b817ed143b02e0d6a4ee',
          height: 768,
          thumbnail: true,
        },
        espece: 'alba Ivory Halo',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 123, 75, 1.00)',
            'rgba(127, 147, 103, 1.00)',
            'rgba(104, 118, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus alba ivory halo 'bailhalo'/cornus alba ivory halo 'bailhalo' (4).jpg",
          width: 576,
          id: '96c407153bcc1bce4b8be452301ef82c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 127, 81, 1.00)',
            'rgba(135, 142, 112, 1.00)',
            'rgba(96, 108, 71, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus alba ivory halo 'bailhalo'/cornus alba ivory halo 'bailhalo' (1).jpg",
          width: 576,
          id: 'c34197c8a3ee879dcf9591f690f1e485',
          height: 768,
          thumbnail: true,
        },
        location: [47.270922, -1.58202],
        genre: 'Cornus',
        cultivar: 'Bailhalo',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58202, 47.270922] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0c3bcf1e7ef6a67e5b17136b8d27958d5efab19b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'hongkongensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 138, 79, 1.00)',
            'rgba(126, 148, 113, 1.00)',
            'rgba(63, 88, 36, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus hongkongensis/cornus hongkongensis  (2).jpg',
          width: 576,
          id: 'a02cd3e63392d96f7a5a252d8049ae3f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 147, 49, 1.00)',
            'rgba(136, 141, 71, 1.00)',
            'rgba(122, 134, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus hongkongensis/cornus hongkongensis (2).jpg',
          width: 576,
          id: 'bdbc3251cb95e5c12b768023349fde04',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 148, 57, 1.00)',
            'rgba(137, 148, 72, 1.00)',
            'rgba(99, 128, 27, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus hongkongensis/cornus hongkongensis  (1).jpg',
          width: 576,
          id: '58952da3a9559d2a79fce1f3aa6a02a8',
          height: 768,
          thumbnail: true,
        },
        location: [47.27137, -1.581787],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581787, 47.27137] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b792c3ad0aada083b3c75e8219b27efbf199f69d',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 168, 137, 1.00)',
            'rgba(78, 110, 72, 1.00)',
            'rgba(127, 147, 127, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'nicole'/cornus kousa 'nicole' (3).jpg",
          width: 576,
          id: '8f5145207ef4a942769479003756ef93',
          height: 768,
          thumbnail: true,
        },
        espece: 'kousa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 117, 70, 1.00)',
            'rgba(103, 119, 68, 1.00)',
            'rgba(88, 107, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'nicole'/cornus kousa 'nicole' (2).jpg",
          width: 1024,
          id: '76464d28cf1395f587850f4a12ddcb12',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(169, 180, 159, 1.00)',
            'rgba(180, 190, 170, 1.00)',
            'rgba(171, 182, 160, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'nicole'/cornus kousa 'nicole' (1).jpg",
          width: 576,
          id: 'dc4ef3e0e5a37da12c61fb5cd98fc6ec',
          height: 768,
          thumbnail: true,
        },
        location: [47.271388, -1.581872],
        genre: 'Cornus',
        cultivar: 'Nicole',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581872, 47.271388] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '906df6d6853a5d5cc671d234f567f5e1436d2967',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 137, 121, 1.00)',
            'rgba(146, 129, 120, 1.00)',
            'rgba(114, 105, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus sanguinea 'winter beauty'/cornus sanguinea 'winter beauty' (5).jpg",
          width: 576,
          id: '869d03b55ba716965f35222586d46c59',
          height: 768,
          thumbnail: true,
        },
        espece: 'sanguinea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 141, 107, 1.00)',
            'rgba(118, 117, 53, 1.00)',
            'rgba(82, 84, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus sanguinea 'winter beauty'/cornus sanguinea 'winter beauty' (2).jpg",
          width: 576,
          id: 'd47963ee570cd498cc66a0b5e5499f17',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 139, 87, 1.00)',
            'rgba(148, 129, 102, 1.00)',
            'rgba(144, 115, 93, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus sanguinea 'winter beauty'/cornus sanguinea 'winter beauty' (1).jpg",
          width: 576,
          id: 'f2fd8ff52ce0eeb561916a1573c160d0',
          height: 768,
          thumbnail: true,
        },
        location: [47.270072, -1.585792],
        genre: 'Cornus',
        cultivar: 'Winter Beauty',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585792, 47.270072] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3c5e50e5f32e041ec76cc928ff91b65c38723804',
      fields: {
        origine: 'Botanische Garten (Meckenheimer), Bonn, Allemagne',
        espece: 'kamtschaticum Fisch.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Sedum',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4e79b98510e147a6b066eccfb7f50ffcb6816874',
      fields: {
        origine: 'Institut B.de Montjuic (Barcelogne)',
        espece: 'sediforme Pau',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Sedum',
        date_plantation: '1990',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '28f8975a82132ffe17287278379587dff2a25cdf',
      fields: {
        origine: 'JB.Olomouc (R\u00e9publique Tch\u00e8que)',
        espece: 'jullianum Grulich',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Hylotelephium',
        date_plantation: '2006',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '19370078dfafc97a9450a76a8e4f070551d9965a',
      fields: {
        origine: 'Mr.C.Bouchy',
        espece: 'maximum Suter.',
        localisation: 'D3H',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2199567, -1.5416248],
        genre: 'Sedum',
        date_plantation: '1998',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5416248, 47.2199567] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4aeb27923dbadcbb193b513aeb15ab73727071ad',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'lanceolata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 156, 53, 1.00)',
            'rgba(118, 135, 38, 1.00)',
            'rgba(108, 123, 33, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cunninghamia [cupressaceae]/cunninghamia lanceolata/cunninghamia lanceolata (2).jpg',
          width: 1024,
          id: 'd86ac4254605494626f562885c1a6bc6',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 140, 114, 1.00)',
            'rgba(123, 117, 61, 1.00)',
            'rgba(84, 95, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cunninghamia [cupressaceae]/cunninghamia lanceolata/cunninghamia lanceolata (3).jpg',
          width: 1024,
          id: '7c7ed5e2a987aeaba53b2563b14efbaa',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 153, 48, 1.00)',
            'rgba(129, 153, 48, 1.00)',
            'rgba(116, 137, 32, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cunninghamia [cupressaceae]/cunninghamia lanceolata/cunninghamia lanceolata (1).jpg',
          width: 576,
          id: '311ec9aaa013f2592c0572ba93d9bdfc',
          height: 768,
          thumbnail: true,
        },
        location: [47.271917, -1.58647],
        genre: 'Cunninghamia',
        famille: 'Cupressaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58647, 47.271917] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ae7b0a2628932eb6c2ec18bfddd4e7b8027c92dc',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'glyptostroboides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 141, 116, 1.00)',
            'rgba(135, 122, 83, 1.00)',
            'rgba(135, 115, 75, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/metasequoia [cupressaceae]/metasequoia glyptostroboides/metasequoia glyptostroboides (2).jpg',
          width: 576,
          id: 'b0c5d46a155a427966c14a9de7738fcd',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 171, 186, 1.00)',
            'rgba(146, 128, 122, 1.00)',
            'rgba(90, 84, 44, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/metasequoia [cupressaceae]/metasequoia glyptostroboides/metasequoia glyptostroboides (3).jpg',
          width: 1024,
          id: '3b5de57ae31c0d925bb864923dceb5c8',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 111, 67, 1.00)',
            'rgba(168, 111, 70, 1.00)',
            'rgba(162, 97, 48, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/metasequoia [cupressaceae]/metasequoia glyptostroboides/metasequoia glyptostroboides (1).jpg',
          width: 576,
          id: '90bca40b08d47798be675901dceb6502',
          height: 768,
          thumbnail: true,
        },
        location: [47.261155, -1.533053],
        genre: 'Metasequoia',
        famille: 'Cupressaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533053, 47.261155] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '923d1995220722797657f7ff4d7575ec871a5423',
      fields: {
        espece: 'revoluta',
        localisation: 'B1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2204652, -1.544656],
        genre: 'Cycas',
        date_plantation: '1973',
        famille: 'Cycadaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544656, 47.2204652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f67c404b4fbab8f857f8f75bcf6bd7531ed9282a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'lotus (femelle)',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 103, 64, 1.00)',
            'rgba(124, 137, 105, 1.00)',
            'rgba(114, 129, 90, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/diospyros [ebenaceae]/diospyros lotus (femelle)/diospyros lotus (2).jpg',
          width: 576,
          id: '7497bb17cae5b56d0014cf7c87930193',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 132, 110, 1.00)',
            'rgba(135, 110, 67, 1.00)',
            'rgba(89, 79, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/diospyros [ebenaceae]/diospyros lotus (femelle)/diospyros lotus (4).jpg',
          width: 576,
          id: '4db3b8ac66a585e49c676ba6a4f0912a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 119, 84, 1.00)',
            'rgba(123, 166, 81, 1.00)',
            'rgba(113, 141, 71, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/diospyros [ebenaceae]/diospyros lotus (femelle)/diospyros lotus (1).jpg',
          width: 576,
          id: '949a9da4d0d659a01e0f34336360a338',
          height: 768,
          thumbnail: true,
        },
        location: [47.269342, -1.584467],
        genre: 'Diospyros',
        famille: 'Ebenaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584467, 47.269342] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8c9de08b7c0e806aa27e5d9854e79a8deb6a5bd5',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Gd Blottereau',
        espece: 'ponticum',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Rhododendron',
        date_plantation: '2014',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '28a78adec2ecd91982fe471f3427646f48701f02',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Gd Blottereau',
        espece: 'ponticum',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Rhododendron',
        date_plantation: '2018',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e8af22f76c14b23b9487893d4b1a73acd89a452f',
      fields: {
        espece: 'virgata x rubra',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Escallonia',
        date_plantation: '1973',
        cultivar: 'macrantha',
        famille: 'Escalloniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3a67f91fc12c6ff316365d4d497305a69e5d7fca',
      fields: {
        espece: 'illinita',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 145, 77, 1.00)',
            'rgba(118, 154, 73, 1.00)',
            'rgba(113, 143, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/escallonia [escalloniaceae]/escallonia illinita/escallonia illinita (2).jpg',
          width: 576,
          id: 'fca0f3cee1d047822d1201383f538c00',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(59, 74, 39, 1.00)',
            'rgba(113, 127, 79, 1.00)',
            'rgba(76, 100, 31, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/escallonia [escalloniaceae]/escallonia illinita/escallonia illinita (1).jpg',
          width: 576,
          id: 'cd1057b8fe4c4d0dd5595d9960e5d759',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Escallonia',
        famille: 'Escalloniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b47e7c2f02fe022140d4b423ce29e7fab417a8fd',
      fields: {
        espece: 'nereidum Jahandiez & Maire',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Euphorbia',
        date_plantation: '1973',
        famille: 'Euphorbiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ed8eda6a092c30d1702d5b19a055a534e1903290',
      fields: {
        espece: 'japonicus',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 140, 77, 1.00)',
            'rgba(142, 141, 93, 1.00)',
            'rgba(150, 142, 99, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/mallotus [euphorbiaceae]/mallotus japonicus/mallotus japonicus.jpg',
          width: 576,
          id: 'e45fd00a5d129da8ca8634905ba9a8c4',
          height: 768,
          thumbnail: true,
        },
        location: [47.229892, -1.508003],
        genre: 'Mallotus',
        famille: 'Euphorbiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508003, 47.229892] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '288f4e7034289424766706af876eb5727fc1e902',
      fields: {
        origine: 'JBAlpin de la Ja\u00ffsinia, Sam\u00f6ens (France)',
        espece: 'pentaphyllum Scop.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Dorycnium',
        date_plantation: '2011',
        cultivar: 'germanicum Gams',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6d675017955e9baaeccabb304232c204594b44d3',
      fields: {
        origine: 'Palmen Garten Frankfurt (All.)',
        espece: 'canescens Pursh',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Amorpha',
        date_plantation: '2014',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '47f127730069896f39cde822cbc8078fc9872b8e',
      fields: {
        origine: 'P\u00e9pin\u00e8res Arven - Poullan-Sur-Mer (29)',
        espece: 'barba-jovis',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Anthyllis',
        date_plantation: '2018',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '512a63820dd9ebc71bb534c97c92d738184d250f',
      fields: {
        origine: 'JB Vitoria-Gasteiz',
        espece: 'robur',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Quercus',
        date_plantation: '2017',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9036da483608b190add3f0887380dde6380d774e',
      fields: {
        espece: 'engleriana',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 152, 109, 1.00)',
            'rgba(113, 125, 82, 1.00)',
            'rgba(74, 77, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus engleriana/fagus engleriana (20).jpg',
          width: 1024,
          id: '24f9f0a784f1706b33003827495e3de2',
          height: 683,
          thumbnail: true,
        },
        location: [47.271073, -1.586234],
        genre: 'Fagus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586234, 47.271073] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bbc9229ee95c40937e3fa8daf51bde89cd71c65c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'grandifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 151, 101, 1.00)',
            'rgba(93, 111, 36, 1.00)',
            'rgba(78, 105, 19, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus grandifolia/fagus grandifolia (4).jpg',
          width: 576,
          id: 'fcf08b28f334d5904e4c12ed50c8db14',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 147, 92, 1.00)',
            'rgba(117, 156, 96, 1.00)',
            'rgba(105, 127, 74, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus grandifolia/fagus grandifolia (5).jpg',
          width: 576,
          id: 'ea0910235b1d8734a7405802bb1f5671',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 150, 85, 1.00)',
            'rgba(120, 150, 104, 1.00)',
            'rgba(121, 114, 78, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus grandifolia/fagus grandifolia (3).jpg',
          width: 576,
          id: 'f4c2b9b37b4b3cbdc7c01391c2399672',
          height: 768,
          thumbnail: true,
        },
        location: [47.27055, -1.581712],
        genre: 'Fagus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581712, 47.27055] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '35b84a0be346d62a482587d69320faa30cb5df7b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'orientalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 150, 123, 1.00)',
            'rgba(114, 121, 82, 1.00)',
            'rgba(117, 131, 104, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus orientalis/fagus orientalis  (3).jpg',
          width: 576,
          id: '8947915d37ccae8d66ad986306634469',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(186, 187, 150, 1.00)',
            'rgba(105, 113, 64, 1.00)',
            'rgba(45, 53, 20, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus orientalis/fagus orientalis  (4).jpg',
          width: 1024,
          id: '74e4b8b9873a06066fa92159bc113887',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(191, 215, 212, 1.00)',
            'rgba(102, 122, 100, 1.00)',
            'rgba(46, 59, 33, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus orientalis/fagus orientalis  (2).jpg',
          width: 868,
          id: 'ce09f1435ea5bce7088e4fd2f353dd5d',
          height: 768,
          thumbnail: true,
        },
        location: [47.271003, -1.585712],
        genre: 'Fagus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585712, 47.271003] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5d42299b6f7e192d649b3ee5c05c2de9c0f1a164',
      fields: {
        espece: 'orientalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(175, 157, 104, 1.00)',
            'rgba(135, 114, 46, 1.00)',
            'rgba(61, 57, 34, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus orientalis/fagus orientalis (2).jpg',
          width: 674,
          id: '7ceee03212241fdead7fb28003775e05',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 115, 90, 1.00)',
            'rgba(165, 135, 65, 1.00)',
            'rgba(106, 92, 45, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus orientalis/fagus orientalis (1).jpg',
          width: 576,
          id: '3550a44999bf9f3060e75374dac0eca4',
          height: 768,
          thumbnail: true,
        },
        location: [47.270587, -1.581455],
        genre: 'Fagus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581455, 47.270587] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '00a42586517c26709e2fc029cd5e60d7caf5c5c0',
      fields: {
        espece: 'orientalis',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 53, 20, 1.00)',
            'rgba(122, 87, 52, 1.00)',
            'rgba(118, 87, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus orientalis/fagus orientalis.jpg',
          width: 512,
          id: 'd243f9cc63ae97818cc24eb09ba118d2',
          height: 768,
          thumbnail: true,
        },
        location: [47.271005, -1.585712],
        genre: 'Fagus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585712, 47.271005] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f1e4724588c39650494d0a349ef202dccd32a7ce',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 106, 69, 1.00)',
            'rgba(129, 128, 84, 1.00)',
            'rgba(108, 109, 82, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fagus [fagaceae]/fagus sylvatica 'aspleniifolia'/fagus sylvatica 'aspleniifolia' (4).jpg",
          width: 576,
          id: '6a6feba8452fba4e32d2a0721887e865',
          height: 768,
          thumbnail: true,
        },
        espece: 'sylvatica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 120, 89, 1.00)',
            'rgba(102, 121, 85, 1.00)',
            'rgba(107, 120, 87, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fagus [fagaceae]/fagus sylvatica 'aspleniifolia'/fagus sylvatica 'aspleniifolia' (3).jpg",
          width: 576,
          id: '050b68bcf0115146aa1506336ad80113',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 105, 27, 1.00)',
            'rgba(116, 142, 46, 1.00)',
            'rgba(130, 151, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fagus [fagaceae]/fagus sylvatica 'aspleniifolia'/fagus sylvatica 'aspleniifolia' (2).jpg",
          width: 576,
          id: '8d8a140feaad525eb7fd04acf32e622c',
          height: 768,
          thumbnail: true,
        },
        location: [47.269742, -1.581955],
        genre: 'Fagus',
        cultivar: 'Aspleniifolia',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581955, 47.269742] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4946f50d7add6355e2a16e74931376a073d948de',
      fields: {
        espece: 'sylvatica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 73, 18, 1.00)',
            'rgba(121, 88, 25, 1.00)',
            'rgba(86, 71, 26, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fagus [fagaceae]/fagus sylvatica 'aspleniifolia'/fagus sylvatica 'aspleniifolia' (9).jpg",
          width: 1024,
          id: '1ea2fce8002a2ed79acd2313be09bd0a',
          height: 683,
          thumbnail: true,
        },
        location: [47.269633, -1.582097],
        genre: 'Fagus',
        cultivar: 'Aspleniifolia',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582097, 47.269633] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3edc27c444c29d430866aa551b369f56ef5df66b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'sylvatica Atropurpurea Group',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 154, 132, 1.00)',
            'rgba(131, 111, 102, 1.00)',
            'rgba(121, 120, 100, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus sylvatica atropurpurea group/fagus sylvatica atropurpurea group (2).jpg',
          width: 626,
          id: '73d46c61aeab17d5e9d5b078300869cf',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 138, 119, 1.00)',
            'rgba(142, 114, 74, 1.00)',
            'rgba(108, 90, 42, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus sylvatica atropurpurea group/fagus sylvatica atropurpurea group (4).jpg',
          width: 576,
          id: '4b7fd5d668f0e91dfcd21971e593121c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 149, 127, 1.00)',
            'rgba(123, 120, 112, 1.00)',
            'rgba(148, 148, 114, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus sylvatica atropurpurea group/fagus sylvatica atropurpurea group (1).jpg',
          width: 576,
          id: 'ffe13e933becc23386d4635a973612e4',
          height: 768,
          thumbnail: true,
        },
        location: [47.270047, -1.584588],
        genre: 'Fagus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584588, 47.270047] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c3a9701c13151da78842b2bea045f977d6222425',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'henryi',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 160, 111, 1.00)',
            'rgba(129, 133, 73, 1.00)',
            'rgba(108, 118, 67, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lithocarpus [fagaceae]/lithocarpus henryi/lithocarpus henryi (10).jpg',
          width: 1024,
          id: '03b1aa500decea56100173645567fab5',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 167, 166, 1.00)',
            'rgba(86, 91, 56, 1.00)',
            'rgba(89, 85, 51, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lithocarpus [fagaceae]/lithocarpus henryi/lithocarpus henryi (11).jpg',
          width: 617,
          id: 'dcb6a73b0695e29b6c6e05e8e3e41e1f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 141, 90, 1.00)',
            'rgba(126, 121, 63, 1.00)',
            'rgba(84, 97, 39, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lithocarpus [fagaceae]/lithocarpus henryi/lithocarpus henryi (1).jpg',
          width: 576,
          id: 'f09e439fbd2dd222517bfb28710c7083',
          height: 768,
          thumbnail: true,
        },
        location: [47.27148, -1.581537],
        genre: 'Lithocarpus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581537, 47.27148] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c86162ed79a0a12830242186a48c1aa7618daf0f',
      fields: {
        espece: 'hemisphaerica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(173, 184, 168, 1.00)',
            'rgba(142, 154, 108, 1.00)',
            'rgba(105, 115, 82, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus hemisphaerica/quercus hemisphaerica (2).jpg',
          width: 576,
          id: 'b85696c06f2d2326a7a6b6099b4e33dc',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 163, 151, 1.00)',
            'rgba(128, 131, 110, 1.00)',
            'rgba(100, 101, 86, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus hemisphaerica/quercus hemisphaerica (1).jpg',
          width: 576,
          id: 'bfb19dd1e197641e4d25832130f901dd',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2696676b5568bfa0434c93ed313ae6c0859d6ca4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'ilicifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 148, 72, 1.00)',
            'rgba(118, 133, 69, 1.00)',
            'rgba(96, 107, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus ilicifolia/quercus ilicifolia (2).jpg',
          width: 576,
          id: 'a43b0c3bbe1f25d3aaf14e89b59da522',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 106, 77, 1.00)',
            'rgba(119, 137, 112, 1.00)',
            'rgba(107, 105, 77, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus ilicifolia/quercus ilicifolia (3).jpg',
          width: 576,
          id: '3cd40c835aaecb0e17c4b5f834257910',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 138, 44, 1.00)',
            'rgba(121, 132, 54, 1.00)',
            'rgba(98, 99, 21, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus ilicifolia/quercus ilicifolia (1).jpg',
          width: 576,
          id: '9adb9eee6ac6c5bc561cd3708243fb68',
          height: 768,
          thumbnail: true,
        },
        location: [47.270753, -1.586463],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586463, 47.270753] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dec031d4ad2a794304737eb8ff0ef7263a6b651d',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'Pondaim Group',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 94, 93, 1.00)',
            'rgba(119, 123, 114, 1.00)',
            'rgba(100, 100, 92, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus pondaim group/quercus pondaim group (2).jpg',
          width: 713,
          id: '1b49b52a93b1c1ec1280b311ffec74a8',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 79, 62, 1.00)',
            'rgba(144, 123, 40, 1.00)',
            'rgba(103, 96, 47, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus pondaim group/quercus pondaim group (3).jpg',
          width: 576,
          id: '11021fb8c70cbedb1010eadacd9d23b2',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 114, 86, 1.00)',
            'rgba(107, 128, 86, 1.00)',
            'rgba(108, 119, 85, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus pondaim group/quercus pondaim group (1).jpg',
          width: 744,
          id: '658d14a28bd4157a639c8d5165c1bd00',
          height: 768,
          thumbnail: true,
        },
        location: [47.270422, -1.580703],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580703, 47.270422] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9584df9da4bb71dd20a5022d0c071def89b4f890',
      fields: {
        espece: 'rubra',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(189, 169, 160, 1.00)',
            'rgba(147, 98, 59, 1.00)',
            'rgba(95, 80, 42, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus rubra/quercus rubra.jpg',
          width: 576,
          id: '88c6c285644e9daeb7544062d2d66f97',
          height: 768,
          thumbnail: true,
        },
        location: [47.270617, -1.585763],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585763, 47.270617] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9ecd6e419fde094ea8e0201ad21ba3cfc9dd0d55',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'rysophylla',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 115, 113, 1.00)',
            'rgba(107, 115, 105, 1.00)',
            'rgba(90, 96, 91, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus rysophylla/quercus rysophylla (3).jpg',
          width: 576,
          id: '2af09c247a36c9ae3745f4e0f879e6aa',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 99, 88, 1.00)',
            'rgba(110, 118, 97, 1.00)',
            'rgba(97, 94, 81, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus rysophylla/quercus rysophylla (4).jpg',
          width: 576,
          id: '1a0c3067d941f9597554fdc90d3cb991',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 143, 155, 1.00)',
            'rgba(121, 119, 93, 1.00)',
            'rgba(89, 80, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus rysophylla/quercus rysophylla (1).jpg',
          width: 576,
          id: 'a8720d63938f9df59a7865c96384b6d6',
          height: 768,
          thumbnail: true,
        },
        location: [47.271717, -1.586872],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586872, 47.271717] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8d34edbe54bf79ca305e0fb741dfc84f5cf7fe0a',
      fields: {
        espece: 'variabilis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 107, 151, 1.00)',
            'rgba(102, 96, 107, 1.00)',
            'rgba(94, 88, 90, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus variabilis/quercus variabilis (4).jpg',
          width: 512,
          id: '17bd1d274615e8dc87d356345c3169e0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 142, 182, 1.00)',
            'rgba(124, 111, 91, 1.00)',
            'rgba(56, 48, 28, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus variabilis/quercus variabilis (3).jpg',
          width: 512,
          id: '61daee608772e2cb92570bbf19d0f116',
          height: 768,
          thumbnail: true,
        },
        location: [47.270019, -1.584694],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584694, 47.270019] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '08780a8e929467425de3afa563fa44ef069600c3',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x kewensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 102, 87, 1.00)',
            'rgba(95, 106, 85, 1.00)',
            'rgba(102, 105, 92, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus x kewensis/quercus x kewensis (3).jpg',
          width: 576,
          id: 'b1860f950ddb249ae3c2ef75f39d7aca',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 120, 118, 1.00)',
            'rgba(133, 130, 126, 1.00)',
            'rgba(129, 128, 120, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus x kewensis/quercus x kewensis (6).jpg',
          width: 576,
          id: '327eda9d1ee88adfecfcfbd332576565',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 134, 130, 1.00)',
            'rgba(113, 126, 121, 1.00)',
            'rgba(102, 115, 100, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus x kewensis/quercus x kewensis (1).jpg',
          width: 576,
          id: 'a0d181ba11f49ff554b48ab6e1f0fbf3',
          height: 768,
          thumbnail: true,
        },
        location: [47.270255, -1.581833],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581833, 47.270255] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4e905493c014e7f5991350ae62b0ad0be5d3cd6f',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'elliptica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 110, 86, 1.00)',
            'rgba(93, 112, 87, 1.00)',
            'rgba(74, 96, 76, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/garrya [garryaceae]/garrya elliptica/garrya elliptica (2).jpg',
          width: 512,
          id: 'f28bb350fcaafb91edb259f9e2b58c68',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(179, 186, 176, 1.00)',
            'rgba(107, 117, 98, 1.00)',
            'rgba(56, 66, 51, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/garrya [garryaceae]/garrya elliptica/garrya elliptica (3).jpg',
          width: 1024,
          id: 'f60dca3734daace69ed718f943a08895',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(192, 201, 195, 1.00)',
            'rgba(91, 108, 92, 1.00)',
            'rgba(40, 51, 39, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/garrya [garryaceae]/garrya elliptica/garrya elliptica (1).jpg',
          width: 1024,
          id: '2f2ebd760ccbc34fb4979cd6b1bbbff7',
          height: 683,
          thumbnail: true,
        },
        location: [47.228387, -1.508662],
        genre: 'Garrya',
        famille: 'Garryaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508662, 47.228387] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '229a506b90b4e61917171ca0f863e0f14cb46ec4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'elliptica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 118, 65, 1.00)',
            'rgba(131, 141, 75, 1.00)',
            'rgba(84, 94, 34, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/garrya [garyaceae]/garrya elliptica/garrya elliptica (2).jpg',
          width: 576,
          id: 'e4371b4263508b3820940f96ceab9647',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 126, 67, 1.00)',
            'rgba(130, 144, 70, 1.00)',
            'rgba(116, 125, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/garrya [garyaceae]/garrya elliptica/garrya elliptica (3).jpg',
          width: 576,
          id: 'a2f17b03ef726233b2597f60cf3859f8',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 198, 209, 1.00)',
            'rgba(107, 107, 77, 1.00)',
            'rgba(102, 98, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/garrya [garyaceae]/garrya elliptica/garrya elliptica (1).jpg',
          width: 1024,
          id: '615cea28ff4799d16e4bc890a1d063e9',
          height: 745,
          thumbnail: true,
        },
        location: [47.271197, -1.5817],
        genre: 'Garrya',
        famille: 'Garryaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5817, 47.271197] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '96af17abd886f2bb2b59964d7821d7a3ca085cdc',
      fields: {
        origine: 'JB.Takashi (Japon)',
        espece: 'shikokianum Matsudo',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Geranium',
        date_plantation: '2009',
        famille: 'Geraniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5b0bfdb811a45721bc9063408e6106804b30354f',
      fields: {
        origine: 'JB.Tourmalet, Bar\u00e8ges (France)',
        espece: 'endressii Gay',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Geranium',
        date_plantation: '2006',
        famille: 'Geraniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9dc73630387989a29e58b60c2e3cc71f6b5a47f7',
      fields: {
        origine: 'P\u00e9pini\u00e8res Emmanuel LEPAGE',
        espece: 'pratense L.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Geranium',
        date_plantation: '2015',
        famille: 'Geraniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '90ade40cc946882064ee7a8a119628eee69f2d54',
      fields: {
        espece: 'biloba',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 162, 184, 1.00)',
            'rgba(111, 111, 104, 1.00)',
            'rgba(15, 19, 11, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/ginkgo [ginkgoaceae]/ginkgo biloba/ginkgo biloba (3).jpg',
          width: 1024,
          id: 'd0010d9d59598e768ad95a861e0fe71b',
          height: 740,
          thumbnail: true,
        },
        location: [47.262295, -1.531697],
        genre: 'Ginkgo',
        famille: 'Ginkgoaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531697, 47.262295] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cb1419d8d20e85719d5d24920987299c10f70694',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'fasciculatum var. chinense',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 125, 61, 1.00)',
            'rgba(114, 148, 76, 1.00)',
            'rgba(94, 124, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ribes [grossulariaceae]/ribes fasciculatum var. chinense/ribes fasciculatum var. chinense (2).jpg',
          width: 576,
          id: '2e6feb1a234116e07023d8c94ce22eda',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 172, 118, 1.00)',
            'rgba(108, 129, 71, 1.00)',
            'rgba(89, 102, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ribes [grossulariaceae]/ribes fasciculatum var. chinense/ribes fasciculatum var. chinense (3).jpg',
          width: 1024,
          id: 'd66799a2f5c5acac98fab0e55877ae0b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 130, 71, 1.00)',
            'rgba(120, 122, 66, 1.00)',
            'rgba(99, 116, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ribes [grossulariaceae]/ribes fasciculatum var. chinense/ribes fasciculatum var. chinense (1).jpg',
          width: 576,
          id: '0fabcfd965b5dcec5d6075bcf7519b93',
          height: 768,
          thumbnail: true,
        },
        location: [47.271087, -1.585395],
        genre: 'Ribes',
        famille: 'Grossulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585395, 47.271087] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cb159c2c76772e3a218a0ecab66e50f8c67e9f74',
      fields: {
        origine: 'Arboretum Volga Kama, Zapovednik (Russie)',
        espece: 'x monstrosus',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Philadelphus',
        date_plantation: '2005',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f7b942cbdea65296d2007ccaa3dfd0544d7b9052',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 127, 87, 1.00)',
            'rgba(137, 142, 97, 1.00)',
            'rgba(119, 138, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia ningpoensis 'pink charm'/deutzia ningpoensis 'pink charm' (3).jpg",
          width: 576,
          id: 'ea54a2105646811e15c401d635c662e5',
          height: 768,
          thumbnail: true,
        },
        espece: 'ningpoensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 146, 86, 1.00)',
            'rgba(108, 136, 67, 1.00)',
            'rgba(117, 126, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia ningpoensis 'pink charm'/deutzia ningpoensis 'pink charm' (2).jpg",
          width: 576,
          id: '3052f2be7969738130d57a0cfbd2a0da',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 115, 80, 1.00)',
            'rgba(128, 126, 103, 1.00)',
            'rgba(98, 102, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia ningpoensis 'pink charm'/deutzia ningpoensis 'pink charm' (1).jpg",
          width: 576,
          id: '96f5556eaf048502642e49a92316d7e6',
          height: 768,
          thumbnail: true,
        },
        location: [47.271122, -1.585283],
        genre: 'Deutzia',
        cultivar: 'Pink Charm',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585283, 47.271122] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3565dc15203e6c5a0c79f9ed5b9458dafebcfbb3',
      fields: {
        espece: 'x hybrida',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 159, 125, 1.00)',
            'rgba(124, 123, 79, 1.00)',
            'rgba(100, 102, 67, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia x hybrida 'strawberry fields'/deutzia x hybrida 'strawberry fields'.jpg",
          width: 1024,
          id: '4830023b7de27a624d1b34171240e5bf',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Deutzia',
        cultivar: 'Strawberry Fields',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '64d08b046db00de712009dd02f9314bfbbf05f19',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 83, 52, 1.00)',
            'rgba(126, 125, 101, 1.00)',
            'rgba(130, 123, 98, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia x maliflora 'avalanche'/deutzia x maliflora 'avalanche' .jpg",
          width: 1024,
          id: 'd6d96b7d0290f0e836a3166912962b62',
          height: 768,
          thumbnail: true,
        },
        espece: 'x maliflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 106, 89, 1.00)',
            'rgba(172, 155, 157, 1.00)',
            'rgba(162, 138, 140, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia x maliflora 'avalanche'/deutzia x maliflora 'avalanche' (3).jpg",
          width: 623,
          id: '89a1d0075b63dd2bf6b1ba21b0dc21aa',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 110, 97, 1.00)',
            'rgba(155, 151, 145, 1.00)',
            'rgba(144, 137, 130, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia x maliflora 'avalanche'/deutzia x maliflora 'avalanche' (2).jpg",
          width: 576,
          id: '4b839ebdd6e06021b0f7549c5bff3268',
          height: 768,
          thumbnail: true,
        },
        location: [47.271305, -1.5864],
        genre: 'Deutzia',
        cultivar: 'Avalanche',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5864, 47.271305] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '631b1bf5a505dd1b483aeb9627a5325848c1866e',
      fields: {
        espece: 'x hidcoteense',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 146, 76, 1.00)',
            'rgba(107, 134, 41, 1.00)',
            'rgba(136, 135, 82, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hypericum [hypericaceae]/hypericum x hidcoteense 'hidcote'/hypericum x hidcoteense 'hidcote' (4).jpg",
          width: 1024,
          id: '31efe212646d30bcdfbe2923e57a3dd0',
          height: 768,
          thumbnail: true,
        },
        location: [47.270845, -1.581872],
        genre: 'Hypericum',
        cultivar: 'Hidcote',
        famille: 'Hypericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581872, 47.270845] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4414477c6e62eb0c006cc0e13fe679e774d4515a',
      fields: {
        origine: 'Botanischer Garten,Mainz,Allamagne',
        espece: 'crocata Ker-Gawl.',
        localisation: 'G2A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185657, -1.5426599],
        genre: 'Tritonia',
        date_plantation: '2014',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426599, 47.2185657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '594584aaa17553879c046cbf71c4560526511af7',
      fields: {
        origine: 'J.B. de Christchurch,New Z\u00e9land',
        espece: 'grandiflora Phil.',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Libertia',
        date_plantation: '2014',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e4740fe074520ce2f8770c7aa83bb44059db8bcd',
      fields: {
        origine: 'JB. De Wuppertal (Allemagne)',
        espece: 'striatum Sm.',
        localisation: 'I2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185657, -1.5426599],
        genre: 'Sisyrinchium',
        date_plantation: '2001',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426599, 47.2185657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4b3a09c42d1c23819487782f86d3d979a1dcaf28',
      fields: {
        origine: 'JB. Graz (Autriche)',
        espece: 'graminea L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Iris',
        date_plantation: '2010',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bea9dbd19f9e2bb2297bbaf774f23ad999da04de',
      fields: {
        origine: 'Med.Herb.Garden,Seattle,USA',
        espece: 'douglasiana Herb.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Iris',
        date_plantation: '2012',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4b47ad3ff9a4aa12eee65a7bdde878e7d2b5d296',
      fields: {
        origine: 'Sichtungsgartens Hermannshof,Weinheim,All.',
        espece: 'crocea Jacquem.',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Iris',
        date_plantation: '2012',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e8b770890afe571c078729a6c042384977db86d3',
      fields: {
        origine: 'Universit\u00e9 de Potsdam (Allemagne)',
        espece: 'ancyrensis Maw',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Crocus',
        date_plantation: '2010',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7ec62f20905809af7121271c36fb1171a9c3bc46',
      fields: {
        espece: 'illinoinensis',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 142, 69, 1.00)',
            'rgba(115, 133, 48, 1.00)',
            'rgba(98, 130, 25, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/carya [juglandaceae]/carya illinoinensis/carya illinoinensis.jpg",
          width: 576,
          id: '4642f16c0c0181a73c55995f53a45330',
          height: 768,
          thumbnail: true,
        },
        location: [47.226637, -1.5127],
        genre: 'Carya',
        famille: 'Juglandaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5127, 47.226637] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9ad1b243ceefba08d156026ebc517ace17722bbc',
      fields: {
        origine: 'Conservatoire et JB.de Gen\u00e8ve (Suisse)',
        espece: 'sudetica DC.',
        localisation: 'A9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2212566, -1.5434775],
        genre: 'Luzula',
        date_plantation: '2003',
        famille: 'Juncaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5434775, 47.2212566] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '18ddd1059fc62de5f2cf137bd6ca2e5a3f1e7b9d',
      fields: {
        origine: 'Acad\u00e9mie des Sciences Ouzbekistan',
        espece: 'stepposa Schost.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Salvia',
        date_plantation: '2001',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '134c1ca9e06711a60e6e67754a0f2bc16bdb27a0',
      fields: {
        origine: 'Emmanuel LEPAGE',
        espece: 'clarkei Hook.f.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Nepeta',
        date_plantation: '2015',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd74ad434b25217bf37eaa93a8b57cb4a447be345',
      fields: {
        origine: 'Grugapark Essen (Allemagne)',
        espece: 'montana L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Satureja',
        date_plantation: '1987',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3e8015ad2b8b93e83bdb9037bb19ccba7272fcd1',
      fields: {
        origine: 'J.P. de Montpellier',
        espece: 'embergeri Roussine',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Thymus',
        date_plantation: '2014',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f2035b6a4b84dc11c83a512e4b0161b947c9d8a0',
      fields: {
        origine: 'JB. Jerusalem (Israel)',
        espece: 'hierosolymitana Boiss.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Salvia',
        date_plantation: '2010',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5121e899cd19221896fc744197f7c7fb58f2e82b',
      fields: {
        origine: 'JB.Bern (Suisse)',
        espece: 'macrantha Stearn',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Stachys',
        date_plantation: '2009',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a21a95803c3ca578b18f71410ff223d6d170ac5e',
      fields: {
        origine: 'JB.Leipzig (Allemagne)',
        espece: 'bucharica Popov.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Salvia',
        date_plantation: '2009',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '52c08f8eabdfc9da1a49bda5a9e5005c8c356b7c',
      fields: {
        origine: 'JB.Montpellier (France)',
        espece: 'polium L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Teucrium',
        date_plantation: '2004',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '495fb4fd784b845163b663a9e9c4871f213bb56b',
      fields: {
        origine: 'JB.Prague (R\u00e9p.Tch\u00e8que)',
        espece: 'tattanthum Gonsch.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Origanum',
        date_plantation: '2006',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cc1ad740214d5ce0559fb0e1695d43c61ef7a056',
      fields: {
        origine: 'Med.Herb.Garden of Washington (USA)',
        espece: 'rubescens H.Hara',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Rabdosia',
        date_plantation: '2015',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '23dcd25a58e67215197642794ee94cdf25e9fc8a',
      fields: {
        origine: 'Mr.Henri Besansson',
        espece: 'nuda L.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Nepeta',
        date_plantation: '2000',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bbde39176d014690ffe0719734a18896628f529a',
      fields: {
        origine: 'origine perdue,culture enclo bota pour AO',
        espece: 'montana L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Satureja',
        date_plantation: '2014',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f6d04dffc03aad03e7406fbb867659cb71eeace2',
      fields: {
        espece: 'dichotoma',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 162, 88, 1.00)',
            'rgba(125, 134, 75, 1.00)',
            'rgba(126, 136, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/callicarpa [lamiaceae]/callicarpa dichotoma 'issai'/callicarpa dichotoma 'issai'  (7).jpg",
          width: 576,
          id: 'e63f628ecf2ca8c360b36886dc22a732',
          height: 768,
          thumbnail: true,
        },
        location: [47.270888, -1.585012],
        genre: 'Callicarpa',
        cultivar: 'Issai',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585012, 47.270888] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1f8991c6695e3c9283c8d059ed52cb0e37bb89ed',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'dependens',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 148, 108, 1.00)',
            'rgba(118, 129, 111, 1.00)',
            'rgba(107, 135, 122, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/rostrinucula [lamiaceae]/rostrinucula dependens/rostrinucula dependens (10).jpg',
          width: 1024,
          id: '82cbbe7e128dd43e13636d1037ceae49',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 154, 121, 1.00)',
            'rgba(107, 125, 103, 1.00)',
            'rgba(116, 129, 110, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/rostrinucula [lamiaceae]/rostrinucula dependens/rostrinucula dependens (9).jpg',
          width: 922,
          id: '8b1cad8648ef15d63d6113b1c4954274',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 133, 102, 1.00)',
            'rgba(131, 137, 120, 1.00)',
            'rgba(111, 109, 106, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/rostrinucula [lamiaceae]/rostrinucula dependens/rostrinucula dependens (1).jpg',
          width: 576,
          id: '3adfbafd3786f99922dbd960b66d94d8',
          height: 768,
          thumbnail: true,
        },
        location: [47.270508, -1.586392],
        genre: 'Rostrinucula',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586392, 47.270508] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'efdc38381fb968a8013ebc2b20f207e7842c7396',
      fields: {
        espece: 'dependens',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 72, 44, 1.00)',
            'rgba(105, 101, 73, 1.00)',
            'rgba(123, 116, 75, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/rostrinucula [lamiaceae]/rostrinucula dependens/rostrinucula dependens (12).jpg',
          width: 1024,
          id: '5c79c5d1d46432cf54596a02ae05401a',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 75, 46, 1.00)',
            'rgba(104, 88, 66, 1.00)',
            'rgba(112, 96, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/rostrinucula [lamiaceae]/rostrinucula dependens/rostrinucula dependens (11).jpg',
          width: 1024,
          id: '539af4bf422b9727110a8427ebf6dd1a',
          height: 683,
          thumbnail: true,
        },
        location: [47.270953, -1.584763],
        genre: 'Rostrinucula',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584763, 47.270953] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0a2b8fb828a66529be8428857e7d31c7bcb0b054',
      fields: {
        espece: 'agnus-castus',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 143, 99, 1.00)',
            'rgba(130, 131, 113, 1.00)',
            'rgba(122, 126, 110, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/vitex [lamiaceae]/vitex agnus-castus/vitex agnus-castus.jpg',
          width: 576,
          id: '9c4bcd47097d925606ab016df5b61703',
          height: 768,
          thumbnail: true,
        },
        location: [47.267608, -1.58212],
        genre: 'Vitex',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58212, 47.267608] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '93807dcabff51521679f513d95db93daa5156776',
      fields: {
        origine: 'J.B.,Kawauchi Sendai,Japon',
        espece: 'medeoloides A.Gray',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Lilium',
        date_plantation: '2010',
        famille: 'Liliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '790ba1f2903709f28c18a51cc5ca0ce329b75d27',
      fields: {
        origine: 'JB.Yeomjii (Cor\u00e9e)',
        espece: 'anceps  Makino',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Lythrum',
        date_plantation: '2008',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2a7b26cd23d822c129011f7ed9e2194e6fa17b01',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 90, 32, 1.00)',
            'rgba(92, 86, 30, 1.00)',
            'rgba(68, 82, 24, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/punica [lythraceae]/punica granatum 'flore pleno'/punica granatum 'flore pleno' (3).jpg",
          width: 1024,
          id: 'c0d6aa31733c653156e92a4749f0c32e',
          height: 683,
          thumbnail: true,
        },
        espece: 'granatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 149, 66, 1.00)',
            'rgba(86, 118, 41, 1.00)',
            'rgba(80, 103, 46, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/punica [lythraceae]/punica granatum 'flore pleno'/punica granatum 'flore pleno' (2).jpg",
          width: 1024,
          id: '429413fc54443b6bf8eb6ded6a4b0144',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 107, 13, 1.00)',
            'rgba(126, 128, 32, 1.00)',
            'rgba(97, 107, 32, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/punica [lythraceae]/punica granatum 'flore pleno'/punica granatum 'flore pleno' (1).jpg",
          width: 576,
          id: '3e26ff9ef84f077f20edbcdfd3bf89d3',
          height: 768,
          thumbnail: true,
        },
        location: [47.2693, -1.584003],
        genre: 'Punica',
        cultivar: 'Flore Pleno',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584003, 47.2693] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '87c9a832cfbe2f8f366acf2e4faf1a9deeb85b42',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(48, 72, 23, 1.00)',
            'rgba(92, 104, 71, 1.00)',
            'rgba(72, 86, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'charles coates'/magnolia 'charles coates' (11).jpg",
          width: 1024,
          id: '417648da5fd8ddb1080d18cea52ee2d9',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 109, 48, 1.00)',
            'rgba(103, 146, 76, 1.00)',
            'rgba(77, 119, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'charles coates'/magnolia 'charles coates' (8).jpg",
          width: 1024,
          id: 'd867d9a1788039783b56076a7f9ff439',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 176, 166, 1.00)',
            'rgba(89, 105, 57, 1.00)',
            'rgba(64, 86, 26, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'charles coates'/magnolia 'charles coates' (10).jpg",
          width: 1024,
          id: '97864b910a9080266387ea895430575f',
          height: 683,
          thumbnail: true,
        },
        location: [47.270462, -1.582263],
        genre: 'Magnolia',
        cultivar: 'Charles Coates',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582263, 47.270462] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bdf0251c4648c0f254961bfbc900a5a12f82bc64',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 121, 139, 1.00)',
            'rgba(123, 106, 120, 1.00)',
            'rgba(85, 73, 77, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'galaxy'/magnolia 'galaxy' (4).jpg",
          width: 1024,
          id: '9bbf56e95e6bde1b8cc19fe301587e75',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 146, 186, 1.00)',
            'rgba(103, 93, 91, 1.00)',
            'rgba(92, 89, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'galaxy'/magnolia 'galaxy' (5).jpg",
          width: 1024,
          id: 'eff9e225dcdf185622255a9b040192fc',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 138, 180, 1.00)',
            'rgba(105, 82, 83, 1.00)',
            'rgba(95, 90, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'galaxy'/magnolia 'galaxy' (3).jpg",
          width: 512,
          id: '2bd42ae5a854f34f1e266935c5dd349c',
          height: 768,
          thumbnail: true,
        },
        location: [47.269587, -1.582378],
        genre: 'Magnolia',
        cultivar: 'Galaxy',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582378, 47.269587] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '42cc1557d152e9385be10628a5ad8066ae7536dd',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 112, 118, 1.00)',
            'rgba(100, 100, 80, 1.00)',
            'rgba(101, 97, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia salicifolia 'kewensis'/magnolia salicifolia 'kewensis' (6).jpg",
          width: 1024,
          id: '0d494699b259837289e4d0f799b2087a',
          height: 683,
          thumbnail: true,
        },
        espece: 'salicifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 165, 174, 1.00)',
            'rgba(144, 146, 150, 1.00)',
            'rgba(87, 83, 63, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia salicifolia 'kewensis'/magnolia salicifolia 'kewensis' (5).jpg",
          width: 512,
          id: 'e67fb0af51e7432abcd36688e972c06b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 129, 121, 1.00)',
            'rgba(114, 116, 106, 1.00)',
            'rgba(94, 93, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia salicifolia 'kewensis'/magnolia salicifolia 'kewensis' (4).jpg",
          width: 1024,
          id: '90b51f5bca2244959ae4f987bb1b6e9c',
          height: 683,
          thumbnail: true,
        },
        location: [47.271297, -1.581608],
        genre: 'Magnolia',
        cultivar: 'Kewensis',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581608, 47.271297] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b66d27170b803df72273ec5d4edd34a84af5fb23',
      fields: {
        espece: 'x soulangeana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 86, 63, 1.00)',
            'rgba(130, 111, 115, 1.00)',
            'rgba(91, 70, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia x soulangeana 'san jose'/magnolia x soulangeana 'san jose' .jpg",
          width: 576,
          id: '7c97650068a7076255abdebb76e7036c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 134, 122, 1.00)',
            'rgba(142, 114, 101, 1.00)',
            'rgba(166, 146, 132, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia x soulangeana 'san jose'/magnolia x soulangeana 'san jose' (3).jpg",
          width: 668,
          id: 'e1dfbe96b1ef0a26bfa72e520762b78a',
          height: 768,
          thumbnail: true,
        },
        location: [47.269653, -1.584945],
        genre: 'Magnolia',
        cultivar: 'San Jos\u00e9',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584945, 47.269653] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '10fa2fe8fa3042234b0dc156223420fc3eac564e',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 143, 93, 1.00)',
            'rgba(110, 150, 79, 1.00)',
            'rgba(110, 145, 81, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/lavatera [malvaceae]/lavatera x clementii 'rosea'/lavatera x clementii 'rosea' (3).jpg",
          width: 576,
          id: 'a9d1c42fad3897a01b84850b500f6499',
          height: 768,
          thumbnail: true,
        },
        espece: 'x clementii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 121, 94, 1.00)',
            'rgba(188, 124, 179, 1.00)',
            'rgba(108, 113, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/lavatera [malvaceae]/lavatera x clementii 'rosea'/lavatera x clementii 'rosea' (2).jpg",
          width: 576,
          id: '7feab3a3c74b7031868e3b58b5cae815',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 129, 85, 1.00)',
            'rgba(106, 135, 76, 1.00)',
            'rgba(142, 144, 101, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/lavatera [malvaceae]/lavatera x clementii 'rosea'/lavatera x clementii 'rosea' (1).jpg",
          width: 1024,
          id: '0c5225969fb7465e99a32d2c2b473625',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Lavatera',
        cultivar: 'Rosea',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5dafe7d88c8b20a0807e724636898af1df1be6a0',
      fields: {
        espece: 'henryana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 131, 128, 1.00)',
            'rgba(123, 126, 58, 1.00)',
            'rgba(109, 104, 29, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tilia [malvaceae]/tilia henryana/tilia henryana (3).jpg',
          width: 571,
          id: 'dc45d99afae7d5520300bac2b24c1fee',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(174, 180, 173, 1.00)',
            'rgba(123, 121, 77, 1.00)',
            'rgba(55, 60, 23, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tilia [malvaceae]/tilia henryana/tilia henryana (2).jpg',
          width: 1024,
          id: '85a0adeadee94431ca84fca12795a298',
          height: 683,
          thumbnail: true,
        },
        location: [47.271272, -1.580817],
        genre: 'Tilia',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580817, 47.271272] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3baca447097599d1b3bf8d85563da6a68528083d',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 146, 46, 1.00)',
            'rgba(130, 140, 66, 1.00)',
            'rgba(112, 115, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/tilia [malvaceae]/tilia platyphyllos 'laciniata'/tilia platyphyllos 'laciniata'(5).jpg",
          width: 631,
          id: '9b39695cad3fcde3f078ab9aa4d14dac',
          height: 768,
          thumbnail: true,
        },
        espece: 'platyphyllos',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 176, 86, 1.00)',
            'rgba(124, 140, 92, 1.00)',
            'rgba(138, 139, 98, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/tilia [malvaceae]/tilia platyphyllos 'laciniata'/tilia platyphyllos 'laciniata'(3).jpg",
          width: 576,
          id: '746e91fbc0f55dcf8bdb990e361b91b4',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(190, 200, 200, 1.00)',
            'rgba(100, 99, 63, 1.00)',
            'rgba(92, 90, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/tilia [malvaceae]/tilia platyphyllos 'laciniata'/tilia platyphyllos 'laciniata' (3).jpg",
          width: 630,
          id: '3af2bfb8a9f540ef6578b1d77b15d6ef',
          height: 768,
          thumbnail: true,
        },
        location: [47.27055, -1.582588],
        genre: 'Tilia',
        cultivar: 'Laciniata',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582588, 47.27055] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0d5cff30b307d26528a166689ffc8065f3bf6a75',
      fields: {
        espece: 'azedarach',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Melia',
        date_plantation: '1980',
        famille: 'Meliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a8b1b13e9389b1635d5095b054805b5f08695405',
      fields: {
        espece: 'azedarach',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Melia',
        date_plantation: '1986',
        cultivar: 'toosendan',
        famille: 'Meliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '121db7f75ddf1a9d62a84101bd759cbca46025b5',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'azedarach',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 112, 67, 1.00)',
            'rgba(129, 132, 115, 1.00)',
            'rgba(100, 114, 85, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/melia [meliaceae]/melia azedarach/melia azedarach (1).jpg',
          width: 576,
          id: '0ba55a5a782711ace2283a4afd1adfad',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 120, 88, 1.00)',
            'rgba(125, 145, 96, 1.00)',
            'rgba(141, 148, 136, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/melia [meliaceae]/melia azedarach/melia azedarach (2).jpg',
          width: 642,
          id: 'd246a02014e9da31d410625634307c63',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 169, 147, 1.00)',
            'rgba(117, 127, 96, 1.00)',
            'rgba(90, 95, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/melia [meliaceae]/melia azedarach/melia azedarach  (2).jpg',
          width: 927,
          id: 'c620c98b7ca259a14ff183af5464f14a',
          height: 768,
          thumbnail: true,
        },
        location: [47.26873, -1.584747],
        genre: 'Melia',
        famille: 'Meliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584747, 47.26873] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0a3d9bfc173e5daa18156242fef912a200a61873',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 136, 84, 1.00)',
            'rgba(119, 137, 88, 1.00)',
            'rgba(146, 153, 119, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/toona [meliaceae]/toona sinensis 'flamingo'/toona sinensis 'flamingo' .jpg",
          width: 576,
          id: '9ff7165353ac9b597c4bfc7ca0595ed8',
          height: 768,
          thumbnail: true,
        },
        espece: 'sinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(169, 164, 160, 1.00)',
            'rgba(122, 112, 94, 1.00)',
            'rgba(123, 104, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/toona [meliaceae]/toona sinensis 'flamingo'/toona sinensis 'flamingo' (2).jpg",
          width: 576,
          id: '08227a84096a15b9cdae35e533d149bb',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(177, 144, 146, 1.00)',
            'rgba(172, 114, 124, 1.00)',
            'rgba(166, 125, 114, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/toona [meliaceae]/toona sinensis 'flamingo'/toona sinensis 'flamingo' (1).jpg",
          width: 576,
          id: '01b72414f247c8373d5d95fa691ebe56',
          height: 768,
          thumbnail: true,
        },
        location: [47.271637, -1.581847],
        genre: 'Toona',
        cultivar: 'Flamingo',
        famille: 'Meliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581847, 47.271637] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '440c28c5fe54b240cbc72da9b3f4d48eec27c4e2',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'pomifera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 104, 54, 1.00)',
            'rgba(116, 120, 69, 1.00)',
            'rgba(137, 141, 91, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/maclura [moraceae]/maclura pomifera/maclura pomifera (4).jpg',
          width: 576,
          id: 'c404698575945c0a7f43fff235c04ee9',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 132, 57, 1.00)',
            'rgba(97, 137, 66, 1.00)',
            'rgba(87, 125, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/maclura [moraceae]/maclura pomifera/maclura pomifera (5).jpg',
          width: 576,
          id: 'a2e50edd5e9bba26751d6b7c1a8bf180',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 146, 38, 1.00)',
            'rgba(117, 144, 61, 1.00)',
            'rgba(65, 94, 29, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/maclura [moraceae]/maclura pomifera/maclura pomifera (1).jpg',
          width: 576,
          id: 'f439272b131755bfa1d1cc79b19d305e',
          height: 768,
          thumbnail: true,
        },
        location: [47.272405, -1.589342],
        genre: 'Maclura',
        famille: 'Moraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.589342, 47.272405] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a7ece2505a41b3ae8c3867b41b6ff6d856f7dc51',
      fields: {
        espece: 'excelsa',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 162, 144, 1.00)',
            'rgba(116, 111, 79, 1.00)',
            'rgba(97, 85, 73, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/milicia [moraceae]/milicia excelsa/milicia excelsa.jpg",
          width: 576,
          id: 'a22b9cf0f61bc3937d37166856a3f094',
          height: 768,
          thumbnail: true,
        },
        location: [47.227092, -1.512038],
        genre: 'Milicia',
        famille: 'Moraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512038, 47.227092] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1fb0cff5ebfde98de86204446c9e446216cedeed',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'apiculata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 128, 84, 1.00)',
            'rgba(154, 124, 87, 1.00)',
            'rgba(124, 96, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/luma [myrtaceae]/luma apiculata/luma apiculata (2).jpg',
          width: 576,
          id: '087d6eb673db60244ecfcaca51f27d7e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 79, 42, 1.00)',
            'rgba(143, 120, 76, 1.00)',
            'rgba(144, 114, 77, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/luma [myrtaceae]/luma apiculata/luma apiculata (3).jpg',
          width: 576,
          id: 'd22ab67d6f9a22dd9ad9f647975715d8',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 165, 124, 1.00)',
            'rgba(97, 111, 50, 1.00)',
            'rgba(125, 124, 71, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/luma [myrtaceae]/luma apiculata/luma apiculata (1).jpg',
          width: 673,
          id: '3fb6f78149cb1b60832ae52898a7b4a2',
          height: 768,
          thumbnail: true,
        },
        location: [47.269625, -1.582422],
        genre: 'Luma',
        famille: 'Myrtaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582422, 47.269625] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cdb1562c948ad2c18c1a6347322ad89eaf629df7',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'retusus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 96, 65, 1.00)',
            'rgba(132, 142, 104, 1.00)',
            'rgba(110, 113, 74, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chionanthus [oleaceae]/chionanthus retusus/chionanthus retusus (5).jpg',
          width: 576,
          id: 'be84d238fbdfaaeabaec0a7c8bdd2f66',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 135, 92, 1.00)',
            'rgba(147, 158, 90, 1.00)',
            'rgba(136, 143, 82, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chionanthus [oleaceae]/chionanthus retusus/chionanthus retusus (6).jpg',
          width: 576,
          id: '6d1779333ff05b0bb29255c4606d4411',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 138, 98, 1.00)',
            'rgba(127, 127, 85, 1.00)',
            'rgba(96, 111, 74, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chionanthus [oleaceae]/chionanthus retusus/chionanthus retusus (10).jpg',
          width: 576,
          id: '13dc602fb7b18cece448a81ad6482cc4',
          height: 768,
          thumbnail: true,
        },
        location: [47.271345, -1.582437],
        genre: 'Chionanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582437, 47.271345] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a30035cb7c8a35ad1d2531084401e1d5eeec1327',
      fields: {
        espece: "Mar\u00e9e d'Or (Courtasol)",
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 126, 18, 1.00)',
            'rgba(152, 128, 20, 1.00)',
            'rgba(138, 115, 20, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/forsythia [oleaceae]/forsythia maree d'or ('courtasol')/forsythia maree d'or ('courtasol') (2).jpg",
          width: 576,
          id: 'b8de2e4a3c2e1336d0206747761d201e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 106, 76, 1.00)',
            'rgba(145, 126, 40, 1.00)',
            'rgba(95, 80, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/forsythia [oleaceae]/forsythia maree d'or ('courtasol')/forsythia maree d'or ('courtasol') (1).jpg",
          width: 1024,
          id: 'fc8a74b4efe73f3f3d37b8b60e6fdc05',
          height: 768,
          thumbnail: true,
        },
        location: [47.270445, -1.582303],
        genre: 'Forsythia',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582303, 47.270445] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9592ba5804f8c998b286d5757c94362e7ccf4e6c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'quadrangulata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 105, 80, 1.00)',
            'rgba(114, 115, 78, 1.00)',
            'rgba(85, 82, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus quadrangulata/fraxinus quadrangulata (2).jpg',
          width: 576,
          id: '571961ee6997627003de59e8b7c86a47',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 132, 91, 1.00)',
            'rgba(142, 149, 87, 1.00)',
            'rgba(119, 112, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus quadrangulata/fraxinus quadrangulata (3).jpg',
          width: 576,
          id: '093d736be283cc0e3ccd9dfeb6390022',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 99, 165, 1.00)',
            'rgba(100, 106, 96, 1.00)',
            'rgba(81, 84, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus quadrangulata/fraxinus quadrangulata  (2).jpg',
          width: 512,
          id: '71fc7b47859a387210a5d10e28f26e5c',
          height: 768,
          thumbnail: true,
        },
        location: [47.271297, -1.585488],
        genre: 'Fraxinus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585488, 47.271297] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '76956203b7b4788503441747cd151367edc258c7',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 166, 149, 1.00)',
            'rgba(111, 118, 62, 1.00)',
            'rgba(106, 113, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum vulgare 'chlorocarpum'/ligustrum vulgare 'chlorocarpum' (3).jpg",
          width: 576,
          id: '6fee17ef0c4d97548831c91af99224c8',
          height: 768,
          thumbnail: true,
        },
        espece: 'vulgare',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 157, 157, 1.00)',
            'rgba(124, 132, 92, 1.00)',
            'rgba(97, 104, 29, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum vulgare 'chlorocarpum'/ligustrum vulgare 'chlorocarpum' (2).jpg",
          width: 576,
          id: '55708ef2b2fa5e3ca5fed478a71239fa',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 120, 40, 1.00)',
            'rgba(118, 135, 65, 1.00)',
            'rgba(112, 132, 52, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum vulgare 'chlorocarpum'/ligustrum vulgare 'chlorocarpum' (1).jpg",
          width: 576,
          id: '62971f3e4c25bcdf92ae4a6beb981392',
          height: 768,
          thumbnail: true,
        },
        location: [47.27193, -1.58645],
        genre: 'Ligustrum',
        cultivar: 'Chlorocarpum',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58645, 47.27193] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e8606abdcc99d43984bd8e725c940666418b3573',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'delavayi',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 85, 76, 1.00)',
            'rgba(93, 113, 102, 1.00)',
            'rgba(147, 150, 134, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus delavayi/osmanthus delavayi (2).jpg',
          width: 546,
          id: '6de170985057d8031808b9a982ae9830',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 106, 103, 1.00)',
            'rgba(102, 106, 100, 1.00)',
            'rgba(66, 70, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus delavayi/osmanthus delavayi (3).jpg',
          width: 576,
          id: '09ae3bea946b3a7cd72461f09a1da9ab',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(168, 169, 150, 1.00)',
            'rgba(89, 99, 77, 1.00)',
            'rgba(104, 98, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus delavayi/osmanthus delavayi  (2).jpg',
          width: 650,
          id: '588a10958bb3c6e7cfa72028c331101e',
          height: 768,
          thumbnail: true,
        },
        location: [47.269967, -1.581195],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581195, 47.269967] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '75cc0083652a2953b87a4c070e3dcfc6c1a47396',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 127, 81, 1.00)',
            'rgba(115, 121, 69, 1.00)',
            'rgba(104, 105, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus heterophyllus 'variegatus'/osmanthus heterophyllus 'variegatus'.jpg",
          width: 576,
          id: '7b5da9bf11927952e093e0dd81cc5748',
          height: 768,
          thumbnail: true,
        },
        espece: 'heterophyllus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 141, 107, 1.00)',
            'rgba(133, 145, 117, 1.00)',
            'rgba(139, 138, 124, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus heterophyllus 'variegatus'/osmanthus heterophyllus 'variegatus' (2).jpg",
          width: 576,
          id: 'df9e6d653ec4916eeabf696327f1f2bd',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 135, 81, 1.00)',
            'rgba(101, 128, 66, 1.00)',
            'rgba(108, 131, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus heterophyllus 'variegatus'/osmanthus heterophyllus 'variegatus' (1).jpg",
          width: 576,
          id: 'f5f7fcdb61e0dded9d4adc9a7d30c321',
          height: 768,
          thumbnail: true,
        },
        location: [47.271272, -1.580553],
        genre: 'Osmanthus',
        cultivar: 'Variegatus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580553, 47.271272] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd8cba72ed0eb9f29ef50cf892c4b21bb9230748b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'heterophyllus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 83, 31, 1.00)',
            'rgba(97, 126, 63, 1.00)',
            'rgba(152, 163, 114, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus heterophyllus/osmanthus heterophyllus (2).jpg',
          width: 576,
          id: '5ea4c7e4ab15f77dcc358d5614a786f3',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 115, 109, 1.00)',
            'rgba(119, 120, 108, 1.00)',
            'rgba(76, 84, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus heterophyllus/osmanthus heterophyllus.jpg',
          width: 576,
          id: 'fbc1fbedb49e96199fe276dfa23d6971',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 148, 98, 1.00)',
            'rgba(92, 130, 83, 1.00)',
            'rgba(121, 141, 96, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus heterophyllus/osmanthus heterophyllus (1).jpg',
          width: 576,
          id: '7082ce3320e275f7458d90d81c73fe33',
          height: 768,
          thumbnail: true,
        },
        location: [47.271197, -1.582947],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582947, 47.271197] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0303515632c1c1cd8e79a5fb50119fcc9cec4c61',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'yunnanensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 151, 72, 1.00)',
            'rgba(119, 125, 55, 1.00)',
            'rgba(102, 92, 47, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus yunnanensis/osmanthus yunnanensis (2).jpg',
          width: 739,
          id: '1dbee0a7369d57fc8e4921939827b4bd',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 110, 50, 1.00)',
            'rgba(104, 125, 68, 1.00)',
            'rgba(100, 116, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus yunnanensis/osmanthus yunnanensis (3).jpg',
          width: 576,
          id: '9b513062ba2bb9ea11914afbe736249f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(169, 200, 216, 1.00)',
            'rgba(99, 108, 70, 1.00)',
            'rgba(87, 88, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus yunnanensis/osmanthus yunnanensis (1).jpg',
          width: 576,
          id: '441972e95dcbe142dffa484688ee3031',
          height: 768,
          thumbnail: true,
        },
        location: [47.27123, -1.581862],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581862, 47.27123] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fe4bb530adad11dc2a332d33f8cdbf156870f17c',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 90, 45, 1.00)',
            'rgba(121, 158, 61, 1.00)',
            'rgba(121, 141, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fuchsia [onagraceae]/fuchsia magellanica 'alba'/fuchsia magellanica 'alba'.jpg",
          width: 576,
          id: '68925eb8e4ba3eac1cb0681c251d0516',
          height: 768,
          thumbnail: true,
        },
        espece: 'magellanica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(69, 109, 50, 1.00)',
            'rgba(88, 126, 80, 1.00)',
            'rgba(42, 66, 42, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fuchsia [onagraceae]/fuchsia magellanica 'alba'/fuchsia magellanica 'alba' (2).jpg",
          width: 576,
          id: '05d99a319bd78656fa8e0cabe5f2f516',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 95, 66, 1.00)',
            'rgba(100, 121, 74, 1.00)',
            'rgba(70, 92, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fuchsia [onagraceae]/fuchsia magellanica 'alba'/fuchsia magellanica 'alba' (1).jpg",
          width: 576,
          id: '8a50b01eb0cc3a970df7118bea189c76',
          height: 768,
          thumbnail: true,
        },
        location: [47.271445, -1.58205],
        genre: 'Fuchsia',
        cultivar: 'Alba',
        famille: 'Onagraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58205, 47.271445] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7b342c205aaec738853e53e39f4e0c6a21445535',
      fields: {
        espece: 'regia subsp. reitzii',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 167, 123, 1.00)',
            'rgba(129, 138, 113, 1.00)',
            'rgba(110, 129, 95, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/fuchsia [onagraceae]/fuchsia regia subsp. reitzii/fuchsia regia subsp. reitzi.jpg",
          width: 576,
          id: '1ca93b9b605aa27959c103b0cc61a6d8',
          height: 768,
          thumbnail: true,
        },
        location: [47.2268, -1.512317],
        genre: 'Fuchsia',
        famille: 'Onagraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512317, 47.2268] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ca1d12f8fb94c0107799c3028dcbf5101cb1c567',
      fields: {
        origine: 'Les Ponts de C\u00e9_p\u00e9pini\u00e8re Lepage',
        espece: 'microcarpa Fedde',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Macleaya',
        date_plantation: '2016',
        famille: 'Papaveraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3851a93ae1808013c2e475c7e2a7153f90af2101',
      fields: {
        origine: 'Zoological and B.G. of the Plzen (Rep. Tch\u00e8que)',
        espece: 'popovii Sipliv.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Papaver',
        date_plantation: '2014',
        famille: 'Papaveraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e46b2e4c765734900b13effb877335f2c94a7169',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'kentukea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 146, 58, 1.00)',
            'rgba(119, 148, 54, 1.00)',
            'rgba(116, 124, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cladrastis [papilionaceae]/cladrastis kentukea/cladrastis kentukea (1).jpg',
          width: 576,
          id: '0c4fc61cd7ed08104202ed483bfbcb40',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 129, 66, 1.00)',
            'rgba(123, 152, 92, 1.00)',
            'rgba(96, 118, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cladrastis [papilionaceae]/cladrastis kentukea/cladrastis kentukea (2).jpg',
          width: 576,
          id: '0e84b52f073ae46dae539168e6aa9b40',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(54, 79, 26, 1.00)',
            'rgba(106, 136, 72, 1.00)',
            'rgba(104, 148, 187, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cladrastis [papilionaceae]/cladrastis kentukea/cladrastis kentukea (.jpg',
          width: 512,
          id: '589273b986874877b81a5bf453245b91',
          height: 768,
          thumbnail: true,
        },
        location: [47.271087, -1.58278],
        genre: 'Cladrastis',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58278, 47.271087] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd34de1924942607df62d4774abc6dfa143a4ebd5',
      fields: {
        espece: 'kentukea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 100, 103, 1.00)',
            'rgba(133, 100, 61, 1.00)',
            'rgba(143, 96, 32, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cladrastis [papilionaceae]/cladrastis kentukea/cladrastis kentukea (14).jpg',
          width: 512,
          id: '857dca635a957290ecea95ea84d003a4',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 142, 148, 1.00)',
            'rgba(165, 119, 32, 1.00)',
            'rgba(61, 52, 19, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cladrastis [papilionaceae]/cladrastis kentukea/cladrastis kentukea (10).jpg',
          width: 1024,
          id: '25a8d14bb3c0db73a89e238493d05239',
          height: 683,
          thumbnail: true,
        },
        location: [47.270847, -1.582747],
        genre: 'Cladrastis',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582747, 47.270847] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1e039a5a8f25a678353e2dd9bfd6f481c81897c8',
      fields: {
        espece: 'kentukea',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(192, 204, 178, 1.00)',
            'rgba(94, 122, 64, 1.00)',
            'rgba(43, 63, 25, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cladrastis [papilionaceae]/cladrastis kentukea/cladrastis kentukea.jpg',
          width: 1024,
          id: 'faf7f4900d291465222bc6b92a4dfd9a',
          height: 768,
          thumbnail: true,
        },
        location: [47.270845, -1.58275],
        genre: 'Cladrastis',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58275, 47.270845] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '130acdcb4568ea33c172c85a6590b9aaebcbe347',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'dosua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 132, 104, 1.00)',
            'rgba(138, 138, 116, 1.00)',
            'rgba(108, 122, 83, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/indigofera [papilionaceae]/indigofera dosua/indigofera dosua (2).jpg',
          width: 576,
          id: '26ec86efadcdadc39ad637fc883b5ab2',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 143, 113, 1.00)',
            'rgba(108, 134, 78, 1.00)',
            'rgba(108, 136, 87, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/indigofera [papilionaceae]/indigofera dosua/indigofera dosua (3).jpg',
          width: 576,
          id: '75cdad0eb47a938e0e7d996b40ec759d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 140, 115, 1.00)',
            'rgba(120, 132, 99, 1.00)',
            'rgba(120, 137, 93, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/indigofera [papilionaceae]/indigofera dosua/indigofera dosua (1).jpg',
          width: 1024,
          id: '77524ac3797ec77a05dcda2d5484d69b',
          height: 768,
          thumbnail: true,
        },
        location: [47.2717, -1.587203],
        genre: 'Indigofera',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587203, 47.2717] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6c6e1392117898828ec8d86c7eab2c5c44becc12',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 153, 88, 1.00)',
            'rgba(143, 144, 83, 1.00)',
            'rgba(124, 131, 71, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/sophora [papilionaceae]/sophora 'little baby'/sophora 'little baby' (2).jpg",
          width: 576,
          id: '3fcc784c84261d29b948153792bbddd5',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 134, 58, 1.00)',
            'rgba(135, 128, 39, 1.00)',
            'rgba(115, 118, 35, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/sophora [papilionaceae]/sophora 'little baby'/sophora 'little baby' (3).jpg",
          width: 576,
          id: 'd3782da7452029d8cd3d3d29ca209b43',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 144, 84, 1.00)',
            'rgba(145, 139, 86, 1.00)',
            'rgba(125, 135, 77, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/sophora [papilionaceae]/sophora 'little baby'/sophora 'little baby' (1).jpg",
          width: 576,
          id: 'b820480ce02cc40cf34506d05c5d857a',
          height: 768,
          thumbnail: true,
        },
        location: [47.27118, -1.585038],
        genre: 'Sophora',
        cultivar: 'Little Baby',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585038, 47.27118] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c010296f538631cb832410e050067b3f98892916',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'Sun King (Hilsop)',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(54, 63, 43, 1.00)',
            'rgba(98, 98, 39, 1.00)',
            'rgba(66, 67, 30, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/sophora [papilionaceae]/sophora sun king ('hilsop')/sophora sun king ('hilsop') (2).jpg",
          width: 1024,
          id: '3d2da4d342f7034ef266bec52ea6081b',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 128, 125, 1.00)',
            'rgba(95, 98, 75, 1.00)',
            'rgba(103, 98, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/sophora [papilionaceae]/sophora sun king ('hilsop')/sophora sun king ('hilsop') (7).jpg",
          width: 1024,
          id: 'c4884926f5bba3bbcf7a662938ed3acc',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 132, 155, 1.00)',
            'rgba(88, 97, 74, 1.00)',
            'rgba(81, 83, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/sophora [papilionaceae]/sophora sun king ('hilsop')/sophora sun king ('hilsop') (1).jpg",
          width: 999,
          id: '307fdc8173fc04667db16dc6a79b0cb9',
          height: 768,
          thumbnail: true,
        },
        location: [47.27133, -1.58205],
        genre: 'Sophora',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58205, 47.27133] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '14183a016ade5d9195e233490fbfc0a97eea32af',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'Sun King (Hilsop)',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 129, 114, 1.00)',
            'rgba(128, 124, 61, 1.00)',
            'rgba(119, 111, 81, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/sophora [papilionaceae]/sophora sun king ('hilsop')/sophora sun king ('hilsop') (5).jpg",
          width: 623,
          id: '8ab0030a9b1dc3638c63010954f228ea',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(228, 228, 223, 1.00)',
            'rgba(123, 125, 91, 1.00)',
            'rgba(95, 97, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/sophora [papilionaceae]/sophora sun king ('hilsop')/sophora sun king ('hilsop') (6).jpg",
          width: 1024,
          id: '45ba032de1f2df7d6273c58f7db4a41d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 116, 35, 1.00)',
            'rgba(138, 136, 34, 1.00)',
            'rgba(91, 101, 34, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/sophora [papilionaceae]/sophora sun king ('hilsop')/sophora sun king ('hilsop') (3).jpg",
          width: 1024,
          id: '3a35d38bf2470393f0a01e396898f531',
          height: 768,
          thumbnail: true,
        },
        location: [47.271703, -1.587058],
        genre: 'Sophora',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587058, 47.271703] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '45d44a7e63001b80c7356fa56bc9fe287c0d1587',
      fields: {
        espece: 'antioquiensis',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 78, 68, 1.00)',
            'rgba(150, 149, 125, 1.00)',
            'rgba(65, 64, 50, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/passiflora [passifloraceae]/passiflora antioquiensis/passiflora antioquiensis.jpg",
          width: 576,
          id: 'a4887d069d84cde13d0b4f5e5b00a963',
          height: 768,
          thumbnail: true,
        },
        location: [47.22678, -1.512637],
        genre: 'Passiflora',
        famille: 'Passifloraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512637, 47.22678] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b82b6be658ca9a9b657795056b63eb294ea9f479',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Grand Blottereau',
        espece: 'libani',
        localisation: 'B1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2204652, -1.544656],
        genre: 'Cedrus',
        date_plantation: '2015',
        famille: 'Pinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544656, 47.2204652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd9681e6771ba5dad42371fbe9e4c109b1408a6c3',
      fields: {
        origine: 'P. F\u00e9rard, nature - Pyr\u00e9n\u00e9es',
        espece: 'fruticans Jacq.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Veronica',
        date_plantation: '2014',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd4f54da37b27751d4ba325198cbe6456d20a7919',
      fields: {
        origine: 'J.Alp.Paradisia Cogne (Italie)',
        espece: 'spicata L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Veronica',
        date_plantation: '1999',
        cultivar: 'orchidea Hayek & Hegi',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e9452197a3d6c09c34f52753105faad1b384ccc1',
      fields: {
        origine: 'J.B Munchen (Allemagne)',
        espece: 'baldaccii Degen',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Wulfenia',
        date_plantation: '2011',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '35933a85c40b521a40863849b81faa085e98bd44',
      fields: {
        origine: 'JB. Alpin Joseph Fourier Lautaret (France)',
        espece: 'bisnagarica L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Globularia',
        date_plantation: '2011',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2346fd9962f075f0d8046e0f3f02a055403bfaaf',
      fields: {
        origine: 'JB.Yeomjii (Cor\u00e9e)',
        espece: 'kiusianum  T. Yamazaki',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Pseudolysimachion',
        date_plantation: '2008',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4a20387374c68b370f6144ca7ac007c7f7487c0a',
      fields: {
        origine: 'JBU.Besan\u00e7on (France)',
        espece: 'punctata Lapeyr.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Globularia',
        date_plantation: '2001',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '70ee9d1320280375e447754b03d2246b3d8ae50e',
      fields: {
        origine: 'JBU.Lansing (U.S.A.)',
        espece: 'digitalis Nutt.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Penstemon',
        date_plantation: '2004',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '132497a13434e1a8096197f099873c71c2860f80',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'orientalis var. insularis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 112, 145, 1.00)',
            'rgba(86, 101, 109, 1.00)',
            'rgba(89, 108, 128, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/platanus [platanaceae]/platanus orientalis var. insularis/platanus orientalis var. insularis (14).jpg',
          width: 509,
          id: '5ca14c443bb2d7f33770558b70638b64',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 88, 61, 1.00)',
            'rgba(133, 121, 94, 1.00)',
            'rgba(112, 100, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/platanus [platanaceae]/platanus orientalis var. insularis/platanus orientalis var. insularis (16).jpg',
          width: 1024,
          id: 'e430baae2d212a081d6725b078cbdb25',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 85, 41, 1.00)',
            'rgba(105, 118, 96, 1.00)',
            'rgba(96, 127, 165, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/platanus [platanaceae]/platanus orientalis var. insularis/platanus orientalis var. insularis (13).jpg',
          width: 1024,
          id: '581c0893de4cd094a06df8af0ca53133',
          height: 683,
          thumbnail: true,
        },
        location: [47.270617, -1.582094],
        genre: 'Platanus',
        famille: 'Platanaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582094, 47.270617] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ef79b47d34779e95ce781a996d355cace10df622',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 99, 41, 1.00)',
            'rgba(110, 125, 70, 1.00)',
            'rgba(97, 120, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/platanus [platanaceae]/platanus x hispanica 'suttneri'/platanus x hispanica 'suttneri' (3).jpg",
          width: 576,
          id: 'eca437d8c86b442c502a2a0568bc3df7',
          height: 768,
          thumbnail: true,
        },
        espece: 'x hispanica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 135, 71, 1.00)',
            'rgba(122, 146, 86, 1.00)',
            'rgba(110, 125, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/platanus [platanaceae]/platanus x hispanica 'suttneri'/platanus x hispanica 'suttneri' (2).jpg",
          width: 1024,
          id: '3af210a31b4f0aaa682e333abc6bc334',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 140, 137, 1.00)',
            'rgba(146, 145, 142, 1.00)',
            'rgba(112, 116, 103, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/platanus [platanaceae]/platanus x hispanica 'suttneri'/platanus x hispanica 'suttneri' (1).jpg",
          width: 576,
          id: '141aad409f8a53118d44848d06dc54d1',
          height: 768,
          thumbnail: true,
        },
        location: [47.270845, -1.582142],
        genre: 'Platanus',
        cultivar: 'Suttneri',
        famille: 'Platanaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582142, 47.270845] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5037b3540c20adaa5fd3cf68e1ce6be15b14ac92',
      fields: {
        origine: 'Chelsea physic Garden Londre (Angl.)',
        espece: 'cosyrense Kuntze',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Limonium',
        date_plantation: '2015',
        famille: 'Plumbaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9cab4d42d6c4b18cc69015bd3817457f0ab433fb',
      fields: {
        origine: 'JB.Chemnitz (Allemagne)',
        espece: 'maritima Willd.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Armeria',
        date_plantation: '2004',
        famille: 'Plumbaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '118f6a2fb098bf487143ab89aae9f0ffa97a6cc7',
      fields: {
        origine: 'Universitatea de Stiinte Agricole, Cluj - Napoca, Roumanie',
        espece: 'welwitschii Boiss.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Armeria',
        date_plantation: '2013',
        famille: 'Plumbaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '75dadff1d1138629061d75b97da8fa9b7d791f08',
      fields: {
        origine: 'INRA',
        espece: 'vasconcensis Auquier & kergu\u00e9len',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Festuca',
        date_plantation: '1989',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '47a12beb9164f6da8ba8a98699bb05a0196e1acf',
      fields: {
        origine: 'JBU.Li\u00e8ge (Belgique)',
        espece: 'filiformis C.Sm.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Festuca',
        date_plantation: '1989',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '73e6bda6151d28a4175eaaaf1abc0b25184d1e82',
      fields: {
        origine: 'R\u00e9colte nature (WLG-PF)',
        espece: 'cespitosa P. Beauv.',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Deschampsia',
        date_plantation: '2016',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f23f76ad5cbd6e4b4a4f92cc3e1b691de7ad8697',
      fields: {
        origine: 'Goteborg Botanical Garden(Su\u00e8de)',
        espece: 'chinense Brand',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Polemonium',
        date_plantation: '2014',
        famille: 'Polemoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5f6d8b0f486420fe73c3bae44e9e7eba5ebb0d6f',
      fields: {
        origine: 'JB.Framingham (USA)',
        espece: 'reptans L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Polemonium',
        date_plantation: '1988',
        famille: 'Polemoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a5959970e56baec2e3859333d2a97f6287ce3402',
      fields: {
        origine: 'J.B. de Lausanne,Suisse',
        espece: 'rhaponticum L.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Rheum',
        date_plantation: '2014',
        famille: 'Polygonaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '051aa29bf2f474a87424537f63e24a7d965977ca',
      fields: {
        origine: 'JB. Carl Skottsbergs, Goteb\u00f6rg (Su\u00e8de)',
        espece: 'sikokiana Miq.',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Lysimachia',
        date_plantation: '2011',
        famille: 'Primulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bf022d5fe39897ef3195e79dd52e111f9766a325',
      fields: {
        origine: 'JB. T\u00fcbingen (Allemagne)',
        espece: 'alpina L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Soldanella',
        date_plantation: '2011',
        famille: 'Primulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6472c843be6c24b01f569e74ee5886a826f55427',
      fields: {
        espece: 'hederaefolium Ait.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Cyclamen',
        date_plantation: '1973',
        famille: 'Primulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f5dd9a7f09692b76973ea2783aa98df6188b0e5c',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'saponaria',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 166, 116, 1.00)',
            'rgba(119, 125, 96, 1.00)',
            'rgba(105, 119, 76, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/quillaja [quillajaceae]/quillaja saponaria/quillaja saponaria  (2).jpg",
          width: 576,
          id: 'e4ada40d4bec977dc91e9fb6d640895f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 122, 65, 1.00)',
            'rgba(86, 119, 52, 1.00)',
            'rgba(81, 111, 52, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/quillaja [quillajaceae]/quillaja saponaria/quillaja saponaria  (3).jpg",
          width: 1024,
          id: '64fa6c50e050be9b70ccbdbc3b197758',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 113, 51, 1.00)',
            'rgba(91, 124, 57, 1.00)',
            'rgba(75, 108, 49, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/quillaja [quillajaceae]/quillaja saponaria/quillaja saponaria  (1).jpg",
          width: 1024,
          id: '787ef2309223aea7fb5d1abb413f0cd1',
          height: 683,
          thumbnail: true,
        },
        location: [47.226867, -1.512817],
        genre: 'Quillaja',
        famille: 'Quillajaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512817, 47.226867] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '31fc6af5426b04a6ea2290ad655aa74d86e3be32',
      fields: {
        origine: 'Arboha Bergen (localit\u00e9 situ\u00e9es en Georgie)',
        espece: 'buschianum Kemul.-Nath.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Thalictrum',
        date_plantation: '1993',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '16fc499daa616b6de443d67a7164be1dac9f8162',
      fields: {
        origine: 'Conservatoire botanique de Gen\u00e8ve (Suisse)',
        espece: 'gramineus L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Ranunculus',
        date_plantation: '2011',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8c5fbeb6cf6a80b5dc6a214280691e057cdc308b',
      fields: {
        origine: 'J.B. Kaunas (Lituanie)',
        espece: 'ledebourii Rchb.',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Trollius',
        date_plantation: '2011',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '360cc881949b41eb5833cfd836187acb01a9b8ac',
      fields: {
        origine: 'J.B. Montr\u00e9al,Canada',
        espece: 'canadensis L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Anemone',
        date_plantation: '2014',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6724c761af7d4783214a49878d2e32314d23b7a5',
      fields: {
        origine: 'JB Universit\u00e9 Tartu (Estonie)',
        espece: 'macropetalus F.Schmidt',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Trollius',
        date_plantation: '2011',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '14f2a6c67606fab41a680e027894e79ced8c61f8',
      fields: {
        origine: 'JB. Carl Skottsbergs, Goteb\u00f6rg (Su\u00e8de)',
        espece: 'caucasicum C.A.Mey.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Delphinium',
        date_plantation: '2011',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1c0159a7de922dfe2f99ed2463c226a996a0394e',
      fields: {
        origine: 'JB.Leipzig (Allemagne)',
        espece: 'nevadensis Boiss.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Aquilegia',
        date_plantation: '2009',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bb3800b8b96f1b2ea4c393c578539fd0f8f8727b',
      fields: {
        origine: 'JB.Montr\u00e9al (Canada)',
        espece: 'cylindrica A.Gray',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Anemone',
        date_plantation: '2009',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd80d716ec82eb4250387237febde73246b6e3ec2',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'multifida Poir.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Anemone',
        date_plantation: '2006',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7103bb18df08e71c1ef396ce896c23d85d6abe16',
      fields: {
        origine: 'JB.Amsterdam (Hollande)',
        espece: 'atrovinosa Popov.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Aquilegia',
        date_plantation: '1984',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0faf2f985170dca71aff7dd5e912e8d7a0858aff',
      fields: {
        origine: 'Tubingen (Allemagne)',
        espece: 'paradoxa',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Colletia',
        date_plantation: '2015',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b57f873ab800946f3389ad22f6d6eae20386ef3a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'arboreus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 173, 125, 1.00)',
            'rgba(111, 137, 78, 1.00)',
            'rgba(110, 127, 87, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus arboreus/ceanothus arboreus  (2).jpg',
          width: 512,
          id: '0d3365978e5fac48fc1446132a03867e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 160, 156, 1.00)',
            'rgba(127, 127, 117, 1.00)',
            'rgba(101, 91, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus arboreus/ceanothus arboreus  (3).jpg',
          width: 1024,
          id: 'c8e7c2f0c9f46c4ca2563d458930dfbb',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 127, 76, 1.00)',
            'rgba(107, 124, 95, 1.00)',
            'rgba(87, 107, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus arboreus/ceanothus arboreus  (1).jpg',
          width: 1024,
          id: '11af709ad46a7529c7355de8aa293fd5',
          height: 683,
          thumbnail: true,
        },
        location: [47.271537, -1.585225],
        genre: 'Ceanothus',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585225, 47.271537] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0a57ac798cac1061a9bb373422eb625b9ecae311',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 158, 91, 1.00)',
            'rgba(155, 139, 84, 1.00)',
            'rgba(135, 138, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus x pallidus 'marie simon'/ceanothus x pallidus 'marie simon' (2).jpg",
          width: 576,
          id: '1008564a28dc437236504fe73a98bf19',
          height: 768,
          thumbnail: true,
        },
        espece: 'x pallidus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 137, 94, 1.00)',
            'rgba(138, 145, 82, 1.00)',
            'rgba(130, 128, 84, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus x pallidus 'marie simon'/ceanothus x pallidus 'marie simon' (1).jpg",
          width: 1024,
          id: '6fec6ef152f4303c40b8a34e54d28885',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 112, 75, 1.00)',
            'rgba(139, 127, 109, 1.00)',
            'rgba(70, 87, 34, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus x pallidus 'marie simon'/ceanothus x pallidus 'marie simon'  (2).jpg",
          width: 576,
          id: '9430fde8641182d98a2fe382f9c0cb34',
          height: 768,
          thumbnail: true,
        },
        location: [47.271972, -1.58253],
        genre: 'Ceanothus',
        cultivar: 'Marie Simon',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58253, 47.271972] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '77ca1abe79e48d45b46caaff0c0ac78cf8cd6042',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 129, 82, 1.00)',
            'rgba(112, 136, 83, 1.00)',
            'rgba(96, 117, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/frangula [rhamnaceae]/frangula alnus 'aspleniifolia'/frangula alnus 'aspleniifolia' .jpg",
          width: 1024,
          id: '1d6fa056977ce1f41f5cdf3048560b74',
          height: 683,
          thumbnail: true,
        },
        espece: 'alnus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 135, 74, 1.00)',
            'rgba(111, 139, 76, 1.00)',
            'rgba(133, 159, 92, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/frangula [rhamnaceae]/frangula alnus 'aspleniifolia'/frangula alnus 'aspleniifolia' (2).jpg",
          width: 576,
          id: 'a27f223b7c27c55844376482d216d6dd',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 176, 124, 1.00)',
            'rgba(113, 132, 81, 1.00)',
            'rgba(103, 127, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/frangula [rhamnaceae]/frangula alnus 'aspleniifolia'/frangula alnus 'aspleniifolia' (1).jpg",
          width: 1024,
          id: '757bf06a29e8e612d643e89ffb40486d',
          height: 768,
          thumbnail: true,
        },
        location: [47.271745, -1.587167],
        genre: 'Frangula',
        cultivar: 'Aspleniifolia',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587167, 47.271745] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '78a12ff657a7a385e43a5a0e4e2a0ddc1b72824c',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'dulcis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(200, 207, 186, 1.00)',
            'rgba(91, 106, 67, 1.00)',
            'rgba(47, 57, 29, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/hovenia [rhamnaceae]/hovenia dulcis/hovenia dulcis (3).jpg",
          width: 512,
          id: '8fa9f3640b601a05b36e05dc5cd8727b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 92, 56, 1.00)',
            'rgba(123, 135, 84, 1.00)',
            'rgba(85, 110, 54, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/hovenia [rhamnaceae]/hovenia dulcis/hovenia dulcis (4).jpg",
          width: 1024,
          id: '879ae5bb70e941b66fab2dd75353df8f',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(46, 60, 31, 1.00)',
            'rgba(111, 122, 76, 1.00)',
            'rgba(108, 118, 71, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/hovenia [rhamnaceae]/hovenia dulcis/hovenia dulcis (1).jpg",
          width: 1024,
          id: '5505e54b9e0fdb7f8ec17d11e8ac6d71',
          height: 683,
          thumbnail: true,
        },
        location: [47.227012, -1.51257],
        genre: 'Hovenia',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.51257, 47.227012] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cdf1d526d845c0bfbe39a5fcd155d58859078fe8',
      fields: {
        espece: 'davurica',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Rhamnus',
        date_plantation: '1996',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cdd516d3ecaa1279e745411905b80a0d80684078',
      fields: {
        origine: 'Arboretum National Univers.de Seoul,Cor\u00e9e du Sud',
        espece: 'formosa Nakai',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Filipendula',
        date_plantation: '2014',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8604bafb7e503bb2fc1a14584466d15165a057ae',
      fields: {
        origine: 'Botanic Garden of Siauliai University, Siauliai, Lithuanie',
        espece: 'sanguisorbae L.f.',
        localisation: 'I2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185657, -1.5426599],
        genre: 'Acaena',
        date_plantation: '2012',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426599, 47.2185657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '549c37bd88acb233e4aa99259db356e50481f3cc',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'longigemmis',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '128b0187b7f428d312a51076bf59f9304dfd3e19',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'prunifolia',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a4397a4906152a412659b6bce7bc4d6ecdaa8b56',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'sp',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '745640cf7add7cdecd199cb7b5c741f7821a634b',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'trilobata',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '654523a002718b39e4ed419aa817c96337ba7823',
      fields: {
        origine: 'J.Alp.U.Lautaret (Grenoble)',
        espece: 'glaucescens Wallr.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Alchemilla',
        date_plantation: '2004',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '17a9f640db4b695ee33617aec4096a735357bca0',
      fields: {
        origine: 'J.B. Klagenfurt (Autriche)',
        espece: 'japonicum Thunb.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Geum',
        date_plantation: '2011',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1d4d7c3a998ff1513523ad50538a1f598da84990',
      fields: {
        origine: 'JB.Alberta (Allemagne)',
        espece: 'virginiana Mill.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Fragaria',
        date_plantation: '2008',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3bf5f62f6a4ec893236bbcb4d9fff8a248974bce',
      fields: {
        origine: 'JB.Lyon (France)',
        espece: 'hirta L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Potentilla',
        date_plantation: '2008',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'eb52cc0e301bfc1aa682ee174cefa8543db92d71',
      fields: {
        origine: 'P\u00e9pini\u00e8re Municipale du Grand Blottereau',
        espece: 'longigemmis',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '1996',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4b14ff308556e99108366699519c1b27c886cd29',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 112, 41, 1.00)',
            'rgba(181, 116, 70, 1.00)',
            'rgba(139, 89, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/chaenomeles [rosaceae]/chaenomeles x superba 'cameo'/chaenomeles x superba 'cameo' (3).jpg",
          width: 576,
          id: '4ae1ae8447f7660642711f5c6b7bf149',
          height: 768,
          thumbnail: true,
        },
        espece: 'x superba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 165, 97, 1.00)',
            'rgba(130, 131, 58, 1.00)',
            'rgba(112, 118, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/chaenomeles [rosaceae]/chaenomeles x superba 'cameo'/chaenomeles x superba 'cameo'  .jpg",
          width: 1024,
          id: '034e474b16c05978cd1d4fcc31c34b56',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 140, 103, 1.00)',
            'rgba(133, 151, 60, 1.00)',
            'rgba(127, 134, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/chaenomeles [rosaceae]/chaenomeles x superba 'cameo'/chaenomeles x superba 'cameo'  (2).jpg",
          width: 576,
          id: '760543e3ac45fa686eb44391c565ae62',
          height: 768,
          thumbnail: true,
        },
        location: [47.271325, -1.584628],
        genre: 'Chaenomeles',
        cultivar: 'Cameo',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584628, 47.271325] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ccb9812ffb007c8b31f5edc13559dee7729f779e',
      fields: {
        espece: 'x superba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 122, 103, 1.00)',
            'rgba(175, 88, 87, 1.00)',
            'rgba(159, 140, 133, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/chaenomeles [rosaceae]/chaenomeles x superba 'ernst finken'/chaenomeles x superba 'ernst finken'.jpg",
          width: 576,
          id: '35ee8f2779cfdf3fcc8d1e1c113ff180',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 160, 126, 1.00)',
            'rgba(119, 140, 88, 1.00)',
            'rgba(110, 112, 98, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/chaenomeles [rosaceae]/chaenomeles x superba 'ernst finken'/chaenomeles x superba 'ernst finken' (2).jpg",
          width: 576,
          id: 'ae640ae37f0f8681aa242c49fd091102',
          height: 768,
          thumbnail: true,
        },
        location: [47.270813, -1.580653],
        genre: 'Chaenomeles',
        cultivar: 'Ernst Finken',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580653, 47.270813] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dbf0bae25af8efaa2cea0b311f5e7e9e8d3916a8',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 107, 74, 1.00)',
            'rgba(133, 120, 86, 1.00)',
            'rgba(81, 65, 36, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/kerria [rosaceae]/kerria japonica 'kin kan'/kerria japonica 'kin kan' (5).jpg",
          width: 1024,
          id: '4b80948ea0de30efdd0c37ac514c6a2f',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 75, 50, 1.00)',
            'rgba(130, 123, 105, 1.00)',
            'rgba(80, 65, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/kerria [rosaceae]/kerria japonica 'kin kan'/kerria japonica 'kin kan' (4).jpg",
          width: 1024,
          id: 'af05bd59eb372561aa267b90d53f04e3',
          height: 683,
          thumbnail: true,
        },
        location: [47.270808, -1.5861],
        genre: 'Kerria',
        cultivar: 'Kin Kan',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5861, 47.270808] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '500a02527780d99b23794c244b1542e4c03fe297',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 124, 56, 1.00)',
            'rgba(120, 123, 32, 1.00)',
            'rgba(114, 124, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/kerria [rosaceae]/kerria japonica/kerria japonica  (2).jpg',
          width: 1024,
          id: '78b5f9b2859b5881571b02d4960f0dc8',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 142, 73, 1.00)',
            'rgba(108, 145, 63, 1.00)',
            'rgba(85, 118, 42, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/kerria [rosaceae]/kerria japonica/kerria japonica (3).jpg',
          width: 576,
          id: 'b60312bb2b37202573c9145fe2558327',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 85, 4, 1.00)',
            'rgba(169, 143, 10, 1.00)',
            'rgba(112, 94, 6, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/kerria [rosaceae]/kerria japonica/kerria japonica  (1).jpg',
          width: 576,
          id: '0e01a377ee1a852255ffd524e3234eca',
          height: 768,
          thumbnail: true,
        },
        location: [47.27117, -1.585092],
        genre: 'Kerria',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585092, 47.27117] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd0931ddfe08a9e9677a16f1b714e3e9f93067b88',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 124, 103, 1.00)',
            'rgba(144, 140, 123, 1.00)',
            'rgba(64, 79, 44, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'beaute'/malus 'beaute'  (2).jpg",
          width: 576,
          id: '419a0611f279fe01152f0270bdacf25b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 136, 90, 1.00)',
            'rgba(97, 129, 65, 1.00)',
            'rgba(72, 114, 36, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'beaute'/malus 'beaute'  (3).jpg",
          width: 576,
          id: '83a905991b2b8f374b6695496e568ec1',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(230, 230, 228, 1.00)',
            'rgba(137, 138, 124, 1.00)',
            'rgba(79, 95, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'beaute'/malus 'beaute'  (1).jpg",
          width: 587,
          id: '7cb22b2e0caf4fea0df643153022e068',
          height: 768,
          thumbnail: true,
        },
        location: [47.271758, -1.587122],
        genre: 'Malus',
        cultivar: 'Beaut\u00e9',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587122, 47.271758] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '149c28f3185dc20ff0df5d65826c66c7a473b5e8',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 103, 109, 1.00)',
            'rgba(145, 141, 126, 1.00)',
            'rgba(127, 120, 110, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'evereste'/malus 'evereste' (3).jpg",
          width: 576,
          id: '50c90723439bf2a09819a965651aefce',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(183, 186, 171, 1.00)',
            'rgba(162, 145, 89, 1.00)',
            'rgba(113, 89, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'evereste'/malus 'evereste' (4).jpg",
          width: 576,
          id: 'dc7f8e315432e192ac39af599fe595fc',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(169, 166, 136, 1.00)',
            'rgba(111, 104, 70, 1.00)',
            'rgba(111, 112, 81, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'evereste'/malus 'evereste' (2).jpg",
          width: 576,
          id: '13c4e0b617f42dae75129f6f8e2cf968',
          height: 768,
          thumbnail: true,
        },
        location: [47.27065, -1.581075],
        genre: 'Malus',
        cultivar: 'Evereste',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581075, 47.27065] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd7885d4e08712cad3e831ea8d9ed009db0395f35',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 137, 112, 1.00)',
            'rgba(120, 126, 71, 1.00)',
            'rgba(105, 120, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'van eseltine'/malus 'van eseltine' (2).jpg",
          width: 576,
          id: '8f6f9ef155c8730ceac023031473c745',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(198, 201, 184, 1.00)',
            'rgba(134, 136, 113, 1.00)',
            'rgba(81, 88, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'van eseltine'/malus 'van eseltine' (3).jpg",
          width: 576,
          id: '693e88669f87079fc9555744bbee1823',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 79, 65, 1.00)',
            'rgba(139, 138, 130, 1.00)',
            'rgba(80, 90, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'van eseltine'/malus 'van eseltine' (1).jpg",
          width: 576,
          id: 'd39d6c4f118dc133d8c9e5e679bf3961',
          height: 768,
          thumbnail: true,
        },
        location: [47.270653, -1.586475],
        genre: 'Malus',
        cultivar: 'Van Eseltine',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586475, 47.270653] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '68ee3a6a84225592335d3d7627ed50f659533c92',
      fields: {
        espece: 'tschonoskii',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 104, 99, 1.00)',
            'rgba(152, 137, 106, 1.00)',
            'rgba(116, 106, 93, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/malus [rosaceae]/malus tschonoskii/malus tschonoskii (3).jpg',
          width: 576,
          id: 'a47c552c861362a86fbb237cd1dcaef2',
          height: 768,
          thumbnail: true,
        },
        location: [47.269897, -1.58565],
        genre: 'Malus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58565, 47.269897] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9acdf1e056baf135e34155c73811ae2cb5577571',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'serratifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 78, 57, 1.00)',
            'rgba(112, 101, 63, 1.00)',
            'rgba(73, 91, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/photinia [rosaceae]/photinia serratifolia/photinia serratifolia  (2).jpg',
          width: 1024,
          id: 'c82a05ce0cf4ef214a1cfeccd73ebe57',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 110, 101, 1.00)',
            'rgba(110, 112, 106, 1.00)',
            'rgba(102, 109, 99, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/photinia [rosaceae]/photinia serratifolia/photinia serratifolia  (3).jpg',
          width: 1024,
          id: 'cef136923a00939a308b01f36e3cd448',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 161, 150, 1.00)',
            'rgba(112, 112, 74, 1.00)',
            'rgba(95, 92, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/photinia [rosaceae]/photinia serratifolia/photinia serratifolia  (1).jpg',
          width: 512,
          id: '2293b0ac5a2027aa151368efaccd6e28',
          height: 768,
          thumbnail: true,
        },
        location: [47.27143, -1.58508],
        genre: 'Photinia',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58508, 47.27143] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ebb9ae5bbacbd55540dd81300a9533a29f8282f3',
      fields: {
        espece: 'intermedius',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Physocarpus',
        date_plantation: '1986',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4791476cbf46add807188f469fa6837fa670f751',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 130, 109, 1.00)',
            'rgba(154, 134, 108, 1.00)',
            'rgba(155, 131, 104, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus sargentii 'rancho'/prunus sargentii 'rancho' (1).jpg",
          width: 576,
          id: '2f2a2ad552da934f5d412536047dec7f',
          height: 768,
          thumbnail: true,
        },
        espece: 'sargentii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 93, 90, 1.00)',
            'rgba(114, 101, 97, 1.00)',
            'rgba(84, 79, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus sargentii 'rancho'/prunus sargentii 'rancho'  (2).jpg",
          width: 1024,
          id: 'ac5685b8c458b9e8949314470c0cac70',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 161, 193, 1.00)',
            'rgba(141, 137, 148, 1.00)',
            'rgba(81, 74, 46, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus sargentii 'rancho'/prunus sargentii 'rancho'  (1).jpg",
          width: 1024,
          id: 'fd31a07286dd35b8ae66b3c7ea0801a3',
          height: 716,
          thumbnail: true,
        },
        location: [47.270825, -1.584978],
        genre: 'Prunus',
        cultivar: 'Rancho',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584978, 47.270825] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e1199155335240547451ecd325cfece871e126f1',
      fields: {
        espece: 'x cistena',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 99, 86, 1.00)',
            'rgba(144, 105, 102, 1.00)',
            'rgba(147, 116, 107, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/prunus [rosaceae]/prunus x cistena/prunus x cistena (2).jpg',
          width: 576,
          id: 'b414239f9e0b51fbe98d4f9e09a60c93',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 98, 67, 1.00)',
            'rgba(124, 95, 85, 1.00)',
            'rgba(103, 74, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/prunus [rosaceae]/prunus x cistena/prunus x cistena (1).jpg',
          width: 576,
          id: 'bd869af613f2e00f1b9ddf92db641e41',
          height: 768,
          thumbnail: true,
        },
        location: [47.271192, -1.58568],
        genre: 'Prunus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58568, 47.271192] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a1849296b9b99e8ec25d9d6b228c502520661d51',
      fields: {
        espece: 'pyrifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 129, 118, 1.00)',
            'rgba(140, 135, 119, 1.00)',
            'rgba(116, 112, 99, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/pyrus [rosaceae]/pyrus pyrifolia 'choju'/pyrus pyrifolia 'choju' (3).jpg",
          width: 1024,
          id: '7253da2fff3a2b8a79c3404d45d5aadd',
          height: 687,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 119, 163, 1.00)',
            'rgba(102, 105, 95, 1.00)',
            'rgba(82, 77, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/pyrus [rosaceae]/pyrus pyrifolia 'choju'/pyrus pyrifolia 'choju' (2).jpg",
          width: 1024,
          id: '81d3a89735757f083d057ca9cce1ab4b',
          height: 683,
          thumbnail: true,
        },
        location: [47.269808, -1.584492],
        genre: 'Pyrus',
        cultivar: 'Choju',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584492, 47.269808] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bded4342b8772fa3897c877855d6a6b7968e0018',
      fields: {
        espece: 'pyrifolia',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 98, 20, 1.00)',
            'rgba(174, 114, 21, 1.00)',
            'rgba(132, 93, 17, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/pyrus [rosaceae]/pyrus pyrifolia 'choju'/pyrus pyrifolia 'choju'.jpg",
          width: 576,
          id: '21761186e4844be162abd2efcd0735d8',
          height: 768,
          thumbnail: true,
        },
        location: [47.269958, -1.584422],
        genre: 'Pyrus',
        cultivar: 'Choju',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584422, 47.269958] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '72b194d417ceaca4f48a7483692d22990c263c72',
      fields: {
        espece: 'salicifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 98, 92, 1.00)',
            'rgba(100, 111, 83, 1.00)',
            'rgba(105, 130, 99, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/pyrus [rosaceae]/pyrus salicifolia 'pendula'/pyrus salicifolia 'pendula' (2).jpg",
          width: 576,
          id: '92782f0cd90f0b86d12604b68341772c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(69, 87, 55, 1.00)',
            'rgba(89, 119, 68, 1.00)',
            'rgba(91, 110, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/pyrus [rosaceae]/pyrus salicifolia 'pendula'/pyrus salicifolia 'pendula' (1).jpg",
          width: 576,
          id: '9dbdf922a2db050534fecff9822d099b',
          height: 768,
          thumbnail: true,
        },
        location: [47.270005, -1.585845],
        genre: 'Pyrus',
        cultivar: 'Pendula',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585845, 47.270005] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6ed47d9e14b9c430f3849ef513b7cb2fc951a669',
      fields: {
        espece: 'thunbergii',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Spiraea',
        date_plantation: '1973',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ef3db6d05cfa2fd76eee1f9cbe00b3af7a744357',
      fields: {
        espece: 'media',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '1995',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e5c181b958b70694d8b22a49cf21e680ec6824cb',
      fields: {
        espece: 'alba var. latifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 115, 49, 1.00)',
            'rgba(96, 124, 88, 1.00)',
            'rgba(56, 90, 45, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea alba var. latifolia/spiraea alba var. latifolia (2).jpg',
          width: 576,
          id: 'f75d0ccce9335fdfefb5a342503a351d',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 169, 90, 1.00)',
            'rgba(90, 153, 69, 1.00)',
            'rgba(73, 128, 47, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea alba var. latifolia/spiraea alba var. latifolia (1).jpg',
          width: 576,
          id: '2b91be2b55cce31cd3980eaf004488c6',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '94875f39483fe090eff90bf292d1c991ec690364',
      fields: {
        espece: 'cantoniensis',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 125, 84, 1.00)',
            'rgba(120, 131, 93, 1.00)',
            'rgba(92, 95, 69, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea cantoniensis/spiraea cantoniensis (3).jpg',
          width: 1024,
          id: 'feec9425b0fbf3bba2140db1cac557f0',
          height: 768,
          thumbnail: true,
        },
        location: [47.271288, -1.585678],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585678, 47.271288] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7970c09d7108a650e2aec5bb0ad2845e9e7a17c8',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 142, 92, 1.00)',
            'rgba(131, 150, 90, 1.00)',
            'rgba(101, 118, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea japonica 'goldflame'/spiraea japonica 'goldflame' (3).jpg",
          width: 1024,
          id: '208c674bdbda7611384b13158bebfccd',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 161, 106, 1.00)',
            'rgba(148, 126, 106, 1.00)',
            'rgba(107, 133, 52, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea japonica 'goldflame'/spiraea japonica 'goldflame' (2).jpg",
          width: 576,
          id: '453266743da6128dbdd2261629fdbf18',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 170, 100, 1.00)',
            'rgba(126, 135, 74, 1.00)',
            'rgba(86, 114, 43, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea japonica 'goldflame'/spiraea japonica 'goldflame' (1).jpg",
          width: 576,
          id: '1116b9e1f0086a89bab9a834ca7a1932',
          height: 768,
          thumbnail: true,
        },
        location: [47.269978, -1.582228],
        genre: 'Spiraea',
        cultivar: 'Goldflame',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582228, 47.269978] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f99b6b3a12de8755ecbd3f1d0a0a50e7138e0c21',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'longigemmis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 155, 100, 1.00)',
            'rgba(122, 144, 96, 1.00)',
            'rgba(96, 128, 77, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea longigemmis/spiraea longigemmis (4).jpg',
          width: 576,
          id: '4bc2c45c932586157a1b57d2c9502f40',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 115, 61, 1.00)',
            'rgba(117, 149, 88, 1.00)',
            'rgba(118, 139, 90, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea longigemmis/spiraea longigemmis (5).jpg',
          width: 576,
          id: '62a22eeb95dfdbd66cefd7c80b566efd',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 122, 64, 1.00)',
            'rgba(103, 132, 84, 1.00)',
            'rgba(89, 118, 69, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea longigemmis/spiraea longigemmis (3).jpg',
          width: 703,
          id: 'fe580ac8e15b0db921d4369ee499d65b',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4e4973a95093918642104b828259c785ee77f3a0',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'nervosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 126, 114, 1.00)',
            'rgba(133, 134, 103, 1.00)',
            'rgba(117, 115, 89, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea nervosa/spiraea nervosa (2).jpg',
          width: 576,
          id: '3be34b22c66ce341dd117e522d1f365f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 85, 15, 1.00)',
            'rgba(137, 113, 60, 1.00)',
            'rgba(113, 79, 23, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea nervosa/spiraea nervosa (3).jpg',
          width: 576,
          id: '84918b55af08abcdb6510fb0e1b92056',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(62, 59, 27, 1.00)',
            'rgba(112, 115, 75, 1.00)',
            'rgba(74, 62, 37, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea nervosa/spiraea nervosa (1).jpg',
          width: 576,
          id: '2a2b4d698a42039631ce0a7084ae45ba',
          height: 768,
          thumbnail: true,
        },
        location: [47.271188, -1.584703],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584703, 47.271188] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '694b0e06978f388604f88ec0b654dc4cd20be88c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'nervosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 111, 66, 1.00)',
            'rgba(131, 157, 92, 1.00)',
            'rgba(121, 145, 77, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea nervosa/spiraea nervosa (11).jpg',
          width: 576,
          id: '6ba0f5fcbc2282369ed6414143e86e83',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 140, 99, 1.00)',
            'rgba(124, 128, 87, 1.00)',
            'rgba(118, 118, 87, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea nervosa/spiraea nervosa (12).jpg',
          width: 1024,
          id: 'f0f8f18f2d2dff40521d3f34d779e1eb',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 153, 67, 1.00)',
            'rgba(119, 149, 52, 1.00)',
            'rgba(128, 145, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea nervosa/spiraea nervosa (10).jpg',
          width: 576,
          id: 'ba76640fb48d89d951f457b54dcdb93c',
          height: 768,
          thumbnail: true,
        },
        location: [47.271567, -1.584883],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584883, 47.271567] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0e16677511db37d575bce4e0ec929dc43523f626',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'rosthornii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 157, 112, 1.00)',
            'rgba(125, 128, 85, 1.00)',
            'rgba(112, 114, 92, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea rosthornii/spiraea rosthornii .jpg',
          width: 576,
          id: 'b1e1aa26d2e4105440362df67919486e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 152, 52, 1.00)',
            'rgba(114, 153, 41, 1.00)',
            'rgba(103, 125, 40, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea rosthornii/spiraea rosthornii.jpg',
          width: 576,
          id: 'abb1062c1f6eb4740165e4dbe647155e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 111, 64, 1.00)',
            'rgba(113, 140, 110, 1.00)',
            'rgba(51, 78, 30, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea rosthornii/spiraea rosthornii (2).jpg',
          width: 576,
          id: '4c1ac88a9ffb1fd84047111689dce53c',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '992a0616ac89c3b0bf099708dca959c90dc6059b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'tomentosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 171, 75, 1.00)',
            'rgba(129, 152, 74, 1.00)',
            'rgba(118, 153, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea tomentosa/spiraea tomentosa (3).jpg',
          width: 576,
          id: '2a56820fe26b86c8897bfc2f88f8367e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 137, 83, 1.00)',
            'rgba(128, 157, 102, 1.00)',
            'rgba(88, 121, 64, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea tomentosa/spiraea tomentosa (4).jpg',
          width: 444,
          id: '23ad6a5440545f16435ef4bd677f158f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 160, 74, 1.00)',
            'rgba(115, 144, 69, 1.00)',
            'rgba(75, 98, 37, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea tomentosa/spiraea tomentosa (1).jpg',
          width: 576,
          id: '06c47f034de8fe29509fd0fc47a9e4fb',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '115b3ffdaeefc8011fa94ed745701bd411949b67',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 174, 112, 1.00)',
            'rgba(130, 150, 93, 1.00)',
            'rgba(92, 119, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea x cinerea 'grefsheim'/spiraea x cinerea 'grefsheim' (3).jpg",
          width: 576,
          id: '5004327bae7a8404031c14c7889d94f7',
          height: 768,
          thumbnail: true,
        },
        espece: 'x cinerea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 182, 117, 1.00)',
            'rgba(118, 147, 78, 1.00)',
            'rgba(89, 108, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea x cinerea 'grefsheim'/spiraea x cinerea 'grefsheim' (2).jpg",
          width: 576,
          id: '2a9772c4b85ccdbab15303fbe0836ba9',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 144, 86, 1.00)',
            'rgba(124, 146, 85, 1.00)',
            'rgba(119, 128, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea x cinerea 'grefsheim'/spiraea x cinerea 'grefsheim' (1).jpg",
          width: 1024,
          id: '6762705c1d12db18a8ceb96e1204b8e6',
          height: 768,
          thumbnail: true,
        },
        location: [47.271503, -1.587113],
        genre: 'Spiraea',
        cultivar: 'Grefsheim',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587113, 47.271503] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'af1b60fc541df3f1e32312f459d5f9818510df82',
      fields: {
        espece: 'x pseudosalicifolia',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 108, 131, 1.00)',
            'rgba(145, 114, 127, 1.00)',
            'rgba(132, 124, 111, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea x pseudosalicifolia 'triumphans'/spiraea x pseudosalicifolia 'triumphans'.jpg",
          width: 576,
          id: '0f1bc8b802fb298ea3a699c747c491b7',
          height: 768,
          thumbnail: true,
        },
        location: [47.271242, -1.582842],
        genre: 'Spiraea',
        cultivar: 'Triumphans',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582842, 47.271242] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '867b4086cfb28d8785b2ce45ba028884f1139ecf',
      fields: {
        origine: 'JB.Kyoto (Japon)',
        espece: 'armatum',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Zanthoxylum',
        date_plantation: '2004',
        cultivar: 'subtrifoliatum',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0bc9b11274461c3c5969e4c4b297a63e8a4f64bc',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 137, 120, 1.00)',
            'rgba(125, 134, 102, 1.00)',
            'rgba(68, 68, 46, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/choisya [rutaceae]/choisya x dewitteana 'aztec pearl'/choisya x dewitteana 'aztec pearl'  (3).jpg",
          width: 576,
          id: '592f62171244ab2a9fea3425ed35e645',
          height: 768,
          thumbnail: true,
        },
        espece: 'x dewitteana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 137, 108, 1.00)',
            'rgba(106, 116, 76, 1.00)',
            'rgba(98, 97, 65, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/choisya [rutaceae]/choisya x dewitteana 'aztec pearl'/choisya x dewitteana 'aztec pearl'  (2).jpg",
          width: 1024,
          id: '1ffd3c64ceda91baa582fc3602d2d9b9',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 85, 57, 1.00)',
            'rgba(133, 135, 112, 1.00)',
            'rgba(89, 91, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/choisya [rutaceae]/choisya x dewitteana 'aztec pearl'/choisya x dewitteana 'aztec pearl'  (1).jpg",
          width: 576,
          id: '6889406cee9ff14951a0e8bb034a2614',
          height: 768,
          thumbnail: true,
        },
        location: [47.27138, -1.582467],
        genre: 'Choisya',
        cultivar: 'Aztec Pearl',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582467, 47.27138] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a674f127002ea6be41d3af50a3da3ead6c46955e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'trifoliata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 101, 63, 1.00)',
            'rgba(105, 131, 73, 1.00)',
            'rgba(70, 93, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/citrus [rutaceae]/citrus trifoliata/citrus trifoliata  (2).jpg',
          width: 576,
          id: '94bf81a161d694db3c37513e9cff5062',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 97, 67, 1.00)',
            'rgba(111, 129, 92, 1.00)',
            'rgba(44, 63, 27, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/citrus [rutaceae]/citrus trifoliata/citrus trifoliata  (3).jpg',
          width: 576,
          id: '9a31d598cd353877b2eba67e301ffdbd',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 115, 44, 1.00)',
            'rgba(92, 110, 36, 1.00)',
            'rgba(111, 116, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/citrus [rutaceae]/citrus trifoliata/citrus trifoliata  (1).jpg',
          width: 1024,
          id: '6c40b3781537095cab573f0ffdbad0c7',
          height: 768,
          thumbnail: true,
        },
        location: [47.270628, -1.586428],
        genre: 'Citrus',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586428, 47.270628] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a4e31d497bc46699b125a5bd8bb5f68e4ba7dca9',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'amurense',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(187, 163, 103, 1.00)',
            'rgba(136, 118, 58, 1.00)',
            'rgba(67, 61, 37, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/phellodendron [rutaceae]/phellodendron amurense/phellodendron amurense (10).jpg',
          width: 512,
          id: '2577cc680635b56047d336791bda43d7',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 125, 76, 1.00)',
            'rgba(137, 136, 85, 1.00)',
            'rgba(147, 147, 82, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/phellodendron [rutaceae]/phellodendron amurense/phellodendron amurense (3).jpg',
          width: 576,
          id: 'd3e2aa7306ab68513885f15245e1de05',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 102, 78, 1.00)',
            'rgba(151, 143, 111, 1.00)',
            'rgba(99, 95, 78, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/phellodendron [rutaceae]/phellodendron amurense/phellodendron amurense (1).jpg',
          width: 651,
          id: '40d0d5ab9bdadf1d2f415584b16f9d3e',
          height: 768,
          thumbnail: true,
        },
        location: [47.270972, -1.581238],
        genre: 'Phellodendron',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581238, 47.270972] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '43d20e2fb703b48776bbc245744e2c61458518a2',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'trifoliata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 155, 62, 1.00)',
            'rgba(98, 141, 50, 1.00)',
            'rgba(99, 123, 50, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/ptelea [rutaceae]/ptelea trifoliata/ptelea trifoliata (2).jpg",
          width: 576,
          id: '989c850db2956450e7cc5599abd4cc7c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(189, 209, 188, 1.00)',
            'rgba(121, 138, 75, 1.00)',
            'rgba(80, 89, 46, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/ptelea [rutaceae]/ptelea trifoliata/ptelea trifoliata (3).jpg",
          width: 1024,
          id: 'f2efb61d1b30b2e428ee451177c11ee4',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 115, 42, 1.00)',
            'rgba(129, 149, 65, 1.00)',
            'rgba(92, 118, 36, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/ptelea [rutaceae]/ptelea trifoliata/ptelea trifoliata (1).jpg",
          width: 576,
          id: '2878c32c5fc8e3b2683ac90cd2d52633',
          height: 768,
          thumbnail: true,
        },
        location: [47.22678, -1.512853],
        genre: 'Ptelea',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512853, 47.22678] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7f04d6c1f797faadce904221bc35b88f10de2e67',
      fields: {
        espece: 'trifoliata',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 137, 119, 1.00)',
            'rgba(123, 126, 104, 1.00)',
            'rgba(101, 115, 80, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/ptelea [rutaceae]/ptelea trifoliata/ptelea trifoliata (4).jpg",
          width: 512,
          id: '9f15707316f965cd7c993e1ef75a8137',
          height: 768,
          thumbnail: true,
        },
        location: [47.226778, -1.512845],
        genre: 'Ptelea',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512845, 47.226778] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd7a8bf9c7718757c084a457c39e60c7963516057',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 131, 66, 1.00)',
            'rgba(118, 131, 70, 1.00)',
            'rgba(118, 118, 78, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/skimmia [rutaceae]/skimmia japonica 'olympic flame'/skimmia japonica 'olympic flame' (5).jpg",
          width: 1024,
          id: '97be89f174bd1cf2e7fe60be041c9e99',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 138, 63, 1.00)',
            'rgba(87, 117, 26, 1.00)',
            'rgba(127, 142, 67, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/skimmia [rutaceae]/skimmia japonica 'olympic flame'/skimmia japonica 'olympic flame' (4).jpg",
          width: 576,
          id: '77f95d9bac3606397cafbc3b92043b37',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 113, 67, 1.00)',
            'rgba(128, 134, 86, 1.00)',
            'rgba(115, 138, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/skimmia [rutaceae]/skimmia japonica 'olympic flame'/skimmia japonica 'olympic flame' (3).jpg",
          width: 576,
          id: '97eacced854f00df5246431918e41854',
          height: 768,
          thumbnail: true,
        },
        location: [47.270795, -1.582325],
        genre: 'Skimmia',
        cultivar: 'Olympic Flame',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582325, 47.270795] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd86e32e25e31a986ba0cc69b86f4c64bda201625',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 123, 34, 1.00)',
            'rgba(115, 124, 40, 1.00)',
            'rgba(113, 124, 37, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/skimmia [rutaceae]/skimmia x confusa 'kew green'/skimmia x confusa 'kew green' (1).jpg",
          width: 576,
          id: 'dd3f1271dbbf938c78420b687ec0e0b0',
          height: 768,
          thumbnail: true,
        },
        espece: 'x confusa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 143, 70, 1.00)',
            'rgba(118, 148, 79, 1.00)',
            'rgba(79, 107, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/skimmia [rutaceae]/skimmia x confusa 'kew green'/skimmia x confusa 'kew green'  (2).jpg",
          width: 576,
          id: 'de82e6d96436d243cf6eff3a5e92a5fe',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 127, 94, 1.00)',
            'rgba(117, 138, 83, 1.00)',
            'rgba(101, 131, 74, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/skimmia [rutaceae]/skimmia x confusa 'kew green'/skimmia x confusa 'kew green'  (1).jpg",
          width: 576,
          id: '4388e155297110de93c8ff3559b6c0ef',
          height: 768,
          thumbnail: true,
        },
        location: [47.271353, -1.586537],
        genre: 'Skimmia',
        cultivar: 'Kew Green',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586537, 47.271353] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5ae2f9079e82163da9fdd3a553a3aaf22a4e0bb5',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'ailanthoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 155, 118, 1.00)',
            'rgba(168, 172, 128, 1.00)',
            'rgba(153, 154, 106, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/zanthoxylum [rutaceae]/zanthoxylum ailanthoides/zanthoxylum ailanthoides (2).jpg',
          width: 576,
          id: 'c8846d2c6cc3ac9ee174b718b87a61e9',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 125, 83, 1.00)',
            'rgba(96, 129, 71, 1.00)',
            'rgba(95, 122, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/zanthoxylum [rutaceae]/zanthoxylum ailanthoides/zanthoxylum ailanthoides (3).jpg',
          width: 1024,
          id: '9f3e85c628cd042f6618563d1ba618fe',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 124, 60, 1.00)',
            'rgba(141, 160, 60, 1.00)',
            'rgba(140, 136, 79, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/zanthoxylum [rutaceae]/zanthoxylum ailanthoides/zanthoxylum ailanthoides (1).jpg',
          width: 576,
          id: '66b5eea9e6cb927dfb6d264bac365dab',
          height: 768,
          thumbnail: true,
        },
        location: [47.269633, -1.585075],
        genre: 'Zanthoxylum',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585075, 47.269633] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0a9fe34f67131b4bb60416eeea14a1314b0e69dd',
      fields: {
        espece: 'integra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 86, 44, 1.00)',
            'rgba(167, 169, 140, 1.00)',
            'rgba(96, 111, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/salix [salicaceae]/salix integra 'hakuro nishiki'/salix integra 'hakuro nishiki' .jpg",
          width: 615,
          id: 'e3b30a5e9157e3c0682b3466bfe6dbd9',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(200, 205, 183, 1.00)',
            'rgba(90, 103, 51, 1.00)',
            'rgba(95, 102, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/salix [salicaceae]/salix integra 'hakuro nishiki'/salix integra 'hakuro nishiki'  (2).jpg",
          width: 1024,
          id: 'e7a83ab6a4a412315d85ec85ab20ad9b',
          height: 768,
          thumbnail: true,
        },
        location: [47.26987, -1.584503],
        genre: 'Salix',
        cultivar: 'Hakuro Nishiki',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584503, 47.26987] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '350017236003ac2c123be140ea9b8dad75a1dca8',
      fields: {
        origine:
          "JB de l'institut de botanique syst\u00e9matique - universit\u00e9 d Ath\u00e8nes",
        espece: 'paniculata',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Koelreuteria',
        date_plantation: '2002',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ca2b74564659ebad864acbc95bd70caf2de1519f',
      fields: {
        origine: 'JB.Hiroshima (Japon)',
        espece: 'cissifolium',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Acer',
        date_plantation: '2004',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '79b3d1c8f6dcdd8b68c35ad2e85b40445074b6bd',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale',
        espece: 'tataricum',
        localisation: 'B1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2204652, -1.544656],
        genre: 'Acer',
        date_plantation: '2017',
        cultivar: 'ginnala',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544656, 47.2204652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9f5ad5b8b7b1e5fc0c1f4381f29458a8090c1ec4',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Gd Blottereau',
        espece: 'buergerianum',
        localisation: 'B1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2204652, -1.544656],
        genre: 'Acer',
        date_plantation: '2017',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544656, 47.2204652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f99a5d661c2f957154ef6b0fd3b46a644d09a718',
      fields: {
        origine: 'P\u00e9pini\u00e8res Dauguet - 53 Larchamp',
        espece: 'capillipes',
        localisation: 'A5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2207668, -1.5440149],
        genre: 'Acer',
        date_plantation: '2012',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440149, 47.2207668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '98ed571d55fd0777e8e8cca2834f1affbc0e97a2',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'buergerianum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 102, 45, 1.00)',
            'rgba(111, 133, 50, 1.00)',
            'rgba(78, 104, 42, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer buergerianum/acer buergerianum  (2).jpg',
          width: 576,
          id: '86c055153f76d847fdea765e05be18fd',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 134, 84, 1.00)',
            'rgba(157, 133, 79, 1.00)',
            'rgba(156, 131, 77, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer buergerianum/acer buergerianum  (3).jpg',
          width: 576,
          id: '83361aefed7e31207c8642a627fef190',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 121, 45, 1.00)',
            'rgba(121, 146, 34, 1.00)',
            'rgba(95, 120, 30, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer buergerianum/acer buergerianum  (1).jpg',
          width: 576,
          id: '5261637c2765b0db4f2713a095e4b434',
          height: 768,
          thumbnail: true,
        },
        location: [47.271053, -1.581372],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581372, 47.271053] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cb0eac38bc8ef219a8f364be5313e8cf834cee75',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'capillipes',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 141, 62, 1.00)',
            'rgba(110, 118, 40, 1.00)',
            'rgba(113, 116, 64, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer capillipes/acer capillipes (2).jpg',
          width: 576,
          id: 'a650fd0f8a2f12fc0944db5659dc383e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 141, 71, 1.00)',
            'rgba(136, 129, 65, 1.00)',
            'rgba(119, 117, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer capillipes/acer capillipes (3).jpg',
          width: 576,
          id: '5ee2e1ed7412e85ffadae21f33de66e7',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 117, 51, 1.00)',
            'rgba(112, 139, 64, 1.00)',
            'rgba(135, 131, 79, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer capillipes/acer capillipes (1).jpg',
          width: 545,
          id: '297f6583878ba579abe856a441df5108',
          height: 768,
          thumbnail: true,
        },
        location: [47.271108, -1.585703],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585703, 47.271108] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'db9852fc4d187c427afd16de0af110027d3a5495',
      fields: {
        espece: 'grosseri var. hersii',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(174, 165, 164, 1.00)',
            'rgba(141, 102, 62, 1.00)',
            'rgba(69, 49, 19, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer grosseri var. hersii/acer grosseri var.hersii  (3).jpg',
          width: 950,
          id: '8f863adbaef93d9419f8ebb13a1ab147',
          height: 768,
          thumbnail: true,
        },
        location: [47.271063, -1.586058],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586058, 47.271063] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '113aaeb6978d7836dcb1056c77f72af5ecec47ee',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'macrophyllum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 149, 91, 1.00)',
            'rgba(108, 118, 50, 1.00)',
            'rgba(77, 81, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer macrophyllum/acer macrophyllum  (2).jpg',
          width: 576,
          id: 'c19c295b64f5d723100782897a4e5df2',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 124, 97, 1.00)',
            'rgba(119, 116, 63, 1.00)',
            'rgba(143, 140, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer macrophyllum/acer macrophyllum  (3).jpg',
          width: 576,
          id: 'dc05323d438a83a8acc6906d6dc2c8fa',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 121, 57, 1.00)',
            'rgba(146, 151, 48, 1.00)',
            'rgba(147, 154, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer macrophyllum/acer macrophyllum  (1).jpg',
          width: 696,
          id: '220d5bafe7c1511e01ff8c3e5ab25262',
          height: 768,
          thumbnail: true,
        },
        location: [47.270683, -1.581608],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581608, 47.270683] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c60d1e72a0ce2508b34cd55703590bb55f99f5b4',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 138, 91, 1.00)',
            'rgba(137, 151, 90, 1.00)',
            'rgba(110, 122, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer negundo 'flamingo'/acer negundo 'flamingo' (3).jpg",
          width: 576,
          id: '6c58026fd34310a8c147fee998df84c6',
          height: 768,
          thumbnail: true,
        },
        espece: 'negundo',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(210, 222, 230, 1.00)',
            'rgba(136, 140, 94, 1.00)',
            'rgba(82, 88, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer negundo 'flamingo'/acer negundo 'flamingo' (2).jpg",
          width: 576,
          id: 'ebcce5416e8da07036fdade8529ca01e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 134, 104, 1.00)',
            'rgba(120, 109, 59, 1.00)',
            'rgba(80, 79, 46, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer negundo 'flamingo'/acer negundo 'flamingo' (1).jpg",
          width: 576,
          id: '53ad6f7a65f73b1f4f02d2093e475374',
          height: 768,
          thumbnail: true,
        },
        location: [47.27155, -1.586487],
        genre: 'Acer',
        cultivar: 'Flamingo',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586487, 47.27155] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '10a18e3b2f7b016548c6b883a5b5f2b1a7197ebb',
      fields: {
        espece: 'platanoides',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 131, 134, 1.00)',
            'rgba(115, 110, 98, 1.00)',
            'rgba(32, 31, 19, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer platanoides 'schwedleri'/acer platanoides 'schwedleri' (2).jpg",
          width: 1024,
          id: '5c8d79f859199ed3a932504afc1a38ed',
          height: 683,
          thumbnail: true,
        },
        location: [47.269883, -1.585092],
        genre: 'Acer',
        cultivar: 'Schwedleri',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585092, 47.269883] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '509c2a528b0733f630ecd76a0f736ee9de949d1d',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(171, 183, 110, 1.00)',
            'rgba(138, 158, 43, 1.00)',
            'rgba(91, 111, 12, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer pseudoplatanus 'worley'/acer pseudoplatanus 'worley' (2).jpg",
          width: 576,
          id: '4aeea83e710a8d7a509aceeb57178208',
          height: 768,
          thumbnail: true,
        },
        espece: 'pseudoplatanus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 163, 127, 1.00)',
            'rgba(128, 133, 46, 1.00)',
            'rgba(78, 83, 36, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer pseudoplatanus 'worley'/acer pseudoplatanus 'worley'  (2).jpg",
          width: 1024,
          id: '6c111932cfd656deb2025c74c7d031d8',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 132, 38, 1.00)',
            'rgba(153, 169, 36, 1.00)',
            'rgba(121, 133, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer pseudoplatanus 'worley'/acer pseudoplatanus 'worley'  (1).jpg",
          width: 612,
          id: 'bce295dae878c09a9f7041a7a33a301e',
          height: 768,
          thumbnail: true,
        },
        location: [47.270825, -1.581338],
        genre: 'Acer',
        cultivar: 'Worley',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581338, 47.270825] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0a991f84761d578692f966f87a9ed1b82657e754',
      fields: {
        espece: 'pseudoplatanus',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(213, 225, 175, 1.00)',
            'rgba(97, 122, 33, 1.00)',
            'rgba(57, 67, 22, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer pseudoplatanus 'worley'/acer pseudoplatanus 'worley' (4).jpg",
          width: 576,
          id: 'b0d29b02ef810398b9b9186ebcf0dca0',
          height: 768,
          thumbnail: true,
        },
        location: [47.270897, -1.581262],
        genre: 'Acer',
        cultivar: 'Worley',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581262, 47.270897] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6d42c3763fb2cc23898fd68ec3c809f18eac0059',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 114, 110, 1.00)',
            'rgba(127, 128, 126, 1.00)',
            'rgba(120, 121, 115, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer rubrum 'schlesingeri'/acer rubrum 'schlesingeri'  (2).jpg",
          width: 576,
          id: '014a1c975fa81f9fa17bc206479a6d80',
          height: 768,
          thumbnail: true,
        },
        espece: 'rubrum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(202, 198, 199, 1.00)',
            'rgba(137, 117, 92, 1.00)',
            'rgba(83, 82, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer rubrum 'schlesingeri'/acer rubrum 'schlesingeri'  (10).jpg",
          width: 882,
          id: 'df3c2255bd566cee5a8b0d2a87042aa3',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 97, 85, 1.00)',
            'rgba(162, 89, 85, 1.00)',
            'rgba(110, 110, 74, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer rubrum 'schlesingeri'/acer rubrum 'schlesingeri'  (1).jpg",
          width: 576,
          id: 'f70ed1274e6e2c9219bf3d4a74f3e0a7',
          height: 768,
          thumbnail: true,
        },
        location: [47.27123, -1.58497],
        genre: 'Acer',
        cultivar: 'Schlesingeri',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58497, 47.27123] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a7011e072b2c47c5f455cc20e80f1d9712d20c78',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'saccharinum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 91, 85, 1.00)',
            'rgba(129, 134, 126, 1.00)',
            'rgba(114, 103, 98, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer saccharinum/acer saccharinum (3).jpg',
          width: 576,
          id: '4c4249a7e140429802092db995087ce6',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 127, 49, 1.00)',
            'rgba(104, 131, 69, 1.00)',
            'rgba(126, 126, 112, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer saccharinum/acer saccharinum (6).jpg',
          width: 576,
          id: '18a46c6a495984fc0e3336da78beeeac',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(188, 196, 148, 1.00)',
            'rgba(114, 132, 65, 1.00)',
            'rgba(80, 91, 49, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer saccharinum/acer saccharinum (2).jpg',
          width: 1024,
          id: '4011ba948c1cd76553e7027ec8b661aa',
          height: 768,
          thumbnail: true,
        },
        location: [47.270925, -1.581375],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581375, 47.270925] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'de0fddd1c8e0566bc2585d169c1cf70f759f7c3c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'tataricum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 100, 28, 1.00)',
            'rgba(134, 147, 65, 1.00)',
            'rgba(112, 135, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer tataricum/acer tataricum (2).jpg',
          width: 576,
          id: '75c9b44d525f513c55f15a92b0f3a71c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 145, 55, 1.00)',
            'rgba(111, 146, 52, 1.00)',
            'rgba(102, 128, 45, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer tataricum/acer tataricum (3).jpg',
          width: 576,
          id: 'e974f0cc0e8d1b0f85ab751260d4459e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 120, 68, 1.00)',
            'rgba(112, 108, 65, 1.00)',
            'rgba(117, 88, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer tataricum/acer tataricum (1).jpg',
          width: 580,
          id: '275487edd84b87dba78bca230079cc29',
          height: 768,
          thumbnail: true,
        },
        location: [47.270617, -1.582787],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582787, 47.270617] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f8d3ec7798fc0171669a8b58f51acd1dba0e4c1b',
      fields: {
        espece: 'tataricum',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(203, 208, 184, 1.00)',
            'rgba(92, 106, 60, 1.00)',
            'rgba(91, 106, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer tataricum/acer tataricum.jpg',
          width: 1024,
          id: '845d036f903080d48b6eb37f77dabff5',
          height: 768,
          thumbnail: true,
        },
        location: [47.270467, -1.581042],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581042, 47.270467] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2ceb79f986eaf62ded70e9c6f7f638f03fef5129',
      fields: {
        espece: 'saccharinum',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(214, 219, 207, 1.00)',
            'rgba(97, 116, 68, 1.00)',
            'rgba(68, 81, 41, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/acer [sapindaceae]/acer saccharinum/acer saccharinum.jpg',
          width: 1024,
          id: '6e9f3b99c95a350c4f2ba6752d311f96',
          height: 768,
          thumbnail: true,
        },
        location: [47.261497, -1.53277],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53277, 47.261497] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fc12585d3918540a06d0292bc0e41acb34302fc2',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'indica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 117, 62, 1.00)',
            'rgba(120, 130, 50, 1.00)',
            'rgba(111, 124, 45, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus indica/aesculus indica (10).jpg',
          width: 1024,
          id: '017d23c744c11dccf862cba7399a4913',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 200, 169, 1.00)',
            'rgba(93, 116, 75, 1.00)',
            'rgba(54, 78, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus indica/aesculus indica (11).jpg',
          width: 1024,
          id: 'd0c97ff165673b04e6976a0d87e0b23e',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 142, 55, 1.00)',
            'rgba(150, 136, 50, 1.00)',
            'rgba(127, 129, 30, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus indica/aesculus indica (1).jpg',
          width: 576,
          id: '16d8e8eacb7bcec602929d6e3ac0eb9e',
          height: 768,
          thumbnail: true,
        },
        location: [47.269905, -1.584583],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584583, 47.269905] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f28b2a8d2c8df330cbde36ecfa0a96c7d67b17c2',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'bipinnata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 175, 106, 1.00)',
            'rgba(104, 149, 59, 1.00)',
            'rgba(98, 136, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/koelreuteria [sapindaceae]/koelreuteria bipinnata/koelreuteria bipinnata (14).jpg',
          width: 576,
          id: '3613265f46168c12edbcef36c9e26f69',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 144, 74, 1.00)',
            'rgba(115, 144, 74, 1.00)',
            'rgba(93, 122, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/koelreuteria [sapindaceae]/koelreuteria bipinnata/koelreuteria bipinnata (18).jpg',
          width: 576,
          id: 'f145cbe7a002d0e201d2ab341cf35a95',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 144, 100, 1.00)',
            'rgba(127, 145, 85, 1.00)',
            'rgba(111, 121, 74, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/koelreuteria [sapindaceae]/koelreuteria bipinnata/koelreuteria bipinnata (1).jpg',
          width: 576,
          id: '440317e560262a4d729535dd2cecbf13',
          height: 768,
          thumbnail: true,
        },
        location: [47.271122, -1.586255],
        genre: 'Koelreuteria',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586255, 47.271122] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '40a92f9f4635f1a596d425409d362b3bb08814b7',
      fields: {
        origine: 'J.Alp.Trento (Italie)',
        espece: 'cordifolia L.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Tiarella',
        date_plantation: '2006',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0b623f18f7d7d946abdce1985f99396101e1f5f9',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'chinensis Franch. & Sav.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Astilbe',
        date_plantation: '2008',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9c3e14fe3d880eaf58c26c9288179b0f4fb54a74',
      fields: {
        origine: 'JB.Tours (France)',
        espece: 'peltatum Engl.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Peltiphyllum',
        date_plantation: '2008',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b48b3b5fbb49799d20ca2a5a27e5e1dc60ea62a3',
      fields: {
        origine: 'Les Ponts de C\u00e9_p\u00e9pini\u00e8re Lepage',
        espece: 'chinensis Franch. & Sav.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Astilbe',
        date_plantation: '2016',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '316700824c922b12c72f8c0fe1f7ae4ee891f61a',
      fields: {
        origine: 'Honorable Municipalidad de Cochabamba',
        espece: 'sp.(5 pieds)',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Solanaceae',
        date_plantation: '2003',
        famille: 'Solanaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '34977b62d20417d618f3f4922bd8ad5cf8cc1b16',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'aurantiacum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 145, 37, 1.00)',
            'rgba(108, 153, 50, 1.00)',
            'rgba(130, 155, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cestrum [solanaceae]/cestrum aurantiacum/cestrum aurantiacum  (2).jpg',
          width: 576,
          id: '5efa1dd18071452d8efc5ab0d6569841',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(60, 101, 51, 1.00)',
            'rgba(109, 136, 64, 1.00)',
            'rgba(56, 89, 48, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cestrum [solanaceae]/cestrum aurantiacum/cestrum aurantiacum (2).jpg',
          width: 576,
          id: 'a91aea4efaf657ee8e69d00ffe85eef2',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(176, 183, 155, 1.00)',
            'rgba(94, 113, 34, 1.00)',
            'rgba(65, 96, 28, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cestrum [solanaceae]/cestrum aurantiacum/cestrum aurantiacum  (1).jpg',
          width: 576,
          id: 'f55f9b9d5ed45bb7bdfb33119f9c3074',
          height: 768,
          thumbnail: true,
        },
        location: [47.271775, -1.582705],
        genre: 'Cestrum',
        famille: 'Solanaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582705, 47.271775] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '34fc2ede79a21bf50f5b8de5218feeb3b11aef51',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'yunnanensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 135, 137, 1.00)',
            'rgba(154, 148, 131, 1.00)',
            'rgba(120, 125, 110, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stachyurus [stachyuraceae]/stachyurus yunnanensis/stachyurus yunnanensis (2).jpg',
          width: 659,
          id: 'b9d18094f41538ef546ab75b8ab55734',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 132, 121, 1.00)',
            'rgba(131, 129, 117, 1.00)',
            'rgba(124, 116, 118, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stachyurus [stachyuraceae]/stachyurus yunnanensis/stachyurus yunnanensis (3).jpg',
          width: 576,
          id: '35f608ad4d2d7ad5a63f0728ddbe0b48',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 143, 132, 1.00)',
            'rgba(142, 136, 130, 1.00)',
            'rgba(149, 134, 129, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stachyurus [stachyuraceae]/stachyurus yunnanensis/stachyurus yunnanensis (1).jpg',
          width: 576,
          id: '710f1537651aa2c2c02c8a4873be717b',
          height: 768,
          thumbnail: true,
        },
        location: [47.270783, -1.585305],
        genre: 'Stachyurus',
        famille: 'Stachyuraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585305, 47.270783] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8a911c89d67420692ac1c348776eed21dce0c783',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'carolina  Monticola Group',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 158, 123, 1.00)',
            'rgba(109, 120, 82, 1.00)',
            'rgba(85, 92, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/halesia [styracaceae]/halesia carolina  monticola group/halesia carolina monticola group (6).jpg',
          width: 1024,
          id: 'b12adc3c77ebce35447c4cc5c406ee73',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(55, 67, 37, 1.00)',
            'rgba(99, 108, 77, 1.00)',
            'rgba(76, 91, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/halesia [styracaceae]/halesia carolina  monticola group/halesia carolina monticola group (7).jpg',
          width: 1024,
          id: 'd98db5ea51b5bdeff9cbf3f337d266b1',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 147, 163, 1.00)',
            'rgba(120, 131, 140, 1.00)',
            'rgba(120, 130, 133, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/halesia [styracaceae]/halesia carolina  monticola group/halesia carolina monticola group (5).jpg',
          width: 889,
          id: '155223862704bcc3d0434f37bb2dc85b',
          height: 768,
          thumbnail: true,
        },
        location: [47.270497, -1.582003],
        genre: 'Halesia',
        famille: 'Styracaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582003, 47.270497] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '98558291fd0a00c61fd709cdfbc4610c8bb38e64',
      fields: {
        espece: 'carolina',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 137, 135, 1.00)',
            'rgba(132, 125, 120, 1.00)',
            'rgba(116, 105, 101, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/halesia [styracaceae]/halesia carolina/halesia carolina (12).jpg',
          width: 512,
          id: '2a30fa92c44de7eaa27f3aab31fed3eb',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 142, 139, 1.00)',
            'rgba(125, 115, 112, 1.00)',
            'rgba(95, 77, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/halesia [styracaceae]/halesia carolina/halesia carolina (11).jpg',
          width: 512,
          id: '6acd18307d2ca9f663591d1655992eeb',
          height: 768,
          thumbnail: true,
        },
        location: [47.270208, -1.58142],
        genre: 'Halesia',
        famille: 'Styracaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58142, 47.270208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ff0e6371a8d18d7e45a05833ed55252b341d0a7f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 88, 58, 1.00)',
            'rgba(104, 104, 87, 1.00)',
            'rgba(61, 61, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'polar ice'/camellia 'polar ice' (2).jpg",
          width: 1024,
          id: '4872df597f66e96c1f050afeff11185e',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 144, 105, 1.00)',
            'rgba(103, 121, 86, 1.00)',
            'rgba(100, 103, 85, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'polar ice'/camellia 'polar ice' (3).jpg",
          width: 512,
          id: '127745a26fbb6733f6eea53a42487213',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 130, 115, 1.00)',
            'rgba(79, 85, 64, 1.00)',
            'rgba(88, 81, 67, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'polar ice'/camellia 'polar ice' (1).jpg",
          width: 1024,
          id: 'aba8ee7664b26271499abdeea710e3c6',
          height: 683,
          thumbnail: true,
        },
        location: [47.268753, -1.584997],
        genre: 'Camellia',
        cultivar: 'Polar Ice',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584997, 47.268753] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c78c392fb8189f551f53abf6cb7864255771863e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 82, 43, 1.00)',
            'rgba(126, 135, 107, 1.00)',
            'rgba(80, 94, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'showa-wabisuke'/camellia 'showa-wabisuke' (2).jpg",
          width: 576,
          id: '6b3c028079a61ec62eb11d425c4aa9dc',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 162, 105, 1.00)',
            'rgba(107, 149, 88, 1.00)',
            'rgba(86, 117, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'showa-wabisuke'/camellia 'showa-wabisuke' (3).jpg",
          width: 576,
          id: '98aa995d8db4a7bec0fca2889533c888',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 141, 41, 1.00)',
            'rgba(129, 139, 44, 1.00)',
            'rgba(114, 126, 29, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'showa-wabisuke'/camellia 'showa-wabisuke' (1).jpg",
          width: 576,
          id: '26871822cced3f8e56b561feb7545185',
          height: 768,
          thumbnail: true,
        },
        location: [47.269695, -1.581655],
        genre: 'Camellia',
        cultivar: 'Sh\u00f4wa-wabisuke',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581655, 47.269695] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'efa1cafe4d143b4e283131b20883d9f37badb09a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 149, 138, 1.00)',
            'rgba(112, 97, 66, 1.00)',
            'rgba(103, 92, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'spring festival'/camellia 'spring festival' (5).jpg",
          width: 512,
          id: '28a252a62ec602973435bde98b58bf1b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 86, 60, 1.00)',
            'rgba(135, 96, 90, 1.00)',
            'rgba(70, 66, 39, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'spring festival'/camellia 'spring festival' (6).jpg",
          width: 1024,
          id: 'ca77c864ec9bd8a1627376ada958de5c',
          height: 710,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 164, 146, 1.00)',
            'rgba(97, 91, 57, 1.00)',
            'rgba(99, 89, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'spring festival'/camellia 'spring festival' (4).jpg",
          width: 1024,
          id: 'dc06af0df492fe127238473e49c0333e',
          height: 683,
          thumbnail: true,
        },
        location: [47.271375, -1.584422],
        genre: 'Camellia',
        cultivar: 'Spring Festival',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584422, 47.271375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '31954a8018e00cb1160f25c93c50803a17d4de34',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 84, 85, 1.00)',
            'rgba(101, 84, 105, 1.00)',
            'rgba(68, 72, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia hiemalis 'shishigashira'/camellia hiemalis 'shishigashira' (3).jpg",
          width: 1024,
          id: '7acbb40a522a86e07ba6914dd9a12c33',
          height: 683,
          thumbnail: true,
        },
        espece: 'hiemalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 120, 123, 1.00)',
            'rgba(102, 120, 123, 1.00)',
            'rgba(66, 82, 82, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia hiemalis 'shishigashira'/camellia hiemalis 'shishigashira' (2).jpg",
          width: 1024,
          id: '7e8e751755279cbe348f6f8a30f13c57',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 86, 81, 1.00)',
            'rgba(96, 114, 111, 1.00)',
            'rgba(114, 107, 105, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia hiemalis 'shishigashira'/camellia hiemalis 'shishigashira' (1).jpg",
          width: 1024,
          id: '807a340f92dd13a59c5755cf09e03d71',
          height: 683,
          thumbnail: true,
        },
        location: [47.27026, -1.586547],
        genre: 'Camellia',
        cultivar: 'Shishigashira',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586547, 47.27026] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1a99d187be0d91524bcc159e77690490d8fc96f8',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(65, 63, 44, 1.00)',
            'rgba(124, 61, 68, 1.00)',
            'rgba(101, 67, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'albertii'/camellia japonica 'albertii'.jpg",
          width: 1024,
          id: '73a712e8f5f9ccf549f5008eba85a6a0',
          height: 683,
          thumbnail: true,
        },
        location: [47.26773, -1.584153],
        genre: 'Camellia',
        cultivar: 'Albertii',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584153, 47.26773] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7e7ba942ca235ea36f8e8b4271426ca72ab1e990',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 95, 63, 1.00)',
            'rgba(122, 124, 88, 1.00)',
            'rgba(80, 94, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'asagao' (higo)/camellia japonica 'asagao' (higo).jpg",
          width: 1024,
          id: '77965c0f491462239226ae9c7dde5d1b',
          height: 719,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 152, 122, 1.00)',
            'rgba(149, 141, 93, 1.00)',
            'rgba(78, 66, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'asagao' (higo)/camellia japonica 'asagao' (higo) (2).jpg",
          width: 1024,
          id: '4ec0d752a274d65a5587559f9e5480ec',
          height: 745,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 139, 92, 1.00)',
            'rgba(111, 135, 90, 1.00)',
            'rgba(87, 111, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'asagao' (higo)/camellia japonica 'asagao' (higo) (1).jpg",
          width: 1024,
          id: 'b91dfeef0675e6b7f8fb319b3701d924',
          height: 683,
          thumbnail: true,
        },
        location: [47.269678, -1.584903],
        genre: 'Camellia',
        cultivar: 'Asagao (Higo)',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584903, 47.269678] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6f411a7e62afece9ca5df7451644a3324ab53832',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 113, 80, 1.00)',
            'rgba(111, 83, 64, 1.00)',
            'rgba(80, 66, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'ausonia'/camellia japonica 'ausonia'.jpg",
          width: 1024,
          id: '621084cd2267cb59f33d6ca5468e7a5b',
          height: 683,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Ausonia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6c842ed9bd85ea1ea6f81d2be74b5969adb1c0f5',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 141, 134, 1.00)',
            'rgba(91, 96, 87, 1.00)',
            'rgba(83, 87, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'clovis guervel'/camellia japonica 'clovis guervel' (3).jpg",
          width: 1024,
          id: '52b7e3a9cc296c3bdf9a40640a07e001',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 80, 72, 1.00)',
            'rgba(115, 50, 43, 1.00)',
            'rgba(70, 41, 30, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'clovis guervel'/camellia japonica 'clovis guervel' (2).jpg",
          width: 1024,
          id: '9ef715fc7e6b5de4d285b1b33ef4b6b0',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 87, 76, 1.00)',
            'rgba(118, 122, 104, 1.00)',
            'rgba(57, 69, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'clovis guervel'/camellia japonica 'clovis guervel' (1).jpg",
          width: 1024,
          id: 'cb463098f2bff8d737bf650848ada9b8',
          height: 683,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Camellia',
        cultivar: 'Clovis Guervel',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f8381409f4b826e7be11de6dd72473a341303d5f',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 68, 51, 1.00)',
            'rgba(141, 138, 133, 1.00)',
            'rgba(57, 64, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'compacta alba'/camellia japonica 'compacta alba' (3).jpg",
          width: 576,
          id: '3fb1d281dd53914ecdbd224958279ea0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 161, 124, 1.00)',
            'rgba(97, 132, 81, 1.00)',
            'rgba(132, 139, 107, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'compacta alba'/camellia japonica 'compacta alba' (1).jpg",
          width: 576,
          id: 'bba845be21cf5828aeb0156faf7ca8be',
          height: 768,
          thumbnail: true,
        },
        location: [47.27005, -1.585033],
        genre: 'Camellia',
        cultivar: 'Compacta Alba',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585033, 47.27005] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a61d53a88d58586747751e4f442840a00ac10f0b',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(63, 73, 59, 1.00)',
            'rgba(112, 100, 95, 1.00)',
            'rgba(67, 65, 52, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'debutante'/camellia japonica 'debutante'.jpg",
          width: 1024,
          id: '25242f1bd1f6e5b64406076a2cb51245',
          height: 683,
          thumbnail: true,
        },
        location: [47.26867, -1.585003],
        genre: 'Camellia',
        cultivar: 'Debutante',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585003, 47.26867] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b312f166ecf525bf9a89884c2f15ee1a7d5ddc90',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(50, 50, 43, 1.00)',
            'rgba(107, 93, 86, 1.00)',
            'rgba(87, 84, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'desire'/camellia japonica 'desire'.jpg",
          width: 1024,
          id: 'd9c9a0d1bbb6c01b1d844b4383ab299d',
          height: 683,
          thumbnail: true,
        },
        location: [47.269547, -1.583794],
        genre: 'Camellia',
        cultivar: 'Desire',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583794, 47.269547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '93baa0c5cde53c1adb99f4fb8b67447b53adbdcb',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 88, 65, 1.00)',
            'rgba(132, 138, 122, 1.00)',
            'rgba(89, 96, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'fimbriata'/camellia japonica 'fimbriata' (3).jpg",
          width: 1024,
          id: '20ca6b7b8fbd5dff418d537d47429a58',
          height: 603,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 79, 62, 1.00)',
            'rgba(120, 126, 113, 1.00)',
            'rgba(68, 76, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'fimbriata'/camellia japonica 'fimbriata' (2).jpg",
          width: 1024,
          id: '517fb5e9f6c0b6086e64b31db93b27b3',
          height: 647,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 114, 98, 1.00)',
            'rgba(88, 97, 82, 1.00)',
            'rgba(84, 82, 77, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'fimbriata'/camellia japonica 'fimbriata' (1).jpg",
          width: 1024,
          id: '162b4f79abe65e0785efcf89a8db5026',
          height: 683,
          thumbnail: true,
        },
        location: [47.269692, -1.585737],
        genre: 'Camellia',
        cultivar: 'Fimbriata',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585737, 47.269692] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '986cf0534ec3a816bd41d6b237f3ad82f1ea8bdc',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(167, 171, 170, 1.00)',
            'rgba(90, 96, 82, 1.00)',
            'rgba(63, 70, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'il cigno'/camellia japonica 'il cigno' (3).jpg",
          width: 576,
          id: 'dc7a4967c2a20f1525fc7b318dc0d04b',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(35, 36, 38, 1.00)',
            'rgba(135, 135, 148, 1.00)',
            'rgba(60, 61, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'il cigno'/camellia japonica 'il cigno' (2).jpg",
          width: 576,
          id: '53ec988892a84ec2a5a3a09182c9ebd5',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 129, 125, 1.00)',
            'rgba(125, 131, 141, 1.00)',
            'rgba(95, 98, 95, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'il cigno'/camellia japonica 'il cigno' (1).jpg",
          width: 576,
          id: 'cd1e5f526ee81a07f0bb5c33bbe9a983',
          height: 768,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Il Cigno',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2522df51a90cf526986bad91033554c3e703295e',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 85, 57, 1.00)',
            'rgba(107, 81, 63, 1.00)',
            'rgba(86, 81, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'kumagai'/camellia japonica 'kumagai' (4).jpg",
          width: 1024,
          id: '5177e95e7f2b107b9d9a61c80576c5ec',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 149, 132, 1.00)',
            'rgba(99, 115, 76, 1.00)',
            'rgba(105, 111, 71, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'kumagai'/camellia japonica 'kumagai' (2).jpg",
          width: 1024,
          id: 'c066ffc0a21540f3368fb25fd25391de',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 49, 36, 1.00)',
            'rgba(140, 68, 71, 1.00)',
            'rgba(112, 66, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'kumagai'/camellia japonica 'kumagai' (1).jpg",
          width: 1024,
          id: '0246d03cd87e87836da728af1535e3ae',
          height: 683,
          thumbnail: true,
        },
        location: [47.270367, -1.584025],
        genre: 'Camellia',
        cultivar: 'Kumagai',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584025, 47.270367] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd4d86ceddcb47cc06cf9c5d700036b203dff4f41',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 71, 41, 1.00)',
            'rgba(148, 136, 132, 1.00)',
            'rgba(60, 59, 39, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'maria bagnasco'/camellia japonica 'maria bagnasco' (3).jpg",
          width: 576,
          id: 'fc8bd7a1fd6fd361721a6e055b68e5ad',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 152, 120, 1.00)',
            'rgba(123, 132, 69, 1.00)',
            'rgba(105, 110, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'maria bagnasco'/camellia japonica 'maria bagnasco' (1).jpg",
          width: 576,
          id: '29ec3049b7654a40127c4bbeb0497d7e',
          height: 768,
          thumbnail: true,
        },
        location: [47.271412, -1.584437],
        genre: 'Camellia',
        cultivar: 'Maria Bagnasco',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584437, 47.271412] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3b9d889cc26b50193fe48ba59218e92f447a5385',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 135, 111, 1.00)',
            'rgba(92, 99, 58, 1.00)',
            'rgba(93, 89, 65, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'marie-curie'/camellia japonica 'marie-curie' (3).jpg",
          width: 1024,
          id: '7ae63cefeb66335bb2b884c4c7b8a4a9',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 71, 54, 1.00)',
            'rgba(126, 75, 75, 1.00)',
            'rgba(97, 72, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'marie-curie'/camellia japonica 'marie-curie' (2).jpg",
          width: 1024,
          id: 'a6b87f79ae5d1f1e8fb1ac9a32cd7851',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 69, 58, 1.00)',
            'rgba(125, 73, 72, 1.00)',
            'rgba(86, 65, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'marie-curie'/camellia japonica 'marie-curie' (1).jpg",
          width: 1024,
          id: '9233793ec14287bb2ebf71b9bc7593ca',
          height: 683,
          thumbnail: true,
        },
        location: [47.269797, -1.584297],
        genre: 'Camellia',
        cultivar: 'Marie-Curie',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584297, 47.269797] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ffc28deee2de07799cfb7a36fcd117e7bfe2ec35',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 75, 67, 1.00)',
            'rgba(139, 83, 91, 1.00)',
            'rgba(91, 67, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'oo-la-la'/camellia japonica 'oo-la-la' (5).jpg",
          width: 1024,
          id: '781d9589044c896912258683725ee5d3',
          height: 684,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 115, 94, 1.00)',
            'rgba(104, 112, 102, 1.00)',
            'rgba(77, 85, 84, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'oo-la-la'/camellia japonica 'oo-la-la' (4).jpg",
          width: 1024,
          id: 'e1d644e710094c67081456ea4705e0cd',
          height: 683,
          thumbnail: true,
        },
        location: [47.269825, -1.582238],
        genre: 'Camellia',
        cultivar: 'Oo-La-La',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582238, 47.269825] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '907f0da385ef0f87e35ea376c192e966b379f6a7',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(46, 51, 40, 1.00)',
            'rgba(141, 121, 128, 1.00)',
            'rgba(52, 61, 43, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'shuchuka'/camellia japonica 'shuchuka' (3).jpg",
          width: 576,
          id: '238c48777bbe4168927adbe0c6c63328',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 86, 67, 1.00)',
            'rgba(127, 142, 126, 1.00)',
            'rgba(92, 101, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'shuchuka'/camellia japonica 'shuchuka' (2).jpg",
          width: 576,
          id: 'c0261d5941ad7c8d2e0285d564e65d3a',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(171, 179, 165, 1.00)',
            'rgba(87, 100, 78, 1.00)',
            'rgba(94, 93, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'shuchuka'/camellia japonica 'shuchuka' (1).jpg",
          width: 576,
          id: '7f9c5da71916d5349ac82d657a42ae28',
          height: 768,
          thumbnail: true,
        },
        location: [47.270463, -1.581287],
        genre: 'Camellia',
        cultivar: 'Shuch\u00fbka',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581287, 47.270463] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '30ca9fe7622f41cf75ece87b57e24c6ca44c1244',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(75, 79, 53, 1.00)',
            'rgba(107, 90, 72, 1.00)',
            'rgba(71, 74, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'smellie nellie'/camellia japonica 'smellie nellie' (2).jpg",
          width: 1024,
          id: 'eeff2f2c0f235c8b580a70f6260a2be0',
          height: 675,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 123, 114, 1.00)',
            'rgba(88, 98, 73, 1.00)',
            'rgba(77, 85, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'smellie nellie'/camellia japonica 'smellie nellie' (1).jpg",
          width: 1024,
          id: '46b783690d7e9205e9d90ea9c33785e9',
          height: 683,
          thumbnail: true,
        },
        location: [47.270533, -1.585647],
        genre: 'Camellia',
        cultivar: 'Smellie Nellie',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585647, 47.270533] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a44fcb45dc8c12db771290317687d9925432cba3',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 93, 70, 1.00)',
            'rgba(114, 83, 78, 1.00)',
            'rgba(81, 65, 63, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'villa madre'/camellia japonica 'villa madre'.jpg",
          width: 1024,
          id: 'bdf2e7a59bcd229ae5308d1e878137b2',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(25, 22, 13, 1.00)',
            'rgba(99, 54, 42, 1.00)',
            'rgba(58, 43, 35, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'villa madre'/camellia japonica 'villa madre' (2).jpg",
          width: 1024,
          id: 'c45df611fe146833acfd4c4ad697cee8',
          height: 683,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Villa Madre',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8abea9ef6c4e9c907694ba48c7a718905df6a0d3',
      fields: {
        espece: 'sasanqua',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 142, 121, 1.00)',
            'rgba(81, 99, 74, 1.00)',
            'rgba(71, 84, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'asakura'/camellia sasanqua 'asakura' (4).jpg",
          width: 1024,
          id: '564b375cf4c3e40f8b2d9e24e70fb398',
          height: 683,
          thumbnail: true,
        },
        location: [47.270517, -1.581347],
        genre: 'Camellia',
        cultivar: 'Asakura',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581347, 47.270517] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f4348d063f041bcfe165d9014693542d5106cbfc',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 119, 72, 1.00)',
            'rgba(131, 124, 75, 1.00)',
            'rgba(88, 109, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'narumigata'/camellia sasanqua 'narumigata' (3).jpg",
          width: 576,
          id: '6b2d78e7f3aa1ee28117f9ecbdeb8c52',
          height: 768,
          thumbnail: true,
        },
        espece: 'sasanqua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 95, 106, 1.00)',
            'rgba(100, 95, 62, 1.00)',
            'rgba(90, 88, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'narumigata'/camellia sasanqua 'narumigata' (2).jpg",
          width: 1024,
          id: 'd19d185962f8b20919b60c4e24e5acb1',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(53, 57, 21, 1.00)',
            'rgba(110, 105, 60, 1.00)',
            'rgba(62, 64, 31, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'narumigata'/camellia sasanqua 'narumigata' (1).jpg",
          width: 1024,
          id: 'd6bff2d0e74756073b7bbfa314b14e7d',
          height: 683,
          thumbnail: true,
        },
        location: [47.271122, -1.582878],
        genre: 'Camellia',
        cultivar: 'Narumigata',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582878, 47.271122] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a8aee962e7b35424af683b352ac788d1dbfb1e21',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 59, 43, 1.00)',
            'rgba(182, 119, 112, 1.00)',
            'rgba(78, 59, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'plantation pink'/camellia sasanqua 'plantation pink'  (3).jpg",
          width: 561,
          id: '1638aa203dc88b614c629cdef20e8615',
          height: 768,
          thumbnail: true,
        },
        espece: 'sasanqua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 125, 131, 1.00)',
            'rgba(102, 100, 92, 1.00)',
            'rgba(98, 104, 101, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'plantation pink'/camellia sasanqua 'plantation pink'  (2).jpg",
          width: 512,
          id: 'a6eb3f72215af8464dd070d1fb8224fd',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 77, 51, 1.00)',
            'rgba(104, 93, 65, 1.00)',
            'rgba(61, 63, 35, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'plantation pink'/camellia sasanqua 'plantation pink'  (1).jpg",
          width: 1024,
          id: 'fc48a56742bef342b559c5bae52c3eb0',
          height: 683,
          thumbnail: true,
        },
        location: [47.27028, -1.585858],
        genre: 'Camellia',
        cultivar: 'Plantation Pink',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585858, 47.27028] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'db1823fb8c8b8dcadea003f4dc5762f9bb1cd567',
      fields: {
        espece: 'sasanqua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(59, 73, 53, 1.00)',
            'rgba(97, 103, 87, 1.00)',
            'rgba(52, 62, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'versicolor'/camellia sasanqua 'versicolor'  (3).jpg",
          width: 1024,
          id: '8092e12524e2ec11800344d6e0c51456',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 140, 132, 1.00)',
            'rgba(94, 104, 89, 1.00)',
            'rgba(80, 86, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'versicolor'/camellia sasanqua 'versicolor'  (2).jpg",
          width: 1024,
          id: '309905d989b0410b8f64b260f6e7c63d',
          height: 683,
          thumbnail: true,
        },
        location: [47.27026, -1.586547],
        genre: 'Camellia',
        cultivar: 'Versicolor',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586547, 47.27026] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7442ceb2bf05bd95bc7229ed8c84dd7981ddd421',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'tsaii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 153, 112, 1.00)',
            'rgba(110, 117, 59, 1.00)',
            'rgba(88, 93, 49, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia tsaii/camellia tsaii  (2).jpg',
          width: 1024,
          id: '5040d2c6a209812ebe035b59ff3b5637',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 163, 130, 1.00)',
            'rgba(119, 120, 66, 1.00)',
            'rgba(75, 83, 40, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia tsaii/camellia tsaii  (3).jpg',
          width: 1024,
          id: 'd580fdc7e005a9e14f7030ea6c3cfd3e',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 106, 55, 1.00)',
            'rgba(127, 124, 82, 1.00)',
            'rgba(104, 120, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia tsaii/camellia tsaii  (1).jpg',
          width: 1024,
          id: '35f5a3f9887ac2d9e4713cbf2acea372',
          height: 683,
          thumbnail: true,
        },
        location: [47.269513, -1.584417],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584417, 47.269513] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9276c191188556db7d34af0fbe17159a27702275',
      fields: {
        espece: 'x williamsii',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 124, 107, 1.00)',
            'rgba(111, 125, 111, 1.00)',
            'rgba(83, 96, 81, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'garden glory'/camellia x williamsii 'garden glory' (1).jpg",
          width: 1024,
          id: '5eb583a1731b2d7c2cdaca70e91f9ba3',
          height: 683,
          thumbnail: true,
        },
        location: [47.269797, -1.584153],
        genre: 'Camellia',
        cultivar: 'Garden Glory',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584153, 47.269797] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bd216a491cb9222f6bbeb7223870637a3a43451c',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 125, 102, 1.00)',
            'rgba(98, 107, 97, 1.00)',
            'rgba(74, 85, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'mildred veitch'/camellia x williamsii 'mildred veitch' (3).jpg",
          width: 1024,
          id: '0f6868a03ec82af6a8fb7091266e8030',
          height: 683,
          thumbnail: true,
        },
        espece: 'x williamsii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(52, 57, 47, 1.00)',
            'rgba(105, 88, 85, 1.00)',
            'rgba(73, 61, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'mildred veitch'/camellia x williamsii 'mildred veitch' (2).jpg",
          width: 1024,
          id: '9539992fadd7cb1dba9bdced552def50',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 122, 98, 1.00)',
            'rgba(110, 125, 70, 1.00)',
            'rgba(100, 94, 65, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'mildred veitch'/camellia x williamsii 'mildred veitch' (1).jpg",
          width: 512,
          id: '61d0390e43ef513d61a1dc5ca9ad425b',
          height: 768,
          thumbnail: true,
        },
        location: [47.269655, -1.583633],
        genre: 'Camellia',
        cultivar: 'Mildred Veitch',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583633, 47.269655] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ea1b7b7c1e5bf3d5c7f966247c8888a145b3b5c0',
      fields: {
        espece: 'odora',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(192, 192, 177, 1.00)',
            'rgba(108, 108, 72, 1.00)',
            'rgba(82, 69, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/daphne [thymelaeaceae]/daphne odora 'aureomarginata'/daphne odora 'aureomarginata' (6).jpg",
          width: 1024,
          id: 'eea9875e00ecce0ae0ad6d0f6cd19e5c',
          height: 683,
          thumbnail: true,
        },
        location: [47.27087, -1.584737],
        genre: 'Daphne',
        cultivar: 'Aureomarginata',
        famille: 'Thymelaeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584737, 47.27087] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '064f7aa28c630ad57cc3cd99102b6362c92c3bd8',
      fields: {
        espece: 'chrysantha',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 87, 61, 1.00)',
            'rgba(122, 106, 82, 1.00)',
            'rgba(114, 94, 74, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/edgeworthia [thymelaeaceae]/edgeworthia chrysantha/edgeworthia chrysantha.jpg",
          width: 512,
          id: 'efd796b64d071c34c66d5f2095fe1491',
          height: 768,
          thumbnail: true,
        },
        location: [47.226825, -1.512387],
        genre: 'Edgeworthia',
        famille: 'Thymelaeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512387, 47.226825] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7a6eae03f7763ae66befc9c2a51b04e73000347f',
      fields: {
        espece: 'platyphyllos',
        localisation: 'B2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201934, -1.5449557],
        genre: 'Tilia',
        date_plantation: '1973',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449557, 47.2201934] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'de109f28cd6f27eed60db0fd73f133a1f8f067b2',
      fields: {
        origine: 'P\u00e9pini\u00e8re Ville de Nantes',
        espece: 'carpinifolia',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Zelkova',
        date_plantation: '2014',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5d6c9cf59a2038b26a17b859ad1636611b5b9a16',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'citriodora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 141, 109, 1.00)',
            'rgba(126, 139, 93, 1.00)',
            'rgba(88, 111, 41, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/aloysia [verbenaceae]/aloysia citriodora/aloysia citriodora (2).jpg",
          width: 576,
          id: '3b78e8474b297545542000e1c9d394b0',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 139, 54, 1.00)',
            'rgba(127, 153, 61, 1.00)',
            'rgba(120, 145, 57, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/aloysia [verbenaceae]/aloysia citriodora/aloysia citriodora (3).jpg",
          width: 1024,
          id: '4a112216392634afbbaf9112f22ae127',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 168, 125, 1.00)',
            'rgba(111, 134, 56, 1.00)',
            'rgba(116, 121, 67, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/aloysia [verbenaceae]/aloysia citriodora/aloysia citriodora (1).jpg",
          width: 1024,
          id: '59932246a9d403f872da077149b5c72e',
          height: 768,
          thumbnail: true,
        },
        location: [47.226833, -1.512333],
        genre: 'Aloysia',
        famille: 'Verbenaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512333, 47.226833] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '042936f4b66d7976c25bec8490433f695e8f54cc',
      fields: {
        espece: 'tricuspidata',
        localisation: 'A5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2207668, -1.5440149],
        genre: 'Parthenocissus',
        date_plantation: '1973',
        famille: 'Vitaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440149, 47.2207668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5d1a5ec74db1a46cec05f0bd9899a7a5ec42d4c3',
      fields: {
        origine: 'B.G. Freidrich Jena (All.)',
        espece: 'altaicus Steven',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Eremurus',
        date_plantation: '2012',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '347c456260a1984f5182637183d9109ce5256227',
      fields: {
        origine: 'J.B. Juan Carlos 1 Alcala de Henares,Espagne',
        espece: 'aestivus Brot.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Asphodelus',
        date_plantation: '2014',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1d694840396adb6940632f9fded6eb137ef0d9be',
      fields: {
        origine: 'J.B.Alpin "La Jaysinia" Samoins,France',
        espece: 'albus Mill.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Asphodelus',
        date_plantation: '2013',
        cultivar: 'subsp.albus',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b5b659a09542b86626f6a06beae8288bc72c055f',
      fields: {
        origine: 'JB.Christchurch',
        espece: 'nigra Colenso.',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Dianella',
        date_plantation: '1989',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ee1ee1109e4f90fcbab0c4407078583f6f0691ee',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'liburnica Reichb.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Asphodeline',
        date_plantation: '2006',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2abf58038d4bf91dedc9bc41f9a874bc2fd2584b',
      fields: {
        origine: 'JBU.Hongrie',
        espece: 'liburnica Reichb.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Asphodeline',
        date_plantation: '1996',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '75f8d70f2e3d40cce376c3f89a6edca3120275bb',
      fields: {
        espece: 'cookianum Le Jolis',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Phormium',
        date_plantation: '1973',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '64b8f974694ce34396eba026319af908f4e8b142',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'grosseri var. hersii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 160, 128, 1.00)',
            'rgba(117, 122, 76, 1.00)',
            'rgba(112, 109, 75, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/acer/acer grosseri var. hersii/acer grosseri var. hersii (2).jpg',
          width: 576,
          id: '6fd82df51a1036aa67570c3e55c58898',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 151, 105, 1.00)',
            'rgba(135, 144, 80, 1.00)',
            'rgba(125, 126, 61, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/acer/acer grosseri var. hersii/acer grosseri var. hersii (3).jpg',
          width: 576,
          id: 'bccce600924932a3ae0f19454410ce8a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 146, 83, 1.00)',
            'rgba(132, 147, 62, 1.00)',
            'rgba(136, 140, 64, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/acer/acer grosseri var. hersii/acer grosseri var. hersii (1).jpg',
          width: 611,
          id: '1c809594b49832d1a5c4e8be8da50162',
          height: 768,
          thumbnail: true,
        },
        location: [47.220478, -1.543925],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543925, 47.220478] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '49ec832e4f4e9fab8fdc385e401bf5b39d3ba19c',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(183, 181, 141, 1.00)',
            'rgba(123, 96, 65, 1.00)',
            'rgba(100, 103, 64, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer palmatum 'atropurpureum'/acer palmatum 'atropurpureum' .jpg",
          width: 576,
          id: '8e68f5f66d099bfe6b48e475f00cd455',
          height: 768,
          thumbnail: true,
        },
        espece: 'palmatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(173, 152, 125, 1.00)',
            'rgba(112, 84, 59, 1.00)',
            'rgba(103, 98, 66, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer palmatum 'atropurpureum'/acer palmatum 'atropurpureum' (4).jpg",
          width: 576,
          id: 'eed7d2095e4b3df27190f2275e8fdf7e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(171, 141, 138, 1.00)',
            'rgba(120, 84, 76, 1.00)',
            'rgba(103, 93, 70, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer palmatum 'atropurpureum'/acer palmatum 'atropurpureum'  (2).jpg",
          width: 512,
          id: 'dab26a93bd6a7d48a541df2274ef725b',
          height: 768,
          thumbnail: true,
        },
        location: [47.223, -1.57968],
        genre: 'Acer',
        cultivar: 'Atropurpureum',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.57968, 47.223] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1e43b5e829366d893e59b3226d5d89e90f8e71b2',
      fields: {
        espece: 'palmatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 137, 77, 1.00)',
            'rgba(181, 149, 75, 1.00)',
            'rgba(142, 111, 42, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer palmatum 'orange dream'/acer palmatum 'orange dream' (2).jpg",
          width: 576,
          id: 'ec47b1b379c4d7d22cbeb5d4413923e2',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 143, 35, 1.00)',
            'rgba(157, 152, 43, 1.00)',
            'rgba(132, 122, 39, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer palmatum 'orange dream'/acer palmatum 'orange dream' (1).jpg",
          width: 576,
          id: '684512d897cb96a23f4752ffb4961483',
          height: 768,
          thumbnail: true,
        },
        location: [47.225328, -1.581147],
        genre: 'Acer',
        cultivar: 'Orange Dream',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581147, 47.225328] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '14f4199aa1adbc9392d3c20b6add77b9300ee046',
      fields: {
        espece: 'palmatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(187, 200, 164, 1.00)',
            'rgba(93, 112, 45, 1.00)',
            'rgba(71, 72, 41, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer palmatum 'sango-kaku'/acer palmatum 'sango-kaku' (2).jpg",
          width: 576,
          id: '63747298ec59ef077de32c9428b7158f',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 96, 43, 1.00)',
            'rgba(118, 123, 42, 1.00)',
            'rgba(115, 108, 46, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer palmatum 'sango-kaku'/acer palmatum 'sango-kaku' (1).jpg",
          width: 576,
          id: '357059acf387fd14529db20ea766f6e0',
          height: 768,
          thumbnail: true,
        },
        location: [47.225255, -1.581337],
        genre: 'Acer',
        cultivar: 'Sango-kaku',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581337, 47.225255] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b68114e971f0a742ee4b502394d3f99fa17ee070',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 138, 35, 1.00)',
            'rgba(124, 160, 55, 1.00)',
            'rgba(97, 105, 64, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/acer/acer davidii 'george forrest'/acer davidii 'george forrest' (3).jpg",
          width: 576,
          id: 'b75f6617a0ba0f15663c49d2c7fe0d9d',
          height: 768,
          thumbnail: true,
        },
        espece: 'davidii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 162, 131, 1.00)',
            'rgba(129, 128, 83, 1.00)',
            'rgba(101, 95, 66, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/acer/acer davidii 'george forrest'/acer davidii 'george forrest' (2).jpg",
          width: 576,
          id: '40a88ce4815ff58c9045a286ec23809d',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(193, 197, 169, 1.00)',
            'rgba(145, 154, 114, 1.00)',
            'rgba(87, 90, 61, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/acer/acer davidii 'george forrest'/acer davidii 'george forrest' (1).jpg",
          width: 576,
          id: '72a01086c05c5a5dc3186050c51c7d9d',
          height: 768,
          thumbnail: true,
        },
        location: [47.228233, -1.508047],
        genre: 'Acer',
        cultivar: 'George Forrest',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508047, 47.228233] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f4ed2dde56bb9415a987e91fff151d6bafb2480a',
      fields: {
        espece: 'saccharinum',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 165, 186, 1.00)',
            'rgba(126, 133, 90, 1.00)',
            'rgba(114, 111, 83, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/acer/acer saccharinum/acer saccharinum.jpg',
          width: 1024,
          id: '88c737fb56763b336060ce7755b27afa',
          height: 768,
          thumbnail: true,
        },
        location: [47.227317, -1.51025],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.51025, 47.227317] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '67646ab4832103747f401966874b4700a76989cf',
      fields: {
        espece: 'hippocastanum',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 142, 99, 1.00)',
            'rgba(105, 118, 68, 1.00)',
            'rgba(131, 129, 86, 1.00)',
          ],
          filename:
            "ip parc de proce/aesculus/aesculus hippocastanum 'monstrosa'/aesculus hippocastanum 'monstrosa'.jpg",
          width: 576,
          id: '3581ff89c3b5cb5920da69d91782236f',
          height: 768,
          thumbnail: true,
        },
        location: [47.224853, -1.581287],
        genre: 'Aesculus',
        cultivar: 'Monstrosa',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581287, 47.224853] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f06651e79715dccc1a96d4d34714362d6ccb1ee2',
      fields: {
        espece: 'altissima',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(220, 223, 219, 1.00)',
            'rgba(97, 104, 80, 1.00)',
            'rgba(50, 48, 39, 1.00)',
          ],
          filename:
            'ip ville de nantes/ailanthus/ailanthus altissima/ailanthus altissima.jpg',
          width: 576,
          id: 'cf15c9f33521c9cc405bd3316032ad35',
          height: 768,
          thumbnail: true,
        },
        location: [47.218125, -1.555053],
        genre: 'Ailanthus',
        famille: 'Simaroubaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.555053, 47.218125] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0d47a6e64f94243274cc907cf3ff6effdb08e24d',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'julibrissin',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(63, 89, 54, 1.00)',
            'rgba(127, 131, 94, 1.00)',
            'rgba(99, 117, 57, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/albizia/albizia julibrissin/albizia julibrissin (1).jpg',
          width: 576,
          id: '666a4ef46cf73171ef96f6cfdb7226b5',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(55, 99, 57, 1.00)',
            'rgba(79, 117, 75, 1.00)',
            'rgba(134, 151, 122, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/albizia/albizia julibrissin/albizia julibrissin (2).jpg',
          width: 576,
          id: '81fba8d934f870b339e752a69daa130c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 135, 176, 1.00)',
            'rgba(123, 130, 149, 1.00)',
            'rgba(62, 62, 49, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/albizia/albizia julibrissin/albizia julibrissin  (2).jpg',
          width: 512,
          id: 'af58c8f16ef720782e9f8ad1e60275f9',
          height: 768,
          thumbnail: true,
        },
        location: [47.261628, -1.533322],
        genre: 'Albizia',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533322, 47.261628] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bda83d17ffc38b183334e3a4a171d1b9fe0ff17a',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'fruticosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 117, 97, 1.00)',
            'rgba(97, 124, 54, 1.00)',
            'rgba(103, 117, 55, 1.00)',
          ],
          filename:
            'ip parc de proce/amorpha/amorpha fruticosa/amorpha fruticosa (2).jpg',
          width: 1024,
          id: 'fe108ce0acecd045527060468f8ebca4',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 165, 85, 1.00)',
            'rgba(129, 150, 79, 1.00)',
            'rgba(113, 131, 66, 1.00)',
          ],
          filename:
            'ip parc de proce/amorpha/amorpha fruticosa/amorpha fruticosa (3).jpg',
          width: 576,
          id: 'b37b89dc357f6be32f40cb7f937b6bf7',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 163, 71, 1.00)',
            'rgba(118, 125, 72, 1.00)',
            'rgba(128, 146, 76, 1.00)',
          ],
          filename:
            'ip parc de proce/amorpha/amorpha fruticosa/amorpha fruticosa (1).jpg',
          width: 576,
          id: '98ebc43954133abc5adf5231a92beb72',
          height: 768,
          thumbnail: true,
        },
        location: [47.22517, -1.58313],
        genre: 'Amorpha',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58313, 47.22517] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '47f1aaf8054791194c628036d9633ddce70ca3a2',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'x andrachnoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 131, 108, 1.00)',
            'rgba(113, 98, 71, 1.00)',
            'rgba(82, 70, 43, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/arbutus/arbutus x andrachnoides/arbutus x andrachnoides (6).jpg',
          width: 552,
          id: '40c3cd705dbaed4f98107d3910ab7cf0',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 130, 152, 1.00)',
            'rgba(112, 117, 101, 1.00)',
            'rgba(117, 116, 70, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/arbutus/arbutus x andrachnoides/arbutus x andrachnoides.jpg',
          width: 619,
          id: 'f7ad9cfba57e907f893ff8700db68d9d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(176, 152, 129, 1.00)',
            'rgba(143, 118, 91, 1.00)',
            'rgba(131, 109, 90, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/arbutus/arbutus x andrachnoides/arbutus x andrachnoides (2).jpg',
          width: 576,
          id: '6eb7a6fc8a24f7ff140d0dea218ce2f1',
          height: 768,
          thumbnail: true,
        },
        location: [47.219545, -1.542075],
        genre: 'Arbutus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542075, 47.219545] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '914bd9c4d957778d162d812f8b60c099daf2fa5b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 135, 80, 1.00)',
            'rgba(104, 133, 89, 1.00)',
            'rgba(133, 164, 95, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/buddleja scrophulariaceae/buddleja lindleyana/buddleja lindleyana (2).jpg',
          width: 576,
          id: '29216142daa2702914c7e2223c99ece0',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 132, 74, 1.00)',
            'rgba(101, 141, 73, 1.00)',
            'rgba(133, 160, 96, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/buddleja scrophulariaceae/buddleja lindleyana/buddleja lindleyana (3).jpg',
          width: 576,
          id: '46bc9edffdecab5f041f3975bb0d2017',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 147, 91, 1.00)',
            'rgba(92, 138, 64, 1.00)',
            'rgba(140, 171, 108, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/buddleja scrophulariaceae/buddleja lindleyana/buddleja lindleyana (1).jpg',
          width: 576,
          id: '4295b9ec0c8fe2270a492aed5acf5117',
          height: 768,
          thumbnail: true,
        },
        location: [47.270462, -1.582722],
        genre: 'Buddleja',
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582722, 47.270462] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dcb171ede437a388c666d9d9ccb0be26162fba0e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 124, 71, 1.00)',
            'rgba(114, 147, 61, 1.00)',
            'rgba(122, 142, 44, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/buddleja scrophulariaceae/buddleja x weyeriana 'sungold'/buddleja x weyeriana 'sungold'  (2).jpg",
          width: 576,
          id: '3f6bda542c4685a7221c81981f208e6a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 138, 136, 1.00)',
            'rgba(109, 127, 115, 1.00)',
            'rgba(87, 108, 83, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/buddleja scrophulariaceae/buddleja x weyeriana 'sungold'/buddleja x weyeriana 'sungold' (3).jpg",
          width: 576,
          id: '7ad3ff5cad35d14a364448b8a670e283',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 113, 61, 1.00)',
            'rgba(128, 123, 45, 1.00)',
            'rgba(110, 121, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/buddleja scrophulariaceae/buddleja x weyeriana 'sungold'/buddleja x weyeriana 'sungold'  (1).jpg",
          width: 576,
          id: '2b9319ca4b388af68b1064670bec9fe2',
          height: 768,
          thumbnail: true,
        },
        location: [47.270787, -1.581397],
        genre: 'Buddleja',
        cultivar: 'Sungold',
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581397, 47.270787] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '86648d6421f3dddd2e037779a485d76e6a4c9c66',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'sempervirens',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 126, 87, 1.00)',
            'rgba(137, 130, 85, 1.00)',
            'rgba(138, 122, 84, 1.00)',
          ],
          filename:
            'ip parc de proce/buxus/buxus sempervirens/buxus sempervirens (3).jpg',
          width: 576,
          id: '2f44c566f8716ed30ef830a8cd72a89e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(181, 182, 182, 1.00)',
            'rgba(114, 119, 97, 1.00)',
            'rgba(113, 116, 70, 1.00)',
          ],
          filename:
            'ip parc de proce/buxus/buxus sempervirens/buxus sempervirens (4).jpg',
          width: 1024,
          id: '729382c7aeb556b2e742e1a82162646f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 109, 72, 1.00)',
            'rgba(135, 145, 83, 1.00)',
            'rgba(125, 124, 76, 1.00)',
          ],
          filename:
            'ip parc de proce/buxus/buxus sempervirens/buxus sempervirens (1).jpg',
          width: 576,
          id: 'c1f5b63838259bcd69a25806542a6b54',
          height: 768,
          thumbnail: true,
        },
        location: [47.223292, -1.582472],
        genre: 'Buxus',
        famille: 'Buxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582472, 47.223292] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f79ab4eee3c88a937aa88dfa3aa1d02b33a9433a',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'pallidus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(182, 186, 181, 1.00)',
            'rgba(96, 103, 79, 1.00)',
            'rgba(69, 69, 44, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/callistemon/callistemon pallidus/callistemon pallidus (2).jpg',
          width: 1024,
          id: '039fbb0b03fdedf7eb98fe9d8302559a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 102, 84, 1.00)',
            'rgba(135, 151, 136, 1.00)',
            'rgba(136, 141, 132, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/callistemon/callistemon pallidus/callistemon pallidus (3).jpg',
          width: 576,
          id: 'dd8c61655866a97735f532c9a013fff3',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(53, 56, 52, 1.00)',
            'rgba(114, 118, 100, 1.00)',
            'rgba(120, 120, 113, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/callistemon/callistemon pallidus/callistemon pallidus (1).jpg',
          width: 576,
          id: '420432c8469bccff6e12b500ba0a105e',
          height: 768,
          thumbnail: true,
        },
        location: [47.219587, -1.542187],
        genre: 'Callistemon',
        famille: 'Myrtaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542187, 47.219587] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '75e3f12789b44516ce54bb92024259c982ee9a15',
      fields: {
        espece: 'floridus',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(183, 187, 162, 1.00)',
            'rgba(143, 152, 92, 1.00)',
            'rgba(99, 125, 45, 1.00)',
          ],
          filename:
            "ip ville de nantes/calycanthus/calycanthus floridus 'athens'/calycanthus floridus 'athens'.jpg",
          width: 855,
          id: '39dd6eaf902cad39598b20d03a001f25',
          height: 768,
          thumbnail: true,
        },
        genre: 'Calycanthus',
        cultivar: 'Athens',
        famille: 'Calycanthaceae',
      },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b68f4d36c1a8c752c63020fae833524acb26387c',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(64, 64, 49, 1.00)',
            'rgba(120, 123, 116, 1.00)',
            'rgba(58, 60, 55, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia 'cinnamon cindy'/camellia 'cinnamon cindy'.jpg",
          width: 1024,
          id: '279bc4542fe1277d2b85b22234f73a65',
          height: 683,
          thumbnail: true,
        },
        location: [47.219225, -1.541025],
        genre: 'Camellia',
        cultivar: 'Cinnamon Cindy',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541025, 47.219225] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '15c9f91ce392937d34391febca962e5c55d889ea',
      fields: {
        espece: 'californica',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 76, 43, 1.00)',
            'rgba(89, 104, 63, 1.00)',
            'rgba(94, 107, 57, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/carpenteria/carpenteria californica/carpenteria californica.jpg',
          width: 953,
          id: 'b10a62492d6d7792089f637232055669',
          height: 768,
          thumbnail: true,
        },
        location: [47.261692, -1.533355],
        genre: 'Carpenteria',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533355, 47.261692] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '84cf39d70f40d9ea134a22c41fc224ea9abb7df1',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'cordata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 111, 81, 1.00)',
            'rgba(90, 104, 87, 1.00)',
            'rgba(83, 96, 85, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/carpinus/carpinus cordata/carpinus cordata (3).jpg',
          width: 512,
          id: '61e01bf29885061f08ddf13c7ce2c825',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 152, 132, 1.00)',
            'rgba(140, 153, 131, 1.00)',
            'rgba(109, 118, 100, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/carpinus/carpinus cordata/carpinus cordata (4).jpg',
          width: 596,
          id: 'f65638129a29718cdac933758d322368',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 138, 119, 1.00)',
            'rgba(133, 143, 128, 1.00)',
            'rgba(111, 121, 109, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/carpinus/carpinus cordata/carpinus cordata (1).jpg',
          width: 574,
          id: 'b17873e32e25f28ddc18e0f39a41467b',
          height: 768,
          thumbnail: true,
        },
        location: [47.218645, -1.542688],
        genre: 'Carpinus',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542688, 47.218645] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '14f1aa0425c5958ede997de365775ae0fe5426ed',
      fields: {
        espece: 'cordiformis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 172, 201, 1.00)',
            'rgba(144, 142, 117, 1.00)',
            'rgba(81, 68, 19, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/carya/carya cordiformis/carya cordiformis.jpg',
          width: 576,
          id: '9cfd81f513ae1ee8fc898f1663e57f44',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 134, 34, 1.00)',
            'rgba(125, 162, 55, 1.00)',
            'rgba(104, 138, 28, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/carya/carya cordiformis/carya cordiformis (2).jpg',
          width: 576,
          id: 'e3bab9ae6b2e278dcfde54f043f577f5',
          height: 768,
          thumbnail: true,
        },
        location: [47.219247, -1.541262],
        genre: 'Carya',
        famille: 'Juglandaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541262, 47.219247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '02ea8ea6739374f4ea554d616bbb79c5b529d417',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'bungei',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 114, 102, 1.00)',
            'rgba(99, 107, 93, 1.00)',
            'rgba(123, 118, 111, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/catalpa/catalpa bungei/catalpa bungei (2).jpg',
          width: 576,
          id: 'c13406f835af82772f9e6d756e41f2d6',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 131, 89, 1.00)',
            'rgba(113, 154, 96, 1.00)',
            'rgba(83, 123, 49, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/catalpa/catalpa bungei/catalpa bungei (3).jpg',
          width: 576,
          id: 'a65e49174927c9f7f5f566b32ed41e5d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 175, 137, 1.00)',
            'rgba(86, 112, 60, 1.00)',
            'rgba(98, 110, 76, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/catalpa/catalpa bungei/catalpa bungei (1).jpg',
          width: 1024,
          id: '36f5b799f2e8e5079495eef2057879d1',
          height: 768,
          thumbnail: true,
        },
        location: [47.2206, -1.54245],
        genre: 'Catalpa',
        famille: 'Bignoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54245, 47.2206] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4dd70d2e54d4d02ac6282386aa662da07d3456c9',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'impressus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 135, 91, 1.00)',
            'rgba(133, 141, 100, 1.00)',
            'rgba(154, 145, 120, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ceanothus/ceanothus impressus/ceanothus impressus (2).jpg',
          width: 576,
          id: '9bcd3c408ea84f8f80ebd285755de467',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(171, 167, 171, 1.00)',
            'rgba(138, 130, 115, 1.00)',
            'rgba(107, 111, 87, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ceanothus/ceanothus impressus/ceanothus impressus (3).jpg',
          width: 576,
          id: '68298938ce090a6e0a83cd64a8a18c2f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 137, 134, 1.00)',
            'rgba(133, 128, 142, 1.00)',
            'rgba(112, 99, 122, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ceanothus/ceanothus impressus/ceanothus impressus (1).jpg',
          width: 576,
          id: '9b4f2cb96370ec915038ae7934c5ce9f',
          height: 768,
          thumbnail: true,
        },
        location: [47.2204, -1.544037],
        genre: 'Ceanothus',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544037, 47.2204] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '54db28f72758e0bfd16a4405bd1bf3f722f7b7a5',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'plumbaginoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 146, 77, 1.00)',
            'rgba(125, 142, 108, 1.00)',
            'rgba(81, 97, 19, 1.00)',
          ],
          filename:
            'ip parc de proce/ceratostigma/ceratostigma plumbaginoides/ceratostigma plumbaginoides (2).jpg',
          width: 576,
          id: 'f618a92202b2a8452c8895e6d79cbea5',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 112, 91, 1.00)',
            'rgba(166, 124, 108, 1.00)',
            'rgba(129, 94, 67, 1.00)',
          ],
          filename:
            'ip parc de proce/ceratostigma/ceratostigma plumbaginoides/ceratostigma plumbaginoides (3).jpg',
          width: 576,
          id: 'f3b34307beb362d3fe434b3b09b7d847',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 136, 41, 1.00)',
            'rgba(134, 147, 58, 1.00)',
            'rgba(102, 105, 31, 1.00)',
          ],
          filename:
            'ip parc de proce/ceratostigma/ceratostigma plumbaginoides/ceratostigma plumbaginoides (1).jpg',
          width: 576,
          id: 'aee3d8867139f99ffe39dc7eef4f8862',
          height: 768,
          thumbnail: true,
        },
        location: [47.225142, -1.583162],
        genre: 'Ceratostigma',
        famille: 'Plumbaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583162, 47.225142] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '07bc6214bd767561b67778a0e2746aa89c754065',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 116, 149, 1.00)',
            'rgba(104, 102, 118, 1.00)',
            'rgba(94, 96, 119, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cercidiphyllum cercidiphyllaceae/cercidiphyllum japonicum/cercidiphyllum japonicum (5).jpg',
          width: 660,
          id: 'ced34c1aff7be2a8c33c330d3039774f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 114, 127, 1.00)',
            'rgba(107, 105, 115, 1.00)',
            'rgba(99, 97, 94, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cercidiphyllum cercidiphyllaceae/cercidiphyllum japonicum/cercidiphyllum japonicum (8).jpg',
          width: 1024,
          id: '2b4c01a61d583b9c3f54d00808c1d27c',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 147, 159, 1.00)',
            'rgba(99, 91, 70, 1.00)',
            'rgba(77, 74, 49, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cercidiphyllum cercidiphyllaceae/cercidiphyllum japonicum/cercidiphyllum japonicum (1).jpg',
          width: 512,
          id: '702f7c627d1449046b5283ee91ab2422',
          height: 768,
          thumbnail: true,
        },
        location: [47.270888, -1.584122],
        genre: 'Cercidiphyllum',
        famille: 'Cercidiphyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584122, 47.270888] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f14a3855d2d096776937831ae4985cdb35d3d090',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'zhejiangensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 160, 92, 1.00)',
            'rgba(106, 128, 68, 1.00)',
            'rgba(97, 117, 61, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/chimonanthus/chimonanthus zhejiangensis/chimonanthus zhejiangensis (2).jpg',
          width: 1024,
          id: 'f86ce30da7bb801882a0a6821a779556',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 133, 66, 1.00)',
            'rgba(101, 134, 59, 1.00)',
            'rgba(94, 126, 46, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/chimonanthus/chimonanthus zhejiangensis/chimonanthus zhejiangensis.jpg',
          width: 576,
          id: 'c288245b3d8c717dd83d4b90b84983da',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 153, 103, 1.00)',
            'rgba(104, 127, 70, 1.00)',
            'rgba(81, 103, 53, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/chimonanthus/chimonanthus zhejiangensis/chimonanthus zhejiangensis (1).jpg',
          width: 1024,
          id: '0da59b1c689c7aed450cf03c72c36cb7',
          height: 683,
          thumbnail: true,
        },
        location: [47.219708, -1.542738],
        genre: 'Chimonanthus',
        famille: 'Calycanthaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542738, 47.219708] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2fcd545c6b6a215880e210cd5b4c61d55b58c796',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'kentukea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 166, 170, 1.00)',
            'rgba(122, 133, 98, 1.00)',
            'rgba(50, 56, 35, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/cladrastis/cladrastis kentukea/cladrastis kentukea (2).jpg',
          width: 1024,
          id: '7be31010bd842735f901ffc1ba714d4e',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 115, 85, 1.00)',
            'rgba(86, 99, 55, 1.00)',
            'rgba(72, 78, 52, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/cladrastis/cladrastis kentukea/cladrastis kentukea (3).jpg',
          width: 1024,
          id: '27f292d8fe6f32180f1a9cc24dcaeefd',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 124, 144, 1.00)',
            'rgba(97, 115, 78, 1.00)',
            'rgba(90, 99, 53, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/cladrastis/cladrastis kentukea/cladrastis kentukea (1).jpg',
          width: 1024,
          id: '95daba657b17f45f25938a90bb4c383a',
          height: 683,
          thumbnail: true,
        },
        location: [47.230847, -1.508587],
        genre: 'Cladrastis',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508587, 47.230847] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '62c06366075e97221b9f3f8d026adf8ab8f936bc',
      fields: {
        espece: 'kentukea',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(214, 221, 205, 1.00)',
            'rgba(108, 123, 97, 1.00)',
            'rgba(48, 57, 33, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/cladrastis/cladrastis kentukea/cladrastis kentukea (1).jpg',
          width: 1024,
          id: '328680f4fc1bf86432fd03cffc2906fa',
          height: 683,
          thumbnail: true,
        },
        location: [47.262467, -1.532945],
        genre: 'Cladrastis',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532945, 47.262467] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ec466177f9c8f8ceddfd93b89a4470e53814f40e',
      fields: {
        espece: 'trichotomum',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 112, 58, 1.00)',
            'rgba(130, 127, 80, 1.00)',
            'rgba(107, 113, 45, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/clerodendrum/clerodendrum trichotomum/clerodendrum trichotomum.jpg',
          width: 576,
          id: 'b75786091a4f32759997f927a68fe21a',
          height: 768,
          thumbnail: true,
        },
        location: [47.229903, -1.507903],
        genre: 'Clerodendrum',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507903, 47.229903] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1d2288eb59bec1d640a202e7eeb7202cdcee98c1',
      fields: {
        espece: 'paradoxa',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(174, 179, 178, 1.00)',
            'rgba(93, 96, 83, 1.00)',
            'rgba(72, 78, 52, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/colletia/colletia paradoxa/colletia paradoxa (2).jpg',
          width: 1024,
          id: '23bc8169898c35aa4bb2584129fcdf7c',
          height: 683,
          thumbnail: true,
        },
        location: [47.220878, -1.544414],
        genre: 'Colletia',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544414, 47.220878] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2e2c824cf0ffed3fe776173d79a9f7c0f793b106',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'amomum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 144, 89, 1.00)',
            'rgba(118, 157, 74, 1.00)',
            'rgba(90, 112, 31, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cornus/cornus amomum/cornus amomum (2).jpg',
          width: 576,
          id: 'fd86052b91f5d323aea6f180e7710b87',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 171, 109, 1.00)',
            'rgba(129, 143, 83, 1.00)',
            'rgba(110, 121, 63, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cornus/cornus amomum/cornus amomum (3).jpg',
          width: 576,
          id: '8e8e3af612e24beb28420a50bd8c6970',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 165, 105, 1.00)',
            'rgba(130, 152, 81, 1.00)',
            'rgba(99, 120, 54, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cornus/cornus amomum/cornus amomum (1).jpg',
          width: 1024,
          id: '0578f05f8657b7a5576969b89fa2a001',
          height: 768,
          thumbnail: true,
        },
        location: [47.2189, -1.541595],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541595, 47.2189] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c05e302df5a2f32bb5ae5eeec44f933033f4a1cf',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'officinalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 152, 100, 1.00)',
            'rgba(111, 136, 73, 1.00)',
            'rgba(75, 90, 59, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cornus/cornus officinalis/cornus officinalis (2).jpg',
          width: 576,
          id: '69c199a10229e7dd3fbc341af8ddf201',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 129, 121, 1.00)',
            'rgba(170, 101, 95, 1.00)',
            'rgba(175, 144, 134, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cornus/cornus officinalis/cornus officinalis .jpg',
          width: 576,
          id: 'e6e6057cd29fee6bd84cff52cb9b5908',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 152, 91, 1.00)',
            'rgba(126, 134, 80, 1.00)',
            'rgba(107, 131, 82, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cornus/cornus officinalis/cornus officinalis (1).jpg',
          width: 576,
          id: '8a2822e9ab9d8480ce92ecf79c01c6ef',
          height: 768,
          thumbnail: true,
        },
        location: [47.219067, -1.541478],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541478, 47.219067] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '39689eabdac20632620fca73f0e2fc32da9b22ce',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'wilsoniana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 174, 128, 1.00)',
            'rgba(116, 147, 77, 1.00)',
            'rgba(97, 104, 58, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cornus/cornus wilsoniana/cornus wilsoniana (10).jpg',
          width: 576,
          id: '5338c4b9b7cd1c8855e31a3ac298435c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 145, 85, 1.00)',
            'rgba(108, 137, 84, 1.00)',
            'rgba(120, 141, 85, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cornus/cornus wilsoniana/cornus wilsoniana (11).jpg',
          width: 576,
          id: '38b0ca8465acbff2086434c33c38c009',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 139, 113, 1.00)',
            'rgba(113, 134, 106, 1.00)',
            'rgba(91, 86, 89, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cornus/cornus wilsoniana/cornus wilsoniana (1).jpg',
          width: 1024,
          id: 'd9b51e84ae7be1d7a259cd07f51c4173',
          height: 700,
          thumbnail: true,
        },
        location: [47.218958, -1.541475],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541475, 47.218958] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '647826f567cafaf245b6d1012ebfdd6448b01be6',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'buddleioides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 132, 103, 1.00)',
            'rgba(112, 125, 96, 1.00)',
            'rgba(83, 82, 77, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/corokia/corokia buddleioides/corokia buddleioides (2).jpg',
          width: 1024,
          id: 'cedc57ced7c43abdae5df99fd05792d3',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 138, 121, 1.00)',
            'rgba(105, 117, 97, 1.00)',
            'rgba(91, 109, 79, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/corokia/corokia buddleioides/corokia buddleioides (3).jpg',
          width: 1024,
          id: '29b112dc74dbd2807b5cc936efeb0d9c',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 164, 139, 1.00)',
            'rgba(132, 128, 125, 1.00)',
            'rgba(77, 72, 77, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/corokia/corokia buddleioides/corokia buddleioides (1).jpg',
          width: 512,
          id: '53f848fc9dde76eb871646596b990c29',
          height: 768,
          thumbnail: true,
        },
        location: [47.218745, -1.54267],
        genre: 'Corokia',
        famille: 'Argophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54267, 47.218745] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd63882797eb24b12f2d167a229f2e25757a2dba6',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'x virgata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 163, 97, 1.00)',
            'rgba(139, 147, 82, 1.00)',
            'rgba(124, 126, 62, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/corokia/corokia x virgata/corokia x virgata (2).jpg',
          width: 576,
          id: 'c76b32226032ac6990b8be186c657dd1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 143, 94, 1.00)',
            'rgba(125, 125, 70, 1.00)',
            'rgba(100, 110, 55, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/corokia/corokia x virgata/corokia x virgata (3).jpg',
          width: 1024,
          id: 'eb7bce89cb4440b2a04c8032d8a9bc29',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 136, 60, 1.00)',
            'rgba(120, 123, 53, 1.00)',
            'rgba(113, 110, 40, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/corokia/corokia x virgata/corokia x virgata (1).jpg',
          width: 576,
          id: '04cf641817d5e45520fbd815c2196b42',
          height: 768,
          thumbnail: true,
        },
        location: [47.262612, -1.530853],
        genre: 'Corokia',
        famille: 'Argophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530853, 47.262612] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3bd336f5d6798d87f897228e3d437b783d7d272b',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'sinensis var. calvescens',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 140, 80, 1.00)',
            'rgba(138, 127, 60, 1.00)',
            'rgba(98, 83, 51, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/corylopsis/corylopsis sinensis var. calvescens/corylopsis sinensis var. calvescens (2).jpg',
          width: 576,
          id: 'f60435d21eef4f3dddde1f2d851543a1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 159, 137, 1.00)',
            'rgba(107, 121, 109, 1.00)',
            'rgba(99, 110, 107, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/corylopsis/corylopsis sinensis var. calvescens/corylopsis sinensis var. calvescens (3).jpg',
          width: 1024,
          id: '1d814a9d8d2aada963857563b7da989b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(167, 165, 157, 1.00)',
            'rgba(120, 116, 73, 1.00)',
            'rgba(97, 88, 63, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/corylopsis/corylopsis sinensis var. calvescens/corylopsis sinensis var. calvescens (1).jpg',
          width: 1024,
          id: '056725ce2cbaa9a9271a9dc43c96df6b',
          height: 768,
          thumbnail: true,
        },
        location: [47.219228, -1.541155],
        genre: 'Corylopsis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541155, 47.219228] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '85fa23da2f4877d4c91cb44fb3ad4a46ec55d170',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(168, 153, 124, 1.00)',
            'rgba(141, 122, 82, 1.00)',
            'rgba(122, 104, 56, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/corylus/corylus avellana 'contorta'/corylus avellana 'contorta' (3).jpg",
          width: 576,
          id: 'd93b27af8c2e18247eab8a28c6211e49',
          height: 768,
          thumbnail: true,
        },
        espece: 'avellana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 138, 105, 1.00)',
            'rgba(139, 120, 70, 1.00)',
            'rgba(110, 94, 53, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/corylus/corylus avellana 'contorta'/corylus avellana 'contorta' (2).jpg",
          width: 576,
          id: '5b1625c0cf1c2c82494d2e13815ba592',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 167, 178, 1.00)',
            'rgba(127, 116, 81, 1.00)',
            'rgba(133, 123, 83, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/corylus/corylus avellana 'contorta'/corylus avellana 'contorta' (1).jpg",
          width: 1024,
          id: 'aaec7aef35fce4e0d69e5389ac2b6145',
          height: 768,
          thumbnail: true,
        },
        location: [47.262713, -1.531688],
        genre: 'Corylus',
        cultivar: 'Contorta',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531688, 47.262713] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4eebf4ec11f46ad137542bef5850075534c3f6b7',
      fields: {
        espece: 'coggygria',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 92, 86, 1.00)',
            'rgba(131, 104, 95, 1.00)',
            'rgba(118, 100, 97, 1.00)',
          ],
          filename:
            "ip foyer des anciens/cotinus/cotinus coggygria 'royal purple'/cotinus coggygria 'royal purple' (2).jpg",
          width: 576,
          id: '0d3c4c26cef72f1defdb9087e18ef1e1',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Foyer des Anciens',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 149, 153, 1.00)',
            'rgba(95, 85, 76, 1.00)',
            'rgba(101, 107, 91, 1.00)',
          ],
          filename:
            "ip foyer des anciens/cotinus/cotinus coggygria 'royal purple'/cotinus coggygria 'royal purple' (1).jpg",
          width: 1024,
          id: '6de0e81894b4b4c0eb3f2b9a809426a1',
          height: 768,
          thumbnail: true,
        },
        location: [47.231742, -1.583083],
        genre: 'Cotinus',
        cultivar: 'Royal Purple',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583083, 47.231742] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '03c91f8b2ecd24b05ff8f6be8966a479b83bf84e',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'cashmeriana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 120, 106, 1.00)',
            'rgba(108, 115, 92, 1.00)',
            'rgba(123, 125, 120, 1.00)',
          ],
          filename:
            'ip parc de proce/cupressus/cupressus cashmeriana/cupressus cashmeriana (2).jpg',
          width: 1024,
          id: '8d4b8751b6b1d1b73e54d7a8dccefa6c',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 146, 147, 1.00)',
            'rgba(114, 118, 105, 1.00)',
            'rgba(95, 102, 86, 1.00)',
          ],
          filename:
            'ip parc de proce/cupressus/cupressus cashmeriana/cupressus cashmeriana (3).jpg',
          width: 512,
          id: '2fceea6ea5ccf0c2918019a37f11e8e8',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 93, 89, 1.00)',
            'rgba(115, 111, 97, 1.00)',
            'rgba(107, 104, 91, 1.00)',
          ],
          filename:
            'ip parc de proce/cupressus/cupressus cashmeriana/cupressus cashmeriana (1).jpg',
          width: 512,
          id: '8b92f2b22d44d9a10c39b31033b3f75a',
          height: 768,
          thumbnail: true,
        },
        location: [47.222725, -1.580588],
        genre: 'Cupressus',
        famille: 'Cupressaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580588, 47.222725] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e1a498034657262179b6b1c608394b62aaf497a0',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'cashmeriana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 132, 143, 1.00)',
            'rgba(100, 121, 129, 1.00)',
            'rgba(109, 128, 135, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/cupressus/cupressus cashmeriana/cupressus cashmeriana (11).jpg',
          width: 1024,
          id: 'baf3791c9046458a67508195cc649a07',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 150, 161, 1.00)',
            'rgba(111, 124, 101, 1.00)',
            'rgba(67, 73, 33, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/cupressus/cupressus cashmeriana/cupressus cashmeriana (3).jpg',
          width: 512,
          id: 'a8f29bc4865b688ad8c6bdbbd465ec95',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 141, 130, 1.00)',
            'rgba(92, 105, 74, 1.00)',
            'rgba(72, 83, 43, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/cupressus/cupressus cashmeriana/cupressus cashmeriana (10).jpg',
          width: 941,
          id: '0fd6938d2be742fc50961ed1295079aa',
          height: 768,
          thumbnail: true,
        },
        location: [47.262058, -1.531975],
        genre: 'Cupressus',
        famille: 'Cupressaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531975, 47.262058] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '90ebac1e5f623f5c741b0f45ecf0cc3b8bbb4180',
      fields: {
        espece: 'oblongua',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(63, 86, 43, 1.00)',
            'rgba(121, 132, 110, 1.00)',
            'rgba(46, 67, 35, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/cydonia/cydonia oblongua/cydonia oblongua.jpg',
          width: 576,
          id: '440a875e08cf0c91a8f7f77448364cba',
          height: 768,
          thumbnail: true,
        },
        location: [47.23033, -1.506967],
        genre: 'Cydonia',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.506967, 47.23033] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6d0e7d6cda4647135f712d7c4fe9013a2a52d83b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(173, 184, 132, 1.00)',
            'rgba(120, 131, 71, 1.00)',
            'rgba(106, 100, 70, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/daphniphyllum daphniphyllaceae/daphniphyllum macropodum/daphniphyllum macropodum (2).jpg',
          width: 576,
          id: '91a26267188b949c5e3b310fb75cdffa',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 147, 54, 1.00)',
            'rgba(161, 115, 74, 1.00)',
            'rgba(154, 127, 85, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/daphniphyllum daphniphyllaceae/daphniphyllum macropodum/daphniphyllum macropodum (4).jpg',
          width: 576,
          id: '4f4146fe8ff52ede92e15d4165b94756',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 124, 43, 1.00)',
            'rgba(132, 154, 42, 1.00)',
            'rgba(114, 127, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/daphniphyllum daphniphyllaceae/daphniphyllum macropodum/daphniphyllum macropodum (1).jpg',
          width: 576,
          id: 'b69be3416ffe3311a97673c40a9a51c0',
          height: 768,
          thumbnail: true,
        },
        location: [47.270222, -1.581945],
        genre: 'Daphniphyllum',
        famille: 'Daphniphyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581945, 47.270222] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3708bfbbdca73d164d3ad5bebd10b9c6f085a38c',
      fields: {
        espece: 'kaki',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 159, 47, 1.00)',
            'rgba(87, 143, 30, 1.00)',
            'rgba(112, 154, 54, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/diospyros/diospyros kaki 'costata'/diospyros kaki 'costata' (2).jpg",
          width: 576,
          id: 'cec7341157a1d6af248650881632a9dc',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 144, 35, 1.00)',
            'rgba(104, 142, 42, 1.00)',
            'rgba(78, 120, 39, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/diospyros/diospyros kaki 'costata'/diospyros kaki 'costata' (1).jpg",
          width: 576,
          id: '6e806a5604ffcb836fe207424f7228af',
          height: 768,
          thumbnail: true,
        },
        location: [47.220545, -1.542542],
        genre: 'Diospyros',
        cultivar: 'Costata',
        famille: 'Ebenaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542542, 47.220545] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dfd6f3856807ee8cec78ac04f8b602a43727bb37',
      fields: {
        espece: 'campanulatus',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 144, 87, 1.00)',
            'rgba(118, 127, 80, 1.00)',
            'rgba(81, 94, 49, 1.00)',
          ],
          filename:
            'ip parc de proce/enkianthus/enkianthus campanulatus/enkianthus campanulatus.jpg',
          width: 1024,
          id: '2a98d03d1afe712f06dd9a9911fb9ec5',
          height: 768,
          thumbnail: true,
        },
        location: [47.223113, -1.581272],
        genre: 'Enkianthus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581272, 47.223113] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'df2fab209eb27c0e3c58747fc9a23a33bdfbea43',
      fields: {
        espece: 'japonicus',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 127, 93, 1.00)',
            'rgba(117, 132, 67, 1.00)',
            'rgba(103, 104, 68, 1.00)',
          ],
          filename:
            'ip parc de proce/euonymus/euonymus japonicus/euonymus japonicus.jpg',
          width: 576,
          id: 'c3dc41277fe61d84b4fec8af6b37f9b4',
          height: 768,
          thumbnail: true,
        },
        location: [47.225162, -1.583312],
        genre: 'Euonymus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583312, 47.225162] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '23b078ff5031579185229d171409032742e7e572',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 140, 64, 1.00)',
            'rgba(145, 130, 83, 1.00)',
            'rgba(155, 126, 102, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/eurya pentaphylacaceae/eurya japonica/eurya japonica (male) (2).jpg',
          width: 576,
          id: 'ad3d3b2dd88cbd3e7ff86fe741bce58c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 183, 165, 1.00)',
            'rgba(122, 109, 70, 1.00)',
            'rgba(123, 96, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/eurya pentaphylacaceae/eurya japonica/eurya japonica (male) (3).jpg',
          width: 1024,
          id: '8b438cd552bd5d1dde83e96790473916',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 158, 106, 1.00)',
            'rgba(136, 124, 86, 1.00)',
            'rgba(112, 109, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/eurya pentaphylacaceae/eurya japonica/eurya japonica (male) (1).jpg',
          width: 576,
          id: '86822cc07534b1f8c61cf8d51cb306e6',
          height: 768,
          thumbnail: true,
        },
        location: [47.271542, -1.584688],
        genre: 'Eurya',
        famille: 'Pentaphylacaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584688, 47.271542] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '30780ecbfc8bcca5ee42f9e0824cefcf99fcf497',
      fields: {
        espece: 'sylvatica',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 157, 196, 1.00)',
            'rgba(111, 117, 123, 1.00)',
            'rgba(65, 59, 25, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/fagus/fagus sylvatica 'pendula'/fagus sylvatica 'pendula' (2).jpg",
          width: 1024,
          id: 'bfa22596729f139aa2625d0888a290e9',
          height: 683,
          thumbnail: true,
        },
        location: [47.262133, -1.530055],
        genre: 'Fagus',
        cultivar: 'Pendula',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530055, 47.262133] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0d7674e4ce565c66304f40955e1e740a0b0b2e89',
      fields: {
        espece: 'simplex',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 140, 74, 1.00)',
            'rgba(120, 135, 53, 1.00)',
            'rgba(141, 150, 66, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/firmiana/firmiana simplex/firmiana simplex.jpg',
          width: 576,
          id: 'c3c4777f4f9b688d462add7fb00352c8',
          height: 768,
          thumbnail: true,
        },
        location: [47.220095, -1.542072],
        genre: 'Firmiana',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542072, 47.220095] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8bcd51ae0a74caa93fb7c587d9b87b8407c4a1a9',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(183, 186, 175, 1.00)',
            'rgba(120, 117, 76, 1.00)',
            'rgba(111, 113, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fothergilla hamamelidaceae/fothergilla major/fothergilla major (10).jpg',
          width: 1024,
          id: '8285a9484854ec7e673f93592c6f56ff',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 114, 86, 1.00)',
            'rgba(115, 102, 59, 1.00)',
            'rgba(76, 71, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fothergilla hamamelidaceae/fothergilla major/fothergilla major (11).jpg',
          width: 1024,
          id: '9d095ac83ed25265a8ad49e173a0d6c4',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(171, 152, 126, 1.00)',
            'rgba(123, 94, 23, 1.00)',
            'rgba(119, 103, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fothergilla hamamelidaceae/fothergilla major/fothergilla major (1).jpg',
          width: 576,
          id: '18c18e6fd0298bb271e15aa743cc9b70',
          height: 768,
          thumbnail: true,
        },
        location: [47.271025, -1.582742],
        genre: 'Fothergilla',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582742, 47.271025] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '16e97aa31efd19841b7e4ac46af4c020d290d283',
      fields: {
        espece: 'ornus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(203, 210, 186, 1.00)',
            'rgba(95, 108, 69, 1.00)',
            'rgba(56, 71, 37, 1.00)',
          ],
          filename:
            'ip parc de la gaudiniere/fraxinus/fraxinus ornus/fraxinus ornus (2).jpg',
          width: 1024,
          id: '927baf6c724bee3a0dd116698367216a',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc de la Gaudini\u00e8re',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 94, 44, 1.00)',
            'rgba(81, 94, 56, 1.00)',
            'rgba(58, 72, 37, 1.00)',
          ],
          filename:
            'ip parc de la gaudiniere/fraxinus/fraxinus ornus/fraxinus ornus (1).jpg',
          width: 1024,
          id: '693f6b1436da085582cf4c14081e9c44',
          height: 683,
          thumbnail: true,
        },
        location: [47.24292, -1.579508],
        genre: 'Fraxinus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.579508, 47.24292] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b559665a44e2f3176f2c4424252e250a57d396db',
      fields: {
        espece: 'angustifolia',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 194, 195, 1.00)',
            'rgba(83, 111, 59, 1.00)',
            'rgba(66, 79, 40, 1.00)',
          ],
          filename:
            'ip parc de proce/fraxinus/fraxinus angustifolia/fraxinus angustifolia.jpg',
          width: 576,
          id: '08de20d96f8d9e1b79e4e8fe1da921d2',
          height: 768,
          thumbnail: true,
        },
        location: [47.222013, -1.581903],
        genre: 'Fraxinus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581903, 47.222013] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '147fe16c477faaea66ecb2f4b0d64eb7edbb4487',
      fields: {
        espece: 'angustifolia',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 128, 194, 1.00)',
            'rgba(98, 110, 126, 1.00)',
            'rgba(87, 84, 63, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/fraxinus/fraxinus angustifolia 'raywood'/fraxinus angustifolia 'raywood'.jpg",
          width: 1024,
          id: '2f324034b13cb1b3e644a5ceedbdc3ad',
          height: 683,
          thumbnail: true,
        },
        location: [47.262337, -1.529511],
        genre: 'Fraxinus',
        cultivar: 'Raywood',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529511, 47.262337] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '85b5a777676b655eda86a9f4a5204097a15ec49a',
      fields: {
        espece: 'californicum',
        nom_du_site: 'Foyer des Anciens',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 149, 156, 1.00)',
            'rgba(119, 121, 111, 1.00)',
            'rgba(133, 136, 110, 1.00)',
          ],
          filename:
            'ip foyer des anciens/fremontodendron/fremontodendron californicum/fremontodendron californicum.jpg',
          width: 609,
          id: 'f217beabe0f156ae9d596288133ea111',
          height: 768,
          thumbnail: true,
        },
        location: [47.231892, -1.582883],
        genre: 'Fremontodendron',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582883, 47.231892] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '416ac736587076e922de39416a0ec26491e2fa5d',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'meleagris',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 137, 113, 1.00)',
            'rgba(106, 138, 60, 1.00)',
            'rgba(99, 137, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fritillaria/fritillaria meleagris/fritillaria meleagris (2).jpg',
          width: 1024,
          id: 'dbe9478a0a20f8a9b7d3d9983a3309bb',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 144, 69, 1.00)',
            'rgba(111, 132, 66, 1.00)',
            'rgba(95, 122, 51, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fritillaria/fritillaria meleagris/fritillaria meleagris (3).jpg',
          width: 1024,
          id: 'a40941ec624b0a02cd1ff7bcbe803547',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 141, 81, 1.00)',
            'rgba(113, 133, 68, 1.00)',
            'rgba(88, 122, 42, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fritillaria/fritillaria meleagris/fritillaria meleagris (1).jpg',
          width: 1024,
          id: '93650219e6315311540297efc0a432b3',
          height: 683,
          thumbnail: true,
        },
        location: [47.273047, -1.584542],
        genre: 'Fritillaria',
        famille: 'Liliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584542, 47.273047] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '005fe1dd24f4b6b986587fb80015610e5fe31a28',
      fields: {
        espece: 'biloba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(171, 197, 187, 1.00)',
            'rgba(130, 149, 117, 1.00)',
            'rgba(66, 71, 47, 1.00)',
          ],
          filename:
            'ip parc de proce/ginkgo/ginkgo biloba/ginkgo biloba (2).jpg',
          width: 576,
          id: '1669da0daeac20f07a312c7e864bec7d',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 135, 104, 1.00)',
            'rgba(110, 131, 38, 1.00)',
            'rgba(108, 131, 32, 1.00)',
          ],
          filename:
            'ip parc de proce/ginkgo/ginkgo biloba/ginkgo biloba (1).jpg',
          width: 576,
          id: '723499509142f4f59a102ff18849cb23',
          height: 768,
          thumbnail: true,
        },
        location: [47.222362, -1.581447],
        genre: 'Ginkgo',
        famille: 'Ginkgoaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581447, 47.222362] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5a3721cb80a766e66018431d58f41e2b6ed7df58',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'sinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 154, 77, 1.00)',
            'rgba(118, 157, 62, 1.00)',
            'rgba(121, 135, 83, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/gleditsia/gleditsia sinensis/gleditsia sinensis (2).jpg',
          width: 576,
          id: 'c056804890bb59c8f430068f03b34c33',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 105, 80, 1.00)',
            'rgba(120, 122, 109, 1.00)',
            'rgba(161, 158, 154, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/gleditsia/gleditsia sinensis/gleditsia sinensis (3).jpg',
          width: 576,
          id: '7596e74979be0f4893ac4c1f51bb3576',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 139, 99, 1.00)',
            'rgba(119, 148, 82, 1.00)',
            'rgba(114, 126, 78, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/gleditsia/gleditsia sinensis/gleditsia sinensis (1).jpg',
          width: 576,
          id: 'f442fa204b664b2e0ad3f299f8fa83c5',
          height: 768,
          thumbnail: true,
        },
        location: [47.219417, -1.543037],
        genre: 'Gleditsia',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543037, 47.219417] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8f2c94b61b120624edb87484dbcee9cda7caa4da',
      fields: {
        espece: 'triacanthos f. inermis',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 125, 168, 1.00)',
            'rgba(99, 123, 143, 1.00)',
            'rgba(86, 114, 156, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/gleditsia/gleditsia triacanthos f. inermis 'sunburst'/gleditsia triacanthos f. inermis 'sunburst'.jpg",
          width: 598,
          id: '2dc6fc9ca61ca0af4cf62e967f77921e',
          height: 768,
          thumbnail: true,
        },
        location: [47.26215, -1.5316],
        genre: 'Gleditsia',
        cultivar: 'Sunburst',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5316, 47.26215] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6b63e2161e8ee4e79a6ebbc82ba847c896046d96',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 152, 39, 1.00)',
            'rgba(159, 142, 61, 1.00)',
            'rgba(117, 103, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis x intermedia 'pallida'/hamamelis x intermedia 'pallida' (4).jpg",
          width: 576,
          id: 'b419767e5c044adf4420f7dff4bf8f58',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 140, 168, 1.00)',
            'rgba(111, 101, 78, 1.00)',
            'rgba(115, 97, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis x intermedia 'pallida'/hamamelis x intermedia 'pallida' .jpg",
          width: 1024,
          id: '48c2e1365a7a77eb2696e188b37b6531',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 99, 27, 1.00)',
            'rgba(184, 137, 22, 1.00)',
            'rgba(92, 71, 22, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis x intermedia 'pallida'/hamamelis x intermedia 'pallida' (3).jpg",
          width: 576,
          id: '00cf61e8b9250e5e1af10f2e2402a30e',
          height: 768,
          thumbnail: true,
        },
        location: [47.271192, -1.584672],
        genre: 'Hamamelis',
        cultivar: 'Pallida',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584672, 47.271192] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7d8d02aab3c7185c6ccfa147d8717398e806eff4',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'discolor',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 161, 92, 1.00)',
            'rgba(99, 123, 71, 1.00)',
            'rgba(99, 103, 73, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/holodiscus/holodiscus discolor/holodiscus discolor (2).jpg',
          width: 1024,
          id: '4e3c53df71a942a1714681ab70477e1b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 112, 55, 1.00)',
            'rgba(96, 111, 64, 1.00)',
            'rgba(69, 81, 42, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/holodiscus/holodiscus discolor/holodiscus discolor (3).jpg',
          width: 576,
          id: '660b626d08485757355c04a32c2540ac',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 110, 75, 1.00)',
            'rgba(108, 121, 83, 1.00)',
            'rgba(99, 108, 72, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/holodiscus/holodiscus discolor/holodiscus discolor (1).jpg',
          width: 576,
          id: 'd29e072f8621d586cfdfcbbf2a7c6087',
          height: 768,
          thumbnail: true,
        },
        location: [47.261667, -1.531128],
        genre: 'Holodiscus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531128, 47.261667] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0acdf33f05dded722d82c34728ac79efc9ab05aa',
      fields: {
        espece: 'macropoda',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(167, 186, 142, 1.00)',
            'rgba(98, 125, 67, 1.00)',
            'rgba(63, 85, 41, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ilex/ilex macropoda/ilex macropoda (3).jpg',
          width: 1024,
          id: 'cb987b7defb629833e2296532891f5bc',
          height: 683,
          thumbnail: true,
        },
        location: [47.219988, -1.542112],
        genre: 'Ilex',
        famille: 'Aquifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542112, 47.219988] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dab809a5f555f6daff55a264c94941211351205a',
      fields: {
        espece: 'macropoda',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 127, 49, 1.00)',
            'rgba(96, 124, 50, 1.00)',
            'rgba(87, 115, 41, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ilex/ilex macropoda/ilex macropoda.jpg',
          width: 1024,
          id: 'a92842c3c3b371e56bde33453f62c880',
          height: 683,
          thumbnail: true,
        },
        location: [47.219987, -1.542112],
        genre: 'Ilex',
        famille: 'Aquifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542112, 47.219987] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3ffd680c6adf0417f623756fbf14955d1d41708b',
      fields: {
        espece: 'fontanesiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 150, 92, 1.00)',
            'rgba(112, 128, 79, 1.00)',
            'rgba(46, 66, 19, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/leucothoe/leucothoe fontanesiana 'rollissonii'/leucothoe fontanesiana 'rollissonii' (2).jpg",
          width: 576,
          id: '3107962e4ffc276e35d07a2cdcc9a1e0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 167, 101, 1.00)',
            'rgba(106, 133, 70, 1.00)',
            'rgba(84, 108, 35, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/leucothoe/leucothoe fontanesiana 'rollissonii'/leucothoe fontanesiana 'rollissonii' (1).jpg",
          width: 576,
          id: '1f91976b5733b728dc075b687e0ce03b',
          height: 768,
          thumbnail: true,
        },
        location: [47.219267, -1.54282],
        genre: 'Leucothoe',
        cultivar: 'Rollissonii',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54282, 47.219267] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1f4f584d92d211ccfc30bf7a4fb0890c3a4139de',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'japonicum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 153, 218, 1.00)',
            'rgba(103, 126, 89, 1.00)',
            'rgba(100, 125, 59, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/ligustrum/ligustrum japonicum/ligustrum japonicum (2).jpg',
          width: 576,
          id: '0b4b76b2c2cfac43fec15340f484b829',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(56, 86, 30, 1.00)',
            'rgba(91, 130, 41, 1.00)',
            'rgba(88, 115, 30, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/ligustrum/ligustrum japonicum/ligustrum japonicum (3).jpg',
          width: 576,
          id: 'caeeceda051a470cc16637a0c9d3acfd',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 121, 68, 1.00)',
            'rgba(117, 127, 79, 1.00)',
            'rgba(72, 85, 40, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/ligustrum/ligustrum japonicum/ligustrum japonicum (1).jpg',
          width: 576,
          id: '9cc549c1fc29f940a2315c3147a7b443',
          height: 768,
          thumbnail: true,
        },
        location: [47.229938, -1.507988],
        genre: 'Ligustrum',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507988, 47.229938] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dc5e16dfd74b70e14145386d3425b322bfd6eeb4',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'japonicum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 144, 93, 1.00)',
            'rgba(101, 126, 67, 1.00)',
            'rgba(99, 123, 77, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/ligustrum/ligustrum japonicum/ligustrum japonicum (5).jpg',
          width: 576,
          id: 'f7a1bd240288fc4dfff9241629615e60',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 148, 91, 1.00)',
            'rgba(133, 134, 94, 1.00)',
            'rgba(113, 117, 67, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/ligustrum/ligustrum japonicum/ligustrum japonicum (6).jpg',
          width: 576,
          id: '4c329cc7538396e8a150d5f4c8585fd4',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 133, 95, 1.00)',
            'rgba(112, 116, 78, 1.00)',
            'rgba(115, 121, 77, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/ligustrum/ligustrum japonicum/ligustrum japonicum (4).jpg',
          width: 576,
          id: '017c085c7bc601ab2788e05730fe3801',
          height: 768,
          thumbnail: true,
        },
        location: [47.230263, -1.50808],
        genre: 'Ligustrum',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.50808, 47.230263] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8b9c8c0971fc4fbef42854e4ba5c0a72c3b536fd',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 108, 66, 1.00)',
            'rgba(125, 143, 56, 1.00)',
            'rgba(116, 124, 41, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/liquidambar hamamelidaceae/liquidambar styraciflua 'burgundy'/liquidambar styraciflua 'burgundy' (2).jpg",
          width: 576,
          id: '5f1044960b8f1d9b7e82d34d0afd7639',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 84, 70, 1.00)',
            'rgba(167, 101, 84, 1.00)',
            'rgba(151, 81, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/liquidambar hamamelidaceae/liquidambar styraciflua 'burgundy'/liquidambar styraciflua 'burgundy' (3).jpg",
          width: 576,
          id: '9054cd7871d9b7ee3f7c55ba392c475e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 181, 230, 1.00)',
            'rgba(143, 123, 82, 1.00)',
            'rgba(118, 102, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/liquidambar hamamelidaceae/liquidambar styraciflua 'burgundy'/liquidambar styraciflua 'burgundy' (1).jpg",
          width: 576,
          id: '1c9f61d558462b9e4dc16004e847d5a7',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Liquidambar',
        cultivar: 'Burgundy',
        famille: 'Altingiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6a64d9ccc23d1be0467076316282ec2fd5b4cd39',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'edulis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 153, 100, 1.00)',
            'rgba(102, 120, 71, 1.00)',
            'rgba(59, 79, 49, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/lithocarpus/lithocarpus edulis/lithocarpus edulis (2).jpg',
          width: 1024,
          id: 'e71053d21f3bb66ff8dd6a2fad31fb1a',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(64, 76, 46, 1.00)',
            'rgba(101, 116, 76, 1.00)',
            'rgba(74, 91, 50, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/lithocarpus/lithocarpus edulis/lithocarpus edulis (3).jpg',
          width: 1024,
          id: 'd4c9fbb1f1c6eba676f85a33a2e20d16',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 94, 76, 1.00)',
            'rgba(104, 113, 88, 1.00)',
            'rgba(99, 106, 80, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/lithocarpus/lithocarpus edulis/lithocarpus edulis (1).jpg',
          width: 1024,
          id: '34087a500424a051f9b2192425e60339',
          height: 683,
          thumbnail: true,
        },
        location: [47.26158, -1.532897],
        genre: 'Lithocarpus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532897, 47.26158] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9817c88b51a11ca997d598547253625b94a09758',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'ruprechtiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 121, 41, 1.00)',
            'rgba(121, 142, 77, 1.00)',
            'rgba(71, 95, 34, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/lonicera/lonicera ruprechtiana/lonicera ruprechtiana (2).jpg',
          width: 576,
          id: '6ed9f96e60da0e8258ef68b9bdd5512c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 162, 78, 1.00)',
            'rgba(115, 147, 63, 1.00)',
            'rgba(75, 103, 22, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/lonicera/lonicera ruprechtiana/lonicera ruprechtiana (3).jpg',
          width: 576,
          id: '8d7d446eac03c84101ebdda3fd38a7c3',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 157, 57, 1.00)',
            'rgba(105, 147, 34, 1.00)',
            'rgba(121, 152, 60, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/lonicera/lonicera ruprechtiana/lonicera ruprechtiana (1).jpg',
          width: 576,
          id: '48087fd996f2247722174655326b9adc',
          height: 768,
          thumbnail: true,
        },
        location: [47.220475, -1.542103],
        genre: 'Lonicera',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542103, 47.220475] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8981ccb30ac6548681ed93af9264683e2bedadc5',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 134, 117, 1.00)',
            'rgba(131, 124, 51, 1.00)',
            'rgba(89, 78, 43, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/magnolia/magnolia 'butterflies'/magnolia 'butterflies' (3).jpg",
          width: 576,
          id: 'a66bb399baa9262207f406c0e2deb611',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 157, 88, 1.00)',
            'rgba(166, 149, 68, 1.00)',
            'rgba(101, 88, 46, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/magnolia/magnolia 'butterflies'/magnolia 'butterflies' (1).jpg",
          width: 576,
          id: '2cd1d571ea35bcddef2e6b849b3d5ee1',
          height: 768,
          thumbnail: true,
        },
        location: [47.219467, -1.544108],
        genre: 'Magnolia',
        cultivar: 'Butterflies',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544108, 47.219467] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9e2c49d5c3ad02008c1614862fecb986adf1eb5f',
      fields: {
        espece: 'x soulangeana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 88, 85, 1.00)',
            'rgba(146, 135, 133, 1.00)',
            'rgba(94, 81, 50, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia x soulangeana/magnolia x soulangeana.jpg',
          width: 576,
          id: 'e2dc2a970cf306254d2098a0f3f40b1b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 117, 137, 1.00)',
            'rgba(152, 142, 144, 1.00)',
            'rgba(90, 87, 50, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia x soulangeana/magnolia x soulangeana (2).jpg',
          width: 576,
          id: '828f6c8928a0bf347acc662d0b174913',
          height: 768,
          thumbnail: true,
        },
        location: [47.219333, -1.542325],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542325, 47.219333] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '35c8f13d2c8b925084baaf05c2ec4f00ec0dc886',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(211, 213, 220, 1.00)',
            'rgba(111, 112, 93, 1.00)',
            'rgba(56, 59, 27, 1.00)',
          ],
          filename:
            "ip parc de la gaudiniere/magnolia/magnolia x foggii 'all spice'/magnolia x foggii 'all spice' (3).jpg",
          width: 1024,
          id: '1ac9c035bf35bf4bfd0aaf458e37aebd',
          height: 683,
          thumbnail: true,
        },
        espece: 'x foggii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(173, 165, 139, 1.00)',
            'rgba(131, 107, 46, 1.00)',
            'rgba(139, 138, 90, 1.00)',
          ],
          filename:
            "ip parc de la gaudiniere/magnolia/magnolia x foggii 'all spice'/magnolia x foggii 'all spice' (2).jpg",
          width: 576,
          id: '816312597974977e0bdb441699e60a46',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de la Gaudini\u00e8re',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 155, 126, 1.00)',
            'rgba(102, 130, 77, 1.00)',
            'rgba(140, 148, 95, 1.00)',
          ],
          filename:
            "ip parc de la gaudiniere/magnolia/magnolia x foggii 'all spice'/magnolia x foggii 'all spice' (1).jpg",
          width: 576,
          id: 'c68933256cf3a6f33d13a025a7dcd881',
          height: 768,
          thumbnail: true,
        },
        location: [47.242008, -1.578472],
        genre: 'Magnolia',
        cultivar: 'All Spice',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.578472, 47.242008] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '910a910a438e2fdbf754eb54478d503f87690580',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 143, 160, 1.00)',
            'rgba(135, 119, 108, 1.00)',
            'rgba(117, 117, 80, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia 'ricki'/magnolia 'ricki' (2).jpg",
          width: 1024,
          id: '4f3e36f67134383986902c9b55b87fad',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 107, 100, 1.00)',
            'rgba(168, 135, 136, 1.00)',
            'rgba(108, 104, 57, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia 'ricki'/magnolia 'ricki' (1).jpg",
          width: 576,
          id: '10375be4a268e557e710403e30f9bc6a',
          height: 768,
          thumbnail: true,
        },
        location: [47.225703, -1.581717],
        genre: 'Magnolia',
        cultivar: 'Ricki',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581717, 47.225703] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '515aae0a83a842f30dec5b169494eb35a0f41aae',
      fields: {
        espece: 'denudata',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 90, 118, 1.00)',
            'rgba(103, 120, 140, 1.00)',
            'rgba(103, 111, 117, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia denudata 'double diamond'/magnolia denudata 'double diamond'.jpg",
          width: 576,
          id: 'd4fd5daa4632c145cf398c7c5d242fc4',
          height: 768,
          thumbnail: true,
        },
        location: [47.226013, -1.582828],
        genre: 'Magnolia',
        cultivar: 'Double Diamond',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582828, 47.226013] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '73234d3b3a72b6d7aa604f0f5cb529d0cb73a347',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 195, 232, 1.00)',
            'rgba(128, 137, 146, 1.00)',
            'rgba(78, 74, 54, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia stellata 'rosea king'/magnolia stellata 'rosea king' (3).jpg",
          width: 576,
          id: '6302b71ffbd5a8378eb80d597aa13b0e',
          height: 768,
          thumbnail: true,
        },
        espece: 'stellata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(167, 172, 167, 1.00)',
            'rgba(157, 148, 131, 1.00)',
            'rgba(84, 87, 70, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia stellata 'rosea king'/magnolia stellata 'rosea king' (2).jpg",
          width: 576,
          id: '48174e83a4e9e1bee57b4bb61cf2369f',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 101, 101, 1.00)',
            'rgba(128, 125, 118, 1.00)',
            'rgba(105, 102, 100, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia stellata 'rosea king'/magnolia stellata 'rosea king' (1).jpg",
          width: 576,
          id: '3b1e57d2f272b6155f362f6bd83b7ddd',
          height: 768,
          thumbnail: true,
        },
        location: [47.225547, -1.581513],
        genre: 'Magnolia',
        cultivar: 'Rosea King',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581513, 47.225547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '106dd7246846c57a8238ddb82424c6252b4f7b4e',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 86, 27, 1.00)',
            'rgba(119, 128, 94, 1.00)',
            'rgba(52, 62, 32, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/magnolia/magnolia 'satisfaction'/magnolia 'satisfaction' (2).jpg",
          width: 512,
          id: '56290f0f2fd304ef6139f34593df9c3e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 91, 43, 1.00)',
            'rgba(110, 123, 76, 1.00)',
            'rgba(44, 60, 15, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/magnolia/magnolia 'satisfaction'/magnolia 'satisfaction' (1).jpg",
          width: 1024,
          id: 'bd899a8fc40a961dcdcfc9646d58492c',
          height: 683,
          thumbnail: true,
        },
        location: [47.227533, -1.508425],
        genre: 'Magnolia',
        cultivar: 'Satisfaction',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508425, 47.227533] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e04d4217131f7de2aeef6e60429f36c222da2e7c',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 186, 222, 1.00)',
            'rgba(119, 107, 94, 1.00)',
            'rgba(109, 94, 71, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'ann'/magnolia 'ann' (3).jpg",
          width: 1024,
          id: '7a450239ea9717a96d7ead85127886f6',
          height: 727,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 114, 158, 1.00)',
            'rgba(129, 89, 130, 1.00)',
            'rgba(103, 88, 90, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'ann'/magnolia 'ann' (1).jpg",
          width: 1024,
          id: '87fe7397f1b772d39e6ba084c6751f4d',
          height: 683,
          thumbnail: true,
        },
        location: [47.261733, -1.529058],
        genre: 'Magnolia',
        cultivar: 'Ann',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529058, 47.261733] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7a63beea90146e3ef730e0406fe40f4c07a29f5a',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 139, 166, 1.00)',
            'rgba(94, 103, 106, 1.00)',
            'rgba(72, 78, 50, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'atlas'/magnolia 'atlas' (4).jpg",
          width: 1024,
          id: '81c1a4fe5e1bd1b62cc7485c3390a157',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 99, 103, 1.00)',
            'rgba(117, 107, 112, 1.00)',
            'rgba(89, 92, 84, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'atlas'/magnolia 'atlas' (5).jpg",
          width: 1024,
          id: 'c8f9a9e1fd81c512d22838e1017dfe83',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 145, 171, 1.00)',
            'rgba(111, 102, 109, 1.00)',
            'rgba(76, 60, 52, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'atlas'/magnolia 'atlas' (3).jpg",
          width: 512,
          id: '1b648e24187bfeaa0d3f254c003bdf36',
          height: 768,
          thumbnail: true,
        },
        location: [47.26268, -1.531758],
        genre: 'Magnolia',
        cultivar: 'Atlas',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531758, 47.26268] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0cbde8b3d14056abc47a8a30bca58002484f4a7c',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 116, 151, 1.00)',
            'rgba(92, 117, 153, 1.00)',
            'rgba(86, 96, 105, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'elisa odenwald'/magnolia 'elisa odenwald' (2).jpg",
          width: 512,
          id: '24e6d7596d8975a9faeb3b58eda5123c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 103, 92, 1.00)',
            'rgba(97, 102, 82, 1.00)',
            'rgba(98, 106, 94, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'elisa odenwald'/magnolia 'elisa odenwald' (3).jpg",
          width: 1024,
          id: 'e4de6ef3421381993f8c9b9c1c53f5d5',
          height: 681,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 169, 186, 1.00)',
            'rgba(80, 84, 73, 1.00)',
            'rgba(72, 73, 43, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'elisa odenwald'/magnolia 'elisa odenwald' (1).jpg",
          width: 512,
          id: 'ecdead94aead7177fe3a3e478b9b2934',
          height: 768,
          thumbnail: true,
        },
        location: [47.2615, -1.531167],
        genre: 'Magnolia',
        cultivar: 'Elisa Odenwald',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531167, 47.2615] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '876080836aa34ac82547b9af9349caf878e02340',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 136, 197, 1.00)',
            'rgba(124, 140, 152, 1.00)',
            'rgba(53, 61, 33, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'franck gladney'/magnolia 'franck gladney' (2).jpg",
          width: 529,
          id: '0a1cb24da5510530fa277b1d4c66f922',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 118, 125, 1.00)',
            'rgba(130, 129, 119, 1.00)',
            'rgba(69, 71, 50, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'franck gladney'/magnolia 'franck gladney' (1).jpg",
          width: 1024,
          id: 'a07a226e80f7f92a8284443a1f2dfffb',
          height: 683,
          thumbnail: true,
        },
        location: [47.262047, -1.533325],
        genre: 'Magnolia',
        cultivar: 'Franck Gladney',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533325, 47.262047] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6577a77cc034569cfe3a8713216b0859d350353e',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 150, 180, 1.00)',
            'rgba(116, 101, 110, 1.00)',
            'rgba(72, 77, 38, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'heaven scent'/magnolia 'heaven scent' (4).jpg",
          width: 1024,
          id: '824de9dac8da78b0dc796be9e0c5dd0e',
          height: 683,
          thumbnail: true,
        },
        location: [47.261338, -1.532695],
        genre: 'Magnolia',
        cultivar: 'Heaven Scent',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532695, 47.261338] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3241d6e91b5a9b6ceac4e6e7b414f445ebbfbcf9',
      fields: {
        espece: 'amoena',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 125, 176, 1.00)',
            'rgba(99, 131, 178, 1.00)',
            'rgba(85, 121, 172, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia amoena/magnolia amoena.jpg',
          width: 1024,
          id: 'dffc235a82cd23adc10fe1fa7d5e448f',
          height: 605,
          thumbnail: true,
        },
        location: [47.262862, -1.535888],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535888, 47.262862] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '97db89481b4344a590e48480567583055def5653',
      fields: {
        espece: 'denudata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 149, 167, 1.00)',
            'rgba(120, 118, 104, 1.00)',
            'rgba(80, 74, 43, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia denudata 'japanese clone'/magnolia denudata 'japanese clone' (2).jpg",
          width: 1024,
          id: 'b07db2262f93425ffc6ef909b6874763',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 83, 77, 1.00)',
            'rgba(138, 136, 114, 1.00)',
            'rgba(70, 63, 44, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia denudata 'japanese clone'/magnolia denudata 'japanese clone' (1).jpg",
          width: 576,
          id: 'b513e4be94021f488f14317de6b5db2c',
          height: 768,
          thumbnail: true,
        },
        location: [47.263262, -1.533403],
        genre: 'Magnolia',
        cultivar: 'Japanese Clone',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533403, 47.263262] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6601389a7b4d6190c9855fb811fdd8e6bd24ed56',
      fields: {
        espece: 'sieboldii',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 87, 61, 1.00)',
            'rgba(113, 118, 82, 1.00)',
            'rgba(80, 98, 52, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sieboldii 'yellow stamens'/magnolia sieboldii 'yellow stamens' (8).jpg",
          width: 1024,
          id: '0f4bd8119099531ea1fd9f624b711f57',
          height: 744,
          thumbnail: true,
        },
        location: [47.261588, -1.534887],
        genre: 'Magnolia',
        cultivar: 'Yellow Stamens',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534887, 47.261588] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6a5fcedee3eeb87cca84bc1006a7d114d8c06e55',
      fields: {
        espece: 'stellata',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 119, 126, 1.00)',
            'rgba(128, 113, 100, 1.00)',
            'rgba(125, 107, 82, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'keiskei plena'/magnolia stellata 'keiskei plena'.jpg",
          width: 619,
          id: 'bdc26766b367a4e9c4b58bb5dd6607fe',
          height: 768,
          thumbnail: true,
        },
        location: [47.263245, -1.534037],
        genre: 'Magnolia',
        cultivar: 'Keiskei Plena',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534037, 47.263245] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '59acbb471e4d594d078accaf5ff09545d061e3a0',
      fields: {
        espece: 'virginiana var. australis',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 142, 154, 1.00)',
            'rgba(94, 96, 72, 1.00)',
            'rgba(83, 79, 34, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia virginiana var. australis/magnolia virginiana var. australis  (2).jpg',
          width: 1024,
          id: 'eb68708e2a5d9ee465095c00200959d2',
          height: 683,
          thumbnail: true,
        },
        location: [47.262005, -1.531378],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531378, 47.262005] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '96ce1cd099d74efce823d02343673d34d7741c2d',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'virginiana var. australis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 123, 91, 1.00)',
            'rgba(113, 128, 103, 1.00)',
            'rgba(102, 113, 86, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia virginiana var. australis/magnolia virginiana var. australis (2).jpg',
          width: 576,
          id: '5b928a108ac1686b2b7eb43796205067',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 139, 74, 1.00)',
            'rgba(100, 127, 51, 1.00)',
            'rgba(84, 104, 36, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia virginiana var. australis/magnolia virginiana var. australis (3).jpg',
          width: 576,
          id: 'bc2ecab11b760fdeddac86f0cbe5d832',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 184, 168, 1.00)',
            'rgba(97, 113, 77, 1.00)',
            'rgba(85, 96, 57, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia virginiana var. australis/magnolia virginiana var. australis (1).jpg',
          width: 1024,
          id: 'f9686afb591328945184f0f7b31ca807',
          height: 768,
          thumbnail: true,
        },
        location: [47.262705, -1.53483],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53483, 47.262705] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '32a2699aec75843fff369d8c8b1b7c20adda30f2',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 157, 208, 1.00)',
            'rgba(122, 131, 134, 1.00)',
            'rgba(55, 56, 39, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'moutiers'/magnolia x loebneri 'moutiers' (3).jpg",
          width: 1024,
          id: '2130bcda7acdea88404e34c90b1cc000',
          height: 683,
          thumbnail: true,
        },
        espece: 'x loebneri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 172, 221, 1.00)',
            'rgba(102, 109, 112, 1.00)',
            'rgba(45, 51, 27, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'moutiers'/magnolia x loebneri 'moutiers' (2).jpg",
          width: 1024,
          id: '56b4a0a070311903ebcc79bce9c1a1e4',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 121, 108, 1.00)',
            'rgba(123, 119, 104, 1.00)',
            'rgba(89, 89, 78, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'moutiers'/magnolia x loebneri 'moutiers' (1).jpg",
          width: 576,
          id: 'f2140c356c0498cb2e5b58f4f4c8d298',
          height: 768,
          thumbnail: true,
        },
        location: [47.26222, -1.533937],
        genre: 'Magnolia',
        cultivar: 'Moutiers',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533937, 47.26222] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '15d6158f8c3f8d433ef91a30d908ce2efe0e25e7',
      fields: {
        espece: 'x soulangeana',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 103, 127, 1.00)',
            'rgba(89, 88, 82, 1.00)',
            'rgba(68, 66, 54, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'amabilis'/magnolia x soulangeana 'amabilis'.jpg",
          width: 1024,
          id: '2bacb919e5c76d3d620a459a9de987c0',
          height: 683,
          thumbnail: true,
        },
        location: [47.262187, -1.532013],
        genre: 'Magnolia',
        cultivar: 'Amabilis',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532013, 47.262187] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '533ae96cf4d855b6b1537b127970f35348c2f44e',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'japonicus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 134, 88, 1.00)',
            'rgba(110, 117, 70, 1.00)',
            'rgba(113, 122, 77, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/mallotus/mallotus japonicus/mallotus japonicus (10).jpg',
          width: 1024,
          id: '60734860f483a2d426a208e32ea8cc05',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 124, 116, 1.00)',
            'rgba(89, 106, 76, 1.00)',
            'rgba(72, 88, 49, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/mallotus/mallotus japonicus/mallotus japonicus (11).jpg',
          width: 1024,
          id: '28be85f72f48c993707b531d04e16efa',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(192, 201, 193, 1.00)',
            'rgba(88, 100, 55, 1.00)',
            'rgba(87, 100, 43, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/mallotus/mallotus japonicus/mallotus japonicus (1).jpg',
          width: 1024,
          id: '5d51e8765af227ec78fd2094ccd623c5',
          height: 768,
          thumbnail: true,
        },
        location: [47.26198, -1.530228],
        genre: 'Mallotus',
        famille: 'Euphorbiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530228, 47.26198] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cc6c66a5a9b9718f6885197aa0ca8acb41418727',
      fields: {
        espece: 'azedarach var. subtripinnata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 136, 73, 1.00)',
            'rgba(119, 127, 80, 1.00)',
            'rgba(99, 112, 61, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/melia/melia azedarach var. subtripinnata/melia azedarach var. subtripinnata (2).jpg',
          width: 1024,
          id: '3c944659aa1a1f0ac398e56fdc23363e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 196, 204, 1.00)',
            'rgba(101, 115, 73, 1.00)',
            'rgba(81, 86, 63, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/melia/melia azedarach var. subtripinnata/melia azedarach var. subtripinnata (1).jpg',
          width: 1024,
          id: '5617a3e212c2011d7debc9c882d44670',
          height: 768,
          thumbnail: true,
        },
        location: [47.221125, -1.543972],
        genre: 'Melia',
        famille: 'Meliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543972, 47.221125] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2f3083eb68ffb0d4a8920b2f73bf2be8601b07db',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'parviflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 171, 135, 1.00)',
            'rgba(90, 109, 54, 1.00)',
            'rgba(76, 93, 52, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/meliosma/meliosma parviflora/meliosma parviflora (1).jpg',
          width: 576,
          id: 'd7144a29d4544105f25f221589e6ff72',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 101, 57, 1.00)',
            'rgba(111, 128, 87, 1.00)',
            'rgba(95, 123, 74, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/meliosma/meliosma parviflora/meliosma parviflora (2).jpg',
          width: 1024,
          id: '4886fddc15c461eeeafe21465880788a',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 145, 135, 1.00)',
            'rgba(113, 130, 112, 1.00)',
            'rgba(61, 83, 63, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/meliosma/meliosma parviflora/meliosma parviflora  (2).jpg',
          width: 512,
          id: 'e12f1a185236a8cd8b7e205105ee1972',
          height: 768,
          thumbnail: true,
        },
        location: [47.261687, -1.529447],
        genre: 'Meliosma',
        famille: 'Sabiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529447, 47.261687] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4bd6ac2a95e5676513e76783d244f70437461383',
      fields: {
        espece: 'carpinifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 121, 109, 1.00)',
            'rgba(112, 123, 116, 1.00)',
            'rgba(85, 102, 84, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ostrya/ostrya carpinifolia/ostrya carpinifolia (2).jpg',
          width: 1024,
          id: 'c4355473a6fedd42853357f56ba19cdd',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 90, 78, 1.00)',
            'rgba(93, 107, 87, 1.00)',
            'rgba(99, 111, 88, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ostrya/ostrya carpinifolia/ostrya carpinifolia (1).jpg',
          width: 1024,
          id: 'e3fe82843f5ec5ff971d197d2e1048ff',
          height: 683,
          thumbnail: true,
        },
        location: [47.218572, -1.542495],
        genre: 'Ostrya',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542495, 47.218572] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1ca933e71ca865c268867d999708c6fae462081b',
      fields: {
        espece: 'napaulensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 127, 123, 1.00)',
            'rgba(119, 122, 109, 1.00)',
            'rgba(133, 129, 124, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/padus/padus napaulensis/padus napaulensis (2).jpg',
          width: 512,
          id: '3e1da762a549dd895738db4124c7324a',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 99, 85, 1.00)',
            'rgba(125, 120, 85, 1.00)',
            'rgba(126, 123, 81, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/padus/padus napaulensis/padus napaulensis (1).jpg',
          width: 1024,
          id: '95a2141ab27f820ebb3d96ee4fc907f6',
          height: 683,
          thumbnail: true,
        },
        location: [47.219225, -1.541025],
        genre: 'Padus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541025, 47.219225] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'beae7c2b34b3f227102e8e4adfcc5068e32d4d12',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'persica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 138, 122, 1.00)',
            'rgba(138, 122, 97, 1.00)',
            'rgba(125, 112, 83, 1.00)',
          ],
          filename:
            'ip parc de proce/parrotia/parrotia persica/parrotia persica (3).jpg',
          width: 576,
          id: '86ad0f789a248c0078c6f7a290ce69be',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 123, 131, 1.00)',
            'rgba(140, 124, 109, 1.00)',
            'rgba(135, 123, 92, 1.00)',
          ],
          filename:
            'ip parc de proce/parrotia/parrotia persica/parrotia persica (5).jpg',
          width: 1024,
          id: 'b94d6cc08face95a5b2b4f5a333f8ef0',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 147, 219, 1.00)',
            'rgba(125, 128, 141, 1.00)',
            'rgba(99, 88, 55, 1.00)',
          ],
          filename:
            'ip parc de proce/parrotia/parrotia persica/parrotia persica (1).jpg',
          width: 576,
          id: 'fcc5df0ae2694b989f81e9bdfe7fa378',
          height: 768,
          thumbnail: true,
        },
        location: [47.221612, -1.57857],
        genre: 'Parrotia',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.57857, 47.221612] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'aa33386f708aaf3b83819a81b3d6ba0606f04ea8',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 74, 75, 1.00)',
            'rgba(128, 86, 68, 1.00)',
            'rgba(115, 73, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/parrotia hamamelidaceae/parrotia persica 'vanessa'/parrotia persica 'vanessa'  (2).jpg",
          width: 512,
          id: 'f6ca24bbe4433da55ed30a6ee344b15a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(179, 128, 80, 1.00)',
            'rgba(143, 91, 20, 1.00)',
            'rgba(52, 41, 16, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/parrotia hamamelidaceae/parrotia persica 'vanessa'/parrotia persica 'vanessa'  (4).jpg",
          width: 512,
          id: '42b094d7e7828e465e4ebd4283afbf40',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 88, 106, 1.00)',
            'rgba(103, 93, 104, 1.00)',
            'rgba(107, 90, 100, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/parrotia hamamelidaceae/parrotia persica 'vanessa'/parrotia persica 'vanessa'  (1).jpg",
          width: 512,
          id: 'd20e1cb710206ec1106f43217bcb2d2e',
          height: 768,
          thumbnail: true,
        },
        location: [47.270013, -1.585922],
        genre: 'Parrotia',
        cultivar: 'Vanessa',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585922, 47.270013] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '66439dc465aa04da4ba7698e425efc09837b7827',
      fields: {
        espece: 'jacquemontiana',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 143, 121, 1.00)',
            'rgba(108, 111, 76, 1.00)',
            'rgba(118, 128, 73, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/parrotiopsis/parrotiopsis jacquemontiana/parrotiopsis jacquemontiana (2).jpg',
          width: 576,
          id: '616315c6cee4d1ddfafc4c2510201761',
          height: 768,
          thumbnail: true,
        },
        location: [47.21903, -1.541867],
        genre: 'Parrotiopsis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541867, 47.21903] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e107972cbfe487de0d8c30f1049ccce5f4ad4f09',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 102, 74, 1.00)',
            'rgba(104, 103, 62, 1.00)',
            'rgba(84, 81, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/parrotiopsis hamamelidaceae/parrotiopsis jacquemontiana/parrotiopsis jacquemontiana (3).jpg',
          width: 1024,
          id: '6bf210e69445bf4baa5dea4df548e2de',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 96, 97, 1.00)',
            'rgba(94, 101, 105, 1.00)',
            'rgba(99, 106, 113, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/parrotiopsis hamamelidaceae/parrotiopsis jacquemontiana/parrotiopsis jacquemontiana (6).jpg',
          width: 512,
          id: 'dad1a62acf4e7debbb4d57b12873661d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 136, 158, 1.00)',
            'rgba(90, 98, 85, 1.00)',
            'rgba(44, 45, 31, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/parrotiopsis hamamelidaceae/parrotiopsis jacquemontiana/parrotiopsis jacquemontiana (1).jpg',
          width: 512,
          id: '4aae0d9a70decbc6de5493de254b2a38',
          height: 768,
          thumbnail: true,
        },
        location: [47.270306, -1.585147],
        genre: 'Parrotiopsis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585147, 47.270306] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '80719b96ad02c8001880ad67d383ac2f716bfdf3',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 146, 95, 1.00)',
            'rgba(96, 112, 57, 1.00)',
            'rgba(97, 102, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/parrotiopsis hamamelidaceae/parrotiopsis jacquemontiana/parrotiopsis jacquemontiana (4).jpg',
          width: 576,
          id: 'b66dae9ec4ac1b59e64484f4e7c64c8b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 102, 82, 1.00)',
            'rgba(107, 106, 70, 1.00)',
            'rgba(107, 102, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/parrotiopsis hamamelidaceae/parrotiopsis jacquemontiana/parrotiopsis jacquemontiana (5).jpg',
          width: 1024,
          id: '4dd738600db86a50a8faa07051fe484c',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 117, 96, 1.00)',
            'rgba(114, 102, 73, 1.00)',
            'rgba(107, 92, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/parrotiopsis hamamelidaceae/parrotiopsis jacquemontiana/parrotiopsis jacquemontiana (2).jpg',
          width: 576,
          id: '17cbb92e5b9daec6c8a1c5dfead34c00',
          height: 768,
          thumbnail: true,
        },
        location: [47.270305, -1.585147],
        genre: 'Parrotiopsis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585147, 47.270305] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dfdf5883e6dce163b7c65594c92e2498e3262e9f',
      fields: {
        nom_du_site: 'Cimeti\u00e8re de la Bouteillerie',
        espece: 'amurense',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 140, 123, 1.00)',
            'rgba(140, 141, 139, 1.00)',
            'rgba(130, 125, 126, 1.00)',
          ],
          filename:
            'ip cimetiere de la bouteillerie/phellodendron/phellodendron amurense/phellodendron amurense (2).jpg',
          width: 576,
          id: '049e1b19a8362ac8888130f39118bc26',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 123, 102, 1.00)',
            'rgba(130, 137, 129, 1.00)',
            'rgba(118, 111, 110, 1.00)',
          ],
          filename:
            'ip cimetiere de la bouteillerie/phellodendron/phellodendron amurense/phellodendron amurense (3).jpg',
          width: 576,
          id: '35ab05debf71acd810b69a19e91842f2',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(215, 222, 211, 1.00)',
            'rgba(85, 98, 74, 1.00)',
            'rgba(88, 89, 78, 1.00)',
          ],
          filename:
            'ip cimetiere de la bouteillerie/phellodendron/phellodendron amurense/phellodendron amurense (1).jpg',
          width: 1024,
          id: '8fdcc9509e15c1ad4ed7f4a2a800cb37',
          height: 768,
          thumbnail: true,
        },
        location: [47.221612, -1.541972],
        genre: 'Phellodendron',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541972, 47.221612] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '49920389cb73703d32d07d7f784875c001d047b5',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 132, 116, 1.00)',
            'rgba(124, 131, 104, 1.00)',
            'rgba(82, 92, 54, 1.00)',
          ],
          filename:
            "ip parc de proce/philadelphus/philadelphus 'manteau d'hermine'/philadelphus 'manteau d'hermine'.jpg",
          width: 576,
          id: 'b21ebb95ee9373574ea293db38371a6f',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 150, 87, 1.00)',
            'rgba(94, 145, 54, 1.00)',
            'rgba(81, 132, 41, 1.00)',
          ],
          filename:
            "ip parc de proce/philadelphus/philadelphus 'manteau d'hermine'/philadelphus 'manteau d'hermine' (2).jpg",
          width: 576,
          id: 'a895fd75d40ce1a421dc454d6defbb14',
          height: 768,
          thumbnail: true,
        },
        location: [47.224778, -1.581287],
        genre: 'Philadelphus',
        cultivar: "Manteau d'Hermine",
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581287, 47.224778] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a48290c9379128fa101468b6cbb49aa1c904384e',
      fields: {
        espece: 'adaphniphylloides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 163, 94, 1.00)',
            'rgba(108, 132, 63, 1.00)',
            'rgba(93, 115, 50, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/pittosporum/pittosporum adaphniphylloides/pittosporum adaphniphylloides (2).jpg',
          width: 1024,
          id: '4235b67d81fa1f163909296b4f1fc374',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 161, 89, 1.00)',
            'rgba(100, 140, 74, 1.00)',
            'rgba(81, 113, 44, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/pittosporum/pittosporum adaphniphylloides/pittosporum adaphniphylloides (1).jpg',
          width: 576,
          id: '3d1e7863abcd6d4639d85d944e5e56ae',
          height: 768,
          thumbnail: true,
        },
        location: [47.218903, -1.542728],
        genre: 'Pittosporum',
        famille: 'Pittosporaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542728, 47.218903] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '37b7f9020184031faf021deda16abd787e28861b',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'speciosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 80, 101, 1.00)',
            'rgba(97, 101, 108, 1.00)',
            'rgba(84, 89, 88, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/polyspora/polyspora speciosa/polyspora sp. (2).jpg',
          width: 1024,
          id: '4e151c61f8d11fcf98c1aa462f559577',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(69, 77, 89, 1.00)',
            'rgba(129, 119, 98, 1.00)',
            'rgba(100, 93, 74, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/polyspora/polyspora speciosa/polyspora sp. (3).jpg',
          width: 1024,
          id: '25457208312ad1bed3482e71d1a56928',
          height: 662,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 160, 131, 1.00)',
            'rgba(96, 108, 66, 1.00)',
            'rgba(65, 82, 52, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/polyspora/polyspora speciosa/polyspora sp. (1).jpg',
          width: 1024,
          id: '687db62a5e82866b5494a2d27f12257e',
          height: 715,
          thumbnail: true,
        },
        location: [47.220517, -1.542292],
        genre: 'Polyspora',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542292, 47.220517] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8e11f4bbe56be16c2e69647136eae79459700f55',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 151, 132, 1.00)',
            'rgba(101, 98, 71, 1.00)',
            'rgba(132, 126, 85, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/prunus/prunus mume 'beni-chidori'/prunus mume 'beni-chidori' (2).jpg",
          width: 512,
          id: 'e05396714f3c29f591d0a3791859495e',
          height: 768,
          thumbnail: true,
        },
        espece: 'mume',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 127, 106, 1.00)',
            'rgba(121, 118, 90, 1.00)',
            'rgba(121, 115, 91, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/prunus/prunus mume 'beni-chidori'/prunus mume 'beni-chidori' (1).jpg",
          width: 512,
          id: 'dbf7596d32e11e8dad1f46b154489417',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 120, 115, 1.00)',
            'rgba(111, 94, 89, 1.00)',
            'rgba(120, 107, 96, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/prunus/prunus mume 'beni-chidori'/prunus mume 'beni-chidori'  (4).jpg",
          width: 1024,
          id: '13c5c129565800eadf60d423366deea2',
          height: 683,
          thumbnail: true,
        },
        location: [47.228858, -1.507947],
        genre: 'Prunus',
        cultivar: 'Beni-chidori',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507947, 47.228858] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '86f10edc295d01c62a8e6bf9e06bb860f0f02df1',
      fields: {
        espece: 'glauca',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 141, 114, 1.00)',
            'rgba(155, 138, 121, 1.00)',
            'rgba(113, 113, 87, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/quercus/quercus glauca/quercus glauca (2).jpg',
          width: 576,
          id: 'ee7d4820cdeb313e09c6a208271862d8',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 116, 93, 1.00)',
            'rgba(127, 126, 110, 1.00)',
            'rgba(121, 130, 117, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/quercus/quercus glauca/quercus glauca (1).jpg',
          width: 576,
          id: '2e91f33fec3b6d2fe90c3e22c8f45bb6',
          height: 768,
          thumbnail: true,
        },
        location: [47.219147, -1.543628],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543628, 47.219147] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5ec03608eef957cf56aa27140959942754f99d4c',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(192, 202, 155, 1.00)',
            'rgba(96, 116, 62, 1.00)',
            'rgba(73, 88, 54, 1.00)',
          ],
          filename:
            "ip parc de proce/quercus/quercus x hispanica 'ambrozyana'/quercus x hispanica 'ambrozyana' (3).jpg",
          width: 576,
          id: '51ec83ef0e12d18fd9b3d396aaa286ba',
          height: 768,
          thumbnail: true,
        },
        espece: 'x hispanica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 121, 105, 1.00)',
            'rgba(143, 139, 125, 1.00)',
            'rgba(139, 136, 124, 1.00)',
          ],
          filename:
            "ip parc de proce/quercus/quercus x hispanica 'ambrozyana'/quercus x hispanica 'ambrozyana' (2).jpg",
          width: 576,
          id: '6586c3b2e86b72054a7b45e46294d3dc',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 125, 96, 1.00)',
            'rgba(127, 144, 98, 1.00)',
            'rgba(98, 102, 64, 1.00)',
          ],
          filename:
            "ip parc de proce/quercus/quercus x hispanica 'ambrozyana'/quercus x hispanica 'ambrozyana' (1).jpg",
          width: 576,
          id: '1059a21c8e68f2120f2a9cd6c079ddbb',
          height: 768,
          thumbnail: true,
        },
        location: [47.225395, -1.581895],
        genre: 'Quercus',
        cultivar: 'Ambrozyana',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581895, 47.225395] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '69a70df0c90e9e871d1c5f65975c1acc6d002106',
      fields: {
        espece: 'robur',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(169, 168, 154, 1.00)',
            'rgba(102, 87, 55, 1.00)',
            'rgba(79, 81, 48, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/quercus/quercus robur/quercus robur.jpg',
          width: 1024,
          id: '158b7715baead7b0d24486818091729b',
          height: 768,
          thumbnail: true,
        },
        location: [47.227138, -1.511128],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.511128, 47.227138] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a128e3247ea1ee0cd033282e2b48378a4c8ef313',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'serrata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 121, 114, 1.00)',
            'rgba(135, 132, 123, 1.00)',
            'rgba(137, 135, 136, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/quercus/quercus serrata/quercus serrata (2).jpg',
          width: 576,
          id: '9dd8d5401b6b1a2ad3901abf3ce3782d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 156, 86, 1.00)',
            'rgba(116, 154, 79, 1.00)',
            'rgba(94, 132, 51, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/quercus/quercus serrata/quercus serrata.jpg',
          width: 576,
          id: '8685b08bde6eec9446bfc18bc1f7d6f4',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 146, 101, 1.00)',
            'rgba(112, 138, 84, 1.00)',
            'rgba(123, 129, 87, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/quercus/quercus serrata/quercus serrata (1).jpg',
          width: 576,
          id: '50c5506cdf97633bf731f1bcb6cbb20a',
          height: 768,
          thumbnail: true,
        },
        location: [47.229837, -1.506763],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.506763, 47.229837] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bc90a18893e91c73fe60b1fcc150ddf3a46fac51',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'marilandica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 139, 99, 1.00)',
            'rgba(184, 184, 100, 1.00)',
            'rgba(85, 94, 14, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus marilandica/quercus marilandica (2).jpg',
          width: 576,
          id: 'b705aea29e2edce2b15bd884fb9a855c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 112, 53, 1.00)',
            'rgba(117, 146, 78, 1.00)',
            'rgba(126, 142, 67, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus marilandica/quercus marilandica (3).jpg',
          width: 576,
          id: '0ff902d67df8cc045c9c3249e8366f10',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 146, 102, 1.00)',
            'rgba(91, 110, 65, 1.00)',
            'rgba(104, 118, 66, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus marilandica/quercus marilandica (1).jpg',
          width: 1024,
          id: '92544f957cf44a000fbefe24395b9fca',
          height: 768,
          thumbnail: true,
        },
        location: [47.261817, -1.529408],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529408, 47.261817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '82e68335b4d4433ce9a3486cffa3497537815019',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'scandens',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 110, 61, 1.00)',
            'rgba(130, 141, 106, 1.00)',
            'rgba(78, 80, 41, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/rhodotypos/rhodotypos scandens/rhodotypos scandens (2).jpg',
          width: 576,
          id: 'cf6d3d4d3175672cc1a686b529095a69',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 114, 51, 1.00)',
            'rgba(134, 143, 75, 1.00)',
            'rgba(142, 135, 84, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/rhodotypos/rhodotypos scandens/rhodotypos scandens (3).jpg',
          width: 1024,
          id: 'ad84f2eebb33ca51335fe0a980526d28',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 151, 72, 1.00)',
            'rgba(133, 152, 58, 1.00)',
            'rgba(140, 140, 75, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/rhodotypos/rhodotypos scandens/rhodotypos scandens (1).jpg',
          width: 617,
          id: '1fd6f005f45bcaf08cbd7c74b4133ed2',
          height: 768,
          thumbnail: true,
        },
        location: [47.219205, -1.542858],
        genre: 'Rhodotypos',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542858, 47.219205] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '86763076a80a11884f756b28e40d625c2510762c',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'odoratum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 141, 71, 1.00)',
            'rgba(131, 152, 81, 1.00)',
            'rgba(127, 136, 69, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ribes/ribes odoratum/ribes odoratum (2).jpg',
          width: 576,
          id: '007bfb2beb38b4429a7466327fb12c36',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(179, 183, 164, 1.00)',
            'rgba(139, 150, 106, 1.00)',
            'rgba(105, 104, 106, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ribes/ribes odoratum/ribes odoratum (3).jpg',
          width: 658,
          id: 'd7e67cf4a224511564eae086c0ee144a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 120, 38, 1.00)',
            'rgba(141, 137, 38, 1.00)',
            'rgba(120, 112, 48, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ribes/ribes odoratum/ribes odoratum (1).jpg',
          width: 576,
          id: 'b9af5862eb210c086bbea8d7f0d38348',
          height: 768,
          thumbnail: true,
        },
        location: [47.219638, -1.542622],
        genre: 'Ribes',
        famille: 'Grossulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542622, 47.219638] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f0d796855c1afcc18708868c6ef350558ef8c120',
      fields: {
        espece: 'pseudoacacia',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 168, 161, 1.00)',
            'rgba(109, 132, 80, 1.00)',
            'rgba(94, 113, 53, 1.00)',
          ],
          filename:
            'ip ville de nantes/robinia/robinia pseudoacacia/robinia pseudoacacia (1).jpg',
          width: 576,
          id: 'c033644269a21affa9494115d99f85bc',
          height: 768,
          thumbnail: true,
        },
        location: [47.245383, -1.533622],
        genre: 'Robinia',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533622, 47.245383] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '92e86ebeb43fae9c26336c5d8c266c382ac63b77',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'davidii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 120, 83, 1.00)',
            'rgba(132, 140, 117, 1.00)',
            'rgba(92, 104, 68, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/sophora/sophora davidii/sophora davidii (2).jpg',
          width: 576,
          id: 'fe450d4dca736fc77adbba452b8eaf3f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 165, 136, 1.00)',
            'rgba(119, 139, 98, 1.00)',
            'rgba(120, 136, 98, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/sophora/sophora davidii/sophora davidii (3).jpg',
          width: 576,
          id: '4ea8cb3555ce25a21a133c4d498fba4c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 153, 99, 1.00)',
            'rgba(105, 124, 87, 1.00)',
            'rgba(103, 118, 75, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/sophora/sophora davidii/sophora davidii (1).jpg',
          width: 576,
          id: '51d71be37d50b53def1eb00baff0bd10',
          height: 768,
          thumbnail: true,
        },
        location: [47.219897, -1.542622],
        genre: 'Sophora',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542622, 47.219897] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '37888cf048a095879223b6ba846c47e46720b996',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'domestica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 114, 60, 1.00)',
            'rgba(100, 118, 62, 1.00)',
            'rgba(99, 117, 62, 1.00)',
          ],
          filename:
            'ip parc de proce/sorbus/sorbus domestica/sorbus domestica (3).jpg',
          width: 1024,
          id: 'adb281e068d064c6aafaf90b1e6c8257',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 141, 89, 1.00)',
            'rgba(114, 123, 70, 1.00)',
            'rgba(98, 99, 57, 1.00)',
          ],
          filename:
            'ip parc de proce/sorbus/sorbus domestica/sorbus domestica (4).jpg',
          width: 512,
          id: '47c5cbbaf30abba6ff666ae5d98c94d2',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 145, 150, 1.00)',
            'rgba(116, 120, 119, 1.00)',
            'rgba(121, 127, 131, 1.00)',
          ],
          filename:
            'ip parc de proce/sorbus/sorbus domestica/sorbus domestica (1).jpg',
          width: 512,
          id: 'c10add0d7bf4767e8e560ad9cc048172',
          height: 768,
          thumbnail: true,
        },
        location: [47.224255, -1.582155],
        genre: 'Sorbus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582155, 47.224255] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '07880b18e92ff0ac789cdcbaf14dfba3b45a6e01',
      fields: {
        espece: 'domestica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 140, 191, 1.00)',
            'rgba(107, 117, 111, 1.00)',
            'rgba(96, 92, 45, 1.00)',
          ],
          filename:
            'ip parc de proce/sorbus/sorbus domestica/sorbus domestica.jpg',
          width: 1024,
          id: 'bef3f94b211f78e2efc23d0d2847e8a4',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 133, 196, 1.00)',
            'rgba(126, 152, 194, 1.00)',
            'rgba(125, 132, 111, 1.00)',
          ],
          filename:
            'ip parc de proce/sorbus/sorbus domestica/sorbus domestica (2).jpg',
          width: 576,
          id: '3aaf5b898a285d987ff763987f0c41c2',
          height: 768,
          thumbnail: true,
        },
        location: [47.224255, -1.582163],
        genre: 'Sorbus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582163, 47.224255] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8c41052d021a0ad33b67d6ee427fcfcc13c41110',
      fields: {
        espece: 'fritschiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 152, 74, 1.00)',
            'rgba(108, 153, 65, 1.00)',
            'rgba(79, 120, 50, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/spiraea/spiraea fritschiana/spiraea fritschiana (2).jpg',
          width: 576,
          id: '83b66a60b86ea6abd7ba70edd04aa7c1',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 93, 50, 1.00)',
            'rgba(118, 134, 105, 1.00)',
            'rgba(52, 80, 22, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/spiraea/spiraea fritschiana/spiraea fritschiana (1).jpg',
          width: 576,
          id: '7909af5e380f4fae8e7b26e7fcde720e',
          height: 768,
          thumbnail: true,
        },
        location: [47.220705, -1.54292],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54292, 47.220705] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '94bc9731f925467a9deb24f8ddcf25266b3d2672',
      fields: {
        espece: 'japonicus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 134, 86, 1.00)',
            'rgba(108, 127, 84, 1.00)',
            'rgba(60, 77, 46, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/styrax/styrax japonicus/styrax japonicus (2).jpg',
          width: 1024,
          id: '86b15ed1cd3b63e1b330d7f8bfc08f21',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 127, 68, 1.00)',
            'rgba(105, 128, 74, 1.00)',
            'rgba(62, 82, 44, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/styrax/styrax japonicus/styrax japonicus (1).jpg',
          width: 1024,
          id: '5b9ce52107bae1929ae9c904f289922c',
          height: 683,
          thumbnail: true,
        },
        location: [47.261588, -1.53127],
        genre: 'Styrax',
        famille: 'Styracaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53127, 47.261588] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e7ba111eca573af62bf58dd80860415f0459f529',
      fields: {
        espece: 'reticulata var. mandshurica',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 142, 126, 1.00)',
            'rgba(135, 133, 131, 1.00)',
            'rgba(104, 97, 97, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/syringa/syringa reticulata var. mandshurica/syringa reticulata var. mandshurica.jpg',
          width: 576,
          id: 'd6df16157e5785cc644b138227390f90',
          height: 768,
          thumbnail: true,
        },
        location: [47.219217, -1.541903],
        genre: 'Syringa',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541903, 47.219217] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '87a192614d5e05335da4b8af38c7fb819e1f5ee6',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 143, 76, 1.00)',
            'rgba(119, 123, 87, 1.00)',
            'rgba(105, 99, 89, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/syringa/syringa 'red pixie'/syringa 'red pixie' (2).jpg",
          width: 1024,
          id: '367b8e9bd79838d9e6862fdd1248caa4',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 83, 56, 1.00)',
            'rgba(135, 122, 113, 1.00)',
            'rgba(99, 112, 64, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/syringa/syringa 'red pixie'/syringa 'red pixie' (3).jpg",
          width: 576,
          id: '89941ced32c015bc11921f7ed746f04e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 149, 91, 1.00)',
            'rgba(133, 145, 98, 1.00)',
            'rgba(120, 120, 99, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/syringa/syringa 'red pixie'/syringa 'red pixie' (1).jpg",
          width: 576,
          id: '7567da7b3039d44e9ced42f217845e32',
          height: 768,
          thumbnail: true,
        },
        location: [47.22808, -1.508242],
        genre: 'Syringa',
        cultivar: 'Red Pixie',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508242, 47.22808] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c014f64860fcb0612f20c9b73fdf50205de114e3',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 161, 98, 1.00)',
            'rgba(90, 137, 75, 1.00)',
            'rgba(68, 114, 39, 1.00)',
          ],
          filename:
            "ip parc de proce/viburnum/viburnum rufidulum 'royal guard'/viburnum rufidulum 'royal guard' (3).jpg",
          width: 1024,
          id: 'eb58cfd5870a516bb29be43a93fd422d',
          height: 768,
          thumbnail: true,
        },
        espece: 'rufidulum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 92, 30, 1.00)',
            'rgba(127, 150, 98, 1.00)',
            'rgba(45, 67, 33, 1.00)',
          ],
          filename:
            "ip parc de proce/viburnum/viburnum rufidulum 'royal guard'/viburnum rufidulum 'royal guard' (2).jpg",
          width: 576,
          id: 'e5d70d18b0ec1e98d0dcc5aca5207471',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 155, 76, 1.00)',
            'rgba(118, 168, 90, 1.00)',
            'rgba(61, 110, 34, 1.00)',
          ],
          filename:
            "ip parc de proce/viburnum/viburnum rufidulum 'royal guard'/viburnum rufidulum 'royal guard' (1).jpg",
          width: 576,
          id: '78b5955ecb1f40c06a1103e509efff3b',
          height: 768,
          thumbnail: true,
        },
        location: [47.223108, -1.584617],
        genre: 'Viburnum',
        cultivar: 'Royal Guard',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584617, 47.223108] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6ab0e8627dabd343a29e6200b5b8a467711e708b',
      fields: {
        espece: 'serrata',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 147, 144, 1.00)',
            'rgba(117, 119, 108, 1.00)',
            'rgba(106, 109, 77, 1.00)',
          ],
          filename:
            'ip parc de proce/zelkova/zelkova serrata/zelkova serrata.jpg',
          width: 1024,
          id: '943199595bb00e858c0f87e740fcdf6d',
          height: 768,
          thumbnail: true,
        },
        location: [47.223125, -1.581567],
        genre: 'Zelkova',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581567, 47.223125] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7293407f3333393342460f31becfe8312f1762c7',
      fields: {
        espece: 'serrata',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 169, 186, 1.00)',
            'rgba(101, 102, 78, 1.00)',
            'rgba(98, 104, 62, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/zelkova/zelkova serrata/zelkova serrata (2).jpg',
          width: 1024,
          id: '087f1b3fa11c16c87a9955700284526d',
          height: 768,
          thumbnail: true,
        },
        location: [47.229833, -1.507597],
        genre: 'Zelkova',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507597, 47.229833] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '78b3157b303d11812c2276940d20c5f573ac2a67',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'jujuba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 126, 76, 1.00)',
            'rgba(91, 127, 69, 1.00)',
            'rgba(86, 125, 67, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/ziziphus/ziziphus jujuba/ziziphus jujuba (11).jpg',
          width: 1024,
          id: '809881c1808913415ee7ec41e4b9ba1a',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 147, 98, 1.00)',
            'rgba(76, 107, 46, 1.00)',
            'rgba(89, 113, 51, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/ziziphus/ziziphus jujuba/ziziphus jujuba (9).jpg',
          width: 512,
          id: 'fb854b9c3168ca510faa181ddb15757b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 137, 94, 1.00)',
            'rgba(99, 130, 72, 1.00)',
            'rgba(73, 111, 53, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/ziziphus/ziziphus jujuba/ziziphus jujuba (10).jpg',
          width: 1024,
          id: 'e01c9f464ed0f9c82cd6aee613cc2cc3',
          height: 683,
          thumbnail: true,
        },
        location: [47.230383, -1.507],
        genre: 'Ziziphus',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507, 47.230383] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '01e14d1cbe0ba4f4ee5ac8efa9448af3b05171c6',
      fields: {
        espece: 'chinensis',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Actinidia',
        date_plantation: '1973',
        cultivar: 'Abbot',
        famille: 'Actinidiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '760b9112d23aef2700adf3bd403522d8841ee3df',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 160, 143, 1.00)',
            'rgba(121, 93, 59, 1.00)',
            'rgba(122, 93, 78, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum carlesii 'diane'/viburnum carlesii 'diana' (14).jpg",
          width: 576,
          id: '7d36acd6e292d1d2f03397e456fecc4f',
          height: 768,
          thumbnail: true,
        },
        espece: 'carlesii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 78, 64, 1.00)',
            'rgba(175, 81, 91, 1.00)',
            'rgba(152, 74, 82, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum carlesii 'diane'/viburnum carlesii 'diana' (11).jpg",
          width: 576,
          id: 'd93f6c8512d389879981d58f550a86bd',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(65, 73, 33, 1.00)',
            'rgba(147, 147, 137, 1.00)',
            'rgba(88, 94, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum carlesii 'diane'/viburnum carlesii 'diana' (1).jpg",
          width: 576,
          id: '86d041c0d1eae2cd08a946680c36bb1b',
          height: 768,
          thumbnail: true,
        },
        location: [47.271787, -1.58637],
        genre: 'Viburnum',
        cultivar: 'Diane',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58637, 47.271787] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5f694e7f3fd226f063c466b2e96862ebe725ae18',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'davidii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 124, 93, 1.00)',
            'rgba(85, 112, 77, 1.00)',
            'rgba(111, 116, 87, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum davidii/viburnum davidii (2).jpg',
          width: 1024,
          id: '2bfcfb518e1b34d8f2e2e35ccc1e35bf',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(28, 46, 24, 1.00)',
            'rgba(95, 109, 88, 1.00)',
            'rgba(75, 84, 67, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum davidii/viburnum davidii (3).jpg',
          width: 576,
          id: 'abd79c78608aee6542676a06d4176a20',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 131, 98, 1.00)',
            'rgba(122, 139, 105, 1.00)',
            'rgba(102, 125, 95, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum davidii/viburnum davidii (1).jpg',
          width: 576,
          id: 'ed530cfb2488affc91e9e8e36f2520de',
          height: 768,
          thumbnail: true,
        },
        location: [47.271513, -1.580592],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580592, 47.271513] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cacca2b90bca00bb76d0d91f3dd60267bb9316b5',
      fields: {
        espece: 'dentatum',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 132, 60, 1.00)',
            'rgba(79, 102, 38, 1.00)',
            'rgba(72, 81, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum dentatum/viburnum dentatum (7).jpg',
          width: 719,
          id: 'bbdb0c2cc4f0b49fa1a96c9ce73947fd',
          height: 768,
          thumbnail: true,
        },
        location: [47.271, -1.58105],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58105, 47.271] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '12ee2f14ae61253a003eafc086237f76b38d6131',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'erubescens var. gracilipes',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 168, 89, 1.00)',
            'rgba(93, 134, 36, 1.00)',
            'rgba(88, 120, 30, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum erubescens var. gracilipes/viburnum erubescens var. gracilipes (2).jpg',
          width: 576,
          id: '75671e29286a9f84d0d4dcd174a4a736',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 118, 54, 1.00)',
            'rgba(114, 130, 74, 1.00)',
            'rgba(76, 98, 36, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum erubescens var. gracilipes/viburnum erubescens var. gracilipes (3).jpg',
          width: 576,
          id: '2342f65d75629c6fc2ae987e1f3b6979',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 139, 64, 1.00)',
            'rgba(122, 138, 67, 1.00)',
            'rgba(85, 97, 25, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum erubescens var. gracilipes/viburnum erubescens var. gracilipes (1).jpg',
          width: 576,
          id: '607692311294a5ec46a5ebb647eadd60',
          height: 768,
          thumbnail: true,
        },
        location: [47.271212, -1.585108],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585108, 47.271212] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9746612eaa28889f2c2b8a17aa98244df1a34896',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'foetidum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 156, 74, 1.00)',
            'rgba(127, 143, 70, 1.00)',
            'rgba(86, 117, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum foetidum/viburnum foetidum (2).jpg',
          width: 576,
          id: 'b84ca932ea57ea0ef33f4a40127f399b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 159, 77, 1.00)',
            'rgba(118, 125, 72, 1.00)',
            'rgba(144, 146, 102, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum foetidum/viburnum foetidum (3).jpg',
          width: 576,
          id: '0f0478e7878ecaa7721378e9bd9b0e32',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 125, 63, 1.00)',
            'rgba(118, 153, 94, 1.00)',
            'rgba(107, 125, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum foetidum/viburnum foetidum (1).jpg',
          width: 576,
          id: '318ed8885fe2fa7633a4950d452e29bd',
          height: 768,
          thumbnail: true,
        },
        location: [47.27092, -1.584862],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584862, 47.27092] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '627ebfa100b9372bfb289fb66dabf94280c3897b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'japonicum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 123, 87, 1.00)',
            'rgba(106, 111, 44, 1.00)',
            'rgba(98, 109, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum japonicum/viburnum japonicum (4).jpg',
          width: 1024,
          id: '16ce0b2b8a5fb40a7af2b6f53fdcaa1f',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 154, 98, 1.00)',
            'rgba(140, 140, 83, 1.00)',
            'rgba(117, 111, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum japonicum/viburnum japonicum (5).jpg',
          width: 1024,
          id: 'c057561b9cab43fe608885b8e53dc61c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(59, 66, 24, 1.00)',
            'rgba(107, 111, 67, 1.00)',
            'rgba(86, 98, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum japonicum/viburnum japonicum (3).jpg',
          width: 1024,
          id: '51f02a1a6ca44691b836c87835b1aee3',
          height: 683,
          thumbnail: true,
        },
        location: [47.270497, -1.582003],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582003, 47.270497] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9fc63e16f4071509c76a83a0dea9a94fda105811',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 137, 99, 1.00)',
            'rgba(152, 130, 92, 1.00)',
            'rgba(111, 121, 78, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum lantana 'variegatum'/viburnum lantana 'variegatum' .jpg",
          width: 601,
          id: '152a625a6faed06cbc1828daea0807b1',
          height: 768,
          thumbnail: true,
        },
        espece: 'lantana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 80, 45, 1.00)',
            'rgba(137, 140, 113, 1.00)',
            'rgba(63, 66, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum lantana 'variegatum'/viburnum lantana 'variegatum' (3).jpg",
          width: 576,
          id: '71a7915ceae79a4eab3c4837c626d0b5',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 137, 56, 1.00)',
            'rgba(109, 132, 55, 1.00)',
            'rgba(112, 118, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum lantana 'variegatum'/viburnum lantana 'variegatum' (2).jpg",
          width: 576,
          id: 'a232f551348ba8450c4f6a1ec5b5ebac',
          height: 768,
          thumbnail: true,
        },
        location: [47.270847, -1.584908],
        genre: 'Viburnum',
        cultivar: 'Variegatum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584908, 47.270847] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ffe57b52b33038218c360ec71f0e024104e249b6',
      fields: {
        espece: 'melanocarpum',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 112, 114, 1.00)',
            'rgba(126, 87, 71, 1.00)',
            'rgba(111, 68, 42, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum melanocarpum/viburnum melanocarpum (9).jpg',
          width: 1024,
          id: '55b3fddd247c3555f88258fcccbfaf49',
          height: 683,
          thumbnail: true,
        },
        location: [47.270589, -1.582647],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582647, 47.270589] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '450a2f16b5acf9e771d6859767200c92c627ea34',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 132, 145, 1.00)',
            'rgba(141, 129, 107, 1.00)',
            'rgba(105, 99, 98, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum nudum 'pink beauty'/viburnum nudum 'pink beauty' (4).jpg",
          width: 632,
          id: '630ab10ab1323aa960da8120dcb20e71',
          height: 768,
          thumbnail: true,
        },
        espece: 'nudum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 125, 110, 1.00)',
            'rgba(150, 109, 114, 1.00)',
            'rgba(127, 105, 98, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum nudum 'pink beauty'/viburnum nudum 'pink beauty' (2).jpg",
          width: 560,
          id: '13df8d3c013ad2ee8123e296fd96f5c4',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 134, 122, 1.00)',
            'rgba(125, 114, 117, 1.00)',
            'rgba(136, 129, 109, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum nudum 'pink beauty'/viburnum nudum 'pink beauty' (1).jpg",
          width: 576,
          id: '0d489af643bad6c4cc003df9f3a4bd60',
          height: 768,
          thumbnail: true,
        },
        location: [47.27105, -1.582542],
        genre: 'Viburnum',
        cultivar: 'Pink Beauty',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582542, 47.27105] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0775cbdf9229637673407bde93fc4abf54e9942b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'sieboldii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(177, 183, 156, 1.00)',
            'rgba(96, 110, 62, 1.00)',
            'rgba(69, 79, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum sieboldii/viburnum sieboldii  (2).jpg',
          width: 576,
          id: '88a6296c11363ebaeaeb32ef498fc382',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 166, 114, 1.00)',
            'rgba(97, 112, 54, 1.00)',
            'rgba(84, 88, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum sieboldii/viburnum sieboldii (1).jpg',
          width: 576,
          id: 'b24035ddf0747d8955451acf7525e5db',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 111, 57, 1.00)',
            'rgba(116, 128, 76, 1.00)',
            'rgba(79, 92, 39, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum sieboldii/viburnum sieboldii  (1).jpg',
          width: 576,
          id: 'a8a833c65f9d8224260e27f4464e95c3',
          height: 768,
          thumbnail: true,
        },
        location: [47.271147, -1.582172],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582172, 47.271147] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e77e6069c402c245bab6db607c8de49cfc3765d0',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'tinus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 146, 127, 1.00)',
            'rgba(113, 123, 116, 1.00)',
            'rgba(94, 98, 86, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum tinus/viburnum tinus  (2).jpg',
          width: 576,
          id: '664548ea0a24bafed8627f6cb06ae736',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 132, 95, 1.00)',
            'rgba(110, 122, 113, 1.00)',
            'rgba(104, 119, 109, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum tinus/viburnum tinus (1).jpg',
          width: 576,
          id: '51fb1ac97c423e32dd1f83362493ed83',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 92, 81, 1.00)',
            'rgba(96, 107, 83, 1.00)',
            'rgba(47, 55, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum tinus/viburnum tinus  (1).jpg',
          width: 576,
          id: '4f63500078587eac90157aac0cd6203d',
          height: 768,
          thumbnail: true,
        },
        location: [47.269253, -1.584903],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584903, 47.269253] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a8015c58b3ea282c1f7adcd772a7b47a30717539',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'wrightii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 126, 82, 1.00)',
            'rgba(135, 125, 79, 1.00)',
            'rgba(117, 118, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum wrightii/viburnum wrightii  (10).jpg',
          width: 1024,
          id: 'ee3a425608e39a67ce3d7d09a07b0607',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 139, 103, 1.00)',
            'rgba(189, 134, 118, 1.00)',
            'rgba(115, 120, 71, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum wrightii/viburnum wrightii  (4).jpg',
          width: 576,
          id: '4c1b78a1ab0309e7f58dc5fe4523d3e5',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 148, 110, 1.00)',
            'rgba(100, 119, 58, 1.00)',
            'rgba(96, 107, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum wrightii/viburnum wrightii  (1).jpg',
          width: 576,
          id: '92899470af941a07196064b52cf3d7bf',
          height: 768,
          thumbnail: true,
        },
        location: [47.270662, -1.582463],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582463, 47.270662] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ddcf2f9d1525d7482bf762ffc3534cffda1d40f3',
      fields: {
        espece: 'x bodnantense',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 106, 74, 1.00)',
            'rgba(110, 117, 88, 1.00)',
            'rgba(66, 80, 36, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x bodnantense 'aberconway'/viburnum x bodnantense 'aberconway' (2).jpg",
          width: 576,
          id: '68ec642a738a054759e5bbc023d9b01b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 135, 92, 1.00)',
            'rgba(117, 159, 100, 1.00)',
            'rgba(89, 117, 85, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x bodnantense 'aberconway'/viburnum x bodnantense 'aberconway' (1).jpg",
          width: 547,
          id: '98729c24d30ac91a8b846f291765734f',
          height: 768,
          thumbnail: true,
        },
        location: [47.271147, -1.582075],
        genre: 'Viburnum',
        cultivar: 'Aberconway',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582075, 47.271147] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8da23b007f7c4a6d763a826fda0a6cb8331c3e53',
      fields: {
        origine: 'Goteborg Botanical Garden,Su\u00e8de',
        espece: 'macranthum Baker',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Allium',
        date_plantation: '2014',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd04bd3c2c2a2060026df2d99c9dcfc01a04b6762',
      fields: {
        origine: 'J.B. UBC,Vancouver,Canada',
        espece: 'californica Lindl.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Brodiaea',
        date_plantation: '2010',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '125b2b9a3bbec3af60b272299fd7c2b0efd96836',
      fields: {
        origine: 'J.B.,Universit\u00e9 de Berne,Berne,Suisse',
        espece: 'valentinum Pau',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Leucojum',
        date_plantation: '2011',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f1fb6e7f0fff778b3ef37de6d70ad3f7e8627255',
      fields: {
        origine: 'JB.Kyoto (Japon)',
        espece: 'tuberosum Rottler',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Allium',
        date_plantation: '2008',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a65431ab763baeb52fcd5ff2e8307624cf73ef12',
      fields: {
        origine: 'JB.Samara (Russie)',
        espece: 'decipiens Fisch.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Allium',
        date_plantation: '2008',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6e3fa00bfe5f3d76680eeb5411645ab55901ec8a',
      fields: {
        origine: 'R\u00e9colte JB Nantes',
        espece: 'ursinum L.',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Allium',
        date_plantation: '2016',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '17a821227d39e8074268fdcdacc7a39b3383c397',
      fields: {
        origine: 'Zoo and BG.of the Plzen(R\u00e9p.Tch\u00e8que)',
        espece: 'andersonii Herb.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Habranthus',
        date_plantation: '2015',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fd693477a8fbf01bcb04f11ab965ad4b68695dfa',
      fields: {
        origine: 'P\u00e9pin\u00e8res Arven - Poullan-Sur-Mer (29)',
        espece: 'lentiscus',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Pistacia',
        date_plantation: '2014',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f576a4cdc1a255bf24335e62686740479d670cd6',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'coggygria',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 70, 65, 1.00)',
            'rgba(139, 53, 34, 1.00)',
            'rgba(87, 43, 27, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cotinus [anacardiaceae]/cotinus coggygria/cotinus coggygria  (2).jpg',
          width: 1024,
          id: 'd9b8d0665623fc5020968371d27b3250',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 113, 130, 1.00)',
            'rgba(121, 78, 56, 1.00)',
            'rgba(81, 68, 37, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cotinus [anacardiaceae]/cotinus coggygria/cotinus coggygria  (3).jpg',
          width: 512,
          id: '412110de6d37906e79e9fea0495f29d4',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(60, 65, 45, 1.00)',
            'rgba(138, 84, 52, 1.00)',
            'rgba(137, 62, 29, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cotinus [anacardiaceae]/cotinus coggygria/cotinus coggygria  (1).jpg',
          width: 512,
          id: '804dc72fe44059798329348f60060c1e',
          height: 768,
          thumbnail: true,
        },
        location: [47.270942, -1.582875],
        genre: 'Cotinus',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582875, 47.270942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9db7a5291edfe2b9b41053a690e015f198309b81',
      fields: {
        espece: 'chinensis',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 115, 111, 1.00)',
            'rgba(166, 126, 123, 1.00)',
            'rgba(167, 108, 108, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/pistacia [anacardiaceae]/pistacia chinensis/pistacia chinensis.jpg",
          width: 576,
          id: 'ecb80d79f4fa8470f8c5f1d5c3dfa999',
          height: 768,
          thumbnail: true,
        },
        location: [47.226422, -1.512453],
        genre: 'Pistacia',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512453, 47.226422] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6f4d442eacc6b51e6d1101c13a1f61546fed38b9',
      fields: {
        origine: "Inst.Sup\u00e9rieur d'agronomie Tapada de Ajuda (Portugal)",
        espece: 'garganica L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Thapsia',
        date_plantation: '2004',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9a7292b61f80fb3dae1a4acde60c2d94da26817b',
      fields: {
        origine: 'W.J. Beal B.G. Michigan (USA)',
        espece: 'gregaria Bicknell',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Sanicula',
        date_plantation: '2012',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '68bc18ef802964cd9411b9872b1f0703273e67ca',
      fields: {
        origine: 'W.J.Beal Botanical Garden, Michigan, USA',
        espece: 'canadensis DC.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Cryptotaenia',
        date_plantation: '2012',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ede41d8c01a82c3b4d08fa10b36d869a354bdf85',
      fields: {
        espece: 'tricuspidatum L.',
        localisation: 'A9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2212566, -1.5434775],
        genre: 'Eryngium',
        date_plantation: '1973',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5434775, 47.2212566] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f84c5b4606397521b0eb736ef6fadd39ea0d1a67',
      fields: {
        origine: 'Arboretum Morton Lisle (U.S.A.)',
        espece: 'tabernaemontana Walt.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Amsonia',
        date_plantation: '2003',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e5218680996022a5edbba58cb1359759bc1f346b',
      fields: {
        origine: "Domaine exp\u00e9rimental d'Ain Taoujdate\u00a0- Maroc",
        espece: 'oleander',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Nerium',
        date_plantation: '2011',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '91ed5e3137c92aacc8951f1786f02134627a3f88',
      fields: {
        origine:
          "JB de Nantes (Semis naturel d'une plante d\u00e9j\u00e0 cultiv\u00e9e)",
        espece: 'sericifera',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Araujia',
        date_plantation: '2014',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0785cac0b1a3c2866dec2d97463d857f5f368249',
      fields: {
        origine: 'JB. Osterr-garten, Graz (Autriche)',
        espece: 'salicifolia Pursh',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Amsonia',
        date_plantation: '2011',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7967fd03855a66c77c817e3c8c38db708fc69aed',
      fields: {
        origine: 'P\u00e9pini\u00e8re Municipale',
        espece: 'jasminoides',
        localisation: 'A11',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2211256, -1.5428042],
        genre: 'Trachelospermum',
        date_plantation: '2015',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428042, 47.2211256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '376c5f99e9fe043ea64dff30c70d46a12421a249',
      fields: {
        espece: 'latifolia',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 104, 60, 1.00)',
            'rgba(127, 142, 51, 1.00)',
            'rgba(71, 97, 39, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ilex [aquifoliaceae]/ilex latifolia/ilex latifolia (3).jpg',
          width: 576,
          id: '1eec8f923d342ce995265fb811411a0d',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Ilex',
        famille: 'Aquifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ba7dce46ca641786d9c08ec6e560aa2151abf726',
      fields: {
        origine:
          'Botanischer Garten der Justus-Liebig-Universit\u00e4t, Giessen, Allemagne',
        espece: 'apulum P.C.Boyce',
        localisation: 'B1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2204652, -1.544656],
        genre: 'Arum',
        date_plantation: '2013',
        famille: 'Araceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544656, 47.2204652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bfa75066b296d8806fa403badaeb1ea8d5d13712',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes',
        espece: 'septemlobus',
        localisation: 'B7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198817, -1.5442188],
        genre: 'Kalopanax',
        date_plantation: '2018',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442188, 47.2198817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2eaecf26ec7f5e9a8af9ae277d445449ec396b18',
      fields: {
        origine:
          'Shanghai botanica garden - origine nature\u00a0: Mt. Maiji, 1800m (Chine)',
        espece: 'setchuenensis',
        localisation: 'B7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198817, -1.5442188],
        genre: 'Eleutherococcus',
        date_plantation: '2005',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442188, 47.2198817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '066948688aef7a9ab8f769535f2a64f45bc43a19',
      fields: {
        espece: 'cordata',
        localisation: 'B7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198817, -1.5442188],
        genre: 'Aralia',
        date_plantation: '1986',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442188, 47.2198817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8ad5d7855ee1f37c4ca512c48a73f1e629e2f18e',
      fields: {
        espece: 'helix',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Hedera',
        date_plantation: '1973',
        cultivar: 'Hibernica',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd8d59c3c975487ca4994461eb264c83f216ea957',
      fields: {
        espece: 'robusta',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Agathis',
        date_plantation: '1987',
        famille: 'Araucariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bcfd9297ab2dc3d92db84ad2877ac4cf91fa21cb',
      fields: {
        origine: 'Ets.Lepage',
        espece: 'europaeum L.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Asarum',
        date_plantation: '1986',
        famille: 'Aristolochiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ed1a35a0da5b7cab0cba44e2415380fc182a2c09',
      fields: {
        origine: 'Alpengarten im Belvederegarten,Wien,Autriche',
        espece: 'persica Hausskn.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Scilla',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '785972b27718d2d63f6b73a269753e2ccf17ed9c',
      fields: {
        origine: 'Botanischer Garten Kiel,Kiel,All.',
        espece: 'ramosum L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Anthericum',
        date_plantation: '2013',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '20112bb3ac0f8f07676b3c71af89c47fec3d1d39',
      fields: {
        origine: 'Botanischer Garten,Dresden,All.',
        espece: 'armeniacum Leichtl.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Muscari',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2ed5a38004a19350aaa50bad156a3968fee8be5a',
      fields: {
        origine: 'Botanischrt Garten,Dresden,All.',
        espece: 'princeps Bak.',
        localisation: 'I2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185657, -1.5426599],
        genre: 'Ornithogalum',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426599, 47.2185657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2f79de50d18729b460d8002d5772957e5f2ab9ae',
      fields: {
        origine: 'Ets.Horticoles Camus',
        espece: 'elatior Blume.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Aspidistra',
        date_plantation: '1975',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd135bdc2b3ac63665b00ebd31831e8d9debb3a38',
      fields: {
        origine: 'J.B. Lyon (France)',
        espece: 'romana Rchb.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Bellevalia',
        date_plantation: '2011',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '99b9f4cadc25644a1905379ee396d857f7be527c',
      fields: {
        origine: 'J.B.Edouard-Marie Heckel,Marseille,FR.',
        espece: 'peruviana L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Scilla',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b5f7479c257dd81dad29f20e3222fe87138e630e',
      fields: {
        origine: 'J.B.Friedrich Jena,Jena,All.',
        espece: 'litardierei Breistr.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Scilla',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1684a549299fb19fc29fbf04782270208ff4a16e',
      fields: {
        origine: 'JB.Porto (Portugal)',
        espece: 'italica Rothm',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Hyacinthoides',
        date_plantation: '2006',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a183ef0713b508e1810097ddac1bce546f9a534b',
      fields: {
        origine: 'JB.Tbilisi (G\u00e9orgie)',
        espece: 'szovitsianum  Baker',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Muscari',
        date_plantation: '2008',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e6b59f81c51b6ff39d6e0edf44876c26e61fc341',
      fields: {
        origine: 'JB.Timaru (N-Z\u00e9lande)',
        espece: 'australis Endl.',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Cordyline',
        date_plantation: '2006',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4d51f8f113df98fd1a4e0cf893a6df2fb78d9e21',
      fields: {
        origine: 'JB.Wurzburg (Allemagne)',
        espece: 'amethystina Chouad',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Brimeura',
        date_plantation: '2008',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'efeb42c1118491c4907b5b81fa0aaf2249440e82',
      fields: {
        origine: 'National Botanic Garden of Belgique,Meise,Belgique',
        espece: 'siberica Haw.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Scilla',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1a2a62be042a3189ed08128c1f10deacde05a1bb',
      fields: {
        origine: 'Rivierenhof arboretum Deurne (Belgique)',
        espece: 'asphadeloides Bunge',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Anemarrhena',
        date_plantation: '2015',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e0f0cbb6239bbe1c4ff47288ba83af0c3788aa09',
      fields: {
        origine: 'Universit\u00e9 de Potsdam',
        espece: 'aucheri Baker',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Muscari',
        date_plantation: '2010',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '834422a6fef56dbc4cd9afdfd1e791724439ba43',
      fields: {
        espece: 'elatior Blume.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Aspidistra',
        date_plantation: '1973',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2267da643a1b1f7f898f0aa8c33b853b9ba646c4',
      fields: {
        espece: 'australis',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Cordyline',
        date_plantation: '1973',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6c375c5b7436f4c51995a23db19e76f834e6f51f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'racemosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 158, 89, 1.00)',
            'rgba(110, 144, 70, 1.00)',
            'rgba(100, 122, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/danae [asparagaceae]/danae racemosa/danae racemosa (2).jpg',
          width: 1024,
          id: 'bd72a8c409732b67909caa988d6c7802',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 121, 45, 1.00)',
            'rgba(116, 159, 59, 1.00)',
            'rgba(98, 141, 47, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/danae [asparagaceae]/danae racemosa/danae racemosa (3).jpg',
          width: 576,
          id: 'a975bb377500ef12cd95f8e7109d4dbb',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 156, 74, 1.00)',
            'rgba(126, 154, 63, 1.00)',
            'rgba(79, 117, 39, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/danae [asparagaceae]/danae racemosa/danae racemosa (1).jpg',
          width: 576,
          id: '1d668c8dbbdce9e1216fac2142cfaeec',
          height: 768,
          thumbnail: true,
        },
        location: [47.270792, -1.585064],
        genre: 'Danae',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585064, 47.270792] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fa169e138476874fad412d79c54f71c2b34b001f',
      fields: {
        espece: 'platyphylla F.T.Wang & T.Tang',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Liriope',
        date_plantation: '1998',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9d28c7f77876b04cdcfb1f3a03dcdc36e9c7bd69',
      fields: {
        origine: 'B.G. de Chemnitz (All.)',
        espece: 'argentea L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Potentilla',
        date_plantation: '2014',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '21395d3c3d608facb4f4f68d0568ddb4bda59297',
      fields: {
        origine: 'Botanischer Garten, Tubingen, Allemagne',
        espece: 'tatarinowii Maxim.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Prenanthes',
        date_plantation: '2012',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0b89c24072c7851fd93144c045f8584002e7c51c',
      fields: {
        origine: 'J. Alpin du Lautaret        (France)',
        espece: 'doronicum L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Senecio',
        date_plantation: '2010',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1425434db6203f20e0b06d4bde29e9f57500dd1c',
      fields: {
        origine: 'J.Alp.Courmayeur',
        espece: 'pyrenaicus  Gouan.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Leontodon',
        date_plantation: '1999',
        cultivar: 'danubialis Simonkai',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c80abaddcdf5e094cc633b52750c672fb538573a',
      fields: {
        origine: 'J.Alp.Meyrin (Suisse)',
        espece: 'cynaroides G. Lopez Gonzalez',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Leuzea',
        date_plantation: '1999',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '686433d9d16ca595f8cc294708507325317cbc24',
      fields: {
        origine: 'Jardin botanique alpin et institution Murmansk',
        espece: 'hyparcticum Along.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Hieracium',
        date_plantation: '2010',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '45ad943a1ec801e95eba5430f67f51903b2872a7',
      fields: {
        origine: 'JB. G\u00f6teborg (Su\u00e8de)',
        espece: 'sparsifolium Lindeb.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Hieracium',
        date_plantation: '2010',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0dd3d96b4c23e3cedd2965e6174ee4287ca1c4b0',
      fields: {
        origine: 'JB. Michele Tenor, Lama Dei Peligni (Italie)',
        espece: 'triumfetti Dost\u00e1l ex \u00c1.L\u00f6ve & D.L\u00f6ve',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Cyanus',
        date_plantation: '2011',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '16b657333f4f776a3d033ec83450f08c0bbb0f11',
      fields: {
        origine: 'JB.Bremen (Allemagne)',
        espece: 'amellus L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Aster',
        date_plantation: '2009',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bcd2fa60e5d393943648cec17f3e0fed97e6d6be',
      fields: {
        origine: 'JB.Ibaraki (Japon)',
        espece: 'montana  Schlecht. ex Ledeb',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Artemisia',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '87b16c7271d737a20dc54e0353844a6ab350fc1c',
      fields: {
        origine: 'JB.Lausanne (Suisse)',
        espece: 'yunnanensis Franch.',
        localisation: 'D2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195252, -1.5420507],
        genre: 'Aster',
        date_plantation: '1992',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420507, 47.2195252] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b84ea12a1df6daa17b2c8f7fbef1d5d2a6ef33ed',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'picroides Roth.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Reichardia',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bb8dd1811508aae209772cacf3695b7476e05045',
      fields: {
        origine: 'JB.Postdam (Allemagne)',
        espece: 'salicifolia L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Achillea',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '84b19256fb63b5c22218aed2c808d994395da8af',
      fields: {
        origine: 'JB.Prague (R\u00e9p.Tch\u00e8que)',
        espece: 'margaritae Soo',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Leucanthemum',
        date_plantation: '2009',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '652a2e4a1d57e5d4bd8f519e3a4da6570194d710',
      fields: {
        origine: 'JB.Rostov ad Donum (Russie)',
        espece: 'setacea Waldst.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Achillea',
        date_plantation: '2009',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3011005c81bcbd580879666b92feb36db91778dd',
      fields: {
        origine: 'JB.Rostov ad Donum (Russie)',
        espece: 'virosum Pall.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Hieracium',
        date_plantation: '2009',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '14c8ea46c3d6b45cfae869419a87d2d53dafd36f',
      fields: {
        origine: 'JB.Seattle (USA)',
        espece: 'aromaticum L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Eupatorium',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e8ac71d2695d1658fb7b7ab2dbc6f386739eada6',
      fields: {
        origine: 'JB.W.J Beal Michigan (USA.)',
        espece: 'flexicaulis L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Solidago',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0569905c5b3ddb44e7d39cce0b0b715e60616a0f',
      fields: {
        origine: 'JBU.& Alp.Innsbr\u00fcck (Autriche)',
        espece: 'pseudophrygia Meyer',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Centaurea',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e7c4270ce418d1aa3b464bf51f0b0f5e089b99e9',
      fields: {
        origine: 'JBU.Riga (Lettonie)',
        espece: 'alpinus L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Erigeron',
        date_plantation: '1990',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ce03b3d6d6ebd3c3fbae152ae984b4e9675f2143',
      fields: {
        origine: 'Mus\u00e9e Botanique de Kristiansand',
        espece: 'alpinum L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Hieracium',
        date_plantation: '2003',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2d4ed5e5274d66dde88c587bd39fb4e3228f703d',
      fields: {
        origine: "R\u00e9serve Bowman's Hill (U.S.A.)",
        espece: 'puniceus L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Aster',
        date_plantation: '1990',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4aa813253051a91a03a6f51a19e350128641a749',
      fields: {
        espece: 'fistulosum Barrat.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Eupatorium',
        date_plantation: '1988',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9c1a4e349952a33bc535ca51ecd04cf1253c9f3e',
      fields: {
        espece: 'x haastii',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 105, 70, 1.00)',
            'rgba(113, 126, 96, 1.00)',
            'rgba(143, 139, 116, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/olearia [asteraceae]/olearia x haastii/olearia x haastii .jpg',
          width: 1024,
          id: '0b6a6767f24bfbf131e796677292b839',
          height: 768,
          thumbnail: true,
        },
        location: [47.270617, -1.581522],
        genre: 'Olearia',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581522, 47.270617] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '93731a98fa305dc1255bcf52f05adc34267ff9f6',
      fields: {
        espece: 'przewalskii  Maxim.',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Senecio',
        date_plantation: '1973',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5a12b0d8d85a778dc9beda35c961c937ccd23efd',
      fields: {
        origine: 'Universit\u00e9 de Postdam (Allemagne)',
        espece: 'delavayi Bur.et Franch',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Incarvillea',
        date_plantation: '2011',
        famille: 'Bignoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1371f147e923d1f8dae97d3cb7db7a1514717752',
      fields: {
        origine: "jardins d'\u00e9coute s'il pleut",
        espece: 'unigemmata Nakai',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Woodwardia',
        date_plantation: '2015',
        famille: 'Blechnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2c797fa2581d2f221401b57e8dc077dc2e694bb9',
      fields: {
        origine: 'Friedrich Alexander B.G. Erlangen (All.)',
        espece: 'helveticum Boiss.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Onosma',
        date_plantation: '2014',
        famille: 'Boraginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4a43b7bcc3b265c4cb6c44ee244590dc0e660cec',
      fields: {
        origine: 'J.B Bayreuth (Allemagne)',
        espece: 'montana Wulf. ex Schrank',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Pulmonaria',
        date_plantation: '2011',
        cultivar: 'mollis',
        famille: 'Boraginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '786b322862d77f1448ee1438b83c5e086986dada',
      fields: {
        origine: 'JB.Trieste (Italie)',
        espece: 'javorkae Simonkai',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Onosma',
        date_plantation: '2008',
        famille: 'Boraginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '58413ebb8a075bfc88709afa5107de261d181cce',
      fields: {
        origine: 'Botanischer Garten Tubingen (All.)',
        espece: 'odoratum Ehrh.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Erysimum',
        date_plantation: '2014',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a11c8bb9e415b9c9119eeb1c4afb3bd1d77273f7',
      fields: {
        origine: 'J.Montreux (France)',
        espece: 'utriculata  Medik.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Alyssoides',
        date_plantation: '2008',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '516d19ee62b9a387ff64bb565124a835ad7429df',
      fields: {
        origine: 'JB. Zagreb (Croatie)',
        espece: 'argenteum All.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Alyssum',
        date_plantation: '2001',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7ec8cb24de3ff86093fad16925e04f1661613056',
      fields: {
        origine: 'JBU.Z\u00fcrich (Suisse)',
        espece: 'sempervirens L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Iberis',
        date_plantation: '2004',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cf61db9c2e4b5cf084ceb59f0596a594bb08ec6a',
      fields: {
        origine: 'JB.Desert Phoenix USA.',
        espece: 'mirabilis L.B. Smith',
        localisation: 'A2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2208871, -1.5444631],
        genre: 'Puya',
        date_plantation: '1994',
        famille: 'Bromeliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444631, 47.2208871] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1da10394b8f102d406a2a80c1c45b1ad28d6afbf',
      fields: {
        espece: 'hookeriana var. humilis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 142, 85, 1.00)',
            'rgba(106, 130, 45, 1.00)',
            'rgba(121, 139, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sarcococca [buxaceae]/sarcococca hookeriana var. humilis/sarcococca hookeriana var. humilis (2).jpg',
          width: 576,
          id: 'cf78bf9e11306c0b78d3e364552bb941',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 140, 84, 1.00)',
            'rgba(115, 131, 59, 1.00)',
            'rgba(96, 109, 32, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sarcococca [buxaceae]/sarcococca hookeriana var. humilis/sarcococca hookeriana var. humilis (1).jpg',
          width: 576,
          id: '24d9bcace389fe6c16c1fcc2b0abcbd8',
          height: 768,
          thumbnail: true,
        },
        location: [47.27107, -1.582178],
        genre: 'Sarcococca',
        famille: 'Buxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582178, 47.27107] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1460700cb94af33de1b4c271f31956a10e81d9bb',
      fields: {
        origine: 'JB.Chambesy (Gen\u00e8ve)',
        espece: 'thyrsoides L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Campanula',
        date_plantation: '2004',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cd5977da7b2e1d0aa7f27283b6d7fc2502e9d754',
      fields: {
        origine: 'Jean-Michel  SPAS (France)',
        espece: 'syphilitica L.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Lobelia',
        date_plantation: '2008',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '55933e285933e6ea7636bdedc56949c2d02a8530',
      fields: {
        origine: 'Plantentuin Gent (Belgique)',
        espece: 'tchihatcheffii Fisch.& C.A.Mey.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Michauxia',
        date_plantation: '2014',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8a91ac5a8fa3f4be90b2de07e7910d2d0a96e85e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'tatarinowii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 152, 66, 1.00)',
            'rgba(103, 140, 59, 1.00)',
            'rgba(85, 108, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pteroceltis [cannabaceae]/pteroceltis tatarinowii/pteroceltis tatarinowii (2).jpg',
          width: 576,
          id: '51cc82a6aa348c6944e676a0e750c285',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 102, 67, 1.00)',
            'rgba(124, 150, 84, 1.00)',
            'rgba(109, 131, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pteroceltis [cannabaceae]/pteroceltis tatarinowii/pteroceltis tatarinowii (3).jpg',
          width: 576,
          id: 'abf04d15ca71b88370a64692af27e6e4',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(180, 198, 188, 1.00)',
            'rgba(109, 126, 82, 1.00)',
            'rgba(54, 72, 39, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pteroceltis [cannabaceae]/pteroceltis tatarinowii/pteroceltis tatarinowii (1).jpg',
          width: 576,
          id: '128c2be16beac31dbf8eb80fc750a959',
          height: 768,
          thumbnail: true,
        },
        location: [47.271728, -1.586178],
        genre: 'Pteroceltis',
        famille: 'Cannabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586178, 47.271728] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5174b8cbcd6be925a41532182dfc5ba8687a7647',
      fields: {
        origine: 'J.B Wuppertal (Allemagne)',
        espece: 'columbaria L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Scabiosa',
        date_plantation: '2011',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2e776632dc93b7c3dfe7d1416ecdcac9c62ebede',
      fields: {
        origine: "Mus\u00e9um National d'histoire de Paris",
        espece: 'villosa Juss.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Patrinia',
        date_plantation: '2006',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd68d736f758abb17d4ab57fbe2bde4c094395468',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'parvifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 157, 106, 1.00)',
            'rgba(129, 148, 69, 1.00)',
            'rgba(114, 124, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia parvifolia/abelia parvifolia (2).jpg',
          width: 682,
          id: 'bd9c654cadeec37185197b51fe496c08',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 140, 84, 1.00)',
            'rgba(145, 134, 100, 1.00)',
            'rgba(141, 134, 98, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia parvifolia/abelia parvifolia (3).jpg',
          width: 576,
          id: '8f42cbe38997c4ba98ab01ddb27625da',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 109, 77, 1.00)',
            'rgba(133, 124, 105, 1.00)',
            'rgba(77, 80, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia parvifolia/abelia parvifolia (1).jpg',
          width: 576,
          id: '4376d36644bcee01036a01485a798cc9',
          height: 768,
          thumbnail: true,
        },
        location: [47.271587, -1.583145],
        genre: 'Abelia',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583145, 47.271587] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b86ca79dbd6d1d4feb870e27954db1e4a553fcef',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'syringantha',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 137, 75, 1.00)',
            'rgba(129, 133, 92, 1.00)',
            'rgba(150, 157, 120, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera syringantha/lonicera syringantha  (3).jpg',
          width: 576,
          id: 'bf6b918634241727dbb1c52637b83779',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 123, 82, 1.00)',
            'rgba(145, 151, 112, 1.00)',
            'rgba(149, 151, 117, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera syringantha/lonicera syringantha (1).jpg',
          width: 576,
          id: '897787cab1d01476810d6801b2753d7c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 122, 78, 1.00)',
            'rgba(130, 150, 113, 1.00)',
            'rgba(135, 144, 115, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera syringantha/lonicera syringantha  (1).jpg',
          width: 576,
          id: '00063604b36bfa10e7b6f3874f5c0386',
          height: 768,
          thumbnail: true,
        },
        location: [47.270197, -1.583853],
        genre: 'Lonicera',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583853, 47.270197] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '03c496b696c9cbe633c6e9c24fcf7b3bf6f9e9bf',
      fields: {
        espece: 'x purpusii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 134, 111, 1.00)',
            'rgba(119, 112, 84, 1.00)',
            'rgba(108, 108, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera x purpusii 'winter beauty'/lonicera x purpusii 'winter beauty' (2).jpg",
          width: 1024,
          id: 'c9f25727e56cab4582a3b5068155b410',
          height: 722,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 115, 91, 1.00)',
            'rgba(122, 112, 82, 1.00)',
            'rgba(104, 103, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera x purpusii 'winter beauty'/lonicera x purpusii 'winter beauty' (1).jpg",
          width: 1024,
          id: 'ea9276f6a8be5b2fce304bef414ffa87',
          height: 683,
          thumbnail: true,
        },
        location: [47.269953, -1.584611],
        genre: 'Lonicera',
        cultivar: 'Winter Beauty',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584611, 47.269953] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e01e42a9963d648a8adfc5b8534fff88bc9ab94d',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 107, 91, 1.00)',
            'rgba(130, 124, 101, 1.00)',
            'rgba(122, 113, 98, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera x purpusii 'winter beauty'/lonicera x purpusii 'winter beauty' (6).jpg",
          width: 576,
          id: 'e9a9da52fc5189c1da0dbcb51cc8c448',
          height: 768,
          thumbnail: true,
        },
        espece: 'x purpusii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 161, 133, 1.00)',
            'rgba(130, 119, 85, 1.00)',
            'rgba(130, 125, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera x purpusii 'winter beauty'/lonicera x purpusii 'winter beauty' (5).jpg",
          width: 576,
          id: 'beeb4d10cf9e54ff15e4fc5765946194',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 155, 91, 1.00)',
            'rgba(127, 142, 80, 1.00)',
            'rgba(117, 123, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera x purpusii 'winter beauty'/lonicera x purpusii 'winter beauty' (4).jpg",
          width: 576,
          id: '929e50d8787fb3854bd4b65b3ad71d61',
          height: 768,
          thumbnail: true,
        },
        location: [47.269953, -1.584612],
        genre: 'Lonicera',
        cultivar: 'Winter Beauty',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584612, 47.269953] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd28eb91dd7d860eb621b325159c263207c794c0a',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'fragrantissima',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 156, 152, 1.00)',
            'rgba(121, 109, 85, 1.00)',
            'rgba(79, 71, 48, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/lonicera [caprifoliaceae]/lonicera fragrantissima/lonicera fragrantissima  (2).jpg',
          width: 1024,
          id: 'f838fba1b1cb2f72206f66d09e764b91',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 129, 107, 1.00)',
            'rgba(112, 116, 74, 1.00)',
            'rgba(86, 91, 53, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/lonicera [caprifoliaceae]/lonicera fragrantissima/lonicera fragrantissima (1).jpg',
          width: 512,
          id: '415def4447a870a6761a6f228484db12',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(185, 182, 175, 1.00)',
            'rgba(112, 105, 77, 1.00)',
            'rgba(86, 82, 56, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/lonicera [caprifoliaceae]/lonicera fragrantissima/lonicera fragrantissima  (1).jpg',
          width: 864,
          id: '89ace8a3983dda11225ea996756eeaf9',
          height: 768,
          thumbnail: true,
        },
        location: [47.227997, -1.508888],
        genre: 'Lonicera',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508888, 47.227997] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f6c03021a6d43778040d3164e935a982a8f1015b',
      fields: {
        origine: 'Botanischer Garten,Mainz,Allamagne',
        espece: 'knappii Asch. & Kanitz',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Dianthus',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5c71ad421f9a2d2099e4da1502cceaf19f8f847c',
      fields: {
        origine: 'Experimenteller B.G. Gottingen (All.)',
        espece: 'fastigiata L.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Gypsophila',
        date_plantation: '2015',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ab7124d2fc830947e368215c5656f351e1402b84',
      fields: {
        origine: 'Goteborg Botanical Garden(Su\u00e8de)',
        espece: 'eriophorum Kit.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Cerastium',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '702e45eba3d16a63b486b3d9d03efbc85860d1c3',
      fields: {
        origine: 'J. alpin la Ramberta, Montreux (Suisse)',
        espece: 'flos-jovis Greuter & Burdet',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Silene',
        date_plantation: '2011',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e10347eac526bfb36e412aa18381bd2b36c6432a',
      fields: {
        origine: 'J.Alp.Belvedere Wien (Autriche)',
        espece: 'caespilosa',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Saponaria',
        date_plantation: '2005',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b14d936036afc4d976c828fbb68ae76330b96b4b',
      fields: {
        origine: 'J.B. Graz (Autriche)',
        espece: 'persica Boiss.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Saponaria',
        date_plantation: '2011',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4231c29a5612a7f2e9e67b03d2aaa2da0533fcd8',
      fields: {
        origine: 'Jardin botanique universit\u00e9 Ljubljana',
        espece: 'flos-cuculi L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Lychnis',
        date_plantation: '2010',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '183c9a6fbf2bec7c46c492d114f121165050b85e',
      fields: {
        origine: 'JB.Bremen (Allemagne)',
        espece: 'seguieri Vill.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Dianthus',
        date_plantation: '2009',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e94bf9c83137bd7e0c5a4f84c4a56dfcd39799a8',
      fields: {
        origine: 'JB.Oulu (Finlande)',
        espece: 'longifolia Willd.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Stellaria',
        date_plantation: '2009',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd264e8556f79bd02287feecfff6d9d8384d995a2',
      fields: {
        espece: 'alatus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 90, 75, 1.00)',
            'rgba(97, 60, 47, 1.00)',
            'rgba(80, 54, 42, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus alatus/euonymus alatus (7).jpg',
          width: 1024,
          id: 'd8df7f3619be5194a77b79bddfbee299',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 99, 135, 1.00)',
            'rgba(112, 113, 144, 1.00)',
            'rgba(126, 100, 129, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus alatus/euonymus alatus (6).jpg',
          width: 1024,
          id: '354f2f2f24f08290fa28115a2a1c4041',
          height: 683,
          thumbnail: true,
        },
        location: [47.271508, -1.580553],
        genre: 'Euonymus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580553, 47.271508] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f84db97419c20f3484c8fafe96ea1227ac27436b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'planipes',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 117, 83, 1.00)',
            'rgba(162, 117, 107, 1.00)',
            'rgba(105, 76, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus planipes/euonymus planipes  (2).jpg',
          width: 576,
          id: 'fab65cfd3ffc0c454357223daebb56ef',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 133, 94, 1.00)',
            'rgba(163, 116, 106, 1.00)',
            'rgba(160, 107, 97, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus planipes/euonymus planipes  (3).jpg',
          width: 576,
          id: '9b6e761df6c4f50689ff2c25a5b631e1',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 145, 112, 1.00)',
            'rgba(133, 112, 70, 1.00)',
            'rgba(99, 93, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus planipes/euonymus planipes  (1).jpg',
          width: 576,
          id: '6c7bbf257fadcbe6e44d3c99496e6b93',
          height: 768,
          thumbnail: true,
        },
        location: [47.271362, -1.582403],
        genre: 'Euonymus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582403, 47.271362] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f66f5650027f56b8f56959401b6cea83ef1c54d9',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'boaria',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 128, 81, 1.00)',
            'rgba(128, 139, 84, 1.00)',
            'rgba(119, 130, 87, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/maytenus [celastraceae]/maytenus boaria/maytenus boaria (3).jpg',
          width: 1024,
          id: '02b88bfba8959c2bf3f98674e073fdeb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 150, 76, 1.00)',
            'rgba(125, 142, 85, 1.00)',
            'rgba(105, 123, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/maytenus [celastraceae]/maytenus boaria/maytenus boaria (4).jpg',
          width: 576,
          id: '0fb71f5315c8779d88da00a6425a4243',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 117, 68, 1.00)',
            'rgba(101, 123, 68, 1.00)',
            'rgba(109, 129, 82, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/maytenus [celastraceae]/maytenus boaria/maytenus boaria (2).jpg',
          width: 1024,
          id: 'a0f0589cdca465bb308c88b9198821fa',
          height: 683,
          thumbnail: true,
        },
        location: [47.269705, -1.584778],
        genre: 'Maytenus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584778, 47.269705] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '79ba9465f464edd79d388bdc105fcaff2c3c03af',
      fields: {
        origine: 'JB.Lausanne (Suisse)',
        espece: 'canum Baumg.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Helianthemum',
        date_plantation: '2004',
        cultivar: 'canum',
        famille: 'Cistaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2a22988b85db4d7a04307ec6163eeeebbd483581',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale Gd Blottereau',
        espece: 'X obtusifolius',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Cistus',
        date_plantation: '2014',
        famille: 'Cistaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6da8e34f3b09ecdf9c86aba6ec164a4b630ac723',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 127, 102, 1.00)',
            'rgba(151, 93, 84, 1.00)',
            'rgba(109, 97, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus 'eddie's white wonder'/cornus 'eddie's white wonder' (11).jpg",
          width: 576,
          id: 'a93b9a79029ce24d0f353bbcb13b1d6f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 136, 91, 1.00)',
            'rgba(152, 131, 85, 1.00)',
            'rgba(65, 88, 34, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus 'eddie's white wonder'/cornus 'eddie's white wonder' (12).jpg",
          width: 634,
          id: 'fd4b683634bd4c3606438edcf8ffe6d3',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 134, 86, 1.00)',
            'rgba(129, 147, 54, 1.00)',
            'rgba(119, 124, 78, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus 'eddie's white wonder'/cornus 'eddie's white wonder' (10).jpg",
          width: 576,
          id: '133f4317eca7c03933326b3942f4c23b',
          height: 768,
          thumbnail: true,
        },
        location: [47.270817, -1.581538],
        genre: 'Cornus',
        cultivar: "Eddie's White Wonder",
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581538, 47.270817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c4401d81b8e443bebe10f7bb01ae3a2d28fa80cd',
      fields: {
        espece: 'alternifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 136, 79, 1.00)',
            'rgba(136, 142, 48, 1.00)',
            'rgba(138, 135, 83, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus alternifolia 'candie light'/cornus alternifolia 'candie light' .jpg",
          width: 576,
          id: '3ad894554b8e30f82862ec7a13b83825',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 124, 100, 1.00)',
            'rgba(119, 138, 89, 1.00)',
            'rgba(127, 128, 104, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus alternifolia 'candie light'/cornus alternifolia 'candie light' (1).jpg",
          width: 576,
          id: '617563f8ce8fc1d50fac09bd7dafd70f',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Cornus',
        cultivar: 'Candie Light',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6e2be202f78854104baa7bbbe029e4f19561c5fe',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'controversa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(181, 191, 161, 1.00)',
            'rgba(97, 114, 57, 1.00)',
            'rgba(89, 95, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus controversa/cornus controversa  (2).jpg',
          width: 1024,
          id: '83aabdfc124328f567597ca6ef6d8b46',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 147, 79, 1.00)',
            'rgba(112, 153, 61, 1.00)',
            'rgba(106, 121, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus controversa/cornus controversa  (3).jpg',
          width: 576,
          id: '04f780178062eb8d0b392d6c9535f4d6',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 128, 62, 1.00)',
            'rgba(118, 127, 69, 1.00)',
            'rgba(62, 78, 23, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus controversa/cornus controversa  (1).jpg',
          width: 576,
          id: '35986480a2277adf59df53c65646f8c2',
          height: 768,
          thumbnail: true,
        },
        location: [47.270103, -1.585988],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585988, 47.270103] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3d741bf2ad9c583e1f5cbc425d52be3ccf5ba797',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'elliptica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 117, 79, 1.00)',
            'rgba(93, 111, 72, 1.00)',
            'rgba(89, 96, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus elliptica/cornus elliptica (11).jpg',
          width: 1024,
          id: '6408a56fc7604d562fdddccdfa67b4ad',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 107, 72, 1.00)',
            'rgba(106, 122, 87, 1.00)',
            'rgba(106, 120, 90, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus elliptica/cornus elliptica (12).jpg',
          width: 1024,
          id: 'f16e6839782a61c0470304f04c82e8f7',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 106, 59, 1.00)',
            'rgba(89, 110, 67, 1.00)',
            'rgba(105, 116, 88, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus elliptica/cornus elliptica (1).jpg',
          width: 1024,
          id: '68b7b6cbb90354682656db80dc5eb20b',
          height: 683,
          thumbnail: true,
        },
        location: [47.270847, -1.584908],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584908, 47.270847] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a80f7a6b57274cbc45743fea68802fa7c013b282',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 125, 46, 1.00)',
            'rgba(119, 161, 62, 1.00)',
            'rgba(104, 139, 42, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'bultinck's giant flower'/cornus kousa 'bultinck's giant flower' (3).jpg",
          width: 576,
          id: 'ccf58be42a1e431f81bd9d5c5251bdc2',
          height: 768,
          thumbnail: true,
        },
        espece: 'kousa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 96, 73, 1.00)',
            'rgba(115, 103, 71, 1.00)',
            'rgba(146, 119, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'bultinck's giant flower'/cornus kousa 'bultinck's giant flower' (2).jpg",
          width: 605,
          id: 'd6e487c91dc045bd1a2d912ed6e01622',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 105, 72, 1.00)',
            'rgba(152, 158, 127, 1.00)',
            'rgba(109, 117, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'bultinck's giant flower'/cornus kousa 'bultinck's giant flower' (1).jpg",
          width: 578,
          id: '7bd3b991fddfd705bc8afc7a3eed212a',
          height: 768,
          thumbnail: true,
        },
        location: [47.269695, -1.584008],
        genre: 'Cornus',
        cultivar: "Bultinck's Giant Flower",
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584008, 47.269695] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '13e7efe419c20b52f65a3e53af61ae4e1c446e9a',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 99, 82, 1.00)',
            'rgba(121, 114, 81, 1.00)',
            'rgba(151, 140, 99, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus mas 'spring glory'/cornus mas 'spring glory' (5).jpg",
          width: 1024,
          id: 'c9a145bd99769d5e79fb6b0dd0f2f750',
          height: 683,
          thumbnail: true,
        },
        espece: 'mas',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 143, 127, 1.00)',
            'rgba(94, 89, 53, 1.00)',
            'rgba(92, 85, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus mas 'spring glory'/cornus mas 'spring glory' (2).jpg",
          width: 1024,
          id: '407d138b604e043992a1fecfe19c59a4',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 140, 158, 1.00)',
            'rgba(97, 94, 77, 1.00)',
            'rgba(92, 78, 34, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus mas 'spring glory'/cornus mas 'spring glory' (1).jpg",
          width: 1024,
          id: 'e7ff05e0b79fbaf9393126cd2a34dcdf',
          height: 683,
          thumbnail: true,
        },
        location: [47.270309, -1.584461],
        genre: 'Cornus',
        cultivar: 'Spring Glory',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584461, 47.270309] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '09e9b3fc45149cfca08f1a15f70cefb2a7a1e7a5',
      fields: {
        espece: 'sanguinea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 72, 44, 1.00)',
            'rgba(150, 117, 69, 1.00)',
            'rgba(159, 124, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus sanguinea 'midwinter fire'/cornus sanguinea 'midwinter fire' (2).jpg",
          width: 576,
          id: '48f7fea130c77734addc8d0d1c6872ec',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(173, 190, 202, 1.00)',
            'rgba(113, 91, 55, 1.00)',
            'rgba(134, 108, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus sanguinea 'midwinter fire'/cornus sanguinea 'midwinter fire' (1).jpg",
          width: 576,
          id: '1a715d36bb426d3e5fd74d8343ce4604',
          height: 768,
          thumbnail: true,
        },
        location: [47.271375, -1.581905],
        genre: 'Cornus',
        cultivar: 'Midwinter Fire',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581905, 47.271375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'abd96ce1dfcf1a97dea9a3bf00ad97e31c632060',
      fields: {
        origine:
          'Conservatoire & Jardin Botanique de Gen\u00e8ve, Gen\u00e8ve, Suisse',
        espece: 'spurium M.Bieb.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Sedum',
        date_plantation: '2013',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '51498360b0c5bb2a0edbd8f646fadc0c426f34a5',
      fields: {
        origine: 'Grugapark Essen (Allemagne)',
        espece: 'kirilowii Regel',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Rhodiola',
        date_plantation: '1987',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c2fc38bd325e41b4906a500cb47b19c87d16ffb9',
      fields: {
        origine: 'Inst.BU.Sch\u00f7nbeinstr (Suisse)',
        espece: 'obtusifolium C.A. Mey.',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Sedum',
        date_plantation: '2002',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '193e1a393f846525388e622504430dd85eb2d7f6',
      fields: {
        origine: 'J.Alp.Paradisia Cogne (Italie)',
        espece: 'ochroleucum Chaix.',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Sedum',
        date_plantation: '2001',
        cultivar: 'montanum D.A. Webb.',
        famille: 'crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0176fa7795626524a7ac77978fcae2f6212de3b6',
      fields: {
        origine: 'JBU.Fribourg (Suisse)',
        espece: 'telephium L.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Sedum',
        date_plantation: '2003',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '443f809b22c17b8af36efddb7248044d0afbed2d',
      fields: {
        origine: 'JBU.Li\u00e8ge (Belgique)',
        espece: 'kamtschaticum  Fisch. & Mey.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Sedum',
        date_plantation: '1989',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'acc62690b00c5468b40baeec4178632951bb2603',
      fields: {
        origine: 'JBU.Li\u00e8ge (Belgique)',
        espece: 'oreganum Nutt.',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Sedum',
        date_plantation: '1989',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5ee0369d40431e506564cec312c242245115c9d9',
      fields: {
        origine: 'Mr.Figureau C.',
        espece: 'hirsutum All.',
        localisation: 'A2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2208871, -1.5444631],
        genre: 'Sedum',
        date_plantation: '1995',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444631, 47.2208871] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '253f434b4015ede908e66e61df54fc08547bd882',
      fields: {
        origine: 'JB.Dijon (France)',
        espece: 'spicata Hudson',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Carex',
        date_plantation: '2004',
        famille: 'Cyperaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b97aaa03f56f8f1543f0091512fe4d73501efe53',
      fields: {
        origine: 'JB.Timaru (N-Z\u00e9lande)',
        espece: 'virgata Sol.',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Carex',
        date_plantation: '1999',
        famille: 'Cyperaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd21a955896f20a6579acda9f5e77c0288004bca4',
      fields: {
        origine: 'Les Ponts de C\u00e9_p\u00e9pini\u00e8re Lepage',
        espece: 'polyblepharum C.Presl',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Polystichum',
        date_plantation: '2016',
        famille: 'Dryopteridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6e54dc705fb6ed23e84a4f255e96aea0ac137079',
      fields: {
        espece: 'lotus (femelle)',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 125, 189, 1.00)',
            'rgba(132, 150, 172, 1.00)',
            'rgba(100, 97, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/diospyros [ebenaceae]/diospyros lotus (femelle)/diospyros lotus (7).jpg',
          width: 576,
          id: '81a807e4c5070e061b7e2bfd5540640b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 123, 142, 1.00)',
            'rgba(119, 124, 128, 1.00)',
            'rgba(114, 132, 150, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/diospyros [ebenaceae]/diospyros lotus (femelle)/diospyros lotus (6).jpg',
          width: 576,
          id: 'e881584491c130b5f12649f1f01b5468',
          height: 768,
          thumbnail: true,
        },
        location: [47.269333, -1.584462],
        genre: 'Diospyros',
        famille: 'Ebenaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584462, 47.269333] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8a629a83eb1b367d2dde4a3928b9c0b0aa3c6ce1',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 102, 39, 1.00)',
            'rgba(111, 98, 48, 1.00)',
            'rgba(114, 107, 44, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/elaeagnus [elaeagnaceae]/elaeagnus x ebbingei 'gilt edge'/elaeagnus x ebbengei 'gilt edge' .jpg",
          width: 576,
          id: '5f9c9f0a012b629828df9dfe55a7ccb8',
          height: 768,
          thumbnail: true,
        },
        espece: 'x ebbingei',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 116, 94, 1.00)',
            'rgba(109, 126, 99, 1.00)',
            'rgba(103, 113, 78, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/elaeagnus [elaeagnaceae]/elaeagnus x ebbingei 'gilt edge'/elaeagnus x ebbengei 'gilt edge' (2).jpg",
          width: 576,
          id: '07e53cd5d49c53ab5c2b86ac084d5ef0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 161, 166, 1.00)',
            'rgba(103, 107, 86, 1.00)',
            'rgba(101, 121, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/elaeagnus [elaeagnaceae]/elaeagnus x ebbingei 'gilt edge'/elaeagnus x ebbengei 'gilt edge' (1).jpg",
          width: 1024,
          id: '3bd7c1e6228e5c48a049c7c04ea5e634',
          height: 768,
          thumbnail: true,
        },
        location: [47.271575, -1.580725],
        genre: 'Elaeagnus',
        cultivar: 'Gilt Edge',
        famille: 'Elaeagnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580725, 47.271575] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c0fcc1f85bb5c547cb81cfc9362b97e0f27f294c',
      fields: {
        origine: 'Dr.Tauran (Sautron)',
        espece: 'praealtum Raf.',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Equisetum',
        date_plantation: '1994',
        famille: 'Equisetaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f6796af899cb3f362d162c4670e657ca9495d7ef',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Gd Blottereau',
        espece: 'X',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Rhododendron',
        date_plantation: '2018',
        cultivar: 'Midsummer',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2df14938d78c022a5801e681a0258b9e77728974',
      fields: {
        espece: 'angustifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 121, 69, 1.00)',
            'rgba(107, 150, 83, 1.00)',
            'rgba(112, 131, 88, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/kalmia [ericaceae]/kalmia angustifolia 'rubra'/kalmia angustifolia 'rubra' (2).jpg",
          width: 576,
          id: '5a93e7a8f3f8bc78282596b711bbc9d5',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 148, 85, 1.00)',
            'rgba(158, 131, 124, 1.00)',
            'rgba(100, 129, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/kalmia [ericaceae]/kalmia angustifolia 'rubra'/kalmia angustifolia 'rubra' (1).jpg",
          width: 576,
          id: '52e59b15fbe1ba85a91e68c25b9a3a2d',
          height: 768,
          thumbnail: true,
        },
        location: [47.271503, -1.585638],
        genre: 'Kalmia',
        cultivar: 'Rubra',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585638, 47.271503] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0255199e3ba3dc88bccc61138019d65cd236f34f',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 133, 73, 1.00)',
            'rgba(131, 151, 90, 1.00)',
            'rgba(119, 122, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/kalmia [ericaceae]/kalmia latifolia 'alba'/kalmia latifolia 'alba' (3).jpg",
          width: 576,
          id: 'e095410fa14e8b51debf0c6ef8291805',
          height: 768,
          thumbnail: true,
        },
        espece: 'latifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 99, 97, 1.00)',
            'rgba(155, 133, 144, 1.00)',
            'rgba(80, 82, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/kalmia [ericaceae]/kalmia latifolia 'alba'/kalmia latifolia 'alba' (2).jpg",
          width: 576,
          id: 'aff4a23e90d29dd57afeed701fa8d1f4',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 84, 50, 1.00)',
            'rgba(117, 123, 96, 1.00)',
            'rgba(128, 115, 94, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/kalmia [ericaceae]/kalmia latifolia 'alba'/kalmia latifolia 'alba' (1).jpg",
          width: 1024,
          id: '913a396f0d97f9b424f893be2204cbe2',
          height: 768,
          thumbnail: true,
        },
        location: [47.269413, -1.582187],
        genre: 'Kalmia',
        cultivar: 'Alba',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582187, 47.269413] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3f5c30223af0dc2821b44f02ae098051d4f38d2a',
      fields: {
        espece: 'augustinii',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Rhododendron',
        date_plantation: '1998',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c3605fdc089266d05500f3346641ba70cd74314b',
      fields: {
        origine: 'JB.Nice (France)',
        espece: 'spinosa L.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Euphorbia',
        date_plantation: '2006',
        famille: 'Euphorbiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '34176088847a5e547c74d1e7b459b3a05313dd8b',
      fields: {
        origine: 'National botanical Garden of.Iran - T\u00e9h\u00e9ran',
        espece: 'boissieriana',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Euphorbia',
        date_plantation: '2006',
        famille: 'Euphorbiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8e02217d5ea034aa522bee189f4aed2c57770946',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'esculenta',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 153, 70, 1.00)',
            'rgba(112, 149, 55, 1.00)',
            'rgba(85, 128, 43, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/manihot [euphorbiaceae]/manihot esculenta/manihot esculenta (2).jpg",
          width: 576,
          id: 'df9e83864993523da834397fee9f7b6e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 154, 80, 1.00)',
            'rgba(118, 146, 68, 1.00)',
            'rgba(90, 127, 48, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/manihot [euphorbiaceae]/manihot esculenta/manihot esculenta (3).jpg",
          width: 576,
          id: 'ae7643b46507b565ab8637085494e2cb',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 143, 70, 1.00)',
            'rgba(119, 146, 58, 1.00)',
            'rgba(99, 126, 51, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/manihot [euphorbiaceae]/manihot esculenta/manihot esculenta (1).jpg",
          width: 576,
          id: 'b78b6c65a86d1df4da21699cdf78819f',
          height: 768,
          thumbnail: true,
        },
        location: [47.22682, -1.512225],
        genre: 'Manihot',
        famille: 'Euphorbiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512225, 47.22682] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '45842777bf42ab08ae73a6f3f0581decd452cd5a',
      fields: {
        origine: 'JB. Prague ( Rep. Tch\u00e8que)',
        espece: 'pannonicum Jacq.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Trifolium',
        date_plantation: '2010',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fe3641107e869b2964933dc519cf258d92c3be13',
      fields: {
        origine: 'JB.Lausanne (Suisse)',
        espece: 'bituminosa E.H. Stirton',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Bituminaria',
        date_plantation: '2006',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ebde450e52145eb7fe288a06c4ec9a6475e0648a',
      fields: {
        origine: 'plante issue du jardin particulier - Remi Legros',
        espece: 'hirsutum',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Dorycnium',
        date_plantation: '2016',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bfacfcaff64479686ee0fb29266ecf191bff96bb',
      fields: {
        origine: 'Pontign\u00e9 - Fontevraud',
        espece: 'medium L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Trifolium',
        date_plantation: '1994',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2e8c3c28e2f1454335091cfb23ab2c6db53dc000',
      fields: {
        espece: 'valentina',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Coronilla',
        date_plantation: '1973',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2407012ea3ea5e5abce7df11e02fd57c6723d4d9',
      fields: {
        espece: 'japonicum',
        localisation: 'B7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198817, -1.5442188],
        genre: 'Styphnolobium',
        date_plantation: '1973',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442188, 47.2198817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0d91f846caf66f05cb07565b4507801c55b3415e',
      fields: {
        espece: 'floribunda',
        localisation: 'B2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201934, -1.5449557],
        genre: 'Wisteria',
        date_plantation: '1973',
        cultivar: 'Rosea',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449557, 47.2201934] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd6a1a6e11dcc19cec6f580de8dd03f9b61f80203',
      fields: {
        espece: 'sinensis',
        localisation: 'B2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201934, -1.5449557],
        genre: 'Wisteria',
        date_plantation: '1973',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449557, 47.2201934] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8d6b9cbe8ce45c58f14d86dbaba0eec58b6ee113',
      fields: {
        espece: 'sylvatica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 167, 197, 1.00)',
            'rgba(112, 102, 78, 1.00)',
            'rgba(56, 48, 30, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fagus [fagaceae]/fagus sylvatica 'aspleniifolia'/fagus sylvatica 'aspleniifolia' (11).jpg",
          width: 1024,
          id: 'dd3dc3cf46ca3ab5bb6bc63cbd002af0',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 114, 143, 1.00)',
            'rgba(103, 99, 96, 1.00)',
            'rgba(106, 90, 71, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fagus [fagaceae]/fagus sylvatica 'aspleniifolia'/fagus sylvatica 'aspleniifolia' (1).jpg",
          width: 512,
          id: 'e56cd5482ad406f5004c2e7c9d7e1a2e',
          height: 768,
          thumbnail: true,
        },
        location: [47.270614, -1.584797],
        genre: 'Fagus',
        cultivar: 'Aspleniifolia',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584797, 47.270614] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '91b06816329bb3b3a2b98a4f3fab57bb4a35150d',
      fields: {
        espece: 'sylvatica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 104, 93, 1.00)',
            'rgba(104, 95, 59, 1.00)',
            'rgba(66, 64, 31, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fagus [fagaceae]/fagus sylvatica 'aspleniifolia'/fagus sylvatica 'aspleniifolia' (10).jpg",
          width: 512,
          id: 'f6a4db46c2bb16ae3768cbf2b7fad7e3',
          height: 768,
          thumbnail: true,
        },
        location: [47.2698, -1.58465],
        genre: 'Fagus',
        cultivar: 'Aspleniifolia',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58465, 47.2698] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b4dba8cc18b0a1cd0ee40b29bf5450b0ad8f64da',
      fields: {
        espece: 'sylvatica Atropurpurea Group',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 118, 147, 1.00)',
            'rgba(121, 89, 91, 1.00)',
            'rgba(97, 89, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus sylvatica atropurpurea group/fagus sylvatica atropurpurea group (5).jpg',
          width: 512,
          id: 'e4b0bdf0bc77afcc581dc81530c4a6a8',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 91, 99, 1.00)',
            'rgba(123, 97, 110, 1.00)',
            'rgba(119, 111, 121, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus sylvatica atropurpurea group/fagus sylvatica atropurpurea group (3).jpg',
          width: 512,
          id: 'd5c552ae15c97b955de2ea5a04dc5c50',
          height: 768,
          thumbnail: true,
        },
        location: [47.270373, -1.585056],
        genre: 'Fagus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585056, 47.270373] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9f85d08cf84280acb96e1ca839da108b740c3ca3',
      fields: {
        espece: 'sylvatica',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(180, 176, 168, 1.00)',
            'rgba(83, 71, 46, 1.00)',
            'rgba(77, 76, 38, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/fagus [fagaceae]/fagus sylvatica 'pendula'/fagus sylvatica 'pendula'.jpg",
          width: 1024,
          id: '533a7e40f1e676ef0a9ee4807fbd7539',
          height: 768,
          thumbnail: true,
        },
        location: [47.2288, -1.511667],
        genre: 'Fagus',
        cultivar: 'Pendula',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.511667, 47.2288] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e4b54728e40b0732e98bbcbc974762ba86faf2d6',
      fields: {
        espece: 'ilex',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 114, 113, 1.00)',
            'rgba(123, 120, 117, 1.00)',
            'rgba(114, 112, 108, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus ilex/quercus ilex (1).jpg',
          width: 576,
          id: '3af610c838f171bcb069947b1e4374c1',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5fd4880b760e64f903080fd25f28bd1b54fafa88',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'shumardii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 101, 87, 1.00)',
            'rgba(104, 107, 83, 1.00)',
            'rgba(102, 105, 83, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus shumardii/quercus shumardii (10).jpg',
          width: 1024,
          id: '12005320e2849cbd1829bb0e6d2a48ea',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 130, 156, 1.00)',
            'rgba(112, 117, 112, 1.00)',
            'rgba(83, 90, 79, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus shumardii/quercus shumardii (11).jpg',
          width: 512,
          id: '91ef5b64a4d4b49d903ee02398be98ef',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 117, 109, 1.00)',
            'rgba(153, 122, 94, 1.00)',
            'rgba(143, 91, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus shumardii/quercus shumardii (1).jpg',
          width: 576,
          id: 'ccce72d05e3b6dc437eda2a3eae81299',
          height: 768,
          thumbnail: true,
        },
        location: [47.270655, -1.584497],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584497, 47.270655] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2fea5a57aa77b5c3101de29d0f000b7b7af758c9',
      fields: {
        espece: 'suber',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 91, 76, 1.00)',
            'rgba(118, 114, 104, 1.00)',
            'rgba(120, 115, 109, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus suber/quercus suber (5).jpg',
          width: 576,
          id: '28b5dfdc4c9b395d814dfada01733847',
          height: 768,
          thumbnail: true,
        },
        location: [47.269762, -1.585155],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585155, 47.269762] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f9ecf4152de2255a9a80e897492b2c202bcad321',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 107, 78, 1.00)',
            'rgba(92, 106, 77, 1.00)',
            'rgba(77, 90, 67, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/garrya [garryaceae]/garrya elliptica 'james roof'/garrya elliptica 'james roof' (3).jpg",
          width: 1024,
          id: 'ebc4f5c3e4a119ce7fb02ff9c17313ee',
          height: 683,
          thumbnail: true,
        },
        espece: 'elliptica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(168, 173, 166, 1.00)',
            'rgba(92, 101, 78, 1.00)',
            'rgba(81, 83, 61, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/garrya [garryaceae]/garrya elliptica 'james roof'/garrya elliptica 'james roof' (2).jpg",
          width: 512,
          id: '58e1a56daef60c63ca52a6beba4ec429',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 98, 76, 1.00)',
            'rgba(78, 90, 65, 1.00)',
            'rgba(76, 87, 62, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/garrya [garryaceae]/garrya elliptica 'james roof'/garrya elliptica 'james roof' (1).jpg",
          width: 1024,
          id: '2a87f5b737910eafb5bd3a5bf668f565',
          height: 683,
          thumbnail: true,
        },
        location: [47.228308, -1.508253],
        genre: 'Garrya',
        cultivar: 'James Roof',
        famille: 'Garryaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508253, 47.228308] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd40a9fd839402e10c76a2a57141840c6d2d8e172',
      fields: {
        espece: 'elliptica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 125, 112, 1.00)',
            'rgba(83, 93, 72, 1.00)',
            'rgba(95, 88, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/garrya [garyaceae]/garrya elliptica 'james roof'/garrya elliptica 'james roof'.jpg",
          width: 512,
          id: 'f199ad60e5f1781d2364c41ea681b59b',
          height: 768,
          thumbnail: true,
        },
        location: [47.271583, -1.585863],
        genre: 'Garrya',
        cultivar: 'James Roof',
        famille: 'Garryaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585863, 47.271583] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b789cd7ca074444942e159327f070fcf1707adf5',
      fields: {
        espece: 'coccinea',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 141, 132, 1.00)',
            'rgba(117, 132, 126, 1.00)',
            'rgba(97, 107, 98, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/mitraria [gesneriaceae]/mitraria coccinea/mitraria coccinea.jpg',
          width: 576,
          id: '5a8e866c3b4786ec4f131e2fd2ee53da',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Mitraria',
        famille: 'Gesneriaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '56f2685d9e652cc3b5d3e26e6810c248bb50e35c',
      fields: {
        espece: 'biloba',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 126, 154, 1.00)',
            'rgba(122, 120, 114, 1.00)',
            'rgba(92, 79, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ginkgo [ginkgoaceae]/ginkgo biloba/ginkgo biloba  (2).jpg',
          width: 512,
          id: '73dfcbd0fa683088f47c2cf8db52caff',
          height: 768,
          thumbnail: true,
        },
        location: [47.270344, -1.583922],
        genre: 'Ginkgo',
        famille: 'Ginkgoaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583922, 47.270344] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '520b219237ccccbd5bc72216823e59e8e9ef30b4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'biloba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 114, 52, 1.00)',
            'rgba(161, 124, 69, 1.00)',
            'rgba(121, 94, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ginkgo [ginkgoaceae]/ginkgo biloba/ginkgo biloba (2).jpg',
          width: 576,
          id: 'e97e97fb88d3a259fdbb2d720679c302',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 136, 151, 1.00)',
            'rgba(112, 98, 62, 1.00)',
            'rgba(41, 39, 22, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ginkgo [ginkgoaceae]/ginkgo biloba/ginkgo biloba (4).jpg',
          width: 512,
          id: '89911f08c2695a7daea94eb010f3d294',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 102, 149, 1.00)',
            'rgba(119, 110, 91, 1.00)',
            'rgba(119, 96, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ginkgo [ginkgoaceae]/ginkgo biloba/ginkgo biloba (1).jpg',
          width: 512,
          id: '97fc8466a6a9391937042fe84be14583',
          height: 768,
          thumbnail: true,
        },
        location: [47.270255, -1.58387],
        genre: 'Ginkgo',
        famille: 'Ginkgoaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58387, 47.270255] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cbefdb305ad4b5b937dac1660ac4cd0ef23e5212',
      fields: {
        origine: 'Arboretum Volga Kama, Zapovednik (Russie)',
        espece: 'subcanus',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Philadelphus',
        date_plantation: '2005',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '308eb16e35034b0f006d37ac554a537e980b1feb',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 135, 85, 1.00)',
            'rgba(116, 139, 83, 1.00)',
            'rgba(98, 109, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia gracilis 'nikko'/deutzia gracilis 'nikko' (3).jpg",
          width: 1024,
          id: 'dec500afd0aa312d6c192e2254e2c2b4',
          height: 768,
          thumbnail: true,
        },
        espece: 'gracilis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 134, 40, 1.00)',
            'rgba(115, 150, 64, 1.00)',
            'rgba(90, 123, 43, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia gracilis 'nikko'/deutzia gracilis 'nikko' (2).jpg",
          width: 576,
          id: 'a8bea851e51fce9c519bc252714fd653',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 130, 77, 1.00)',
            'rgba(112, 127, 86, 1.00)',
            'rgba(75, 97, 39, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia gracilis 'nikko'/deutzia gracilis 'nikko' (1).jpg",
          width: 576,
          id: '00a90eeb49c0eb5fd5e3dc5c6e200835',
          height: 768,
          thumbnail: true,
        },
        location: [47.270917, -1.586425],
        genre: 'Deutzia',
        cultivar: 'Nikko',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586425, 47.270917] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '38a7924befb55989ceb111749ca748c8433332cc',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'gracilis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(61, 67, 39, 1.00)',
            'rgba(128, 135, 87, 1.00)',
            'rgba(128, 121, 88, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia gracilis/deutzia gracilis (2).jpg',
          width: 1024,
          id: 'fdf7911c295dbf9f215b41b96ea8c928',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 123, 50, 1.00)',
            'rgba(96, 131, 66, 1.00)',
            'rgba(115, 133, 101, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia gracilis/deutzia gracilis .jpg',
          width: 677,
          id: '2dd0fcc71f91e9010d74d7b2fd5e870c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 92, 80, 1.00)',
            'rgba(123, 125, 109, 1.00)',
            'rgba(91, 100, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia gracilis/deutzia gracilis (1).jpg',
          width: 768,
          id: '44e1d42f2d2bade483bb89b8d9ff893f',
          height: 768,
          thumbnail: true,
        },
        location: [47.270455, -1.581708],
        genre: 'Deutzia',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581708, 47.270455] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '28d732c6eedf383ad1a04ad4cee9365807903306',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'aspera Villosa Group',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 152, 101, 1.00)',
            'rgba(116, 155, 93, 1.00)',
            'rgba(108, 138, 86, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hydrangea [hydrangeaceae]/hydrangea aspera villosa group/hydrangea aspera villosa group (2).jpg',
          width: 576,
          id: '3a07d2290c8a72cc92aa91c3b1278708',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 168, 108, 1.00)',
            'rgba(122, 148, 104, 1.00)',
            'rgba(118, 128, 102, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hydrangea [hydrangeaceae]/hydrangea aspera villosa group/hydrangea aspera villosa group (3).jpg',
          width: 576,
          id: '329f3268532191987c5a4c6ab6a102de',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 125, 94, 1.00)',
            'rgba(141, 137, 146, 1.00)',
            'rgba(119, 116, 101, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hydrangea [hydrangeaceae]/hydrangea aspera villosa group/hydrangea aspera villosa group (1).jpg',
          width: 576,
          id: 'bedb4ece61915660a8e0bf730005963e',
          height: 768,
          thumbnail: true,
        },
        location: [47.269708, -1.583895],
        genre: 'Hydrangea',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583895, 47.269708] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '689f4f135e573d0345007cf0d8953ad1107bf888',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 124, 94, 1.00)',
            'rgba(136, 142, 126, 1.00)',
            'rgba(63, 69, 41, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'silberregen'/philadelphus 'silberregen' (2).jpg",
          width: 576,
          id: '5c3cc45c43b8b0b3200ca92f06768aeb',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 172, 118, 1.00)',
            'rgba(117, 147, 86, 1.00)',
            'rgba(109, 138, 71, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'silberregen'/philadelphus 'silberregen' (1).jpg",
          width: 612,
          id: '2a4b4339924f184544339b5d19f46301',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Philadelphus',
        cultivar: 'Silberregen',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a4181207ec46315505870aae1b16831ee5adad91',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 173, 113, 1.00)',
            'rgba(97, 143, 51, 1.00)',
            'rgba(128, 133, 88, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'virginal'/philadelphus 'virginal' (3).jpg",
          width: 576,
          id: 'fa6da085e1a40f3ec2137298a783a9b6',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(56, 61, 50, 1.00)',
            'rgba(133, 140, 127, 1.00)',
            'rgba(42, 54, 29, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'virginal'/philadelphus 'virginal' .jpg",
          width: 576,
          id: 'd1aa8d9969e6becbd3915a6e138a7fff',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 119, 79, 1.00)',
            'rgba(80, 100, 65, 1.00)',
            'rgba(52, 69, 25, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'virginal'/philadelphus 'virginal' (2).jpg",
          width: 576,
          id: 'fe47d1a14a515b7d402e51d65dffb6e7',
          height: 768,
          thumbnail: true,
        },
        location: [47.270263, -1.58398],
        genre: 'Philadelphus',
        cultivar: 'Virginal',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58398, 47.270263] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4d0092f4aae990a78326815c5c9da934e2e340de',
      fields: {
        origine: 'JB. Chemnitz (Allemagne)',
        espece: 'cerastoides N.K.B. Robson',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Hypericum',
        date_plantation: '2010',
        famille: 'Hypericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '40a23fec336125129e5e4774d54397f7c9beecc3',
      fields: {
        origine: 'Arboretum Bolestraszyce,Przemysl,Pologne',
        espece: 'lactea Pall.',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Iris',
        date_plantation: '2013',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '733d7cd06304d152b4d6c25dc70418bd19d0ef02',
      fields: {
        origine: 'Goteborg Botanical Garten,Goteborg,Su\u00e8de',
        espece: 'cancellatus Herb.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Crocus',
        date_plantation: '2012',
        cultivar: 'mazziaricus B.Mathew',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ec12860664f61465da51a7b586901a3db3641099',
      fields: {
        origine:
          'Inst de botanique et arboretum de Komarovii Perkallksky (Russie)',
        espece: 'notha M.Bieb.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Iris',
        date_plantation: '2010',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8d925e8b25331aab8c51e6434db2c6724fd86c09',
      fields: {
        origine: 'J.B.Osterr-Garten,Graz,Autriche',
        espece: 'olivieri J.Gay',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Crocus',
        date_plantation: '2011',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dbc211467b1e737e2cbbf05dcf77070af9d25310',
      fields: {
        origine: 'JB.Framingham (USA)',
        espece: 'versicolor L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Iris',
        date_plantation: '1989',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7c3363aaf7d9b565664f0227173e0b70bba77570',
      fields: {
        origine: 'JB.Montr\u00e9al (Canada)',
        espece: 'versicolor L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Iris',
        date_plantation: '2006',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b676d3c7f1811350f056f224bb90f864a833a101',
      fields: {
        origine: 'JB.T\u00e9h\u00e9ran (Iran)',
        espece: 'imbricata Lindl.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Iris',
        date_plantation: '1986',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0ddcafac0260cb787fb7da1d645a88d0b1c3fb87',
      fields: {
        origine: 'JB.Trieste (Italie)',
        espece: 'cengialti Ambrosi',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Iris',
        date_plantation: '2006',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6a90d734b58e775475e4d22e61e1bedbe3da4711',
      fields: {
        origine: 'JBU.Hokkaido (Japon)',
        espece: 'sanguinea Hornem.',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Iris',
        date_plantation: '1998',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1e6d551da92a1523e3dda67dbb59375db126e593',
      fields: {
        origine: 'National Botanic Garden of Belgique, Meise, Belgique',
        espece: 'striatum Sm.',
        localisation: 'I2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185657, -1.5426599],
        genre: 'Sisyrinchium',
        date_plantation: '2012',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426599, 47.2185657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '47322d5206ba3312f522dcfd5997b627abeb25ed',
      fields: {
        origine: 'Palmen Garten Frankfurt (All.)',
        espece: 'ixioides Spreng.',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Libertia',
        date_plantation: '2012',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0a6b89ff438ea250bfebd980893dbec49d2d9637',
      fields: {
        origine: 'Universitatea de Stiinte Agricole,Cluj-Napoca,Roumanie',
        espece: 'mandshurica Maxim.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Iris',
        date_plantation: '2013',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '801d5563de9ee96ee0a2ec0f9be4a65666b7722d',
      fields: {
        origine: 'Washington Park Arboretum University',
        espece: 'tenax Dougl.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Iris',
        date_plantation: '2006',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c0449f667e34c35932f25fffb42771877bd60e1e',
      fields: {
        espece: 'pseudacorus L.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Iris',
        date_plantation: '1973',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '36d22bf084d424ae958f54df0c9d11448d302b53',
      fields: {
        origine: 'B.G. Karelia (Russie)',
        espece: 'ruyschiana L.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Dracocephalum',
        date_plantation: '2014',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9fbff7e9054e8595abb18f8abcae540992716a38',
      fields: {
        origine: 'B.G. Leipzig (All.)',
        espece: 'alpina L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Scutellaria',
        date_plantation: '2015',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b5658d43f40314daa9279fcef045e06c8ec5289a',
      fields: {
        origine:
          'Botanic Garden Palacky University, Olomouc, R\u00e9p.Tch\u00e8que',
        espece: 'ruyschiana L.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Dracocephalum',
        date_plantation: '2012',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a0057e2b4da9e002e86f0f70612517612df6cb24',
      fields: {
        origine: 'J.B. Marie Curie, Lublin (Pologne)',
        espece: 'virginianum Durand & B.D.Jacks',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Pycnanthemum',
        date_plantation: '2011',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f1eaf47185568f7911e9c9b158f6f91733896e2e',
      fields: {
        origine: 'JB de Cochabamba',
        espece: 'orbignaei',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Salvia',
        date_plantation: '2003',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3abfc2cdfa85ca31fc8ca66ffb2e00c127acb7d9',
      fields: {
        origine: 'JBU.Oslo (Norv\u00e8ge)',
        espece: 'glutinosa L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Salvia',
        date_plantation: '1986',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f4f4cc72ab8f6fee2e13fd1b956571badded2083',
      fields: {
        origine: 'JBU.Riga (Lettonie)',
        espece: 'grandiflora Benth.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Stachys',
        date_plantation: '1990',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'debecd85214562ee5bcea274c3b70e91a30135aa',
      fields: {
        origine: 'Remi Legros (jardin Rez\u00e9)',
        espece: 'italica',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Phlomis',
        date_plantation: '2014',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '71a24fdd202454b774ab21840aef9029e2e01f65',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 165, 85, 1.00)',
            'rgba(119, 153, 50, 1.00)',
            'rgba(96, 119, 34, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/callicarpa [lamiaceae]/callicarpa dichotoma 'issai'/callicarpa dichotoma 'issai'  (3).jpg",
          width: 576,
          id: 'dad16150cb8eaeab83b23370ebd924c0',
          height: 768,
          thumbnail: true,
        },
        espece: 'dichotoma',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 154, 51, 1.00)',
            'rgba(139, 146, 79, 1.00)',
            'rgba(117, 135, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/callicarpa [lamiaceae]/callicarpa dichotoma 'issai'/callicarpa dichotoma 'issai'  (2).jpg",
          width: 576,
          id: '93d9019d881269f5ea7488c6337d3ddb',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 169, 70, 1.00)',
            'rgba(121, 142, 58, 1.00)',
            'rgba(101, 125, 39, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/callicarpa [lamiaceae]/callicarpa dichotoma 'issai'/callicarpa dichotoma 'issai'  (1).jpg",
          width: 576,
          id: '4ec7caaca78efc829fa99133ed4f86f0',
          height: 768,
          thumbnail: true,
        },
        location: [47.271353, -1.584275],
        genre: 'Callicarpa',
        cultivar: 'Issai',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584275, 47.271353] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1e9c8aeb67f55974bb135e5e4852c30a78088f9c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'abrotanoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 111, 67, 1.00)',
            'rgba(118, 139, 105, 1.00)',
            'rgba(110, 123, 105, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/perovskia [lamiaceae]/perovskia abrotanoides/perovskia abrotanoides (2).jpg',
          width: 576,
          id: 'd959c0a657814e94640156e5b141c49e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 148, 57, 1.00)',
            'rgba(118, 126, 75, 1.00)',
            'rgba(108, 110, 88, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/perovskia [lamiaceae]/perovskia abrotanoides/perovskia abrotanoides (3).jpg',
          width: 576,
          id: '5d9a9faaaef1ad71086d1e6588f4c240',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 132, 55, 1.00)',
            'rgba(96, 104, 55, 1.00)',
            'rgba(137, 117, 93, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/perovskia [lamiaceae]/perovskia abrotanoides/perovskia abrotanoides (1).jpg',
          width: 576,
          id: 'b098b969c38e932040b242f84ce5c2df',
          height: 768,
          thumbnail: true,
        },
        location: [47.271388, -1.584622],
        genre: 'Perovskia',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584622, 47.271388] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2b9702947b78d98d7808adf784f658f437293f02',
      fields: {
        espece: 'fruticosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 112, 75, 1.00)',
            'rgba(100, 134, 104, 1.00)',
            'rgba(89, 118, 86, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/phlomis [lamiaceae]/phlomis fruticosa/phlomis fruticosa (3).jpg',
          width: 576,
          id: '5c68b01f2b0265e3019bc0bc4476716a',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 137, 59, 1.00)',
            'rgba(124, 134, 57, 1.00)',
            'rgba(79, 102, 71, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/phlomis [lamiaceae]/phlomis fruticosa/phlomis fruticosa (2).jpg',
          width: 576,
          id: '4aad907b3e0f80d4a5359761ea90b827',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Phlomis',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '451c781ff582097d9f5a631b212fa4b001db736a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'albidum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 131, 184, 1.00)',
            'rgba(109, 114, 121, 1.00)',
            'rgba(70, 67, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sassafras [lauraceae]/sassafras albidum/sassafras albidum  (3).jpg',
          width: 512,
          id: '92b4a873be5ebab99c17cac662d68819',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 148, 164, 1.00)',
            'rgba(155, 107, 106, 1.00)',
            'rgba(153, 109, 105, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sassafras [lauraceae]/sassafras albidum/sassafras albidum  .jpg',
          width: 576,
          id: 'b0ea1a513e5774c3f485f28c97bbbb61',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 135, 138, 1.00)',
            'rgba(149, 109, 61, 1.00)',
            'rgba(80, 60, 29, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sassafras [lauraceae]/sassafras albidum/sassafras albidum  (2).jpg',
          width: 576,
          id: '7a368d7fb9ad0f8ad59204df2148c150',
          height: 768,
          thumbnail: true,
        },
        location: [47.27082, -1.585805],
        genre: 'Sassafras',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585805, 47.27082] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1040343b5ad9914ac55e64b628e3c13f41240e82',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'albidum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 106, 42, 1.00)',
            'rgba(137, 130, 60, 1.00)',
            'rgba(107, 90, 32, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/sassafras [lauraceae]/sassafras albidum/sassafras albidum (2).jpg',
          width: 576,
          id: 'e477a6ef84819f9e1ca06423bc622164',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 140, 119, 1.00)',
            'rgba(138, 100, 48, 1.00)',
            'rgba(120, 99, 39, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/sassafras [lauraceae]/sassafras albidum/sassafras albidum (3).jpg',
          width: 604,
          id: 'be4c336842b0c313f0f58b3a5ea47e07',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 111, 75, 1.00)',
            'rgba(157, 116, 83, 1.00)',
            'rgba(157, 144, 144, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/sassafras [lauraceae]/sassafras albidum/sassafras albidum (1).jpg',
          width: 576,
          id: 'ef1367e5284bc7e1ea0bdf5eba782711',
          height: 768,
          thumbnail: true,
        },
        location: [47.26222, -1.529787],
        genre: 'Sassafras',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529787, 47.26222] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '577294a22c19739345f71595f48fef55431e7e54',
      fields: {
        origine: 'JB. Bayreutch (Allemagne)',
        espece: 'pallidiflora Shrenk',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Fritillaria',
        date_plantation: '2010',
        famille: 'Liliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '42cba860db60b9b06b543578516f37455b47d9fe',
      fields: {
        origine: 'JB.Hiroshima (Japon)',
        espece: 'cordatum Makino',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Cardiocrinum',
        date_plantation: '2008',
        famille: 'Liliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1e4f448296688514d27630c07daa1ff3cab212ee',
      fields: {
        origine: 'JBU.Matsudo (Japon)',
        espece: 'formosanum Wallace',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Lilium',
        date_plantation: '2006',
        famille: 'Liliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5ccd4090dbe6ce7c6f576c28468bc7b339591a92',
      fields: {
        origine: 'JBU.Tohoku (Sendai)',
        espece: 'latifolia Maxim.',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Tricyrtis',
        date_plantation: '1992',
        famille: 'Liliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd6b9e3cc2ab06db465f84208d32b403355ef743e',
      fields: {
        origine: 'National Botanic Garten of Belgique,Meise,Belgique',
        espece: 'biflora Pall.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Tulipa',
        date_plantation: '2012',
        famille: 'Liliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e0b06105787af38ee442d5489ac8985fd0f1f7cc',
      fields: {
        origine: 'JB.P\u00e9kin (Chine)',
        espece: 'chekiangensis',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Lagerstroemia',
        date_plantation: '1996',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7492cd7818d5d6da3033b4a7381b6acbc7ac0bbd',
      fields: {
        origine: 'P\u00e9pini\u00e8re Municipale',
        espece: 'indica',
        localisation: 'A5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2207668, -1.5440149],
        genre: 'Lagerstroemia',
        date_plantation: '1985',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440149, 47.2207668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5b51485304ca58a592ff848fd732d104eaffce66',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'granatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 93, 28, 1.00)',
            'rgba(117, 108, 28, 1.00)',
            'rgba(62, 92, 19, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/punica [lythraceae]/punica granatum/punica granatum (2).jpg',
          width: 576,
          id: '462fc2a122841eb6bc0b6b4325f7a05a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 153, 103, 1.00)',
            'rgba(128, 112, 72, 1.00)',
            'rgba(111, 122, 31, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/punica [lythraceae]/punica granatum/punica granatum (3).jpg',
          width: 576,
          id: '0011312f9c7a0ce9f0f35c3a1831f7fe',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 164, 127, 1.00)',
            'rgba(92, 118, 46, 1.00)',
            'rgba(91, 104, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/punica [lythraceae]/punica granatum/punica granatum (1).jpg',
          width: 576,
          id: '682ff60bdde495426c5c7f43dcf1e5f9',
          height: 768,
          thumbnail: true,
        },
        location: [47.271237, -1.584287],
        genre: 'Punica',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584287, 47.271237] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ad74210554ceb8b1d6d5d21a2781300fd6b09297',
      fields: {
        espece: 'granatum',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 146, 52, 1.00)',
            'rgba(135, 116, 52, 1.00)',
            'rgba(121, 124, 39, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/punica [lythraceae]/punica granatum/punica granatum (1).jpg",
          width: 576,
          id: 'fae4536a02f7815660812ed2ce16eb5c',
          height: 768,
          thumbnail: true,
        },
        location: [47.22667, -1.512263],
        genre: 'Punica',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512263, 47.22667] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7922174d3d6fd321f903c3b5682f3cf7afa9d433',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Grand Blottereau',
        espece: 'x loebneri',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Magnolia',
        date_plantation: '2015',
        cultivar: 'Leonard Messel',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '15cbe0e4c122fd8b19f30af0e824e994abe2c68c',
      fields: {
        espece: 'tulipifera',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Liriodendron',
        date_plantation: '1973',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e2ca480f60e061dc7f29c1042548c5f85e239d32',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(201, 213, 200, 1.00)',
            'rgba(102, 123, 75, 1.00)',
            'rgba(75, 94, 37, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/liriodendron [magnoliaceae]/liriodendron 'chapel hill'/liriodendron 'chapel hill'  (3).jpg",
          width: 576,
          id: '94c6edc434c54c9a0351f8328fa0cf8d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 121, 60, 1.00)',
            'rgba(140, 133, 44, 1.00)',
            'rgba(91, 101, 28, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/liriodendron [magnoliaceae]/liriodendron 'chapel hill'/liriodendron 'chapel hill' (1).jpg",
          width: 576,
          id: '552c56feb4da8a936c9c0c694d1a8cdd',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 131, 61, 1.00)',
            'rgba(112, 142, 65, 1.00)',
            'rgba(77, 101, 32, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/liriodendron [magnoliaceae]/liriodendron 'chapel hill'/liriodendron 'chapel hill'  (2).jpg",
          width: 576,
          id: 'b7ddd85d565ee43334da46595b037eb2',
          height: 768,
          thumbnail: true,
        },
        location: [47.271622, -1.582533],
        genre: 'Liriodendron',
        cultivar: 'Chapel Hill',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582533, 47.271622] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cb7dc4d44ba101a1d6fc5828446958e03f43dec6',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(191, 208, 208, 1.00)',
            'rgba(104, 119, 82, 1.00)',
            'rgba(100, 114, 44, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/liriodendron [magnoliaceae]/liriodendron 'chapel hill'/liriodendron 'chapel hill'  (jeune).jpg",
          width: 576,
          id: '9903f53b21c124145f87a9d1360d5476',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 170, 156, 1.00)',
            'rgba(90, 93, 62, 1.00)',
            'rgba(116, 126, 74, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/liriodendron [magnoliaceae]/liriodendron 'chapel hill'/liriodendron 'chapel hill'  (4).jpg",
          width: 576,
          id: '32116ac10ba3f064320a3eef2750b069',
          height: 768,
          thumbnail: true,
        },
        location: [47.271433, -1.58158],
        genre: 'Liriodendron',
        cultivar: 'Chapel Hill',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58158, 47.271433] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f03fa5729c36b346041fb3c2831a96b126734ffd',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 154, 79, 1.00)',
            'rgba(112, 147, 68, 1.00)',
            'rgba(92, 124, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/liriodendron [magnoliaceae]/liriodendron tulipifera 'crispa'/liriodendron tulipifera 'crispa' (3).jpg",
          width: 576,
          id: '0cbdd8f83cefd1e249b6ab393b833f2a',
          height: 768,
          thumbnail: true,
        },
        espece: 'tulipifera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 140, 69, 1.00)',
            'rgba(115, 140, 76, 1.00)',
            'rgba(120, 143, 77, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/liriodendron [magnoliaceae]/liriodendron tulipifera 'crispa'/liriodendron tulipifera 'crispa' (2).jpg",
          width: 570,
          id: 'b8127e5b3bb7a579de871eca524da985',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 129, 99, 1.00)',
            'rgba(120, 151, 107, 1.00)',
            'rgba(121, 149, 96, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/liriodendron [magnoliaceae]/liriodendron tulipifera 'crispa'/liriodendron tulipifera 'crispa' (1).jpg",
          width: 576,
          id: '6647842acda94178b39e5e5d60afc989',
          height: 768,
          thumbnail: true,
        },
        location: [47.27013, -1.585003],
        genre: 'Liriodendron',
        cultivar: 'Crispa',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585003, 47.27013] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '536c5fbbf1435959483093de0d210b2a39939510',
      fields: {
        espece: 'tulipifera',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 142, 129, 1.00)',
            'rgba(149, 121, 80, 1.00)',
            'rgba(70, 56, 30, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/liriodendron [magnoliaceae]/liriodendron tulipifera 'crispa'/liriodendron tulipifera 'crispa'.jpg",
          width: 576,
          id: 'cb163da74bc6e2e6a4e3c4abc0a9fc56',
          height: 768,
          thumbnail: true,
        },
        location: [47.269372, -1.584355],
        genre: 'Liriodendron',
        cultivar: 'Crispa',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584355, 47.269372] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7a2efca3b90cc8afce75480519e0115388bad3ba',
      fields: {
        espece: 'x soulangiana',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Magnolia',
        date_plantation: '1973',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2ebe2cd7f4e0febfd0043ac1cbac357a68102d5c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 104, 27, 1.00)',
            'rgba(103, 118, 68, 1.00)',
            'rgba(70, 97, 28, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'charles coates'/magnolia 'charles coates' (2).jpg",
          width: 576,
          id: 'b91503a266c6e9a48fad724e87d056c2',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 130, 69, 1.00)',
            'rgba(119, 141, 87, 1.00)',
            'rgba(94, 118, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'charles coates'/magnolia 'charles coates' (3).jpg",
          width: 576,
          id: '815e95e546e7a8b2ced5810e959a8647',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 139, 77, 1.00)',
            'rgba(108, 147, 62, 1.00)',
            'rgba(86, 120, 35, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'charles coates'/magnolia 'charles coates' (1).jpg",
          width: 576,
          id: '01fa771af8e74a224e04f3f86e8228e4',
          height: 768,
          thumbnail: true,
        },
        location: [47.270461, -1.582264],
        genre: 'Magnolia',
        cultivar: 'Charles Coates',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582264, 47.270461] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0869cd4dffc8c5db1b0e5ca85821e856298dce4f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 154, 189, 1.00)',
            'rgba(122, 118, 119, 1.00)',
            'rgba(83, 73, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'heaven scent'/magnolia 'heaven scent' (5).jpg",
          width: 580,
          id: 'bea944d534199357b63b3dfb0be2e2ae',
          height: 768,
          thumbnail: true,
        },
        location: [47.270253, -1.581263],
        genre: 'Magnolia',
        cultivar: 'Heaven Scent',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581263, 47.270253] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '118a09001d43569db86cc37e056e89a8ae552171',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 80, 49, 1.00)',
            'rgba(107, 92, 77, 1.00)',
            'rgba(91, 78, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'star wars'/magnolia 'star wars' (2).jpg",
          width: 1024,
          id: '54bb2db2a7d2ad7dd819e59e17e84937',
          height: 683,
          thumbnail: true,
        },
        location: [47.269289, -1.584097],
        genre: 'Magnolia',
        cultivar: 'Star Wars',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584097, 47.269289] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '50b4550504d0adc582fa97363ba8ead176f34b9d',
      fields: {
        espece: 'cylindrica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 150, 140, 1.00)',
            'rgba(130, 120, 109, 1.00)',
            'rgba(119, 116, 110, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia cylindrica/magnolia cylindrica (2).jpg',
          width: 511,
          id: '70f32d013d80e0921959cf3dba5f9176',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 87, 67, 1.00)',
            'rgba(128, 119, 114, 1.00)',
            'rgba(87, 71, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia cylindrica/magnolia cylindrica (1).jpg',
          width: 576,
          id: '742c3787cc11a78923339c6c2abd62f3',
          height: 768,
          thumbnail: true,
        },
        location: [47.270895, -1.581953],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581953, 47.270895] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e81648faa477a76297c4d85e2dab063fe97ad529',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 135, 122, 1.00)',
            'rgba(145, 151, 126, 1.00)',
            'rgba(141, 144, 122, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia grandiflora 'crispa'/magnolia grandiflora 'crispa' (3).jpg",
          width: 1024,
          id: 'bf4dca4da3ce2447479e8e2328c12e64',
          height: 683,
          thumbnail: true,
        },
        espece: 'grandiflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 164, 171, 1.00)',
            'rgba(88, 100, 57, 1.00)',
            'rgba(76, 91, 36, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia grandiflora 'crispa'/magnolia grandiflora 'crispa' (2).jpg",
          width: 1024,
          id: '1e81fe23ffcd48b5d41d9cd1ef57236d',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 185, 218, 1.00)',
            'rgba(94, 102, 77, 1.00)',
            'rgba(84, 91, 42, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia grandiflora 'crispa'/magnolia grandiflora 'crispa' (1).jpg",
          width: 512,
          id: 'aa23cd5bc7e7978c33fb3e6636a9d4e4',
          height: 768,
          thumbnail: true,
        },
        location: [47.269455, -1.581842],
        genre: 'Magnolia',
        cultivar: 'Crispa',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581842, 47.269455] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9c9cba33853e1967c07ebabf1e66993a178c969f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'officinalis var. biloba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 112, 54, 1.00)',
            'rgba(158, 153, 89, 1.00)',
            'rgba(103, 98, 51, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia officinalis var. biloba/magnolia officinalis var. biloba (1).jpg',
          width: 576,
          id: '14b3aae1ac24c765610ee4baca45516e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 145, 67, 1.00)',
            'rgba(145, 158, 30, 1.00)',
            'rgba(125, 134, 30, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia officinalis var. biloba/magnolia officinalis var. biloba (2).jpg',
          width: 619,
          id: '0903e7d0ca2e897981216114c3bb0cc5',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 168, 140, 1.00)',
            'rgba(114, 111, 73, 1.00)',
            'rgba(119, 128, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia officinalis var. biloba/magnolia officinalis var. biloba  (2).jpg',
          width: 576,
          id: '0fca4a728a3a34688e7664068e546d71',
          height: 768,
          thumbnail: true,
        },
        location: [47.269705, -1.58208],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58208, 47.269705] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '10e3ba37af3ab0885933c66e0ee2a2fb74561ef5',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 72, 62, 1.00)',
            'rgba(121, 119, 104, 1.00)',
            'rgba(109, 100, 96, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia stellata 'jane platt'/magnolia stellata 'jane platt' (3).jpg",
          width: 1024,
          id: '2ae0be47c6a5742bd7db00288d89609c',
          height: 683,
          thumbnail: true,
        },
        espece: 'stellata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 81, 62, 1.00)',
            'rgba(136, 127, 123, 1.00)',
            'rgba(109, 98, 95, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia stellata 'jane platt'/magnolia stellata 'jane platt' (2).jpg",
          width: 1024,
          id: 'ab544c728e97051239d4cde55006ed55',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 81, 71, 1.00)',
            'rgba(126, 123, 111, 1.00)',
            'rgba(127, 121, 117, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia stellata 'jane platt'/magnolia stellata 'jane platt' (1).jpg",
          width: 1024,
          id: 'bc4df22d8e9600f9c183c01777ef7d86',
          height: 683,
          thumbnail: true,
        },
        location: [47.271495, -1.581263],
        genre: 'Magnolia',
        cultivar: 'Jane Platt',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581263, 47.271495] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '644841698de85e6fbd501f24b29f6268263c416f',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 99, 89, 1.00)',
            'rgba(131, 129, 121, 1.00)',
            'rgba(99, 96, 88, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia x loebneri 'dwarf nr. 1'/magnolia x loebneri 'dwarf nr. 1' (4).jpg",
          width: 1024,
          id: '06e0986d4aa91ce41cddbba272a89904',
          height: 683,
          thumbnail: true,
        },
        espece: 'x loebneri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 125, 145, 1.00)',
            'rgba(101, 96, 76, 1.00)',
            'rgba(81, 80, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia x loebneri 'dwarf nr. 1'/magnolia x loebneri 'dwarf nr. 1' (3).jpg",
          width: 1024,
          id: '9f1de9d8860ebf9778b63a1fa44858ce',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 100, 96, 1.00)',
            'rgba(143, 142, 130, 1.00)',
            'rgba(90, 93, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia x loebneri 'dwarf nr. 1'/magnolia x loebneri 'dwarf nr. 1' (2).jpg",
          width: 1024,
          id: '2f11d094e2c1454517099db3d82effcd',
          height: 683,
          thumbnail: true,
        },
        location: [47.27155, -1.581887],
        genre: 'Magnolia',
        cultivar: 'Dwarf Nr. 1',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581887, 47.27155] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '142facfef605f93c03153ec3741d0365900bc67a',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 97, 88, 1.00)',
            'rgba(113, 107, 78, 1.00)',
            'rgba(117, 103, 88, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia x loebneri 'powder puff'/magnolia x loebneri 'powder puff' (3).jpg",
          width: 1024,
          id: 'b0f599da6e7c5d4d3798cc755622551b',
          height: 683,
          thumbnail: true,
        },
        espece: 'x loebneri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 105, 94, 1.00)',
            'rgba(122, 118, 100, 1.00)',
            'rgba(137, 126, 116, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia x loebneri 'powder puff'/magnolia x loebneri 'powder puff' (2).jpg",
          width: 1024,
          id: '15f21a48fb9f282c2130b6b0b58ce17c',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 92, 99, 1.00)',
            'rgba(97, 95, 75, 1.00)',
            'rgba(108, 103, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia x loebneri 'powder puff'/magnolia x loebneri 'powder puff' (1).jpg",
          width: 1024,
          id: 'e038d4f6183a2b17162b175710ae4573',
          height: 683,
          thumbnail: true,
        },
        location: [47.271538, -1.58168],
        genre: 'Magnolia',
        cultivar: 'Powder Puff',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58168, 47.271538] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4414d7bd444405f1361b67d31b464870d7ca7ccb',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'simplex',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(212, 215, 195, 1.00)',
            'rgba(105, 115, 83, 1.00)',
            'rgba(80, 89, 51, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/firmiana [malvaceae]/firmiana simplex/firmiana simplex (2).jpg",
          width: 576,
          id: '97355b66676e562a586ac9d053936969',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 189, 176, 1.00)',
            'rgba(134, 130, 89, 1.00)',
            'rgba(86, 80, 33, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/firmiana [malvaceae]/firmiana simplex/firmiana simplex (3).jpg",
          width: 576,
          id: '8535a9d7249a36c64c42bf18d9970087',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 160, 128, 1.00)',
            'rgba(127, 134, 99, 1.00)',
            'rgba(91, 98, 63, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/firmiana [malvaceae]/firmiana simplex/firmiana simplex (1).jpg",
          width: 576,
          id: '31b252799e61b28919dc245e0d5aa20e',
          height: 768,
          thumbnail: true,
        },
        location: [47.226822, -1.512892],
        genre: 'Firmiana',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512892, 47.226822] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a61755114374d6b553b7dde7977962f9f68fb183',
      fields: {
        espece: 'platyphyllos',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 185, 169, 1.00)',
            'rgba(111, 127, 55, 1.00)',
            'rgba(71, 76, 38, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/tilia [malvaceae]/tilia platyphyllos 'laciniata'/tilia platyphyllos 'laciniata'(4).jpg",
          width: 688,
          id: '879f1e8d5561199e826dde68e9b6e0a9',
          height: 768,
          thumbnail: true,
        },
        location: [47.271008, -1.580947],
        genre: 'Tilia',
        cultivar: 'Laciniata',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580947, 47.271008] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd8544fa91bedc6b6af16665506bd98ca3b50bf47',
      fields: {
        espece: 'dealbata Fras.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Thalia',
        date_plantation: '1973',
        cultivar: 'vincentinum D.Wood',
        famille: 'Marantaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9a660ee5a48e1bca7aeeac1e03be881a6b0850db',
      fields: {
        origine: 'JB.Hokka\u00efdo (Japon)',
        espece: 'azedarach',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Melia',
        date_plantation: '1995',
        cultivar: 'subtripinnata',
        famille: 'Meliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1a54c2ec9e45ba5694a4c5654b91e3b830e7779f',
      fields: {
        espece: 'julibrissin',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 163, 112, 1.00)',
            'rgba(133, 130, 80, 1.00)',
            'rgba(84, 89, 27, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/albizia [mimosaceae]/albizia julibrissin/albizia julibrissin  (2).jpg',
          width: 576,
          id: 'e376b175ecd47db0820d75e38971b993',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 145, 68, 1.00)',
            'rgba(113, 144, 59, 1.00)',
            'rgba(109, 126, 49, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/albizia [mimosaceae]/albizia julibrissin/albizia julibrissin  (1).jpg',
          width: 576,
          id: '37ab6cd69366de824b202e5ea52bbbdc',
          height: 768,
          thumbnail: true,
        },
        location: [47.271272, -1.5865],
        genre: 'Albizia',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5865, 47.271272] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '01a91b696bd2261f92fb4d1ca0bde831091809b2',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 163, 132, 1.00)',
            'rgba(133, 139, 102, 1.00)',
            'rgba(128, 102, 82, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/callistemon [myrtaceae]/callistemon viminalis 'little john'/callistemon viminalis 'little john' (3).jpg",
          width: 576,
          id: 'ccc904a4b5ae5541c29db59264c966c9',
          height: 768,
          thumbnail: true,
        },
        espece: 'viminalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 137, 98, 1.00)',
            'rgba(150, 100, 90, 1.00)',
            'rgba(95, 82, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/callistemon [myrtaceae]/callistemon viminalis 'little john'/callistemon viminalis 'little john' (2).jpg",
          width: 576,
          id: 'ed92316ae15338fc80e0b82607c710e5',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 163, 114, 1.00)',
            'rgba(133, 137, 96, 1.00)',
            'rgba(118, 116, 87, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/callistemon [myrtaceae]/callistemon viminalis 'little john'/callistemon viminalis 'little john' (1).jpg",
          width: 576,
          id: '92acd29ed389c56ec4fb9c7228b96482',
          height: 768,
          thumbnail: true,
        },
        location: [47.2719, -1.582962],
        genre: 'Callistemon',
        cultivar: 'Little John',
        famille: 'Myrtaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582962, 47.2719] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1d97f293913c1d314bb04d88b35c969afe50a215',
      fields: {
        espece: 'apiculata',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 132, 128, 1.00)',
            'rgba(120, 125, 124, 1.00)',
            'rgba(109, 111, 115, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/luma [myrtaceae]/luma apiculata 'glanleam gold'/luma apiculata 'glanleam gold'.jpg",
          width: 576,
          id: 'eabada48a7c3ffd68694e6836abb3c06',
          height: 768,
          thumbnail: true,
        },
        location: [47.271538, -1.580533],
        genre: 'Luma',
        cultivar: 'Glanleam Gold',
        famille: 'Myrtaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580533, 47.271538] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e4cf0abb42817b1c0f9f4884071bd490e97c2603',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'virginicus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 162, 133, 1.00)',
            'rgba(135, 140, 86, 1.00)',
            'rgba(119, 120, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chionanthus [oleaceae]/chionanthus virginicus/chionanthus virginicus  (2).jpg',
          width: 576,
          id: '4d3ac2d2fdba7a27ae4ea58eb926e2f5',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 158, 150, 1.00)',
            'rgba(123, 116, 88, 1.00)',
            'rgba(164, 138, 118, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chionanthus [oleaceae]/chionanthus virginicus/chionanthus virginicus  (3).jpg',
          width: 622,
          id: '0f66f280b90b0be1983b0736ebed69af',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 182, 93, 1.00)',
            'rgba(91, 150, 45, 1.00)',
            'rgba(70, 122, 23, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chionanthus [oleaceae]/chionanthus virginicus/chionanthus virginicus  (1).jpg',
          width: 576,
          id: '3cf0f6da86104b6377962475c32cad82',
          height: 768,
          thumbnail: true,
        },
        location: [47.271513, -1.585272],
        genre: 'Chionanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585272, 47.271513] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'abda1ec3dcfd3b8dba55ba5fad6a9e6f77494dc5',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 158, 90, 1.00)',
            'rgba(137, 142, 75, 1.00)',
            'rgba(136, 129, 67, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum 'vicaryi'/ligustrum 'vicaryi' (2).jpg",
          width: 576,
          id: 'c7b55e81fde44ec22c7a28313a34750b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 128, 65, 1.00)',
            'rgba(148, 147, 79, 1.00)',
            'rgba(128, 118, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum 'vicaryi'/ligustrum 'vicaryi' (3).jpg",
          width: 576,
          id: '9e974c0a15efb37e1bea718a1119e44f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 102, 52, 1.00)',
            'rgba(129, 134, 78, 1.00)',
            'rgba(135, 119, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum 'vicaryi'/ligustrum 'vicaryi' (1).jpg",
          width: 576,
          id: 'c6b86380f3a93efba34b1c246594a5dc',
          height: 768,
          thumbnail: true,
        },
        location: [47.270938, -1.586847],
        genre: 'Ligustrum',
        cultivar: 'Vicaryi',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586847, 47.270938] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '296f5c805a302ddf3ec4709f7d282dc974649529',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'obtusifolium',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 151, 57, 1.00)',
            'rgba(113, 151, 45, 1.00)',
            'rgba(114, 144, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum obtusifolium/ligustrum obtusifolium (2).jpg',
          width: 576,
          id: '3aa21f9fbb1f06dbf6562e87eb99ad51',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 137, 56, 1.00)',
            'rgba(108, 134, 58, 1.00)',
            'rgba(87, 114, 37, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum obtusifolium/ligustrum obtusifolium (3).jpg',
          width: 576,
          id: '004bfe99b60e0a6dc27d7945543c038c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 156, 90, 1.00)',
            'rgba(110, 127, 58, 1.00)',
            'rgba(98, 112, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum obtusifolium/ligustrum obtusifolium (1).jpg',
          width: 1024,
          id: '3601019025f594a05c2b224f1563acf8',
          height: 768,
          thumbnail: true,
        },
        location: [47.271858, -1.586397],
        genre: 'Ligustrum',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586397, 47.271858] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c237435de0ae621dce6b0ebc89c2f3522d135f99',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'europaea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 159, 130, 1.00)',
            'rgba(121, 126, 111, 1.00)',
            'rgba(114, 124, 96, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/olea [oleaceae]/olea europaea/olea europaea (2).jpg',
          width: 576,
          id: '7aab892c16eaea8a5f17cbed3c5c6094',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 151, 130, 1.00)',
            'rgba(133, 133, 107, 1.00)',
            'rgba(124, 136, 94, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/olea [oleaceae]/olea europaea/olea europaea (3).jpg',
          width: 1024,
          id: '513c1faccdb21b6e12200846572d5bb6',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 136, 127, 1.00)',
            'rgba(105, 112, 92, 1.00)',
            'rgba(121, 138, 88, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/olea [oleaceae]/olea europaea/olea europaea (1).jpg',
          width: 1024,
          id: 'e4184e9598379bd1b21366b45c1cb25e',
          height: 768,
          thumbnail: true,
        },
        location: [47.22848, -1.51122],
        genre: 'Olea',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.51122, 47.22848] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '94125f21dee512462d8d6490c8f23dde98db1fd8',
      fields: {
        espece: 'x fortunei',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 112, 77, 1.00)',
            'rgba(102, 115, 74, 1.00)',
            'rgba(111, 125, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus x fortunei/osmanthus x fortunei .jpg',
          width: 1024,
          id: '1b67ebeccc4e79f1adb65633576850ad',
          height: 683,
          thumbnail: true,
        },
        location: [47.271147, -1.582075],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582075, 47.271147] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bb86d9330e137fd25debc24d8a2e56175f4aabce',
      fields: {
        espece: 'latifolia',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 149, 99, 1.00)',
            'rgba(103, 126, 54, 1.00)',
            'rgba(110, 129, 83, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/phillyrea [oleaceae]/phillyrea latifolia/phillyrea latifolia.jpg',
          width: 576,
          id: 'a5a66a255593f06d4e251fddfab6f267',
          height: 768,
          thumbnail: true,
        },
        location: [47.26797, -1.583258],
        genre: 'Phillyrea',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583258, 47.26797] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '59580fa3d7de9a692c462ef9d8b484b67d0c0c36',
      fields: {
        espece: 'struthiopteris Tod.',
        localisation: 'G1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193375, -1.5415093],
        genre: 'Matteuccia',
        date_plantation: '1973',
        famille: 'Onocleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5415093, 47.2193375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2cec20485aa3aeae3a9df17efabbba3750369942',
      fields: {
        origine: "J. Alp.d'Aquila (Italie)",
        espece: 'officinalis L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Paeonia',
        date_plantation: '2010',
        cultivar: 'italica N.G. Passal & Bernardo',
        famille: 'Paeoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fcace70165be5d8061abaa12d7d2a222c3acb346',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'daurica Andrews',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Paeonia',
        date_plantation: '2008',
        cultivar: 'coriifolia  D.Y.Hong',
        famille: 'Paeoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd673c1f42ede9522380c5b1b8e4c22d8222f741d',
      fields: {
        origine: 'JB.Nantes',
        espece: 'cambessedessii Willk.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Paeonia',
        date_plantation: '2003',
        famille: 'Paeoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ba009358c68d856f2054f2b13f12f93cc913fe6d',
      fields: {
        espece: 'scoparius',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 192, 225, 1.00)',
            'rgba(149, 145, 109, 1.00)',
            'rgba(116, 97, 36, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cytisus [papilionaceae]/cytisus scoparius/cytisus scoparius.jpg',
          width: 576,
          id: 'a27b638230c371c8bd0ec265c188adbb',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Cytisus',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '514bb1f7723bc4dada2959e3937e8e3249e8ded4',
      fields: {
        espece: 'arborea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 135, 76, 1.00)',
            'rgba(135, 137, 47, 1.00)',
            'rgba(105, 119, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/medicago [papilionaceae]/medicago arborea/medicago arborea (2).jpg',
          width: 589,
          id: '73dec79e6b252d786f1158f6d802f99f',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 141, 90, 1.00)',
            'rgba(138, 152, 81, 1.00)',
            'rgba(136, 148, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/medicago [papilionaceae]/medicago arborea/medicago arborea (1).jpg',
          width: 576,
          id: '4744c76eebddaaee028f0fd8f1f152d4',
          height: 768,
          thumbnail: true,
        },
        location: [47.270438, -1.581067],
        genre: 'Medicago',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581067, 47.270438] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '221fa39fac08f365e1d9c07cc4dc1990758bda89',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'caerulea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 151, 138, 1.00)',
            'rgba(124, 123, 89, 1.00)',
            'rgba(166, 160, 146, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/passiflora [passifloraceae]/passiflora caerulea/passiflora caerulea (2).jpg",
          width: 1024,
          id: '9d6ecabd5d19b89b51dca54c20a537da',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 113, 71, 1.00)',
            'rgba(125, 128, 103, 1.00)',
            'rgba(135, 138, 118, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/passiflora [passifloraceae]/passiflora caerulea/passiflora caerulea (3).jpg",
          width: 576,
          id: 'de6633e5b2c529205d0d3cd2b4a7aaef',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 111, 80, 1.00)',
            'rgba(148, 127, 99, 1.00)',
            'rgba(149, 141, 120, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/passiflora [passifloraceae]/passiflora caerulea/passiflora caerulea (1).jpg",
          width: 576,
          id: 'd34686f6a6d1c4860bbad4fdb5ad8d46',
          height: 768,
          thumbnail: true,
        },
        location: [47.226542, -1.511695],
        genre: 'Passiflora',
        famille: 'Passifloraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.511695, 47.226542] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e28d4e68a52f8237074f86fbd8ceeabc14103bf9',
      fields: {
        espece: 'tomentosa',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 126, 173, 1.00)',
            'rgba(125, 135, 152, 1.00)',
            'rgba(61, 58, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/paulownia [paulowniaceae]/paulownia tomentosa/paulownia tomentosa (5).jpg',
          width: 542,
          id: 'df2461a5df2b04fc01afc70c77bf7163',
          height: 768,
          thumbnail: true,
        },
        location: [47.27112, -1.585588],
        genre: 'Paulownia',
        famille: 'Paulowniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585588, 47.27112] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3ab2b46418aefdccb4506527911778873593a37e',
      fields: {
        origine: "P\u00e9pini\u00e8re Val d'Erdre",
        espece: 'wallichiana',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Pinus',
        date_plantation: '2017',
        famille: 'Pinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '121d936c2024f2dea030f0298665d5f78a85f56c',
      fields: {
        origine: "P\u00e9pini\u00e8re Val d'Erdre",
        espece: 'radiata',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Pinus',
        date_plantation: '2017',
        famille: 'Pinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0ae133d9e42915b57ae976f987c548d953c52272',
      fields: {
        origine: "P\u00e9pini\u00e8re Val d'Erdre",
        espece: 'sylvestris',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Pinus',
        date_plantation: '2017',
        famille: 'Pinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '49b09977e87020c5b11d225f5c746dc2cce663ec',
      fields: {
        origine: 'Botanischer Garten,Universitat Rostock, Rostock, Allemagne',
        espece: 'sempervirens Soj\u00e1k',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Psyllium',
        date_plantation: '2012',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6ccb746bc3a367582c33d8e977f2a27a7b92cf37',
      fields: {
        origine: 'JB."Michele Tenor" Lama dei Peligni',
        espece: 'lutea L.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Digitalis',
        date_plantation: '2004',
        cultivar: 'australis Archangeli',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0df3152278bc38cb3f2306bfe513595fb3d22c3a',
      fields: {
        origine: 'JB.Karelia (Russie)',
        espece: 'longifolia L.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Veronica',
        date_plantation: '2009',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4397e0e7428020d98b7ef265964ff246dade15e7',
      fields: {
        origine: 'JB.St.Andrews (Ecosse)',
        espece: 'pungens Hooffmgg. & Link',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Armeria',
        date_plantation: '1994',
        famille: 'Plumbaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2b7f9f755eb5c860346a2790ae0fa51739cb930f',
      fields: {
        origine: 'JB. Oslo (Norv\u00e8ge)',
        espece: 'spicatum K.Richt.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Trisetum',
        date_plantation: '2010',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6c690c6e81ff8194b5dab543af8be2e64f845d2f',
      fields: {
        origine: 'JB.Budapest (Hongrie)',
        espece: 'hungarica Milkovits',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Molinia',
        date_plantation: '2009',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7b9f9f75a908179e9b8784ba1c2670bbe7727457',
      fields: {
        origine: 'JB.Dunedin (N-Z\u00e9lande)',
        espece: 'lessoniana Veldkamp',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Anemanthele',
        date_plantation: '2006',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6195babf91731154f9e85474a67f3d3303fd2533',
      fields: {
        origine: 'JB.Weinheim (Allemagne)',
        espece: 'hallii Hack.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Andropogon',
        date_plantation: '2008',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a76b20e76d345bd9c8582eac8af52e086a88bd4f',
      fields: {
        origine: 'Les Ponts de C\u00e9_p\u00e9pini\u00e8re Lepage',
        espece: 'macra Honda',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Hakonechloa',
        date_plantation: '2016',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '58060111709c9caad681c6b8eb8a0611d4fc44f2',
      fields: {
        origine: "Universit\u00e9 des sciences Cappito, l'Aquila (Italie)",
        espece: 'tenuifolia Schrader',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Seslaria',
        date_plantation: '2004',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '957883377e6e358c2f7a8a6230377471e55ebe15',
      fields: {
        origine: 'B.G. der Stadt Linz (Autriche)',
        espece: 'elatior Hill.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Primula',
        date_plantation: '2015',
        cultivar: 'ssp.elatior',
        famille: 'Primulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1efac21d7d4d71024e904ee023da36e79dec5ca4',
      fields: {
        origine: 'Emmanuel LEPAGE',
        espece: 'denticulata Sm.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Primula',
        date_plantation: '2015',
        famille: 'Primulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'faa7f91453814a2921eed080869223291c042613',
      fields: {
        origine: 'JB.Kyoto (Japon)',
        espece: 'denticulata Sm.cahier intro florindae F.K.Ward',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Primula',
        date_plantation: '1986',
        famille: 'Primulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f8e00b8a4f80c527fafd9136916e03eabba0ef6d',
      fields: {
        origine: 'JB.Kyoto (Japon)',
        espece: 'japonica A.Gray',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Primula',
        date_plantation: '2006',
        famille: 'Primulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '96833a239893f6d35f09bac6a68963cc510f8e88',
      fields: {
        origine: 'Ets.Lepage',
        espece: 'hupehensis  Hort.',
        localisation: 'G2A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2197208, -1.5414609],
        genre: 'Anemone',
        date_plantation: '1986',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5414609, 47.2197208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3762c6f19b46b809b4cbd57ac0ff02cad8573c92',
      fields: {
        origine: 'J.B. de Montreal,Canada',
        espece: 'canadensis L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Aquilegia',
        date_plantation: '2014',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '88925fa671dd677b625804679b65ab633b2b3a72',
      fields: {
        origine: 'JB. Zurich (Suisse)',
        espece: 'narcissiflora L.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Anemone',
        date_plantation: '2010',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c1e22a57f791c9db272ffe6d1004a2f8541ddde0',
      fields: {
        origine: 'JB.Bolestraszyce (Pologne)',
        espece: 'strigulosus Schur.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Ranunculus',
        date_plantation: '2009',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9e7cf4bc89cf014eb3d4667b594cac831793d83b',
      fields: {
        origine: 'JB.Greifswald (Allemagne)',
        espece: 'anomala L.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Paeonia',
        date_plantation: '2006',
        famille: 'Paeoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '723bef8ff333776a6a9a1ddcda394314c8798763',
      fields: {
        origine: 'JB.Kiel (Allemagne)',
        espece: 'parviflora Ledeb.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Aquilegia',
        date_plantation: '2009',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a2464611940a1aef864702d066ad9c08c2700dd1',
      fields: {
        origine: 'p\u00e9pini\u00e8re Ellebore- Saint Jouin de Blavou (61)',
        espece: 'rehderiana',
        localisation: 'B1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2204652, -1.544656],
        genre: 'Clematis',
        date_plantation: '2015',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544656, 47.2204652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9d362b400260ae6602b350b874861febc76086f1',
      fields: {
        origine: 'RHS Garden Surrey (Angl.)',
        espece: 'tangutica Korsh.',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Clematis',
        date_plantation: '2014',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '08615ace9345e36f43dddc6a76423bc778cb77be',
      fields: {
        origine: 'Station de rech. plt.M\u00e9dici Tsukuba-Shi Ibaraki (Japon)',
        espece: 'terniflora',
        localisation: 'A11',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2211256, -1.5428042],
        genre: 'Clematis',
        date_plantation: '1998',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428042, 47.2211256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '97b781b937d41cf4cba7617b32251b1ef98e8fab',
      fields: {
        espece: 'requienii DC.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Delphinium',
        date_plantation: '1973',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '22bf00662314761560020fd1b9e401ea92b9a136',
      fields: {
        espece: 'lividus Aiton',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Helleborus',
        date_plantation: '1973',
        cultivar: 'corsicus Tutin',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f8d02f7c08c02ec61497a2afd4423da87560e1dd',
      fields: {
        origine: 'JB.Zagreb (Croatie)',
        espece: 'einseleana F.W.Schultz.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Aquilegia',
        date_plantation: '2001',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7d96a40d4c6ebab865e65b3a80bf3e5d0e2f9768',
      fields: {
        origine: 'P\u00e9pini\u00e8res E.Lepage',
        espece: 'palustris L.',
        localisation: 'G2A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2197208, -1.5414609],
        genre: 'Caltha',
        date_plantation: '1986',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5414609, 47.2197208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6697a53b3371fc096bf10badea17163eccee2557',
      fields: {
        origine: 'JB.Hangzhou (Chine)',
        espece: 'acerba',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Hovenia',
        date_plantation: '1997',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e70c4264dea32b8177e44729d25ca0bed24ea79b',
      fields: {
        origine: 'Universit\u00e9 Dresden (Allemagne)',
        espece: 'utilis',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Rhamnus',
        date_plantation: '2005',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7086dbb6600c848e8bb0a5a4d4fc8d268b2a0ace',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'spinosissima',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 137, 125, 1.00)',
            'rgba(133, 135, 127, 1.00)',
            'rgba(123, 121, 111, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/colletia [rhamnaceae]/colletia spinosissima/colletia spinosissima (2).jpg',
          width: 576,
          id: 'f1ed3b69a5fed526a83889f13b03eb8e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 148, 134, 1.00)',
            'rgba(135, 138, 129, 1.00)',
            'rgba(131, 129, 125, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/colletia [rhamnaceae]/colletia spinosissima/colletia spinosissima (3).jpg',
          width: 576,
          id: 'f5fe38215a3b3c0650d479dc923f1956',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 144, 141, 1.00)',
            'rgba(137, 139, 134, 1.00)',
            'rgba(134, 130, 132, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/colletia [rhamnaceae]/colletia spinosissima/colletia spinosissima (1).jpg',
          width: 576,
          id: '3ffd72dfa02adfd0f1b87a1f6297d108',
          height: 768,
          thumbnail: true,
        },
        location: [47.269942, -1.581555],
        genre: 'Colletia',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581555, 47.269942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1f1fc471a22972b5d6b22766f75f6c3d4bbe4440',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'crenata',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e31d66b823e78d0ae43e2312d3df306a0d0907e4',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'douglasii',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '153a1b3e0ebb91cc86d24319e792c838efa132be',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'japonica',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        cultivar: 'Magnum',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1c43ea1ae89d9fb0ddb3732150941f603dc9b798',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'syringaeflora',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5f1118c19dbcd58f1e81f662bd96129306843142',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'tanakae',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Stephanandra',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a93ecf8ade64033b66e42e7716d5932c3fc5a3ca',
      fields: {
        origine: 'G\u00f6teborg Botanical Garden, G\u00f6teborg, Su\u00e8de',
        espece: 'chiloensis Mill.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Fragaria',
        date_plantation: '2012',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e0c0d9c4537b780ae5375e4c6c55f89d03a56789',
      fields: {
        origine: "J.de L'universit\u00e9 de Hoheiheim,Stugartt,Allemagne",
        espece: 'ovalifolia Ruiz & Pav.',
        localisation: 'C9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201723, -1.5423876],
        genre: 'Acaena',
        date_plantation: '2014',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5423876, 47.2201723] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0d113101072ff041f5e7b2edf0937856414ce9a0',
      fields: {
        origine: 'JB.Alp. Kirovsk (Russie)',
        espece: 'media',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2006',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0ea282c142906ecaef5bb980340ecd69112a7052',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'magellanicum Pers.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Geum',
        date_plantation: '2008',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '74d8159970189906e6a0141a959353496fb5ee50',
      fields: {
        origine: 'JBU.Regensburg (Allemagne)',
        espece: 'transiens Buser',
        localisation: 'A9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2212566, -1.5434775],
        genre: 'Alchemilla',
        date_plantation: '2006',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5434775, 47.2212566] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dc38e22bc3cec11cd6f88ab56981592580e51784',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'racemosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 86, 57, 1.00)',
            'rgba(121, 125, 91, 1.00)',
            'rgba(85, 87, 48, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/exochorda [rosaceae]/exochorda racemosa/exochorda racemosa (3).jpg',
          width: 576,
          id: '9aafd69920af2c547ff2bbd1853f333e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 185, 179, 1.00)',
            'rgba(110, 113, 85, 1.00)',
            'rgba(102, 97, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/exochorda [rosaceae]/exochorda racemosa/exochorda racemosa.jpg',
          width: 1024,
          id: 'd458b17d05319330a2f327ff9ac2bf55',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 125, 75, 1.00)',
            'rgba(122, 138, 68, 1.00)',
            'rgba(136, 141, 105, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/exochorda [rosaceae]/exochorda racemosa/exochorda racemosa (2).jpg',
          width: 576,
          id: '0133b8d6bbd5229025272ef15f2a85ef',
          height: 768,
          thumbnail: true,
        },
        location: [47.271262, -1.584245],
        genre: 'Exochorda',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584245, 47.271262] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '154756d918a89603568c2d64ca7ac1cdca90f22c',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 77, 50, 1.00)',
            'rgba(124, 129, 116, 1.00)',
            'rgba(84, 80, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/exochorda [rosaceae]/exochorda x macrantha 'the bride'/exochorda x macrantha 'the bride' (2).jpg",
          width: 576,
          id: '416bd66988a37fc8a14a4c4ce1e331c3',
          height: 768,
          thumbnail: true,
        },
        espece: 'x macrantha',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 99, 75, 1.00)',
            'rgba(126, 136, 99, 1.00)',
            'rgba(121, 138, 99, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/exochorda [rosaceae]/exochorda x macrantha 'the bride'/exochorda x macrantha 'the bride' (1).jpg",
          width: 576,
          id: 'b1e91e544dab0ef6c0283be929308ea0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 141, 124, 1.00)',
            'rgba(111, 120, 96, 1.00)',
            'rgba(74, 77, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/exochorda [rosaceae]/exochorda x macrantha 'the bride'/exochorda x macrantha 'the bride (2).jpg",
          width: 911,
          id: '128cc64625a9f1f728810d1e7793884e',
          height: 768,
          thumbnail: true,
        },
        location: [47.270747, -1.580475],
        genre: 'Exochorda',
        cultivar: 'The Bride',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580475, 47.270747] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '68fba40363120675e4482af38032d3fdee88e567',
      fields: {
        espece: 'x macrantha',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 129, 101, 1.00)',
            'rgba(98, 109, 86, 1.00)',
            'rgba(90, 92, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/exochorda [rosaceae]/exochorda x macrantha 'the bride'/exochorda x macrantha 'the bride'.jpg",
          width: 1024,
          id: '506d31c2846065fed0fea8aa542e8d85',
          height: 768,
          thumbnail: true,
        },
        location: [47.270513, -1.582753],
        genre: 'Exochorda',
        cultivar: 'The Bride',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582753, 47.270513] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '416622b658cbd77764bb3648281ee51e0803b4d7',
      fields: {
        espece: 'indica Andr.',
        localisation: 'D3G',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2197244, -1.5416062],
        genre: 'Fragaria',
        date_plantation: '1973',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5416062, 47.2197244] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ba76b3c93dbc2cf3ccc55183f9411cb39fe6736d',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 165, 121, 1.00)',
            'rgba(156, 148, 41, 1.00)',
            'rgba(51, 80, 15, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/kerria [rosaceae]/kerria japonica 'pleniflora'/kerria japonica 'pleniflora'.jpg",
          width: 576,
          id: '1fb587ff675bb20842deef0f4abaa1ee',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 152, 125, 1.00)',
            'rgba(133, 142, 114, 1.00)',
            'rgba(131, 133, 117, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/kerria [rosaceae]/kerria japonica 'pleniflora'/kerria japonica 'pleniflora' (2).jpg",
          width: 576,
          id: '4cad229ab4f882e7b72278a4aea7e1b4',
          height: 768,
          thumbnail: true,
        },
        location: [47.271213, -1.583005],
        genre: 'Kerria',
        cultivar: 'Pleniflora',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583005, 47.271213] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b63ca5dcef513431cc334c42fcfd4733833d3f8b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 127, 96, 1.00)',
            'rgba(145, 85, 80, 1.00)',
            'rgba(141, 98, 90, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'claude bellion'/malus 'claude bellion' (3).jpg",
          width: 576,
          id: '7a84182e1f8a40fb2ec5f085b2ba449b',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Malus',
        cultivar: 'Claude Bellion',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cd7cffce3375ec48711b1cdcd2961f939eb4b347',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 122, 90, 1.00)',
            'rgba(121, 116, 69, 1.00)',
            'rgba(104, 103, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'golden hornet'/malus 'golden hornet' (2).jpg",
          width: 576,
          id: 'ace268f44f66bc43560fc6e45cf77e7a',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Malus',
        cultivar: 'Golden Hornet',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2b451800972e921cab7b2c0b1381c52947969f2d',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'germanica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 124, 90, 1.00)',
            'rgba(119, 124, 84, 1.00)',
            'rgba(106, 129, 105, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/mespilus [rosaceae]/mespilus germanica/mespilus germanica (2).jpg',
          width: 576,
          id: 'ee2c1fdea91046a6ed5fae82346af918',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 101, 43, 1.00)',
            'rgba(134, 155, 135, 1.00)',
            'rgba(66, 93, 39, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/mespilus [rosaceae]/mespilus germanica/mespilus germanica (4).jpg',
          width: 576,
          id: '3275737476cb8f029cad2b4083cf13e4',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 112, 93, 1.00)',
            'rgba(132, 126, 74, 1.00)',
            'rgba(97, 110, 81, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/mespilus [rosaceae]/mespilus germanica/mespilus germanica (1).jpg',
          width: 576,
          id: '245e94c9c91346638fd4284f614b18f1',
          height: 768,
          thumbnail: true,
        },
        location: [47.2697, -1.584333],
        genre: 'Mespilus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584333, 47.2697] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'db3e24567cbc9fb0e549bcf5f8d771555c2f3243',
      fields: {
        espece: 'anthyllidifolia',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 139, 91, 1.00)',
            'rgba(121, 145, 84, 1.00)',
            'rgba(109, 133, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osteomeles [rosaceae]/osteomeles anthyllidifolia/osteomeles anthyllidifolia (1).jpg',
          width: 1024,
          id: '65749af76742cc98fd78ea39c7751e5b',
          height: 768,
          thumbnail: true,
        },
        location: [47.27153, -1.584587],
        genre: 'Osteomeles',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584587, 47.27153] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ab1bf89e22e7cb0266e8beff5e2ce18d42fd48ee',
      fields: {
        espece: 'capitatus',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Physocarpus',
        date_plantation: '1992',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '42d6bf92df892e03720ac41cc5b3d70a14770318',
      fields: {
        espece: 'opulifolius',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(38, 52, 30, 1.00)',
            'rgba(115, 129, 96, 1.00)',
            'rgba(98, 113, 65, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/physocarpus [rosaceae]/physocarpus opulifolius 'dart's gold'/physocarpus opulifolius 'dart's gold' .jpg",
          width: 576,
          id: '84b8b27a4a1e62de24fbb8c590dc9f6f',
          height: 768,
          thumbnail: true,
        },
        location: [47.269908, -1.585675],
        genre: 'Physocarpus',
        cultivar: "Dart's Gold",
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585675, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fb70274041c79a22112b65b07debe34104bbf71c',
      fields: {
        espece: 'alba L.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Potentilla',
        date_plantation: '1973',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f5881285344e3945737c01dce630a1c905a1321d',
      fields: {
        espece: 'subhirtella',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Prunus',
        date_plantation: '1973',
        cultivar: 'Pendula',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '23b3267eec7daa9e39c23f5caa97afce14974ce4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 156, 201, 1.00)',
            'rgba(143, 128, 119, 1.00)',
            'rgba(90, 79, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'bettina'/prunus 'bettina' (2).jpg",
          width: 576,
          id: 'c91cccce7f18d0b6471f06bbfb83f97d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 92, 94, 1.00)',
            'rgba(147, 120, 123, 1.00)',
            'rgba(80, 66, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'bettina'/prunus 'bettina' (3).jpg",
          width: 576,
          id: '46fcf70862fceca2984fc064e06618a3',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 141, 142, 1.00)',
            'rgba(148, 130, 127, 1.00)',
            'rgba(137, 127, 117, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'bettina'/prunus 'bettina'  (3).jpg",
          width: 576,
          id: '276291566d8bf050dbd1e4691e6803e8',
          height: 768,
          thumbnail: true,
        },
        location: [47.270508, -1.586428],
        genre: 'Prunus',
        cultivar: 'Bettina',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586428, 47.270508] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7350c93c439d84fb0ff3d87be1ce26c4e312f2f6',
      fields: {
        espece: 'incisa',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 142, 154, 1.00)',
            'rgba(122, 84, 42, 1.00)',
            'rgba(69, 60, 29, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus incisa 'diva'/prunus incisa 'diva' (4).jpg",
          width: 512,
          id: 'e170a2a3dc83396c8e58aada997f0581',
          height: 768,
          thumbnail: true,
        },
        location: [47.27107, -1.584613],
        genre: 'Prunus',
        cultivar: 'Diva',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584613, 47.27107] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a35126796042bb3ed4da3ecf29a1a4823c15db18',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'sinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 112, 76, 1.00)',
            'rgba(101, 132, 88, 1.00)',
            'rgba(85, 118, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pseudocydonia [rosaceae]/pseudocydonia sinensis/pseudocydonia sinensis  (2).jpg',
          width: 576,
          id: '7db6f6c70e0251d4cba6dcbb62aab0fc',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 145, 122, 1.00)',
            'rgba(142, 124, 104, 1.00)',
            'rgba(120, 102, 88, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pseudocydonia [rosaceae]/pseudocydonia sinensis/pseudocydonia sinensis  (3).jpg',
          width: 576,
          id: 'd51e40fdae161510b9d993713042622a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(191, 192, 186, 1.00)',
            'rgba(125, 115, 83, 1.00)',
            'rgba(105, 86, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pseudocydonia [rosaceae]/pseudocydonia sinensis/pseudocydonia sinensis  (1).jpg',
          width: 576,
          id: 'a12314de0673d7dcaa69f3569d61534a',
          height: 768,
          thumbnail: true,
        },
        location: [47.27075, -1.586022],
        genre: 'Pseudocydonia',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586022, 47.27075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd14be2bf1b744a3da2b8d3576cedd252fd2dca14',
      fields: {
        espece: 'nervosa',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '1986',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '93588fcf805de16b2c01d1cad865db1453f38d37',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'gemmata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 140, 69, 1.00)',
            'rgba(104, 125, 69, 1.00)',
            'rgba(116, 117, 81, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea gemmata/spiraea gemmata (2).jpg',
          width: 1024,
          id: '20a5eff6b1d83dbfa5f56668f5ad055d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(61, 80, 30, 1.00)',
            'rgba(97, 117, 79, 1.00)',
            'rgba(37, 53, 21, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea gemmata/spiraea gemmata (3).jpg',
          width: 576,
          id: '3a364ce28a82c6d1edac4a784b9f5e8b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 125, 44, 1.00)',
            'rgba(128, 164, 76, 1.00)',
            'rgba(104, 135, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea gemmata/spiraea gemmata (1).jpg',
          width: 576,
          id: '6ecf6fb49e0839a732cb7366448caadd',
          height: 768,
          thumbnail: true,
        },
        location: [47.269883, -1.582317],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582317, 47.269883] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a662a7156f0b28498c0a8b52a725208c9fb3ce3c',
      fields: {
        espece: 'thunbergii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 169, 153, 1.00)',
            'rgba(113, 118, 62, 1.00)',
            'rgba(88, 87, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea thunbergii/spiraea thunbergii (2).jpg',
          width: 576,
          id: 'f7abe5fd0160214cca220e6d35f5b8a6',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 116, 97, 1.00)',
            'rgba(116, 117, 87, 1.00)',
            'rgba(75, 80, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea thunbergii/spiraea thunbergii (1).jpg',
          width: 576,
          id: 'cdc59519d01ab1490649798e5f58ba07',
          height: 768,
          thumbnail: true,
        },
        location: [47.270989, -1.585197],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585197, 47.270989] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'af50f8a36f1caf566466ef8f98596b9464b0c6db',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'tanakae',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 154, 79, 1.00)',
            'rgba(118, 148, 61, 1.00)',
            'rgba(147, 146, 93, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stephanandra [rosaceae]/stephanandra tanakae/stephanandra tanakae (3).jpg',
          width: 576,
          id: '1cf45d49c7b9fc678d7523d510add93e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 107, 56, 1.00)',
            'rgba(196, 166, 76, 1.00)',
            'rgba(177, 156, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stephanandra [rosaceae]/stephanandra tanakae/stephanandra tanakae (4).jpg',
          width: 710,
          id: 'a62e317c0daee40a063938c7685edb3c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 139, 55, 1.00)',
            'rgba(145, 143, 38, 1.00)',
            'rgba(90, 73, 19, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stephanandra [rosaceae]/stephanandra tanakae/stephanandra tanakae (2).jpg',
          width: 576,
          id: 'bd2cd6a88e3dbb4fc0cfc45961e4ca62',
          height: 768,
          thumbnail: true,
        },
        location: [47.2704, -1.58223],
        genre: 'Stephanandra',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58223, 47.2704] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6e84be1f51e19e24fc86b9f31017570c53495aa4',
      fields: {
        origine: 'P\u00e9pini\u00e8re Arven',
        espece: 'trifoliata',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Ptelea',
        date_plantation: '2018',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1df059eea8e9d0731c9713b67b812063365490e4',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'reticulata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 96, 34, 1.00)',
            'rgba(120, 141, 56, 1.00)',
            'rgba(75, 96, 33, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/citrus [rutaceae]/citrus reticulata/citrus reticulata (2).jpg",
          width: 576,
          id: '27990765014a600c8a69a2d1f5863b9f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 71, 30, 1.00)',
            'rgba(119, 116, 23, 1.00)',
            'rgba(68, 84, 10, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/citrus [rutaceae]/citrus reticulata/citrus reticulata (3).jpg",
          width: 576,
          id: 'd06e266932729a95639a38277692bd12',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 137, 74, 1.00)',
            'rgba(121, 137, 80, 1.00)',
            'rgba(124, 133, 83, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/citrus [rutaceae]/citrus reticulata/citrus reticulata (1).jpg",
          width: 1024,
          id: 'b33d94986d897c01f0694d79234caef1',
          height: 768,
          thumbnail: true,
        },
        location: [47.226658, -1.512203],
        genre: 'Citrus',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512203, 47.226658] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ecaf93039b00a177ad83529059f77f992bcc70e8',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 121, 96, 1.00)',
            'rgba(89, 109, 77, 1.00)',
            'rgba(57, 76, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/skimmia [rutaceae]/skimmia japonica 'keessen'/skimmia japonica 'keessen'.jpg",
          width: 576,
          id: '6dd1ebce1b40daf13d6474df90c48143',
          height: 768,
          thumbnail: true,
        },
        location: [47.270953, -1.582083],
        genre: 'Skimmia',
        cultivar: 'Keessen',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582083, 47.270953] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3f5403cb745bc7c82f4b1c2f7dc0d9568b4fa84b',
      fields: {
        espece: 'daniellii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(175, 174, 140, 1.00)',
            'rgba(105, 100, 49, 1.00)',
            'rgba(65, 61, 23, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tetradium [rutaceae]/tetradium daniellii/tetradium daniellii (17).jpg',
          width: 1024,
          id: '62396395750cb2614f4710c710d0ab70',
          height: 756,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 170, 144, 1.00)',
            'rgba(79, 102, 50, 1.00)',
            'rgba(48, 64, 26, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tetradium [rutaceae]/tetradium daniellii/tetradium daniellii (16).jpg',
          width: 944,
          id: '7741c1b4cd5d121804b3cc2f1750b0e2',
          height: 768,
          thumbnail: true,
        },
        location: [47.271292, -1.585292],
        genre: 'Tetradium',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585292, 47.271292] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6165b9847bb56dfa68eb112866be2e0de80ac5be',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'parviflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 137, 85, 1.00)',
            'rgba(105, 109, 46, 1.00)',
            'rgba(118, 118, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/meliosma [sabiaceae]/meliosma parviflora/meliosma parviflora  (2).jpg',
          width: 576,
          id: '68b630442a33d3c8578fe7f182809e65',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 131, 54, 1.00)',
            'rgba(134, 130, 79, 1.00)',
            'rgba(85, 81, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/meliosma [sabiaceae]/meliosma parviflora/meliosma parviflora  (4).jpg',
          width: 576,
          id: 'b3f9f9407e44ce0db655700eaf4d1400',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(171, 192, 173, 1.00)',
            'rgba(92, 100, 38, 1.00)',
            'rgba(119, 116, 75, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/meliosma [sabiaceae]/meliosma parviflora/meliosma parviflora  (1).jpg',
          width: 576,
          id: 'df3225f8c95c9ac9dc62ed755bb41593',
          height: 768,
          thumbnail: true,
        },
        location: [47.270938, -1.582042],
        genre: 'Meliosma',
        famille: 'Sabiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582042, 47.270938] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '62e988fcf706f5bae250aa58c3ae965d6cd5a83a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'microphylla',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(220, 223, 228, 1.00)',
            'rgba(141, 139, 116, 1.00)',
            'rgba(107, 98, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/azara [salicaceae]/azara microphylla/azara microphylla  (2).jpg',
          width: 576,
          id: 'b46547c8915482a12a1de0cbd3493b02',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 121, 66, 1.00)',
            'rgba(135, 129, 49, 1.00)',
            'rgba(124, 116, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/azara [salicaceae]/azara microphylla/azara microphylla  (3).jpg',
          width: 576,
          id: '00a01f549e05c018690ffbf95a3ad18d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 137, 74, 1.00)',
            'rgba(137, 128, 49, 1.00)',
            'rgba(123, 116, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/azara [salicaceae]/azara microphylla/azara microphylla  (1).jpg',
          width: 576,
          id: 'f4d3dfb5e3458bff7b7a3005be6a6cdc',
          height: 768,
          thumbnail: true,
        },
        location: [47.27187, -1.583092],
        genre: 'Azara',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583092, 47.27187] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '559d0ba9c5b4b942f7e4b08853fa56a33cbc43f9',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'sinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 145, 91, 1.00)',
            'rgba(166, 134, 87, 1.00)',
            'rgba(165, 142, 107, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/poliothyrsis [salicaceae]/poliothyrsis sinensis/poliothyrsis sinensis (1).jpg',
          width: 576,
          id: 'd165a1da435a87371840329adc3a46b2',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 143, 82, 1.00)',
            'rgba(142, 135, 82, 1.00)',
            'rgba(145, 125, 89, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/poliothyrsis [salicaceae]/poliothyrsis sinensis/poliothyrsis sinensis (2).jpg',
          width: 576,
          id: '5fec61f13ed4d9cbd827ece8325ee38e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(181, 192, 157, 1.00)',
            'rgba(81, 102, 48, 1.00)',
            'rgba(60, 67, 35, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/poliothyrsis [salicaceae]/poliothyrsis sinensis/poliothyrsis sinensis  (2).jpg',
          width: 576,
          id: '8e17f82430c5968d3a50e7ace47df13b',
          height: 768,
          thumbnail: true,
        },
        location: [47.271042, -1.585592],
        genre: 'Poliothyrsis',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585592, 47.271042] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '963e4a1bbaf3cd11a074c533d43677aed26591d3',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale.',
        espece: 'opalus',
        localisation: 'B1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2204652, -1.544656],
        genre: 'Acer',
        date_plantation: '2017',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544656, 47.2204652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3978005671f78b7e658ec64cd7ae887e728ee298',
      fields: {
        origine: 'P\u00e9pini\u00e8res Dauguet - 53 Larchamp',
        espece: 'triflorum',
        localisation: 'A5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2207668, -1.5440149],
        genre: 'Acer',
        date_plantation: '2012',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440149, 47.2207668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7b3af7018fb033c504726a2aab5698dace1c25f1',
      fields: {
        espece: 'platanoides',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Acer',
        date_plantation: '1973',
        cultivar: 'Reitenbachii',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cd49e575d175ea4dc045f101e440808c894f8911',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'cappadocicum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 142, 132, 1.00)',
            'rgba(158, 158, 85, 1.00)',
            'rgba(130, 131, 89, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer cappadocicum/acer cappadocicum  (2).jpg',
          width: 615,
          id: '3a3307d5326d66e6cf9f85c2713e029b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 126, 78, 1.00)',
            'rgba(116, 139, 66, 1.00)',
            'rgba(85, 106, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer cappadocicum/acer cappadocicum (1).jpg',
          width: 576,
          id: '0ab6e5878b9961d9704b5d6f760d685d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 124, 98, 1.00)',
            'rgba(134, 140, 53, 1.00)',
            'rgba(152, 156, 75, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer cappadocicum/acer cappadocicum  (1).jpg',
          width: 576,
          id: '94954583483a8745542385c3ca0e8b20',
          height: 768,
          thumbnail: true,
        },
        location: [47.27138, -1.586012],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586012, 47.27138] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8c6d8bfc576f71681c57f28c6f0972373354ec67',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'palmatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 95, 61, 1.00)',
            'rgba(115, 75, 40, 1.00)',
            'rgba(101, 81, 45, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer palmatum/acer palmatum (11).jpg',
          width: 1024,
          id: '3df54cf8fb5b9050b104b4fe9c51397d',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 123, 103, 1.00)',
            'rgba(116, 80, 51, 1.00)',
            'rgba(76, 64, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer palmatum/acer palmatum (7).jpg',
          width: 512,
          id: '5e86ebaf29652a1271bac6fd37740c86',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 112, 135, 1.00)',
            'rgba(120, 67, 50, 1.00)',
            'rgba(93, 69, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer palmatum/acer palmatum (10).jpg',
          width: 1024,
          id: 'a31df9ef5cb231b1a583b65fa2454f45',
          height: 683,
          thumbnail: true,
        },
        location: [47.270831, -1.584117],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584117, 47.270831] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dc0cd49d187a91eecbc1c20ebbcd779552b7942d',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'platanoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 119, 114, 1.00)',
            'rgba(106, 89, 50, 1.00)',
            'rgba(59, 47, 20, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer platanoides/acer platanoides (2).jpg',
          width: 648,
          id: '65215915a2e2d7a894da606fab2029fd',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 135, 77, 1.00)',
            'rgba(121, 104, 41, 1.00)',
            'rgba(72, 64, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer platanoides/acer platanoides (3).jpg',
          width: 1024,
          id: '39f8aa62cfea5c1d880c4e28ec657c06',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 85, 74, 1.00)',
            'rgba(125, 103, 65, 1.00)',
            'rgba(97, 80, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer platanoides/acer platanoides (1).jpg',
          width: 512,
          id: '4a1c15a1956791dd67830655d020d847',
          height: 768,
          thumbnail: true,
        },
        location: [47.269753, -1.584728],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584728, 47.269753] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '35816feaa6ec136f5d5cae04481652f7133b7c77',
      fields: {
        espece: 'triflorum',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 98, 61, 1.00)',
            'rgba(104, 92, 60, 1.00)',
            'rgba(66, 65, 47, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer triflorum/acer triflorum (15).jpg',
          width: 1024,
          id: '91139c0d9ecda7bc6f8d49e4039f44c3',
          height: 683,
          thumbnail: true,
        },
        location: [47.269394, -1.582183],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582183, 47.269394] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c1e629aca075eb13f7d603471d0b4ccf0adafd6a',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'pensylvanicum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 98, 65, 1.00)',
            'rgba(120, 137, 92, 1.00)',
            'rgba(107, 125, 77, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/acer [sapindaceae]/acer pensylvanicum/acer pensylvanicum (2).jpg',
          width: 1024,
          id: 'ddd3799fb6fa25fbd8cf93cd05958641',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 182, 131, 1.00)',
            'rgba(65, 92, 56, 1.00)',
            'rgba(53, 73, 48, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/acer [sapindaceae]/acer pensylvanicum/acer pensylvanicum (3).jpg',
          width: 512,
          id: '8b8ae7787ad47311a28fa3639e0fa155',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(50, 71, 46, 1.00)',
            'rgba(89, 114, 86, 1.00)',
            'rgba(73, 96, 70, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/acer [sapindaceae]/acer pensylvanicum/acer pensylvanicum (1).jpg',
          width: 1024,
          id: '25a933f84d26f69367a8e45b5e6f9330',
          height: 683,
          thumbnail: true,
        },
        location: [47.262762, -1.52967],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.52967, 47.262762] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0994cadff30adc27b9fef63578d7faf1c66533c3',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'saccharinum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 178, 192, 1.00)',
            'rgba(145, 145, 113, 1.00)',
            'rgba(91, 86, 51, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/acer [sapindaceae]/acer saccharinum/acer saccharinum  (2).jpg',
          width: 1024,
          id: 'a9211dbdef55e99ab78231402e8e7a90',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 164, 191, 1.00)',
            'rgba(135, 136, 143, 1.00)',
            'rgba(85, 80, 63, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/acer [sapindaceae]/acer saccharinum/acer saccharinum (3).jpg',
          width: 1024,
          id: 'bc2e4e927cdc7c655209411a24978064',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 123, 59, 1.00)',
            'rgba(148, 127, 56, 1.00)',
            'rgba(105, 85, 47, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/acer [sapindaceae]/acer saccharinum/acer saccharinum  (1).jpg',
          width: 576,
          id: '85ebfb4f18fbb6c1fdfa2f64b09ae492',
          height: 768,
          thumbnail: true,
        },
        location: [47.261172, -1.534395],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534395, 47.261172] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '689305cad1b5768cadab181ca01aa1fb1c84fd65',
      fields: {
        espece: 'hippocastanum',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Aesculus',
        date_plantation: '1973',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ed414ce5a7030c2582a5b9ca49701ad3b8951760',
      fields: {
        espece: 'hippocastanum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(197, 208, 174, 1.00)',
            'rgba(120, 144, 80, 1.00)',
            'rgba(89, 113, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus hippocastanum 'baumannii'/aesculus hippocastanum 'baumannii' (2).jpg",
          width: 598,
          id: '3c98adf33b6c0a788c617b1a167bb08f',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 97, 29, 1.00)',
            'rgba(140, 138, 93, 1.00)',
            'rgba(84, 98, 41, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus hippocastanum 'baumannii'/aesculus hippocastanum 'baumannii' (1).jpg",
          width: 576,
          id: 'c93186a3ee7be6fd262d2a4ee2c074d1',
          height: 768,
          thumbnail: true,
        },
        location: [47.270495, -1.582122],
        genre: 'Aesculus',
        cultivar: 'Baumannii',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582122, 47.270495] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2e96be6a149431865d7fff2c4fa59e2753765ced',
      fields: {
        espece: 'californica',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 96, 75, 1.00)',
            'rgba(91, 100, 78, 1.00)',
            'rgba(52, 64, 38, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/aesculus [sapindaceae]/aesculus californica/aesculus californica (2).jpg',
          width: 1024,
          id: '3b2e07544ac1e82cd648602dde2720cb',
          height: 683,
          thumbnail: true,
        },
        location: [47.262208, -1.529525],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529525, 47.262208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '167cee6fdb13d05e24dd54314cc0e37cf2d2f51e',
      fields: {
        origine: 'B.G. Bielefeld (All.)',
        espece: 'breweri A.Gray',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Mitella',
        date_plantation: '2012',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7b160962b87b23bde063c607374edadce387acf9',
      fields: {
        origine: 'B.G. der Albert-Ludwigs Freiburg (All.)',
        espece: 'himalayensis Decne.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Heuchera',
        date_plantation: '2014',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ceab5d0bed92880002443e6eec9a6f37dae3f03d',
      fields: {
        origine: 'Botanischer Garten St. Gallen, St. Gallen, Suisse',
        espece: 'mutata L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Saxifraga',
        date_plantation: '2013',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4bef1cbcaaf2a9a1d10f1a35013b2880747862ba',
      fields: {
        origine: 'Ets.Lepage',
        espece: 'alternifolium L.',
        localisation: 'G2A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2197208, -1.5414609],
        genre: 'Chrysosplenium',
        date_plantation: '1986',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5414609, 47.2197208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4386f25d7867b5cab550f3c7df144899d6fc3e79',
      fields: {
        origine: 'J.Alp.Meyrin (Suisse)',
        espece: 'chrysosplenifolia Boiss.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Saxifraga',
        date_plantation: '1989',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '141c8d155082a8f9fd40a3ab1a0f851076725c85',
      fields: {
        origine: 'J.Alp.Meyrin (Suisse)',
        espece: 'grandiflora Dougl.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Tellima',
        date_plantation: '2004',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4ea4fdcac48db61bb203028638f8fefbede4f618',
      fields: {
        espece: 'crassifolia Fritsch.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Bergenia',
        date_plantation: '1973',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4eee02e6b30530ae23b66b626dd9b49b331d6409',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'anisatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 141, 54, 1.00)',
            'rgba(117, 151, 50, 1.00)',
            'rgba(125, 146, 63, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/illicium [schisandraceae]/illicium anisatum/illicium anisatum (2).jpg",
          width: 576,
          id: '730d9a1e5b38555f879103df6a73043c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 139, 47, 1.00)',
            'rgba(156, 142, 54, 1.00)',
            'rgba(134, 116, 28, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/illicium [schisandraceae]/illicium anisatum/illicium anisatum (3).jpg",
          width: 576,
          id: '15118371eda716cfade1340760a239df',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(211, 213, 197, 1.00)',
            'rgba(107, 116, 64, 1.00)',
            'rgba(74, 94, 34, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/illicium [schisandraceae]/illicium anisatum/illicium anisatum (1).jpg",
          width: 576,
          id: 'd873b842a531e920b5c6fc989953c023',
          height: 768,
          thumbnail: true,
        },
        location: [47.226797, -1.512087],
        genre: 'Illicium',
        famille: 'Schisandraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512087, 47.226797] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a7e6eba78d7bf580e8553c6621c6168175ee8963',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'eriophorum Godron',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Verbascum',
        date_plantation: '2009',
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '53f8639b375f53cf98b20ce420b099cc2aa23a2a',
      fields: {
        origine: 'JB.Nantes',
        espece: 'denticulata Link',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Selaginella',
        date_plantation: '2002',
        cultivar: 'montanum D.A. Webb',
        famille: 'Selaginellaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7d43f81e3b268bfc0f2fd36a469656b9882ee42a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(64, 77, 41, 1.00)',
            'rgba(102, 109, 92, 1.00)',
            'rgba(47, 55, 36, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'cinnamon cindy'/camellia 'cinnamon cindy' (2).jpg",
          width: 1024,
          id: '6356c61810a7eb26eb6cef0311518602',
          height: 645,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 152, 143, 1.00)',
            'rgba(126, 141, 107, 1.00)',
            'rgba(108, 121, 90, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'cinnamon cindy'/camellia 'cinnamon cindy' (5).jpg",
          width: 576,
          id: 'c5b058e5f3735cdc059c5411438c6364',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 141, 117, 1.00)',
            'rgba(115, 127, 99, 1.00)',
            'rgba(103, 111, 82, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'cinnamon cindy'/camellia 'cinnamon cindy' (1).jpg",
          width: 576,
          id: '8ca2a7e5064915bdaedce1d62ea5f231',
          height: 768,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Cinnamon Cindy',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c2060ea7a7c0dc84d394e20cd232a63ed5a4f5a4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(171, 164, 163, 1.00)',
            'rgba(110, 91, 79, 1.00)',
            'rgba(116, 100, 81, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'freedom bell'/camellia 'freedom bell' (4).jpg",
          width: 1024,
          id: 'fa1a7606f5dc0dcca83353700d2cc36c',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 104, 104, 1.00)',
            'rgba(122, 78, 75, 1.00)',
            'rgba(106, 77, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'freedom bell'/camellia 'freedom bell' (5).jpg",
          width: 1024,
          id: 'd6df4b8cf1eeb7885682e6f0e1e9a516',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 90, 83, 1.00)',
            'rgba(136, 44, 46, 1.00)',
            'rgba(101, 45, 43, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'freedom bell'/camellia 'freedom bell' (1).jpg",
          width: 1024,
          id: '627893bad34f2290cf49ba302ed8d474',
          height: 627,
          thumbnail: true,
        },
        location: [47.269558, -1.584597],
        genre: 'Camellia',
        cultivar: 'Freedom Bell',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584597, 47.269558] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5014c242e4777276e3976b929b43aa1d19613a6f',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 158, 135, 1.00)',
            'rgba(103, 117, 87, 1.00)',
            'rgba(69, 78, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'winton'/camellia 'winton' (6).jpg",
          width: 1024,
          id: '4322b6498e4e4dd20a281f9abfcd4f8c',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 89, 69, 1.00)',
            'rgba(120, 122, 110, 1.00)',
            'rgba(61, 66, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'winton'/camellia 'winton' (11).jpg",
          width: 1024,
          id: '1390bf1cce0a80e9e8a3d5ad454cde2a',
          height: 697,
          thumbnail: true,
        },
        location: [47.270219, -1.583881],
        genre: 'Camellia',
        cultivar: 'Winton',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583881, 47.270219] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6a586b5b13f67736345f60538d3c3bd3d3ef24fb',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 122, 68, 1.00)',
            'rgba(134, 155, 108, 1.00)',
            'rgba(67, 83, 37, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia grijsii 'zhenzhu cha'/camellia grijsii 'zhenzhu cha' (2).jpg",
          width: 576,
          id: '67b449f5cd0764ed75cce9e214736cd0',
          height: 768,
          thumbnail: true,
        },
        espece: 'grijsii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(50, 54, 45, 1.00)',
            'rgba(142, 144, 140, 1.00)',
            'rgba(44, 53, 38, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia grijsii 'zhenzhu cha'/camellia grijsii 'zhenzhu cha' (1).jpg",
          width: 587,
          id: '89566eaab02d80f5b8d4fa9935bea0c6',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(54, 73, 42, 1.00)',
            'rgba(96, 110, 84, 1.00)',
            'rgba(51, 60, 35, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia grijsii 'zhenzhu cha'/camellia grijsii 'zhenzhu cha'  (2).jpg",
          width: 1024,
          id: '061394dd38f71e31527d35f673566d4a',
          height: 682,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Zhenzhu Cha',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '89f6d76fb5c5412fd9051fe2ed11c3efeb749522',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 79, 48, 1.00)',
            'rgba(134, 70, 60, 1.00)',
            'rgba(110, 72, 52, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'beau harp'/camellia japonica 'beau harp'.jpg",
          width: 1024,
          id: '7c1088a43ed7b1569ba0c8c47d7b5bc4',
          height: 639,
          thumbnail: true,
        },
        location: [47.270314, -1.584731],
        genre: 'Camellia',
        cultivar: 'Beau Harp',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584731, 47.270314] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3d458c88c8d501cc4362a5f852502a4d4b3c3304',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(64, 57, 33, 1.00)',
            'rgba(122, 47, 55, 1.00)',
            'rgba(93, 46, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'bonomiana rubra'/camellia japonica 'bonomiana rubra'.jpg",
          width: 1024,
          id: '41338bf130851850902948e126b9abc9',
          height: 683,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Camellia',
        cultivar: 'Bonomiana Rubra',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6011b5f8c942e9603e07c18f51a1b76bd0e2c8eb',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(64, 81, 69, 1.00)',
            'rgba(108, 113, 91, 1.00)',
            'rgba(59, 69, 52, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'brushfield's yellow'/camellia japonica 'brushfield's yellow'.jpg",
          width: 1024,
          id: '1edf0fb6c0aa2c388ef7fde2fcbfaf1c',
          height: 668,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: "Brushfield's Yellow",
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ac6ade6587dad014d9c3cd0869e0ee0e465a777a',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 150, 146, 1.00)',
            'rgba(84, 94, 77, 1.00)',
            'rgba(72, 75, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'candidissima'/camellia japonica 'candidissima' (2).jpg",
          width: 1024,
          id: '8ee0124491096ebd0accabdda5ea4301',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(50, 59, 42, 1.00)',
            'rgba(102, 105, 97, 1.00)',
            'rgba(45, 58, 46, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'candidissima'/camellia japonica 'candidissima' (1).jpg",
          width: 1024,
          id: '199b79f4ce8d5a0fafbbd7e6454b482f',
          height: 675,
          thumbnail: true,
        },
        location: [47.270542, -1.585428],
        genre: 'Camellia',
        cultivar: 'Candidissima',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585428, 47.270542] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '88920808933b0b4532388c55c0637b713186faa8',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 136, 114, 1.00)',
            'rgba(102, 111, 81, 1.00)',
            'rgba(94, 96, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'carol lynn'/camellia japonica 'carol lynn' (3).jpg",
          width: 1024,
          id: '05d530b26cceb372c1f64e90c117fc39',
          height: 683,
          thumbnail: true,
        },
        location: [47.269683, -1.584633],
        genre: 'Camellia',
        cultivar: 'Carol Lynn',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584633, 47.269683] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2f7e65cd825bdbd97c597e3405a6b4d1af8a429e',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 121, 111, 1.00)',
            'rgba(76, 84, 65, 1.00)',
            'rgba(112, 99, 83, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'chandleri elegans'/camellia japonica 'chandleri elegans' (3).jpg",
          width: 1024,
          id: '4701007c887f901c5f78371220925001',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 74, 64, 1.00)',
            'rgba(119, 70, 74, 1.00)',
            'rgba(99, 75, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'chandleri elegans'/camellia japonica 'chandleri elegans' (2).jpg",
          width: 1024,
          id: 'd9cf2569e9d3d68c7d5a74c7b149f3b6',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(59, 64, 48, 1.00)',
            'rgba(112, 71, 78, 1.00)',
            'rgba(92, 52, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'chandleri elegans'/camellia japonica 'chandleri elegans' (1).jpg",
          width: 1024,
          id: '42d4486b95b8c49f1298b03e2cc6d362',
          height: 683,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Camellia',
        cultivar: 'Chandleri Elegans',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7cddbff984a5c6c4e1b66c0d9269144f07af5c37',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 115, 87, 1.00)',
            'rgba(88, 98, 71, 1.00)',
            'rgba(78, 86, 63, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'clotilde'/camellia japonica 'clotilde' (5).jpg",
          width: 512,
          id: '86d8123acc9ff90da3898f4ab2853ed1',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 60, 49, 1.00)',
            'rgba(105, 84, 82, 1.00)',
            'rgba(89, 78, 74, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'clotilde'/camellia japonica 'clotilde' (4).jpg",
          width: 1024,
          id: '4ed8c54cf99ce4436a0e2b0145190f72',
          height: 683,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Clotilde',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd59afdfdc6c3ecf98410a480b5593cafb67e4cba',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 123, 103, 1.00)',
            'rgba(90, 93, 70, 1.00)',
            'rgba(91, 82, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'elegans supreme'/camellia japonica 'elegans supreme' (2).jpg",
          width: 1024,
          id: '867eeec2c5af92745d72b1f4f8384cf6',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(47, 48, 32, 1.00)',
            'rgba(125, 76, 76, 1.00)',
            'rgba(102, 54, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'elegans supreme'/camellia japonica 'elegans supreme' (1).jpg",
          width: 1024,
          id: 'c9e885b619609cd6fc148196e839ca89',
          height: 683,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Camellia',
        cultivar: 'Elegans Supreme',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1d9763b5194eaedd408eb792cab1557adbd79a04',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 49, 49, 1.00)',
            'rgba(150, 78, 97, 1.00)',
            'rgba(100, 58, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'elegans'/camellia japonica 'elegans'.jpg",
          width: 1024,
          id: 'fee3fda5073e94be673d2446767f971d',
          height: 634,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Camellia',
        cultivar: 'Elegans',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '95781670de93561749244ba1f0ee06dffd73fae0',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 81, 67, 1.00)',
            'rgba(88, 84, 74, 1.00)',
            'rgba(70, 63, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'grace bunton'/camellia japonica 'grace bunton' (4).jpg",
          width: 1024,
          id: 'e2aa2bfc770442129b5530795291a1bb',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 96, 84, 1.00)',
            'rgba(99, 90, 95, 1.00)',
            'rgba(78, 78, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'grace bunton'/camellia japonica 'grace bunton' (2).jpg",
          width: 1024,
          id: 'e7191a6ebffeca977d311eb014723bdd',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 164, 156, 1.00)',
            'rgba(119, 135, 117, 1.00)',
            'rgba(96, 107, 83, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'grace bunton'/camellia japonica 'grace bunton' (1).jpg",
          width: 576,
          id: '85f725d3dc59b6ac646950888c91963d',
          height: 768,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Grace Bunton',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '65e2d1e5d84c8943bc66a77aed53b9706237449a',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 171, 144, 1.00)',
            'rgba(101, 115, 75, 1.00)',
            'rgba(90, 91, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'hakuhan-kujaku'/camellia japonica 'hakuhan-kujaku' (1).jpg",
          width: 1024,
          id: '5d906773f283d633dc665c03d63a7db9',
          height: 683,
          thumbnail: true,
        },
        location: [47.27052, -1.581495],
        genre: 'Camellia',
        cultivar: 'Hakuhan-kujaku',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581495, 47.27052] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'eb2ed2e378c9f1604a6ff18d8aaba5bc1dee10eb',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 85, 81, 1.00)',
            'rgba(141, 89, 117, 1.00)',
            'rgba(77, 62, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'hikarugenji'/camellia japonica 'hikarugenji' (3).jpg",
          width: 1024,
          id: 'a23de20a831b36ca5f1b70789c11d089',
          height: 675,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 146, 154, 1.00)',
            'rgba(67, 67, 63, 1.00)',
            'rgba(48, 53, 48, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'hikarugenji'/camellia japonica 'hikarugenji' (2).jpg",
          width: 573,
          id: '59d8ed980c8399d850318b64134e90fb',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(37, 34, 33, 1.00)',
            'rgba(83, 65, 74, 1.00)',
            'rgba(61, 48, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'hikarugenji'/camellia japonica 'hikarugenji' (1).jpg",
          width: 1024,
          id: '0c1897c152ab915b08dc4e826747ce6d',
          height: 683,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Hikarugenji',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7c6f6252582299f30b390df9a18aec3b30364dfb',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 157, 121, 1.00)',
            'rgba(90, 100, 61, 1.00)',
            'rgba(72, 73, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'lemon drop'/camellia japonica 'lemon drop' (2).jpg",
          width: 1024,
          id: 'c0325c9cdac16d15aa257ca50ca6d5dd',
          height: 683,
          thumbnail: true,
        },
        location: [47.270528, -1.581275],
        genre: 'Camellia',
        cultivar: 'Lemon Drop',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581275, 47.270528] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7635afcfae7d7c9dda900a6ce7eeed6bd5a582ed',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(55, 68, 38, 1.00)',
            'rgba(113, 124, 104, 1.00)',
            'rgba(91, 108, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'lemon drop'/camellia japonica 'lemon drop' (6).jpg",
          width: 1024,
          id: 'bd487c8986cbb5bf4251289c5e2db3c8',
          height: 742,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 153, 127, 1.00)',
            'rgba(94, 107, 78, 1.00)',
            'rgba(76, 81, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'lemon drop'/camellia japonica 'lemon drop' (5).jpg",
          width: 1024,
          id: '8712a6dabce7a7ecdaa55c4260e60fad',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 85, 81, 1.00)',
            'rgba(129, 132, 118, 1.00)',
            'rgba(71, 74, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'lemon drop'/camellia japonica 'lemon drop' (4).jpg",
          width: 1024,
          id: 'ad5536c9534778100ea0ad3c3d844a05',
          height: 683,
          thumbnail: true,
        },
        location: [47.270517, -1.581347],
        genre: 'Camellia',
        cultivar: 'Lemon Drop',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581347, 47.270517] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cbe9584a2bff0927d182f15d242303bdbf621fd7',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 166, 163, 1.00)',
            'rgba(76, 87, 71, 1.00)',
            'rgba(75, 73, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'lillian ricketts'/camellia japonica 'lillian ricketts' (2).jpg",
          width: 1024,
          id: '0dfbcb26ff5c97a7d24678f38fa3b79f',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(61, 74, 56, 1.00)',
            'rgba(107, 107, 91, 1.00)',
            'rgba(82, 80, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'lillian ricketts'/camellia japonica 'lillian ricketts' (1).jpg",
          width: 1024,
          id: '63c6af289c9425de68b4d1333728cabd',
          height: 683,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Lillian Ricketts',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd2ba80390d32eb2446fd4988f5bbf91491d8c601',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(54, 60, 40, 1.00)',
            'rgba(115, 110, 93, 1.00)',
            'rgba(67, 71, 44, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'marguerite gouillon '/camellia japonica 'marguerite gouillon'.jpg",
          width: 1024,
          id: '6288c8b6c759c3e09b13923616ef6b49',
          height: 683,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Camellia',
        cultivar: 'Marguerite Gouillon',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '047d2a950f6205ca7990e1128170054baa41034f',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 71, 83, 1.00)',
            'rgba(134, 79, 79, 1.00)',
            'rgba(86, 71, 63, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'mattie cole'/camellia japonica 'mattie cole' (1).jpg",
          width: 1024,
          id: '29b3ad0f6600276f1f08fa9336ee67ca',
          height: 665,
          thumbnail: true,
        },
        location: [47.270572, -1.58562],
        genre: 'Camellia',
        cultivar: 'Mattie Cole',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58562, 47.270572] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dd99493d6c307229155e2e5af277d86222c06c81',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 156, 143, 1.00)',
            'rgba(79, 87, 53, 1.00)',
            'rgba(80, 85, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'nuccio's jewel'/camellia japonica 'nuccio's jewel' (2).jpg",
          width: 1024,
          id: 'c0de45194650007b9ca3bf1bb0310ddd',
          height: 683,
          thumbnail: true,
        },
        location: [47.270097, -1.58147],
        genre: 'Camellia',
        cultivar: "Nuccio's Jewel",
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58147, 47.270097] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '032d7ff760cc641571645e640f0bb6e401999a5f',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 115, 96, 1.00)',
            'rgba(121, 86, 69, 1.00)',
            'rgba(74, 49, 35, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'ville de nantes'/camellia japonica 'ville de nantes' (3).jpg",
          width: 1024,
          id: 'a0be4f2a850031433a648345f79a9297',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 95, 93, 1.00)',
            'rgba(144, 86, 93, 1.00)',
            'rgba(121, 91, 93, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'ville de nantes'/camellia japonica 'ville de nantes' (2).jpg",
          width: 1024,
          id: '8e79f6ebfd6145bb08807588d6b47a22',
          height: 713,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 125, 105, 1.00)',
            'rgba(131, 106, 85, 1.00)',
            'rgba(93, 61, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'ville de nantes'/camellia japonica 'ville de nantes' (1).jpg",
          width: 1024,
          id: '2f3aed4a06a1293be44d38ebe30ff028',
          height: 683,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Camellia',
        cultivar: 'Ville de Nantes',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bb9d697e46761f247b6fb5d48295fa2d82b1cbe4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'maliflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 82, 46, 1.00)',
            'rgba(127, 115, 101, 1.00)',
            'rgba(105, 105, 74, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia maliflora/camellia maliflora (2).jpg',
          width: 576,
          id: '34646647dd7488f8a0b1f3387ad48d25',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 112, 77, 1.00)',
            'rgba(131, 133, 91, 1.00)',
            'rgba(97, 123, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia maliflora/camellia maliflora (3).jpg',
          width: 598,
          id: '0359e6c52ec6d3c0ac166225f09a23a5',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(62, 68, 44, 1.00)',
            'rgba(131, 119, 117, 1.00)',
            'rgba(63, 61, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia maliflora/camellia maliflora (1).jpg',
          width: 576,
          id: 'f54ee9f97b1828a23a4e40122872b886',
          height: 768,
          thumbnail: true,
        },
        location: [47.270122, -1.582238],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582238, 47.270122] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0b6278fe92703936ebba9bd08adfb55124355494',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(54, 75, 57, 1.00)',
            'rgba(107, 120, 116, 1.00)',
            'rgba(79, 92, 88, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'asakura'/camellia sasanqua 'asakura' (3).jpg",
          width: 1024,
          id: '757f6cb009cc83424e0c1f53f6a9dd48',
          height: 683,
          thumbnail: true,
        },
        espece: 'sasanqua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 139, 127, 1.00)',
            'rgba(77, 96, 80, 1.00)',
            'rgba(81, 91, 85, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'asakura'/camellia sasanqua 'asakura' (2).jpg",
          width: 1024,
          id: 'e573224ed6e8a30428cb9f0af78e97eb',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 104, 84, 1.00)',
            'rgba(91, 109, 93, 1.00)',
            'rgba(44, 62, 42, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'asakura'/camellia sasanqua 'asakura' (1).jpg",
          width: 1024,
          id: '17a1139046274a481e3837be590d2788',
          height: 727,
          thumbnail: true,
        },
        location: [47.270388, -1.58543],
        genre: 'Camellia',
        cultivar: 'Asakura',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58543, 47.270388] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6f73eaf3bd4c7cbe7f39ad0c7ce99e1b11d89191',
      fields: {
        espece: 'sasanqua',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(41, 51, 33, 1.00)',
            'rgba(97, 101, 85, 1.00)',
            'rgba(59, 63, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'asakura'/camellia sasanqua 'asakura'.jpg",
          width: 1024,
          id: '81dfa3edf838dc43496bd678dfa0b58e',
          height: 683,
          thumbnail: true,
        },
        location: [47.270386, -1.585428],
        genre: 'Camellia',
        cultivar: 'Asakura',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585428, 47.270386] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c42f205fd18fceac249508f860f5a4a464cb23f5',
      fields: {
        espece: 'sasanqua',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 72, 70, 1.00)',
            'rgba(109, 77, 82, 1.00)',
            'rgba(54, 58, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'cleopatra' (sawada)/camellia sasanqua 'cleopatra' (sawada).jpg",
          width: 1024,
          id: '5eecc84ec00a8c69ac4d8747ad58bf9e',
          height: 736,
          thumbnail: true,
        },
        location: [47.27026, -1.586547],
        genre: 'Camellia',
        cultivar: 'Cleopatra (Sawada)',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586547, 47.27026] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c528fe7fbb234fd0e19a45632420ea19530d3237',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(65, 79, 64, 1.00)',
            'rgba(99, 114, 99, 1.00)',
            'rgba(88, 100, 84, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'daydream'/camellia sasanqua 'daydream' (3).jpg",
          width: 1024,
          id: 'fb19bd0283eb7269ead93519169d781f',
          height: 683,
          thumbnail: true,
        },
        espece: 'sasanqua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(37, 39, 26, 1.00)',
            'rgba(125, 122, 108, 1.00)',
            'rgba(68, 69, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'daydream'/camellia sasanqua 'daydream' (2).jpg",
          width: 576,
          id: 'f3846762aec741d9972c95021fb19a44',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(204, 208, 202, 1.00)',
            'rgba(62, 75, 43, 1.00)',
            'rgba(68, 69, 52, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'daydream'/camellia sasanqua 'daydream' (1).jpg",
          width: 576,
          id: '4581c4aea53cb6fbc9b399098ad62675',
          height: 768,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Camellia',
        cultivar: 'Daydream',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '49391612fc1c0a74a5da30a0b5bdf8756a322853',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'sinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 123, 92, 1.00)',
            'rgba(120, 122, 89, 1.00)',
            'rgba(61, 80, 47, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia sinensis/camellia sinensis (3).jpg',
          width: 576,
          id: '2a4db042072b5f76470750eb93532d2f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 107, 91, 1.00)',
            'rgba(100, 118, 93, 1.00)',
            'rgba(69, 87, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia sinensis/camellia sinensis (5).jpg',
          width: 576,
          id: '925dd87b2f4370211fc6fe543a77f1b1',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 116, 92, 1.00)',
            'rgba(120, 128, 90, 1.00)',
            'rgba(105, 115, 80, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia sinensis/camellia sinensis (2).jpg',
          width: 1024,
          id: '1609c8265c9324b69df1b0f1c28f0b76',
          height: 768,
          thumbnail: true,
        },
        location: [47.271053, -1.586888],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586888, 47.271053] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '949439f7f6061cb8a89f947978b254146bc8aeb3',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 82, 49, 1.00)',
            'rgba(95, 72, 64, 1.00)',
            'rgba(98, 67, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'debbie'/camellia x williamsii 'debbie' (3).jpg",
          width: 1024,
          id: 'c160b331881843c692ca4964a503bfdc',
          height: 683,
          thumbnail: true,
        },
        espece: 'x williamsii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 115, 77, 1.00)',
            'rgba(124, 158, 110, 1.00)',
            'rgba(102, 127, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'debbie'/camellia x williamsii 'debbie' (2).jpg",
          width: 576,
          id: 'a8d01cff214c3531480b65df6cdcf9e7',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 177, 150, 1.00)',
            'rgba(86, 105, 58, 1.00)',
            'rgba(99, 84, 67, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'debbie'/camellia x williamsii 'debbie' (1).jpg",
          width: 512,
          id: '443145cd447a86c3b58179ddfb663cb1',
          height: 768,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Camellia',
        cultivar: 'Debbie',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f0d8db630873495cc8bf02006530ca0a1d53b210',
      fields: {
        espece: 'x williamsii',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(63, 81, 40, 1.00)',
            'rgba(105, 115, 76, 1.00)',
            'rgba(50, 61, 30, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'jury's yellow'/camellia x williamsii 'jury's yellow'.jpg",
          width: 1024,
          id: '69d62d152949ecac71186b4c819f040c',
          height: 683,
          thumbnail: true,
        },
        location: [47.271498, -1.582407],
        genre: 'Camellia',
        cultivar: "Jury's Yellow",
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582407, 47.271498] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f2b224c4b094cdc52de74f81c6afa335454433dc',
      fields: {
        espece: 'odora',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 126, 100, 1.00)',
            'rgba(98, 111, 84, 1.00)',
            'rgba(78, 79, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/daphne [thymelaeaceae]/daphne odora/daphne odora.jpg',
          width: 576,
          id: 'be8c085f950f555d0830317ebc1878b9',
          height: 768,
          thumbnail: true,
        },
        location: [47.271463, -1.582178],
        genre: 'Daphne',
        famille: 'Thymelaeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582178, 47.271463] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9ea63824a0cc2082df00de3a823fa7f03f0d3a9f',
      fields: {
        espece: 'latifolia',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Typha',
        date_plantation: '1973',
        famille: 'Typhaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '475e5e49bcfa874f28e87a273714809d7f4b4465',
      fields: {
        origine: 'Facult\u00e9 de Matsudo (Japon)',
        espece: 'gryposeras Gray.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Viola',
        date_plantation: '2006',
        famille: 'Violaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '19000133ab20418308cd1599fff6471700df4fe2',
      fields: {
        origine: 'JB.Samara (Russie)',
        espece: 'aconitifolia',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Ampelopsis',
        date_plantation: '2005',
        famille: 'Vitaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2959e04031be0eb4dbcb738e9a48eaf7edee18a8',
      fields: {
        origine: 'Arboretum Trsteno (Croatie)',
        espece: 'fistulosus L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Asphodelus',
        date_plantation: '1998',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '805819b702eef290c33857029b1bc02909aa53f1',
      fields: {
        origine: 'JB.Dunedin (N-Z\u00e9lande)',
        espece: 'cookianun Le Jolis',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Phormium',
        date_plantation: '2004',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8c48be36d0fe3dc78e01eed65522b414a446df10',
      fields: {
        origine: 'JB.Irkutsk (Russie)',
        espece: 'lilio-asphodelus  L.',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Hemerocallis',
        date_plantation: '2008',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '83b58fde1adfeb671b4117b87aef2853955020c4',
      fields: {
        origine: 'JB.Timaru (N-Z\u00e9lande)',
        espece: 'tenax J.R. & G. Forst.',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Phormium',
        date_plantation: '2006',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3f72f10ca47564229f453c92dcba68a3a27a4add',
      fields: {
        origine: 'JBU.Tohoku (Sendai)',
        espece: 'citrina Baroni',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Hemerocallis',
        date_plantation: '1998',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '80823c566013d4b2b4a0ec6d1783f41aa9f3327b',
      fields: {
        origine: 'Mr.Boff B.',
        espece: 'schimperi Baker.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Kniphofia',
        date_plantation: '1998',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '61b97d06f9e6c635caff8594b5fe84ece4ee6db6',
      fields: {
        espece: 'distichum',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 164, 51, 1.00)',
            'rgba(118, 146, 49, 1.00)',
            'rgba(114, 134, 58, 1.00)',
          ],
          filename:
            'ip parc de proce/abeliophyllum/abeliophyllum distichum/abeliophyllum distichum.jpg',
          width: 576,
          id: '51181ee3bffb5a6b6cec89c8031ba5b7',
          height: 768,
          thumbnail: true,
        },
        location: [47.2259, -1.58192],
        genre: 'Abeliophyllum',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58192, 47.2259] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3a914e1bf34f9097f05d6c50fa094fa20ffc6202',
      fields: {
        espece: 'concolor',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(192, 215, 223, 1.00)',
            'rgba(128, 144, 116, 1.00)',
            'rgba(77, 82, 50, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/abies/abies concolor/abies concolor (2).jpg',
          width: 576,
          id: 'e78ccad57b4ebc8965c4c19827014b64',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 122, 82, 1.00)',
            'rgba(134, 160, 103, 1.00)',
            'rgba(91, 104, 59, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/abies/abies concolor/abies concolor (1).jpg',
          width: 1024,
          id: 'bcea57a0b2c3e5ba49294960a9bd5ff8',
          height: 768,
          thumbnail: true,
        },
        location: [47.23042, -1.506642],
        genre: 'Abies',
        famille: 'Pinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.506642, 47.23042] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '571d6c9d6c1b4c6e72c22ff8984ba8abcbb1fea5',
      fields: {
        espece: 'platanoides',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(183, 203, 183, 1.00)',
            'rgba(76, 101, 46, 1.00)',
            'rgba(86, 106, 55, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/acer/acer platanoides 'reitenbachii'/acer platanoides 'reitenbachii' .jpg",
          width: 576,
          id: 'd58a251edd09a0e09bdfdae3647ddb0e',
          height: 768,
          thumbnail: true,
        },
        location: [47.220562, -1.543703],
        genre: 'Acer',
        cultivar: 'Reitenbachii',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543703, 47.220562] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f0fbd8fc5d5924590710880cabced9a44d35b6b5',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 129, 57, 1.00)',
            'rgba(151, 144, 57, 1.00)',
            'rgba(127, 132, 36, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer buergerianum 'miyako kaede'/acer buergerianum 'miyako kaede' (3).jpg",
          width: 576,
          id: '0872139c14887389a6bcbbcc9b85ec43',
          height: 768,
          thumbnail: true,
        },
        espece: 'buergerianum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 91, 55, 1.00)',
            'rgba(131, 149, 75, 1.00)',
            'rgba(154, 143, 100, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer buergerianum 'miyako kaede'/acer buergerianum 'miyako kaede' (2).jpg",
          width: 1024,
          id: 'f153ef75a0e2dee0082cf0cc8b41fde3',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 120, 48, 1.00)',
            'rgba(126, 156, 53, 1.00)',
            'rgba(104, 117, 37, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer buergerianum 'miyako kaede'/acer buergerianum 'miyako kaede' (1).jpg",
          width: 576,
          id: '159ef978e8e931f8424ade288f095100',
          height: 768,
          thumbnail: true,
        },
        location: [47.222687, -1.58025],
        genre: 'Acer',
        cultivar: 'Miyako Kaede',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58025, 47.222687] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '68baa648ea9edbabdfe6df03662e652627de23e6',
      fields: {
        espece: 'cissifolium',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 191, 120, 1.00)',
            'rgba(124, 144, 70, 1.00)',
            'rgba(101, 116, 68, 1.00)',
          ],
          filename:
            'ip parc de proce/acer/acer cissifolium/acer cissifolium.jpg',
          width: 1024,
          id: '66db8d361734e7390500d5552e7b6b4a',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 153, 168, 1.00)',
            'rgba(155, 146, 142, 1.00)',
            'rgba(124, 146, 140, 1.00)',
          ],
          filename:
            'ip parc de proce/acer/acer cissifolium/acer cissifolium (2).jpg',
          width: 649,
          id: 'ce297a3c97240594b994d54d41df72ca',
          height: 768,
          thumbnail: true,
        },
        location: [47.22338, -1.584367],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584367, 47.22338] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b3116348b90ce2e6a65639c5f30f9af171580f9c',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'griseum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 172, 107, 1.00)',
            'rgba(97, 115, 68, 1.00)',
            'rgba(93, 107, 62, 1.00)',
          ],
          filename: 'ip parc de proce/acer/acer griseum/acer griseum  (2).jpg',
          width: 576,
          id: 'c0e68bd8cc893b42eb461e4fb36e074a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 165, 141, 1.00)',
            'rgba(95, 108, 78, 1.00)',
            'rgba(108, 113, 85, 1.00)',
          ],
          filename: 'ip parc de proce/acer/acer griseum/acer griseum  (3).jpg',
          width: 576,
          id: 'e36a7e109491dfbea205e269044212c8',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(187, 189, 205, 1.00)',
            'rgba(86, 94, 91, 1.00)',
            'rgba(69, 75, 64, 1.00)',
          ],
          filename: 'ip parc de proce/acer/acer griseum/acer griseum  (1).jpg',
          width: 512,
          id: '78bcc01c9956ad1836e1cd05b7bcfba9',
          height: 768,
          thumbnail: true,
        },
        location: [47.222897, -1.579263],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.579263, 47.222897] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '87fa9e4a910e15bff890743aa543124c0e0d74e7',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 112, 84, 1.00)',
            'rgba(127, 144, 78, 1.00)',
            'rgba(122, 137, 70, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer japonicum 'aconitifolium'/acer japonicum 'aconitifolium' (3).jpg",
          width: 576,
          id: '4502be72214656ea1bba8c4f0f48d18f',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonicum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 152, 126, 1.00)',
            'rgba(117, 124, 83, 1.00)',
            'rgba(109, 112, 81, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer japonicum 'aconitifolium'/acer japonicum 'aconitifolium' (2).jpg",
          width: 1024,
          id: '925a2265cb2ec97bf8632c6dae228cbe',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 152, 124, 1.00)',
            'rgba(148, 143, 104, 1.00)',
            'rgba(104, 103, 76, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer japonicum 'aconitifolium'/acer japonicum 'aconitifolium' (1).jpg",
          width: 576,
          id: '0d2d8593bff41664dcf83634689ee8f5',
          height: 768,
          thumbnail: true,
        },
        location: [47.222767, -1.5826],
        genre: 'Acer',
        cultivar: 'Aconitifolium',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5826, 47.222767] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd0ebacd0918253412e37c94b50e416b00b9929b1',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 142, 79, 1.00)',
            'rgba(142, 150, 93, 1.00)',
            'rgba(131, 133, 85, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer palmatum 'kagiri-nishiki'/acer palmatum 'kagiri-nishiki' (3).jpg",
          width: 576,
          id: 'c76e9f444e3c752fa337aa5057619fd7',
          height: 768,
          thumbnail: true,
        },
        espece: 'palmatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 106, 58, 1.00)',
            'rgba(124, 120, 76, 1.00)',
            'rgba(134, 126, 90, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer palmatum 'kagiri-nishiki'/acer palmatum 'kagiri-nishiki' (2).jpg",
          width: 576,
          id: 'e88d96326ff9c2075436a5629deed3cf',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 124, 72, 1.00)',
            'rgba(114, 123, 74, 1.00)',
            'rgba(107, 97, 73, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer palmatum 'kagiri-nishiki'/acer palmatum 'kagiri-nishiki' (1).jpg",
          width: 1024,
          id: '9fe699a96669a4760837532c0c218e59',
          height: 768,
          thumbnail: true,
        },
        location: [47.225205, -1.581338],
        genre: 'Acer',
        cultivar: 'Kagiri-nishiki',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581338, 47.225205] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c193a8823cbb9bb4a9d15447d0b7939120bd6e43',
      fields: {
        espece: 'palmatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 116, 52, 1.00)',
            'rgba(119, 150, 70, 1.00)',
            'rgba(129, 136, 84, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer palmatum 'shishi-gashira'/acer palmatum 'shishi-gashira' (2).jpg",
          width: 576,
          id: '9e2ed072026a8a70d14cb7f0e68d64b0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 131, 80, 1.00)',
            'rgba(117, 136, 87, 1.00)',
            'rgba(145, 135, 114, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer palmatum 'shishi-gashira'/acer palmatum 'shishi-gashira' (1).jpg",
          width: 946,
          id: 'ab22c9e830bbaa62b7c4f835656169b7',
          height: 768,
          thumbnail: true,
        },
        location: [47.222883, -1.579247],
        genre: 'Acer',
        cultivar: 'Shishi-gashira',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.579247, 47.222883] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '97d16e259bfcc479dbd78dd9bb5291ebf9d319ad',
      fields: {
        nom_du_site: 'Autre site',
        espece: 'x carnea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 99, 60, 1.00)',
            'rgba(147, 106, 93, 1.00)',
            'rgba(126, 134, 76, 1.00)',
          ],
          filename:
            'ip ville de nantes/aesculus/aesculus x carnea/aesculus x carnea  (2).jpg',
          width: 576,
          id: 'd3a77c40ba8e2a449d200441ab1c2810',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(218, 223, 217, 1.00)',
            'rgba(106, 110, 88, 1.00)',
            'rgba(97, 108, 70, 1.00)',
          ],
          filename:
            'ip ville de nantes/aesculus/aesculus x carnea/aesculus x carnea  (3).jpg',
          width: 1024,
          id: 'a93759610b5da1f0d6dada92a2c1a43f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 122, 57, 1.00)',
            'rgba(156, 149, 94, 1.00)',
            'rgba(150, 116, 80, 1.00)',
          ],
          filename:
            'ip ville de nantes/aesculus/aesculus x carnea/aesculus x carnea  (1).jpg',
          width: 576,
          id: '10404019a0f154842d8fc43b2af004e7',
          height: 768,
          thumbnail: true,
        },
        location: [47.224325, -1.566612],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.566612, 47.224325] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd615645f992acbd214d31d4967afa0c5ecaea3a5',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'x andrachnoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(190, 130, 100, 1.00)',
            'rgba(197, 123, 86, 1.00)',
            'rgba(174, 108, 74, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/arbutus/arbutus x andrachnoides/arbutus x andrachnoides (3).jpg',
          width: 576,
          id: '7f36f5e64bf379ccc60772cd053dfa0f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 96, 70, 1.00)',
            'rgba(127, 110, 67, 1.00)',
            'rgba(177, 156, 127, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/arbutus/arbutus x andrachnoides/arbutus x andrachnoides (4).jpg',
          width: 576,
          id: '31df31ae56d52f313e3f465c715d64f7',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(186, 191, 193, 1.00)',
            'rgba(96, 94, 76, 1.00)',
            'rgba(90, 89, 51, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/arbutus/arbutus x andrachnoides/arbutus x andrachnoides (1).jpg',
          width: 576,
          id: 'bea90c235e5d14f6f199d21ca2923c99',
          height: 768,
          thumbnail: true,
        },
        location: [47.220175, -1.542045],
        genre: 'Arbutus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542045, 47.220175] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a21857988695c9f16f295976ae8cc9bc97b6fdba',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'x thuretiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 106, 47, 1.00)',
            'rgba(115, 123, 61, 1.00)',
            'rgba(135, 136, 69, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/arbutus/arbutus x thuretiana/arbutus x thuretiana (2).jpg',
          width: 576,
          id: 'ba8e495f7615bd8309a7b12bf5f2fb80',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 158, 99, 1.00)',
            'rgba(105, 140, 74, 1.00)',
            'rgba(133, 140, 112, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/arbutus/arbutus x thuretiana/arbutus x thuretiana (3).jpg',
          width: 576,
          id: '0f629daf871154a2a73ce13a112a4438',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 147, 105, 1.00)',
            'rgba(141, 142, 99, 1.00)',
            'rgba(144, 133, 96, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/arbutus/arbutus x thuretiana/arbutus x thuretiana (1).jpg',
          width: 576,
          id: '0636d74905bf6a9818e0c417b0dacae7',
          height: 768,
          thumbnail: true,
        },
        location: [47.228338, -1.508237],
        genre: 'Arbutus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508237, 47.228338] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e3adf31d76405fceabfd2e709c087496226ac879',
      fields: {
        espece: 'lanceolata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 161, 129, 1.00)',
            'rgba(128, 144, 112, 1.00)',
            'rgba(143, 144, 142, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/azara/azara lanceolata/azara lanceolata (2).jpg',
          width: 576,
          id: '2e967d33a0919994a79b43a0b6de09d6',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 145, 124, 1.00)',
            'rgba(151, 147, 66, 1.00)',
            'rgba(114, 115, 97, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/azara/azara lanceolata/azara lanceolata (1).jpg',
          width: 635,
          id: '44943f0c212b3b5af87e700154c1b240',
          height: 768,
          thumbnail: true,
        },
        location: [47.218492, -1.542353],
        genre: 'Azara',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542353, 47.218492] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1e47675acca5f84a1d4c5667b71e48aca5961345',
      fields: {
        espece: 'albiflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 182, 104, 1.00)',
            'rgba(86, 137, 49, 1.00)',
            'rgba(105, 127, 81, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/buddleja/buddleja albiflora/buddleja albiflora (2).jpg',
          width: 576,
          id: '0a2f86d2f077513ce776a5751d6fd210',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 148, 89, 1.00)',
            'rgba(94, 110, 71, 1.00)',
            'rgba(99, 123, 82, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/buddleja/buddleja albiflora/buddleja albiflora (1).jpg',
          width: 1024,
          id: '849b3588041bc53ef8c2a577b6ae0d8a',
          height: 768,
          thumbnail: true,
        },
        location: [47.2205, -1.542575],
        genre: 'Buddleja',
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542575, 47.2205] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '413564b0779518308ab881388d27d9e1bc40bd9d',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 96, 102, 1.00)',
            'rgba(109, 90, 94, 1.00)',
            'rgba(127, 118, 105, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/buddleja scrophulariaceae/buddleja davidii 'pink delight'/buddleja davidii 'pink delight'.jpg",
          width: 576,
          id: 'af30b13adaa027e5c15f5b304d2e2684',
          height: 768,
          thumbnail: true,
        },
        location: [47.271355, -1.582137],
        genre: 'Buddleja',
        cultivar: 'Pink Delight',
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582137, 47.271355] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bff56e9e9c20c7c3a2945cbdaee16d7c2d8f19fe',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 148, 148, 1.00)',
            'rgba(111, 116, 104, 1.00)',
            'rgba(117, 108, 108, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia 'minato-no-akebono'/camellia 'minato-no-akebono' (2).jpg",
          width: 508,
          id: 'cd38ebfb2537172449197609af3bbaa6',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 116, 117, 1.00)',
            'rgba(110, 112, 110, 1.00)',
            'rgba(103, 106, 104, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia 'minato-no-akebono'/camellia 'minato-no-akebono' (3).jpg",
          width: 1024,
          id: '28afd61a69de98448e038d7d39fe99f1',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 94, 95, 1.00)',
            'rgba(147, 123, 139, 1.00)',
            'rgba(81, 76, 87, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia 'minato-no-akebono'/camellia 'minato-no-akebono' (1).jpg",
          width: 988,
          id: '4bf3ebacd3379d67d2433e630a1d486d',
          height: 768,
          thumbnail: true,
        },
        location: [47.219225, -1.541025],
        genre: 'Camellia',
        cultivar: 'Minato-no-akebono',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541025, 47.219225] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '70ec37701e5affab688fc28e1fbb190a81efe82e',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'cuspidata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 72, 64, 1.00)',
            'rgba(131, 127, 128, 1.00)',
            'rgba(77, 84, 83, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia cuspidata/camellia cuspidata (2).jpg',
          width: 576,
          id: 'c13f13aced84cb591239415a0692f1ff',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 133, 127, 1.00)',
            'rgba(119, 136, 130, 1.00)',
            'rgba(88, 97, 89, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia cuspidata/camellia cuspidata (3).jpg',
          width: 576,
          id: '9de4c5bc7c97bf4b71643a202c9b12e8',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 141, 128, 1.00)',
            'rgba(107, 116, 112, 1.00)',
            'rgba(113, 109, 107, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia cuspidata/camellia cuspidata (1).jpg',
          width: 576,
          id: '9212f2d5312af3980d15382bc0ddbf58',
          height: 768,
          thumbnail: true,
        },
        location: [47.220247, -1.54168],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54168, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7924359debd93ecdcf776ceacedda29d63f88c66',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'fraterna',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 114, 118, 1.00)',
            'rgba(89, 95, 95, 1.00)',
            'rgba(84, 91, 90, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia fraterna/camellia fraterna (2).jpg',
          width: 1024,
          id: '1f87a9fca621531af52cbc26883e25f2',
          height: 719,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 120, 122, 1.00)',
            'rgba(68, 73, 80, 1.00)',
            'rgba(74, 69, 73, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia fraterna/camellia fraterna (4).jpg',
          width: 1024,
          id: '9944bd01ba86836e4c52409f5ccea669',
          height: 752,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 112, 112, 1.00)',
            'rgba(94, 100, 96, 1.00)',
            'rgba(38, 51, 39, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia fraterna/camellia fraterna (1).jpg',
          width: 1024,
          id: '9ae9cfaa47258efbeffbffdab12b5f62',
          height: 691,
          thumbnail: true,
        },
        location: [47.220247, -1.541681],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541681, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7de95d77e25a2cc72cefefeed06713eaff791f92',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(40, 47, 36, 1.00)',
            'rgba(113, 100, 105, 1.00)',
            'rgba(60, 58, 53, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'duchesse decazes'/camellia japonica 'duchesse decazes' (3).jpg",
          width: 1024,
          id: '3291b03f9724ad0bff89fdff6cbd2818',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(24, 25, 22, 1.00)',
            'rgba(98, 90, 93, 1.00)',
            'rgba(67, 63, 64, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'duchesse decazes'/camellia japonica 'duchesse decazes' (2).jpg",
          width: 1024,
          id: '437fc17aadc24661caa8ec8baef1d149',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(191, 191, 187, 1.00)',
            'rgba(94, 104, 90, 1.00)',
            'rgba(63, 69, 63, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'duchesse decazes'/camellia japonica 'duchesse decazes' (1).jpg",
          width: 512,
          id: '1651b7242facfe1157712780ba1de08a',
          height: 768,
          thumbnail: true,
        },
        location: [47.220247, -1.54168],
        genre: 'Camellia',
        cultivar: 'Duchesse Decazes',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54168, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '01b92e9f609b2f0bd0fc7c4750f8ef0c71380146',
      fields: {
        espece: 'sasanqua',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 53, 55, 1.00)',
            'rgba(129, 65, 67, 1.00)',
            'rgba(83, 51, 57, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia sasanqua 'yuletide'/camellia sasanqua 'yuletide' (5).jpg",
          width: 1024,
          id: 'c0a8848632cb4381c094e30304629335',
          height: 685,
          thumbnail: true,
        },
        location: [47.220392, -1.544583],
        genre: 'Camellia',
        cultivar: 'Yuletide',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544583, 47.220392] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ee741c97cf32f8333f596e398ded741409aa2d4c',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 146, 132, 1.00)',
            'rgba(105, 136, 97, 1.00)',
            'rgba(121, 139, 99, 1.00)',
          ],
          filename:
            "ip parc de proce/camellia/camellia japonica 'mrs d. w. davis'/camellia japonica 'mrs d. w. davis' (2).jpg",
          width: 576,
          id: 'ac75f0a47bf35163ee9a997c81438a7c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 68, 54, 1.00)',
            'rgba(150, 138, 137, 1.00)',
            'rgba(77, 79, 74, 1.00)',
          ],
          filename:
            "ip parc de proce/camellia/camellia japonica 'mrs d. w. davis'/camellia japonica 'mrs d. w. davis' (1).jpg",
          width: 576,
          id: 'aea754b0e7839092c63e9cf69ca41567',
          height: 768,
          thumbnail: true,
        },
        location: [47.222538, -1.583517],
        genre: 'Camellia',
        cultivar: 'Mrs D. W. Davis',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583517, 47.222538] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '93fda1cd8335ebb9fd2b1931de3983459e35b0f4',
      fields: {
        espece: 'caroliniana',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 117, 98, 1.00)',
            'rgba(136, 103, 52, 1.00)',
            'rgba(103, 113, 49, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/carpinus/carpinus caroliniana/carpinus caroliniana .jpg',
          width: 576,
          id: '6ff8758855d2108fce33b8d7eb842a59',
          height: 768,
          thumbnail: true,
        },
        location: [47.21828, -1.541544],
        genre: 'Carpinus',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541544, 47.21828] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '145466801921f5c4644bf0b72c82f3a7fdc5126a',
      fields: {
        espece: 'betulus',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(171, 171, 165, 1.00)',
            'rgba(116, 106, 77, 1.00)',
            'rgba(95, 82, 48, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/carpinus/carpinus betulus/carpinus betulus.jpg',
          width: 1024,
          id: '851623679c0bad4f6d5096387e277aae',
          height: 768,
          thumbnail: true,
        },
        location: [47.2625, -1.532037],
        genre: 'Carpinus',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532037, 47.2625] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c1fa702daa0d478dc964a6a58129accb21f7c734',
      fields: {
        espece: 'bignonioides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 163, 118, 1.00)',
            'rgba(116, 127, 87, 1.00)',
            'rgba(68, 77, 43, 1.00)',
          ],
          filename:
            'ip parc de proce/catalpa/catalpa bignonioides/catalpa bignonioides.jpg',
          width: 576,
          id: '197f4b4b93178fc8dfa0c50fe7645a12',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(167, 178, 151, 1.00)',
            'rgba(96, 111, 79, 1.00)',
            'rgba(61, 71, 44, 1.00)',
          ],
          filename:
            'ip parc de proce/catalpa/catalpa bignonioides/catalpa bignonioides (2).jpg',
          width: 576,
          id: 'decee7a1e191f0631720890ef0ef5ef8',
          height: 768,
          thumbnail: true,
        },
        location: [47.224583, -1.581347],
        genre: 'Catalpa',
        famille: 'Bignoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581347, 47.224583] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dc1c4f1a7151f2f0514f22c79bb748047f157723',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'nitens var. salicifolius',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 124, 83, 1.00)',
            'rgba(118, 141, 83, 1.00)',
            'rgba(74, 103, 51, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/chimonanthus/chimonanthus nitens var. salicifolius/chimonanthus nitens var. salicifolius (2).jpg',
          width: 576,
          id: '4a0d7a1c5fa99f6f5eee2618da95f644',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(180, 192, 181, 1.00)',
            'rgba(76, 79, 30, 1.00)',
            'rgba(77, 72, 50, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/chimonanthus/chimonanthus nitens var. salicifolius/chimonanthus nitens var. salicifolius (3).jpg',
          width: 617,
          id: 'eabdc13ef02a8a8fe0f27b9b5a0a9ab8',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 115, 37, 1.00)',
            'rgba(111, 134, 69, 1.00)',
            'rgba(82, 114, 49, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/chimonanthus/chimonanthus nitens var. salicifolius/chimonanthus nitens var. salicifolius (1).jpg',
          width: 576,
          id: '7e2c4750596f84fbcb747bf76ebe266d',
          height: 768,
          thumbnail: true,
        },
        location: [47.219742, -1.542667],
        genre: 'Chimonanthus',
        famille: 'Calycanthaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542667, 47.219742] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7b56999d8d7466f06864fad03e39f76d0bbdd11d',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'bungei',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 132, 89, 1.00)',
            'rgba(128, 115, 114, 1.00)',
            'rgba(74, 94, 56, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/clerodendrum/clerodendrum bungei/clerodendrum bungei (2).jpg',
          width: 1024,
          id: '7f9c58c25f71c33d0e32534bf6549933',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 99, 65, 1.00)',
            'rgba(96, 130, 100, 1.00)',
            'rgba(84, 113, 73, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/clerodendrum/clerodendrum bungei/clerodendrum bungei (3).jpg',
          width: 576,
          id: '8aff642ec806e3b1254d5830e96ec85b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 140, 90, 1.00)',
            'rgba(99, 123, 73, 1.00)',
            'rgba(97, 129, 73, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/clerodendrum/clerodendrum bungei/clerodendrum bungei (1).jpg',
          width: 576,
          id: '45cd88009af8054cd77d0b0427a6c13d',
          height: 768,
          thumbnail: true,
        },
        location: [47.219517, -1.543153],
        genre: 'Clerodendrum',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543153, 47.219517] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '344b413a63e29e3ca41ef978d42965c7efa988e0',
      fields: {
        espece: 'barbinervis',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 123, 93, 1.00)',
            'rgba(86, 129, 92, 1.00)',
            'rgba(83, 125, 90, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/clethra/clethra barbinervis/clethra barbinervis (2).jpg',
          width: 1024,
          id: 'a37abdefbfec71fa44f9c9e2ce6e0149',
          height: 683,
          thumbnail: true,
        },
        location: [47.219047, -1.541853],
        genre: 'Clethra',
        famille: 'Clethraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541853, 47.219047] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '347cf1fefde78e3dc4131ff8a0788ecd6c91e85f',
      fields: {
        espece: 'capitata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 127, 48, 1.00)',
            'rgba(142, 161, 62, 1.00)',
            'rgba(88, 113, 30, 1.00)',
          ],
          filename:
            'ip parc de proce/cornus/cornus capitata/cornus capitata (3).jpg',
          width: 576,
          id: 'aea34bbd277f026154096de13ac6cb20',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 138, 120, 1.00)',
            'rgba(77, 98, 54, 1.00)',
            'rgba(68, 94, 39, 1.00)',
          ],
          filename:
            'ip parc de proce/cornus/cornus capitata/cornus capitata (1).jpg',
          width: 576,
          id: 'fb3169cff1178901b14387ce9aa02d36',
          height: 768,
          thumbnail: true,
        },
        location: [47.225605, -1.582813],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582813, 47.225605] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ca39d95875cf647f56111094f6680e1e1789b3fa',
      fields: {
        espece: 'florida f. rubra',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(182, 173, 162, 1.00)',
            'rgba(106, 100, 61, 1.00)',
            'rgba(95, 94, 75, 1.00)',
          ],
          filename:
            'ip parc de proce/cornus/cornus florida f. rubra/cornus florida f. rubra.jpg',
          width: 576,
          id: '08a525814f95eb7c33247733cf591a9c',
          height: 768,
          thumbnail: true,
        },
        location: [47.222817, -1.578113],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.578113, 47.222817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2cc5b5ad642fa1e208da483a8c69c888667202b8',
      fields: {
        espece: 'sanguinea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 82, 92, 1.00)',
            'rgba(135, 77, 61, 1.00)',
            'rgba(112, 66, 37, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/cornus/cornus sanguinea 'midwinter fire'/cornus sanguinea 'midwinter fire' (2).jpg",
          width: 1024,
          id: 'df0b64681f1c9df0df88a98c58a463a8',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 104, 118, 1.00)',
            'rgba(130, 86, 62, 1.00)',
            'rgba(110, 81, 54, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/cornus/cornus sanguinea 'midwinter fire'/cornus sanguinea 'midwinter fire' (1).jpg",
          width: 921,
          id: 'cbbd7c7ec97133a7dee65420866213c6',
          height: 768,
          thumbnail: true,
        },
        location: [47.230403, -1.506597],
        genre: 'Cornus',
        cultivar: 'Midwinter Fire',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.506597, 47.230403] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '898d0f787e3dac7b8bea71a4840379d4d352cca0',
      fields: {
        espece: 'hongkongensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(51, 81, 42, 1.00)',
            'rgba(90, 112, 64, 1.00)',
            'rgba(66, 82, 41, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/cornus/cornus hongkongensis/cornus hongkongensis  (2).jpg',
          width: 1024,
          id: '8df83e03a575fc0a5b7a39efaec96b0b',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 82, 59, 1.00)',
            'rgba(94, 105, 80, 1.00)',
            'rgba(99, 107, 82, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/cornus/cornus hongkongensis/cornus hongkongensis  (1).jpg',
          width: 1024,
          id: '0c6e71795630cf8d0e68372e551eaf75',
          height: 683,
          thumbnail: true,
        },
        location: [47.26263, -1.530455],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530455, 47.26263] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0060ff215ee24b5578670a9c3eef00e15e0c584d',
      fields: {
        espece: 'hongkongensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(209, 214, 205, 1.00)',
            'rgba(116, 125, 99, 1.00)',
            'rgba(48, 58, 23, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/cornus/cornus hongkongensis/cornus hongkongensis (2).jpg',
          width: 1024,
          id: '9ddcdf20696a147ffcc50d4c2c1ff81b',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 150, 84, 1.00)',
            'rgba(99, 132, 44, 1.00)',
            'rgba(95, 120, 43, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/cornus/cornus hongkongensis/cornus hongkongensis (1).jpg',
          width: 1024,
          id: '8fd6ec684c4d1ce34b04d330eb5330e3',
          height: 683,
          thumbnail: true,
        },
        location: [47.262397, -1.534313],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534313, 47.262397] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9f13489f1dc999c06afed49ceea518f9016cb112',
      fields: {
        espece: 'mas',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 191, 227, 1.00)',
            'rgba(136, 137, 113, 1.00)',
            'rgba(91, 89, 53, 1.00)',
          ],
          filename: 'ip ville de nantes/cornus/cornus mas/cornus mas.jpg',
          width: 576,
          id: 'a1061fb6da0623f118fd44585cd03977',
          height: 768,
          thumbnail: true,
        },
        location: [47.246267, -1.55538],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.55538, 47.246267] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '264d8870c3fbb0d6b8068041fe3add7330585bd7',
      fields: {
        espece: 'patagua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 115, 84, 1.00)',
            'rgba(99, 124, 75, 1.00)',
            'rgba(74, 97, 52, 1.00)',
          ],
          filename:
            'ip parc de proce/crinodendron/crinodendron patagua/crinodendron patagua (2).jpg',
          width: 576,
          id: '26ac0ec747aff996b37952c173b58c14',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 160, 136, 1.00)',
            'rgba(93, 113, 82, 1.00)',
            'rgba(111, 121, 89, 1.00)',
          ],
          filename:
            'ip parc de proce/crinodendron/crinodendron patagua/crinodendron patagua (1).jpg',
          width: 1024,
          id: '3aee48ff39cb22109c60660a88e6b19a',
          height: 768,
          thumbnail: true,
        },
        location: [47.222605, -1.582497],
        genre: 'Crinodendron',
        famille: 'Elaeocarpaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582497, 47.222605] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '500fbfdf97356c48165078703e6c5f0fe06ffd7d',
      fields: {
        nom_du_site: 'Cimeti\u00e8re de la Bouteillerie',
        espece: 'lanceolata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 108, 94, 1.00)',
            'rgba(141, 148, 122, 1.00)',
            'rgba(121, 129, 91, 1.00)',
          ],
          filename:
            'ip cimetiere de la bouteillerie/cunninghamia/cunninghamia lanceolata/cunninghamia lanceolata (2).jpg',
          width: 576,
          id: '7212bfb1c2d26d8bb21ab0351a35f0ae',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 130, 64, 1.00)',
            'rgba(128, 160, 48, 1.00)',
            'rgba(94, 119, 41, 1.00)',
          ],
          filename:
            'ip cimetiere de la bouteillerie/cunninghamia/cunninghamia lanceolata/cunninghamia lanceolata (3).jpg',
          width: 576,
          id: '3695803bb0c1f40e9419fcc2364dd4bf',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(199, 200, 198, 1.00)',
            'rgba(117, 122, 111, 1.00)',
            'rgba(95, 94, 73, 1.00)',
          ],
          filename:
            'ip cimetiere de la bouteillerie/cunninghamia/cunninghamia lanceolata/cunninghamia lanceolata (1).jpg',
          width: 576,
          id: 'adec7502b834409c7e4b7582eb513a29',
          height: 768,
          thumbnail: true,
        },
        location: [47.222245, -1.538662],
        genre: 'Cunninghamia',
        famille: 'Cupressaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.538662, 47.222245] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '95ccf6c6d5d8b71abf49aaaf51eb4a9443e4beb4',
      fields: {
        espece: 'konishii',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 153, 145, 1.00)',
            'rgba(69, 86, 54, 1.00)',
            'rgba(65, 81, 54, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cunninghamia/cunninghamia konishii/cunninghamia konishii.jpg',
          width: 512,
          id: '5d805962af6d82bdd02ed253321d2abf',
          height: 768,
          thumbnail: true,
        },
        location: [47.220078, -1.541668],
        genre: 'Cunninghamia',
        famille: 'Cupressaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541668, 47.220078] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a750dcd8e1da6ba24faba9d0ef502a94e10c0572',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'umbellata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 158, 96, 1.00)',
            'rgba(134, 151, 84, 1.00)',
            'rgba(116, 128, 67, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/elaeagnus/elaeagnus umbellata/elaeagnus umbellata (2).jpg',
          width: 576,
          id: '0a8668060229bcdbb6b0d31964feee0c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 131, 99, 1.00)',
            'rgba(142, 146, 102, 1.00)',
            'rgba(126, 136, 78, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/elaeagnus/elaeagnus umbellata/elaeagnus umbellata (3).jpg',
          width: 576,
          id: 'fdd7a058163e9d9dc82522f357e578bd',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 127, 75, 1.00)',
            'rgba(134, 139, 78, 1.00)',
            'rgba(111, 117, 63, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/elaeagnus/elaeagnus umbellata/elaeagnus umbellata (1).jpg',
          width: 576,
          id: 'aae2705acfe83a8909c3905dc40440a5',
          height: 768,
          thumbnail: true,
        },
        location: [47.219347, -1.543888],
        genre: 'Elaeagnus',
        famille: 'Elaeagnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543888, 47.219347] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd65cb20990ca8b2a2946828d7e8a8cd97d789fe2',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'henryi',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(202, 204, 194, 1.00)',
            'rgba(118, 134, 90, 1.00)',
            'rgba(77, 86, 53, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/emmenopterys/emmenopterys henryi/emmenopterys henryi (2).jpg',
          width: 576,
          id: 'de2d23324656557940abb99358abb98e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 126, 61, 1.00)',
            'rgba(110, 121, 60, 1.00)',
            'rgba(131, 142, 79, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/emmenopterys/emmenopterys henryi/emmenopterys henryi (3).jpg',
          width: 941,
          id: '69ce9d8571d0adbd27fcbfdcdfee2ca9',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 145, 73, 1.00)',
            'rgba(122, 155, 70, 1.00)',
            'rgba(117, 134, 67, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/emmenopterys/emmenopterys henryi/emmenopterys henryi (1).jpg',
          width: 576,
          id: '6e599929727eafc95779b8d482f2199e',
          height: 768,
          thumbnail: true,
        },
        location: [47.228197, -1.508467],
        genre: 'Emmenopterys',
        famille: 'Rubiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508467, 47.228197] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ef9c5ec8706c441be24d982ea74f069c74d8e572',
      fields: {
        espece: 'sylvatica Atropurpurea Group',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(189, 203, 224, 1.00)',
            'rgba(116, 110, 113, 1.00)',
            'rgba(90, 99, 58, 1.00)',
          ],
          filename:
            'ip parc de proce/fagus/fagus sylvatica atropurpurea group/fagus sylvatica atropurpurea group.jpg',
          width: 576,
          id: '7af2fac06d9b759dc04639c441e61be5',
          height: 768,
          thumbnail: true,
        },
        location: [47.22295, -1.582283],
        genre: 'Fagus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582283, 47.22295] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '91e61a0604546d7ae304a80b860a5be15b6e0eef',
      fields: {
        espece: 'sylvatica',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(195, 215, 176, 1.00)',
            'rgba(127, 140, 39, 1.00)',
            'rgba(80, 91, 32, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/fagus/fagus sylvatica 'zlatia'/fagus sylvatica 'zlatia'.jpg",
          width: 576,
          id: '09f5a423bb30037f48a20332e7cd1781',
          height: 768,
          thumbnail: true,
        },
        location: [47.262703, -1.535233],
        genre: 'Fagus',
        cultivar: 'Zlatia',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535233, 47.262703] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ab6b35a68ed788358813d980ffe7923b047d17df',
      fields: {
        espece: 'excelsior',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 145, 110, 1.00)',
            'rgba(74, 92, 48, 1.00)',
            'rgba(107, 110, 72, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/fraxinus/fraxinus excelsior 'crispa'/fraxinus excelsior 'crispa' (2).jpg",
          width: 512,
          id: 'd4f44dca43e8ac53263d07182ac01ee1',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 126, 99, 1.00)',
            'rgba(97, 112, 78, 1.00)',
            'rgba(126, 131, 95, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/fraxinus/fraxinus excelsior 'crispa'/fraxinus excelsior 'crispa' (1).jpg",
          width: 1024,
          id: '09d86f605219e6cb083b5f63a2821734',
          height: 683,
          thumbnail: true,
        },
        location: [47.261227, -1.534158],
        genre: 'Fraxinus',
        cultivar: 'Crispa',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534158, 47.261227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ba3559b7ed1d5a84d4feba8c1b4ba66332b50639',
      fields: {
        espece: 'mucronata',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 99, 61, 1.00)',
            'rgba(96, 111, 89, 1.00)',
            'rgba(104, 99, 84, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/gaultheria/gaultheria mucronata/gaultheria mucronata.jpg',
          width: 1024,
          id: '1bb7289cc3f01bcc211d6ab20c532c24',
          height: 768,
          thumbnail: true,
        },
        location: [47.218513, -1.541362],
        genre: 'Gaultheria',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541362, 47.218513] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '137d9b74810f4a90c338fa8957713a12578048f5',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'caspica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 142, 67, 1.00)',
            'rgba(115, 153, 62, 1.00)',
            'rgba(92, 134, 41, 1.00)',
          ],
          filename:
            'ip parc de proce/gleditsia/gleditsia caspica/gleditsia caspica (2).jpg',
          width: 576,
          id: '13545265cd37585830822ed06aafdf43',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 151, 77, 1.00)',
            'rgba(110, 142, 48, 1.00)',
            'rgba(91, 131, 25, 1.00)',
          ],
          filename:
            'ip parc de proce/gleditsia/gleditsia caspica/gleditsia caspica (3).jpg',
          width: 576,
          id: 'e615ec09518369483980d44c479e120a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 139, 65, 1.00)',
            'rgba(116, 141, 60, 1.00)',
            'rgba(105, 127, 53, 1.00)',
          ],
          filename:
            'ip parc de proce/gleditsia/gleditsia caspica/gleditsia caspica (1).jpg',
          width: 576,
          id: '131cb45d1f0ce437fa9cfa26bd4183d5',
          height: 768,
          thumbnail: true,
        },
        location: [47.223938, -1.582842],
        genre: 'Gleditsia',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582842, 47.223938] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '946ce567770002008cd72a5c6fc61ee3cabfbba7',
      fields: {
        espece: 'dulcis',
        nom_du_site: 'Cimeti\u00e8re de la Bouteillerie',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(197, 202, 200, 1.00)',
            'rgba(121, 129, 108, 1.00)',
            'rgba(90, 87, 63, 1.00)',
          ],
          filename:
            'ip cimetiere de la bouteillerie/hovenia/hovenia dulcis/hovenia dulcis.jpg',
          width: 1024,
          id: '200c77e54fb3fdd9cb489c3f51bc1f6e',
          height: 768,
          thumbnail: true,
        },
        location: [47.221608, -1.542272],
        genre: 'Hovenia',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542272, 47.221608] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b9ddea96688f24096c1f9b62202c1793a33bb7a9',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'polycarpa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 113, 77, 1.00)',
            'rgba(136, 149, 134, 1.00)',
            'rgba(84, 108, 83, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/idesia/idesia polycarpa/idesia polycarpa (1).jpg',
          width: 576,
          id: 'ea653c7b88176eefcc77cca9fb3c5d81',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 161, 93, 1.00)',
            'rgba(91, 133, 47, 1.00)',
            'rgba(80, 121, 23, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/idesia/idesia polycarpa/idesia polycarpa (3).jpg',
          width: 576,
          id: '574157fd97e8d9ed0a09eb2b1d0bde48',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 148, 97, 1.00)',
            'rgba(82, 103, 49, 1.00)',
            'rgba(91, 111, 57, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/idesia/idesia polycarpa/idesia polycarpa  (2).jpg',
          width: 1024,
          id: '9e2a5d92b5220df66912469308e9ac75',
          height: 683,
          thumbnail: true,
        },
        location: [47.220522, -1.543175],
        genre: 'Idesia',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543175, 47.220522] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fba2ac5553a1dab9f7d74bdd57456594098dc208',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'floridanum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 146, 53, 1.00)',
            'rgba(113, 149, 68, 1.00)',
            'rgba(98, 130, 45, 1.00)',
          ],
          filename:
            'ip parc de proce/illicium/illicium floridanum/illicium floridanum (2).jpg',
          width: 576,
          id: '64a9359db27ce4c608a45b3aafd60a6b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 131, 82, 1.00)',
            'rgba(116, 136, 69, 1.00)',
            'rgba(100, 119, 57, 1.00)',
          ],
          filename:
            'ip parc de proce/illicium/illicium floridanum/illicium floridanum (3).jpg',
          width: 1024,
          id: '3dcb62fca87cf395e0ebee37ba0bb3a8',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 159, 102, 1.00)',
            'rgba(112, 111, 53, 1.00)',
            'rgba(112, 139, 59, 1.00)',
          ],
          filename:
            'ip parc de proce/illicium/illicium floridanum/illicium floridanum (1).jpg',
          width: 576,
          id: '91581e13c32539ce5dd097ca1be5c8c8',
          height: 768,
          thumbnail: true,
        },
        location: [47.222947, -1.578863],
        genre: 'Illicium',
        famille: 'Schisandraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.578863, 47.222947] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '15067fe1f4add4f23d17407e4ff26c99421516cd',
      fields: {
        espece: 'formosana',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 150, 189, 1.00)',
            'rgba(95, 101, 81, 1.00)',
            'rgba(70, 67, 52, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/liquidambar/liquidambar formosana/liquidambar formosana.jpg',
          width: 512,
          id: 'cfe7959b8e3fa516145f013e1fc155cb',
          height: 768,
          thumbnail: true,
        },
        location: [47.218938, -1.541222],
        genre: 'Liquidambar',
        famille: 'Altingiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541222, 47.218938] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '38edf82cd3f9e74985e8c2e4b324ab7795397c44',
      fields: {
        espece: 'styraciflua',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 103, 72, 1.00)',
            'rgba(136, 128, 70, 1.00)',
            'rgba(129, 132, 115, 1.00)',
          ],
          filename:
            "ip parc de proce/liquidambar/liquidambar styraciflua 'variegata'/liquidambar styraciflua 'variegata' (4).jpg",
          width: 653,
          id: 'ac5556352ef264fed4ab65697354ba42',
          height: 768,
          thumbnail: true,
        },
        location: [47.223047, -1.58288],
        genre: 'Liquidambar',
        cultivar: 'Variegata',
        famille: 'Altingiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58288, 47.223047] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '975f1ac168b34c52f808aa9243837a3d603b819a',
      fields: {
        espece: 'tulipifera',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 128, 140, 1.00)',
            'rgba(91, 91, 56, 1.00)',
            'rgba(67, 62, 33, 1.00)',
          ],
          filename:
            'ip parc de proce/liriodendron/liriodendron tulipifera/liriodendron tulipifera.jpg',
          width: 588,
          id: '1cd5eba357ebe1c2bebb4b3939547ed6',
          height: 768,
          thumbnail: true,
        },
        location: [47.22285, -1.58103],
        genre: 'Liriodendron',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58103, 47.22285] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '67b206bd8368b08ba41e112515266bc8e5d9c231',
      fields: {
        espece: 'involucrata var. ledebourii',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 150, 76, 1.00)',
            'rgba(123, 100, 76, 1.00)',
            'rgba(118, 131, 96, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/lonicera/lonicera involucrata var. ledebourii/lonicera involucrata var. ledebourii.jpg',
          width: 576,
          id: '1b767d881b1933e79b093c9cf56cc3f5',
          height: 768,
          thumbnail: true,
        },
        location: [47.263375, -1.531613],
        genre: 'Lonicera',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531613, 47.263375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4fb63412f6152c87c42fa117cb1a25ad3f38c15b',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 101, 87, 1.00)',
            'rgba(123, 99, 69, 1.00)',
            'rgba(130, 110, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/loropetalum hamamelidaceae/loropetalum chinense 'red form'/loropetalum chinense 'red form'.jpg",
          width: 576,
          id: 'e75e0e207fea9d4c264330632c0d677e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 147, 89, 1.00)',
            'rgba(124, 123, 83, 1.00)',
            'rgba(125, 126, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/loropetalum hamamelidaceae/loropetalum chinense 'red form'/loropetalum chinense 'red form' (2).jpg",
          width: 1024,
          id: '0e76adaefc4f400e2ecef3e49b8f4a60',
          height: 768,
          thumbnail: true,
        },
        location: [47.270488, -1.58222],
        genre: 'Loropetalum',
        cultivar: 'Red Form',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58222, 47.270488] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '12121001d25f85953c8607f96f1f7c0a35e76a53',
      fields: {
        espece: 'delavayi',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(63, 88, 40, 1.00)',
            'rgba(107, 123, 75, 1.00)',
            'rgba(110, 132, 76, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia delavayi/magnolia delavayi.jpg',
          width: 576,
          id: '9a6abc09be3c444d22c3f0937c394343',
          height: 768,
          thumbnail: true,
        },
        location: [47.220963, -1.544033],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544033, 47.220963] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '75ed9ad7bd1f816b90e4212731db7a6d87773011',
      fields: {
        espece: 'stellata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 163, 185, 1.00)',
            'rgba(155, 150, 151, 1.00)',
            'rgba(72, 72, 54, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia stellata 'rosea'/magnolia stellata 'rosea' (2).jpg",
          width: 576,
          id: '9e0c9b4173041cbbb95eabbcfc28e45e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 147, 149, 1.00)',
            'rgba(109, 105, 83, 1.00)',
            'rgba(94, 90, 54, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia stellata 'rosea'/magnolia stellata 'rosea' (1).jpg",
          width: 667,
          id: '1c3a9e1fc5ae8b689cc873deab50b614',
          height: 768,
          thumbnail: true,
        },
        location: [47.222672, -1.578405],
        genre: 'Magnolia',
        cultivar: 'Rosea',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.578405, 47.222672] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7aa840e564049aea5d9a986a365e670071050ef0',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 128, 61, 1.00)',
            'rgba(97, 134, 46, 1.00)',
            'rgba(97, 126, 45, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/magnolia/magnolia 'butterflies'/magnolia 'butterflies' (2).jpg",
          width: 512,
          id: '0a9b2972497ef23cb19fbd570f9cca9a',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(48, 72, 20, 1.00)',
            'rgba(107, 126, 52, 1.00)',
            'rgba(67, 98, 29, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/magnolia/magnolia 'butterflies'/magnolia 'butterflies' (1).jpg",
          width: 1024,
          id: '5ed357f3a58c2080820078b230e17358',
          height: 683,
          thumbnail: true,
        },
        location: [47.227533, -1.508425],
        genre: 'Magnolia',
        cultivar: 'Butterflies',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508425, 47.227533] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6aff4d6d3d55a94d55bc6a7a62fd1d765b701a91',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'obovata x Magnolia tripetala',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(174, 188, 160, 1.00)',
            'rgba(110, 145, 60, 1.00)',
            'rgba(88, 116, 44, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/magnolia/magnolia obovata x magnolia tripetala/magnolia obovata x magnolia tripetala (2).jpg',
          width: 512,
          id: 'e54748567d4e765a32d34078934a6189',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(51, 67, 29, 1.00)',
            'rgba(112, 124, 88, 1.00)',
            'rgba(63, 80, 32, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/magnolia/magnolia obovata x magnolia tripetala/magnolia obovata x magnolia tripetala (3).jpg',
          width: 1024,
          id: 'b18fca5da5e04deda4bffbc55d89e3cd',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 142, 85, 1.00)',
            'rgba(115, 144, 76, 1.00)',
            'rgba(87, 130, 49, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/magnolia/magnolia obovata x magnolia tripetala/magnolia obovata x magnolia tripetala (1).jpg',
          width: 1024,
          id: '734070ec80f6dd3fbe2dc43dcdf387d7',
          height: 683,
          thumbnail: true,
        },
        location: [47.227533, -1.508425],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508425, 47.227533] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8cbeecbf454501518e7ecf550a24e2ec1fc6380b',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 96, 126, 1.00)',
            'rgba(110, 101, 132, 1.00)',
            'rgba(100, 95, 111, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'apollo'/magnolia 'apollo' (2).jpg",
          width: 1024,
          id: 'a1fd434f23d9632ce5b151e8fb820ee1',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 167, 224, 1.00)',
            'rgba(119, 109, 125, 1.00)',
            'rgba(55, 59, 22, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'apollo'/magnolia 'apollo' (1).jpg",
          width: 512,
          id: '8df8c3c9e3d52717582cf9754cf0aadd',
          height: 768,
          thumbnail: true,
        },
        location: [47.262733, -1.531463],
        genre: 'Magnolia',
        cultivar: 'Apollo',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531463, 47.262733] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'af45c55c5d9a01ff31538fd094f0b1d7541407a6',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(168, 148, 174, 1.00)',
            'rgba(91, 75, 49, 1.00)',
            'rgba(46, 52, 26, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'betty'/magnolia 'betty' (2).jpg",
          width: 643,
          id: 'f4dca9ba5cea9a3bb8adb97a0e87616b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 103, 141, 1.00)',
            'rgba(141, 77, 93, 1.00)',
            'rgba(95, 67, 61, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'betty'/magnolia 'betty' (1).jpg",
          width: 1024,
          id: '3c2aeca97ff9e65218d5c91bd0676272',
          height: 683,
          thumbnail: true,
        },
        location: [47.263008, -1.532403],
        genre: 'Magnolia',
        cultivar: 'Betty',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532403, 47.263008] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0463444001a19e4df8f138631f1b488e2d9483c6',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 105, 81, 1.00)',
            'rgba(106, 110, 87, 1.00)',
            'rgba(48, 52, 35, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'binette'/magnolia 'binette'.jpg",
          width: 1024,
          id: 'fc2dd796776c1f27e5246b92bd392cec',
          height: 683,
          thumbnail: true,
        },
        location: [47.261705, -1.531172],
        genre: 'Magnolia',
        cultivar: 'Binette',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531172, 47.261705] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a354278f8224a5a03f628dd2bc33fe9335767a22',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(53, 67, 31, 1.00)',
            'rgba(132, 142, 125, 1.00)',
            'rgba(98, 108, 84, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'eskimo'/magnolia 'eskimo' (2).jpg",
          width: 576,
          id: 'b83df51a3f52a74a1ce46fcb2c1c8d47',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 153, 77, 1.00)',
            'rgba(115, 134, 80, 1.00)',
            'rgba(99, 98, 65, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'eskimo'/magnolia 'eskimo' (1).jpg",
          width: 1024,
          id: '400f09497bf24f69f424f01743844c0e',
          height: 768,
          thumbnail: true,
        },
        location: [47.261342, -1.531917],
        genre: 'Magnolia',
        cultivar: 'Eskimo',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531917, 47.261342] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd49bb3930e2a495a33716984de88ee30c3a65205',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 131, 47, 1.00)',
            'rgba(128, 152, 68, 1.00)',
            'rgba(106, 127, 50, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'freeman'/magnolia 'freeman' (2).jpg",
          width: 576,
          id: 'fadc2d0eaf709d2117977400a6fc8f42',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 102, 38, 1.00)',
            'rgba(131, 138, 78, 1.00)',
            'rgba(155, 159, 95, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'freeman'/magnolia 'freeman' (3).jpg",
          width: 576,
          id: 'a4f0bb17644682539a2fba6929705d83',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(196, 194, 159, 1.00)',
            'rgba(164, 155, 98, 1.00)',
            'rgba(136, 128, 82, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'freeman'/magnolia 'freeman' (1).jpg",
          width: 576,
          id: '7ee36159dc737c98e15e4eb23aaf1050',
          height: 768,
          thumbnail: true,
        },
        location: [47.262033, -1.528692],
        genre: 'Magnolia',
        cultivar: 'Freeman',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.528692, 47.262033] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3b13670549ff89d9691ad88d46d66958e2861389',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 101, 113, 1.00)',
            'rgba(105, 91, 90, 1.00)',
            'rgba(121, 112, 102, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'heaven scent'/magnolia 'heaven scent' (3).jpg",
          width: 1024,
          id: '7939be1beaf6fa56d364e98c63541bf3',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 101, 130, 1.00)',
            'rgba(126, 109, 131, 1.00)',
            'rgba(104, 90, 90, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'heaven scent'/magnolia 'heaven scent' (1).jpg",
          width: 512,
          id: '1619144844b47adc1462d01a464120ba',
          height: 768,
          thumbnail: true,
        },
        location: [47.262987, -1.531245],
        genre: 'Magnolia',
        cultivar: 'Heaven Scent',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531245, 47.262987] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a11c676e48584c82252697a5f14fc8799a727ecb',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 160, 207, 1.00)',
            'rgba(144, 136, 136, 1.00)',
            'rgba(120, 119, 66, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'kim kunso'/magnolia 'kim kunso' (2).jpg",
          width: 576,
          id: '56247104982f95350754bff2cf23f2cb',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 107, 109, 1.00)',
            'rgba(159, 123, 133, 1.00)',
            'rgba(97, 78, 48, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'kim kunso'/magnolia 'kim kunso' (1).jpg",
          width: 576,
          id: 'd226a37375ab28500976afab511e8c23',
          height: 768,
          thumbnail: true,
        },
        location: [47.264075, -1.535503],
        genre: 'Magnolia',
        cultivar: 'Kim Kunso',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535503, 47.264075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '77f171b8ac4771fa84c7648989596c4b64f1c447',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 153, 180, 1.00)',
            'rgba(116, 117, 99, 1.00)',
            'rgba(87, 91, 84, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'moondance'/magnolia 'moondance' (2).jpg",
          width: 1024,
          id: '2f8e950abf179783864d7f338f574e5d',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 93, 75, 1.00)',
            'rgba(96, 96, 70, 1.00)',
            'rgba(97, 105, 58, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'moondance'/magnolia 'moondance' (1).jpg",
          width: 1024,
          id: '977c5200c7be650883433e3084e60d31',
          height: 683,
          thumbnail: true,
        },
        location: [47.261308, -1.531883],
        genre: 'Magnolia',
        cultivar: 'Moondance',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531883, 47.261308] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '554b763ca9bbaf413317e3356a24805f55dc1916',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 121, 86, 1.00)',
            'rgba(133, 121, 106, 1.00)',
            'rgba(87, 91, 41, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'purple globe'/magnolia 'purple globe'.jpg",
          width: 576,
          id: 'f43cf375d900718ca93cea81e57c0de5',
          height: 768,
          thumbnail: true,
        },
        location: [47.261008, -1.532667],
        genre: 'Magnolia',
        cultivar: 'Purple Globe',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532667, 47.261008] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8074b673b0e27e404c73c581ed73803e536c7b96',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 142, 169, 1.00)',
            'rgba(111, 108, 106, 1.00)',
            'rgba(45, 48, 28, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'royal flush'/magnolia 'royal flush' (2).jpg",
          width: 1024,
          id: '6b1e30daf29a50fdd1f66da05d6ed247',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 124, 135, 1.00)',
            'rgba(119, 118, 108, 1.00)',
            'rgba(60, 66, 26, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'royal flush'/magnolia 'royal flush' (1).jpg",
          width: 1024,
          id: 'a31987a5ab7c2d6a75d742fd32e6d015',
          height: 683,
          thumbnail: true,
        },
        location: [47.262713, -1.5315],
        genre: 'Magnolia',
        cultivar: 'Royal Flush',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5315, 47.262713] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'eb8e32efa294995915d045f47e5c82d8508c3331',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 147, 173, 1.00)',
            'rgba(109, 104, 96, 1.00)',
            'rgba(84, 83, 52, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'vulcan'/magnolia 'vulcan' (3).jpg",
          width: 1024,
          id: 'a5aa13796b96db05e286d87453ad0520',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 58, 47, 1.00)',
            'rgba(111, 71, 75, 1.00)',
            'rgba(131, 92, 91, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'vulcan'/magnolia 'vulcan' (4).jpg",
          width: 1024,
          id: 'cc04d0b5c02a7d44213747c0d2792237',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 103, 147, 1.00)',
            'rgba(119, 94, 136, 1.00)',
            'rgba(97, 97, 134, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'vulcan'/magnolia 'vulcan' (1).jpg",
          width: 512,
          id: '8525250048f0759caa089535971d6661',
          height: 768,
          thumbnail: true,
        },
        location: [47.262245, -1.529742],
        genre: 'Magnolia',
        cultivar: 'Vulcan',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529742, 47.262245] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7832153955d1d6a313c20874a8eec8778d32037c',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 76, 48, 1.00)',
            'rgba(106, 117, 73, 1.00)',
            'rgba(95, 124, 49, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'yellow fever'/magnolia 'yellow fever'.jpg",
          width: 576,
          id: '70f62de042ac98ba2e7c302bc1514e08',
          height: 768,
          thumbnail: true,
        },
        location: [47.261697, -1.530513],
        genre: 'Magnolia',
        cultivar: 'Yellow Fever',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530513, 47.261697] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ee32beab96e1f97e720804e77aa78dd3a45c0082',
      fields: {
        espece: 'grandiflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 152, 165, 1.00)',
            'rgba(126, 96, 70, 1.00)',
            'rgba(68, 63, 26, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia grandiflora 'little gem'/magnolia grandiflora 'little gem' (2).jpg",
          width: 1024,
          id: '6ae0acf7b5141c8210db59473bcc24c7',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 132, 89, 1.00)',
            'rgba(115, 128, 67, 1.00)',
            'rgba(79, 101, 49, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia grandiflora 'little gem'/magnolia grandiflora 'little gem' (1).jpg",
          width: 1024,
          id: 'cc3fbf55a834555e76cddcc4d9e97783',
          height: 683,
          thumbnail: true,
        },
        location: [47.262717, -1.529763],
        genre: 'Magnolia',
        cultivar: 'Little Gem',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529763, 47.262717] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'aae1f3a29ce22ec9574e234508912484218b4efb',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 113, 68, 1.00)',
            'rgba(129, 121, 47, 1.00)',
            'rgba(83, 86, 28, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia grandiflora 'salicifolia'/magnolia grandiflora 'salicifolia' (2).jpg",
          width: 576,
          id: '79c530ab68fc8943c4b20cad37ffdf7b',
          height: 768,
          thumbnail: true,
        },
        espece: 'grandiflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 90, 38, 1.00)',
            'rgba(104, 118, 67, 1.00)',
            'rgba(64, 86, 22, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia grandiflora 'salicifolia'/magnolia grandiflora 'salicifolia'  (3).jpg",
          width: 576,
          id: '42086f7173ce1ca7a0304c525292c773',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(47, 55, 22, 1.00)',
            'rgba(130, 137, 121, 1.00)',
            'rgba(96, 98, 74, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia grandiflora 'salicifolia'/magnolia grandiflora 'salicifolia'  (2).jpg",
          width: 576,
          id: 'afeb07c9608ae8c10d8bf73db4351048',
          height: 768,
          thumbnail: true,
        },
        location: [47.262203, -1.529253],
        genre: 'Magnolia',
        cultivar: 'Salicifolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529253, 47.262203] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f5775a993fe8bf3b3355076b0068c0676f3db8bb',
      fields: {
        espece: 'salicifolia',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 132, 186, 1.00)',
            'rgba(111, 129, 151, 1.00)',
            'rgba(75, 84, 45, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia salicifolia 'kewensis'/magnolia salicifolia 'kewensis' (3).jpg",
          width: 1024,
          id: '8c43e6d32706e7862b26fe3230eb1b17',
          height: 683,
          thumbnail: true,
        },
        location: [47.262092, -1.52935],
        genre: 'Magnolia',
        cultivar: 'Kewensis',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.52935, 47.262092] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd4afba0718d0b271d83a7623ea38332d18be0848',
      fields: {
        espece: 'stellata',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 164, 163, 1.00)',
            'rgba(127, 117, 103, 1.00)',
            'rgba(67, 52, 26, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'centennial'/magnolia stellata 'centennial' (2).jpg",
          width: 576,
          id: 'a2ec29246d19b8af628f85ca761667ff',
          height: 768,
          thumbnail: true,
        },
        location: [47.262683, -1.532183],
        genre: 'Magnolia',
        cultivar: 'Centennial',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532183, 47.262683] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f28af11717d234931854a4d5a70fb5ca51b7d289',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'tripetala',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 160, 51, 1.00)',
            'rgba(97, 158, 40, 1.00)',
            'rgba(86, 141, 39, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia tripetala/magnolia tripetala (2).jpg',
          width: 576,
          id: '02cba398d9805c5a3bd1958e0d0baa4e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(53, 76, 15, 1.00)',
            'rgba(103, 117, 67, 1.00)',
            'rgba(116, 132, 64, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia tripetala/magnolia tripetala (4).jpg',
          width: 576,
          id: '3156cb6c32fe158d02cac32187ebabdb',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 132, 78, 1.00)',
            'rgba(91, 103, 65, 1.00)',
            'rgba(78, 91, 41, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia tripetala/magnolia tripetala (1).jpg',
          width: 576,
          id: 'f9543864e77f02e956b25b52677c250d',
          height: 768,
          thumbnail: true,
        },
        location: [47.262505, -1.528513],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.528513, 47.262505] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7ddcd88c15cbd25529c5de8b2d29f2caa5e69fa5',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'tripetala',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 94, 34, 1.00)',
            'rgba(111, 143, 50, 1.00)',
            'rgba(108, 135, 46, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia tripetala/magnolia tripetala (5).jpg',
          width: 1024,
          id: 'cd29fbcf6cb6e00dc5b9df29c55bd53a',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 123, 72, 1.00)',
            'rgba(111, 131, 74, 1.00)',
            'rgba(81, 106, 42, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia tripetala/magnolia tripetala (6).jpg',
          width: 512,
          id: 'd0847d65210c302814389f328c9c4004',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 115, 92, 1.00)',
            'rgba(90, 113, 46, 1.00)',
            'rgba(110, 136, 60, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia tripetala/magnolia tripetala (3).jpg',
          width: 1024,
          id: '74967fb50299ad7af6579a26457d67c6',
          height: 683,
          thumbnail: true,
        },
        location: [47.261875, -1.529513],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529513, 47.261875] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd5c497047c38cab1a62bf4892a8b7215db2e6dcc',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 148, 96, 1.00)',
            'rgba(94, 130, 67, 1.00)',
            'rgba(100, 137, 67, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia virginiana 'white side largest'/magnolia virginiana 'white side largest' (6).jpg",
          width: 1024,
          id: 'abcc474efa3daf2280400dec2f8c547f',
          height: 683,
          thumbnail: true,
        },
        espece: 'virginiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 101, 65, 1.00)',
            'rgba(99, 114, 72, 1.00)',
            'rgba(61, 77, 34, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia virginiana 'white side largest'/magnolia virginiana 'white side largest' (5).jpg",
          width: 1024,
          id: 'f6bdb3bb7b8d55ca89f14cac41b61234',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 135, 100, 1.00)',
            'rgba(99, 121, 78, 1.00)',
            'rgba(94, 113, 66, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia virginiana 'white side largest'/magnolia virginiana 'white side largest' (4).jpg",
          width: 1024,
          id: '1c4e5e23ea65ce21886399c33355d58b',
          height: 683,
          thumbnail: true,
        },
        location: [47.262431, -1.533923],
        genre: 'Magnolia',
        cultivar: 'White Side Largest',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533923, 47.262431] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fbfeb90bc298aef8888d607ad0fae267b977ac85',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 147, 144, 1.00)',
            'rgba(139, 136, 127, 1.00)',
            'rgba(78, 76, 59, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'neil mceacharn'/magnolia x loebneri 'neil mceacharn' (3).jpg",
          width: 576,
          id: '131c0fc2e047592ca1d095dc4c84cf2a',
          height: 768,
          thumbnail: true,
        },
        espece: 'x loebneri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 144, 127, 1.00)',
            'rgba(142, 131, 106, 1.00)',
            'rgba(88, 77, 49, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'neil mceacharn'/magnolia x loebneri 'neil mceacharn' (2).jpg",
          width: 576,
          id: 'f5447a8b8356e90dfcc8c8694b6c7db4',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(219, 217, 220, 1.00)',
            'rgba(112, 110, 103, 1.00)',
            'rgba(78, 79, 51, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'neil mceacharn'/magnolia x loebneri 'neil mceacharn' (1).jpg",
          width: 1024,
          id: '737a3127687b7fa7c1cf5bd323949c2e',
          height: 768,
          thumbnail: true,
        },
        location: [47.261833, -1.528733],
        genre: 'Magnolia',
        cultivar: 'Neil McEacharn',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.528733, 47.261833] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '50108bf406b0584c67c28e220fc2c952d46db6a4',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(55, 60, 42, 1.00)',
            'rgba(109, 111, 98, 1.00)',
            'rgba(88, 89, 74, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'spring joy'/magnolia x loebneri 'spring joy' (4).jpg",
          width: 1024,
          id: '04d751aad9dbf7b783489e1e84b92daa',
          height: 683,
          thumbnail: true,
        },
        espece: 'x loebneri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(52, 53, 37, 1.00)',
            'rgba(100, 101, 90, 1.00)',
            'rgba(76, 75, 65, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'spring joy'/magnolia x loebneri 'spring joy' (2).jpg",
          width: 1024,
          id: '30257ba9727238e67587668d5d95fad7',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 108, 94, 1.00)',
            'rgba(85, 92, 54, 1.00)',
            'rgba(64, 67, 42, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'spring joy'/magnolia x loebneri 'spring joy' (1).jpg",
          width: 1024,
          id: '4c9fc9a171b789e71711b3f8ca83ae68',
          height: 683,
          thumbnail: true,
        },
        location: [47.262687, -1.529245],
        genre: 'Magnolia',
        cultivar: 'Spring Joy',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529245, 47.262687] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e6f5984bafb70c3db7ee66dbbd7e3f92a95d14e1',
      fields: {
        espece: 'x soulangeana',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 173, 175, 1.00)',
            'rgba(115, 114, 103, 1.00)',
            'rgba(100, 100, 61, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'pickard's opal'/magnolia x soulangeana 'pickard's opal' (1).jpg",
          width: 576,
          id: 'c295ac7c6a517e9963665b84d87cab4f',
          height: 768,
          thumbnail: true,
        },
        location: [47.26188, -1.534688],
        genre: 'Magnolia',
        cultivar: "Pickard's Opal",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534688, 47.26188] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f7345a7f1b0c4e7192f6024cffebbf3682f459b2',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 126, 160, 1.00)',
            'rgba(130, 108, 121, 1.00)',
            'rgba(107, 95, 100, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'picture superba'/magnolia x soulangeana 'picture superba' (3).jpg",
          width: 512,
          id: 'c27c2bcf7c4a631debda62bd99438e2b',
          height: 768,
          thumbnail: true,
        },
        espece: 'x soulangeana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 102, 99, 1.00)',
            'rgba(117, 111, 101, 1.00)',
            'rgba(84, 83, 65, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'picture superba'/magnolia x soulangeana 'picture superba' (2).jpg",
          width: 1024,
          id: 'a3fedf8155500f2453ea7998eeb13284',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 138, 181, 1.00)',
            'rgba(121, 108, 106, 1.00)',
            'rgba(56, 55, 34, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'picture superba'/magnolia x soulangeana 'picture superba' (1).jpg",
          width: 1024,
          id: '2a08dc45a467dde2e4b14072dc3b208c',
          height: 683,
          thumbnail: true,
        },
        location: [47.262072, -1.53168],
        genre: 'Magnolia',
        cultivar: 'Picture Superba',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53168, 47.262072] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3b0cab5c7237754e6c242b24c498ee0f00fa58d8',
      fields: {
        espece: 'x soulangeana',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(182, 204, 230, 1.00)',
            'rgba(124, 114, 112, 1.00)',
            'rgba(79, 83, 44, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'picture'/magnolia x soulangeana 'picture' (1).jpg",
          width: 576,
          id: '905b98a8fd6ffe3ae80653a5daee5015',
          height: 768,
          thumbnail: true,
        },
        location: [47.262242, -1.528705],
        genre: 'Magnolia',
        cultivar: 'Picture',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.528705, 47.262242] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6d6b83b19626798b5b053cbc9a3bb1b7a6144d49',
      fields: {
        espece: 'x veitchii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 137, 183, 1.00)',
            'rgba(118, 127, 139, 1.00)',
            'rgba(68, 68, 41, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x veitchii 'peter veitch'/magnolia x veitchii 'peter veitch' (2).jpg",
          width: 1024,
          id: 'bfe0f03239a77c969d8e49d448059d1f',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 92, 129, 1.00)',
            'rgba(91, 112, 142, 1.00)',
            'rgba(84, 103, 127, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x veitchii 'peter veitch'/magnolia x veitchii 'peter veitch' (1).jpg",
          width: 512,
          id: '224708e46c8e4d4296d6894080eeacdc',
          height: 768,
          thumbnail: true,
        },
        location: [47.26102, -1.534217],
        genre: 'Magnolia',
        cultivar: 'Peter Veitch',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534217, 47.26102] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '30253372f4c02819dd9d8c0d02b0c96e9f3d86e7',
      fields: {
        espece: 'germanica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 171, 146, 1.00)',
            'rgba(85, 110, 61, 1.00)',
            'rgba(79, 98, 53, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/mespilus/mespilus germanica/mespilus germanica (2).jpg',
          width: 1024,
          id: '5fbff6e78becf65742d24ea04a4fa792',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(189, 196, 175, 1.00)',
            'rgba(79, 100, 46, 1.00)',
            'rgba(89, 108, 52, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/mespilus/mespilus germanica/mespilus germanica (1).jpg',
          width: 1024,
          id: '70da9b3a6ee20a6e88c600cf3bad7428',
          height: 768,
          thumbnail: true,
        },
        location: [47.228038, -1.508883],
        genre: 'Mespilus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508883, 47.228038] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4628bd9ef3253be42979ccf1383389c51761e71c',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'sericea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 123, 100, 1.00)',
            'rgba(112, 129, 102, 1.00)',
            'rgba(92, 117, 84, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/neolitsea/neolitsea sericea/neolitsea sericea  (9).jpg',
          width: 512,
          id: 'b39347698d92b2388042993203befd58',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 150, 96, 1.00)',
            'rgba(128, 146, 96, 1.00)',
            'rgba(115, 139, 83, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/neolitsea/neolitsea sericea/neolitsea sericea (3).jpg',
          width: 576,
          id: '0ab9d8619eb7e9b9201a2a0d47109dad',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 128, 86, 1.00)',
            'rgba(115, 108, 66, 1.00)',
            'rgba(88, 103, 48, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/neolitsea/neolitsea sericea/neolitsea sericea  (8).jpg',
          width: 1024,
          id: 'd63851ae3998eba3d6029be2122dc0d7',
          height: 683,
          thumbnail: true,
        },
        location: [47.219055, -1.541808],
        genre: 'Neolitsea',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541808, 47.219055] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '46c8d6dd697334dcaae0fba0d24ca0ad8eb4ac0c',
      fields: {
        espece: 'dombeyi',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 142, 113, 1.00)',
            'rgba(140, 134, 100, 1.00)',
            'rgba(169, 150, 126, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/nothofagus/nothofagus dombeyi/nothofagus dombeyi.jpg',
          width: 576,
          id: '7ac88130f4d3c7f4a4be9c1b870d5ee4',
          height: 768,
          thumbnail: true,
        },
        location: [47.218533, -1.542088],
        genre: 'Nothofagus',
        famille: 'Nothofagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542088, 47.218533] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c9f0473fffdf7c0ddf5e9a19aa36f712e10628e8',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'sylvatica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 137, 169, 1.00)',
            'rgba(153, 126, 131, 1.00)',
            'rgba(138, 110, 114, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/nyssa/nyssa sylvatica/nyssa sylvatica (10).jpg',
          width: 654,
          id: 'b54314f45c7f1b3b3e73fa840ef3bed1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(189, 198, 194, 1.00)',
            'rgba(125, 110, 65, 1.00)',
            'rgba(87, 81, 28, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/nyssa/nyssa sylvatica/nyssa sylvatica (11).jpg',
          width: 576,
          id: '0bd01e49f964fd00c347f89a36cec8cb',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 130, 79, 1.00)',
            'rgba(146, 121, 89, 1.00)',
            'rgba(132, 119, 85, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/nyssa/nyssa sylvatica/nyssa sylvatica (1).jpg',
          width: 576,
          id: 'c71003a714e52564adb1dcfa69282aa6',
          height: 768,
          thumbnail: true,
        },
        location: [47.219308, -1.541512],
        genre: 'Nyssa',
        famille: 'Nyssaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541512, 47.219308] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '30cb09f9844cbad2630dbfea62f20b45768d9132',
      fields: {
        espece: 'sylvatica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 167, 139, 1.00)',
            'rgba(117, 118, 74, 1.00)',
            'rgba(67, 71, 36, 1.00)',
          ],
          filename:
            'ip parc de proce/nyssa/nyssa sylvatica/nyssa sylvatica (3).jpg',
          width: 680,
          id: '7624cd8ea3a4a84348ad03943a2cfb6d',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 120, 86, 1.00)',
            'rgba(118, 110, 58, 1.00)',
            'rgba(79, 82, 30, 1.00)',
          ],
          filename:
            'ip parc de proce/nyssa/nyssa sylvatica/nyssa sylvatica (1).jpg',
          width: 650,
          id: '9fc14480c1664b52ecfa795310c47921',
          height: 768,
          thumbnail: true,
        },
        location: [47.222838, -1.578995],
        genre: 'Nyssa',
        famille: 'Nyssaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.578995, 47.222838] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4f3e2c031282a246a6cbb6ccce0f1cf4ef6cab44',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'sylvatica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(173, 190, 189, 1.00)',
            'rgba(90, 108, 64, 1.00)',
            'rgba(54, 68, 26, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/nyssa/nyssa sylvatica/nyssa sylvatica (3).jpg',
          width: 1024,
          id: '9912a30e463b3016b8a4907b6960301a',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 129, 47, 1.00)',
            'rgba(104, 126, 38, 1.00)',
            'rgba(121, 127, 70, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/nyssa/nyssa sylvatica/nyssa sylvatica (4).jpg',
          width: 1024,
          id: '38993be1893773e89552410dd2628559',
          height: 724,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 152, 52, 1.00)',
            'rgba(108, 141, 34, 1.00)',
            'rgba(69, 97, 24, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/nyssa/nyssa sylvatica/nyssa sylvatica (2).jpg',
          width: 576,
          id: '7063aa77bb2d06b49a368db2aa65526c',
          height: 768,
          thumbnail: true,
        },
        location: [47.262053, -1.531283],
        genre: 'Nyssa',
        famille: 'Nyssaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531283, 47.262053] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd70f98d901a746483765a5f8d6eb62eda8f1a01a',
      fields: {
        espece: 'decorus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 102, 81, 1.00)',
            'rgba(107, 120, 93, 1.00)',
            'rgba(68, 81, 62, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/osmanthus/osmanthus decorus/osmanthus decorus (2).jpg',
          width: 576,
          id: '8090e53848f4666960a9931eb0b5683e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 161, 141, 1.00)',
            'rgba(114, 135, 119, 1.00)',
            'rgba(116, 138, 111, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/osmanthus/osmanthus decorus/osmanthus decorus (1).jpg',
          width: 576,
          id: 'd17c242e96dab2bdd2b280fe91988107',
          height: 768,
          thumbnail: true,
        },
        location: [47.21955, -1.543178],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543178, 47.21955] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8fbc961eb28276e035c753c25f080ac7602b2101',
      fields: {
        espece: 'tomentosa',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 178, 133, 1.00)',
            'rgba(90, 106, 60, 1.00)',
            'rgba(72, 91, 40, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/paulownia/paulownia tomentosa/paulownia tomentosa.jpg',
          width: 657,
          id: '2b92aee1801d217fb62142b2794edd5f',
          height: 768,
          thumbnail: true,
        },
        location: [47.261678, -1.529883],
        genre: 'Paulownia',
        famille: 'Paulowniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529883, 47.261678] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '44118f63aee2bb503476c3c975ead15cd134523c',
      fields: {
        espece: 'satsumi',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 106, 46, 1.00)',
            'rgba(114, 138, 69, 1.00)',
            'rgba(109, 124, 68, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/philadelphus/philadelphus satsumi/philadelphus satsumi (5).jpg',
          width: 576,
          id: '2de21cae0e3c86c12eb34606bee6616e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 88, 38, 1.00)',
            'rgba(114, 137, 84, 1.00)',
            'rgba(82, 105, 38, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/philadelphus/philadelphus satsumi/philadelphus satsumi (2).jpg',
          width: 576,
          id: 'c8ec0de5bb23bceba9765bda2be72532',
          height: 768,
          thumbnail: true,
        },
        location: [47.220662, -1.543342],
        genre: 'Philadelphus',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543342, 47.220662] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'da03ca44c1c2fda5344913ba98ee8917bdb77f79',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'quassioides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(199, 217, 198, 1.00)',
            'rgba(81, 105, 56, 1.00)',
            'rgba(65, 104, 38, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/picrasma/picrasma quassioides/picrasma quassioides (10).jpg',
          width: 512,
          id: 'e4b4b34467a9ad4cbcf8279c4d3600fd',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 154, 123, 1.00)',
            'rgba(112, 107, 61, 1.00)',
            'rgba(103, 105, 50, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/picrasma/picrasma quassioides/picrasma quassioides (11).jpg',
          width: 1024,
          id: '5cfd51e175595281b50f35139a55e0aa',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 151, 169, 1.00)',
            'rgba(131, 119, 113, 1.00)',
            'rgba(99, 90, 82, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/picrasma/picrasma quassioides/picrasma quassioides  (2).jpg',
          width: 576,
          id: '7717ddffa415eefd27a6713fc8b35e02',
          height: 768,
          thumbnail: true,
        },
        location: [47.230222, -1.507963],
        genre: 'Picrasma',
        famille: 'Simaroubaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507963, 47.230222] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '26e794453f96ec323b3039e891660415ded3e556',
      fields: {
        espece: 'orientalis',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 177, 164, 1.00)',
            'rgba(82, 91, 72, 1.00)',
            'rgba(84, 83, 80, 1.00)',
          ],
          filename:
            'ip ville de nantes/platanus/platanus orientalis/platanus orientalis.jpg',
          width: 512,
          id: 'f65b4a7e5b9098754527756dbba62e4f',
          height: 768,
          thumbnail: true,
        },
        location: [47.215158, -1.556805],
        genre: 'Platanus',
        famille: 'Platanaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.556805, 47.215158] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0e554f95a807f25a0052f50fbe0cb24ce81559d7',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 81, 58, 1.00)',
            'rgba(102, 91, 74, 1.00)',
            'rgba(122, 106, 91, 1.00)',
          ],
          filename:
            "ip parc de proce/prunus/prunus mume 'omoi-no-mama'/prunus mume 'omoi-no-mama' (3).jpg",
          width: 576,
          id: '6348823b2dca59fb64f424151f94347a',
          height: 768,
          thumbnail: true,
        },
        espece: 'mume',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 72, 44, 1.00)',
            'rgba(119, 106, 87, 1.00)',
            'rgba(80, 64, 47, 1.00)',
          ],
          filename:
            "ip parc de proce/prunus/prunus mume 'omoi-no-mama'/prunus mume 'omoi-no-mama' (2).jpg",
          width: 576,
          id: '3aaa4e182b1cf76f3981db5580aff615',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 151, 117, 1.00)',
            'rgba(128, 116, 78, 1.00)',
            'rgba(120, 96, 67, 1.00)',
          ],
          filename:
            "ip parc de proce/prunus/prunus mume 'omoi-no-mama'/prunus mume 'omoi-no-mama' (1).jpg",
          width: 576,
          id: '0eb2aa573842e6acc70587434153ebb2',
          height: 768,
          thumbnail: true,
        },
        location: [47.222808, -1.579487],
        genre: 'Prunus',
        cultivar: 'Omoi-no-mama',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.579487, 47.222808] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2bfea44ee3a916cbe86667be5000b17b78ab4da5',
      fields: {
        espece: 'sinensis',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 152, 133, 1.00)',
            'rgba(152, 113, 98, 1.00)',
            'rgba(77, 76, 30, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/pseudocydonia/pseudocydonia sinensis/pseudocydonia sinensis (1).jpg',
          width: 576,
          id: 'a87cc7167b026b4e942fa6cbbc28fcc2',
          height: 768,
          thumbnail: true,
        },
        location: [47.219683, -1.541463],
        genre: 'Pseudocydonia',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541463, 47.219683] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2163318dcd93c43da2888ce5fb5bf585b0d33e8e',
      fields: {
        espece: 'glandulosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 141, 53, 1.00)',
            'rgba(132, 159, 52, 1.00)',
            'rgba(116, 146, 37, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/psoralea/psoralea glandulosa/psoralea glandulosa (2).jpg',
          width: 576,
          id: 'efd2467275ce82c8a2a71c93f81b1ffc',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 124, 45, 1.00)',
            'rgba(127, 146, 62, 1.00)',
            'rgba(116, 135, 56, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/psoralea/psoralea glandulosa/psoralea glandulosa (1).jpg',
          width: 576,
          id: '35bebed57e3177ce4bfbb9224247c140',
          height: 768,
          thumbnail: true,
        },
        location: [47.228037, -1.508212],
        genre: 'Psoralea',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508212, 47.228037] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'efa4cd1640ac248a3d64867756915864103dc7cf',
      fields: {
        espece: 'palustris',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 111, 132, 1.00)',
            'rgba(116, 99, 78, 1.00)',
            'rgba(69, 61, 28, 1.00)',
          ],
          filename:
            'ip parc de proce/quercus/quercus palustris/quercus palustris .jpg',
          width: 512,
          id: '2a5e972b94a16b430ff52c516859ad46',
          height: 768,
          thumbnail: true,
        },
        location: [47.223138, -1.583812],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583812, 47.223138] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0a279058265e144d0eb0d5461def5474aaf4eca6',
      fields: {
        espece: 'robur',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 117, 75, 1.00)',
            'rgba(91, 106, 76, 1.00)',
            'rgba(77, 83, 59, 1.00)',
          ],
          filename: 'ip parc de proce/quercus/quercus robur/quercus robur.jpg',
          width: 576,
          id: '9db04cfa9d93c87ea957fe30262d5205',
          height: 768,
          thumbnail: true,
        },
        location: [47.222808, -1.579747],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.579747, 47.222808] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5523e99fae8a7a07da0c5c1a61453914874e6802',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'frainetto',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(193, 191, 167, 1.00)',
            'rgba(125, 111, 61, 1.00)',
            'rgba(68, 66, 31, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/quercus/quercus frainetto/quercus frainetto (2).jpg',
          width: 1024,
          id: '761e96ed40b8fa2ffcc5fdf95c606561',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(193, 201, 186, 1.00)',
            'rgba(88, 107, 73, 1.00)',
            'rgba(72, 89, 45, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/quercus/quercus frainetto/quercus frainetto.jpg',
          width: 1024,
          id: 'e91f3e8561a9a72a3ffb03cab2df2565',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 104, 34, 1.00)',
            'rgba(159, 132, 68, 1.00)',
            'rgba(123, 108, 61, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/quercus/quercus frainetto/quercus frainetto (1).jpg',
          width: 576,
          id: 'c89cad43cef821dd427d87ef4280ceb4',
          height: 768,
          thumbnail: true,
        },
        location: [47.229142, -1.50768],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.50768, 47.229142] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ea5b797b1236885ad666661171f1312f1a55c0a3',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'phellos',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 153, 142, 1.00)',
            'rgba(127, 116, 55, 1.00)',
            'rgba(111, 104, 56, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/quercus/quercus phellos/quercus phellos (2).jpg',
          width: 1024,
          id: 'b1e8de7a7ed09b507945f38d7474d160',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 147, 52, 1.00)',
            'rgba(146, 131, 35, 1.00)',
            'rgba(72, 64, 12, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/quercus/quercus phellos/quercus phellos (3).jpg',
          width: 576,
          id: 'be90ff37a0a74b0dc8d9a431da360e8d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 118, 46, 1.00)',
            'rgba(123, 133, 50, 1.00)',
            'rgba(125, 124, 52, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/quercus/quercus phellos/quercus phellos (1).jpg',
          width: 576,
          id: 'c70262b205dd72fe547db1a39a0e1335',
          height: 768,
          thumbnail: true,
        },
        location: [47.227462, -1.511962],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.511962, 47.227462] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '74dbbe912221ff2979d171e4e3977b324fa7b567',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(177, 194, 162, 1.00)',
            'rgba(145, 151, 98, 1.00)',
            'rgba(76, 77, 45, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/quercus/quercus rubra 'aurea'/quercus rubra 'aurea' (3).jpg",
          width: 1024,
          id: '4e012e417ce25ed64c305e48e1b26d04',
          height: 768,
          thumbnail: true,
        },
        espece: 'rubra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 61, 27, 1.00)',
            'rgba(126, 127, 35, 1.00)',
            'rgba(112, 122, 43, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/quercus/quercus rubra 'aurea'/quercus rubra 'aurea' (2).jpg",
          width: 576,
          id: '1d0c1c39f6faaf1a0cbcb821b3dedcdc',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 173, 162, 1.00)',
            'rgba(145, 144, 86, 1.00)',
            'rgba(88, 91, 61, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/quercus/quercus rubra 'aurea'/quercus rubra 'aurea' (1).jpg",
          width: 576,
          id: 'cbf2b632ec1d51e977f22378c165d389',
          height: 768,
          thumbnail: true,
        },
        location: [47.228738, -1.511838],
        genre: 'Quercus',
        cultivar: 'Aurea',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.511838, 47.228738] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '62f2e3cfac4139afd9fd82666b20535818375bc2',
      fields: {
        espece: 'imbricaria',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 182, 165, 1.00)',
            'rgba(108, 131, 47, 1.00)',
            'rgba(87, 104, 47, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus imbricaria/quercus imbricaria (2).jpg',
          width: 576,
          id: '59f1160077051a205218c8f6258c8b98',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 138, 45, 1.00)',
            'rgba(127, 158, 66, 1.00)',
            'rgba(105, 137, 41, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus imbricaria/quercus imbricaria (1).jpg',
          width: 576,
          id: '53745e97442280ad0a4b91bf68c927a3',
          height: 768,
          thumbnail: true,
        },
        location: [47.262178, -1.535572],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535572, 47.262178] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7691b15aa993a8fccd6363d3edc6871b8d396b21',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'suber',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 158, 155, 1.00)',
            'rgba(91, 93, 78, 1.00)',
            'rgba(82, 76, 42, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus suber/quercus suber (3).jpg',
          width: 1024,
          id: '92b4b8264e28b28922b1dce5affac1c3',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 130, 119, 1.00)',
            'rgba(123, 113, 93, 1.00)',
            'rgba(91, 88, 71, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus suber/quercus suber (4).jpg',
          width: 1024,
          id: '9cbbdeceb03ed40a50eb60687708827b',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(64, 66, 62, 1.00)',
            'rgba(114, 109, 95, 1.00)',
            'rgba(99, 95, 50, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus suber/quercus suber (2).jpg',
          width: 512,
          id: 'd21d602dcbb1ed9a08e7e31d4b15e5f6',
          height: 768,
          thumbnail: true,
        },
        location: [47.262537, -1.528862],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.528862, 47.262537] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '311fdad22e48248f74dc0ae4d995ba9bbe6d09a5',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 99, 68, 1.00)',
            'rgba(121, 111, 66, 1.00)',
            'rgba(115, 113, 82, 1.00)',
          ],
          filename:
            "ip ville de nantes/rhamnus/rhamnus alaternus 'argenteovariegata'/rhamnus alaternus 'argenteovariegata' (3).jpg",
          width: 576,
          id: '64b70ed57c5626416d893cd04a26c3ed',
          height: 768,
          thumbnail: true,
        },
        espece: 'alaternus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 83, 69, 1.00)',
            'rgba(130, 132, 110, 1.00)',
            'rgba(105, 105, 94, 1.00)',
          ],
          filename:
            "ip ville de nantes/rhamnus/rhamnus alaternus 'argenteovariegata'/rhamnus alaternus 'argenteovariegata' (2).jpg",
          width: 576,
          id: '8d8cc79c79a156e8e4213e9381fdc277',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 79, 47, 1.00)',
            'rgba(118, 119, 88, 1.00)',
            'rgba(107, 109, 80, 1.00)',
          ],
          filename:
            "ip ville de nantes/rhamnus/rhamnus alaternus 'argenteovariegata'/rhamnus alaternus 'argenteovariegata' (1).jpg",
          width: 576,
          id: '56e14b410521136c6e58b3c3d8c15fb6',
          height: 768,
          thumbnail: true,
        },
        location: [47.21723, -1.559358],
        genre: 'Rhamnus',
        cultivar: 'Argenteovariegata',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.559358, 47.21723] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '660b6aa97f7a650aff7094fc910f528ed472da2e',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 98, 84, 1.00)',
            'rgba(101, 100, 89, 1.00)',
            'rgba(156, 111, 133, 1.00)',
          ],
          filename:
            "ip parc de proce/rhododendron/rhododendron 'hydon dawn'/rhododendron 'hydon dawn' (2).jpg",
          width: 576,
          id: '037cb5620019b2e52b422d0ebc74fbea',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 106, 89, 1.00)',
            'rgba(130, 103, 112, 1.00)',
            'rgba(67, 64, 45, 1.00)',
          ],
          filename:
            "ip parc de proce/rhododendron/rhododendron 'hydon dawn'/rhododendron 'hydon dawn' (3).jpg",
          width: 1024,
          id: 'f68d15fbc72c738b205904787e437f50',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 115, 136, 1.00)',
            'rgba(168, 108, 134, 1.00)',
            'rgba(142, 68, 96, 1.00)',
          ],
          filename:
            "ip parc de proce/rhododendron/rhododendron 'hydon dawn'/rhododendron 'hydon dawn' (1).jpg",
          width: 576,
          id: 'fc1f0c71904b547bd50d299af65b4ac1',
          height: 768,
          thumbnail: true,
        },
        location: [47.225958, -1.58218],
        genre: 'Rhododendron',
        cultivar: 'Hydon Dawn',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58218, 47.225958] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '26571b579ace6f3460d87435c11f0086111eaacf',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 137, 126, 1.00)',
            'rgba(126, 137, 130, 1.00)',
            'rgba(118, 122, 119, 1.00)',
          ],
          filename:
            "ip parc de proce/rhododendron/rhododendron stenopetalum 'linearifolium'/rhododendron stenopetalum 'linearifolium' (3).jpg",
          width: 576,
          id: '0ffb7386cb3e71778cc95e1665911a4e',
          height: 768,
          thumbnail: true,
        },
        espece: 'stenopetalum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 131, 128, 1.00)',
            'rgba(139, 137, 135, 1.00)',
            'rgba(147, 129, 140, 1.00)',
          ],
          filename:
            "ip parc de proce/rhododendron/rhododendron stenopetalum 'linearifolium'/rhododendron stenopetalum 'linearifolium' (2).jpg",
          width: 1024,
          id: '38650b8950e06f7a14ebb3dadfc67ada',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 129, 120, 1.00)',
            'rgba(125, 114, 119, 1.00)',
            'rgba(98, 96, 97, 1.00)',
          ],
          filename:
            "ip parc de proce/rhododendron/rhododendron stenopetalum 'linearifolium'/rhododendron stenopetalum 'linearifolium' (1).jpg",
          width: 1024,
          id: 'b9080eed393edc80e83ca517d3c96133',
          height: 768,
          thumbnail: true,
        },
        location: [47.222953, -1.580983],
        genre: 'Rhododendron',
        cultivar: 'Linearifolium',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580983, 47.222953] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '08861fbc6d7e11b078bcc713ee618c114a7c4848',
      fields: {
        espece: 'pseudoacacia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(208, 220, 230, 1.00)',
            'rgba(157, 159, 127, 1.00)',
            'rgba(101, 102, 78, 1.00)',
          ],
          filename:
            "ip ville de nantes/robinia/robinia pseudoacacia 'frisia'/robinia pseudoacacia 'frisia' (2).jpg",
          width: 1024,
          id: '62756eb82915515b34af79a98cc85ace',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 132, 118, 1.00)',
            'rgba(134, 135, 77, 1.00)',
            'rgba(112, 108, 30, 1.00)',
          ],
          filename:
            "ip ville de nantes/robinia/robinia pseudoacacia 'frisia'/robinia pseudoacacia 'frisia' (1).jpg",
          width: 576,
          id: 'aa8daf0e41b4399ed425a88e7a0ab3c3',
          height: 768,
          thumbnail: true,
        },
        location: [47.235472, -1.541028],
        genre: 'Robinia',
        cultivar: 'Frisia',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541028, 47.235472] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bcf91f1021e841549997763161bd033480caad5c',
      fields: {
        espece: 'contoniensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 125, 65, 1.00)',
            'rgba(118, 126, 81, 1.00)',
            'rgba(86, 93, 53, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/spiraea/spiraea contoniensis 'flore pleno'/spiraea contoniensis 'flore pleno'(2).jpg",
          width: 576,
          id: 'b6b20a9674c3b062d0bf63a8d55426f2',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 144, 74, 1.00)',
            'rgba(133, 140, 80, 1.00)',
            'rgba(111, 118, 66, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/spiraea/spiraea contoniensis 'flore pleno'/spiraea contoniensis 'flore pleno'(1).jpg",
          width: 576,
          id: '8e10034883883bd2112f9564a46ae9d6',
          height: 768,
          thumbnail: true,
        },
        location: [47.220705, -1.54292],
        genre: 'Spiraea',
        cultivar: 'Flore Pleno',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54292, 47.220705] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '936927691fe4f18a98507f76fe8bd0cd11976a26',
      fields: {
        espece: 'albus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 137, 115, 1.00)',
            'rgba(129, 130, 98, 1.00)',
            'rgba(105, 98, 83, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/symphoricarpos/symphoricarpos albus/symphoricarpos albus (2).jpg',
          width: 576,
          id: 'ed7cd7d1cfc0038383044f8a32b450d2',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 94, 79, 1.00)',
            'rgba(113, 112, 88, 1.00)',
            'rgba(81, 80, 46, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/symphoricarpos/symphoricarpos albus/symphoricarpos albus (1).jpg',
          width: 576,
          id: 'db2471886f95333d3556e1cc4fee519c',
          height: 768,
          thumbnail: true,
        },
        location: [47.220803, -1.54262],
        genre: 'Symphoricarpos',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54262, 47.220803] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e7c47b191eccd039ebbf09f53244c1b90644b0c2',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'daniellii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 130, 168, 1.00)',
            'rgba(91, 98, 112, 1.00)',
            'rgba(78, 97, 120, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/tetradium/tetradium daniellii/tetradium daniellii (2).jpg',
          width: 1024,
          id: '372ee94ea6bdf20c10189b3628b5403a',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 78, 54, 1.00)',
            'rgba(98, 75, 53, 1.00)',
            'rgba(104, 77, 54, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/tetradium/tetradium daniellii/tetradium daniellii (3).jpg',
          width: 1024,
          id: '862e7e6f451ac57d4e86843c88d0b752',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 86, 52, 1.00)',
            'rgba(121, 84, 60, 1.00)',
            'rgba(92, 62, 44, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/tetradium/tetradium daniellii/tetradium daniellii (1).jpg',
          width: 1024,
          id: '3faa9e75c31c55aa77b19dd6e5bf5d22',
          height: 683,
          thumbnail: true,
        },
        location: [47.262187, -1.528942],
        genre: 'Tetradium',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.528942, 47.262187] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0db51bfd3514a2ca2ee6b74a4d3a9db54671e251',
      fields: {
        espece: 'plicatum f. tomentosum',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 113, 88, 1.00)',
            'rgba(97, 108, 52, 1.00)',
            'rgba(98, 107, 51, 1.00)',
          ],
          filename:
            'ip parc de proce/viburnum/viburnum plicatum f. tomentosum/viburnum plicatum f. tomentosum.jpg',
          width: 1024,
          id: '4560e363a5481963baef37fef267fdf6',
          height: 768,
          thumbnail: true,
        },
        location: [47.225463, -1.58298],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58298, 47.225463] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '85e63e4b54af10facbaa5e6ab8821b9aaf10c6ca',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'ailanthoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 129, 125, 1.00)',
            'rgba(99, 103, 63, 1.00)',
            'rgba(70, 71, 35, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/zanthoxylum/zanthoxylum ailanthoides/zanthoxylum ailanthoides  (2).jpg',
          width: 512,
          id: '2957ae8cd7e5fa414a9f2f95778254af',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 157, 146, 1.00)',
            'rgba(81, 87, 61, 1.00)',
            'rgba(35, 39, 20, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/zanthoxylum/zanthoxylum ailanthoides/zanthoxylum ailanthoides  (3).jpg',
          width: 978,
          id: '0ac31374f453d1edfa4d31119cc6ec7f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 158, 134, 1.00)',
            'rgba(98, 103, 57, 1.00)',
            'rgba(53, 59, 31, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/zanthoxylum/zanthoxylum ailanthoides/zanthoxylum ailanthoides  (1).jpg',
          width: 1024,
          id: '972876e7c98b44605a0a96ee24bbbbef',
          height: 683,
          thumbnail: true,
        },
        location: [47.219487, -1.543372],
        genre: 'Zanthoxylum',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543372, 47.219487] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ec8f6c51707b250cdd44e0e6af4feca0c0c1e621',
      fields: {
        espece: 'sinica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 167, 91, 1.00)',
            'rgba(108, 146, 73, 1.00)',
            'rgba(109, 142, 69, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/zelkova/zelkova sinica/zelkova sinica (2).jpg',
          width: 576,
          id: '2a26493f52eb181b874eca9607f0f2b0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 160, 77, 1.00)',
            'rgba(123, 157, 73, 1.00)',
            'rgba(115, 146, 66, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/zelkova/zelkova sinica/zelkova sinica (1).jpg',
          width: 1024,
          id: 'cadb3fd3a32f5a6bc98f8d071cd10885',
          height: 768,
          thumbnail: true,
        },
        location: [47.219208, -1.543138],
        genre: 'Zelkova',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543138, 47.219208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ebcd85047fa275fb3d5a5c9e24e20b85985a6072',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'serrata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 140, 114, 1.00)',
            'rgba(139, 133, 106, 1.00)',
            'rgba(134, 126, 98, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/zelkova/zelkova serrata/zelkova serrata (3).jpg',
          width: 576,
          id: '97b19272084fcd2bbbb26115dfb5eb43',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(193, 182, 181, 1.00)',
            'rgba(110, 104, 75, 1.00)',
            'rgba(87, 95, 43, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/zelkova/zelkova serrata/zelkova serrata (4).jpg',
          width: 1024,
          id: 'e73aa9519bccf4c977f52d2e616c2bd5',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 101, 73, 1.00)',
            'rgba(114, 108, 88, 1.00)',
            'rgba(123, 124, 84, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/zelkova/zelkova serrata/zelkova serrata (1).jpg',
          width: 576,
          id: '7c21fb433344a5aa9ed132ea4217b7ab',
          height: 768,
          thumbnail: true,
        },
        location: [47.230362, -1.507967],
        genre: 'Zelkova',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507967, 47.230362] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b19108eb6112310b0926393c319f549c5dfdf6ee',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 174, 137, 1.00)',
            'rgba(102, 114, 72, 1.00)',
            'rgba(92, 96, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum 'chesapeake'/viburnum 'chesapeake' (3).jpg",
          width: 576,
          id: 'c6d23e16bb0e8648b64c8cec0bb4d3b2',
          height: 768,
          thumbnail: true,
        },
        location: [47.271188, -1.585787],
        genre: 'Viburnum',
        cultivar: 'Chesapeake',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585787, 47.271188] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0d412d0d93da8cbe0e87b71fbd56eedf4fb1e5b2',
      fields: {
        espece: 'mongolicum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 111, 49, 1.00)',
            'rgba(150, 124, 58, 1.00)',
            'rgba(114, 116, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum mongolicum/viburnum mongolicum (4).jpg',
          width: 576,
          id: 'a5bf7e184b8cc5f39009b99feb8804a7',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(40, 71, 25, 1.00)',
            'rgba(81, 116, 54, 1.00)',
            'rgba(73, 108, 51, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum mongolicum/viburnum mongolicum (2).jpg',
          width: 576,
          id: '560ea75190a0bb343b2e44355d9b28b5',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '29d4bf9d701a6e5a0ecc406e94f48da5d659fb3a',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 87, 77, 1.00)',
            'rgba(149, 110, 101, 1.00)',
            'rgba(132, 112, 103, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum opulus 'notcutt's variety'/viburnum opulus 'notcutt's variety'  (4).jpg",
          width: 576,
          id: 'ce0db3d57472f00724dd01b274ba353a',
          height: 768,
          thumbnail: true,
        },
        espece: 'opulus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 123, 92, 1.00)',
            'rgba(137, 135, 102, 1.00)',
            'rgba(112, 131, 104, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum opulus 'notcutt's variety'/viburnum opulus 'notcutt's variety'  (3).jpg",
          width: 576,
          id: '5800f007a6ddb7cf9b30c653aef929ac',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(210, 139, 112, 1.00)',
            'rgba(176, 112, 61, 1.00)',
            'rgba(112, 96, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum opulus 'notcutt's variety'/viburnum opulus 'notcutt's variety'  (2).jpg",
          width: 576,
          id: '7c27c1c15c0f77ccb5692d7e569183aa',
          height: 768,
          thumbnail: true,
        },
        location: [47.270842, -1.585688],
        genre: 'Viburnum',
        cultivar: "Notcutt's Variety",
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585688, 47.270842] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ae69072495c56de6655300b971fd53210b2b717b',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 152, 128, 1.00)',
            'rgba(147, 132, 119, 1.00)',
            'rgba(153, 144, 125, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum sargentii 'onondaga'/viburnum sargentii 'onondaga'  (3).jpg",
          width: 576,
          id: '45ecbadf35d1c27a6c7430de96b73435',
          height: 768,
          thumbnail: true,
        },
        espece: 'sargentii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(183, 122, 114, 1.00)',
            'rgba(173, 114, 104, 1.00)',
            'rgba(150, 121, 93, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum sargentii 'onondaga'/viburnum sargentii 'onondaga'  (2).jpg",
          width: 576,
          id: '4e600282d563237cdf92f904e1120fc4',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(194, 186, 168, 1.00)',
            'rgba(98, 84, 47, 1.00)',
            'rgba(75, 72, 35, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum sargentii 'onondaga'/viburnum sargentii 'onondaga'  (1).jpg",
          width: 576,
          id: '1def048bdc80a873e8eabf17d279af31',
          height: 768,
          thumbnail: true,
        },
        location: [47.269942, -1.58458],
        genre: 'Viburnum',
        cultivar: 'Onondaga',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58458, 47.269942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '30882b33f2ffe532478cc4a42d4843c73c8bb994',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'setigerum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 168, 144, 1.00)',
            'rgba(158, 133, 104, 1.00)',
            'rgba(107, 87, 40, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum setigerum/viburnum setigerum (21).jpg',
          width: 576,
          id: '202bf581c175557f2d6e591d62570dc1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 114, 106, 1.00)',
            'rgba(175, 76, 83, 1.00)',
            'rgba(118, 116, 104, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum setigerum/viburnum setigerum (22).jpg',
          width: 706,
          id: '7746290d7f9aeed4c486ec957b5a88d6',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 114, 78, 1.00)',
            'rgba(149, 129, 65, 1.00)',
            'rgba(114, 98, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum setigerum/viburnum setigerum (20).jpg',
          width: 576,
          id: '842826fda1225a916a4a7b0334c776be',
          height: 768,
          thumbnail: true,
        },
        location: [47.271337, -1.580678],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580678, 47.271337] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6aa9a7ab1420fa4953530eb0ce225c0e8c5ebaac',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'utile',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 119, 76, 1.00)',
            'rgba(123, 142, 99, 1.00)',
            'rgba(91, 109, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum utile/viburnum utile  (2).jpg',
          width: 576,
          id: '48f293bd1c102a6ce583992248f1727d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 90, 63, 1.00)',
            'rgba(123, 121, 90, 1.00)',
            'rgba(107, 106, 77, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum utile/viburnum utile (1).jpg',
          width: 576,
          id: '2598180d477622a3af8921ca38f1a8cb',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 161, 114, 1.00)',
            'rgba(120, 141, 94, 1.00)',
            'rgba(99, 128, 83, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum utile/viburnum utile  (1).jpg',
          width: 576,
          id: '952f85858c363fd0cb749ca5aa7d73f1',
          height: 768,
          thumbnail: true,
        },
        location: [47.271517, -1.586467],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586467, 47.271517] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1226f645e9cdf632b9f53990e5c8aa2642c45050',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 139, 90, 1.00)',
            'rgba(135, 150, 98, 1.00)',
            'rgba(100, 117, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x burkwoodii 'mohawk'/viburnum x burkwoodii 'mohawk' (3).jpg",
          width: 576,
          id: '686b795c4ebf81c9373517b098319da8',
          height: 768,
          thumbnail: true,
        },
        espece: 'x burkwoodii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 145, 93, 1.00)',
            'rgba(127, 133, 95, 1.00)',
            'rgba(148, 141, 107, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x burkwoodii 'mohawk'/viburnum x burkwoodii 'mohawk' (2).jpg",
          width: 576,
          id: '662bb56527bd27b8e8f0bcb7bc95b7b0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 91, 52, 1.00)',
            'rgba(132, 135, 116, 1.00)',
            'rgba(63, 74, 34, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x burkwoodii 'mohawk'/viburnum x burkwoodii 'mohawk' (1).jpg",
          width: 576,
          id: '0cbea4bff9b23698be15637c336e0f6d',
          height: 768,
          thumbnail: true,
        },
        location: [47.271437, -1.586247],
        genre: 'Viburnum',
        cultivar: 'Mohawk',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586247, 47.271437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4ba84d2e1b8df2361ea487bfb371d39f4ebb81b3',
      fields: {
        origine: 'J.B. Lyon (France)',
        espece: 'papyraceus Ker Gawl.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Narcissus',
        date_plantation: '2011',
        cultivar: 'barlae (Parl.) Nyman',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '679c9df13ea68938c11a6cfdfbd3602b5dda6c52',
      fields: {
        origine: 'J.B.Friedrich Jena,Jena,All.',
        espece: 'uniflorum Raf.',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Ipheion',
        date_plantation: '2013',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '48044ba47f712fffbbefdbc82f7a2500c75b9404',
      fields: {
        origine: 'J.B.Osterr-Garten,Graz,Autriche',
        espece: 'bowdenii W.Watson',
        localisation: 'I2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185657, -1.5426599],
        genre: 'Nerine',
        date_plantation: '2011',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426599, 47.2185657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7bbe0060597db03d85b83938c7da5123dd2bb1cd',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'cyathophorum E. Bureau & A. Franchet',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Allium',
        date_plantation: '1998',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2c97ea3b606e1ce19861e719897a6a4c636b4d82',
      fields: {
        origine: 'JBU.Varsovie',
        espece: 'senescens L.(intro.sinescens L.)',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Allium',
        date_plantation: '2001',
        cultivar: 'montanum Holub.',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1f925b74055215e47ee524b59009bb54b3a3b6d1',
      fields: {
        origine: 'JBU.Vitebsk (Bielorussie)',
        espece: 'stellatum Ker-Gawl.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Allium',
        date_plantation: '2006',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a5bb5f4d6dea70d89aa686f04c760b0a98f6846e',
      fields: {
        origine: 'Mr.Franklin Picard',
        espece: 'sp.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Allium',
        date_plantation: '2015',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '832783997668bcd1e609b92df061916f5e15971c',
      fields: {
        espece: 'cherimola',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 155, 107, 1.00)',
            'rgba(115, 141, 67, 1.00)',
            'rgba(93, 117, 43, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/annona [annonaceae]/annona cherimola/annona cherimola.jpg",
          width: 576,
          id: '150b6552bf2104791f4e55df5462a4e4',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 182, 76, 1.00)',
            'rgba(119, 157, 33, 1.00)',
            'rgba(110, 148, 33, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/annona [annonaceae]/annona cherimola/annona cherimola (1).jpg",
          width: 576,
          id: '658580d0f66aeb102b06bf64b3c4c43e',
          height: 768,
          thumbnail: true,
        },
        location: [47.22692, -1.51195],
        genre: 'Annona',
        famille: 'Annonaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.51195, 47.22692] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0dac25eacf1fa1baef8b4da4cf805e59d3b3e3bc',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'triloba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 132, 107, 1.00)',
            'rgba(132, 120, 98, 1.00)',
            'rgba(176, 176, 138, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/asimina [annonaceae]/asimina triloba/asimina triloba (2).jpg',
          width: 576,
          id: 'f18428ec29dc42ab44abc6e412fe4041',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 144, 104, 1.00)',
            'rgba(135, 125, 112, 1.00)',
            'rgba(173, 168, 144, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/asimina [annonaceae]/asimina triloba/asimina triloba (3).jpg',
          width: 576,
          id: 'd06b8641b176acd3d2f5daa5f0667508',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 127, 102, 1.00)',
            'rgba(147, 143, 113, 1.00)',
            'rgba(158, 154, 125, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/asimina [annonaceae]/asimina triloba/asimina triloba (1).jpg',
          width: 576,
          id: '66789f98179c968cf9ec2eba63315087',
          height: 768,
          thumbnail: true,
        },
        location: [47.269717, -1.582155],
        genre: 'Asimina',
        famille: 'Annonaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582155, 47.269717] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c3632cbfdc40eaa856a07a705f98787a59db6613',
      fields: {
        espece: 'myristica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 166, 110, 1.00)',
            'rgba(95, 156, 82, 1.00)',
            'rgba(42, 79, 43, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/monodora [annonaceae]/monodora myristica/monodora myristica.jpg",
          width: 576,
          id: '8809a06370842b6f1cde0715ca044a1f',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 151, 92, 1.00)',
            'rgba(91, 150, 84, 1.00)',
            'rgba(101, 167, 80, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/monodora [annonaceae]/monodora myristica/monodora myristica (1).jpg",
          width: 576,
          id: '11ec1d5352195a053618839e4c99992b',
          height: 768,
          thumbnail: true,
        },
        location: [47.227047, -1.511953],
        genre: 'Monodora',
        famille: 'Annonaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.511953, 47.227047] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c3b333d3c145be3c01e984917f60c66f97cf7632',
      fields: {
        origine: 'J.Alp.Meyrin (Suisse)',
        espece: 'planum L.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Eryngium',
        date_plantation: '1989',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5f8ea8a988a5b09f49648619d30155a381bc28b3',
      fields: {
        origine: 'JBU.Besan\u00e7on (France)',
        espece: 'libanotis Koch.',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Seseli',
        date_plantation: '2001',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '75f6b197b5d8d683396191ca38a70b6c5b81d169',
      fields: {
        origine: 'JBU.Fribourg (Suisse)',
        espece: 'major L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Astrantia',
        date_plantation: '2004',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3a45f0cbebbe57ad1e6299622b6f9b8f0e875259',
      fields: {
        origine: 'R\u00e9colte nature (WLG-PF)',
        espece: 'sylvestris L.',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Angelica',
        date_plantation: '2016',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6d572bf8dda0d2483fa318ec85e7f611fc969cab',
      fields: {
        origine: "Universita degli Studi dell'Aquila",
        espece: 'amethystinum L.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Eryngium',
        date_plantation: '2006',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b9d6a7c2d2306e07df3c26d8b1b471d2c9d6a291',
      fields: {
        origine: 'Hiroshima Botanical Garden,Japon',
        espece: 'asiaticum Nakai',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Trachelospermum',
        date_plantation: '2014',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd19600b7ed23a22ec8f4223446bd6423d9a0efe8',
      fields: {
        origine: 'JB. Osterr-garten, Graz (Autriche)',
        espece: 'illustris Woodson',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Amsonia',
        date_plantation: '2011',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e1938b617aafa76eba807e7d4c1c3313d4ee9235',
      fields: {
        espece: 'sericifera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 102, 79, 1.00)',
            'rgba(108, 128, 75, 1.00)',
            'rgba(146, 169, 95, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/araujia [apocynaceae]/araujia sericifera/araujia sericifera (2).jpg",
          width: 576,
          id: '66340fb2d0984bd67a216f0db6bccaf2',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 107, 69, 1.00)',
            'rgba(129, 130, 94, 1.00)',
            'rgba(81, 90, 44, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/araujia [apocynaceae]/araujia sericifera/araujia sericifera (1).jpg",
          width: 576,
          id: '667283564bdc2e286f3cc8e7b34d84f1',
          height: 768,
          thumbnail: true,
        },
        location: [47.226967, -1.512492],
        genre: 'Araujia',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512492, 47.226967] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a4fe28630278484f7797ba9c604202b3cccb3d8d',
      fields: {
        origine: "jardins d'\u00e9coute s'il pleut",
        espece: 'glabra A.Grey',
        localisation: 'B5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202019, -1.5440256],
        genre: 'Ilex',
        date_plantation: '2015',
        famille: 'Aquifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440256, 47.2202019] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'eb5d2676c181603c24a5467b7b48a47904ac18c0',
      fields: {
        origine:
          'Botanischer Garten der Justus-Liebig-Universit\u00e4t, Giessen, Allemagne',
        espece: 'tortuosum Schott',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Arisaema',
        date_plantation: '2013',
        famille: 'Araceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c916e75934dd503a8e3c99eb57f45608bd4c7aba',
      fields: {
        origine:
          'Botanischer Garten der Universitat, Erlangen-Nurnberg, Allemagne',
        espece: 'tortuosum Schott',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Arisaema',
        date_plantation: '2012',
        famille: 'Araceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cd13c3178dac90cbdd384c6e0577548a8fdfb4c4',
      fields: {
        origine: 'Jardin Botanique de Nantes',
        espece: 'helix',
        localisation: 'B1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2204652, -1.544656],
        genre: 'Hedera',
        date_plantation: '2012',
        cultivar: 'Pedata',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544656, 47.2204652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '98391a7d521b3939eb04e873ef8ee5ff47f27cb7',
      fields: {
        origine: 'P\u00e9pin\u00e8res Arven - Poullan-Sur-Mer (29)',
        espece: 'arboreus',
        localisation: 'B7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198817, -1.5442188],
        genre: 'Neopanax',
        date_plantation: '2015',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442188, 47.2198817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '48b8d93beec8347ffc8a382baea2ca0167fda8d2',
      fields: {
        origine: 'P\u00e9pin\u00e8res Arven - Poullan-Sur-Mer (29)',
        espece: 'laetivirens',
        localisation: 'B7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198817, -1.5442188],
        genre: 'Raukaua',
        date_plantation: '2015',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442188, 47.2198817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '092329d8ffbbbbfe24f301c3aa841adf861308a3',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 135, 102, 1.00)',
            'rgba(119, 125, 88, 1.00)',
            'rgba(80, 91, 56, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/fatsia [araliaceae]/fatsia japonica/fatsia japonica (2).jpg',
          width: 1024,
          id: 'bb5b92fe33a6e38a96128675fa3f6cd8',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 133, 101, 1.00)',
            'rgba(98, 107, 71, 1.00)',
            'rgba(88, 89, 56, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/fatsia [araliaceae]/fatsia japonica/fatsia japonica (3).jpg',
          width: 576,
          id: '9a7e56f6f78c53f58ca8d06b05668cdb',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 166, 139, 1.00)',
            'rgba(82, 101, 62, 1.00)',
            'rgba(67, 74, 42, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/fatsia [araliaceae]/fatsia japonica/fatsia japonica (1).jpg',
          width: 576,
          id: '638076252ef45e2c793425cbb06d344b',
          height: 768,
          thumbnail: true,
        },
        location: [47.229238, -1.51167],
        genre: 'Fatsia',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.51167, 47.229238] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1998ac6d10d0b15ba9414c57651ebe38b9774f83',
      fields: {
        espece: 'septemlobus',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 172, 140, 1.00)',
            'rgba(89, 109, 52, 1.00)',
            'rgba(50, 58, 28, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/kalopanax [araliaceae]/kalopanax septemlobus/kalopanax septemlobus (3).jpg',
          width: 961,
          id: '140e1a9ba6bb02c020da6078f7678471',
          height: 768,
          thumbnail: true,
        },
        location: [47.27042, -1.582717],
        genre: 'Kalopanax',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582717, 47.27042] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8d2bbdbba19880aafa727b5d82d341cbcd350005',
      fields: {
        origine: 'Maison Bananier (Cou\u00ebron)',
        espece: 'humilis',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Chamaerops',
        date_plantation: '2014',
        cultivar: 'Volcano',
        famille: 'Arecaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2dc817a9eeaca3e50301690d65bbf6f069d4e69a',
      fields: {
        origine: 'Ets.Lepage',
        espece: 'montana F.Maekawa.',
        localisation: 'D3G',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2197244, -1.5416062],
        genre: 'Hosta',
        date_plantation: '1992',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5416062, 47.2197244] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '32a70d5c733b8bfb7a0069becc359540d5168308',
      fields: {
        origine: 'Goteborg Botanical Garten (Su\u00e8de)',
        espece: 'weissii Freyn',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Muscari',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '16de4be2169569b2f64fe8e38b8108f40d6f7805',
      fields: {
        origine: 'Horthus Botanicus Basiliensis, Basel, Suisse',
        espece: 'bracteata Harv.',
        localisation: 'I2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185657, -1.5426599],
        genre: 'Veltheimia',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426599, 47.2185657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '20c835a11034d9331db2afc5d336df62da9b4927',
      fields: {
        origine: 'Hortus Botanicus Tallinensis,Tallinn,Estonie',
        espece: 'mischtschenkoana Grossh.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Scilla',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ab140b96c810576d0cd294ab2fd542a8fb62aafd',
      fields: {
        origine: 'Inst.Bot. De Komarovii Perkalsky,Stauropol,Russie',
        espece: 'magnum Krasch.& Schichk',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Ornithogalum',
        date_plantation: '2010',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ff0555da92c311595c74e8fa0c49e639e7865dc1',
      fields: {
        origine: 'J.P.Alpin la Saussurea,Courmayeur (Italie)',
        espece: 'multiflorum All.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Polygonatum',
        date_plantation: '2011',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '31db7bf86c891f42be9de170e53d77fed3337b95',
      fields: {
        origine: 'JB.Dunedin (N-Z\u00e9lande)',
        espece: 'australis Endl.',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Cordyline',
        date_plantation: '2006',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7ed8976c050228915e22f90085608a27cc70d8ca',
      fields: {
        origine: 'JB.Goteborg  (Suede)',
        espece: 'orientalis L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Hyacinthus',
        date_plantation: '2010',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '80e03f1788567a44a941ff5de6af3478e2e9d6d5',
      fields: {
        origine: 'La Maison du bananier - Cou\u00ebron',
        espece: 'australis',
        localisation: 'A5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2207668, -1.5440149],
        genre: 'Cordyline',
        date_plantation: '2014',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440149, 47.2207668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b918593a825afe45c22669b0fea239a4fd15e5c2',
      fields: {
        origine: 'Les Ponts de C\u00e9_p\u00e9pini\u00e8re Lepage',
        espece: 'japonicus Ker-Gawl.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Ophiopogon',
        date_plantation: '2016',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2fbfad6f88fe63c933c09b92fd93f5c803048959',
      fields: {
        origine: 'Mr.Boff B.',
        espece: 'macrocarpa S. Wats.',
        localisation: 'A2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2208871, -1.5444631],
        genre: 'Nolina',
        date_plantation: '1995',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444631, 47.2208871] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ec36c813ca1446be6d4cf76ba4a15135ee14b58d',
      fields: {
        origine: 'Universitatea de Stiinte Agricole,Cluj-Napoca,Roumanie',
        espece: 'romana Sweet',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Bellevalia',
        date_plantation: '2013',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2637dc78bc8400c76fe734a97738d2bb593f2c10',
      fields: {
        origine: 'inconnue',
        espece: 'officinarum DC.',
        localisation: 'A2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2208871, -1.5444631],
        genre: 'Ceterach',
        date_plantation: '1976',
        famille: 'Aspleniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444631, 47.2208871] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0070d42c0e1c7e2c15b41094b04f30ac64adecd3',
      fields: {
        origine: 'Botanischer Garten,Friedrich Jena, Jena, Allemagne',
        espece: 'caerulea L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Catananche',
        date_plantation: '2012',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b561d60af4ad5a6654d686d045f432c06b18b35d',
      fields: {
        origine: 'Emmanuel LEPAGE',
        espece: 'triplinervis Sims',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Anaphalis',
        date_plantation: '2015',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4a0121afe92cf00978dd6081f03ab1763ea98e13',
      fields: {
        origine: 'Hortus Botanicus Reykjavikensis (Islande)',
        espece: 'hookeri Beaman',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Townsendia',
        date_plantation: '2012',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5275f0c12bc9a6652c22e4ff3f9e520ff891fb1b',
      fields: {
        origine: 'Institut biom\u00e9dical de Tsukuba (Japon)',
        espece: 'pinnatifida Kitam',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Kalimeris',
        date_plantation: '2009',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5f99ba53e90d087180c8277835f55b3578a5b1c9',
      fields: {
        origine: 'J.Alp.Graz (Autriche)',
        espece: 'corymbosum Sch.Bip.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Tanacetum',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'df01e5cf8e865505d7089731a3d6c0ee0fa935a5',
      fields: {
        origine: 'J.B. Marie Curie, Lublin (Pologne)',
        espece: 'onopordifolia Besser',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Carlina',
        date_plantation: '2011',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '96f738edd08a63fcd95249ea72441a66d48a1b92',
      fields: {
        origine: 'JB. E.M.Heckel (Marseille,France)',
        espece: 'ageratum L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Achillea',
        date_plantation: '2011',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '32f60362cfe812b607d41eb2543a6fd1a1fa5060',
      fields: {
        origine: "JB.d'Aquila (Italie)",
        espece: 'montana L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Inula',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5918c80b84a7dc06ed0f2ccc930e8bbc2b7d080b',
      fields: {
        origine: "JB.de l'Acad\u00e9mie des Sciences de Sofia",
        espece: 'thracica Hayek',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Centaurea',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8911cb96381cf7725c1846377027831d83456995',
      fields: {
        origine: 'JB.Oberhof (Allemagne)',
        espece: 'pannosum Boiss.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Hieracium',
        date_plantation: '2000',
        cultivar: 'bornmuelleri Zahn',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ea380c27499d49882f3e9da31c880427942e81af',
      fields: {
        origine: 'JB.Prague (R\u00e9p.Tch\u00e8que)',
        espece: 'pannonica Scheele',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Achillea',
        date_plantation: '2009',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '62239dd67956b2561a11cf063c1127e25bcab875',
      fields: {
        origine: 'JB.Seattle (USA)',
        espece: 'graminifolia  Nutt.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Euthamia',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '209eebc6312035e51df001d6175288ac3d4c6f3f',
      fields: {
        origine: 'JB.Stadt Krefeld (Allemagne)',
        espece: 'bupleuroides Bellarf ex Wild',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Hieracium',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8da9157db1b5b2b9f51e890eb5323bcef605e2d8',
      fields: {
        origine: 'JB.T\u00e9h\u00e9ran (Iran)',
        espece: 'tinctoria L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Anthemis',
        date_plantation: '2006',
        cultivar: 'tinctoria',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a4440a6fedb24eaba37766ea136cb0a2dfb0d764',
      fields: {
        origine: 'JBU.Lansing (U.S.A.)',
        espece: 'pinnata Bamh.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Ratibida',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c4a00beae7ca6cad0cb9d30239fb4866f3d1fd2b',
      fields: {
        origine: "R\u00e9serve Bowman's Hill (U.S.A.)",
        espece: 'tripteris L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Coreopsis',
        date_plantation: '1992',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '237df2bbbb482e018dea0fca4a4997c8e6220383',
      fields: {
        origine: 'Tatton Park Knutsford (Angleterre)',
        espece: 'caerulea L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Catananche',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '30cb1245ba9561ce76f913576b26ed3d52bdf2a8',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'nummularifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 84, 31, 1.00)',
            'rgba(124, 136, 101, 1.00)',
            'rgba(74, 87, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/olearia [asteraceae]/olearia nummularifolia/olearia nummularifolia  (2).jpg',
          width: 576,
          id: 'ee5cea248504e55bd20cbc9a96d023a1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 129, 55, 1.00)',
            'rgba(122, 153, 64, 1.00)',
            'rgba(115, 142, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/olearia [asteraceae]/olearia nummularifolia/olearia nummularifolia  (3).jpg',
          width: 576,
          id: 'd568e1fdb63ccf5c71c8d8e2eb945f0d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 97, 59, 1.00)',
            'rgba(90, 108, 80, 1.00)',
            'rgba(143, 135, 110, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/olearia [asteraceae]/olearia nummularifolia/olearia nummularifolia  (1).jpg',
          width: 967,
          id: '95caef66389bcc64aa8766a8be3b486e',
          height: 768,
          thumbnail: true,
        },
        location: [47.271297, -1.582217],
        genre: 'Olearia',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582217, 47.271297] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3c2efba09217ca9cc541f89ff7f3b4ba566eb2a5',
      fields: {
        espece: 'solandri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 135, 118, 1.00)',
            'rgba(137, 145, 130, 1.00)',
            'rgba(111, 105, 111, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/olearia [asteraceae]/olearia solandri 'aurea'/olearia solandri 'aurea' (2).jpg",
          width: 576,
          id: 'bc9af6756b702d6f7720e77889e5ad83',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 143, 129, 1.00)',
            'rgba(134, 139, 128, 1.00)',
            'rgba(131, 136, 127, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/olearia [asteraceae]/olearia solandri 'aurea'/olearia solandri 'aurea' (1).jpg",
          width: 576,
          id: '67d178964937a90df811e046dd2c27db',
          height: 768,
          thumbnail: true,
        },
        location: [47.271303, -1.586588],
        genre: 'Olearia',
        cultivar: 'Aurea',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586588, 47.271303] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9b1ea4ce306b005a356e352665e86805abbebe2c',
      fields: {
        origine: "La Boite \u00e0 Graines, L'Herbergement, France",
        espece: 'hexandrum Royle',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Podophyllum',
        date_plantation: '2013',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0e43af556f02227e4339b42dfee58891b681f9d8',
      fields: {
        espece: 'virgetorum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 107, 93, 1.00)',
            'rgba(101, 133, 109, 1.00)',
            'rgba(109, 145, 112, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/berberis [berberidaceae]/berberis virgetorum/berberis virgetorum (2).jpg',
          width: 576,
          id: '7753b26d8570494058016d73a78653d8',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 123, 113, 1.00)',
            'rgba(110, 109, 94, 1.00)',
            'rgba(96, 124, 91, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/berberis [berberidaceae]/berberis virgetorum/berberis virgetorum (1).jpg',
          width: 576,
          id: 'ef7b6ee73bf3aca1e66fabd98bc9c4de',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Berberis',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '77d832d438563bc5d9c5cad4c18146aab4b0304a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'domestica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 117, 161, 1.00)',
            'rgba(105, 106, 135, 1.00)',
            'rgba(98, 110, 139, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/nandina [berberidaceae]/nandina domestica/nandina domestica (2).jpg',
          width: 1024,
          id: 'fd5bf0bf1b51bc8ed82ed3efdb377a75',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 109, 63, 1.00)',
            'rgba(136, 141, 90, 1.00)',
            'rgba(127, 132, 82, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/nandina [berberidaceae]/nandina domestica/nandina domestica (3).jpg',
          width: 576,
          id: '1ba24f4b45477803d15b1d6182aef88c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 160, 156, 1.00)',
            'rgba(102, 82, 52, 1.00)',
            'rgba(81, 62, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/nandina [berberidaceae]/nandina domestica/nandina domestica (1).jpg',
          width: 512,
          id: 'e76758d663ffcade8b457ff7cea15076',
          height: 768,
          thumbnail: true,
        },
        location: [47.270778, -1.585678],
        genre: 'Nandina',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585678, 47.270778] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b4ea20dae50a8997179c8ee664822f9fcf299be6',
      fields: {
        origine: "P\u00e9pini\u00e8re Val d'Erdre",
        espece: 'ermanii',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Betula',
        date_plantation: '2017',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b49cff6d091b4c03120a26d7a0ad216f319f4dbd',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'costata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 102, 89, 1.00)',
            'rgba(131, 113, 99, 1.00)',
            'rgba(129, 122, 113, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/betula [betulaceae]/betula costata/betula costata  (3).jpg',
          width: 512,
          id: '1571b8e3cd03e3825689b8943cba793d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 154, 101, 1.00)',
            'rgba(99, 113, 55, 1.00)',
            'rgba(101, 112, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/betula [betulaceae]/betula costata/betula costata (1).jpg',
          width: 576,
          id: 'fc692eaa335e7e0e69c998156ab76e42',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 153, 171, 1.00)',
            'rgba(130, 124, 113, 1.00)',
            'rgba(70, 62, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/betula [betulaceae]/betula costata/betula costata  (1).jpg',
          width: 512,
          id: '227088e267a43e071da2adc7d54268bb',
          height: 768,
          thumbnail: true,
        },
        location: [47.270708, -1.580778],
        genre: 'Betula',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580778, 47.270708] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '459aa3a1b2cbe411c51d708fe9f8545628df1a09',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'carpinifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 150, 58, 1.00)',
            'rgba(135, 131, 61, 1.00)',
            'rgba(141, 140, 77, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ostrya [betulaceae]/ostrya carpinifolia/ostrya carpinifolia  (3).jpg',
          width: 576,
          id: '019bf60f0246dc4b95303451abcd3034',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 146, 85, 1.00)',
            'rgba(123, 143, 53, 1.00)',
            'rgba(115, 128, 48, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ostrya [betulaceae]/ostrya carpinifolia/ostrya carpinifolia  (4).jpg',
          width: 576,
          id: '4d4fba8d574d75fce1ad2adc5ae4c294',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 141, 44, 1.00)',
            'rgba(142, 144, 66, 1.00)',
            'rgba(151, 145, 75, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ostrya [betulaceae]/ostrya carpinifolia/ostrya carpinifolia  (2).jpg',
          width: 587,
          id: '66cf42268133441b7f7cd60e8488e2c6',
          height: 768,
          thumbnail: true,
        },
        location: [47.271, -1.586703],
        genre: 'Ostrya',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586703, 47.271] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c0b3d2e0f2ec78ef0e688b859fc07827b16b52df',
      fields: {
        origine: 'Hort.Botanicus Reykjavikensis,Islande',
        espece: 'forrestii H.R.Fletcher',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Incarvillea',
        date_plantation: '2014',
        famille: 'Bignoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3a23df2be1970c9cba71a859899a7b2811270d06',
      fields: {
        origine: 'JB Universit\u00e9 Tartu (Estonie)',
        espece: 'sinensis Lam.',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Incarvillea',
        date_plantation: '2011',
        famille: 'Bignoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '67df30f08a278cf0d0a51ebd0cb0125e088316de',
      fields: {
        origine: "P\u00e9pini\u00e8re Val d'Erdre",
        espece: 'bignonioides',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Catalpa',
        date_plantation: '2017',
        famille: 'Bignoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e9e06a91056993e3839a4bbd18e77248164b937d',
      fields: {
        espece: 'grandiflora',
        localisation: 'B2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201934, -1.5449557],
        genre: 'Campsis',
        date_plantation: '1973',
        famille: 'Bignoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449557, 47.2201934] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a426040ebb6fdf1a32131a88a51f183f19bda2cd',
      fields: {
        espece: 'bonvalotii Bur.& Franch.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Incarvillea',
        date_plantation: '2011',
        famille: 'Bignoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '93167cae2e7cfef142011a413ed68158c4b25325',
      fields: {
        origine: 'Botanischer Garten,Friedrich Jena, Jena, Allemagne',
        espece: 'caucasica Willd.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Arabis',
        date_plantation: '2012',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4c79adb6c9172649fad91da016ca467f8a95eaec',
      fields: {
        origine: 'J.Alp.Meyrin (Suisse)',
        espece: 'thomasianum Gay.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Aethionema',
        date_plantation: '1997',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '705fbd23694a196e0a7fef5621d0e45d92a92885',
      fields: {
        origine: 'JB.Berlin (Allemagne)',
        espece: 'deltoidea  DC.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Aubrieta',
        date_plantation: '2008',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1749fc449ad0b83a10cb5639b99d898ab4c50b6f',
      fields: {
        origine: 'JB.Irkutsk (Russie)',
        espece: 'sibirica L.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Hesperis',
        date_plantation: '2006',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2bab14388c171ef977a9ab1eebac7d16d30d45b5',
      fields: {
        espece: 'sempervirens',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Buxus',
        date_plantation: '1973',
        famille: 'Buxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e0a345c0e1af2c489b8917c5f8b6f1d2c5769761',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'forficata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 124, 55, 1.00)',
            'rgba(134, 157, 34, 1.00)',
            'rgba(125, 119, 47, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/bauhinia [caesalpiniaceae]/bauhinia forficata/bauhinia forficata (2).jpg",
          width: 576,
          id: '88628f6fd1f5ecb90bfd97cb1c7838e2',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 136, 78, 1.00)',
            'rgba(135, 143, 65, 1.00)',
            'rgba(125, 121, 71, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/bauhinia [caesalpiniaceae]/bauhinia forficata/bauhinia forficata (3).jpg",
          width: 576,
          id: '0d07b22a6cefcc200c939f62042bbb61',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 152, 141, 1.00)',
            'rgba(93, 98, 57, 1.00)',
            'rgba(78, 74, 39, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/bauhinia [caesalpiniaceae]/bauhinia forficata/bauhinia forficata (1).jpg",
          width: 1024,
          id: '2ce2f896817d67647cafb55260807a88',
          height: 768,
          thumbnail: true,
        },
        location: [47.226505, -1.512308],
        genre: 'Bauhinia',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512308, 47.226505] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '37d529b35edade207e5952dad600727abfbd33b8',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 72, 72, 1.00)',
            'rgba(88, 65, 42, 1.00)',
            'rgba(76, 59, 33, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/gleditsia [caesalpiniaceae]/gleditsia triacanthos 'rubylace'/gleditsia triacanthos 'rubylace' (7).jpg",
          width: 612,
          id: '18c0050750d93a44e7e0f9208a1c39eb',
          height: 768,
          thumbnail: true,
        },
        espece: 'triacanthos',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 95, 123, 1.00)',
            'rgba(95, 85, 81, 1.00)',
            'rgba(113, 126, 89, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/gleditsia [caesalpiniaceae]/gleditsia triacanthos 'rubylace'/gleditsia triacanthos 'rubylace' (6).jpg",
          width: 512,
          id: '54fa5cbf51382b9316ca341840c04887',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 70, 77, 1.00)',
            'rgba(94, 95, 109, 1.00)',
            'rgba(102, 128, 172, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/gleditsia [caesalpiniaceae]/gleditsia triacanthos 'rubylace'/gleditsia triacanthos 'rubylace' (5).jpg",
          width: 608,
          id: 'a6cdaec75132cf59b2fdcb869853ad66',
          height: 768,
          thumbnail: true,
        },
        location: [47.270513, -1.582753],
        genre: 'Gleditsia',
        cultivar: 'Rubylace',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582753, 47.270513] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '63ca6be7a3125d3c07123300e40e31be4eea4a28',
      fields: {
        origine: 'B.G. Munchen (All.)',
        espece: 'hofmannii Pant.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Symphyandra',
        date_plantation: '2014',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a19952adccf5b9b09d949f6e5d746dd9079833f7',
      fields: {
        origine: 'J.E.U.de Bruxelles',
        espece: 'persicifolia L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Campanula',
        date_plantation: '2001',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '68fa1100b8dcf7d59c434c9c9d1c3f94870aa8ea',
      fields: {
        origine: 'JB.et Museum de Berolino-Dahlem (Allemagne)',
        espece: 'garganica Tenore',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Campanula',
        date_plantation: '2006',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1ea2dc4d2a2047f5716b8a1dac911d5591d315c0',
      fields: {
        origine: 'JBU.G\u00f6ethe de Frankf\u00fcrt am Main (Allemagne)',
        espece: 'sarmatica Ker-Gawl.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Campanula',
        date_plantation: '2006',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '11bfdadd66f997b8bc76ea8d457e702f88c793fe',
      fields: {
        origine: 'JBU.Hokkaido (Japon)',
        espece: 'grandiflorus A.DC.',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Platycodon',
        date_plantation: '1993',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '43925a75bdea5114db5d18581bb08360c9115aa4',
      fields: {
        origine: 'JBU.Labacensis de la ville Ljubljana (Slovenie)',
        espece: 'pyramidalis L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Campanula',
        date_plantation: '2006',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '22f3acbb0831ed0e824bb805a1b4ed953152e219',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 106, 74, 1.00)',
            'rgba(109, 120, 65, 1.00)',
            'rgba(83, 89, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia x grandiflora 'francis mason'/abelia x grandiflora 'francis mason' (3).jpg",
          width: 576,
          id: '11d745d5221510bcf2bb30ab5e18148f',
          height: 768,
          thumbnail: true,
        },
        espece: 'x grandiflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 100, 75, 1.00)',
            'rgba(144, 123, 111, 1.00)',
            'rgba(78, 74, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia x grandiflora 'francis mason'/abelia x grandiflora 'francis mason' (2).jpg",
          width: 576,
          id: '4510b3ed571c05b7e3f408e6759c49a6',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 117, 73, 1.00)',
            'rgba(119, 130, 86, 1.00)',
            'rgba(89, 104, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia x grandiflora 'francis mason'/abelia x grandiflora 'francis mason' (1).jpg",
          width: 1024,
          id: '8094ab1982017064b104d26923426c67',
          height: 768,
          thumbnail: true,
        },
        location: [47.271787, -1.587217],
        genre: 'Abelia',
        cultivar: 'Francis Mason',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587217, 47.271787] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5d2b15c6204b106faab696190e2abc009bdc4856',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x grandiflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 160, 91, 1.00)',
            'rgba(97, 130, 63, 1.00)',
            'rgba(108, 147, 90, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia x grandiflora/abelia x grandiflora  (2).jpg',
          width: 576,
          id: 'f1e12ef1548db56a2c51e99ad673ba64',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 120, 84, 1.00)',
            'rgba(151, 124, 97, 1.00)',
            'rgba(101, 94, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia x grandiflora/abelia x grandiflora  (4).jpg',
          width: 576,
          id: 'e411d39d483762582725bfabcb0713f1',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 120, 55, 1.00)',
            'rgba(101, 148, 49, 1.00)',
            'rgba(90, 132, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia x grandiflora/abelia x grandiflora  (1).jpg',
          width: 576,
          id: '3534271349004324b9677b8622120463',
          height: 768,
          thumbnail: true,
        },
        location: [47.2716, -1.586588],
        genre: 'Abelia',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586588, 47.2716] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'aa974844490b207d15219c28a95ba406d54bdc4d',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'demissa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 160, 99, 1.00)',
            'rgba(119, 141, 74, 1.00)',
            'rgba(108, 126, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera demissa/lonicera demissa (2).jpg',
          width: 1024,
          id: '33aaea4192df1b1ffd66afeeb95b5638',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 121, 69, 1.00)',
            'rgba(111, 131, 77, 1.00)',
            'rgba(72, 102, 37, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera demissa/lonicera demissa (3).jpg',
          width: 576,
          id: 'e85983cac6e5accacc725fad169c0c71',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 142, 78, 1.00)',
            'rgba(126, 138, 64, 1.00)',
            'rgba(134, 142, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera demissa/lonicera demissa (1).jpg',
          width: 1024,
          id: '1ef469049090beda7bd752d32100f3e7',
          height: 768,
          thumbnail: true,
        },
        location: [47.269897, -1.584544],
        genre: 'Lonicera',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584544, 47.269897] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'db66b2c6a85a81d73a844dffcac0357e4c80ef75',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'morrowii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 132, 42, 1.00)',
            'rgba(129, 140, 41, 1.00)',
            'rgba(120, 117, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera morrowii/lonicera morrowii (2).jpg',
          width: 576,
          id: '7e5c76d9b8d8d12282c14c5bf2869fd1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 152, 73, 1.00)',
            'rgba(125, 141, 58, 1.00)',
            'rgba(86, 111, 24, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera morrowii/lonicera morrowii (3).jpg',
          width: 576,
          id: '669e980fb073131bf47efe59552d63b3',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 168, 85, 1.00)',
            'rgba(115, 139, 55, 1.00)',
            'rgba(110, 126, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera morrowii/lonicera morrowii (1).jpg',
          width: 576,
          id: 'dfe8155944eb0b44b3e674afc6b348be',
          height: 768,
          thumbnail: true,
        },
        location: [47.269867, -1.581647],
        genre: 'Lonicera',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581647, 47.269867] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '17204d28fedd5edd44271daf8dda4792125ed14b',
      fields: {
        origine: 'B.G. Tartu (Estonie)',
        espece: 'lutea L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Saponaria',
        date_plantation: '2015',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e70fdd3274d4c4b32eb7ca4288c217548c0fecbf',
      fields: {
        origine: 'Botanische Garten (Meckenheimer), Bonn, Allemagne',
        espece: 'chungtienensis W.W.Sm.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Silene',
        date_plantation: '2012',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1b4a95c774578fe15ed5715efc09224b1e40a36b',
      fields: {
        origine: 'Botanischer Garten Karl-Franzens, Graz, Autriche',
        espece: 'saxifraga L.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Silene',
        date_plantation: '2012',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '48c7a102d107341912e13abe5858006699e7cb16',
      fields: {
        origine: 'BVGA Cordoba (Esp.)',
        espece: 'cintrana Rothm.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Silene',
        date_plantation: '2015',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f149aabe6177ebd63cf955bd194a02ac955ad85e',
      fields: {
        origine: 'Hortus Botanicus Reykjavikensis, Reykjavik, Islande',
        espece: 'lerchenfeldiana Baumg.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Silene',
        date_plantation: '2013',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0c89d83e001adf5ff727d4eed165bcc02d5cfe98',
      fields: {
        origine: 'J.Alp.Belvedere Wien (Autriche)',
        espece: 'pontederae A.Kern.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Dianthus',
        date_plantation: '1997',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '70be422a3364801ef595c7ee003b81bab38a9c0a',
      fields: {
        origine: 'J.B.ST.Andrews,Ecosse',
        espece: 'pygmaea Adam',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Silene',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '71c3c1fc4df5692253e13bfafda53858b9dd06c5',
      fields: {
        origine: 'JB. Ljubljani (Slov\u00e9nie)',
        espece: 'scorzonerifolia Ser.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Gypsophila',
        date_plantation: '2011',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '89d31cfa99a9971fcdff3eac4cdd7d1b799e18b2',
      fields: {
        origine: 'JB.Kyoto (Japon)',
        espece: 'superbus L.',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Dianthus',
        date_plantation: '2008',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5b17c2eb2d21c561aa0b629b3b136d4b42f976cf',
      fields: {
        origine: 'JB.Museum Klagenfurt (Autriche)',
        espece: 'plumarius L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Dianthus',
        date_plantation: '2004',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a9207ee2c7a4dd20a7a1b3a641d9bb386f56a117',
      fields: {
        origine: 'JB.Olomouc (R\u00e9publique Tch\u00e8que)',
        espece: 'arenarius L.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Dianthus',
        date_plantation: '1999',
        cultivar: 'bohemicus O. Sch warz',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0ee5f8b1922dbc5655cf6b3dac420873e0df92ff',
      fields: {
        origine: 'JBU.Edmonton (Canada)',
        espece: 'yunnanensis Bakerf.',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Lychnis',
        date_plantation: '1987',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3e3031dd73cbf805429eae3784080d0c23a8151e',
      fields: {
        origine: 'Komarov Botanicale institute (Russie)',
        espece: 'brotherana Woron.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Minuartia',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fa28369a5c38dcd56ca634b210ba10dbd309e3a5',
      fields: {
        origine: 'Universit\u00e9 de Postdam (Allemagne)',
        espece: 'zawadzkii Herbich.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Silene',
        date_plantation: '2011',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9079d4b727b42a4cac156aa7fb915629578bdb6c',
      fields: {
        espece: 'alatus',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 118, 65, 1.00)',
            'rgba(93, 132, 58, 1.00)',
            'rgba(92, 115, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus alatus/euonymus alatus  (3).jpg',
          width: 1024,
          id: '4288b7ba492f9f5e9d6013fb03d82c9d',
          height: 683,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Euonymus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7d760d47923d43f32f06f7056c7a6ff9560369d0',
      fields: {
        origine: 'J.Alp.U.Insbruck (Autriche)',
        espece: 'canum Boiss.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Helianthemum',
        date_plantation: '2006',
        famille: 'Cistaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f76f51a5cccef7ee352d1c9b76ba9e7932050080',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 146, 99, 1.00)',
            'rgba(109, 146, 51, 1.00)',
            'rgba(105, 143, 36, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/coriaria [coriariaceae]/coriaria japonica/coriaria japonica (2).jpg',
          width: 576,
          id: 'b7b2b16bbafc56cda8bc39eb1c9d99bf',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 151, 103, 1.00)',
            'rgba(117, 121, 88, 1.00)',
            'rgba(120, 126, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/coriaria [coriariaceae]/coriaria japonica/coriaria japonica (3).jpg',
          width: 576,
          id: 'e0e583923d34c182e2cba5bb459aa23b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 158, 76, 1.00)',
            'rgba(109, 151, 43, 1.00)',
            'rgba(115, 161, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/coriaria [coriariaceae]/coriaria japonica/coriaria japonica (1).jpg',
          width: 576,
          id: '9e8bf0c37ded8755233905d18fcf4c4f',
          height: 768,
          thumbnail: true,
        },
        location: [47.270472, -1.581805],
        genre: 'Coriaria',
        famille: 'Coriariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581805, 47.270472] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ef19a0da260913845625dfbb07b9f5027f77d8cd',
      fields: {
        espece: 'kousa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 67, 56, 1.00)',
            'rgba(151, 53, 43, 1.00)',
            'rgba(105, 56, 38, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'bultinck's beauty'/cornus kousa 'bultinck's beauty' (4).jpg",
          width: 1024,
          id: '600f6cf63252201794b171f6f9bdc89a',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 81, 64, 1.00)',
            'rgba(139, 83, 67, 1.00)',
            'rgba(112, 56, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'bultinck's beauty'/cornus kousa 'bultinck's beauty' (3).jpg",
          width: 1024,
          id: '31d00064c7be46b28b60876dc3d01fae',
          height: 683,
          thumbnail: true,
        },
        location: [47.270436, -1.581289],
        genre: 'Cornus',
        cultivar: "Bultinck's Beauty",
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581289, 47.270436] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '08cb67a552b31b904a9db7e5be651a8d47eb3f81',
      fields: {
        espece: 'kousa',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 142, 124, 1.00)',
            'rgba(99, 107, 89, 1.00)',
            'rgba(64, 73, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa/cornus kousa (6).jpg',
          width: 1024,
          id: '9f893ae8659bebcfcb0c424a6f7f85bb',
          height: 683,
          thumbnail: true,
        },
        location: [47.269467, -1.5851],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5851, 47.269467] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd0bcdfa7a8e6880d1966bbc54b5b6cc705466f72',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'macrophylla',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 89, 26, 1.00)',
            'rgba(113, 121, 72, 1.00)',
            'rgba(66, 83, 30, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus macrophylla/cornus macrophylla (a1) (2).jpg',
          width: 576,
          id: '417517d85e5f4e793f9c8a806c093183',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 122, 38, 1.00)',
            'rgba(107, 143, 44, 1.00)',
            'rgba(101, 133, 39, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus macrophylla/cornus macrophylla (a1) (3).jpg',
          width: 576,
          id: 'e135030dd0769da3e2d4e116f6d64f41',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 89, 42, 1.00)',
            'rgba(111, 134, 84, 1.00)',
            'rgba(93, 107, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus macrophylla/cornus macrophylla (a1) (1).jpg',
          width: 576,
          id: 'ca71d55b52577d2f14d3e09a0d37559b',
          height: 768,
          thumbnail: true,
        },
        location: [47.271825, -1.582447],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582447, 47.271825] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '125a0cecc0e0fdc058daef82df45d13cc6dfdebf',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'mas',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 162, 131, 1.00)',
            'rgba(142, 130, 55, 1.00)',
            'rgba(122, 105, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus mas/cornus mas (11).jpg',
          width: 1024,
          id: 'fb60a00616846e0213362bc55be50449',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 156, 139, 1.00)',
            'rgba(141, 123, 94, 1.00)',
            'rgba(132, 100, 80, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus mas/cornus mas (12).jpg',
          width: 576,
          id: '154749b8573355204e1f9919eb96c02a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 144, 156, 1.00)',
            'rgba(112, 110, 86, 1.00)',
            'rgba(93, 79, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus mas/cornus mas (1).jpg',
          width: 1024,
          id: '58f28feac2ad555623f081f49a281bca',
          height: 683,
          thumbnail: true,
        },
        location: [47.271203, -1.586283],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586283, 47.271203] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7be9ff8e4024febfc164b72b87a7906e926ef8d9',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 156, 117, 1.00)',
            'rgba(81, 100, 47, 1.00)',
            'rgba(116, 131, 78, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus nuttallii 'gold spot'/cornus nuttallii 'gold spot' (11).jpg",
          width: 1024,
          id: '620599fcf8e3944d2e87e54f7d8b2f6a',
          height: 768,
          thumbnail: true,
        },
        espece: 'nuttallii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 148, 91, 1.00)',
            'rgba(127, 147, 87, 1.00)',
            'rgba(104, 124, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus nuttallii 'gold spot'/cornus nuttallii 'gold spot' (10).jpg",
          width: 576,
          id: '4d98e7d519297d03bc6d31c701194961',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 168, 77, 1.00)',
            'rgba(123, 142, 50, 1.00)',
            'rgba(117, 114, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus nuttallii 'gold spot'/cornus nuttallii 'gold spot' (1).jpg",
          width: 576,
          id: '9a1cea3352a306c2c19be72e5acf0579',
          height: 768,
          thumbnail: true,
        },
        location: [47.269758, -1.584428],
        genre: 'Cornus',
        cultivar: 'Gold Spot',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584428, 47.269758] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'da6b4dd3ebc07fd15d46cbff58b1af554a4d8fac',
      fields: {
        espece: 'Venus (Kn30 8)',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(39, 56, 17, 1.00)',
            'rgba(90, 101, 77, 1.00)',
            'rgba(112, 121, 98, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus venus ('kn30 8')/cornus venus ('kn30 8').jpg",
          width: 1024,
          id: '35a253aa9745451e08c5b9e5d187d840',
          height: 683,
          thumbnail: true,
        },
        location: [47.27087, -1.580903],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580903, 47.27087] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '706ecb965bec8a0562dd8876e4a8bc9c7fd848a7',
      fields: {
        espece: 'indica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 102, 103, 1.00)',
            'rgba(89, 103, 103, 1.00)',
            'rgba(104, 122, 123, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus indica/aesculus indica (14).jpg',
          width: 1024,
          id: '1047cd6774d0525bfcbdb68bd8b05271',
          height: 683,
          thumbnail: true,
        },
        location: [47.269906, -1.584583],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584583, 47.269906] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '789139447909e9da5794d5dee8b3944ca067adf5',
      fields: {
        espece: 'cainito',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 166, 71, 1.00)',
            'rgba(132, 132, 53, 1.00)',
            'rgba(103, 102, 42, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/chrysophyllum [sapotaceae]/chrysophyllum cainito/chrysophyllum cainito (4).jpg",
          width: 576,
          id: '15e9023e803cfa69bd3dfc34ae46856d',
          height: 768,
          thumbnail: true,
        },
        location: [47.226505, -1.512308],
        genre: 'Chrysophyllum',
        famille: 'Sapotaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512308, 47.226505] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '254f71f9401c54b8396eaee453a1539855ffb8e2',
      fields: {
        espece: 'gutta',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 144, 142, 1.00)',
            'rgba(135, 141, 121, 1.00)',
            'rgba(135, 152, 55, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/palaquium [sapotaceae]/palaquium gutta/palaquium gutta.jpg",
          width: 576,
          id: 'f31111606d65bff27a3f851c92880ae4',
          height: 768,
          thumbnail: true,
        },
        location: [47.22718, -1.512095],
        genre: 'Palaquium',
        famille: 'Sapotaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512095, 47.22718] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e8ef8223bce2e7b49b1d5b0b91d2dc4e0b74d277',
      fields: {
        origine: 'J.Alp.Meyrin (Suisse)',
        espece: 'cordata Thunb.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Houttuynia',
        date_plantation: '1989',
        famille: 'Saururaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd78b33019d664a33580355da4269ec8fb6adb9e9',
      fields: {
        origine: 'J.Alp.Graz (Autriche)',
        espece: 'hostii Tausch.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Saxifraga',
        date_plantation: '2001',
        cultivar: 'hirsuta',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4999c1ac7963f0423fd6d0752554f3560b4004e8',
      fields: {
        origine: 'J.B. Stiftung, Gr\u00fcningen (Suisse)',
        espece: 'paniculata Mill.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Saxifraga',
        date_plantation: '2011',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '515ef5cbd69dd3e62ccf591c4c6bb1d1a0858e8b',
      fields: {
        origine: 'JB.Framingham (USA)',
        espece: 'americana L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Heuchera',
        date_plantation: '1988',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e0203c5278079f43519506398bbcf88a6b37dbd3',
      fields: {
        origine: 'JB.South Hadley (U.S.A.)',
        espece: 'cordifolia  L.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Tiarella',
        date_plantation: '2008',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fe64bd2466253286c97b8dc201733b19bd87ba8c',
      fields: {
        origine: 'JBU.Berlin Dahlem (Allemagne)',
        espece: 'tomentosum L.',
        localisation: 'A2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2208871, -1.5444631],
        genre: 'Cestrum',
        date_plantation: '1979',
        famille: 'Solanaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444631, 47.2208871] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e8d519a8d4525411b53d135bb965d33ded61582a',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'betaceum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 121, 30, 1.00)',
            'rgba(130, 135, 95, 1.00)',
            'rgba(110, 112, 67, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/solanum [solanaceae]/solanum betaceum/solanum betaceum (2).jpg",
          width: 576,
          id: '388c84f67927c8e1d358a69a8740ef48',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 143, 95, 1.00)',
            'rgba(123, 131, 85, 1.00)',
            'rgba(85, 98, 48, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/solanum [solanaceae]/solanum betaceum/solanum betaceum (3).jpg",
          width: 576,
          id: 'f371a2b7ca54342035e7143095349bb6',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 161, 91, 1.00)',
            'rgba(117, 151, 70, 1.00)',
            'rgba(95, 120, 44, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/solanum [solanaceae]/solanum betaceum/solanum betaceum (1).jpg",
          width: 576,
          id: '64c620c8aec83580b4111030accea8f6',
          height: 768,
          thumbnail: true,
        },
        location: [47.226803, -1.512258],
        genre: 'Solanum',
        famille: 'Solanaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512258, 47.226803] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bcdb2a31facc79a5c9c126ba67902905b4a32ab4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'chinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 152, 136, 1.00)',
            'rgba(127, 118, 87, 1.00)',
            'rgba(103, 101, 92, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stachyurus [stachyuraceae]/stachyurus chinensis/stachyurus chinensis (13).jpg',
          width: 1024,
          id: 'f2ea359eeb44ff7c0a304f974cc9d3fb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 136, 109, 1.00)',
            'rgba(133, 120, 98, 1.00)',
            'rgba(101, 91, 83, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stachyurus [stachyuraceae]/stachyurus chinensis/stachyurus chinensis (14).jpg',
          width: 576,
          id: '81f0c1a1eb3b59a0d4bb7da45b1cd6c1',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 132, 100, 1.00)',
            'rgba(158, 129, 99, 1.00)',
            'rgba(130, 117, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stachyurus [stachyuraceae]/stachyurus chinensis/stachyurus chinensis (1).jpg',
          width: 1024,
          id: '209d3131787140b310f12cf9ab7a57a5',
          height: 768,
          thumbnail: true,
        },
        location: [47.271838, -1.58272],
        genre: 'Stachyurus',
        famille: 'Stachyuraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58272, 47.271838] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '89f8dee233b312337c1be1118d3a1220515cdfc3',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'salicifolius',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 114, 66, 1.00)',
            'rgba(123, 127, 87, 1.00)',
            'rgba(166, 157, 133, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stachyurus [stachyuraceae]/stachyurus salicifolius/stachyurus salicifolius (2).jpg',
          width: 576,
          id: 'c0774f14d160a3379f8461f7add589f3',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 126, 82, 1.00)',
            'rgba(129, 134, 76, 1.00)',
            'rgba(146, 140, 116, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stachyurus [stachyuraceae]/stachyurus salicifolius/stachyurus salicifolius (3).jpg',
          width: 1024,
          id: '55f85f76dfc46fd4f8337f68d0ce8a47',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 142, 112, 1.00)',
            'rgba(143, 129, 99, 1.00)',
            'rgba(144, 126, 103, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stachyurus [stachyuraceae]/stachyurus salicifolius/stachyurus salicifolius (1).jpg',
          width: 576,
          id: 'effae4280e79ecb123230576ee149423',
          height: 768,
          thumbnail: true,
        },
        location: [47.271862, -1.582725],
        genre: 'Stachyurus',
        famille: 'Stachyuraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582725, 47.271862] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd8ffb9cd3395facb62143281dafa9ca003801562',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'corymbosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(181, 191, 173, 1.00)',
            'rgba(96, 113, 55, 1.00)',
            'rgba(98, 105, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pterostyrax [styracaceae]/pterostyrax corymbosa/pterostyrax corymbosa  (2).jpg',
          width: 1024,
          id: 'ac7ba30266d9beb7823b1aa3df6e6190',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 141, 81, 1.00)',
            'rgba(116, 125, 72, 1.00)',
            'rgba(72, 88, 27, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pterostyrax [styracaceae]/pterostyrax corymbosa/pterostyrax corymbosa  (3).jpg',
          width: 576,
          id: 'c12940d7c839785f375615cce8c8890d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 150, 65, 1.00)',
            'rgba(120, 157, 52, 1.00)',
            'rgba(112, 128, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pterostyrax [styracaceae]/pterostyrax corymbosa/pterostyrax corymbosa  (1).jpg',
          width: 576,
          id: '6a33851d91a2b530c34bc0377099daca',
          height: 768,
          thumbnail: true,
        },
        location: [47.271042, -1.584667],
        genre: 'Pterostyrax',
        famille: 'Styracaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584667, 47.271042] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5f9e56a193fdca717bb75b6fb3d70922b77d4bce',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 80, 60, 1.00)',
            'rgba(140, 93, 89, 1.00)',
            'rgba(77, 73, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'black lace'/camellia 'black lace' (3).jpg",
          width: 1024,
          id: '5c49ffd980f4afab66ce18dfb127762e',
          height: 644,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 142, 124, 1.00)',
            'rgba(96, 103, 69, 1.00)',
            'rgba(113, 107, 85, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'black lace'/camellia 'black lace' (4).jpg",
          width: 1024,
          id: 'c1f97eff499ab915b8706ea9103ec200',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 112, 74, 1.00)',
            'rgba(159, 80, 71, 1.00)',
            'rgba(124, 90, 74, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'black lace'/camellia 'black lace' (2).jpg",
          width: 1024,
          id: '92fe40c5fff93b9646ded4d72d8ca91f',
          height: 678,
          thumbnail: true,
        },
        location: [47.270362, -1.585333],
        genre: 'Camellia',
        cultivar: 'Black Lace',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585333, 47.270362] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '20dd2e645495acbd852261747eb46691657ac050',
      fields: {
        espece: 'forrestii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 126, 90, 1.00)',
            'rgba(117, 118, 82, 1.00)',
            'rgba(88, 94, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia forrestii/camellia forrestii (8).jpg',
          width: 1024,
          id: 'c34e7288404479bd0045125d23dab006',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 124, 91, 1.00)',
            'rgba(123, 129, 104, 1.00)',
            'rgba(98, 99, 78, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia forrestii/camellia forrestii (7).jpg',
          width: 1024,
          id: '6b53e4e0c67d068a10b005de7a421243',
          height: 683,
          thumbnail: true,
        },
        location: [47.270442, -1.584081],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584081, 47.270442] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4ee2d5122ad975d675ae0d9a985ca666c61db325',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 139, 124, 1.00)',
            'rgba(85, 92, 62, 1.00)',
            'rgba(106, 104, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'aspasia'/camellia japonica 'aspasia' (3).jpg",
          width: 1024,
          id: '17fda73c0f8ba7e3952bb377224ede72',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 86, 63, 1.00)',
            'rgba(114, 68, 65, 1.00)',
            'rgba(67, 52, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'aspasia'/camellia japonica 'aspasia' (2).jpg",
          width: 1024,
          id: '0972b60bacc8059351dd2775db6c5293',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 91, 67, 1.00)',
            'rgba(112, 93, 76, 1.00)',
            'rgba(97, 83, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'aspasia'/camellia japonica 'aspasia' (1).jpg",
          width: 1024,
          id: 'c8cd5989c3cb941ba8dafb8aaab61acd',
          height: 683,
          thumbnail: true,
        },
        location: [47.270528, -1.581275],
        genre: 'Camellia',
        cultivar: 'Aspasia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581275, 47.270528] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '403dffadc09057edfa5a8cd15e5d0cf5d92fc9d2',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 76, 60, 1.00)',
            'rgba(100, 100, 92, 1.00)',
            'rgba(77, 86, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'ave maria'/camellia japonica 'ave maria' (3).jpg",
          width: 1024,
          id: '664ae3cecbb7ce4940b34c42c2a6513f',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(46, 61, 28, 1.00)',
            'rgba(128, 120, 113, 1.00)',
            'rgba(92, 97, 91, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'ave maria'/camellia japonica 'ave maria' (2).jpg",
          width: 1024,
          id: 'c0efa2c162f891bc7e32dd7bdb2ce05e',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(56, 84, 38, 1.00)',
            'rgba(87, 96, 64, 1.00)',
            'rgba(50, 61, 37, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'ave maria'/camellia japonica 'ave maria' (1).jpg",
          width: 1024,
          id: '5fc305f92c3521a426cec531f788d185',
          height: 683,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Ave Maria',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7ea5bb3ca7ae125b7c387ce70d872ec5030eddcf',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 91, 76, 1.00)',
            'rgba(120, 78, 79, 1.00)',
            'rgba(91, 51, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'bob's tinsie'/camellia japonica 'bob's tinsie' (6).jpg",
          width: 1024,
          id: '3f2ee5f28e2e034bbe5233546ebaea9b',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 84, 74, 1.00)',
            'rgba(137, 60, 68, 1.00)',
            'rgba(120, 42, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'bob's tinsie'/camellia japonica 'bob's tinsie' (5).jpg",
          width: 1024,
          id: '9cce5dcd8232d528b090448d8b19496c',
          height: 683,
          thumbnail: true,
        },
        location: [47.269538, -1.585169],
        genre: 'Camellia',
        cultivar: "Bob's Tinsie",
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585169, 47.269538] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '02bf96eabd1b2a89149ea86eea7ecd391a2672c7',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 64, 45, 1.00)',
            'rgba(105, 78, 57, 1.00)',
            'rgba(54, 53, 30, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'carol lynn'/camellia japonica 'carol lynn'.jpg",
          width: 1024,
          id: '31ee6f257873ba920e4d05abdf58f22d',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 121, 123, 1.00)',
            'rgba(95, 92, 77, 1.00)',
            'rgba(65, 67, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'carol lynn'/camellia japonica 'carol lynn' (1).jpg",
          width: 1024,
          id: 'e6b588b81e1641b3f75dbf3d24a8e9a7',
          height: 683,
          thumbnail: true,
        },
        location: [47.269687, -1.584633],
        genre: 'Camellia',
        cultivar: 'Carol Lynn',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584633, 47.269687] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '78270299960b60d360a0abed651d11f808b1ae43',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 152, 143, 1.00)',
            'rgba(91, 97, 64, 1.00)',
            'rgba(100, 103, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'compacta alba'/camellia japonica 'compacta alba'.jpg",
          width: 1024,
          id: '3fc259fe944814c8acfb82d88e179d67',
          height: 683,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Camellia',
        cultivar: 'Compacta Alba',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5603d22ac9a2643708bae0dc90f898c482d554c3',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 151, 150, 1.00)',
            'rgba(84, 86, 76, 1.00)',
            'rgba(70, 66, 65, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'coquettii'/camellia japonica 'coquettii'.jpg",
          width: 512,
          id: 'b10c061885072104b81260f5dd60b8a6',
          height: 768,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Coquettii',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9689a5be729fc49bb20b33521bee95116a023376',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 68, 72, 1.00)',
            'rgba(123, 69, 77, 1.00)',
            'rgba(57, 38, 34, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'dewatairin' (higo)/camellia japonica 'dewatairin' (2).jpg",
          width: 1024,
          id: '0491634cfa539ad86268c502a71bd7c6',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 73, 64, 1.00)',
            'rgba(101, 104, 91, 1.00)',
            'rgba(97, 102, 88, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'dewatairin' (higo)/camellia japonica 'dewatairin' (1).jpg",
          width: 1024,
          id: '9e3d80b31c390d4fb0a734b227b9d37d',
          height: 683,
          thumbnail: true,
        },
        location: [47.268897, -1.5853],
        genre: 'Camellia',
        cultivar: 'Dewatairin (Higo)',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5853, 47.268897] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5b9a4c8921e8a527da0a3f46f4c4265394957e17',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(48, 64, 43, 1.00)',
            'rgba(110, 73, 73, 1.00)',
            'rgba(103, 78, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'eugene lize'/camellia japonica 'eugene lize'.jpg",
          width: 1024,
          id: 'e1f755214ceade42e5ab234e4c57bb9e',
          height: 683,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Camellia',
        cultivar: 'Eugene Liz\u00e9',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd4e8041974d87645e056896540201e63b7f22434',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 109, 95, 1.00)',
            'rgba(108, 124, 106, 1.00)',
            'rgba(85, 98, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'flamingo'/camellia japonica 'flamingo' (1).jpg",
          width: 1024,
          id: 'a3631a72b41894603249aa9cd95a2436',
          height: 683,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Camellia',
        cultivar: 'Flamingo',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1bd537f44a3c21bfa8bc5bc4d41c0db05f3569b7',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 91, 75, 1.00)',
            'rgba(103, 115, 85, 1.00)',
            'rgba(117, 114, 92, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'fragrant frill'/camellia japonica 'fragrant frill' (2).jpg",
          width: 512,
          id: '46b2ed388acdabd67a8d46e71cf8653d',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 77, 48, 1.00)',
            'rgba(113, 119, 91, 1.00)',
            'rgba(83, 84, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'fragrant frill'/camellia japonica 'fragrant frill' (1).jpg",
          width: 1024,
          id: 'bcd018b204c3c8e563caba00cef90739',
          height: 687,
          thumbnail: true,
        },
        location: [47.269433, -1.584425],
        genre: 'Camellia',
        cultivar: 'Fragrant Frill',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584425, 47.269433] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e3eb0cabbad9fa9945abd2d774a44fb6ae09b039',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 102, 83, 1.00)',
            'rgba(124, 111, 99, 1.00)',
            'rgba(85, 80, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'grace bunton'/camellia japonica 'grace bunton'.jpg",
          width: 1024,
          id: 'f9cff3ffab3f71d5bef4fe23a9c03a82',
          height: 630,
          thumbnail: true,
        },
        location: [47.27026, -1.586547],
        genre: 'Camellia',
        cultivar: 'Grace Bunton',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586547, 47.27026] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a1020944c2ba2610a16bca9bc8442bc9be2745d2',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 96, 77, 1.00)',
            'rgba(105, 77, 69, 1.00)',
            'rgba(78, 66, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'izumusume'/camellia japonica 'izumusume'.jpg",
          width: 1024,
          id: '0c6a70589e37361a8c537acf031455a3',
          height: 683,
          thumbnail: true,
        },
        location: [47.269538, -1.585169],
        genre: 'Camellia',
        cultivar: 'Izumusume',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585169, 47.269538] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '772713306d1db7488dd5a0ca330d058c4b87b7f4',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(53, 61, 37, 1.00)',
            'rgba(150, 143, 128, 1.00)',
            'rgba(82, 80, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'margaret davis'/camellia japonica 'margaret davis'.jpg",
          width: 576,
          id: '738a57b624caffed8206bc63711a49ac',
          height: 768,
          thumbnail: true,
        },
        location: [47.271458, -1.582337],
        genre: 'Camellia',
        cultivar: 'Margaret Davis',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582337, 47.271458] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fe89707860a780710da581ae597b58a2c36a291c',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 96, 51, 1.00)',
            'rgba(104, 121, 94, 1.00)',
            'rgba(46, 65, 37, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'margarete hertrich'/camellia japonica 'margarete hertrich'.jpg",
          width: 1024,
          id: '1493787375ec8b187d2b8ed09ee96b79',
          height: 602,
          thumbnail: true,
        },
        location: [47.268438, -1.584887],
        genre: 'Camellia',
        cultivar: 'Margarete Hertrich',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584887, 47.268438] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '132b69784bd3b50ad1ad8a9fc04c931aef79ed05',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(48, 56, 38, 1.00)',
            'rgba(118, 120, 103, 1.00)',
            'rgba(66, 73, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'punctata boutourlin'/camellia japonica 'punctata boutourlin'.jpg",
          width: 1024,
          id: 'afc1b013686404580053ab97a13a2b4d',
          height: 698,
          thumbnail: true,
        },
        location: [47.269033, -1.58518],
        genre: 'Camellia',
        cultivar: 'Punctata Boutourlin',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58518, 47.269033] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '296a9640f9b286d8785a947e2f1ac6a4b75f017d',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(48, 65, 35, 1.00)',
            'rgba(102, 106, 85, 1.00)',
            'rgba(81, 92, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'touch of pink'/camellia japonica 'touch of pink'.jpg",
          width: 1024,
          id: '3982e58ea39f258ab7cc96e8f6dfcd5d',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(49, 50, 41, 1.00)',
            'rgba(123, 109, 95, 1.00)',
            'rgba(95, 84, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'touch of pink'/camellia japonica 'touch of pink' (2).jpg",
          width: 1024,
          id: 'd4f2da4bb3ca1d0f9c129bb96a3b7607',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(64, 78, 59, 1.00)',
            'rgba(88, 91, 77, 1.00)',
            'rgba(80, 86, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'touch of pink'/camellia japonica 'touch of pink' (1).jpg",
          width: 1024,
          id: '529173d0590745591d9c710e26c0d0dc',
          height: 683,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Touch of Pink',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b2633bbe04e12b7d002cce208fae5a84d8b80169',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 104, 60, 1.00)',
            'rgba(110, 130, 77, 1.00)',
            'rgba(106, 124, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'yukimiguruma'/camellia japonica 'yukimiguruma' (2).jpg",
          width: 1024,
          id: '2bded310d79027a287d73cb3b825c91c',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 104, 61, 1.00)',
            'rgba(123, 133, 91, 1.00)',
            'rgba(80, 94, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'yukimiguruma'/camellia japonica 'yukimiguruma' (1).jpg",
          width: 1024,
          id: 'da3cafc506dd88dd1a3915163b481820',
          height: 714,
          thumbnail: true,
        },
        location: [47.269725, -1.583658],
        genre: 'Camellia',
        cultivar: 'Yukimiguruma',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583658, 47.269725] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2eec0cdd0727aacff3b61eb9865ff9ea0843d477',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 97, 72, 1.00)',
            'rgba(133, 130, 100, 1.00)',
            'rgba(85, 85, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'yukimiguruma'/camellia japonica 'yukimiguruma'.jpg",
          width: 1024,
          id: '18096875600d464769df3bc156b45dce',
          height: 640,
          thumbnail: true,
        },
        location: [47.269722, -1.583662],
        genre: 'Camellia',
        cultivar: 'Yukimiguruma',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583662, 47.269722] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b57926f8db47088c72d02062c3b1fc3ad7699b49',
      fields: {
        espece: 'sasanqua',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 124, 125, 1.00)',
            'rgba(78, 83, 64, 1.00)',
            'rgba(68, 59, 42, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'rainbow'/camellia sasanqua 'rainbow'  (1).jpg",
          width: 1024,
          id: 'becf0df184acec7e8d700f4785c4b77d',
          height: 683,
          thumbnail: true,
        },
        location: [47.268183, -1.584492],
        genre: 'Camellia',
        cultivar: 'Rainbow',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584492, 47.268183] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6c7c33473a18f43e6a2618eb064a73ad11e6a81d',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 92, 58, 1.00)',
            'rgba(127, 118, 97, 1.00)',
            'rgba(102, 78, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'variegata'/camellia sasanqua 'variegata' (4).jpg",
          width: 576,
          id: '10179dfc19ebb9ef9e05a42be14052b4',
          height: 768,
          thumbnail: true,
        },
        espece: 'sasanqua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 124, 107, 1.00)',
            'rgba(160, 146, 121, 1.00)',
            'rgba(100, 100, 67, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'variegata'/camellia sasanqua 'variegata' (3).jpg",
          width: 576,
          id: 'f7febac46cca684353cc599daeccbd8e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 88, 81, 1.00)',
            'rgba(115, 120, 105, 1.00)',
            'rgba(98, 94, 71, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'variegata'/camellia sasanqua 'variegata' (2).jpg",
          width: 576,
          id: 'e00eca0ec94717ca076717b3d923fcab',
          height: 768,
          thumbnail: true,
        },
        location: [47.269438, -1.584588],
        genre: 'Camellia',
        cultivar: 'Variegata',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584588, 47.269438] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '965f88b97b71c88910d641f12e8e4ae9ea237d3c',
      fields: {
        espece: 'sasanqua',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 107, 120, 1.00)',
            'rgba(166, 107, 154, 1.00)',
            'rgba(111, 90, 107, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'vicomte de noailles'/camellia sasanqua 'vicomte de noailles'.jpg",
          width: 576,
          id: 'b09336f564e70b0652eebb4ad20ff66b',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Camellia',
        cultivar: 'Vicomte de Noailles',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '35a64d7b8305bf2ed44c625dc29cb135176b4197',
      fields: {
        espece: 'rostrata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 158, 86, 1.00)',
            'rgba(145, 148, 66, 1.00)',
            'rgba(127, 112, 63, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/stewartia [theaceae]/stewartia rostrata 'rosea'/stewartia rostrata 'rosea' (2).jpg",
          width: 576,
          id: '12a99a564e6705b5cb286cdb6c119126',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 152, 78, 1.00)',
            'rgba(129, 152, 56, 1.00)',
            'rgba(116, 137, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/stewartia [theaceae]/stewartia rostrata 'rosea'/stewartia rostrata 'rosea' (1).jpg",
          width: 576,
          id: '2398e8c52fdeb2bbee7a224c46a2b49d',
          height: 768,
          thumbnail: true,
        },
        location: [47.270692, -1.585792],
        genre: 'Stewartia',
        cultivar: 'Rosea',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585792, 47.270692] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0eded97d58b96b155fac6c9405d1a2ebe458a2f3',
      fields: {
        espece: 'serrata',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 177, 199, 1.00)',
            'rgba(105, 100, 67, 1.00)',
            'rgba(108, 107, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/zelkova [ulmaceae]/zelkova serrata/zelkova serrata .jpg',
          width: 1024,
          id: '3912c14844fb87aeb1db117589bb7e16',
          height: 768,
          thumbnail: true,
        },
        location: [47.26997, -1.58173],
        genre: 'Zelkova',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58173, 47.26997] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '467573ecf0a52e836a3b82639915322441ec5d2a',
      fields: {
        espece: 'serrata',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(181, 178, 196, 1.00)',
            'rgba(124, 97, 72, 1.00)',
            'rgba(93, 90, 60, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/zelkova [ulmaceae]/zelkova serrata/zelkova serrata.jpg',
          width: 576,
          id: '96bb89fff00f89c9e0f68ad7a2022e06',
          height: 768,
          thumbnail: true,
        },
        location: [47.26238, -1.531167],
        genre: 'Zelkova',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531167, 47.26238] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5d44301d1d9f376ec70ecd1d7536200a04ea5494',
      fields: {
        origine: 'Hortus Botanicus Reykjavikensis, Reykjavik, Islande',
        espece: 'labradorica Schrank',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Viola',
        date_plantation: '2011',
        famille: 'Violaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3ba6fc925759f22a3c8119da9c55ee3df5d628da',
      fields: {
        origine: 'JB.Samara (Russie)',
        espece: 'monticola',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Vitis',
        date_plantation: '2005',
        famille: 'Vitaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0df252da17b2090f81be1a17559751cf7e3f826d',
      fields: {
        origine: 'JBU.Wroclaw (Pologne)',
        espece: 'brevipedunculata',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Ampelopsis',
        date_plantation: '2002',
        cultivar: 'maximowiczii',
        famille: 'Vitaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bff774618a36e0ecc1bccd63bdb45dc5b58ee93d',
      fields: {
        espece: 'quinquefolia',
        localisation: 'A5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2207668, -1.5440149],
        genre: 'Ampelopsis',
        date_plantation: '1973',
        famille: 'Vitaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440149, 47.2207668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c8f872798d1b770e8e242055d15c82310fce707c',
      fields: {
        origine: 'Inst.Bot. De Komarovii Perkalsky,Stauropol,Russie',
        espece: 'spectabilis M.Bieb.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Eremurus',
        date_plantation: '2010',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8367621492b52b80482325dcacd5cbe1cec3fe86',
      fields: {
        origine: 'JB.Bergen (Norv\u00e8ge)',
        espece: 'triangularis Kunth.',
        localisation: 'G2A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2197208, -1.5414609],
        genre: 'Kniphofia',
        date_plantation: '2009',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5414609, 47.2197208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '62a3bcde478223e564da71b69a486aaecd603031',
      fields: {
        origine: 'JBU.Tohoku (Sendai)',
        espece: 'dumortierii  C.Morr.',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Hemerocallis',
        date_plantation: '2001',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9db7f4b29f45447da3944d42a62bd13783a73260',
      fields: {
        origine: 'Mr.Bouet',
        espece: 'galpini Baker',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Kniphofia',
        date_plantation: '1989',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f2dc9f10098955af7726ffb34a5af713e71d0b2f',
      fields: {
        espece: 'dealbata',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(202, 206, 200, 1.00)',
            'rgba(104, 109, 80, 1.00)',
            'rgba(78, 89, 47, 1.00)',
          ],
          filename:
            'ip ville de nantes/acacia/acacia dealbata/acacia dealbata.jpg',
          width: 988,
          id: '08e497369dcc94ccb5ece77199b18fac',
          height: 768,
          thumbnail: true,
        },
        location: [47.227713, -1.574997],
        genre: 'Acacia',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.574997, 47.227713] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '10eff13af60cae392c485ae31802abedc10f5b8c',
      fields: {
        espece: 'sellowiana',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 140, 109, 1.00)',
            'rgba(127, 120, 85, 1.00)',
            'rgba(83, 66, 47, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/acca/acca sellowiana/acca sellowiana.jpg',
          width: 1024,
          id: 'a9a1e34aa111c8e8fd131e3318068bb4',
          height: 683,
          thumbnail: true,
        },
        location: [47.262542, -1.532303],
        genre: 'Acca',
        famille: 'Myrtaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532303, 47.262542] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '90ed7a7dc9ebe88f9dc8734cf8f3046e44dcf580',
      fields: {
        espece: 'platanoides',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 184, 221, 1.00)',
            'rgba(117, 111, 97, 1.00)',
            'rgba(95, 105, 60, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/acer/acer platanoides 'schwedleri'/acer platanoides 'schwedleri'.jpg",
          width: 576,
          id: '57599a74ff7dfa55e9e407a2d414a9e1',
          height: 768,
          thumbnail: true,
        },
        location: [47.22067, -1.54295],
        genre: 'Acer',
        cultivar: 'Schwedleri',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54295, 47.22067] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2f4e99a522ef3c85537f8a237453e3e8623b9768',
      fields: {
        espece: 'pseudoplatanus',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 181, 188, 1.00)',
            'rgba(108, 112, 62, 1.00)',
            'rgba(93, 106, 54, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/acer/acer pseudoplatanus 'nizetii'/acer pseudoplatanus 'nizetii' (2).jpg",
          width: 576,
          id: '7e6422a3bc15d365dee3b01ec551b29a',
          height: 768,
          thumbnail: true,
        },
        location: [47.22067, -1.543295],
        genre: 'Acer',
        cultivar: 'Nizetii',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543295, 47.22067] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b95590a900aa2e3667a957edde36740189256b95',
      fields: {
        espece: 'saccharinum',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(185, 190, 169, 1.00)',
            'rgba(108, 117, 75, 1.00)',
            'rgba(97, 99, 87, 1.00)',
          ],
          filename:
            'ip ville de nantes/acer/acer saccharinum/acer saccharinum.jpg',
          width: 1024,
          id: '9362285614c47e5247b6b4278b8c5e20',
          height: 768,
          thumbnail: true,
        },
        location: [47.230072, -1.571575],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.571575, 47.230072] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fc7b244c16c0915d4fc4ab4f8b72c1f17b81c373',
      fields: {
        espece: 'x woerlitzensis',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 108, 62, 1.00)',
            'rgba(154, 144, 76, 1.00)',
            'rgba(149, 147, 77, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/aesculus/aesculus x woerlitzensis/aesculus x woerlitzensis (2).jpg',
          width: 576,
          id: '4934d51f645c7bf38c68bacf41c2ea38',
          height: 768,
          thumbnail: true,
        },
        location: [47.219538, -1.541337],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541337, 47.219538] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'edaa2115773e22442224b2588e45615bac147c98',
      fields: {
        espece: 'hippocastanum',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(205, 214, 207, 1.00)',
            'rgba(117, 127, 101, 1.00)',
            'rgba(90, 97, 61, 1.00)',
          ],
          filename:
            'ip ville de nantes/aesculus/aesculus hippocastanum/aesculus hippocastanum (2).jpg',
          width: 1024,
          id: '994d21e461762316f86494094db73119',
          height: 768,
          thumbnail: true,
        },
        location: [47.216283, -1.548175],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.548175, 47.216283] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9bc17d3d8848e77a2c1e37b303a549a566b01d82',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'triloba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 138, 92, 1.00)',
            'rgba(132, 115, 49, 1.00)',
            'rgba(92, 87, 39, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/asimina/asimina triloba/asimina triloba (10).jpg',
          width: 1024,
          id: '1cc4798b092ab983b2bbef509755b212',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(177, 151, 132, 1.00)',
            'rgba(121, 98, 48, 1.00)',
            'rgba(70, 64, 32, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/asimina/asimina triloba/asimina triloba (11).jpg',
          width: 972,
          id: '1ff2164be70561235865684673bc6e53',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 159, 203, 1.00)',
            'rgba(144, 149, 149, 1.00)',
            'rgba(110, 91, 64, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/asimina/asimina triloba/asimina triloba (1).jpg',
          width: 576,
          id: '24344c9994811a302a365ddae12fa80b',
          height: 768,
          thumbnail: true,
        },
        location: [47.229067, -1.50893],
        genre: 'Asimina',
        famille: 'Annonaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.50893, 47.229067] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ec8ee2bce1299bffe5fd68da054ec4a95a7453f3',
      fields: {
        genre: 'Buddleja',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 126, 80, 1.00)',
            'rgba(121, 126, 99, 1.00)',
            'rgba(86, 106, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/buddleja scrophulariaceae/buddleja alternifolia/buddleja alternifolia.jpg',
          width: 1024,
          id: '1caaa6a252eba438481492b7f13ebace',
          height: 753,
          thumbnail: true,
        },
        location: [47.269975, -1.582062],
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582062, 47.269975] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4c33a06ea5922c79f132352a604a86e6bea0cae4',
      fields: {
        espece: 'occidentalis',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 134, 109, 1.00)',
            'rgba(113, 127, 81, 1.00)',
            'rgba(60, 73, 33, 1.00)',
          ],
          filename:
            'ip parc de proce/calycanthus/calycanthus occidentalis/calycanthus occidentalis.jpg',
          width: 1024,
          id: '7afa9feaa52c28a4e3975e3243d95c01',
          height: 768,
          thumbnail: true,
        },
        location: [47.223313, -1.584703],
        genre: 'Calycanthus',
        famille: 'Calycanthaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584703, 47.223313] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '08dd4302c9b360a232f49c51389e93a7a134c8c8',
      fields: {
        genre: 'Calycanthus',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 124, 96, 1.00)',
            'rgba(96, 101, 78, 1.00)',
            'rgba(54, 61, 42, 1.00)',
          ],
          filename:
            "ip ville de nantes/calycanthus/calycanthus 'venus'/calycanthus 'venus'.jpg",
          width: 1024,
          id: '669bbfb61da50e7015314f698d8643c9',
          height: 683,
          thumbnail: true,
        },
        cultivar: 'Venus',
        famille: 'Calycanthaceae',
      },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6e925aeb5abf78502f11e42ee0d63f10af46c02a',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(65, 76, 69, 1.00)',
            'rgba(100, 83, 88, 1.00)',
            'rgba(73, 63, 64, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'dewatairin'/camellia japonica 'dewatairin'.jpg",
          width: 1024,
          id: '12c95829d5b80c5e444d204e1473cdf1',
          height: 683,
          thumbnail: true,
        },
        location: [47.219225, -1.541025],
        genre: 'Camellia',
        cultivar: 'Dewatairin',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541025, 47.219225] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e9fb4d542a049143373ef6acb22d564cc84a6472',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 99, 91, 1.00)',
            'rgba(108, 62, 65, 1.00)',
            'rgba(62, 49, 45, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'lady de saumarez'/camellia japonica 'lady de saumarez'.jpg",
          width: 1024,
          id: '37a9a1ffc6409b4e2b0a482d348ee7e0',
          height: 683,
          thumbnail: true,
        },
        location: [47.220247, -1.541681],
        genre: 'Camellia',
        cultivar: 'Lady de Saumarez',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541681, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7ae10318124bc8bf9803fabd646ae33c2a58d02c',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 121, 114, 1.00)',
            'rgba(119, 107, 108, 1.00)',
            'rgba(74, 75, 70, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'paul jones supreme'/camellia japonica 'paul jones supreme'.jpg",
          width: 1024,
          id: '4ef7f12da05cbb0ad2194e4a25778d2c',
          height: 683,
          thumbnail: true,
        },
        location: [47.219225, -1.541025],
        genre: 'Camellia',
        cultivar: 'Paul Jones Supreme',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541025, 47.219225] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '014db3e997123735a5d5d5b0fcaea00bfd467c65',
      fields: {
        espece: 'sasanqua',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 154, 150, 1.00)',
            'rgba(73, 87, 77, 1.00)',
            'rgba(79, 83, 78, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia sasanqua 'hinode-gumo'/camellia sasanqua 'hinode-gumo'.jpg",
          width: 512,
          id: 'e3fc3231690c698e92af0f6be83b4cd7',
          height: 768,
          thumbnail: true,
        },
        location: [47.220247, -1.54168],
        genre: 'Camellia',
        cultivar: 'Hinode-gumo',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54168, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '813834b8e0fb91fac7e97c780a7c3a656923fa18',
      fields: {
        espece: 'sasanqua',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(46, 45, 40, 1.00)',
            'rgba(89, 67, 72, 1.00)',
            'rgba(100, 83, 84, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia sasanqua 'totenko'/camellia sasanqua 'totenko'.jpg",
          width: 1024,
          id: '5f1b1e781b43b1256b27d65de498f319',
          height: 683,
          thumbnail: true,
        },
        location: [47.220247, -1.54168],
        genre: 'Camellia',
        cultivar: 'T\u00f4tenko',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54168, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7b06084bb800f0c6e439f42bd9b3322a3e7e11d7',
      fields: {
        espece: 'x williamsii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 134, 134, 1.00)',
            'rgba(105, 99, 71, 1.00)',
            'rgba(63, 66, 37, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia x williamsii 'demure'/camellia x williamsii 'demure' (2).jpg",
          width: 1024,
          id: 'd21b9c9f92f8985d7de62d19b5828319',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 66, 67, 1.00)',
            'rgba(110, 92, 85, 1.00)',
            'rgba(43, 36, 20, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia x williamsii 'demure'/camellia x williamsii 'demure' (1).jpg",
          width: 1024,
          id: '431d9587ef5da3f3f0ffa82d2a1446bb',
          height: 677,
          thumbnail: true,
        },
        location: [47.220247, -1.541681],
        genre: 'Camellia',
        cultivar: 'Demure',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541681, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6cb7d69b64b4a38835a086519dc95b168eb13cb8',
      fields: {
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(178, 189, 188, 1.00)',
            'rgba(121, 92, 78, 1.00)',
            'rgba(56, 64, 54, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/camellia/camellia azalea/camellia azalea.jpg',
          width: 1024,
          id: 'f1f42dfa6e9dd52b2df2cf540c1eb415',
          height: 683,
          thumbnail: true,
        },
        genre: 'Camellia',
        espece: 'azalea',
        famille: 'Theaceae',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
      },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '11d82301ab2079e47f06f931f88c16111940f9b2',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(69, 80, 40, 1.00)',
            'rgba(152, 99, 107, 1.00)',
            'rgba(71, 70, 47, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/camellia/camellia sasanqua 'hiryu'/camellia sasanqua 'hiryu' (3).jpg",
          width: 576,
          id: '89662505ea16cba19b88207d8304765a',
          height: 768,
          thumbnail: true,
        },
        espece: 'sasanqua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(198, 201, 186, 1.00)',
            'rgba(81, 93, 53, 1.00)',
            'rgba(86, 102, 56, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/camellia/camellia sasanqua 'hiryu'/camellia sasanqua 'hiryu' (2).jpg",
          width: 1024,
          id: '487ce191ab5ef0c6ae00e4d087a6ea93',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 134, 80, 1.00)',
            'rgba(118, 145, 73, 1.00)',
            'rgba(111, 137, 52, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/camellia/camellia sasanqua 'hiryu'/camellia sasanqua 'hiryu' (1).jpg",
          width: 576,
          id: '44606c528e577a76b20186219152c36f',
          height: 768,
          thumbnail: true,
        },
        location: [47.22765, -1.50865],
        genre: 'Camellia',
        cultivar: 'Hiry\u00fb',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.50865, 47.22765] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7d7e919f723994a8c04d42eb8ae3e0c37bd602d9',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 108, 93, 1.00)',
            'rgba(104, 108, 92, 1.00)',
            'rgba(94, 107, 90, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/camellia/camellia japonica 'mattie cole'/camellia japonica 'mattie cole' (2).jpg",
          width: 1024,
          id: 'e9ef5ddfe90ef7fac61e9a99d8dfa4a0',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(46, 53, 45, 1.00)',
            'rgba(125, 72, 75, 1.00)',
            'rgba(95, 67, 64, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/camellia/camellia japonica 'mattie cole'/camellia japonica 'mattie cole' (1).jpg",
          width: 1024,
          id: '213af0d107ffa696c1dc544be49260fe',
          height: 683,
          thumbnail: true,
        },
        location: [47.261337, -1.531662],
        genre: 'Camellia',
        cultivar: 'Mattie Cole',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531662, 47.261337] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9edf8e9952cc7dd37939c8f7ebdbfa247159bfdd',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'coreana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 122, 78, 1.00)',
            'rgba(119, 135, 73, 1.00)',
            'rgba(116, 133, 85, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/carpinus/carpinus coreana/carpinus coreana  (2).jpg',
          width: 1024,
          id: 'ba8588520cc4f5f745b07adaa48952d7',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 153, 96, 1.00)',
            'rgba(97, 107, 58, 1.00)',
            'rgba(74, 106, 44, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/carpinus/carpinus coreana/carpinus coreana  (3).jpg',
          width: 1024,
          id: '56441f89624393af9208adb0b2c6cc2a',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 115, 42, 1.00)',
            'rgba(91, 106, 49, 1.00)',
            'rgba(115, 146, 75, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/carpinus/carpinus coreana/carpinus coreana  (1).jpg',
          width: 1024,
          id: '42812acef93d305efa8da6b42c02fee7',
          height: 683,
          thumbnail: true,
        },
        location: [47.229887, -1.506863],
        genre: 'Carpinus',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.506863, 47.229887] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4f537b355eb7c33da1dee6c76586f008bbc96300',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 128, 66, 1.00)',
            'rgba(163, 146, 105, 1.00)',
            'rgba(106, 116, 79, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cercidiphyllum cercidiphyllaceae/cercidiphyllum japonicum/cercidiphyllum japonicum (3).jpg',
          width: 576,
          id: '559311255ec4f1147253ef411ecda6a8',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(209, 220, 221, 1.00)',
            'rgba(121, 122, 67, 1.00)',
            'rgba(77, 79, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cercidiphyllum cercidiphyllaceae/cercidiphyllum japonicum/cercidiphyllum japonicum (4).jpg',
          width: 576,
          id: '2066b3beaaa4912a1ca5b72d8a3ce5ce',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(173, 159, 120, 1.00)',
            'rgba(166, 122, 93, 1.00)',
            'rgba(159, 137, 123, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cercidiphyllum cercidiphyllaceae/cercidiphyllum japonicum/cercidiphyllum japonicum (2).jpg',
          width: 576,
          id: '84f22592497e4318f7141fdd88724a05',
          height: 768,
          thumbnail: true,
        },
        location: [47.269605, -1.585078],
        genre: 'Cercidiphyllum',
        famille: 'Cercidiphyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585078, 47.269605] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '52a59f8e1914ed5b043c864e9112e67d971fc71e',
      fields: {
        espece: 'siliquastrum',
        nom_du_site: 'Parc de la Gaudini\u00e8re',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(189, 180, 185, 1.00)',
            'rgba(116, 99, 73, 1.00)',
            'rgba(88, 100, 39, 1.00)',
          ],
          filename:
            'ip parc de la gaudiniere/cercis/cercis siliquastrum/cercis siliquastrum.jpg',
          width: 1024,
          id: '66e88a7f9ca8a4207a596ce56d478797',
          height: 683,
          thumbnail: true,
        },
        location: [47.242792, -1.57925],
        genre: 'Cercis',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.57925, 47.242792] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '75672ce8129ae6369b299bdb0e03a9b502b29261',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'camphora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 114, 92, 1.00)',
            'rgba(149, 139, 119, 1.00)',
            'rgba(140, 131, 103, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cinnamomum/cinnamomum camphora/cinnamomum camphora (2).jpg',
          width: 576,
          id: 'e9e699d21122a8bc8aac6fdee49cfc36',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 157, 149, 1.00)',
            'rgba(109, 108, 76, 1.00)',
            'rgba(91, 85, 54, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cinnamomum/cinnamomum camphora/cinnamomum camphora (3).jpg',
          width: 576,
          id: 'c322712330b8937df140c3d0d4d1dd2f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 119, 85, 1.00)',
            'rgba(142, 111, 52, 1.00)',
            'rgba(132, 118, 65, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cinnamomum/cinnamomum camphora/cinnamomum camphora (1).jpg',
          width: 576,
          id: '7546ed4482b4c7047fdf0c43a8a06100',
          height: 768,
          thumbnail: true,
        },
        location: [47.221028, -1.542658],
        genre: 'Cinnamomum',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542658, 47.221028] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0ab5f84ad3cb5eecc5f1e1fa5ac5512707cf08ca',
      fields: {
        nom_du_site: 'Autre site',
        espece: 'trichotomum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(23, 46, 24, 1.00)',
            'rgba(66, 84, 57, 1.00)',
            'rgba(68, 87, 54, 1.00)',
          ],
          filename:
            'ip ville de nantes/clerodendrum/clerodendrum trichotomum/clerodendrum trichotomum (2).jpg',
          width: 576,
          id: 'b8716160d7045d51d547a6c3baa14a89',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 121, 103, 1.00)',
            'rgba(81, 102, 68, 1.00)',
            'rgba(69, 95, 42, 1.00)',
          ],
          filename:
            'ip ville de nantes/clerodendrum/clerodendrum trichotomum/clerodendrum trichotomum.jpg',
          width: 1024,
          id: '8953f5e56d97442f8f4475b2dc96b1d5',
          height: 742,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 116, 85, 1.00)',
            'rgba(62, 92, 58, 1.00)',
            'rgba(37, 60, 31, 1.00)',
          ],
          filename:
            'ip ville de nantes/clerodendrum/clerodendrum trichotomum/clerodendrum trichotomum (1).jpg',
          width: 576,
          id: 'dc986287786d387ca3aa3a2b18f30af8',
          height: 768,
          thumbnail: true,
        },
        location: [47.26383, -1.5406],
        genre: 'Clerodendrum',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5406, 47.26383] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '34cccef96e7c6224662f5309d05ced897881f9b5',
      fields: {
        espece: 'barbinervis',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 144, 99, 1.00)',
            'rgba(91, 124, 78, 1.00)',
            'rgba(71, 94, 67, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/clethra/clethra barbinervis/clethra barbinervis (1).jpg',
          width: 512,
          id: 'a53c4c86999b58f820611fd46f671188',
          height: 768,
          thumbnail: true,
        },
        location: [47.219047, -1.541855],
        genre: 'Clethra',
        famille: 'Clethraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541855, 47.219047] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '72d82f1d02d3429186f7fdd0584e732d53acd7e0',
      fields: {
        espece: 'controversa',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 194, 215, 1.00)',
            'rgba(114, 128, 97, 1.00)',
            'rgba(66, 72, 48, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/cornus/cornus controversa 'variegata'/cornus controversa 'variegata'.jpg",
          width: 576,
          id: 'da0593c7ea5364b8e3c363d240c1c949',
          height: 768,
          thumbnail: true,
        },
        location: [47.21912, -1.541592],
        genre: 'Cornus',
        cultivar: 'Variegata',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541592, 47.21912] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd4db1ebe220683ca786a08c478c59a4170a185f5',
      fields: {
        espece: 'controversa',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 117, 70, 1.00)',
            'rgba(126, 148, 87, 1.00)',
            'rgba(79, 105, 42, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cornus/cornus controversa/cornus controversa.jpg',
          width: 1024,
          id: '1be341c7b4c6a5d533cff6b455c278d1',
          height: 683,
          thumbnail: true,
        },
        location: [47.219003, -1.541583],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541583, 47.219003] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2604965c9424077bc037137cefe7a4d8232c30a2',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'florida',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 155, 105, 1.00)',
            'rgba(147, 151, 74, 1.00)',
            'rgba(133, 128, 73, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cornus/cornus florida/cornus florida (2).jpg',
          width: 576,
          id: '3c544abb9a921902eaf1d881e4a03ccc',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 118, 85, 1.00)',
            'rgba(154, 148, 110, 1.00)',
            'rgba(76, 63, 45, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cornus/cornus florida/cornus florida (3).jpg',
          width: 576,
          id: 'cae91fe23e4fc0097c1a2a4eefa1928e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 159, 92, 1.00)',
            'rgba(140, 144, 60, 1.00)',
            'rgba(129, 131, 47, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cornus/cornus florida/cornus florida (1).jpg',
          width: 576,
          id: '785c0f3fbfa1acfc58c044cbe6a911dd',
          height: 768,
          thumbnail: true,
        },
        location: [47.218928, -1.541588],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541588, 47.218928] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a2835c78c0dfb3c5b1dba2cd9988f39f4828e86d',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 126, 105, 1.00)',
            'rgba(99, 108, 84, 1.00)',
            'rgba(92, 100, 82, 1.00)',
          ],
          filename:
            "ip parc de proce/cornus/cornus alternifolia 'argentea'/cornus alternifolia 'argentea' (3).jpg",
          width: 1024,
          id: '30565668dd265595ae10f7e37086123a',
          height: 683,
          thumbnail: true,
        },
        espece: 'alternifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 116, 92, 1.00)',
            'rgba(116, 125, 96, 1.00)',
            'rgba(78, 87, 68, 1.00)',
          ],
          filename:
            "ip parc de proce/cornus/cornus alternifolia 'argentea'/cornus alternifolia 'argentea' (2).jpg",
          width: 1024,
          id: 'f8e1d5f909bc0376a99032cb4dc8296b',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 137, 116, 1.00)',
            'rgba(95, 93, 72, 1.00)',
            'rgba(29, 32, 27, 1.00)',
          ],
          filename:
            "ip parc de proce/cornus/cornus alternifolia 'argentea'/cornus alternifolia 'argentea' (1).jpg",
          width: 628,
          id: '48f9b6e12749479505ea2aef5c4895a5',
          height: 768,
          thumbnail: true,
        },
        location: [47.222933, -1.58477],
        genre: 'Cornus',
        cultivar: 'Argentea',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58477, 47.222933] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '929ed186d04b4ee2760f41abfa868c437dfe4252',
      fields: {
        espece: 'florida f. rubra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 121, 84, 1.00)',
            'rgba(116, 122, 94, 1.00)',
            'rgba(63, 77, 38, 1.00)',
          ],
          filename:
            'ip parc de proce/cornus/cornus florida f. rubra/cornus florida f. rubra (6).jpg',
          width: 1024,
          id: '27d06e1592281d4c2e47d352339bd11a',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 145, 121, 1.00)',
            'rgba(125, 116, 92, 1.00)',
            'rgba(69, 76, 40, 1.00)',
          ],
          filename:
            'ip parc de proce/cornus/cornus florida f. rubra/cornus florida f. rubra (5).jpg',
          width: 1024,
          id: '43250ef9f26aa03931af1265f7aaec76',
          height: 768,
          thumbnail: true,
        },
        location: [47.225758, -1.581587],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581587, 47.225758] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a17e1bc0254fa75471b321dc347e47d8b2a684a4',
      fields: {
        espece: 'pauciflora',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(52, 57, 46, 1.00)',
            'rgba(118, 120, 84, 1.00)',
            'rgba(123, 139, 77, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/corylopsis/corylopsis pauciflora/corylopsis pauciflora.jpg',
          width: 576,
          id: '56d84731e87fb7653f32b0c09c96c86c',
          height: 768,
          thumbnail: true,
        },
        location: [47.260933, -1.532872],
        genre: 'Corylopsis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532872, 47.260933] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f8518998c88abe286bdb82794ea42bec3fd4de9f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 172, 140, 1.00)',
            'rgba(86, 118, 74, 1.00)',
            'rgba(92, 94, 71, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/daphniphyllum daphniphyllaceae/daphniphyllum macropodum 'nanum'/daphniphyllum macropodum 'nanum'  (2).jpg",
          width: 576,
          id: 'd317c136487226056738ca48299adf13',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 136, 37, 1.00)',
            'rgba(141, 160, 41, 1.00)',
            'rgba(106, 116, 46, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/daphniphyllum daphniphyllaceae/daphniphyllum macropodum 'nanum'/daphniphyllum macropodum 'nanum' (1).jpg",
          width: 576,
          id: 'd8a330dc3009037fec25a949e34fd8a1',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 172, 143, 1.00)',
            'rgba(119, 124, 92, 1.00)',
            'rgba(86, 87, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/daphniphyllum daphniphyllaceae/daphniphyllum macropodum 'nanum'/daphniphyllum macropodum 'nanum'  (1).jpg",
          width: 576,
          id: 'd1fd32596cbb8a55b49dc1eae7b4b182',
          height: 768,
          thumbnail: true,
        },
        location: [47.271297, -1.586622],
        genre: 'Daphniphyllum',
        cultivar: 'Nanum',
        famille: 'Daphniphyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586622, 47.271297] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '16f8b64c60c5f49c808680dc56b2e3ef97b80ac2',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'kaki',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 106, 35, 1.00)',
            'rgba(110, 133, 66, 1.00)',
            'rgba(73, 90, 55, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/diospyros/diospyros kaki/diospyros kaki (2).jpg',
          width: 576,
          id: '08f9672a048a1a57f419c32538532b50',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 120, 81, 1.00)',
            'rgba(142, 162, 121, 1.00)',
            'rgba(110, 127, 82, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/diospyros/diospyros kaki/diospyros kaki (3).jpg',
          width: 576,
          id: '7c923cc8f3f7c38108aacd4661abe8b8',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 129, 90, 1.00)',
            'rgba(128, 149, 114, 1.00)',
            'rgba(117, 135, 92, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/diospyros/diospyros kaki/diospyros kaki (1).jpg',
          width: 576,
          id: '891309a6354c960e49c134caef192294',
          height: 768,
          thumbnail: true,
        },
        location: [47.230272, -1.506555],
        genre: 'Diospyros',
        famille: 'Ebenaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.506555, 47.230272] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd147d95f42a87f4280d64d96af5c43bebd53e58a',
      fields: {
        espece: 'cercidifolius',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 133, 105, 1.00)',
            'rgba(118, 124, 98, 1.00)',
            'rgba(102, 95, 77, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/disanthus/disanthus cercidifolius/disanthus cercidifolius (2).jpg',
          width: 1024,
          id: '9ffefac89b47cc7ddde9e4a4d9177af4',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 102, 86, 1.00)',
            'rgba(116, 87, 83, 1.00)',
            'rgba(108, 69, 72, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/disanthus/disanthus cercidifolius/disanthus cercidifolius (1).jpg',
          width: 1024,
          id: 'de4d882c0c5dc80eddb780eee0382605',
          height: 683,
          thumbnail: true,
        },
        location: [47.218787, -1.541533],
        genre: 'Disanthus',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541533, 47.218787] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2eb0b64d944278adba3970f9c44c7b0a189798f3',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 114, 57, 1.00)',
            'rgba(98, 104, 49, 1.00)',
            'rgba(106, 121, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/distylium hamamelidaceae/distylium racemosum/distylium racemosum (4).jpg',
          width: 1024,
          id: 'a4bb25535b726aae4fc357319f5b5595',
          height: 754,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 131, 71, 1.00)',
            'rgba(110, 113, 61, 1.00)',
            'rgba(93, 103, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/distylium hamamelidaceae/distylium racemosum/distylium racemosum (5).jpg',
          width: 1024,
          id: 'd3405140f8636df8e7d0a9572d83a544',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 139, 80, 1.00)',
            'rgba(107, 124, 46, 1.00)',
            'rgba(112, 130, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/distylium hamamelidaceae/distylium racemosum/distylium racemosum (1).jpg',
          width: 1024,
          id: '6bb1c7cd06ad375a27b5787347fa4fd1',
          height: 740,
          thumbnail: true,
        },
        location: [47.270703, -1.582795],
        genre: 'Distylium',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582795, 47.270703] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2020cde9f09e9bcf1279a668ff1137c0cb522bbe',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(193, 217, 219, 1.00)',
            'rgba(122, 119, 81, 1.00)',
            'rgba(95, 100, 49, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/distylium hamamelidaceae/distylium racemosum/distylium racemosum (3).jpg',
          width: 612,
          id: '7ec2f4d0e5230630eee86c26204774f4',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(169, 142, 117, 1.00)',
            'rgba(157, 110, 87, 1.00)',
            'rgba(153, 130, 95, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/distylium hamamelidaceae/distylium racemosum/distylium racemosum.jpg',
          width: 598,
          id: '6140b379adb949ae5db43017a54b0785',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 146, 122, 1.00)',
            'rgba(121, 146, 113, 1.00)',
            'rgba(135, 132, 111, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/distylium hamamelidaceae/distylium racemosum/distylium racemosum (2).jpg',
          width: 576,
          id: 'b08068a8794bc355369a2cd0475548f6',
          height: 768,
          thumbnail: true,
        },
        location: [47.271158, -1.587213],
        genre: 'Distylium',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587213, 47.271158] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f9c886e6155aa57a5b433cfc5000c23bddaaf188',
      fields: {
        espece: 'chrysantha',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(53, 48, 23, 1.00)',
            'rgba(151, 130, 85, 1.00)',
            'rgba(131, 111, 85, 1.00)',
          ],
          filename:
            "ip parc de proce/edgeworthia/edgeworthia chrysantha 'grandiflora'/edgeworthia chrysantha 'grandiflora'.jpg",
          width: 1024,
          id: 'f4fe058ab0af1a41e021a710ec30613b',
          height: 683,
          thumbnail: true,
        },
        location: [47.225883, -1.581975],
        genre: 'Edgeworthia',
        cultivar: 'Grandiflora',
        famille: 'Thymelaeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581975, 47.225883] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '930d5ac228d0c6702dbe2dd21a1d98e425cc8593',
      fields: {
        espece: 'chrysantha',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 149, 133, 1.00)',
            'rgba(100, 103, 80, 1.00)',
            'rgba(73, 70, 63, 1.00)',
          ],
          filename:
            'ip ville de nantes/edgeworthia/edgeworthia chrysantha/edgeworthia chrysantha (2).jpg',
          width: 1024,
          id: '127706b3d4812df3590f27f46ce671b5',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 128, 98, 1.00)',
            'rgba(101, 101, 89, 1.00)',
            'rgba(96, 88, 88, 1.00)',
          ],
          filename:
            'ip ville de nantes/edgeworthia/edgeworthia chrysantha/edgeworthia chrysantha (1).jpg',
          width: 512,
          id: 'b5fe74890b63981aad52b9079e61ad2c',
          height: 768,
          thumbnail: true,
        },
        location: [47.228138, -1.526075],
        genre: 'Edgeworthia',
        famille: 'Thymelaeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.526075, 47.228138] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bb1855755aa2b441ae221ce1a63e801fac8659c5',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 165, 164, 1.00)',
            'rgba(91, 98, 79, 1.00)',
            'rgba(100, 103, 78, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/eriobotrya/eriobotrya japonica/eriobotrya japonica.jpg',
          width: 676,
          id: '5bd0efa7fb4e47fbe135858eda6ee3cd',
          height: 768,
          thumbnail: true,
        },
        location: [47.22128, -1.54352],
        genre: 'Eriobotrya',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54352, 47.22128] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '718d2bbe6e68dc23fd724f937afa1f34edb0a778',
      fields: {
        espece: 'myrianthus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 150, 130, 1.00)',
            'rgba(97, 116, 75, 1.00)',
            'rgba(65, 79, 49, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/euonymus/euonymus myrianthus/euonymus myrianthus (4).jpg',
          width: 1024,
          id: 'e606ad1e605ee640293567ff6cac0d6d',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 120, 85, 1.00)',
            'rgba(89, 97, 46, 1.00)',
            'rgba(68, 87, 53, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/euonymus/euonymus myrianthus/euonymus myrianthus (3).jpg',
          width: 1024,
          id: 'fa03616d94244e2832405fcbb1447542',
          height: 683,
          thumbnail: true,
        },
        location: [47.262505, -1.529117],
        genre: 'Euonymus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529117, 47.262505] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8b67552d8831a57124c632c1eda899eb8142a787',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'polyandra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(169, 165, 157, 1.00)',
            'rgba(105, 107, 76, 1.00)',
            'rgba(104, 109, 68, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/euptelea/euptelea polyandra/euptelea polyandra (2).jpg',
          width: 576,
          id: 'ff05a285c5e0733e38c1933aec9ed788',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(179, 196, 153, 1.00)',
            'rgba(81, 110, 44, 1.00)',
            'rgba(61, 79, 40, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/euptelea/euptelea polyandra/euptelea polyandra.jpg',
          width: 576,
          id: '23b9906c108360169a7d52a372d2cfe5',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 128, 86, 1.00)',
            'rgba(144, 132, 90, 1.00)',
            'rgba(131, 120, 77, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/euptelea/euptelea polyandra/euptelea polyandra (1).jpg',
          width: 576,
          id: '7338c080c00f1ab29e00b9d97f2404f6',
          height: 768,
          thumbnail: true,
        },
        location: [47.21955, -1.541347],
        genre: 'Euptelea',
        famille: 'Eupteleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541347, 47.21955] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '87f28b68db944af598261b1c5889d60c28af4421',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'japonica (femelle)',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 147, 63, 1.00)',
            'rgba(128, 139, 63, 1.00)',
            'rgba(120, 136, 73, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/eurya/eurya japonica (femelle)/eurya japonica (femelle) (2).jpg',
          width: 576,
          id: 'ffb1e70ccf4c94bfd32d28d8ddb474b3',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(204, 204, 201, 1.00)',
            'rgba(118, 124, 84, 1.00)',
            'rgba(89, 87, 58, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/eurya/eurya japonica (femelle)/eurya japonica (femelle) (3).jpg',
          width: 1024,
          id: '32fbaf1f6989194c7834f9623546f7ab',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 166, 92, 1.00)',
            'rgba(117, 120, 67, 1.00)',
            'rgba(108, 121, 63, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/eurya/eurya japonica (femelle)/eurya japonica (femelle) (1).jpg',
          width: 576,
          id: '339e0253c90a9c84bb08e07adafd0250',
          height: 768,
          thumbnail: true,
        },
        location: [47.261203, -1.5339],
        genre: 'Eurya',
        famille: 'Pentaphylacaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5339, 47.261203] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5befa8033f7a55628fad614a3d2ef3aa90a57df9',
      fields: {
        espece: 'giraldii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 83, 57, 1.00)',
            'rgba(123, 119, 93, 1.00)',
            'rgba(111, 103, 83, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/exochorda/exochorda giraldii/exochorda giraldii (2).jpg',
          width: 576,
          id: '86ef604fc1e6c1b6c9951eac62ae270a',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 143, 98, 1.00)',
            'rgba(129, 135, 77, 1.00)',
            'rgba(141, 126, 100, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/exochorda/exochorda giraldii/exochorda giraldii (1).jpg',
          width: 576,
          id: '95ef6336bd6fee3422c22f1ad93bb231',
          height: 768,
          thumbnail: true,
        },
        location: [47.219675, -1.541422],
        genre: 'Exochorda',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541422, 47.219675] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4a3cf2917bf60c127d513553876d2013c95f1a75',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 123, 36, 1.00)',
            'rgba(136, 151, 43, 1.00)',
            'rgba(133, 144, 41, 1.00)',
          ],
          filename:
            "ip parc de proce/fagus/fagus sylvatica 'zlatia'/fagus sylvatica 'zlatia' (3).jpg",
          width: 576,
          id: '8f12bc7267adf044b9592dc749f68e9c',
          height: 768,
          thumbnail: true,
        },
        espece: 'sylvatica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 150, 42, 1.00)',
            'rgba(135, 154, 57, 1.00)',
            'rgba(110, 129, 59, 1.00)',
          ],
          filename:
            "ip parc de proce/fagus/fagus sylvatica 'zlatia'/fagus sylvatica 'zlatia' (2).jpg",
          width: 576,
          id: 'bc4639b1376ed49f151bb294e37853b2',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 153, 103, 1.00)',
            'rgba(119, 130, 82, 1.00)',
            'rgba(82, 85, 64, 1.00)',
          ],
          filename:
            "ip parc de proce/fagus/fagus sylvatica 'zlatia'/fagus sylvatica 'zlatia' (1).jpg",
          width: 576,
          id: '481118c9fdb8a939b88cdaca15f547f2',
          height: 768,
          thumbnail: true,
        },
        location: [47.222742, -1.584938],
        genre: 'Fagus',
        cultivar: 'Zlatia',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584938, 47.222742] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4017060f8fe2413aa4d5841735316238a9290a8f',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'simplex',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 150, 126, 1.00)',
            'rgba(144, 146, 123, 1.00)',
            'rgba(135, 137, 113, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/firmiana/firmiana simplex/firmiana simplex (3).jpg',
          width: 576,
          id: 'd886aedb201acd34fd82c077948b90ee',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(188, 189, 175, 1.00)',
            'rgba(128, 136, 102, 1.00)',
            'rgba(80, 99, 30, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/firmiana/firmiana simplex/firmiana simplex (4).jpg',
          width: 597,
          id: '9f510cea93ef2055d948c7d41ffbd318',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 119, 33, 1.00)',
            'rgba(131, 147, 54, 1.00)',
            'rgba(106, 123, 79, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/firmiana/firmiana simplex/firmiana simplex (1).jpg',
          width: 576,
          id: '328235ff475b03ea22d87914d4f3895d',
          height: 768,
          thumbnail: true,
        },
        location: [47.220108, -1.54233],
        genre: 'Firmiana',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54233, 47.220108] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5a09a34a14257a42570a943d9e2b4fd7ecf8b016',
      fields: {
        espece: 'simplex',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 124, 171, 1.00)',
            'rgba(95, 120, 147, 1.00)',
            'rgba(88, 114, 150, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/firmiana/firmiana simplex/firmiana simplex.jpg',
          width: 572,
          id: '7a04ef8f47f775147546cdeb77fa9dfa',
          height: 768,
          thumbnail: true,
        },
        location: [47.264462, -1.535275],
        genre: 'Firmiana',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535275, 47.264462] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '26a565661bdd2e1c6f5c3a5c9688923ef815400b',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 135, 69, 1.00)',
            'rgba(129, 133, 91, 1.00)',
            'rgba(148, 135, 89, 1.00)',
          ],
          filename:
            "ip ville de nantes/fraxinus/fraxinus excelsior 'jaspidea'/fraxinus excelsior 'jaspidea' .jpg",
          width: 576,
          id: '48d179472da1bdbf4319a53c48ac9c36',
          height: 768,
          thumbnail: true,
        },
        espece: 'excelsior',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 178, 189, 1.00)',
            'rgba(73, 94, 74, 1.00)',
            'rgba(61, 64, 53, 1.00)',
          ],
          filename:
            "ip ville de nantes/fraxinus/fraxinus excelsior 'jaspidea'/fraxinus excelsior 'jaspidea' (2).jpg",
          width: 1024,
          id: 'a96d43b871c01295326d1341d288e8d2',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 116, 111, 1.00)',
            'rgba(112, 115, 100, 1.00)',
            'rgba(125, 116, 105, 1.00)',
          ],
          filename:
            "ip ville de nantes/fraxinus/fraxinus excelsior 'jaspidea'/fraxinus excelsior 'jaspidea' (1).jpg",
          width: 576,
          id: 'ceec3c3f88385fa408ab37fabcc1176a',
          height: 768,
          thumbnail: true,
        },
        location: [47.234247, -1.5362],
        genre: 'Fraxinus',
        cultivar: 'Jaspidea',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5362, 47.234247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0de8b3960ab849658f14f5ffc32d08fa43983ec2',
      fields: {
        espece: 'californicum',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(204, 207, 199, 1.00)',
            'rgba(104, 109, 81, 1.00)',
            'rgba(75, 91, 41, 1.00)',
          ],
          filename:
            'ip ville de nantes/fremontodendron/fremontodendron californicum/fremontodendron californicum.jpg',
          width: 1024,
          id: '77f1f4f78be8c9cf7a81d7edd086f14e',
          height: 768,
          thumbnail: true,
        },
        location: [47.226637, -1.581],
        genre: 'Fremontodendron',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581, 47.226637] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8627b448dcdab5c9f358def56586ec4f0a3593b3',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'triacanthos',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 127, 127, 1.00)',
            'rgba(126, 123, 122, 1.00)',
            'rgba(115, 112, 109, 1.00)',
          ],
          filename:
            'ip parc de proce/gleditsia/gleditsia triacanthos/gleditsia triacanthos  (2).jpg',
          width: 576,
          id: '3963019aa2e967c4ff0a61cd204b3f91',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 115, 77, 1.00)',
            'rgba(103, 115, 84, 1.00)',
            'rgba(125, 133, 105, 1.00)',
          ],
          filename:
            'ip parc de proce/gleditsia/gleditsia triacanthos/gleditsia triacanthos  (3).jpg',
          width: 576,
          id: '82d48fa3c4564cb4c89d2e6a68b78822',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 164, 112, 1.00)',
            'rgba(115, 131, 93, 1.00)',
            'rgba(73, 82, 50, 1.00)',
          ],
          filename:
            'ip parc de proce/gleditsia/gleditsia triacanthos/gleditsia triacanthos  (1).jpg',
          width: 576,
          id: 'aa3ad750d0acfa2f0a5e243b6c423df8',
          height: 768,
          thumbnail: true,
        },
        location: [47.225925, -1.581958],
        genre: 'Gleditsia',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581958, 47.225925] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1867d40a6feec6da2cde5f9b2a73a893664d2b26',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'dulcis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(188, 211, 217, 1.00)',
            'rgba(113, 123, 107, 1.00)',
            'rgba(57, 62, 35, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/hovenia/hovenia dulcis/hovenia dulcis (4).jpg',
          width: 576,
          id: '2cc88f84d9b0c07b6c961b4bc4e096c8',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(202, 205, 197, 1.00)',
            'rgba(106, 117, 87, 1.00)',
            'rgba(46, 57, 26, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/hovenia/hovenia dulcis/hovenia dulcis.jpg',
          width: 609,
          id: '29c5a1c049ecfd38b3949902335559e5',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 125, 66, 1.00)',
            'rgba(115, 129, 72, 1.00)',
            'rgba(103, 125, 67, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/hovenia/hovenia dulcis/hovenia dulcis (3).jpg',
          width: 576,
          id: 'f098d903cacab5b6681cd56b61ff5773',
          height: 768,
          thumbnail: true,
        },
        location: [47.220438, -1.544067],
        genre: 'Hovenia',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544067, 47.220438] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '463516291de2f3f6c45c658346cc4227bae26961',
      fields: {
        espece: 'polycarpa',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 126, 89, 1.00)',
            'rgba(142, 128, 89, 1.00)',
            'rgba(162, 140, 108, 1.00)',
          ],
          filename:
            'ip parc de proce/idesia/idesia polycarpa/idesia polycarpa.jpg',
          width: 576,
          id: 'dd4d93a4605f90159eec8ecc17e5eba9',
          height: 768,
          thumbnail: true,
        },
        location: [47.223113, -1.581272],
        genre: 'Idesia',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581272, 47.223113] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '23ee42bf8c78c85d69aa1629337490b80b2bee4a',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 89, 65, 1.00)',
            'rgba(116, 127, 102, 1.00)',
            'rgba(106, 95, 97, 1.00)',
          ],
          filename:
            "ip parc de proce/ilex/ilex aquifolium 'argentea marginata pendula'/ilex aquifolium 'argentea marginata pendula' (3).jpg",
          width: 576,
          id: '9235c0d30819e7829c02323922790a01',
          height: 768,
          thumbnail: true,
        },
        espece: 'aquifolium',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 122, 103, 1.00)',
            'rgba(123, 126, 117, 1.00)',
            'rgba(120, 118, 116, 1.00)',
          ],
          filename:
            "ip parc de proce/ilex/ilex aquifolium 'argentea marginata pendula'/ilex aquifolium 'argentea marginata pendula' (2).jpg",
          width: 576,
          id: '653d2d4327eda10e389f7792f6dcc20d',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 115, 107, 1.00)',
            'rgba(121, 129, 126, 1.00)',
            'rgba(94, 92, 88, 1.00)',
          ],
          filename:
            "ip parc de proce/ilex/ilex aquifolium 'argentea marginata pendula'/ilex aquifolium 'argentea marginata pendula' (1).jpg",
          width: 576,
          id: 'ffedc5a1f3c45ce192ce5a51cdd596da',
          height: 768,
          thumbnail: true,
        },
        location: [47.222833, -1.579867],
        genre: 'Ilex',
        cultivar: 'Argentea Marginata Pendula',
        famille: 'Aquifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.579867, 47.222833] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '736b5cc6376571eacb5bbd521665fada6ae4a266',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'anisatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 104, 63, 1.00)',
            'rgba(91, 116, 55, 1.00)',
            'rgba(68, 93, 34, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/illicium/illicium anisatum/illicium anisatum (2).jpg',
          width: 576,
          id: '29f84a7ad4b95353ae98410e35adac42',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 180, 156, 1.00)',
            'rgba(103, 132, 89, 1.00)',
            'rgba(101, 114, 85, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/illicium/illicium anisatum/illicium anisatum (3).jpg',
          width: 1024,
          id: '2a35644cc31bb9e7531a6137a5e0e4e9',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 131, 90, 1.00)',
            'rgba(96, 133, 75, 1.00)',
            'rgba(108, 137, 61, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/illicium/illicium anisatum/illicium anisatum (1).jpg',
          width: 576,
          id: '121aaf65127f4dffb174ce1a28d6d581',
          height: 768,
          thumbnail: true,
        },
        location: [47.219311, -1.542158],
        genre: 'Illicium',
        famille: 'Schisandraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542158, 47.219311] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '18b8032e026f9f5b2630cd20a4830a110e016392',
      fields: {
        espece: 'anisatum',
        nom_du_site: 'Parc de la Gaudini\u00e8re',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 134, 117, 1.00)',
            'rgba(108, 117, 73, 1.00)',
            'rgba(158, 142, 116, 1.00)',
          ],
          filename:
            'ip parc de la gaudiniere/illicium/illicium anisatum/illicium anisatum.jpg',
          width: 576,
          id: 'eca0f3a77a2b94594650d68cece2386b',
          height: 768,
          thumbnail: true,
        },
        location: [47.245792, -1.57963],
        genre: 'Illicium',
        famille: 'Schisandraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.57963, 47.245792] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8ee781518e1e828e424aa07b77497be20da37ae4',
      fields: {
        espece: 'nigra',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 173, 128, 1.00)',
            'rgba(100, 116, 63, 1.00)',
            'rgba(59, 77, 42, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/juglans/juglans nigra/juglans nigra.jpg',
          width: 621,
          id: '4c9c28df13d84bd2ebfc3fe84cdffb1a',
          height: 768,
          thumbnail: true,
        },
        location: [47.219158, -1.541342],
        genre: 'Juglans',
        famille: 'Juglandaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541342, 47.219158] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'edc37a733baa4d0b8b3c905056f4c674fe8b37fb',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 111, 84, 1.00)',
            'rgba(157, 120, 123, 1.00)',
            'rgba(81, 75, 55, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/kalmia/kalmia latifolia 'minuet'/kalmia latifolia 'minuet' (3).jpg",
          width: 1024,
          id: '46072c366cad54b7b5bb514ac1692c35',
          height: 768,
          thumbnail: true,
        },
        espece: 'latifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 152, 109, 1.00)',
            'rgba(113, 131, 76, 1.00)',
            'rgba(101, 128, 64, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/kalmia/kalmia latifolia 'minuet'/kalmia latifolia 'minuet' (2).jpg",
          width: 1024,
          id: 'b713871547bc9fbfb0dc441843d95bcd',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 148, 75, 1.00)',
            'rgba(111, 140, 65, 1.00)',
            'rgba(115, 142, 72, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/kalmia/kalmia latifolia 'minuet'/kalmia latifolia 'minuet' (1).jpg",
          width: 576,
          id: 'b32f6b01a0d855a66538e428b892bd31',
          height: 768,
          thumbnail: true,
        },
        location: [47.261703, -1.533283],
        genre: 'Kalmia',
        cultivar: 'Minuet',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533283, 47.261703] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ad5c2d26a85f4dfd3591217a756987c9e3309e34',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'chekiangensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(195, 205, 190, 1.00)',
            'rgba(79, 94, 61, 1.00)',
            'rgba(67, 75, 48, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/lagerstroemia/lagerstroemia chekiangensis/lagerstroemia chekiangensis (2).jpg',
          width: 1024,
          id: '4a9a96c41a2cb0e6b86ecaa903e83f5e',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 173, 176, 1.00)',
            'rgba(95, 110, 91, 1.00)',
            'rgba(47, 61, 42, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/lagerstroemia/lagerstroemia chekiangensis/lagerstroemia chekiangensis (3).jpg',
          width: 1024,
          id: '94bdef839f9a0af8f398ec6afe4ea116',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 124, 171, 1.00)',
            'rgba(100, 116, 151, 1.00)',
            'rgba(88, 108, 133, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/lagerstroemia/lagerstroemia chekiangensis/lagerstroemia chekiangensis (1).jpg',
          width: 1024,
          id: '9681279f2895820e6f8d6d60ef12fae2',
          height: 683,
          thumbnail: true,
        },
        location: [47.220897, -1.544747],
        genre: 'Lagerstroemia',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544747, 47.220897] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a0ee6bc4a7189670b91ef6d2369c6dfdab302ed0',
      fields: {
        espece: 'indica',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(234, 233, 230, 1.00)',
            'rgba(117, 120, 104, 1.00)',
            'rgba(102, 103, 94, 1.00)',
          ],
          filename:
            'ip ville de nantes/lagerstroemia/lagerstroemia indica/lagerstroemia indica.jpg',
          width: 1024,
          id: 'ac0c476308e1a3c72d7481ad41cb9960',
          height: 768,
          thumbnail: true,
        },
        location: [47.227497, -1.570313],
        genre: 'Lagerstroemia',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.570313, 47.227497] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1438717d00b00fa6a39bb1d7db17e1d74f436cb0',
      fields: {
        espece: 'obtusiloba',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 176, 165, 1.00)',
            'rgba(105, 119, 77, 1.00)',
            'rgba(94, 74, 62, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/lindera/lindera obtusiloba/lindera obtusiloba (3).jpg',
          width: 1024,
          id: '1fd05b3fd1d4687dd254fb8c275b7efa',
          height: 683,
          thumbnail: true,
        },
        location: [47.219513, -1.54412],
        genre: 'Lindera',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54412, 47.219513] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e957c10d5d008cd113dcf88d848e91a9513952f8',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'formosana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 139, 211, 1.00)',
            'rgba(105, 108, 125, 1.00)',
            'rgba(87, 73, 53, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/liquidambar/liquidambar formosana/liquidambar formosana (2).jpg',
          width: 1024,
          id: '96de732fc10ad6972aee337044d91b76',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 129, 163, 1.00)',
            'rgba(101, 90, 80, 1.00)',
            'rgba(87, 91, 97, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/liquidambar/liquidambar formosana/liquidambar formosana (3).jpg',
          width: 512,
          id: '99e3a4b5f5c5f0bd1bdbb6d53062192e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 164, 219, 1.00)',
            'rgba(101, 98, 82, 1.00)',
            'rgba(70, 72, 56, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/liquidambar/liquidambar formosana/liquidambar formosana (1).jpg',
          width: 512,
          id: '704589a746e002719f7ab48ca6014d58',
          height: 768,
          thumbnail: true,
        },
        location: [47.21893, -1.541168],
        genre: 'Liquidambar',
        famille: 'Altingiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541168, 47.21893] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'aad8835d740ca5947118b9d7f6064e41716c486e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 102, 68, 1.00)',
            'rgba(97, 126, 87, 1.00)',
            'rgba(100, 115, 89, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/liquidambar hamamelidaceae/liquidambar formosana/liquidambar formosana (2).jpg',
          width: 576,
          id: '29beccb1d75ea0ef9d6c6ec37ae574f0',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 102, 90, 1.00)',
            'rgba(159, 107, 116, 1.00)',
            'rgba(130, 122, 124, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/liquidambar hamamelidaceae/liquidambar formosana/liquidambar formosana (3).jpg',
          width: 576,
          id: '7d9c11d757fa6324070ad17d8e4d3d93',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 101, 62, 1.00)',
            'rgba(135, 125, 113, 1.00)',
            'rgba(106, 121, 101, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/liquidambar hamamelidaceae/liquidambar formosana/liquidambar formosana (1).jpg',
          width: 576,
          id: 'b4d7af97b271ae1f824986b58988cf90',
          height: 768,
          thumbnail: true,
        },
        location: [47.271608, -1.584592],
        genre: 'Liquidambar',
        famille: 'Altingiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584592, 47.271608] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c12f27baf6d8d8faac6fb45abee70b1e9664e597',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 117, 89, 1.00)',
            'rgba(97, 119, 88, 1.00)',
            'rgba(65, 97, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/liquidambar hamamelidaceae/liquidambar styraciflua 'frosty'/liquidambar styraciflua 'frosty'.jpg",
          width: 576,
          id: '9c6bf457d4972bcb93ccdccaacbb7f4b',
          height: 768,
          thumbnail: true,
        },
        location: [47.271958, -1.582587],
        genre: 'Liquidambar',
        cultivar: 'Frosty',
        famille: 'Altingiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582587, 47.271958] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b0c76645d7d410d3256e60aed85b9c639ff214b0',
      fields: {
        espece: 'tulipifera',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 116, 166, 1.00)',
            'rgba(117, 98, 61, 1.00)',
            'rgba(75, 68, 30, 1.00)',
          ],
          filename:
            'ip parc de proce/liriodendron/liriodendron tulipifera/liriodendron tulipifera (2).jpg',
          width: 512,
          id: '43fdf6709737958fcf8b414ccbd91a5a',
          height: 768,
          thumbnail: true,
        },
        location: [47.225078, -1.582817],
        genre: 'Liriodendron',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582817, 47.225078] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b8bf079f76faecc7f256a4ccf141ebe93ac2248d',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'amurensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 143, 134, 1.00)',
            'rgba(120, 130, 120, 1.00)',
            'rgba(123, 126, 122, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/maackia/maackia amurensis/maackia amurensis  (2).jpg',
          width: 576,
          id: '62801521389c68746abf9b1a0f368dca',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 155, 76, 1.00)',
            'rgba(97, 147, 49, 1.00)',
            'rgba(118, 160, 73, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/maackia/maackia amurensis/maackia amurensis (1).jpg',
          width: 1024,
          id: '89e4ad0bea07722898ae9ff1d706b9df',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 156, 150, 1.00)',
            'rgba(122, 132, 123, 1.00)',
            'rgba(105, 116, 104, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/maackia/maackia amurensis/maackia amurensis  (1).jpg',
          width: 576,
          id: '4c1bb51c0f5bbedd6fee73e0ec4c007e',
          height: 768,
          thumbnail: true,
        },
        location: [47.219912, -1.542595],
        genre: 'Maackia',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542595, 47.219912] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '080c21b3b8098c31303a5b2231850a14de048c91',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'pomifera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 160, 192, 1.00)',
            'rgba(135, 144, 101, 1.00)',
            'rgba(115, 114, 74, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/maclura/maclura pomifera/maclura pomifera (22).jpg',
          width: 1024,
          id: '33c4f56e18f00df6adb0e9e82ed65c7c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 139, 193, 1.00)',
            'rgba(118, 133, 149, 1.00)',
            'rgba(68, 70, 55, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/maclura/maclura pomifera/maclura pomifera (9).jpg',
          width: 1024,
          id: '6a2f31090a87d8c16fd53c182131be6e',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 96, 133, 1.00)',
            'rgba(82, 106, 141, 1.00)',
            'rgba(83, 94, 111, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/maclura/maclura pomifera/maclura pomifera (14).jpg',
          width: 512,
          id: 'a427b3db4ca7381e6ed347a338307fae',
          height: 768,
          thumbnail: true,
        },
        location: [47.227908, -1.508888],
        genre: 'Maclura',
        famille: 'Moraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508888, 47.227908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8ff0b664d8d4b925ce5f4bfeef57776eaac3da2e',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(210, 196, 203, 1.00)',
            'rgba(150, 120, 125, 1.00)',
            'rgba(100, 91, 57, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia 'heaven scent'/magnolia 'heaven scent' (2).jpg",
          width: 576,
          id: '6fbbc2d2588d0edd66606e38af5ab191',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(236, 230, 236, 1.00)',
            'rgba(157, 147, 145, 1.00)',
            'rgba(97, 95, 69, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia 'heaven scent'/magnolia 'heaven scent' (1).jpg",
          width: 1024,
          id: 'f4fcb0b3a74913cb609944bd538127f3',
          height: 768,
          thumbnail: true,
        },
        location: [47.222678, -1.58155],
        genre: 'Magnolia',
        cultivar: 'Heaven Scent',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58155, 47.222678] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '759c17cec1feeb60f5cb126d8d38aa49d3c939be',
      fields: {
        espece: 'x soulangeana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 96, 109, 1.00)',
            'rgba(124, 116, 122, 1.00)',
            'rgba(92, 92, 79, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia x soulangeana 'pickard's schmetterling'/magnolia x soulangeana 'pickard's schmetterling' (3).jpg",
          width: 576,
          id: '2575c865080425fd3d8cf3c5cf8db2b3',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 164, 204, 1.00)',
            'rgba(130, 148, 173, 1.00)',
            'rgba(54, 50, 42, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia x soulangeana 'pickard's schmetterling'/magnolia x soulangeana 'pickard's schmetterling' (2).jpg",
          width: 627,
          id: '6372984991c3eb8172f3f486b7a52005',
          height: 768,
          thumbnail: true,
        },
        location: [47.224408, -1.581112],
        genre: 'Magnolia',
        cultivar: "Pickard's Schmetterling",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581112, 47.224408] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a93c4a3fb88e6cb52d0d99fd54a31c86c9f2b965',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(51, 63, 30, 1.00)',
            'rgba(103, 115, 73, 1.00)',
            'rgba(64, 86, 41, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/magnolia/magnolia 'sundance'/magnolia 'sundance'.jpg",
          width: 1024,
          id: '4c509536c7027ea0def67190356bd452',
          height: 683,
          thumbnail: true,
        },
        location: [47.227533, -1.508425],
        genre: 'Magnolia',
        cultivar: 'Sundance',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508425, 47.227533] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5c75cd7d1cb097601e98e5a053142999c823a188',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'tripetala',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(64, 98, 33, 1.00)',
            'rgba(102, 145, 66, 1.00)',
            'rgba(86, 131, 50, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/magnolia/magnolia tripetala/magnolia tripetala (3).jpg',
          width: 1024,
          id: '0292549e99964d898d697f652cd7fdbf',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 99, 37, 1.00)',
            'rgba(117, 133, 74, 1.00)',
            'rgba(86, 104, 53, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/magnolia/magnolia tripetala/magnolia tripetala (4).jpg',
          width: 1024,
          id: 'bfc52c45c710600db6e04b1e7cb5f6c0',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 130, 63, 1.00)',
            'rgba(90, 133, 70, 1.00)',
            'rgba(99, 142, 76, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/magnolia/magnolia tripetala/magnolia tripetala (2).jpg',
          width: 512,
          id: 'df654b3bfe55287de9604e4931d68009',
          height: 768,
          thumbnail: true,
        },
        location: [47.229625, -1.50837],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.50837, 47.229625] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e4a0bcad3897ac870c09415ee3f91c4af15fdd1c',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 125, 115, 1.00)',
            'rgba(103, 110, 80, 1.00)',
            'rgba(82, 89, 59, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/magnolia/magnolia x foggii 'allspice'/magnolia x foggii 'allspice' (3).jpg",
          width: 1024,
          id: '0f1106e08098272a64e84e4f294ccc7d',
          height: 683,
          thumbnail: true,
        },
        espece: 'x foggii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 100, 59, 1.00)',
            'rgba(87, 101, 62, 1.00)',
            'rgba(76, 86, 52, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/magnolia/magnolia x foggii 'allspice'/magnolia x foggii 'allspice' (2).jpg",
          width: 1024,
          id: '1833446f5311351a5cd96b737b7ff340',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 148, 132, 1.00)',
            'rgba(93, 106, 71, 1.00)',
            'rgba(51, 68, 33, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/magnolia/magnolia x foggii 'allspice'/magnolia x foggii 'allspice' (1).jpg",
          width: 1024,
          id: 'd326c234192ec8460718a1f29a14c2a0',
          height: 683,
          thumbnail: true,
        },
        location: [47.228167, -1.508447],
        genre: 'Magnolia',
        cultivar: 'Allspice',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508447, 47.228167] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9f1d775e4159133e48e0da78604246b38c20f06d',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 135, 159, 1.00)',
            'rgba(98, 84, 98, 1.00)',
            'rgba(89, 47, 64, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'arou'/magnolia 'arou' (3).jpg",
          width: 1024,
          id: '56c88d6c331aea6e8687d1979250957f',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 130, 166, 1.00)',
            'rgba(99, 69, 94, 1.00)',
            'rgba(70, 83, 55, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'arou'/magnolia 'arou' (4).jpg",
          width: 1024,
          id: '20ba1fa5ae27d01a3db013896724db46',
          height: 631,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(188, 209, 230, 1.00)',
            'rgba(123, 99, 116, 1.00)',
            'rgba(79, 86, 65, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'arou'/magnolia 'arou' (1).jpg",
          width: 1024,
          id: 'ffcd98b5072ef2f67f563ccc66b5d888',
          height: 741,
          thumbnail: true,
        },
        location: [47.262978, -1.536053],
        genre: 'Magnolia',
        cultivar: 'Arou',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.536053, 47.262978] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6f873e9e192156fb964695e21c7734e5053c2e10',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(213, 217, 196, 1.00)',
            'rgba(151, 144, 115, 1.00)',
            'rgba(78, 84, 26, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'george henry kern'/magnolia 'george henry kern' (2).jpg",
          width: 576,
          id: 'e6c29979e100456e9001aa1aae6727a6',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 93, 46, 1.00)',
            'rgba(131, 131, 103, 1.00)',
            'rgba(78, 92, 27, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'george henry kern'/magnolia 'george henry kern' (1).jpg",
          width: 576,
          id: '9cb37717a89daa7a9b850f4d6311a50b',
          height: 768,
          thumbnail: true,
        },
        location: [47.261663, -1.534088],
        genre: 'Magnolia',
        cultivar: 'George Henry Kern',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534088, 47.261663] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '11df526b506b75985ef4cd72e790f46c6ae32911',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 130, 156, 1.00)',
            'rgba(117, 98, 96, 1.00)',
            'rgba(79, 73, 52, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'heaven scent'/magnolia 'heaven scent' (2).jpg",
          width: 1024,
          id: '31f2b25238e2f98c5424d53460169ed0',
          height: 683,
          thumbnail: true,
        },
        location: [47.261342, -1.532692],
        genre: 'Magnolia',
        cultivar: 'Heaven Scent',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532692, 47.261342] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd59f06d91dfe032d5fb3e733a6a4e02e169ceef8',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 100, 114, 1.00)',
            'rgba(117, 120, 141, 1.00)',
            'rgba(108, 106, 119, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'legacy'/magnolia 'legacy' (2).jpg",
          width: 1024,
          id: 'd78bece1ecc5a4d929cbc5b7c8091dbe',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 149, 192, 1.00)',
            'rgba(127, 130, 147, 1.00)',
            'rgba(57, 58, 59, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'legacy'/magnolia 'legacy' (3).jpg",
          width: 512,
          id: 'dd6acb041654890596e46413d884cd2b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 97, 99, 1.00)',
            'rgba(115, 112, 123, 1.00)',
            'rgba(126, 127, 144, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'legacy'/magnolia 'legacy' (1).jpg",
          width: 1024,
          id: '3a26684c58d78fe3b843050742405080',
          height: 683,
          thumbnail: true,
        },
        location: [47.262312, -1.528558],
        genre: 'Magnolia',
        cultivar: 'Legacy',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.528558, 47.262312] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ca43c82e864f3eb50beb9750cb12a71c0e7aa6f6',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 136, 168, 1.00)',
            'rgba(111, 112, 97, 1.00)',
            'rgba(92, 73, 53, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'lufer'/magnolia 'lufer' (2).jpg",
          width: 512,
          id: '23cb3d4880613c8162ca85d385dff423',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 109, 129, 1.00)',
            'rgba(107, 115, 115, 1.00)',
            'rgba(97, 96, 75, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'lufer'/magnolia 'lufer' (3).jpg",
          width: 1024,
          id: '84697f16a50a7d91ef2e0c9a7b51461c',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 104, 128, 1.00)',
            'rgba(114, 123, 117, 1.00)',
            'rgba(80, 77, 50, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'lufer'/magnolia 'lufer' (1).jpg",
          width: 1024,
          id: '153fda83a5b7c17161e4615431d3b82e',
          height: 683,
          thumbnail: true,
        },
        location: [47.261567, -1.530817],
        genre: 'Magnolia',
        cultivar: 'Lufer',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530817, 47.261567] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2d4b7d99a5f09c199839bdd6aa2c8dae96bea7c1',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 98, 117, 1.00)',
            'rgba(142, 147, 148, 1.00)',
            'rgba(94, 90, 70, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'manchu fan'/magnolia 'manchu fan' (2).jpg",
          width: 576,
          id: '3aaad97098c5091b97a774d89fc33d4f',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 158, 194, 1.00)',
            'rgba(136, 153, 168, 1.00)',
            'rgba(104, 96, 69, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'manchu fan'/magnolia 'manchu fan' (1).jpg",
          width: 576,
          id: 'a1f2c3bf02dd4a2af798c3a572a04296',
          height: 768,
          thumbnail: true,
        },
        location: [47.262942, -1.535712],
        genre: 'Magnolia',
        cultivar: 'Manchu Fan',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535712, 47.262942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '487a750723dcb9eddfabd8c851382e54a95bdcbb',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 101, 88, 1.00)',
            'rgba(155, 130, 127, 1.00)',
            'rgba(117, 100, 87, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'peppermint stick'/magnolia 'peppermint stick' (2).jpg",
          width: 1024,
          id: '397ea8702869781a7efa6c4852be9e35',
          height: 740,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 127, 169, 1.00)',
            'rgba(109, 100, 92, 1.00)',
            'rgba(77, 76, 47, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'peppermint stick'/magnolia 'peppermint stick' (3).jpg",
          width: 512,
          id: '18c29244cbf299922e009e28d6b69670',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 80, 77, 1.00)',
            'rgba(123, 109, 105, 1.00)',
            'rgba(102, 86, 77, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'peppermint stick'/magnolia 'peppermint stick' (1).jpg",
          width: 1024,
          id: 'ee1c46928f479115b09f2c54d0e4f358',
          height: 683,
          thumbnail: true,
        },
        location: [47.262388, -1.528553],
        genre: 'Magnolia',
        cultivar: 'Peppermint Stick',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.528553, 47.262388] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ab307d250b0595368632efb62b86fe989bfa2997',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 160, 188, 1.00)',
            'rgba(101, 104, 94, 1.00)',
            'rgba(94, 104, 48, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'petit chicon'/magnolia 'petit chicon' (2).jpg",
          width: 1024,
          id: 'fcfc88bc34c58b6ce6889e1f96549e39',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 83, 75, 1.00)',
            'rgba(111, 111, 81, 1.00)',
            'rgba(104, 112, 66, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'petit chicon'/magnolia 'petit chicon' (3).jpg",
          width: 1024,
          id: 'de01b6e24b0d7231591d89c582e040a8',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(65, 96, 150, 1.00)',
            'rgba(95, 116, 129, 1.00)',
            'rgba(82, 108, 138, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'petit chicon'/magnolia 'petit chicon' (1).jpg",
          width: 1024,
          id: '47dc36b5df8245df008c89ef7db5f790',
          height: 683,
          thumbnail: true,
        },
        location: [47.262067, -1.528972],
        genre: 'Magnolia',
        cultivar: 'Petit Chicon',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.528972, 47.262067] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5a58e53cfd7749070a7de6854a5932e54d7ae7a2',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 142, 75, 1.00)',
            'rgba(132, 136, 101, 1.00)',
            'rgba(78, 95, 19, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'pinkie'/magnolia 'pinkie' (2).jpg",
          width: 576,
          id: '9455d43d6cf7caee4a1342f2065d3f9f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 73, 43, 1.00)',
            'rgba(121, 140, 93, 1.00)',
            'rgba(110, 129, 79, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'pinkie'/magnolia 'pinkie' (3).jpg",
          width: 576,
          id: 'c47f31e98cca674d2951ea568cfb869f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(167, 172, 148, 1.00)',
            'rgba(90, 99, 52, 1.00)',
            'rgba(81, 89, 52, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'pinkie'/magnolia 'pinkie' (1).jpg",
          width: 1024,
          id: 'c92c73b3191cc10d76b36c96235c0d85',
          height: 768,
          thumbnail: true,
        },
        location: [47.261163, -1.53243],
        genre: 'Magnolia',
        cultivar: 'Pinkie',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53243, 47.261163] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c1cf80e5bce3f46d8ba70292d6e888fee6f34b5c',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 64, 51, 1.00)',
            'rgba(173, 142, 153, 1.00)',
            'rgba(121, 99, 102, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'star wars'/magnolia 'star wars' (2).jpg",
          width: 576,
          id: '0d0faa9eb092f382fe1466a4f9156b3e',
          height: 768,
          thumbnail: true,
        },
        location: [47.263188, -1.532812],
        genre: 'Magnolia',
        cultivar: 'Star Wars',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532812, 47.263188] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '45d2613c73a9d96aa2d199c5292c68cf556870ec',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 135, 137, 1.00)',
            'rgba(141, 134, 119, 1.00)',
            'rgba(74, 78, 31, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'tiffany'/magnolia 'tiffany' (2).jpg",
          width: 576,
          id: '78344ba972806acc98af8abf8f8749c0',
          height: 768,
          thumbnail: true,
        },
        location: [47.262017, -1.531578],
        genre: 'Magnolia',
        cultivar: 'Tiffany',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531578, 47.262017] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1928748c6c5c9e6a8fbe6270076608def11beff0',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 114, 115, 1.00)',
            'rgba(99, 97, 93, 1.00)',
            'rgba(54, 54, 32, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'titan'/magnolia 'titan' (4).jpg",
          width: 1024,
          id: 'ffa187ddda2b78bcf12bb2e5601170b4',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 89, 68, 1.00)',
            'rgba(97, 89, 86, 1.00)',
            'rgba(94, 88, 57, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'titan'/magnolia 'titan' (6).jpg",
          width: 1024,
          id: 'c637cd4afe7d2154cc0f23d7228a02ea',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 83, 79, 1.00)',
            'rgba(112, 101, 93, 1.00)',
            'rgba(66, 67, 46, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'titan'/magnolia 'titan' (1).jpg",
          width: 1024,
          id: 'dc1069793f3ac0a81ed075f4b0578b2a',
          height: 747,
          thumbnail: true,
        },
        location: [47.262655, -1.530987],
        genre: 'Magnolia',
        cultivar: 'Titan',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530987, 47.262655] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'eb319c45313898fd5a14690df03ee0a29d6fc676',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 115, 59, 1.00)',
            'rgba(104, 115, 65, 1.00)',
            'rgba(64, 72, 31, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia acuminata 'golden glow'/magnolia acuminata 'golden glow' (2).jpg",
          width: 576,
          id: '86d61e9e4ae6166fe51b6e45db0aa400',
          height: 768,
          thumbnail: true,
        },
        espece: 'acuminata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 194, 163, 1.00)',
            'rgba(76, 94, 41, 1.00)',
            'rgba(34, 43, 18, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia acuminata 'golden glow'/magnolia acuminata 'golden glow'  (2).jpg",
          width: 664,
          id: 'b9382d185fd97a752027a50e40588e09',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(177, 187, 159, 1.00)',
            'rgba(143, 150, 93, 1.00)',
            'rgba(72, 84, 44, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia acuminata 'golden glow'/magnolia acuminata 'golden glow'  (1).jpg",
          width: 576,
          id: '81b0de25d77a7f4055c8ff1b862ffeea',
          height: 768,
          thumbnail: true,
        },
        location: [47.26167, -1.53012],
        genre: 'Magnolia',
        cultivar: 'Golden Glow',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53012, 47.26167] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1eb8da13f81c09c8eb69a47b99dd07759fc5768b',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 112, 143, 1.00)',
            'rgba(129, 115, 135, 1.00)',
            'rgba(126, 123, 121, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia campbellii 'betty jessel'/magnolia campbellii 'betty jessel'  (3).jpg",
          width: 576,
          id: '99ebdd9a56a4288fcaafa5afc532396a',
          height: 768,
          thumbnail: true,
        },
        espece: 'campbellii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 131, 124, 1.00)',
            'rgba(139, 73, 89, 1.00)',
            'rgba(177, 154, 154, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia campbellii 'betty jessel'/magnolia campbellii 'betty jessel'  (2).jpg",
          width: 576,
          id: '270cfd8b9ed16f8cbc0aa43b2d5c8ec7',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(176, 143, 157, 1.00)',
            'rgba(147, 92, 110, 1.00)',
            'rgba(145, 99, 119, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia campbellii 'betty jessel'/magnolia campbellii 'betty jessel'  (1).jpg",
          width: 576,
          id: 'd3331f9df585def29ce1a2a3679706c8',
          height: 768,
          thumbnail: true,
        },
        location: [47.262503, -1.532463],
        genre: 'Magnolia',
        cultivar: 'Betty Jessel',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532463, 47.262503] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ad7d5c3a59b8a59987399580682d3014baea3517',
      fields: {
        espece: 'campbellii Alba Group',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 124, 140, 1.00)',
            'rgba(133, 142, 144, 1.00)',
            'rgba(111, 117, 113, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia campbellii alba group/magnolia campbellii alba group (2).jpg',
          width: 576,
          id: '14fc07cad3323ec446c6c37f6d54b0e3',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 174, 210, 1.00)',
            'rgba(122, 132, 137, 1.00)',
            'rgba(77, 73, 46, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia campbellii alba group/magnolia campbellii alba group (1).jpg',
          width: 576,
          id: 'f0ee64b6952c2d88f697be5e05c494d5',
          height: 768,
          thumbnail: true,
        },
        location: [47.262412, -1.535742],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535742, 47.262412] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cda9faaa1db7b4a2fcd6e40db573ce6d7e7565f7',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(75, 80, 61, 1.00)',
            'rgba(104, 111, 56, 1.00)',
            'rgba(111, 109, 58, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia doltsopa 'silver cloud'/magnolia doltsopa 'silver cloud' (3).jpg",
          width: 512,
          id: 'be69f2e7593b286d854fe38dc0258eed',
          height: 768,
          thumbnail: true,
        },
        espece: 'doltsopa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 107, 85, 1.00)',
            'rgba(84, 96, 73, 1.00)',
            'rgba(45, 61, 38, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia doltsopa 'silver cloud'/magnolia doltsopa 'silver cloud' (2).jpg",
          width: 1024,
          id: 'b53a0d59de45fa10ac9b70175d036b01',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 133, 119, 1.00)',
            'rgba(75, 88, 63, 1.00)',
            'rgba(68, 80, 55, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia doltsopa 'silver cloud'/magnolia doltsopa 'silver cloud' (1).jpg",
          width: 1024,
          id: '914fee8528e3bf24ad3155d735048f69',
          height: 683,
          thumbnail: true,
        },
        location: [47.261822, -1.534797],
        genre: 'Magnolia',
        cultivar: 'Silver Cloud',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534797, 47.261822] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e777e6c124ee68d58beb48f03c8e724626573cd2',
      fields: {
        espece: 'doltsopa',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 166, 98, 1.00)',
            'rgba(128, 149, 82, 1.00)',
            'rgba(104, 122, 60, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia doltsopa 'silver cloud'/magnolia doltsopa 'silver cloud'.jpg",
          width: 576,
          id: '3adc456a457a77398330440425531fb7',
          height: 768,
          thumbnail: true,
        },
        location: [47.261822, -1.534795],
        genre: 'Magnolia',
        cultivar: 'Silver Cloud',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534795, 47.261822] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f8f8c964f65118e5faae8ee6371d9926a498dbff',
      fields: {
        espece: 'salicifolia',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(217, 218, 223, 1.00)',
            'rgba(145, 146, 149, 1.00)',
            'rgba(71, 81, 35, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia salicifolia 'kewensis'/magnolia salicifolia 'kewensis'.jpg",
          width: 1024,
          id: '1f1c6b807202f12a3679978db673332a',
          height: 683,
          thumbnail: true,
        },
        location: [47.262088, -1.52935],
        genre: 'Magnolia',
        cultivar: 'Kewensis',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.52935, 47.262088] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '635e074d61196b3b9bb95418eab7c07b4511682d',
      fields: {
        espece: 'salicifolia',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 142, 175, 1.00)',
            'rgba(88, 90, 74, 1.00)',
            'rgba(75, 77, 46, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia salicifolia 'w.b. clarke'/magnolia salicifolia 'w.b. clarke' .jpg",
          width: 1024,
          id: '1b34cf296f8f34a0ad91d8a10e17b237',
          height: 683,
          thumbnail: true,
        },
        location: [47.262178, -1.531437],
        genre: 'Magnolia',
        cultivar: 'W.B. Clarke',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531437, 47.262178] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6b02c7f00981f8baa79c077f4a6195fc62fbe9d2',
      fields: {
        espece: 'salicifolia',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 164, 202, 1.00)',
            'rgba(119, 126, 127, 1.00)',
            'rgba(97, 94, 61, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia salicifolia 'wada's memory'/magnolia salicifolia 'wada's memory'.jpg",
          width: 576,
          id: '1a0a19658d831ffe88526de00bcda7e8',
          height: 768,
          thumbnail: true,
        },
        location: [47.262767, -1.530478],
        genre: 'Magnolia',
        cultivar: "Wada's Memory",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530478, 47.262767] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '74a45304d105c373dff56a474cf20a791caec4b5',
      fields: {
        espece: 'sprengeri var. diva',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 156, 190, 1.00)',
            'rgba(129, 137, 138, 1.00)',
            'rgba(102, 104, 44, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sprengeri var. diva 'double form'/magnolia sprengeri var. diva 'double form' (2).jpg",
          width: 576,
          id: 'ed3269d5d363d7af5e515de19dd91860',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 104, 123, 1.00)',
            'rgba(125, 127, 134, 1.00)',
            'rgba(97, 91, 92, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sprengeri var. diva 'double form'/magnolia sprengeri var. diva 'double form' (1).jpg",
          width: 576,
          id: '97199e949e1f9533851bd59e98118611',
          height: 768,
          thumbnail: true,
        },
        location: [47.264213, -1.535538],
        genre: 'Magnolia',
        cultivar: 'Double Form',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535538, 47.264213] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cfa4dfa078d1a8d65a748d6b62d187f5cf29ff5d',
      fields: {
        espece: 'stellata',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(36, 37, 33, 1.00)',
            'rgba(95, 84, 78, 1.00)',
            'rgba(83, 87, 60, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'dawn'/magnolia stellata 'dawn'.jpg",
          width: 1024,
          id: '452833434bef8261a3251581c0b346a4',
          height: 683,
          thumbnail: true,
        },
        location: [47.262763, -1.531858],
        genre: 'Magnolia',
        cultivar: 'Dawn',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531858, 47.262763] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1e12113a3637ca05adef8abfcf7fa020c2794722',
      fields: {
        espece: 'stellata',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 76, 58, 1.00)',
            'rgba(97, 102, 86, 1.00)',
            'rgba(83, 89, 71, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'starlite'/magnolia stellata 'starlite'.jpg",
          width: 1024,
          id: 'd783c6a6e5aa73e740f1b80beda0f317',
          height: 683,
          thumbnail: true,
        },
        location: [47.261297, -1.531767],
        genre: 'Magnolia',
        cultivar: 'Starlite',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531767, 47.261297] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '26215f5411449879b07ffdbb3fb4ddc660dc4983',
      fields: {
        espece: 'stellata',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 109, 150, 1.00)',
            'rgba(101, 104, 108, 1.00)',
            'rgba(68, 66, 41, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'wada's arboreal form'/magnolia stellata 'wada's arboreal form' (2).jpg",
          width: 1019,
          id: 'bed0d8fb5b6af1614f5e2997de5ab5ee',
          height: 768,
          thumbnail: true,
        },
        location: [47.262492, -1.530658],
        genre: 'Magnolia',
        cultivar: "Wada's Arboreal Form",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530658, 47.262492] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cb9725bc294eb9c4adf59ff9037d8f4e656f866e',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 90, 64, 1.00)',
            'rgba(94, 114, 53, 1.00)',
            'rgba(107, 118, 45, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x brooklynensis 'hattie carthan'/magnolia x brooklynensis 'hattie carthan' (3).jpg",
          width: 576,
          id: '72c1052d2870763f8830484dea02db87',
          height: 768,
          thumbnail: true,
        },
        espece: 'x brooklynensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(59, 68, 37, 1.00)',
            'rgba(138, 137, 68, 1.00)',
            'rgba(103, 111, 43, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x brooklynensis 'hattie carthan'/magnolia x brooklynensis 'hattie carthan' (2).jpg",
          width: 1024,
          id: '66fcd8022eafd6fd8875f5b63c451933',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 133, 53, 1.00)',
            'rgba(114, 137, 36, 1.00)',
            'rgba(118, 138, 30, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x brooklynensis 'hattie carthan'/magnolia x brooklynensis 'hattie carthan' (1).jpg",
          width: 576,
          id: 'deeeaf450d9bb107abd3a35564cca3e9',
          height: 768,
          thumbnail: true,
        },
        location: [47.263308, -1.53442],
        genre: 'Magnolia',
        cultivar: 'Hattie Carthan',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53442, 47.263308] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c32f77c6a7f81af16eccf66f866fc68797cef86b',
      fields: {
        espece: 'x foggii',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 115, 108, 1.00)',
            'rgba(83, 95, 80, 1.00)',
            'rgba(77, 88, 49, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x foggii 'allspice'/magnolia x foggii 'allspice'  (2).jpg",
          width: 1024,
          id: 'a7c58901611b4259bdea4845aec1e042',
          height: 683,
          thumbnail: true,
        },
        location: [47.261787, -1.53478],
        genre: 'Magnolia',
        cultivar: 'Allspice',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53478, 47.261787] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bbe46ebef9990f76196abf09a1895de457a2fae5',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 134, 100, 1.00)',
            'rgba(109, 117, 81, 1.00)',
            'rgba(47, 60, 22, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x foggii 'allspice'/magnolia x foggii 'allspice' (3).jpg",
          width: 576,
          id: 'e28aa8c48dac950c58943acbe89b5b13',
          height: 768,
          thumbnail: true,
        },
        espece: 'x foggii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 121, 171, 1.00)',
            'rgba(94, 106, 118, 1.00)',
            'rgba(82, 82, 66, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x foggii 'allspice'/magnolia x foggii 'allspice' (2).jpg",
          width: 512,
          id: '315dcc35a16f5aab0bc6e5d1f395fae0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 169, 118, 1.00)',
            'rgba(99, 132, 74, 1.00)',
            'rgba(96, 119, 43, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x foggii 'allspice'/magnolia x foggii 'allspice' (1).jpg",
          width: 576,
          id: '02bbb5e9985e71afbb5744afa00670ef',
          height: 768,
          thumbnail: true,
        },
        location: [47.261863, -1.534937],
        genre: 'Magnolia',
        cultivar: 'Allspice',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534937, 47.261863] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7d7082c8d0a5df7621145fd5b65b169f58fc9bb4',
      fields: {
        espece: 'x loebneri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 112, 108, 1.00)',
            'rgba(119, 113, 96, 1.00)',
            'rgba(72, 64, 38, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'merrill'/magnolia x loebneri 'merrill' (2).jpg",
          width: 576,
          id: '5bc233ac31398a50627c8736cb574b0c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 175, 195, 1.00)',
            'rgba(111, 111, 104, 1.00)',
            'rgba(71, 67, 43, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'merrill'/magnolia x loebneri 'merrill' (1).jpg",
          width: 576,
          id: '1f1005b54800d8a95a3424d724be8d9d',
          height: 768,
          thumbnail: true,
        },
        location: [47.261862, -1.535305],
        genre: 'Magnolia',
        cultivar: 'Merrill',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535305, 47.261862] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'acd6b46b7a1960f4f447bbdd5cbc72a9c826c72e',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 117, 82, 1.00)',
            'rgba(148, 143, 100, 1.00)',
            'rgba(118, 128, 39, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'purpliana'/magnolia x soulangeana 'purpliana' (3).jpg",
          width: 576,
          id: '9c3706b76ae3ea30893bbef858e54089',
          height: 768,
          thumbnail: true,
        },
        espece: 'x soulangeana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 89, 48, 1.00)',
            'rgba(131, 134, 100, 1.00)',
            'rgba(87, 92, 32, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'purpliana'/magnolia x soulangeana 'purpliana' (2).jpg",
          width: 576,
          id: '0459813e1a0fe79a2b2d11fdea372059',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 120, 67, 1.00)',
            'rgba(116, 126, 67, 1.00)',
            'rgba(121, 128, 61, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'purpliana'/magnolia x soulangeana 'purpliana' (1).jpg",
          width: 576,
          id: '4c8f2b29d53bddec5f84fc6757923c45',
          height: 768,
          thumbnail: true,
        },
        location: [47.261813, -1.529133],
        genre: 'Magnolia',
        cultivar: 'Purpliana',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529133, 47.261813] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ca4acf31d68475f80381ed701d80f1650642c002',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'x thompsoniana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 102, 31, 1.00)',
            'rgba(129, 140, 65, 1.00)',
            'rgba(78, 106, 15, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia x thompsoniana/magnolia x thompsoniana (2).jpg',
          width: 576,
          id: '3c6aed8a09d15f491dc505f07c00ea62',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 161, 35, 1.00)',
            'rgba(125, 158, 37, 1.00)',
            'rgba(118, 150, 34, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia x thompsoniana/magnolia x thompsoniana (3).jpg',
          width: 576,
          id: '1a538feda146712acfa1b009244fc704',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 134, 65, 1.00)',
            'rgba(109, 123, 55, 1.00)',
            'rgba(103, 116, 47, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia x thompsoniana/magnolia x thompsoniana (1).jpg',
          width: 1024,
          id: 'd7d5bf8aa6e9867a661800872d407364',
          height: 768,
          thumbnail: true,
        },
        location: [47.26173, -1.528995],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.528995, 47.26173] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0c771fd0ac1e37cdfe55b0ddab234ab770558b36',
      fields: {
        espece: 'sericea',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(69, 88, 34, 1.00)',
            'rgba(108, 135, 61, 1.00)',
            'rgba(133, 167, 77, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/neolitsea/neolitsea sericea/neolitsea sericea  (5).jpg',
          width: 576,
          id: '05cc23ef637a556a0160573e08cdb79f',
          height: 768,
          thumbnail: true,
        },
        location: [47.21905, -1.541833],
        genre: 'Neolitsea',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541833, 47.21905] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f5adf84f1ad15ba58db954c179f877375a2a37b1',
      fields: {
        espece: 'nitida',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 144, 83, 1.00)',
            'rgba(118, 141, 77, 1.00)',
            'rgba(124, 146, 81, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/nothofagus/nothofagus nitida/nothofagus nitida (2).jpg',
          width: 576,
          id: '9d997fb0199585156d6fbf98246efa12',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 133, 96, 1.00)',
            'rgba(130, 136, 78, 1.00)',
            'rgba(111, 121, 51, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/nothofagus/nothofagus nitida/nothofagus nitida (1).jpg',
          width: 576,
          id: 'cd144aedd2de8bb4922d937c8bbc124f',
          height: 768,
          thumbnail: true,
        },
        location: [47.218612, -1.542262],
        genre: 'Nothofagus',
        famille: 'Nothofagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542262, 47.218612] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9557b57b14abaab8d958a9de4465848499b8751a',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'dombeyi',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 149, 79, 1.00)',
            'rgba(121, 134, 81, 1.00)',
            'rgba(107, 120, 83, 1.00)',
          ],
          filename:
            'ip parc de proce/nothofagus/nothofagus dombeyi/nothofagus dombeyi (2).jpg',
          width: 576,
          id: '3403514a2f2e4012aecf3c2b3067523a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 143, 135, 1.00)',
            'rgba(129, 132, 120, 1.00)',
            'rgba(126, 131, 118, 1.00)',
          ],
          filename:
            'ip parc de proce/nothofagus/nothofagus dombeyi/nothofagus dombeyi (3).jpg',
          width: 576,
          id: '61fe287a9a9ff80fd5f47ba12790f8f9',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 136, 96, 1.00)',
            'rgba(94, 125, 66, 1.00)',
            'rgba(86, 119, 61, 1.00)',
          ],
          filename:
            'ip parc de proce/nothofagus/nothofagus dombeyi/nothofagus dombeyi (1).jpg',
          width: 576,
          id: '3827cb777e41e1f4ffa45428ed46b3fa',
          height: 768,
          thumbnail: true,
        },
        location: [47.222738, -1.578462],
        genre: 'Nothofagus',
        famille: 'Nothofagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.578462, 47.222738] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd6bf99af8252cf2754433ed2c5543a3a9de6c39b',
      fields: {
        espece: 'persica',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(178, 191, 194, 1.00)',
            'rgba(117, 106, 48, 1.00)',
            'rgba(79, 78, 18, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/parrotia/parrotia persica/parrotia persica.jpg',
          width: 576,
          id: '22fd8a76e3c40970015ed0b40db6b516',
          height: 768,
          thumbnail: true,
        },
        location: [47.21898, -1.54178],
        genre: 'Parrotia',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54178, 47.21898] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f7be803c749911bccb9ab8a7a89d9ea44db7e04c',
      fields: {
        espece: 'persica',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 173, 200, 1.00)',
            'rgba(130, 127, 118, 1.00)',
            'rgba(106, 88, 55, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/parrotia/parrotia persica/parrotia persica (1).jpg',
          width: 576,
          id: '8730502491f93113b9d1b70add298d6b',
          height: 768,
          thumbnail: true,
        },
        location: [47.230192, -1.507128],
        genre: 'Parrotia',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507128, 47.230192] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e8ca4f526631b02ddae81cd4eb95a5d4a080e166',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 161, 159, 1.00)',
            'rgba(118, 112, 90, 1.00)',
            'rgba(74, 74, 67, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/parrotia hamamelidaceae/parrotia persica/parrotia persica (2).jpg',
          width: 1024,
          id: '50a0a2a8f045c74703f4764e5b16d3b0',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 132, 86, 1.00)',
            'rgba(148, 126, 54, 1.00)',
            'rgba(110, 91, 37, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/parrotia hamamelidaceae/parrotia persica/parrotia persica (3).jpg',
          width: 576,
          id: 'c5aca43b8f6a922d2927dd80bad9eb82',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 112, 110, 1.00)',
            'rgba(136, 130, 127, 1.00)',
            'rgba(121, 118, 116, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/parrotia hamamelidaceae/parrotia persica/parrotia persica (1).jpg',
          width: 576,
          id: '4ce962f67e1cd79bf44813f81a41c4bd',
          height: 768,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Parrotia',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ecc9c1cab46fe999937cde3a2ecb4f829e0a2333',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'nussia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 179, 135, 1.00)',
            'rgba(90, 108, 59, 1.00)',
            'rgba(74, 88, 44, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/photinia/photinia nussia/photinia nussia (2).jpg',
          width: 1024,
          id: 'c37e1fb18e2d07f4dee981b0234231cc',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 122, 65, 1.00)',
            'rgba(115, 138, 63, 1.00)',
            'rgba(90, 114, 34, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/photinia/photinia nussia/photinia nussia (3).jpg',
          width: 1024,
          id: 'c774874a66ef2ead396e0344ede7d381',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 131, 61, 1.00)',
            'rgba(92, 113, 56, 1.00)',
            'rgba(120, 114, 80, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/photinia/photinia nussia/photinia nussia (1).jpg',
          width: 1024,
          id: 'a0d6b1b4033041912d227d59057c2f8a',
          height: 683,
          thumbnail: true,
        },
        location: [47.220658, -1.542755],
        genre: 'Photinia',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542755, 47.220658] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '10aaa9c4a680dfac2ffb4b6ac590bcc8c7e20bed',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'coulteri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 106, 59, 1.00)',
            'rgba(99, 94, 71, 1.00)',
            'rgba(106, 96, 71, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/pinus/pinus coulteri/pinus coulteri (2).jpg',
          width: 1024,
          id: 'b969b3d269a9257487e9c1e64fc720d1',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 163, 166, 1.00)',
            'rgba(111, 118, 106, 1.00)',
            'rgba(33, 38, 18, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/pinus/pinus coulteri/pinus coulteri (3).jpg',
          width: 512,
          id: '79b9f8a718fcf5f022afa35aff117e07',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 133, 145, 1.00)',
            'rgba(102, 115, 129, 1.00)',
            'rgba(94, 104, 107, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/pinus/pinus coulteri/pinus coulteri (1).jpg',
          width: 1024,
          id: '28bcc1d41f56193a0600f0c4898716b9',
          height: 683,
          thumbnail: true,
        },
        location: [47.262103, -1.5352],
        genre: 'Pinus',
        famille: 'Pinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5352, 47.262103] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9bb34d37f9d5e8f70fd561aad5e813c03a636640',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'eugenioides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 131, 89, 1.00)',
            'rgba(118, 136, 84, 1.00)',
            'rgba(74, 92, 39, 1.00)',
          ],
          filename:
            'ip parc de proce/pittosporum/pittosporum eugenioides/pittosporum eugenioides (2).jpg',
          width: 576,
          id: '44638e67e7db5800e30b2ff2ef2d056f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 129, 90, 1.00)',
            'rgba(113, 131, 70, 1.00)',
            'rgba(104, 117, 62, 1.00)',
          ],
          filename:
            'ip parc de proce/pittosporum/pittosporum eugenioides/pittosporum eugenioides (3).jpg',
          width: 576,
          id: 'e0bca221cc09daccdf6e42095b2dbc77',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 128, 73, 1.00)',
            'rgba(104, 124, 69, 1.00)',
            'rgba(88, 102, 49, 1.00)',
          ],
          filename:
            'ip parc de proce/pittosporum/pittosporum eugenioides/pittosporum eugenioides (1).jpg',
          width: 576,
          id: '1f80683bafa0b39fd2cb10231a7d4dfe',
          height: 768,
          thumbnail: true,
        },
        location: [47.223437, -1.580253],
        genre: 'Pittosporum',
        famille: 'Pittosporaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580253, 47.223437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fcc5f4b0ab9b8f94ffd79e653639823823959496',
      fields: {
        espece: 'nivalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 117, 72, 1.00)',
            'rgba(118, 130, 81, 1.00)',
            'rgba(110, 123, 80, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/podocarpus/podocarpus nivalis/podocarpus nivalis (2).jpg',
          width: 576,
          id: 'cc734612d3ae6df6ec26933669b4ab88',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 146, 117, 1.00)',
            'rgba(113, 125, 82, 1.00)',
            'rgba(125, 132, 92, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/podocarpus/podocarpus nivalis/podocarpus nivalis (1).jpg',
          width: 1024,
          id: '1bf3216749a853ec94a1f5c17c7531f2',
          height: 768,
          thumbnail: true,
        },
        location: [47.219803, -1.541608],
        genre: 'Podocarpus',
        famille: 'Podocarpaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541608, 47.219803] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f65d507627dc7f839838798ed5f6e071da24a9f3',
      fields: {
        espece: 'avium',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(204, 220, 223, 1.00)',
            'rgba(116, 130, 96, 1.00)',
            'rgba(73, 84, 39, 1.00)',
          ],
          filename:
            "ip parc de proce/prunus/prunus avium 'plena'/prunus avium 'plena'.jpg",
          width: 576,
          id: 'b8afcde3583f32649b9e274fca198e1e',
          height: 768,
          thumbnail: true,
        },
        location: [47.225597, -1.581708],
        genre: 'Prunus',
        cultivar: 'Plena',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581708, 47.225597] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0d40bc4209a519c64ca0a481d96a9e8d26501f8e',
      fields: {
        espece: 'incisa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 147, 139, 1.00)',
            'rgba(133, 118, 106, 1.00)',
            'rgba(94, 86, 67, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/prunus/prunus incisa 'kojo no mai'/prunus incisa 'kojo no mai' (2).jpg",
          width: 848,
          id: 'f12fb175ba9d17d6271b070ebbf01cc7',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 74, 70, 1.00)',
            'rgba(127, 106, 105, 1.00)',
            'rgba(98, 82, 78, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/prunus/prunus incisa 'kojo no mai'/prunus incisa 'kojo no mai' (1).jpg",
          width: 1024,
          id: '341b29cd2f0605ff809896306df59571',
          height: 683,
          thumbnail: true,
        },
        location: [47.228317, -1.508228],
        genre: 'Prunus',
        cultivar: 'Koj\u00f4 No Mai',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508228, 47.228317] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '40c578157e9324e3ccf95f84db77e8f9286aa2fe',
      fields: {
        espece: 'mume',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 109, 165, 1.00)',
            'rgba(87, 101, 150, 1.00)',
            'rgba(92, 89, 128, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/prunus/prunus mume 'beni-chidori'/prunus mume 'beni-chidori' (5).jpg",
          width: 556,
          id: 'dc764b9e31483b69d4cba8312ef6da07',
          height: 768,
          thumbnail: true,
        },
        location: [47.260928, -1.533347],
        genre: 'Prunus',
        cultivar: 'Beni-chidori',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533347, 47.260928] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1b677efa1d8a25c8b65c6663683ab69886d112dc',
      fields: {
        espece: 'fraxinifolia',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(205, 213, 188, 1.00)',
            'rgba(104, 124, 65, 1.00)',
            'rgba(88, 95, 66, 1.00)',
          ],
          filename:
            'ip ville de nantes/pterocarya/pterocarya fraxinifolia/pterocarya fraxinifolia (1).jpg',
          width: 678,
          id: 'e02ae5813f66f38b08f873bd02263ab9',
          height: 768,
          thumbnail: true,
        },
        location: [47.224613, -1.553842],
        genre: 'Pterocarya',
        famille: 'Juglandaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.553842, 47.224613] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0a942dbfa50b0dc48dd8db440fa2b57f7869ea36',
      fields: {
        espece: 'robur',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 170, 195, 1.00)',
            'rgba(107, 104, 97, 1.00)',
            'rgba(47, 44, 30, 1.00)',
          ],
          filename:
            'ip parc de proce/quercus/quercus robur/quercus robur (2).jpg',
          width: 556,
          id: '1b09e00e5a227ab6c0a989f2cc77688f',
          height: 768,
          thumbnail: true,
        },
        location: [47.222808, -1.579742],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.579742, 47.222808] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e9ae4fdf07bfeccb2d6642c9ea012e955d28f99d',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'shumardii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 95, 138, 1.00)',
            'rgba(115, 83, 79, 1.00)',
            'rgba(98, 87, 103, 1.00)',
          ],
          filename:
            'ip parc de proce/quercus/quercus shumardii/quercus shumardii  (2).jpg',
          width: 512,
          id: 'd5853e4b67c66fb283edf0e17de65fce',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 147, 196, 1.00)',
            'rgba(135, 93, 53, 1.00)',
            'rgba(45, 37, 16, 1.00)',
          ],
          filename:
            'ip parc de proce/quercus/quercus shumardii/quercus shumardii  (3).jpg',
          width: 512,
          id: '413cba202a9e43257358bd4f47b3db77',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 133, 160, 1.00)',
            'rgba(135, 90, 49, 1.00)',
            'rgba(73, 67, 34, 1.00)',
          ],
          filename:
            'ip parc de proce/quercus/quercus shumardii/quercus shumardii  (1).jpg',
          width: 512,
          id: '932d927eaeab13e0eeaff664b9ae5c2c',
          height: 768,
          thumbnail: true,
        },
        location: [47.222533, -1.5794],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5794, 47.222533] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '286f2ce3363e66b29d39af6bdbac5d6fd237d185',
      fields: {
        espece: 'palustris',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(221, 231, 239, 1.00)',
            'rgba(117, 126, 104, 1.00)',
            'rgba(127, 129, 122, 1.00)',
          ],
          filename:
            'ip ville de nantes/quercus/quercus palustris/quercus palustris (2).jpg',
          width: 1024,
          id: '2038ef6b43439b1b7fdc755faa3186be',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(218, 225, 224, 1.00)',
            'rgba(101, 109, 74, 1.00)',
            'rgba(96, 98, 86, 1.00)',
          ],
          filename:
            'ip ville de nantes/quercus/quercus palustris/quercus palustris (1).jpg',
          width: 576,
          id: '79ae97bc760dad076c0f6dd7224597b0',
          height: 768,
          thumbnail: true,
        },
        location: [47.246975, -1.552005],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.552005, 47.246975] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f16fce01ea6ebdfaa056ce97cc811dfa4176bded',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 106, 82, 1.00)',
            'rgba(114, 117, 96, 1.00)',
            'rgba(120, 128, 113, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/rhamnus/rhamnus alaternus 'argenteovariegata'/rhamnus alaternus 'argenteovariegata' (1).jpg",
          width: 512,
          id: 'e66bbfc121a0e523ed497baf9ad8c83c',
          height: 768,
          thumbnail: true,
        },
        espece: 'alaternus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 122, 109, 1.00)',
            'rgba(106, 99, 67, 1.00)',
            'rgba(68, 61, 36, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/rhamnus/rhamnus alaternus 'argenteovariegata'/rhamnus alaternus 'argenteovariegata'  (2).jpg",
          width: 1024,
          id: 'e38438178fd4715ed1176c7fb1e00ba7',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 100, 60, 1.00)',
            'rgba(124, 114, 70, 1.00)',
            'rgba(95, 86, 50, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/rhamnus/rhamnus alaternus 'argenteovariegata'/rhamnus alaternus 'argenteovariegata'  (1).jpg",
          width: 512,
          id: '5403b83f7738e74a28ba32b9fa48a3f0',
          height: 768,
          thumbnail: true,
        },
        location: [47.228095, -1.508287],
        genre: 'Rhamnus',
        cultivar: 'Argenteovariegata',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508287, 47.228095] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b89ebe3f56fb8d3be7d6ecd8a2f71f0871a29753',
      fields: {
        espece: 'pseudoacacia',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(175, 185, 152, 1.00)',
            'rgba(109, 126, 70, 1.00)',
            'rgba(78, 94, 41, 1.00)',
          ],
          filename:
            'ip ville de nantes/robinia/robinia pseudoacacia/robinia pseudoacacia.jpg',
          width: 1024,
          id: '9727abdbb2b098490fd6faec42a7a838',
          height: 768,
          thumbnail: true,
        },
        location: [47.267322, -1.581858],
        genre: 'Robinia',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581858, 47.267322] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5b6cb8ac7aab6e54a1b8f6c47ba845b979f1a7bd',
      fields: {
        espece: 'praecox',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 87, 80, 1.00)',
            'rgba(102, 111, 97, 1.00)',
            'rgba(96, 96, 89, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/stachyurus/stachyurus praecox/stachyurus praecox.jpg',
          width: 1024,
          id: '7cb8d23c373b5be650672d4ff65fd2da',
          height: 768,
          thumbnail: true,
        },
        location: [47.219855, -1.54173],
        genre: 'Stachyurus',
        famille: 'Stachyuraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54173, 47.219855] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd15ec1979f6740d10b17d1fdd678c5c7e1f9056f',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'bumalda',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 153, 56, 1.00)',
            'rgba(108, 150, 47, 1.00)',
            'rgba(106, 140, 41, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/staphylea/staphylea bumalda/staphylea bumalda (2).jpg',
          width: 576,
          id: '17a9f6a43fc9e8b22b1ff55aa1b24211',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 106, 41, 1.00)',
            'rgba(116, 141, 72, 1.00)',
            'rgba(80, 107, 43, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/staphylea/staphylea bumalda/staphylea bumalda (3).jpg',
          width: 576,
          id: '2976e061afbe16670a0efd33ab4a9664',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 168, 96, 1.00)',
            'rgba(99, 135, 57, 1.00)',
            'rgba(100, 121, 59, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/staphylea/staphylea bumalda/staphylea bumalda (1).jpg',
          width: 1024,
          id: '21947e89c952476ca223f485a4c5f55c',
          height: 768,
          thumbnail: true,
        },
        location: [47.218612, -1.542347],
        genre: 'Staphylea',
        famille: 'Staphyleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542347, 47.218612] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd341094abca6f0e40ea87e9f956bf2949e2d53f2',
      fields: {
        espece: 'colchica',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 133, 108, 1.00)',
            'rgba(101, 120, 75, 1.00)',
            'rgba(48, 61, 29, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/staphylea/staphylea colchica/staphylea colchica (2).jpg',
          width: 599,
          id: 'be6145ad9fdf4639371ac9976850f052',
          height: 768,
          thumbnail: true,
        },
        location: [47.230162, -1.50592],
        genre: 'Staphylea',
        famille: 'Staphyleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.50592, 47.230162] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8789b35e67545d5532409162f64f22ee8c4973f8',
      fields: {
        espece: 'japonicum',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 160, 120, 1.00)',
            'rgba(90, 113, 74, 1.00)',
            'rgba(64, 78, 45, 1.00)',
          ],
          filename:
            'ip ville de nantes/styphnolobium/styphnolobium japonicum/styphnolobium japonicum.jpg',
          width: 1024,
          id: '062a2f634101d4e054d33d2135dab804',
          height: 683,
          thumbnail: true,
        },
        location: [47.193345, -1.5325],
        genre: 'Styphnolobium',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5325, 47.193345] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '977bf76162a21bdc35c9f5946b87e8bbf720f20c',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'sebifera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 151, 70, 1.00)',
            'rgba(124, 153, 54, 1.00)',
            'rgba(99, 136, 35, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/triadica/triadica sebifera/triadica sebifera (10).jpg',
          width: 576,
          id: '9544eb391dc3ef396f2237441d7df9ea',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 147, 56, 1.00)',
            'rgba(121, 151, 68, 1.00)',
            'rgba(109, 144, 68, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/triadica/triadica sebifera/triadica sebifera (11).jpg',
          width: 576,
          id: 'f5cfcca84f0a382e13a08597de3c6beb',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 142, 101, 1.00)',
            'rgba(101, 139, 81, 1.00)',
            'rgba(120, 149, 82, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/triadica/triadica sebifera/triadica sebifera (1).jpg',
          width: 576,
          id: 'bd8e4800ff385d170a7d0b1ea86eb8f0',
          height: 768,
          thumbnail: true,
        },
        location: [47.219103, -1.543588],
        genre: 'Triadica',
        famille: 'Euphorbiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543588, 47.219103] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '530ec05ebdefed13842a099f82bf28a23cda82d5',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'molinae',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 154, 106, 1.00)',
            'rgba(112, 143, 111, 1.00)',
            'rgba(126, 142, 128, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ugni/ugni molinae/ugni molinae (2).jpg',
          width: 576,
          id: '7787132f64d3ec2ad8ab4175a7329ed1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 123, 104, 1.00)',
            'rgba(123, 125, 114, 1.00)',
            'rgba(120, 126, 120, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ugni/ugni molinae/ugni molinae (3).jpg',
          width: 1024,
          id: '128ad1fbd2dfc43e539f910b38809974',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 145, 90, 1.00)',
            'rgba(119, 132, 111, 1.00)',
            'rgba(73, 90, 72, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ugni/ugni molinae/ugni molinae (1).jpg',
          width: 576,
          id: 'e2a37fa46889e0c496f66516014b49e1',
          height: 768,
          thumbnail: true,
        },
        location: [47.218937, -1.54298],
        genre: 'Ugni',
        famille: 'Myrtaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54298, 47.218937] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e9924978e40bd939598d7ca144e6426db22ed361',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'californica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 108, 101, 1.00)',
            'rgba(144, 149, 137, 1.00)',
            'rgba(118, 132, 126, 1.00)',
          ],
          filename:
            'ip parc de proce/umbellularia/umbellularia californica/umbellularia californica (2).jpg',
          width: 576,
          id: '5e7653fef45a6231f08bc763a0c3f2b1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 144, 139, 1.00)',
            'rgba(126, 138, 128, 1.00)',
            'rgba(103, 114, 90, 1.00)',
          ],
          filename:
            'ip parc de proce/umbellularia/umbellularia californica/umbellularia californica (3).jpg',
          width: 576,
          id: '2449f68ac82f09c91ec9492d312f6578',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 136, 130, 1.00)',
            'rgba(140, 141, 133, 1.00)',
            'rgba(133, 135, 125, 1.00)',
          ],
          filename:
            'ip parc de proce/umbellularia/umbellularia californica/umbellularia californica (1).jpg',
          width: 576,
          id: 'e83feadafe873b4e0c15eae4b6e544b8',
          height: 768,
          thumbnail: true,
        },
        location: [47.224355, -1.58135],
        genre: 'Umbellularia',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58135, 47.224355] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'da488eb9c58947cf1ba1498176bc724e608aafcc',
      fields: {
        espece: 'x burkwoodii',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(53, 63, 34, 1.00)',
            'rgba(115, 123, 103, 1.00)',
            'rgba(58, 70, 43, 1.00)',
          ],
          filename:
            'ip parc de proce/viburnum/viburnum x burkwoodii/viburnum x burkwoodii (2).jpg',
          width: 576,
          id: 'cfd13740941ab52dae9a53a0f6e2b6cd',
          height: 768,
          thumbnail: true,
        },
        location: [47.222487, -1.57962],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.57962, 47.222487] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5c92a513dc09f72998d33261cb40d2fb8e7d66f7',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 127, 61, 1.00)',
            'rgba(194, 122, 82, 1.00)',
            'rgba(176, 114, 72, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/viburnum/viburnum opulus 'compactum'/viburnum opulus 'compactum' (3).jpg",
          width: 576,
          id: '807c515dc09b1ee660837dab4d347db1',
          height: 768,
          thumbnail: true,
        },
        espece: 'opulus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 106, 52, 1.00)',
            'rgba(129, 137, 61, 1.00)',
            'rgba(145, 131, 88, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/viburnum/viburnum opulus 'compactum'/viburnum opulus 'compactum' (2).jpg",
          width: 576,
          id: '89fd4bda8bc3c7f18d3dd9e47a2d07f2',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 136, 83, 1.00)',
            'rgba(174, 115, 89, 1.00)',
            'rgba(128, 127, 50, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/viburnum/viburnum opulus 'compactum'/viburnum opulus 'compactum' (1).jpg",
          width: 576,
          id: '39800aca58578ca898ae189b39fb0b11',
          height: 768,
          thumbnail: true,
        },
        location: [47.26153, -1.530845],
        genre: 'Viburnum',
        cultivar: 'Compactum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530845, 47.26153] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1aca8188eade1f93cf3b4c0cd04a61d0f612def0',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'suspensum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(54, 68, 39, 1.00)',
            'rgba(71, 80, 48, 1.00)',
            'rgba(49, 64, 35, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/viburnum/viburnum suspensum/viburnum suspensum (10).jpg',
          width: 1024,
          id: 'e36e40d39bdb45367158b501da84bc25',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(31, 53, 29, 1.00)',
            'rgba(91, 104, 80, 1.00)',
            'rgba(47, 64, 38, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/viburnum/viburnum suspensum/viburnum suspensum (11).jpg',
          width: 1024,
          id: '566b58ea2d02639b9137217df3ee3f71',
          height: 658,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 97, 49, 1.00)',
            'rgba(109, 107, 68, 1.00)',
            'rgba(76, 89, 29, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/viburnum/viburnum suspensum/viburnum suspensum (1).jpg',
          width: 576,
          id: '0feea3d42467442984f7c65ec8e431ae',
          height: 768,
          thumbnail: true,
        },
        location: [47.26108, -1.533025],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533025, 47.26108] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f26ad670597c3ca53ca94d2c51a32e933e6a167b',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(192, 213, 215, 1.00)',
            'rgba(89, 110, 63, 1.00)',
            'rgba(112, 141, 73, 1.00)',
          ],
          filename:
            "ip ville de nantes/viburnum/viburnum opulus 'compactum'/viburnum opulus 'compactum' (3).jpg",
          width: 1024,
          id: '670be1077121ca3163cd092565321ece',
          height: 768,
          thumbnail: true,
        },
        espece: 'opulus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 129, 73, 1.00)',
            'rgba(135, 120, 66, 1.00)',
            'rgba(122, 108, 53, 1.00)',
          ],
          filename:
            "ip ville de nantes/viburnum/viburnum opulus 'compactum'/viburnum opulus 'compactum' (2).jpg",
          width: 576,
          id: '963bd0f6204cfd7aff1185f32dcc7776',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(64, 100, 50, 1.00)',
            'rgba(78, 122, 70, 1.00)',
            'rgba(88, 117, 65, 1.00)',
          ],
          filename:
            "ip ville de nantes/viburnum/viburnum opulus 'compactum'/viburnum opulus 'compactum' (1).jpg",
          width: 576,
          id: 'f932fe8ad8883cb50a154e9f8596e194',
          height: 768,
          thumbnail: true,
        },
        location: [47.263722, -1.540325],
        genre: 'Viburnum',
        cultivar: 'Compactum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.540325, 47.263722] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a6dae800aa941999ce1a620f016856065f5ba1bb',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 120, 64, 1.00)',
            'rgba(113, 125, 75, 1.00)',
            'rgba(108, 114, 69, 1.00)',
          ],
          filename:
            "ip parc de proce/zelkova/zelkova serrata 'ogon'/zelkova serrata 'ogon'  (3).jpg",
          width: 576,
          id: 'c7b88adca7e2d02fe30e242689e75755',
          height: 768,
          thumbnail: true,
        },
        espece: 'serrata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 133, 99, 1.00)',
            'rgba(144, 111, 72, 1.00)',
            'rgba(130, 95, 55, 1.00)',
          ],
          filename:
            "ip parc de proce/zelkova/zelkova serrata 'ogon'/zelkova serrata 'ogon'  (2).jpg",
          width: 576,
          id: '43989c4afe941e000dd2351101be4889',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(186, 201, 162, 1.00)',
            'rgba(95, 114, 60, 1.00)',
            'rgba(90, 97, 54, 1.00)',
          ],
          filename:
            "ip parc de proce/zelkova/zelkova serrata 'ogon'/zelkova serrata 'ogon'  (1).jpg",
          width: 1024,
          id: 'eee4e6168284f270cf150c34776fdf39',
          height: 768,
          thumbnail: true,
        },
        location: [47.222525, -1.584555],
        genre: 'Zelkova',
        cultivar: 'Ogon',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584555, 47.222525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '66bb8d388b16ac7267b2d5c9f890d705e9aa91ff',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'jujuba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 131, 100, 1.00)',
            'rgba(120, 124, 68, 1.00)',
            'rgba(114, 119, 60, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/ziziphus/ziziphus jujuba/ziziphus jujuba (2).jpg',
          width: 576,
          id: '4e200daca7fa066b37128537c03f329a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 131, 96, 1.00)',
            'rgba(118, 119, 70, 1.00)',
            'rgba(111, 125, 52, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/ziziphus/ziziphus jujuba/ziziphus jujuba (3).jpg',
          width: 576,
          id: 'd531a39d7d73f5c593ed949edeb302ea',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 159, 45, 1.00)',
            'rgba(112, 140, 30, 1.00)',
            'rgba(146, 160, 53, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/ziziphus/ziziphus jujuba/ziziphus jujuba (1).jpg',
          width: 576,
          id: '091ad97ce2f44577456742a5b5e96c26',
          height: 768,
          thumbnail: true,
        },
        location: [47.227697, -1.510242],
        genre: 'Ziziphus',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.510242, 47.227697] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '90949e3821e5fba70fdcac5c02643afb214a3ba2',
      fields: {
        espece: 'jujuba',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 162, 171, 1.00)',
            'rgba(127, 126, 79, 1.00)',
            'rgba(124, 113, 62, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/ziziphus/ziziphus jujuba/ziziphus jujuba.jpg',
          width: 1024,
          id: '8a3577ca5c9d55cfc5bec36e2b89f25a',
          height: 768,
          thumbnail: true,
        },
        location: [47.227695, -1.510237],
        genre: 'Ziziphus',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.510237, 47.227695] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0f6097d84192ff5704e681120f87e2106359e91c',
      fields: {
        origine: 'J.B FEB RAS, Blagoveschensk (Russie)',
        espece: 'telephium L.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Sedum',
        date_plantation: '2011',
        cultivar: 'telephium',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a78823e993aea6750934f3214a868b2b25cfab60',
      fields: {
        origine: 'J.B.Porrentruy,Belgique',
        espece: 'selskianum Regel & Maack',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Sedum',
        date_plantation: '2014',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '02c986e282cc513d8edf014b3cbf05a7db3f4a8b',
      fields: {
        origine: 'Smith College Northampton (USA)',
        espece: 'maximum Suter',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Sedum',
        date_plantation: '2014',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cfcb6f37656741f016dcd5b5be4107819f7d6fb5',
      fields: {
        origine: 'Utrecht Botanic garden',
        espece: 'obtusifolium C.A. Mey.',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Sedum',
        date_plantation: '2001',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2a21b5dd4ec547c6272b8e79eae610e4d968744f',
      fields: {
        espece: 'konishii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(169, 173, 170, 1.00)',
            'rgba(123, 126, 101, 1.00)',
            'rgba(69, 68, 48, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/cunninghamia [cupressaceae]/cunninghamia konishii/cunninghamia konishii (2).jpg',
          width: 576,
          id: '4058763ee343997e49f3c619a2ed545f',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 96, 34, 1.00)',
            'rgba(103, 103, 41, 1.00)',
            'rgba(95, 106, 51, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/cunninghamia [cupressaceae]/cunninghamia konishii/cunninghamia konishii (1).jpg',
          width: 576,
          id: '2422d215fb4367d2992e2470a229b288',
          height: 768,
          thumbnail: true,
        },
        location: [47.261688, -1.535803],
        genre: 'Cunninghamia',
        famille: 'Cupressaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535803, 47.261688] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '704cf8f76f8a196c69a9dd7a4eb3ab550a22ec58',
      fields: {
        espece: 'pendula Huds.',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Carex',
        date_plantation: '1973',
        famille: 'Cyperaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a6b0a19821c4c67698244b1a3dbe0590a99c4f00',
      fields: {
        origine: 'JB.Cluj-Napoca (Roumanie)',
        espece: 'uralensis Roem.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Cephalaria',
        date_plantation: '2009',
        famille: 'Dipsacaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bb2dbb3bba761c21950354c6cc95ff1f41187793',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'macrophylla',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 100, 72, 1.00)',
            'rgba(94, 114, 86, 1.00)',
            'rgba(87, 103, 79, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/elaeagnus [elaeagnaceae]/elaeagnus macrophylla/elaeagnus macrophylla (6).jpg',
          width: 1024,
          id: '6f8f35eb6308322dd3d544195e8b1f8d',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 156, 127, 1.00)',
            'rgba(98, 115, 84, 1.00)',
            'rgba(66, 87, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/elaeagnus [elaeagnaceae]/elaeagnus macrophylla/elaeagnus macrophylla (7).jpg',
          width: 1024,
          id: '9e59b4efa716da64ebb867921eca518a',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 152, 128, 1.00)',
            'rgba(94, 109, 77, 1.00)',
            'rgba(90, 96, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/elaeagnus [elaeagnaceae]/elaeagnus macrophylla/elaeagnus macrophylla (5).jpg',
          width: 1024,
          id: 'cfc21614124765f16975f121c79f36f6',
          height: 683,
          thumbnail: true,
        },
        location: [47.270136, -1.584478],
        genre: 'Elaeagnus',
        famille: 'Elaeagnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584478, 47.270136] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6000ce3a57d53538f480d5ed3ac3faa8e242aa7b',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Gd Blottereau',
        espece: 'x praecox',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Rhododendron',
        date_plantation: '2015',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3c32b2d70e694060bae3ce1d722130b45d085df3',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'unedo',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 100, 71, 1.00)',
            'rgba(115, 125, 99, 1.00)',
            'rgba(66, 76, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus unedo/arbutus unedo (1).jpg',
          width: 576,
          id: 'b6466b2b7a6ef8f47c5be5986553558e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 105, 96, 1.00)',
            'rgba(115, 111, 99, 1.00)',
            'rgba(127, 118, 101, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus unedo/arbutus unedo (2).jpg',
          width: 576,
          id: '21783ba6553eaed27c27b29956df3bf4',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 148, 120, 1.00)',
            'rgba(115, 136, 104, 1.00)',
            'rgba(138, 142, 130, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus unedo/arbutus unedo  (1).jpg',
          width: 576,
          id: '43151a3caddc6dcadb64ba894d5e2a10',
          height: 768,
          thumbnail: true,
        },
        location: [47.271662, -1.582192],
        genre: 'Arbutus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582192, 47.271662] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '85b7c9750ad6e90f86dacd5028bec79431a8456b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x andrachnoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 93, 67, 1.00)',
            'rgba(110, 120, 93, 1.00)',
            'rgba(72, 83, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus x andrachnoides/arbutus x andrachnoides (16).jpg',
          width: 512,
          id: 'e03d1c0fd7c0ecee471575cd6b493762',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 132, 75, 1.00)',
            'rgba(106, 119, 71, 1.00)',
            'rgba(97, 109, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus x andrachnoides/arbutus x andrachnoides (18).jpg',
          width: 512,
          id: 'a63a40497f7f072ce1f41e7ef64c20af',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 150, 125, 1.00)',
            'rgba(94, 106, 71, 1.00)',
            'rgba(80, 83, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus x andrachnoides/arbutus x andrachnoides (1).jpg',
          width: 512,
          id: 'fe3bd19b991911569b1613d854aaf31c',
          height: 768,
          thumbnail: true,
        },
        location: [47.270613, -1.58402],
        genre: 'Arbutus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58402, 47.270613] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f449f5b3c587eb2c29825083cb98e69bea8468c7',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x andrachnoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 140, 120, 1.00)',
            'rgba(121, 146, 129, 1.00)',
            'rgba(120, 119, 118, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus x andrachnoides/arbutus x andrachnoides (13).jpg',
          width: 576,
          id: '9f896bdf2a3bc22e04dac71e90944e94',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 170, 147, 1.00)',
            'rgba(116, 131, 113, 1.00)',
            'rgba(84, 108, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus x andrachnoides/arbutus x andrachnoides (14).jpg',
          width: 576,
          id: '732371be65e960f28fe6c884c4a1257a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 126, 105, 1.00)',
            'rgba(115, 133, 130, 1.00)',
            'rgba(158, 141, 146, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus x andrachnoides/arbutus x andrachnoides (12).jpg',
          width: 576,
          id: 'fd186db42dec75e4483538e58229a6fe',
          height: 768,
          thumbnail: true,
        },
        location: [47.271962, -1.582613],
        genre: 'Arbutus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582613, 47.271962] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1a0b60deade7910092fcef3e4f8bc5a4aed37930',
      fields: {
        espece: 'x andrachnoides',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 139, 156, 1.00)',
            'rgba(114, 109, 99, 1.00)',
            'rgba(85, 74, 39, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/arbutus [ericaceae]/arbutus x andrachnoides/arbutus x andrachnoides.jpg',
          width: 1024,
          id: '4578b2c56db566603d2f17ed1092717b',
          height: 683,
          thumbnail: true,
        },
        location: [47.262545, -1.528625],
        genre: 'Arbutus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.528625, 47.262545] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c60da58b8797a551b1cfe506d101a3389da68c56',
      fields: {
        espece: 'campanulatus',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 144, 96, 1.00)',
            'rgba(109, 124, 74, 1.00)',
            'rgba(93, 96, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/enkianthus [ericaceae]/enkianthus campanulatus/enkianthus campanulatus .jpg',
          width: 1024,
          id: 'cbeacc04be37a8546038c901d8a7ee1c',
          height: 768,
          thumbnail: true,
        },
        location: [47.269312, -1.585188],
        genre: 'Enkianthus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585188, 47.269312] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '64597d8f4b718fc21c2b4e5b76d744c5d36aa48d',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'japonicus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 127, 46, 1.00)',
            'rgba(143, 148, 84, 1.00)',
            'rgba(138, 149, 86, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/mallotus [euphorbiaceae]/mallotus japonicus/mallotus japonicus (10).jpg',
          width: 576,
          id: 'dec232747fa7b986b2c7d4aebce23922',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 149, 103, 1.00)',
            'rgba(96, 116, 51, 1.00)',
            'rgba(109, 114, 70, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/mallotus [euphorbiaceae]/mallotus japonicus/mallotus japonicus (11).jpg',
          width: 1024,
          id: 'b62cf7ea5dc086e1c7c634fbfea62763',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 139, 60, 1.00)',
            'rgba(105, 147, 51, 1.00)',
            'rgba(139, 151, 86, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/mallotus [euphorbiaceae]/mallotus japonicus/mallotus japonicus (1).jpg',
          width: 576,
          id: 'c99b96e5c23595399cc7484f9afb6347',
          height: 768,
          thumbnail: true,
        },
        location: [47.269787, -1.581617],
        genre: 'Mallotus',
        famille: 'Euphorbiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581617, 47.269787] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2d909ea7f82231ba59340dcfb7d7b29c4740bccd',
      fields: {
        origine: 'P. F\u00e9rard, nature - Pyr\u00e9n\u00e9es',
        espece: 'alpinum L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Trifolium',
        date_plantation: '2014',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '85b26cff91dc79c0e8776f0d2808943753a9af59',
      fields: {
        origine: 'JB.Framingham (USA)',
        espece: 'australis R.Br.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Baptisia',
        date_plantation: '1988',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a7aa706b96823553b68eb154d8d391ff7ea2fc14',
      fields: {
        origine: 'JBU.Besan\u00e7on (France)',
        espece: 'varia L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Coronilla',
        date_plantation: '2003',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0ff17de613666e911f7fc10d5d6f7bf758804ceb',
      fields: {
        origine: 'JBU.Chiba Matsudo (Japon)',
        espece: 'floribunda',
        localisation: 'B2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201934, -1.5449557],
        genre: 'Wisteria',
        date_plantation: '1998',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449557, 47.2201934] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '983dba0b3548cbe3da5a6cf682b2f3a403f29eac',
      fields: {
        origine: 'Remi Legros ( collection personnelle)',
        espece: 'gilliesii',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Caesalpinia',
        date_plantation: '2014',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7f938e14519db89aa3f0e0f3698cc407080a9043',
      fields: {
        espece: 'americana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 159, 105, 1.00)',
            'rgba(139, 141, 104, 1.00)',
            'rgba(109, 131, 73, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/apios [fabaceae]/apios americana/apios americana (2).jpg",
          width: 576,
          id: '57ab091f5e1a0d6043c96039835a283e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 144, 91, 1.00)',
            'rgba(120, 141, 90, 1.00)',
            'rgba(107, 137, 80, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/apios [fabaceae]/apios americana/apios americana (1).jpg",
          width: 576,
          id: 'de211b654b2dcd803839a896e2cd402b',
          height: 768,
          thumbnail: true,
        },
        location: [47.226588, -1.512412],
        genre: 'Apios',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512412, 47.226588] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0c865dff55693bb195ab9558bb2ce0ab3bc53d3d',
      fields: {
        espece: 'siliquastrum',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Cercis',
        date_plantation: '1973',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '18357e9d4dec5008796eb3890213249dffdc3e51',
      fields: {
        espece: 'anagyro\u00efdes',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Laburnum',
        date_plantation: '1973',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '51082d093f0afb7a0fe3cd584258e18da94acc14',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'grandifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 173, 137, 1.00)',
            'rgba(109, 129, 80, 1.00)',
            'rgba(82, 122, 42, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/piscidia [fabaceae]/piscidia grandifolia/piscidia grandifolia (2).jpg",
          width: 576,
          id: '695c150ae160afad577c0d9c2bf52115',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 165, 89, 1.00)',
            'rgba(95, 150, 46, 1.00)',
            'rgba(85, 133, 33, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/piscidia [fabaceae]/piscidia grandifolia/piscidia grandifolia (3).jpg",
          width: 576,
          id: '63133976d6555c8f6fc43256759e2abb',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 186, 153, 1.00)',
            'rgba(110, 133, 88, 1.00)',
            'rgba(70, 102, 38, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/piscidia [fabaceae]/piscidia grandifolia/piscidia grandifolia (1).jpg",
          width: 576,
          id: '8a927b1bbc33b9b3fa6cbd584101b45b',
          height: 768,
          thumbnail: true,
        },
        location: [47.22702, -1.511953],
        genre: 'Piscidia',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.511953, 47.22702] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c74e5d11d78787261c70887a0e740ffbcbb11114',
      fields: {
        espece: 'orientalis',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 142, 179, 1.00)',
            'rgba(130, 135, 141, 1.00)',
            'rgba(94, 84, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus orientalis/fagus orientalis  (1).jpg',
          width: 576,
          id: '25fdb8793497b0382102f0223ca5f52f',
          height: 768,
          thumbnail: true,
        },
        location: [47.270558, -1.581628],
        genre: 'Fagus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581628, 47.270558] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bd8dc948596b1c1123a5aef9822e67ed7901c842',
      fields: {
        espece: 'canariensis',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 158, 141, 1.00)',
            'rgba(98, 101, 83, 1.00)',
            'rgba(68, 68, 42, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus canariensis/quercus canariensis.jpg',
          width: 1024,
          id: 'a595346c5707c21e4901d9e9ab408033',
          height: 683,
          thumbnail: true,
        },
        location: [47.269642, -1.584405],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584405, 47.269642] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '77eb85118a6c06ecda8ee60ba78444e5eebd998b',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(48, 52, 21, 1.00)',
            'rgba(105, 110, 46, 1.00)',
            'rgba(131, 126, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/quercus [fagaceae]/quercus cerris 'variegata'/quercus cerris 'variegata' (3).jpg",
          width: 576,
          id: '48998fbbb5289894842ef5bd67ce9840',
          height: 768,
          thumbnail: true,
        },
        espece: 'cerris',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 125, 99, 1.00)',
            'rgba(111, 130, 96, 1.00)',
            'rgba(99, 111, 93, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/quercus [fagaceae]/quercus cerris 'variegata'/quercus cerris 'variegata' (2).jpg",
          width: 1024,
          id: '3c337e297b5b7d7d4360b58a51dbbd3c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 147, 100, 1.00)',
            'rgba(119, 140, 87, 1.00)',
            'rgba(106, 126, 77, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/quercus [fagaceae]/quercus cerris 'variegata'/quercus cerris 'variegata' (1).jpg",
          width: 576,
          id: '0836431d3bf4fb1d386bf1203d139bb3',
          height: 768,
          thumbnail: true,
        },
        location: [47.270425, -1.581395],
        genre: 'Quercus',
        cultivar: 'Variegata',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581395, 47.270425] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9706957443a1161576f38453444c8feafeaff5b4',
      fields: {
        espece: 'glauca',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(181, 185, 172, 1.00)',
            'rgba(96, 101, 73, 1.00)',
            'rgba(82, 71, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus glauca/quercus glauca  (3).jpg',
          width: 531,
          id: '1dfce37bfdfc9131bb16317640d40ed4',
          height: 768,
          thumbnail: true,
        },
        location: [47.271138, -1.58595],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58595, 47.271138] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'eaca70d1106fd3308aa4f390c77c56e6fa382049',
      fields: {
        espece: 'myrsinifolia',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(175, 186, 169, 1.00)',
            'rgba(87, 101, 76, 1.00)',
            'rgba(68, 75, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus myrsinifolia/quercus myrsinifolia  (2).jpg',
          width: 1024,
          id: 'e9489ff34a939887cfe68cb65b3dbb52',
          height: 683,
          thumbnail: true,
        },
        location: [47.269778, -1.581658],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581658, 47.269778] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '29d1b6c85cb5e081707bc0d6ddab4050fa7bbead',
      fields: {
        espece: 'myrsinifolia',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 92, 75, 1.00)',
            'rgba(117, 105, 85, 1.00)',
            'rgba(113, 101, 85, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus myrsinifolia/quercus myrsinifolia (6).jpg',
          width: 1024,
          id: 'f5277a06c81f45568407f29ca01f1ba5',
          height: 683,
          thumbnail: true,
        },
        location: [47.269683, -1.581725],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581725, 47.269683] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '52df89f8cacebcdbe264bdf2424ad363ffaf4817',
      fields: {
        espece: 'rubra',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(180, 187, 184, 1.00)',
            'rgba(99, 96, 57, 1.00)',
            'rgba(36, 42, 18, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/quercus [fagaceae]/quercus rubra 'aurea'/quercus rubra 'aurea' (6).jpg",
          width: 1024,
          id: 'c0229bb91939dae1fcea506955e083ea',
          height: 597,
          thumbnail: true,
        },
        location: [47.271172, -1.5804],
        genre: 'Quercus',
        cultivar: 'Aurea',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5804, 47.271172] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '49146e34bb2e756ddbe4efef8f972ea455557a42',
      fields: {
        origine: 'JB.Gr\u00fcningen (Suisse)',
        espece: 'gelida',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Gentiana',
        date_plantation: '2006',
        famille: 'Gentianaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a16a81715f1fcd3e44c73dca0c772e0555b740e8',
      fields: {
        origine: 'JBU.Z\u00fcrich (Suisse)',
        espece: 'lutea L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Gentiana',
        date_plantation: '2006',
        famille: 'Gentianaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '56f5e9f1aef010f446507084d81da67089f276c2',
      fields: {
        origine: 'JB.Northampton Massachusets (USA)',
        espece: 'maculatum L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Geranium',
        date_plantation: '1990',
        famille: 'Geraniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '904ac38c4a94abbce233e69d0c9da82bb19970b3',
      fields: {
        espece: 'thumbergii',
        localisation: 'D3F',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220122, -1.5416317],
        genre: 'Geranium',
        date_plantation: '1995',
        famille: 'Geraniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5416317, 47.220122] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ce0bf89f2a8a108de3be32cf5b1347415e410be8',
      fields: {
        espece: 'biloba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 102, 37, 1.00)',
            'rgba(117, 94, 35, 1.00)',
            'rgba(64, 55, 22, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ginkgo [ginkgoaceae]/ginkgo biloba/ginkgo biloba (6).jpg',
          width: 1024,
          id: '38ee2f36e1bd3e0eb195e24c07191231',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 143, 136, 1.00)',
            'rgba(161, 149, 129, 1.00)',
            'rgba(65, 71, 67, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ginkgo [ginkgoaceae]/ginkgo biloba/ginkgo biloba (5).jpg',
          width: 512,
          id: '56216793005448a4b226a63b588328c8',
          height: 768,
          thumbnail: true,
        },
        location: [47.270188, -1.582445],
        genre: 'Ginkgo',
        famille: 'Ginkgoaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582445, 47.270188] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2159825f0ee04bec39dcc7bff143d70da9b336fc',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'viburnifolium',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 119, 66, 1.00)',
            'rgba(109, 151, 87, 1.00)',
            'rgba(97, 137, 81, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ribes [grossulariaceae]/ribes viburnifolium/ribes viburnifolium (2).jpg',
          width: 662,
          id: '2d6123e12752c772c9250614a5e98fcc',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 159, 147, 1.00)',
            'rgba(120, 144, 102, 1.00)',
            'rgba(96, 114, 74, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ribes [grossulariaceae]/ribes viburnifolium/ribes viburnifolium (3).jpg',
          width: 576,
          id: '3e4f556456f3981660513081e5a21b4a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 134, 131, 1.00)',
            'rgba(135, 135, 125, 1.00)',
            'rgba(152, 137, 138, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ribes [grossulariaceae]/ribes viburnifolium/ribes viburnifolium (1).jpg',
          width: 576,
          id: '07d105c91e0e090bf5bd72264f71adb6',
          height: 768,
          thumbnail: true,
        },
        location: [47.271203, -1.585987],
        genre: 'Ribes',
        famille: 'Grossulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585987, 47.271203] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f9381683e9f783a94d9818981835cb59e3dc45b4',
      fields: {
        origine: "J.P.d'Amiens,France",
        espece: 'erecta Schindl.',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Haloragis',
        date_plantation: '2015',
        famille: 'Haloragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1843cb4c2d07e79703480e80eb10645148eb37c8',
      fields: {
        espece: 'persica',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 145, 106, 1.00)',
            'rgba(108, 119, 80, 1.00)',
            'rgba(76, 94, 51, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/parrotia [hamamelidaceae]/parrotia persica/parrotia persica (4).jpg',
          width: 1024,
          id: '1273c033f2979ab9afa9c9f603dae80a',
          height: 683,
          thumbnail: true,
        },
        location: [47.261982, -1.535304],
        genre: 'Parrotia',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535304, 47.261982] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd158e0b374793bdac5a2b5703b6eea32eaeed4cc',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 113, 60, 1.00)',
            'rgba(142, 145, 90, 1.00)',
            'rgba(77, 91, 30, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia scabra 'punctata'/deutzia scabra 'punctata'.jpg",
          width: 576,
          id: '4e042050d2715b8d2a3d20da8f6f59fe',
          height: 768,
          thumbnail: true,
        },
        espece: 'scabra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 107, 64, 1.00)',
            'rgba(144, 149, 116, 1.00)',
            'rgba(78, 91, 44, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia scabra 'punctata'/deutzia scabra 'punctata' (2).jpg",
          width: 576,
          id: '61841f34fd52c8003623988aeccae0c3',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 129, 81, 1.00)',
            'rgba(122, 134, 90, 1.00)',
            'rgba(101, 114, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia scabra 'punctata'/deutzia scabra 'punctata' (1).jpg",
          width: 867,
          id: '6aa87e5e59455e414d961c263aaecdb0',
          height: 768,
          thumbnail: true,
        },
        location: [47.271672, -1.58212],
        genre: 'Deutzia',
        cultivar: 'Punctata',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58212, 47.271672] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a70f861e3c190c720a9cd552837356fa3c39a6c9',
      fields: {
        espece: 'scabra',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 109, 77, 1.00)',
            'rgba(126, 138, 86, 1.00)',
            'rgba(121, 123, 87, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia scabra 'punctata'/deutzia scabra 'punctata' (3).jpg",
          width: 1024,
          id: '271bbe84a2a47003f1f22e90fe7e98c9',
          height: 768,
          thumbnail: true,
        },
        location: [47.270217, -1.586238],
        genre: 'Deutzia',
        cultivar: 'Punctata',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586238, 47.270217] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '370a7bcae05ea081e9cad19727c73b8587bc0fe0',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 117, 91, 1.00)',
            'rgba(144, 154, 138, 1.00)',
            'rgba(63, 82, 44, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'natchez'/philadelphus 'natchez' (3).jpg",
          width: 576,
          id: 'd3a29689942be04655338c2545085025',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(75, 89, 68, 1.00)',
            'rgba(92, 104, 83, 1.00)',
            'rgba(64, 81, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'natchez'/philadelphus 'natchez' (4).jpg",
          width: 1024,
          id: '313964a58e0a207fbaedad65a7323c16',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 127, 89, 1.00)',
            'rgba(105, 119, 75, 1.00)',
            'rgba(90, 94, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'natchez'/philadelphus 'natchez' (2).jpg",
          width: 1024,
          id: '88ff7c2394514f17cd1ed05d29dbf2db',
          height: 768,
          thumbnail: true,
        },
        location: [47.271178, -1.586658],
        genre: 'Philadelphus',
        cultivar: 'Natchez',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586658, 47.271178] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e7234aeae533757290de6de79946899f8441ef1e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 110, 63, 1.00)',
            'rgba(107, 124, 79, 1.00)',
            'rgba(83, 94, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'natchez'/philadelphus 'natchez'.jpg",
          width: 1024,
          id: 'd5b1349ff8d43cf4b4e91c748603b3d0',
          height: 768,
          thumbnail: true,
        },
        location: [47.271617, -1.581967],
        genre: 'Philadelphus',
        cultivar: 'Natchez',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581967, 47.271617] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd1f4dd0e61809a72d23d226f429decb99a165459',
      fields: {
        origine: 'J.Alp.U.Insbruck (Autriche)',
        espece: 'oblongifolium Choisy',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Hypericum',
        date_plantation: '1999',
        famille: 'Hypericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '80e5d5fcfcf54a9d2286b0242fb2c11324c03bf4',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes 71290 La Gen\u00eate',
        espece: 'hookerianum Wight & Arn.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Hypericum',
        date_plantation: '2015',
        famille: 'Hypericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'acf9c8ffd165b949207f3d49f25f813e942f5620',
      fields: {
        origine: 'J.Alp.Meyrin (Suisse)',
        espece: 'montanum E.L Greene.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Sisyrinchium',
        date_plantation: '2000',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dcd7f221b76b07a141ca45ff468dbb83723d7262',
      fields: {
        origine: 'JB. G\u00f6teborg (Su\u00e8de)',
        espece: 'vernus All.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Crocus',
        date_plantation: '2010',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '074b9d92cf2f28129bea70f59d6beb2b02148a1b',
      fields: {
        origine: 'JB.Nanjingensis (Chine)',
        espece: 'sanguinea Hornem.',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Iris',
        date_plantation: '1993',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7d1916f38cec67a5e4c6064c15e9103dd596e63b',
      fields: {
        origine: 'JB.Timaru (N-Z\u00e9lande)',
        espece: 'pulcherrimum Baker',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Dierama',
        date_plantation: '1994',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a197991166777e9a2fc8a2c89eb4d5d81bbd4f89',
      fields: {
        origine: 'Mr.Figureau C.',
        espece: 'chamaeiris Bertol.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Iris',
        date_plantation: '1998',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c19ec411540ade9a6a506581db8ff23a0a9ae8d8',
      fields: {
        origine: "Park et Arboretum de l'universit\u00e9 de Washington USA",
        espece: 'missouriensis M. Martens',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Iris',
        date_plantation: '2006',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ee707c2825147eb9508a472b2590ba500db7f582',
      fields: {
        origine: 'Universitatea de Stiinte Agricole,Cluj-Napoca,Roumanie',
        espece: 'magnifica Vved.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Iris',
        date_plantation: '2013',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2a59d43554175290381c4c8b56e7009d28d7eafb',
      fields: {
        espece: 'laevigata Fisch.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Iris',
        date_plantation: '1973',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a5bd665fd6fbb1f2f9c8f817d5197ec18dc006b1',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'ilicifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(188, 198, 157, 1.00)',
            'rgba(95, 112, 57, 1.00)',
            'rgba(98, 116, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/itea [iteaceae]/itea ilicifolia/itea ilicifolia    (2).jpg',
          width: 1024,
          id: 'dd5b35fb382cc8b47359830c0d229172',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(213, 208, 197, 1.00)',
            'rgba(107, 113, 68, 1.00)',
            'rgba(86, 101, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/itea [iteaceae]/itea ilicifolia/itea ilicifolia    (3).jpg',
          width: 1024,
          id: '6563eb7000558967209dd87512039127',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 123, 64, 1.00)',
            'rgba(117, 135, 67, 1.00)',
            'rgba(118, 138, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/itea [iteaceae]/itea ilicifolia/itea ilicifolia    (1).jpg',
          width: 576,
          id: '3db823c7df647f364d3a75f437f39de4',
          height: 768,
          thumbnail: true,
        },
        location: [47.26997, -1.582453],
        genre: 'Itea',
        famille: 'Iteaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582453, 47.26997] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c78c19412f3639479a94e915253d089e3fd2df88',
      fields: {
        origine: 'Botanischer Garten Karl-Franzens, Graz, Autriche',
        espece: 'camphoratus Hoffmanns & Link',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Thymus',
        date_plantation: '2012',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3d19fbabaac0aa32c8ac288d44d6864e0225c8e9',
      fields: {
        origine: 'Honorable Municipalidad de Cochabamba',
        espece: 'cf.orbignaei Benth.(4 pieds)',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Salvia',
        date_plantation: '2003',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4eba21cd6632c788e793a2cc9768edda9a372bcd',
      fields: {
        origine: 'J.B. Marie Curie, Lublin (Pologne)',
        espece: 'dalmatica Benth.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Micromeria',
        date_plantation: '2011',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1596ec2902cbc9ad76ed2d8a6aef899e68cc16cd',
      fields: {
        origine: 'JB.Dijon (France)',
        espece: 'montana L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Satureja',
        date_plantation: '1997',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'abfc4e8065e9b8033fb0c705169eb9be5551b678',
      fields: {
        origine: 'JB.Montpellier (France)',
        espece: 'flavum L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Teucrium',
        date_plantation: '2004',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ec03feed996b7fa51b768610b7caaa97c0f758df',
      fields: {
        origine: 'JBU.Bern (Suisse)',
        espece: 'hyssopifolia L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Sideritis',
        date_plantation: '2008',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6866d244aa0f5e9dd7e0f8bba114f0a16f7eb6b6',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes 71290 La Gen\u00eate',
        espece: 'moschata Miq.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Chelonopsis',
        date_plantation: '2015',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0261a014c64e13b536f8903900c2e4e2dcfca56e',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes 71290 La Gen\u00eate',
        espece: 'stellipilum Kitamura & Murata',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Leucosceptrum',
        date_plantation: '2015',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9ff0299bb9cd74c22bf7e01dd3a78883ecb2cfec',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 154, 60, 1.00)',
            'rgba(107, 143, 44, 1.00)',
            'rgba(95, 132, 28, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/premna [lamiaceae]/premna japonica/premna japonica (2).jpg',
          width: 576,
          id: 'e7cd056a0468114d894224bbd1f6a5d5',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 161, 99, 1.00)',
            'rgba(109, 146, 84, 1.00)',
            'rgba(95, 116, 71, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/premna [lamiaceae]/premna japonica/premna japonica.jpg',
          width: 576,
          id: 'ab7d0f17936d522fc78b203138a425a1',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 103, 44, 1.00)',
            'rgba(105, 123, 62, 1.00)',
            'rgba(53, 62, 34, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/premna [lamiaceae]/premna japonica/premna japonica (1).jpg',
          width: 576,
          id: '77e760f55bec37f87c16df9b1de0da3d',
          height: 768,
          thumbnail: true,
        },
        location: [47.270567, -1.58158],
        genre: 'Premna',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58158, 47.270567] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '283e7e8222dda446dd739c8f8ad08f032137335b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'dependens',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 113, 85, 1.00)',
            'rgba(95, 108, 85, 1.00)',
            'rgba(87, 101, 70, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/rostrinucula [lamiaceae]/rostrinucula dependens/rostrinucula dependens (3).jpg',
          width: 576,
          id: '6159b067b7a790863e1a5f1d570f7b4a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 165, 139, 1.00)',
            'rgba(106, 110, 71, 1.00)',
            'rgba(105, 104, 74, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/rostrinucula [lamiaceae]/rostrinucula dependens/rostrinucula dependens (4).jpg',
          width: 1024,
          id: '0b8e646894fa19d83c6e32d0d16d75c5',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 119, 104, 1.00)',
            'rgba(114, 136, 120, 1.00)',
            'rgba(99, 118, 103, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/rostrinucula [lamiaceae]/rostrinucula dependens/rostrinucula dependens (2).jpg',
          width: 725,
          id: '11b91f0b808d941536cdca743d242eeb',
          height: 768,
          thumbnail: true,
        },
        location: [47.271712, -1.582575],
        genre: 'Rostrinucula',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582575, 47.271712] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f807efb3298b94af45ccb0fd5943028a3c50e643',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'agnus-castus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 141, 128, 1.00)',
            'rgba(123, 128, 96, 1.00)',
            'rgba(139, 129, 116, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/vitex [lamiaceae]/vitex agnus-castus/vitex agnus-castus (2).jpg',
          width: 576,
          id: '562549763240d0fd0559cde1923ce4a4',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 165, 129, 1.00)',
            'rgba(101, 122, 82, 1.00)',
            'rgba(102, 109, 79, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/vitex [lamiaceae]/vitex agnus-castus/vitex agnus-castus (3).jpg',
          width: 1024,
          id: 'e4143e8ffd91d40d6c6a0f171e37f995',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 138, 112, 1.00)',
            'rgba(129, 132, 125, 1.00)',
            'rgba(91, 106, 69, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/vitex [lamiaceae]/vitex agnus-castus/vitex agnus-castus (1).jpg',
          width: 576,
          id: '607e102e7db1e16e44a2666453a4f2ca',
          height: 768,
          thumbnail: true,
        },
        location: [47.271875, -1.58218],
        genre: 'Vitex',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58218, 47.271875] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ada7131973c5a02808dee88a699b77e384b5bf2b',
      fields: {
        espece: 'agnus-castus',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 164, 140, 1.00)',
            'rgba(82, 96, 63, 1.00)',
            'rgba(95, 102, 77, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/vitex [lamiaceae]/vitex agnus-castus/vitex agnus-castus (golf).jpg',
          width: 1024,
          id: 'bcc1fca1ad8ff4262a9a8b50859c9a57',
          height: 768,
          thumbnail: true,
        },
        location: [47.267608, -1.582117],
        genre: 'Vitex',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582117, 47.267608] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c551bae768862ade76b3662b36133030544f7aa8',
      fields: {
        origine: 'JB.Strasbourg',
        espece: 'californica',
        localisation: 'A5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2207668, -1.5440149],
        genre: 'Umbellularia',
        date_plantation: '2004',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440149, 47.2207668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '88c4d7608dd1e272fa3dd101c2cfff9f85fd1b86',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'albidum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 96, 38, 1.00)',
            'rgba(132, 124, 48, 1.00)',
            'rgba(68, 69, 31, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sassafras [lauraceae]/sassafras albidum/sassafras albidum (10).jpg',
          width: 576,
          id: '043508433c04d341469888edbb9670ab',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 126, 114, 1.00)',
            'rgba(153, 139, 132, 1.00)',
            'rgba(142, 119, 110, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sassafras [lauraceae]/sassafras albidum/sassafras albidum (12).jpg',
          width: 576,
          id: 'fa15cfb6abcd9cd3229292019b143c6d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 146, 83, 1.00)',
            'rgba(104, 140, 78, 1.00)',
            'rgba(147, 169, 104, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sassafras [lauraceae]/sassafras albidum/sassafras albidum (1).jpg',
          width: 576,
          id: 'b8f50f61db65dc8dd26daff34244acf3',
          height: 768,
          thumbnail: true,
        },
        location: [47.270817, -1.585808],
        genre: 'Sassafras',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585808, 47.270817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b837bbd8881140de78d1659d4563e75c405a6246',
      fields: {
        origine: 'J.Alpin des Rochers-de-Naye,Montreux,Suisse',
        espece: 'buschianum Lodd.',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Lilium',
        date_plantation: '2012',
        famille: 'Liliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dd2a5f3b2e8c8c690400d41f8c410333733e8b85',
      fields: {
        origine: 'JB.Ljubljani (Slov\u00e9nie)',
        espece: 'carniolicum Bernh.',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Lilium',
        date_plantation: '2006',
        famille: 'Liliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'debf1e3d1a2c317d1187cc81ba7fe365cfe403e2',
      fields: {
        espece: 'granatum var. nana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 142, 69, 1.00)',
            'rgba(137, 130, 45, 1.00)',
            'rgba(137, 121, 65, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/punica [lythraceae]/punica granatum var. nana/punica granatum var. nana.jpg",
          width: 576,
          id: '121c283764c8ae092b2a1ec1a9e7c850',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(192, 193, 149, 1.00)',
            'rgba(128, 129, 50, 1.00)',
            'rgba(140, 136, 97, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/punica [lythraceae]/punica granatum var. nana/punica granatum var. nana (2).jpg",
          width: 1024,
          id: '8851b47a955a8da18b63783e63d43a50',
          height: 768,
          thumbnail: true,
        },
        location: [47.226587, -1.512158],
        genre: 'Punica',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512158, 47.226587] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '50091be957592d08cd2c017c0950e080fece6f77',
      fields: {
        origine: "P\u00e9pini\u00e8re du Val d' Erdre",
        espece: 'acuminata',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Magnolia',
        date_plantation: '2011',
        cultivar: 'Butterfly',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2d85e399b09d464564035a2547998a560230681f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 98, 153, 1.00)',
            'rgba(105, 132, 170, 1.00)',
            'rgba(81, 80, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/liriodendron [magnoliaceae]/liriodendron 'chapel hill'/liriodendron 'chapel hill'  (5).jpg",
          width: 556,
          id: '49c18f2a3ba4dee89a6f7feb33289c9d',
          height: 768,
          thumbnail: true,
        },
        location: [47.271638, -1.582563],
        genre: 'Liriodendron',
        cultivar: 'Chapel Hill',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582563, 47.271638] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bf58a29eab3a1594845c89e67a2b7486906d6778',
      fields: {
        espece: 'delavayi',
        localisation: 'A5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2207668, -1.5440149],
        genre: 'Magnolia',
        date_plantation: '1973',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440149, 47.2207668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '515f8d364f9a71f561676c4bc857a95f2a032049',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 100, 122, 1.00)',
            'rgba(82, 87, 74, 1.00)',
            'rgba(64, 63, 42, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'elizabeth'/magnolia 'elizabeth' (2).jpg",
          width: 1024,
          id: 'f392fb77712a33402608ff464f10dbf9',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 104, 107, 1.00)',
            'rgba(98, 107, 103, 1.00)',
            'rgba(81, 98, 116, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'elizabeth'/magnolia 'elizabeth' (3).jpg",
          width: 1024,
          id: '06393ac58ce2edc867c0280457c8a729',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 159, 173, 1.00)',
            'rgba(125, 131, 126, 1.00)',
            'rgba(71, 70, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'elizabeth'/magnolia 'elizabeth' (1).jpg",
          width: 1024,
          id: '547f6915695882dbcf94122ab61f38b3',
          height: 627,
          thumbnail: true,
        },
        location: [47.26817, -1.583017],
        genre: 'Magnolia',
        cultivar: 'Elizabeth',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583017, 47.26817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '762437baa427efae7721bc8b0338cfe101219cf3',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 123, 127, 1.00)',
            'rgba(144, 130, 133, 1.00)',
            'rgba(109, 90, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'floppy'/magnolia 'floppy' (5).jpg",
          width: 1024,
          id: '5dc3820f0922783712496fcbca99b59c',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 119, 122, 1.00)',
            'rgba(144, 130, 132, 1.00)',
            'rgba(80, 70, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'floppy'/magnolia 'floppy' (4).jpg",
          width: 1024,
          id: '0a1fdb5473c1bb6ae2f6884dfca048ca',
          height: 683,
          thumbnail: true,
        },
        location: [47.271325, -1.584792],
        genre: 'Magnolia',
        cultivar: 'Floppy',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584792, 47.271325] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '17efdfde59effda6adf7e905b15027a091abef63',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 115, 161, 1.00)',
            'rgba(113, 129, 146, 1.00)',
            'rgba(86, 83, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia salicifolia 'kewensis'/magnolia salicifolia 'kewensis' (3).jpg",
          width: 512,
          id: '5216bdaac39399f0e65fa72cd5673923',
          height: 768,
          thumbnail: true,
        },
        espece: 'salicifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 123, 107, 1.00)',
            'rgba(153, 152, 143, 1.00)',
            'rgba(66, 73, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia salicifolia 'kewensis'/magnolia salicifolia 'kewensis' (2).jpg",
          width: 576,
          id: '17584867b87aa6600bda63c8b449c3e8',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 79, 54, 1.00)',
            'rgba(133, 134, 124, 1.00)',
            'rgba(77, 78, 65, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia salicifolia 'kewensis'/magnolia salicifolia 'kewensis' (1).jpg",
          width: 576,
          id: '8fb51fc467be61608f1f0b7394702a6e',
          height: 768,
          thumbnail: true,
        },
        location: [47.271313, -1.58167],
        genre: 'Magnolia',
        cultivar: 'Kewensis',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58167, 47.271313] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9def3e0ed9f5643db7490187c5cc36896bc422c4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 101, 56, 1.00)',
            'rgba(122, 130, 100, 1.00)',
            'rgba(161, 152, 135, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fremontodendron [malvaceae]/fremontodendron 'tequila sunrise'/fremontodendron 'tequila sunrise' (2).jpg",
          width: 576,
          id: 'eb992eb82e08d9cbb137e8409db2e59d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 113, 59, 1.00)',
            'rgba(154, 132, 67, 1.00)',
            'rgba(117, 119, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fremontodendron [malvaceae]/fremontodendron 'tequila sunrise'/fremontodendron 'tequila sunrise' (3).jpg",
          width: 576,
          id: '0b5d669dfcd9c914c6e91f36e262ea54',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 124, 77, 1.00)',
            'rgba(125, 115, 67, 1.00)',
            'rgba(112, 119, 88, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fremontodendron [malvaceae]/fremontodendron 'tequila sunrise'/fremontodendron 'tequila sunrise' (1).jpg",
          width: 576,
          id: 'a77a5a76e90b15e5faead2d6ce09332e',
          height: 768,
          thumbnail: true,
        },
        location: [47.27193, -1.582555],
        genre: 'Fremontodendron',
        cultivar: 'Tequila Sunrise',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582555, 47.27193] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd7fcceee521f4c922562fe9a5caacefcaa398afc',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 107, 38, 1.00)',
            'rgba(118, 147, 65, 1.00)',
            'rgba(168, 153, 104, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hibiscus [malvaceae]/hibiscus sinosyriacus 'ruby glow'/hibiscus sinosyriacus 'ruby glow'  (3).jpg",
          width: 576,
          id: 'b98f9893cf8e0960ecfd482520809549',
          height: 768,
          thumbnail: true,
        },
        espece: 'sinosyriacus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 113, 75, 1.00)',
            'rgba(135, 135, 110, 1.00)',
            'rgba(71, 80, 38, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hibiscus [malvaceae]/hibiscus sinosyriacus 'ruby glow'/hibiscus sinosyriacus 'ruby glow'  (2).jpg",
          width: 576,
          id: 'dcb183d0e51732834765c6725e48ee84',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 109, 65, 1.00)',
            'rgba(112, 125, 72, 1.00)',
            'rgba(150, 125, 92, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hibiscus [malvaceae]/hibiscus sinosyriacus 'ruby glow'/hibiscus sinosyriacus 'ruby glow'  (1).jpg",
          width: 576,
          id: '05751817ecb8b304e3858a6c13d9683f',
          height: 768,
          thumbnail: true,
        },
        location: [47.2712, -1.58197],
        genre: 'Hibiscus',
        cultivar: 'Ruby Glow',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58197, 47.2712] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '13c81223ef7f5e0c87897ffececaa5cfbb5e9989',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'henryana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 142, 78, 1.00)',
            'rgba(128, 134, 72, 1.00)',
            'rgba(60, 79, 36, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tilia [malvaceae]/tilia henryana/tilia henryana  (4).jpg',
          width: 576,
          id: 'e04de757df7d8988cba9ceaa6e1f61bb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 125, 43, 1.00)',
            'rgba(132, 135, 38, 1.00)',
            'rgba(103, 104, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tilia [malvaceae]/tilia henryana/tilia henryana (1).jpg',
          width: 576,
          id: 'aa3a3c7fb88358f274065a77f7bded7e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(189, 197, 178, 1.00)',
            'rgba(93, 106, 63, 1.00)',
            'rgba(75, 80, 49, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tilia [malvaceae]/tilia henryana/tilia henryana  (2).jpg',
          width: 1024,
          id: '1e5ae276a56cb5498477b79683347d45',
          height: 768,
          thumbnail: true,
        },
        location: [47.270413, -1.580945],
        genre: 'Tilia',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580945, 47.270413] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fbafd20d6ae33514fbb3d990ec6cfe66f35ec2d4',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'appendiculata Cav.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Francoa',
        date_plantation: '1998',
        famille: 'Melianthaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '353c17f0f5bb40b810346b0a139f6c71db6239ac',
      fields: {
        origine:
          'JB B. Boff -Asni\u00e8resJardin botanique - nature\u00a0: Tokyo, Japon',
        espece: 'orbiculatus',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Cocculus',
        date_plantation: '2002',
        famille: 'Menispermaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8bb260f72618031918dea913a3cee19e68a93398',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'papyrifera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 135, 63, 1.00)',
            'rgba(129, 112, 54, 1.00)',
            'rgba(130, 139, 82, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/broussonetia [moraceae]/broussonetia papyrifera/broussonetia papyrifera (2).jpg',
          width: 997,
          id: 'c32d3d34a72f24c7e85dd274ea64915f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(185, 176, 146, 1.00)',
            'rgba(121, 141, 93, 1.00)',
            'rgba(141, 148, 109, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/broussonetia [moraceae]/broussonetia papyrifera/broussonetia papyrifera (3).jpg',
          width: 576,
          id: '1408e2d84e80a1f21b59f77d9e76da3b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 149, 135, 1.00)',
            'rgba(139, 119, 102, 1.00)',
            'rgba(139, 121, 104, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/broussonetia [moraceae]/broussonetia papyrifera/broussonetia papyrifera (1).jpg',
          width: 576,
          id: '5be1ad40302a2406fa7976981dcaea3b',
          height: 768,
          thumbnail: true,
        },
        location: [47.269733, -1.586088],
        genre: 'Broussonetia',
        famille: 'Moraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586088, 47.269733] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bd9cfa7afe25a66176b116c9cd913f42f537c6a4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'tricuspidata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 124, 82, 1.00)',
            'rgba(147, 146, 54, 1.00)',
            'rgba(109, 104, 69, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/maclura [moraceae]/maclura tricuspidata/maclura tricuspidata (4).jpg',
          width: 576,
          id: 'bcd05fccf7e6454315189ceec6a5b5eb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 129, 83, 1.00)',
            'rgba(137, 132, 110, 1.00)',
            'rgba(135, 124, 128, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/maclura [moraceae]/maclura tricuspidata/maclura tricuspidata (5).jpg',
          width: 576,
          id: '7762b45ee9bbd9d373d1d00ae8637640',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 109, 75, 1.00)',
            'rgba(108, 131, 108, 1.00)',
            'rgba(73, 79, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/maclura [moraceae]/maclura tricuspidata/maclura tricuspidata (1).jpg',
          width: 576,
          id: '85a16f9e84643f58b3c5a7e2ece9bd2f',
          height: 768,
          thumbnail: true,
        },
        location: [47.270513, -1.581538],
        genre: 'Maclura',
        famille: 'Moraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581538, 47.270513] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '211fc5026a5d969be18c76af538ce067eca0028b',
      fields: {
        espece: 'alba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 149, 76, 1.00)',
            'rgba(134, 160, 48, 1.00)',
            'rgba(133, 149, 71, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/morus [moraceae]/morus alba/morus alba (2).jpg',
          width: 576,
          id: '7950e1e404a8d3d374d354d61cb09239',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 141, 79, 1.00)',
            'rgba(150, 152, 73, 1.00)',
            'rgba(130, 135, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/morus [moraceae]/morus alba/morus alba (1).jpg',
          width: 576,
          id: 'b99795787128d0598a5aa9ae24a92b6b',
          height: 768,
          thumbnail: true,
        },
        location: [47.271487, -1.584538],
        genre: 'Morus',
        famille: 'Moraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584538, 47.271487] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7c322e6d3e68393d28c12c7e793882ba2cdf8ced',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 152, 94, 1.00)',
            'rgba(123, 126, 68, 1.00)',
            'rgba(138, 123, 102, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/morus [moraceae]/morus nigra 'tortuosa'/morus nigra 'tortuosa.jpg",
          width: 576,
          id: '48a20a877d962d0e41825d2e27563fc8',
          height: 768,
          thumbnail: true,
        },
        espece: 'nigra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 100, 89, 1.00)',
            'rgba(134, 114, 91, 1.00)',
            'rgba(138, 121, 97, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/morus [moraceae]/morus nigra 'tortuosa'/morus nigra 'tortuosa'.jpg",
          width: 576,
          id: '8dfc657e842053d16985799462c8525d',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 138, 59, 1.00)',
            'rgba(115, 164, 59, 1.00)',
            'rgba(79, 122, 29, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/morus [moraceae]/morus nigra 'tortuosa'/morus nigra 'tortuosa' (3).jpg",
          width: 576,
          id: '53a03309dc859499bd6168a7e3bbe478',
          height: 768,
          thumbnail: true,
        },
        location: [47.270883, -1.582862],
        genre: 'Morus',
        cultivar: 'Tortuosa',
        famille: 'Moraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582862, 47.270883] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9a6ec6c3eab34f6ae0140c4bb8ec86da43137197',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'citriodora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 137, 60, 1.00)',
            'rgba(140, 145, 48, 1.00)',
            'rgba(98, 107, 19, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/backhousia [myrtaceae]/backhousia citriodora/backhousia citriodora (3).jpg",
          width: 576,
          id: '8b92dd4cab5836bff96cb7f6c3d169cb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 136, 59, 1.00)',
            'rgba(137, 135, 58, 1.00)',
            'rgba(134, 140, 38, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/backhousia [myrtaceae]/backhousia citriodora/backhousia citriodora (4).jpg",
          width: 576,
          id: 'c25b6bad64e14c9a1592842722bce1b4',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 146, 64, 1.00)',
            'rgba(135, 140, 57, 1.00)',
            'rgba(102, 112, 13, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/backhousia [myrtaceae]/backhousia citriodora/backhousia citriodora (2).jpg",
          width: 576,
          id: '0eebd4519864c78df2c199c864dd99f9',
          height: 768,
          thumbnail: true,
        },
        location: [47.226505, -1.512308],
        genre: 'Backhousia',
        famille: 'Myrtaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512308, 47.226505] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0ce0843ed811711d84b82b34ae5be445f8673ba1',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'sylvatica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 107, 26, 1.00)',
            'rgba(98, 150, 29, 1.00)',
            'rgba(122, 166, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/nyssa [nyssaceae]/nyssa sylvatica/nyssa sylvatica (2).jpg',
          width: 576,
          id: 'c7c92a48df9a17577c17d8baa4def53f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 135, 56, 1.00)',
            'rgba(125, 104, 28, 1.00)',
            'rgba(116, 95, 14, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/nyssa [nyssaceae]/nyssa sylvatica/nyssa sylvatica (3).jpg',
          width: 576,
          id: '9607b6cab44bd343d5069142ac713ada',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 93, 31, 1.00)',
            'rgba(145, 114, 49, 1.00)',
            'rgba(106, 85, 18, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/nyssa [nyssaceae]/nyssa sylvatica/nyssa sylvatica (1).jpg',
          width: 576,
          id: '5138c31d9e095d61b3ff7651a210aa65',
          height: 768,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Nyssa',
        famille: 'Nyssaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ed975dfffbb3b77315168e8ba00e03bd459dd142',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 183, 204, 1.00)',
            'rgba(121, 134, 109, 1.00)',
            'rgba(98, 102, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus excelsior 'crispa'/fraxinus excelsior 'crispa' (2).jpg",
          width: 576,
          id: '7cf63ff6f13f83a735f61d874b626961',
          height: 768,
          thumbnail: true,
        },
        espece: 'excelsior',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 126, 110, 1.00)',
            'rgba(132, 128, 111, 1.00)',
            'rgba(147, 139, 128, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus excelsior 'crispa'/fraxinus excelsior 'crispa'  (2).jpg",
          width: 576,
          id: '61bbf3c21932f09e88010767ed21b055',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 167, 142, 1.00)',
            'rgba(102, 125, 91, 1.00)',
            'rgba(132, 134, 109, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus excelsior 'crispa'/fraxinus excelsior 'crispa'  (1).jpg",
          width: 576,
          id: '79fa11a6e91f0a4d8bbe726d2f8a4b52',
          height: 768,
          thumbnail: true,
        },
        location: [47.270688, -1.581492],
        genre: 'Fraxinus',
        cultivar: 'Crispa',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581492, 47.270688] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '78060091acf5fd96c646590e965c66836b0ea77b',
      fields: {
        espece: 'nudiflorum',
        localisation: 'A11',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2211256, -1.5428042],
        genre: 'Jasminum',
        date_plantation: '1973',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428042, 47.2211256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6e248e1c7d0e932c5e09ffd113b02ee09c360eda',
      fields: {
        espece: 'heterophyllus',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 133, 105, 1.00)',
            'rgba(105, 127, 99, 1.00)',
            'rgba(82, 89, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus heterophyllus 'goshiki'/osmanthus heterophyllus 'goshiki' (4).jpg",
          width: 665,
          id: 'edd4d8ffd2e04594a50f4cda1291aad7',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Osmanthus',
        cultivar: 'Goshiki',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ae57181c1fb886a3e097aeeb1898156a395d6a7c',
      fields: {
        espece: 'heterophyllus',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 172, 136, 1.00)',
            'rgba(115, 116, 107, 1.00)',
            'rgba(80, 72, 74, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus heterophyllus 'purpureus'/osmanthus heterophyllus 'purpureus' (2).jpg",
          width: 1024,
          id: '067ded33106a5e831f84ec1592b97dc5',
          height: 683,
          thumbnail: true,
        },
        location: [47.270708, -1.581017],
        genre: 'Osmanthus',
        cultivar: 'Purpureus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581017, 47.270708] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '262963e3b760909a91318f0b86c7b9ac23bf8871',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x laciniata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 137, 108, 1.00)',
            'rgba(96, 123, 67, 1.00)',
            'rgba(108, 132, 75, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/syringa [oleaceae]/syringa x laciniata/syringa x laciniata  (2).jpg',
          width: 576,
          id: 'd378837317bcfe8f5957b08c30a76b0b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 99, 33, 1.00)',
            'rgba(102, 118, 82, 1.00)',
            'rgba(57, 89, 26, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/syringa [oleaceae]/syringa x laciniata/syringa x laciniata (1).jpg',
          width: 576,
          id: '82d5e13cdc04ec959ee20830aaecca32',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 113, 99, 1.00)',
            'rgba(122, 123, 115, 1.00)',
            'rgba(74, 90, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/syringa [oleaceae]/syringa x laciniata/syringa x laciniata  (1).jpg',
          width: 576,
          id: '49750354b16fd307499129f95e4783be',
          height: 768,
          thumbnail: true,
        },
        location: [47.270595, -1.586387],
        genre: 'Syringa',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586387, 47.270595] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fd81d2cecfee4416abaa82e2a4fa0bb546930479',
      fields: {
        origine: 'Universit\u00e9 Marie Curie JB. Lublin (Pologne)',
        espece: 'canovirens E.S.Steele',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Oenothera',
        date_plantation: '2011',
        famille: 'Onagraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '213b0ba478651af3827b5b4ccbac6b54ce2200ff',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'lutea Delavay',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Paeonia',
        date_plantation: '1987',
        famille: 'Paeoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7b2476ebf7a8995d795734c2e5f87dc994938ce0',
      fields: {
        origine: 'JBU.Neuch\u00e2tel (Suisse)',
        espece: 'peregrina Mill.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Paeonia',
        date_plantation: '1987',
        famille: 'Paeoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5613899d646db684d2e32d53dfa77624ae0d4270',
      fields: {
        espece: 'smithiana',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 171, 208, 1.00)',
            'rgba(101, 109, 102, 1.00)',
            'rgba(94, 87, 64, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/picea [pinaceae]/picea smithiana/picea smithiana (3).jpg',
          width: 512,
          id: '0f3239c5e6b2ba2ec16534610af4ea71',
          height: 768,
          thumbnail: true,
        },
        location: [47.270872, -1.584862],
        genre: 'Picea',
        famille: 'Pinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584862, 47.270872] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e9ffc955c75b5c68ebd9f166e371e648358c6178',
      fields: {
        espece: 'strobus',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(211, 216, 210, 1.00)',
            'rgba(109, 102, 46, 1.00)',
            'rgba(55, 59, 23, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pinus [pinaceae]/pinus strobus/pinus strobus (2).jpg',
          width: 512,
          id: '58c33a4346e4762b4693c29f366e583d',
          height: 768,
          thumbnail: true,
        },
        location: [47.271345, -1.58567],
        genre: 'Pinus',
        famille: 'Pinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58567, 47.271345] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '42091de313178c225f1875974213c87437e169a4',
      fields: {
        origine: 'JB. de la Chanousia, Torino seez (Italie/France)',
        espece: 'lutea L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Digitalis',
        date_plantation: '2011',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ddf323699e755518ffc3de14fb0bf835f72d8a40',
      fields: {
        origine: 'JB. Hermannshof, Wheinheim (Allemagne)',
        espece: 'tubaeflorus Nutt.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Penstemon',
        date_plantation: '2011',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '62a0afdaf642efc770b0cd9b790b4172bcdd3602',
      fields: {
        origine: 'JB.Bern (Suisse)',
        espece: 'alpinus L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Erinus',
        date_plantation: '2006',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9789a60350257ce59e47ec3f890b267b5ed08aea',
      fields: {
        origine: "U.Science Ambientali L' Aquila",
        espece: 'purpurea Mill.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Linaria',
        date_plantation: '2001',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '52d6d4c6dff4c0cd3b8244f794c55c7167fddc4a',
      fields: {
        espece: 'plumbaginioides Bunge',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Ceratostigma',
        date_plantation: '1973',
        famille: 'Plumbaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1695216542bf7ed2229e18abd56c3151f8a9b4d2',
      fields: {
        origine: 'Conservatoire et JB.de Gen\u00e8ve (Suisse)',
        espece: 'ciliata L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Melica',
        date_plantation: '2003',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '497e5e1ff2b65655a7ad90afeb9538dd777689e1',
      fields: {
        origine: 'JB.Olomouc (R\u00e9publique Tch\u00e8que)',
        espece: 'hyalina Doell.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Melica',
        date_plantation: '2006',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b604ee5dc7762e1a651cc52222d153ccf993937a',
      fields: {
        origine: 'JB.Sofia (Bulgarie)',
        espece: 'nigrescens Lam.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Festuca',
        date_plantation: '2009',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1ca6ccbe18020670d305b93e768e37a09d4ec2c1',
      fields: {
        origine: 'Niagara Falls botanic Garden',
        espece: 'latifolia Michx.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Uniola',
        date_plantation: '2006',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bf09095add4dc47ad0ca4b16dd8302db3ac6ff43',
      fields: {
        origine: 'R\u00e9colte nature (WLG-PF)',
        espece: 'caerulea Moench',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Molinia',
        date_plantation: '2016',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '53d0c63ed746e2c0555d52ada82978cc334361bb',
      fields: {
        origine: 'serres de production du Gd Blottereau',
        espece: 'falcatus',
        localisation: 'A5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2207668, -1.5440149],
        genre: 'Afrocarpus',
        date_plantation: '2014',
        famille: 'Podocarpaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440149, 47.2207668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b669f5d743121e5fb33053d17e6fe2514225092a',
      fields: {
        origine: 'J. alpin Viotte, Trento (Italie)',
        espece: 'caeruleum L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Polemonium',
        date_plantation: '2011',
        famille: 'Polemoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5c06a322160143a3cd04ce8594744b22ad5c3a8d',
      fields: {
        origine: 'JB. Osterr-garten, Graz (Autriche)',
        espece: 'pauciflorum S.Watson',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Polemonium',
        date_plantation: '2011',
        famille: 'Polemoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cdd687aaabd951a36b5062d651fdfd5bd70dc288',
      fields: {
        origine: 'Remi Legros ( Les Sorini\u00e8res)',
        espece: 'scoparium',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Polygonum',
        date_plantation: '2015',
        famille: 'Polygonaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '080d8f510886fb4aab4cc12cea5dac79b8ee706e',
      fields: {
        origine: 'BG Univ. Wurzburg',
        espece: 'coum Mill.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Cyclamen',
        date_plantation: '2006',
        cultivar: 'coum',
        famille: 'Primulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '08356e119fcb0f812da335a1dab3b950a086ed11',
      fields: {
        origine: 'Les Ponts de C\u00e9_p\u00e9pini\u00e8re Lepage',
        espece: 'barystachys Bunge.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Lysimachia',
        date_plantation: '2016',
        famille: 'Primulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd6b988f0b28fba4047bf5b1944a8e5ade20cbfd1',
      fields: {
        origine: 'Les Ponts de C\u00e9_p\u00e9pini\u00e8re Lepage',
        espece: 'vialii Delavay',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Primula',
        date_plantation: '2016',
        famille: 'Primulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e4c2e538f2223acd6080ec580d4fa5b28f0d3d25',
      fields: {
        origine: 'R\u00e9colte nature (WLG-PF)',
        espece: 'vulgaris L.',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Lysimachia',
        date_plantation: '2016',
        famille: 'Primulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f3a3fe9951cc7ec6946018cc748cecb2f5fda0bc',
      fields: {
        origine: 'JB-Nantes',
        espece: 'venustum D. Don',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Adiantum',
        date_plantation: '2015',
        famille: 'Pteridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b3042e6d9511944e0d3a92897a21b88ed21c82fc',
      fields: {
        origine: 'Goteborg Botanical Garden,Su\u00e8de',
        espece: 'przewalskii Maxim.',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Thalictrum',
        date_plantation: '2014',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bc759e1373155767c2e29487d4bd33fe16ef6815',
      fields: {
        origine: 'J.Alp.La Thomasia (Suisse)',
        espece: 'polyantha D.Don.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Anemone',
        date_plantation: '1988',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bd239e3305c1ce617133fe8aaa4cacd2002052db',
      fields: {
        origine: 'JB. Alpin la Saussurea, Courmayer (Italie)',
        espece: 'apertus Perf ex Igoschina',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Trollius',
        date_plantation: '2010',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f70849610afc2b12b17b4600bf907f79ae9333ed',
      fields: {
        origine: 'JB.Weinheim (Allemagne)',
        espece: 'carmichaelii Debeaux.',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Aconitum',
        date_plantation: '2001',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a9cd2f29a05886c6d2e3aa061bb6d5385c493685',
      fields: {
        origine: 'JBU.Chiba Matsudo (Japon)',
        espece: 'dulcis',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Hovenia',
        date_plantation: '1997',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd9b39ad5bf9cb467f153c6f79738ba2236891003',
      fields: {
        origine: 'Taiwan foresty institute -  Taipei',
        espece: 'nakaharae',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Rhamnus',
        date_plantation: '2005',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0f3907ecfc4a15409563e87202770092a68bfdbc',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'paradoxa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 106, 64, 1.00)',
            'rgba(110, 117, 78, 1.00)',
            'rgba(106, 110, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/colletia [rhamnaceae]/colletia paradoxa/colletia paradoxa  (2).jpg',
          width: 576,
          id: 'a6e47d7a6b4198a8aa7e38a4b705fb0f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 96, 56, 1.00)',
            'rgba(111, 120, 79, 1.00)',
            'rgba(117, 117, 84, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/colletia [rhamnaceae]/colletia paradoxa/colletia paradoxa  (3).jpg',
          width: 576,
          id: '2e5a09e03d6bd374f4b386ce5c0bfd3d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 143, 96, 1.00)',
            'rgba(101, 115, 78, 1.00)',
            'rgba(120, 119, 98, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/colletia [rhamnaceae]/colletia paradoxa/colletia paradoxa  (1).jpg',
          width: 1024,
          id: 'c779bd0829536749eb4cfe511d8f3179',
          height: 768,
          thumbnail: true,
        },
        location: [47.271878, -1.582312],
        genre: 'Colletia',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582312, 47.271878] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e407bdd6b0d28b50683ef87d3f5b1305464bec69',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'alaternus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 129, 100, 1.00)',
            'rgba(116, 139, 124, 1.00)',
            'rgba(160, 166, 164, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/rhamnus [rhamnaceae]/rhamnus alaternus/rhamnus alaternus (2).jpg',
          width: 576,
          id: '74d42b3e3855ec8ed4ad8902d39bf1c3',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 135, 105, 1.00)',
            'rgba(114, 134, 108, 1.00)',
            'rgba(133, 147, 123, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/rhamnus [rhamnaceae]/rhamnus alaternus/rhamnus alaternus (3).jpg',
          width: 576,
          id: '4bb7b5eb986dadf65f50a6cd1de43039',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 117, 67, 1.00)',
            'rgba(135, 139, 74, 1.00)',
            'rgba(136, 141, 108, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/rhamnus [rhamnaceae]/rhamnus alaternus/rhamnus alaternus (1).jpg',
          width: 576,
          id: '4a3bd061d693e7d209c10c4a51691342',
          height: 768,
          thumbnail: true,
        },
        location: [47.270517, -1.586492],
        genre: 'Rhamnus',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586492, 47.270517] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3781a2edb78570920ca3549729b497419f52edc2',
      fields: {
        origine: 'Botanischer Garten Albert-Ludwigs',
        espece: 'andicola Benth.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Potentilla',
        date_plantation: '2014',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '44a24ed282957bd95163e4027d9516952f12e968',
      fields: {
        origine: 'Collect. priv\u00e9e Pascal Prieur',
        espece: 'alba',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fa5208b2abc247194caea6df83ce13dfbe10c0ed',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'micrantha',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '570da4d7f111452245f9a05f76510bab8c484f27',
      fields: {
        origine: 'J.Alp."Viott\u00e9" Trento (Italie)',
        espece: 'dioicus Fernald',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Aruncus',
        date_plantation: '2006',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a8cf2fb4a16debdf1e2eebd7aa9a461c1dd653a5',
      fields: {
        origine: 'Les Ponts de C\u00e9_p\u00e9pini\u00e8re Lepage',
        espece: 'dioicus Fernald',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Aruncus',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e7e27c1bfe17585dc99ae7d73adb6daa9ce2f62e',
      fields: {
        origine: 'P\u00e9pini\u00e8re Municipale',
        espece: 'cantoniensis',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '1996',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1e1c74bde7236ff3c888b3e4f70ce811e4873df7',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 157, 129, 1.00)',
            'rgba(129, 146, 125, 1.00)',
            'rgba(121, 133, 111, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/aronia [rosaceae]/aronia x prunifolia 'brilliant'/aronia x prunifolia 'brilliant' (3).jpg",
          width: 576,
          id: '700c529de0fb1dd98752266845d65d09',
          height: 768,
          thumbnail: true,
        },
        espece: 'x prunifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 150, 125, 1.00)',
            'rgba(140, 123, 110, 1.00)',
            'rgba(149, 137, 137, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/aronia [rosaceae]/aronia x prunifolia 'brilliant'/aronia x prunifolia 'brilliant' (2).jpg",
          width: 576,
          id: 'e0cacea62cfecbd02679c1a0a4db4b0d',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 163, 156, 1.00)',
            'rgba(112, 138, 105, 1.00)',
            'rgba(121, 135, 113, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/aronia [rosaceae]/aronia x prunifolia 'brilliant'/aronia x prunifolia 'brilliant' (1).jpg",
          width: 576,
          id: '81a0ea31de7125d2ba362cbfd56775da',
          height: 768,
          thumbnail: true,
        },
        location: [47.271497, -1.581087],
        genre: 'Aronia',
        cultivar: 'Brilliant',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581087, 47.271497] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0494c71f39857f3c75645e5f20c0d76e58ddd2f9',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 113, 69, 1.00)',
            'rgba(130, 81, 79, 1.00)',
            'rgba(82, 91, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/crataegus [rosaceae]/crataegus laevigata 'paul's scarlet'/crataegus laevigata 'paul's scarlet' (3).jpg",
          width: 576,
          id: '2e70e49cf9747d13ce5fb24752e001d2',
          height: 768,
          thumbnail: true,
        },
        espece: 'laevigata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 119, 62, 1.00)',
            'rgba(120, 132, 72, 1.00)',
            'rgba(95, 97, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/crataegus [rosaceae]/crataegus laevigata 'paul's scarlet'/crataegus laevigata 'paul's scarlet' (2).jpg",
          width: 576,
          id: '384d3112f5f5228d374149be7d93923a',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(178, 193, 200, 1.00)',
            'rgba(116, 107, 63, 1.00)',
            'rgba(68, 75, 35, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/crataegus [rosaceae]/crataegus laevigata 'paul's scarlet'/crataegus laevigata 'paul's scarlet' (1).jpg",
          width: 576,
          id: 'c364a61abcb117e510911d11df1af25d',
          height: 768,
          thumbnail: true,
        },
        location: [47.269892, -1.584355],
        genre: 'Crataegus',
        cultivar: "Paul's Scarlet",
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584355, 47.269892] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '69fab9944926d65e06d2fc062dec5a1090a75c3f',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 92, 49, 1.00)',
            'rgba(145, 139, 92, 1.00)',
            'rgba(106, 105, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/photinia [rosaceae]/photinia davidiana 'palette'/photinia davidiana 'palette' (3).jpg",
          width: 576,
          id: '1fa8b5e872aa55b3d7921513cbaf7f2d',
          height: 768,
          thumbnail: true,
        },
        espece: 'davidiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 96, 57, 1.00)',
            'rgba(167, 129, 109, 1.00)',
            'rgba(126, 107, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/photinia [rosaceae]/photinia davidiana 'palette'/photinia davidiana 'palette' (2).jpg",
          width: 576,
          id: '036d33efaf7249594fdc96deaa6186d0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 120, 67, 1.00)',
            'rgba(118, 133, 68, 1.00)',
            'rgba(106, 116, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/photinia [rosaceae]/photinia davidiana 'palette'/photinia davidiana 'palette' (1).jpg",
          width: 576,
          id: 'b32b13588ad6ff6b90c1e8c3d53fba65',
          height: 768,
          thumbnail: true,
        },
        location: [47.27147, -1.586347],
        genre: 'Photinia',
        cultivar: 'Palette',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586347, 47.27147] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9e3c8f14377bb47fd91eb22c016d8e48bf5d631e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'davidiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 159, 52, 1.00)',
            'rgba(113, 137, 40, 1.00)',
            'rgba(124, 146, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/photinia [rosaceae]/photinia davidiana/photinia davidiana  (2).jpg',
          width: 576,
          id: '61c6abb6a387095fab449c9d0dda5f8d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 116, 48, 1.00)',
            'rgba(127, 138, 81, 1.00)',
            'rgba(94, 111, 47, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/photinia [rosaceae]/photinia davidiana/photinia davidiana  (3).jpg',
          width: 576,
          id: 'ae92548b880bb2b0ec0f48a4cc8681eb',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 133, 37, 1.00)',
            'rgba(112, 155, 39, 1.00)',
            'rgba(109, 136, 36, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/photinia [rosaceae]/photinia davidiana/photinia davidiana  (1).jpg',
          width: 576,
          id: '4a72e368e7fefef804fba977351c731d',
          height: 768,
          thumbnail: true,
        },
        location: [47.270355, -1.582367],
        genre: 'Photinia',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582367, 47.270355] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '09378aa5efab8cdf2003df856dc308ec5d7aa606',
      fields: {
        espece: 'opulifolius',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 130, 83, 1.00)',
            'rgba(104, 128, 74, 1.00)',
            'rgba(105, 114, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/physocarpus [rosaceae]/physocarpus opulifolius/physocarpus opulifolius.jpg',
          width: 1024,
          id: '56e14002c4359ae31bdc909f60d9a0fc',
          height: 768,
          thumbnail: true,
        },
        location: [47.27192, -1.58275],
        genre: 'Physocarpus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58275, 47.27192] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '56eb9d9d9dcd3393228ffc99333c4382fb5587a1',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 161, 185, 1.00)',
            'rgba(121, 109, 105, 1.00)',
            'rgba(71, 67, 43, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'accolade'/prunus 'accolade'.jpg",
          width: 1024,
          id: '7e08b587590e2d41ecec546e38c87d4c',
          height: 683,
          thumbnail: true,
        },
        location: [47.270794, -1.585947],
        genre: 'Prunus',
        cultivar: 'Accolade',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585947, 47.270794] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '105c9c3c4d93e50a04856d7834819d0c38059e87',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 127, 131, 1.00)',
            'rgba(143, 129, 130, 1.00)',
            'rgba(145, 131, 103, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'pandora'/prunus 'pandora' (2).jpg",
          width: 576,
          id: '25380707ae85c5fb40781abcfe25b6c9',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(187, 190, 207, 1.00)',
            'rgba(116, 107, 97, 1.00)',
            'rgba(72, 64, 34, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'pandora'/prunus 'pandora' (4).jpg",
          width: 1024,
          id: '17522bde462130b3e9c56223bda04f24',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 106, 107, 1.00)',
            'rgba(144, 128, 126, 1.00)',
            'rgba(100, 88, 85, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'pandora'/prunus 'pandora' (1).jpg",
          width: 1024,
          id: '51a98ac9602336ac4cb9f68510ac8ac0',
          height: 683,
          thumbnail: true,
        },
        location: [47.271672, -1.586487],
        genre: 'Prunus',
        cultivar: 'Pandora',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586487, 47.271672] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '222674099644325884bd37e8b03b64191fceb239',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 136, 197, 1.00)',
            'rgba(123, 103, 96, 1.00)',
            'rgba(78, 66, 38, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'shirofugen'/prunus 'shirofugen'.jpg",
          width: 1024,
          id: '3fbf286aef72db2edda6a42a42ddd2c8',
          height: 683,
          thumbnail: true,
        },
        location: [47.270981, -1.584625],
        genre: 'Prunus',
        cultivar: 'Shirofugen',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584625, 47.270981] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f0168b6af17b69be7248415fada30c9262397de9',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 192, 208, 1.00)',
            'rgba(144, 149, 148, 1.00)',
            'rgba(111, 94, 48, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'spire'/prunus 'spire' (2).jpg",
          width: 576,
          id: '41588b9c356821731046e4bfe5cb3c6a',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 90, 77, 1.00)',
            'rgba(138, 132, 127, 1.00)',
            'rgba(87, 80, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'spire'/prunus 'spire' (1).jpg",
          width: 576,
          id: 'cf133dd311726be796ffa5133bcbf6fe',
          height: 768,
          thumbnail: true,
        },
        location: [47.271637, -1.582655],
        genre: 'Prunus',
        cultivar: 'Spire',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582655, 47.271637] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a22a634daaaa84873207dffa5fa0d30f9dfb301e',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(198, 132, 118, 1.00)',
            'rgba(188, 97, 83, 1.00)',
            'rgba(90, 71, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'tai-haku'/prunus 'tai-haku' (3).jpg",
          width: 662,
          id: '2cc2afb6fb5c0482dede8c45b1c1c2b5',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 59, 48, 1.00)',
            'rgba(146, 144, 137, 1.00)',
            'rgba(109, 106, 97, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'tai-haku'/prunus 'tai-haku' (2).jpg",
          width: 576,
          id: '6448bb40c5a8cfb7339f8aa4527dbbbb',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Prunus',
        cultivar: 'Tai-haku',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '224c8953075fc117e2e5f8060d54d4392e5cdbd6',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 126, 111, 1.00)',
            'rgba(126, 118, 96, 1.00)',
            'rgba(100, 93, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'the bride'/prunus 'the bride' (4).jpg",
          width: 1024,
          id: 'cce2bef0f80501eaf553f09cce7f9ee0',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(185, 185, 191, 1.00)',
            'rgba(139, 132, 116, 1.00)',
            'rgba(70, 59, 36, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'the bride'/prunus 'the bride' (3).jpg",
          width: 1024,
          id: '3dbc90d62e4acb4e61731247cfbf6676',
          height: 683,
          thumbnail: true,
        },
        location: [47.270958, -1.582917],
        genre: 'Prunus',
        cultivar: 'The Bride',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582917, 47.270958] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8a07c48732fe37712842731a337f320feaab989f',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 169, 222, 1.00)',
            'rgba(140, 142, 142, 1.00)',
            'rgba(119, 107, 77, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus incisa 'diva'/prunus incisa 'diva' (3).jpg",
          width: 1024,
          id: '9c4536242b16aa8eba407ae9a73df549',
          height: 768,
          thumbnail: true,
        },
        espece: 'incisa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 103, 88, 1.00)',
            'rgba(155, 140, 139, 1.00)',
            'rgba(132, 113, 105, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus incisa 'diva'/prunus incisa 'diva' (2).jpg",
          width: 576,
          id: '28af792aed64e51f12ce4b4294b0abf7',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 123, 105, 1.00)',
            'rgba(138, 122, 97, 1.00)',
            'rgba(153, 135, 110, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus incisa 'diva'/prunus incisa 'diva' (1).jpg",
          width: 576,
          id: '77e0a0bec669938bb85e1f20de811071',
          height: 768,
          thumbnail: true,
        },
        location: [47.271088, -1.5846],
        genre: 'Prunus',
        cultivar: 'Diva',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5846, 47.271088] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3ff5efa01313b0c70fd2f0f3c8f7425d1fcb4abd',
      fields: {
        espece: 'incisa',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 104, 40, 1.00)',
            'rgba(141, 122, 77, 1.00)',
            'rgba(94, 76, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus incisa 'february pink'/prunus incisa 'february pink'.jpg",
          width: 576,
          id: '70b69d260c664eb8cfef4c7baa19bccf',
          height: 768,
          thumbnail: true,
        },
        location: [47.27133, -1.582387],
        genre: 'Prunus',
        cultivar: 'February Pink',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582387, 47.27133] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '776784fd58f3b861e409ec912057a318908cdaa3',
      fields: {
        espece: 'laurocerasus',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 166, 154, 1.00)',
            'rgba(91, 111, 68, 1.00)',
            'rgba(61, 73, 34, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus laurocerasus 'camelliifolia'/prunus laurocerasus 'camelliifolia'.jpg",
          width: 1024,
          id: 'f4eb480a87fbd3533209d59319094846',
          height: 683,
          thumbnail: true,
        },
        location: [47.27143, -1.5874],
        genre: 'Prunus',
        cultivar: 'Camelliifolia',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5874, 47.27143] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4aa9afd8764e52f25b65a6db3bafe14a7485a3e3',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x dawyckensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 119, 116, 1.00)',
            'rgba(119, 118, 111, 1.00)',
            'rgba(130, 129, 120, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/prunus [rosaceae]/prunus x dawyckensis/prunus x dawyckensis (2).jpg',
          width: 1024,
          id: '49857b1eeaf904bcd4429f1b332fd115',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(75, 79, 60, 1.00)',
            'rgba(110, 108, 89, 1.00)',
            'rgba(122, 109, 93, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/prunus [rosaceae]/prunus x dawyckensis/prunus x dawyckensis (3).jpg',
          width: 1024,
          id: '437eb0b22d26d20e9d5720fcdc65ce23',
          height: 693,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 113, 83, 1.00)',
            'rgba(147, 139, 124, 1.00)',
            'rgba(137, 129, 117, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/prunus [rosaceae]/prunus x dawyckensis/prunus x dawyckensis (1).jpg',
          width: 576,
          id: 'ad02115f88e15657eb2f8d9f3ee772e6',
          height: 768,
          thumbnail: true,
        },
        location: [47.27065, -1.584328],
        genre: 'Prunus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584328, 47.27065] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1c5f2f3bd137c7b05ed4d67a90c21a6407111a38',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 113, 48, 1.00)',
            'rgba(125, 151, 93, 1.00)',
            'rgba(109, 134, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea japonica 'albiflora'/spiraea japonica 'albiflora' (3).jpg",
          width: 576,
          id: '24e420f6d8ff8db3dc29c59e4a9e67e6',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 120, 81, 1.00)',
            'rgba(143, 148, 111, 1.00)',
            'rgba(98, 107, 74, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea japonica 'albiflora'/spiraea japonica 'albiflora' (2).jpg",
          width: 576,
          id: 'd36f0ea0d1c37985763009cf2c3ce42f',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 135, 102, 1.00)',
            'rgba(113, 131, 84, 1.00)',
            'rgba(79, 95, 43, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea japonica 'albiflora'/spiraea japonica 'albiflora' (1).jpg",
          width: 576,
          id: 'df22730e11a8369df4daaa5de8f490fa',
          height: 768,
          thumbnail: true,
        },
        location: [47.270903, -1.582517],
        genre: 'Spiraea',
        cultivar: 'Albiflora',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582517, 47.270903] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e9bd472bd30656f5e0067b0bd229eaa7a32b83bd',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'mollifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 129, 76, 1.00)',
            'rgba(118, 138, 79, 1.00)',
            'rgba(117, 133, 69, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea mollifolia/spiraea mollifolia (2).jpg',
          width: 644,
          id: '7e1f72808b3ccb2f39445de288c3cff7',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 157, 115, 1.00)',
            'rgba(138, 153, 98, 1.00)',
            'rgba(111, 125, 70, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea mollifolia/spiraea mollifolia (3).jpg',
          width: 576,
          id: 'f765b27e7e56a145eeb2a82e93038f66',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 150, 104, 1.00)',
            'rgba(130, 154, 92, 1.00)',
            'rgba(117, 131, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea mollifolia/spiraea mollifolia (1).jpg',
          width: 576,
          id: '7fdbd7990efa7b36527d13690e02ce08',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '48249fa51efda1a7f5fea5980090a0dd1307a0fa',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'wilsonii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 104, 64, 1.00)',
            'rgba(110, 120, 83, 1.00)',
            'rgba(100, 108, 77, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea wilsonii/spiraea wilsonii  (2).jpg',
          width: 576,
          id: 'a2980647b0876bf7d2f90abd1fe34453',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 84, 25, 1.00)',
            'rgba(119, 151, 70, 1.00)',
            'rgba(107, 134, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea wilsonii/spiraea wilsonii (1).jpg',
          width: 576,
          id: '5dbcc7a627d6c4a3a45a916894581b68',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 161, 98, 1.00)',
            'rgba(112, 121, 73, 1.00)',
            'rgba(76, 93, 47, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea wilsonii/spiraea wilsonii  (1).jpg',
          width: 768,
          id: 'f9d630a60597542f9c5d9ba832ead4bd',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '17bdee4dab7d76a4b4df1786b35df62f53ef27ad',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x brumalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 181, 139, 1.00)',
            'rgba(101, 131, 65, 1.00)',
            'rgba(104, 123, 67, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea x brumalis/spiraea x brumalis (2).jpg',
          width: 609,
          id: 'bf37c62118ba57889d68e2923d88099d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(52, 68, 25, 1.00)',
            'rgba(112, 130, 81, 1.00)',
            'rgba(72, 99, 39, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea x brumalis/spiraea x brumalis (3).jpg',
          width: 576,
          id: '273c160aeb675a69be5517ccc166f5d0',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 134, 64, 1.00)',
            'rgba(116, 155, 69, 1.00)',
            'rgba(112, 149, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea x brumalis/spiraea x brumalis (1).jpg',
          width: 576,
          id: 'a5deee13b9c0e9b2566180e30608dd73',
          height: 768,
          thumbnail: true,
        },
        location: [47.270775, -1.582392],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582392, 47.270775] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f2cb1fcfa1f5c97832bcfdc8bd740f9afec07ea5',
      fields: {
        espece: 'tanakae',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 108, 116, 1.00)',
            'rgba(105, 101, 107, 1.00)',
            'rgba(96, 91, 96, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stephanandra [rosaceae]/stephanandra tanakae/stephanandra tanakae (5).jpg',
          width: 1024,
          id: '39e54015c287675ada0c90631c47e125',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 87, 98, 1.00)',
            'rgba(103, 96, 100, 1.00)',
            'rgba(87, 81, 87, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stephanandra [rosaceae]/stephanandra tanakae/stephanandra tanakae (10).jpg',
          width: 1024,
          id: 'e6810507dc7a550db8b9291cf470d25b',
          height: 683,
          thumbnail: true,
        },
        location: [47.270394, -1.582227],
        genre: 'Stephanandra',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582227, 47.270394] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c5be3b3f009b0e596f694989e496159be3334f09',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 151, 113, 1.00)',
            'rgba(110, 115, 81, 1.00)',
            'rgba(97, 99, 71, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/x rhaphiobotrya [rosaceae]/x rhaphiobotrya 'coppertone'/x rhaphiobotrya 'coppertone' (1).jpg",
          width: 732,
          id: '737bcf3838b69f17e495d77d53dff83b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 133, 107, 1.00)',
            'rgba(146, 115, 91, 1.00)',
            'rgba(107, 116, 93, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/x rhaphiobotrya [rosaceae]/x rhaphiobotrya 'coppertone'/x rhaphiobotrya 'coppertone' (2).jpg",
          width: 576,
          id: '6e6b429789d288d9ae7850b5bee7ee5e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 171, 150, 1.00)',
            'rgba(105, 130, 100, 1.00)',
            'rgba(101, 112, 91, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/x rhaphiobotrya [rosaceae]/x rhaphiobotrya 'coppertone'/x rhaphiobotrya 'coppertone'  (2).jpg",
          width: 1024,
          id: 'fa81b80b68e2f85eea942eed46bdcaeb',
          height: 768,
          thumbnail: true,
        },
        location: [47.271253, -1.58703],
        genre: 'x Rhaphiobotrya',
        cultivar: 'Coppertone',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58703, 47.271253] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bba5f54dac18554dc5770de502feeafb45639e9c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'occidentalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 101, 50, 1.00)',
            'rgba(139, 131, 67, 1.00)',
            'rgba(155, 134, 95, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cephalanthus [rubiaceae]/cephalanthus occidentalis/cephalanthus occidentalis (11).jpg',
          width: 576,
          id: '135530f6433b70b9d933c45cde6ba1d5',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 141, 67, 1.00)',
            'rgba(99, 137, 58, 1.00)',
            'rgba(84, 123, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cephalanthus [rubiaceae]/cephalanthus occidentalis/cephalanthus occidentalis (13).jpg',
          width: 1024,
          id: '620eb9379bf4a487dd7bddf64d631471',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 148, 81, 1.00)',
            'rgba(101, 148, 75, 1.00)',
            'rgba(75, 117, 33, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cephalanthus [rubiaceae]/cephalanthus occidentalis/cephalanthus occidentalis (10).jpg',
          width: 576,
          id: '73f29152219f2d7666268e33bbd86491',
          height: 768,
          thumbnail: true,
        },
        location: [47.27092, -1.58478],
        genre: 'Cephalanthus',
        famille: 'Rubiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58478, 47.27092] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'eaf9ff0c92576d43bb2b00b9c9eeed7c28105747',
      fields: {
        origine: 'P\u00e9pini\u00e8re Arven',
        espece: 'bauerlenii',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Correa',
        date_plantation: '2018',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '88af5108a4e1a6af30a540488e51c1e5de840a0b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'microphylla',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 130, 105, 1.00)',
            'rgba(143, 129, 109, 1.00)',
            'rgba(97, 86, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/azara [salicaceae]/azara microphylla/azara microphylla (4).jpg',
          width: 576,
          id: '68a4796f5d1ca73f9550f7da0757ee23',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 139, 117, 1.00)',
            'rgba(102, 121, 89, 1.00)',
            'rgba(106, 115, 89, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/azara [salicaceae]/azara microphylla/azara microphylla (5).jpg',
          width: 1024,
          id: 'ff0358ef24297e7f2fda650e3c06c5ed',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 202, 240, 1.00)',
            'rgba(121, 128, 100, 1.00)',
            'rgba(82, 77, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/azara [salicaceae]/azara microphylla/azara microphylla (3).jpg',
          width: 576,
          id: '0267a394e581f59c7d342bdb42a27359',
          height: 768,
          thumbnail: true,
        },
        location: [47.271505, -1.581925],
        genre: 'Azara',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581925, 47.271505] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '74f2ed708952be7bb2eacabd20963e5bfbced421',
      fields: {
        origine: 'Arb.des Barres Nogent sur Vernisson (France)',
        espece: 'rufinerve',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Acer',
        date_plantation: '1986',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8c49872597f8641bec406568755f7f8d2a01a8ef',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes',
        espece: 'amplum',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Acer',
        date_plantation: '2015',
        cultivar: 'catalpifolium',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '146b7293754a175c0c1c4db79bb1058e4c3e6b3f',
      fields: {
        origine: 'P\u00e9pini\u00e8re Guervel',
        espece: 'japonicum',
        localisation: 'B5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202019, -1.5440256],
        genre: 'Acer',
        date_plantation: '2014',
        cultivar: 'Aconitifolium',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440256, 47.2202019] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fd70dec581624e0137dcac67b025df188d5f7747',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Gd Blottereau',
        espece: 'campestre',
        localisation: 'B1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2204652, -1.544656],
        genre: 'Acer',
        date_plantation: '2017',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544656, 47.2204652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '949aaadf8e1938d2fb4521d56643c6b769473caa',
      fields: {
        espece: 'palmatum',
        localisation: 'B5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202019, -1.5440256],
        genre: 'Acer',
        date_plantation: '1973',
        cultivar: 'Dissectum',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440256, 47.2202019] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '64f335607f4ddcdbee98b54310585ba96926429a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'griseum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 143, 125, 1.00)',
            'rgba(123, 133, 88, 1.00)',
            'rgba(115, 108, 83, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer griseum/acer griseum (2).jpg',
          width: 576,
          id: 'c80a20c0bd0e7bf6250442372ed9ddf0',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 150, 102, 1.00)',
            'rgba(120, 139, 80, 1.00)',
            'rgba(130, 111, 96, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer griseum/acer griseum (3).jpg',
          width: 576,
          id: '0ffac48b2b4f8e84a928bfec05a9be30',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 118, 120, 1.00)',
            'rgba(157, 139, 138, 1.00)',
            'rgba(150, 132, 132, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer griseum/acer griseum (1).jpg',
          width: 649,
          id: 'e887dad742c5462b939799e3bcc12625',
          height: 768,
          thumbnail: true,
        },
        location: [47.271903, -1.582997],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582997, 47.271903] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '01c719e8d3b82b1e00b124d97aa0252c3f75d3b4',
      fields: {
        espece: 'platanoides',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(209, 221, 224, 1.00)',
            'rgba(141, 149, 89, 1.00)',
            'rgba(97, 98, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer platanoides 'drummondii'/acer platanoides 'drummondii' (3).jpg",
          width: 576,
          id: '04e21382b39c028cda490e58cd988a3f',
          height: 768,
          thumbnail: true,
        },
        location: [47.2713, -1.585597],
        genre: 'Acer',
        cultivar: 'Drummondii',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585597, 47.2713] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e7e4e4adac16153503b2756852f3bd3b02124fcc',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 108, 35, 1.00)',
            'rgba(136, 148, 60, 1.00)',
            'rgba(114, 126, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer pseudoplatanus 'leopoldii'/acer pseudoplatanus 'leopoldii' (4).jpg",
          width: 576,
          id: 'ae6820ebcb3e52eb77a0815abdca4b94',
          height: 768,
          thumbnail: true,
        },
        espece: 'pseudoplatanus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(169, 152, 88, 1.00)',
            'rgba(134, 118, 47, 1.00)',
            'rgba(110, 108, 46, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer pseudoplatanus 'leopoldii'/acer pseudoplatanus 'leopoldii' (3).jpg",
          width: 576,
          id: '5be7403361b3c6b5cc05b4c3f5f598e3',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 150, 55, 1.00)',
            'rgba(122, 139, 50, 1.00)',
            'rgba(108, 119, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer pseudoplatanus 'leopoldii'/acer pseudoplatanus 'leopoldii' (2).jpg",
          width: 576,
          id: '622e90e20493586b75781892fad4be7f',
          height: 768,
          thumbnail: true,
        },
        location: [47.2712, -1.587],
        genre: 'Acer',
        cultivar: 'Leopoldii',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587, 47.2712] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '719323ee3fab48a4fa4d3f945f407cd00b1bf3b8',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 114, 146, 1.00)',
            'rgba(118, 85, 88, 1.00)',
            'rgba(73, 38, 21, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer rubrum 'northwood'/acer rubrum 'northwood' (1).jpg",
          width: 512,
          id: '3c3cfa1829449582531698ae9d8abbd1',
          height: 768,
          thumbnail: true,
        },
        espece: 'rubrum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 101, 157, 1.00)',
            'rgba(105, 113, 132, 1.00)',
            'rgba(91, 83, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer rubrum 'northwood'/acer rubrum 'northwood'  (2).jpg",
          width: 512,
          id: '8c019905c4e9837494a25e0af0130c01',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 108, 156, 1.00)',
            'rgba(99, 105, 142, 1.00)',
            'rgba(109, 117, 144, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer rubrum 'northwood'/acer rubrum 'northwood'  (1).jpg",
          width: 512,
          id: '4b8a69964dca71f646c4aa6715d755b8',
          height: 768,
          thumbnail: true,
        },
        location: [47.271295, -1.582403],
        genre: 'Acer',
        cultivar: 'Northwood',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582403, 47.271295] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '284c03c3f716fd48da68060135dce14dcf1622aa',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'saccharum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 145, 180, 1.00)',
            'rgba(114, 125, 103, 1.00)',
            'rgba(60, 66, 32, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer saccharum/acer saccharum  (2).jpg',
          width: 576,
          id: '781ccef1884f002702b500fe439405cb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 113, 148, 1.00)',
            'rgba(125, 97, 93, 1.00)',
            'rgba(41, 33, 22, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer saccharum/acer saccharum  (3).jpg',
          width: 512,
          id: 'b687cf09b86022066ee7be4c582dce16',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 110, 141, 1.00)',
            'rgba(132, 79, 62, 1.00)',
            'rgba(119, 79, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer saccharum/acer saccharum  (1).jpg',
          width: 512,
          id: 'c568fb3201fbf303276f8c06611205ea',
          height: 768,
          thumbnail: true,
        },
        location: [47.271858, -1.58317],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58317, 47.271858] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2ef0e5c3ac24ba36c9a3ba6a5b6edf480829874a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'triflorum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 117, 78, 1.00)',
            'rgba(130, 140, 75, 1.00)',
            'rgba(121, 134, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer triflorum/acer triflorum (10).jpg',
          width: 576,
          id: '2d69980d0ef50ccaa981f1842a1c1935',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 165, 148, 1.00)',
            'rgba(77, 93, 50, 1.00)',
            'rgba(64, 71, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer triflorum/acer triflorum (11).jpg',
          width: 1024,
          id: 'c567814cd22380d1a37847f729220ba0',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 120, 79, 1.00)',
            'rgba(105, 94, 49, 1.00)',
            'rgba(61, 67, 35, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer triflorum/acer triflorum (1).jpg',
          width: 973,
          id: 'dd1d1a6ca5ad868d3ab22232bf0f3b14',
          height: 768,
          thumbnail: true,
        },
        location: [47.269395, -1.582183],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582183, 47.269395] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cce3d055e98aa6bf520de47ba08eb3c5ca51e4ca',
      fields: {
        espece: 'californica',
        localisation: 'A12',
        nom_du_site: 'Jardin des Plantes',
        location: [47.22098, -1.5430278],
        genre: 'Aesculus',
        date_plantation: '1973',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5430278, 47.22098] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4cd1964ef89b91938385e8c46821408d6b09303b',
      fields: {
        espece: 'parviflora',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Aesculus',
        date_plantation: '1973',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2746d0a810ad44a5059412c860d6ba4866ba9954',
      fields: {
        espece: 'mollis L.',
        localisation: 'D2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195252, -1.5420507],
        genre: 'Acanthus',
        date_plantation: '1973',
        famille: 'Acanthaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420507, 47.2195252] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '23d81414c66ada4ba25091351296c421c81b2d22',
      fields: {
        origine: 'JB.P\u00e9kin (Chine)',
        espece: 'deliciosa',
        localisation: 'A12',
        nom_du_site: 'Jardin des Plantes',
        location: [47.22098, -1.5430278],
        genre: 'Actinidia',
        date_plantation: '1996',
        famille: 'Actinidiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5430278, 47.22098] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '20d128652f498128cce23925ff22ccd9ea00f236',
      fields: {
        origine: 'JBU.Wroclaw (Pologne)',
        espece: 'kolomikta',
        localisation: 'A12',
        nom_du_site: 'Jardin des Plantes',
        location: [47.22098, -1.5430278],
        genre: 'Actinidia',
        date_plantation: '2002',
        cultivar: 'Dr Szymanowski',
        famille: 'Actinidiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5430278, 47.22098] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8d9c317a08222c7469c8b12ced3468cd091b4e63',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'racemosa var. callicarpa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 144, 137, 1.00)',
            'rgba(149, 155, 128, 1.00)',
            'rgba(104, 127, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sambucus [adoxaceae]/sambucus racemosa var. callicarpa/sambucus racemosa var. callicarpa (3).jpg',
          width: 576,
          id: 'f2d7525a6f86ad5cd1752931814abe20',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 135, 185, 1.00)',
            'rgba(110, 116, 157, 1.00)',
            'rgba(116, 150, 194, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sambucus [adoxaceae]/sambucus racemosa var. callicarpa/sambucus racemosa var. callicarpa (4).jpg',
          width: 576,
          id: 'b8b6e2038facbf9a8f3cd3c1ef51e802',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 130, 91, 1.00)',
            'rgba(135, 150, 50, 1.00)',
            'rgba(103, 123, 24, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sambucus [adoxaceae]/sambucus racemosa var. callicarpa/sambucus racemosa var. callicarpa (1).jpg',
          width: 576,
          id: '20a5820c949956f22b214a8007679ba2',
          height: 768,
          thumbnail: true,
        },
        location: [47.269828, -1.581597],
        genre: 'Sambucus',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581597, 47.269828] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd63a20313f685ad5ac39a652fc1bd67844497762',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 158, 101, 1.00)',
            'rgba(97, 118, 71, 1.00)',
            'rgba(63, 86, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum 'le bois marquis'/viburnum 'le bois marquis' (2).jpg",
          width: 1024,
          id: 'affd0ef9c38d2a5fa2e5e0ecc258cfba',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 105, 73, 1.00)',
            'rgba(92, 106, 66, 1.00)',
            'rgba(67, 80, 48, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum 'le bois marquis'/viburnum 'le bois marquis' (3).jpg",
          width: 1024,
          id: 'c726e90e94bcc50a3a78b4345cf5e72b',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 71, 43, 1.00)',
            'rgba(86, 98, 64, 1.00)',
            'rgba(59, 70, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum 'le bois marquis'/viburnum 'le bois marquis' (1).jpg",
          width: 1024,
          id: '72ecc5474d05ecdac5edff5cc3a6ca38',
          height: 683,
          thumbnail: true,
        },
        location: [47.270492, -1.586355],
        genre: 'Viburnum',
        cultivar: 'Le Bois Marquis',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586355, 47.270492] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '92f242dfeddc182ffeb7a1f513f6c1f2323ff109',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'betulifolium',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 126, 52, 1.00)',
            'rgba(137, 161, 99, 1.00)',
            'rgba(94, 110, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum betulifolium/viburnum betulifolium (2).jpg',
          width: 576,
          id: 'd27be09bd4ea93f957862d14594115ce',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 160, 89, 1.00)',
            'rgba(130, 146, 75, 1.00)',
            'rgba(97, 119, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum betulifolium/viburnum betulifolium (3).jpg',
          width: 576,
          id: 'f0cde151b82671e9b801ad110b8ae5ac',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 162, 85, 1.00)',
            'rgba(132, 145, 69, 1.00)',
            'rgba(106, 115, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum betulifolium/viburnum betulifolium (1).jpg',
          width: 576,
          id: '2c99d0a884a4a0c3003650427e994fe4',
          height: 768,
          thumbnail: true,
        },
        location: [47.270662, -1.582487],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582487, 47.270662] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '10a45f361ed14013ad8449c24ad2641e7498e8cb',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'cinnamomifolium',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(171, 169, 138, 1.00)',
            'rgba(117, 119, 61, 1.00)',
            'rgba(133, 131, 87, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum cinnamomifolium/viburnum cinnamomifolium (2).jpg',
          width: 1024,
          id: 'e580fd6cc2c1808d3105a4b3f161222e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 117, 89, 1.00)',
            'rgba(112, 141, 115, 1.00)',
            'rgba(120, 136, 124, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum cinnamomifolium/viburnum cinnamomifolium (3).jpg',
          width: 576,
          id: '055625a00974bfcfde24ce9f6863675e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 85, 39, 1.00)',
            'rgba(141, 135, 82, 1.00)',
            'rgba(93, 99, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum cinnamomifolium/viburnum cinnamomifolium (1).jpg',
          width: 576,
          id: '493c8ac1c98c16df5a0b68986c3da974',
          height: 768,
          thumbnail: true,
        },
        location: [47.271195, -1.586322],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586322, 47.271195] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5c158f5ad2147139c7dd143df502f99b990d24e8',
      fields: {
        espece: 'harryanum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 132, 106, 1.00)',
            'rgba(119, 151, 107, 1.00)',
            'rgba(118, 138, 105, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum harryanum/viburnum harryanum.jpg',
          width: 576,
          id: 'a644d06ddd77d6e003132eadf8b8d6fc',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 147, 128, 1.00)',
            'rgba(107, 129, 80, 1.00)',
            'rgba(70, 79, 51, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum harryanum/viburnum harryanum (2).jpg',
          width: 576,
          id: '4f39a8637274e67847944cb75b9e8654',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd38e631d08750ea49ca1d5c228166c010cf1da38',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'japonicum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 156, 91, 1.00)',
            'rgba(109, 127, 66, 1.00)',
            'rgba(89, 103, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum japonicum/viburnum japonicum (2).jpg',
          width: 1024,
          id: 'cfaf0e13aea4f996a1ea0d05986988e5',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 102, 45, 1.00)',
            'rgba(128, 132, 96, 1.00)',
            'rgba(65, 74, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum japonicum/viburnum japonicum (6).jpg',
          width: 576,
          id: '05ba05c392481f065b712348ca8507f8',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 148, 78, 1.00)',
            'rgba(114, 158, 77, 1.00)',
            'rgba(101, 122, 64, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum japonicum/viburnum japonicum (1).jpg',
          width: 576,
          id: '4e65e37e08d710c2538c3c9c6d1d31cf',
          height: 768,
          thumbnail: true,
        },
        location: [47.2708, -1.58113],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58113, 47.2708] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ae284e1bcfbd54b84f4cf303885db20860638e8e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'lentago',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 145, 77, 1.00)',
            'rgba(120, 130, 76, 1.00)',
            'rgba(107, 104, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum lentago/viburnum lentago  (2).jpg',
          width: 576,
          id: '2c1621834ced91059de1555084fde99c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 122, 75, 1.00)',
            'rgba(123, 142, 93, 1.00)',
            'rgba(83, 108, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum lentago/viburnum lentago  (3).jpg',
          width: 576,
          id: '5331fd9dc6301aa53995cfbfbf0d63eb',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 147, 74, 1.00)',
            'rgba(146, 134, 83, 1.00)',
            'rgba(77, 84, 37, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum lentago/viburnum lentago  (1).jpg',
          width: 576,
          id: '59b198caf64f7af22abdc1239b5d7e07',
          height: 768,
          thumbnail: true,
        },
        location: [47.271145, -1.582122],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582122, 47.271145] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e163e4c4fed751e19096766075c87f772cd310fe',
      fields: {
        espece: 'lentago',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 170, 126, 1.00)',
            'rgba(96, 121, 63, 1.00)',
            'rgba(61, 79, 40, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum lentago/viburnum lentago (3).jpg',
          width: 1024,
          id: 'cbf980c9dbbe17f081a4244c07221766',
          height: 768,
          thumbnail: true,
        },
        location: [47.271367, -1.586267],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586267, 47.271367] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'adb947a94d754483dfdda84c72dbffba067138e4',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 103, 19, 1.00)',
            'rgba(119, 140, 31, 1.00)',
            'rgba(114, 137, 22, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum opulus 'park harvest'/viburnum opulus 'park harvest' (3).jpg",
          width: 576,
          id: '5e0bb68bfe22469c881de7d79ad64528',
          height: 768,
          thumbnail: true,
        },
        espece: 'opulus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(175, 193, 116, 1.00)',
            'rgba(101, 126, 40, 1.00)',
            'rgba(77, 105, 27, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum opulus 'park harvest'/viburnum opulus 'park harvest' (2).jpg",
          width: 576,
          id: '2e1b8d16c1193efd13f4d575d76aef52',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 131, 35, 1.00)',
            'rgba(131, 148, 33, 1.00)',
            'rgba(130, 149, 22, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum opulus 'park harvest'/viburnum opulus 'park harvest' (1).jpg",
          width: 576,
          id: 'badb0e637310da0d42e73755927c8ac6',
          height: 768,
          thumbnail: true,
        },
        location: [47.271247, -1.585287],
        genre: 'Viburnum',
        cultivar: 'Park Harvest',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585287, 47.271247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '894d050a4fbbdf2aaf5be5b53ac15f991bab954c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'propinquum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 130, 58, 1.00)',
            'rgba(135, 143, 70, 1.00)',
            'rgba(116, 125, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum propinquum/viburnum propinquum  (4).jpg',
          width: 576,
          id: 'f0b38e8f832377c9a653ae7aa558dd15',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 98, 78, 1.00)',
            'rgba(112, 137, 116, 1.00)',
            'rgba(137, 134, 123, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum propinquum/viburnum propinquum (1).jpg',
          width: 576,
          id: 'd500ba84297aee6604ba30cd77a76e0e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 163, 92, 1.00)',
            'rgba(139, 150, 62, 1.00)',
            'rgba(104, 110, 39, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum propinquum/viburnum propinquum  (1).jpg',
          width: 576,
          id: '564115c677bc73228ddb6f099d1c773f',
          height: 768,
          thumbnail: true,
        },
        location: [47.270808, -1.5861],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5861, 47.270808] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0a4a60509a2c1389a51ed84da3b695661d552259',
      fields: {
        espece: 'taitoense',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 153, 111, 1.00)',
            'rgba(144, 150, 77, 1.00)',
            'rgba(143, 143, 78, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum taitoense/viburnum taitoense (3).jpg',
          width: 576,
          id: '65084ca1a8136cee3a0a4ab62feba3b6',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 125, 70, 1.00)',
            'rgba(150, 147, 97, 1.00)',
            'rgba(161, 147, 116, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum taitoense/viburnum taitoense (2).jpg',
          width: 576,
          id: 'bee2c58cf6dce6ede2f5e550d9aee90e',
          height: 768,
          thumbnail: true,
        },
        location: [47.271625, -1.581808],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581808, 47.271625] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '04f84ea6312079e015d96220dadc3b4d49a33f40',
      fields: {
        origine: 'JB Amiens - Direction Am\u00e9nagement & espaces publics',
        espece: 'poeticus L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Narcissus',
        date_plantation: '2010',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '76a1ebdda6e7aaafad612dc49147ddef208ce726',
      fields: {
        origine: 'JB.Prague (R\u00e9p.Tch\u00e8que)',
        espece: 'flavum L.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Allium',
        date_plantation: '2009',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '18554868efb6f8316a7ebfde8671ed7c4db18d51',
      fields: {
        origine: 'JBU. Graz (Autriche)',
        espece: 'bowdenii W.Watson',
        localisation: 'I2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185657, -1.5426599],
        genre: 'Nerine',
        date_plantation: '2011',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426599, 47.2185657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3194de5de9850df93317ba872128cd8d5b5b7fe0',
      fields: {
        espece: 'bulbocodium L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Narcissus',
        date_plantation: '1999',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '121bd7cd7f5b2ef3440b001460215f58e37b921d',
      fields: {
        origine:
          'Honorable Municipalidad de Cochabamba - origine nature\u00a0: Montepunco "B" Pocona Provincia, alt. 2900M',
        espece: 'microphyllus',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Schinus',
        date_plantation: '2003',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '40c68dbf8a362d171d4f14b68b1ae297e9ee11dc',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 99, 65, 1.00)',
            'rgba(99, 96, 60, 1.00)',
            'rgba(161, 154, 121, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cotinus [anacardiaceae]/cotinus coggygria 'young lady'/cotinus coggygria 'young lady'  (1).jpg",
          width: 1024,
          id: '757f9609f895a249fe83efe1baa5ff36',
          height: 689,
          thumbnail: true,
        },
        espece: 'coggygria',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 81, 50, 1.00)',
            'rgba(159, 137, 117, 1.00)',
            'rgba(194, 163, 148, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cotinus [anacardiaceae]/cotinus coggygria 'young lady'/cotinus coggygria 'young lady'   (2).jpg",
          width: 576,
          id: '07cdfc1914814180dd08180d646b0028',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 134, 104, 1.00)',
            'rgba(154, 133, 107, 1.00)',
            'rgba(128, 112, 90, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cotinus [anacardiaceae]/cotinus coggygria 'young lady'/cotinus coggygria 'young lady'   (1).jpg",
          width: 576,
          id: '0d7d30a1995a6eb97dcd403f9487143b',
          height: 768,
          thumbnail: true,
        },
        location: [47.271888, -1.583083],
        genre: 'Cotinus',
        cultivar: 'Young Lady',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583083, 47.271888] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '54a40519beb9f262aef2dd1894731e4e4fc817e8',
      fields: {
        origine: 'J.B. Lyon (France)',
        espece: 'sicula DC.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Kundmannia',
        date_plantation: '2011',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'deda0be93c13289fc50f9c3f28af2f4957674825',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'giganteum M.Bieb.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Eryngium',
        date_plantation: '2006',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a27ba6772ea2e08967c0dfa55eee29c878184837',
      fields: {
        origine: 'JB.Utrecht (Hollande)',
        espece: 'amethystinum L.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Eryngium',
        date_plantation: '2004',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ce64bd96dd9ab90f5a531ea2a3baa23d64513449',
      fields: {
        origine: 'JBU.Fribourg (Suisse)',
        espece: 'major L .',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Astrantia',
        date_plantation: '1992',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '33e43b7254be7b6f42221687eb0c563523aafbb7',
      fields: {
        espece: 'podagraria L.',
        localisation: 'G1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193375, -1.5415093],
        genre: 'Aegopodium',
        date_plantation: '1973',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5415093, 47.2193375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'be5b6c69bc70cc597a884e6ea54009ba3127decc',
      fields: {
        origine: 'J.B.,Arboretum de Gottingen,Allemagne',
        espece: 'sepium Bunge',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Periploca',
        date_plantation: '2014',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0ff0ddda66dcd0dc53ccc9c3eda4381f926f741f',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'forrestii',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Vincetoxicum',
        date_plantation: '2006',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5163a150565c57d85c234c6bb305678a1e10e61b',
      fields: {
        origine: 'JB.Lewis Ginter (USA)',
        espece: 'ludoviciana Small.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Amsonia',
        date_plantation: '2006',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6059336ef5ded97354be8a9ab218d630fe46a0e0',
      fields: {
        origine: 'Sichtungsgartens Hermannshof Weinheim (All.)',
        espece: 'orientalis Decne.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Amsonia',
        date_plantation: '2014',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e911a986a8dc19abbb50b7665dd118f200b499a6',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'alba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 147, 140, 1.00)',
            'rgba(130, 135, 126, 1.00)',
            'rgba(108, 111, 101, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/plumeria [apocynaceae]/plumeria alba/plumeria alba (2).jpg",
          width: 576,
          id: '2d3630cb22ab48943a0edf00fd315ccd',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 103, 51, 1.00)',
            'rgba(117, 126, 82, 1.00)',
            'rgba(66, 65, 48, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/plumeria [apocynaceae]/plumeria alba/plumeria alba.jpg",
          width: 576,
          id: 'a9e66de95ca533ff1b9c62456a6a2d4a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 95, 62, 1.00)',
            'rgba(123, 124, 95, 1.00)',
            'rgba(81, 84, 59, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/plumeria [apocynaceae]/plumeria alba/plumeria alba (1).jpg",
          width: 576,
          id: 'a07e0de490660c63788cb99a6486b4b8',
          height: 768,
          thumbnail: true,
        },
        location: [47.226963, -1.512125],
        genre: 'Plumeria',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512125, 47.226963] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3a901f5a4d980cf7f474ca3af8f6ae3ec92250d5',
      fields: {
        espece: 'latifolia',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 155, 97, 1.00)',
            'rgba(106, 141, 63, 1.00)',
            'rgba(95, 129, 39, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ilex [aquifoliaceae]/ilex latifolia/ilex latifolia (2).jpg',
          width: 576,
          id: 'ad3c0bb12a22d115e529b0f2e34f4e1b',
          height: 768,
          thumbnail: true,
        },
        location: [47.270495, -1.581025],
        genre: 'Ilex',
        famille: 'Aquifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581025, 47.270495] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3f7c35ad33281c2308e10e52d4372d16b8332877',
      fields: {
        espece: 'x attenuata',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 96, 80, 1.00)',
            'rgba(103, 118, 91, 1.00)',
            'rgba(101, 110, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ilex [aquifoliaceae]/ilex x attenuata 'oriole'/ilex x attenuata 'oriole'.jpg",
          width: 1024,
          id: '2a04967292063be3d813fc58eb355da4',
          height: 683,
          thumbnail: true,
        },
        location: [47.270997, -1.585754],
        genre: 'Ilex',
        cultivar: 'Oriole',
        famille: 'Aquifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585754, 47.270997] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6c6129fbbbb3d859435c864707859b597dbfe44c',
      fields: {
        origine: 'B.G.Utrecht,Utrecht,Pays Bas',
        espece: 'consanguineum Schott',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Arisaema',
        date_plantation: '2012',
        famille: 'Araceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '98b9ed3224531e89552e51d559279ba732000baa',
      fields: {
        origine: 'Utrecht University Botanic Gardens, Utrecht, Pays Bas',
        espece: 'ciliatum H.Li',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Arisaema',
        date_plantation: '2012',
        famille: 'Araceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '48b319497f44103956c36c658783385a320730d0',
      fields: {
        origine: 'Nucot paysage - Quimper (29)',
        espece: 'nobillis',
        localisation: 'B1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2204652, -1.544656],
        genre: 'Wollemia',
        date_plantation: '2010',
        famille: 'Araucariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544656, 47.2204652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '05ccf30cd0dab75e35290acf67d4706e2b5e07c9',
      fields: {
        origine: 'B.G. Kiel (All.)',
        espece: 'liliago L.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Anthericum',
        date_plantation: '2013',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'db1f6f265ccfdd42a1441937938f1915736fd42b',
      fields: {
        origine: 'Hothus Botanicus Basiliensis,Basel,Suisse',
        espece: 'candicans Decne',
        localisation: 'I2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185657, -1.5426599],
        genre: 'Galtonia',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426599, 47.2185657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8641484ffbe9323812534c07ca68802d0442e067',
      fields: {
        origine: 'J. alpin la Ramberta, Montreux (Suisse)',
        espece: 'peruviana L.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Scilla',
        date_plantation: '2011',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '66324fb969aa94b5a0567cf79b562502e9b09b35',
      fields: {
        origine: 'J.B. Alpin,"La Saussurea" Courmayeur,Italie',
        espece: 'odoratum Druce',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Polygonatum',
        date_plantation: '2011',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9b57c660a203ea1c40340fa5451a750acd6c5415',
      fields: {
        origine: 'J.B.Friedrich Jena,Jena,All.',
        espece: 'mischtschenkoana Grossh.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Scilla',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0ae30a0ad694e2523c47785b6ef6c36904e0f39c',
      fields: {
        origine: 'JB. Wurzburg (Allemagne)',
        espece: 'orientalis L.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Hyacinthus',
        date_plantation: '2010',
        cultivar: 'chionophilus Wendelbo',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '720b241e3889a1edbb9691abfd4619bd615e1119',
      fields: {
        origine: 'JB.Arboretum der Stadt Linz (Autriche)',
        espece: 'bicolor Baker.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Eucomis',
        date_plantation: '1986',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0e8a60a4a1c46fd02a31657f4235bc7e435f0d36',
      fields: {
        origine: 'JB.Dunedin (N-Z\u00e9lande)',
        espece: 'australis Endl.',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Cordyline',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6c9811dd1eb2e6eac8bedac461ad9024382d931a',
      fields: {
        origine: 'JB.Nanjingensis (Chine)',
        espece: 'japonicus Ker-Gawl.',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Ophiopogon',
        date_plantation: '1993',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9f65c4b5e4675a2f794ad8085a9cca2864bb2ed3',
      fields: {
        origine: 'JB.Taschkent (Ouzbekistan)',
        espece: 'bucharicum Rgl.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Muscari',
        date_plantation: '2006',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3f2ca908750b9b7c59bd254d0ce7e4d67d1b7590',
      fields: {
        origine: 'JB.Yalta (Ukraine)',
        espece: 'ponticum',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Ornithogalum',
        date_plantation: '1985',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5617fe803aa8660be880f56acc88ad1273ad2bbb',
      fields: {
        origine: 'JBU.de Mildred E Mathias Los Angeles',
        espece: 'beldingi T. S. Brandeg.',
        localisation: 'A2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2208871, -1.5444631],
        genre: 'Nolina',
        date_plantation: '1986',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444631, 47.2208871] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e2c162dd9e90656f640d2faf887c67c30cf1f8d1',
      fields: {
        origine: 'JBU.Z\u00fcrich (Suisse)',
        espece: 'comosa Hort. Ex Wehrh.',
        localisation: 'G2A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2197208, -1.5414609],
        genre: 'Eucomis',
        date_plantation: '2006',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5414609, 47.2197208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd6438a369686cbf5f7fa179580946342c2a5bf58',
      fields: {
        origine: 'Kovacs PAL,Dorog,Hongrie',
        espece: 'litardierei Breistr.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Scilla',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f4cc2ede5d8c0111b42f0af4d5d53a7f67b96c67',
      fields: {
        origine: 'Les Ponts de C\u00e9_p\u00e9pini\u00e8re Lepage',
        espece: 'plantaginea Asch.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Hosta',
        date_plantation: '2016',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0d077cccecf6f94e7b53f647356fd54a8978f8cd',
      fields: {
        origine: 'Portugal CF.',
        espece: 'sp.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Ornithogalum',
        date_plantation: '1988',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fcc0763fdd7ab223d33d69c19d42ad7f912770c4',
      fields: {
        origine: 'The Arboretum Seoul National University, Seoul, Rep.of Korea',
        espece: 'muscari L.H.Bailey',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Liriope',
        date_plantation: '2013',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3c85b0a3db8046b6379cda4eeefeabdf977d9a0b',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'americana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 156, 180, 1.00)',
            'rgba(127, 136, 130, 1.00)',
            'rgba(74, 78, 57, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/agave [asparagaceae]/agave americana/agave americana (2).jpg",
          width: 670,
          id: 'de1d38c622e74cae62a75e7406646735',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 198, 218, 1.00)',
            'rgba(98, 111, 84, 1.00)',
            'rgba(72, 74, 55, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/agave [asparagaceae]/agave americana/agave americana (3).jpg",
          width: 671,
          id: '80e6ae6838ff4b7ba35a965b7724fd1a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 129, 118, 1.00)',
            'rgba(116, 132, 93, 1.00)',
            'rgba(111, 132, 127, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/agave [asparagaceae]/agave americana/agave americana (1).jpg",
          width: 576,
          id: '6e9260a7e171d5914119a90d46a0555c',
          height: 768,
          thumbnail: true,
        },
        location: [47.226737, -1.512328],
        genre: 'Agave',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512328, 47.226737] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ed44d199be954a849cab859074f8da9bf1d37b2d',
      fields: {
        espece: 'hispanica Rothm.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Hyacinthoides',
        date_plantation: '1987',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ab17d592cd0b20603ae0e780a8c7a8b4fd1f9cf0',
      fields: {
        origine: 'B.G. Zurich (Suise)',
        espece: 'delfloratus L.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Carduus',
        date_plantation: '2014',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '634457192b3e35e171d96ec45a40e4db9b2191f3',
      fields: {
        origine: 'Botanische Garten Bonn (All.)',
        espece: 'macrophylla B.Nord.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Caucasalia',
        date_plantation: '2015',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7f075f3d8db61b2036a2521d7919dccb4a1e7f84',
      fields: {
        origine: 'Botanischer Garten,Universitat Rostock, Rostock, Allemagne',
        espece: 'exaltatus Schrad.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Echinops',
        date_plantation: '2012',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5f718accfd36acdc57615c16618f953f4cdddd03',
      fields: {
        origine: 'Ets.Lepage',
        espece: 'serotina Ait.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Solidago',
        date_plantation: '1986',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b8517393e09f9d127dae98b93e12098d900e9836',
      fields: {
        origine: 'Jardin botanique alpin Saussurea',
        espece: 'absinthium L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Artemisia',
        date_plantation: '2010',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a83afc0c720fae5b0945f85139da038d5910d1aa',
      fields: {
        origine: 'JB. Hermannshof, Wheinheim (Allemagne)',
        espece: 'purpurea Moench',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Echinacea',
        date_plantation: '2011',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5c8fbc5c2f5a61eafa58105b085fe9646bd94709',
      fields: {
        origine: 'JB.Bremen (Allemagne)',
        espece: 'xanthochlora Rothm.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Alchemilla',
        date_plantation: '2009',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6d16d38ad200144d8b5fa7523f9309439b709e3e',
      fields: {
        origine: 'JB.Dijon (France)',
        espece: 'montana L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Centaurea',
        date_plantation: '1999',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '095a217809cbb111557fd166a425c1749a405064',
      fields: {
        origine: 'JB.Peligni (Italie)',
        espece: 'coronopifolium Vill.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Leucanthemum',
        date_plantation: '2008',
        cultivar: 'tenuifolium Vogt&Greuter',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd0798c6470621338ff008752d6c9d44afa82bdb0',
      fields: {
        origine: 'JB.Yeomjii (Cor\u00e9e)',
        espece: 'autumnale L.',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Helenium',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2097ec4200c43469e74c231e13171038672b6dbe',
      fields: {
        origine: 'JBU.Graz (Autriche)',
        espece: 'ptarmica L.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Achillea',
        date_plantation: '2006',
        cultivar: 'pyrenaica  Heimerl',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e58268a0ef53b77c519ec063c6831550d3dcd6f0',
      fields: {
        origine: 'JBU.Marburg (Allemagne)',
        espece: 'glabellus Nutt.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Erigeron',
        date_plantation: '1994',
        cultivar: 'pubescens',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9a08354ded6c08a274882a4bee1c6d75ea807b79',
      fields: {
        origine: 'JBU.Z\u00fcrich (Suisse)',
        espece: 'acaule Scop.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Cirsium',
        date_plantation: '2003',
        cultivar: 'acaule',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b49c433878360e491151a7ad41d2f07786538dfd',
      fields: {
        origine: 'Sichtungs garten Weinheim (Allemagne)',
        espece: 'columnifera Wooton & Standl.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Ratibida',
        date_plantation: '2011',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '68cabf9171a4475dc60149a66b8f67d636ccbfc7',
      fields: {
        origine: 'Universit\u00e9e de Lublin (Pologne)',
        espece: 'ensifolia L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Inula',
        date_plantation: '2009',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2ce655c75497d16eda80120e2008a512da0657e0',
      fields: {
        origine: 'Zoo and BG.of the Plzen(R\u00e9p.Tch\u00e8que)',
        espece: 'pamirica Th.Wolf',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Potentilla',
        date_plantation: '2014',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3e37bc1f594213b356c903c79d37ff20f67f0640',
      fields: {
        espece: 'leptophylla',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 111, 68, 1.00)',
            'rgba(122, 125, 81, 1.00)',
            'rgba(118, 119, 83, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cassinia [asteraceae]/cassinia leptophylla/cassinia leptophylla.jpg',
          width: 576,
          id: '5326e506cc3bf33b7d477b778bfcd5e1',
          height: 768,
          thumbnail: true,
        },
        location: [47.271237, -1.581908],
        genre: 'Cassinia',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581908, 47.271237] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '22b1f315076efd4542385f24e8e64368f8ad8073',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 149, 52, 1.00)',
            'rgba(111, 141, 32, 1.00)',
            'rgba(120, 151, 35, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/berberis [berberidaceae]/berberis microphylla 'pygmea'/berberis microphylla 'pygmea' (4).jpg",
          width: 576,
          id: 'f5d7f041d68d91b87cb45962124fec28',
          height: 768,
          thumbnail: true,
        },
        espece: 'microphylla',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 159, 85, 1.00)',
            'rgba(121, 131, 37, 1.00)',
            'rgba(83, 86, 16, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/berberis [berberidaceae]/berberis microphylla 'pygmea'/berberis microphylla 'pygmea' (3).jpg",
          width: 576,
          id: '5cda2c892745b856377718a029556d53',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(63, 72, 56, 1.00)',
            'rgba(82, 68, 53, 1.00)',
            'rgba(74, 60, 37, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/berberis [berberidaceae]/berberis microphylla 'pygmea'/berberis microphylla 'pygmea' (2).jpg",
          width: 576,
          id: '60bad1071e0bd11ae2c03a596b4719bc',
          height: 768,
          thumbnail: true,
        },
        location: [47.271172, -1.584728],
        genre: 'Berberis',
        cultivar: 'Pygmea',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584728, 47.271172] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dc7a113f61cdb860b3bd7d5371c5ce361c896de0',
      fields: {
        espece: 'x ottawensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 89, 74, 1.00)',
            'rgba(120, 109, 117, 1.00)',
            'rgba(105, 99, 99, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/berberis [berberidaceae]/berberis x ottawensis 'auricoma'/berberis x ottawensis 'auricoma' (2).jpg",
          width: 576,
          id: 'a4c502a6a047b4a0128fbb3772387b44',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 120, 97, 1.00)',
            'rgba(118, 108, 77, 1.00)',
            'rgba(91, 86, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/berberis [berberidaceae]/berberis x ottawensis 'auricoma'/berberis x ottawensis 'auricoma' (1).jpg",
          width: 576,
          id: '073e866e1c437602c3b4c585615438bb',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Berberis',
        cultivar: 'Auricoma',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '08a2f8d0806fa9b194319f6f029be7678fe6730a',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'latifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(62, 81, 25, 1.00)',
            'rgba(93, 107, 52, 1.00)',
            'rgba(102, 123, 63, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/holboellia [berberidaceae]/holboellia latifolia/holboellia latifolia (2).jpg",
          width: 512,
          id: '9b55fa9008c85138c907d5af4010741b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(63, 75, 26, 1.00)',
            'rgba(110, 126, 40, 1.00)',
            'rgba(82, 92, 33, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/holboellia [berberidaceae]/holboellia latifolia/holboellia latifolia (3).jpg",
          width: 512,
          id: 'c0b1d63a5514c0917d44fb52e1181ea9',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 153, 113, 1.00)',
            'rgba(91, 103, 36, 1.00)',
            'rgba(91, 91, 48, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/holboellia [berberidaceae]/holboellia latifolia/holboellia latifolia (1).jpg",
          width: 1024,
          id: 'afa5c1f09f1eecea7aa94fd6feb949b1',
          height: 683,
          thumbnail: true,
        },
        location: [47.226667, -1.512737],
        genre: 'Holboellia',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512737, 47.226667] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7f4a72b2060a26e5ffc1a3110ccb1f65d7ab096e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'americana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(194, 193, 186, 1.00)',
            'rgba(111, 99, 75, 1.00)',
            'rgba(97, 88, 78, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylus [betulaceae]/corylus americana/corylus americana (3).jpg',
          width: 576,
          id: 'fda6fa1e6301694b460a77a50af65012',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 163, 146, 1.00)',
            'rgba(122, 110, 80, 1.00)',
            'rgba(105, 89, 67, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylus [betulaceae]/corylus americana/corylus americana .jpg',
          width: 576,
          id: '6e9e18c0f166ac25c96a861c8a475598',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 145, 120, 1.00)',
            'rgba(143, 120, 98, 1.00)',
            'rgba(145, 117, 93, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylus [betulaceae]/corylus americana/corylus americana (1).jpg',
          width: 576,
          id: '7e02bd502d43f3a6cf9d8dd24591778d',
          height: 768,
          thumbnail: true,
        },
        location: [47.271228, -1.58233],
        genre: 'Corylus',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58233, 47.271228] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4271bf7c1d80c05039a34a1cab6fe4849bc68a0d',
      fields: {
        espece: 'colurna',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(213, 219, 196, 1.00)',
            'rgba(96, 121, 63, 1.00)',
            'rgba(52, 68, 32, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylus [betulaceae]/corylus colurna/corylus colurna.jpg',
          width: 576,
          id: '685796a6ab7d122731be80b4340f82aa',
          height: 768,
          thumbnail: true,
        },
        location: [47.270995, -1.58035],
        genre: 'Corylus',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58035, 47.270995] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8889982a2f69a24e88c398abcfa0aefe092153e8',
      fields: {
        origine: 'Mr.Franklin Picard',
        espece: 'zhongdianensis Grey-Wilson',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Incarvillea',
        date_plantation: '2015',
        famille: 'Bignoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '49d6a0d159124b7249961f3be91b2af58814a16f',
      fields: {
        origine: 'B.G Munchen All.',
        espece: 'alpina L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Arabis',
        date_plantation: '2014',
        cultivar: 'ssp. Caucasica Briq.',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '61274c58611cde86880cfb3ead902001055e3b89',
      fields: {
        origine: 'JB. T\u00fcbingen (Allemagne)',
        espece: 'rhaeticum DC.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Erysimum',
        date_plantation: '2011',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7c1d57f3b6b65cc9e0b23f1fc84b64fc50b4dcbb',
      fields: {
        espece: 'balearica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 132, 93, 1.00)',
            'rgba(138, 131, 84, 1.00)',
            'rgba(99, 115, 99, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/buxus [buxaceae]/buxus balearica/buxus balearica (2).jpg',
          width: 576,
          id: '321ea3494a4930778229ed894077d639',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 140, 113, 1.00)',
            'rgba(129, 135, 91, 1.00)',
            'rgba(95, 104, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/buxus [buxaceae]/buxus balearica/buxus balearica (1).jpg',
          width: 576,
          id: 'c01439f222c0632d3965b402b88ca8e5',
          height: 768,
          thumbnail: true,
        },
        location: [47.271508, -1.581325],
        genre: 'Buxus',
        famille: 'Buxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581325, 47.271508] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '91cef59cc84a252d684d43e2963812411e0d6403',
      fields: {
        espece: 'terminalis Sieb. & Zucc.',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Pachysandra',
        date_plantation: '1973',
        famille: 'Buxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '45bd66e5e391e7bfa2d790e5038ca2ec11a96040',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'praecox',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 87, 31, 1.00)',
            'rgba(118, 101, 30, 1.00)',
            'rgba(114, 94, 20, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chimonanthus [calycanthaceae]/chimonanthus praecox/chimonanthus praecox (2).jpg',
          width: 1024,
          id: '39105ec373f7d0e9eac161b97c64fabf',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 144, 134, 1.00)',
            'rgba(96, 81, 38, 1.00)',
            'rgba(75, 63, 26, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chimonanthus [calycanthaceae]/chimonanthus praecox/chimonanthus praecox (6).jpg',
          width: 601,
          id: '7df6101357d57b653dd86a264abd6718',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 74, 47, 1.00)',
            'rgba(109, 93, 35, 1.00)',
            'rgba(102, 92, 28, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chimonanthus [calycanthaceae]/chimonanthus praecox/chimonanthus praecox (10).jpg',
          width: 1024,
          id: '22ea9e86051bd0d37e3d1d275e0f2470',
          height: 683,
          thumbnail: true,
        },
        location: [47.270403, -1.584636],
        genre: 'Chimonanthus',
        famille: 'Calycanthaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584636, 47.270403] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '08bbc64f0318286f5d353064b8ba2a7382d2f46c',
      fields: {
        origine: 'JB.et coll\u00e8ge de la ville de Northamton (USA)',
        espece: 'cardinalis L.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Lobelia',
        date_plantation: '2006',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '516deaec0c83ed42c7896b95057e62efbbe9255a',
      fields: {
        origine: 'JBU.G\u00f6ethe de Frankf\u00fcrt am Main (Allemagne)',
        espece: 'poscharskyana Degen',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Campanula',
        date_plantation: '2006',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2a89081e04fd4cfcfafb8ae45b0daa59df65530b',
      fields: {
        origine: 'Med.Herb.Garden of Seatle',
        espece: 'inflata L.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Lobelia',
        date_plantation: '2014',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3413eabd9e74e0f633e7b3823337581deff30ec6',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'georgica Sulak.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Scabiosa',
        date_plantation: '2006',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd702966322fc74e713f8c63806bdb44dc99fb8d8',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 151, 85, 1.00)',
            'rgba(139, 137, 66, 1.00)',
            'rgba(118, 118, 46, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia 'edward goucher'/abelia 'edward goucher' (5).jpg",
          width: 576,
          id: '992cbe3a9e651d67b2d956e46bc46072',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 159, 83, 1.00)',
            'rgba(114, 136, 56, 1.00)',
            'rgba(86, 107, 28, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia 'edward goucher'/abelia 'edward goucher' (6).jpg",
          width: 576,
          id: 'b7e445da198b1fea1c8e03ec0674bb9a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 145, 85, 1.00)',
            'rgba(134, 137, 85, 1.00)',
            'rgba(139, 138, 96, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia 'edward goucher'/abelia 'edward goucher' (4).jpg",
          width: 1024,
          id: '38a813ba97df226d4c09798dbe1e6596',
          height: 768,
          thumbnail: true,
        },
        location: [47.271487, -1.58193],
        genre: 'Abelia',
        cultivar: 'Edward Goucher',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58193, 47.271487] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2e3e5966e44ec2d549cd2178efe6368123cbaa93',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'chinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 138, 118, 1.00)',
            'rgba(102, 123, 102, 1.00)',
            'rgba(107, 109, 98, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia chinensis/abelia chinensis  (3).jpg',
          width: 1024,
          id: '255dd0d11b8c49bd6ce01ef1f5c53034',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 109, 84, 1.00)',
            'rgba(121, 131, 110, 1.00)',
            'rgba(55, 66, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia chinensis/abelia chinensis  (4).jpg',
          width: 576,
          id: '66bb8280ffeafab1768e5060b8d45a11',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 132, 79, 1.00)',
            'rgba(100, 128, 79, 1.00)',
            'rgba(103, 138, 108, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia chinensis/abelia chinensis  (2).jpg',
          width: 616,
          id: '631ff624aabc6e57e7fc6c3ef07cd45a',
          height: 768,
          thumbnail: true,
        },
        location: [47.271538, -1.580653],
        genre: 'Abelia',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580653, 47.271538] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'afd32b7cee78b62fc3a5166294d255720cf0d5c4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'floribunda',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 149, 103, 1.00)',
            'rgba(116, 138, 72, 1.00)',
            'rgba(124, 118, 91, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia floribunda/abelia floribunda (2).jpg',
          width: 576,
          id: '7177f40ab5f08eca03d32527afd290d7',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 122, 106, 1.00)',
            'rgba(85, 114, 80, 1.00)',
            'rgba(49, 74, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia floribunda/abelia floribunda.jpg',
          width: 576,
          id: '2d763005bca19eb75557ba11eeecce86',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 137, 113, 1.00)',
            'rgba(143, 119, 108, 1.00)',
            'rgba(106, 120, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia floribunda/abelia floribunda (1).jpg',
          width: 576,
          id: 'dc015a4725c19c9993e61222d7d4434f',
          height: 768,
          thumbnail: true,
        },
        location: [47.270358, -1.580817],
        genre: 'Abelia',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580817, 47.270358] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8fee9bd025e204eb28ddc3cea82b07e07bec520e',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 113, 54, 1.00)',
            'rgba(130, 158, 65, 1.00)',
            'rgba(122, 144, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia x grandiflora 'sherwoodii'/abelia x grandiflora 'sherwood' (3).jpg",
          width: 576,
          id: '32b6b91e7ed800f8e652cc1538db9b5d',
          height: 768,
          thumbnail: true,
        },
        espece: 'x grandiflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 122, 42, 1.00)',
            'rgba(103, 119, 52, 1.00)',
            'rgba(78, 91, 29, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia x grandiflora 'sherwoodii'/abelia x grandiflora 'sherwood' (2).jpg",
          width: 576,
          id: 'bf7542566150e4df83f39e5d55f95c69',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 108, 52, 1.00)',
            'rgba(121, 139, 66, 1.00)',
            'rgba(140, 141, 95, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia x grandiflora 'sherwoodii'/abelia x grandiflora 'sherwood' (1).jpg",
          width: 1024,
          id: 'e51a9431768654cb8df71fdec77786cf',
          height: 768,
          thumbnail: true,
        },
        location: [47.271145, -1.582292],
        genre: 'Abelia',
        cultivar: 'Sherwoodii',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582292, 47.271145] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a9e68fa46f22954ada02b465f3cc19257c0382b1',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'lonicera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 153, 96, 1.00)',
            'rgba(148, 127, 86, 1.00)',
            'rgba(143, 149, 89, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/diervilla [caprifoliaceae]/diervilla lonicera/diervilla lonicera (3).jpg',
          width: 576,
          id: '6d8e4f46e3901b124165c5e3b29a74d1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 87, 86, 1.00)',
            'rgba(137, 107, 57, 1.00)',
            'rgba(97, 65, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/diervilla [caprifoliaceae]/diervilla lonicera/diervilla lonicera .jpg',
          width: 576,
          id: '992352e3f237c40d98fc47863e674ed2',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(191, 132, 134, 1.00)',
            'rgba(184, 109, 117, 1.00)',
            'rgba(174, 106, 102, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/diervilla [caprifoliaceae]/diervilla lonicera/diervilla lonicera (2).jpg',
          width: 576,
          id: '9de6752ff3a3c289eb4100fe0aeac2d3',
          height: 768,
          thumbnail: true,
        },
        location: [47.270722, -1.582425],
        genre: 'Diervilla',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582425, 47.270722] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4529658a11f1a3a7c765da8d78c1e31a8112e8f2',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'chrysantha',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 155, 80, 1.00)',
            'rgba(108, 145, 57, 1.00)',
            'rgba(94, 119, 48, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera chrysantha/lonicera chrysantha (2).jpg',
          width: 576,
          id: '128acb54985b4074e66a8c3289c4fbcb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 110, 56, 1.00)',
            'rgba(114, 134, 71, 1.00)',
            'rgba(76, 107, 32, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera chrysantha/lonicera chrysantha (3).jpg',
          width: 576,
          id: '94d919f1c0b5127d4eba7c724757f8c8',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(193, 196, 180, 1.00)',
            'rgba(105, 120, 66, 1.00)',
            'rgba(92, 101, 51, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera chrysantha/lonicera chrysantha (1).jpg',
          width: 1024,
          id: '4f35322b751ecf8725397331ff42a155',
          height: 768,
          thumbnail: true,
        },
        location: [47.270722, -1.582075],
        genre: 'Lonicera',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582075, 47.270722] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4b9ef16933a0e71eae212b29fabba642dac394ab',
      fields: {
        espece: 'standishii',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(188, 188, 175, 1.00)',
            'rgba(115, 116, 77, 1.00)',
            'rgba(83, 83, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera standishii/lonicera standishii  (5).jpg',
          width: 832,
          id: 'e4011a14e529073ce2ea80fad364b944',
          height: 768,
          thumbnail: true,
        },
        location: [47.270062, -1.585725],
        genre: 'Lonicera',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585725, 47.270062] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '652ac0e4661e86bf04eaa6c5c04ce82bdffdcd54',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 181, 142, 1.00)',
            'rgba(63, 88, 21, 1.00)',
            'rgba(102, 106, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera tatarica 'zabelii'/lonicera tatarica 'zabelii' (3).jpg",
          width: 576,
          id: '0b6359f3f37e9f212ec7d04135fa6c23',
          height: 768,
          thumbnail: true,
        },
        espece: 'tatarica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 123, 51, 1.00)',
            'rgba(123, 163, 64, 1.00)',
            'rgba(114, 144, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera tatarica 'zabelii'/lonicera tatarica 'zabelii' (2).jpg",
          width: 576,
          id: 'd74b76655f713dee69c9f6b7b4e4cb57',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 138, 70, 1.00)',
            'rgba(126, 131, 88, 1.00)',
            'rgba(80, 98, 37, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera tatarica 'zabelii'/lonicera tatarica 'zabelii' (1).jpg",
          width: 576,
          id: '1b69251f57dbfd9afaae09a58b8b45e3',
          height: 768,
          thumbnail: true,
        },
        location: [47.27195, -1.582628],
        genre: 'Lonicera',
        cultivar: 'Zabelii',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582628, 47.27195] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ffae989a4be8bc5ca63aeb013a358810aa6d8c9d',
      fields: {
        origine: 'Botanischer Garten Karl-Franzens, Graz, Autriche',
        espece: 'graefferi Guss.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Silene',
        date_plantation: '2012',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f60209de95f322b8d6a0544522c649f66a9b87ab',
      fields: {
        origine: 'Botanischer Garten Universit\u00e4t,  Innsbruck, Autriche',
        espece: 'X s\u00fcndermannii Hort.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Saponaria',
        date_plantation: '2013',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '04a44ed7cf5e50122f43cbc66804743943726500',
      fields: {
        origine: 'Botanischer Garten,Stuttgart,Allemagne',
        espece: 'saxifraga L.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Silene',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6cc14f33977c4e0dd709a497c596328a791d011f',
      fields: {
        origine: 'Conservatoire et JB.de Gen\u00e8ve (Suisse)',
        espece: 'acaulis Jacq.',
        localisation: 'A2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2208871, -1.5444631],
        genre: 'Silene',
        date_plantation: '2003',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444631, 47.2208871] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'da0d37eeca103fbb9c9897e9c454ea1b50657af3',
      fields: {
        origine: 'J.Alp.U.Insbruck (Autriche)',
        espece: 'alpinus L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Dianthus',
        date_plantation: '1992',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fc4474a067081d3b49d8ef0df59b75f44c6e1f63',
      fields: {
        origine: 'J.Alp.Vienne (Autriche)',
        espece: 'alpestris Jacq.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Silene',
        date_plantation: '2006',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0b62bc2688bd04313606026843f31ee6bcd1b8a2',
      fields: {
        origine: 'J.B. Innsbruck (Autriche)',
        espece: 'chalcedonica E.H.L. Krause',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Silene',
        date_plantation: '2011',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3fc0ff6faae93e5d026b091c88a59eb4bf6f9fab',
      fields: {
        origine: 'J.B.de Bordeaux,France',
        espece: 'graniticus Jordan',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Dianthus',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0d2ca45961b04ea1c31ac14a65b0451085ce7dc1',
      fields: {
        origine: 'J.B.ST.Andrews,Ecosse',
        espece: 'regis-ferdinandi Degen & Urumoff.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Silene',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '30b2e57a68db378198219623bdf34b151476322e',
      fields: {
        origine: 'Jardin botanico Real Juan Carlos - Madrid',
        espece: 'bermejoi G.Lopez',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Gypsophila',
        date_plantation: '2010',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6de343c71f5f239285edd928f5fbb260409c1b97',
      fields: {
        origine: 'JB. Ljubljani (Slov\u00e9nie)',
        espece: 'viscaria L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Lychnis',
        date_plantation: '2011',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ca6450202bde5f9698b580d638fe9ccab7957c10',
      fields: {
        origine: 'JB.Budapest (Hongrie)',
        espece: "giganteus D'Urv.",
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Dianthus',
        date_plantation: '2008',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '41077c764cd357a73fa8d0c6b6c10503182b6e5d',
      fields: {
        origine: 'JB.Sofia (Bulgarie)',
        espece: 'cruentus Griseb.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Dianthus',
        date_plantation: '2009',
        cultivar: 'turcicus Velen.',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3416eee2c468d9df449a5927dc2b5772877cbf9f',
      fields: {
        origine: 'JBU.Hokkaido (Japon)',
        espece: 'superbus L.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Dianthus',
        date_plantation: '2003',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6fa559ba16a3e717d1c3405f3e2865ca3bf8d667',
      fields: {
        origine: 'JBU.Vitebsk (Bielorussie)',
        espece: 'carthusianorum L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Dianthus',
        date_plantation: '2006',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '38f7d8246bea3878425cd4f844403101fef17520',
      fields: {
        origine: 'P\u00e9pini\u00e8res Emmanuel LEPAGE',
        espece: 'cerastoides D.Don',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Gypsophila',
        date_plantation: '2015',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '52a805fbac487565f14431a1c8ebffa63f6fec29',
      fields: {
        origine: "Particulier - Jardin \u00e0 l'\u00eele de la R\u00e9union",
        espece: 'equisetifolia',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Casuarina',
        date_plantation: '2003',
        famille: 'Casuarinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0ccb85e0d0c9608a73e8ad00366c935bfeede9de',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 79, 71, 1.00)',
            'rgba(117, 78, 65, 1.00)',
            'rgba(118, 81, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus 'den haag'/euonymus 'den haag' (12).jpg",
          width: 1024,
          id: '208628ecf937579b938fbe06e941ac76',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 105, 85, 1.00)',
            'rgba(85, 78, 45, 1.00)',
            'rgba(63, 54, 30, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus 'den haag'/euonymus 'den haag' (13).jpg",
          width: 1024,
          id: '14ba6317e02cd5b49d4149734991f53b',
          height: 727,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(63, 69, 67, 1.00)',
            'rgba(114, 105, 85, 1.00)',
            'rgba(72, 67, 39, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus 'den haag'/euonymus 'den haag' (11).jpg",
          width: 802,
          id: '9e3064f2d76e6ddfb03e09f00b81a0c6',
          height: 768,
          thumbnail: true,
        },
        location: [47.270294, -1.586425],
        genre: 'Euonymus',
        cultivar: 'Den Haag',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586425, 47.270294] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ed75ce55df422e95ec0612b1ac7e7dbcdc194376',
      fields: {
        origine: 'J.B. Alpin du Lauteret (Grenoble)',
        espece: 'alpestre Rchb.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Helianthemum',
        date_plantation: '2014',
        famille: 'Cistaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd22612c5f53f39b717a07bf1dafc8cf5cbec50f1',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 94, 49, 1.00)',
            'rgba(115, 134, 89, 1.00)',
            'rgba(133, 130, 107, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/clethra [clethraceae]/clethra alnifolia 'hummingbird'/clethra alnifolia 'hummingbird'  (3).jpg",
          width: 1024,
          id: 'e91ea75d7ecb60d7c0aa8dc1ec00ab91',
          height: 768,
          thumbnail: true,
        },
        espece: 'alnifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 122, 72, 1.00)',
            'rgba(160, 132, 53, 1.00)',
            'rgba(122, 105, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/clethra [clethraceae]/clethra alnifolia 'hummingbird'/clethra alnifolia 'hummingbird'  (2).jpg",
          width: 689,
          id: '0620dfc78316fe0bedd76295a6067db3',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 112, 76, 1.00)',
            'rgba(150, 130, 46, 1.00)',
            'rgba(129, 102, 24, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/clethra [clethraceae]/clethra alnifolia 'hummingbird'/clethra alnifolia 'hummingbird'  (1).jpg",
          width: 576,
          id: 'e8d62c2346b3cd54817b8c0f878d865c',
          height: 768,
          thumbnail: true,
        },
        location: [47.271667, -1.582337],
        genre: 'Clethra',
        cultivar: 'Hummingbird',
        famille: 'Clethraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582337, 47.271667] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7e2c5f72bdef1b15f4f0581b9d4b29b3f36b54a4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'barbinervis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 147, 65, 1.00)',
            'rgba(124, 151, 67, 1.00)',
            'rgba(119, 132, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/clethra [clethraceae]/clethra barbinervis/clethra barbinervis  (2).jpg',
          width: 576,
          id: 'f1cec56a6ffefee8aa4fd7e7f4abf086',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 131, 81, 1.00)',
            'rgba(110, 118, 77, 1.00)',
            'rgba(147, 135, 122, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/clethra [clethraceae]/clethra barbinervis/clethra barbinervis (1).jpg',
          width: 1024,
          id: '6cc569ad87dc8dec786f09a678d0b5b2',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 157, 57, 1.00)',
            'rgba(133, 140, 51, 1.00)',
            'rgba(114, 142, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/clethra [clethraceae]/clethra barbinervis/clethra barbinervis  (1).jpg',
          width: 576,
          id: 'b74f446aa2193e362d7504dd1133b5f0',
          height: 768,
          thumbnail: true,
        },
        location: [47.272028, -1.582055],
        genre: 'Clethra',
        famille: 'Clethraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582055, 47.272028] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '10b19e52c7ac3ff2393fc01048366d207a948040',
      fields: {
        origine:
          'Acad\u00e9mie de m\u00e9decine de "Ogrod Roslin" Wroclaw (Pologne)',
        espece: 'ohiensis Raf.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Tradescantia',
        date_plantation: '2006',
        famille: 'Commelinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e8bd0847d562ea9b0d448eb1d7b36b292e6a4b49',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 123, 82, 1.00)',
            'rgba(117, 128, 91, 1.00)',
            'rgba(113, 139, 65, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus alba 'sibirica'/cornus alba 'sibirica' (3).jpg",
          width: 576,
          id: 'd2d7048bca2b9a9b7fe19f771c7db48a',
          height: 768,
          thumbnail: true,
        },
        espece: 'alba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 130, 112, 1.00)',
            'rgba(174, 115, 112, 1.00)',
            'rgba(138, 118, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus alba 'sibirica'/cornus alba 'sibirica' (2).jpg",
          width: 576,
          id: 'b75612b94c975771f09547bd07f6d452',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 105, 59, 1.00)',
            'rgba(114, 135, 79, 1.00)',
            'rgba(113, 130, 94, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus alba 'sibirica'/cornus alba 'sibirica' (1).jpg",
          width: 576,
          id: '9597d8b0c8dc1dfaa80b101eee41851f',
          height: 768,
          thumbnail: true,
        },
        location: [47.270745, -1.581267],
        genre: 'Cornus',
        cultivar: 'Sibirica',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581267, 47.270745] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8686040295908cc396c4b4caa45936619601fcf7',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 133, 69, 1.00)',
            'rgba(119, 160, 113, 1.00)',
            'rgba(97, 139, 93, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus amomum 'grandiflorum'/cornus amomum 'grandiflorum' (3).jpg",
          width: 576,
          id: 'c91d9321ca61e217d59caabb1e7547dc',
          height: 768,
          thumbnail: true,
        },
        espece: 'amomum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 132, 70, 1.00)',
            'rgba(108, 153, 74, 1.00)',
            'rgba(124, 161, 90, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus amomum 'grandiflorum'/cornus amomum 'grandiflorum' (2).jpg",
          width: 576,
          id: 'f6e7efa1cbcdf1f1a176d4220b26f0d8',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 135, 113, 1.00)',
            'rgba(91, 110, 86, 1.00)',
            'rgba(87, 118, 89, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus amomum 'grandiflorum'/cornus amomum 'grandiflorum' (1).jpg",
          width: 576,
          id: '37a815d3bacbd141d18ecbf0b7c5acc6',
          height: 768,
          thumbnail: true,
        },
        location: [47.27035, -1.584837],
        genre: 'Cornus',
        cultivar: 'Grandiflorum',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584837, 47.27035] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'afdf6346a4681dda3e8c1e8b2ff6069820379376',
      fields: {
        espece: 'controversa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 96, 59, 1.00)',
            'rgba(93, 109, 66, 1.00)',
            'rgba(34, 50, 17, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus controversa/cornus controversa  (5).jpg',
          width: 1024,
          id: '3f24506ad8a3b968530ac654317f27b0',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(176, 188, 159, 1.00)',
            'rgba(89, 106, 58, 1.00)',
            'rgba(42, 56, 25, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus controversa/cornus controversa  (4).jpg',
          width: 1024,
          id: '62337effd736ef0c7b5c3613590b96fc',
          height: 683,
          thumbnail: true,
        },
        location: [47.271042, -1.585413],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585413, 47.271042] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1e366a2b88b2b8f7fddd23b3071dc4109e9783b0',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'florida ssp. urbiniana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 91, 60, 1.00)',
            'rgba(96, 99, 71, 1.00)',
            'rgba(86, 86, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida ssp. urbiniana/cornus florida ssp. urbiniana (14).jpg',
          width: 1024,
          id: '7223fb4f9bf451e26ecc5dc3b54409bd',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 89, 63, 1.00)',
            'rgba(92, 98, 75, 1.00)',
            'rgba(76, 82, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida ssp. urbiniana/cornus florida ssp. urbiniana (15).jpg',
          width: 1024,
          id: '0d4f19e7ff0c062e89c4e3dc235fb9b5',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 78, 49, 1.00)',
            'rgba(85, 86, 65, 1.00)',
            'rgba(113, 114, 86, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida ssp. urbiniana/cornus florida ssp. urbiniana (13).jpg',
          width: 1024,
          id: '5dea339eac73bac014d3c5f8c570048a',
          height: 683,
          thumbnail: true,
        },
        location: [47.270517, -1.581347],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581347, 47.270517] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f796111ee37e3476635bfcd89e89c3d70a84b71a',
      fields: {
        espece: 'kousa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 125, 102, 1.00)',
            'rgba(146, 149, 128, 1.00)',
            'rgba(68, 70, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'ed mezitt'/cornus kousa 'ed mezitt' (3).jpg",
          width: 576,
          id: '08c263f3d40890a0d1416a04ee30fa6a',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 131, 61, 1.00)',
            'rgba(124, 150, 71, 1.00)',
            'rgba(102, 104, 42, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'ed mezitt'/cornus kousa 'ed mezitt' (2).jpg",
          width: 576,
          id: 'b5a27c9a9816b3780714cf758cc8efba',
          height: 768,
          thumbnail: true,
        },
        location: [47.270338, -1.581367],
        genre: 'Cornus',
        cultivar: 'Ed Mezitt',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581367, 47.270338] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c2a601d4248875133568fb0b255ae5432316577c',
      fields: {
        espece: 'kousa',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 140, 124, 1.00)',
            'rgba(121, 144, 127, 1.00)',
            'rgba(99, 120, 101, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'milky way'/cornus kousa 'milky way' (2).jpg",
          width: 576,
          id: 'eb0e76eaf32962fa3ac910d55aad2fff',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Cornus',
        cultivar: 'Milky Way',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9864f423140a628a0b5b61718e26cdf031803162',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 89, 56, 1.00)',
            'rgba(184, 120, 136, 1.00)',
            'rgba(79, 83, 42, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'miss satomi'/cornus kousa 'miss satomi'  (12).jpg",
          width: 576,
          id: 'b306dc9176d8bbeea7ba1e95450fc56f',
          height: 768,
          thumbnail: true,
        },
        espece: 'kousa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 121, 38, 1.00)',
            'rgba(127, 130, 54, 1.00)',
            'rgba(99, 117, 31, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'miss satomi'/cornus kousa 'miss satomi'  (11).jpg",
          width: 1024,
          id: '3d92c501c93c59792c77dc9ede4620ad',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 106, 98, 1.00)',
            'rgba(168, 96, 79, 1.00)',
            'rgba(135, 69, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'miss satomi'/cornus kousa 'miss satomi'  (1).jpg",
          width: 576,
          id: '3434fd9261ecadf766968f61bb7501d1',
          height: 768,
          thumbnail: true,
        },
        location: [47.270678, -1.582375],
        genre: 'Cornus',
        cultivar: 'Miss Satomi',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582375, 47.270678] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7811bae02e61c8bdd3a68be5e72b88195b9c4fd2',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'pumila',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 130, 124, 1.00)',
            'rgba(109, 134, 118, 1.00)',
            'rgba(79, 107, 79, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus pumila/cornus pumila (3).jpg',
          width: 576,
          id: '7aecbc59b054531846a406306f3fc0f7',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 144, 102, 1.00)',
            'rgba(143, 140, 70, 1.00)',
            'rgba(108, 140, 47, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus pumila/cornus pumila.jpg',
          width: 576,
          id: '0157ff3c02dc135474c3420b9683953b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 161, 90, 1.00)',
            'rgba(111, 152, 72, 1.00)',
            'rgba(93, 138, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus pumila/cornus pumila (2).jpg',
          width: 576,
          id: 'a61bb6547bcfe36da7570e6785cdfdc1',
          height: 768,
          thumbnail: true,
        },
        location: [47.270353, -1.580795],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580795, 47.270353] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '410c39594876abe84b338c551df6302f9f79ba1d',
      fields: {
        espece: 'californica',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 158, 130, 1.00)',
            'rgba(110, 123, 92, 1.00)',
            'rgba(69, 81, 53, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/aesculus [sapindaceae]/aesculus californica/aesculus californica.jpg',
          width: 1024,
          id: '710354fd8169b1e58d064c700b06bbd1',
          height: 768,
          thumbnail: true,
        },
        location: [47.262212, -1.529525],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529525, 47.262212] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '80cb85720d95357c9c522521357cbf3409d27c61',
      fields: {
        espece: 'bipinnata',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(168, 168, 140, 1.00)',
            'rgba(58, 74, 31, 1.00)',
            'rgba(36, 44, 21, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/koelreuteria [sapindaceae]/koelreuteria bipinnata/koelreuteria bipinnata (13).jpg',
          width: 590,
          id: 'e1fd98e15efebb96fb8ca351a789d182',
          height: 768,
          thumbnail: true,
        },
        location: [47.270762, -1.58552],
        genre: 'Koelreuteria',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58552, 47.270762] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7888123861ca90e889c4e8698dd6c76260355a78',
      fields: {
        origine: 'D\u00e9partement recreati, Antwerpen (Pays Bas)',
        espece: 'americana L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Heuchera',
        date_plantation: '2011',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd0f45a33fe4b5e3c1589aa603f21e014801520bf',
      fields: {
        origine: 'JB.Arboretum der Stadt Linz (Autriche)',
        espece: 'grandiflora R. Br.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Tellima',
        date_plantation: '1986',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '32c6a6ee1aa3b0b25ad82c13bba6f6439cda1920',
      fields: {
        origine: 'JB.Uppsala (Su\u00e8de)',
        espece: 'crassifolia Fritsch',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Bergenia',
        date_plantation: '2006',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '789a39793edb5c4c336818dfe9d29bd74b559d7b',
      fields: {
        origine: 'Les Ponts de C\u00e9_p\u00e9pini\u00e8re Lepage',
        espece: 'tabularis Engl.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Astilboides',
        date_plantation: '2016',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2930dd5472ce49c2767afb64cb5c8da168187190',
      fields: {
        espece: 'parviflorum',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 89, 80, 1.00)',
            'rgba(115, 121, 93, 1.00)',
            'rgba(96, 110, 64, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/illicium [schisandraceae]/illicium parviflorum/illicium parviflorum.jpg',
          width: 1024,
          id: '19b7e5ce3f9380368bf0c4b90035fea0',
          height: 683,
          thumbnail: true,
        },
        location: [47.270372, -1.584875],
        genre: 'Illicium',
        famille: 'Schisandraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584875, 47.270372] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '889431d59d22a31c423b107ff1f26fed678f5041',
      fields: {
        origine: 'Remi Legros ( Lepage p\u00e9pini\u00e8re)',
        espece: 'virgatum',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Gomphostigma',
        date_plantation: '2014',
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a21bf31e0672cdc042a0035d4e66f22194ffd63f',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 123, 69, 1.00)',
            'rgba(93, 126, 49, 1.00)',
            'rgba(115, 137, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/styrax [styracaceae]/styrax japonicus 'fargesii'/styrax japonicus 'fargesii' (3).jpg",
          width: 576,
          id: '5395221535daa890b440b53b6dd63527',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonicus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 97, 37, 1.00)',
            'rgba(130, 133, 100, 1.00)',
            'rgba(61, 70, 38, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/styrax [styracaceae]/styrax japonicus 'fargesii'/styrax japonicus 'fargesii' (2).jpg",
          width: 1024,
          id: '2a7f7ada2f134d4cf8e4553fad6f04b0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 96, 65, 1.00)',
            'rgba(93, 110, 67, 1.00)',
            'rgba(85, 93, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/styrax [styracaceae]/styrax japonicus 'fargesii'/styrax japonicus 'fargesii' (1).jpg",
          width: 1024,
          id: 'df1fb934dbe224a68e2793fde1d15c23',
          height: 683,
          thumbnail: true,
        },
        location: [47.270725, -1.586058],
        genre: 'Styrax',
        cultivar: 'Fargesii',
        famille: 'Styracaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586058, 47.270725] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a48a8bcf0a036db1a34577695c3f886c6d59a1e5',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 103, 85, 1.00)',
            'rgba(134, 123, 106, 1.00)',
            'rgba(114, 104, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'cornish snow'/camellia 'cornish snow'.jpg",
          width: 1024,
          id: '494f4ab82ebce6eb25691e223f8d4d10',
          height: 638,
          thumbnail: true,
        },
        location: [47.267762, -1.584047],
        genre: 'Camellia',
        cultivar: 'Cornish Snow',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584047, 47.267762] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bba386fd2781d4aec339417e37621ac37234a3c0',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 114, 89, 1.00)',
            'rgba(110, 128, 70, 1.00)',
            'rgba(112, 115, 67, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'scentuous'/camellia 'scentuous' (4).jpg",
          width: 1024,
          id: '4fbeb004645986cde0a6447b48a869ac',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(46, 51, 35, 1.00)',
            'rgba(122, 120, 109, 1.00)',
            'rgba(110, 105, 91, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'scentuous'/camellia 'scentuous' (5).jpg",
          width: 1024,
          id: '6971cd19688d87c275de87513e742773',
          height: 671,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 130, 99, 1.00)',
            'rgba(115, 121, 80, 1.00)',
            'rgba(128, 133, 84, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'scentuous'/camellia 'scentuous' (3).jpg",
          width: 1024,
          id: '335793d9d30d6ccf8ad2809707ff5e1f',
          height: 683,
          thumbnail: true,
        },
        location: [47.269672, -1.583675],
        genre: 'Camellia',
        cultivar: 'Scentuous',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583675, 47.269672] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a1793d5475f68045c95ec60fb89e8cbe46be2c2a',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 95, 87, 1.00)',
            'rgba(85, 90, 71, 1.00)',
            'rgba(44, 48, 24, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'shiro-wabisuke'/camellia 'shiro-wabisuke' (3).jpg",
          width: 1024,
          id: 'c5edf2af68194e18b9620b991f0b3ca3',
          height: 694,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(65, 74, 56, 1.00)',
            'rgba(81, 94, 54, 1.00)',
            'rgba(78, 76, 48, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'shiro-wabisuke'/camellia 'shiro-wabisuke' (2).jpg",
          width: 1024,
          id: 'e1b5ad9caf4d5f1051828a61a8922429',
          height: 718,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Shiro-wabisuke',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '69bc2cf0e2132e0db1ea78022c1f4a34790dfb80',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 141, 130, 1.00)',
            'rgba(96, 94, 80, 1.00)',
            'rgba(92, 87, 77, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'tongzimian' (baby face)/camellia 'tongzimian' (baby face) (1).jpg",
          width: 1024,
          id: 'c445edd2e1ad10f85ecc7283dccd8ef4',
          height: 683,
          thumbnail: true,
        },
        location: [47.270637, -1.585578],
        genre: 'Camellia',
        cultivar: 'Tongzimian (Baby Face)',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585578, 47.270637] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '05fe5a0769181f421772b696671c490a981822c4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 59, 85, 1.00)',
            'rgba(182, 40, 81, 1.00)',
            'rgba(168, 36, 78, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'virginia w. cutter'/camellia 'virginia w. cutter' (2).jpg",
          width: 1024,
          id: 'eedc906ac4530851eb4ad6e71d5f72dd',
          height: 754,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 72, 73, 1.00)',
            'rgba(145, 63, 92, 1.00)',
            'rgba(91, 63, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'virginia w. cutter'/camellia 'virginia w. cutter' (3).jpg",
          width: 1024,
          id: 'feea08e4c68a2526c6899a69fc0db8f7',
          height: 652,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 125, 98, 1.00)',
            'rgba(100, 96, 62, 1.00)',
            'rgba(60, 60, 39, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'virginia w. cutter'/camellia 'virginia w. cutter' (1).jpg",
          width: 512,
          id: 'dbe0e7914dc11aa5d42d85e72c24ffb6',
          height: 768,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Virginia W. Cutter',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2191ad320fe3d40e5f42eb6e9383a6c8eb978a1c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 88, 74, 1.00)',
            'rgba(138, 131, 131, 1.00)',
            'rgba(90, 88, 82, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'white retic'/camellia 'white retic' (2).jpg",
          width: 1024,
          id: '6f124a09f0c2420e164fc1af3c49da4a',
          height: 689,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 118, 80, 1.00)',
            'rgba(104, 114, 90, 1.00)',
            'rgba(100, 99, 82, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'white retic'/camellia 'white retic' (3).jpg",
          width: 1024,
          id: '7645b0728a119ec413d5b802763382ad',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 155, 146, 1.00)',
            'rgba(85, 94, 76, 1.00)',
            'rgba(69, 71, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'white retic'/camellia 'white retic' (1).jpg",
          width: 512,
          id: '2f208d69735e59bdd369bf80b86c5ca2',
          height: 768,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'White Retic',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b359740570b9ea7073646e48ae1abb18ebd01583',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'fraterna',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 96, 76, 1.00)',
            'rgba(158, 156, 144, 1.00)',
            'rgba(111, 113, 97, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia fraterna/camellia fraterna (2).jpg',
          width: 830,
          id: '7a7d8274628211d2a4e3999a51f781ea',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 118, 111, 1.00)',
            'rgba(114, 121, 113, 1.00)',
            'rgba(81, 89, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia fraterna/camellia fraterna (3).jpg',
          width: 512,
          id: 'cf9984920d3fd4bed25e1190a8deb60c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 91, 69, 1.00)',
            'rgba(106, 114, 95, 1.00)',
            'rgba(49, 58, 49, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia fraterna/camellia fraterna (1).jpg',
          width: 512,
          id: '9b91c20ad42f7b4164ee33b760fbaeee',
          height: 768,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2a2791596820b4ac0e765cce46d6fbef96964ecf',
      fields: {
        espece: 'hiemalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(169, 177, 176, 1.00)',
            'rgba(84, 82, 75, 1.00)',
            'rgba(65, 76, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia hiemalis 'kanjiro'/camellia hiemalis 'kanjiro' (6).jpg",
          width: 1024,
          id: 'f622733e855b248e6c8790eef4418c97',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 93, 95, 1.00)',
            'rgba(125, 82, 94, 1.00)',
            'rgba(98, 69, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia hiemalis 'kanjiro'/camellia hiemalis 'kanjiro' (5).jpg",
          width: 1024,
          id: 'aa410eae7db5eb340c431af489706317',
          height: 683,
          thumbnail: true,
        },
        location: [47.268142, -1.584445],
        genre: 'Camellia',
        cultivar: 'Kanjir\u00f4',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584445, 47.268142] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9949398e5fc75dbbbc6c20ad233612a58a09c4f9',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 81, 102, 1.00)',
            'rgba(170, 90, 117, 1.00)',
            'rgba(146, 101, 122, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'aki-no-yama'/camellia japonica 'aki-no-yama' (7).jpg",
          width: 1024,
          id: '6e246c362458ced04e6ff7d5f26c2635',
          height: 768,
          thumbnail: true,
        },
        location: [47.270497, -1.581312],
        genre: 'Camellia',
        cultivar: 'Aki-no-yama',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581312, 47.270497] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dfa3251b10a51e62418686d0c33799ba98e39acc',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 103, 54, 1.00)',
            'rgba(161, 143, 127, 1.00)',
            'rgba(84, 75, 46, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'baby pearl'/camellia japonica 'baby pearl'.jpg",
          width: 576,
          id: '49316a763fca9c2526649d5a5458c80c',
          height: 768,
          thumbnail: true,
        },
        location: [47.270022, -1.584108],
        genre: 'Camellia',
        cultivar: 'Baby Pearl',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584108, 47.270022] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cff4b1dfd58cfc9aecb8fad634362f7c1320961b',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 145, 121, 1.00)',
            'rgba(94, 109, 78, 1.00)',
            'rgba(97, 88, 77, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'belle judith'/camellia japonica 'belle judith' (3).jpg",
          width: 1024,
          id: '8688393c290a8bb80ffb82cc1725f93b',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 105, 98, 1.00)',
            'rgba(107, 120, 104, 1.00)',
            'rgba(98, 110, 97, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'belle judith'/camellia japonica 'belle judith' (2).jpg",
          width: 1024,
          id: '441b69b8dd28adf3406de16ae850babb',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 78, 58, 1.00)',
            'rgba(98, 92, 84, 1.00)',
            'rgba(81, 83, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'belle judith'/camellia japonica 'belle judith' (1).jpg",
          width: 1024,
          id: '953478cdeac5391a7a4e0c3eaac86231',
          height: 683,
          thumbnail: true,
        },
        location: [47.270428, -1.584117],
        genre: 'Camellia',
        cultivar: 'Belle Judith',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584117, 47.270428] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd385813d05e0b297d8a9ca8d1d5df35055709685',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 135, 125, 1.00)',
            'rgba(100, 106, 79, 1.00)',
            'rgba(106, 104, 83, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'breca'/camellia japonica 'breca' (3).jpg",
          width: 1024,
          id: 'a492f6561e411175c7bc5285a32aa7c7',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 121, 99, 1.00)',
            'rgba(100, 116, 82, 1.00)',
            'rgba(88, 101, 71, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'breca'/camellia japonica 'breca' (2).jpg",
          width: 1024,
          id: '2d7bd6f37a345a32b9a94770fe6a9f60',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 123, 105, 1.00)',
            'rgba(91, 93, 71, 1.00)',
            'rgba(101, 99, 81, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'breca'/camellia japonica 'breca' (1).jpg",
          width: 1024,
          id: 'df744ebdd06fe3240ae19cd42e87cd18',
          height: 683,
          thumbnail: true,
        },
        location: [47.270362, -1.585333],
        genre: 'Camellia',
        cultivar: 'Breca',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585333, 47.270362] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '42f3b151c5f78b1eafa9b2965494eee8a670099b',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 80, 76, 1.00)',
            'rgba(126, 76, 89, 1.00)',
            'rgba(74, 54, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'can can'/camellia japonica 'can can'.jpg",
          width: 1024,
          id: '11ab4726cd856c96e7059855181ad16a',
          height: 700,
          thumbnail: true,
        },
        location: [47.27055, -1.58127],
        genre: 'Camellia',
        cultivar: 'Can Can',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58127, 47.27055] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e19c3c04d9f0742bf08d5bce3393a0467357c635',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 84, 71, 1.00)',
            'rgba(111, 89, 98, 1.00)',
            'rgba(80, 88, 87, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'conte bouturlin'/camellia japonica 'conte bouturlin'.jpg",
          width: 1024,
          id: '023769123bf1982b6ab4f8ce4aafaf60',
          height: 706,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Camellia',
        cultivar: 'Conte Bouturlin',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9697883e7be2db81f2436d9e2984348f74d764e1',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(47, 60, 40, 1.00)',
            'rgba(107, 88, 89, 1.00)',
            'rgba(76, 62, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'duchesse decazes'/camellia japonica 'duchesse decazes' (2).jpg",
          width: 1024,
          id: '7a7c594fd3fefb45d566f31ed26822fc',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(49, 59, 59, 1.00)',
            'rgba(117, 100, 91, 1.00)',
            'rgba(72, 67, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'duchesse decazes'/camellia japonica 'duchesse decazes' (1).jpg",
          width: 1024,
          id: '62902dc7aaeb39d3b633462c16df9d64',
          height: 683,
          thumbnail: true,
        },
        location: [47.2704, -1.584088],
        genre: 'Camellia',
        cultivar: 'Duchesse Decazes',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584088, 47.2704] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fddccab90d8964d60c39820ffc142e38ecb4fa9f',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 97, 58, 1.00)',
            'rgba(122, 72, 75, 1.00)',
            'rgba(104, 77, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'edith linton'/camellia japonica 'edith linton'.jpg",
          width: 1024,
          id: 'c36fdc67e5c5138947d703d9aafbf247',
          height: 683,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Camellia',
        cultivar: 'Edith Linton',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4f8de0ee9e8dc1b2f8ad92dd7cde22ee9494687c',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 66, 62, 1.00)',
            'rgba(149, 57, 83, 1.00)',
            'rgba(90, 43, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'elegans'/camellia japonica 'elegans' (2).jpg",
          width: 1024,
          id: '2b230321a7dd2b1ec547929683633085',
          height: 641,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 90, 84, 1.00)',
            'rgba(108, 111, 103, 1.00)',
            'rgba(74, 78, 71, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'elegans'/camellia japonica 'elegans' (1).jpg",
          width: 1024,
          id: 'c7e3bc34f9a4067b6d58893a806df12c',
          height: 683,
          thumbnail: true,
        },
        location: [47.270097, -1.583942],
        genre: 'Camellia',
        cultivar: 'Elegans',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583942, 47.270097] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9c3c31e0787fd5fe68f7aab9a9a556783c1ed761',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 160, 141, 1.00)',
            'rgba(62, 78, 55, 1.00)',
            'rgba(97, 91, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'general washington'/camellia japonica 'general washington' (2).jpg",
          width: 512,
          id: '746d6f2dc71d31bf91a13492d6657507',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(43, 54, 39, 1.00)',
            'rgba(100, 111, 96, 1.00)',
            'rgba(49, 58, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'general washington'/camellia japonica 'general washington' (1).jpg",
          width: 910,
          id: '45a628a37b760d1a68571881d6107e20',
          height: 768,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Camellia',
        cultivar: 'General Washington',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f17fc77d404101ec68cc6b8a32e91103c872b4fb',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 82, 38, 1.00)',
            'rgba(116, 62, 42, 1.00)',
            'rgba(83, 39, 29, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'jules verne'/camellia japonica 'jules verne'.jpg",
          width: 1024,
          id: '9cb16127f8b2989a15790c80a11a4a2f',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 143, 121, 1.00)',
            'rgba(113, 122, 91, 1.00)',
            'rgba(96, 102, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'jules verne'/camellia japonica 'jules verne' (2).jpg",
          width: 1024,
          id: '7b2b6a171daad5cfd5fc611f24a63b15',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 85, 68, 1.00)',
            'rgba(123, 70, 61, 1.00)',
            'rgba(85, 65, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'jules verne'/camellia japonica 'jules verne' (1).jpg",
          width: 1024,
          id: '10704ac7fb3656bf99435df8486bb26c',
          height: 683,
          thumbnail: true,
        },
        location: [47.270683, -1.585425],
        genre: 'Camellia',
        cultivar: 'Jules Verne',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585425, 47.270683] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ca6ea91d629dff2bfc62c3687f4d38338608a789',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 81, 69, 1.00)',
            'rgba(100, 100, 100, 1.00)',
            'rgba(81, 82, 81, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'shokoshi'/camellia japonica 'shokoshi'  (2).jpg",
          width: 1024,
          id: 'c0837ea1ab5cc075c43ea0c413cd5d54',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 158, 150, 1.00)',
            'rgba(90, 103, 94, 1.00)',
            'rgba(100, 92, 91, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'shokoshi'/camellia japonica 'shokoshi'  (1).jpg",
          width: 1024,
          id: '9bc1478d378e8da1250cf97956c1d7db',
          height: 683,
          thumbnail: true,
        },
        location: [47.269542, -1.58548],
        genre: 'Camellia',
        cultivar: 'Sh\u00f4k\u00f4shi',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58548, 47.269542] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fe16ce9f00815707c4f467aa6018d536a6c10725',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(54, 75, 40, 1.00)',
            'rgba(107, 74, 68, 1.00)',
            'rgba(126, 73, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'sugar babe'/camellia japonica 'sugar babe'.jpg",
          width: 1024,
          id: '1c5ecd74b97de144d6c494206cbaab3d',
          height: 683,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Camellia',
        cultivar: 'Sugar Babe',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '69ec72fa9387bcc8c8d5e387486415dd39ac5263',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 97, 73, 1.00)',
            'rgba(105, 68, 55, 1.00)',
            'rgba(112, 67, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'the czar'/camellia japonica 'the czar' (2).jpg",
          width: 1024,
          id: '797f9ce515664bad5471728738991cbf',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 110, 79, 1.00)',
            'rgba(114, 110, 88, 1.00)',
            'rgba(110, 89, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'the czar'/camellia japonica 'the czar' (1).jpg",
          width: 1024,
          id: '0deaac86e8f9fcf28f1517359f704943',
          height: 683,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Camellia',
        cultivar: 'The Czar',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b7af9cdb0c637642e3b45d7abafd0185157a1500',
      fields: {
        espece: 'sasanqua',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(41, 54, 53, 1.00)',
            'rgba(96, 99, 82, 1.00)',
            'rgba(65, 66, 52, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'hinode-gumo'/camellia sasanqua 'hinode-gumo'.jpg",
          width: 1024,
          id: '8d9682c70dddae4253b79b2bfb7b87a5',
          height: 683,
          thumbnail: true,
        },
        location: [47.270517, -1.581347],
        genre: 'Camellia',
        cultivar: 'Hinode-gumo',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581347, 47.270517] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '31127ae4e141571ed8cfe113d567e93ef576b8b0',
      fields: {
        espece: 'sasanqua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 77, 56, 1.00)',
            'rgba(106, 103, 85, 1.00)',
            'rgba(84, 88, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'maiden's blush'/camellia sasanqua 'maiden's blush'.jpg",
          width: 1024,
          id: '9ff1907c1b511c9b92319473687f6224',
          height: 675,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 144, 105, 1.00)',
            'rgba(101, 133, 92, 1.00)',
            'rgba(75, 81, 63, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'maiden's blush'/camellia sasanqua 'maiden's blush' (2).jpg",
          width: 554,
          id: '38ced81ee81f0a8148b500c93e3b36e0',
          height: 768,
          thumbnail: true,
        },
        location: [47.270583, -1.585705],
        genre: 'Camellia',
        cultivar: "Maiden's Blush",
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585705, 47.270583] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5bf4ac8896b59f763db5ff410489ec1cb44395fe',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 158, 138, 1.00)',
            'rgba(99, 109, 72, 1.00)',
            'rgba(101, 95, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'setsugekka'/camellia sasanqua 'setsugekka'.jpg",
          width: 1024,
          id: 'c12873ebe9b9a1ceced2b005d4f13402',
          height: 683,
          thumbnail: true,
        },
        espece: 'sasanqua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 129, 114, 1.00)',
            'rgba(93, 116, 102, 1.00)',
            'rgba(96, 106, 94, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'setsugekka'/camellia sasanqua 'setsugekka' (2).jpg",
          width: 1024,
          id: '0d15d4975e2384e2ee9e7e3f599132a5',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 78, 54, 1.00)',
            'rgba(112, 115, 99, 1.00)',
            'rgba(51, 60, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'setsugekka'/camellia sasanqua 'setsugekka' (1).jpg",
          width: 1024,
          id: '27d04ce4f8306629b6a3f2cc4946e730',
          height: 683,
          thumbnail: true,
        },
        location: [47.270667, -1.584633],
        genre: 'Camellia',
        cultivar: 'Setsugekka',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584633, 47.270667] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'aac5f1d5fe175327a6bfd7d0759b80a65e4f7ba4',
      fields: {
        espece: 'x williamsii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 72, 61, 1.00)',
            'rgba(116, 92, 99, 1.00)',
            'rgba(109, 94, 96, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'mary larcom'/camellia x williamsii 'mary larcom' (2).jpg",
          width: 1024,
          id: '1ba0192fb827cc76a906a04fe75da99f',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 152, 143, 1.00)',
            'rgba(108, 105, 80, 1.00)',
            'rgba(81, 80, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'mary larcom'/camellia x williamsii 'mary larcom' (1).jpg",
          width: 512,
          id: '4c1579359856b50cc8a7263f8cafe667',
          height: 768,
          thumbnail: true,
        },
        location: [47.269537, -1.584453],
        genre: 'Camellia',
        cultivar: 'Mary Larcom',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584453, 47.269537] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '02a1c23edbbae9f282af3a6a626d1cf4687246be',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 126, 86, 1.00)',
            'rgba(126, 135, 108, 1.00)',
            'rgba(119, 132, 92, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/daphne [thymelaeaceae]/daphne odora 'aureomarginata'/daphne odora 'aureomarginata' (2).jpg",
          width: 576,
          id: '1a6d761fd7e3066041a0daca5efc8faa',
          height: 768,
          thumbnail: true,
        },
        espece: 'odora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 150, 133, 1.00)',
            'rgba(103, 124, 101, 1.00)',
            'rgba(100, 123, 109, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/daphne [thymelaeaceae]/daphne odora 'aureomarginata'/daphne odora 'aureomarginata'  (2).jpg",
          width: 576,
          id: '016c20ae5edc8c4a9c73c74eaafefe3c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 165, 169, 1.00)',
            'rgba(110, 118, 93, 1.00)',
            'rgba(105, 122, 84, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/daphne [thymelaeaceae]/daphne odora 'aureomarginata'/daphne odora 'aureomarginata'  (1).jpg",
          width: 576,
          id: '9609b21a9858f8ca76658d79ce7984f8',
          height: 768,
          thumbnail: true,
        },
        location: [47.27187, -1.582872],
        genre: 'Daphne',
        cultivar: 'Aureomarginata',
        famille: 'Thymelaeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582872, 47.27187] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '016674c6af8e8bc00424a5a9737bf8f1e76658b7',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'tangutica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 131, 108, 1.00)',
            'rgba(110, 114, 91, 1.00)',
            'rgba(64, 78, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/daphne [thymelaeaceae]/daphne tangutica/daphne tangutica (2).jpg',
          width: 576,
          id: '38ebf28ff369aeaec0a5953fd0954298',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 164, 132, 1.00)',
            'rgba(124, 140, 105, 1.00)',
            'rgba(122, 130, 87, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/daphne [thymelaeaceae]/daphne tangutica/daphne tangutica (3).jpg',
          width: 576,
          id: '6746d78002a3210ffd220e1ae7436072',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 137, 101, 1.00)',
            'rgba(113, 117, 87, 1.00)',
            'rgba(119, 121, 83, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/daphne [thymelaeaceae]/daphne tangutica/daphne tangutica (1).jpg',
          width: 576,
          id: 'c5129d3e379119016549ecad8fda1345',
          height: 768,
          thumbnail: true,
        },
        location: [47.271692, -1.58258],
        genre: 'Daphne',
        famille: 'Thymelaeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58258, 47.271692] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2c4db8c84e8b3ab46253cef8a0a0621f16dc6188',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 113, 71, 1.00)',
            'rgba(140, 141, 110, 1.00)',
            'rgba(138, 125, 111, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/daphne [thymelaeaceae]/daphne x burkwoodii 'somerset'/daphne x burkwoodii 'somerset' (3).jpg",
          width: 1024,
          id: 'b0bf649d60fde50729ae50872f444ee0',
          height: 768,
          thumbnail: true,
        },
        espece: 'x burkwoodii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 128, 90, 1.00)',
            'rgba(142, 129, 130, 1.00)',
            'rgba(118, 112, 100, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/daphne [thymelaeaceae]/daphne x burkwoodii 'somerset'/daphne x burkwoodii 'somerset' (2).jpg",
          width: 576,
          id: '1591f2d405fbeca87d0e9e13bb6d0665',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 149, 110, 1.00)',
            'rgba(125, 141, 86, 1.00)',
            'rgba(137, 137, 115, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/daphne [thymelaeaceae]/daphne x burkwoodii 'somerset'/daphne x burkwoodii 'somerset' (1).jpg",
          width: 576,
          id: '8cfddaf1fdabd5617b70406f1a5d99a1',
          height: 768,
          thumbnail: true,
        },
        location: [47.270445, -1.582437],
        genre: 'Daphne',
        cultivar: 'Somerset',
        famille: 'Thymelaeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582437, 47.270445] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '706cb80df28ee7db46d649e25712d4b66d60bfeb',
      fields: {
        espece: 'x hollandica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 144, 137, 1.00)',
            'rgba(131, 134, 123, 1.00)',
            'rgba(109, 116, 105, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ulmus [ulmaceae]/ulmus x hollandica 'jacqueline hillier'/ulmus x hollandica 'jacqueline hillier' (3).jpg",
          width: 576,
          id: 'dfb44ad0bfee8effeda1c8d44ea35286',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 94, 48, 1.00)',
            'rgba(120, 144, 71, 1.00)',
            'rgba(81, 96, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ulmus [ulmaceae]/ulmus x hollandica 'jacqueline hillier'/ulmus x hollandica 'jacqueline hillier' (2).jpg",
          width: 576,
          id: '644305050161d9e80f46d30df4fcf8f8',
          height: 768,
          thumbnail: true,
        },
        location: [47.270013, -1.582222],
        genre: 'Ulmus',
        cultivar: 'Jacqueline Hillier',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582222, 47.270013] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '35c80a47ae5676908f1a93c2cc530a343c773e8b',
      fields: {
        espece: 'sinica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 116, 102, 1.00)',
            'rgba(128, 125, 103, 1.00)',
            'rgba(91, 85, 58, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/zelkova [ulmaceae]/zelkova sinica/zelkova sinica (2).jpg',
          width: 1024,
          id: 'a72214ffb86f2237a9a00d4f76bed5ef',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 133, 147, 1.00)',
            'rgba(118, 119, 109, 1.00)',
            'rgba(62, 62, 42, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/zelkova [ulmaceae]/zelkova sinica/zelkova sinica (1).jpg',
          width: 1024,
          id: '637d3642a8cc317ed7f63646d03cd94c',
          height: 683,
          thumbnail: true,
        },
        location: [47.262378, -1.531275],
        genre: 'Zelkova',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531275, 47.262378] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3dc700fe8ea9321028ff07e8ae795aa50e703da0',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'obovatus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 103, 63, 1.00)',
            'rgba(113, 125, 89, 1.00)',
            'rgba(76, 84, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/melicytus [violaceae]/melicytus obovatus/melicytus  obovatus (2).jpg',
          width: 576,
          id: '49a27aae1fd3f5f4eddb054620857de9',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 94, 75, 1.00)',
            'rgba(112, 118, 95, 1.00)',
            'rgba(100, 101, 84, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/melicytus [violaceae]/melicytus obovatus/melicytus  obovatus (3).jpg',
          width: 1024,
          id: 'dbec0160432a9cfe13266a026324c4dc',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 103, 72, 1.00)',
            'rgba(105, 108, 84, 1.00)',
            'rgba(97, 95, 74, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/melicytus [violaceae]/melicytus obovatus/melicytus  obovatus (1).jpg',
          width: 1024,
          id: 'fbccd672285b1abdced45115e59249e8',
          height: 768,
          thumbnail: true,
        },
        location: [47.271363, -1.581945],
        genre: 'Melicytus',
        famille: 'Violaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581945, 47.271363] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4f29f88641e31b952305414493561d02b0cf8515',
      fields: {
        origine: 'JBU.Wroclaw (Pologne)',
        espece: 'aconitifolia',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Ampelopsis',
        date_plantation: '2002',
        famille: 'Vitaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ba95a27c7141fcccf6b64753d1840d591a3dd887',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'lanceolata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 161, 159, 1.00)',
            'rgba(124, 125, 121, 1.00)',
            'rgba(94, 110, 99, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tasmannia [winteraceae]/tasmannia lanceolata/tasmannia lanceolata (3).jpg',
          width: 576,
          id: 'cbb522761ce6efeecbf206630c619632',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 94, 67, 1.00)',
            'rgba(92, 126, 85, 1.00)',
            'rgba(102, 122, 88, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tasmannia [winteraceae]/tasmannia lanceolata/tasmannia lanceolata (4).jpg',
          width: 576,
          id: 'c55d5a8ca3ac4316e2bcfdadf096eb6a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 152, 134, 1.00)',
            'rgba(134, 129, 108, 1.00)',
            'rgba(123, 138, 114, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tasmannia [winteraceae]/tasmannia lanceolata/tasmannia lanceolata (1).jpg',
          width: 576,
          id: '0240dba56b5370f0dbdbe7bfa3f620ec',
          height: 768,
          thumbnail: true,
        },
        location: [47.272038, -1.582097],
        genre: 'Tasmannia',
        famille: 'Winteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582097, 47.272038] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b7f5887c15ed4f6409859ed9c3c4e311ce475aa5',
      fields: {
        origine: 'J.B."Clelia Durazzo Grimaldi" G\u00e8nes,Italie',
        espece: 'tasmanica Hook.F.',
        localisation: 'I2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185657, -1.5426599],
        genre: 'Dianella',
        date_plantation: '2013',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426599, 47.2185657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fa9d8f64677f89bb9615384805686c3dae877b6c',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 93, 74, 1.00)',
            'rgba(101, 118, 89, 1.00)',
            'rgba(97, 103, 81, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/abies/abies pinsapo 'pyramidalis'/abies pinsapo 'pyramidalis' (3).jpg",
          width: 1024,
          id: '91461133ff1345ba12fcf1e064ba41b1',
          height: 683,
          thumbnail: true,
        },
        espece: 'pinsapo',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 163, 210, 1.00)',
            'rgba(101, 110, 111, 1.00)',
            'rgba(60, 59, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/abies/abies pinsapo 'pyramidalis'/abies pinsapo 'pyramidalis' (2).jpg",
          width: 512,
          id: 'acf9b5b321ebcbe9f61aab8d6645c29d',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 86, 68, 1.00)',
            'rgba(94, 95, 75, 1.00)',
            'rgba(86, 96, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/abies/abies pinsapo 'pyramidalis'/abies pinsapo 'pyramidalis' (1).jpg",
          width: 1024,
          id: 'f742f4fe9eacc3869963bb7368bffed3',
          height: 683,
          thumbnail: true,
        },
        location: [47.270922, -1.58605],
        genre: 'Abies',
        cultivar: 'Pyramidalis',
        famille: 'Pinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58605, 47.270922] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ea08c9d2920bebf7fad4e7eed2bb1c9ac1c75771',
      fields: {
        espece: 'platanoides',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(199, 209, 209, 1.00)',
            'rgba(83, 83, 63, 1.00)',
            'rgba(103, 106, 60, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/acer/acer platanoides 'reitenbachii'/acer platanoides 'reitenbachii' (2).jpg",
          width: 1024,
          id: '48d2bce502b6c4d4ac518759288a9266',
          height: 768,
          thumbnail: true,
        },
        location: [47.220562, -1.543705],
        genre: 'Acer',
        cultivar: 'Reitenbachii',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543705, 47.220562] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2c6fe9e247da4a1b7f1a33458149b28c97073fbb',
      fields: {
        espece: 'carpinifolium',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 132, 47, 1.00)',
            'rgba(136, 166, 55, 1.00)',
            'rgba(108, 131, 37, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer carpinifolium 'esveld select'/acer carpinifolium 'esveld select' (2).jpg",
          width: 576,
          id: 'e5c185c811e8e8f3aa06cb635afb5a6b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(69, 90, 37, 1.00)',
            'rgba(99, 123, 57, 1.00)',
            'rgba(163, 180, 107, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer carpinifolium 'esveld select'/acer carpinifolium 'esveld select' (1).jpg",
          width: 576,
          id: 'bf18efb0505b2ddba1dbb4d786d98138',
          height: 768,
          thumbnail: true,
        },
        location: [47.225208, -1.581358],
        genre: 'Acer',
        cultivar: 'Esveld Select',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581358, 47.225208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9d07d734876798b1ea22a6f0145796416fc4814a',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'buergerianum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 117, 105, 1.00)',
            'rgba(108, 106, 93, 1.00)',
            'rgba(128, 111, 103, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/acer/acer buergerianum/acer buergerianum (2).jpg',
          width: 512,
          id: 'f61bb062956cd829a39b963993fbb200',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 127, 107, 1.00)',
            'rgba(134, 121, 103, 1.00)',
            'rgba(104, 94, 86, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/acer/acer buergerianum/acer buergerianum (3).jpg',
          width: 512,
          id: 'd049d46300344778d33a4419f05fc9cd',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 147, 121, 1.00)',
            'rgba(126, 114, 79, 1.00)',
            'rgba(114, 98, 61, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/acer/acer buergerianum/acer buergerianum (1).jpg',
          width: 512,
          id: 'be942bc6ccf049c3b3b187520dd28070',
          height: 768,
          thumbnail: true,
        },
        location: [47.229683, -1.507105],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507105, 47.229683] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c1ff2c5a69916a5d0587103d791780a63bef0b2a',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'opalus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(65, 76, 48, 1.00)',
            'rgba(127, 130, 64, 1.00)',
            'rgba(89, 86, 53, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/acer/acer opalus/acer opalus  (2).jpg',
          width: 512,
          id: '00c3b7fe312db5494cb6bc547a35b803',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 86, 124, 1.00)',
            'rgba(88, 102, 125, 1.00)',
            'rgba(96, 119, 153, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/acer/acer opalus/acer opalus  (3).jpg',
          width: 512,
          id: 'bae9fd0991b6460d3638a7b0aa889519',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 94, 64, 1.00)',
            'rgba(121, 122, 63, 1.00)',
            'rgba(103, 99, 65, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/acer/acer opalus/acer opalus  (1).jpg',
          width: 512,
          id: '5b61a84c024bf99a8b21c553d417f699',
          height: 768,
          thumbnail: true,
        },
        location: [47.22677, -1.509913],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.509913, 47.22677] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '06cb4edf10bd57a59b7d14fd429d99980e85521d',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'parviflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 106, 97, 1.00)',
            'rgba(129, 109, 108, 1.00)',
            'rgba(122, 119, 118, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/aesculus/aesculus parviflora/aesculus parviflora (3).jpg',
          width: 1024,
          id: '03bd1e50fc883f3e73e07c917b9ffcd4',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(179, 185, 169, 1.00)',
            'rgba(80, 109, 74, 1.00)',
            'rgba(31, 57, 34, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/aesculus/aesculus parviflora/aesculus parviflora (4).jpg',
          width: 1024,
          id: '59cca1469df78f3393229620351bddd4',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 141, 40, 1.00)',
            'rgba(106, 146, 39, 1.00)',
            'rgba(103, 143, 31, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/aesculus/aesculus parviflora/aesculus parviflora (1).jpg',
          width: 576,
          id: '53e0b949b2bb314f5c7c545265ecccb8',
          height: 768,
          thumbnail: true,
        },
        location: [47.220525, -1.543337],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543337, 47.220525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fb2529c43dd77f12ff964f6d4f80867424084eac',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'x thuretiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 126, 78, 1.00)',
            'rgba(90, 105, 57, 1.00)',
            'rgba(90, 111, 80, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/arbutus/arbutus x thuretiana/arbutus x thuretiana (11).jpg',
          width: 1024,
          id: 'd8f954e36e9665d92312beddeebbe0dc',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(65, 84, 47, 1.00)',
            'rgba(91, 102, 64, 1.00)',
            'rgba(95, 107, 72, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/arbutus/arbutus x thuretiana/arbutus x thuretiana (12).jpg',
          width: 1024,
          id: '2dc5810bea79037a902e5107127f83ca',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 107, 63, 1.00)',
            'rgba(92, 119, 82, 1.00)',
            'rgba(109, 132, 104, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/arbutus/arbutus x thuretiana/arbutus x thuretiana (10).jpg',
          width: 1024,
          id: 'e684ba19cd784d5a403b10193b5a0108',
          height: 683,
          thumbnail: true,
        },
        location: [47.228478, -1.511297],
        genre: 'Arbutus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.511297, 47.228478] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '633df0e19b598475db8016dc25da09030320b299',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'battandieri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 147, 91, 1.00)',
            'rgba(123, 123, 37, 1.00)',
            'rgba(66, 85, 51, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/argyrocytisus/argyrocytisus battandieri/argyrocytisus battandieri (3).jpg',
          width: 576,
          id: '98ec767cc4b9f8235d06f64791d27d62',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 137, 83, 1.00)',
            'rgba(85, 110, 67, 1.00)',
            'rgba(106, 122, 91, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/argyrocytisus/argyrocytisus battandieri/argyrocytisus battandieri.jpg',
          width: 1024,
          id: '43dd39797c35ac2c8c6ef8a1fe85f1c6',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 162, 123, 1.00)',
            'rgba(100, 119, 76, 1.00)',
            'rgba(105, 113, 72, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/argyrocytisus/argyrocytisus battandieri/argyrocytisus battandieri (2).jpg',
          width: 576,
          id: '260bad8e24a38a8e693c7a6eda054418',
          height: 768,
          thumbnail: true,
        },
        location: [47.219955, -1.542603],
        genre: 'Argyrocytisus',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542603, 47.219955] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '11e90b3f3ce4e8c5cf534cdc9939615f1016a56f',
      fields: {
        espece: 'triloba',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 132, 74, 1.00)',
            'rgba(125, 138, 61, 1.00)',
            'rgba(86, 90, 52, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/asimina/asimina triloba/asimina triloba.jpg',
          width: 576,
          id: 'ca53de093935b6f8b3cbee63b58a1e24',
          height: 768,
          thumbnail: true,
        },
        location: [47.219764, -1.542714],
        genre: 'Asimina',
        famille: 'Annonaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542714, 47.219764] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '02491847c5b40f119a66f8a6b5ab257e3c43d7de',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'nigra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 114, 97, 1.00)',
            'rgba(147, 132, 115, 1.00)',
            'rgba(152, 142, 127, 1.00)',
          ],
          filename:
            'ip parc de proce/betula/betula nigra/betula nigra  (2).jpg',
          width: 576,
          id: 'b13de5a885c5a91883cfe09c355d12c7',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 103, 94, 1.00)',
            'rgba(108, 117, 97, 1.00)',
            'rgba(157, 149, 134, 1.00)',
          ],
          filename:
            'ip parc de proce/betula/betula nigra/betula nigra  (3).jpg',
          width: 576,
          id: '826ddaf10c0ad18623b640d216eb7a47',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 111, 100, 1.00)',
            'rgba(131, 129, 119, 1.00)',
            'rgba(141, 136, 133, 1.00)',
          ],
          filename:
            'ip parc de proce/betula/betula nigra/betula nigra  (1).jpg',
          width: 576,
          id: '36820cdcaa560e95eece95a2a1b50f5f',
          height: 768,
          thumbnail: true,
        },
        location: [47.222613, -1.578787],
        genre: 'Betula',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.578787, 47.222613] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd6896efecadba82e49cd29b409bd771f49a7ab3d',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'pendula',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(212, 214, 206, 1.00)',
            'rgba(102, 110, 79, 1.00)',
            'rgba(98, 107, 40, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/betula/betula pendula/betula pendula (2).jpg',
          width: 576,
          id: '9f7cbb0eb1899936e251d2bbb6c57dfb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 126, 97, 1.00)',
            'rgba(115, 124, 82, 1.00)',
            'rgba(115, 112, 74, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/betula/betula pendula/betula pendula (3).jpg',
          width: 576,
          id: 'e027c2f2c41583138da2ecaa1f337d43',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 134, 62, 1.00)',
            'rgba(112, 145, 57, 1.00)',
            'rgba(104, 123, 46, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/betula/betula pendula/betula pendula (1).jpg',
          width: 576,
          id: '09a0ccd1d87750d8bcbb3e3ce51289fb',
          height: 768,
          thumbnail: true,
        },
        location: [47.26187, -1.530317],
        genre: 'Betula',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530317, 47.26187] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '824ddd6a21e63d3e8042c54fe3ecf588c8e0683d',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 161, 100, 1.00)',
            'rgba(136, 143, 65, 1.00)',
            'rgba(110, 124, 37, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/buddleja/buddleja japonica/buddleja japonica (2).jpg',
          width: 576,
          id: 'c0fa7ac4b65ef4881e965c060b25523a',
          height: 768,
          thumbnail: true,
        },
        location: [47.220497, -1.542628],
        genre: 'Buddleja',
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542628, 47.220497] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f7bf019abbf662a7084853bafa2362abbba7d852',
      fields: {
        genre: 'Buddleja',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 101, 67, 1.00)',
            'rgba(109, 118, 99, 1.00)',
            'rgba(102, 105, 90, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/buddleja scrophulariaceae/buddleja alternifolia/buddleja alternifolia (2).jpg',
          width: 1024,
          id: 'bc57032450efff7750d8b776f2fdb448',
          height: 683,
          thumbnail: true,
        },
        location: [47.270842, -1.586142],
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586142, 47.270842] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '55f00724276c97eda24983214b3203cb26220c99',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 101, 162, 1.00)',
            'rgba(162, 103, 153, 1.00)',
            'rgba(132, 161, 107, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/buddleja scrophulariaceae/buddleja davidii 'royal red'/buddleja davidii 'royal red' (2).jpg",
          width: 576,
          id: '47a7d7fe54a80b9ca4b2b6c662fcfa99',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 144, 107, 1.00)',
            'rgba(138, 118, 122, 1.00)',
            'rgba(132, 138, 107, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/buddleja scrophulariaceae/buddleja davidii 'royal red'/buddleja davidii 'royal red' (1).jpg",
          width: 576,
          id: '8857f7c0a2dcd08a0d910d9be16cbac3',
          height: 768,
          thumbnail: true,
        },
        location: [47.271322, -1.582225],
        genre: 'Buddleja',
        cultivar: 'Royal Red',
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582225, 47.271322] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c4212b42e9552e1ebe5af269ec695ab82035b146',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 87, 62, 1.00)',
            'rgba(108, 118, 90, 1.00)',
            'rgba(86, 96, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/buddleja scrophulariaceae/buddleja davidii 'white profusion'/buddleja davidii 'white profusion'.jpg",
          width: 576,
          id: 'b9dc1ad6b256024d181e0c4bbdf38b57',
          height: 768,
          thumbnail: true,
        },
        location: [47.27133, -1.582287],
        genre: 'Buddleja',
        cultivar: 'White Profusion',
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582287, 47.27133] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3af8ccf82f8bf1adf3b6855375edc8dadaadef13',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 91, 81, 1.00)',
            'rgba(132, 137, 131, 1.00)',
            'rgba(81, 86, 78, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'collettii'/camellia japonica 'collettii' (2).jpg",
          width: 1024,
          id: 'e6aa87a8690a2c83636e52d4834dd4c6',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 94, 88, 1.00)',
            'rgba(118, 89, 96, 1.00)',
            'rgba(96, 94, 89, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'collettii'/camellia japonica 'collettii' (1).jpg",
          width: 1024,
          id: 'a13a4c0ce610f2b94efbc8d80d7e1847',
          height: 683,
          thumbnail: true,
        },
        location: [47.219983, -1.543953],
        genre: 'Camellia',
        cultivar: 'Collettii',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543953, 47.219983] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8c557ebefd35d51fe3f752080ce6682e26ee9528',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(69, 68, 55, 1.00)',
            'rgba(112, 121, 106, 1.00)',
            'rgba(90, 88, 82, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'daikagura'/camellia japonica 'daikagura' (3).jpg",
          width: 512,
          id: '57e70e9b26e8fe7df12e4548b418ca6d',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(32, 34, 27, 1.00)',
            'rgba(131, 83, 96, 1.00)',
            'rgba(106, 84, 82, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'daikagura'/camellia japonica 'daikagura' (2).jpg",
          width: 1024,
          id: '46b8be3bfa2cace12a650e08328e9663',
          height: 741,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 162, 144, 1.00)',
            'rgba(86, 94, 80, 1.00)',
            'rgba(81, 79, 70, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'daikagura'/camellia japonica 'daikagura' (1).jpg",
          width: 512,
          id: '38f341d1eb286513196bb6269233b093',
          height: 768,
          thumbnail: true,
        },
        location: [47.220247, -1.54168],
        genre: 'Camellia',
        cultivar: 'Daikagura',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54168, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '59a09091c68749ff4c7bb3d1797d65894c680bca',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(44, 44, 37, 1.00)',
            'rgba(123, 66, 103, 1.00)',
            'rgba(82, 53, 70, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'fragrant pink'/camellia japonica 'fragrant pink' (3).jpg",
          width: 1024,
          id: 'ce67f9f8389a94b211215e6792a2e7b5',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 82, 68, 1.00)',
            'rgba(111, 132, 111, 1.00)',
            'rgba(77, 98, 79, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'fragrant pink'/camellia japonica 'fragrant pink' (2).jpg",
          width: 1024,
          id: '335132fd22756926b4f4325cb147fa0c',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 78, 68, 1.00)',
            'rgba(91, 77, 79, 1.00)',
            'rgba(80, 77, 76, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'fragrant pink'/camellia japonica 'fragrant pink' (1).jpg",
          width: 1024,
          id: '4752f238390c136a46772f93b1c3561e',
          height: 683,
          thumbnail: true,
        },
        location: [47.220247, -1.541681],
        genre: 'Camellia',
        cultivar: 'Fragrant Pink',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541681, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fc50231478572447eb90b078398266a87ba191ed',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'yunnanensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(50, 50, 45, 1.00)',
            'rgba(136, 129, 117, 1.00)',
            'rgba(72, 69, 62, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia yunnanensis/camellia yunnanensis (2).jpg',
          width: 576,
          id: '777a7f6be39894e4cfeab408fe945c4b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 109, 92, 1.00)',
            'rgba(91, 99, 89, 1.00)',
            'rgba(103, 93, 90, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia yunnanensis/camellia yunnanensis (3).jpg',
          width: 1024,
          id: '03a5fc3eff60d7a05a4f2396cce47f31',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 137, 126, 1.00)',
            'rgba(124, 137, 135, 1.00)',
            'rgba(86, 91, 83, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia yunnanensis/camellia yunnanensis (1).jpg',
          width: 576,
          id: 'afc0206bd6fb81a3ed9542c4493b7855',
          height: 768,
          thumbnail: true,
        },
        location: [47.220247, -1.54168],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54168, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f5f1b23baa1f0eb9f4c454dae11c103bdd67755d',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 162, 121, 1.00)',
            'rgba(121, 142, 76, 1.00)',
            'rgba(95, 114, 34, 1.00)',
          ],
          filename:
            "ip parc de proce/camellia/camellia 'cornish snow'/camellia 'cornish snow' (3).jpg",
          width: 576,
          id: '949f41c8099e077232637f53e9ed572e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 106, 70, 1.00)',
            'rgba(102, 106, 75, 1.00)',
            'rgba(62, 72, 33, 1.00)',
          ],
          filename:
            "ip parc de proce/camellia/camellia 'cornish snow'/camellia 'cornish snow' (4).jpg",
          width: 576,
          id: '5f184f92638d0253be7de611b99d6e57',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 77, 49, 1.00)',
            'rgba(120, 121, 105, 1.00)',
            'rgba(61, 51, 40, 1.00)',
          ],
          filename:
            "ip parc de proce/camellia/camellia 'cornish snow'/camellia 'cornish snow' (2).jpg",
          width: 576,
          id: '046caf502a2c85a08267ce655cc3602e',
          height: 768,
          thumbnail: true,
        },
        location: [47.225597, -1.583355],
        genre: 'Camellia',
        cultivar: 'Cornish Snow',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583355, 47.225597] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '79ca3f20e840058d7c243661e88dad683a1f39ba',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 124, 92, 1.00)',
            'rgba(112, 139, 113, 1.00)',
            'rgba(88, 92, 69, 1.00)',
          ],
          filename:
            "ip parc de proce/camellia/camellia japonica 'ballet dancer'/camellia japonica 'ballet dancer' (3).jpg",
          width: 576,
          id: '4393df740dc12a8d947610060dd07906',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(64, 62, 48, 1.00)',
            'rgba(150, 116, 121, 1.00)',
            'rgba(56, 53, 39, 1.00)',
          ],
          filename:
            "ip parc de proce/camellia/camellia japonica 'ballet dancer'/camellia japonica 'ballet dancer' (2).jpg",
          width: 576,
          id: 'd967c192af1c89b7aa6b407f4d7e22af',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 155, 139, 1.00)',
            'rgba(106, 115, 83, 1.00)',
            'rgba(102, 114, 84, 1.00)',
          ],
          filename:
            "ip parc de proce/camellia/camellia japonica 'ballet dancer'/camellia japonica 'ballet dancer' (1).jpg",
          width: 576,
          id: '716f5be0b90e243bd9cd7d687b9e2e72',
          height: 768,
          thumbnail: true,
        },
        location: [47.222887, -1.57965],
        genre: 'Camellia',
        cultivar: 'Ballet Dancer',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.57965, 47.222887] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b53893aee96c694de23046445bcfb98c3d3d0353',
      fields: {
        espece: 'kawakamii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 137, 118, 1.00)',
            'rgba(132, 135, 97, 1.00)',
            'rgba(91, 92, 48, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/carpinus/carpinus kawakamii/carpinus kawakamii (2).jpg',
          width: 1024,
          id: '1c73b4811bb982e8622ac2ccbd49b9ef',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(171, 177, 193, 1.00)',
            'rgba(113, 112, 92, 1.00)',
            'rgba(60, 69, 24, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/carpinus/carpinus kawakamii/carpinus kawakamii (1).jpg',
          width: 512,
          id: '1b83c59887f8e5474ce4ae56bf0c6c08',
          height: 768,
          thumbnail: true,
        },
        location: [47.218608, -1.542625],
        genre: 'Carpinus',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542625, 47.218608] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '453573368ef953e6419af0cdb3fc5e7bc2ca98f8',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 138, 149, 1.00)',
            'rgba(114, 116, 113, 1.00)',
            'rgba(119, 132, 109, 1.00)',
          ],
          filename:
            "ip ville de nantes/cedrus/cedrus atlantica 'glauca'/cedrus atlantica 'glauca' (3).jpg",
          width: 1024,
          id: '83ae8fdb2227c7f69503fd5e6b9a992a',
          height: 768,
          thumbnail: true,
        },
        espece: 'atlantica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(181, 188, 188, 1.00)',
            'rgba(103, 106, 99, 1.00)',
            'rgba(54, 64, 38, 1.00)',
          ],
          filename:
            "ip ville de nantes/cedrus/cedrus atlantica 'glauca'/cedrus atlantica 'glauca' (2).jpg",
          width: 1024,
          id: 'fc6c064db26d0afa6e4d44e96db77d7c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(176, 182, 183, 1.00)',
            'rgba(103, 110, 102, 1.00)',
            'rgba(60, 73, 54, 1.00)',
          ],
          filename:
            "ip ville de nantes/cedrus/cedrus atlantica 'glauca'/cedrus atlantica 'glauca' (1).jpg",
          width: 1024,
          id: 'c3a69b9323470656d9a869aaf8154cc6',
          height: 768,
          thumbnail: true,
        },
        location: [47.241792, -1.567705],
        genre: 'Cedrus',
        cultivar: 'Glauca',
        famille: 'Pinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.567705, 47.241792] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6026ff3080a77dd382dd7f6cc1f156982b95180b',
      fields: {
        espece: 'occidentalis',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 130, 57, 1.00)',
            'rgba(88, 125, 45, 1.00)',
            'rgba(123, 125, 88, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/celtis/celtis occidentalis/celtis occidentalis.jpg',
          width: 576,
          id: '14ddcf2e1be0d1c0ed036c054f1787a1',
          height: 768,
          thumbnail: true,
        },
        location: [47.262513, -1.529037],
        genre: 'Celtis',
        famille: 'Cannabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529037, 47.262513] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '896d04e407bb0e9476b57355c682bb7dced1d806',
      fields: {
        espece: 'japonicum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 141, 120, 1.00)',
            'rgba(122, 128, 109, 1.00)',
            'rgba(88, 96, 70, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/cercidiphyllum/cercidiphyllum japonicum 'rotfuchs'/cercidiphyllum japonicum 'rotfuchs' (2).jpg",
          width: 1024,
          id: '93f6d570cfb6c90a259aac7ad8f7ac0b',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 144, 117, 1.00)',
            'rgba(100, 113, 81, 1.00)',
            'rgba(101, 110, 90, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/cercidiphyllum/cercidiphyllum japonicum 'rotfuchs'/cercidiphyllum japonicum 'rotfuchs' (1).jpg",
          width: 512,
          id: '8ee23fc0e5b4ea5c28fd8277e4104d3c',
          height: 768,
          thumbnail: true,
        },
        location: [47.228295, -1.508325],
        genre: 'Cercidiphyllum',
        cultivar: 'Rotfuchs',
        famille: 'Cercidiphyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508325, 47.228295] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6d90557bf9cf8e0508bfcb331bf0149dfc527187',
      fields: {
        espece: 'siliquastrum',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 168, 190, 1.00)',
            'rgba(124, 117, 114, 1.00)',
            'rgba(94, 94, 84, 1.00)',
          ],
          filename:
            'ip ville de nantes/cercis/cercis siliquastrum/cercis siliquastrum.jpg',
          width: 1024,
          id: '16f6f1ed8cff80740442921b3a0f8886',
          height: 768,
          thumbnail: true,
        },
        location: [47.247895, -1.57762],
        genre: 'Cercis',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.57762, 47.247895] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dd996b8f5d918def17ab52fa1f994aba8bb71c86',
      fields: {
        espece: 'praecox',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 137, 144, 1.00)',
            'rgba(131, 126, 101, 1.00)',
            'rgba(100, 93, 54, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/chimonanthus/chimonanthus praecox/chimonanthus praecox (2).jpg',
          width: 1024,
          id: '6c392f9d1ac2fc6b205d6dcb16931adf',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 127, 142, 1.00)',
            'rgba(82, 82, 66, 1.00)',
            'rgba(80, 81, 44, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/chimonanthus/chimonanthus praecox/chimonanthus praecox (1).jpg',
          width: 512,
          id: 'b95ea73b9826f9e1c7b87b333a9b84c9',
          height: 768,
          thumbnail: true,
        },
        location: [47.219688, -1.542687],
        genre: 'Chimonanthus',
        famille: 'Calycanthaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542687, 47.219688] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '57172b466a00c7737a20cfd2924635a41550183f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 78, 27, 1.00)',
            'rgba(134, 133, 53, 1.00)',
            'rgba(127, 142, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cleyera pentaphylacaceae/cleyera japonica 'fortunei'/cleyera japonica 'fortunei'  (2).jpg",
          width: 576,
          id: '6ee5e6553aa34fa3b664b717d6b9684c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 117, 101, 1.00)',
            'rgba(121, 123, 100, 1.00)',
            'rgba(89, 94, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cleyera pentaphylacaceae/cleyera japonica 'fortunei'/cleyera japonica 'fortunei'  (3).jpg",
          width: 512,
          id: 'f57383ad9cf2080766335216f14b4b4a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 84, 44, 1.00)',
            'rgba(140, 123, 75, 1.00)',
            'rgba(113, 136, 94, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cleyera pentaphylacaceae/cleyera japonica 'fortunei'/cleyera japonica 'fortunei'  (1).jpg",
          width: 576,
          id: '94cbb112ef5793faf27747ec8c97977f',
          height: 768,
          thumbnail: true,
        },
        location: [47.2709, -1.586178],
        genre: 'Cleyera',
        cultivar: 'Fortunei',
        famille: 'Pentaphylacaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586178, 47.2709] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9e6b524c8d483692015dc2a4f7a6c41a237042fd',
      fields: {
        espece: 'controversa',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 149, 108, 1.00)',
            'rgba(68, 91, 46, 1.00)',
            'rgba(62, 82, 37, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cornus/cornus controversa/cornus controversa (2).jpg',
          width: 724,
          id: '4fdadd1706ca76b734344eee3dc9adb7',
          height: 768,
          thumbnail: true,
        },
        location: [47.219005, -1.541588],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541588, 47.219005] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3a9da59321a7177f0cc1db6a1fdedaccfc65a249',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'mas',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 161, 110, 1.00)',
            'rgba(110, 133, 65, 1.00)',
            'rgba(101, 125, 57, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/cornus/cornus mas/cornus mas (2).jpg',
          width: 1024,
          id: '0558abdfc6dea23fa7374c7e68c29a5d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 156, 161, 1.00)',
            'rgba(124, 116, 83, 1.00)',
            'rgba(60, 64, 33, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/cornus/cornus mas/cornus mas .jpg',
          width: 814,
          id: 'e8335c5ae8e9669736359f51192ec1f2',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 131, 54, 1.00)',
            'rgba(128, 145, 62, 1.00)',
            'rgba(112, 128, 55, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/cornus/cornus mas/cornus mas (1).jpg',
          width: 1024,
          id: 'c5abdd3f9e10dcc73b2aca203db3dbba',
          height: 768,
          thumbnail: true,
        },
        location: [47.230347, -1.507703],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507703, 47.230347] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e4b641cfd85d9ac31d80d8dbfe1d41b82069527a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 89, 68, 1.00)',
            'rgba(131, 125, 77, 1.00)',
            'rgba(111, 105, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylopsis hamamelidaceae/corylopsis pauciflora/corylopsis pauciflora (13).jpg',
          width: 1024,
          id: '4adb45853e097beabf1d0797c366f7d9',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 125, 122, 1.00)',
            'rgba(125, 118, 87, 1.00)',
            'rgba(111, 105, 90, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylopsis hamamelidaceae/corylopsis pauciflora/corylopsis pauciflora (4).jpg',
          width: 576,
          id: 'e7bb8c49a723a0d74024e4528a23e0e4',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 135, 57, 1.00)',
            'rgba(134, 128, 52, 1.00)',
            'rgba(104, 98, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylopsis hamamelidaceae/corylopsis pauciflora/corylopsis pauciflora (1).jpg',
          width: 576,
          id: '6295ac0587872d55b29112d13561a82e',
          height: 768,
          thumbnail: true,
        },
        location: [47.270322, -1.586108],
        genre: 'Corylopsis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586108, 47.270322] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '900996052d084441c3ad2af72586f53a2f140812',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'sinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 160, 152, 1.00)',
            'rgba(173, 151, 91, 1.00)',
            'rgba(130, 112, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylopsis hamamelidaceae/corylopsis sinensis var. sinensis/corylopsis sinensis var. sinensis (3).jpg',
          width: 576,
          id: '135b7774652ee6e7f47c1f0a53b6ca6e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 129, 57, 1.00)',
            'rgba(115, 135, 50, 1.00)',
            'rgba(87, 106, 34, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylopsis hamamelidaceae/corylopsis sinensis var. sinensis/corylopsis sinensis var. sinensis (4).jpg',
          width: 713,
          id: 'c6ef6ec10a89afb4eb074cf67bc6272b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 100, 49, 1.00)',
            'rgba(163, 144, 71, 1.00)',
            'rgba(80, 91, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylopsis hamamelidaceae/corylopsis sinensis var. sinensis/corylopsis sinensis var. sinensis (1).jpg',
          width: 576,
          id: '0cb8c05c3d1fccadc908f877ceb08327',
          height: 768,
          thumbnail: true,
        },
        location: [47.271038, -1.582442],
        genre: 'Corylopsis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582442, 47.271038] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '82c9a2880cf92c8b4723f726c10469977da661e7',
      fields: {
        espece: 'colurna',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(181, 198, 184, 1.00)',
            'rgba(90, 103, 71, 1.00)',
            'rgba(121, 123, 98, 1.00)',
          ],
          filename:
            'ip ville de nantes/corylus/corylus colurna/corylus colurna.jpg',
          width: 1024,
          id: '917ea4238cd81a5c04ccc7000adbe85f',
          height: 768,
          thumbnail: true,
        },
        location: [47.238725, -1.584837],
        genre: 'Corylus',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584837, 47.238725] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9e277ca69f5d9b3279bf110d73ba2d93f3f56911',
      fields: {
        espece: 'coggygria',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(171, 185, 171, 1.00)',
            'rgba(80, 81, 44, 1.00)',
            'rgba(46, 51, 25, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cotinus/cotinus coggygria/cotinus coggygria (2).jpg',
          width: 1024,
          id: '23c768e446cba465d4aebbf4b6de879c',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 142, 199, 1.00)',
            'rgba(102, 115, 130, 1.00)',
            'rgba(83, 70, 48, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cotinus/cotinus coggygria/cotinus coggygria (1).jpg',
          width: 1024,
          id: '699c9bfbce45cdd87c5c60be1ba472b7',
          height: 683,
          thumbnail: true,
        },
        location: [47.21945, -1.543547],
        genre: 'Cotinus',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543547, 47.21945] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e8f456f7fdef5139445fea3ce14d3f3e2bf97e81',
      fields: {
        espece: 'ovatifolius',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 164, 130, 1.00)',
            'rgba(107, 124, 104, 1.00)',
            'rgba(101, 102, 100, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/disanthus/disanthus ovatifolius/disanthus ovatifolius (2).jpg',
          width: 1024,
          id: '592caff3d7caec86e8109e59bd708d17',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 139, 130, 1.00)',
            'rgba(124, 133, 128, 1.00)',
            'rgba(93, 104, 86, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/disanthus/disanthus ovatifolius/disanthus ovatifolius (1).jpg',
          width: 512,
          id: '3f03e49de6bcebb4a56b61a4db8fcec1',
          height: 768,
          thumbnail: true,
        },
        location: [47.2188, -1.541522],
        genre: 'Disanthus',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541522, 47.2188] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9b8ae669e3b40f885d9171235c44b0e54a56b991',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'chrysantha',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 158, 151, 1.00)',
            'rgba(85, 80, 60, 1.00)',
            'rgba(111, 99, 86, 1.00)',
          ],
          filename:
            'ip parc de proce/edgeworthia/edgeworthia chrysantha/edgeworthia chrysantha  (2).jpg',
          width: 576,
          id: 'c547ec8726e4d456336f2a0f1b134f3b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 109, 83, 1.00)',
            'rgba(154, 139, 86, 1.00)',
            'rgba(112, 97, 77, 1.00)',
          ],
          filename:
            'ip parc de proce/edgeworthia/edgeworthia chrysantha/edgeworthia chrysantha  (3).jpg',
          width: 576,
          id: '21e2d9d0b5a5edbcea4c88ec4d77c9c0',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 172, 163, 1.00)',
            'rgba(88, 88, 67, 1.00)',
            'rgba(98, 90, 73, 1.00)',
          ],
          filename:
            'ip parc de proce/edgeworthia/edgeworthia chrysantha/edgeworthia chrysantha  (1).jpg',
          width: 576,
          id: '84e0eedd52febf227fd55ee05b6e87bf',
          height: 768,
          thumbnail: true,
        },
        location: [47.224805, -1.581287],
        genre: 'Edgeworthia',
        famille: 'Thymelaeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581287, 47.224805] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f79f7d728d6cd0e876aba21a4ff04e618f86ecd8',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'planipes',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 134, 127, 1.00)',
            'rgba(141, 125, 112, 1.00)',
            'rgba(163, 126, 115, 1.00)',
          ],
          filename:
            'ip parc de proce/euonymus/euonymus planipes/euonymus planipes (2).jpg',
          width: 576,
          id: '26a06491102ef2ed9224a7063e581d39',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 148, 98, 1.00)',
            'rgba(94, 124, 62, 1.00)',
            'rgba(85, 110, 52, 1.00)',
          ],
          filename:
            'ip parc de proce/euonymus/euonymus planipes/euonymus planipes (3).jpg',
          width: 1024,
          id: '80fc1d2f6d26f4c0828365e8d08cb654',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 137, 129, 1.00)',
            'rgba(140, 124, 113, 1.00)',
            'rgba(155, 120, 105, 1.00)',
          ],
          filename:
            'ip parc de proce/euonymus/euonymus planipes/euonymus planipes (1).jpg',
          width: 576,
          id: '53ee3e972b39f71ad12291834044c235',
          height: 768,
          thumbnail: true,
        },
        location: [47.22275, -1.58248],
        genre: 'Euonymus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58248, 47.22275] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'be99e35e4f1ddc327b40977456acae7d326ee0a9',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(210, 224, 223, 1.00)',
            'rgba(86, 85, 63, 1.00)',
            'rgba(89, 99, 64, 1.00)',
          ],
          filename:
            "ip parc de proce/fagus/fagus sylvatica 'rohanii'/fagus sylvatica 'rohanii'.jpg",
          width: 576,
          id: '87132cb8f091d8839d2a2436aff26cd0',
          height: 768,
          thumbnail: true,
        },
        espece: 'sylvatica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 150, 90, 1.00)',
            'rgba(137, 139, 84, 1.00)',
            'rgba(117, 114, 67, 1.00)',
          ],
          filename:
            "ip parc de proce/fagus/fagus sylvatica 'rohanii'/fagus sylvatica 'rohanii' (2).jpg",
          width: 576,
          id: 'f20d6a1660aa6a85fd75a081da48c076',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 155, 89, 1.00)',
            'rgba(138, 139, 81, 1.00)',
            'rgba(96, 84, 37, 1.00)',
          ],
          filename:
            "ip parc de proce/fagus/fagus sylvatica 'rohanii'/fagus sylvatica 'rohanii' (1).jpg",
          width: 576,
          id: 'af2298c64180fa55a097980e15bf2e75',
          height: 768,
          thumbnail: true,
        },
        location: [47.222647, -1.584238],
        genre: 'Fagus',
        cultivar: 'Rohanii',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584238, 47.222647] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '07f10b960dbe9956e8438d7317b19f505216c27f',
      fields: {
        espece: 'sylvatica',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 189, 180, 1.00)',
            'rgba(101, 122, 53, 1.00)',
            'rgba(81, 99, 32, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/fagus/fagus sylvatica 'pendula'/fagus sylvatica 'pendula'.jpg",
          width: 1024,
          id: 'b3b12ccbdac62d17251c9b10dadc57db',
          height: 768,
          thumbnail: true,
        },
        location: [47.26213, -1.530058],
        genre: 'Fagus',
        cultivar: 'Pendula',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530058, 47.26213] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4d3eed04fd10227a9a1de54a3d840b4a594aec57',
      fields: {
        espece: 'simplex',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 85, 67, 1.00)',
            'rgba(193, 178, 139, 1.00)',
            'rgba(185, 171, 121, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/firmiana/firmiana simplex/firmiana simplex (7).jpg',
          width: 629,
          id: '7956f7d8b9899bb56813542959f370a6',
          height: 768,
          thumbnail: true,
        },
        location: [47.230062, -1.509828],
        genre: 'Firmiana',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.509828, 47.230062] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f945e5823a8f34a74bfa4adfa758f15fd1c06631',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'americana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 175, 168, 1.00)',
            'rgba(113, 120, 81, 1.00)',
            'rgba(81, 83, 46, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/fraxinus/fraxinus americana/fraxinus americana (2).jpg',
          width: 576,
          id: 'c63f0e067e54e939d77757bd1e4078fc',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 142, 70, 1.00)',
            'rgba(113, 152, 87, 1.00)',
            'rgba(107, 138, 84, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/fraxinus/fraxinus americana/fraxinus americana.jpg',
          width: 576,
          id: '4b54168a8e8ccc8bad09ced6069cae32',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 142, 172, 1.00)',
            'rgba(150, 120, 111, 1.00)',
            'rgba(161, 107, 63, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/fraxinus/fraxinus americana/fraxinus americana (1).jpg',
          width: 576,
          id: 'fa2eca5ff6edc732b4eaed3a8e521c85',
          height: 768,
          thumbnail: true,
        },
        location: [47.21927, -1.541678],
        genre: 'Fraxinus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541678, 47.21927] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '735c7c75e10b0409b4140cb023f3e7d20f0cbc6d',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 139, 138, 1.00)',
            'rgba(148, 135, 111, 1.00)',
            'rgba(132, 119, 94, 1.00)',
          ],
          filename:
            "ip parc de proce/fraxinus/fraxinus excelsior 'jaspidea'/fraxinus excelsior 'jaspidea' (3).jpg",
          width: 576,
          id: 'c18145d681e9c20ba9ee470aa8dfc2bf',
          height: 768,
          thumbnail: true,
        },
        espece: 'excelsior',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 147, 180, 1.00)',
            'rgba(135, 140, 139, 1.00)',
            'rgba(103, 90, 62, 1.00)',
          ],
          filename:
            "ip parc de proce/fraxinus/fraxinus excelsior 'jaspidea'/fraxinus excelsior 'jaspidea' (2).jpg",
          width: 576,
          id: '9b645a49f57277517997de292537182b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 87, 64, 1.00)',
            'rgba(163, 147, 124, 1.00)',
            'rgba(165, 145, 126, 1.00)',
          ],
          filename:
            "ip parc de proce/fraxinus/fraxinus excelsior 'jaspidea'/fraxinus excelsior 'jaspidea' (1).jpg",
          width: 576,
          id: '67e88ccf5f4f755758da45833345b84a',
          height: 768,
          thumbnail: true,
        },
        location: [47.222372, -1.585438],
        genre: 'Fraxinus',
        cultivar: 'Jaspidea',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585438, 47.222372] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd972531a3fad86f5e3686238eb7d78284430d125',
      fields: {
        espece: 'excelsior',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 200, 150, 1.00)',
            'rgba(101, 131, 57, 1.00)',
            'rgba(84, 103, 58, 1.00)',
          ],
          filename:
            "ip parc de proce/fraxinus/fraxinus excelsior 'jaspidea'/fraxinus excelsior 'jaspidea' (5).jpg",
          width: 1024,
          id: '804b5243696e65ebdf76bbb2db31f111',
          height: 768,
          thumbnail: true,
        },
        location: [47.223042, -1.58268],
        genre: 'Fraxinus',
        cultivar: 'Jaspidea',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58268, 47.223042] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1a4a8303e982e847bfdc5c2277c1e615ad6cd7da',
      fields: {
        espece: 'triacanthos',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(179, 194, 192, 1.00)',
            'rgba(139, 151, 115, 1.00)',
            'rgba(87, 95, 54, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/gleditsia/gleditsia triacanthos/gleditsia triacanthos (2).jpg',
          width: 1024,
          id: 'a71f1de43048e2a61827d046219711d2',
          height: 768,
          thumbnail: true,
        },
        location: [47.26278, -1.531697],
        genre: 'Gleditsia',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531697, 47.26278] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c99b5aef6f85e2d410f1d80a9be5dfef65fc6658',
      fields: {
        espece: 'triacanthos f. inermis',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(211, 221, 227, 1.00)',
            'rgba(134, 132, 101, 1.00)',
            'rgba(131, 127, 114, 1.00)',
          ],
          filename:
            "ip ville de nantes/gleditsia/gleditsia triacanthos f. inermis 'sunburst'/gleditsia triacanthos f. inermis 'sunburst'.jpg",
          width: 1024,
          id: 'd0c2dd218c166a2752bcca222d3a8a93',
          height: 768,
          thumbnail: true,
        },
        location: [47.218125, -1.555053],
        genre: 'Gleditsia',
        cultivar: 'Sunburst',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.555053, 47.218125] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dabb5ac8c5adaff07ee0c9523059bcb859d6904b',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'puberum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 136, 124, 1.00)',
            'rgba(139, 122, 105, 1.00)',
            'rgba(143, 124, 97, 1.00)',
          ],
          filename:
            'ip parc de proce/glochidion/glochidion puberum/glochidion puberum (2).jpg',
          width: 576,
          id: '9e54bca3eed8a295c17e508120eca168',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 106, 80, 1.00)',
            'rgba(115, 138, 110, 1.00)',
            'rgba(87, 107, 80, 1.00)',
          ],
          filename:
            'ip parc de proce/glochidion/glochidion puberum/glochidion puberum (3).jpg',
          width: 1024,
          id: '8bff04e0ef4045c8e018cef13597a599',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 137, 121, 1.00)',
            'rgba(138, 131, 126, 1.00)',
            'rgba(127, 120, 112, 1.00)',
          ],
          filename:
            'ip parc de proce/glochidion/glochidion puberum/glochidion puberum (1).jpg',
          width: 576,
          id: '49d4036df15503a5daddcbb8809e5d42',
          height: 768,
          thumbnail: true,
        },
        location: [47.222905, -1.579553],
        genre: 'Glochidion',
        famille: 'Phyllanthaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.579553, 47.222905] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd5c0fc522bb0243176e1f20291aa6957197c557a',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 178, 62, 1.00)',
            'rgba(116, 146, 27, 1.00)',
            'rgba(76, 93, 9, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis virginiana/hamamelis virginiana.jpg',
          width: 576,
          id: 'db00f64a7640583c9bba97760908f116',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 177, 87, 1.00)',
            'rgba(105, 137, 55, 1.00)',
            'rgba(66, 109, 30, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis virginiana/hamamelis virginiana (2).jpg',
          width: 576,
          id: 'ff579396111913d1ac471724ecad9333',
          height: 768,
          thumbnail: true,
        },
        location: [47.271238, -1.585088],
        genre: 'Hamamelis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585088, 47.271238] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '07a5880511cce714c0e1ad6fa2c22df457574dd0',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 128, 105, 1.00)',
            'rgba(85, 71, 52, 1.00)',
            'rgba(77, 85, 82, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis x intermedia 'jelena'/hamamelis x intermedia 'jelena' (12).jpg",
          width: 928,
          id: '8132d69dca44976f2f971c4bf2163ec1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 120, 94, 1.00)',
            'rgba(140, 123, 109, 1.00)',
            'rgba(159, 141, 126, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis x intermedia 'jelena'/hamamelis x intermedia 'jelena' (18).jpg",
          width: 576,
          id: '73f8b87d9cb0882fa417930bb62daf80',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 96, 88, 1.00)',
            'rgba(136, 117, 111, 1.00)',
            'rgba(147, 126, 129, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis x intermedia 'jelena'/hamamelis x intermedia 'jelena' (1).jpg",
          width: 615,
          id: '532756dbf2b3096acf600a143896860a',
          height: 768,
          thumbnail: true,
        },
        location: [47.269825, -1.585653],
        genre: 'Hamamelis',
        cultivar: 'Jelena',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585653, 47.269825] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0d2dce2d872807685b3d0d95d8d182f953b389f8',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'dulcis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 140, 175, 1.00)',
            'rgba(91, 107, 138, 1.00)',
            'rgba(80, 100, 131, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/hovenia/hovenia dulcis/hovenia dulcis (3).jpg',
          width: 512,
          id: 'df41c5cc1237e97474512fa3e35cb23a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 131, 165, 1.00)',
            'rgba(106, 123, 151, 1.00)',
            'rgba(88, 90, 82, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/hovenia/hovenia dulcis/hovenia dulcis (4).jpg',
          width: 1024,
          id: 'cfba58c5ee104228ab8d634f39c54a56',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 110, 150, 1.00)',
            'rgba(92, 113, 146, 1.00)',
            'rgba(123, 141, 166, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/hovenia/hovenia dulcis/hovenia dulcis (1).jpg',
          width: 1024,
          id: '1659af5379347978d8344e69ac7a2b5b',
          height: 683,
          thumbnail: true,
        },
        location: [47.262491, -1.532337],
        genre: 'Hovenia',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532337, 47.262491] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '38001f07d3d0fa2c09e8a40205ce5f1cc578f1c0',
      fields: {
        espece: 'dulcis',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 134, 199, 1.00)',
            'rgba(106, 127, 153, 1.00)',
            'rgba(86, 83, 68, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/hovenia/hovenia dulcis/hovenia dulcis (2).jpg',
          width: 1024,
          id: 'bc7e9146a1dbc546656f680a397d4acd',
          height: 683,
          thumbnail: true,
        },
        location: [47.262497, -1.532333],
        genre: 'Hovenia',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532333, 47.262497] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '639fad1f6b769c0e4f25185e573ae5ff45d26186',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'macropoda',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 143, 68, 1.00)',
            'rgba(102, 141, 56, 1.00)',
            'rgba(96, 139, 48, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ilex/ilex macropoda/ilex macropoda (1).jpg',
          width: 576,
          id: '8a93fe597858c8c84dc678996da10bf9',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 156, 64, 1.00)',
            'rgba(99, 148, 52, 1.00)',
            'rgba(118, 160, 54, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ilex/ilex macropoda/ilex macropoda (2).jpg',
          width: 576,
          id: '83290dd9fc2db87e92e98b307bdc9103',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 131, 79, 1.00)',
            'rgba(93, 127, 55, 1.00)',
            'rgba(129, 177, 82, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ilex/ilex macropoda/ilex macropoda  (2).jpg',
          width: 576,
          id: '6654fd965e0e10e5b3f1de59e85165c1',
          height: 768,
          thumbnail: true,
        },
        location: [47.219986, -1.542111],
        genre: 'Ilex',
        famille: 'Aquifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542111, 47.219986] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c7a14838184f12f1be3a59e5059c8372abc476d7',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'henryi',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 164, 105, 1.00)',
            'rgba(92, 119, 54, 1.00)',
            'rgba(119, 137, 86, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/illicium/illicium henryi/illicium henryi (3).jpg',
          width: 576,
          id: 'adb0c112dab3264ab13fb99ad43032fe',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 145, 89, 1.00)',
            'rgba(106, 145, 92, 1.00)',
            'rgba(116, 143, 71, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/illicium/illicium henryi/illicium henryi (4).jpg',
          width: 576,
          id: '9f387cc0ba46e5e78c0abf1ff31a0ff6',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 142, 84, 1.00)',
            'rgba(154, 129, 92, 1.00)',
            'rgba(120, 146, 81, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/illicium/illicium henryi/illicium henryi (1).jpg',
          width: 576,
          id: 'c7bb8a548b8d7293ea7576d659a9a4ac',
          height: 768,
          thumbnail: true,
        },
        location: [47.219288, -1.5421],
        genre: 'Illicium',
        famille: 'Schisandraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421, 47.219288] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bc9cecb22812815c4e24e84fffc8e7e7bf9dd0b9',
      fields: {
        espece: 'latifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 146, 131, 1.00)',
            'rgba(108, 134, 101, 1.00)',
            'rgba(115, 136, 102, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/kalmia/kalmia latifolia 'pink wheel'/kalmia latifolia 'pink wheel' (2).jpg",
          width: 576,
          id: 'e3ae57d0638e624a1cce20a3f4517341',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 137, 96, 1.00)',
            'rgba(136, 126, 116, 1.00)',
            'rgba(92, 106, 83, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/kalmia/kalmia latifolia 'pink wheel'/kalmia latifolia 'pink wheel' (1).jpg",
          width: 1024,
          id: '8a0e769b0e918c4dec62a3dfa690a624',
          height: 768,
          thumbnail: true,
        },
        location: [47.218963, -1.54277],
        genre: 'Kalmia',
        cultivar: 'Pink Wheel',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54277, 47.218963] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'aa5820a01ca2dea4dc583258fce17057b16fb7f8',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'paniculata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 182, 234, 1.00)',
            'rgba(108, 121, 78, 1.00)',
            'rgba(65, 73, 31, 1.00)',
          ],
          filename:
            'ip parc de proce/koelreuteria/koelreuteria paniculata/koelreuteria paniculata (2).jpg',
          width: 576,
          id: '950afc69382d17bbce2d941e132fcd1b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 153, 182, 1.00)',
            'rgba(120, 128, 135, 1.00)',
            'rgba(75, 77, 47, 1.00)',
          ],
          filename:
            'ip parc de proce/koelreuteria/koelreuteria paniculata/koelreuteria paniculata (3).jpg',
          width: 613,
          id: '28934620182a87136f293616f992fcb8',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(218, 229, 221, 1.00)',
            'rgba(88, 104, 53, 1.00)',
            'rgba(74, 83, 40, 1.00)',
          ],
          filename:
            'ip parc de proce/koelreuteria/koelreuteria paniculata/koelreuteria paniculata (1).jpg',
          width: 576,
          id: 'e18fca9088f3eeeb97bb995dcd6b4d30',
          height: 768,
          thumbnail: true,
        },
        location: [47.225992, -1.582578],
        genre: 'Koelreuteria',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582578, 47.225992] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e78e062a024c99d0a37239ebed34e513dd4391c0',
      fields: {
        espece: 'japonicum',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(204, 209, 200, 1.00)',
            'rgba(90, 92, 76, 1.00)',
            'rgba(91, 91, 86, 1.00)',
          ],
          filename:
            'ip ville de nantes/ligustrum/ligustrum japonicum/ligustrum japonicum.jpg',
          width: 576,
          id: '5ae538205337e9fc54a3dfd926436a4f',
          height: 768,
          thumbnail: true,
        },
        location: [47.219497, -1.534858],
        genre: 'Ligustrum',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534858, 47.219497] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3a885654888552927add8665c4270b7da0a66076',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'benzoin',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 164, 78, 1.00)',
            'rgba(113, 155, 51, 1.00)',
            'rgba(99, 132, 39, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/lindera/lindera benzoin/lindera benzoin (3).jpg',
          width: 576,
          id: 'ab29aa7bdf7496af395fe5f809fbfba7',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 167, 126, 1.00)',
            'rgba(130, 154, 94, 1.00)',
            'rgba(118, 118, 96, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/lindera/lindera benzoin/lindera benzoin.jpg',
          width: 1024,
          id: '3ff8ee1b2ae7aeb980029223962d12ed',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 171, 175, 1.00)',
            'rgba(113, 119, 50, 1.00)',
            'rgba(106, 100, 56, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/lindera/lindera benzoin/lindera benzoin (2).jpg',
          width: 1024,
          id: '04b2f922de6aba318a6ccf082c015468',
          height: 768,
          thumbnail: true,
        },
        location: [47.21953, -1.544105],
        genre: 'Lindera',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544105, 47.21953] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '35854daccc586625438ed21aa17dde7d1724668d',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'obtusiloba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 121, 80, 1.00)',
            'rgba(108, 136, 91, 1.00)',
            'rgba(83, 97, 69, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/lindera/lindera obtusiloba/lindera obtusiloba  (2).jpg',
          width: 1024,
          id: '97e023a5da08d2094d21c570be79efcc',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 166, 95, 1.00)',
            'rgba(112, 161, 68, 1.00)',
            'rgba(98, 130, 55, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/lindera/lindera obtusiloba/lindera obtusiloba (2).jpg',
          width: 576,
          id: '5a5938c2159ddfa249e8867bc814e482',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(75, 114, 59, 1.00)',
            'rgba(83, 137, 68, 1.00)',
            'rgba(72, 118, 60, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/lindera/lindera obtusiloba/lindera obtusiloba  (1).jpg',
          width: 512,
          id: '2d64bf34d55180b298547c3592ad578a',
          height: 768,
          thumbnail: true,
        },
        location: [47.219513, -1.544122],
        genre: 'Lindera',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544122, 47.219513] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4782669e8e9eb712462bd59b2b86fdcae1123be4',
      fields: {
        espece: 'reflexa',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 107, 78, 1.00)',
            'rgba(117, 130, 96, 1.00)',
            'rgba(101, 118, 80, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/lindera/lindera reflexa/lindera reflexa.jpg',
          width: 1024,
          id: '6c65c0ab1aa6017360cbaa47788b04ef',
          height: 683,
          thumbnail: true,
        },
        location: [47.219483, -1.544088],
        genre: 'Lindera',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544088, 47.219483] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'de7cd3541caf600f9f2c4d29e0e9b53e9de76017',
      fields: {
        espece: 'formosana Monticola Group',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(181, 198, 154, 1.00)',
            'rgba(107, 132, 76, 1.00)',
            'rgba(69, 86, 44, 1.00)',
          ],
          filename:
            'ip parc de proce/liquidambar/liquidambar formosana monticola group/liquidambar formosana monticola group (2).jpg',
          width: 576,
          id: 'fe06cd166486bbb8e955bdae523b38ef',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 106, 67, 1.00)',
            'rgba(119, 150, 66, 1.00)',
            'rgba(134, 142, 86, 1.00)',
          ],
          filename:
            'ip parc de proce/liquidambar/liquidambar formosana monticola group/liquidambar formosana monticola group (1).jpg',
          width: 576,
          id: '47cf6dbc1b193238f378e38a7848908f',
          height: 768,
          thumbnail: true,
        },
        location: [47.223125, -1.582917],
        genre: 'Liquidambar',
        famille: 'Altingiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582917, 47.223125] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dfd6bba67585d326a73e04c6815d6744b34c7fb6',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 191, 181, 1.00)',
            'rgba(109, 114, 73, 1.00)',
            'rgba(59, 58, 28, 1.00)',
          ],
          filename:
            "ip parc de proce/liquidambar/liquidambar styraciflua 'variegata'/liquidambar styraciflua 'variegata' (5).jpg",
          width: 1024,
          id: 'd485947263f0085671290d0e4cf4a412',
          height: 683,
          thumbnail: true,
        },
        espece: 'styraciflua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 158, 91, 1.00)',
            'rgba(116, 136, 76, 1.00)',
            'rgba(95, 113, 55, 1.00)',
          ],
          filename:
            "ip parc de proce/liquidambar/liquidambar styraciflua 'variegata'/liquidambar styraciflua 'variegata' (2).jpg",
          width: 576,
          id: '9ed6686aa7c6161eb924d1064582b7d1',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(219, 225, 206, 1.00)',
            'rgba(111, 129, 75, 1.00)',
            'rgba(65, 81, 35, 1.00)',
          ],
          filename:
            "ip parc de proce/liquidambar/liquidambar styraciflua 'variegata'/liquidambar styraciflua 'variegata' (1).jpg",
          width: 1024,
          id: '9db090cd13985d9e006d6d977b47a0ab',
          height: 753,
          thumbnail: true,
        },
        location: [47.223047, -1.582887],
        genre: 'Liquidambar',
        cultivar: 'Variegata',
        famille: 'Altingiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582887, 47.223047] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a8e219cf5b743c7fd00b9ca3e858d23665f029ad',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 166, 118, 1.00)',
            'rgba(94, 130, 53, 1.00)',
            'rgba(93, 126, 42, 1.00)',
          ],
          filename:
            "ip foyer des anciens/liriodendron/liriodendron tulipifera 'aureomarginatum'/liriodendron tulipifera 'aureomarginatum' (3).jpg",
          width: 576,
          id: '6edcc5cea6fc91c1777ca3097287e339',
          height: 768,
          thumbnail: true,
        },
        espece: 'tulipifera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 182, 142, 1.00)',
            'rgba(91, 115, 64, 1.00)',
            'rgba(68, 87, 52, 1.00)',
          ],
          filename:
            "ip foyer des anciens/liriodendron/liriodendron tulipifera 'aureomarginatum'/liriodendron tulipifera 'aureomarginatum' (2).jpg",
          width: 1024,
          id: 'c70012155b83a9853f7ea47814c377f6',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Foyer des Anciens',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 143, 85, 1.00)',
            'rgba(104, 121, 81, 1.00)',
            'rgba(80, 93, 75, 1.00)',
          ],
          filename:
            "ip foyer des anciens/liriodendron/liriodendron tulipifera 'aureomarginatum'/liriodendron tulipifera 'aureomarginatum' (1).jpg",
          width: 576,
          id: 'e5221889e4cda12c3bb316c583512c25',
          height: 768,
          thumbnail: true,
        },
        location: [47.231688, -1.58187],
        genre: 'Liriodendron',
        cultivar: 'Aureomarginatum',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58187, 47.231688] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9339a53b35d19a3ac634598cbc9e3673a611af30',
      fields: {
        espece: 'tulipifera',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(178, 162, 134, 1.00)',
            'rgba(146, 117, 48, 1.00)',
            'rgba(83, 77, 35, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/liriodendron/liriodendron tulipifera 'aureomarginatum'/liriodendron tulipifera 'aureomarginatum'.jpg",
          width: 576,
          id: 'fbcd66ea8151365b6695c13c7bf76e49',
          height: 768,
          thumbnail: true,
        },
        location: [47.219217, -1.542112],
        genre: 'Liriodendron',
        cultivar: 'Aureomarginatum',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542112, 47.219217] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '795a23afc474101f52056382569b170eca14efd1',
      fields: {
        espece: 'chinense',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 118, 71, 1.00)',
            'rgba(125, 142, 78, 1.00)',
            'rgba(86, 99, 47, 1.00)',
          ],
          filename:
            'ip parc de proce/loropetalum/loropetalum chinense/loropetalum chinense.jpg',
          width: 576,
          id: 'a3bd58e4380e31b0100474677e3fe0b4',
          height: 768,
          thumbnail: true,
        },
        location: [47.223238, -1.5827],
        genre: 'Loropetalum',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5827, 47.223238] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e372e982da68c786eeb58450ab53acf1538e0386',
      fields: {
        espece: 'apiculata',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 165, 149, 1.00)',
            'rgba(73, 74, 55, 1.00)',
            'rgba(70, 66, 40, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/luma/luma apiculata/luma apiculata.jpg',
          width: 1024,
          id: 'f3f71e4435113dbf407658099b644947',
          height: 683,
          thumbnail: true,
        },
        location: [47.262738, -1.530453],
        genre: 'Luma',
        famille: 'Myrtaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530453, 47.262738] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bf59e0e34b73cfd536beff9259644048725500e0',
      fields: {
        espece: 'grandiflora',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 135, 181, 1.00)',
            'rgba(101, 112, 120, 1.00)',
            'rgba(75, 77, 46, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/magnolia/magnolia grandiflora 'maillardiensis'/magnolia grandiflora 'maillardiensis' (2).jpg",
          width: 1024,
          id: '1f8f6880c1ecb846e5f0f8af5b02e587',
          height: 683,
          thumbnail: true,
        },
        location: [47.219642, -1.542803],
        genre: 'Magnolia',
        cultivar: 'Maillardiensis',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542803, 47.219642] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4e12d4956edb2077308d2b5fcee6e369ca32a583',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'stellata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 188, 192, 1.00)',
            'rgba(120, 117, 86, 1.00)',
            'rgba(89, 89, 49, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia stellata/magnolia stellata (2).jpg',
          width: 1024,
          id: '273d12738339dfd4af5c05b8cb0a0a8d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 178, 46, 1.00)',
            'rgba(86, 139, 38, 1.00)',
            'rgba(73, 120, 26, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia stellata/magnolia stellata .jpg',
          width: 576,
          id: '881efc21b2fed8126530bebcb9020c47',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 90, 66, 1.00)',
            'rgba(124, 126, 110, 1.00)',
            'rgba(106, 107, 82, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia stellata/magnolia stellata (1).jpg',
          width: 576,
          id: '1cab2d561b841ef7f0149ff34479f8ab',
          height: 768,
          thumbnail: true,
        },
        location: [47.220547, -1.543097],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543097, 47.220547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '25c7dfffafb1e46ef1c5407c9550ec371614ec10',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 181, 218, 1.00)',
            'rgba(108, 118, 102, 1.00)',
            'rgba(57, 51, 27, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia 'yellow lantern'/magnolia 'yellow lantern'.jpg",
          width: 576,
          id: '167c7870146912da0eea34ed8d3214d8',
          height: 768,
          thumbnail: true,
        },
        location: [47.22282, -1.5808],
        genre: 'Magnolia',
        cultivar: 'Yellow Lantern',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5808, 47.22282] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c816a1b76ef171c505db4c63347cae62bcc8c452',
      fields: {
        espece: 'laevifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 86, 63, 1.00)',
            'rgba(121, 129, 89, 1.00)',
            'rgba(90, 106, 53, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/magnolia/magnolia laevifolia 'summer snowflake'/magnolia laevifolia 'summer snowflake' (2).jpg",
          width: 1024,
          id: '9f925f6128501637571e111eecd7a144',
          height: 735,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 117, 83, 1.00)',
            'rgba(123, 128, 80, 1.00)',
            'rgba(86, 101, 56, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/magnolia/magnolia laevifolia 'summer snowflake'/magnolia laevifolia 'summer snowflake' (1).jpg",
          width: 1024,
          id: 'dea17d77d681fbc4bf063300b3318b45',
          height: 683,
          thumbnail: true,
        },
        location: [47.227533, -1.508425],
        genre: 'Magnolia',
        cultivar: 'Summer Snowflake',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508425, 47.227533] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a50feb46dd995960a93685fbd15876f74c1b9610',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 109, 170, 1.00)',
            'rgba(96, 113, 135, 1.00)',
            'rgba(65, 68, 44, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'albatross'/magnolia 'albatross' (3).jpg",
          width: 1024,
          id: 'd096f4feacd87fc8d2397a76b6bccaa3',
          height: 683,
          thumbnail: true,
        },
        location: [47.262512, -1.53265],
        genre: 'Magnolia',
        cultivar: 'Albatross',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53265, 47.262512] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '07635f769bf8f5a22683973a65aaf68dd714e8f6',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(167, 167, 150, 1.00)',
            'rgba(124, 111, 85, 1.00)',
            'rgba(149, 133, 100, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'ann'/magnolia 'ann' (4).jpg",
          width: 576,
          id: '5af461938cb019580c04765a032264d3',
          height: 768,
          thumbnail: true,
        },
        location: [47.261747, -1.52915],
        genre: 'Magnolia',
        cultivar: 'Ann',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.52915, 47.261747] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '85e0262017901fe05519a271be824f707576bb21',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 148, 102, 1.00)',
            'rgba(100, 110, 75, 1.00)',
            'rgba(110, 125, 63, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'banana split'/magnolia 'banana split' (2).jpg",
          width: 576,
          id: '88a2812dcf93e06ea253c37de0665133',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 122, 100, 1.00)',
            'rgba(115, 127, 79, 1.00)',
            'rgba(87, 102, 50, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'banana split'/magnolia 'banana split' (3).jpg",
          width: 576,
          id: '1f0327a1844fb3dd19aefdca778238bd',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 118, 110, 1.00)',
            'rgba(98, 104, 71, 1.00)',
            'rgba(101, 110, 59, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'banana split'/magnolia 'banana split' (1).jpg",
          width: 576,
          id: 'f79f18b79f8292afef0148867d032ff0',
          height: 768,
          thumbnail: true,
        },
        location: [47.262712, -1.530355],
        genre: 'Magnolia',
        cultivar: 'Banana Split',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530355, 47.262712] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '07aeb72ab48ae605ae290259021b1d51aa48578f',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 131, 120, 1.00)',
            'rgba(114, 117, 85, 1.00)',
            'rgba(89, 94, 72, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'butterflies'/magnolia 'butterflies' (2).jpg",
          width: 1024,
          id: 'a373ad70dfa9b08d77a53916c4d0caea',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 149, 173, 1.00)',
            'rgba(108, 109, 79, 1.00)',
            'rgba(98, 108, 51, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'butterflies'/magnolia 'butterflies' (3).jpg",
          width: 1024,
          id: '75fd7fccc4381df0d8c10088aba6096d',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 99, 103, 1.00)',
            'rgba(120, 124, 104, 1.00)',
            'rgba(105, 105, 64, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'butterflies'/magnolia 'butterflies' (1).jpg",
          width: 1024,
          id: '01f74e8874abbd05d8fc523ed91d864b',
          height: 734,
          thumbnail: true,
        },
        location: [47.262667, -1.531458],
        genre: 'Magnolia',
        cultivar: 'Butterflies',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531458, 47.262667] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8b269160106b13215e66f33b20cc12eb917ed480',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 74, 64, 1.00)',
            'rgba(145, 109, 116, 1.00)',
            'rgba(82, 63, 51, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'caerhays belle'/magnolia 'caerhays belle'  (2).jpg",
          width: 576,
          id: 'd53d6041017d2e5368c6f44ee1df8100',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 157, 176, 1.00)',
            'rgba(124, 108, 90, 1.00)',
            'rgba(93, 82, 49, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'caerhays belle'/magnolia 'caerhays belle'  (1).jpg",
          width: 576,
          id: '04252dbc88ddc5ea7dda0b04c47b054e',
          height: 768,
          thumbnail: true,
        },
        location: [47.263275, -1.533808],
        genre: 'Magnolia',
        cultivar: 'Caerhays Belle',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533808, 47.263275] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5c85dde041f055b1e8d58378e7d1bce8a1335091',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 165, 199, 1.00)',
            'rgba(137, 134, 125, 1.00)',
            'rgba(119, 115, 66, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'dog cage'/magnolia 'dog cage' (2).jpg",
          width: 576,
          id: '7f33ff0cd3d458625c3d0f9b33caa76d',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 101, 102, 1.00)',
            'rgba(128, 117, 117, 1.00)',
            'rgba(84, 74, 38, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'dog cage'/magnolia 'dog cage' (1).jpg",
          width: 576,
          id: 'aa494b11b2f4481e120f046370ec12aa',
          height: 768,
          thumbnail: true,
        },
        location: [47.264075, -1.535503],
        genre: 'Magnolia',
        cultivar: 'Dog Cage',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535503, 47.264075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c55dd6f684e68c17e1336d691f358462b57c13f5',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 72, 95, 1.00)',
            'rgba(136, 83, 106, 1.00)',
            'rgba(102, 58, 71, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'eleanor may'/magnolia 'eleanor may' (5).jpg",
          width: 1024,
          id: '33566fc0ecc60cb288d13617dd149f1a',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 52, 71, 1.00)',
            'rgba(128, 81, 95, 1.00)',
            'rgba(80, 66, 55, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'eleanor may'/magnolia 'eleanor may' (6).jpg",
          width: 1024,
          id: 'bf4b6c4eb5ba74658482a32e1f2c6e02',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 138, 188, 1.00)',
            'rgba(131, 114, 134, 1.00)',
            'rgba(67, 66, 47, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'eleanor may'/magnolia 'eleanor may' (2).jpg",
          width: 1024,
          id: '50db7970e69a6770218ad5594579d61e',
          height: 683,
          thumbnail: true,
        },
        location: [47.262908, -1.532272],
        genre: 'Magnolia',
        cultivar: 'Eleanor May',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532272, 47.262908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8c6a511a490ce7b777803b8222f61e9aad7e51c5',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 171, 205, 1.00)',
            'rgba(129, 122, 123, 1.00)',
            'rgba(75, 69, 33, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'full eclipse'/magnolia 'full eclipse' (2).jpg",
          width: 640,
          id: '447ea1344dcab5b224d7817cda9b2941',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 176, 214, 1.00)',
            'rgba(115, 107, 104, 1.00)',
            'rgba(74, 71, 39, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'full eclipse'/magnolia 'full eclipse' (3).jpg",
          width: 1024,
          id: '1c2e2271a70ef57476f401d3cd93f822',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 128, 138, 1.00)',
            'rgba(163, 126, 131, 1.00)',
            'rgba(88, 68, 49, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'full eclipse'/magnolia 'full eclipse' (1).jpg",
          width: 576,
          id: '9d4d5dcfe1a878ed4d6e85488daeef74',
          height: 768,
          thumbnail: true,
        },
        location: [47.263153, -1.534647],
        genre: 'Magnolia',
        cultivar: 'Full Eclipse',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534647, 47.263153] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fc817de7f4c663895acc18a2aa16ba221baada0a',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 146, 99, 1.00)',
            'rgba(103, 116, 75, 1.00)',
            'rgba(115, 127, 83, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'legend'/magnolia 'legend' (2).jpg",
          width: 576,
          id: 'f7afdca34b45a718d707291a80600066',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(52, 59, 42, 1.00)',
            'rgba(118, 125, 85, 1.00)',
            'rgba(96, 117, 34, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'legend'/magnolia 'legend' (1).jpg",
          width: 576,
          id: '6478cba908b4f020633b3d4ab2d29bce',
          height: 768,
          thumbnail: true,
        },
        location: [47.261688, -1.529747],
        genre: 'Magnolia',
        cultivar: 'Legend',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529747, 47.261688] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '89cfef3e9abcda877d4c1dc81f2105b57662a3fe',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 138, 173, 1.00)',
            'rgba(112, 120, 122, 1.00)',
            'rgba(62, 67, 40, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'lotus'/magnolia 'lotus' (2).jpg",
          width: 1024,
          id: 'fb8191724b2ed821ba07bd13d2e44e66',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 114, 129, 1.00)',
            'rgba(136, 137, 126, 1.00)',
            'rgba(69, 77, 54, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'lotus'/magnolia 'lotus' (3).jpg",
          width: 1024,
          id: '86e82c82c9f9c22dca66b4dc040f07db',
          height: 733,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 135, 155, 1.00)',
            'rgba(122, 134, 149, 1.00)',
            'rgba(118, 132, 149, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'lotus'/magnolia 'lotus' (1).jpg",
          width: 1024,
          id: '303f32d9d02af90407b7dab7269e9a3d',
          height: 683,
          thumbnail: true,
        },
        location: [47.262413, -1.530038],
        genre: 'Magnolia',
        cultivar: 'Lotus',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530038, 47.262413] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e5d3dbe691a89105207c86afae8a0688359adb6f',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 143, 135, 1.00)',
            'rgba(99, 103, 90, 1.00)',
            'rgba(69, 73, 52, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'snow white'/magnolia 'snow white' (2).jpg",
          width: 1024,
          id: 'c84fb110b7d99af7078e8d54f7cb1106',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 95, 68, 1.00)',
            'rgba(108, 109, 89, 1.00)',
            'rgba(74, 71, 53, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'snow white'/magnolia 'snow white' (1).jpg",
          width: 1024,
          id: 'c34dd2a085b9ac214076d5cc3753773b',
          height: 683,
          thumbnail: true,
        },
        location: [47.261705, -1.5299],
        genre: 'Magnolia',
        cultivar: 'Snow White',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5299, 47.261705] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6acff3926dd5332cad3cc82b046b24785b2c0f2e',
      fields: {
        espece: 'campbellii',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 117, 120, 1.00)',
            'rgba(144, 120, 134, 1.00)',
            'rgba(121, 101, 106, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia campbellii 'darjeeling'/magnolia campbellii 'darjeeling'.jpg",
          width: 576,
          id: 'e608f11b63510d9d9112247eb5374276',
          height: 768,
          thumbnail: true,
        },
        location: [47.262387, -1.53135],
        genre: 'Magnolia',
        cultivar: 'Darjeeling',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53135, 47.262387] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cefc0b5644f23c42714864583b029964bc42ee80',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(208, 207, 214, 1.00)',
            'rgba(65, 63, 61, 1.00)',
            'rgba(40, 53, 11, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia campbellii 'strybing pink'/magnolia campbellii 'strybing pink'  (3).jpg",
          width: 617,
          id: '53b2b69ead83df414fb516b07c5b743f',
          height: 768,
          thumbnail: true,
        },
        espece: 'campbellii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 126, 128, 1.00)',
            'rgba(130, 94, 92, 1.00)',
            'rgba(54, 64, 18, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia campbellii 'strybing pink'/magnolia campbellii 'strybing pink'  (2).jpg",
          width: 512,
          id: '6caf12b20991ed15114e7d94a3e38150',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(181, 186, 196, 1.00)',
            'rgba(145, 112, 121, 1.00)',
            'rgba(73, 74, 27, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia campbellii 'strybing pink'/magnolia campbellii 'strybing pink'  (1).jpg",
          width: 512,
          id: 'c96cb8bb068f790b943c6afb47892ebc',
          height: 768,
          thumbnail: true,
        },
        location: [47.262667, -1.529597],
        genre: 'Magnolia',
        cultivar: 'Strybing Pink',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529597, 47.262667] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e95eb855d4f405df9b5946aeabc086ad86cff1a1',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'delavayi',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 139, 109, 1.00)',
            'rgba(77, 86, 59, 1.00)',
            'rgba(58, 57, 42, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia delavayi/magnolia delavayi (2).jpg',
          width: 512,
          id: '3d9b265fe0826d11f5aa00b990559e48',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 119, 91, 1.00)',
            'rgba(119, 131, 113, 1.00)',
            'rgba(78, 88, 68, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia delavayi/magnolia delavayi.jpg',
          width: 1024,
          id: '36331348569bedb3d4a7bb3607644427',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 132, 112, 1.00)',
            'rgba(74, 82, 64, 1.00)',
            'rgba(42, 40, 28, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia delavayi/magnolia delavayi (1).jpg',
          width: 512,
          id: 'c0dd11e6e1028f08bcc262d6ad2bfc2a',
          height: 768,
          thumbnail: true,
        },
        location: [47.262608, -1.53607],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53607, 47.262608] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '317f6b4cef38916f7fa14f11ccf3bff0f9026f95',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'fraseri var. pyramidata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 108, 104, 1.00)',
            'rgba(108, 117, 84, 1.00)',
            'rgba(106, 111, 76, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia fraseri var. pyramidata/magnolia fraseri var. pyramidata (4).jpg',
          width: 579,
          id: '355c6923317e854d47bdb2812834f440',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 91, 68, 1.00)',
            'rgba(104, 127, 120, 1.00)',
            'rgba(89, 110, 86, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia fraseri var. pyramidata/magnolia fraseri var. pyramidata (5).jpg',
          width: 575,
          id: '4660784ac576a9381cc84ad7ddd728f8',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 133, 154, 1.00)',
            'rgba(104, 123, 135, 1.00)',
            'rgba(73, 83, 53, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia fraseri var. pyramidata/magnolia fraseri var. pyramidata (3).jpg',
          width: 512,
          id: '3acd8d607e2aff62f7254f50dcd58214',
          height: 768,
          thumbnail: true,
        },
        location: [47.261542, -1.535438],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535438, 47.261542] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cee4dda1dd92a468a2e70e13cbbacff31223ffe8',
      fields: {
        espece: 'liliiflora',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 106, 92, 1.00)',
            'rgba(112, 84, 61, 1.00)',
            'rgba(97, 93, 45, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia liliiflora 'nigra'/magnolia liliiflora 'nigra'.jpg",
          width: 1024,
          id: 'eb84d5ad618e1a5516d2e12131a19cd5',
          height: 683,
          thumbnail: true,
        },
        location: [47.262572, -1.531378],
        genre: 'Magnolia',
        cultivar: 'Nigra',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531378, 47.262572] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '307d691850e43fbeae5a7f0e876292bac5d0fa32',
      fields: {
        espece: 'macrophylla',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 103, 69, 1.00)',
            'rgba(121, 134, 112, 1.00)',
            'rgba(81, 90, 65, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia macrophylla 'gwavas'/magnolia macrophylla 'gwavas' (2).jpg",
          width: 576,
          id: 'c473dfa23acc7e5ee10ca2aaa6124897',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 145, 93, 1.00)',
            'rgba(117, 144, 80, 1.00)',
            'rgba(97, 115, 64, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia macrophylla 'gwavas'/magnolia macrophylla 'gwavas' (1).jpg",
          width: 576,
          id: '90eca7fcc3a6c8b3f345a8347c1f483d',
          height: 768,
          thumbnail: true,
        },
        location: [47.261772, -1.53323],
        genre: 'Magnolia',
        cultivar: 'Gwavas',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53323, 47.261772] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd313be5e14b422aa2dca522bfaf26e80246a1b3d',
      fields: {
        espece: 'salicifolia',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 65, 56, 1.00)',
            'rgba(142, 136, 120, 1.00)',
            'rgba(73, 65, 45, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia salicifolia 'w.b. clarke'/magnolia salicifolia 'w.b. clarke' (1).jpg",
          width: 531,
          id: '8835cfa78536facf6216b443811d39fe',
          height: 768,
          thumbnail: true,
        },
        location: [47.262178, -1.531433],
        genre: 'Magnolia',
        cultivar: 'W.B. Clarke',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531433, 47.262178] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5d30540a4dba13bf55f4c37b8448980a1fdb368b',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 96, 119, 1.00)',
            'rgba(183, 117, 151, 1.00)',
            'rgba(96, 70, 70, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sprengeri var. diva 'eric savill'/magnolia sprengeri var. diva 'eric savill' (3).jpg",
          width: 576,
          id: 'e0dbbc77b0aeb4d367729241c173f7e5',
          height: 768,
          thumbnail: true,
        },
        espece: 'sprengeri var. diva',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 135, 115, 1.00)',
            'rgba(91, 97, 75, 1.00)',
            'rgba(91, 89, 61, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sprengeri var. diva 'eric savill'/magnolia sprengeri var. diva 'eric savill' (2).jpg",
          width: 1024,
          id: '1e371ab99baf77760901946be5aa686f',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 90, 134, 1.00)',
            'rgba(167, 92, 115, 1.00)',
            'rgba(185, 155, 161, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sprengeri var. diva 'eric savill'/magnolia sprengeri var. diva 'eric savill' (1).jpg",
          width: 576,
          id: 'e94c35d47df964f5880527b17f9c6b73',
          height: 768,
          thumbnail: true,
        },
        location: [47.262563, -1.53035],
        genre: 'Magnolia',
        cultivar: 'Eric Savill',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53035, 47.262563] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8d14be14c31a0aa9ce1b5cd804354dcce8da836d',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 103, 111, 1.00)',
            'rgba(89, 87, 62, 1.00)',
            'rgba(99, 90, 58, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'centennial'/magnolia stellata 'centennial' .jpg",
          width: 1024,
          id: '127a695eb3613f515e965ab5bf74404e',
          height: 683,
          thumbnail: true,
        },
        espece: 'stellata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 100, 101, 1.00)',
            'rgba(112, 109, 95, 1.00)',
            'rgba(74, 76, 51, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'centennial'/magnolia stellata 'centennial'  (2).jpg",
          width: 1024,
          id: '2671ac3a748192498044a41bf7241ec3',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 111, 121, 1.00)',
            'rgba(87, 84, 75, 1.00)',
            'rgba(79, 72, 53, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'centennial'/magnolia stellata 'centennial'  (1).jpg",
          width: 600,
          id: '934b4255b9868ba6c27cc718b7c53690',
          height: 768,
          thumbnail: true,
        },
        location: [47.262625, -1.532203],
        genre: 'Magnolia',
        cultivar: 'Centennial',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532203, 47.262625] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '56d5666676f317df6bb6cef1cd5314b399545540',
      fields: {
        espece: 'stellata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(75, 77, 63, 1.00)',
            'rgba(122, 117, 91, 1.00)',
            'rgba(63, 60, 42, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'royal star'/magnolia stellata 'royal star' (2).jpg",
          width: 576,
          id: 'e0ba85c1c7a74eae28b1acbb2b38ebba',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 170, 183, 1.00)',
            'rgba(113, 109, 78, 1.00)',
            'rgba(97, 88, 48, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'royal star'/magnolia stellata 'royal star' (1).jpg",
          width: 576,
          id: '9de7847544bb43988530f9fb4a30cfe1',
          height: 768,
          thumbnail: true,
        },
        location: [47.262492, -1.528647],
        genre: 'Magnolia',
        cultivar: 'Royal Star',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.528647, 47.262492] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2c25c325db1fb372ac5456511129e80fc1e4d546',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 128, 143, 1.00)',
            'rgba(88, 86, 68, 1.00)',
            'rgba(94, 101, 61, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'rubra'/magnolia stellata 'rubra'.jpg",
          width: 1024,
          id: '9ace24fe004273163cf6cd4db656e17c',
          height: 683,
          thumbnail: true,
        },
        espece: 'stellata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(185, 182, 189, 1.00)',
            'rgba(135, 123, 122, 1.00)',
            'rgba(78, 75, 51, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'rubra'/magnolia stellata 'rubra' (2).jpg",
          width: 1024,
          id: '92f4f2dcac6e93f08d704be4f065746b',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 104, 65, 1.00)',
            'rgba(109, 117, 92, 1.00)',
            'rgba(59, 69, 39, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'rubra'/magnolia stellata 'rubra' (1).jpg",
          width: 1024,
          id: 'ea28d40018cf05f47622900e76752dba',
          height: 683,
          thumbnail: true,
        },
        location: [47.261558, -1.530713],
        genre: 'Magnolia',
        cultivar: 'Rubra',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530713, 47.261558] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '47c6edc2072c79dc0b634c217392b0c1e86eab4c',
      fields: {
        espece: 'x loebneri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 95, 91, 1.00)',
            'rgba(123, 125, 115, 1.00)',
            'rgba(92, 95, 88, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'snowdrift'/magnolia x loebneri 'snowdrift' (2).jpg",
          width: 1024,
          id: '97d2310ca7fd30d31dbc532f2c672665',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 129, 135, 1.00)',
            'rgba(108, 110, 89, 1.00)',
            'rgba(74, 74, 41, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'snowdrift'/magnolia x loebneri 'snowdrift' (1).jpg",
          width: 1024,
          id: 'eecfbf0a224d0c99b49a72008e69f4b8',
          height: 683,
          thumbnail: true,
        },
        location: [47.262597, -1.52907],
        genre: 'Magnolia',
        cultivar: 'Snowdrift',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.52907, 47.262597] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c95731881d47c21944e65c51edd0edcb65c4198c',
      fields: {
        espece: 'x loebneri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(65, 64, 59, 1.00)',
            'rgba(114, 114, 111, 1.00)',
            'rgba(82, 76, 62, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'star bright'/magnolia x loebneri 'star bright' (2).jpg",
          width: 576,
          id: 'ef0f0a8ac21614e6288e544d8ba22347',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 106, 110, 1.00)',
            'rgba(113, 118, 101, 1.00)',
            'rgba(122, 136, 82, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'star bright'/magnolia x loebneri 'star bright' (1).jpg",
          width: 576,
          id: 'fe10a277abad3024278c9b96fc0300d2',
          height: 768,
          thumbnail: true,
        },
        location: [47.262788, -1.531905],
        genre: 'Magnolia',
        cultivar: 'Star Bright',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531905, 47.262788] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '047a41d2d6a4284ce6d5d77d789299fe16555e6d',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'x proctoriana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 171, 169, 1.00)',
            'rgba(126, 124, 101, 1.00)',
            'rgba(91, 78, 53, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia x proctoriana/magnolia x proctoriana (2).jpg',
          width: 576,
          id: 'dcc4ed05e5361a079d06404bc745517d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(202, 199, 202, 1.00)',
            'rgba(124, 122, 106, 1.00)',
            'rgba(86, 80, 44, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia x proctoriana/magnolia x proctoriana (3).jpg',
          width: 576,
          id: '4d967911b139a636db89cc27ae8aea73',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 127, 118, 1.00)',
            'rgba(127, 123, 108, 1.00)',
            'rgba(93, 82, 68, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia x proctoriana/magnolia x proctoriana (1).jpg',
          width: 576,
          id: '3392a0cb2913575597cbeab0fadbcaec',
          height: 768,
          thumbnail: true,
        },
        location: [47.261958, -1.533647],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533647, 47.261958] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3af0f5247f511015090c0067f6c3c1bc6393f58e',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 145, 150, 1.00)',
            'rgba(112, 110, 98, 1.00)',
            'rgba(55, 68, 36, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'alexandrina'/magnolia x soulangeana 'alexandrina'  (3).jpg",
          width: 1024,
          id: '3e16ef5dd7d430d672edb510d5da2e03',
          height: 683,
          thumbnail: true,
        },
        espece: 'x soulangeana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 115, 160, 1.00)',
            'rgba(81, 92, 113, 1.00)',
            'rgba(89, 96, 109, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'alexandrina'/magnolia x soulangeana 'alexandrina'  (2).jpg",
          width: 512,
          id: 'b3231927aade9541ee126d0d979bcf21',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(62, 65, 60, 1.00)',
            'rgba(99, 104, 83, 1.00)',
            'rgba(67, 82, 54, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'alexandrina'/magnolia x soulangeana 'alexandrina'  (1).jpg",
          width: 1024,
          id: '06f511a8a28e54572c0f3abfe388f753',
          height: 683,
          thumbnail: true,
        },
        location: [47.261975, -1.533438],
        genre: 'Magnolia',
        cultivar: 'Alexandrina',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533438, 47.261975] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a01ed1314a386fdf6c2e6d36cb1127f7c0771d19',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(61, 92, 141, 1.00)',
            'rgba(96, 109, 119, 1.00)',
            'rgba(84, 108, 137, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'brozzonii'/magnolia x soulangeana 'brozzonii' (4).jpg",
          width: 512,
          id: 'b07fe342776fb9d1e040e8f2263f3f0a',
          height: 768,
          thumbnail: true,
        },
        espece: 'x soulangeana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 110, 130, 1.00)',
            'rgba(107, 111, 116, 1.00)',
            'rgba(47, 52, 30, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'brozzonii'/magnolia x soulangeana 'brozzonii' (3).jpg",
          width: 1024,
          id: '44c7ffefd9e496c61d20f302be6edc7a',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 147, 188, 1.00)',
            'rgba(123, 127, 121, 1.00)',
            'rgba(50, 57, 28, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'brozzonii'/magnolia x soulangeana 'brozzonii' (1).jpg",
          width: 1024,
          id: '74f2f71aed4740b3fc806294355fd36a',
          height: 683,
          thumbnail: true,
        },
        location: [47.262678, -1.529183],
        genre: 'Magnolia',
        cultivar: 'Brozzonii',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529183, 47.262678] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8cc86ce033274457ed433eb2c5ee97f9ff8b09bc',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 145, 183, 1.00)',
            'rgba(104, 91, 99, 1.00)',
            'rgba(83, 83, 56, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'pickard's ruby'/magnolia x soulangeana 'pickard's ruby' (3).jpg",
          width: 1024,
          id: '5a92ffd523b551a9bd714c50f73e9d7f',
          height: 683,
          thumbnail: true,
        },
        espece: 'x soulangeana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 120, 105, 1.00)',
            'rgba(127, 84, 92, 1.00)',
            'rgba(116, 64, 77, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'pickard's ruby'/magnolia x soulangeana 'pickard's ruby' (2).jpg",
          width: 1024,
          id: '215e9d76ffa57f08cba143a0fa4524be',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 147, 141, 1.00)',
            'rgba(117, 83, 79, 1.00)',
            'rgba(78, 75, 61, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'pickard's ruby'/magnolia x soulangeana 'pickard's ruby' (1).jpg",
          width: 1024,
          id: '57fd92b8b33b418f6b246d3975263c1f',
          height: 683,
          thumbnail: true,
        },
        location: [47.262187, -1.533542],
        genre: 'Magnolia',
        cultivar: "Pickard's Ruby",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533542, 47.262187] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6c53dd681ba38490abf90e375d3036bfc3b461a9',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 139, 170, 1.00)',
            'rgba(137, 114, 134, 1.00)',
            'rgba(89, 69, 59, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'red lucky'/magnolia x soulangeana 'red lucky' (3).jpg",
          width: 1024,
          id: '445f9dfb27bca12042f311f225beb22c',
          height: 683,
          thumbnail: true,
        },
        espece: 'x soulangeana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 152, 169, 1.00)',
            'rgba(95, 92, 67, 1.00)',
            'rgba(102, 115, 54, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'red lucky'/magnolia x soulangeana 'red lucky' (2).jpg",
          width: 1024,
          id: '853a84c287bf36b13b5402efee447cfb',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 135, 163, 1.00)',
            'rgba(125, 103, 109, 1.00)',
            'rgba(98, 82, 65, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'red lucky'/magnolia x soulangeana 'red lucky' (1).jpg",
          width: 1024,
          id: 'dd327b88622b8b5461c24941634b9ba6',
          height: 683,
          thumbnail: true,
        },
        location: [47.2611, -1.5341],
        genre: 'Magnolia',
        cultivar: 'Red Lucky',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5341, 47.2611] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c23169e8c8396ce1967ad6c922b53e0d4dc1e1b4',
      fields: {
        espece: 'x soulangeana',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 134, 144, 1.00)',
            'rgba(90, 75, 72, 1.00)',
            'rgba(75, 87, 51, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia x soulangeana/magnolia x soulangeana (2).jpg',
          width: 1024,
          id: '78d72d9d6deac1f35b16c262e033ed63',
          height: 683,
          thumbnail: true,
        },
        location: [47.262083, -1.53468],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53468, 47.262083] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ec7ac59bdefd74c43b570de18618f2eb34090a18',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'Yellow River (Fei Huang)',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(168, 181, 157, 1.00)',
            'rgba(121, 112, 80, 1.00)',
            'rgba(103, 84, 73, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia yellow river ('fei huang')/magnolia yellow river ('fei huang') (2).jpg",
          width: 576,
          id: '994cabe63c6a2ae2bdff374675af2993',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(64, 75, 49, 1.00)',
            'rgba(130, 142, 96, 1.00)',
            'rgba(83, 98, 33, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia yellow river ('fei huang')/magnolia yellow river ('fei huang') (3).jpg",
          width: 576,
          id: 'f1a3d96835e84fc6a95f10baf2cee4ee',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 77, 70, 1.00)',
            'rgba(121, 119, 94, 1.00)',
            'rgba(65, 84, 23, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia yellow river ('fei huang')/magnolia yellow river ('fei huang') (1).jpg",
          width: 576,
          id: '360467fc19bcdf05d1302885f6626308',
          height: 768,
          thumbnail: true,
        },
        location: [47.262305, -1.530947],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530947, 47.262305] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a5724768202ab7133b2afba923d9ca3f5f5adaae',
      fields: {
        espece: 'azedarach',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 108, 144, 1.00)',
            'rgba(85, 109, 142, 1.00)',
            'rgba(85, 107, 136, 1.00)',
          ],
          filename:
            'ip ville de nantes/melia/melia azedarach/melia azedarach (3).jpg',
          width: 1024,
          id: 'a485a720bd1da97c280256e340c2531e',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 120, 170, 1.00)',
            'rgba(83, 102, 128, 1.00)',
            'rgba(76, 90, 106, 1.00)',
          ],
          filename:
            'ip ville de nantes/melia/melia azedarach/melia azedarach (1).jpg',
          width: 1024,
          id: '2d39f841b8c03100ac39582815d055f8',
          height: 758,
          thumbnail: true,
        },
        genre: 'Melia',
        famille: 'Meliaceae',
      },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0afac3ec2d3f2139270290fd9478b704abfcdfec',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'crassifolius',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 138, 96, 1.00)',
            'rgba(126, 135, 99, 1.00)',
            'rgba(112, 119, 88, 1.00)',
          ],
          filename:
            'ip parc de proce/melicytus/melicytus crassifolius/melicytus crassifolius (2).jpg',
          width: 576,
          id: '6c492170951bcbe0cf70a33617a5cebd',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 117, 72, 1.00)',
            'rgba(121, 143, 82, 1.00)',
            'rgba(93, 105, 64, 1.00)',
          ],
          filename:
            'ip parc de proce/melicytus/melicytus crassifolius/melicytus crassifolius (3).jpg',
          width: 576,
          id: 'e2f0a66a14d40852ecfc14b227413518',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 150, 114, 1.00)',
            'rgba(130, 137, 97, 1.00)',
            'rgba(106, 110, 77, 1.00)',
          ],
          filename:
            'ip parc de proce/melicytus/melicytus crassifolius/melicytus crassifolius (1).jpg',
          width: 1024,
          id: 'c3a1dbac582dc39ebc7cb0630b0e6912',
          height: 768,
          thumbnail: true,
        },
        location: [47.224847, -1.58132],
        genre: 'Melicytus',
        famille: 'Violaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58132, 47.224847] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2269ed1c2a48eb82067e2f95521dee996bcd1a03',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'parviflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 147, 118, 1.00)',
            'rgba(87, 111, 70, 1.00)',
            'rgba(83, 93, 64, 1.00)',
          ],
          filename:
            'ip parc de proce/meliosma/meliosma parviflora/meliosma parviflora (10).jpg',
          width: 1023,
          id: 'f7b89010f4f30240b1088a2dd60df6da',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 152, 107, 1.00)',
            'rgba(106, 120, 83, 1.00)',
            'rgba(66, 69, 41, 1.00)',
          ],
          filename:
            'ip parc de proce/meliosma/meliosma parviflora/meliosma parviflora (2).jpg',
          width: 1024,
          id: '445cb2f250cf202165d33362449b1115',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 149, 105, 1.00)',
            'rgba(97, 118, 75, 1.00)',
            'rgba(87, 130, 71, 1.00)',
          ],
          filename:
            'ip parc de proce/meliosma/meliosma parviflora/meliosma parviflora (1).jpg',
          width: 512,
          id: 'af9b1f8eb47087576e899e7e4b2e3e6f',
          height: 768,
          thumbnail: true,
        },
        location: [47.222903, -1.57985],
        genre: 'Meliosma',
        famille: 'Sabiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.57985, 47.222903] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5c1279c0365c972d1a1b0027d52f5f74346790dd',
      fields: {
        espece: 'sylvatica',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 117, 61, 1.00)',
            'rgba(102, 123, 59, 1.00)',
            'rgba(100, 126, 60, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/nyssa/nyssa sylvatica/nyssa sylvatica.jpg',
          width: 1024,
          id: 'afb76a72d977837eec30387d1c41750f',
          height: 683,
          thumbnail: true,
        },
        location: [47.263375, -1.531613],
        genre: 'Nyssa',
        famille: 'Nyssaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531613, 47.263375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cfed6df5d4b1521b2f15e04dd1b6b73377871d54',
      fields: {
        espece: 'yunnanensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 158, 161, 1.00)',
            'rgba(96, 110, 97, 1.00)',
            'rgba(96, 96, 87, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/osmanthus/osmanthus yunnanensis/osmanthus yunnanensis (2).jpg',
          width: 576,
          id: '153b4660a956704e78184bccd6c985e6',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(51, 59, 53, 1.00)',
            'rgba(102, 109, 91, 1.00)',
            'rgba(66, 79, 70, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/osmanthus/osmanthus yunnanensis/osmanthus yunnanensis (1).jpg',
          width: 576,
          id: '34f638eb117d22d90d72d7ff6c668c6b',
          height: 768,
          thumbnail: true,
        },
        location: [47.22953, -1.511183],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.511183, 47.22953] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3cad824ddec0d232ede710f1d53bd3673cca5a9d',
      fields: {
        espece: 'delavayi',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 152, 156, 1.00)',
            'rgba(86, 86, 50, 1.00)',
            'rgba(64, 62, 36, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/osmanthus/osmanthus delavayi/osmanthus delavayi.jpg',
          width: 1024,
          id: 'c494bcf7e7b119c696a2ffacf651afac',
          height: 683,
          thumbnail: true,
        },
        location: [47.262887, -1.532538],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532538, 47.262887] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8fee61a3a13ec146f5cc1c6d94398106bec09401',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'spina-christi',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 168, 72, 1.00)',
            'rgba(137, 146, 48, 1.00)',
            'rgba(122, 130, 37, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/paliurus/paliurus spina-christi/paliurus spina-christi  (2).jpg',
          width: 576,
          id: 'ba73f94a6734ed4fcdb0fb30b73e0b83',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 149, 44, 1.00)',
            'rgba(122, 138, 46, 1.00)',
            'rgba(115, 123, 77, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/paliurus/paliurus spina-christi/paliurus spina-christi (1).jpg',
          width: 576,
          id: 'deebf406b4dabfedd4fa86ae0f01d2fe',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 172, 127, 1.00)',
            'rgba(119, 139, 53, 1.00)',
            'rgba(135, 139, 77, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/paliurus/paliurus spina-christi/paliurus spina-christi  (1).jpg',
          width: 1024,
          id: '6b39f35e044bf952a29f27cf84d064a6',
          height: 768,
          thumbnail: true,
        },
        location: [47.220505, -1.543917],
        genre: 'Paliurus',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543917, 47.220505] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '944892f9c88bc15a417264ab9f5585f5cc94eb9a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 119, 171, 1.00)',
            'rgba(108, 122, 146, 1.00)',
            'rgba(71, 65, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/parrotia hamamelidaceae/parrotia persica 'vanessa'/parrotia persica 'vanessa' (3).jpg",
          width: 512,
          id: '949dce85aeb76e436e3b506f7e6a5e08',
          height: 768,
          thumbnail: true,
        },
        location: [47.270945, -1.584288],
        genre: 'Parrotia',
        cultivar: 'Vanessa',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584288, 47.270945] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3a69b019afa1b4b64ea4c5e4477166d3cd0b0686',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'coulteri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 142, 201, 1.00)',
            'rgba(88, 112, 125, 1.00)',
            'rgba(74, 91, 92, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/pinus/pinus coulteri/pinus coulteri (6).jpg',
          width: 1024,
          id: 'c7e90b1ddcf87146c900f572e53a26c2',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 110, 109, 1.00)',
            'rgba(102, 107, 113, 1.00)',
            'rgba(106, 117, 137, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/pinus/pinus coulteri/pinus coulteri (7).jpg',
          width: 1024,
          id: '4713c6e7c0dd48f1dd4e77f6fc599f57',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 143, 201, 1.00)',
            'rgba(85, 106, 132, 1.00)',
            'rgba(88, 105, 128, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/pinus/pinus coulteri/pinus coulteri (5).jpg',
          width: 1024,
          id: 'b832ec1314bef1b10bf8d0b919c20a85',
          height: 683,
          thumbnail: true,
        },
        location: [47.262124, -1.53521],
        genre: 'Pinus',
        famille: 'Pinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53521, 47.262124] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b995fbc24514a06a6bad0fcbcb79a755ae429bd9',
      fields: {
        espece: 'lentiscus',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 134, 91, 1.00)',
            'rgba(111, 127, 86, 1.00)',
            'rgba(105, 121, 97, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/pistacia/pistacia lentiscus/pistacia lentiscus.jpg',
          width: 1024,
          id: 'a6898e90225b8e3877946e77da96e2eb',
          height: 683,
          thumbnail: true,
        },
        location: [47.227872, -1.51025],
        genre: 'Pistacia',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.51025, 47.227872] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '600ea041fd0fe397efdf1aa1707b42bef2169872',
      fields: {
        espece: 'salignus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 164, 132, 1.00)',
            'rgba(93, 112, 61, 1.00)',
            'rgba(81, 87, 49, 1.00)',
          ],
          filename:
            'ip parc de proce/podocarpus/podocarpus salignus/podocarpus salignus.jpg',
          width: 824,
          id: '3054004a628d766409240699dee6c231',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 126, 58, 1.00)',
            'rgba(123, 136, 78, 1.00)',
            'rgba(126, 130, 77, 1.00)',
          ],
          filename:
            'ip parc de proce/podocarpus/podocarpus salignus/podocarpus salignus (1).jpg',
          width: 576,
          id: '36f6e7aa7be3d1f89f28a7536754b61a',
          height: 768,
          thumbnail: true,
        },
        location: [47.223275, -1.584487],
        genre: 'Podocarpus',
        famille: 'Podocarpaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584487, 47.223275] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '722fe369053fa04ba352443d767e1ee38366f22f',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'wuana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 118, 41, 1.00)',
            'rgba(116, 145, 57, 1.00)',
            'rgba(127, 123, 80, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/populus/populus wuana/populus wuana (2).jpg',
          width: 576,
          id: 'fef7ee918f959c6b1b14b860bed82069',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 130, 65, 1.00)',
            'rgba(131, 143, 77, 1.00)',
            'rgba(130, 150, 72, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/populus/populus wuana/populus wuana (3).jpg',
          width: 576,
          id: '3377869b81c4b4aced135d85dfcc8e80',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(75, 105, 35, 1.00)',
            'rgba(120, 149, 72, 1.00)',
            'rgba(122, 145, 67, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/populus/populus wuana/populus wuana (1).jpg',
          width: 576,
          id: 'dce45e31cd51b9086feca5a156fbfb2f',
          height: 768,
          thumbnail: true,
        },
        location: [47.218925, -1.541622],
        genre: 'Populus',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541622, 47.218925] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'be2c92ac2e711b5d0dd006fd847c924fa01dac50',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'andina',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 169, 136, 1.00)',
            'rgba(107, 126, 73, 1.00)',
            'rgba(81, 96, 50, 1.00)',
          ],
          filename:
            'ip parc de proce/prumnopitys/prumnopitys andina/prumnopitys andina (2).jpg',
          width: 1024,
          id: 'df80ae4b4fb15b2aadc15078fead82c5',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 116, 42, 1.00)',
            'rgba(108, 123, 50, 1.00)',
            'rgba(125, 141, 69, 1.00)',
          ],
          filename:
            'ip parc de proce/prumnopitys/prumnopitys andina/prumnopitys andina (3).jpg',
          width: 576,
          id: '496a50c611a4cb762d90c99c256e580d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 105, 60, 1.00)',
            'rgba(113, 133, 80, 1.00)',
            'rgba(142, 164, 102, 1.00)',
          ],
          filename:
            'ip parc de proce/prumnopitys/prumnopitys andina/prumnopitys andina (1).jpg',
          width: 576,
          id: '27356b9010e8cef3efe46c090f153715',
          height: 768,
          thumbnail: true,
        },
        location: [47.22282, -1.579197],
        genre: 'Prumnopitys',
        famille: 'Podocarpaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.579197, 47.22282] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fd1324f7356ecacf3b896f901b19e3475d78cf45',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'serrula',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 175, 182, 1.00)',
            'rgba(149, 145, 124, 1.00)',
            'rgba(91, 88, 56, 1.00)',
          ],
          filename:
            'ip parc de proce/prunus/prunus serrula/prunus serrula (2).jpg',
          width: 576,
          id: '614ab42b6949e6b9359cf8f714669e62',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 164, 151, 1.00)',
            'rgba(168, 148, 134, 1.00)',
            'rgba(122, 100, 85, 1.00)',
          ],
          filename:
            'ip parc de proce/prunus/prunus serrula/prunus serrula (3).jpg',
          width: 576,
          id: '586436cb4767de051fbe301d5b6c9ae3',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(180, 156, 144, 1.00)',
            'rgba(128, 109, 95, 1.00)',
            'rgba(75, 61, 57, 1.00)',
          ],
          filename:
            'ip parc de proce/prunus/prunus serrula/prunus serrula (1).jpg',
          width: 576,
          id: '289a0f74133a07b0e2d69f7f67671edd',
          height: 768,
          thumbnail: true,
        },
        location: [47.225263, -1.581003],
        genre: 'Prunus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581003, 47.225263] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '94cc60adb151916c7da042bd1c3be8e8e202daa6',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'hispida',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 149, 69, 1.00)',
            'rgba(117, 157, 62, 1.00)',
            'rgba(54, 89, 13, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/pterostyrax/pterostyrax hispida/pterostyrax hispida (2).jpg',
          width: 576,
          id: '7ef5a92b4b244c3f16991d86ffd27c77',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 164, 82, 1.00)',
            'rgba(110, 143, 66, 1.00)',
            'rgba(82, 119, 33, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/pterostyrax/pterostyrax hispida/pterostyrax hispida (3).jpg',
          width: 576,
          id: '197de6cb4bee23df09d73153ec5583af',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 168, 131, 1.00)',
            'rgba(95, 118, 53, 1.00)',
            'rgba(68, 92, 37, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/pterostyrax/pterostyrax hispida/pterostyrax hispida (1).jpg',
          width: 1024,
          id: '421f71485d82351350c996074cc74f79',
          height: 768,
          thumbnail: true,
        },
        location: [47.219537, -1.543203],
        genre: 'Pterostyrax',
        famille: 'Styracaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543203, 47.219537] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0cb95c12d2990dd4b59fc90bc4564e2d7276ffb6',
      fields: {
        espece: 'palustris',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 136, 132, 1.00)',
            'rgba(134, 107, 101, 1.00)',
            'rgba(109, 72, 41, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus palustris/quercus palustris .jpg',
          width: 576,
          id: 'dbd9c275a2eaa1e96cdc754918a83467',
          height: 768,
          thumbnail: true,
        },
        location: [47.261975, -1.533755],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533755, 47.261975] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2c5188e27c8be9d9908158200eacea1da30bc49c',
      fields: {
        espece: 'rubra',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 167, 105, 1.00)',
            'rgba(116, 112, 52, 1.00)',
            'rgba(50, 53, 28, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/quercus/quercus rubra 'aurea'/quercus rubra 'aurea' (3).jpg",
          width: 1024,
          id: '84b733709684610d4955a87ec6697c90',
          height: 683,
          thumbnail: true,
        },
        location: [47.261767, -1.532908],
        genre: 'Quercus',
        cultivar: 'Aurea',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532908, 47.261767] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '06785e064c3fd5660ff27878d21a373b0ceebc28',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'nakaharai',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 168, 58, 1.00)',
            'rgba(144, 140, 44, 1.00)',
            'rgba(125, 132, 33, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/rhamnus/rhamnus nakaharai/rhamnus nakaharai (2).jpg',
          width: 576,
          id: '78aa6897a1b0b48741a36d7f2886dbce',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 164, 148, 1.00)',
            'rgba(130, 122, 82, 1.00)',
            'rgba(122, 131, 66, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/rhamnus/rhamnus nakaharai/rhamnus nakaharai (3).jpg',
          width: 960,
          id: 'f052c11abfa01577e293ca88d0d04abf',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 151, 43, 1.00)',
            'rgba(126, 144, 25, 1.00)',
            'rgba(129, 132, 50, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/rhamnus/rhamnus nakaharai/rhamnus nakaharai (1).jpg',
          width: 576,
          id: 'ec06cf3fe7728cfa25819b6cb683380e',
          height: 768,
          thumbnail: true,
        },
        location: [47.220455, -1.543908],
        genre: 'Rhamnus',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543908, 47.220455] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6b9627a416df87a056883637b7ceb7b0df64fdcf',
      fields: {
        espece: 'sachalinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 109, 54, 1.00)',
            'rgba(109, 136, 63, 1.00)',
            'rgba(113, 150, 74, 1.00)',
          ],
          filename:
            "ip parc de proce/salix/salix sachalinensis 'golden sunshine'/salix sachalinensis 'golden sunshine'  (3).jpg",
          width: 1024,
          id: 'bee34c42d8427daf8c6c129d3b06dc22',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 111, 36, 1.00)',
            'rgba(114, 152, 42, 1.00)',
            'rgba(95, 128, 36, 1.00)',
          ],
          filename:
            "ip parc de proce/salix/salix sachalinensis 'golden sunshine'/salix sachalinensis 'golden sunshine'  (1).jpg",
          width: 576,
          id: '16c6483568773ff36b34af95f9b67473',
          height: 768,
          thumbnail: true,
        },
        location: [47.222922, -1.584538],
        genre: 'Salix',
        cultivar: 'Golden Sunshine',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584538, 47.222922] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cd1db920240a29c24a144c7ec90a423963dac520',
      fields: {
        espece: 'discolor',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 140, 82, 1.00)',
            'rgba(108, 124, 75, 1.00)',
            'rgba(139, 144, 102, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/salvia/salvia discolor/salvia discolor.jpg',
          width: 838,
          id: 'bdf0e390cf8f62ae245ca791ed44d371',
          height: 768,
          thumbnail: true,
        },
        location: [47.22918, -1.5117],
        genre: 'Salvia',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5117, 47.22918] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '726e960d8a236c6c3441b2cbdf5af03033c7783e',
      fields: {
        espece: 'hookeriana var. digyna',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 117, 96, 1.00)',
            'rgba(119, 119, 90, 1.00)',
            'rgba(119, 126, 95, 1.00)',
          ],
          filename:
            'ip parc de proce/sarcococca/sarcococca hookeriana var. digyna/sarcococca hookeriana var. digyna (2).jpg',
          width: 1024,
          id: '2491e710f4ae0e5ab4af3294e260fef4',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 141, 116, 1.00)',
            'rgba(137, 146, 112, 1.00)',
            'rgba(113, 111, 85, 1.00)',
          ],
          filename:
            'ip parc de proce/sarcococca/sarcococca hookeriana var. digyna/sarcococca hookeriana var. digyna (1).jpg',
          width: 576,
          id: '208142e1f834efb61196b5a74e0618f7',
          height: 768,
          thumbnail: true,
        },
        location: [47.225705, -1.582925],
        genre: 'Sarcococca',
        famille: 'Buxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582925, 47.225705] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4ba8f8d1bfb0ce6d43a5bbc5d792021e57434813',
      fields: {
        espece: 'xylocarpa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 142, 41, 1.00)',
            'rgba(86, 116, 49, 1.00)',
            'rgba(79, 107, 43, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/sinojackia/sinojackia xylocarpa/sinojackia xylocarpa (2).jpg',
          width: 576,
          id: '9e82a2ee1d5083d3bdcdd6d7f29861b9',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 147, 42, 1.00)',
            'rgba(115, 158, 36, 1.00)',
            'rgba(94, 139, 19, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/sinojackia/sinojackia xylocarpa/sinojackia xylocarpa (1).jpg',
          width: 576,
          id: '6e81f09230ce888973bb8c0217c0878e',
          height: 768,
          thumbnail: true,
        },
        location: [47.219592, -1.543062],
        genre: 'Sinojackia',
        famille: 'Styracaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543062, 47.219592] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b3b6a530a4d1a98ec3e6b86414df50c8454febd4',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'thunbergii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 167, 132, 1.00)',
            'rgba(121, 135, 82, 1.00)',
            'rgba(81, 87, 56, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/spiraea/spiraea thunbergii/spiraea thunbergii (2).jpg',
          width: 1024,
          id: '4b0d0dbfc903af9a2d444e84bb5ecde4',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 133, 77, 1.00)',
            'rgba(110, 129, 65, 1.00)',
            'rgba(134, 148, 117, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/spiraea/spiraea thunbergii/spiraea thunbergii (3).jpg',
          width: 576,
          id: '7209d8e12ad7f301a6fafa40b07fa720',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 80, 48, 1.00)',
            'rgba(112, 116, 99, 1.00)',
            'rgba(93, 94, 81, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/spiraea/spiraea thunbergii/spiraea thunbergii (1).jpg',
          width: 576,
          id: '04ac8f42bf8290f8cb11aae13d795331',
          height: 768,
          thumbnail: true,
        },
        location: [47.220705, -1.54288],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54288, 47.220705] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '38de2e663708fe026ac5a937962e33ff8d677ac1',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 109, 151, 1.00)',
            'rgba(107, 142, 198, 1.00)',
            'rgba(133, 156, 182, 1.00)',
          ],
          filename:
            "ip parc de proce/tilia/tilia cordata 'winter orange'/tilia cordata 'winter orange' (3).jpg",
          width: 576,
          id: 'b12d89574a1a8da08bf15acfa11f1b14',
          height: 768,
          thumbnail: true,
        },
        espece: 'cordata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 116, 150, 1.00)',
            'rgba(135, 151, 183, 1.00)',
            'rgba(129, 126, 102, 1.00)',
          ],
          filename:
            "ip parc de proce/tilia/tilia cordata 'winter orange'/tilia cordata 'winter orange' (2).jpg",
          width: 576,
          id: 'a20c55a6ce8d088ab68e334db959a1b2',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 187, 255, 1.00)',
            'rgba(126, 142, 147, 1.00)',
            'rgba(63, 79, 29, 1.00)',
          ],
          filename:
            "ip parc de proce/tilia/tilia cordata 'winter orange'/tilia cordata 'winter orange' (1).jpg",
          width: 576,
          id: 'd534597afecbb5755ff6da9047aedf7c',
          height: 768,
          thumbnail: true,
        },
        location: [47.222958, -1.584075],
        genre: 'Tilia',
        cultivar: 'Winter Orange',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584075, 47.222958] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '06bb3b8befe951c79c99b1ac8fd9958ef5f51e67',
      fields: {
        nom_du_site: 'Autre site',
        espece: 'mongolica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 92, 64, 1.00)',
            'rgba(90, 94, 68, 1.00)',
            'rgba(118, 108, 85, 1.00)',
          ],
          filename:
            'ip ville de nantes/tilia/tilia mongolica/tilia mongolica (2).jpg',
          width: 512,
          id: '34db19af917df40a0b7f590c47998822',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 160, 132, 1.00)',
            'rgba(88, 103, 79, 1.00)',
            'rgba(74, 71, 52, 1.00)',
          ],
          filename:
            'ip ville de nantes/tilia/tilia mongolica/tilia mongolica (5).jpg',
          width: 512,
          id: '53aecebca9cbea32bfdbc10112db7a61',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 92, 66, 1.00)',
            'rgba(94, 112, 82, 1.00)',
            'rgba(110, 122, 96, 1.00)',
          ],
          filename:
            'ip ville de nantes/tilia/tilia mongolica/tilia mongolica (1).jpg',
          width: 1024,
          id: '0fbc177c7dc9ce3c8f1ca32e92115235',
          height: 683,
          thumbnail: true,
        },
        location: [47.193608, -1.532195],
        genre: 'Tilia',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532195, 47.193608] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fae55733d654f64afcacc61cb3a418f531e5e2be',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'sinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 139, 71, 1.00)',
            'rgba(97, 123, 43, 1.00)',
            'rgba(122, 146, 60, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/toona/toona sinensis/toona sinensis  (2).jpg',
          width: 1024,
          id: '372965b764a98e21ce348a398479491e',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 156, 133, 1.00)',
            'rgba(107, 121, 69, 1.00)',
            'rgba(85, 95, 39, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/toona/toona sinensis/toona sinensis  (3).jpg',
          width: 1024,
          id: '2b107a78aca635d1201dd68e6797493c',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 147, 174, 1.00)',
            'rgba(123, 130, 100, 1.00)',
            'rgba(61, 70, 32, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/toona/toona sinensis/toona sinensis  (1).jpg',
          width: 1024,
          id: '8fb0ac45fd0b15614495c0c43785f323',
          height: 768,
          thumbnail: true,
        },
        location: [47.230417, -1.50688],
        genre: 'Toona',
        famille: 'Meliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.50688, 47.230417] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7d121f605f7616a4e5ec9338b7cf173dc97c3782',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 143, 72, 1.00)',
            'rgba(102, 135, 63, 1.00)',
            'rgba(94, 102, 58, 1.00)',
          ],
          filename:
            "ip parc de proce/ulmus/ulmus x hollandica 'smithii'/ulmus x hollandica 'smithii' (3).jpg",
          width: 1024,
          id: 'dfca0b80a72a6b78391e964fd6cd4bac',
          height: 768,
          thumbnail: true,
        },
        espece: 'x hollandica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 145, 127, 1.00)',
            'rgba(102, 109, 61, 1.00)',
            'rgba(107, 107, 61, 1.00)',
          ],
          filename:
            "ip parc de proce/ulmus/ulmus x hollandica 'smithii'/ulmus x hollandica 'smithii' (2).jpg",
          width: 1024,
          id: 'e3103cb21e330f280662945e6fe25fbf',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 123, 62, 1.00)',
            'rgba(145, 157, 70, 1.00)',
            'rgba(110, 109, 59, 1.00)',
          ],
          filename:
            "ip parc de proce/ulmus/ulmus x hollandica 'smithii'/ulmus x hollandica 'smithii' (1).jpg",
          width: 576,
          id: '4aa2b5dfdc3985f5c61b93b9ffa9c7bf',
          height: 768,
          thumbnail: true,
        },
        location: [47.223262, -1.584372],
        genre: 'Ulmus',
        cultivar: 'Smithii',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584372, 47.223262] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7aa19417bc2c667547821b29f9bd7b7bcaa91bcd',
      fields: {
        espece: 'propinquum',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 141, 117, 1.00)',
            'rgba(143, 145, 106, 1.00)',
            'rgba(109, 125, 94, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/viburnum/viburnum propinquum/viburnum propinquum.jpg',
          width: 576,
          id: 'c910ec2d627d937a1767cb936862fc8b',
          height: 768,
          thumbnail: true,
        },
        location: [47.262563, -1.536008],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.536008, 47.262563] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ac72645790016a34b01773a562148b9c9c9e78f0',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 154, 193, 1.00)',
            'rgba(143, 141, 135, 1.00)',
            'rgba(113, 104, 75, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/x sycoparrotia hamamelidaceae/x sycoparrotia semidecidua/x sycoparrotia semidecidua  (3).jpg',
          width: 694,
          id: 'e5da715d7e3e8e037da08207e721d32c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 119, 64, 1.00)',
            'rgba(145, 126, 59, 1.00)',
            'rgba(124, 102, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/x sycoparrotia hamamelidaceae/x sycoparrotia semidecidua/x sycoparrotia semidecidua  (5).jpg',
          width: 1024,
          id: 'e4c103c5b8dbc4ff79004aebc255cb04',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 110, 47, 1.00)',
            'rgba(137, 112, 47, 1.00)',
            'rgba(88, 89, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/x sycoparrotia hamamelidaceae/x sycoparrotia semidecidua/x sycoparrotia semidecidua  (1).jpg',
          width: 576,
          id: 'b112ce115637f446cfeeb76432ef9188',
          height: 768,
          thumbnail: true,
        },
        location: [47.271422, -1.586972],
        genre: 'x Sycoparrotia',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586972, 47.271422] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '51c5c50ef7e25bfba8a294b6cd7a276c9430e1f4',
      fields: {
        espece: 'ailanthoides',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 123, 98, 1.00)',
            'rgba(117, 122, 98, 1.00)',
            'rgba(126, 130, 104, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/zanthoxylum/zanthoxylum ailanthoides/zanthoxylum ailanthoides (1).jpg',
          width: 576,
          id: '74623c1cca2c070f4ca8daf32fd15992',
          height: 768,
          thumbnail: true,
        },
        location: [47.219488, -1.543367],
        genre: 'Zanthoxylum',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543367, 47.219488] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3341bcf3b2baaf2caeef171cb9c1fd666fa28229',
      fields: {
        espece: 'serrata',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 179, 166, 1.00)',
            'rgba(89, 104, 76, 1.00)',
            'rgba(99, 111, 66, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/zelkova/zelkova serrata/zelkova serrata.jpg',
          width: 1024,
          id: '4154f62f4b5ae3c32a50387df9262f0c',
          height: 768,
          thumbnail: true,
        },
        location: [47.229838, -1.507603],
        genre: 'Zelkova',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507603, 47.229838] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e76c052be2b904de8a33334696a73f610dd21d24',
      fields: {
        origine: 'J.B.de Bern,Suisse',
        espece: 'anacampseros L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Sedum',
        date_plantation: '2014',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '26411bd390f0a3d5744bfaf69ddd47582e18f8b1',
      fields: {
        origine: 'JB.Lib\u00e9rec (Tch\u00e8coslovaquie)',
        espece: 'sobolifera Opiz',
        localisation: 'A2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2208871, -1.5444631],
        genre: 'Jovibarba',
        date_plantation: '1998',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444631, 47.2208871] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bcf242b870c0bd9b0c348fc2d3fa1554859f3413',
      fields: {
        origine: 'JBU.Riga (Lettonie)',
        espece: 'hirta Opiz.',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Jovibarba',
        date_plantation: '1998',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e8f4af276e1d554dc1a9f0254d505b18bab574af',
      fields: {
        origine:
          'Remi Legros (graine r\u00e9colt\u00e9e bord de La Loire amont)',
        espece: 'sempervirens',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Cupressus',
        date_plantation: '2014',
        cultivar: 'f. stricta',
        famille: 'Cupressaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '521b8cc5cb085c4e87e5521fb232c701e433b142',
      fields: {
        espece: 'distichum',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 107, 138, 1.00)',
            'rgba(117, 112, 122, 1.00)',
            'rgba(66, 57, 51, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/taxodium [cupressaceae]/taxodium distichum/taxodium distichum.jpg',
          width: 512,
          id: '7d72a413bc0e9430b878f93c5a5ac33f',
          height: 768,
          thumbnail: true,
        },
        location: [47.262083, -1.531075],
        genre: 'Taxodium',
        famille: 'Cupressaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531075, 47.262083] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7780ad43d8734f8e166d1b448ce6ab1368d3da46',
      fields: {
        origine: 'JB.Dijon (France)',
        espece: 'remota L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Carex',
        date_plantation: '2006',
        famille: 'Cyperaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '70242b5bb8a995a6da5724e5bc89886a15a9c21a',
      fields: {
        origine: 'JB.Montr\u00e9al (Canada)',
        espece: 'strigosus L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Cyperus',
        date_plantation: '2006',
        famille: 'Cyperaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '95e9e9343036835a7400e0fbfcc6a67225a33dce',
      fields: {
        origine: 'R\u00e9colte nature (WLG-PF)',
        espece: 'dilatata A. Gray',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Dryopteris',
        date_plantation: '2016',
        famille: 'Dryopteridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '156ad2cfa119c796ff3e30a411e126c1b8c3bb50',
      fields: {
        espece: 'lotus (femelle)',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 164, 152, 1.00)',
            'rgba(104, 103, 65, 1.00)',
            'rgba(54, 52, 25, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/diospyros [ebenaceae]/diospyros lotus (femelle)/diospyros lotus (10).jpg',
          width: 880,
          id: '62fd79e9904ae3aa23e319eb5b8a9ac8',
          height: 768,
          thumbnail: true,
        },
        location: [47.26932, -1.584447],
        genre: 'Diospyros',
        famille: 'Ebenaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584447, 47.26932] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '17d93cd20f12a154a93bd65fc4fbec165664ea18',
      fields: {
        espece: 'x ebbingei',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 152, 101, 1.00)',
            'rgba(134, 109, 49, 1.00)',
            'rgba(105, 93, 27, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/elaeagnus [elaeagnaceae]/elaeagnus x ebbingei 'limelight'/elaeagnus x ebbingei 'limelight'.jpg",
          width: 576,
          id: 'e81cfeecc40b332cdee944e6678a129c',
          height: 768,
          thumbnail: true,
        },
        location: [47.271142, -1.58667],
        genre: 'Elaeagnus',
        cultivar: 'Limelight',
        famille: 'Elaeagnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58667, 47.271142] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c3e7d05d3b124257e2c25cb8f2e7b6eb20e2f996',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Gd Blottereau',
        espece: 'hybridus',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Rhododendron',
        date_plantation: '2014',
        cultivar: 'Simona',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '04cdf47a99f03211e79abd1ff19e01e76db27eb5',
      fields: {
        espece: 'x andrachnoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 110, 65, 1.00)',
            'rgba(90, 106, 64, 1.00)',
            'rgba(104, 106, 77, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus x andrachnoides/arbutus x andrachnoides (7).jpg',
          width: 1024,
          id: '4bf328d041e207b8d38234918b81ac7b',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 146, 127, 1.00)',
            'rgba(89, 98, 65, 1.00)',
            'rgba(83, 87, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus x andrachnoides/arbutus x andrachnoides (21).jpg',
          width: 1024,
          id: '34ee3fdc4942dd81996624289633073a',
          height: 683,
          thumbnail: true,
        },
        location: [47.270445, -1.582437],
        genre: 'Arbutus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582437, 47.270445] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '886386bf5d2afe898ace7bd8b389c07b3143819a',
      fields: {
        espece: 'mucronata',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 110, 66, 1.00)',
            'rgba(112, 121, 93, 1.00)',
            'rgba(89, 78, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/gaultheria [ericaceae]/gaultheria mucronata 'parelmoer'/gaultheria mucronata 'parelmoer'.jpg",
          width: 576,
          id: '8c4b52c42080ff72fd2ad9c45a87b625',
          height: 768,
          thumbnail: true,
        },
        location: [47.271553, -1.582533],
        genre: 'Gaultheria',
        cultivar: 'Parelmoer',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582533, 47.271553] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f4762610ec85bb04ca2093057e1830b000185acf',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 144, 110, 1.00)',
            'rgba(129, 129, 94, 1.00)',
            'rgba(113, 112, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/pieris [ericaceae]/pieris japonica 'little heath'/pieris japonica 'little heath' (3).jpg",
          width: 576,
          id: 'ff9ddf70b33f1497e772af1e31984136',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 157, 123, 1.00)',
            'rgba(110, 121, 67, 1.00)',
            'rgba(114, 115, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/pieris [ericaceae]/pieris japonica 'little heath'/pieris japonica 'little heath' (2).jpg",
          width: 576,
          id: 'e1b27502c10fa7347d7d6bda24dc81bc',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 68, 49, 1.00)',
            'rgba(118, 115, 84, 1.00)',
            'rgba(121, 110, 85, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/pieris [ericaceae]/pieris japonica 'little heath'/pieris japonica 'little heath' (1).jpg",
          width: 1024,
          id: '78582710b8a37a07921944dff9c48a2c',
          height: 768,
          thumbnail: true,
        },
        location: [47.268158, -1.58307],
        genre: 'Pieris',
        cultivar: 'Little Heath',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58307, 47.268158] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ef639cbe7d20123307cba08d7290782b534fd5e5',
      fields: {
        espece: 'hybridus',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Rhododendron',
        date_plantation: '1973',
        cultivar: 'Dr H.C.Dresselhuis',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '37502e70ec46227caef665dc45a6db21246e4b25',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 137, 84, 1.00)',
            'rgba(124, 156, 88, 1.00)',
            'rgba(129, 152, 89, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/escallonia [escalloniaceae]/escallonia 'iveyi'/escallonia 'iveyi' (2).jpg",
          width: 1024,
          id: '929ecc9618541ce3d33aa9cc6c392353',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 85, 50, 1.00)',
            'rgba(113, 123, 96, 1.00)',
            'rgba(67, 76, 46, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/escallonia [escalloniaceae]/escallonia 'iveyi'/escallonia 'iveyi' (1).jpg",
          width: 576,
          id: '938a50d6d1351ac37f2bc20d3589710b',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Escallonia',
        cultivar: 'Iveyi',
        famille: 'Escalloniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1dbf51e80c86ca5e3d3c565a419ecd291da81247',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'ulmoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 103, 42, 1.00)',
            'rgba(107, 144, 72, 1.00)',
            'rgba(93, 128, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/eucommia [eucommiaceae]/eucommia ulmoides/eucommia ulmoides (2).jpg',
          width: 576,
          id: '550b77543a9c1c42457ef6873c0a04bb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 97, 101, 1.00)',
            'rgba(106, 131, 74, 1.00)',
            'rgba(68, 75, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/eucommia [eucommiaceae]/eucommia ulmoides/eucommia ulmoides (caoutchouc).jpg',
          width: 595,
          id: '9cddfe5ab33588dc547983b9ce01cf30',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 130, 53, 1.00)',
            'rgba(107, 157, 67, 1.00)',
            'rgba(85, 131, 34, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/eucommia [eucommiaceae]/eucommia ulmoides/eucommia ulmoides (1).jpg',
          width: 576,
          id: 'e0799550e569f0d2951c7a89e089cc41',
          height: 768,
          thumbnail: true,
        },
        location: [47.270355, -1.582187],
        genre: 'Eucommia',
        famille: 'Eucommiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582187, 47.270355] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4e4c7b361ce73539c9658073cd32be9b02d0fe8a',
      fields: {
        origine:
          "JB de Universit\u00e9 de  Gent - origine sauvage connue\u00a0:  l'Encumeada (1007 m) - Mad\u00e8re",
        espece: 'mellifera',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Euphorbia',
        date_plantation: '2008',
        famille: 'Euphorbiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f602abe731ae3d3bdf410cc6e0a059473093efb3',
      fields: {
        origine: 'JB Vintimille (IT)',
        espece: 'dendroides',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Euphorbia',
        date_plantation: '2013',
        famille: 'Euphorbiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e437dfe4573f497136272ecf3fc227512b9dd25d',
      fields: {
        origine: 'J.Alp.Meyrin (Suisse)',
        espece: 'sagittalis L.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Genista',
        date_plantation: '1999',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f6199b42829791d9120efe332a7271992769215c',
      fields: {
        origine: 'JB.Siena (Italie)',
        espece: 'rectum Ser.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Dorycnium',
        date_plantation: '2008',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9879d3fed45479952fed32de218fabf511853717',
      fields: {
        origine: 'JB.Siena (Italie)',
        espece: 'pentaphyllum Scop.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Dorycnium',
        date_plantation: '2008',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'db7d668500fe2e5016aa4b3acea564b3f627ba3d',
      fields: {
        origine: 'Sichtungsgartens Hermannshof Bielefeld (All.)',
        espece: 'candida Willd.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Dalea',
        date_plantation: '2014',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '17bb0a999077581f8a4d72d7646548c2ff04515e',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'siliqua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 134, 73, 1.00)',
            'rgba(99, 137, 72, 1.00)',
            'rgba(74, 107, 42, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/ceratonia [fabaceae]/ceratonia siliqua/ceratonia siliqua (3).jpg",
          width: 576,
          id: '43b1bdf54cf90d9daf6a288699ec78ac',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 160, 114, 1.00)',
            'rgba(131, 141, 100, 1.00)',
            'rgba(105, 133, 78, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/ceratonia [fabaceae]/ceratonia siliqua/ceratonia siliqua (4).jpg",
          width: 576,
          id: 'f1d962cf270c8501b72232f933a8ea53',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 153, 92, 1.00)',
            'rgba(94, 127, 64, 1.00)',
            'rgba(88, 123, 56, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/ceratonia [fabaceae]/ceratonia siliqua/ceratonia siliqua (2).jpg",
          width: 576,
          id: '3273e0c837e2efbc90324cb7af81ef06',
          height: 768,
          thumbnail: true,
        },
        location: [47.22688, -1.512788],
        genre: 'Ceratonia',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512788, 47.22688] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5015a1f14232e6645c2dc9300f45a8306c921a5f',
      fields: {
        espece: 'engleriana',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(219, 219, 219, 1.00)',
            'rgba(124, 114, 92, 1.00)',
            'rgba(77, 68, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus engleriana/fagus engleriana (23).jpg',
          width: 1024,
          id: '076da39c90063d5ae0e7cadcef1b692c',
          height: 683,
          thumbnail: true,
        },
        location: [47.270625, -1.581872],
        genre: 'Fagus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581872, 47.270625] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '08b05328e639d3d9d17bdb368c5b71825bdef83a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'sylvatica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 129, 69, 1.00)',
            'rgba(115, 133, 69, 1.00)',
            'rgba(86, 93, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus sylvatica/fagus sylvatica (2).jpg',
          width: 576,
          id: 'f7e73071f292a0eb5c13abf37dea05b1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 149, 101, 1.00)',
            'rgba(125, 149, 82, 1.00)',
            'rgba(81, 90, 36, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus sylvatica/fagus sylvatica (3).jpg',
          width: 576,
          id: 'ed59d5ca06e776861dd039acfe70693a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 120, 65, 1.00)',
            'rgba(113, 140, 88, 1.00)',
            'rgba(109, 120, 70, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus sylvatica/fagus sylvatica (1).jpg',
          width: 576,
          id: 'a37233d5321cdd3a69ea3bb6ec902362',
          height: 768,
          thumbnail: true,
        },
        location: [47.269825, -1.584197],
        genre: 'Fagus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584197, 47.269825] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c59e1e7e1a590d35452ff6ff7c3a05138da74668',
      fields: {
        espece: 'edulis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 144, 77, 1.00)',
            'rgba(124, 138, 62, 1.00)',
            'rgba(96, 109, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lithocarpus [fagaceae]/lithocarpus edulis/lithocarpus edulis .jpg',
          width: 576,
          id: '33b0ae476553c95d6ed5e736615b494e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 126, 79, 1.00)',
            'rgba(115, 143, 57, 1.00)',
            'rgba(111, 133, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lithocarpus [fagaceae]/lithocarpus edulis/lithocarpus edulis (2).jpg',
          width: 576,
          id: 'b07440531747a3f17210472a43e9f63b',
          height: 768,
          thumbnail: true,
        },
        location: [47.271417, -1.582003],
        genre: 'Lithocarpus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582003, 47.271417] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3c4e79c9cf41f49e98049800770e055cc8191ed9',
      fields: {
        espece: 'ithaburensis subsp. macrolepsis',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 119, 110, 1.00)',
            'rgba(123, 114, 103, 1.00)',
            'rgba(106, 102, 96, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus ithaburensis subsp. macrolepsis/quercus ithaburensis subsp. macrolepsis.jpg',
          width: 576,
          id: 'cdbcb7392ae663b44a41a9aa45f01a76',
          height: 768,
          thumbnail: true,
        },
        location: [47.27158, -1.584845],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584845, 47.27158] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5a8e6aeb3bbfc023c3388ea7d1f5a38613ad9f0f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'leucotrichophora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 135, 136, 1.00)',
            'rgba(97, 112, 104, 1.00)',
            'rgba(119, 117, 103, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus leucotrichophora/quercus leucotrichophora (2).jpg',
          width: 576,
          id: 'cc9aa667a9f522cffd69ab6966ef1904',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 116, 115, 1.00)',
            'rgba(125, 121, 111, 1.00)',
            'rgba(101, 102, 91, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus leucotrichophora/quercus leucotrichophora (3).jpg',
          width: 576,
          id: 'a4255d8c89a64a76afec1238af428744',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 110, 111, 1.00)',
            'rgba(122, 119, 113, 1.00)',
            'rgba(108, 101, 97, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus leucotrichophora/quercus leucotrichophora (1).jpg',
          width: 576,
          id: '6c727db76cc3fc6e62ddd253f590baeb',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '684a94ba1453c70e14c7d3c3938261e523d7eab1',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'obtusa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 125, 114, 1.00)',
            'rgba(107, 127, 100, 1.00)',
            'rgba(110, 119, 98, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus obtusa/quercus obtusa (11).jpg',
          width: 576,
          id: '607f7039d39c8c73788d6e03955cc481',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 167, 215, 1.00)',
            'rgba(146, 145, 120, 1.00)',
            'rgba(60, 60, 28, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus obtusa/quercus obtusa (4).jpg',
          width: 576,
          id: 'db45b65d8fd135a3ce2f14b205508292',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 118, 105, 1.00)',
            'rgba(118, 124, 105, 1.00)',
            'rgba(116, 122, 105, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus obtusa/quercus obtusa (10).jpg',
          width: 576,
          id: '8bd4830fbc34fc49f6d2144c6878b458',
          height: 768,
          thumbnail: true,
        },
        location: [47.270695, -1.586375],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586375, 47.270695] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e751660b5302c3a174583cf8389132f0f08241c8',
      fields: {
        espece: 'robur',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 110, 20, 1.00)',
            'rgba(92, 93, 17, 1.00)',
            'rgba(74, 77, 13, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/quercus [fagaceae]/quercus robur 'concordia'/quercus robur 'concordia' (2).jpg",
          width: 1024,
          id: '14b69243012c26e959c3f0f1941f3265',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(178, 181, 23, 1.00)',
            'rgba(175, 176, 23, 1.00)',
            'rgba(104, 109, 22, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/quercus [fagaceae]/quercus robur 'concordia'/quercus robur 'concordia' (1).jpg",
          width: 642,
          id: '62530fa4936903771ade661c50738a04',
          height: 768,
          thumbnail: true,
        },
        location: [47.270656, -1.586239],
        genre: 'Quercus',
        cultivar: 'Concordia',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586239, 47.270656] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e7d380e6112f1424e8005201dc2e17c8e1590520',
      fields: {
        espece: 'variabilis',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 87, 99, 1.00)',
            'rgba(106, 95, 103, 1.00)',
            'rgba(102, 100, 122, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus variabilis/quercus variabilis (5).jpg',
          width: 512,
          id: '22190114a11a8529bf6c1f19126b7312',
          height: 768,
          thumbnail: true,
        },
        location: [47.270012, -1.584657],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584657, 47.270012] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c988a157b1466f0f4c64c581ff2f815c35e2c465',
      fields: {
        origine: 'Station de rech. plt.M\u00e9dici Tsukuba-Shi Ibaraki (Japon)',
        espece: 'polycarpa',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Idesia',
        date_plantation: '1998',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7c4f72bf89c05c211056de3859b4cc6170da0fc4',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 166, 133, 1.00)',
            'rgba(118, 132, 70, 1.00)',
            'rgba(103, 96, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/aucuba [garryaceae]/aucuba japonica 'longifolia'/aucuba japonica 'longifolia' (3).jpg",
          width: 576,
          id: '05cdf4a8a2dea9942d975dfb783e902f',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 147, 97, 1.00)',
            'rgba(133, 139, 93, 1.00)',
            'rgba(128, 129, 100, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/aucuba [garryaceae]/aucuba japonica 'longifolia'/aucuba japonica 'longifolia' (2).jpg",
          width: 576,
          id: 'c6e7c8027eb1b0f89c532794bce29ba9',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 130, 60, 1.00)',
            'rgba(120, 139, 71, 1.00)',
            'rgba(147, 139, 117, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/aucuba [garryaceae]/aucuba japonica 'longifolia'/aucuba japonica 'longifolia' (1).jpg",
          width: 576,
          id: '56e844b127a6ac87caff8459ecae20b3',
          height: 768,
          thumbnail: true,
        },
        location: [47.27137, -1.581847],
        genre: 'Aucuba',
        cultivar: 'Longifolia',
        famille: 'Garryaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581847, 47.27137] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '341e3589ff7fcb6e366b3e904e04fa35fe299315',
      fields: {
        origine: 'Centre Medicinal Plant,Tsukuba,Japon',
        espece: 'japonicum Maxim.',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Tripterospermum',
        date_plantation: '2014',
        famille: 'Gentianaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '85be082ef7612559ebdbb81d1fc265563056e96f',
      fields: {
        origine: 'J.Alp."Viott\u00e9" Trento (Italie)',
        espece: 'tiberica King ex Hook.f',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Gentiana',
        date_plantation: '2006',
        famille: 'Gentianaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '311a42ffec04075fc523ec6b6737897ca26f064d',
      fields: {
        origine: 'J.Alp.Graz (Autriche)',
        espece: 'clusii Perrier & Songeon',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Gentiana',
        date_plantation: '2006',
        famille: 'Gentianaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8df47e3b381be07c630d8e963a0bdbf0a6351ca7',
      fields: {
        origine: 'JB.Rotterdam',
        espece: 'kurro Royle',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Gentiana',
        date_plantation: '1990',
        famille: 'Gentianaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd89424ea3de8acd77c2dd0dce964f5b585dfdc80',
      fields: {
        origine: 'JB.Royal Zoological (Rotterdam)',
        espece: 'moorcroftiana Wall.; G. Don',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Gentiana',
        date_plantation: '1990',
        famille: 'Gentianaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '92458dbaadced25ce20716daee33123da1b73e40',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes 71290 La Gen\u00eate',
        espece: 'tibetica King',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Gentiana',
        date_plantation: '2015',
        famille: 'Gentianaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9153384dd8e7c42250eeaaedbaf0c2b3a56a6c4f',
      fields: {
        origine: 'INRA',
        espece: 'manescavi Cosson',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Erodium',
        date_plantation: '1989',
        famille: 'Geraniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4ca4671628bdd543b2dafa4e4f0bda8dd4a8b732',
      fields: {
        origine: "R\u00e9serve Bowman's Hill (U.S.A.)",
        espece: 'maculatum L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Geranium',
        date_plantation: '1992',
        famille: 'Geraniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bff3a9fdd15536dd31dd14da9af9c9ff709175ab',
      fields: {
        espece: 'macrorrhizum L.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Geranium',
        date_plantation: '1973',
        famille: 'Geraniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cade89d1883f37110fcc26a54dbe60938a001e33',
      fields: {
        espece: 'sanguineum L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Geranium',
        date_plantation: '1973',
        famille: 'Geraniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5a37a4c7c70c9cedaafc1a17ab2505ffdcdc1021',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 134, 50, 1.00)',
            'rgba(137, 145, 46, 1.00)',
            'rgba(123, 118, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ginkgo [ginkgoaceae]/ginkgo biloba 'pendula'/ginkgo biloba 'pendula' (3).jpg",
          width: 1024,
          id: '09d04a04acfe9a5d6394758ceb37f5e9',
          height: 768,
          thumbnail: true,
        },
        espece: 'biloba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 128, 46, 1.00)',
            'rgba(115, 129, 63, 1.00)',
            'rgba(80, 89, 46, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ginkgo [ginkgoaceae]/ginkgo biloba 'pendula'/ginkgo biloba 'pendula' (2).jpg",
          width: 576,
          id: 'abc80e4a4487a98c74fc7551c44b0f79',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 121, 28, 1.00)',
            'rgba(155, 119, 21, 1.00)',
            'rgba(127, 96, 24, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ginkgo [ginkgoaceae]/ginkgo biloba 'pendula'/ginkgo biloba 'pendula' (1).jpg",
          width: 576,
          id: '683a6246eb9fa2201c3337137df055c5',
          height: 768,
          thumbnail: true,
        },
        location: [47.270888, -1.581012],
        genre: 'Ginkgo',
        cultivar: 'Pendula',
        famille: 'Ginkgoaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581012, 47.270888] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6cb35b1e2dd42e95df62efbe7947615676d691ba',
      fields: {
        espece: 'biloba',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(180, 194, 196, 1.00)',
            'rgba(134, 128, 87, 1.00)',
            'rgba(86, 91, 30, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/ginkgo [ginkgoaceae]/ginkgo biloba/ginkgo biloba.jpg',
          width: 880,
          id: 'dcdb875e245ea0a48c13ae58a8b5c7e8',
          height: 768,
          thumbnail: true,
        },
        location: [47.261995, -1.529972],
        genre: 'Ginkgo',
        famille: 'Ginkgoaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529972, 47.261995] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dcff96785df38560d1b404f9a2b0acff0edfbad7',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'persica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(193, 186, 177, 1.00)',
            'rgba(125, 107, 52, 1.00)',
            'rgba(75, 77, 32, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/parrotia [hamamelidaceae]/parrotia persica/parrotia persica (2).jpg',
          width: 1024,
          id: '51c26a9a7b51c1afd6f38e985ea3eda6',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 154, 112, 1.00)',
            'rgba(111, 115, 78, 1.00)',
            'rgba(114, 126, 93, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/parrotia [hamamelidaceae]/parrotia persica/parrotia persica (3).jpg',
          width: 576,
          id: 'abe0624867b6bf7f18d81b2753cabec4',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(178, 116, 84, 1.00)',
            'rgba(170, 100, 61, 1.00)',
            'rgba(148, 89, 33, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/parrotia [hamamelidaceae]/parrotia persica/parrotia persica (1).jpg',
          width: 576,
          id: 'b2620f04f3a06223abcc4421fe716121',
          height: 768,
          thumbnail: true,
        },
        location: [47.261937, -1.535542],
        genre: 'Parrotia',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535542, 47.261937] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd4f5a57c66a0f1c21b8d1563c110af917a0e289e',
      fields: {
        origine: 'Les Ponts de C\u00e9_p\u00e9pini\u00e8re Lepage',
        espece: 'palmata Yatabe',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Kirengeshoma',
        date_plantation: '2016',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '19b0195d0e9106883753642a75d382acb12f470c',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale  du Grand Blottereau',
        espece: 'peruviana',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Hydrangea',
        date_plantation: '2014',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7b7bc56bae8c4d818bc5ae2710967fdf1afe0110',
      fields: {
        espece: 'quercifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 143, 69, 1.00)',
            'rgba(105, 140, 54, 1.00)',
            'rgba(119, 135, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hydrangea [hydrangeaceae]/hydrangea quercifolia 'ice crystal'/hydrangea quercifolia 'ice crystal' (2).jpg",
          width: 576,
          id: 'c70ea84c514e3e09317811620740a5cd',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(50, 60, 30, 1.00)',
            'rgba(121, 121, 85, 1.00)',
            'rgba(88, 95, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hydrangea [hydrangeaceae]/hydrangea quercifolia 'ice crystal'/hydrangea quercifolia 'ice crystal' (1).jpg",
          width: 576,
          id: 'd6dcd2986833105fad44756a20f43dab',
          height: 768,
          thumbnail: true,
        },
        location: [47.271083, -1.582345],
        genre: 'Hydrangea',
        cultivar: 'Ice Crystal',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582345, 47.271083] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6343f0d45f4fad91400d17590437239656fa1abe',
      fields: {
        espece: 'coronarius',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Philadelphus',
        date_plantation: '1990',
        cultivar: 'Aureus',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4e9d6d657c506a4e691cb141be47dd6e0503a4d2',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 136, 108, 1.00)',
            'rgba(105, 124, 79, 1.00)',
            'rgba(83, 103, 42, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'minnesota snowflake'/philadelphus 'minnesota snowflake'.jpg",
          width: 576,
          id: 'f732b0bf5735e6afe63c9e50532d06cc',
          height: 768,
          thumbnail: true,
        },
        location: [47.27123, -1.586187],
        genre: 'Philadelphus',
        cultivar: 'Minnesota Snowflake',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586187, 47.27123] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '09fbb0b15b46ff7efc111d2e1c68a511a714197f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'coronarius',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 140, 53, 1.00)',
            'rgba(109, 157, 44, 1.00)',
            'rgba(99, 134, 39, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus coronarius/philadelphus coronarius (4).jpg',
          width: 576,
          id: '90b9c5e7ef08c406483c301f11060d6a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 131, 70, 1.00)',
            'rgba(122, 136, 82, 1.00)',
            'rgba(69, 88, 30, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus coronarius/philadelphus coronarius (5).jpg',
          width: 576,
          id: '606686e4a4c9b70396e482e11dfa42dd',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 125, 58, 1.00)',
            'rgba(102, 134, 50, 1.00)',
            'rgba(130, 149, 97, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus coronarius/philadelphus coronarius (3).jpg',
          width: 1024,
          id: 'e65dbffe58686225f1dd1a94aacd2fda',
          height: 768,
          thumbnail: true,
        },
        location: [47.27073, -1.582387],
        genre: 'Philadelphus',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582387, 47.27073] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5bbd622214e990f3e1510f6904b0f95e351088d5',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'satsumi',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 84, 31, 1.00)',
            'rgba(125, 137, 82, 1.00)',
            'rgba(103, 118, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus satsumi/philadelphus satsumi (2).jpg',
          width: 576,
          id: 'd422256ce23b712732f376a8b31985c4',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 114, 42, 1.00)',
            'rgba(143, 160, 55, 1.00)',
            'rgba(133, 154, 40, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus satsumi/philadelphus satsumi (3).jpg',
          width: 576,
          id: 'bb3433b266eb4585f729d6eca02cceea',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 116, 77, 1.00)',
            'rgba(106, 122, 56, 1.00)',
            'rgba(137, 136, 84, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus satsumi/philadelphus satsumi (1).jpg',
          width: 576,
          id: 'fe8f14ac38c2d7c3b0f4f8c132f407d7',
          height: 768,
          thumbnail: true,
        },
        location: [47.269917, -1.582205],
        genre: 'Philadelphus',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582205, 47.269917] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9af1f8ccd8577d82adfc3f67e4d19503d7a6ab6c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'subcanus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 161, 95, 1.00)',
            'rgba(101, 122, 64, 1.00)',
            'rgba(95, 110, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus subcanus/philadelphus subcanus (2).jpg',
          width: 1024,
          id: '0f7e82c0fbe03f164c83f1e0faacf0cc',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 129, 74, 1.00)',
            'rgba(144, 145, 96, 1.00)',
            'rgba(94, 105, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus subcanus/philadelphus subcanus (3).jpg',
          width: 576,
          id: '10e5e736809a0d74a7fececdcd1aaf0f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 116, 67, 1.00)',
            'rgba(129, 139, 90, 1.00)',
            'rgba(126, 129, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus subcanus/philadelphus subcanus (1).jpg',
          width: 1024,
          id: '0b31523089d1238124dec467077ff9bb',
          height: 768,
          thumbnail: true,
        },
        location: [47.271472, -1.581788],
        genre: 'Philadelphus',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581788, 47.271472] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e0061a3288a6657f82eabc0c0b4bb61f1d0ec108',
      fields: {
        origine: 'B.G. Rostock (All.)',
        espece: 'ecklonii Baker',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Aristea',
        date_plantation: '2014',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5dac9a1d4f5be5489c384a35061b293565800f36',
      fields: {
        origine: 'Botanischer universite de Bay okologisk garten - Bayreuth',
        espece: 'palustris Gaudin',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Gladiolus',
        date_plantation: '2010',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '667de4861fc32ba099f525f0345accb46ddf1ce7',
      fields: {
        origine: 'J.B. Zurich (Suisse)',
        espece: 'ixioides Spreng.',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Libertia',
        date_plantation: '2011',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4fd30d35fcaa3ac5e4ae99e9c89e7d3f38f1c898',
      fields: {
        origine: 'JB. Zagreb (Croatie)',
        espece: 'bermudiana L.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Sisyrinchium',
        date_plantation: '2011',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4997599768ae663b77ac7209ff40e3eb7cf14aa8',
      fields: {
        origine: 'JB.Montr\u00e9al (Canada)',
        espece: 'setosa Pall.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Iris',
        date_plantation: '2006',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8da318482d971fe775b4d47aa3708ae7ca049223',
      fields: {
        origine: 'JBU.Berkeley (USA)',
        espece: 'douglasiana Herb.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Iris',
        date_plantation: '1984',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '22c827aefb4dead092339c2140efacf3d8f0d3f8',
      fields: {
        origine: 'Palmen Garten,Frankfurt,All.',
        espece: 'bulleyana Dykes',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Iris',
        date_plantation: '2012',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '674a0b8aee184a710ea67f27aa37b6ea981504ef',
      fields: {
        espece: 'californicum Dryand.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Sisyrinchium',
        date_plantation: '1973',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f70e8ab5a0c5e288bac4b868fa060770f669523a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'fraxinifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 139, 95, 1.00)',
            'rgba(96, 147, 85, 1.00)',
            'rgba(94, 146, 70, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pterocarya [juglandaceae]/pterocarya fraxinifolia/pterocarya fraxinifolia (2).jpg',
          width: 576,
          id: '06d80fefbf26c9c02608cb45a6027f1c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 149, 105, 1.00)',
            'rgba(103, 133, 81, 1.00)',
            'rgba(77, 104, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pterocarya [juglandaceae]/pterocarya fraxinifolia/pterocarya fraxinifolia (3).jpg',
          width: 576,
          id: '38f3ed5daf356d4aa92041ac86c0bd1a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 124, 70, 1.00)',
            'rgba(111, 160, 93, 1.00)',
            'rgba(103, 144, 86, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pterocarya [juglandaceae]/pterocarya fraxinifolia/pterocarya fraxinifolia (1).jpg',
          width: 1024,
          id: '86aed12c92da417dd31354d02f4ccbf9',
          height: 768,
          thumbnail: true,
        },
        location: [47.2683, -1.583367],
        genre: 'Pterocarya',
        famille: 'Juglandaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583367, 47.2683] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '74db32dd1adb0ece08fca4803344c05e5cb16f11',
      fields: {
        origine: 'B.G. Rostock (All.)',
        espece: 'virginiana Benth.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Physostegia',
        date_plantation: '2014',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e1acb9f8516be511258ff81a88889daed8041f71',
      fields: {
        origine: 'Emmanuel LEPAGE',
        espece: 'abrotanoides Kar.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Perovskia',
        date_plantation: '2015',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7d22b45c4d3d33a226bdfa6ea2bc76fb97bd66bd',
      fields: {
        origine: 'J.B. Graz (Autriche)',
        espece: 'alpina L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Stachys',
        date_plantation: '2011',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '35c2af2db4c00b7419ef6faf887460ba098b17ca',
      fields: {
        origine: 'JB.Nice (France)',
        espece: 'anisodonta Boiss.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Phlomis',
        date_plantation: '2003',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e2e67f294a08cc123085073928f2193047ad5324',
      fields: {
        origine: 'JB.Tallinn (Estonie)',
        espece: 'reichenbachiana Fisch. & Mey.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Nepeta',
        date_plantation: '1990',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '29bcbb9523f73bd29f2434f0f0910a2aac493a67',
      fields: {
        origine: 'origine perdue,culture enclo bota pour AO',
        espece: 'przewalskii Maxim.',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Salvia',
        date_plantation: '2014',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '285016aa94edbc7feeb751e475345d4be1d04511',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes 71290 La Gen\u00eate',
        espece: 'nubicola Wall.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Salvia',
        date_plantation: '2015',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7aa854de13220fc725ec785edcfd5815b7507575',
      fields: {
        origine:
          'Remi Legros (bouture r\u00e9colt\u00e9e jardini\u00e8re mairie Sorini\u00e8res)',
        espece: 'officinalis',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Rosmarinus',
        date_plantation: '2014',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '639d44b3840223ea2eaf48987bb355dfe6d54fb0',
      fields: {
        espece: 'dichotoma',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 167, 114, 1.00)',
            'rgba(99, 120, 52, 1.00)',
            'rgba(118, 131, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/callicarpa [lamiaceae]/callicarpa dichotoma 'issai'/callicarpa dichotoma 'issai'  (4).jpg",
          width: 576,
          id: 'f6a075a82f71cf4bb876ca35c8e791c9',
          height: 768,
          thumbnail: true,
        },
        location: [47.270887, -1.585012],
        genre: 'Callicarpa',
        cultivar: 'Issai',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585012, 47.270887] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7420198b6a679aff275430cc34bf3b265ea7b9b4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'dichotoma f. albifructa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 145, 74, 1.00)',
            'rgba(105, 143, 56, 1.00)',
            'rgba(115, 133, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/callicarpa [lamiaceae]/callicarpa dichotoma f. albifructa/callicarpa dichotoma f. albifructa (2).jpg',
          width: 576,
          id: '1cff6df450e8d713bcd31543c5a18455',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 166, 162, 1.00)',
            'rgba(100, 111, 84, 1.00)',
            'rgba(59, 61, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/callicarpa [lamiaceae]/callicarpa dichotoma f. albifructa/callicarpa dichotoma f. albifructa (3).jpg',
          width: 576,
          id: '4b36a07016d2b4b0063ac197ea444003',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 140, 59, 1.00)',
            'rgba(111, 134, 62, 1.00)',
            'rgba(88, 115, 37, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/callicarpa [lamiaceae]/callicarpa dichotoma f. albifructa/callicarpa dichotoma f. albifructa (1).jpg',
          width: 576,
          id: '5556eeff778eb09940006fa34973e641',
          height: 768,
          thumbnail: true,
        },
        location: [47.270778, -1.585267],
        genre: 'Callicarpa',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585267, 47.270778] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2e862963e9a295185f08813e067405150c97d08a',
      fields: {
        origine: 'JBU.Chiba Matsudo (Japon)',
        espece: 'hexaphylla',
        localisation: 'A11',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2211256, -1.5428042],
        genre: 'Stauntonia',
        date_plantation: '1994',
        famille: 'Lardizabalaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428042, 47.2211256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3eee8a603a2cbda86beecdf6852d8576f072a7d8',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'americana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 128, 94, 1.00)',
            'rgba(127, 139, 109, 1.00)',
            'rgba(138, 141, 115, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/persea [lauraceae]/persea americana/persea americana (2).jpg",
          width: 576,
          id: '42aa79c62317e186da8fce11f33b6561',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 152, 107, 1.00)',
            'rgba(88, 106, 59, 1.00)',
            'rgba(84, 87, 50, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/persea [lauraceae]/persea americana/persea americana.jpg",
          width: 576,
          id: '7e3e8984e8106e471e8b684a050cb491',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 131, 74, 1.00)',
            'rgba(103, 151, 90, 1.00)',
            'rgba(119, 129, 97, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/persea [lauraceae]/persea americana/persea americana (1).jpg",
          width: 576,
          id: '6a27651466ba4250efb85c9bab8b19f7',
          height: 768,
          thumbnail: true,
        },
        location: [47.226805, -1.512397],
        genre: 'Persea',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512397, 47.226805] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b5fab03a22dad9de851c9b148e5baaf38e80e883',
      fields: {
        origine: 'Jardin botanique Karls Franzens universit\u00e9 de Graz',
        espece: 'martagon L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Lilium',
        date_plantation: '2010',
        famille: 'Liliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b475b6ca500e12e2afa846429bd61a3f175572ae',
      fields: {
        origine: "Serres d'agronomie tropicale du Grand Blottereau",
        espece: 'granatum',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Punica',
        date_plantation: '2016',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bfe17e83c82bfbbf99c79c10f57c7ba01cf65d53',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'salicifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 176, 113, 1.00)',
            'rgba(98, 132, 62, 1.00)',
            'rgba(69, 85, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/heimia [lythraceae]/heimia salicifolia/heimia salicifolia  (2).jpg',
          width: 1024,
          id: '62adc4b51455a9a52a1af1ac66dc02cc',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(69, 100, 46, 1.00)',
            'rgba(82, 107, 38, 1.00)',
            'rgba(53, 86, 32, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/heimia [lythraceae]/heimia salicifolia/heimia salicifolia  (3).jpg',
          width: 1024,
          id: 'acc27c177ffd74e291aa90253cc9e8b1',
          height: 712,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 141, 80, 1.00)',
            'rgba(106, 133, 71, 1.00)',
            'rgba(75, 106, 49, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/heimia [lythraceae]/heimia salicifolia/heimia salicifolia  (1).jpg',
          width: 1024,
          id: '320cd3fd0c9e2d5ff72d52e79fbdf805',
          height: 683,
          thumbnail: true,
        },
        location: [47.271042, -1.582938],
        genre: 'Heimia',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582938, 47.271042] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e25ace41f1bda800cef119842502103528a475d5',
      fields: {
        espece: 'granatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 133, 42, 1.00)',
            'rgba(120, 107, 20, 1.00)',
            'rgba(86, 104, 17, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/punica [lythraceae]/punica granatum 'chico'/punica granatum 'chico' (2).jpg",
          width: 576,
          id: 'ae7f6cb1266cb8172107a69c92c50901',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 103, 40, 1.00)',
            'rgba(128, 139, 48, 1.00)',
            'rgba(131, 130, 82, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/punica [lythraceae]/punica granatum 'chico'/punica granatum 'chico' (1).jpg",
          width: 1024,
          id: '8d46b2782a3b0630ca88876b6e0e8a30',
          height: 768,
          thumbnail: true,
        },
        location: [47.27167, -1.587155],
        genre: 'Punica',
        cultivar: 'Chico',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587155, 47.27167] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bc34ea795f1bc03ffbafcbd21297d047b17c2ae9',
      fields: {
        espece: 'granatum',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(56, 64, 15, 1.00)',
            'rgba(124, 88, 43, 1.00)',
            'rgba(106, 116, 43, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/punica [lythraceae]/punica granatum 'legrelliae'/punica granatum 'legrelliae'.jpg",
          width: 576,
          id: '890db47bc2f70af139e1e79bd6d2e20e',
          height: 768,
          thumbnail: true,
        },
        location: [47.2705, -1.580967],
        genre: 'Punica',
        cultivar: 'Legrelliae',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580967, 47.2705] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2b7b8ea577c4d7073e6334fdc2483210bff34b4a',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Grand Blottereau',
        espece: 'tulipifera',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Liriodendron',
        date_plantation: '2009',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '15d292338594ac7e64bbba57d3351f3aed7494f8',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Grand Blottereau',
        espece: 'x brooklynensis',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Magnolia',
        date_plantation: '2015',
        cultivar: 'Susan?',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '151c25cfadfdeb49f631b74c70427518d0b00451',
      fields: {
        espece: 'tulipifera',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(61, 96, 159, 1.00)',
            'rgba(93, 115, 152, 1.00)',
            'rgba(75, 78, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/liriodendron [magnoliaceae]/liriodendron tulipifera/liriodendron tulipifera.jpg',
          width: 512,
          id: '45c105b7f1cbe7b07e31ff2e2e5609ba',
          height: 768,
          thumbnail: true,
        },
        location: [47.270858, -1.585478],
        genre: 'Liriodendron',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585478, 47.270858] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '31903d2c4fa25d991598f3c6ce2d54d6120a5f5e',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 106, 98, 1.00)',
            'rgba(157, 112, 135, 1.00)',
            'rgba(149, 117, 129, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'heaven scent'/magnolia 'heaven scent' (4).jpg",
          width: 576,
          id: 'c0824dae73ca2abfa8879fb2691f8c6b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 85, 66, 1.00)',
            'rgba(130, 120, 109, 1.00)',
            'rgba(151, 136, 123, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'heaven scent'/magnolia 'heaven scent' (3).jpg",
          width: 657,
          id: 'b7a2d28a4613c956d5c4ee955e6956e1',
          height: 768,
          thumbnail: true,
        },
        location: [47.269694, -1.581656],
        genre: 'Magnolia',
        cultivar: 'Heaven Scent',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581656, 47.269694] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '62bcf3a31fe639815eb726c08310ec5f7a81d1b9',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'kobus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 112, 108, 1.00)',
            'rgba(122, 118, 106, 1.00)',
            'rgba(106, 108, 93, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia kobus/magnolia kobus (2).jpg',
          width: 576,
          id: '81424ecb0f7fa67cccec54d0545ac0a2',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 158, 135, 1.00)',
            'rgba(125, 117, 85, 1.00)',
            'rgba(82, 88, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia kobus/magnolia kobus (3).jpg',
          width: 735,
          id: 'a92b94cfdc20842d84097f089b37e82b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 107, 88, 1.00)',
            'rgba(109, 109, 101, 1.00)',
            'rgba(72, 75, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia kobus/magnolia kobus (1).jpg',
          width: 576,
          id: '62a6abf55b0bffa4f7e7dd30921dceb8',
          height: 768,
          thumbnail: true,
        },
        location: [47.269812, -1.584545],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584545, 47.269812] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '384f009a6266403887c40ad6bcb384fab773cb14',
      fields: {
        espece: 'stellata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 119, 111, 1.00)',
            'rgba(133, 133, 122, 1.00)',
            'rgba(91, 90, 79, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia stellata/magnolia stellata (2).jpg',
          width: 576,
          id: '477ae62c834c37768b6f631d46f94604',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(204, 209, 220, 1.00)',
            'rgba(121, 120, 104, 1.00)',
            'rgba(69, 65, 36, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia stellata/magnolia stellata (1).jpg',
          width: 1024,
          id: '90f9c32d203553af8af6e3eb6778df18',
          height: 768,
          thumbnail: true,
        },
        location: [47.269842, -1.584412],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584412, 47.269842] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '28167cc8432c6649fb2176ac121cba1437670101',
      fields: {
        espece: 'x loebneri',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 138, 136, 1.00)',
            'rgba(164, 159, 154, 1.00)',
            'rgba(136, 132, 132, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia x loebneri 'dwarf nr. 1'/magnolia x loebneri 'dwarf nr. 1' (1).jpg",
          width: 576,
          id: 'dfa45fc315875aab827b8a87aa24382a',
          height: 768,
          thumbnail: true,
        },
        location: [47.271542, -1.581975],
        genre: 'Magnolia',
        cultivar: 'Dwarf Nr. 1',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581975, 47.271542] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6442ecf9a21f56da671d5c336f85ea165fd419c0',
      fields: {
        origine: 'JB.Kyoto (Japon)',
        espece: 'simplex',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Firmiana',
        date_plantation: '2002',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ba0bf418fb31aada8b17855daadea4b40bdd3ad8',
      fields: {
        espece: 'papyrifera',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 138, 105, 1.00)',
            'rgba(175, 150, 114, 1.00)',
            'rgba(192, 163, 125, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/broussonetia [moraceae]/broussonetia papyrifera/broussonetia papyrifera (fleur male).jpg',
          width: 576,
          id: '8f6380a540a75c8da193e668e4f65ada',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Broussonetia',
        famille: 'Moraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd2dd4e8a71b6b5963a107e2ccbe24f994bca917f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'pensylvanica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 173, 144, 1.00)',
            'rgba(117, 141, 98, 1.00)',
            'rgba(57, 75, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/myrica [myricaceae]/myrica pensylvanica/myrica pensylvanica (2).jpg',
          width: 576,
          id: '445e24fcc78e99143680f60a45ded2d5',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 136, 73, 1.00)',
            'rgba(135, 140, 75, 1.00)',
            'rgba(119, 125, 75, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/myrica [myricaceae]/myrica pensylvanica/myrica pensylvanica (3).jpg',
          width: 576,
          id: 'eba7db16fc185f34d1db5444ccbf2742',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 157, 115, 1.00)',
            'rgba(104, 126, 98, 1.00)',
            'rgba(72, 77, 70, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/myrica [myricaceae]/myrica pensylvanica/myrica pensylvanica (1).jpg',
          width: 576,
          id: 'cb5ed0c455f1f81493bc04cd1a88f2e4',
          height: 768,
          thumbnail: true,
        },
        location: [47.269687, -1.581828],
        genre: 'Myrica',
        famille: 'Myricaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581828, 47.269687] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e1abf3e3b32e3fe504856fcb275048ad9f4a0369',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'sellowiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 145, 112, 1.00)',
            'rgba(102, 128, 77, 1.00)',
            'rgba(106, 132, 80, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acca [myrtaceae]/acca sellowiana/acca sellowiana (2).jpg',
          width: 576,
          id: 'ec27de6545eee7870a0213defd45c375',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 130, 113, 1.00)',
            'rgba(101, 114, 93, 1.00)',
            'rgba(54, 66, 48, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acca [myrtaceae]/acca sellowiana/acca sellowiana (4).jpg',
          width: 576,
          id: '17bc4b6f8e561dc024ce2d1244b2c5c9',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 82, 50, 1.00)',
            'rgba(118, 100, 86, 1.00)',
            'rgba(48, 67, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acca [myrtaceae]/acca sellowiana/acca sellowiana (1).jpg',
          width: 576,
          id: 'dcd3f6be111df271eb82962f9151cb69',
          height: 768,
          thumbnail: true,
        },
        location: [47.271263, -1.587187],
        genre: 'Acca',
        famille: 'Myrtaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587187, 47.271263] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b3276e97bdd91bb0f3772c010f7b2dc9c0d342b4',
      fields: {
        espece: 'involucrata var. vilmoriniana',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(205, 215, 183, 1.00)',
            'rgba(101, 118, 66, 1.00)',
            'rgba(49, 58, 27, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/davidia [nyssaceae]/davidia involucrata var. vilmoriniana/davidia involucrata var. vilmoriniana  (2).jpg',
          width: 925,
          id: '7039eff8460384c66bd087850899f767',
          height: 768,
          thumbnail: true,
        },
        location: [47.271297, -1.581608],
        genre: 'Davidia',
        famille: 'Nyssaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581608, 47.271297] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9f16683a2fdba3df7f2792946b5460154809f98b',
      fields: {
        origine: 'P\u00e9pini\u00e8res Arven - Ploullan (29)',
        espece: 'azoricum',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Jasminum',
        date_plantation: '2014',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '10b50b232ac4c00fa66982e5645353ff6f7a445e',
      fields: {
        espece: 'retusus',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 140, 126, 1.00)',
            'rgba(81, 90, 103, 1.00)',
            'rgba(51, 49, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chionanthus [oleaceae]/chionanthus retusus/chionanthus retusus (13).jpg',
          width: 914,
          id: '0b1ae860fbc5c057230584638a1475fc',
          height: 768,
          thumbnail: true,
        },
        location: [47.26953, -1.584905],
        genre: 'Chionanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584905, 47.26953] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ec5ec0220895564e887da1501290e1f9362b47bb',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 166, 124, 1.00)',
            'rgba(120, 137, 82, 1.00)',
            'rgba(93, 105, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus heterophyllus 'goshiki'/osmanthus heterophyllus 'goshiki' (3).jpg",
          width: 576,
          id: 'f860c87310eb9b9a3c4279fbebcea1a6',
          height: 768,
          thumbnail: true,
        },
        espece: 'heterophyllus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 110, 83, 1.00)',
            'rgba(90, 105, 78, 1.00)',
            'rgba(76, 90, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus heterophyllus 'goshiki'/osmanthus heterophyllus 'goshiki' (2).jpg",
          width: 576,
          id: '53ef09d821bec334b815863ce193a3de',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 99, 86, 1.00)',
            'rgba(103, 123, 85, 1.00)',
            'rgba(81, 98, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus heterophyllus 'goshiki'/osmanthus heterophyllus 'goshiki' (1).jpg",
          width: 576,
          id: '3a61a0e5b7f859ca67dd98e26bd42b1c',
          height: 768,
          thumbnail: true,
        },
        location: [47.271588, -1.5847],
        genre: 'Osmanthus',
        cultivar: 'Goshiki',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5847, 47.271588] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a96ed3bdd1f47dc6f42ed04fc29d8b117598e761',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'reticulata ssp. amurensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(174, 187, 164, 1.00)',
            'rgba(102, 120, 78, 1.00)',
            'rgba(53, 69, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/syringa [oleaceae]/syringa reticulata ssp. amurensis/syringa reticulata ssp. amurensis  (10).jpg',
          width: 1024,
          id: '4f8d1a2d603a7714af589e8eb89b090f',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 133, 129, 1.00)',
            'rgba(118, 107, 97, 1.00)',
            'rgba(101, 94, 82, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/syringa [oleaceae]/syringa reticulata ssp. amurensis/syringa reticulata ssp. amurensis  (2).jpg',
          width: 576,
          id: '4262dc088c14defd328cdf9357972124',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 192, 180, 1.00)',
            'rgba(95, 110, 74, 1.00)',
            'rgba(91, 104, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/syringa [oleaceae]/syringa reticulata ssp. amurensis/syringa reticulata ssp. amurensis  (1).jpg',
          width: 1024,
          id: '5dd429d0aa4cf43463ce1edfd84f7f8d',
          height: 768,
          thumbnail: true,
        },
        location: [47.270547, -1.583972],
        genre: 'Syringa',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583972, 47.270547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5b44f49ec9eb4fd6fd35510cefd3877d4c18e034',
      fields: {
        origine: 'Botanischer Garten Bielefeld, Bielefeld, Allemagne',
        espece: 'macrocarpa Nutt.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Oenothera',
        date_plantation: '2012',
        famille: 'Onagraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8328cc739a4c4e98909661d3fd47ce8f7168e297',
      fields: {
        origine: 'J.Alp.Graz (Autriche)',
        espece: 'dodonaei Vill.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Epilobium',
        date_plantation: '2001',
        famille: 'Onagraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '15296706c7c45145a7b92d7640b4939c323e1445',
      fields: {
        origine: "jardins d'\u00e9coute s'il pleut",
        espece: 'orientalis Trevis.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Matteuccia',
        date_plantation: '2015',
        famille: 'Onocleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd3090814f9cfb1947ee385a0d689c8ba9a6ddddb',
      fields: {
        origine: 'JB. Sofia       (Bulgarie)',
        espece: 'peregrina Mill.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Paeonia',
        date_plantation: '2010',
        famille: 'Paeoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '928bbddae6d3b1d9b14ff3082cd0e29e0f5b5772',
      fields: {
        origine: 'Knutsford (Angletere)',
        espece: 'lutea  Delavay',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Paeonia',
        date_plantation: '2008',
        famille: 'Paeoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e39010fd506f84b260f2a9dfe97a588fa2e96d99',
      fields: {
        origine: 'Mr.Bonnet (Suisse)',
        espece: 'caucasica  Schipcz.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Paeonia',
        date_plantation: '2008',
        famille: 'Paeoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '95abda91d4023bbd96c28348c39e9643da69a8d9',
      fields: {
        origine: 'JBU.Riga (Lettonie)',
        espece: 'nudicaule L.',
        localisation: 'A9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2212566, -1.5434775],
        genre: 'Papaver',
        date_plantation: '1990',
        famille: 'Papaveraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5434775, 47.2212566] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f400fb2ae1c8cb01d500ea0cf9808957357b31f5',
      fields: {
        origine: "P\u00e9pini\u00e8re Val d'Erdre",
        espece: 'tomentosa',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Paulownia',
        date_plantation: '2017',
        famille: 'Paulowniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9065df36586344e3c5d9a49f83e8465231cd58f0',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'tomentosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 88, 35, 1.00)',
            'rgba(110, 109, 56, 1.00)',
            'rgba(107, 114, 86, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/paulownia [paulowniaceae]/paulownia tomentosa/paulownia tomentosa (2).jpg',
          width: 576,
          id: '953e3ac1ee5108f3965ddc9488dc139a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 153, 183, 1.00)',
            'rgba(132, 125, 138, 1.00)',
            'rgba(115, 117, 118, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/paulownia [paulowniaceae]/paulownia tomentosa/paulownia tomentosa (3).jpg',
          width: 576,
          id: '56e44445b004bb2d029d6a1be66f3d30',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 176, 137, 1.00)',
            'rgba(99, 114, 56, 1.00)',
            'rgba(55, 69, 23, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/paulownia [paulowniaceae]/paulownia tomentosa/paulownia tomentosa (1).jpg',
          width: 551,
          id: '55a7922b3675c5d0f52f773f53f55141',
          height: 768,
          thumbnail: true,
        },
        location: [47.271103, -1.585562],
        genre: 'Paulownia',
        famille: 'Paulowniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585562, 47.271103] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b33f7a183a8fe5e90c9370a8a2df2cea13962cf1',
      fields: {
        espece: 'sylvestris',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 156, 127, 1.00)',
            'rgba(108, 110, 64, 1.00)',
            'rgba(99, 92, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/pinus [pinaceae]/pinus sylvestris 'fastigiata'/pinus sylvestris 'fastigiata' (2).jpg",
          width: 512,
          id: '508995e61ba78b399dda2c81d74b376c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 113, 77, 1.00)',
            'rgba(111, 102, 69, 1.00)',
            'rgba(108, 92, 67, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/pinus [pinaceae]/pinus sylvestris 'fastigiata'/pinus sylvestris 'fastigiata' (1).jpg",
          width: 1024,
          id: '986ceafac09837d7e67112d68a90e472',
          height: 683,
          thumbnail: true,
        },
        location: [47.270745, -1.581267],
        genre: 'Pinus',
        cultivar: 'Fastigiata',
        famille: 'Pinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581267, 47.270745] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4deb63d4ac05f0818e34f80c97facc66c4e64f2a',
      fields: {
        origine: 'J.Alp.Paradisia Cogne (Italie)',
        espece: 'prostrata L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Veronica',
        date_plantation: '1992',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '392c3d408bdec497b571613abf950ea7068eeda1',
      fields: {
        origine: 'J.Alp.U.Insbruck (Autriche)',
        espece: 'prostrata L.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Veronica',
        date_plantation: '2006',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6d0a1108b83890019ef9587c3bc701df704fac13',
      fields: {
        origine: 'Jardin botanique alpin Chanousia',
        espece: 'urticifolia Jacq.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Veronica',
        date_plantation: '2010',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'caa7e0960f95f393eab9372314520c63ace9dbbf',
      fields: {
        origine: 'JB. Di Siena, Siena (Italie)',
        espece: 'lutea L.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Digitalis',
        date_plantation: '2011',
        cultivar: 'australis Arc.',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '37b4a1d596d616f92869ec8a47d2f7aae8b4d1c9',
      fields: {
        origine: 'JB.Clermont-Ferrand (France)',
        espece: 'ambigua Murr.= grandiflora Miller',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Digitalis',
        date_plantation: '2009',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '76dce92e32764829922c9be9a22cd765c59d6331',
      fields: {
        origine: "JB.de l'acad\u00e9mie des Sciences de Vacratot (Hongrie)",
        espece: 'punctata L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Globularia',
        date_plantation: '2006',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f59a8c323403f5ac31cd5b870747d294988fdb9b',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'viridifolia',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Digitalis',
        date_plantation: '2006',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8060fb5dbc73b46d0e5b16dcd114211767883f42',
      fields: {
        origine: 'JB.Ibaraki (Japon)',
        espece: 'asiatica  L.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Plantago',
        date_plantation: '2008',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4b45d7f6a17af560d5caf46825c19654d3755ff1',
      fields: {
        origine: 'JB.Royal Zoological (Rotterdam)',
        espece: 'minor L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Digitalis',
        date_plantation: '1990',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd3f5625dfa1d9f4884dd146922957305f8c4dc3f',
      fields: {
        origine: 'P.F\u00e9rard  - nature Pyr\u00e9n\u00e9es',
        espece: 'nudicaulis L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Globularia',
        date_plantation: '2014',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '47eddd2b8644148f50cae77c15faa725de59054f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'orientalis var. insularis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 111, 151, 1.00)',
            'rgba(115, 129, 153, 1.00)',
            'rgba(78, 78, 71, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/platanus [platanaceae]/platanus orientalis var. insularis/platanus orientalis var. insularis (10).jpg',
          width: 512,
          id: '8c496683a14d35639f334d93d0835d4c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 127, 108, 1.00)',
            'rgba(132, 139, 96, 1.00)',
            'rgba(102, 103, 74, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/platanus [platanaceae]/platanus orientalis var. insularis/platanus orientalis var. insularis (11).jpg',
          width: 576,
          id: '99a8bf11e3546240fb2417a12b0d269d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 142, 125, 1.00)',
            'rgba(133, 143, 83, 1.00)',
            'rgba(110, 110, 81, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/platanus [platanaceae]/platanus orientalis var. insularis/platanus orientalis var. insularis (1).jpg',
          width: 576,
          id: '24fe82fd61fe119afb0c6d33cefe1678',
          height: 768,
          thumbnail: true,
        },
        location: [47.270617, -1.582095],
        genre: 'Platanus',
        famille: 'Platanaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582095, 47.270617] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '47fa31921ed2cecfb50817a4618cc00eb3270f58',
      fields: {
        origine: 'JB.Zagreb (Croatie)',
        espece: 'anfractum Salmon',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Limonium',
        date_plantation: '2006',
        famille: 'Plumbaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4e41ae8e9a8606b8b2d678843c4b72f616b1260a',
      fields: {
        origine: 'Real Jardin Botanico Juan Carlos, Alcala de Henares, Espagne',
        espece: 'toletanum Erben',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Limonium',
        famille: 'Plumbaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '77bae577923061bd9e10dbe195bb72b524ea9c1e',
      fields: {
        origine: 'JB.Rostov ad Donum (Russie)',
        espece: 'lessingiana Trin.& Rupr.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Stipa',
        date_plantation: '2009',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '51539478c66a44ef1a42fc9ec9bd1a9a0ed3b793',
      fields: {
        origine: 'JB.W.J Beal Michigan (USA.)',
        espece: 'gerardii Vitman',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Andropogon',
        date_plantation: '2008',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'caac149a3818d6b2d823ebc3c5c910c5de47e7b0',
      fields: {
        origine: 'JBU.Berlin Dahlem (Allemagne)',
        espece: 'media L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Briza',
        date_plantation: '2003',
        cultivar: 'media',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b53f688f939ab31565bcf9960eccfdd0a40ab6fc',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'andina',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 151, 62, 1.00)',
            'rgba(98, 126, 50, 1.00)',
            'rgba(104, 123, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/prumnopitys [podocarpaceae]/prumnopitys andina/prumnopitys andina (2).jpg',
          width: 576,
          id: '69c1b7ab5eaafaf79d3a449597419e3e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 136, 94, 1.00)',
            'rgba(119, 133, 81, 1.00)',
            'rgba(95, 108, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/prumnopitys [podocarpaceae]/prumnopitys andina/prumnopitys andina.jpg',
          width: 576,
          id: '77cff698d7a66836cd437d623c05e4cc',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 92, 27, 1.00)',
            'rgba(117, 125, 41, 1.00)',
            'rgba(101, 111, 37, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/prumnopitys [podocarpaceae]/prumnopitys andina/prumnopitys andina (1).jpg',
          width: 576,
          id: 'd16debec6670830e6dabec46993e77c3',
          height: 768,
          thumbnail: true,
        },
        location: [47.270375, -1.580972],
        genre: 'Prumnopitys',
        famille: 'Podocarpaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580972, 47.270375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9a0f1aa773c0f723917ac8eadd00b7bda652d3eb',
      fields: {
        origine: 'JB.The Hiroshima "Sacki-Ku (Japon)',
        espece: 'filiforme Roberty & Vautier',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Antenoron',
        date_plantation: '2006',
        famille: 'Polygonaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '47eb8a1ac58d5c7c98e89903e9611ed8299bc73c',
      fields: {
        origine: 'J.Alp.Paradisia Cogne (Italie)',
        espece: 'foetidum L.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Thalictrum',
        date_plantation: '1989',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '79ef0fa6dd315d2e9ff9e931b4dca03f88ce03bd',
      fields: {
        origine: 'JB.Framingham (USA)',
        espece: 'canadensis L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Aquilegia',
        date_plantation: '1988',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '62ba8a5c5b9bcf480d94e6d648adbd0a80ef692e',
      fields: {
        origine: 'JBU.Berlin Dahlem (Allemagne)',
        espece: 'minus L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Thalictrum',
        date_plantation: '2003',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '851e2815f8b15c83afb69b4d0fecae262d4d816b',
      fields: {
        origine: 'JBU.Siena (Italie)',
        espece: 'foetidus L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Helleborus',
        date_plantation: '2004',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a1e956e73a577eb763cc16fe3815d34bbf17154c',
      fields: {
        origine: 'Les Ponts de C\u00e9_p\u00e9pini\u00e8re Lepage',
        espece: 'carmichaelii Debeaux.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Aconitum',
        date_plantation: '2016',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '34772bca7324e8984f88b203d4873b2b880784c7',
      fields: {
        origine: 'origine perdue,culture enclo bota pour AO',
        espece: 'saximontana Rydb.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Aquilegia',
        date_plantation: '2014',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4bf8eafe740db89e4c3ad02c4e3dbe576011a05e',
      fields: {
        origine: 'R\u00e9colte nature (WLG-PF)',
        espece: 'flammula L.',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Ranunculus',
        date_plantation: '2016',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8659fc43e7b29a7cf682b39889eaa7c79d1cdb36',
      fields: {
        origine: 'JB.Hiroshima (Japon)',
        espece: 'flabellata Siebold & zucc',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Aquilegia',
        date_plantation: '1998',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '95446c3a21d4bb6f7120d9927f1ca0eb6f7e6e30',
      fields: {
        origine: 'Arboretum univ. Seoul',
        espece: 'yoshinoi',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Rhamnus',
        date_plantation: '2014',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5ac4a780f96dc3632a6e680e9b0232b511ca6eb8',
      fields: {
        origine: 'JB Tharandt (DE)',
        espece: 'caroliniana',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Rhamnus',
        date_plantation: '2017',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '26ded43051221761383e5047a43a58b96a512317',
      fields: {
        origine: 'B.G. Stuttgart (All.)',
        espece: 'buchananii Hook.F.',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Acaena',
        date_plantation: '2012',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c4b805549dc0b5e0d874b477e503697aec80dba0',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'X margaritae',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '17618526bb9f159663aaf7cf4f43be9df168d02e',
      fields: {
        origine: 'Hotus Botanicus Amsterdam,Pays Bas',
        espece: 'pallida Allan',
        localisation: 'I2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185657, -1.5426599],
        genre: 'Acaena',
        date_plantation: '2014',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426599, 47.2185657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5de715ec3be99171245e6c31e432d01ec2e7d364',
      fields: {
        origine: 'JB.Akureyri (Islande)',
        espece: 'rivale L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Geum',
        date_plantation: '2009',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fd525abd1d72904b66606e475c721779b8419b01',
      fields: {
        origine: 'JB.Bern (Suisse)',
        espece: 'rupestris L.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Potentilla',
        date_plantation: '2006',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a4f57c449dd1dc3ad2358f61788cf6397ca7cff0',
      fields: {
        origine: 'JBU.Martin - Luther Halle (Allemagne)',
        espece: 'neumanniana Reichb.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Potentilla',
        date_plantation: '1993',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '53b9c50904065dd689775e1c3d461cf11bea8753',
      fields: {
        origine: 'P\u00e9pini\u00e8re de s Avettes',
        espece: 'japonica',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2018',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '971beeb2a112f1d89edee441f3e3f2255ecde871',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes 71290 La Gen\u00eate',
        espece: 'dioicus Fernald',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Aruncus',
        date_plantation: '2015',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'aa639effbd588456acdcb9c4802bf7ae0b1748c8',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 110, 96, 1.00)',
            'rgba(122, 119, 80, 1.00)',
            'rgba(114, 113, 98, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'comtesse de paris'/malus 'comtesse de paris' (1).jpg",
          width: 576,
          id: 'e81d817c87851be93bffc13854acf63f',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Malus',
        cultivar: 'Comtesse de Paris',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dd5c07f48512fedee344905d992c0afb6df61e30',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 124, 84, 1.00)',
            'rgba(119, 126, 74, 1.00)',
            'rgba(83, 98, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'gabrielle bellion'/malus 'gabrielle bellion' (3).jpg",
          width: 576,
          id: 'a83091a21cb396a8a475f1d406f54559',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Malus',
        cultivar: 'Gabrielle Bellion',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c98482b769320a9660054583c7f4ee2887aad306',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 192, 165, 1.00)',
            'rgba(104, 117, 69, 1.00)',
            'rgba(94, 92, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'lancelot'/malus 'lancelot' (2).jpg",
          width: 576,
          id: '07e41f2f9641aef6632e30fbaaa3555a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 84, 50, 1.00)',
            'rgba(128, 140, 112, 1.00)',
            'rgba(114, 121, 99, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'lancelot'/malus 'lancelot' (3).jpg",
          width: 576,
          id: 'abf8d428e2b5aa46dacc9b202dd44aa3',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 142, 87, 1.00)',
            'rgba(119, 147, 75, 1.00)',
            'rgba(110, 125, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'lancelot'/malus 'lancelot' (1).jpg",
          width: 576,
          id: '084adfab215569884401bd1cc3f675f7',
          height: 768,
          thumbnail: true,
        },
        location: [47.270075, -1.58583],
        genre: 'Malus',
        cultivar: 'Lancelot',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58583, 47.270075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '86b0fa9456eb5d666e9c922b05766aee43a28b56',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'affinis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 161, 93, 1.00)',
            'rgba(123, 131, 77, 1.00)',
            'rgba(99, 113, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/neillia [rosaceae]/neillia affinis/neillia affinis (2).jpg',
          width: 1024,
          id: '2f9359f31005c0abfba543e0a984d2fd',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 140, 74, 1.00)',
            'rgba(151, 153, 85, 1.00)',
            'rgba(114, 123, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/neillia [rosaceae]/neillia affinis/neillia affinis (3).jpg',
          width: 576,
          id: '29b31cd4a18ff9b68e3b7ea3278e0867',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 118, 55, 1.00)',
            'rgba(124, 148, 72, 1.00)',
            'rgba(110, 132, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/neillia [rosaceae]/neillia affinis/neillia affinis (1).jpg',
          width: 576,
          id: 'ab4b2044977278f74ba8af2708ca51ce',
          height: 768,
          thumbnail: true,
        },
        location: [47.271192, -1.582505],
        genre: 'Neillia',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582505, 47.271192] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9ba3c0a4cbbc4d9646a73792de4d89077e53c032',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 141, 195, 1.00)',
            'rgba(117, 120, 121, 1.00)',
            'rgba(68, 66, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'tai-haku'/prunus 'tai-haku' (11).jpg",
          width: 1024,
          id: '79dd027a4e05c359582b033eb30b9d1e',
          height: 683,
          thumbnail: true,
        },
        location: [47.270705, -1.58403],
        genre: 'Prunus',
        cultivar: 'Tai-haku',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58403, 47.270705] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2ec021804b7460c37ad0a6dd5632e4a67b3695f7',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 106, 86, 1.00)',
            'rgba(107, 79, 47, 1.00)',
            'rgba(80, 68, 36, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'tai-haku'/prunus 'tai-haku' (13).jpg",
          width: 1024,
          id: '777c09c61d37775eeea55739510e65a7',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 92, 94, 1.00)',
            'rgba(115, 71, 46, 1.00)',
            'rgba(81, 66, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'tai-haku'/prunus 'tai-haku' (14).jpg",
          width: 1024,
          id: 'a0ecba30ec18e0bc56d7eced67282f15',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 125, 117, 1.00)',
            'rgba(122, 95, 68, 1.00)',
            'rgba(78, 65, 44, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'tai-haku'/prunus 'tai-haku' (12).jpg",
          width: 1024,
          id: '430fe5bb4bd84cb21a311eb31fc92320',
          height: 683,
          thumbnail: true,
        },
        location: [47.270417, -1.585897],
        genre: 'Prunus',
        cultivar: 'Tai-haku',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585897, 47.270417] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ab287e843c196209322285e58e43a2f5498521c0',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(190, 191, 199, 1.00)',
            'rgba(149, 141, 134, 1.00)',
            'rgba(71, 63, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'the bride'/prunus 'the bride'  (2).jpg",
          width: 1024,
          id: 'dd4a16ac246e8b4d814681c91b9bce22',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 107, 95, 1.00)',
            'rgba(138, 134, 118, 1.00)',
            'rgba(112, 108, 84, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'the bride'/prunus 'the bride' (2).jpg",
          width: 576,
          id: 'c0bdf86ca0f2f38e7da581b5e6be0523',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 109, 107, 1.00)',
            'rgba(123, 116, 111, 1.00)',
            'rgba(120, 114, 106, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'the bride'/prunus 'the bride'  (1).jpg",
          width: 1024,
          id: '16b20bd86ffd5db653d63e9996aa3174',
          height: 683,
          thumbnail: true,
        },
        location: [47.270955, -1.58292],
        genre: 'Prunus',
        cultivar: 'The Bride',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58292, 47.270955] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0a8747be24e8b44958b80a2123ef3ebc6c632bbe',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 99, 116, 1.00)',
            'rgba(110, 108, 126, 1.00)',
            'rgba(88, 91, 107, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus x yedoensis 'ivensii'/prunus x yedoensis 'ivensii'  (3).jpg",
          width: 1024,
          id: '7a8580eecbcf0c70d7f3caa650732425',
          height: 683,
          thumbnail: true,
        },
        espece: 'x yedoensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 165, 184, 1.00)',
            'rgba(118, 108, 90, 1.00)',
            'rgba(75, 70, 42, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus x yedoensis 'ivensii'/prunus x yedoensis 'ivensii'  (2).jpg",
          width: 1024,
          id: '967425c48fbe6c1a1213f5d0f59a693f',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 189, 197, 1.00)',
            'rgba(97, 91, 79, 1.00)',
            'rgba(65, 62, 39, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus x yedoensis 'ivensii'/prunus x yedoensis 'ivensii'  (1).jpg",
          width: 1024,
          id: '4e559d49c7e6cb15d712cc6606dc9e95',
          height: 683,
          thumbnail: true,
        },
        location: [47.269892, -1.5816],
        genre: 'Prunus',
        cultivar: 'Ivensii',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5816, 47.269892] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4b020fdbc8d5f18a429c0a55650364093672c6e4',
      fields: {
        espece: 'sinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 93, 104, 1.00)',
            'rgba(118, 96, 73, 1.00)',
            'rgba(102, 63, 17, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pseudocydonia [rosaceae]/pseudocydonia sinensis/pseudocydonia sinensis  (5).jpg',
          width: 1024,
          id: 'ecb2a6c80409cd00646fa5c6a4e5e24c',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(179, 180, 167, 1.00)',
            'rgba(142, 133, 72, 1.00)',
            'rgba(74, 71, 40, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pseudocydonia [rosaceae]/pseudocydonia sinensis/pseudocydonia sinensis  (4).jpg',
          width: 512,
          id: 'd036ccc1122e2eb6c1f15f9fc8befc16',
          height: 768,
          thumbnail: true,
        },
        location: [47.270767, -1.586047],
        genre: 'Pseudocydonia',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586047, 47.270767] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '231b2cd87b17557e5794a7945978fd8c4be93144',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 97, 33, 1.00)',
            'rgba(116, 134, 51, 1.00)',
            'rgba(136, 159, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/pyrus [rosaceae]/pyrus pyrifolia 'choju'/pyrus pyrifolia 'choju'  (3).jpg",
          width: 576,
          id: 'b1236656e3ba0ddb52374b407620a618',
          height: 768,
          thumbnail: true,
        },
        espece: 'pyrifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(171, 175, 162, 1.00)',
            'rgba(134, 139, 104, 1.00)',
            'rgba(63, 65, 44, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/pyrus [rosaceae]/pyrus pyrifolia 'choju'/pyrus pyrifolia 'choju'  (2).jpg",
          width: 947,
          id: 'c10dc81bccf3b1564e1cba60a669c610',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 102, 44, 1.00)',
            'rgba(145, 137, 87, 1.00)',
            'rgba(82, 99, 43, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/pyrus [rosaceae]/pyrus pyrifolia 'choju'/pyrus pyrifolia 'choju'  (1).jpg",
          width: 576,
          id: '3943c198a77cd68533f81b870bee56c4',
          height: 768,
          thumbnail: true,
        },
        location: [47.269955, -1.584422],
        genre: 'Pyrus',
        cultivar: 'Choju',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584422, 47.269955] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '91660579738291f5f0f610ecf9567712e98e2f0a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'umbellata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 99, 65, 1.00)',
            'rgba(116, 119, 87, 1.00)',
            'rgba(82, 82, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/rhaphiolepis [rosaceae]/rhaphiolepis umbellata/rhaphiolepis umbellata  (2).jpg',
          width: 576,
          id: '53996d6dd44a23731d5fb0385ee1e078',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 163, 114, 1.00)',
            'rgba(109, 141, 82, 1.00)',
            'rgba(121, 145, 90, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/rhaphiolepis [rosaceae]/rhaphiolepis umbellata/rhaphiolepis umbellata (1).jpg',
          width: 576,
          id: 'a0de00b39fc068264a1c6c5a0f38903e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 131, 84, 1.00)',
            'rgba(121, 125, 84, 1.00)',
            'rgba(124, 135, 87, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/rhaphiolepis [rosaceae]/rhaphiolepis umbellata/rhaphiolepis umbellata  (1).jpg',
          width: 1024,
          id: '167fea9788d0c5c4a28fbb473bad9f46',
          height: 768,
          thumbnail: true,
        },
        location: [47.271175, -1.584703],
        genre: 'Rhaphiolepis',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584703, 47.271175] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '52de2fe02ae3bb216029c1c9b6e12b315a002e2d',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'scandens',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 127, 79, 1.00)',
            'rgba(127, 149, 88, 1.00)',
            'rgba(109, 122, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/rhodotypos [rosaceae]/rhodotypos scandens/rhodotypos scandens  (2).jpg',
          width: 845,
          id: '38ef552d5bdd8fe1b25ae0c4d943f02c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 151, 72, 1.00)',
            'rgba(120, 146, 56, 1.00)',
            'rgba(72, 83, 35, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/rhodotypos [rosaceae]/rhodotypos scandens/rhodotypos scandens (1).jpg',
          width: 576,
          id: 'e1ad28cded00838b66a2eb5ba6247930',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 102, 49, 1.00)',
            'rgba(122, 138, 106, 1.00)',
            'rgba(58, 73, 36, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/rhodotypos [rosaceae]/rhodotypos scandens/rhodotypos scandens  (1).jpg',
          width: 576,
          id: '4477562cb1eb83f453bee4bb9bc9c735',
          height: 768,
          thumbnail: true,
        },
        location: [47.270722, -1.582505],
        genre: 'Rhodotypos',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582505, 47.270722] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '04962527b0a6f110228db4a4769692b60dc84dd7',
      fields: {
        espece: 'bella',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '1986',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8fca34c9be980be2f88f36a36057c5b463ac70fb',
      fields: {
        espece: 'canescens',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 147, 83, 1.00)',
            'rgba(109, 146, 77, 1.00)',
            'rgba(127, 151, 91, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea canescens/spiraea canescens (2).jpg',
          width: 576,
          id: 'e50cbd88a0ac7396eafff66cf14dac36',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 92, 50, 1.00)',
            'rgba(135, 143, 111, 1.00)',
            'rgba(73, 80, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea canescens/spiraea canescens (1).jpg',
          width: 576,
          id: 'dcabbb3beeb7b808d1f6f10fb01482c2',
          height: 768,
          thumbnail: true,
        },
        location: [47.271417, -1.586345],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586345, 47.271417] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0d69871f8709c8a501134491a7c07b4b4baec876',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 172, 170, 1.00)',
            'rgba(129, 120, 74, 1.00)',
            'rgba(133, 111, 63, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea thunbergii 'fugino'/spiraea thunbergii 'fugino' (7).jpg",
          width: 576,
          id: '7e3c4b81d8ffbdecc7b1399a220867ea',
          height: 768,
          thumbnail: true,
        },
        espece: 'thunbergii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 123, 57, 1.00)',
            'rgba(144, 145, 44, 1.00)',
            'rgba(136, 125, 77, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea thunbergii 'fugino'/spiraea thunbergii 'fugino' (10).jpg",
          width: 576,
          id: '7267d8c5d6b3ebf25015a8d44e3fc1df',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 132, 80, 1.00)',
            'rgba(166, 137, 95, 1.00)',
            'rgba(140, 115, 78, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea thunbergii 'fugino'/spiraea thunbergii 'fugino' (1).jpg",
          width: 588,
          id: '05f098aa92aa26f1954a6647db780422',
          height: 768,
          thumbnail: true,
        },
        location: [47.271383, -1.587088],
        genre: 'Spiraea',
        cultivar: 'Fugino',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587088, 47.271383] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9f5473c39c9dddafb8c2857e75a863550cf42e56',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x brachybotrys',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 140, 67, 1.00)',
            'rgba(120, 148, 74, 1.00)',
            'rgba(104, 131, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea x brachybotrys/spiraea x brachybotrys (2).jpg',
          width: 576,
          id: '72f216db9a52808cd520803fe4629cb7',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 144, 84, 1.00)',
            'rgba(116, 144, 77, 1.00)',
            'rgba(108, 127, 67, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea x brachybotrys/spiraea x brachybotrys (3).jpg',
          width: 1024,
          id: 'a510adbca0e0c03ce5e095273628b6b7',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 147, 66, 1.00)',
            'rgba(121, 138, 56, 1.00)',
            'rgba(124, 131, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea x brachybotrys/spiraea x brachybotrys (1).jpg',
          width: 576,
          id: 'b32c7ada4406dd381373efbaec5fa1d3',
          height: 768,
          thumbnail: true,
        },
        location: [47.271167, -1.587167],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587167, 47.271167] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dbe52f67b0369acac508b0ca8ee7e79c0c55186e',
      fields: {
        origine: 'Dunedin botanic garden',
        espece: 'acerosa',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Coprosma',
        date_plantation: '2001',
        famille: 'Rubiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '67c538691dabdb624257df48e3c7c905a34e31e4',
      fields: {
        origine: 'JB.Dijon (France)',
        espece: 'glauca Bess.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Asperula',
        date_plantation: '1997',
        famille: 'Rubiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bc651079d4acf6ebf51fcd0d7ba0fd3e5982afc6',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes 71290 La Gen\u00eate',
        espece: 'hirsutus Merr.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Lasianthus',
        date_plantation: '2015',
        famille: 'Rubiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cd34897fae14beaec4fd06167f95d87bd2629b95',
      fields: {
        origine: 'Arboretum des Barres',
        espece: 'daniellii',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Tetradium',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c6d329f953d73a968f7291147594bd8cb1b51c92',
      fields: {
        origine: 'P\u00e9pini\u00e8re Arven',
        espece: 'austrosinense',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Tetradium',
        date_plantation: '2016',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '99f17f42d17931e0db75753259f5cfafe0cee07b',
      fields: {
        origine: 'P\u00e9pini\u00e8re Guervel',
        espece: 'trifoliata',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Citrus',
        date_plantation: '2014',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1f82789e99da621371f340e55b3592b41a10daf0',
      fields: {
        espece: 'ternata',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 104, 68, 1.00)',
            'rgba(152, 141, 49, 1.00)',
            'rgba(68, 56, 37, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/choisya [rutaceae]/choisya ternata 'moonglow'/choisya ternata 'moonglow'.jpg",
          width: 576,
          id: '3e0f36e95ec24559c0d092465cfc1ff3',
          height: 768,
          thumbnail: true,
        },
        location: [47.272042, -1.582138],
        genre: 'Choisya',
        cultivar: 'Moonglow',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582138, 47.272042] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cbed125944ebeb2ee9eed27edda2641ef066503f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'baldwinii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 156, 58, 1.00)',
            'rgba(118, 161, 48, 1.00)',
            'rgba(113, 130, 49, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ptelea [rutaceae]/ptelea baldwinii/ptelea baldwinii (2).jpg',
          width: 576,
          id: '0fca0f4f18e2e82e9d35dfc775f48bc5',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 136, 80, 1.00)',
            'rgba(122, 146, 77, 1.00)',
            'rgba(86, 114, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ptelea [rutaceae]/ptelea baldwinii/ptelea baldwinii .jpg',
          width: 576,
          id: '161fd130231ae1934d100f6c4e6957ba',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 125, 29, 1.00)',
            'rgba(123, 150, 55, 1.00)',
            'rgba(87, 124, 30, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ptelea [rutaceae]/ptelea baldwinii/ptelea baldwinii (1).jpg',
          width: 576,
          id: '75656c6fbfff3431303cf1d78e25b2a1',
          height: 768,
          thumbnail: true,
        },
        location: [47.271638, -1.586447],
        genre: 'Ptelea',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586447, 47.271638] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cc03084d60863258bdbdadd64512117cfa625c3d',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 146, 105, 1.00)',
            'rgba(124, 131, 80, 1.00)',
            'rgba(104, 112, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/skimmia [rutaceae]/skimmia japonica 'rubella'/skimmia japonica 'rubella' (5).jpg",
          width: 1024,
          id: '04024d7c8df8b42cbd6030a2f82f075e',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 149, 84, 1.00)',
            'rgba(106, 142, 71, 1.00)',
            'rgba(103, 124, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/skimmia [rutaceae]/skimmia japonica 'rubella'/skimmia japonica 'rubella' (2).jpg",
          width: 576,
          id: '4a8eebc9a7441374eef61863e9863aa9',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 119, 66, 1.00)',
            'rgba(107, 120, 66, 1.00)',
            'rgba(119, 156, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/skimmia [rutaceae]/skimmia japonica 'rubella'/skimmia japonica 'rubella' (1).jpg",
          width: 576,
          id: '291a82b18df759422d79f18c0897fe89',
          height: 768,
          thumbnail: true,
        },
        location: [47.271078, -1.586372],
        genre: 'Skimmia',
        cultivar: 'Rubella',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586372, 47.271078] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a31a05d60619c3283501c921516a3d879d1602ae',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'simulans',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 159, 78, 1.00)',
            'rgba(140, 118, 60, 1.00)',
            'rgba(102, 118, 43, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/zanthoxylum [rutaceae]/zanthoxylum simulans/zanthoxylum simulans (2).jpg",
          width: 576,
          id: '87504b5b4602467d2bebfcba89f6c946',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 124, 96, 1.00)',
            'rgba(99, 99, 71, 1.00)',
            'rgba(99, 90, 67, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/zanthoxylum [rutaceae]/zanthoxylum simulans/zanthoxylum simulans (3).jpg",
          width: 576,
          id: 'f4cbda76ff7162e5d1c9f14fe513acff',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 163, 138, 1.00)',
            'rgba(121, 130, 101, 1.00)',
            'rgba(83, 89, 48, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/zanthoxylum [rutaceae]/zanthoxylum simulans/zanthoxylum simulans (1).jpg",
          width: 1024,
          id: '640d709dad1e0312734b4e9f6ac921b2',
          height: 768,
          thumbnail: true,
        },
        location: [47.226842, -1.512853],
        genre: 'Zanthoxylum',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512853, 47.226842] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '211031d969bbee647a1e0d3701b97acc9308d24a',
      fields: {
        espece: 'celastrina',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Azara',
        date_plantation: '1998',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e1a0a997246b022d64d971a590004ec848aae2ae',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'serrata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 137, 15, 1.00)',
            'rgba(156, 137, 13, 1.00)',
            'rgba(79, 94, 27, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/azara [salicaceae]/azara serrata/azara serrata (3).jpg',
          width: 576,
          id: '20041cb9d6b30c788498b532e6cde6fb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 154, 49, 1.00)',
            'rgba(124, 145, 61, 1.00)',
            'rgba(149, 147, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/azara [salicaceae]/azara serrata/azara serrata (4).jpg',
          width: 576,
          id: 'ee3fdbb97ec6c0338f978c97d538eebd',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 158, 82, 1.00)',
            'rgba(147, 147, 62, 1.00)',
            'rgba(129, 131, 86, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/azara [salicaceae]/azara serrata/azara serrata (2).jpg',
          width: 845,
          id: '96a067fff5c72db0f0a1eefea13ebaf9',
          height: 768,
          thumbnail: true,
        },
        location: [47.270663, -1.580983],
        genre: 'Azara',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580983, 47.270663] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '518893b06ba81c8edab4d9500d3bf7ec504fc224',
      fields: {
        origine: 'Arboretum des Barres',
        espece: 'grosseri',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Acer',
        date_plantation: '2011',
        cultivar: 'hersii',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd816919a5e5c3fabf044d3ad783665a9501b08d4',
      fields: {
        origine: 'Arboretum des Barres',
        espece: 'pennsylvanicum',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Acer',
        date_plantation: '2011',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b0822801e7c5267ba696f050c74fc81baa2813a4',
      fields: {
        espece: 'henryi',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Acer',
        date_plantation: '1973',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4127351f5465a983fe9af87ff461b6d3a1a9c0f7',
      fields: {
        espece: 'palmatum',
        localisation: 'B5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202019, -1.5440256],
        genre: 'Acer',
        date_plantation: '1973',
        cultivar: 'Atropurpurea',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440256, 47.2202019] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9d5453d246943da4925fde6d58f66ee811efad72',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(208, 209, 172, 1.00)',
            'rgba(130, 114, 40, 1.00)',
            'rgba(67, 60, 16, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer buergerianum 'hanachiru sato'/acer buergerianum 'hanachiru sato'  (3).jpg",
          width: 683,
          id: '82fd091965e7363467932c0c3dae7483',
          height: 768,
          thumbnail: true,
        },
        espece: 'buergerianum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(240, 245, 252, 1.00)',
            'rgba(167, 166, 119, 1.00)',
            'rgba(97, 99, 25, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer buergerianum 'hanachiru sato'/acer buergerianum 'hanachiru sato'  (2).jpg",
          width: 682,
          id: 'd12c299cf4174756818e7fb16acfde6b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 128, 77, 1.00)',
            'rgba(144, 144, 94, 1.00)',
            'rgba(96, 98, 48, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer buergerianum 'hanachiru sato'/acer buergerianum 'hanachiru sato'  (1).jpg",
          width: 576,
          id: '465f7bf4770a84ace589d1610d1e780f',
          height: 768,
          thumbnail: true,
        },
        location: [47.271787, -1.587238],
        genre: 'Acer',
        cultivar: 'Hanachiru Sato',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587238, 47.271787] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7dd9910d218ed06c293179079880a15d29e901f9',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'henryi',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 140, 98, 1.00)',
            'rgba(134, 131, 89, 1.00)',
            'rgba(136, 113, 95, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer henryi/acer henryi (10).jpg',
          width: 576,
          id: '73219bbddf6b6f5a298420a4e75f2cac',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 101, 56, 1.00)',
            'rgba(102, 134, 65, 1.00)',
            'rgba(122, 128, 95, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer henryi/acer henryi (11).jpg',
          width: 576,
          id: 'bad361278c453658fb1c1753e95a7c18',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 148, 101, 1.00)',
            'rgba(119, 116, 74, 1.00)',
            'rgba(99, 92, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer henryi/acer henryi (1).jpg',
          width: 576,
          id: '9211e470de824236477ac2f81b88a312',
          height: 768,
          thumbnail: true,
        },
        location: [47.269845, -1.584063],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584063, 47.269845] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '82a66331eea7ae2c39fa2a68213d04091fbc7dd3',
      fields: {
        espece: 'platanoides',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 148, 113, 1.00)',
            'rgba(92, 112, 54, 1.00)',
            'rgba(49, 60, 25, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer platanoides 'drummondii'/acer platanoides 'drummondii' .jpg",
          width: 1024,
          id: '04f2bf40e9efa3abc2e5a2f3c6c2c4f2',
          height: 683,
          thumbnail: true,
        },
        location: [47.2713, -1.5856],
        genre: 'Acer',
        cultivar: 'Drummondii',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5856, 47.2713] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '99f0c95689d7a01eba8d72e0adb292252353eb0a',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 164, 151, 1.00)',
            'rgba(134, 112, 63, 1.00)',
            'rgba(69, 58, 24, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer platanoides 'summershade'/acer platanoides 'summershade'  (12).jpg",
          width: 1024,
          id: '3b405a4fd9d4bbd5134660ab1de1e6ba',
          height: 683,
          thumbnail: true,
        },
        espece: 'platanoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 129, 175, 1.00)',
            'rgba(144, 99, 41, 1.00)',
            'rgba(121, 69, 3, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer platanoides 'summershade'/acer platanoides 'summershade'  (11).jpg",
          width: 512,
          id: '7033068af392bc5e13aca507b67be871',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 149, 139, 1.00)',
            'rgba(134, 91, 18, 1.00)',
            'rgba(67, 57, 27, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer platanoides 'summershade'/acer platanoides 'summershade'  (10).jpg",
          width: 512,
          id: '5c54121df58bdc5db2824ecec17ad7d4',
          height: 768,
          thumbnail: true,
        },
        location: [47.271217, -1.585403],
        genre: 'Acer',
        cultivar: 'Summershade',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585403, 47.271217] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cca25f6a07a13e8b847f4b80f658566e19fc5995',
      fields: {
        espece: 'platanoides',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 159, 164, 1.00)',
            'rgba(145, 114, 45, 1.00)',
            'rgba(79, 67, 37, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer platanoides/acer platanoides (9).jpg',
          width: 576,
          id: '0c4b78ce9cbba4b3b2b7344ee2fab4a1',
          height: 768,
          thumbnail: true,
        },
        location: [47.269755, -1.584733],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584733, 47.269755] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '73af8955e3614f4af9bd6981f2ded9f91f3f8310',
      fields: {
        espece: 'tataricum',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 129, 151, 1.00)',
            'rgba(124, 88, 53, 1.00)',
            'rgba(71, 56, 32, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer tataricum/acer tataricum (9).jpg',
          width: 854,
          id: '177d8d9c78a5ba479b4cb1449eddd553',
          height: 768,
          thumbnail: true,
        },
        location: [47.270617, -1.582786],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582786, 47.270617] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '738def84e345381bc75594b2a46e3ce073f3d7db',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 126, 111, 1.00)',
            'rgba(123, 126, 91, 1.00)',
            'rgba(140, 142, 117, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum 'eskimo'/viburnum 'eskimo'  (2).jpg",
          width: 576,
          id: '138ae210cb00846a9e834d060d983f87',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 139, 128, 1.00)',
            'rgba(143, 142, 129, 1.00)',
            'rgba(136, 135, 121, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum 'eskimo'/viburnum 'eskimo'  (3).jpg",
          width: 1024,
          id: '07f1c39f050e60e2aa06fd3bef655fdf',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 118, 100, 1.00)',
            'rgba(153, 153, 141, 1.00)',
            'rgba(98, 100, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum 'eskimo'/viburnum 'eskimo'  (1).jpg",
          width: 576,
          id: 'f3f14020b5cb8e4d7cea498cb3b897d2',
          height: 768,
          thumbnail: true,
        },
        location: [47.271825, -1.587213],
        genre: 'Viburnum',
        cultivar: 'Eskimo',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587213, 47.271825] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8b3950bdeb2a3fdcac77acf48f0d23ad7b2d73eb',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 165, 126, 1.00)',
            'rgba(107, 118, 65, 1.00)',
            'rgba(101, 105, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum 'le bois marquis'/viburnum 'le bois marquis'   (3).jpg",
          width: 1024,
          id: '580c653ffc72490784b3a9f10b9d2fab',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 116, 91, 1.00)',
            'rgba(145, 89, 97, 1.00)',
            'rgba(108, 65, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum 'le bois marquis'/viburnum 'le bois marquis'  (1).jpg",
          width: 576,
          id: 'b2fd83b2e9cf2aefcfb0e1ae4a4e63f9',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 148, 76, 1.00)',
            'rgba(120, 141, 55, 1.00)',
            'rgba(113, 132, 39, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum 'le bois marquis'/viburnum 'le bois marquis'   (2).jpg",
          width: 576,
          id: '35b22a6de5bf8e2968ce824d74dfd9ca',
          height: 768,
          thumbnail: true,
        },
        location: [47.27165, -1.581963],
        genre: 'Viburnum',
        cultivar: 'Le Bois Marquis',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581963, 47.27165] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e430ff21133c3abb9bded4f84dab67f025a83f53',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'acerifolium',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 76, 55, 1.00)',
            'rgba(145, 105, 91, 1.00)',
            'rgba(132, 101, 79, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum acerifolium/viburnum acerifolium (10).jpg',
          width: 963,
          id: '266f2205d8d0af3ede28101daa454306',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 107, 67, 1.00)',
            'rgba(123, 104, 80, 1.00)',
            'rgba(124, 103, 80, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum acerifolium/viburnum acerifolium (11).jpg',
          width: 1024,
          id: 'f026792db2f2ea7327f849ad893fcf6c',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 112, 65, 1.00)',
            'rgba(100, 141, 79, 1.00)',
            'rgba(76, 108, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum acerifolium/viburnum acerifolium (1).jpg',
          width: 1024,
          id: '48dad0b8f6c559b55ca1283f27e95499',
          height: 683,
          thumbnail: true,
        },
        location: [47.270455, -1.581162],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581162, 47.270455] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3dfb978d5b9b5d2ee8a96f81fe8578de5124e273',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'acerifolium',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 148, 87, 1.00)',
            'rgba(134, 153, 98, 1.00)',
            'rgba(115, 118, 79, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum acerifolium/viburnum acerifolium (3).jpg',
          width: 1024,
          id: 'a891b4363ae77e9a34b3bc49f6c89e98',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 133, 69, 1.00)',
            'rgba(122, 140, 62, 1.00)',
            'rgba(124, 137, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum acerifolium/viburnum acerifolium (4).jpg',
          width: 576,
          id: '314bea6cd429e259fe79e8ab77304d88',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 143, 82, 1.00)',
            'rgba(139, 134, 70, 1.00)',
            'rgba(112, 130, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum acerifolium/viburnum acerifolium (2).jpg',
          width: 576,
          id: 'afb71b130f975ecb3e7b360ba4ccd845',
          height: 768,
          thumbnail: true,
        },
        location: [47.271988, -1.582408],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582408, 47.271988] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a3de1d2401f0c6332c355cbd69b336c95b811846',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'buddlejifolium',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(201, 202, 197, 1.00)',
            'rgba(115, 112, 81, 1.00)',
            'rgba(102, 100, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum buddlejifolium/viburnum buddlejifolium (10).jpg',
          width: 576,
          id: '3a4e9a8498dffdb2608017e6b9005b75',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 149, 126, 1.00)',
            'rgba(156, 120, 96, 1.00)',
            'rgba(142, 119, 88, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum buddlejifolium/viburnum buddlejifolium (11).jpg',
          width: 576,
          id: 'e47048e13a41a2a3c924c1e9cf237e46',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 100, 67, 1.00)',
            'rgba(146, 139, 119, 1.00)',
            'rgba(88, 82, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum buddlejifolium/viburnum buddlejifolium (1).jpg',
          width: 576,
          id: '95d4391ad8b8e5564fa0a664d1a38ab1',
          height: 768,
          thumbnail: true,
        },
        location: [47.271147, -1.584958],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584958, 47.271147] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd96701f2bb29f0dde2ee68e33bd9131ec34b02dd',
      fields: {
        espece: 'dentatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 120, 93, 1.00)',
            'rgba(146, 109, 102, 1.00)',
            'rgba(117, 98, 88, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum dentatum 'white and blue'/viburnum dentatum 'white and blue' (2).jpg",
          width: 576,
          id: '32f564a0b00ceb73eb491c6a1b756d90',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 96, 67, 1.00)',
            'rgba(90, 119, 61, 1.00)',
            'rgba(76, 88, 52, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum dentatum 'white and blue'/viburnum dentatum 'white and blue' (1).jpg",
          width: 576,
          id: 'b44045cb1c7951919d62527448368eb0',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Viburnum',
        cultivar: 'White and Blue',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '07308fe596ec6e9bd9420d9d0f14364bdeb9a3ed',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'dentatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 147, 81, 1.00)',
            'rgba(110, 150, 58, 1.00)',
            'rgba(87, 114, 40, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum dentatum/viburnum dentatum (2).jpg',
          width: 576,
          id: 'fc00f756faaaef1326bdde81cce341ea',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 113, 57, 1.00)',
            'rgba(133, 162, 97, 1.00)',
            'rgba(83, 103, 47, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum dentatum/viburnum dentatum (3).jpg',
          width: 576,
          id: 'e55f55facf1f475e629b64421cbce352',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 86, 41, 1.00)',
            'rgba(115, 135, 88, 1.00)',
            'rgba(54, 80, 22, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum dentatum/viburnum dentatum (1).jpg',
          width: 576,
          id: '79b4da7623a2919c7ec7101a578282b3',
          height: 768,
          thumbnail: true,
        },
        location: [47.271003, -1.582062],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582062, 47.271003] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e6755d6d6a4c1ba268bd044d66a80452afa73504',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 162, 84, 1.00)',
            'rgba(116, 118, 58, 1.00)',
            'rgba(87, 91, 30, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum dilatatum 'erie'/viburnum dilatatum 'erie'   (4).jpg",
          width: 576,
          id: 'c9d450f8bb25d8eb5c02e1ee73dd418a',
          height: 768,
          thumbnail: true,
        },
        espece: 'dilatatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 144, 77, 1.00)',
            'rgba(121, 147, 87, 1.00)',
            'rgba(120, 137, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum dilatatum 'erie'/viburnum dilatatum 'erie'   (3).jpg",
          width: 576,
          id: '13ee95500d0b6f9f2d1127d669f856df',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 180, 114, 1.00)',
            'rgba(104, 119, 54, 1.00)',
            'rgba(89, 93, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum dilatatum 'erie'/viburnum dilatatum 'erie'   (2).jpg",
          width: 576,
          id: '597bf2af62b0e20bfd56babb7b20c0d4',
          height: 768,
          thumbnail: true,
        },
        location: [47.270962, -1.585037],
        genre: 'Viburnum',
        cultivar: 'Erie',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585037, 47.270962] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4bb40955ae09b9ccb91e19a1cf04b9f2679cf2cf',
      fields: {
        espece: 'dilatatum',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 98, 58, 1.00)',
            'rgba(112, 123, 75, 1.00)',
            'rgba(99, 101, 67, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum dilatatum 'erie'/viburnum dilatatum 'erie'  (2).jpg",
          width: 1024,
          id: '1b93d83aef802f3e80fe5d306b60522b',
          height: 768,
          thumbnail: true,
        },
        location: [47.271603, -1.582],
        genre: 'Viburnum',
        cultivar: 'Erie',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582, 47.271603] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '50dd3d12eee1a1b6f713ce3611a2fc33505c2d60',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'lobophyllum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(61, 81, 34, 1.00)',
            'rgba(116, 129, 97, 1.00)',
            'rgba(58, 83, 22, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum lobophyllum/viburnum lobophyllum (2).jpg',
          width: 576,
          id: '48d9204f3638dee4361735d42384cd7d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 129, 52, 1.00)',
            'rgba(126, 147, 67, 1.00)',
            'rgba(140, 164, 96, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum lobophyllum/viburnum lobophyllum (3).jpg',
          width: 576,
          id: 'd3819ca19acf864e8096fc8f66ec2b89',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 154, 63, 1.00)',
            'rgba(115, 156, 60, 1.00)',
            'rgba(93, 125, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum lobophyllum/viburnum lobophyllum (1).jpg',
          width: 576,
          id: '21b0fc534140b971f846a7638cf9c5b4',
          height: 768,
          thumbnail: true,
        },
        location: [47.270888, -1.586453],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586453, 47.270888] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a672c2ea2286431532cd1fd8548a2561cf924f93',
      fields: {
        espece: 'tinus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 137, 69, 1.00)',
            'rgba(118, 135, 68, 1.00)',
            'rgba(121, 126, 78, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum tinus 'bewley's variegated'/viburnum tinus 'bewley's variegated' (2).jpg",
          width: 576,
          id: 'd87aca85bc22bc26b7566b564bdd1fea',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 153, 127, 1.00)',
            'rgba(97, 110, 59, 1.00)',
            'rgba(109, 120, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum tinus 'bewley's variegated'/viburnum tinus 'bewley's variegated' (1).jpg",
          width: 576,
          id: '437affdbac8ec4c2245eca256f68b3bc',
          height: 768,
          thumbnail: true,
        },
        location: [47.269597, -1.585558],
        genre: 'Viburnum',
        cultivar: "Bewley's Variegated",
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585558, 47.269597] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1ec90c892344a45c4d588573739812f39938d274',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'veitchii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 112, 58, 1.00)',
            'rgba(108, 124, 63, 1.00)',
            'rgba(160, 165, 102, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum veitchii/viburnum veitchii  (2).jpg',
          width: 1024,
          id: 'd669e1c5010f163788187079fa624d19',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 135, 62, 1.00)',
            'rgba(131, 151, 63, 1.00)',
            'rgba(130, 144, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum veitchii/viburnum veitchii (3).jpg',
          width: 576,
          id: 'fd7e5ea323eed826b3cd8ac71eedf7bf',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 101, 42, 1.00)',
            'rgba(124, 145, 65, 1.00)',
            'rgba(111, 140, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum veitchii/viburnum veitchii  (1).jpg',
          width: 576,
          id: '2d67a1495b7a6786a39da7209536fcb6',
          height: 768,
          thumbnail: true,
        },
        location: [47.270675, -1.581437],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581437, 47.270675] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3a693ae64cb6a9f62916d8ce780fbeb267c8403b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x burkwoodii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 115, 58, 1.00)',
            'rgba(97, 133, 66, 1.00)',
            'rgba(97, 130, 69, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x burkwoodii/viburnum x burkwoodii (11).jpg',
          width: 1024,
          id: '603be6a73f3b8be05cd921dd5d3eae68',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(177, 185, 177, 1.00)',
            'rgba(79, 89, 57, 1.00)',
            'rgba(79, 84, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x burkwoodii/viburnum x burkwoodii (9).jpg',
          width: 1024,
          id: '1584497bcc07871010fdd4a36bf5349c',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(41, 54, 23, 1.00)',
            'rgba(93, 101, 82, 1.00)',
            'rgba(67, 78, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x burkwoodii/viburnum x burkwoodii (10).jpg',
          width: 1024,
          id: '67643980b6456ba0ed3187252b2a5afb',
          height: 683,
          thumbnail: true,
        },
        location: [47.270267, -1.582345],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582345, 47.270267] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a31114eb1c073167acf1f1a6385a740ad94da7e0',
      fields: {
        espece: 'x globosum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 143, 112, 1.00)',
            'rgba(122, 140, 67, 1.00)',
            'rgba(129, 135, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x globosum 'jermyns globe'/viburnum x globosum 'jermyns globe' (2).jpg",
          width: 633,
          id: 'b894416f56718f95b67f62008887d83d',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 124, 52, 1.00)',
            'rgba(138, 149, 56, 1.00)',
            'rgba(113, 123, 42, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x globosum 'jermyns globe'/viburnum x globosum 'jermyns globe' (1).jpg",
          width: 576,
          id: 'e49c559e0f1c433f2be11ce9992abcb3',
          height: 768,
          thumbnail: true,
        },
        location: [47.27053, -1.581738],
        genre: 'Viburnum',
        cultivar: 'Jermyns Globe',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581738, 47.27053] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '49721714af76708c7d119bff9946a633ff409065',
      fields: {
        origine: 'JB. De Voronozh (Russie)',
        espece: 'christophii Trautv.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Allium',
        date_plantation: '2010',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0a619a9a0507e016afc78e57c3b1be30af3bbad1',
      fields: {
        origine: 'JB. Prague (Rep. Tch\u00e8que)',
        espece: 'papyraceus Ker.Gawl',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Narcissus',
        date_plantation: '2010',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd433359f5716810198de27043af7746cb836e9cd',
      fields: {
        origine: 'JB.& Mus\u00e9um de Dahlem (Allemagne)',
        espece: 'carinatum L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Allium',
        date_plantation: '2006',
        cultivar: 'carinatum',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '62048f0323f772e011ce25135112282a5bd2bc80',
      fields: {
        origine: 'JB.Hiroshima (Japon)',
        espece: 'tuberosum Rottl.',
        localisation: 'D3H',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2199567, -1.5416248],
        genre: 'Allium',
        date_plantation: '1998',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5416248, 47.2199567] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1efc5cc3565816a2639d16417553ffe950f7ca24',
      fields: {
        origine: 'JB.Lyon (France)',
        espece: 'suaveolens Jacq.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Allium',
        date_plantation: '1999',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ebe0d52338405de4ce60cf446878db51763c1740',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'angulosum L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Allium',
        date_plantation: '2001',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '83d15f7639dfbafbd474b1c2a808255c72ed2301',
      fields: {
        origine: 'JB.Vienne (Autriche)',
        espece: 'flavum L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Allium',
        date_plantation: '2006',
        cultivar: 'flavum',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2f3ffec7f290b404cc37dc157d51d3c55728f0e5',
      fields: {
        origine: 'JB.Wurzburg (Allemagne)',
        espece: 'triandrus L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Narcissus',
        date_plantation: '2006',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a557566a0c9656101a63591bc1056ffcd967c2f0',
      fields: {
        origine: 'JBU.Besan\u00e7on (France)',
        espece: 'angulosum L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Allium',
        date_plantation: '2001',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '22701d29544b693573ca6fd9129a1f91d34430b6',
      fields: {
        espece: 'nivalis L.',
        localisation: 'I4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2186346, -1.541674],
        genre: 'Galanthus',
        date_plantation: '1973',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541674, 47.2186346] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '71f9b2e84a99530b6aa46f4e40e599ca941923fb',
      fields: {
        origine: 'B.G. de Brno (Rep. Tch\u00e8que)',
        espece: 'glauca Dumort.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Trinia',
        date_plantation: '2014',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5f0c8e67d3472f8f8fffa177b461d50a77477539',
      fields: {
        origine: 'Inst. Hodowli Roslin (Pologne)',
        espece: 'sonowskyi Manden.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Heracleum',
        date_plantation: '2010',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '463e4bcd91c81c21bcd5d28c8b647309b6e4369e',
      fields: {
        origine: 'JB. Vladivostok (Russie)',
        espece: 'chinensis Bunge',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Sanicula',
        date_plantation: '2010',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5a5785ef3b6c013c3c5ea62f0a636e9e311b12bc',
      fields: {
        origine: 'JBU.G\u00f6ethe de Frankf\u00fcrt am Main (Allemagne)',
        espece: 'bourgati Gouan.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Eryngium',
        date_plantation: '2006',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '46e436c2e683c777763276cd9a63d8e0728e5aaf',
      fields: {
        origine: 'Klagenfurt BG',
        espece: 'trilobum Baumg.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Laser',
        date_plantation: '2010',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a47220677893d604ae0a1702c5a5ec5b848fd78b',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'spinarum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 151, 71, 1.00)',
            'rgba(121, 142, 48, 1.00)',
            'rgba(123, 123, 64, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/carissa [apocynaceae]/carissa spinarum/carissa spinarum  (2).jpg",
          width: 576,
          id: '0a5830d1d733b4aebbdceeb005a0fec8',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(167, 140, 109, 1.00)',
            'rgba(145, 109, 81, 1.00)',
            'rgba(84, 77, 22, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/carissa [apocynaceae]/carissa spinarum/carissa spinarum  (3).jpg",
          width: 576,
          id: 'fe10d843fa60682f4898fcf38d42f98f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(173, 171, 110, 1.00)',
            'rgba(156, 125, 60, 1.00)',
            'rgba(126, 126, 53, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/carissa [apocynaceae]/carissa spinarum/carissa spinarum  (1).jpg",
          width: 576,
          id: '471209bb01127c277bd72010c353b11b',
          height: 768,
          thumbnail: true,
        },
        location: [47.226505, -1.512308],
        genre: 'Carissa',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512308, 47.226505] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8727f4bf39d9f54d8a1b4affd68dbd7b44ab3ee2',
      fields: {
        espece: 'oleander',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Nerium',
        cultivar: 'Blanc',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd906e48eeb5ec4838b8f942e6b81610dc9fec009',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'verticillata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 128, 55, 1.00)',
            'rgba(115, 144, 50, 1.00)',
            'rgba(122, 136, 69, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ilex [aquifoliaceae]/ilex verticillata/ilex verticillata (3).jpg',
          width: 576,
          id: 'a5ead2a3a41c72aa295ba4dcc70c9e5b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 139, 69, 1.00)',
            'rgba(134, 145, 50, 1.00)',
            'rgba(113, 104, 48, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ilex [aquifoliaceae]/ilex verticillata/ilex verticillata (4).jpg',
          width: 1024,
          id: 'fd4211724577d7d206deb0e8f669ebb3',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 136, 55, 1.00)',
            'rgba(117, 117, 44, 1.00)',
            'rgba(98, 126, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ilex [aquifoliaceae]/ilex verticillata/ilex verticillata (2).jpg',
          width: 576,
          id: 'af4ede115b8375f6b85abf57fbe45e75',
          height: 768,
          thumbnail: true,
        },
        location: [47.271058, -1.58668],
        genre: 'Ilex',
        famille: 'Aquifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58668, 47.271058] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '93285e03e5f32f257fb2848e26695497c27c56e7',
      fields: {
        espece: 'x koehneana',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 144, 165, 1.00)',
            'rgba(107, 113, 101, 1.00)',
            'rgba(81, 77, 39, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ilex [aquifoliaceae]/ilex x koehneana 'chestnut leaf'/ilex x koehneana 'chestnut leaf' (3).jpg",
          width: 1024,
          id: '4a1f3d0ef70d5ffde712039e375d811f',
          height: 683,
          thumbnail: true,
        },
        location: [47.271321, -1.585043],
        genre: 'Ilex',
        cultivar: 'Chestnut Leaf',
        famille: 'Aquifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585043, 47.271321] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e6464b538fa50dcac431ce8652c4da0ff5fb576a',
      fields: {
        origine: 'B.G. Bonn (All.)',
        espece: 'griffithii Schott',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Arisaema',
        date_plantation: '2014',
        famille: 'Araceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '53bc4a78f463ae3f7719563ad02dee26658d054f',
      fields: {
        origine:
          'Botanischer Garten der Universitat, Erlangen-Nurnberg, Allemagne',
        espece: 'amurense Maxim.',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Arisaema',
        date_plantation: '2012',
        famille: 'Araceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'eba4880a207909e972dcec97991b249f15b49adf',
      fields: {
        origine: "La Boite \u00e0 Graines, L'Herbergement, France",
        espece: 'pedatisecta Schott',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Pinellia',
        date_plantation: '2013',
        famille: 'Araceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ed07f4d4016d2500013970cf93b7b9a743711831',
      fields: {
        origine: 'JBU.Berkeley (USA)',
        espece: 'californica S. Wats.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Aralia',
        date_plantation: '1988',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7a563ccb31f47ce7599af534d848dcf3c283e84b',
      fields: {
        espece: 'spinosa',
        localisation: 'B7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198817, -1.5442188],
        genre: 'Aralia',
        date_plantation: '1986',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442188, 47.2198817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '33ca9d2b5c9571e10975530b10c36c93378a00c2',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'septemlobus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 167, 101, 1.00)',
            'rgba(121, 134, 67, 1.00)',
            'rgba(67, 88, 27, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/kalopanax [araliaceae]/kalopanax septemlobus/kalopanax septemlobus (14).jpg',
          width: 576,
          id: 'd6c76e88c3e17644cce92fc20eee617a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 101, 80, 1.00)',
            'rgba(146, 150, 139, 1.00)',
            'rgba(92, 98, 80, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/kalopanax [araliaceae]/kalopanax septemlobus/kalopanax septemlobus (15).jpg',
          width: 576,
          id: '18a3570776e94eb830852bc7715801ca',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 105, 65, 1.00)',
            'rgba(96, 142, 66, 1.00)',
            'rgba(60, 92, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/kalopanax [araliaceae]/kalopanax septemlobus/kalopanax septemlobus (1).jpg',
          width: 576,
          id: 'bf5532712a54e89aa7836e6082191f6b',
          height: 768,
          thumbnail: true,
        },
        location: [47.270647, -1.581344],
        genre: 'Kalopanax',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581344, 47.270647] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '04c283a06df911216581a7847a89eb0394eb4bcd',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'septemlobus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 112, 169, 1.00)',
            'rgba(84, 109, 153, 1.00)',
            'rgba(88, 111, 148, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/kalopanax [araliaceae]/kalopanax septemlobus/kalopanax septemlobus (13).jpg',
          width: 1024,
          id: '6fdb50bee3b4b45eab5ccec706c7c0ce',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(75, 106, 158, 1.00)',
            'rgba(102, 125, 159, 1.00)',
            'rgba(88, 91, 90, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/kalopanax [araliaceae]/kalopanax septemlobus/kalopanax septemlobus (8).jpg',
          width: 512,
          id: '239789fe1294129653dd6dac00c6bd31',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 109, 160, 1.00)',
            'rgba(80, 107, 153, 1.00)',
            'rgba(90, 121, 165, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/kalopanax [araliaceae]/kalopanax septemlobus/kalopanax septemlobus (10).jpg',
          width: 1024,
          id: '3c1e5e8e1f5abd112414f2d64412021a',
          height: 683,
          thumbnail: true,
        },
        location: [47.270407, -1.582702],
        genre: 'Kalopanax',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582702, 47.270407] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '01e3638e40cd09a42de088530391dcc920a71573',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'papyrifer',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(214, 209, 198, 1.00)',
            'rgba(107, 103, 76, 1.00)',
            'rgba(60, 70, 47, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/tetrapanax [araliaceae]/tetrapanax papyrifer/tetrapanax papyrifer  (2).jpg",
          width: 576,
          id: '663a1c05bc7395e6fc450f6c9265911f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 114, 68, 1.00)',
            'rgba(103, 110, 77, 1.00)',
            'rgba(121, 124, 87, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/tetrapanax [araliaceae]/tetrapanax papyrifer/tetrapanax papyrifer  (3).jpg",
          width: 576,
          id: '4c1e1825264794f2cca0ffbefb1b6914',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 161, 141, 1.00)',
            'rgba(114, 110, 74, 1.00)',
            'rgba(75, 73, 49, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/tetrapanax [araliaceae]/tetrapanax papyrifer/tetrapanax papyrifer  (1).jpg",
          width: 576,
          id: '970fde437ab0639940d48dd8cfcc80a8',
          height: 768,
          thumbnail: true,
        },
        location: [47.227005, -1.512508],
        genre: 'Tetrapanax',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512508, 47.227005] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ff71b526b97e5436715c02c7eb5c636f0477ce16',
      fields: {
        origine: 'Palerme?',
        espece: 'havanensis Lodd.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Sabal',
        date_plantation: '1979',
        famille: 'Arecaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8fac080ba2c013a2072be68b43f15827bb8af595',
      fields: {
        espece: 'excelsus',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Trachycarpus',
        date_plantation: '1973',
        famille: 'Arecaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dbba941baf40cc9a87e6123a7ea516f453eab0c6',
      fields: {
        origine: 'Arboretum de Washington (U.S.A.)',
        espece: 'hyacinthina  Greene',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Triteleia',
        date_plantation: '2008',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5511de8c7b311bd8983be430113a3b65dfdf7aa7',
      fields: {
        origine: 'Jardin alpin la Ramberta - Rochers de Naye (CH)',
        espece: 'pyrenaicum L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Ornithogalum',
        date_plantation: '2010',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dc1219edf2bf647a97916b14d1004b92597df48b',
      fields: {
        origine: 'JB.Askhabad (U.S.A).',
        espece: 'leucostomum G.Woronow',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Muscari',
        date_plantation: '1984',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c2cf4b06dc8e7974e50bc123283dae64ed72f823',
      fields: {
        origine: "JB.d'Aquila (Italie)",
        espece: 'comosa Parl.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Leopoldia',
        date_plantation: '2006',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '84793b0711191e99e8b196857d7196d60acac112',
      fields: {
        origine: 'JB.Harrogate (Angleterre)',
        espece: 'sieboldiana Engl.',
        localisation: 'D3G',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2197244, -1.5416062],
        genre: 'Hosta',
        date_plantation: '1998',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5416062, 47.2197244] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '38f8b9901728284189c95acd30ebe46f8484ea04',
      fields: {
        origine: 'JB.Wisley (R.H.S.)',
        espece: 'planiscapus  Nakai',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Ophiopogon',
        date_plantation: '1992',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8019135f1e9659528d8b9a068dd6721f4e5bb349',
      fields: {
        origine: 'JBU.Matsudo (Japon)',
        espece: 'sp.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Hosta',
        date_plantation: '2006',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cbf6d9e692a875eb00014603cd2af9f7b4f7992b',
      fields: {
        origine: 'JBU.Tohoku (Sendai)',
        espece: 'keiskei Miq.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Convallaria',
        date_plantation: '1992',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e6d28fa2e49a76177c83f098da90ceedc4641e61',
      fields: {
        origine: 'p\u00e9pini\u00e8re Ellebore',
        espece: 'regalis Hilliard & B.L.Burtt',
        localisation: 'I2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185657, -1.5426599],
        genre: 'Galtonia',
        date_plantation: '2015',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426599, 47.2185657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7863154f05e153b2a2aecd02d7f7d1e7632c5183',
      fields: {
        origine: 'Universit\u00e9 de Potsdam',
        espece: 'azureum Fenzl.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Muscari',
        date_plantation: '2010',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e23a216d9ecd11de8439ade7e3928882a1801097',
      fields: {
        espece: 'carnea Kunth.',
        localisation: 'D3F',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220122, -1.5416317],
        genre: 'Reineckea',
        date_plantation: '1973',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5416317, 47.220122] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd71423cdb089dfa1e2e7c5d4821fa351f95f9284',
      fields: {
        origine: 'Botanische Garten (Meckenheimer), Bonn, Allemagne',
        espece: 'howellii A.Gray',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Erigeron',
        date_plantation: '2012',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cc7b61d315cee24563720977274069e464d01206',
      fields: {
        origine: 'Botanischer Garten Munchen',
        espece: 'caucasicus Stev.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Erigeron',
        date_plantation: '2015',
        cultivar: 'ssp. Caucasicus',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a95fa9e642404838edf741e1861587bb1b92e1e9',
      fields: {
        origine: 'Emmanuel LEPAGE',
        espece: 'margaritaceae L.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Anaphalis',
        date_plantation: '2015',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd95434865b71821c6ec82e87cded354dae8ef3c4',
      fields: {
        origine: 'Emmanuel LEPAGE',
        espece: 'dracunculus L.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Artemisia',
        date_plantation: '2015',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3cc4a3261c2034315d328680f424fd98a504a7e5',
      fields: {
        origine: 'Giardino Botanico "Michele Tenore", Lama dei Peligni',
        espece: 'rupestris L.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Centaurea',
        date_plantation: '2006',
        cultivar: 'ceratophylla',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '275311e3b83b7a7baa10921827595bbee5a487a3',
      fields: {
        origine: 'J.B. G\u00f6teborg (Su\u00e8de)',
        espece: 'stenolepis Kern.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Centaurea',
        date_plantation: '2011',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5e7d195d7fa4c3bec061c13bdaf4dd7c15b7282d',
      fields: {
        origine: 'JB. Carl Skottsbergs, Goteb\u00f6rg (Su\u00e8de)',
        espece: 'acerifolia Schultz',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Ainsliaea',
        date_plantation: '2011',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fa08fd7851e0c4464455a27f46181f206750e414',
      fields: {
        origine: 'JB.Graz (Autriche)',
        espece: 'salicifolium L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Buphtalmum',
        date_plantation: '1998',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '561f1c8e37531793b8c9a62237fbafcf0b0b2bb8',
      fields: {
        origine: 'JB.Hokkaido (Japon)',
        espece: 'virgaurea L.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Solidago',
        date_plantation: '2009',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3a9585298bc2e2452b23c85cc142cc65b66e9a21',
      fields: {
        origine: 'JB.Klagenf\u00fcrt (Autriche)',
        espece: 'pseudo-phrygia C.A.Mey.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Centaurea',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b9aac740c085477906c9f8f9ae274810ebd04d0a',
      fields: {
        origine: 'JB.Siena (Italie)',
        espece: 'dubia L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Staehelina',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c8c24c1777b046581c2dca374901d0014ff92458',
      fields: {
        origine: 'JB.Yeomjii (Cor\u00e9e)',
        espece: 'coronata L.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Serratula',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b36dfb1b632b2ec1ec430d0664cf1e8b8b4c8697',
      fields: {
        origine: 'JBU.Cracovie',
        espece: 'grandiflora Nutt.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Coreopsis',
        date_plantation: '1988',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a76ae7ac4f5f7a8be667f2d11c87be5ccf785f0b',
      fields: {
        origine: 'JBU.Olomouc (R\u00e9public Tch\u00e8que',
        espece: 'linosyris Bernth.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Aster',
        date_plantation: '1998',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9321ab1fa9dd46240f01fff0ed94059d6c1dde63',
      fields: {
        origine: 'P\u00e9pini\u00e8res Huls-Dank - Peer - Belgique',
        espece: 'cheirifolia',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Hertia',
        date_plantation: '2010',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9b2243434ff5b391ffb63e7d921059dd48adf383',
      fields: {
        espece: 'margaritacea Benth. et Hook.f.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Anaphalis',
        date_plantation: '1973',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '530f11fd4bb7cd9284d499c389d2e06c6f267fbe',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 113, 45, 1.00)',
            'rgba(129, 137, 35, 1.00)',
            'rgba(91, 98, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/baccharis [asteraceae]/baccharis halimifolia 'baccador'/baccharis halimifolia 'baccador' (3).jpg",
          width: 1024,
          id: '96acaf68142c9732202637129b234813',
          height: 768,
          thumbnail: true,
        },
        espece: 'halimifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 132, 75, 1.00)',
            'rgba(175, 152, 43, 1.00)',
            'rgba(152, 128, 21, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/baccharis [asteraceae]/baccharis halimifolia 'baccador'/baccharis halimifolia 'baccador' (2).jpg",
          width: 576,
          id: 'a04aeab4a4154d4cee9cd9dd523f55c3',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 122, 64, 1.00)',
            'rgba(129, 137, 64, 1.00)',
            'rgba(109, 117, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/baccharis [asteraceae]/baccharis halimifolia 'baccador'/baccharis halimifolia 'baccador' (1).jpg",
          width: 1024,
          id: '676ec6815ec01fdf3ed0c2a3a85d8d25',
          height: 768,
          thumbnail: true,
        },
        location: [47.270617, -1.580912],
        genre: 'Baccharis',
        cultivar: 'Baccador',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580912, 47.270617] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '26d902bdd748a5799d0110dae4b1ce726009748c',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'purpurea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 133, 110, 1.00)',
            'rgba(122, 130, 92, 1.00)',
            'rgba(87, 99, 62, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/stevia [asteraceae]/stevia purpurea/stevia purpurea (2).jpg",
          width: 576,
          id: '698538a561e44e0a0826d7da74eeb976',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 102, 81, 1.00)',
            'rgba(129, 141, 103, 1.00)',
            'rgba(134, 133, 109, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/stevia [asteraceae]/stevia purpurea/stevia purpurea (3).jpg",
          width: 576,
          id: 'e879890956dfd69ca2d8b0aab120bd00',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 139, 90, 1.00)',
            'rgba(134, 153, 103, 1.00)',
            'rgba(132, 154, 104, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/stevia [asteraceae]/stevia purpurea/stevia purpurea (1).jpg",
          width: 576,
          id: 'bd41b2872170db7e2543267849e34622',
          height: 768,
          thumbnail: true,
        },
        location: [47.226617, -1.512142],
        genre: 'Stevia',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512142, 47.226617] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cccc11fc2537902e96c578dff78ad53e5f1425ce',
      fields: {
        origine: 'Les Ponts de C\u00e9_p\u00e9pini\u00e8re Lepage',
        espece: 'grandiflorum C.Morren',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Epimedium',
        date_plantation: '2016',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'aa68696a1f6ffec8d5af896e5b76be3400905392',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'darwinii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 129, 113, 1.00)',
            'rgba(152, 117, 70, 1.00)',
            'rgba(139, 130, 119, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/berberis [berberidaceae]/berberis darwinii/berberis darwinii (3).jpg',
          width: 576,
          id: '5042b8a83ada58fa6ed01ce044d20ec2',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 127, 113, 1.00)',
            'rgba(150, 129, 92, 1.00)',
            'rgba(113, 109, 103, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/berberis [berberidaceae]/berberis darwinii/berberis darwinii (4).jpg',
          width: 576,
          id: '11fc064cc6728e7bc2844fc2e671a535',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 155, 149, 1.00)',
            'rgba(137, 147, 140, 1.00)',
            'rgba(115, 122, 117, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/berberis [berberidaceae]/berberis darwinii/berberis darwinii (1).jpg',
          width: 576,
          id: 'ecc2710bd08660ea39d5fffe653f7252',
          height: 768,
          thumbnail: true,
        },
        location: [47.270617, -1.585803],
        genre: 'Berberis',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585803, 47.270617] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5fa00811daca2dfd5820b6d93cfa3cbbac6982bc',
      fields: {
        espece: 'dictyophylla',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(62, 70, 40, 1.00)',
            'rgba(95, 97, 74, 1.00)',
            'rgba(122, 117, 96, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/berberis [berberidaceae]/berberis dictyophylla/berberis dictyophylla (2).jpg',
          width: 576,
          id: '87e201bfb5cbd219815bbac15406bb90',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(61, 68, 41, 1.00)',
            'rgba(78, 81, 32, 1.00)',
            'rgba(50, 58, 29, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/berberis [berberidaceae]/berberis dictyophylla/berberis dictyophylla (1).jpg',
          width: 576,
          id: '2be909463fa61635374d25f995416483',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Berberis',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a62ea5b86ed39309d2de56c2f5b1de1e7c0ff483',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'aquisargentii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 131, 74, 1.00)',
            'rgba(101, 143, 66, 1.00)',
            'rgba(101, 134, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/x mahoberberis [berberidaceae]/x mahoberberis aquisargentii/x mahoberberis aquisargentii (2).jpg',
          width: 576,
          id: 'b9ceae500e94e4f047da6788774769a8',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 126, 94, 1.00)',
            'rgba(104, 128, 95, 1.00)',
            'rgba(135, 132, 121, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/x mahoberberis [berberidaceae]/x mahoberberis aquisargentii/x mahoberberis aquisargentii (3).jpg',
          width: 576,
          id: '46b2f7b6922298bc63a1ea404fcc4a2d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 130, 83, 1.00)',
            'rgba(109, 124, 88, 1.00)',
            'rgba(80, 100, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/x mahoberberis [berberidaceae]/x mahoberberis aquisargentii/x mahoberberis aquisargentii (1).jpg',
          width: 1024,
          id: 'fd4caf2b1877fd599c4a27a085a1a91d',
          height: 768,
          thumbnail: true,
        },
        location: [47.269928, -1.58237],
        genre: 'x Mahoberberis',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58237, 47.269928] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e4d227c16eb3be472d55eeb6974edd5db3f9cb50',
      fields: {
        origine: 'P\u00e9pini\u00e8re Ville de Nantes',
        espece: 'costata',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Betula',
        date_plantation: '2017',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b1494244982b5f4122923b636e94c40efe7d2b4a',
      fields: {
        origine: 'P\u00e9pini\u00e8re Ville de Nantes',
        espece: 'utilis',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Betula',
        date_plantation: '2017',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ac6fc38dfb6e1e11ab95f0bfc535ba26e0bda5de',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'nigra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 93, 57, 1.00)',
            'rgba(123, 162, 90, 1.00)',
            'rgba(123, 160, 79, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/betula [betulaceae]/betula nigra/betula nigra (2).jpg',
          width: 576,
          id: '2770101002595082c0b7f7a2988e0c91',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 133, 127, 1.00)',
            'rgba(130, 131, 124, 1.00)',
            'rgba(134, 133, 126, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/betula [betulaceae]/betula nigra/betula nigra.jpg',
          width: 576,
          id: '53bc73db3f27cf042f28447f3d1212bf',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 146, 97, 1.00)',
            'rgba(132, 155, 116, 1.00)',
            'rgba(101, 121, 78, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/betula [betulaceae]/betula nigra/betula nigra (1).jpg',
          width: 576,
          id: '0f5d4c708d67e4623ee41647f2db1b25',
          height: 768,
          thumbnail: true,
        },
        location: [47.269925, -1.58472],
        genre: 'Betula',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58472, 47.269925] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b2ec4cb29706a709d4a0d420326bf734a749b06d',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'shensiensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 166, 96, 1.00)',
            'rgba(140, 139, 94, 1.00)',
            'rgba(134, 146, 89, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/carpinus [betulaceae]/carpinus shensiensis/carpinus shensiensis  (2).jpg',
          width: 576,
          id: '687db6ebc516d249ac6d49bd499f96f4',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(189, 214, 226, 1.00)',
            'rgba(86, 101, 60, 1.00)',
            'rgba(97, 108, 49, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/carpinus [betulaceae]/carpinus shensiensis/carpinus shensiensis  (3).jpg',
          width: 576,
          id: '2632c8242423cef778de323ea5578c11',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 129, 69, 1.00)',
            'rgba(107, 126, 53, 1.00)',
            'rgba(107, 127, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/carpinus [betulaceae]/carpinus shensiensis/carpinus shensiensis  (1).jpg',
          width: 576,
          id: '1cfdb3e4534fd67dd90cf2449bfedebb',
          height: 768,
          thumbnail: true,
        },
        location: [47.271887, -1.582492],
        genre: 'Carpinus',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582492, 47.271887] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5597105c6dd1e2366cb6979a9884f74a634ecaa7',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 151, 85, 1.00)',
            'rgba(99, 133, 49, 1.00)',
            'rgba(101, 126, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/corylus [betulaceae]/corylus avellana 'contorta'/corylus avellana 'contorta'  (3).jpg",
          width: 576,
          id: '5b4f73c9ccbcdb41cdd587f879fd439e',
          height: 768,
          thumbnail: true,
        },
        espece: 'avellana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 119, 41, 1.00)',
            'rgba(119, 158, 51, 1.00)',
            'rgba(89, 120, 31, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/corylus [betulaceae]/corylus avellana 'contorta'/corylus avellana 'contorta'  (2).jpg",
          width: 576,
          id: '8d720c82f03cd2da52299b2e631defbe',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 112, 55, 1.00)',
            'rgba(113, 148, 76, 1.00)',
            'rgba(103, 142, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/corylus [betulaceae]/corylus avellana 'contorta'/corylus avellana 'contorta'  (1).jpg",
          width: 576,
          id: 'e7355521f62a12473944d618ed622868',
          height: 768,
          thumbnail: true,
        },
        location: [47.270455, -1.581897],
        genre: 'Corylus',
        cultivar: 'Contorta',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581897, 47.270455] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '21eb5d2760b87c361e52298910330bf34255e7ec',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'chinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 154, 54, 1.00)',
            'rgba(157, 150, 66, 1.00)',
            'rgba(113, 110, 47, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylus [betulaceae]/corylus chinensis/corylus chinensis (2).jpg',
          width: 576,
          id: '70722d84235d6e217b159b4332ec52fc',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 135, 166, 1.00)',
            'rgba(156, 155, 123, 1.00)',
            'rgba(122, 112, 69, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylus [betulaceae]/corylus chinensis/corylus chinensis (3).jpg',
          width: 576,
          id: '3dd0cf17878b1d9eb241cd738a722d6f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 129, 187, 1.00)',
            'rgba(137, 136, 118, 1.00)',
            'rgba(93, 81, 47, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylus [betulaceae]/corylus chinensis/corylus chinensis (1).jpg',
          width: 598,
          id: '25e66df9c3fc85e011f468169a4267ea',
          height: 768,
          thumbnail: true,
        },
        location: [47.271725, -1.587033],
        genre: 'Corylus',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587033, 47.271725] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '38955763387671511c4d96464270bd8eed64b2ec',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'colurna',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 101, 31, 1.00)',
            'rgba(111, 156, 43, 1.00)',
            'rgba(79, 115, 33, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylus [betulaceae]/corylus colurna/corylus colurna (2).jpg',
          width: 576,
          id: '1b98a99b61144201c76c2c1694e22ab7',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 112, 50, 1.00)',
            'rgba(92, 112, 55, 1.00)',
            'rgba(59, 66, 48, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylus [betulaceae]/corylus colurna/corylus colurna (5).jpg',
          width: 576,
          id: '5f01de0e2b04f500591aba87d3e762d6',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 135, 138, 1.00)',
            'rgba(132, 132, 130, 1.00)',
            'rgba(124, 123, 122, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylus [betulaceae]/corylus colurna/corylus colurna (1).jpg',
          width: 576,
          id: 'f3b7f5b8b089eda61c5ae9e10839e42d',
          height: 768,
          thumbnail: true,
        },
        location: [47.271103, -1.581038],
        genre: 'Corylus',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581038, 47.271103] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '45ccb4d8644369deedafa0b03a3ab3a6469fdaaf',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(55, 73, 18, 1.00)',
            'rgba(100, 136, 54, 1.00)',
            'rgba(121, 158, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/catalpa [bignoniaceae]/catalpa bignonioides 'nana'/catalpa bignonioides 'nana' (3).jpg",
          width: 576,
          id: '4e1ec9969bec5c1f4b0e78d66c58f6e4',
          height: 768,
          thumbnail: true,
        },
        espece: 'bignonioides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 146, 65, 1.00)',
            'rgba(119, 155, 74, 1.00)',
            'rgba(115, 155, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/catalpa [bignoniaceae]/catalpa bignonioides 'nana'/catalpa bignonioides 'nana' (2).jpg",
          width: 576,
          id: '2c4f98271b4dd7ed2c88d72fc13ffa59',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(185, 195, 174, 1.00)',
            'rgba(84, 108, 54, 1.00)',
            'rgba(84, 98, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/catalpa [bignoniaceae]/catalpa bignonioides 'nana'/catalpa bignonioides 'nana' (1).jpg",
          width: 1024,
          id: '67e7ccf9c9db3a613b5d00796e16bf16',
          height: 768,
          thumbnail: true,
        },
        location: [47.271692, -1.582797],
        genre: 'Catalpa',
        cultivar: 'Nana',
        famille: 'Bignoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582797, 47.271692] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '80055c4e3067850ebef2b54cef1da6dfc111fbcc',
      fields: {
        origine: 'B.G.Munchen (All.)',
        espece: 'anchusoides Lehm.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Lindelofia',
        date_plantation: '2014',
        famille: 'Boraginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8b0655712e9583f30e3c730099705aa33bf2f03e',
      fields: {
        origine: 'Botanischer Garten,Stuttgart,Allemagne',
        espece: 'stellulata Waldst.& Kit.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Onosma',
        date_plantation: '2014',
        famille: 'Boraginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a75f55c284d5c19cfef13f0c9a4e991bef458820',
      fields: {
        origine: 'B.G. Brno (R\u00e8p.Tch\u00e8que)',
        espece: 'saxatilis Desv.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Aurinia',
        date_plantation: '2014',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2e0b8ba09877d9867f9ec665c8b4d7ee2011dbeb',
      fields: {
        origine: 'Botanischer Garten,Friedrich Jena, Jena, Allemagne',
        espece: 'soyeri Reut. & Huet',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Arabis',
        date_plantation: '2012',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f84fbf30ec8d6273053df524fbc3f1620aa58279',
      fields: {
        origine: 'J.B Marie Curie, Lublin (Pologne)',
        espece: 'pieninicum Pawl.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Erysimum',
        date_plantation: '2011',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '19ad539a2866c5204031df5ed12f25d975f52544',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'tanacetifolia Rchb.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Hugueniania',
        date_plantation: '2009',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5670ea2cf814da34450be2903db5c40fe82ffdf0',
      fields: {
        espece: 'terminalis Sieb. & Zucc.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Pachysandra',
        date_plantation: '1973',
        famille: 'Buxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '109cf0d9b0f2fba7115ae0b5e136e5d21d1c7e81',
      fields: {
        espece: 'terminalis Sieb. & Zucc.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Pachysandra',
        date_plantation: '1973',
        famille: 'Buxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e69598b4465f2ebf8680c5a900d143cdbc6168e6',
      fields: {
        espece: 'hookeriana var. digyna',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 108, 55, 1.00)',
            'rgba(98, 118, 47, 1.00)',
            'rgba(98, 115, 48, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sarcococca [buxaceae]/sarcococca hookeriana var. digyna/sarcococca hookeriana var. digyna (1).jpg',
          width: 576,
          id: '04bfd47665a0b7e1b314897d8d1e8321',
          height: 768,
          thumbnail: true,
        },
        location: [47.270912, -1.58637],
        genre: 'Sarcococca',
        famille: 'Buxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58637, 47.270912] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e1b429ef85e528dd3a631a4c8d7ef20fd4a73f3a',
      fields: {
        espece: 'hookeriana var. digyna',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 112, 44, 1.00)',
            'rgba(104, 125, 51, 1.00)',
            'rgba(125, 148, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sarcococca [buxaceae]/sarcococca hookeriana var. digyna/sarcococca hookeriana var. digyna (2).jpg',
          width: 576,
          id: '093fc34b8595ce14bcfe7cf4323e5516',
          height: 768,
          thumbnail: true,
        },
        location: [47.270908, -1.586375],
        genre: 'Sarcococca',
        famille: 'Buxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586375, 47.270908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4d04b87a793256e660691fd2262e99617f6a53a3',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'orientalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 148, 77, 1.00)',
            'rgba(102, 141, 83, 1.00)',
            'rgba(98, 131, 78, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sarcococca [buxaceae]/sarcococca orientalis/sarcococca orientalis (2).jpg',
          width: 576,
          id: 'fa1a930a084e1c8d5e363d4da8427334',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 139, 74, 1.00)',
            'rgba(106, 138, 98, 1.00)',
            'rgba(75, 103, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sarcococca [buxaceae]/sarcococca orientalis/sarcococca orientalis (3).jpg',
          width: 576,
          id: '55576cf6f5a53735f90b14f6a6c1549e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(175, 183, 154, 1.00)',
            'rgba(99, 121, 57, 1.00)',
            'rgba(62, 66, 40, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sarcococca [buxaceae]/sarcococca orientalis/sarcococca orientalis (1).jpg',
          width: 512,
          id: '2ad7c100dfa9f66fa16283f31743aa65',
          height: 768,
          thumbnail: true,
        },
        location: [47.271195, -1.585705],
        genre: 'Sarcococca',
        famille: 'Buxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585705, 47.271195] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '68cdd843d64c3c84835b6548b207d930dfb8154f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'prunifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 121, 60, 1.00)',
            'rgba(131, 144, 78, 1.00)',
            'rgba(92, 108, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sarcococca [buxaceae]/sarcococca prunifolia/sarcococca prunifolia (2).jpg',
          width: 547,
          id: '049c7d2c57001ee979ffb3c491976c9b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 133, 60, 1.00)',
            'rgba(108, 141, 68, 1.00)',
            'rgba(135, 153, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sarcococca [buxaceae]/sarcococca prunifolia/sarcococca prunifolia (3).jpg',
          width: 576,
          id: 'f231e1bf5ae73b612efd0f7472359b3f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 152, 101, 1.00)',
            'rgba(114, 127, 67, 1.00)',
            'rgba(91, 95, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sarcococca [buxaceae]/sarcococca prunifolia/sarcococca prunifolia (1).jpg',
          width: 624,
          id: 'efbba8e50f5e889b45279a5cd1540e4c',
          height: 768,
          thumbnail: true,
        },
        location: [47.27118, -1.584328],
        genre: 'Sarcococca',
        famille: 'Buxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584328, 47.27118] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'be9d5708b2da6d91c9247ccbb2cf6122c7e96a52',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'pruniformis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 109, 63, 1.00)',
            'rgba(104, 128, 81, 1.00)',
            'rgba(58, 71, 40, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sarcococca [buxaceae]/sarcococca pruniformis/sarcococca pruniformis (2).jpg',
          width: 576,
          id: 'f3e3de45876ab1b7ca487643a7b81e4c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 119, 82, 1.00)',
            'rgba(121, 150, 102, 1.00)',
            'rgba(102, 116, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sarcococca [buxaceae]/sarcococca pruniformis/sarcococca pruniformis (3).jpg',
          width: 576,
          id: '520dbca9f72dddbbce7ff4610a77cfc8',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 127, 71, 1.00)',
            'rgba(113, 145, 88, 1.00)',
            'rgba(83, 111, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sarcococca [buxaceae]/sarcococca pruniformis/sarcococca pruniformis (1).jpg',
          width: 576,
          id: 'c7e5559916b4b088f89c1b0b91852ac5',
          height: 768,
          thumbnail: true,
        },
        location: [47.269903, -1.58252],
        genre: 'Sarcococca',
        famille: 'Buxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58252, 47.269903] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '69ea3791c9b4c9dfa20260671fe3c62315da8368',
      fields: {
        espece: 'siliquastrum f. albida',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 78, 36, 1.00)',
            'rgba(123, 140, 66, 1.00)',
            'rgba(105, 106, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cercis [caesalpiniaceae]/cercis siliquastrum f. albida/cercis siliquastrum f. albida (2).jpg',
          width: 576,
          id: 'c10753125b4be680705e637143003252',
          height: 768,
          thumbnail: true,
        },
        location: [47.270825, -1.585337],
        genre: 'Cercis',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585337, 47.270825] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9172ab745373f0f870a63ea7214ea8c647c52342',
      fields: {
        origine: 'B.G. Karelia (Russie)',
        espece: 'patula L.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Campanula',
        date_plantation: '2014',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c13e0b8b856796c00bbc68af15f033c59a04831b',
      fields: {
        origine: 'Botanic Garden of Siauliai University, Siauliai, Lituanie',
        espece: 'ovata Benth.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Codonopsis',
        date_plantation: '2012',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '397060e1fea1d97069f3bb728188c1014ac52012',
      fields: {
        origine: 'Botanischer Garten Bonn (All.)',
        espece: 'trachelium L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Campanula',
        date_plantation: '2015',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ecbe115d9e2e1c5b131cdc3752bfae181ce9128a',
      fields: {
        origine: 'Goteborg Botanical Garden(Su\u00e8de)',
        espece: 'tommasiniana Koch',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Campanula',
        date_plantation: '2014',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '417247394c1e36e0999dbee98b27ed03ed4bad38',
      fields: {
        origine: 'JB.et Museum de Berolino-Dahlem (Allemagne)',
        espece: 'fenestrellata Feer.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Campanula',
        date_plantation: '2006',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f2a1b703e3007de11684278b135b87de06f4faf0',
      fields: {
        origine: 'JB.Kyoto (Japon)',
        espece: 'punctata Lam.',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Campanula',
        date_plantation: '1998',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dc9804d237a3d3e86969313f7908fdff2ba5ccbc',
      fields: {
        origine: 'JB.Lausanne (Suisse)',
        espece: 'incurva Aucher.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Campanula',
        date_plantation: '1992',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '53c5168f3eb9c5d69c2b9aadf1065008dc6ac05f',
      fields: {
        origine: 'JB.Royal Zoological (Rotterdam)',
        espece: 'nana Lam.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Campanula',
        date_plantation: '1990',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c4572f202dfc9006401ce0ec46473b862f25c278',
      fields: {
        origine: "Mus\u00e9um d'Histoire Naturelle de Paris",
        espece: 'scheuchzeri Vill.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Campanula',
        date_plantation: '2006',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5c903efa2f5d4ad35cce2be38527a236096cfdb8',
      fields: {
        origine: 'J.B.Porrentruy,Belgique',
        espece: 'gibbosa Maxim.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Patrinia',
        date_plantation: '2014',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6393e6943cbaac901975e505ee10de0609ea398a',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'alliariifolia Adams',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Valeriana',
        date_plantation: '2006',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4486314bf6c9bbfa586467279c215153dfd9c423',
      fields: {
        origine: 'JB.P\u00e9kin (Chine)',
        espece: 'heterophylla Bunge',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Patrinia',
        date_plantation: '2008',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b2e4818b490b2bb261a1b85e4a660e33aa7d7396',
      fields: {
        origine: 'JB.W.J Beal Michigan (USA.)',
        espece: 'wallrothii  Kreyer',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Valeriana',
        date_plantation: '2008',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0512dddebf41305909ea15d100d121e99341d3f8',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(186, 182, 164, 1.00)',
            'rgba(113, 106, 73, 1.00)',
            'rgba(116, 103, 78, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia chinensis 'variegata'/abelia chinensis 'variegata' (3).jpg",
          width: 1024,
          id: '9c023b3f7a29ac5207fd52536919b8ef',
          height: 768,
          thumbnail: true,
        },
        espece: 'chinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 143, 100, 1.00)',
            'rgba(125, 123, 73, 1.00)',
            'rgba(93, 92, 38, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia chinensis 'variegata'/abelia chinensis 'variegata' (2).jpg",
          width: 576,
          id: '29129f6452cd52748cf5235f92775f8a',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 147, 102, 1.00)',
            'rgba(136, 136, 77, 1.00)',
            'rgba(99, 118, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia chinensis 'variegata'/abelia chinensis 'variegata' (1).jpg",
          width: 1024,
          id: '2711ea5fb09af04a8c2a8976510d922e',
          height: 768,
          thumbnail: true,
        },
        location: [47.271642, -1.58452],
        genre: 'Abelia',
        cultivar: 'Variegata',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58452, 47.271642] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2c169c6985858e6b6f0e8c7a8b9e5778cd210d9b',
      fields: {
        espece: 'chinensis',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(69, 94, 64, 1.00)',
            'rgba(76, 98, 67, 1.00)',
            'rgba(67, 82, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia chinensis/abelia chinensis  (1).jpg',
          width: 576,
          id: '3782988e4cb65cd5213b39858da9a371',
          height: 768,
          thumbnail: true,
        },
        location: [47.271539, -1.580653],
        genre: 'Abelia',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580653, 47.271539] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3aec853176b24c305879a63448b7721ba5b50259',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'mosanensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 152, 73, 1.00)',
            'rgba(139, 153, 71, 1.00)',
            'rgba(113, 129, 49, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia mosanensis/abelia mosanensis (2).jpg',
          width: 576,
          id: 'b0dde4e9ce8bc95835cb25ca7045e9db',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 126, 81, 1.00)',
            'rgba(111, 139, 83, 1.00)',
            'rgba(80, 118, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia mosanensis/abelia mosanensis (3).jpg',
          width: 512,
          id: '66d653812419c03146c302172327a763',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 145, 69, 1.00)',
            'rgba(119, 131, 70, 1.00)',
            'rgba(95, 113, 37, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia mosanensis/abelia mosanensis (1).jpg',
          width: 576,
          id: '108837fdfc104e44a205de73efa44e8a',
          height: 768,
          thumbnail: true,
        },
        location: [47.270983, -1.582905],
        genre: 'Abelia',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582905, 47.270983] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6ef7a845fe084b9a66c649d688009b3e022a78dc',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'amabilis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 123, 81, 1.00)',
            'rgba(117, 130, 89, 1.00)',
            'rgba(87, 102, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/kolkwitzia [caprifoliaceae]/kolkwitzia amabilis/kolkwitzia amabilis (4).jpg',
          width: 1024,
          id: 'b6911f0a81e6f5f49c3f414699defac1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 104, 71, 1.00)',
            'rgba(128, 138, 106, 1.00)',
            'rgba(108, 102, 80, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/kolkwitzia [caprifoliaceae]/kolkwitzia amabilis/kolkwitzia amabilis (5).jpg',
          width: 576,
          id: '53e1110a68f1a33d6e7b89fe92b3a895',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(69, 76, 54, 1.00)',
            'rgba(133, 132, 123, 1.00)',
            'rgba(99, 104, 91, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/kolkwitzia [caprifoliaceae]/kolkwitzia amabilis/kolkwitzia amabilis  (1).jpg',
          width: 576,
          id: 'fc004a8874ecc8bc79b15739fb6650d5',
          height: 768,
          thumbnail: true,
        },
        location: [47.270705, -1.58403],
        genre: 'Kolkwitzia',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58403, 47.270705] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c151b4aae2e77eed3fa1cb30280f18ac1f5e4d77',
      fields: {
        espece: 'amabilis',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 161, 119, 1.00)',
            'rgba(94, 112, 71, 1.00)',
            'rgba(69, 84, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/kolkwitzia [caprifoliaceae]/kolkwitzia amabilis/kolkwitzia amabilis  (2).jpg',
          width: 1024,
          id: '4fb2ad2d57632c79a84a6b73d9bdb04a',
          height: 768,
          thumbnail: true,
        },
        location: [47.270767, -1.586047],
        genre: 'Kolkwitzia',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586047, 47.270767] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1716543339d32643518790013539683cbfcc32ef',
      fields: {
        espece: 'formosa',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 158, 113, 1.00)',
            'rgba(140, 131, 121, 1.00)',
            'rgba(111, 148, 107, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/leycesteria [caprifoliaceae]/leycesteria formosa 'purple rain'/leycesteria formosa 'purple rain' (3).jpg",
          width: 576,
          id: '8137e930c5450bc810eb85c32071797b',
          height: 768,
          thumbnail: true,
        },
        location: [47.271647, -1.586847],
        genre: 'Leycesteria',
        cultivar: 'Purple Rain',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586847, 47.271647] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a0cf0289b66452666384fbd0497e05226af8419d',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'formosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 125, 85, 1.00)',
            'rgba(120, 131, 77, 1.00)',
            'rgba(93, 125, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/leycesteria [caprifoliaceae]/leycesteria formosa/leycesteria formosa (2).jpg',
          width: 576,
          id: '273fd4f450ed7e2094058a594a7b782f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 145, 62, 1.00)',
            'rgba(107, 148, 63, 1.00)',
            'rgba(110, 143, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/leycesteria [caprifoliaceae]/leycesteria formosa/leycesteria formosa (3).jpg',
          width: 576,
          id: '7c5a9f7c9746819c9afc5cd9724266a9',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 152, 81, 1.00)',
            'rgba(117, 136, 79, 1.00)',
            'rgba(131, 132, 91, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/leycesteria [caprifoliaceae]/leycesteria formosa/leycesteria formosa (1).jpg',
          width: 1024,
          id: '48682efe74dad709be72631c80bd42d3',
          height: 768,
          thumbnail: true,
        },
        location: [47.26953, -1.584905],
        genre: 'Leycesteria',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584905, 47.26953] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8116ab6fb48b164ae6bb97e25103c369e80d484e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x bella',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 159, 105, 1.00)',
            'rgba(142, 144, 77, 1.00)',
            'rgba(109, 119, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera x bella/lonicera x bella (2).jpg',
          width: 576,
          id: 'd12bd3912001ef5bbfcb506eea2aebc6',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 150, 100, 1.00)',
            'rgba(143, 136, 83, 1.00)',
            'rgba(106, 101, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera x bella/lonicera x bella (3).jpg',
          width: 576,
          id: '81de8df4b79e0b8bb233f63d3d641fda',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(167, 171, 127, 1.00)',
            'rgba(124, 140, 51, 1.00)',
            'rgba(105, 125, 39, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera x bella/lonicera x bella (1).jpg',
          width: 576,
          id: 'fd905d8e30823bcd519183b8615d055f',
          height: 768,
          thumbnail: true,
        },
        location: [47.269908, -1.584617],
        genre: 'Lonicera',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584617, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b829e6c6d4a456ec96f468fe12497c5a25a8b329',
      fields: {
        origine: 'Alpengarten Wien (Autriche)',
        espece: 'austriaca Hayek',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Minuartia',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c4dc100f4c629971d87f16f66d0b13c8d8838975',
      fields: {
        origine: 'B.G. de Kosice (Slovaquie)',
        espece: 'langii Holub.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Minuartia',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6820545fe839d2319a05c197608f4de81821f70e',
      fields: {
        origine: 'B.G.Munchen (All.)',
        espece: 'orientalis Adams',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Dianthus',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '74475b39e64234c18ef0ecf5d28cedb359ed4c70',
      fields: {
        origine: 'Botanische Garten (Meckenheimer), Bonn, Allemagne',
        espece: 'frivaldszkyana Hampe',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Silene',
        date_plantation: '2012',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '00c94d0fb0c36d2d1fe24093c8e7b9fbf897fbc3',
      fields: {
        origine: 'Conservatoire et JB.de Gen\u00e8ve (Suisse)',
        espece: 'suecica Greuter & Burdet',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Silene',
        date_plantation: '2006',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5cf3e6bfb8bc64783a3122df9dc220e4cf28e8c0',
      fields: {
        origine: 'Hortus Botanicus Bratislava (Slovaquie)',
        espece: 'suksdorfii B.L.Rob.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Silene',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6cb66b07ccb97fb8d9672d30a8f9b7259aed919e',
      fields: {
        origine: 'J.B.ST.Andrews,Ecosse',
        espece: 'preslii Sekera',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Lychnis',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '14ee1ead217a8c3aed2fe378f5348ec573a70481',
      fields: {
        origine: 'JB.Bremen (Allemagne)',
        espece: 'gratianopolitanus Vill.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Dianthus',
        date_plantation: '2009',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9950c169ce5aec6f8564f3467542d44553c28ca7',
      fields: {
        origine: 'JB.Novgorood (Russie)',
        espece: 'uralensis Korsh.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Dianthus',
        date_plantation: '2006',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '91420ff671d4a615b096181149a1afa02c2b8053',
      fields: {
        origine: 'JB.Oberhof (Allemagne)',
        espece: 'schafta S.G.Gmel.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Silene',
        date_plantation: '2009',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a0e48d8e50f9aaae7af8411e4f34bf51449114d3',
      fields: {
        origine: 'JBU.et Arbor\u00e9tum Brno (R\u00e9p.Tch\u00e8que)',
        espece: 'serotinus Waldst. et Kit.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Dianthus',
        date_plantation: '1989',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e72286c780fc4cb5355648c6d4839c7e958fec6e',
      fields: {
        origine: 'JBU.Vitebsk (Bielorussie)',
        espece: 'plumarius L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Dianthus',
        date_plantation: '2006',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '61e750f6742011bf33687f6bae5024b1642031b8',
      fields: {
        origine: 'origine perdue,culture enclo bota pour AO',
        espece: 'paniculata L.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Gypsophila',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '81a7c9801e07632a33eada4e487d637c468fd8c8',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 103, 66, 1.00)',
            'rgba(103, 113, 63, 1.00)',
            'rgba(108, 120, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus 'den haag'/euonymus 'den haag' (10).jpg",
          width: 600,
          id: '5c584fa4d785ccc8b6cb309a3a2303ec',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 122, 119, 1.00)',
            'rgba(131, 93, 90, 1.00)',
            'rgba(135, 101, 94, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus 'den haag'/euonymus 'den haag' (6).jpg",
          width: 1024,
          id: '69a732430ba2e606691e5ff8c7199ca6',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 101, 65, 1.00)',
            'rgba(95, 113, 57, 1.00)',
            'rgba(108, 116, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus 'den haag'/euonymus 'den haag' (1).jpg",
          width: 625,
          id: '1c3a2716a8b1bf9a3a27850d8ba859c2',
          height: 768,
          thumbnail: true,
        },
        location: [47.270295, -1.586425],
        genre: 'Euonymus',
        cultivar: 'Den Haag',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586425, 47.270295] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '62ab7c61628219ce25ad679c596e22d329549493',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'carnosus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 124, 93, 1.00)',
            'rgba(100, 123, 85, 1.00)',
            'rgba(91, 113, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus carnosus/euonymus carnosus (5).jpg',
          width: 576,
          id: 'eed6cd5358379372e64005632521d542',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 124, 98, 1.00)',
            'rgba(143, 115, 99, 1.00)',
            'rgba(121, 102, 74, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus carnosus/euonymus carnosus (7).jpg',
          width: 576,
          id: '7261d3d33654cab96679a335f63dd404',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 116, 87, 1.00)',
            'rgba(177, 103, 109, 1.00)',
            'rgba(164, 77, 86, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus carnosus/euonymus carnosus (4).jpg',
          width: 576,
          id: '5d3fdcdc16458e1674cbedf2bf3ddcbf',
          height: 768,
          thumbnail: true,
        },
        location: [47.271638, -1.582563],
        genre: 'Euonymus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582563, 47.271638] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '31ef6b1983608312bd2ae5afafb4ea83a319bbd0',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'europaeus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 128, 124, 1.00)',
            'rgba(144, 120, 114, 1.00)',
            'rgba(108, 105, 78, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus europaeus/euonymus europaeus (1).jpg',
          width: 576,
          id: '4a41c6d9b8ae0ce4c57c0c3e51acc48e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 143, 64, 1.00)',
            'rgba(114, 141, 57, 1.00)',
            'rgba(68, 99, 30, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus europaeus/euonymus europaeus (3).jpg',
          width: 576,
          id: 'be7b306afb7a6c6842d9d77e9aecd6e2',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 128, 108, 1.00)',
            'rgba(137, 125, 107, 1.00)',
            'rgba(115, 88, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus europaeus/euonymus europaeus  (3).jpg',
          width: 576,
          id: '557adf351315c756677a2db4022ebb59',
          height: 768,
          thumbnail: true,
        },
        location: [47.27042, -1.583962],
        genre: 'Euonymus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583962, 47.27042] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bfd6cec9399a888baaa4c4636bc29d019c4dfd91',
      fields: {
        espece: 'hamiltonianus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 123, 86, 1.00)',
            'rgba(109, 127, 83, 1.00)',
            'rgba(93, 109, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus hamiltonianus 'coral charm'/euonymus hamiltonianus 'coral charm' (3).jpg",
          width: 576,
          id: '894c916ac0c6d8ce13f1374136426e6d',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 112, 92, 1.00)',
            'rgba(124, 136, 103, 1.00)',
            'rgba(79, 99, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus hamiltonianus 'coral charm'/euonymus hamiltonianus 'coral charm' (1).jpg",
          width: 576,
          id: 'd116c0b36fe547e57ea4622c54675a3b',
          height: 768,
          thumbnail: true,
        },
        location: [47.269995, -1.581512],
        genre: 'Euonymus',
        cultivar: 'Coral Charm',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581512, 47.269995] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f3c276f0f6579cfe68689082b50260383882ed24',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'myrianthus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 126, 83, 1.00)',
            'rgba(107, 128, 68, 1.00)',
            'rgba(75, 111, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus myrianthus/euonymus myrianthus (10).jpg',
          width: 1024,
          id: 'e141ac9b3248d6df1de561d9d8cdf991',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 133, 117, 1.00)',
            'rgba(90, 96, 69, 1.00)',
            'rgba(78, 84, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus myrianthus/euonymus myrianthus (11).jpg',
          width: 1024,
          id: '898ffcef52c3261ecc4f5bf705b535b7',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 123, 101, 1.00)',
            'rgba(121, 117, 83, 1.00)',
            'rgba(102, 97, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus myrianthus/euonymus myrianthus (1).jpg',
          width: 576,
          id: '5de6f452a041c74e937cb983903fcff3',
          height: 768,
          thumbnail: true,
        },
        location: [47.270372, -1.584875],
        genre: 'Euonymus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584875, 47.270372] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '469ff3b0882909aba3a282af704efc7d55f2ee4e',
      fields: {
        origine: 'JB.Neuch\u00e2tel. (Suisse)',
        espece: 'magnificum',
        localisation: 'B7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198817, -1.5442188],
        genre: 'Cercidiphyllum',
        date_plantation: '1987',
        famille: 'Cercidiphyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442188, 47.2198817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bf91f95b5552e62f32e4d1bdc9d45fd7436637b1',
      fields: {
        origine: 'Botanische Garten Bonn (All.)',
        espece: 'ovatum Dun.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Helianthemum',
        date_plantation: '2014',
        famille: 'Cistaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '619bfd83d9b0a377851a78df1619fc9c74ff8ad3',
      fields: {
        origine: 'J.Alp.U.Insbruck (Autriche)',
        espece: 'thymifolia',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Fumana',
        date_plantation: '2006',
        famille: 'Cistaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9909938c4471f429b3a1ef4bf5c7cfe67a87a75d',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'alnifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 133, 63, 1.00)',
            'rgba(115, 136, 71, 1.00)',
            'rgba(85, 110, 35, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/clethra [clethraceae]/clethra alnifolia/clethra alnifolia (2).jpg',
          width: 576,
          id: '0868a27b3fee19cb8449d869c9f88dcb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 126, 53, 1.00)',
            'rgba(117, 165, 55, 1.00)',
            'rgba(102, 148, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/clethra [clethraceae]/clethra alnifolia/clethra alnifolia (3).jpg',
          width: 576,
          id: '8746a7aa8c618595ef4377b6944d6d47',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 133, 44, 1.00)',
            'rgba(109, 153, 49, 1.00)',
            'rgba(109, 147, 39, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/clethra [clethraceae]/clethra alnifolia/clethra alnifolia (1).jpg',
          width: 576,
          id: '6cfe6ac27984fa3b1adbc5a40b4aea68',
          height: 768,
          thumbnail: true,
        },
        location: [47.270897, -1.581175],
        genre: 'Clethra',
        famille: 'Clethraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581175, 47.270897] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd540597b47b0c80182d51556c860d0545f0b0c0c',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'acuminata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 116, 58, 1.00)',
            'rgba(96, 113, 50, 1.00)',
            'rgba(92, 108, 38, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/camptotheca [cornaceae]/camptotheca acuminata/camptotheca acuminata (2).jpg",
          width: 576,
          id: '41b79fa28d7535f3800c779bbf37ee3f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 126, 165, 1.00)',
            'rgba(106, 134, 158, 1.00)',
            'rgba(85, 93, 74, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/camptotheca [cornaceae]/camptotheca acuminata/camptotheca acuminata (4).jpg",
          width: 1024,
          id: 'd8ebbb9c9fb26aeb1efdc07b1d8dd3f6',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 174, 155, 1.00)',
            'rgba(125, 135, 94, 1.00)',
            'rgba(76, 87, 39, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/camptotheca [cornaceae]/camptotheca acuminata/camptotheca acuminata (1).jpg",
          width: 576,
          id: 'f830e191b9f5982c95ae51977c317072',
          height: 768,
          thumbnail: true,
        },
        location: [47.226928, -1.512697],
        genre: 'Camptotheca',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512697, 47.226928] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4ab94ea19c55f9d4da1e4e2c50dff3bc80cb0595',
      fields: {
        espece: 'alternifolia',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 118, 63, 1.00)',
            'rgba(123, 146, 90, 1.00)',
            'rgba(118, 137, 84, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus alternifolia 'argentea'/cornus alternifolia 'argentea' (4).jpg",
          width: 576,
          id: '6e0ba92220de0589313a8218d0f46d66',
          height: 768,
          thumbnail: true,
        },
        location: [47.27112, -1.585588],
        genre: 'Cornus',
        cultivar: 'Argentea',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585588, 47.27112] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c98bcb9bda9b3505925a830cdc48d1c9cd820d89',
      fields: {
        espece: 'capitata',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 146, 117, 1.00)',
            'rgba(155, 114, 114, 1.00)',
            'rgba(84, 95, 70, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus capitata/cornus capitata.jpg',
          width: 576,
          id: 'ca34bf7d422aeb0a171eb41494c567a2',
          height: 768,
          thumbnail: true,
        },
        location: [47.270303, -1.582278],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582278, 47.270303] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c18014d2f1d1b45c21130d349a154756e74b27d0',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 149, 79, 1.00)',
            'rgba(110, 136, 57, 1.00)',
            'rgba(100, 107, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus controversa 'pagoda'/cornus controversa 'pagoda'  (4).jpg",
          width: 1024,
          id: 'a4ef75b9f45a1d6e476bfdc37347a4ed',
          height: 718,
          thumbnail: true,
        },
        espece: 'controversa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 171, 54, 1.00)',
            'rgba(107, 153, 28, 1.00)',
            'rgba(118, 131, 52, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus controversa 'pagoda'/cornus controversa 'pagoda'  (3).jpg",
          width: 576,
          id: 'ffedef69dd71ba2a8213b3d0a0ff6d43',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 98, 50, 1.00)',
            'rgba(140, 145, 106, 1.00)',
            'rgba(64, 79, 27, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus controversa 'pagoda'/cornus controversa 'pagoda'  (2).jpg",
          width: 576,
          id: '975090b7301972fe93761f3cbd7785f7',
          height: 768,
          thumbnail: true,
        },
        location: [47.270655, -1.581008],
        genre: 'Cornus',
        cultivar: 'Pagoda',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581008, 47.270655] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4a4137005de6b0756748ad7cf5a8bb76cf7f0a69',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 127, 114, 1.00)',
            'rgba(173, 116, 113, 1.00)',
            'rgba(158, 132, 121, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida 'cherokee chief'/cornus florida 'cherokee chief'.jpg",
          width: 599,
          id: '4a8716d732d6cf438dc3958af415aa35',
          height: 768,
          thumbnail: true,
        },
        espece: 'florida',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 99, 86, 1.00)',
            'rgba(157, 134, 140, 1.00)',
            'rgba(106, 86, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida 'cherokee chief'/cornus florida 'cherokee chief' (3).jpg",
          width: 576,
          id: '7cfafc3dc9970f942588b8e9eb380fc0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 134, 128, 1.00)',
            'rgba(147, 82, 77, 1.00)',
            'rgba(106, 103, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida 'cherokee chief'/cornus florida 'cherokee chief' (1).jpg",
          width: 576,
          id: 'a9e0b55bdddc3ed50aeba784c89ed41e',
          height: 768,
          thumbnail: true,
        },
        location: [47.271728, -1.582862],
        genre: 'Cornus',
        cultivar: 'Cherokee Chief',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582862, 47.271728] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5d17869fd0aca1396904dec697211f21a1fccee5',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'florida f. rubra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 115, 86, 1.00)',
            'rgba(138, 135, 114, 1.00)',
            'rgba(79, 83, 42, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida f. rubra/cornus florida f. rubra (2).jpg',
          width: 576,
          id: '8a8706a9923c9d0a62b5d09a15d29324',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(63, 60, 42, 1.00)',
            'rgba(125, 98, 90, 1.00)',
            'rgba(57, 52, 37, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida f. rubra/cornus florida f. rubra (4).jpg',
          width: 576,
          id: 'cfc3d532b8e220cd9dd6affb609ba01f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 127, 112, 1.00)',
            'rgba(108, 79, 59, 1.00)',
            'rgba(57, 50, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida f. rubra/cornus florida f. rubra  (2).jpg',
          width: 573,
          id: '691db93f7cc9a6a691f506e385447cdc',
          height: 768,
          thumbnail: true,
        },
        location: [47.271022, -1.58055],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58055, 47.271022] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5b6bcef0c7f0084839c1e14953610e494001e639',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 119, 92, 1.00)',
            'rgba(82, 102, 79, 1.00)',
            'rgba(39, 60, 37, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'bultinck's beauty'/cornus kousa 'bultinck's beauty' (6).jpg",
          width: 1024,
          id: '9c88e75b57de1c1e053bc394c6a4b23b',
          height: 683,
          thumbnail: true,
        },
        espece: 'kousa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(60, 79, 57, 1.00)',
            'rgba(87, 104, 83, 1.00)',
            'rgba(89, 101, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'bultinck's beauty'/cornus kousa 'bultinck's beauty' (5).jpg",
          width: 1024,
          id: 'f8e79d57271c44398c54627e02e86e61',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 122, 105, 1.00)',
            'rgba(78, 98, 70, 1.00)',
            'rgba(83, 92, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'bultinck's beauty'/cornus kousa 'bultinck's beauty' (2).jpg",
          width: 1024,
          id: 'ac1015fbbfd2bf424238579e40f2fba8',
          height: 683,
          thumbnail: true,
        },
        location: [47.27042, -1.581333],
        genre: 'Cornus',
        cultivar: "Bultinck's Beauty",
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581333, 47.27042] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '05b7aa43978688282285ecc02af63145a80479a6',
      fields: {
        espece: 'macrophylla',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 97, 50, 1.00)',
            'rgba(83, 85, 30, 1.00)',
            'rgba(82, 81, 26, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus macrophylla/cornus macrophylla (a1) (5).jpg',
          width: 1024,
          id: '14646b9760e48815a6b00e290abb9a7e',
          height: 669,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 102, 73, 1.00)',
            'rgba(113, 116, 88, 1.00)',
            'rgba(99, 102, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus macrophylla/cornus macrophylla (a1) (4).jpg',
          width: 1024,
          id: '0a0f8ba1fee800fdd174ca394a870a08',
          height: 683,
          thumbnail: true,
        },
        location: [47.269474, -1.584671],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584671, 47.269474] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5b1a1613daf4cccecfe13e981fac298c9a248232',
      fields: {
        espece: 'mas',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 142, 100, 1.00)',
            'rgba(124, 131, 76, 1.00)',
            'rgba(82, 105, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus mas 'spring glory'/cornus mas 'spring glory' (4).jpg",
          width: 576,
          id: '9e6844f2800d3376720a1a860798dfdb',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 139, 82, 1.00)',
            'rgba(111, 141, 102, 1.00)',
            'rgba(115, 127, 109, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus mas 'spring glory'/cornus mas 'spring glory' (3).jpg",
          width: 576,
          id: '39d92f5b438e758d552fa79b1572dd0a',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Cornus',
        cultivar: 'Spring Glory',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f1d12ce37c7d5e5b20cc7bfa61fadf9099408a76',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'pavia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 147, 101, 1.00)',
            'rgba(133, 130, 76, 1.00)',
            'rgba(136, 136, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus pavia/aesculus pavia (10).jpg',
          width: 576,
          id: '5da172b6fee0a173a982957a5155f747',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 137, 95, 1.00)',
            'rgba(128, 136, 65, 1.00)',
            'rgba(140, 149, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus pavia/aesculus pavia (11).jpg',
          width: 576,
          id: 'f654fcb37748179e8977be8766f83147',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(63, 68, 30, 1.00)',
            'rgba(112, 89, 49, 1.00)',
            'rgba(114, 108, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus pavia/aesculus pavia (1).jpg',
          width: 518,
          id: '997abf9d22f4d2a687242cb671a8a73e',
          height: 768,
          thumbnail: true,
        },
        location: [47.270988, -1.586163],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586163, 47.270988] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9cf78c4cf5d5287f9628bc1cc81c6cc897ba01e3',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 141, 127, 1.00)',
            'rgba(132, 132, 119, 1.00)',
            'rgba(109, 97, 94, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus x neglecta 'erythroblastos'/aesculus x neglecta 'erythroblastos'  (3).jpg",
          width: 576,
          id: 'c32b523ae629b026a003b5f47079e145',
          height: 768,
          thumbnail: true,
        },
        espece: 'x neglecta',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(230, 233, 216, 1.00)',
            'rgba(102, 118, 59, 1.00)',
            'rgba(51, 58, 26, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus x neglecta 'erythroblastos'/aesculus x neglecta 'erythroblastos'  (2).jpg",
          width: 576,
          id: '2d64b6b4b67080316b698dc3029da6ed',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 113, 63, 1.00)',
            'rgba(147, 136, 69, 1.00)',
            'rgba(120, 123, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus x neglecta 'erythroblastos'/aesculus x neglecta 'erythroblastos'  (1).jpg",
          width: 1024,
          id: '3f71ebef45751e49d07baa98a409a378',
          height: 768,
          thumbnail: true,
        },
        location: [47.27108, -1.582028],
        genre: 'Aesculus',
        cultivar: 'Erythroblastos',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582028, 47.27108] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '76f267974c0ee550714a1ca55445e50dde969557',
      fields: {
        espece: 'x carnea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(176, 178, 146, 1.00)',
            'rgba(114, 121, 73, 1.00)',
            'rgba(93, 103, 62, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/aesculus [sapindaceae]/aesculus x carnea/aesculus x carnea (2).jpg',
          width: 1024,
          id: 'b97ea0251291975d986bce38c96a27b1',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 118, 67, 1.00)',
            'rgba(153, 124, 89, 1.00)',
            'rgba(129, 119, 70, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/aesculus [sapindaceae]/aesculus x carnea/aesculus x carnea (1).jpg',
          width: 576,
          id: '1e60ae7dd14f5442ab2fe4fe7f177577',
          height: 768,
          thumbnail: true,
        },
        location: [47.263042, -1.531845],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531845, 47.263042] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8d945b34b7f37943c72ab66f25593d610b22aaab',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'cainito',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 102, 55, 1.00)',
            'rgba(107, 106, 67, 1.00)',
            'rgba(87, 100, 67, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/chrysophyllum [sapotaceae]/chrysophyllum cainito/chrysophyllum cainito (2).jpg",
          width: 576,
          id: 'e75574f47f2b1797b3555f336addfb1d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 147, 48, 1.00)',
            'rgba(123, 165, 44, 1.00)',
            'rgba(102, 135, 35, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/chrysophyllum [sapotaceae]/chrysophyllum cainito/chrysophyllum cainito.jpg",
          width: 576,
          id: 'cf27c6ab0cfcc300a02ff226c0d5eadc',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 134, 80, 1.00)',
            'rgba(144, 133, 67, 1.00)',
            'rgba(90, 96, 42, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/chrysophyllum [sapotaceae]/chrysophyllum cainito/chrysophyllum cainito (1).jpg",
          width: 576,
          id: 'a9f1cf401a9e3778e2e593f936c513a4',
          height: 768,
          thumbnail: true,
        },
        location: [47.226933, -1.511922],
        genre: 'Chrysophyllum',
        famille: 'Sapotaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.511922, 47.226933] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a8bdeadcf9c87a4f5ca59bc7fdd21d17fe8bd0f2',
      fields: {
        espece: 'umbrosa L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Saxifraga',
        date_plantation: '1973',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8e4be9d3fd9bd7c67506921f6aa99c3344093950',
      fields: {
        espece: 'barbarum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 132, 98, 1.00)',
            'rgba(135, 141, 99, 1.00)',
            'rgba(138, 125, 105, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lycium [solanaceae]/lycium barbarum/lycium barbarum (2).jpg',
          width: 1024,
          id: 'f26b2f78231a68182adc4a4a4a135309',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 140, 89, 1.00)',
            'rgba(155, 140, 113, 1.00)',
            'rgba(155, 143, 112, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lycium [solanaceae]/lycium barbarum/lycium barbarum (1).jpg',
          width: 576,
          id: 'b0f1b050ba024c18dc32d2643f16c6da',
          height: 768,
          thumbnail: true,
        },
        location: [47.271508, -1.581128],
        genre: 'Lycium',
        famille: 'Solanaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581128, 47.271508] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '181766184b94ad3619007a2264446d9751fa151f',
      fields: {
        espece: 'barbarum',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 149, 143, 1.00)',
            'rgba(130, 111, 92, 1.00)',
            'rgba(114, 101, 88, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/lycium [solanaceae]/lycium barbarum/lycium barbarum.jpg",
          width: 576,
          id: '80ec26d6e378c3ab8e477ae1c0bc8973',
          height: 768,
          thumbnail: true,
        },
        location: [47.226767, -1.512363],
        genre: 'Lycium',
        famille: 'Solanaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512363, 47.226767] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4642dd8374205d13bff8e6c4056e28a17c12d2d0',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'carolina',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(63, 69, 25, 1.00)',
            'rgba(139, 137, 104, 1.00)',
            'rgba(104, 90, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/halesia [styracaceae]/halesia carolina/halesia carolina (10).jpg',
          width: 1024,
          id: 'ae12887c88576442d84966d7dd3ad886',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 176, 153, 1.00)',
            'rgba(133, 140, 96, 1.00)',
            'rgba(83, 96, 42, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/halesia [styracaceae]/halesia carolina/halesia carolina (5).jpg',
          width: 576,
          id: '0a45d4dbd9229e1d5449ba1a5b074ba4',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 150, 104, 1.00)',
            'rgba(111, 128, 84, 1.00)',
            'rgba(57, 69, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/halesia [styracaceae]/halesia carolina/halesia carolina (1).jpg',
          width: 1024,
          id: 'b733cd20f309b3ce41c351cf4acaa0f3',
          height: 768,
          thumbnail: true,
        },
        location: [47.271017, -1.581067],
        genre: 'Halesia',
        famille: 'Styracaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581067, 47.271017] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2afae28b6e03adb00ec9b375cbd4a6e18b5b5053',
      fields: {
        espece: 'macrocarpum',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 96, 63, 1.00)',
            'rgba(94, 115, 78, 1.00)',
            'rgba(79, 113, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/rehderodendron [styracaceae]/rehderodendron macrocarpum/rehderodendron macrocarpum.jpg',
          width: 1024,
          id: '9c5d7f09b9a23893515c5a48fe278f0f',
          height: 683,
          thumbnail: true,
        },
        location: [47.271263, -1.5863],
        genre: 'Rehderodendron',
        famille: 'Styracaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5863, 47.271263] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'df072d8c9f16bd1ec4324ba79cfbe24483c8a22c',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 132, 71, 1.00)',
            'rgba(136, 140, 79, 1.00)',
            'rgba(112, 112, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/styrax [styracaceae]/styrax japonicus 'masaku'/styrax japonicus 'masaku'.jpg",
          width: 1024,
          id: 'f19ed7c7bcc41ead0c5e3399791f08d1',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonicus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 140, 84, 1.00)',
            'rgba(127, 137, 78, 1.00)',
            'rgba(116, 129, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/styrax [styracaceae]/styrax japonicus 'masaku'/styrax japonicus 'masaku' (2).jpg",
          width: 576,
          id: '2ffd6b3890ab699a0ffd191141659082',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 125, 76, 1.00)',
            'rgba(133, 126, 98, 1.00)',
            'rgba(84, 78, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/styrax [styracaceae]/styrax japonicus 'masaku'/styrax japonicus 'masaku' (1).jpg",
          width: 576,
          id: 'ebb0e0b74bf19aea80183979bfc11ff3',
          height: 768,
          thumbnail: true,
        },
        location: [47.271453, -1.586228],
        genre: 'Styrax',
        cultivar: 'Masaku',
        famille: 'Styracaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586228, 47.271453] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '93e75b17401646d5e3b4d390d205948756d1b287',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 139, 124, 1.00)',
            'rgba(114, 110, 94, 1.00)',
            'rgba(112, 99, 96, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'cornish spring'/camellia 'cornish spring'.jpg",
          width: 1024,
          id: '090a4fe40d88bd8a1ef3d96355f6c554',
          height: 683,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Cornish Spring',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a48ab7baaf03c0609be967217e9da668323dcc92',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 107, 88, 1.00)',
            'rgba(122, 135, 112, 1.00)',
            'rgba(80, 92, 81, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'magali'/camellia 'magali' (2).jpg",
          width: 512,
          id: '07628fd27ba47eb2de89dae2e5b987e1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 134, 118, 1.00)',
            'rgba(136, 112, 111, 1.00)',
            'rgba(59, 64, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'magali'/camellia 'magali' (3).jpg",
          width: 530,
          id: '5a352e2bd8758ef78038a0014548e94c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(171, 181, 170, 1.00)',
            'rgba(70, 86, 67, 1.00)',
            'rgba(38, 49, 37, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'magali'/camellia 'magali' (1).jpg",
          width: 1024,
          id: 'd2a4bb80dd6c930fc3b4134a3b370644',
          height: 683,
          thumbnail: true,
        },
        location: [47.270225, -1.58385],
        genre: 'Camellia',
        cultivar: 'Magali',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58385, 47.270225] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9e61ff92a766833e33c7a25baab73238dab54bdc',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(61, 58, 39, 1.00)',
            'rgba(114, 89, 90, 1.00)',
            'rgba(79, 63, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'spring festival'/camellia 'spring festival' (7).jpg",
          width: 1024,
          id: '9d95ce19c07ac98998e6cf67ba5f5899',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 78, 61, 1.00)',
            'rgba(113, 89, 82, 1.00)',
            'rgba(83, 73, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'spring festival'/camellia 'spring festival' (8).jpg",
          width: 1024,
          id: '05cf3a15b98e81326e3d8afa0b9b4eba',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 151, 141, 1.00)',
            'rgba(88, 86, 57, 1.00)',
            'rgba(99, 96, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'spring festival'/camellia 'spring festival' (2).jpg",
          width: 1024,
          id: '51af491bdb743a14ad7cd78d0d0ed85b',
          height: 683,
          thumbnail: true,
        },
        location: [47.271412, -1.584437],
        genre: 'Camellia',
        cultivar: 'Spring Festival',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584437, 47.271412] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c2a3d46d65b7878a8c12f7d6893cb0324159af5b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 82, 57, 1.00)',
            'rgba(94, 97, 88, 1.00)',
            'rgba(81, 90, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'tongzimian' (baby face)/camellia 'tongzimian' (baby face) (2).jpg",
          width: 1024,
          id: '64ea97a0b490d33a9b64f25a9c061635',
          height: 683,
          thumbnail: true,
        },
        location: [47.270638, -1.585583],
        genre: 'Camellia',
        cultivar: 'Tongzimian (Baby Face)',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585583, 47.270638] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c5b451817af497f98a3a5d9b9869c6eea00af778',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(59, 67, 65, 1.00)',
            'rgba(127, 132, 137, 1.00)',
            'rgba(87, 94, 100, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'white retic'/camellia 'white retic'.jpg",
          width: 1024,
          id: '336e2d8afebe1d137973f776e867ea9c',
          height: 625,
          thumbnail: true,
        },
        location: [47.27026, -1.586547],
        genre: 'Camellia',
        cultivar: 'White Retic',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586547, 47.27026] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c1f4535e69e30e0b81f13d32bd4bd6e8bbe2aded',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'grijsii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 102, 82, 1.00)',
            'rgba(90, 102, 75, 1.00)',
            'rgba(76, 91, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia grijsii/camellia grijsii  (2).jpg',
          width: 1024,
          id: 'b8638e1a2a1cdb145c14921ea02ac6b4',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 63, 45, 1.00)',
            'rgba(84, 91, 69, 1.00)',
            'rgba(51, 64, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia grijsii/camellia grijsii  (3).jpg',
          width: 1024,
          id: 'a20d95b8ef323a537f130f8653cdb96f',
          height: 659,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(189, 198, 180, 1.00)',
            'rgba(78, 90, 60, 1.00)',
            'rgba(63, 67, 51, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia grijsii/camellia grijsii  (1).jpg',
          width: 1024,
          id: '66a5a1e3a427142ae86fb2c4977cce10',
          height: 683,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b210db09c02cae952de6967cf801b92d087dda53',
      fields: {
        espece: 'hiemalis',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 105, 94, 1.00)',
            'rgba(108, 123, 114, 1.00)',
            'rgba(61, 69, 63, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia hiemalis 'kasane-ogi'/camellia hiemalis 'kasane-ogi' (1).jpg",
          width: 512,
          id: '57965f3520b184b920083d174affd718',
          height: 768,
          thumbnail: true,
        },
        location: [47.27026, -1.586547],
        genre: 'Camellia',
        cultivar: 'Kasane-\u00f4gi',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586547, 47.27026] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '73b12f5e829c88bb2aff5e33bc70daeb54a77478',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 69, 55, 1.00)',
            'rgba(112, 62, 90, 1.00)',
            'rgba(61, 54, 52, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia hiemalis 'sparkling burgundy'/camellia hiemalis 'sparkling burgundy' (5).jpg",
          width: 1024,
          id: '19c14f4cd8fc8e261fa6cdd6c75ddf7c',
          height: 683,
          thumbnail: true,
        },
        espece: 'hiemalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 134, 101, 1.00)',
            'rgba(99, 123, 99, 1.00)',
            'rgba(95, 97, 81, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia hiemalis 'sparkling burgundy'/camellia hiemalis 'sparkling burgundy' (4).jpg",
          width: 1024,
          id: 'ff4bc16dac238039417d34266ef50dba',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 143, 125, 1.00)',
            'rgba(168, 95, 118, 1.00)',
            'rgba(95, 93, 77, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia hiemalis 'sparkling burgundy'/camellia hiemalis 'sparkling burgundy' (2).jpg",
          width: 576,
          id: '26085f82a15f671e56a56439c292959f',
          height: 768,
          thumbnail: true,
        },
        location: [47.270494, -1.584536],
        genre: 'Camellia',
        cultivar: 'Sparkling Burgundy',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584536, 47.270494] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8bf565a0b69cc966a9538e660378c2477e484a56',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 79, 76, 1.00)',
            'rgba(151, 71, 97, 1.00)',
            'rgba(103, 49, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'adolphe audusson'/camellia japonica 'adolphe audusson' (3).jpg",
          width: 1024,
          id: '344ee0b7bccc58f2e69abc902887ab65',
          height: 682,
          thumbnail: true,
        },
        location: [47.269538, -1.585169],
        genre: 'Camellia',
        cultivar: 'Adolphe Audusson',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585169, 47.269538] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '45aa003b8f07eee0c0b3fc66f978cf855dcd1e2f',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 155, 99, 1.00)',
            'rgba(107, 141, 67, 1.00)',
            'rgba(120, 142, 85, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'angela cocchi'/camellia japonica 'angela cocchi' (3).jpg",
          width: 576,
          id: '3582a60fdbe4b792a21670ade783c2cb',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(61, 68, 49, 1.00)',
            'rgba(135, 130, 125, 1.00)',
            'rgba(66, 70, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'angela cocchi'/camellia japonica 'angela cocchi' (2).jpg",
          width: 576,
          id: '79d6427f3dc6f75cd2bdd63d69e5a9f9',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(187, 189, 180, 1.00)',
            'rgba(99, 112, 76, 1.00)',
            'rgba(84, 94, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'angela cocchi'/camellia japonica 'angela cocchi' (1).jpg",
          width: 576,
          id: 'd85211826640b60bf81586fa701c816b',
          height: 768,
          thumbnail: true,
        },
        location: [47.270853, -1.584447],
        genre: 'Camellia',
        cultivar: 'Angela Cocchi',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584447, 47.270853] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fb58310c5afda5221390f0825ea7b4632b492b1d',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 81, 57, 1.00)',
            'rgba(137, 82, 77, 1.00)',
            'rgba(96, 72, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'beau harp'/camellia japonica 'beau harp' (3).jpg",
          width: 1024,
          id: '053e54440743d20211f1bdac90891855',
          height: 598,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(174, 76, 88, 1.00)',
            'rgba(146, 56, 47, 1.00)',
            'rgba(117, 62, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'beau harp'/camellia japonica 'beau harp' (2).jpg",
          width: 1024,
          id: '015672c7859c3a499d30e5b271b888be',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 126, 111, 1.00)',
            'rgba(118, 79, 65, 1.00)',
            'rgba(83, 92, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'beau harp'/camellia japonica 'beau harp' (1).jpg",
          width: 1024,
          id: 'cb4832c912e997475969f2f2a01eb4ee',
          height: 703,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Camellia',
        cultivar: 'Beau Harp',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fab1d0f918e4b421d1782008c0251cd8adad5d28',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 133, 115, 1.00)',
            'rgba(95, 100, 60, 1.00)',
            'rgba(111, 107, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'beaute de nantes'/camellia japonica 'beaute de nantes' (2).jpg",
          width: 512,
          id: 'f344c055244589a5543198b65ac19eb4',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 104, 62, 1.00)',
            'rgba(145, 85, 77, 1.00)',
            'rgba(104, 89, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'beaute de nantes'/camellia japonica 'beaute de nantes' (1).jpg",
          width: 1024,
          id: '28af7af84375d3b1609054743cf4cd32',
          height: 643,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Camellia',
        cultivar: 'Beaut\u00e9 de Nantes',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6836831e6dac027783d83d5a6b5abca9c5297864',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(61, 72, 43, 1.00)',
            'rgba(119, 102, 93, 1.00)',
            'rgba(101, 87, 82, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'c. m. wilson'/camellia japonica 'c. m. wilson' (2).jpg",
          width: 1024,
          id: '7cf50644f7e957b686348903783ac1e1',
          height: 683,
          thumbnail: true,
        },
        location: [47.269787, -1.581617],
        genre: 'Camellia',
        cultivar: 'C. M. Wilson',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581617, 47.269787] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c9e48fc2c9dfb721c96340e8485b6e0713cb5109',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 85, 68, 1.00)',
            'rgba(96, 89, 78, 1.00)',
            'rgba(93, 95, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'chardonneret'/camellia japonica 'chardonneret' (5).jpg",
          width: 1024,
          id: '8672a86429dfb9b22f46e81b29152c0b',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 145, 134, 1.00)',
            'rgba(79, 95, 76, 1.00)',
            'rgba(74, 76, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'chardonneret'/camellia japonica 'chardonneret' (4).jpg",
          width: 512,
          id: '42264e8058359bba084d724935cf0890',
          height: 768,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Chardonneret',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b0ea0d4d885d7ac9e0790427342a00a27b647690',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 132, 115, 1.00)',
            'rgba(89, 103, 74, 1.00)',
            'rgba(102, 102, 78, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'fran homeyer'/camellia japonica 'fran homeyer' (2).jpg",
          width: 1024,
          id: '5c160f41c7a0c89198d654f15eb28cff',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 75, 59, 1.00)',
            'rgba(123, 101, 101, 1.00)',
            'rgba(75, 69, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'fran homeyer'/camellia japonica 'fran homeyer' (1).jpg",
          width: 1024,
          id: '3451c843b1be3d68cd6d430033616feb',
          height: 683,
          thumbnail: true,
        },
        location: [47.270295, -1.586425],
        genre: 'Camellia',
        cultivar: 'Fran Homeyer',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586425, 47.270295] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5608a90273de2c8c55f5a6c37726b4ea09257e43',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(75, 79, 68, 1.00)',
            'rgba(106, 113, 102, 1.00)',
            'rgba(106, 112, 99, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'grand slam'/camellia japonica 'grand slam' (3).jpg",
          width: 512,
          id: '90a036d8e1426c4d70dc88e257f44fd2',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 140, 100, 1.00)',
            'rgba(71, 81, 57, 1.00)',
            'rgba(86, 82, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'grand slam'/camellia japonica 'grand slam' (2).jpg",
          width: 1024,
          id: 'a5806877a5babafcaa51c4ae452c5b8f',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(64, 73, 48, 1.00)',
            'rgba(125, 68, 50, 1.00)',
            'rgba(108, 66, 39, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'grand slam'/camellia japonica 'grand slam' (1).jpg",
          width: 1024,
          id: 'f0ea8e7ed95f9209553826f98495fc37',
          height: 683,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Camellia',
        cultivar: 'Grand Slam',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '72b8e31115dc891092262e3d876f3ed0454dd1c0',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(75, 56, 39, 1.00)',
            'rgba(129, 53, 50, 1.00)',
            'rgba(80, 68, 36, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'la pace rubra'/camellia japonica 'la pace rubra' (2).jpg",
          width: 1024,
          id: 'f7e243375a26bd5dfc0d778580515c28',
          height: 683,
          thumbnail: true,
        },
        location: [47.270387, -1.585375],
        genre: 'Camellia',
        cultivar: 'La Pace Rubra',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585375, 47.270387] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '51c8bda94785130e800bb46161b4d04af9a27e67',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(167, 169, 152, 1.00)',
            'rgba(102, 102, 70, 1.00)',
            'rgba(94, 81, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'la pace rubra'/camellia japonica 'la pace rubra'.jpg",
          width: 1024,
          id: 'f2ab4af84201d277216424d18f024155',
          height: 683,
          thumbnail: true,
        },
        location: [47.270392, -1.585375],
        genre: 'Camellia',
        cultivar: 'La Pace Rubra',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585375, 47.270392] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c5de42b6a1b8af5494bb595ddc548e928dbe0b73',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 75, 71, 1.00)',
            'rgba(123, 67, 61, 1.00)',
            'rgba(97, 60, 35, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'leonardo da vinci'/camellia japonica 'leonardo da vinci' (3).jpg",
          width: 1024,
          id: 'f44bb9caee15eb21f0caec15c6c99799',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 115, 106, 1.00)',
            'rgba(131, 81, 74, 1.00)',
            'rgba(93, 77, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'leonardo da vinci'/camellia japonica 'leonardo da vinci' (2).jpg",
          width: 1024,
          id: 'bbc5f2c73224fd2e665cf1e8e5b02218',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(69, 86, 44, 1.00)',
            'rgba(89, 96, 52, 1.00)',
            'rgba(59, 78, 39, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'leonardo da vinci'/camellia japonica 'leonardo da vinci' (1).jpg",
          width: 1024,
          id: 'a86ee9f7aaf9270437341713081a4230',
          height: 683,
          thumbnail: true,
        },
        location: [47.27108, -1.58632],
        genre: 'Camellia',
        cultivar: 'Leonardo da Vinci',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58632, 47.27108] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8cd4854d8a3895ff0d26e5d8f6712cc8cb2876fd',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 97, 102, 1.00)',
            'rgba(130, 132, 110, 1.00)',
            'rgba(87, 96, 77, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'madame lourmand'/camellia japonica 'madame lourmand' (1).jpg",
          width: 1024,
          id: '3b3262187833fd33aec4a379cb3f8031',
          height: 734,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 82, 71, 1.00)',
            'rgba(119, 114, 95, 1.00)',
            'rgba(64, 64, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'madame lourmand'/camellia japonica 'madame lourmand'  (2).jpg",
          width: 1024,
          id: '62a97968b0023aac8d072d968836ee5f',
          height: 731,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 149, 148, 1.00)',
            'rgba(84, 92, 71, 1.00)',
            'rgba(81, 86, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'madame lourmand'/camellia japonica 'madame lourmand'  (1).jpg",
          width: 512,
          id: '1220d835074d205b6b793f6fe41997f2',
          height: 768,
          thumbnail: true,
        },
        location: [47.26925, -1.584292],
        genre: 'Camellia',
        cultivar: 'Madame Lourmand',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584292, 47.26925] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a070fb0d09e38f12f60ce3ef6c034e1b46468a6d',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(54, 73, 44, 1.00)',
            'rgba(132, 105, 110, 1.00)',
            'rgba(94, 76, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'nuccio's cameo'/camellia japonica 'nuccio's cameo' (6).jpg",
          width: 1024,
          id: '3f63fb384d63499b7bcedd0d3514d542',
          height: 616,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(46, 63, 36, 1.00)',
            'rgba(97, 80, 71, 1.00)',
            'rgba(52, 57, 41, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'nuccio's cameo'/camellia japonica 'nuccio's cameo' (5).jpg",
          width: 1024,
          id: 'd1267fcbb0504c2e031b8013b2026270',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 110, 81, 1.00)',
            'rgba(108, 127, 95, 1.00)',
            'rgba(86, 104, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'nuccio's cameo'/camellia japonica 'nuccio's cameo' (4).jpg",
          width: 1024,
          id: '3ab7a6c4745c37d345e7282d5ffc4bb3',
          height: 683,
          thumbnail: true,
        },
        location: [47.271172, -1.582587],
        genre: 'Camellia',
        cultivar: "Nuccio's Cameo",
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582587, 47.271172] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '60edda77ab23e151fd4eb5cc4e5d2fbe6234afde',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 117, 86, 1.00)',
            'rgba(108, 124, 91, 1.00)',
            'rgba(90, 103, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'nuccio's gem'/camellia japonica 'nuccio's gem' (2).jpg",
          width: 1024,
          id: '9a07439b3d255dfbd947c821b3757157',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(53, 62, 45, 1.00)',
            'rgba(116, 122, 110, 1.00)',
            'rgba(67, 78, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'nuccio's gem'/camellia japonica 'nuccio's gem' (1).jpg",
          width: 1024,
          id: 'b814f0b8dfe35582fd15626a0a1e8ad7',
          height: 668,
          thumbnail: true,
        },
        location: [47.26957, -1.58552],
        genre: 'Camellia',
        cultivar: "Nuccio's Gem",
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58552, 47.26957] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0e7e8716199dc365a875bdc7297ddc434227b67c',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(69, 76, 44, 1.00)',
            'rgba(111, 87, 76, 1.00)',
            'rgba(87, 76, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'preston rose'/camellia japonica 'preston rose' (2).jpg",
          width: 1024,
          id: '0b2e7e04e607ba1c2725b0221051a0c1',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 157, 126, 1.00)',
            'rgba(96, 104, 63, 1.00)',
            'rgba(78, 78, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'preston rose'/camellia japonica 'preston rose' (1).jpg",
          width: 1024,
          id: '6f27ebfb253c41122aca54256d4d8552',
          height: 683,
          thumbnail: true,
        },
        location: [47.271128, -1.582958],
        genre: 'Camellia',
        cultivar: 'Preston Rose',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582958, 47.271128] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd45b5c65b464f187d7cb3cb18264cb2c8c808947',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 115, 99, 1.00)',
            'rgba(130, 80, 81, 1.00)',
            'rgba(101, 62, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'r.l. wheeler'/camellia japonica 'r.l. wheeler' (3).jpg",
          width: 1024,
          id: 'cdef5160f24a80fe34ac8c05077cd080',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 149, 144, 1.00)',
            'rgba(99, 104, 83, 1.00)',
            'rgba(75, 80, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'r.l. wheeler'/camellia japonica 'r.l. wheeler' (2).jpg",
          width: 1024,
          id: '8c9a36520d0af03595ccb81d524deacd',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 107, 91, 1.00)',
            'rgba(94, 107, 84, 1.00)',
            'rgba(92, 103, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'r.l. wheeler'/camellia japonica 'r.l. wheeler' (1).jpg",
          width: 1024,
          id: '036e22455b2d2847da5d727460c37202',
          height: 683,
          thumbnail: true,
        },
        location: [47.270533, -1.585647],
        genre: 'Camellia',
        cultivar: 'R.L. Wheeler',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585647, 47.270533] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7118380da1dd1211811d0efafab617d276504ce0',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 159, 149, 1.00)',
            'rgba(85, 91, 58, 1.00)',
            'rgba(88, 90, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'ruddigore'/camellia japonica 'ruddigore' (3).jpg",
          width: 512,
          id: 'ed4090ffec367548861772b3e2c1b125',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 100, 76, 1.00)',
            'rgba(116, 57, 48, 1.00)',
            'rgba(105, 54, 44, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'ruddigore'/camellia japonica 'ruddigore' (2).jpg",
          width: 1024,
          id: '5e2f22fcfddd7f9499a8ef6300d3197b',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 147, 123, 1.00)',
            'rgba(111, 81, 53, 1.00)',
            'rgba(87, 71, 37, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'ruddigore'/camellia japonica 'ruddigore' (1).jpg",
          width: 1024,
          id: 'c7c084fb42efd1861b47116a6dffa4b1',
          height: 683,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Camellia',
        cultivar: 'Ruddigore',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1a1fa3aac67916408218478d52b38863f18347a1',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 84, 85, 1.00)',
            'rgba(131, 82, 87, 1.00)',
            'rgba(83, 71, 67, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'shuchuka'/camellia japonica 'shuchuka'.jpg",
          width: 1024,
          id: '00a0513d1cf61763ff0f064c45f54e41',
          height: 655,
          thumbnail: true,
        },
        location: [47.270528, -1.581275],
        genre: 'Camellia',
        cultivar: 'Shuch\u00fbka',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581275, 47.270528] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'db48f3d10535c51cab1187edec962062eec08054',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 87, 74, 1.00)',
            'rgba(138, 92, 84, 1.00)',
            'rgba(101, 78, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'spring sonnet'/camellia japonica 'spring sonnet' (2).jpg",
          width: 1024,
          id: '5413198931b0c71a2d0b29a54a312fcd',
          height: 609,
          thumbnail: true,
        },
        location: [47.270487, -1.585362],
        genre: 'Camellia',
        cultivar: 'Spring Sonnet',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585362, 47.270487] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9c7aba8b4f17c64754b3763d086a70bd4df7d9ce',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 72, 51, 1.00)',
            'rgba(116, 88, 78, 1.00)',
            'rgba(85, 72, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'spring sonnet'/camellia japonica 'spring sonnet'.jpg",
          width: 1024,
          id: '9290ae7d10059dcc8c52eb66686a4899',
          height: 610,
          thumbnail: true,
        },
        location: [47.270487, -1.585358],
        genre: 'Camellia',
        cultivar: 'Spring Sonnet',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585358, 47.270487] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '43035f790803081e512275db9e955fb2893ab4ea',
      fields: {
        espece: 'sasanqua',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 89, 72, 1.00)',
            'rgba(57, 77, 52, 1.00)',
            'rgba(67, 75, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'asakura'/camellia sasanqua 'asakura' (13).jpg",
          width: 576,
          id: '4066dd5e5ebe8b2df7995dd73655e544',
          height: 768,
          thumbnail: true,
        },
        location: [47.270387, -1.585428],
        genre: 'Camellia',
        cultivar: 'Asakura',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585428, 47.270387] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c55ffeb18fb84fa7ebb78221352163ac672a3ba7',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 143, 124, 1.00)',
            'rgba(88, 103, 79, 1.00)',
            'rgba(100, 97, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'hinode-gumo'/camellia sasanqua 'hinode-gumo' .jpg",
          width: 1024,
          id: 'b160c89e083a69df153c37ea77a3618d',
          height: 683,
          thumbnail: true,
        },
        espece: 'sasanqua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 146, 134, 1.00)',
            'rgba(105, 120, 109, 1.00)',
            'rgba(75, 85, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'hinode-gumo'/camellia sasanqua 'hinode-gumo' (5).jpg",
          width: 512,
          id: '71eec8c00af2b3f222b44c22483fe9d5',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(62, 70, 61, 1.00)',
            'rgba(105, 106, 81, 1.00)',
            'rgba(46, 48, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'hinode-gumo'/camellia sasanqua 'hinode-gumo' (4).jpg",
          width: 1024,
          id: '9d0252a7bfc99a3241b0c16f39719571',
          height: 683,
          thumbnail: true,
        },
        location: [47.27055, -1.581378],
        genre: 'Camellia',
        cultivar: 'Hinode-gumo',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581378, 47.27055] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e8a64d0dd8c094e42ce25d5f4633589426d7cbac',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 98, 79, 1.00)',
            'rgba(107, 110, 82, 1.00)',
            'rgba(44, 54, 32, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'rainbow'/camellia sasanqua 'rainbow' (4).jpg",
          width: 1024,
          id: '28f5b148f445e50769a55f4c27991861',
          height: 683,
          thumbnail: true,
        },
        espece: 'sasanqua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 126, 97, 1.00)',
            'rgba(95, 109, 73, 1.00)',
            'rgba(78, 91, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'rainbow'/camellia sasanqua 'rainbow' (3).jpg",
          width: 1024,
          id: '019ce27c98f64cb6fe10409182eb3541',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 96, 66, 1.00)',
            'rgba(158, 149, 116, 1.00)',
            'rgba(82, 89, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'rainbow'/camellia sasanqua 'rainbow' (2).jpg",
          width: 655,
          id: '45996d6b45ffec2d5b620922adda9e93',
          height: 768,
          thumbnail: true,
        },
        location: [47.269895, -1.582008],
        genre: 'Camellia',
        cultivar: 'Rainbow',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582008, 47.269895] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f957476a98f6eb84019b122507eb740f9e2e775d',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'transarisanensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 100, 120, 1.00)',
            'rgba(140, 113, 118, 1.00)',
            'rgba(138, 137, 141, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia transarisanensis/camellia transarisanensis (10).jpg',
          width: 1024,
          id: '6980542f32283b76c5b4ef04af4711e6',
          height: 736,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 92, 66, 1.00)',
            'rgba(89, 96, 63, 1.00)',
            'rgba(84, 90, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia transarisanensis/camellia transarisanensis (11).jpg',
          width: 1024,
          id: 'd96cc800b22626808c5d4d42bec4cdec',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 108, 85, 1.00)',
            'rgba(133, 122, 108, 1.00)',
            'rgba(93, 98, 75, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia transarisanensis/camellia transarisanensis (1).jpg',
          width: 576,
          id: '41dd4102a5c5cc2d367bc7d9990acfa3',
          height: 768,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9dac365c0ecdfaba7e8f1821b332c7fc3b64e1a0',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 103, 101, 1.00)',
            'rgba(134, 96, 120, 1.00)',
            'rgba(93, 76, 87, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'anemone frill'/camellia x williamsii 'anemone frill'.jpg",
          width: 1024,
          id: '491ae093db59d2eecce55f29437361b6',
          height: 650,
          thumbnail: true,
        },
        espece: 'x williamsii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 116, 113, 1.00)',
            'rgba(96, 102, 87, 1.00)',
            'rgba(103, 94, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'anemone frill'/camellia x williamsii 'anemone frill' (2).jpg",
          width: 512,
          id: '5af458fda0b1f5d672e9fef28b897f27',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 106, 95, 1.00)',
            'rgba(109, 70, 65, 1.00)',
            'rgba(78, 51, 43, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'anemone frill'/camellia x williamsii 'anemone frill' (1).jpg",
          width: 1024,
          id: '234e66619ec8a65b239090d7764090ae',
          height: 683,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Anemone Frill',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '90cf89275c137168a7bb890cf6e2a46f2635215f',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 137, 123, 1.00)',
            'rgba(96, 97, 68, 1.00)',
            'rgba(93, 87, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'garden glory'/camellia x williamsii 'garden glory'  (3).jpg",
          width: 1024,
          id: '25d34fd905916bf33c164996947da1db',
          height: 683,
          thumbnail: true,
        },
        espece: 'x williamsii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 115, 90, 1.00)',
            'rgba(103, 110, 79, 1.00)',
            'rgba(127, 118, 101, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'garden glory'/camellia x williamsii 'garden glory'  (2).jpg",
          width: 1024,
          id: '973342f1e7acff380bd4297c584dc036',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(55, 69, 43, 1.00)',
            'rgba(113, 91, 103, 1.00)',
            'rgba(87, 66, 82, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'garden glory'/camellia x williamsii 'garden glory'  (1).jpg",
          width: 1024,
          id: 'e8ee7f24c65bf6378dcff253845c8512',
          height: 683,
          thumbnail: true,
        },
        location: [47.269795, -1.584153],
        genre: 'Camellia',
        cultivar: 'Garden Glory',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584153, 47.269795] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '32c63cc8d1e2c686b714b62493ad06b3fc5d43c9',
      fields: {
        espece: 'x williamsii',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 84, 77, 1.00)',
            'rgba(109, 134, 114, 1.00)',
            'rgba(98, 116, 106, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'golden spangles'/camellia x williamsii 'golden spangles'.jpg",
          width: 512,
          id: '500f77236cb399ff90da89557b188657',
          height: 768,
          thumbnail: true,
        },
        location: [47.268922, -1.585183],
        genre: 'Camellia',
        cultivar: 'Golden Spangles',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585183, 47.268922] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b1f9170c9cea8dc4cb25ba863370660ad2e39f07',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(55, 64, 65, 1.00)',
            'rgba(117, 85, 91, 1.00)',
            'rgba(122, 77, 84, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'joe nuccio'/camellia x williamsii 'joe nuccio' (5).jpg",
          width: 1024,
          id: '4de7cb8fa513a9a45e61e730cb23337a',
          height: 683,
          thumbnail: true,
        },
        espece: 'x williamsii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(59, 66, 53, 1.00)',
            'rgba(109, 84, 85, 1.00)',
            'rgba(58, 51, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'joe nuccio'/camellia x williamsii 'joe nuccio' (3).jpg",
          width: 1024,
          id: 'dd112f8a6462fc71f15f1941596ba367',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 147, 174, 1.00)',
            'rgba(100, 98, 87, 1.00)',
            'rgba(58, 57, 37, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'joe nuccio'/camellia x williamsii 'joe nuccio' (1).jpg",
          width: 512,
          id: 'e46d5e2275dc7875aa4f23c38490641d',
          height: 768,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Joe Nuccio',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fdb3a64aef83f55a74ce8ae713e34f759fd91bba',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'yuhsienensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 61, 56, 1.00)',
            'rgba(124, 127, 115, 1.00)',
            'rgba(101, 107, 89, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia yuhsienensis/camellia yuhsienensis (3).jpg',
          width: 512,
          id: '6677eedf842e9f4796bd6bc521534201',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 124, 95, 1.00)',
            'rgba(116, 125, 86, 1.00)',
            'rgba(86, 112, 67, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia yuhsienensis/camellia yuhsienensis (4).jpg',
          width: 1024,
          id: 'c781074029f290d8674c0f9d4dcc52f9',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 117, 81, 1.00)',
            'rgba(113, 129, 95, 1.00)',
            'rgba(82, 99, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia yuhsienensis/camellia yuhsienensis (1).jpg',
          width: 1024,
          id: '209227d40931c57219e1ad97664c1d76',
          height: 683,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '63308320f9b114fd58992e0b19873cf7721354aa',
      fields: {
        espece: 'x vulgaris',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Tilia',
        date_plantation: '1973',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e7c57ace36e4c1d312a648261180724a72a3b9fd',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 117, 65, 1.00)',
            'rgba(150, 144, 119, 1.00)',
            'rgba(155, 142, 136, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/zelkova [ulmaceae]/zelkova serrata 'pyramidalis'/zelkova serrata 'pyramidalis' (3).jpg",
          width: 576,
          id: 'f498c5a309aad53dbfc591b0928c1201',
          height: 768,
          thumbnail: true,
        },
        espece: 'serrata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 159, 115, 1.00)',
            'rgba(70, 84, 35, 1.00)',
            'rgba(135, 140, 101, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/zelkova [ulmaceae]/zelkova serrata 'pyramidalis'/zelkova serrata 'pyramidalis' (2).jpg",
          width: 576,
          id: '3c7dc3efcb4557758467375e98d5ebf3',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 169, 78, 1.00)',
            'rgba(120, 150, 53, 1.00)',
            'rgba(95, 124, 30, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/zelkova [ulmaceae]/zelkova serrata 'pyramidalis'/zelkova serrata 'pyramidalis' (1).jpg",
          width: 576,
          id: 'ac28b1f5cce1eeaffea0752f6b3783b1',
          height: 768,
          thumbnail: true,
        },
        location: [47.270847, -1.582378],
        genre: 'Zelkova',
        cultivar: 'Pyramidalis',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582378, 47.270847] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b05875094d54635bf0d92b4643e897b0feff875d',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'spinosum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 99, 57, 1.00)',
            'rgba(109, 130, 86, 1.00)',
            'rgba(128, 137, 115, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/citharexylum [verbenaceae]/citharexylum spinosum/citharexylum spinosum (3).jpg',
          width: 1024,
          id: '993565c36053c4419d9846bbca5a38c6',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 110, 65, 1.00)',
            'rgba(110, 136, 95, 1.00)',
            'rgba(108, 131, 98, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/citharexylum [verbenaceae]/citharexylum spinosum/citharexylum spinosum (4).jpg',
          width: 1024,
          id: '0d2cff8a6f4167773c0f674a961c3d9e',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 116, 79, 1.00)',
            'rgba(118, 149, 106, 1.00)',
            'rgba(92, 115, 80, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/citharexylum [verbenaceae]/citharexylum spinosum/citharexylum spinosum (1).jpg',
          width: 1024,
          id: '0a51e135fc1afcd9a1522c562339f173',
          height: 683,
          thumbnail: true,
        },
        location: [47.270892, -1.585297],
        genre: 'Citharexylum',
        famille: 'Verbenaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585297, 47.270892] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '482e66049ac22347e4b76d02cbbd0b42a99eb246',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'scaberrima',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 110, 76, 1.00)',
            'rgba(136, 127, 94, 1.00)',
            'rgba(117, 100, 76, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/phyla [verbenaceae]/phyla scaberrima/phyla scaberrima (2).jpg",
          width: 576,
          id: '3f59c65a001a867a3bfacd159a03ff1c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 118, 92, 1.00)',
            'rgba(135, 125, 99, 1.00)',
            'rgba(135, 123, 103, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/phyla [verbenaceae]/phyla scaberrima/phyla scaberrima (3).jpg",
          width: 576,
          id: 'e048c5427d061035ba01348ee93a26bb',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 126, 85, 1.00)',
            'rgba(145, 130, 107, 1.00)',
            'rgba(123, 106, 88, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/phyla [verbenaceae]/phyla scaberrima/phyla scaberrima (1).jpg",
          width: 1024,
          id: '4150d55759113664414dd0a8a42e8146',
          height: 768,
          thumbnail: true,
        },
        location: [47.226628, -1.512163],
        genre: 'Phyla',
        famille: 'Verbenaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512163, 47.226628] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ee558bac6cf3962641641bed6c89deec01c4a3a6',
      fields: {
        origine: 'JB.Framingham (USA)',
        espece: 'labradorica Schrank',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Viola',
        date_plantation: '1988',
        famille: 'Violaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '45275d497de121146db19125265c5ca47c8b5b6e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'angustifolius',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 140, 69, 1.00)',
            'rgba(125, 143, 74, 1.00)',
            'rgba(120, 130, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/melicytus [violaceae]/melicytus angustifolius/melicytus angustifolius (2).jpg',
          width: 645,
          id: '6a40d5cdfa1cc7a14a9b9ebc6b699de6',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 162, 97, 1.00)',
            'rgba(119, 147, 65, 1.00)',
            'rgba(106, 133, 51, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/melicytus [violaceae]/melicytus angustifolius/melicytus angustifolius (3).jpg',
          width: 1024,
          id: 'f40ef10505a21b046085594fa8e479bf',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 98, 87, 1.00)',
            'rgba(84, 91, 85, 1.00)',
            'rgba(79, 86, 79, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/melicytus [violaceae]/melicytus angustifolius/melicytus angustifolius (1).jpg',
          width: 576,
          id: '6d8aeeb816891c736dc91db48111a074',
          height: 768,
          thumbnail: true,
        },
        location: [47.271142, -1.586208],
        genre: 'Melicytus',
        famille: 'Violaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586208, 47.271142] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9eb3b6575991bbd3301a3372b06dc206d84f74ba',
      fields: {
        espece: 'brevipedunculata',
        localisation: 'A5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2207668, -1.5440149],
        genre: 'Ampelopsis',
        date_plantation: '1973',
        famille: 'Vitaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440149, 47.2207668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ea9b6172e32c88732a65039d7a8cbc5795a8888e',
      fields: {
        origine: 'BG Munich',
        espece: 'hirsuta Codd',
        localisation: 'G2A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2197208, -1.5414609],
        genre: 'Kniphofia',
        date_plantation: '2006',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5414609, 47.2197208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b994c7ac93796791ad80c03862ab43ee00a2b229',
      fields: {
        origine: 'Grugapark Essen (Allemagne)',
        espece: 'tuckii Back.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Kniphofia',
        date_plantation: '1987',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5cd928d3e56f82360f26446d7ad130710b3eff55',
      fields: {
        origine: 'JB. Prague (Rep. Tch\u00e8que)',
        espece: 'semibarbata Haw.',
        localisation: 'I2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185657, -1.5426599],
        genre: 'Bulbine',
        date_plantation: '2011',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426599, 47.2185657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'eb0370652c8f731f81ef2ced1b64b85a1efee257',
      fields: {
        origine: 'JB.Dunedin (N-Z\u00e9lande)',
        espece: 'tenax J.R. & G. Forst.',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Phormium',
        date_plantation: '2006',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0a6a66e1b59ba94ec901de5ca9668b1e8cfeca83',
      fields: {
        origine: 'JBU.Athens (Panepistimiopolis)',
        espece: 'ramosus L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Asphodelus',
        date_plantation: '2006',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fce0ce7df0947a1cee291846beb8c1a246c56ac8',
      fields: {
        origine: 'JBU.Francfort (Allemagne)',
        espece: 'nelsoni Mast.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Kniphofia',
        date_plantation: '1998',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '83bff7f6f9c1ee2ce607af2fb02849ab2dd43045',
      fields: {
        espece: 'tenax J.R. & G.Forster',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Phormium',
        date_plantation: '1973',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd91ba2ef5284eb917314a5914445accd101686ac',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'davidii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(167, 158, 116, 1.00)',
            'rgba(150, 145, 90, 1.00)',
            'rgba(118, 112, 48, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/acer/acer davidii/acer davidii  (2).jpg',
          width: 576,
          id: 'a7bda9359724dd29edec324e865817b1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 161, 107, 1.00)',
            'rgba(124, 126, 53, 1.00)',
            'rgba(113, 106, 41, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/acer/acer davidii/acer davidii (1).jpg',
          width: 576,
          id: '74b816f11cd16e0a006b0c6b7933886e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 146, 75, 1.00)',
            'rgba(147, 147, 99, 1.00)',
            'rgba(111, 105, 58, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/acer/acer davidii/acer davidii  (1).jpg',
          width: 576,
          id: '390f018f607b4b328389bf2f036cf051',
          height: 768,
          thumbnail: true,
        },
        location: [47.220762, -1.544308],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544308, 47.220762] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '06e60d02c8cf5a87f41d1bafb4d4da2abbd5f079',
      fields: {
        espece: 'rufinerve',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 147, 93, 1.00)',
            'rgba(144, 138, 78, 1.00)',
            'rgba(138, 127, 76, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/acer/acer rufinerve/acer rufinerve.jpg',
          width: 576,
          id: '816e358b24cd74a97f8f04554b5a34ad',
          height: 768,
          thumbnail: true,
        },
        location: [47.220675, -1.542855],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542855, 47.220675] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b982e5c5a2120baf6fdcaad9ab540e5d8b2de5a1',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'glabra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 158, 76, 1.00)',
            'rgba(110, 138, 52, 1.00)',
            'rgba(80, 111, 34, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/aesculus/aesculus glabra/aesculus glabra (2).jpg',
          width: 576,
          id: 'b4eb4ef39dd2b8ce555ad8d6519f5687',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 137, 43, 1.00)',
            'rgba(106, 153, 57, 1.00)',
            'rgba(114, 158, 68, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/aesculus/aesculus glabra/aesculus glabra (3).jpg',
          width: 576,
          id: '257b937fa4e1cb81150c886d0e0f256d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(167, 188, 130, 1.00)',
            'rgba(91, 120, 46, 1.00)',
            'rgba(68, 102, 33, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/aesculus/aesculus glabra/aesculus glabra (1).jpg',
          width: 576,
          id: '0f5e53a020a0eaa3ec40e736d11e65bf',
          height: 768,
          thumbnail: true,
        },
        location: [47.219522, -1.54133],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54133, 47.219522] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f0b75700946a6ba1181dd3eb6f381f7b14533fbb',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'hippocastanum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(195, 214, 198, 1.00)',
            'rgba(128, 149, 107, 1.00)',
            'rgba(80, 95, 49, 1.00)',
          ],
          filename:
            'ip parc de proce/aesculus/aesculus hippocastanum/aesculus hippocastanum (4).jpg',
          width: 1024,
          id: 'ef22fda73039514585c5ea03bb0699b9',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 154, 88, 1.00)',
            'rgba(101, 127, 70, 1.00)',
            'rgba(96, 127, 63, 1.00)',
          ],
          filename:
            'ip parc de proce/aesculus/aesculus hippocastanum/aesculus hippocastanum (5).jpg',
          width: 1024,
          id: '0710ffa90196d4897d54193e912dc147',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 183, 100, 1.00)',
            'rgba(114, 150, 63, 1.00)',
            'rgba(81, 127, 43, 1.00)',
          ],
          filename:
            'ip parc de proce/aesculus/aesculus hippocastanum/aesculus hippocastanum (1).jpg',
          width: 576,
          id: 'dc1aacfd42c8c845a3e46bd53afa4eb8',
          height: 768,
          thumbnail: true,
        },
        location: [47.223187, -1.584603],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584603, 47.223187] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6d4c1ff167cbe61e0bae46be508bbe0040404b02',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'alternifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 133, 95, 1.00)',
            'rgba(88, 104, 69, 1.00)',
            'rgba(99, 113, 67, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/buddleja/buddleja alternifolia/buddleja alternifolia (2).jpg',
          width: 1024,
          id: '0ccd376a3565d48a34bf1bf249d1b420',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 90, 59, 1.00)',
            'rgba(100, 100, 87, 1.00)',
            'rgba(101, 106, 85, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/buddleja/buddleja alternifolia/buddleja alternifolia (3).jpg',
          width: 1024,
          id: 'dfee681088e3475455bdda1657645d04',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 97, 61, 1.00)',
            'rgba(94, 112, 73, 1.00)',
            'rgba(96, 115, 79, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/buddleja/buddleja alternifolia/buddleja alternifolia (1).jpg',
          width: 1024,
          id: 'e311d742eee6e9ab64ab0f1f44811f5d',
          height: 683,
          thumbnail: true,
        },
        location: [47.262772, -1.535525],
        genre: 'Buddleja',
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535525, 47.262772] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '157b5db821193577e33a4a6ecea144cded69cdfc',
      fields: {
        espece: 'sempervirens',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 139, 108, 1.00)',
            'rgba(125, 144, 92, 1.00)',
            'rgba(127, 137, 84, 1.00)',
          ],
          filename:
            'ip parc de proce/buxus/buxus sempervirens/buxus sempervirens (2).jpg',
          width: 576,
          id: 'c90efaef397281c51192ffb3c931b37e',
          height: 768,
          thumbnail: true,
        },
        location: [47.223113, -1.581272],
        genre: 'Buxus',
        famille: 'Buxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581272, 47.223113] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dbf7f4f9c3602d13ae9138a632d7047ac43fd14c',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 60, 79, 1.00)',
            'rgba(107, 101, 138, 1.00)',
            'rgba(65, 66, 91, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia 'magali'/camellia 'magali' (2).jpg",
          width: 1024,
          id: '7e182ed3cf1c405d9cf7363796fd91f9',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 164, 162, 1.00)',
            'rgba(99, 111, 106, 1.00)',
            'rgba(66, 66, 72, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia 'magali'/camellia 'magali' (1).jpg",
          width: 1024,
          id: 'b4a5159d3e746693e7a264c063229b79',
          height: 683,
          thumbnail: true,
        },
        location: [47.220247, -1.54168],
        genre: 'Camellia',
        cultivar: 'Magali',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54168, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '767652bfd311a50dc89022b5cd3a61280c06c602',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'granthamiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(57, 59, 54, 1.00)',
            'rgba(107, 105, 93, 1.00)',
            'rgba(55, 55, 49, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia granthamiana/camellia granthamiana (1).jpg',
          width: 1024,
          id: '0737a6eb3f817e85d33de672ef20c951',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 151, 140, 1.00)',
            'rgba(105, 111, 108, 1.00)',
            'rgba(92, 93, 92, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia granthamiana/camellia granthamiana (2).jpg',
          width: 1024,
          id: 'fc2b129967e94d8e1aeff8798f034a19',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 90, 85, 1.00)',
            'rgba(110, 125, 108, 1.00)',
            'rgba(69, 79, 65, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia granthamiana/camellia granthamiana  (2).jpg',
          width: 512,
          id: '4f12b791aceb43ccf1b2a78d3c5642f0',
          height: 768,
          thumbnail: true,
        },
        location: [47.220247, -1.54168],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54168, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'de375df1ad429ff3ba3d5003ca8a3f7de4019d1a',
      fields: {
        espece: 'hiemalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 95, 76, 1.00)',
            'rgba(93, 103, 89, 1.00)',
            'rgba(94, 102, 94, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia hiemalis 'showa-no-sakae'/camellia hiemalis 'showa-no-sakae' (2).jpg",
          width: 1024,
          id: '4235fc93a74953a2b45a2d13cab1bd3a',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(48, 52, 49, 1.00)',
            'rgba(103, 56, 78, 1.00)',
            'rgba(103, 50, 81, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia hiemalis 'showa-no-sakae'/camellia hiemalis 'showa-no-sakae' (1).jpg",
          width: 1024,
          id: 'da0da7884fc2eed22221f41189a0b81e',
          height: 683,
          thumbnail: true,
        },
        location: [47.220247, -1.541681],
        genre: 'Camellia',
        cultivar: 'Sh\u00f4wa-no-sakae',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541681, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '172318fd699362c091c04f8822990f97398ae668',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 105, 89, 1.00)',
            'rgba(89, 97, 80, 1.00)',
            'rgba(95, 103, 88, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'christmas cheer pink'/camellia japonica 'christmas cheer pink' (2).jpg",
          width: 1024,
          id: '5d07ba72a052378ce55ad4a9d776c053',
          height: 683,
          thumbnail: true,
        },
        location: [47.220247, -1.54168],
        genre: 'Camellia',
        cultivar: 'Christmas Cheer Pink',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54168, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bc4f75125140c3b43b0c0d2d63562a31120c6f4a',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(29, 34, 24, 1.00)',
            'rgba(93, 70, 78, 1.00)',
            'rgba(107, 85, 94, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'variegata'/camellia japonica 'variegata' (2).jpg",
          width: 1024,
          id: '3f88838d16aad2be7ccf3d630f45cef9',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 139, 124, 1.00)',
            'rgba(93, 98, 88, 1.00)',
            'rgba(96, 98, 94, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'variegata'/camellia japonica 'variegata' (1).jpg",
          width: 512,
          id: '5769ed13d4df33677bd2b90d5f47d86c',
          height: 768,
          thumbnail: true,
        },
        location: [47.219983, -1.543953],
        genre: 'Camellia',
        cultivar: 'Variegata',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543953, 47.219983] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '572945c56b569430e040b7ae1a82db0d85c20e67',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 101, 96, 1.00)',
            'rgba(115, 122, 110, 1.00)',
            'rgba(67, 72, 62, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'white swan'/camellia japonica 'white swan' (3).jpg",
          width: 1024,
          id: 'e7825afaf05ec17744695f48a60c0e66',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 68, 57, 1.00)',
            'rgba(106, 103, 86, 1.00)',
            'rgba(66, 73, 67, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'white swan'/camellia japonica 'white swan' (2).jpg",
          width: 1024,
          id: 'ec35766df7e7d9c8489a38623770a203',
          height: 657,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(36, 48, 36, 1.00)',
            'rgba(85, 90, 75, 1.00)',
            'rgba(59, 71, 67, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'white swan'/camellia japonica 'white swan' (1).jpg",
          width: 1024,
          id: 'bbf301b0b3b511ffe0336b14fd247ea0',
          height: 657,
          thumbnail: true,
        },
        location: [47.220247, -1.541681],
        genre: 'Camellia',
        cultivar: 'White Swan',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541681, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1cbcdc8732cf87e5a71232c48333bee5a8fbe3e1',
      fields: {
        espece: 'transarisanensis',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 157, 152, 1.00)',
            'rgba(100, 104, 91, 1.00)',
            'rgba(122, 111, 111, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia transarisanensis/camellia transarisanensis.jpg',
          width: 576,
          id: 'c7f0b36668ac750ea303bdd6100c6582',
          height: 768,
          thumbnail: true,
        },
        location: [47.220247, -1.54168],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54168, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '725d2eede07cde2b32d9af0b0d3e83b3fe8de407',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 152, 86, 1.00)',
            'rgba(146, 98, 84, 1.00)',
            'rgba(85, 90, 33, 1.00)',
          ],
          filename:
            "ip parc de proce/camellia/camellia japonica 'desire'/camellia japonica 'desire' (2).jpg",
          width: 576,
          id: 'c9544f4081ea82a5f58921863025f6fc',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 149, 66, 1.00)',
            'rgba(163, 128, 120, 1.00)',
            'rgba(119, 119, 55, 1.00)',
          ],
          filename:
            "ip parc de proce/camellia/camellia japonica 'desire'/camellia japonica 'desire' (1).jpg",
          width: 576,
          id: 'd66147b63516d913966f5cf4f6832ee1',
          height: 768,
          thumbnail: true,
        },
        location: [47.22568, -1.581375],
        genre: 'Camellia',
        cultivar: 'Desire',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581375, 47.22568] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'aed0b2389a00d53fecfd86f930efd1ed5089c54d',
      fields: {
        espece: 'maliflora',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 107, 49, 1.00)',
            'rgba(116, 140, 75, 1.00)',
            'rgba(110, 132, 67, 1.00)',
          ],
          filename:
            'ip parc de proce/camellia/camellia maliflora/camellia maliflora.jpg',
          width: 1024,
          id: 'b60d6cfc7539dcfef73ca1fb53c24ae4',
          height: 768,
          thumbnail: true,
        },
        location: [47.22593, -1.582572],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582572, 47.22593] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e40a177d917d3d275781259ba3952baeed8a90d6',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'tsaii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 108, 66, 1.00)',
            'rgba(126, 134, 100, 1.00)',
            'rgba(133, 136, 106, 1.00)',
          ],
          filename:
            'ip parc de proce/camellia/camellia tsaii/camellia tsaii (2).jpg',
          width: 576,
          id: '1011acbe4e4acb1756998937e0f2cc87',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 113, 77, 1.00)',
            'rgba(135, 133, 99, 1.00)',
            'rgba(124, 118, 94, 1.00)',
          ],
          filename:
            'ip parc de proce/camellia/camellia tsaii/camellia tsaii (3).jpg',
          width: 576,
          id: 'c6acd0fc1bab07aaca9320cfc0f3db31',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 164, 111, 1.00)',
            'rgba(116, 133, 85, 1.00)',
            'rgba(111, 115, 79, 1.00)',
          ],
          filename:
            'ip parc de proce/camellia/camellia tsaii/camellia tsaii (1).jpg',
          width: 576,
          id: 'd4b019d182a6bd068eb24f9d81813ccc',
          height: 768,
          thumbnail: true,
        },
        location: [47.225183, -1.581337],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581337, 47.225183] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '108252d1b729d2757715ec58de03835d533f9804',
      fields: {
        espece: 'amplexicaulis',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(168, 169, 137, 1.00)',
            'rgba(115, 87, 61, 1.00)',
            'rgba(72, 69, 59, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/camellia/camellia amplexicaulis/camellia amplexicaulis.jpg',
          width: 1024,
          id: 'f2911ef1242862d4e1893afe1d361c73',
          height: 683,
          thumbnail: true,
        },
        location: [47.22828, -1.507742],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507742, 47.22828] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '38b835eddfb3cea68bb4f45d35f7bacc9bea96d4',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 73, 69, 1.00)',
            'rgba(138, 126, 116, 1.00)',
            'rgba(81, 83, 57, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/camellia/camellia japonica 'flamingo'/camellia japonica 'flamingo'.jpg",
          width: 1024,
          id: 'cc6974d313fb46e2bcd9df15b1e7447d',
          height: 768,
          thumbnail: true,
        },
        location: [47.227367, -1.508417],
        genre: 'Camellia',
        cultivar: 'Flamingo',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508417, 47.227367] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f8bdf50ea073e34467360897d3620d0596a75bba',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'granthamiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 145, 101, 1.00)',
            'rgba(90, 104, 62, 1.00)',
            'rgba(80, 95, 62, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/camellia/camellia granthamiana/camellia granthamiana (2).jpg',
          width: 1024,
          id: '0657f7c0f98618412d5ada41741115ba',
          height: 739,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(53, 69, 41, 1.00)',
            'rgba(102, 117, 78, 1.00)',
            'rgba(91, 105, 61, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/camellia/camellia granthamiana/camellia granthamiana (3).jpg',
          width: 1024,
          id: 'bac184536546732f2b374be1f9e27f06',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 98, 108, 1.00)',
            'rgba(109, 107, 83, 1.00)',
            'rgba(70, 73, 34, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/camellia/camellia granthamiana/camellia granthamiana (1).jpg',
          width: 512,
          id: 'ba19bf61015ab0474fbb8b2caa2be3a7',
          height: 768,
          thumbnail: true,
        },
        location: [47.26185, -1.53478],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53478, 47.26185] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ae2e0c4ee016b41f458cfafa72c047ce0335b2f0',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(47, 60, 39, 1.00)',
            'rgba(99, 106, 89, 1.00)',
            'rgba(59, 72, 49, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/camellia/camellia japonica 'nobilissima'/camellia japonica 'nobilissima' (2).jpg",
          width: 1024,
          id: '6a1c99a9984ba656b1e09d852f72a099',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 162, 153, 1.00)',
            'rgba(66, 87, 47, 1.00)',
            'rgba(73, 94, 46, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/camellia/camellia japonica 'nobilissima'/camellia japonica 'nobilissima' (1).jpg",
          width: 512,
          id: 'db249c8e3aa05e5e8768b9e5de212cee',
          height: 768,
          thumbnail: true,
        },
        location: [47.262117, -1.531628],
        genre: 'Camellia',
        cultivar: 'Nobilissima',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531628, 47.262117] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cc04fe480bb3e3730365d43673f4354748f6eb4a',
      fields: {
        espece: 'californica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 132, 102, 1.00)',
            'rgba(118, 121, 93, 1.00)',
            'rgba(90, 103, 72, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/carpenteria/carpenteria californica/carpenteria californica (3).jpg',
          width: 1024,
          id: '61993ca2f8ec5cec9e38e2cd37411873',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 123, 102, 1.00)',
            'rgba(91, 101, 75, 1.00)',
            'rgba(59, 76, 44, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/carpenteria/carpenteria californica/carpenteria californica (1).jpg',
          width: 1024,
          id: '3ad22f24caf084e2dd1d18d5f40844b5',
          height: 721,
          thumbnail: true,
        },
        location: [47.26165, -1.533305],
        genre: 'Carpenteria',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533305, 47.26165] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f2bcfec88d1900046124769a34eae36ee48920fc',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 155, 123, 1.00)',
            'rgba(83, 113, 69, 1.00)',
            'rgba(53, 65, 57, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/carpinus/carpinus japonica/carpinus japonica.jpg',
          width: 907,
          id: 'cbb0ef2a8de7f673ebec425ce81dc0d4',
          height: 768,
          thumbnail: true,
        },
        location: [47.218645, -1.542638],
        genre: 'Carpinus',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542638, 47.218645] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e1daece83747a8e72abb24b94d7811b03a3258d4',
      fields: {
        espece: 'japonicum',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(179, 190, 174, 1.00)',
            'rgba(94, 116, 84, 1.00)',
            'rgba(78, 106, 52, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cercidiphyllum/cercidiphyllum japonicum/cercidiphyllum japonicum (2).jpg',
          width: 576,
          id: '245afcc7de7175bfa5eb06a4ec9b053c',
          height: 768,
          thumbnail: true,
        },
        location: [47.220337, -1.545047],
        genre: 'Cercidiphyllum',
        famille: 'Cercidiphyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.545047, 47.220337] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2aae62e205a068e4b1351dd53af148674bc55d07',
      fields: {
        espece: 'praecox',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 150, 150, 1.00)',
            'rgba(105, 92, 73, 1.00)',
            'rgba(109, 88, 74, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/chimonanthus/chimonathus praecox/chimonathus praecox (2).jpg',
          width: 512,
          id: 'a09bdd2831537b388e12702b18489535',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 136, 124, 1.00)',
            'rgba(123, 114, 83, 1.00)',
            'rgba(112, 101, 82, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/chimonanthus/chimonathus praecox/chimonathus praecox (1).jpg',
          width: 1024,
          id: '5b2d4bb5d774d9f67bf0ccebc93343b7',
          height: 683,
          thumbnail: true,
        },
        location: [47.230667, -1.50772],
        genre: 'Chimonanthus',
        famille: 'Calycanthaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.50772, 47.230667] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '124e440e2ef62b292d03daedefb1b3d7d860aeef',
      fields: {
        espece: 'kentukea',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 172, 143, 1.00)',
            'rgba(82, 97, 69, 1.00)',
            'rgba(44, 54, 28, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/cladrastis/cladrastis kentukea/cladrastis kentukea (2).jpg',
          width: 1024,
          id: '2f947300b2087e93c06b9fe50b218c27',
          height: 683,
          thumbnail: true,
        },
        location: [47.262467, -1.53295],
        genre: 'Cladrastis',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53295, 47.262467] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '176df2665d0b02f244e4d980ae9259e87133b76e',
      fields: {
        nom_du_site: 'Autre site',
        espece: 'trichotomum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 81, 49, 1.00)',
            'rgba(113, 123, 86, 1.00)',
            'rgba(99, 94, 66, 1.00)',
          ],
          filename:
            'ip ville de nantes/clerodendrum/clerodendrum trichotomum/clerodendrum trichotomum (4).jpg',
          width: 576,
          id: 'de5d0f2d3b1142ae1f10d351e56fc04e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 121, 77, 1.00)',
            'rgba(113, 126, 89, 1.00)',
            'rgba(112, 121, 86, 1.00)',
          ],
          filename:
            'ip ville de nantes/clerodendrum/clerodendrum trichotomum/clerodendrum trichotomum (5).jpg',
          width: 576,
          id: '736ea55cb4487f124e93b04b270e7316',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(75, 82, 51, 1.00)',
            'rgba(126, 129, 92, 1.00)',
            'rgba(92, 97, 60, 1.00)',
          ],
          filename:
            'ip ville de nantes/clerodendrum/clerodendrum trichotomum/clerodendrum trichotomum (3).jpg',
          width: 1024,
          id: '5c54f4f6aef9dbae629fa1dfb350fe1d',
          height: 768,
          thumbnail: true,
        },
        location: [47.225837, -1.52252],
        genre: 'Clerodendrum',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.52252, 47.225837] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3ab8c6c4aa7127feb730c34ad1008e7e1abd61f8',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 118, 86, 1.00)',
            'rgba(104, 114, 93, 1.00)',
            'rgba(82, 91, 75, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/cleyera/cleyera japonica 'fortunei'/cleyera japonica 'fortunei'.jpg",
          width: 1024,
          id: 'd3c50f74880e4d27ff22dc206530761b',
          height: 683,
          thumbnail: true,
        },
        location: [47.262638, -1.5305],
        genre: 'Cleyera',
        cultivar: 'Fortunei',
        famille: 'Pentaphylacaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5305, 47.262638] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '528efcac1f56861757e38060fc4ea4624da5c34d',
      fields: {
        espece: 'kousa var. chinensis',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 156, 168, 1.00)',
            'rgba(131, 106, 71, 1.00)',
            'rgba(89, 73, 39, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cornus/cornus kousa var. chinensis/cornus kousa var. chinensis (2).jpg',
          width: 684,
          id: 'cdfdf0cf2c8432083686de96ed09a44c',
          height: 768,
          thumbnail: true,
        },
        location: [47.218912, -1.541645],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541645, 47.218912] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd43dade21089b698e62918749980874cf1c049ba',
      fields: {
        espece: 'capitata',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 126, 108, 1.00)',
            'rgba(98, 112, 75, 1.00)',
            'rgba(80, 97, 42, 1.00)',
          ],
          filename:
            'ip parc de proce/cornus/cornus capitata/cornus capitata (2).jpg',
          width: 1024,
          id: 'f35c130bb8b2efb434df29bdb4683fc1',
          height: 768,
          thumbnail: true,
        },
        location: [47.225828, -1.582967],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582967, 47.225828] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9b897eefdc1b93483d1628a2c468daaef092e041',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 167, 181, 1.00)',
            'rgba(124, 128, 103, 1.00)',
            'rgba(68, 70, 36, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/cornus/cornus controversa 'variegata'/cornus controversa 'variegata' (4).jpg",
          width: 1024,
          id: '2fec4b46268eabe7849abcc5f8a98e59',
          height: 683,
          thumbnail: true,
        },
        espece: 'controversa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 166, 214, 1.00)',
            'rgba(132, 136, 139, 1.00)',
            'rgba(81, 75, 47, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/cornus/cornus controversa 'variegata'/cornus controversa 'variegata'  (2).jpg",
          width: 576,
          id: '9f43e1cad6e636cc1bef8636884fa536',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 126, 144, 1.00)',
            'rgba(145, 137, 111, 1.00)',
            'rgba(139, 129, 71, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/cornus/cornus controversa 'variegata'/cornus controversa 'variegata'  (1).jpg",
          width: 576,
          id: '9e17b8a1bd1cc8f0e4d393520dfc6367',
          height: 768,
          thumbnail: true,
        },
        location: [47.261558, -1.533738],
        genre: 'Cornus',
        cultivar: 'Variegata',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533738, 47.261558] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0218ed18be5412bba17d2b5e9118e261a751e103',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 150, 114, 1.00)',
            'rgba(107, 121, 90, 1.00)',
            'rgba(58, 76, 30, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/cornus/cornus florida 'cloud nine'/cornus florida 'cloud nine' (3).jpg",
          width: 576,
          id: '20ee3d4f4c445df3ce2147af5cb617fa',
          height: 768,
          thumbnail: true,
        },
        espece: 'florida',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 99, 73, 1.00)',
            'rgba(129, 134, 119, 1.00)',
            'rgba(96, 104, 72, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/cornus/cornus florida 'cloud nine'/cornus florida 'cloud nine' (2).jpg",
          width: 576,
          id: '3f90b4669f4c117c88577bcd40599424',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 101, 77, 1.00)',
            'rgba(107, 119, 90, 1.00)',
            'rgba(93, 105, 73, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/cornus/cornus florida 'cloud nine'/cornus florida 'cloud nine' (1).jpg",
          width: 1024,
          id: 'a84aef298f5e1da63d8a009fc5b207d7',
          height: 768,
          thumbnail: true,
        },
        location: [47.262205, -1.528642],
        genre: 'Cornus',
        cultivar: 'Cloud Nine',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.528642, 47.262205] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8b96d841bf5a4b173ab4de5fc8bc373864d0a2f4',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'odora Marianni (Rogbret)',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 109, 71, 1.00)',
            'rgba(104, 112, 69, 1.00)',
            'rgba(99, 106, 64, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/daphne/daphne odora marianni ('rogbret')/daphne odora marianni ('rogbret') (2).jpg",
          width: 512,
          id: '32c9d039a02433c6974884c39d7bcf31',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 123, 84, 1.00)',
            'rgba(107, 108, 80, 1.00)',
            'rgba(71, 68, 52, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/daphne/daphne odora marianni ('rogbret')/daphne odora marianni ('rogbret') (3).jpg",
          width: 1024,
          id: '5bd3339289a809f8e37a91ffb5bc5670',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 114, 75, 1.00)',
            'rgba(110, 121, 76, 1.00)',
            'rgba(95, 99, 60, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/daphne/daphne odora marianni ('rogbret')/daphne odora marianni ('rogbret') (1).jpg",
          width: 512,
          id: '21060763dd5b3455650fae283bce8401',
          height: 768,
          thumbnail: true,
        },
        location: [47.228267, -1.50803],
        genre: 'Daphne',
        famille: 'Thymelaeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.50803, 47.228267] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '18ab4a960d4be2fe528c09dcccb6d2fca4b89de4',
      fields: {
        espece: 'macropodum',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 140, 101, 1.00)',
            'rgba(99, 96, 56, 1.00)',
            'rgba(78, 87, 42, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/daphniphyllum/daphniphyllum macropodum/daphniphyllum macropodum.jpg',
          width: 1024,
          id: '9e9057844098e5e25a6931a968217b13',
          height: 683,
          thumbnail: true,
        },
        location: [47.261687, -1.532947],
        genre: 'Daphniphyllum',
        famille: 'Daphniphyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532947, 47.261687] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ec8de575349a6a90e85461b0c14351bf8b6ad02e',
      fields: {
        espece: 'involucrata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 151, 102, 1.00)',
            'rgba(106, 125, 82, 1.00)',
            'rgba(72, 91, 52, 1.00)',
          ],
          filename:
            'ip parc de la gaudiniere/davidia/davidia involucrata/davidia involucrata (2).jpg',
          width: 1024,
          id: 'ac9da78e0271aecdd25d14f2426af1ad',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc de la Gaudini\u00e8re',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 160, 120, 1.00)',
            'rgba(108, 128, 86, 1.00)',
            'rgba(54, 65, 35, 1.00)',
          ],
          filename:
            'ip parc de la gaudiniere/davidia/davidia involucrata/davidia involucrata (1).jpg',
          width: 1024,
          id: 'd0241e6b0c2839e0767686aac158a1f7',
          height: 683,
          thumbnail: true,
        },
        location: [47.243953, -1.582205],
        genre: 'Davidia',
        famille: 'Nyssaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582205, 47.243953] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '784d618ebc5eb2ead1d7ec906ee0aae404f95d57',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'spathulata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 156, 103, 1.00)',
            'rgba(95, 112, 64, 1.00)',
            'rgba(95, 93, 69, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/diabelia/diabelia spathulata/diabelia spathulata (2).jpg',
          width: 1024,
          id: '14bd2ec98ebc8c9d0bacff41aff446b6',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 123, 81, 1.00)',
            'rgba(111, 127, 81, 1.00)',
            'rgba(93, 115, 68, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/diabelia/diabelia spathulata/diabelia spathulata (3).jpg',
          width: 1024,
          id: '11e511b641b738d8bf0707d581b006c9',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 123, 69, 1.00)',
            'rgba(108, 131, 75, 1.00)',
            'rgba(92, 116, 61, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/diabelia/diabelia spathulata/diabelia spathulata (1).jpg',
          width: 1024,
          id: '75b7c2a4f4ceba16afc3024a18d53383',
          height: 683,
          thumbnail: true,
        },
        location: [47.220378, -1.541988],
        genre: 'Diabelia',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541988, 47.220378] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9a2e8c4b2370e47d9f5ba8c2b6ca0c262502ad98',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'kaki',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 165, 196, 1.00)',
            'rgba(143, 140, 136, 1.00)',
            'rgba(121, 129, 60, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/diospyros/diospyros kaki/diospyros kaki  (2).jpg',
          width: 576,
          id: '3907c6b873f7c676a48fbf59fbe9029d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 177, 214, 1.00)',
            'rgba(130, 120, 121, 1.00)',
            'rgba(55, 52, 15, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/diospyros/diospyros kaki/diospyros kaki  (3).jpg',
          width: 866,
          id: 'b82824b8b70506866bbb1b847c21d0b9',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 111, 108, 1.00)',
            'rgba(134, 109, 88, 1.00)',
            'rgba(106, 107, 121, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/diospyros/diospyros kaki/diospyros kaki  (1).jpg',
          width: 576,
          id: '8fe95a462e2a639bf02b58536f9db775',
          height: 768,
          thumbnail: true,
        },
        location: [47.219612, -1.543575],
        genre: 'Diospyros',
        famille: 'Ebenaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543575, 47.219612] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9df449048bddbca69b3fc68ff7e4ae9f9dc2f6a5',
      fields: {
        espece: 'lotus',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(188, 202, 186, 1.00)',
            'rgba(97, 107, 73, 1.00)',
            'rgba(90, 101, 45, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/diospyros/diospyros lotus/diospyros lotus (femelle).jpg',
          width: 576,
          id: '5440206f0facca2cfd37f24d2eecdf82',
          height: 768,
          thumbnail: true,
        },
        location: [47.220438, -1.542587],
        genre: 'Diospyros',
        famille: 'Ebenaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542587, 47.220438] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '78b30aad3e273701b1a12c911c00f096507e7717',
      fields: {
        espece: 'ovatifolius',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 166, 165, 1.00)',
            'rgba(123, 112, 108, 1.00)',
            'rgba(83, 75, 70, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/disanthus/disanthus ovatifolius/disanthus ovatifolius (3).jpg',
          width: 1024,
          id: '51a23d18e520b5321a4be64351faf017',
          height: 683,
          thumbnail: true,
        },
        location: [47.218787, -1.541533],
        genre: 'Disanthus',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541533, 47.218787] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b525e84eae8493d0099ca6998ced737e88f80e86',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'dicksonii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 82, 44, 1.00)',
            'rgba(115, 124, 76, 1.00)',
            'rgba(122, 146, 100, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ehretia/ehretia dicksonii/ehretia dicksonii (2).jpg',
          width: 576,
          id: 'f35bedddb8b847e69d2b580e047c6dbf',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(177, 186, 164, 1.00)',
            'rgba(101, 119, 79, 1.00)',
            'rgba(74, 89, 40, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ehretia/ehretia dicksonii/ehretia dicksonii (3).jpg',
          width: 559,
          id: '87809a8411d4c39ca6c1af687d060ea0',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 123, 119, 1.00)',
            'rgba(131, 136, 118, 1.00)',
            'rgba(133, 144, 121, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ehretia/ehretia dicksonii/ehretia dicksonii (1).jpg',
          width: 576,
          id: '26dff69fda427802e8c169a0651f7ad1',
          height: 768,
          thumbnail: true,
        },
        location: [47.219242, -1.542912],
        genre: 'Ehretia',
        famille: 'Boraginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542912, 47.219242] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'feb6789c0d66346bb4faf173f3028020bce0b237',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'dicksonii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 122, 54, 1.00)',
            'rgba(128, 153, 61, 1.00)',
            'rgba(112, 127, 53, 1.00)',
          ],
          filename:
            'ip parc de proce/ehretia/ehretia dicksonii/ehretia dicksonii (2).jpg',
          width: 576,
          id: 'ce8b312f38df519fa2b979ded6fc88d9',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 164, 149, 1.00)',
            'rgba(103, 137, 109, 1.00)',
            'rgba(102, 122, 87, 1.00)',
          ],
          filename:
            'ip parc de proce/ehretia/ehretia dicksonii/ehretia dicksonii (3).jpg',
          width: 576,
          id: '09411bd4fb556504e93d1b4bab67fb5b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 161, 163, 1.00)',
            'rgba(125, 138, 117, 1.00)',
            'rgba(90, 109, 84, 1.00)',
          ],
          filename:
            'ip parc de proce/ehretia/ehretia dicksonii/ehretia dicksonii (1).jpg',
          width: 576,
          id: 'e60121bb474a32cf8db4a61702130a0e',
          height: 768,
          thumbnail: true,
        },
        location: [47.223012, -1.580017],
        genre: 'Ehretia',
        famille: 'Boraginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580017, 47.223012] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ac61a3e5ed80dc29545d9f718c96a75b30c03eb0',
      fields: {
        espece: 'campanulatus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 155, 92, 1.00)',
            'rgba(112, 123, 68, 1.00)',
            'rgba(95, 90, 74, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/enkianthus/enkianthus campanulatus/enkianthus campanulatus (2).jpg',
          width: 1024,
          id: 'f72c38c32ed66f0948c6030238c2b4cd',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 154, 68, 1.00)',
            'rgba(140, 130, 71, 1.00)',
            'rgba(118, 119, 57, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/enkianthus/enkianthus campanulatus/enkianthus campanulatus (1).jpg',
          width: 1024,
          id: '21221b8bf6103be3a7dd951b37132c41',
          height: 768,
          thumbnail: true,
        },
        location: [47.228138, -1.508445],
        genre: 'Enkianthus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508445, 47.228138] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '99a03f9007129ab4c088a8063284ab24c11dc243',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'kiautschovicus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 138, 112, 1.00)',
            'rgba(130, 125, 63, 1.00)',
            'rgba(151, 138, 64, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/euonymus/euonymus kiautschovicus/euonymus kiautschovicus (2).jpg',
          width: 576,
          id: '1361e092c4bab9335581b2ab98e8190a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 94, 64, 1.00)',
            'rgba(93, 122, 81, 1.00)',
            'rgba(83, 117, 74, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/euonymus/euonymus kiautschovicus/euonymus kiautschovicus.jpg',
          width: 1024,
          id: 'fe41705fc9c1ef31586c69882fc35d7c',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 95, 47, 1.00)',
            'rgba(116, 154, 70, 1.00)',
            'rgba(97, 123, 49, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/euonymus/euonymus kiautschovicus/euonymus kiautschovicus (1).jpg',
          width: 576,
          id: '4bac810eab6631dcc53eba4d5a517b0c',
          height: 768,
          thumbnail: true,
        },
        location: [47.218992, -1.543655],
        genre: 'Euonymus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543655, 47.218992] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '22478695b9d2403864289053bb794ca0d64b1f38',
      fields: {
        espece: 'myrianthus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 127, 67, 1.00)',
            'rgba(123, 128, 47, 1.00)',
            'rgba(70, 78, 29, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/euonymus/euonymus myrianthus/euonymus myrianthus (5).jpg',
          width: 1024,
          id: '2742b99cab729ffbe297d9a58fff9cd5',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 175, 113, 1.00)',
            'rgba(84, 113, 53, 1.00)',
            'rgba(85, 93, 65, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/euonymus/euonymus myrianthus/euonymus myrianthus (1).jpg',
          width: 1024,
          id: 'd40d2c977593bfd239e35397d1ebfc9e',
          height: 683,
          thumbnail: true,
        },
        location: [47.262495, -1.528987],
        genre: 'Euonymus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.528987, 47.262495] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '45ba512ddb78c7439f292b3d7a71a5eebae13b46',
      fields: {
        espece: 'myrianthus',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 110, 60, 1.00)',
            'rgba(92, 104, 27, 1.00)',
            'rgba(51, 66, 11, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/euonymus/euonymus myrianthus/euonymus myrianthus (2).jpg',
          width: 512,
          id: 'a2c07662c4208c8a0473ef994025d5c8',
          height: 768,
          thumbnail: true,
        },
        location: [47.262517, -1.529025],
        genre: 'Euonymus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529025, 47.262517] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4e73c1809f923b05b0d193565593fee2c6e05bae',
      fields: {
        espece: 'meliaefolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 126, 120, 1.00)',
            'rgba(97, 115, 82, 1.00)',
            'rgba(70, 86, 48, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/evodia/evodia meliaefolia/evodia meliaefolia (2).jpg',
          width: 1024,
          id: '9fbd27abac27de77b87d162e8a5de329',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 174, 171, 1.00)',
            'rgba(91, 105, 62, 1.00)',
            'rgba(41, 52, 24, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/evodia/evodia meliaefolia/evodia meliaefolia (1).jpg',
          width: 512,
          id: 'e232ac441f6c80cb5fdad62d288984b5',
          height: 768,
          thumbnail: true,
        },
        location: [47.219137, -1.54292],
        genre: 'Evodia',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54292, 47.219137] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '892f427c63bfee285071fc161a8ddb38caacca58',
      fields: {
        espece: 'meliaefolia',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 182, 153, 1.00)',
            'rgba(103, 125, 66, 1.00)',
            'rgba(73, 92, 40, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/evodia/evodia meliaefolia/evodia meliaefolia.jpg',
          width: 1024,
          id: '39f1bf02a3564014598d30c7852ef4b9',
          height: 768,
          thumbnail: true,
        },
        location: [47.219138, -1.54292],
        genre: 'Evodia',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54292, 47.219138] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '76a94ba75ec4ac1de8ac2c31d05c93692757ea06',
      fields: {
        espece: 'grandifolia',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 175, 85, 1.00)',
            'rgba(99, 153, 59, 1.00)',
            'rgba(85, 124, 43, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/fagus/fagus grandifolia/fagus grandifolia.jpg',
          width: 576,
          id: '94caa81288b398e27a459c90564ebb4b',
          height: 768,
          thumbnail: true,
        },
        location: [47.218647, -1.542253],
        genre: 'Fagus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542253, 47.218647] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '99880c40cd8ef932a513a769f4639709421c6e47',
      fields: {
        espece: 'sylvatica',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 170, 119, 1.00)',
            'rgba(98, 114, 47, 1.00)',
            'rgba(68, 82, 45, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/fagus/fagus sylvatica 'zlatia'/fagus sylvatica 'zlatia'.jpg",
          width: 576,
          id: '3ce66a97fd9c8d2efefc93055f6b922b',
          height: 768,
          thumbnail: true,
        },
        location: [47.218687, -1.542228],
        genre: 'Fagus',
        cultivar: 'Zlatia',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542228, 47.218687] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '750c9aad78ab411bb35fc876a6089fe0e12343ec',
      fields: {
        espece: 'sylvatica f. tortuosa',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 176, 101, 1.00)',
            'rgba(126, 146, 73, 1.00)',
            'rgba(96, 97, 57, 1.00)',
          ],
          filename:
            'ip parc de proce/fagus/fagus sylvatica f. tortuosa/fagus sylvatica f. tortuosa.jpg',
          width: 576,
          id: '27dfca365756dc6efa3b262a458c253f',
          height: 768,
          thumbnail: true,
        },
        location: [47.222705, -1.584905],
        genre: 'Fagus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584905, 47.222705] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1494c3f538ec6aaf85c7b1da715dd847997f5f22',
      fields: {
        espece: 'sylvatica',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 175, 148, 1.00)',
            'rgba(76, 101, 28, 1.00)',
            'rgba(63, 82, 42, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/fagus/fagus sylvatica 'aspleniifolia'/fagus sylvatica 'aspleniifolia'.jpg",
          width: 512,
          id: '93ef5740fe41d246e52607af600f29a9',
          height: 768,
          thumbnail: true,
        },
        location: [47.262647, -1.535417],
        genre: 'Fagus',
        cultivar: 'Aspleniifolia',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535417, 47.262647] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b874654bf0c39044b56ad82c3e972b1c99fb8350',
      fields: {
        espece: 'simplex',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 87, 38, 1.00)',
            'rgba(157, 137, 81, 1.00)',
            'rgba(63, 84, 27, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/firmiana/firmiana simplex/firmiana simplex (2).jpg',
          width: 576,
          id: '812a4718433b5c018d6e8282213e020e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(173, 162, 136, 1.00)',
            'rgba(137, 115, 63, 1.00)',
            'rgba(86, 87, 52, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/firmiana/firmiana simplex/firmiana simplex (1).jpg',
          width: 640,
          id: '8608ce8277b6a112c467699eb7d7f65d',
          height: 768,
          thumbnail: true,
        },
        location: [47.23003, -1.509937],
        genre: 'Firmiana',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.509937, 47.23003] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4c1cd25d0d065c20910be4074bc08973197299bb',
      fields: {
        espece: 'simplex',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 166, 169, 1.00)',
            'rgba(82, 93, 57, 1.00)',
            'rgba(73, 77, 53, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/firmiana/firmiana simplex/firmiana simplex (6).jpg',
          width: 816,
          id: 'f7bf7cd1cbaf696d411a5010931426f5',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 177, 205, 1.00)',
            'rgba(136, 138, 120, 1.00)',
            'rgba(93, 97, 62, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/firmiana/firmiana simplex/firmiana simplex (4).jpg',
          width: 512,
          id: 'ba9cf70a228297c432d13e96e30e5a23',
          height: 768,
          thumbnail: true,
        },
        location: [47.230063, -1.509833],
        genre: 'Firmiana',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.509833, 47.230063] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'de552132afeef200dc664caa9048ff25b8dccf25',
      fields: {
        espece: 'simplex',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(169, 172, 147, 1.00)',
            'rgba(81, 86, 60, 1.00)',
            'rgba(79, 94, 40, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/firmiana/firmiana simplex/firmiana simplex .jpg',
          width: 671,
          id: '085f85702bc79fb9eaf37f00bb2689d4',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 146, 199, 1.00)',
            'rgba(132, 143, 154, 1.00)',
            'rgba(117, 119, 81, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/firmiana/firmiana simplex/firmiana simplex (5).jpg',
          width: 596,
          id: '03c6419e8563af3b1ae995e38dc9bd43',
          height: 768,
          thumbnail: true,
        },
        location: [47.230072, -1.509975],
        genre: 'Firmiana',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.509975, 47.230072] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '975bf0e6741504854aec86f215f545163c6fdf9d',
      fields: {
        espece: 'excelsior',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 169, 125, 1.00)',
            'rgba(109, 114, 33, 1.00)',
            'rgba(63, 70, 30, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/fraxinus/fraxinus excelsior 'jaspidea'/fraxinus excelsior 'jaspidea'.jpg",
          width: 692,
          id: 'c98fc2c22fdc8a019b6acb4f5489f38d',
          height: 768,
          thumbnail: true,
        },
        location: [47.262244, -1.528845],
        genre: 'Fraxinus',
        cultivar: 'Jaspidea',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.528845, 47.262244] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0e988bf96d687632b2f5c3331267fe9e0d1d5650',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 128, 175, 1.00)',
            'rgba(130, 74, 63, 1.00)',
            'rgba(82, 59, 54, 1.00)',
          ],
          filename:
            "ip ville de nantes/fraxinus/fraxinus angustifolia 'raywood'/fraxinus angustifolia 'raywood' (3).jpg",
          width: 512,
          id: 'cb76918c7a9adf8294319110780a64db',
          height: 768,
          thumbnail: true,
        },
        espece: 'angustifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 95, 132, 1.00)',
            'rgba(115, 86, 102, 1.00)',
            'rgba(113, 66, 48, 1.00)',
          ],
          filename:
            "ip ville de nantes/fraxinus/fraxinus angustifolia 'raywood'/fraxinus angustifolia 'raywood' (2).jpg",
          width: 512,
          id: 'f4557b353eeb18951b6f4698002d4e28',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 115, 177, 1.00)',
            'rgba(108, 81, 116, 1.00)',
            'rgba(98, 121, 180, 1.00)',
          ],
          filename:
            "ip ville de nantes/fraxinus/fraxinus angustifolia 'raywood'/fraxinus angustifolia 'raywood' (1).jpg",
          width: 549,
          id: '8b9d066d117251279e3e497b62128c49',
          height: 768,
          thumbnail: true,
        },
        location: [47.222783, -1.577938],
        genre: 'Fraxinus',
        cultivar: 'Raywood',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.577938, 47.222783] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3f1e6020ae0d8d5a1a2cb47ab36694fde7b4da8b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 57, 27, 1.00)',
            'rgba(125, 78, 41, 1.00)',
            'rgba(110, 78, 38, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis x intermedia 'jelena'/hamamelis x intermedia 'jelena' (11).jpg",
          width: 1024,
          id: 'f54521a37bbc8e6c0f8cd06edf614ab4',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 136, 124, 1.00)',
            'rgba(92, 54, 24, 1.00)',
            'rgba(85, 68, 37, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis x intermedia 'jelena'/hamamelis x intermedia 'jelena' (8).jpg",
          width: 1024,
          id: 'b20ca858e76747a111358a61433c732e',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(61, 48, 26, 1.00)',
            'rgba(127, 79, 45, 1.00)',
            'rgba(125, 90, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis x intermedia 'jelena'/hamamelis x intermedia 'jelena' (10).jpg",
          width: 1024,
          id: '29d44d70cec5842d5b417de523323755',
          height: 743,
          thumbnail: true,
        },
        location: [47.271245, -1.582033],
        genre: 'Hamamelis',
        cultivar: 'Jelena',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582033, 47.271245] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '60bf2694f574d05172b38f0628a31af76d017877',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 103, 84, 1.00)',
            'rgba(103, 94, 63, 1.00)',
            'rgba(108, 101, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis x intermedia 'jelena'/hamamelis x intermedia 'jelena' (14).jpg",
          width: 1024,
          id: '999d7af2bb520f70dcca45bd2a0e6ea9',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 135, 101, 1.00)',
            'rgba(110, 112, 65, 1.00)',
            'rgba(104, 105, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis x intermedia 'jelena'/hamamelis x intermedia 'jelena' (15).jpg",
          width: 1024,
          id: '706e72d6f0befa1d99995fe9d7362e82',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 135, 135, 1.00)',
            'rgba(103, 96, 61, 1.00)',
            'rgba(111, 92, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis x intermedia 'jelena'/hamamelis x intermedia 'jelena' (13).jpg",
          width: 1024,
          id: 'd4482e524e5400c47ca7f83b2a04fc59',
          height: 683,
          thumbnail: true,
        },
        location: [47.271245, -1.582037],
        genre: 'Hamamelis',
        cultivar: 'Jelena',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582037, 47.271245] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cd37edae414b85d96592845545a8b9b33af37b71',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 139, 126, 1.00)',
            'rgba(122, 119, 112, 1.00)',
            'rgba(80, 76, 90, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis x intermedia 'pallida'/hamamelis x intermedia 'pallida' (7).jpg",
          width: 1024,
          id: 'f0ed8c9fb48af8669841c255aae57794',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 154, 151, 1.00)',
            'rgba(102, 98, 75, 1.00)',
            'rgba(56, 53, 48, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis x intermedia 'pallida'/hamamelis x intermedia 'pallida' (5).jpg",
          width: 1024,
          id: '2f371d70b8c9d4462a459598042dc3e0',
          height: 683,
          thumbnail: true,
        },
        location: [47.270332, -1.58219],
        genre: 'Hamamelis',
        cultivar: 'Pallida',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58219, 47.270332] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c98b05a4422e91d72445f78d41b6e120754aaceb',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'angustifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 101, 74, 1.00)',
            'rgba(131, 137, 110, 1.00)',
            'rgba(86, 92, 54, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/hoheria/hoheria angustifolia/hoheria angustifolia (2).jpg',
          width: 576,
          id: '6272a535ae734f6a5a83a4914dbf210c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 132, 72, 1.00)',
            'rgba(136, 148, 88, 1.00)',
            'rgba(116, 126, 79, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/hoheria/hoheria angustifolia/hoheria angustifolia (3).jpg',
          width: 576,
          id: '1acbfb49b84a81a618ea93f59b01eca0',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(202, 214, 219, 1.00)',
            'rgba(121, 127, 96, 1.00)',
            'rgba(92, 98, 53, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/hoheria/hoheria angustifolia/hoheria angustifolia (1).jpg',
          width: 1024,
          id: '14925395c53de4b4cbbc5d0eb0abc500',
          height: 768,
          thumbnail: true,
        },
        location: [47.228133, -1.508188],
        genre: 'Hoheria',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508188, 47.228133] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5ced5a5f7fb1346961abe6396dacfadd15990502',
      fields: {
        espece: 'dulcis',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 130, 171, 1.00)',
            'rgba(77, 99, 88, 1.00)',
            'rgba(65, 86, 76, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/hovenia/hovenia dulcis/hovenia dulcis.jpg',
          width: 979,
          id: '68e58520c4cc0c5494a5affd69a6f305',
          height: 768,
          thumbnail: true,
        },
        location: [47.26249, -1.532337],
        genre: 'Hovenia',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532337, 47.26249] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '93310d94a66cf435e02b8c74d811ea6487eacb0f',
      fields: {
        espece: 'nigra',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 67, 66, 1.00)',
            'rgba(114, 92, 46, 1.00)',
            'rgba(77, 95, 116, 1.00)',
          ],
          filename: 'ip parc de proce/juglans/juglans nigra/juglans nigra.jpg',
          width: 512,
          id: 'e3d52f7fdf9c9b1b7dca24b3e191b601',
          height: 768,
          thumbnail: true,
        },
        location: [47.223122, -1.58272],
        genre: 'Juglans',
        famille: 'Juglandaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58272, 47.223122] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4971d5b8f56535c4acfa0ee0fb099358fa5be4c4',
      fields: {
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 122, 83, 1.00)',
            'rgba(90, 120, 80, 1.00)',
            'rgba(83, 111, 73, 1.00)',
          ],
          filename:
            'ip ville de nantes/koelreuteria/koelreuteria paniculata/koelreuteria paniculata.jpg',
          width: 576,
          id: 'b5001f36cbad76b5369f71c252451849',
          height: 768,
          thumbnail: true,
        },
        genre: 'Koelreuteria',
        espece: 'paniculata',
        famille: 'Sapindaceae',
        nom_du_site: 'Autre site',
      },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c056eaa0426f709531ea44929f8da8f7365dbdbf',
      fields: {
        espece: 'nobilis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(33, 47, 11, 1.00)',
            'rgba(87, 102, 22, 1.00)',
            'rgba(96, 114, 19, 1.00)',
          ],
          filename:
            "ip ville de nantes/laurus/laurus nobilis 'aurea'/laurus nobilis 'aurea' (2).jpg",
          width: 1024,
          id: '4a53048803760298115c7c083a2c36c7',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 155, 127, 1.00)',
            'rgba(86, 103, 46, 1.00)',
            'rgba(67, 83, 34, 1.00)',
          ],
          filename:
            "ip ville de nantes/laurus/laurus nobilis 'aurea'/laurus nobilis 'aurea' (1).jpg",
          width: 512,
          id: 'f80e9cfdd1731c060d95b5671b7ec717',
          height: 768,
          thumbnail: true,
        },
        location: [47.255613, -1.599162],
        genre: 'Laurus',
        cultivar: 'Aurea',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.599162, 47.255613] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'da9256bb3e72a8313fa3c29db6a64b6397c783a6',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'involucrata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 149, 92, 1.00)',
            'rgba(111, 137, 68, 1.00)',
            'rgba(115, 144, 70, 1.00)',
          ],
          filename:
            'ip parc de proce/lonicera/lonicera involucrata/lonicera involucrata (2).jpg',
          width: 1024,
          id: '29e193859d7660ededc291ac5d7c9c32',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 141, 45, 1.00)',
            'rgba(102, 142, 41, 1.00)',
            'rgba(93, 136, 42, 1.00)',
          ],
          filename:
            'ip parc de proce/lonicera/lonicera involucrata/lonicera involucrata (3).jpg',
          width: 576,
          id: 'faa7b03ec845b17966730ab88ecceb08',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 147, 69, 1.00)',
            'rgba(116, 162, 71, 1.00)',
            'rgba(104, 143, 54, 1.00)',
          ],
          filename:
            'ip parc de proce/lonicera/lonicera involucrata/lonicera involucrata (1).jpg',
          width: 576,
          id: '40a3ec9e629a52721c68cebe5b58265f',
          height: 768,
          thumbnail: true,
        },
        location: [47.222925, -1.584817],
        genre: 'Lonicera',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584817, 47.222925] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9a43ee194ba4c7d747e746dfd599ec16fbfded58',
      fields: {
        genre: 'Loropetalum',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 140, 95, 1.00)',
            'rgba(105, 128, 70, 1.00)',
            'rgba(130, 135, 109, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/loropetalum hamamelidaceae/loropetalum chinense/loropetalum chinense (2).jpg',
          width: 1024,
          id: '487b5848483170c5f218f39ea67a90fd',
          height: 768,
          thumbnail: true,
        },
        location: [47.27047, -1.58222],
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58222, 47.27047] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '28fd114b341bae6fdd7980cf228971b0f5321e1c',
      fields: {
        espece: 'pomifera',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 97, 84, 1.00)',
            'rgba(146, 115, 78, 1.00)',
            'rgba(90, 80, 65, 1.00)',
          ],
          filename:
            'ip parc de proce/maclura/maclura pomifera/maclura pomifera.jpg',
          width: 576,
          id: '18dc0489254da65d93855f31146ca37e',
          height: 768,
          thumbnail: true,
        },
        location: [47.222728, -1.580738],
        genre: 'Maclura',
        famille: 'Moraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580738, 47.222728] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3d8c4e4f799121d1cfa97928c6a69ca75a5bd48e',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'acuminata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 162, 85, 1.00)',
            'rgba(112, 137, 57, 1.00)',
            'rgba(86, 110, 25, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia acuminata/magnolia acuminata (2).jpg',
          width: 664,
          id: '23ecef4b78eb2a5a00880933a09ec034',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 173, 122, 1.00)',
            'rgba(91, 106, 49, 1.00)',
            'rgba(53, 61, 26, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia acuminata/magnolia acuminata (4).jpg',
          width: 512,
          id: 'bbbb29d58215ff06ca6edf810d244612',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 145, 110, 1.00)',
            'rgba(91, 120, 71, 1.00)',
            'rgba(83, 106, 67, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia acuminata/magnolia acuminata (1).jpg',
          width: 1024,
          id: '9ba7d8151cd3483c62a8460c38ccf2b9',
          height: 723,
          thumbnail: true,
        },
        location: [47.219322, -1.542058],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542058, 47.219322] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cfa5f7aec48409f2f97c6003f24dee746ba3a404',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 101, 56, 1.00)',
            'rgba(124, 132, 79, 1.00)',
            'rgba(60, 74, 35, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia 'yellow lantern'/magnolia 'yellow lantern' (1).jpg",
          width: 576,
          id: '55513ae0e253590ecd2344898a75359b',
          height: 768,
          thumbnail: true,
        },
        location: [47.2234, -1.580147],
        genre: 'Magnolia',
        cultivar: 'Yellow Lantern',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580147, 47.2234] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '289fd8c13e9cc42bac759e3ba8c27863c6cec4a6',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 177, 162, 1.00)',
            'rgba(96, 120, 72, 1.00)',
            'rgba(90, 102, 54, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia campbellii alba group 'ethel hillier'/magnolia campbellii alba group 'ethel hillier' (3).jpg",
          width: 1024,
          id: '44d713ce046726a6d2a7f185d3219597',
          height: 768,
          thumbnail: true,
        },
        espece: 'campbellii Alba Group',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 155, 166, 1.00)',
            'rgba(120, 123, 119, 1.00)',
            'rgba(62, 59, 36, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia campbellii alba group 'ethel hillier'/magnolia campbellii alba group 'ethel hillier' (2).jpg",
          width: 678,
          id: '04aa077f66533711e1ea4021d31b9ae0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 153, 78, 1.00)',
            'rgba(109, 150, 73, 1.00)',
            'rgba(101, 120, 52, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia campbellii alba group 'ethel hillier'/magnolia campbellii alba group 'ethel hillier' (1).jpg",
          width: 576,
          id: 'bef1c2a32b59860b7cdc458b5ea76b6f',
          height: 768,
          thumbnail: true,
        },
        location: [47.222539, -1.579731],
        genre: 'Magnolia',
        cultivar: 'Ethel Hillier',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.579731, 47.222539] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '00e15b51b773a847f3cbb34d49e0f921b0633a3d',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'denudata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 160, 168, 1.00)',
            'rgba(86, 92, 93, 1.00)',
            'rgba(63, 62, 52, 1.00)',
          ],
          filename:
            'ip parc de proce/magnolia/magnolia denudata/magnolia denudata (2).jpg',
          width: 619,
          id: '1aeb1c54688cf984763c16bbd50b610c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 170, 104, 1.00)',
            'rgba(121, 152, 83, 1.00)',
            'rgba(95, 125, 48, 1.00)',
          ],
          filename:
            'ip parc de proce/magnolia/magnolia denudata/magnolia denudata (3).jpg',
          width: 576,
          id: 'b529b93b414ab6857773f62e67b2cdd8',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 125, 93, 1.00)',
            'rgba(126, 128, 105, 1.00)',
            'rgba(102, 102, 89, 1.00)',
          ],
          filename:
            'ip parc de proce/magnolia/magnolia denudata/magnolia denudata (1).jpg',
          width: 576,
          id: '920ee73ecf63b3738841fc6111325443',
          height: 768,
          thumbnail: true,
        },
        location: [47.222495, -1.579045],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.579045, 47.222495] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '24cdd3eb0c207b549788e8cbbf83283af2fe3ebd',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 163, 125, 1.00)',
            'rgba(137, 129, 76, 1.00)',
            'rgba(99, 102, 33, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia x brooklynensis 'woodsman'/magnolia x brooklynensis 'woodsman'  (1).jpg",
          width: 576,
          id: '995222b5998e4e1a2aece1495a8012af',
          height: 768,
          thumbnail: true,
        },
        espece: 'x brooklynensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 150, 91, 1.00)',
            'rgba(98, 110, 43, 1.00)',
            'rgba(66, 81, 36, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia x brooklynensis 'woodsman'/magnolia x brooklynensis 'woodsman'   (2).jpg",
          width: 672,
          id: '7eb55db527ffb814c0f1b8ef2d4f409e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 147, 66, 1.00)',
            'rgba(114, 146, 56, 1.00)',
            'rgba(101, 129, 55, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia x brooklynensis 'woodsman'/magnolia x brooklynensis 'woodsman'   (1).jpg",
          width: 576,
          id: '81bb2165c049efadbe18661a0efa9802',
          height: 768,
          thumbnail: true,
        },
        location: [47.225747, -1.581772],
        genre: 'Magnolia',
        cultivar: 'Woodsman',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581772, 47.225747] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '499d111ec0e2f305a723bc0bff6de3f901f9ca35',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 126, 137, 1.00)',
            'rgba(155, 104, 124, 1.00)',
            'rgba(108, 71, 74, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'betty'/magnolia 'betty'.jpg",
          width: 576,
          id: 'd6a061d96945d5c3c26e09a2dda95984',
          height: 768,
          thumbnail: true,
        },
        location: [47.263375, -1.531613],
        genre: 'Magnolia',
        cultivar: 'Betty',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531613, 47.263375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a63e0b22b6451a0e801f9590a06eaf866e4db34d',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 83, 134, 1.00)',
            'rgba(123, 75, 105, 1.00)',
            'rgba(119, 63, 79, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'big dude'/magnolia 'big dude' (4).jpg",
          width: 512,
          id: 'dabcafcc2c9187feca09bd0b5dd6e57c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 102, 159, 1.00)',
            'rgba(128, 125, 148, 1.00)',
            'rgba(70, 75, 58, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'big dude'/magnolia 'big dude' (3).jpg",
          width: 512,
          id: 'f5669ed1ea6dc500a0b01ee6cdc67930',
          height: 768,
          thumbnail: true,
        },
        location: [47.263072, -1.53255],
        genre: 'Magnolia',
        cultivar: 'Big Dude',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53255, 47.263072] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd3748087e0dcc1ed985becab85aa5452b583ae25',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 145, 193, 1.00)',
            'rgba(150, 125, 162, 1.00)',
            'rgba(124, 134, 172, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'caerhays belle'/magnolia 'caerhays belle' (2).jpg",
          width: 576,
          id: 'a8ae1d25017ec5b61fc66125d48ee00e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 123, 131, 1.00)',
            'rgba(160, 114, 134, 1.00)',
            'rgba(133, 131, 147, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'caerhays belle'/magnolia 'caerhays belle' (3).jpg",
          width: 576,
          id: '6b0667c81ee68a0f5f6ea0249410ff02',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 183, 220, 1.00)',
            'rgba(134, 134, 128, 1.00)',
            'rgba(104, 98, 49, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'caerhays belle'/magnolia 'caerhays belle' (1).jpg",
          width: 576,
          id: 'ef872930a03df61aa24864bbdff3c99f',
          height: 768,
          thumbnail: true,
        },
        location: [47.263375, -1.531613],
        genre: 'Magnolia',
        cultivar: 'Caerhays Belle',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531613, 47.263375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9cb2187b567d7d53748c44d8493457344a022d41',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 98, 68, 1.00)',
            'rgba(114, 121, 82, 1.00)',
            'rgba(56, 65, 35, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'gold star'/magnolia 'gold star' (10).jpg",
          width: 1024,
          id: '6d8ecf47bd3f67f4003ecfbdaa862e24',
          height: 647,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(168, 191, 225, 1.00)',
            'rgba(114, 120, 124, 1.00)',
            'rgba(48, 46, 21, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'gold star'/magnolia 'gold star' (11).jpg",
          width: 1024,
          id: '735ed8dfd4ba05fc4eb70918bdd6bc72',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(42, 55, 26, 1.00)',
            'rgba(104, 113, 71, 1.00)',
            'rgba(96, 108, 63, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'gold star'/magnolia 'gold star' (1).jpg",
          width: 1024,
          id: '4f984ee7a33db66a1adced51e5ecfea9',
          height: 683,
          thumbnail: true,
        },
        location: [47.26328, -1.535762],
        genre: 'Magnolia',
        cultivar: 'Gold Star',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535762, 47.26328] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b1bb68548a0cf3ccc955e27b857a5735d1b7dbe4',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(177, 189, 208, 1.00)',
            'rgba(102, 99, 91, 1.00)',
            'rgba(68, 71, 41, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'jolly roger'/magnolia 'jolly roger' (2).jpg",
          width: 1024,
          id: 'e5979c98b2017e965409571b87243c20',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 107, 149, 1.00)',
            'rgba(111, 124, 147, 1.00)',
            'rgba(113, 130, 156, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'jolly roger'/magnolia 'jolly roger' (3).jpg",
          width: 512,
          id: '331fa85d7723822abc00ab46a667a383',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 143, 160, 1.00)',
            'rgba(127, 126, 121, 1.00)',
            'rgba(79, 79, 56, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'jolly roger'/magnolia 'jolly roger' (1).jpg",
          width: 1024,
          id: 'df1007f986f4dd0db272ff8d81fd83c6',
          height: 683,
          thumbnail: true,
        },
        location: [47.26435, -1.535642],
        genre: 'Magnolia',
        cultivar: 'Jolly Roger',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535642, 47.26435] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '980c1d004800912f49c80b90e412a6805718c719',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 100, 98, 1.00)',
            'rgba(135, 125, 122, 1.00)',
            'rgba(115, 110, 105, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'mark jury'/magnolia 'mark jury' (1).jpg",
          width: 576,
          id: '0a8fc79a5c685008364366fd6ccf62c0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 149, 177, 1.00)',
            'rgba(138, 142, 130, 1.00)',
            'rgba(108, 106, 38, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'mark jury'/magnolia 'mark jury'  (2).jpg",
          width: 576,
          id: '7bb3bee3043f67d3a4ebcad3b6764452',
          height: 768,
          thumbnail: true,
        },
        location: [47.262738, -1.53132],
        genre: 'Magnolia',
        cultivar: 'Mark Jury',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53132, 47.262738] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9a195d786cc024c3e730b387c7d5dce46654f7aa',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 129, 61, 1.00)',
            'rgba(103, 129, 44, 1.00)',
            'rgba(110, 135, 45, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'porcelain dove'/magnolia 'porcelain dove' (2).jpg",
          width: 576,
          id: '614b3ecfb09adcad1a540d05027af676',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 137, 114, 1.00)',
            'rgba(109, 128, 84, 1.00)',
            'rgba(83, 111, 57, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'porcelain dove'/magnolia 'porcelain dove' (3).jpg",
          width: 1024,
          id: '2d304a88e9cadf38ab9d24bf3abebffc',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 70, 48, 1.00)',
            'rgba(88, 97, 70, 1.00)',
            'rgba(89, 95, 69, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'porcelain dove'/magnolia 'porcelain dove' (10).jpg",
          width: 1024,
          id: '7d81da2a6ee26582bc583e591c6170d9',
          height: 683,
          thumbnail: true,
        },
        location: [47.262428, -1.534088],
        genre: 'Magnolia',
        cultivar: 'Porcelain Dove',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534088, 47.262428] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a91a3ecdc3f278238749d8898b064ee7b8098ee9',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 119, 122, 1.00)',
            'rgba(122, 125, 118, 1.00)',
            'rgba(96, 97, 82, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'tina durio'/magnolia 'tina durio' (2).jpg",
          width: 512,
          id: 'f0a2a96a78d4cb450a25b9c6495f7466',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 140, 174, 1.00)',
            'rgba(107, 112, 108, 1.00)',
            'rgba(64, 64, 46, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'tina durio'/magnolia 'tina durio' (3).jpg",
          width: 1024,
          id: 'ead5433b03d834f86101ff19410c32d7',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 111, 99, 1.00)',
            'rgba(106, 107, 88, 1.00)',
            'rgba(87, 86, 64, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'tina durio'/magnolia 'tina durio' (1).jpg",
          width: 1024,
          id: 'd8df94f74e8e846af9bf2144b32c67e1',
          height: 683,
          thumbnail: true,
        },
        location: [47.2624, -1.530942],
        genre: 'Magnolia',
        cultivar: 'Tina Durio',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530942, 47.2624] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '09350ca1e869cb50e42d53c4f6c29aad010b94ed',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(207, 221, 212, 1.00)',
            'rgba(100, 117, 65, 1.00)',
            'rgba(76, 88, 37, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'yellow bird'/magnolia 'yellow bird' (2).jpg",
          width: 1024,
          id: '114d0689df5d442c359f83129b42ed33',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 127, 42, 1.00)',
            'rgba(103, 139, 47, 1.00)',
            'rgba(128, 145, 59, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'yellow bird'/magnolia 'yellow bird' (3).jpg",
          width: 576,
          id: '581269444b318827abf9d643b014162f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 94, 49, 1.00)',
            'rgba(127, 130, 58, 1.00)',
            'rgba(63, 76, 10, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'yellow bird'/magnolia 'yellow bird' (1).jpg",
          width: 576,
          id: '8d0821b3db7f790e3ef1f0057efe9b41',
          height: 768,
          thumbnail: true,
        },
        location: [47.261553, -1.530555],
        genre: 'Magnolia',
        cultivar: 'Yellow Bird',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530555, 47.261553] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9d33b7accb7f66054db6e5da6852b47f486d4e92',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 113, 115, 1.00)',
            'rgba(105, 106, 88, 1.00)',
            'rgba(72, 73, 45, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'yellow lantern'/magnolia 'yellow lantern' (2).jpg",
          width: 1024,
          id: '04950b4e5b261b6895934a86a688f8c9',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 141, 173, 1.00)',
            'rgba(134, 142, 144, 1.00)',
            'rgba(73, 73, 46, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'yellow lantern'/magnolia 'yellow lantern' (3).jpg",
          width: 1024,
          id: 'b5a7f416c89d3e5fb2e609c00d701ddc',
          height: 714,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 116, 95, 1.00)',
            'rgba(105, 106, 90, 1.00)',
            'rgba(71, 73, 55, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'yellow lantern'/magnolia 'yellow lantern' (1).jpg",
          width: 1024,
          id: '707fa17cb3c1a5e3b5101733a595cd12',
          height: 683,
          thumbnail: true,
        },
        location: [47.262463, -1.530072],
        genre: 'Magnolia',
        cultivar: 'Yellow Lantern',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530072, 47.262463] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1eb0d5f625330622a172c6d906f1c33d81167b90',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'campbellii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 127, 151, 1.00)',
            'rgba(156, 145, 150, 1.00)',
            'rgba(81, 63, 35, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia campbellii/magnolia campbellii (2).jpg',
          width: 576,
          id: 'd17f486e45be26441d15441378011281',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 158, 161, 1.00)',
            'rgba(157, 117, 127, 1.00)',
            'rgba(140, 124, 123, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia campbellii/magnolia campbellii (3).jpg',
          width: 576,
          id: 'a3bd23e956e2e93efd9baf8bb1cb3fa3',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 163, 200, 1.00)',
            'rgba(133, 139, 150, 1.00)',
            'rgba(87, 80, 45, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia campbellii/magnolia campbellii (1).jpg',
          width: 576,
          id: '637e7c1d0823df885592b6126773554c',
          height: 768,
          thumbnail: true,
        },
        location: [47.262313, -1.53088],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53088, 47.262313] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8a2e2030827ea70b1114fa91135f7befd73c68ed',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 138, 73, 1.00)',
            'rgba(129, 141, 43, 1.00)',
            'rgba(114, 132, 34, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia grandiflora 'maulevrie'/magnolia grandiflora 'maulevrie' (12).jpg",
          width: 576,
          id: 'c163a058ea97300c97dceb540ba8c221',
          height: 768,
          thumbnail: true,
        },
        espece: 'grandiflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 121, 77, 1.00)',
            'rgba(99, 113, 53, 1.00)',
            'rgba(69, 88, 45, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia grandiflora 'maulevrie'/magnolia grandiflora 'maulevrie' (10).jpg",
          width: 1024,
          id: 'e884ba1ecbb48628aa67e93b1a0fb7a6',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 98, 45, 1.00)',
            'rgba(131, 139, 69, 1.00)',
            'rgba(92, 101, 28, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia grandiflora 'maulevrie'/magnolia grandiflora 'maulevrie' (1).jpg",
          width: 576,
          id: '0fce8d906795f7f9dbe201dcf1d3f1ac',
          height: 768,
          thumbnail: true,
        },
        location: [47.261428, -1.533037],
        genre: 'Magnolia',
        cultivar: 'Maul\u00e9vrie',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533037, 47.261428] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b5150f2386c8753cbfee306aed9abb02d9a5eddf',
      fields: {
        espece: 'liliiflora',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 92, 84, 1.00)',
            'rgba(109, 94, 81, 1.00)',
            'rgba(92, 88, 55, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia liliiflora 'mini orchid'/magnolia liliiflora 'mini orchid'.jpg",
          width: 1024,
          id: 'dd0bc0c1bb3ea0e47b7dced14647752d',
          height: 683,
          thumbnail: true,
        },
        location: [47.261612, -1.531353],
        genre: 'Magnolia',
        cultivar: 'Mini Orchid',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531353, 47.261612] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '69a22827c2a68f3b5ba85cdc976a04251c6c054a',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'macrophylla',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 95, 43, 1.00)',
            'rgba(90, 115, 77, 1.00)',
            'rgba(67, 97, 50, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia macrophylla/magnolia macrophylla (10).jpg',
          width: 1024,
          id: 'b7fb5420e31affe9c91caaae81a6343f',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(204, 218, 220, 1.00)',
            'rgba(100, 118, 82, 1.00)',
            'rgba(48, 56, 25, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia macrophylla/magnolia macrophylla (11).jpg',
          width: 1024,
          id: '5afae42849831acadaf593b3e157680c',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 146, 110, 1.00)',
            'rgba(161, 155, 107, 1.00)',
            'rgba(175, 177, 140, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia macrophylla/magnolia macrophylla (1).jpg',
          width: 576,
          id: '85fa077e85e9ac1256e2dc51be574d3b',
          height: 768,
          thumbnail: true,
        },
        location: [47.261872, -1.528655],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.528655, 47.261872] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8a74a9e12789053b217a717d01dee16bc4ad7f37',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 148, 106, 1.00)',
            'rgba(94, 114, 61, 1.00)',
            'rgba(97, 114, 70, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sieboldii 'michiko renge'/magnolia sieboldii 'michiko renge' (3).jpg",
          width: 1024,
          id: '18bde118d405b3b0a56bdcefaab15e14',
          height: 683,
          thumbnail: true,
        },
        espece: 'sieboldii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 105, 53, 1.00)',
            'rgba(107, 135, 81, 1.00)',
            'rgba(95, 125, 68, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sieboldii 'michiko renge'/magnolia sieboldii 'michiko renge' (2).jpg",
          width: 1024,
          id: '4bc9988b2fb8ac388c7a7f40d2cf19ae',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 150, 120, 1.00)',
            'rgba(100, 116, 66, 1.00)',
            'rgba(120, 123, 76, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sieboldii 'michiko renge'/magnolia sieboldii 'michiko renge' (1).jpg",
          width: 1024,
          id: '0bf8835a4266316981e2679305491038',
          height: 683,
          thumbnail: true,
        },
        location: [47.261664, -1.534851],
        genre: 'Magnolia',
        cultivar: 'Michiko Renge',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534851, 47.261664] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b9b04cae8d8dd92b4099b6d2b84b26eb5242c16e',
      fields: {
        espece: 'stellata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 109, 127, 1.00)',
            'rgba(104, 83, 67, 1.00)',
            'rgba(52, 49, 31, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'dawn'/magnolia stellata 'dawn' (2).jpg",
          width: 1024,
          id: '892e088d2c6ca0c066f9d685090c300f',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 100, 90, 1.00)',
            'rgba(79, 70, 54, 1.00)',
            'rgba(80, 81, 33, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'dawn'/magnolia stellata 'dawn' (1).jpg",
          width: 1024,
          id: 'b4004f0dc65eb9c787400e79968a8384',
          height: 683,
          thumbnail: true,
        },
        location: [47.262762, -1.531858],
        genre: 'Magnolia',
        cultivar: 'Dawn',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531858, 47.262762] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4e26e89ef2f47c8694094668ebdcf81ee0753042',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 120, 75, 1.00)',
            'rgba(106, 119, 86, 1.00)',
            'rgba(79, 103, 55, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x brooklynensis 'eva maria'/magnolia x brooklynensis 'eva maria' (3).jpg",
          width: 1024,
          id: '33b867e66bf8cc15ed6f7bdecbd461b1',
          height: 683,
          thumbnail: true,
        },
        espece: 'x brooklynensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 169, 101, 1.00)',
            'rgba(132, 143, 104, 1.00)',
            'rgba(85, 118, 60, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x brooklynensis 'eva maria'/magnolia x brooklynensis 'eva maria' (2).jpg",
          width: 1024,
          id: '73100ca6fd227172a75512d7a259608e',
          height: 716,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 165, 133, 1.00)',
            'rgba(86, 109, 63, 1.00)',
            'rgba(68, 91, 43, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x brooklynensis 'eva maria'/magnolia x brooklynensis 'eva maria' (1).jpg",
          width: 1024,
          id: 'c394bb72131dfffedf9b7cdd59a384ff',
          height: 683,
          thumbnail: true,
        },
        location: [47.262003, -1.533367],
        genre: 'Magnolia',
        cultivar: 'Eva Maria',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533367, 47.262003] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f43a5ac58ead2d47bf51f97a193ba9219d9b87be',
      fields: {
        espece: 'x loebneri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 148, 112, 1.00)',
            'rgba(130, 122, 92, 1.00)',
            'rgba(88, 85, 54, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'mag's pirouette'/magnolia x loebneri 'mag's pirouette' (2).jpg",
          width: 576,
          id: '612021c6ec8081db4b3ec882a4b6aa21',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 153, 153, 1.00)',
            'rgba(141, 137, 122, 1.00)',
            'rgba(83, 77, 47, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'mag's pirouette'/magnolia x loebneri 'mag's pirouette' (1).jpg",
          width: 576,
          id: '6a6d283315daa183221040511082acd4',
          height: 768,
          thumbnail: true,
        },
        location: [47.26137, -1.534703],
        genre: 'Magnolia',
        cultivar: "Mag's Pirouette",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534703, 47.26137] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0456c6649c79d6905af4ddd3777281723a36a123',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 101, 134, 1.00)',
            'rgba(95, 101, 125, 1.00)',
            'rgba(90, 104, 129, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'andre leroy'/magnolia x soulangeana 'andre leroy'.jpg",
          width: 1024,
          id: 'd182e6ef3d8fb3745f6f487ccdb0f233',
          height: 683,
          thumbnail: true,
        },
        espece: 'x soulangeana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 132, 188, 1.00)',
            'rgba(116, 108, 115, 1.00)',
            'rgba(78, 78, 57, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'andre leroy'/magnolia x soulangeana 'andre leroy' (3).jpg",
          width: 1024,
          id: '0cffb5b804b2ba89fd11bd4e3fb465a6',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 89, 104, 1.00)',
            'rgba(96, 97, 107, 1.00)',
            'rgba(94, 105, 126, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'andre leroy'/magnolia x soulangeana 'andre leroy' (2).jpg",
          width: 1024,
          id: '8ca97833cb1028a2a5cb8f670c52da1d',
          height: 683,
          thumbnail: true,
        },
        location: [47.261687, -1.531313],
        genre: 'Magnolia',
        cultivar: 'Andre Leroy',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531313, 47.261687] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a51ac84a5ae07496834d2ae4cc2434a93530c827',
      fields: {
        espece: 'x soulangeana',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(185, 182, 182, 1.00)',
            'rgba(130, 111, 104, 1.00)',
            'rgba(62, 66, 44, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'burgundy'/magnolia x soulangeana 'burgundy'.jpg",
          width: 1024,
          id: '10e7e93bffd77ee73a1c7fe5bcbcef89',
          height: 683,
          thumbnail: true,
        },
        location: [47.263375, -1.531613],
        genre: 'Magnolia',
        cultivar: 'Burgundy',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531613, 47.263375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f14eb9421fdebfabc40f22bc622d86cac92dedf3',
      fields: {
        espece: 'x veitchii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 129, 160, 1.00)',
            'rgba(114, 117, 126, 1.00)',
            'rgba(88, 76, 61, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia x veitchii/magnolia x veitchii  (4).jpg',
          width: 1024,
          id: '7cf427a0c61a67b78ed3a386c5f46523',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 103, 100, 1.00)',
            'rgba(101, 94, 84, 1.00)',
            'rgba(65, 66, 53, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia x veitchii/magnolia x veitchii  (3).jpg',
          width: 1024,
          id: '1b9a1da44b5c368ae44eed3e6a74596e',
          height: 683,
          thumbnail: true,
        },
        location: [47.262022, -1.53512],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53512, 47.262022] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0cffa1822457ff493ce87a07a324be57a52ce84c',
      fields: {
        espece: 'hybrids/Magnolia',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 112, 138, 1.00)',
            'rgba(97, 101, 92, 1.00)',
            'rgba(71, 87, 35, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/unnamed hybrids/magnolia 'jg 21' (gresham)/magnolia 'jg 21' (gresham) (2).jpg",
          width: 1024,
          id: '8801458e074503f9f0efd75a11b1cede',
          height: 683,
          thumbnail: true,
        },
        location: [47.261787, -1.529942],
        genre: 'Magnolia',
        cultivar: 'JG 21 (Gresham)',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529942, 47.261787] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f56bdd8c4d276738ec53d8ea303663ca5851ab50',
      fields: {
        espece: 'laevifolia',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 97, 63, 1.00)',
            'rgba(101, 108, 83, 1.00)',
            'rgba(48, 57, 43, 1.00)',
          ],
          filename:
            "ip ville de nantes/magnolia/magnolia laevifolia 'michelle'/magnolia laevifolia 'michelle'.jpg",
          width: 1024,
          id: 'de8acb1b2f357207d3ea426cd80db4c1',
          height: 683,
          thumbnail: true,
        },
        genre: 'Magnolia',
        cultivar: 'Michelle',
        famille: 'Magnoliaceae',
      },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c9945a171841ac19d2bd727d65ffc32d42f60840',
      fields: {
        espece: 'alpina',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 141, 83, 1.00)',
            'rgba(107, 140, 77, 1.00)',
            'rgba(113, 144, 72, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/nothofagus/nothofagus alpina/nothofagus alpina (2).jpg',
          width: 576,
          id: 'c084e5e05859da0edaa0b8e780e7b887',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 156, 105, 1.00)',
            'rgba(128, 126, 68, 1.00)',
            'rgba(115, 121, 69, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/nothofagus/nothofagus alpina/nothofagus alpina (1).jpg',
          width: 576,
          id: 'bdf38653d5a9d887b22147591dce4af6',
          height: 768,
          thumbnail: true,
        },
        location: [47.218462, -1.542305],
        genre: 'Nothofagus',
        famille: 'Nothofagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542305, 47.218462] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a996fd40500e8f930fd133817b3bde91cfa80f32',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'europaea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 123, 82, 1.00)',
            'rgba(133, 147, 99, 1.00)',
            'rgba(141, 151, 94, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/olea/olea europaea/olea europaea (2).jpg',
          width: 576,
          id: '7af990ed7d2237d5802411e09303fd10',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 140, 102, 1.00)',
            'rgba(135, 146, 92, 1.00)',
            'rgba(126, 132, 75, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/olea/olea europaea/olea europaea (3).jpg',
          width: 576,
          id: '37ddf409724ca57933390adfd81e1c8c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(192, 197, 187, 1.00)',
            'rgba(107, 116, 86, 1.00)',
            'rgba(94, 103, 56, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/olea/olea europaea/olea europaea (1).jpg',
          width: 1024,
          id: '181105514719ec2088475de9cdc372cf',
          height: 768,
          thumbnail: true,
        },
        location: [47.261625, -1.534783],
        genre: 'Olea',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534783, 47.261625] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a9736a70a76b2bffa902a2ff365dbd455540aff0',
      fields: {
        espece: 'yunnanensis',
        nom_du_site: 'Foyer des Anciens',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 152, 122, 1.00)',
            'rgba(106, 126, 81, 1.00)',
            'rgba(84, 105, 63, 1.00)',
          ],
          filename:
            'ip foyer des anciens/osmanthus/osmanthus yunnanensis/osmanthus yunnanensis (3).jpg',
          width: 1024,
          id: '38ef820b70e03a9ea0011f31fce86782',
          height: 683,
          thumbnail: true,
        },
        location: [47.231462, -1.582237],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582237, 47.231462] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6bd9fe994114fb6c2aa2c9e82344e427a7226b97',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'heterophyllus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 136, 127, 1.00)',
            'rgba(117, 125, 109, 1.00)',
            'rgba(82, 89, 74, 1.00)',
          ],
          filename:
            'ip parc de proce/osmanthus/osmanthus heterophyllus/osmanthus heterophyllus (2).jpg',
          width: 576,
          id: '316356b809af7a2c6eab751faa21fccc',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 154, 100, 1.00)',
            'rgba(106, 132, 81, 1.00)',
            'rgba(98, 102, 70, 1.00)',
          ],
          filename:
            'ip parc de proce/osmanthus/osmanthus heterophyllus/osmanthus heterophyllus (3).jpg',
          width: 1024,
          id: '292c115842aff451169b8157ceb1ac2d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 131, 108, 1.00)',
            'rgba(111, 140, 119, 1.00)',
            'rgba(116, 127, 111, 1.00)',
          ],
          filename:
            'ip parc de proce/osmanthus/osmanthus heterophyllus/osmanthus heterophyllus (1).jpg',
          width: 576,
          id: '5a90a6589453719c8210bc6b8f93bbd4',
          height: 768,
          thumbnail: true,
        },
        location: [47.224012, -1.583217],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583217, 47.224012] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '49efdb504b2a272601d2c7d4e8b1fa6cbecca4fc',
      fields: {
        espece: 'persica',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 160, 185, 1.00)',
            'rgba(108, 111, 108, 1.00)',
            'rgba(71, 58, 43, 1.00)',
          ],
          filename:
            'ip parc de proce/parrotia/parrotia persica/parrotia persica.jpg',
          width: 512,
          id: '99324720c8fecb9ea35c77b8b58617d7',
          height: 768,
          thumbnail: true,
        },
        location: [47.222613, -1.578288],
        genre: 'Parrotia',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.578288, 47.222613] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'acfd6921fb539c50190f4d1ac0a902dd5660a515',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'persica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 121, 132, 1.00)',
            'rgba(124, 111, 91, 1.00)',
            'rgba(90, 105, 47, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/parrotia/parrotia persica/parrotia persica  (2).jpg',
          width: 1024,
          id: '1dfa0224fac42278cdfebadabfacac24',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 98, 141, 1.00)',
            'rgba(98, 91, 96, 1.00)',
            'rgba(102, 102, 100, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/parrotia/parrotia persica/parrotia persica  (3).jpg',
          width: 512,
          id: '59b5639a1934c403c23c69fd9f4d68a2',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 103, 162, 1.00)',
            'rgba(117, 118, 133, 1.00)',
            'rgba(94, 98, 56, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/parrotia/parrotia persica/parrotia persica  (1).jpg',
          width: 512,
          id: 'c00483714f1ca2daf562d711ec2001d9',
          height: 768,
          thumbnail: true,
        },
        location: [47.230297, -1.507045],
        genre: 'Parrotia',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507045, 47.230297] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fa8364ec88525702ba3d777197126cc66beaa873',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 112, 56, 1.00)',
            'rgba(121, 88, 35, 1.00)',
            'rgba(76, 62, 25, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/parrotia hamamelidaceae/parrotia persica 'vanessa'/parrotia persica 'vanessa' (4).jpg",
          width: 1024,
          id: '8bd8b8b3070ec1f4cfc7f6987b94ac0f',
          height: 683,
          thumbnail: true,
        },
        location: [47.270042, -1.58588],
        genre: 'Parrotia',
        cultivar: 'Vanessa',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58588, 47.270042] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0ae1bbd140f067368e5cc4ae7e8e6976cd22ba7a',
      fields: {
        espece: 'viburnoides',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 127, 77, 1.00)',
            'rgba(127, 112, 64, 1.00)',
            'rgba(102, 121, 41, 1.00)',
          ],
          filename:
            'ip parc de proce/pileostegia/pileostegia viburnoides/pileostegia viburnoides.jpg',
          width: 576,
          id: '2b2a5a01f6127f97e3eb29b778325baa',
          height: 768,
          thumbnail: true,
        },
        location: [47.22527, -1.581263],
        genre: 'Pileostegia',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581263, 47.22527] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c5d2e6a4643d258caca5f942f5d188c2819e2ab9',
      fields: {
        espece: 'bungeana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 151, 161, 1.00)',
            'rgba(128, 133, 122, 1.00)',
            'rgba(110, 112, 97, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/pinus/pinus bungeana/pinus bungeana (2).jpg',
          width: 512,
          id: '4096e82559cde5d76b6b20233daecc1d',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 128, 129, 1.00)',
            'rgba(113, 115, 117, 1.00)',
            'rgba(76, 79, 74, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/pinus/pinus bungeana/pinus bungeana (1).jpg',
          width: 512,
          id: '077c7d6195dba0b696d0e732004b4c2e',
          height: 768,
          thumbnail: true,
        },
        location: [47.219828, -1.54163],
        genre: 'Pinus',
        famille: 'Pinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54163, 47.219828] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '97378b232f901a99273b19aeb6e919cba4ec2268',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'ralphii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 143, 101, 1.00)',
            'rgba(92, 105, 73, 1.00)',
            'rgba(91, 101, 69, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/pittosporum/pittosporum ralphii/pittosporum ralphii (2).jpg',
          width: 1024,
          id: 'c73bfc24d23d859fa7a042dee6aabcaf',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 120, 99, 1.00)',
            'rgba(118, 127, 106, 1.00)',
            'rgba(94, 102, 78, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/pittosporum/pittosporum ralphii/pittosporum ralphii (3).jpg',
          width: 1024,
          id: 'f34e46c677885b940b9628e3086cbd68',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 110, 83, 1.00)',
            'rgba(91, 104, 82, 1.00)',
            'rgba(89, 102, 72, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/pittosporum/pittosporum ralphii/pittosporum ralphii (1).jpg',
          width: 1024,
          id: 'fd22dc3a18f11ae1b58183e2ac72acba',
          height: 683,
          thumbnail: true,
        },
        location: [47.218492, -1.542353],
        genre: 'Pittosporum',
        famille: 'Pittosporaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542353, 47.218492] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e57f99702f3847eedccea41edc2796c386c45a9a',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'campanulata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 96, 150, 1.00)',
            'rgba(108, 94, 134, 1.00)',
            'rgba(89, 85, 105, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/prunus/prunus campanulata/prunus campanulata (2).jpg',
          width: 512,
          id: '32b7bc86d427b985fd161c1122523df5',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 102, 78, 1.00)',
            'rgba(106, 98, 71, 1.00)',
            'rgba(103, 94, 69, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/prunus/prunus campanulata/prunus campanulata (3).jpg',
          width: 1024,
          id: '3181ed610a5c89e3a347ca25e8e873d8',
          height: 672,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(75, 86, 140, 1.00)',
            'rgba(80, 91, 151, 1.00)',
            'rgba(77, 85, 140, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/prunus/prunus campanulata/prunus campanulata (1).jpg',
          width: 512,
          id: '4301e6f00faf0effa6a1d409bb802004',
          height: 768,
          thumbnail: true,
        },
        location: [47.220247, -1.54168],
        genre: 'Prunus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54168, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'adea648f51bcacc3472da174edcb4f4ba7d9c78d',
      fields: {
        espece: 'maackii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 109, 65, 1.00)',
            'rgba(148, 131, 105, 1.00)',
            'rgba(184, 156, 127, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/prunus/prunus maackii 'amber beauty'/prunus maackii 'amber beauty' (2).jpg",
          width: 576,
          id: '57de571d6140ff00b22b1f2bff2493bd',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 157, 118, 1.00)',
            'rgba(65, 88, 48, 1.00)',
            'rgba(140, 143, 114, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/prunus/prunus maackii 'amber beauty'/prunus maackii 'amber beauty' (1).jpg",
          width: 576,
          id: '83f5f6abe7af1186beba12beb598e7ad',
          height: 768,
          thumbnail: true,
        },
        location: [47.218692, -1.5413],
        genre: 'Prunus',
        cultivar: 'Amber Beauty',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5413, 47.218692] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b38b1a92072ade1f9ac83fd0c25847d2b1c0a6d2',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'mume',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 115, 62, 1.00)',
            'rgba(107, 137, 57, 1.00)',
            'rgba(97, 131, 50, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/prunus/prunus mume/prunus mume (14).jpg',
          width: 1024,
          id: 'a2ddd490e5f5c2803244fc9d6e32959f',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 118, 52, 1.00)',
            'rgba(115, 146, 58, 1.00)',
            'rgba(90, 121, 52, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/prunus/prunus mume/prunus mume (15).jpg',
          width: 1024,
          id: '1a4cc92d88cc4d0feaca84a61755484d',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 109, 57, 1.00)',
            'rgba(149, 132, 93, 1.00)',
            'rgba(139, 132, 86, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/prunus/prunus mume/prunus mume (1).jpg',
          width: 576,
          id: '3f4c9e4b0f7845df0b91b5bc4ba9e953',
          height: 768,
          thumbnail: true,
        },
        location: [47.23037, -1.507762],
        genre: 'Prunus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507762, 47.23037] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '082ee5aa0769e6e62e6cffc90464c0e6418264ec',
      fields: {
        espece: 'frainetto',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 165, 186, 1.00)',
            'rgba(136, 104, 69, 1.00)',
            'rgba(129, 119, 69, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus frainetto/quercus frainetto.jpg',
          width: 576,
          id: '385152d5781976f48928f3d5729fc0b0',
          height: 768,
          thumbnail: true,
        },
        location: [47.261767, -1.533903],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533903, 47.261767] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b6a3c0c8787a4040428ab3f6d5770870f631104a',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'palustris',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(176, 196, 168, 1.00)',
            'rgba(103, 123, 81, 1.00)',
            'rgba(73, 89, 43, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus palustris/quercus palustris (2).jpg',
          width: 1024,
          id: '30b7d33e3ea1463fa19463c94ae32b78',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 161, 123, 1.00)',
            'rgba(103, 110, 60, 1.00)',
            'rgba(88, 93, 47, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus palustris/quercus palustris (3).jpg',
          width: 576,
          id: '7bf7885896f015822c0e2f7618112c06',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 136, 96, 1.00)',
            'rgba(135, 130, 90, 1.00)',
            'rgba(120, 114, 76, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus palustris/quercus palustris (1).jpg',
          width: 576,
          id: 'c04507de1e788935a0f61d3d525647e6',
          height: 768,
          thumbnail: true,
        },
        location: [47.262447, -1.535997],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535997, 47.262447] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cbf330241866167a353d5d2c9a58ce0caabb74e5',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'x kewensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 119, 87, 1.00)',
            'rgba(113, 119, 92, 1.00)',
            'rgba(103, 111, 58, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus x kewensis/quercus x kewensis (2).jpg',
          width: 576,
          id: '6b5fccd5354f1a908b7289e940f02256',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 167, 179, 1.00)',
            'rgba(119, 125, 119, 1.00)',
            'rgba(82, 83, 67, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus x kewensis/quercus x kewensis (3).jpg',
          width: 1024,
          id: '78585b3f081b0297fd7f5fb99b4e539d',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 134, 104, 1.00)',
            'rgba(144, 134, 105, 1.00)',
            'rgba(144, 134, 106, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus x kewensis/quercus x kewensis (1).jpg',
          width: 576,
          id: 'cdc3252a7800d4562044feadf95908aa',
          height: 768,
          thumbnail: true,
        },
        location: [47.262917, -1.534903],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534903, 47.262917] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8b116e00a251de92db75efb95e49509393044a81',
      fields: {
        espece: 'davidsonianum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 98, 60, 1.00)',
            'rgba(105, 118, 82, 1.00)',
            'rgba(99, 113, 72, 1.00)',
          ],
          filename:
            'ip parc de proce/rhododendron/rhododendron davidsonianum/rhododendron davidsonianum (2).jpg',
          width: 1024,
          id: '53588ae66186c084cf6b857af5c467ee',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 96, 92, 1.00)',
            'rgba(134, 131, 136, 1.00)',
            'rgba(104, 101, 104, 1.00)',
          ],
          filename:
            'ip parc de proce/rhododendron/rhododendron davidsonianum/rhododendron davidsonianum (1).jpg',
          width: 576,
          id: '05a99b031e49c38c32eaf2e638d6a69c',
          height: 768,
          thumbnail: true,
        },
        location: [47.22587, -1.582225],
        genre: 'Rhododendron',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582225, 47.22587] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a56de7da6f8e536c24ee06f600c5df7f3ac87462',
      fields: {
        espece: 'integra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 130, 98, 1.00)',
            'rgba(118, 133, 110, 1.00)',
            'rgba(76, 78, 64, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/salix/salix integra 'hakuro-nishiki'/salix integra 'hakuro-nishiki' (2).jpg",
          width: 576,
          id: 'c8b6c9f8c2ff83cfbc9eb8e7353a61d8',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 99, 61, 1.00)',
            'rgba(70, 83, 54, 1.00)',
            'rgba(103, 125, 71, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/salix/salix integra 'hakuro-nishiki'/salix integra 'hakuro-nishiki' (1).jpg",
          width: 1024,
          id: 'a3f91a99c7f72187d1060fd7a97fe1a3',
          height: 768,
          thumbnail: true,
        },
        location: [47.263375, -1.531613],
        genre: 'Salix',
        cultivar: 'Hakuro-Nishiki',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531613, 47.263375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd22a943ed682c7a400513705bad98ec64cc1ae62',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'xylocarpa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 142, 40, 1.00)',
            'rgba(112, 139, 58, 1.00)',
            'rgba(68, 104, 24, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/sinojackia/sinojackia xylocarpa/sinojackia xylocarpa (2).jpg',
          width: 576,
          id: '20eb7ea82d218bb12ffdbd0dfbf8f318',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(191, 203, 164, 1.00)',
            'rgba(119, 146, 75, 1.00)',
            'rgba(69, 95, 37, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/sinojackia/sinojackia xylocarpa/sinojackia xylocarpa (3).jpg',
          width: 1024,
          id: '94489b91e1a7cf208ab7fc8a2e3ca4c3',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 166, 80, 1.00)',
            'rgba(110, 156, 66, 1.00)',
            'rgba(79, 122, 30, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/sinojackia/sinojackia xylocarpa/sinojackia xylocarpa (1).jpg',
          width: 576,
          id: '5cc436272e1b69527688922de78971a9',
          height: 768,
          thumbnail: true,
        },
        location: [47.228163, -1.508158],
        genre: 'Sinojackia',
        famille: 'Styracaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508158, 47.228163] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1dd8ee53d40462fa24ec77d0d68d4129429dedd7',
      fields: {
        espece: 'sorbifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 146, 56, 1.00)',
            'rgba(103, 133, 48, 1.00)',
            'rgba(100, 126, 44, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/sorbaria/sorbaria sorbifolia/sorbaria sorbifolia (2).jpg',
          width: 576,
          id: '34d2678f20492530e8982e9a48ddb5dc',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 107, 48, 1.00)',
            'rgba(119, 133, 86, 1.00)',
            'rgba(68, 86, 32, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/sorbaria/sorbaria sorbifolia/sorbaria sorbifolia (1).jpg',
          width: 576,
          id: '538b3699378e5c3570e2e55a2db85336',
          height: 768,
          thumbnail: true,
        },
        location: [47.220625, -1.542737],
        genre: 'Sorbaria',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542737, 47.220625] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a53e05a6554f8f977b4f49381c274cac38dd1d3b',
      fields: {
        nom_du_site: 'Autre site',
        espece: 'aucuparia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 99, 78, 1.00)',
            'rgba(128, 135, 115, 1.00)',
            'rgba(108, 113, 91, 1.00)',
          ],
          filename:
            'ip ville de nantes/sorbus/sorbus aucuparia/sorbus aucuparia  (2).jpg',
          width: 576,
          id: '054a639c6b6212b9493685782cc4ea26',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 203, 209, 1.00)',
            'rgba(76, 85, 71, 1.00)',
            'rgba(80, 89, 53, 1.00)',
          ],
          filename:
            'ip ville de nantes/sorbus/sorbus aucuparia/sorbus aucuparia  (3).jpg',
          width: 827,
          id: 'b4543249b1fcc1ac5375beb64ac3e850',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 103, 55, 1.00)',
            'rgba(145, 98, 56, 1.00)',
            'rgba(103, 130, 66, 1.00)',
          ],
          filename:
            'ip ville de nantes/sorbus/sorbus aucuparia/sorbus aucuparia  (1).jpg',
          width: 576,
          id: 'c6f348acab868eb58d858b146578aaeb',
          height: 768,
          thumbnail: true,
        },
        location: [47.246362, -1.548895],
        genre: 'Sorbus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.548895, 47.246362] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '093e930c560271c596b45c4f515746332544129e',
      fields: {
        espece: 'betulifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 159, 63, 1.00)',
            'rgba(106, 139, 48, 1.00)',
            'rgba(101, 108, 51, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/spiraea/spiraea betulifolia/spiraea betulifolia (2).jpg',
          width: 576,
          id: 'ccc88406014e74394462487ed58f5e33',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 106, 52, 1.00)',
            'rgba(131, 134, 99, 1.00)',
            'rgba(46, 66, 16, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/spiraea/spiraea betulifolia/spiraea betulifolia (1).jpg',
          width: 576,
          id: '4b1f60f5b3a1932487aca6eb3f5071d1',
          height: 768,
          thumbnail: true,
        },
        location: [47.220705, -1.54292],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54292, 47.220705] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '14b4898454f2f798219f5393a108d68485ffb8fa',
      fields: {
        espece: 'japonicus',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 127, 79, 1.00)',
            'rgba(80, 100, 59, 1.00)',
            'rgba(96, 119, 76, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/styrax/styrax japonicus/styrax japonicus.jpg',
          width: 1024,
          id: '9c5173b3ab252023f9c1644b6aa4ac40',
          height: 683,
          thumbnail: true,
        },
        location: [47.262478, -1.529105],
        genre: 'Styrax',
        famille: 'Styracaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529105, 47.262478] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4856f54573ad182fd545e64a5ffc5d6d70646536',
      fields: {
        espece: 'distichum',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 188, 213, 1.00)',
            'rgba(150, 133, 137, 1.00)',
            'rgba(57, 56, 45, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/taxodium/taxodium distichum/taxodium distichum.jpg',
          width: 512,
          id: 'a188652e53a1d8559efd385f569695a4',
          height: 768,
          thumbnail: true,
        },
        location: [47.269095, -1.58374],
        genre: 'Taxodium',
        famille: 'Cupressaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58374, 47.269095] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7769999de0186b34a1835229763bedae4b093d0d',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 157, 152, 1.00)',
            'rgba(130, 135, 109, 1.00)',
            'rgba(108, 129, 98, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ternstroemia pentaphylacaceae/ternstroemia gymnanthera/ternstroemia gymnanthera (2).jpg',
          width: 576,
          id: '5700836639313f3c2e94e1208adab975',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 140, 126, 1.00)',
            'rgba(115, 148, 123, 1.00)',
            'rgba(93, 109, 78, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ternstroemia pentaphylacaceae/ternstroemia gymnanthera/ternstroemia gymnanthera  (2).jpg',
          width: 576,
          id: '1000941986b3f247d26fd425d00dc0ec',
          height: 768,
          thumbnail: true,
        },
        location: [47.270781, -1.585106],
        genre: 'Ternstroemia',
        famille: 'Pentaphylacaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585106, 47.270781] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '735b05545ce84d6b235a96aabfb90b72c09c568c',
      fields: {
        espece: 'mongolica',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(201, 206, 196, 1.00)',
            'rgba(69, 82, 62, 1.00)',
            'rgba(111, 111, 85, 1.00)',
          ],
          filename:
            'ip ville de nantes/tilia/tilia mongolica/tilia mongolica (3).jpg',
          width: 512,
          id: 'a39b110062d1bd6ff115131556798284',
          height: 768,
          thumbnail: true,
        },
        location: [47.193695, -1.533025],
        genre: 'Tilia',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533025, 47.193695] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '66cc91cdc3aac4cdf22cb4e56f733a57d6ca45d3',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 139, 67, 1.00)',
            'rgba(143, 149, 57, 1.00)',
            'rgba(152, 161, 83, 1.00)',
          ],
          filename:
            "ip parc de proce/toona/toona sinensis 'flamingo'/toona sinensis 'flamingo' (3).jpg",
          width: 576,
          id: 'be796ca56e4d639e5c2577f357845ec4',
          height: 768,
          thumbnail: true,
        },
        espece: 'sinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 152, 169, 1.00)',
            'rgba(155, 135, 150, 1.00)',
            'rgba(164, 152, 163, 1.00)',
          ],
          filename:
            "ip parc de proce/toona/toona sinensis 'flamingo'/toona sinensis 'flamingo' (2).jpg",
          width: 713,
          id: 'aa477cf656a9028a5c6275ff3e6a8d50',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(212, 218, 220, 1.00)',
            'rgba(85, 91, 62, 1.00)',
            'rgba(84, 96, 42, 1.00)',
          ],
          filename:
            "ip parc de proce/toona/toona sinensis 'flamingo'/toona sinensis 'flamingo' (1).jpg",
          width: 613,
          id: '926d2b4915920907c2461c969544e1e8',
          height: 768,
          thumbnail: true,
        },
        location: [47.224333, -1.583253],
        genre: 'Toona',
        cultivar: 'Flamingo',
        famille: 'Meliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583253, 47.224333] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8fc40a4facc4e869e3d9e0f09ab77d1754ed4ba7',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'sebifera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 75, 50, 1.00)',
            'rgba(136, 86, 56, 1.00)',
            'rgba(142, 81, 46, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/triadica/triadica sebifera/triadica sebifera (14).jpg',
          width: 639,
          id: '5ddbe4fdd9c9fda14b84052ee78733bf',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 158, 197, 1.00)',
            'rgba(139, 131, 124, 1.00)',
            'rgba(78, 76, 39, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/triadica/triadica sebifera/triadica sebifera (15).jpg',
          width: 1024,
          id: '7d10780c177a204c10a0bfd35750a302',
          height: 741,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 154, 192, 1.00)',
            'rgba(147, 119, 112, 1.00)',
            'rgba(82, 78, 42, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/triadica/triadica sebifera/triadica sebifera (13).jpg',
          width: 619,
          id: '4b46cde46aefe849bc6dd859d73d30b2',
          height: 768,
          thumbnail: true,
        },
        location: [47.21987, -1.542812],
        genre: 'Triadica',
        famille: 'Euphorbiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542812, 47.21987] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a9d0582430252a8248b7dcfdc902d3fd9e37fbcc',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 117, 69, 1.00)',
            'rgba(128, 140, 76, 1.00)',
            'rgba(93, 112, 50, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/ulmus/ulmus parvifolia 'geisha'/ulmus parvifolia 'geisha' (4).jpg",
          width: 1024,
          id: '32c9d35e5ef4b3b80f4ef934c3066900',
          height: 768,
          thumbnail: true,
        },
        espece: 'parvifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 154, 86, 1.00)',
            'rgba(108, 136, 71, 1.00)',
            'rgba(91, 119, 54, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/ulmus/ulmus parvifolia 'geisha'/ulmus parvifolia 'geisha' (2).jpg",
          width: 1024,
          id: 'ee54e5d0ce9a8bd4b388001d30846e52',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 142, 62, 1.00)',
            'rgba(140, 148, 69, 1.00)',
            'rgba(125, 133, 61, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/ulmus/ulmus parvifolia 'geisha'/ulmus parvifolia 'geisha' (1).jpg",
          width: 576,
          id: 'd71717ce9766b75ac56a6d5ca3fb847b',
          height: 768,
          thumbnail: true,
        },
        location: [47.261912, -1.532075],
        genre: 'Ulmus',
        cultivar: 'Geisha',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532075, 47.261912] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6fa5293a8f66e4bd481351d2f58df030e877f786',
      fields: {
        espece: 'parvifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 123, 101, 1.00)',
            'rgba(101, 117, 98, 1.00)',
            'rgba(89, 106, 85, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/ulmus/ulmus parvifolia 'geisha'/ulmus parvifolia 'geisha' (8).jpg",
          width: 1024,
          id: 'fcece52a521dbddf522fec96b561743b',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 79, 65, 1.00)',
            'rgba(97, 111, 91, 1.00)',
            'rgba(79, 95, 73, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/ulmus/ulmus parvifolia 'geisha'/ulmus parvifolia 'geisha' (6).jpg",
          width: 1024,
          id: '1f9664732a77e834a0fae5884fef0625',
          height: 683,
          thumbnail: true,
        },
        location: [47.261888, -1.532087],
        genre: 'Ulmus',
        cultivar: 'Geisha',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532087, 47.261888] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6286157447f84657959f2192a0b7747b20337862',
      fields: {
        espece: 'carlesii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 108, 92, 1.00)',
            'rgba(134, 124, 110, 1.00)',
            'rgba(100, 93, 80, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/viburnum/viburnum carlesii 'diana'/viburnum carlesii 'diana' (2).jpg",
          width: 1024,
          id: '0a7ee2beb27cc264e581ec08ba9dea49',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 117, 95, 1.00)',
            'rgba(114, 104, 80, 1.00)',
            'rgba(99, 86, 71, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/viburnum/viburnum carlesii 'diana'/viburnum carlesii 'diana' (1).jpg",
          width: 1024,
          id: '8f42985e7d89d3af383982f2391d6fb2',
          height: 683,
          thumbnail: true,
        },
        location: [47.228178, -1.508363],
        genre: 'Viburnum',
        cultivar: 'Diana',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508363, 47.228178] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3b325ec77b48d57b5b0aa764db81e0ba2319282b',
      fields: {
        nom_du_site: 'Autre site',
        espece: 'carpinifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 157, 91, 1.00)',
            'rgba(89, 111, 49, 1.00)',
            'rgba(101, 113, 80, 1.00)',
          ],
          filename:
            'ip ville de nantes/zelkova/zelkova carpinifolia/zelkova carpinifolia (2).jpg',
          width: 576,
          id: 'e9202a2150c776d3c0028ac32addb95c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 67, 31, 1.00)',
            'rgba(120, 118, 82, 1.00)',
            'rgba(135, 145, 96, 1.00)',
          ],
          filename:
            'ip ville de nantes/zelkova/zelkova carpinifolia/zelkova carpinifolia (3).jpg',
          width: 576,
          id: '3e02473a09d41fbac9d473b9168c3f42',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 119, 43, 1.00)',
            'rgba(107, 123, 84, 1.00)',
            'rgba(118, 124, 91, 1.00)',
          ],
          filename:
            'ip ville de nantes/zelkova/zelkova carpinifolia/zelkova carpinifolia (1).jpg',
          width: 576,
          id: '229b42ac48451467e946e5b98f74d775',
          height: 768,
          thumbnail: true,
        },
        location: [47.230055, -1.590287],
        genre: 'Zelkova',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.590287, 47.230055] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '27350fd4b041506d202396ae7636cee48e6a8e29',
      fields: {
        origine: 'JB. Zagreb (Croatie)',
        espece: 'selskianum Regel & Maack',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Sedum',
        date_plantation: '2011',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f5418dd20a6f7cee51aa83f967179e69a2db6153',
      fields: {
        origine: 'JB.Chambesy (Gen\u00e8ve)',
        espece: 'anacampseros L.',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Sedum',
        date_plantation: '1998',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'af94fb6590c19402dce25bb6f52ea09258e3f863',
      fields: {
        origine: 'JBU.Li\u00e8ge (Belgique)',
        espece: 'serpentini Janchen',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Sedum',
        date_plantation: '1989',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '37083b44b158a94254fc3f7a68b2320c5c698fa5',
      fields: {
        origine: 'JBU.Ljubljana (Slov\u00e9nie)',
        espece: 'aizoon L.',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Sedum',
        date_plantation: '1999',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e207c6be65786e90eb85236d0365723d6beaf6f9',
      fields: {
        origine: "Museum Nat. d'histoire service de cultures",
        espece: 'anacampseros L.',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Sedum',
        date_plantation: '2004',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd66e647e43abab04849164bd474dfd91f7bfee01',
      fields: {
        origine:
          'r\u00e9colte de Philippe F\u00e9rard,Pyr\u00e9n\u00e9es,26/07/09',
        espece: 'sediforme Pau',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Sedum',
        date_plantation: '2014',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '08d7ab9d13b0a99e41bd669b819b6eafabf5eba6',
      fields: {
        origine: 'Utrecht Botanic garden',
        espece: 'obtusifolium C.A. Mey.',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Sedum',
        date_plantation: '2010',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3f7590b2baceaa25cb4eafe307e94a437e67f28b',
      fields: {
        origine: 'Zoological and botanical Garden, Plzen, Czech Republic',
        espece: 'reflexum L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Sedum',
        date_plantation: '2012',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8f7c548524716bd46206714f76a53e4d1ce9d0e5',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 103, 78, 1.00)',
            'rgba(103, 129, 106, 1.00)',
            'rgba(119, 118, 114, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/eucryphia [cunoniaceae]/eucryphia x nymansensis 'nymansay'/eucryphia x nymansensis 'nymansay'.jpg",
          width: 576,
          id: 'ab9452d884cbfb56db879fdc0ae02e1d',
          height: 768,
          thumbnail: true,
        },
        espece: 'x nymansensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 83, 72, 1.00)',
            'rgba(112, 114, 105, 1.00)',
            'rgba(87, 90, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/eucryphia [cunoniaceae]/eucryphia x nymansensis 'nymansay'/eucryphia x nymansensis 'nymansay' (2).jpg",
          width: 1024,
          id: '62cb427c027974c4b599bb0a3f713286',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 86, 64, 1.00)',
            'rgba(98, 106, 91, 1.00)',
            'rgba(68, 74, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/eucryphia [cunoniaceae]/eucryphia x nymansensis 'nymansay'/eucryphia x nymansensis 'nymansay' (1).jpg",
          width: 1024,
          id: '82b4630e3576c043c265ec1e7a672e03',
          height: 683,
          thumbnail: true,
        },
        location: [47.270325, -1.58485],
        genre: 'Eucryphia',
        cultivar: 'Nymansay',
        famille: 'Cunoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58485, 47.270325] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'df74152ccc584788216cd78394338d922e3675dd',
      fields: {
        espece: 'glyptostroboides',
        localisation: 'B5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202019, -1.5440256],
        genre: 'Metasequoia',
        date_plantation: '1973',
        cultivar: 'Emerald Feathers',
        famille: 'Cupressaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440256, 47.2202019] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9bad9f369ec2047fe09e41fc188d95ef35e6512e',
      fields: {
        origine: 'J. W. Goethe-Universit\u00e4t Botanischer Garten Frankfurt',
        espece: 'muskingumensis Schwein.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Carex',
        date_plantation: '2006',
        famille: 'Cyperaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1d2eb3a6e3f05a0fd837de7338dc693d63dd48e0',
      fields: {
        origine: 'JB.Weinheim (Allemagne)',
        espece: 'crinita Lam.',
        localisation: 'C6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195286, -1.542453],
        genre: 'Carex',
        date_plantation: '2008',
        famille: 'Cyperaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542453, 47.2195286] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7a894fd43c11ecfbe643c474899f2b50f742b2ac',
      fields: {
        espece: 'fortunei Sm.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Cyrtomium',
        date_plantation: '1973',
        famille: 'Dryopteridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '56be9c8a071bc3cb1b093fc5141e9a89c405159a',
      fields: {
        espece: 'filix-mas Schott.',
        localisation: 'A9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2212566, -1.5434775],
        genre: 'Dryopteris',
        date_plantation: '1973',
        famille: 'Dryopteridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5434775, 47.2212566] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f3081e31c15ce6ab3ebfffeb215e90fc8271c1d1',
      fields: {
        espece: 'lotus (femelle)',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 160, 113, 1.00)',
            'rgba(129, 136, 93, 1.00)',
            'rgba(114, 130, 84, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/diospyros [ebenaceae]/diospyros lotus (femelle)/diospyros lotus (9).jpg',
          width: 576,
          id: '96a10f89db8e13266614932ee311a4fd',
          height: 768,
          thumbnail: true,
        },
        location: [47.269413, -1.584097],
        genre: 'Diospyros',
        famille: 'Ebenaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584097, 47.269413] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1e891e1b177b12b35e221b1d5e445c28dbdd849a',
      fields: {
        espece: 'unedo',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 137, 32, 1.00)',
            'rgba(99, 145, 37, 1.00)',
            'rgba(84, 125, 21, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus unedo 'quercifolia'/arbutus unedo 'quercifolia'.jpg",
          width: 576,
          id: 'c41deb492a1edd6c55dd577270f94ff8',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 101, 26, 1.00)',
            'rgba(110, 113, 52, 1.00)',
            'rgba(89, 108, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus unedo 'quercifolia'/arbutus unedo 'quercifolia' (2).jpg",
          width: 576,
          id: '3be502b8ea7d53f1c9d171208b57b93a',
          height: 768,
          thumbnail: true,
        },
        location: [47.271855, -1.582342],
        genre: 'Arbutus',
        cultivar: 'Quercifolia',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582342, 47.271855] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dcb245ae4c0eaf825fbbc3c0434e15715b43b8a3',
      fields: {
        espece: 'x thuretiana',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 80, 85, 1.00)',
            'rgba(102, 91, 73, 1.00)',
            'rgba(103, 94, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus x thuretiana/arbutus x thuretiana.jpg',
          width: 512,
          id: 'eff765626d91c25f79c1ce6ba03f0004',
          height: 768,
          thumbnail: true,
        },
        location: [47.269152, -1.584105],
        genre: 'Arbutus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584105, 47.269152] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '814221daf785670cabc2a159106197e7874f1ce3',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 131, 121, 1.00)',
            'rgba(121, 116, 103, 1.00)',
            'rgba(100, 100, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/gaultheria [ericaceae]/gaultheria mucronata 'crimsonia'/gaultheria mucronata 'crimsonia' (3).jpg",
          width: 576,
          id: '530ab810d0f894f5504f76cc8eeff640',
          height: 768,
          thumbnail: true,
        },
        espece: 'mucronata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(176, 171, 132, 1.00)',
            'rgba(145, 115, 87, 1.00)',
            'rgba(96, 78, 67, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/gaultheria [ericaceae]/gaultheria mucronata 'crimsonia'/gaultheria mucronata 'crimsonia' (2).jpg",
          width: 576,
          id: '19bedafc2451653b25291064c34394f2',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 152, 148, 1.00)',
            'rgba(123, 127, 114, 1.00)',
            'rgba(86, 95, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/gaultheria [ericaceae]/gaultheria mucronata 'crimsonia'/gaultheria mucronata 'crimsonia' (1).jpg",
          width: 576,
          id: '954bf5eed1f2f462ebc5e8a8b66e4dc5',
          height: 768,
          thumbnail: true,
        },
        location: [47.271137, -1.582638],
        genre: 'Gaultheria',
        cultivar: 'Crimsonia',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582638, 47.271137] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '88b629d5ea8abd6a184c9852a7bb39376611baaa',
      fields: {
        espece: 'x obtusum',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Rhododendron',
        date_plantation: '1973',
        cultivar: 'Rex',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '08d79286930de386838b949e7ffc1b7c824b4a70',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'resinosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 125, 94, 1.00)',
            'rgba(112, 120, 80, 1.00)',
            'rgba(80, 91, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/escallonia [escalloniaceae]/escallonia resinosa/escallonia resinosa (1).jpg',
          width: 576,
          id: '14beb7c25f245d7d197b5c33d665e787',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 154, 124, 1.00)',
            'rgba(125, 129, 89, 1.00)',
            'rgba(79, 86, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/escallonia [escalloniaceae]/escallonia resinosa/escallonia resinosa (2).jpg',
          width: 576,
          id: '3ea1ac269684764a89c483bc8f3e4ece',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 133, 92, 1.00)',
            'rgba(123, 126, 75, 1.00)',
            'rgba(126, 118, 79, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/escallonia [escalloniaceae]/escallonia resinosa/escallonia resinosa  (2).jpg',
          width: 1024,
          id: '64a7f66c7784d5a6708f80bd3a4e8ee8',
          height: 768,
          thumbnail: true,
        },
        location: [47.271942, -1.582492],
        genre: 'Escallonia',
        famille: 'Escalloniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582492, 47.271942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1dac1c36d7de1aa278e50e5057e0e69eb95cff1f',
      fields: {
        origine: 'J.Alp.Meyrin (Suisse)',
        espece: 'characias L.',
        localisation: 'D2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195252, -1.5420507],
        genre: 'Euphorbia',
        date_plantation: '1989',
        famille: 'Euphorbiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420507, 47.2195252] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6212ce7ac4576425b8ab54bc3789f73f1d55b220',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'javanica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 174, 108, 1.00)',
            'rgba(139, 149, 83, 1.00)',
            'rgba(63, 75, 52, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/bischofia [euphorbiaceae]/bischofia javanica/bischofia javanica  (2).jpg',
          width: 512,
          id: '23fa9ee81e228085f65ed1ca6d280ac8',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 89, 68, 1.00)',
            'rgba(83, 73, 51, 1.00)',
            'rgba(140, 120, 85, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/bischofia [euphorbiaceae]/bischofia javanica/bischofia javanica (1).jpg',
          width: 576,
          id: '42660c0a3ebc90341dd8324eec2df62a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 167, 100, 1.00)',
            'rgba(83, 105, 52, 1.00)',
            'rgba(74, 97, 55, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/bischofia [euphorbiaceae]/bischofia javanica/bischofia javanica  (1).jpg',
          width: 512,
          id: '56c9fe18ad450cc31d9fe6aac28b888f',
          height: 768,
          thumbnail: true,
        },
        location: [47.228328, -1.508292],
        genre: 'Bischofia',
        famille: 'Euphorbiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508292, 47.228328] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7a1c6984252c20df638e88403d39b206904c170c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'polyandra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 160, 95, 1.00)',
            'rgba(151, 136, 93, 1.00)',
            'rgba(111, 125, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euptelea [eupteleaceae]/euptelea polyandra/euptelea polyandra  (3).jpg',
          width: 576,
          id: '2e6a024aa6cf3831445baa80fcb3dc60',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 137, 125, 1.00)',
            'rgba(133, 126, 109, 1.00)',
            'rgba(135, 123, 100, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euptelea [eupteleaceae]/euptelea polyandra/euptelea polyandra  (5).jpg',
          width: 1024,
          id: 'd30cd99d0c754078bce91119bb6c3a04',
          height: 760,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 142, 102, 1.00)',
            'rgba(168, 121, 105, 1.00)',
            'rgba(123, 106, 97, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euptelea [eupteleaceae]/euptelea polyandra/euptelea polyandra  (1).jpg',
          width: 576,
          id: '86c3ffaa664eeb3ad41f015c447ca578',
          height: 768,
          thumbnail: true,
        },
        location: [47.271342, -1.581567],
        genre: 'Euptelea',
        famille: 'Eupteleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581567, 47.271342] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dce4c04bb7c9f4c5bb506f232be42d09aed8db8e',
      fields: {
        origine: 'JB.Przemyl (Pologne)',
        espece: 'aureum  Pollich',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Trifolium',
        date_plantation: '2008',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bd01b519eeb22311589a4bec7af792063bbf2bfc',
      fields: {
        origine: 'Remi Legros (gare de Vertou)',
        espece: 'tinctoria',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Genista',
        date_plantation: '2015',
        cultivar: 'Humifusa',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '272c2de3dd4e3ff8cc13262926f568ac3030d789',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'engleriana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 81, 48, 1.00)',
            'rgba(138, 81, 45, 1.00)',
            'rgba(141, 83, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus engleriana/fagus engleriana (30).jpg',
          width: 1024,
          id: '6337aeb9f62a50be3daf38ef3836a0b9',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(178, 117, 75, 1.00)',
            'rgba(151, 83, 27, 1.00)',
            'rgba(133, 66, 30, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus engleriana/fagus engleriana (33).jpg',
          width: 1024,
          id: 'c4e7fe3a23ee9ca5f0a3d1b24c8154b9',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 145, 144, 1.00)',
            'rgba(118, 98, 73, 1.00)',
            'rgba(63, 56, 28, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus engleriana/fagus engleriana (28).jpg',
          width: 1024,
          id: '57be0723bf3825269c74f851ff2e3c45',
          height: 683,
          thumbnail: true,
        },
        location: [47.27065, -1.581714],
        genre: 'Fagus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581714, 47.27065] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '68e3539080adb01ef3b15ef63d5d9fbc9be80783',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 124, 111, 1.00)',
            'rgba(127, 128, 115, 1.00)',
            'rgba(119, 118, 108, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/quercus [fagaceae]/quercus coccinea 'splendens'/quercus coccinea 'splendens' (4).jpg",
          width: 576,
          id: 'cd09542d40019627c8ae4bac5cfd1afa',
          height: 768,
          thumbnail: true,
        },
        espece: 'coccinea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 147, 196, 1.00)',
            'rgba(106, 67, 58, 1.00)',
            'rgba(59, 51, 31, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/quercus [fagaceae]/quercus coccinea 'splendens'/quercus coccinea 'splendens' (3).jpg",
          width: 512,
          id: '06689ab11c805bb08657ad6101c16f50',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 120, 197, 1.00)',
            'rgba(113, 77, 111, 1.00)',
            'rgba(104, 30, 28, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/quercus [fagaceae]/quercus coccinea 'splendens'/quercus coccinea 'splendens' (1).jpg",
          width: 512,
          id: '9df32d42163d69a39b84e673b762a829',
          height: 768,
          thumbnail: true,
        },
        location: [47.27137, -1.585512],
        genre: 'Quercus',
        cultivar: 'Splendens',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585512, 47.27137] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ac0de3cda4fe3cbad22c7cecb09d8842b7afb49d',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'frainetto',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(168, 182, 152, 1.00)',
            'rgba(111, 128, 91, 1.00)',
            'rgba(83, 92, 64, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus frainetto/quercus frainetto (2).jpg',
          width: 1024,
          id: 'ba8e09634014c4df53c36abc8309b500',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 78, 59, 1.00)',
            'rgba(112, 89, 53, 1.00)',
            'rgba(33, 31, 17, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus frainetto/quercus frainetto (5).jpg',
          width: 512,
          id: '7a92bf27ee38ee309318e10f708a54c1',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 127, 120, 1.00)',
            'rgba(129, 126, 122, 1.00)',
            'rgba(133, 133, 136, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus frainetto/quercus frainetto (1).jpg',
          width: 576,
          id: '363285d55a63e86d7d1f636b834f02a4',
          height: 768,
          thumbnail: true,
        },
        location: [47.269688, -1.585195],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585195, 47.269688] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bb09176eae00281dc9361021478133e5b902babd',
      fields: {
        espece: 'frainetto',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 151, 145, 1.00)',
            'rgba(183, 117, 34, 1.00)',
            'rgba(148, 74, 6, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus frainetto/quercus frainetto (4).jpg',
          width: 576,
          id: 'f7e0a50c17349b0d651017c7a517f879',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(195, 179, 171, 1.00)',
            'rgba(138, 93, 44, 1.00)',
            'rgba(55, 47, 25, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus frainetto/quercus frainetto (3).jpg',
          width: 576,
          id: '5f23cfeacedf37eb4b44c79711dfe0ab',
          height: 768,
          thumbnail: true,
        },
        location: [47.26968, -1.5852],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5852, 47.26968] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '223557ddb3ebff13c7b621d5c21384f4222916b4',
      fields: {
        espece: 'imbricaria',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(173, 206, 186, 1.00)',
            'rgba(116, 138, 56, 1.00)',
            'rgba(52, 67, 33, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus imbricaria/quercus imbricaria.jpg',
          width: 576,
          id: '48f050e83b0ca0734098036e02062016',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 143, 59, 1.00)',
            'rgba(120, 146, 67, 1.00)',
            'rgba(106, 131, 48, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus imbricaria/quercus imbricaria (2).jpg',
          width: 576,
          id: '8a9ea1a03d4dd999a10aae13eabbf030',
          height: 768,
          thumbnail: true,
        },
        location: [47.270813, -1.584572],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584572, 47.270813] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ab98b530676df33f506c33fb5b33358ed20cb724',
      fields: {
        espece: 'laurifolia',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(189, 203, 167, 1.00)',
            'rgba(89, 110, 56, 1.00)',
            'rgba(74, 89, 36, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus laurifolia/quercus laurifolia.jpg',
          width: 576,
          id: '92762fcb7bc9831089aa63592894396a',
          height: 768,
          thumbnail: true,
        },
        location: [47.270083, -1.584492],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584492, 47.270083] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '42e134bcebdf2734ec11fcb7ca2d325cf3a143da',
      fields: {
        espece: 'myrsinifolia',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(181, 184, 173, 1.00)',
            'rgba(91, 99, 70, 1.00)',
            'rgba(77, 80, 42, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus myrsinifolia/quercus myrsinifolia  (1).jpg',
          width: 1024,
          id: '6df23a30c10b76814a816d5b3fbe02f3',
          height: 683,
          thumbnail: true,
        },
        location: [47.269962, -1.581537],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581537, 47.269962] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2d91a2be312ae1cce2009a82190f0af282f1e2d4',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 140, 132, 1.00)',
            'rgba(91, 106, 93, 1.00)',
            'rgba(79, 87, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/garrya [garyaceae]/garrya elliptica 'james roof'/garrya elliptica 'james roof' (3).jpg",
          width: 520,
          id: '4eb47feff1c2637d9cd092ab9d368ce9',
          height: 768,
          thumbnail: true,
        },
        espece: 'elliptica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 99, 90, 1.00)',
            'rgba(104, 113, 104, 1.00)',
            'rgba(108, 114, 104, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/garrya [garyaceae]/garrya elliptica 'james roof'/garrya elliptica 'james roof' (2).jpg",
          width: 1024,
          id: '5d7732d1408b6c160b31e4b0d3610208',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 98, 90, 1.00)',
            'rgba(104, 111, 101, 1.00)',
            'rgba(85, 94, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/garrya [garyaceae]/garrya elliptica 'james roof'/garrya elliptica 'james roof' (1).jpg",
          width: 512,
          id: '4e4b2f4e84cff01368fe440ba5302448',
          height: 768,
          thumbnail: true,
        },
        location: [47.271172, -1.5804],
        genre: 'Garrya',
        cultivar: 'James Roof',
        famille: 'Garryaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5804, 47.271172] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c2c5f1641cb1eef93166a4043e5015b8d5bf065b',
      fields: {
        origine: 'Devonian BG Alberta (Canada)',
        espece: 'siphonantha Maxim.',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Gentiana',
        date_plantation: '2014',
        famille: 'Gentianaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c7768efedf4b99e244d76ee4546ebb5cac1aeade',
      fields: {
        origine: 'JB.South Hadley (U.S.A.)',
        espece: 'maculatum L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Geranium',
        date_plantation: '2001',
        famille: 'Geraniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '556f92b0cd8ffac4c1d6226daf61c86556b70f9c',
      fields: {
        origine: 'Mr.Gauthier',
        espece: 'manescavi Cosson',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Erodium',
        date_plantation: '1991',
        famille: 'Geraniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a0a94adf59daf385d1694b3ef511ae3fd2196a40',
      fields: {
        espece: 'manicata Lindl.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Gunnera',
        date_plantation: '1973',
        famille: 'Gunneraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '94eca4807ed7146751140aace54d6b2a6179c0d0',
      fields: {
        espece: 'persica',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 152, 107, 1.00)',
            'rgba(126, 103, 59, 1.00)',
            'rgba(78, 69, 28, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/parrotia [hamamelidaceae]/parrotia persica/parrotia persica.jpg',
          width: 1024,
          id: 'c610f8047d008397fd7ac2fbc987d5c5',
          height: 768,
          thumbnail: true,
        },
        location: [47.261988, -1.535313],
        genre: 'Parrotia',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535313, 47.261988] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ca8ec5963bd8dd7c5c6f22f4066013e6c1d5708c',
      fields: {
        espece: 'rostrata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(192, 113, 103, 1.00)',
            'rgba(185, 112, 96, 1.00)',
            'rgba(160, 97, 78, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/heliconia [heliconiaceae]/heliconia rostrata/heliconia rostrata (2).jpg",
          width: 576,
          id: '066b7b7bae87c5105c281e6bc0c313cd',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(187, 149, 126, 1.00)',
            'rgba(152, 119, 85, 1.00)',
            'rgba(84, 73, 38, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/heliconia [heliconiaceae]/heliconia rostrata/heliconia rostrata (1).jpg",
          width: 563,
          id: '007e9055628ff8ba26efb4e9ac258c52',
          height: 768,
          thumbnail: true,
        },
        location: [47.227003, -1.512155],
        genre: 'Heliconia',
        famille: 'Heliconiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512155, 47.227003] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1f273fe989ac8d974f0fe1fd3b35c801c87d2a51',
      fields: {
        origine: 'Arb.Uni.Seattle Washington (U.S.A.)',
        espece: 'lewisii',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Philadelphus',
        date_plantation: '1997',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6c0e1e0edf03d37994d886a9151f142c7a1ce010',
      fields: {
        origine: 'Arboretum Volga Kama, Zapovednik (Russie)',
        espece: 'subcanus',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Philadelphus',
        date_plantation: '2005',
        cultivar: 'magdalenae',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1501bc833ebe2f78b93aa20fd5c0388a5d49c9ea',
      fields: {
        origine:
          'Conservatoire & Arboretum des Barres  sauvage connue\u00a0: Japon r\u00e9f. 52004396W',
        espece: 'schrenkii',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Philadelphus',
        date_plantation: '2009',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '30fc6f634ac27fd1931420c5c0621c2d6b065f15',
      fields: {
        origine: 'JBU.Macea Jud Arad (Roumanie)',
        espece: 'incanus',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Philadelphus',
        date_plantation: '1986',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4b73f47dd7791fe9511519ef1ec4a147821480b6',
      fields: {
        origine: 'RHS Garden Surrey (Angl.)',
        espece: 'californica Torr.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Carpenteria',
        date_plantation: '2014',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3d21ff2a1a4b7b06394d034042facdce3a1937a1',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 150, 53, 1.00)',
            'rgba(130, 153, 44, 1.00)',
            'rgba(123, 123, 71, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia x hybrida 'mont rose'/deutzia x hybrida 'mont rose'  (3).jpg",
          width: 576,
          id: '0c47888d15c6dbde85659128f5439237',
          height: 768,
          thumbnail: true,
        },
        espece: 'x hybrida',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 125, 106, 1.00)',
            'rgba(148, 135, 135, 1.00)',
            'rgba(93, 89, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia x hybrida 'mont rose'/deutzia x hybrida 'mont rose'  (2).jpg",
          width: 576,
          id: '68f1611506d53b1f43aab34d39af57a0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 148, 118, 1.00)',
            'rgba(132, 133, 102, 1.00)',
            'rgba(106, 107, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia x hybrida 'mont rose'/deutzia x hybrida 'mont rose'  (1).jpg",
          width: 882,
          id: '4b6c9e59b03aedf1236f50e08b7512ec',
          height: 768,
          thumbnail: true,
        },
        location: [47.27112, -1.581763],
        genre: 'Deutzia',
        cultivar: 'Mont Rose',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581763, 47.27112] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a0da7dce050503057cf4dd582e77588d954d450b',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 99, 67, 1.00)',
            'rgba(147, 157, 132, 1.00)',
            'rgba(68, 80, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hydrangea [hydrangeaceae]/hydrangea arborescens 'annabelle'/hydrangea arborescens 'annabelle' (3).jpg",
          width: 576,
          id: '2af27235f91c2ff3fc646ecc10612804',
          height: 768,
          thumbnail: true,
        },
        espece: 'arborescens',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(75, 125, 34, 1.00)',
            'rgba(98, 149, 52, 1.00)',
            'rgba(113, 149, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hydrangea [hydrangeaceae]/hydrangea arborescens 'annabelle'/hydrangea arborescens 'annabelle' (2).jpg",
          width: 576,
          id: 'd3c88312e6cebe506aaa619b800ab643',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 99, 53, 1.00)',
            'rgba(91, 120, 57, 1.00)',
            'rgba(57, 81, 20, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hydrangea [hydrangeaceae]/hydrangea arborescens 'annabelle'/hydrangea arborescens 'annabelle' (1).jpg",
          width: 1024,
          id: 'c468f2525351edae456216d77388291e',
          height: 768,
          thumbnail: true,
        },
        location: [47.271133, -1.584483],
        genre: 'Hydrangea',
        cultivar: 'Annabelle',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584483, 47.271133] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b6da49515b4b0f615cb58a3df2956a9cc3237ed3',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 142, 75, 1.00)',
            'rgba(119, 156, 89, 1.00)',
            'rgba(69, 111, 37, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'beauclerk'/philadelphus 'beauclerk' (3).jpg",
          width: 576,
          id: '6edfb86ab81b5545a334d8b3e6a77aed',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 82, 64, 1.00)',
            'rgba(155, 154, 151, 1.00)',
            'rgba(67, 74, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'beauclerk'/philadelphus 'beauclerk' (4).jpg",
          width: 576,
          id: '5d49023bdf31a51a4dd2428d0c105c51',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 132, 80, 1.00)',
            'rgba(121, 142, 86, 1.00)',
            'rgba(88, 108, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'beauclerk'/philadelphus 'beauclerk' (2).jpg",
          width: 1024,
          id: '0437384d758ac67dc67b0662fd2bc872',
          height: 768,
          thumbnail: true,
        },
        location: [47.271058, -1.585245],
        genre: 'Philadelphus',
        cultivar: 'Beauclerk',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585245, 47.271058] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2668292de769a68c5c9fc553c6bd6a4c8999c912',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 108, 29, 1.00)',
            'rgba(117, 143, 54, 1.00)',
            'rgba(112, 135, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'innocence'/philadelphus 'innocence'   (4).jpg",
          width: 576,
          id: 'a187ce7e0ea9a1a763b247ece8e0bb0e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 134, 97, 1.00)',
            'rgba(117, 129, 77, 1.00)',
            'rgba(101, 113, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'innocence'/philadelphus 'innocence'   .jpg",
          width: 1024,
          id: '3b7f94576837b82e193204efcc0e5af2',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 98, 66, 1.00)',
            'rgba(155, 160, 144, 1.00)',
            'rgba(70, 76, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'innocence'/philadelphus 'innocence'   (2).jpg",
          width: 576,
          id: '9ec1f72096eb62a00c23d53345daa721',
          height: 768,
          thumbnail: true,
        },
        location: [47.271405, -1.582045],
        genre: 'Philadelphus',
        cultivar: 'Innocence',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582045, 47.271405] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '465550eacebfee2a787955694477352d93f258d5',
      fields: {
        origine: 'B.G. Kiel (All.)',
        espece: 'striatum Sm.',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Sisyrinchium',
        date_plantation: '2014',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5811978ebe6fc3034dd121d1ad4cec02f7b744b6',
      fields: {
        origine: 'Inst.Bot. De Komarovii Perkalsky,Stauropol,Russie',
        espece: 'tenuis M.Bieb.',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Gladiolus',
        date_plantation: '2010',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '03df0c0dc2d0abaadd78258bf0cf3cc4e6463f64',
      fields: {
        origine: 'J.B Nitra (Slovaquie)',
        espece: 'chinensis DC.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Belamcanda',
        date_plantation: '2011',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f13d95d6998c50f5edaa0a88aac5cf9cc8269db0',
      fields: {
        origine: 'J.B. Limoges (France)',
        espece: 'dracomontanum Hilliard',
        localisation: 'I2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185657, -1.5426599],
        genre: 'Dierama',
        date_plantation: '2011',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426599, 47.2185657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4b0f996599a5f7de4562baeaa25b12ebb5d3df82',
      fields: {
        origine: 'JB. Wurzburg (Allemagne)',
        espece: 'xiphium Desf.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Iris',
        date_plantation: '2010',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b6c9052fa7b997db5647bdcaaed9665185cbb25b',
      fields: {
        origine: 'JB. Zagreb (Croatie)',
        espece: 'pseudopallida Trinajstic',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Iris',
        date_plantation: '2010',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5800a020b55e57df334633a394cce2a206472216',
      fields: {
        origine: 'JB.Chemnitz (Allemagne)',
        espece: 'sibirica L.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Iris',
        date_plantation: '2006',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b009b8e26d526aaf79c590aebaddb9f9a106f687',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'bulleyana Dykes.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Iris',
        date_plantation: '2009',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e9bd2e8454a1f8236cd8313e012827cd461d889a',
      fields: {
        origine: 'Med.Herb Garden,University of Washington, Seattle, USA',
        espece: 'bellum S.Watson',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Sisyrinchium',
        date_plantation: '2012',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '31ae4709d96337bb8daf7a76ee1047984aabd46d',
      fields: {
        origine: 'Medicinal Herb Garden (Seattle USA)',
        espece: 'bellum S.Watson',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Sisyrinchium',
        date_plantation: '2011',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ad32a5e61c770c3ec764fb244af883a84a762939',
      fields: {
        origine: 'Universit\u00e9 de Postdam (Allemagne)',
        espece: 'sanguinea Donn.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Iris',
        date_plantation: '2011',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7c722248a5022217ea8edf7cfdb62e1e1e4f4ce6',
      fields: {
        origine: 'Utrecht BG',
        espece: 'sintenisii Janka',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Iris',
        date_plantation: '2010',
        cultivar: 'sintenisii',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9795cf144e6b9687a3817c60d8b9d6d84e8a5158',
      fields: {
        espece: 'sp.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Iris',
        date_plantation: '1973',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '33f1c625fbde010aeb7139ab7d1bb2fc4a384c2d',
      fields: {
        origine: 'JB. G\u00f6teborg (Su\u00e8de)',
        espece: 'tataricum Herb.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Ixiolirion',
        date_plantation: '2010',
        famille: 'Ixioliriaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '27eabddb07ab4a1bb9561eb565f18f3835f42e7f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'mandshurica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 161, 119, 1.00)',
            'rgba(124, 138, 75, 1.00)',
            'rgba(77, 106, 37, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/juglans [juglandaceae]/juglans mandshurica/juglans mandshurica (12).jpg',
          width: 576,
          id: '7b8fd5879876a4c1a3c2e3fbfd8881a9',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 133, 86, 1.00)',
            'rgba(99, 142, 83, 1.00)',
            'rgba(69, 118, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/juglans [juglandaceae]/juglans mandshurica/juglans mandshurica (13).jpg',
          width: 576,
          id: '7b76baa53dfbb6c0397935b326cbdeee',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 149, 103, 1.00)',
            'rgba(125, 138, 78, 1.00)',
            'rgba(114, 128, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/juglans [juglandaceae]/juglans mandshurica/juglans mandshurica (1).jpg',
          width: 576,
          id: 'd90ba9217d303736230cf421329cfa4d',
          height: 768,
          thumbnail: true,
        },
        location: [47.270108, -1.582417],
        genre: 'Juglans',
        famille: 'Juglandaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582417, 47.270108] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2f6ba5cd13ffb440a8bce5d1beadccc3ca1effe8',
      fields: {
        origine: 'Emmanuel LEPAGE',
        espece: 'nervosa Royle',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Nepeta',
        date_plantation: '2015',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '030073abee149b2b624756535e34b3602f3ceaf6',
      fields: {
        origine: 'Inst. Bio. Medic. Tsukuba, Ibaraki',
        espece: 'vulgaris L.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Prunella',
        date_plantation: '2008',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '358e9b9c0f0277b34e921ae5d29b6cbbab1da2ed',
      fields: {
        origine: "Jardin botanique de l'Universit\u00e9 de Sienne",
        espece: 'columnae All.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Scutellaria',
        date_plantation: '2010',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f9f65e8c9b6c18942a681657fd2591ee14f30f5f',
      fields: {
        origine: 'JB. Osterr-garten, Graz (Autriche)',
        espece: 'deserta Schangin',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Salvia',
        date_plantation: '2011',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd222212b0ef7688dcba9f074a745cc64e4d3b318',
      fields: {
        origine: 'JB.Bremen (Allemagne)',
        espece: 'grandiflora Scholler',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Prunella',
        date_plantation: '2009',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '63b211dd9bfbf295c3a704c2a49743633a1bae11',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'macrantha  Stearn',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Stachys',
        date_plantation: '2008',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3354dec31ca9f7c1ace284ffc77752533eb8c21f',
      fields: {
        origine: 'JB.Nice (France)',
        espece: 'lunariifolia Sm.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Phlomis',
        date_plantation: '2003',
        cultivar: 'pungens Maire',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c1da8ef91be9b92b63f68d3657ed37ba1db7a7d1',
      fields: {
        origine: 'JB.Rostov ad Donum (Russie)',
        espece: 'tesquicola Klokov.& Pobed.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Salvia',
        date_plantation: '2009',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '09c4834a247d21d9ca7d3b06377260e1a8d99be6',
      fields: {
        origine: 'JB.Utrecht-Pays bas',
        espece: 'laciniata L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Prunella',
        date_plantation: '2010',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a89cf0c278d62cf785bcfc4544e87809736d2f8e',
      fields: {
        origine: 'Kyoto Herbal Garden',
        espece: 'baicalensis Georgi',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Scutellaria',
        date_plantation: '2008',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f325b7dedd90883de7e0713f4828e8154f72affb',
      fields: {
        origine: 'P\u00e9pini\u00e8re Akebia',
        espece: 'longitubus Kudo',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Isodon',
        date_plantation: '2015',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '55275fe8b62cdd5391ed7381153806ef6abec1a3',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 148, 67, 1.00)',
            'rgba(124, 166, 59, 1.00)',
            'rgba(106, 141, 42, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/callicarpa [lamiaceae]/callicarpa japonica/callicarpa japonica (2).jpg',
          width: 576,
          id: 'bbb70f5e641f1dec2db22d2a6824fefb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 130, 90, 1.00)',
            'rgba(95, 136, 95, 1.00)',
            'rgba(82, 122, 81, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/callicarpa [lamiaceae]/callicarpa japonica/callicarpa japonica (4).jpg',
          width: 1024,
          id: '393f0667275fd7947fdd409104a352a3',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 137, 53, 1.00)',
            'rgba(124, 133, 78, 1.00)',
            'rgba(112, 126, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/callicarpa [lamiaceae]/callicarpa japonica/callicarpa japonica (1).jpg',
          width: 576,
          id: 'eb8029699bfa4ce56752fa3e27c63b23',
          height: 768,
          thumbnail: true,
        },
        location: [47.269895, -1.584717],
        genre: 'Callicarpa',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584717, 47.269895] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'daf5fc9ef173bfc5ded89cc13dba8419d5fe5108',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x clandonensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 140, 79, 1.00)',
            'rgba(127, 145, 105, 1.00)',
            'rgba(88, 115, 48, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/caryopteris [lamiaceae]/caryopteris x clandonensis/caryopteris x clandonensis (2).jpg',
          width: 576,
          id: 'ec0980adb2a3e028184223943240a7a1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 168, 108, 1.00)',
            'rgba(127, 161, 72, 1.00)',
            'rgba(126, 152, 97, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/caryopteris [lamiaceae]/caryopteris x clandonensis/caryopteris x clandonensis (3).jpg',
          width: 576,
          id: '395167afe206298635023c47802e9825',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 133, 85, 1.00)',
            'rgba(131, 159, 96, 1.00)',
            'rgba(96, 121, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/caryopteris [lamiaceae]/caryopteris x clandonensis/caryopteris x clandonensis (1).jpg',
          width: 576,
          id: '2a37aa7ff2b351d1974461886beb95e5',
          height: 768,
          thumbnail: true,
        },
        location: [47.2716, -1.584663],
        genre: 'Caryopteris',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584663, 47.2716] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c40629102d8605f1c74fd381d596491a5760652c',
      fields: {
        espece: 'dependens',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 123, 100, 1.00)',
            'rgba(120, 111, 109, 1.00)',
            'rgba(99, 102, 98, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/rostrinucula [lamiaceae]/rostrinucula dependens/rostrinucula dependens (13).jpg',
          width: 1024,
          id: '9189fed9c6b6017d55ad24a491991636',
          height: 683,
          thumbnail: true,
        },
        location: [47.270717, -1.585828],
        genre: 'Rostrinucula',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585828, 47.270717] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '33e5a3e11cefc8d9a886e3cc4285b4ab18733ac9',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'fruticans',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 150, 127, 1.00)',
            'rgba(125, 129, 115, 1.00)',
            'rgba(117, 105, 90, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/teucrium [lamiaceae]/teucrium fruticans/teucrium fruticans (2).jpg',
          width: 576,
          id: '1b99b78c8eff9d63d7826b0e717160c2',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 137, 118, 1.00)',
            'rgba(118, 131, 105, 1.00)',
            'rgba(122, 132, 104, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/teucrium [lamiaceae]/teucrium fruticans/teucrium fruticans (3).jpg',
          width: 576,
          id: '093dd711c7be35109e8037fff570d0e2',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 140, 99, 1.00)',
            'rgba(131, 136, 110, 1.00)',
            'rgba(101, 96, 78, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/teucrium [lamiaceae]/teucrium fruticans/teucrium fruticans (1).jpg',
          width: 1024,
          id: '83f6ff18cb9cd5ada2cd6770c1893ffb',
          height: 768,
          thumbnail: true,
        },
        location: [47.27177, -1.582787],
        genre: 'Teucrium',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582787, 47.27177] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7b3e62e4939b90d326e1fbef66f9a4caa947976a',
      fields: {
        espece: 'fargesii',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 136, 89, 1.00)',
            'rgba(113, 129, 76, 1.00)',
            'rgba(108, 122, 81, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/decaisnea [lardizabalaceae]/decaisnea fargesii/decaisnea fargesii.jpg',
          width: 1024,
          id: '3efc5cecd1b4331b726501f8bf5acf43',
          height: 683,
          thumbnail: true,
        },
        location: [47.271145, -1.581925],
        genre: 'Decaisnea',
        famille: 'Lardizabalaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581925, 47.271145] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c97916197a20b063b3d6a70156379f522a4edc9d',
      fields: {
        origine: 'J.Alp.Meyrin (Suisse)',
        espece: 'sprengeri Bak.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Tulipa',
        date_plantation: '2006',
        famille: 'Liliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7479f0ddf6fe98cf99d804fbb3f99d489249cb25',
      fields: {
        origine: 'J.B.de Prague,Rep.Tch\u00e8que',
        espece: 'turkestanica Regel',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Tulipa',
        date_plantation: '2010',
        famille: 'Liliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '87ce03571a5831f0cba458c7375297e32f26287c',
      fields: {
        espece: 'granatum',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(177, 182, 141, 1.00)',
            'rgba(85, 99, 34, 1.00)',
            'rgba(85, 83, 56, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/punica [lythraceae]/punica granatum/punica granatum (2).jpg",
          width: 576,
          id: '8753297bd3ab14d1eb76ab6df0572d85',
          height: 768,
          thumbnail: true,
        },
        location: [47.22668, -1.512263],
        genre: 'Punica',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512263, 47.22668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '432641158c3307c6322ec298812ad37b2d53a9d4',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Grand Blottereau',
        espece: 'x',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Magnolia',
        date_plantation: '2015',
        cultivar: 'Joe Mc Daniels',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e31a64461b9b19bdfdacac738320e3c9c9e8ee1a',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Grand Blottereau',
        espece: 'stellata',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Magnolia',
        date_plantation: '2016',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0a13e6e3822a6b6e986133ddf7395472522b8a6a',
      fields: {
        espece: 'tulipifera',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 135, 151, 1.00)',
            'rgba(118, 107, 63, 1.00)',
            'rgba(54, 51, 26, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/liriodendron [magnoliaceae]/liriodendron tulipifera 'fastigiata'/liriodendron tulipifera 'fastigiata'.jpg",
          width: 583,
          id: 'f0f4f2171736117bf062df9fbfff1709',
          height: 768,
          thumbnail: true,
        },
        location: [47.269233, -1.584317],
        genre: 'Liriodendron',
        cultivar: 'Fastigiata',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584317, 47.269233] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '26a5caa6a77e16440ce23339e060d7be6130b72e',
      fields: {
        espece: 'tulipifera',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 147, 151, 1.00)',
            'rgba(151, 136, 119, 1.00)',
            'rgba(99, 79, 32, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/liriodendron [magnoliaceae]/liriodendron tulipifera/liriodendron tulipifera.jpg",
          width: 605,
          id: '03e7e84aedddc2dbf20c1338fac446c8',
          height: 768,
          thumbnail: true,
        },
        location: [47.227313, -1.512197],
        genre: 'Liriodendron',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512197, 47.227313] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '377991950bd9230488c6db5950a7418c90fbda79',
      fields: {
        espece: 'grandiflora',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Magnolia',
        date_plantation: '1973',
        cultivar: 'Ferruginea',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '90dba7937441bd54dd800da68526d4f05072a259',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 102, 89, 1.00)',
            'rgba(169, 124, 143, 1.00)',
            'rgba(120, 91, 85, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'heaven scent'/magnolia 'heaven scent' (2).jpg",
          width: 576,
          id: '439136a76b0d3b1513131e9242a5db66',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 118, 93, 1.00)',
            'rgba(144, 120, 96, 1.00)',
            'rgba(132, 110, 83, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'heaven scent'/magnolia 'heaven scent' (1).jpg",
          width: 576,
          id: '5113732f69a962a74d8dc3a7fddfde50',
          height: 768,
          thumbnail: true,
        },
        location: [47.269694, -1.58165],
        genre: 'Magnolia',
        cultivar: 'Heaven Scent',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58165, 47.269694] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '165fd9387d0608eb3d7c0498af3a6438e2c77d93',
      fields: {
        origine: 'J.B. Kaunas (Lituanie)',
        espece: 'napaea Cav.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Sida',
        date_plantation: '2011',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ce06c9de6a3921e7f508146713b9a420e7bfafe1',
      fields: {
        espece: 'acuminata',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 148, 48, 1.00)',
            'rgba(108, 134, 48, 1.00)',
            'rgba(109, 132, 59, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/cola [malvaceae]/cola acuminata/cola acuminata.jpg",
          width: 684,
          id: 'b9172a6d07996d02132744b78919cd66',
          height: 768,
          thumbnail: true,
        },
        location: [47.226967, -1.51185],
        genre: 'Cola',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.51185, 47.226967] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '39d5425d506cc3e1d57923c9998da38868f069a8',
      fields: {
        espece: 'cordata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 150, 56, 1.00)',
            'rgba(125, 158, 54, 1.00)',
            'rgba(107, 134, 36, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/tilia [malvaceae]/tilia cordata 'lico'/tilia cordata 'lico' (2).jpg",
          width: 576,
          id: 'eea35515a57550a9e7a9c14adcc831f0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 162, 100, 1.00)',
            'rgba(115, 131, 64, 1.00)',
            'rgba(123, 112, 78, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/tilia [malvaceae]/tilia cordata 'lico'/tilia cordata 'lico' (1).jpg",
          width: 576,
          id: 'f722a7f0256e1e35e08ac7922ae1f5c5',
          height: 768,
          thumbnail: true,
        },
        location: [47.269428, -1.584575],
        genre: 'Tilia',
        cultivar: 'Lico',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584575, 47.269428] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8144ecd1a136670f9d525fa044b8292516e4b31c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'mongolica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(60, 78, 30, 1.00)',
            'rgba(97, 134, 56, 1.00)',
            'rgba(97, 117, 42, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tilia [malvaceae]/tilia mongolica/tilia mongolica (2).jpg',
          width: 576,
          id: 'a408f54c6e2267553483fb745edb61a8',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 117, 57, 1.00)',
            'rgba(147, 170, 118, 1.00)',
            'rgba(115, 136, 88, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tilia [malvaceae]/tilia mongolica/tilia mongolica (3).jpg',
          width: 576,
          id: 'b7fa403324bd43b531fb10e502b0ee48',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 152, 85, 1.00)',
            'rgba(118, 140, 82, 1.00)',
            'rgba(72, 96, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tilia [malvaceae]/tilia mongolica/tilia mongolica (1).jpg',
          width: 576,
          id: 'd8bb0d939f4408d2b0c8a6ecdfe7a354',
          height: 768,
          thumbnail: true,
        },
        location: [47.27095, -1.580345],
        genre: 'Tilia',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580345, 47.27095] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bb05428fdf776f1bab5281a7a8c70287b7f86d87',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x europaea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 150, 93, 1.00)',
            'rgba(121, 150, 91, 1.00)',
            'rgba(99, 122, 75, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tilia [malvaceae]/tilia x europaea/tilia cordata (2).jpg',
          width: 576,
          id: 'a75a2a35dab9dd8e6fa97b0e9cf0fb60',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 153, 114, 1.00)',
            'rgba(123, 145, 102, 1.00)',
            'rgba(117, 126, 87, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tilia [malvaceae]/tilia x europaea/tilia cordata (3).jpg',
          width: 576,
          id: '4d031b02b446e6494616ca97948195ae',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 129, 72, 1.00)',
            'rgba(118, 139, 89, 1.00)',
            'rgba(99, 106, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tilia [malvaceae]/tilia x europaea/tilia cordata (1).jpg',
          width: 576,
          id: 'cdb1a018807683d32fd8d3d2e4a64907',
          height: 768,
          thumbnail: true,
        },
        location: [47.2693, -1.582528],
        genre: 'Tilia',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582528, 47.2693] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8e81a3e4542365884d7d053f76a75d28b60d5a71',
      fields: {
        origine: 'P\u00e9pini\u00e8re Municipale',
        espece: 'sellowiana',
        localisation: 'A12',
        nom_du_site: 'Jardin des Plantes',
        location: [47.22098, -1.5430278],
        genre: 'Acca',
        date_plantation: '1996',
        famille: 'Myrtaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5430278, 47.22098] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '73345bc51c692579f79a0668b6201c2849211680',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'grandiflorum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 136, 116, 1.00)',
            'rgba(124, 127, 84, 1.00)',
            'rgba(115, 106, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/leptospermum [myrtaceae]/leptospermum grandiflorum/leptospermum grandiflorum (2).jpg',
          width: 576,
          id: 'ab0aa022e693f58fd7917d4630a18dc0',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 162, 159, 1.00)',
            'rgba(97, 96, 76, 1.00)',
            'rgba(120, 108, 84, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/leptospermum [myrtaceae]/leptospermum grandiflorum/leptospermum grandiflorum (3).jpg',
          width: 576,
          id: 'a9b8effd88fc8c451288eb24597d7105',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 133, 110, 1.00)',
            'rgba(150, 120, 95, 1.00)',
            'rgba(137, 110, 86, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/leptospermum [myrtaceae]/leptospermum grandiflorum/leptospermum grandiflorum (1).jpg',
          width: 576,
          id: '33f0a33615e33cacedfacbddf54cad24',
          height: 768,
          thumbnail: true,
        },
        location: [47.270767, -1.58588],
        genre: 'Leptospermum',
        famille: 'Myrtaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58588, 47.270767] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6ce2823caef96d23850ca2df1d21171d5ba07a69',
      fields: {
        espece: 'molinae',
        localisation: 'A2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2208871, -1.5444631],
        genre: 'Ugni',
        date_plantation: '2015',
        famille: 'Myrtaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444631, 47.2208871] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2563c9aba0ac26e77f2fc89a7f20f4f89496332d',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'involucrata var. vilmoriniana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 107, 39, 1.00)',
            'rgba(126, 136, 97, 1.00)',
            'rgba(88, 101, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/davidia [nyssaceae]/davidia involucrata var. vilmoriniana/davidia involucrata var. vilmoriniana (2).jpg',
          width: 576,
          id: 'cbdca18861c8edf58bb9065dd360c713',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 153, 79, 1.00)',
            'rgba(106, 140, 53, 1.00)',
            'rgba(116, 135, 75, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/davidia [nyssaceae]/davidia involucrata var. vilmoriniana/davidia involucrata var. vilmoriniana (3).jpg',
          width: 635,
          id: 'a53bf7c8f052787c476fb7029527f330',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 110, 72, 1.00)',
            'rgba(126, 139, 111, 1.00)',
            'rgba(62, 76, 40, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/davidia [nyssaceae]/davidia involucrata var. vilmoriniana/davidia involucrata var. vilmoriniana (1).jpg',
          width: 576,
          id: '4313d4e072bf83bc1192f3b8e8cbdfb6',
          height: 768,
          thumbnail: true,
        },
        location: [47.271242, -1.581605],
        genre: 'Davidia',
        famille: 'Nyssaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581605, 47.271242] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6b51adbb126be881cfca5111ece04f6a9ba5e257',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'fortunei',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 153, 47, 1.00)',
            'rgba(115, 147, 52, 1.00)',
            'rgba(122, 134, 67, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fontanesia [oleaceae]/fontanesia fortunei/fontanesia fortunei  (4).jpg',
          width: 576,
          id: 'b1e3e8489e7725d2c3b6ae0dab4608ec',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 101, 139, 1.00)',
            'rgba(97, 111, 100, 1.00)',
            'rgba(114, 111, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fontanesia [oleaceae]/fontanesia fortunei/fontanesia fortunei (1).jpg',
          width: 512,
          id: '649bb46fc773539c4557b314ff6baa5d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 123, 67, 1.00)',
            'rgba(126, 136, 70, 1.00)',
            'rgba(82, 99, 33, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fontanesia [oleaceae]/fontanesia fortunei/fontanesia fortunei  (3).jpg',
          width: 576,
          id: 'b495ca72ad7dee6c9e3a85bd27eed1b0',
          height: 768,
          thumbnail: true,
        },
        location: [47.270175, -1.5859],
        genre: 'Fontanesia',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5859, 47.270175] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2a25baaf37a4c43bcd8fd22c70f432513a17994a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'sieboldiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 138, 39, 1.00)',
            'rgba(121, 143, 48, 1.00)',
            'rgba(115, 133, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus sieboldiana/fraxinus sieboldiana (2).jpg',
          width: 576,
          id: '8b1b11af1f1d501e91b73fe7d16cfea8',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 154, 117, 1.00)',
            'rgba(147, 151, 90, 1.00)',
            'rgba(152, 148, 117, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus sieboldiana/fraxinus sieboldiana (3).jpg',
          width: 576,
          id: 'f40a9cafc9eddc71414a89fbc7644f46',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(217, 232, 229, 1.00)',
            'rgba(137, 148, 101, 1.00)',
            'rgba(73, 81, 36, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus sieboldiana/fraxinus sieboldiana (1).jpg',
          width: 1024,
          id: 'd420b5a200a7dd4725bc65cd8fca2ad8',
          height: 768,
          thumbnail: true,
        },
        location: [47.271025, -1.584887],
        genre: 'Fraxinus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584887, 47.271025] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ea5c1833dcc165a826c107c9e2569c1aa70eab79',
      fields: {
        espece: 'mesnyi',
        localisation: 'A11',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2211256, -1.5428042],
        genre: 'Jasminum',
        date_plantation: '1973',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428042, 47.2211256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '58179e2a7b3f6b19a8bdbfb7bbc27cc83fb57afe',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 91, 58, 1.00)',
            'rgba(116, 123, 93, 1.00)',
            'rgba(81, 87, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum lucidum 'excelsum superbum'/ligustrum lucidum 'excelsum superbum' (3).jpg",
          width: 576,
          id: '24834677760815aafbe13b9d5382a809',
          height: 768,
          thumbnail: true,
        },
        espece: 'lucidum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(189, 194, 180, 1.00)',
            'rgba(84, 97, 56, 1.00)',
            'rgba(47, 59, 26, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum lucidum 'excelsum superbum'/ligustrum lucidum 'excelsum superbum' (2).jpg",
          width: 576,
          id: 'd642c314ff4f605d84f74ae2f7d70b7b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 71, 33, 1.00)',
            'rgba(152, 153, 87, 1.00)',
            'rgba(93, 99, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum lucidum 'excelsum superbum'/ligustrum lucidum 'excelsum superbum' (1).jpg",
          width: 576,
          id: '3d4016845f7386e1933f50e8775b4ba3',
          height: 768,
          thumbnail: true,
        },
        location: [47.269953, -1.584658],
        genre: 'Ligustrum',
        cultivar: 'Excelsum Superbum',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584658, 47.269953] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e01748b34b040346636084b320948306cd10c5ca',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'tschonoskii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 93, 70, 1.00)',
            'rgba(108, 124, 97, 1.00)',
            'rgba(84, 91, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum tschonoskii/ligustrum tschonoskii (2).jpg',
          width: 576,
          id: 'd3562cfdbcf8024bfcf83c9f11aca675',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 125, 58, 1.00)',
            'rgba(119, 128, 85, 1.00)',
            'rgba(141, 130, 99, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum tschonoskii/ligustrum tschonoskii (3).jpg',
          width: 1024,
          id: '36e29465b6a4a0f55d046cf3f9d9cfe6',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 169, 123, 1.00)',
            'rgba(119, 135, 81, 1.00)',
            'rgba(110, 119, 69, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum tschonoskii/ligustrum tschonoskii (1).jpg',
          width: 576,
          id: 'adbbc6eaf27ee614e9584b1a9e8f06ca',
          height: 768,
          thumbnail: true,
        },
        location: [47.269987, -1.581537],
        genre: 'Ligustrum',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581537, 47.269987] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dec94ecf3f1c71ea07d10db6fb319ab6f582e4a0',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'armatus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 128, 90, 1.00)',
            'rgba(108, 135, 99, 1.00)',
            'rgba(103, 122, 97, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus armatus/osmanthus armatus (2).jpg',
          width: 576,
          id: '6fc3bd9dc96afd8f37443d2a6b91ae24',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 110, 67, 1.00)',
            'rgba(106, 121, 63, 1.00)',
            'rgba(78, 97, 47, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus armatus/osmanthus armatus (3).jpg',
          width: 576,
          id: '8d6e2eeadb3165c7304a38ac96fcb480',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 104, 45, 1.00)',
            'rgba(134, 155, 63, 1.00)',
            'rgba(116, 123, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus armatus/osmanthus armatus (1).jpg',
          width: 576,
          id: '211993ce86e3a0ab53e1e876c73e15b3',
          height: 768,
          thumbnail: true,
        },
        location: [47.271078, -1.58483],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58483, 47.271078] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '92cfbeebc5265c6fae85e377bd09dab2614ba34a',
      fields: {
        espece: 'x burkwoodii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 122, 104, 1.00)',
            'rgba(114, 124, 97, 1.00)',
            'rgba(89, 102, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus x burkwoodii/osmanthus x burkwoodii (3).jpg',
          width: 1024,
          id: '6c17d322ac08fc71a289e6fc391d37b4',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 91, 72, 1.00)',
            'rgba(105, 118, 97, 1.00)',
            'rgba(70, 85, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus x burkwoodii/osmanthus x burkwoodii (1).jpg',
          width: 1024,
          id: 'b0afe2f8b62c0d37eca9e2dc3700109e',
          height: 683,
          thumbnail: true,
        },
        location: [47.270503, -1.586458],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586458, 47.270503] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fd74aefa3991ab66226f0f83ad31d8c71d27b097',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x fortunei',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 106, 83, 1.00)',
            'rgba(98, 137, 106, 1.00)',
            'rgba(114, 121, 108, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus x fortunei/osmanthus x fortunei  (2).jpg',
          width: 576,
          id: '7f1c37af6d3145de109f033a0085fa1a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 157, 102, 1.00)',
            'rgba(109, 145, 90, 1.00)',
            'rgba(103, 134, 71, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus x fortunei/osmanthus x fortunei  (3).jpg',
          width: 576,
          id: '9a911f2472befb43c225e878f8dd8f49',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 151, 118, 1.00)',
            'rgba(103, 150, 100, 1.00)',
            'rgba(114, 149, 110, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus x fortunei/osmanthus x fortunei  (1).jpg',
          width: 576,
          id: 'd452833963d8d0c78845d522164f8841',
          height: 768,
          thumbnail: true,
        },
        location: [47.270317, -1.582637],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582637, 47.270317] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4477a5ada3c9ac7fbaf519cedae7bd8621d532fc',
      fields: {
        espece: 'angustifolia',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 160, 123, 1.00)',
            'rgba(117, 132, 93, 1.00)',
            'rgba(124, 122, 95, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/phillyrea [oleaceae]/phillyrea angustifolia/phillyrea angustifolia .jpg',
          width: 1024,
          id: '1c60343091cc3dd2c82a14878c3af498',
          height: 768,
          thumbnail: true,
        },
        location: [47.269375, -1.585413],
        genre: 'Phillyrea',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585413, 47.269375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e219ab943179bae83a978fa52c90712d39166227',
      fields: {
        origine: 'Goteborg Botanical Garden(Su\u00e8de)',
        espece: 'odorata Jacq.',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Oenothera',
        date_plantation: '2014',
        famille: 'Onagraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ddfa91a91de111921b1ae42844cf2a8ab8d24dc2',
      fields: {
        espece: 'carambola',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 147, 98, 1.00)',
            'rgba(104, 123, 76, 1.00)',
            'rgba(119, 128, 93, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/averrhoa [oxalidaceae]/averrhoa carambola/averrhoa carambola (2).jpg",
          width: 576,
          id: '113d246474a9a182f73f33e9909bd66d',
          height: 768,
          thumbnail: true,
        },
        location: [47.226945, -1.512142],
        genre: 'Averrhoa',
        famille: 'Oxalidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512142, 47.226945] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f764ec13ee4d37c3bd9cf4c07cf269ddc838db86',
      fields: {
        origine: 'J.Alp.La Thomasia (Suisse)',
        espece: 'caucasica  Schipcz.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Paeonia',
        date_plantation: '1996',
        famille: 'Paeoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8e1e862d820923f0fed0caf7444176699c1a5b33',
      fields: {
        origine: 'JBU.Hokkaido (Japon)',
        espece: 'cordata R.Br.',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Macleaya',
        date_plantation: '1998',
        famille: 'Papaveraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fb5b4444e10944391871891af2ca362524519749',
      fields: {
        espece: 'spectabilis Lem.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Dicentra',
        date_plantation: '1973',
        famille: 'Papaveraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7130212dab1fa939902e1c9a272dcb1375ae0cb2',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'battandieri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 129, 53, 1.00)',
            'rgba(111, 148, 60, 1.00)',
            'rgba(99, 142, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/argyrocytisus [papilionaceae]/argyrocytisus battandieri/argyrocytisus battandieri (2).jpg',
          width: 576,
          id: 'd6801620319d0b29913e2de0ea20479c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 127, 66, 1.00)',
            'rgba(121, 144, 65, 1.00)',
            'rgba(95, 127, 48, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/argyrocytisus [papilionaceae]/argyrocytisus battandieri/argyrocytisus battandieri (3).jpg',
          width: 576,
          id: '645b00495af1179d6410a78eac710af5',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 141, 71, 1.00)',
            'rgba(103, 151, 67, 1.00)',
            'rgba(91, 138, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/argyrocytisus [papilionaceae]/argyrocytisus battandieri/argyrocytisus battandieri (1).jpg',
          width: 576,
          id: '4ace445b850114235de0456b83309ac2',
          height: 768,
          thumbnail: true,
        },
        location: [47.271792, -1.586217],
        genre: 'Argyrocytisus',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586217, 47.271792] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '565b97a0603327910909908acf7f217f2816e437',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'kentukea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(186, 199, 170, 1.00)',
            'rgba(78, 100, 56, 1.00)',
            'rgba(69, 86, 45, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cladrastis [papilionaceae]/cladrastis kentukea/cladrastis kentukea (15).jpg',
          width: 1024,
          id: '9d19b92022252630fbb27ea4d820016d',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 141, 162, 1.00)',
            'rgba(115, 119, 95, 1.00)',
            'rgba(54, 55, 23, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cladrastis [papilionaceae]/cladrastis kentukea/cladrastis kentukea (6).jpg',
          width: 1024,
          id: '5bb5076f57a69a48f4b15597f654f2f4',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 126, 127, 1.00)',
            'rgba(120, 120, 84, 1.00)',
            'rgba(60, 60, 33, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cladrastis [papilionaceae]/cladrastis kentukea/cladrastis kentukea (13).jpg',
          width: 512,
          id: '32e5df5b5caf0a5d5ec4366a6dae310a',
          height: 768,
          thumbnail: true,
        },
        location: [47.271108, -1.58292],
        genre: 'Cladrastis',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58292, 47.271108] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7ff04bed44bb099ba5a831509adf45711c54ab17',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 86, 67, 1.00)',
            'rgba(102, 110, 100, 1.00)',
            'rgba(136, 124, 122, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/lespedeza [papilionaceae]/lespedeza thunbergii 'gibraltar'/lespedeza thunbergii 'gibraltar' (3).jpg",
          width: 1024,
          id: '66a7a16d27a51ff0bb8520d0ef37d6d7',
          height: 768,
          thumbnail: true,
        },
        espece: 'thunbergii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 113, 110, 1.00)',
            'rgba(104, 124, 118, 1.00)',
            'rgba(87, 109, 100, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/lespedeza [papilionaceae]/lespedeza thunbergii 'gibraltar'/lespedeza thunbergii 'gibraltar' (2).jpg",
          width: 576,
          id: '5f9252c2a2097ac6819d817badba160f',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 116, 112, 1.00)',
            'rgba(120, 121, 123, 1.00)',
            'rgba(125, 110, 122, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/lespedeza [papilionaceae]/lespedeza thunbergii 'gibraltar'/lespedeza thunbergii 'gibraltar' (1).jpg",
          width: 576,
          id: '991e26e2dcf0bfb54ba54ba1f7ec1c60',
          height: 768,
          thumbnail: true,
        },
        location: [47.270912, -1.584447],
        genre: 'Lespedeza',
        cultivar: 'Gibraltar',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584447, 47.270912] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ac0030269a09f65d5ed07cb063672c66eea6354f',
      fields: {
        espece: 'citrina',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 98, 47, 1.00)',
            'rgba(112, 152, 68, 1.00)',
            'rgba(100, 136, 50, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/passiflora [passifloraceae]/passiflora citrina/passiflora citrina (2).jpg",
          width: 576,
          id: '2843be1d50368af01fadeb3c6c082bb5',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 102, 50, 1.00)',
            'rgba(111, 131, 50, 1.00)',
            'rgba(91, 113, 45, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/passiflora [passifloraceae]/passiflora citrina/passiflora citrina (1).jpg",
          width: 576,
          id: '56e1cf6a240f3cd5690cda938166ea6a',
          height: 768,
          thumbnail: true,
        },
        location: [47.22678, -1.512637],
        genre: 'Passiflora',
        famille: 'Passifloraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512637, 47.22678] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '532dda67c6f9ac8554588300417105de159d589d',
      fields: {
        espece: 'adaphniphylloides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 156, 140, 1.00)',
            'rgba(72, 88, 62, 1.00)',
            'rgba(83, 95, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pittosporum [pittosporaceae]/pittosporum adaphniphylloides/pittosporum adaphniphylloides (2).jpg',
          width: 990,
          id: '8a59a46908b38f63c0d66b0438cf9b43',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 102, 81, 1.00)',
            'rgba(116, 131, 98, 1.00)',
            'rgba(87, 100, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pittosporum [pittosporaceae]/pittosporum adaphniphylloides/pittosporum adaphniphylloides (1).jpg',
          width: 1024,
          id: '9b463c37afc208be719f0ab5dd6e9e35',
          height: 683,
          thumbnail: true,
        },
        location: [47.271306, -1.584339],
        genre: 'Pittosporum',
        famille: 'Pittosporaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584339, 47.271306] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6aa5b988bd984ac4bf8563ab41734fb2aac59097',
      fields: {
        origine: 'Botanical Garden University of Berne, Berne, Suisse',
        espece: 'lutea L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Digitalis',
        date_plantation: '2012',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '479f0daa18f8cc515519ab9d1d89bd9338e0c611',
      fields: {
        origine: 'J.Alp.U.Insbruck (Autriche)',
        espece: 'fruticosus Greene',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Penstemon',
        date_plantation: '2006',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '11f06283f7a6bf753624e8f542bbf8230c911785',
      fields: {
        origine: 'Jardin botanique Glasnevin',
        espece: 'trojana Ivan',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Digitalis',
        date_plantation: '2010',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1c434e0fe19aac513a06d74aca1b049513f017ab',
      fields: {
        origine: 'JB.Hokkaido (Japon)',
        espece: 'sibiricum Pennell',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Veronicastrum',
        date_plantation: '2009',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6b511abaaa665d321b9312e404ec47de60895997',
      fields: {
        origine: 'JB.Mich\u00e8le Tenore (Italie)',
        espece: 'ferruginea L.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Digitalis',
        date_plantation: '2004',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a98b173a4dd0fafc865c5d5ba539c2dc7ea913e7',
      fields: {
        origine: 'JB.Postdam (Allemagne)',
        espece: 'longifolium Opiz',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Pseudolysimachion',
        date_plantation: '2008',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '570e098cb28f673df2108a22a607daaf6e732480',
      fields: {
        origine: 'JB.Pruhonice (Rep.Tch\u00e8que)',
        espece: 'obscura  L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Digitalis',
        date_plantation: '2008',
        cultivar: 'obscura',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5d28b77f45cd09ba57821d9ef9febf9b13a7f13f',
      fields: {
        origine: 'J.Alp.U.Lautaret (Grenoble)',
        espece: 'alliacea Hoffamanns.& Link',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Armeria',
        date_plantation: '2004',
        famille: 'Plumbaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0fe535d42fd2dac3ad543dda8adc6cae0c3d8bb7',
      fields: {
        origine: 'MNHN Paris (Fr.)',
        espece: 'confusum Fourr.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Limonium',
        date_plantation: '2014',
        famille: 'Plumbaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fcd55b124f60c107892e121fb1b4fa88b9601587',
      fields: {
        origine: 'B.G. der Stadt Linz (Autriche)',
        espece: 'alpina L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Poa',
        date_plantation: '2015',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '66bfba927612b0218aff7d74430791774d11ab7d',
      fields: {
        origine: 'JB.Surrey (Angleterre)',
        espece: 'trichodes Alph. Wood',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Eragrostis',
        date_plantation: '2008',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9da087617eaca5dfc60fb200c6719df5ff836a19',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes 71290 La Gen\u00eate',
        espece: 'affinis Greene',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Bistorta',
        date_plantation: '2015',
        famille: 'Polygonaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '120420bae27eb0b6abdc8a2662c9bd5887e0f84a',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale (Nantes)',
        espece: 'complexa Meissn.',
        localisation: 'I4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2186346, -1.541674],
        genre: 'Muehlenbeckia',
        date_plantation: '1989',
        famille: 'Polygonaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541674, 47.2186346] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '31b0a582fca8616e301064a0675a7b126273d174',
      fields: {
        origine: 'JB.Weinheim (Allemagne)',
        espece: 'barystachys Bunge.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Lysimachia',
        date_plantation: '2001',
        famille: 'Primulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '537d87b3404f1335d9f7246d05640515012b3b57',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'myricoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 161, 122, 1.00)',
            'rgba(106, 115, 59, 1.00)',
            'rgba(132, 124, 96, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lomatia [proteaceae]/lomatia myricoides/lomatia myricoides (3).jpg',
          width: 1024,
          id: '9fdf6d244dfa23ff44f149d1d9cd7220',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 122, 55, 1.00)',
            'rgba(131, 145, 86, 1.00)',
            'rgba(92, 111, 45, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lomatia [proteaceae]/lomatia myricoides/lomatia myricoides (4).jpg',
          width: 618,
          id: 'b9897a6f5e4ae5d9e1f3193b9c78049c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 128, 60, 1.00)',
            'rgba(139, 148, 74, 1.00)',
            'rgba(145, 151, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lomatia [proteaceae]/lomatia myricoides/lomatia myricoides (2).jpg',
          width: 576,
          id: '5ffac1c0151e81f6246bb283c80228dc',
          height: 768,
          thumbnail: true,
        },
        location: [47.271863, -1.58213],
        genre: 'Lomatia',
        famille: 'Proteaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58213, 47.271863] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '200f44125a5d6658792d316867ace81153410624',
      fields: {
        origine: 'Amur Branch of B.G. (Russie)',
        espece: 'ussuriense Luferov',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Thalictrum',
        date_plantation: '2014',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5fbe41c4b8418ff871cf0b0894f0d323866e2cf0',
      fields: {
        origine: 'J.B. Bayreuth (Allemagne)',
        espece: 'zimmermannii Soo',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Pulsatilla',
        date_plantation: '2011',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9f64a9536dfbdb63b20dced884f9e44705b8cefc',
      fields: {
        origine: 'JB.Chemnitz (Allemagne)',
        espece: 'multifida Poiret',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Anemone',
        date_plantation: '2009',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '26f909b3b4bb6aab977975e6515adcbebfe613a1',
      fields: {
        origine: 'JB.Framingham (USA)',
        espece: 'fendleri Engelm.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Thalictrum',
        date_plantation: '1988',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bc423f107b46f3042e4f4d01723aacb33bbbc599',
      fields: {
        origine: 'JB.Graz (Autriche)',
        espece: 'einseleana F.W.Schultz.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Aquilegia',
        date_plantation: '2006',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd1a4a95893e034f622edde470217085d11d9f44c',
      fields: {
        origine: 'JB.Ibaraki (Japon)',
        espece: 'minus  L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Thalictrum',
        date_plantation: '2008',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a37e8beb6030994f536e3663eca7f1fb72a47d8e',
      fields: {
        origine: 'JB.Yakut (Russie)',
        espece: 'barbatum Patr. ex Pers.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Aconitum',
        date_plantation: '2004',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1623e4e96a4e007f16f89e2a82f741c9eaa42c24',
      fields: {
        origine: 'JBU.Fribourg (Suisse)',
        espece: 'alpinum L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Thalictrum',
        date_plantation: '1987',
        cultivar: 'aureum Archangeli',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c3d19bee2030b4abdfa873f34129f55e8e28d68b',
      fields: {
        origine: 'P\u00e9pini\u00e8res E.Lepage',
        espece: 'palustris L.',
        localisation: 'G1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193375, -1.5415093],
        genre: 'Caltha',
        date_plantation: '1986',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5415093, 47.2193375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a0302b8253dea5c5ce2bbb4704f41a9771550cc0',
      fields: {
        origine: 'Arboretum Komarovii Perkalski (Russie)',
        espece: 'pallasii',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Rhamnus',
        date_plantation: '2015',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0e3d2fbd1c2499cbfb2d78b4347cc12bb19054d8',
      fields: {
        origine: 'Jardin Botanique Hanbury - La Mortola',
        espece: 'hystrix',
        localisation: 'A2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2208871, -1.5444631],
        genre: 'Colletia',
        date_plantation: '2013',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444631, 47.2208871] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd943616723929d240608ce4c8179c2a37f51b881',
      fields: {
        origine: 'P\u00e9pini\u00e8res Arven',
        espece: 'arborea',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Phylica',
        date_plantation: '2018',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c05ae209f6e92c734c9f9e8123ebca2b513ac090',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 131, 117, 1.00)',
            'rgba(139, 135, 139, 1.00)',
            'rgba(144, 134, 144, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus 'concha'/ceanothus 'concha' (2).jpg",
          width: 576,
          id: 'dece87d9c2891d226d6bb64ab4289735',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 114, 50, 1.00)',
            'rgba(121, 130, 109, 1.00)',
            'rgba(192, 170, 166, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus 'concha'/ceanothus 'concha' (3).jpg",
          width: 576,
          id: '6859a1b5a9bc73aa44ce60ecc5e0a2aa',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 132, 90, 1.00)',
            'rgba(142, 136, 125, 1.00)',
            'rgba(163, 149, 136, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus 'concha'/ceanothus 'concha' (1).jpg",
          width: 1024,
          id: 'c4b17cb4253b87f6064b53095370cb95',
          height: 768,
          thumbnail: true,
        },
        location: [47.27182, -1.587105],
        genre: 'Ceanothus',
        cultivar: 'Concha',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587105, 47.27182] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ee54a82289cb8a8136660e3d43b66f92a97ba48d',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'thyrsiflorus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 121, 86, 1.00)',
            'rgba(105, 120, 117, 1.00)',
            'rgba(105, 120, 114, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus thyrsiflorus/ceanothus thyrsiflorus (2).jpg',
          width: 572,
          id: 'd873ff4754eeca4fdd7a1f9da055d4af',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 124, 63, 1.00)',
            'rgba(117, 154, 86, 1.00)',
            'rgba(138, 172, 100, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus thyrsiflorus/ceanothus thyrsiflorus (3).jpg',
          width: 576,
          id: '1aad56fdf34f53e16baf43bfdfce741c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 135, 118, 1.00)',
            'rgba(85, 105, 77, 1.00)',
            'rgba(69, 94, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus thyrsiflorus/ceanothus thyrsiflorus (1).jpg',
          width: 1024,
          id: '27b57c84c3c6aa3bb84c86a69d6ed631',
          height: 768,
          thumbnail: true,
        },
        location: [47.27145, -1.584792],
        genre: 'Ceanothus',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584792, 47.27145] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f05f696dfc531b03905d6465141790fbaf42d8be',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x logan',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 102, 45, 1.00)',
            'rgba(88, 134, 51, 1.00)',
            'rgba(102, 135, 92, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus x logan/ceanothus x logan (3).jpg',
          width: 518,
          id: 'e32672b06b041e09f4012cee9b90e04a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 120, 108, 1.00)',
            'rgba(124, 125, 135, 1.00)',
            'rgba(105, 105, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus x logan/ceanothus x logan (4).jpg',
          width: 576,
          id: '6c4461707c0892f4bbe359624b7f1ccb',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(167, 170, 144, 1.00)',
            'rgba(116, 122, 87, 1.00)',
            'rgba(106, 111, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus x logan/ceanothus x logan (1).jpg',
          width: 1024,
          id: 'ed25eb228c7573e97365bba85a47f27e',
          height: 768,
          thumbnail: true,
        },
        location: [47.271392, -1.581925],
        genre: 'Ceanothus',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581925, 47.271392] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bdaab00a2950466387e5d7b1d12ebfed7708fdda',
      fields: {
        origine: 'Collect. priv\u00e9e Pascal Prieur',
        espece: 'alabamensis',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Neviusia',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4debceb9d7ab4828765cfbe724914d8f50485147',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'canescens',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        cultivar: 'Myrtifolia',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dfc253cdfc23743070907aea09632101d3819238',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'douglasii',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        cultivar: 'menziesii',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a65915db91fc1a1ff1225626c2d0406197680259',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'media',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fa1a53b1a623a8060d5d71e538dd770e1fe4f0c3',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'miyabei',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '46b39f1a258bbda6bbd8efd5152892fe4b181bf2',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'X notha',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '246f8811af455149ce965a79cbda7c9f54fae4db',
      fields: {
        origine: 'J.B. Nitra (Slovaquie)',
        espece: 'hippiana Lehm.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Potentilla',
        date_plantation: '2011',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '15f357087f037d35113072a30f97a381e472f16c',
      fields: {
        origine:
          'JB Lyon - origine sauvage connue\u00a0: Col de Vergio (Corse)',
        espece: 'serafinii',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Rosa',
        date_plantation: '2012',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2d3f329dda388be3d2afec57006815abd3df37d9',
      fields: {
        origine: 'JB. Leipzig, Leipzig (Allemagne)',
        espece: 'fissistipula Bitter',
        localisation: 'G2A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Acaena',
        date_plantation: '2011',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2443f66b0497a2a23d407ebca1d3979654a6e63b',
      fields: {
        origine: 'JB.Hiroshima (Japon)',
        espece: 'thunbergii Miq.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Astilbe',
        date_plantation: '2006',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'eb6205dd1dcab6f60228ede895e0a3a8b388cdb9',
      fields: {
        origine: 'JB.Montr\u00e9al (Canada)',
        espece: 'virginiana Duchesne',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Fragaria',
        date_plantation: '1996',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e460f1445f3d2be5b458787a0bdfc54ebf2cbf09',
      fields: {
        origine: 'Les Ponts de C\u00e9_p\u00e9pini\u00e8re Lepage',
        espece: 'obtusa Maxim.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Sanguisorba',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'eaac643cadb4f6f14df2d35f69cfd7a9611bb146',
      fields: {
        espece: 'x prunifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 118, 103, 1.00)',
            'rgba(152, 120, 111, 1.00)',
            'rgba(153, 126, 118, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aronia [rosaceae]/aronia x prunifolia/aronia x prunifolia (2).jpg',
          width: 576,
          id: 'c077df2a8205f01f4dd225cc87a2b107',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 147, 114, 1.00)',
            'rgba(114, 119, 103, 1.00)',
            'rgba(99, 99, 90, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aronia [rosaceae]/aronia x prunifolia/aronia x prunifolia (1).jpg',
          width: 689,
          id: '77cf425fd8eb898cb74d1a5f4a450ba5',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Aronia',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '968fbec43c37f9d650ea572f686721ff3e06728f',
      fields: {
        espece: 'x superba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 93, 60, 1.00)',
            'rgba(166, 105, 70, 1.00)',
            'rgba(68, 46, 33, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/chaenomeles [rosaceae]/chaenomeles x superba 'cameo'/chaenomeles x superba 'cameo' (4).jpg",
          width: 1024,
          id: '146f121559ddbe43afabae861807ca17',
          height: 682,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 97, 60, 1.00)',
            'rgba(113, 99, 48, 1.00)',
            'rgba(91, 77, 42, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/chaenomeles [rosaceae]/chaenomeles x superba 'cameo'/chaenomeles x superba 'cameo' (2).jpg",
          width: 1024,
          id: 'aad8cac26dbea0914aa3b556f582afc3',
          height: 683,
          thumbnail: true,
        },
        location: [47.270297, -1.581378],
        genre: 'Chaenomeles',
        cultivar: 'Cameo',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581378, 47.270297] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '80f6b0740bd14ca0a0b8421973b0134db8316217',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'trilobata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 111, 82, 1.00)',
            'rgba(129, 136, 109, 1.00)',
            'rgba(57, 73, 31, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/malus [rosaceae]/malus trilobata/malus trilobata (2).jpg',
          width: 576,
          id: 'aa7925d9fa1ff35eec4c24b98f652d7c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 138, 111, 1.00)',
            'rgba(126, 134, 89, 1.00)',
            'rgba(111, 95, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/malus [rosaceae]/malus trilobata/malus trilobata (3).jpg',
          width: 576,
          id: '10ff3bd7ab578ba90263d6ad3792226c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 160, 108, 1.00)',
            'rgba(137, 157, 106, 1.00)',
            'rgba(103, 101, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/malus [rosaceae]/malus trilobata/malus trilobata (1).jpg',
          width: 576,
          id: '33d726ebbc07d896517b916d5dfedc5d',
          height: 768,
          thumbnail: true,
        },
        location: [47.271028, -1.585303],
        genre: 'Malus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585303, 47.271028] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '97a5fcf3c3c0cadd5267d381af7dc381d232d6ab',
      fields: {
        espece: 'serratifolia',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 126, 108, 1.00)',
            'rgba(112, 107, 82, 1.00)',
            'rgba(91, 101, 85, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/photinia [rosaceae]/photinia serratifolia/photinia serratifolia .jpg',
          width: 1024,
          id: '74b405d668f47b024e9e9e6c7fb0bc0c',
          height: 683,
          thumbnail: true,
        },
        location: [47.270213, -1.581447],
        genre: 'Photinia',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581447, 47.270213] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4a21d20f1ae454ac764f78ad7c691e65607ac601',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 92, 64, 1.00)',
            'rgba(107, 98, 75, 1.00)',
            'rgba(101, 101, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/photinia [rosaceae]/photinia x fraseri 'red robin'/photinia x fraseri 'red robin' (6).jpg",
          width: 1024,
          id: 'fe982279a01cd33f56762c75184c0b6b',
          height: 683,
          thumbnail: true,
        },
        espece: 'x fraseri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 128, 101, 1.00)',
            'rgba(133, 122, 84, 1.00)',
            'rgba(140, 137, 105, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/photinia [rosaceae]/photinia x fraseri 'red robin'/photinia x fraseri 'red robin' (2).jpg",
          width: 576,
          id: '6ab1d32549b585e4f27a60c4f88dd6c0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 103, 65, 1.00)',
            'rgba(111, 135, 80, 1.00)',
            'rgba(80, 104, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/photinia [rosaceae]/photinia x fraseri 'red robin'/photinia x fraseri 'red robin' (1).jpg",
          width: 576,
          id: '61eb1da953e5cea231cde3924c282ecc',
          height: 768,
          thumbnail: true,
        },
        location: [47.270197, -1.585792],
        genre: 'Photinia',
        cultivar: 'Red Robin',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585792, 47.270197] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a390765f89dee91343b3943fdfed64e9c3097e3a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 112, 89, 1.00)',
            'rgba(163, 131, 151, 1.00)',
            'rgba(96, 85, 74, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'kanzan'/prunus 'kanzan' (2).jpg",
          width: 576,
          id: '34fa3242c5ce67d9729645d5e4b55804',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 142, 119, 1.00)',
            'rgba(138, 149, 100, 1.00)',
            'rgba(90, 104, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'kanzan'/prunus 'kanzan' (3).jpg",
          width: 576,
          id: '9f85f202f9d3fbd07c389ca346f59ab1',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 134, 109, 1.00)',
            'rgba(145, 122, 123, 1.00)',
            'rgba(85, 76, 67, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'kanzan'/prunus 'kanzan' (1).jpg",
          width: 576,
          id: 'a281ef948c1c88f557465424673d7a44',
          height: 768,
          thumbnail: true,
        },
        location: [47.271088, -1.585903],
        genre: 'Prunus',
        cultivar: 'Kanzan',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585903, 47.271088] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5a75cc187f2d69693e6553bdf9686cbdb5b141d0',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 128, 139, 1.00)',
            'rgba(107, 106, 98, 1.00)',
            'rgba(69, 67, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'tai-haku'/prunus 'tai-haku' (4).jpg",
          width: 1024,
          id: 'f1b82f1971884c0fadff967d9b04c19f',
          height: 683,
          thumbnail: true,
        },
        location: [47.270242, -1.585097],
        genre: 'Prunus',
        cultivar: 'Tai-haku',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585097, 47.270242] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6b43e6a5503ec3d802c198cf08937dcb8e356f6f',
      fields: {
        espece: 'glandulosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 79, 53, 1.00)',
            'rgba(142, 146, 136, 1.00)',
            'rgba(103, 97, 93, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/prunus [rosaceae]/prunus glandulosa/prunus glandulosa .jpg',
          width: 576,
          id: '8e761517edd1ea82784f03369bed3fd7',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 131, 124, 1.00)',
            'rgba(148, 149, 139, 1.00)',
            'rgba(92, 84, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/prunus [rosaceae]/prunus glandulosa/prunus glandulosa (1).jpg',
          width: 1024,
          id: '0c94bffe55265af5a6f9db3c98735722',
          height: 768,
          thumbnail: true,
        },
        location: [47.271053, -1.584688],
        genre: 'Prunus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584688, 47.271053] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2e0f98f6558390317c1adff1dc4a3954018df69f',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 118, 112, 1.00)',
            'rgba(110, 102, 85, 1.00)',
            'rgba(83, 69, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus incisa 'february pink'/prunus incisa 'february pink' (3).jpg",
          width: 1024,
          id: 'cb1f85a04c83b36bbb6ab9390fe023dc',
          height: 683,
          thumbnail: true,
        },
        espece: 'incisa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(177, 173, 161, 1.00)',
            'rgba(117, 108, 81, 1.00)',
            'rgba(95, 74, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus incisa 'february pink'/prunus incisa 'february pink' (2).jpg",
          width: 512,
          id: '81df1e112a7d3c8566dd482ce1b49a7b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 130, 120, 1.00)',
            'rgba(127, 114, 105, 1.00)',
            'rgba(123, 104, 93, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus incisa 'february pink'/prunus incisa 'february pink' (1).jpg",
          width: 1024,
          id: '033ef472ecf26754a222c937f96af63b',
          height: 683,
          thumbnail: true,
        },
        location: [47.27133, -1.582383],
        genre: 'Prunus',
        cultivar: 'February Pink',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582383, 47.27133] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a3332af17a587e8e010b55661235fe2cb498f14d',
      fields: {
        espece: 'x yedoensis',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 160, 135, 1.00)',
            'rgba(99, 96, 39, 1.00)',
            'rgba(89, 92, 43, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus x yedoensis 'ivensii'/prunus x yedoensis 'ivensii' (4).jpg",
          width: 1024,
          id: 'da25d4681c9956bf0cd1c8adc39158bf',
          height: 768,
          thumbnail: true,
        },
        location: [47.269892, -1.581597],
        genre: 'Prunus',
        cultivar: 'Ivensii',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581597, 47.269892] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ef5a507e4705c73d3b833dba26b1d7651dd66a0c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'betulifolia var. aemiliana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 155, 60, 1.00)',
            'rgba(101, 144, 66, 1.00)',
            'rgba(117, 142, 84, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea betulifolia var. aemiliana/spiraea betulifolia var. aemiliana (2).jpg',
          width: 576,
          id: 'bb52f4412be1f5b8e259508c80a3bc89',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 158, 53, 1.00)',
            'rgba(108, 156, 62, 1.00)',
            'rgba(82, 118, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea betulifolia var. aemiliana/spiraea betulifolia var. aemiliana (3).jpg',
          width: 576,
          id: '66299ffb7bd708b7dee04bc32debe41e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 199, 111, 1.00)',
            'rgba(86, 124, 53, 1.00)',
            'rgba(54, 86, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea betulifolia var. aemiliana/spiraea betulifolia var. aemiliana (1).jpg',
          width: 572,
          id: '77109de7272c59e29b78d03c2870244c',
          height: 768,
          thumbnail: true,
        },
        location: [47.27072, -1.582395],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582395, 47.27072] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '60a846769bd27f4fa389ed121dc42b8410971539',
      fields: {
        espece: 'nipponica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 110, 34, 1.00)',
            'rgba(102, 126, 76, 1.00)',
            'rgba(38, 64, 10, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea nipponica 'halward's silver'/spiraea nipponica 'halward's silver' (2).jpg",
          width: 576,
          id: 'd531b77f90ad19abd15d75b1293a2cd2',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 147, 33, 1.00)',
            'rgba(111, 162, 45, 1.00)',
            'rgba(85, 123, 23, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea nipponica 'halward's silver'/spiraea nipponica 'halward's silver' (1).jpg",
          width: 576,
          id: '6dc6ea245c773b16212d3b7be6be3064',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Spiraea',
        cultivar: "Halward's Silver",
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2228e04ff8f280ee90cae3e62bbfd689dfe4a84b',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 164, 119, 1.00)',
            'rgba(109, 132, 76, 1.00)',
            'rgba(101, 122, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea salicifolia 'carnea'/spiraea salicifolia 'carnea'  (3).jpg",
          width: 1024,
          id: '8766db7437f3f67d8f5acc4a85aba7af',
          height: 768,
          thumbnail: true,
        },
        espece: 'salicifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 100, 72, 1.00)',
            'rgba(127, 118, 102, 1.00)',
            'rgba(86, 94, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea salicifolia 'carnea'/spiraea salicifolia 'carnea'  (2).jpg",
          width: 576,
          id: '9b5b40addafabd2d988643134a0a5b0c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 133, 80, 1.00)',
            'rgba(128, 165, 108, 1.00)',
            'rgba(93, 125, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea salicifolia 'carnea'/spiraea salicifolia 'carnea'  (1).jpg",
          width: 474,
          id: 'a698488d145e3bc7098d41e2efadaa7c',
          height: 768,
          thumbnail: true,
        },
        location: [47.2712, -1.584222],
        genre: 'Spiraea',
        cultivar: 'Carnea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584222, 47.2712] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1077796b86cb1be2f61e2a2eddffe9b693b932cb',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 117, 82, 1.00)',
            'rgba(114, 114, 77, 1.00)',
            'rgba(107, 112, 63, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea thunbergii 'fugino'/spiraea thunbergii 'fugino' (9).jpg",
          width: 1024,
          id: '8338e42a1eb7efd6c8fa5083730e4eb4',
          height: 683,
          thumbnail: true,
        },
        espece: 'thunbergii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 99, 61, 1.00)',
            'rgba(104, 106, 70, 1.00)',
            'rgba(86, 86, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea thunbergii 'fugino'/spiraea thunbergii 'fugino' (12).jpg",
          width: 1024,
          id: 'a6d34e3271d7299cd91db14ea92525e0',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 142, 119, 1.00)',
            'rgba(117, 116, 69, 1.00)',
            'rgba(102, 94, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea thunbergii 'fugino'/spiraea thunbergii 'fugino' (11).jpg",
          width: 1024,
          id: '7b67358bd5e8bd1ef48c2fda1ce77acc',
          height: 683,
          thumbnail: true,
        },
        location: [47.271437, -1.584288],
        genre: 'Spiraea',
        cultivar: 'Fugino',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584288, 47.271437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd4d19cea1450cf65027a224b7a48e3b6f0791f13',
      fields: {
        origine: 'Arboretum Keracoual (22)',
        espece: 'armatum',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Zanthoxylum',
        date_plantation: '2013',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3d4b10206c67b6171b8b6bfacaf7577d9c7996e1',
      fields: {
        origine: 'Conservatoire botanique de Gen\u00e8ve (Suisse)',
        espece: 'montana Mill.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Ruta',
        date_plantation: '2011',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd719423fe4043eea3413ff8a96048c4c35c52d0d',
      fields: {
        espece: 'ternata',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Choisya',
        date_plantation: '1973',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dedfa685f1729f67915ba7ef5420ee80aaba5876',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'backhouseana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 143, 107, 1.00)',
            'rgba(109, 135, 100, 1.00)',
            'rgba(78, 102, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/correa [rutaceae]/correa backhouseana/correa backhouseana (2).jpg',
          width: 576,
          id: '2cf5eaa52a7aeda4fcf79c3eb6d9447b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 126, 96, 1.00)',
            'rgba(104, 128, 92, 1.00)',
            'rgba(72, 96, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/correa [rutaceae]/correa backhouseana/correa backhouseana (3).jpg',
          width: 576,
          id: '1309a704b6aad46847fbd09f90cb8513',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 118, 84, 1.00)',
            'rgba(124, 149, 117, 1.00)',
            'rgba(91, 116, 82, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/correa [rutaceae]/correa backhouseana/correa backhouseana (1).jpg',
          width: 576,
          id: 'f0484404257c19237fcb8a2611fe31a7',
          height: 768,
          thumbnail: true,
        },
        location: [47.270005, -1.584558],
        genre: 'Correa',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584558, 47.270005] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c63ba7cd764af60b527f40da4577462194b7b584',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 91, 39, 1.00)',
            'rgba(108, 119, 66, 1.00)',
            'rgba(96, 108, 42, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/skimmia [rutaceae]/skimmia japonica 'olympic flame'/skimmia japonica 'olympic flame' (2).jpg",
          width: 576,
          id: 'faef4ac128f4e093ac839f635a78e72e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(61, 88, 33, 1.00)',
            'rgba(128, 83, 47, 1.00)',
            'rgba(107, 103, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/skimmia [rutaceae]/skimmia japonica 'olympic flame'/skimmia japonica 'olympic flame' (1).jpg",
          width: 576,
          id: '2dc8e2387cd742218358e5f791bf3cb2',
          height: 768,
          thumbnail: true,
        },
        location: [47.270953, -1.582083],
        genre: 'Skimmia',
        cultivar: 'Olympic Flame',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582083, 47.270953] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e333bf26918cc3c9440eb4d3c9ee5bbf400e4818',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'simulans',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(180, 196, 183, 1.00)',
            'rgba(84, 98, 53, 1.00)',
            'rgba(79, 89, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/zanthoxylum [rutaceae]/zanthoxylum simulans/zanthoxylum simulans (2).jpg',
          width: 576,
          id: 'ff3fcba63675a67f846916c607d6ba21',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 143, 76, 1.00)',
            'rgba(140, 140, 59, 1.00)',
            'rgba(110, 131, 40, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/zanthoxylum [rutaceae]/zanthoxylum simulans/zanthoxylum simulans (3).jpg',
          width: 576,
          id: '09d092eecf71f3cc4b0d5953a17905c0',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 146, 103, 1.00)',
            'rgba(130, 151, 91, 1.00)',
            'rgba(127, 130, 85, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/zanthoxylum [rutaceae]/zanthoxylum simulans/zanthoxylum simulans (1).jpg',
          width: 576,
          id: '7f2e02eab1f83326f25c086f43302cb6',
          height: 768,
          thumbnail: true,
        },
        location: [47.269688, -1.581795],
        genre: 'Zanthoxylum',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581795, 47.269688] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8d88ab69342d9c4c3ce8728cb64c675a58c1e947',
      fields: {
        espece: 'koreana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 137, 153, 1.00)',
            'rgba(114, 129, 83, 1.00)',
            'rgba(100, 88, 51, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/populus [salicaceae]/populus koreana/populus koreana (2).jpg',
          width: 512,
          id: 'f7815464782380df4247dd61b297cc1c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 118, 50, 1.00)',
            'rgba(107, 127, 58, 1.00)',
            'rgba(114, 119, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/populus [salicaceae]/populus koreana/populus koreana (1).jpg',
          width: 1024,
          id: 'ca47bec3e58c04bc61f26ff76e0545fa',
          height: 683,
          thumbnail: true,
        },
        location: [47.271903, -1.582417],
        genre: 'Populus',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582417, 47.271903] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a4a048508c2090a88ac3e3c5709096ed868dd726',
      fields: {
        origine: 'P\u00e9pini\u00e8re  Arven',
        espece: 'sorbifolium',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Xanthoceras',
        date_plantation: '2016',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c97f285dac5a69a87245190fd0c624f422fdfdb9',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'carpinifolium',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 103, 74, 1.00)',
            'rgba(127, 108, 67, 1.00)',
            'rgba(115, 99, 64, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer carpinifolium/acer carpinifolium (10).jpg',
          width: 1024,
          id: 'e1a426ee16f567012f6f6c6a398d25c9',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(200, 188, 157, 1.00)',
            'rgba(119, 105, 48, 1.00)',
            'rgba(72, 74, 45, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer carpinifolium/acer carpinifolium (11).jpg',
          width: 547,
          id: '0200e44a0a00a87ea70ed1abc1d79222',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 140, 115, 1.00)',
            'rgba(115, 131, 96, 1.00)',
            'rgba(76, 105, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer carpinifolium/acer carpinifolium (1).jpg',
          width: 576,
          id: 'e6fb649c92165344af22b83b7bfe0561',
          height: 768,
          thumbnail: true,
        },
        location: [47.270955, -1.581642],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581642, 47.270955] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '901d21bb2de981c1bf31e1cc5adafbd213475417',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'carpinifolium',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 85, 74, 1.00)',
            'rgba(139, 120, 81, 1.00)',
            'rgba(104, 83, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer carpinifolium/acer carpinifolium (13).jpg',
          width: 1024,
          id: '0b866e4024d079d2a3d1dfc53c7a68df',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 88, 50, 1.00)',
            'rgba(136, 107, 60, 1.00)',
            'rgba(103, 83, 25, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer carpinifolium/acer carpinifolium (14).jpg',
          width: 1024,
          id: 'c4c656d264e5ef7cb4e89d5891ad19a6',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 86, 45, 1.00)',
            'rgba(121, 99, 65, 1.00)',
            'rgba(104, 89, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer carpinifolium/acer carpinifolium (12).jpg',
          width: 1024,
          id: 'e31a7832231cb495ef06d07add3bbfd7',
          height: 683,
          thumbnail: true,
        },
        location: [47.270956, -1.581642],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581642, 47.270956] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd510f4559b2b47f7564bea659623fbf7f628c849',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'paxii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 128, 63, 1.00)',
            'rgba(134, 127, 74, 1.00)',
            'rgba(134, 131, 77, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer paxii/acer paxii (2).jpg',
          width: 576,
          id: '09b1a0dcbf5c96b3e78ebccdcbbb1b81',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 99, 60, 1.00)',
            'rgba(147, 157, 112, 1.00)',
            'rgba(107, 114, 71, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer paxii/acer paxii (3).jpg',
          width: 601,
          id: '50951e1822f51396128e960110856bbf',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 110, 59, 1.00)',
            'rgba(125, 139, 78, 1.00)',
            'rgba(126, 131, 74, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer paxii/acer paxii (1).jpg',
          width: 576,
          id: '51acf337df1bf9419de7a71f19135aa2',
          height: 768,
          thumbnail: true,
        },
        location: [47.271345, -1.587175],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587175, 47.271345] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd69d005d312e30c8a474506b4a9bee1ddfb48666',
      fields: {
        espece: 'platanoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 129, 66, 1.00)',
            'rgba(134, 152, 90, 1.00)',
            'rgba(70, 86, 32, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer platanoides 'drummondii'/acer platanoides 'drummondii' (2).jpg",
          width: 576,
          id: 'b9d13e0ced06b2ab0553d6ca82d0ac72',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 190, 207, 1.00)',
            'rgba(162, 165, 116, 1.00)',
            'rgba(86, 86, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer platanoides 'drummondii'/acer platanoides 'drummondii' (1).jpg",
          width: 576,
          id: '4a3246e2516c34835c57a9cf1f317364',
          height: 768,
          thumbnail: true,
        },
        location: [47.270988, -1.584945],
        genre: 'Acer',
        cultivar: 'Drummondii',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584945, 47.270988] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '04b8ccce628a00959e5b13399c7258487be1bb38',
      fields: {
        espece: 'pseudoplatanus',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(193, 204, 168, 1.00)',
            'rgba(81, 98, 32, 1.00)',
            'rgba(81, 82, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer pseudoplatanus 'worley'/acer pseudoplatanus 'worley'.jpg",
          width: 634,
          id: '0f6cd8771b42f28671ebcd5ff33e2e7e',
          height: 768,
          thumbnail: true,
        },
        location: [47.269972, -1.581422],
        genre: 'Acer',
        cultivar: 'Worley',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581422, 47.269972] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '00a6f578b6cdc2959fc2f9b6191ae5cebb2284e6',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'rubrum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 132, 157, 1.00)',
            'rgba(132, 104, 70, 1.00)',
            'rgba(123, 86, 32, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer rubrum/acer rubrum (10).jpg',
          width: 512,
          id: '4b58594bae2fe7cc3c5c45a5297db9fb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(175, 179, 192, 1.00)',
            'rgba(142, 120, 71, 1.00)',
            'rgba(45, 40, 17, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer rubrum/acer rubrum (11).jpg',
          width: 572,
          id: 'ac3bc9363d933de6ae89be8d2fbb1845',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 99, 59, 1.00)',
            'rgba(135, 155, 121, 1.00)',
            'rgba(105, 110, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer rubrum/acer rubrum (1).jpg',
          width: 576,
          id: '99df57568bda485f56deb4384352d6cb',
          height: 768,
          thumbnail: true,
        },
        location: [47.270433, -1.581858],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581858, 47.270433] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '83e75421a46b82dc3c85dbdebba28739f3c01285',
      fields: {
        espece: 'griseum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 141, 133, 1.00)',
            'rgba(117, 111, 75, 1.00)',
            'rgba(123, 115, 61, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/acer [sapindaceae]/acer griseum/acer griseum.jpg',
          width: 623,
          id: '7bffd123ed773a0841d6303e04ef64fa',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 100, 76, 1.00)',
            'rgba(102, 114, 78, 1.00)',
            'rgba(99, 107, 77, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/acer [sapindaceae]/acer griseum/acer griseum (2).jpg',
          width: 1024,
          id: '4e951a6b5bd2bf48fe3e0b26e768a708',
          height: 683,
          thumbnail: true,
        },
        location: [47.26165, -1.533305],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533305, 47.26165] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '28e84c4e4c54444fd769352db8facb3e31a8ac73',
      fields: {
        espece: 'saccharinum',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 143, 131, 1.00)',
            'rgba(150, 132, 122, 1.00)',
            'rgba(139, 127, 117, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/acer [sapindaceae]/acer saccharinum/acer saccharinum (2).jpg',
          width: 576,
          id: '297b85cf178348c796afc6489d0a4ccd',
          height: 768,
          thumbnail: true,
        },
        location: [47.261497, -1.532772],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532772, 47.261497] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dd2f9011ae34895a315cc36266ab97ec40c6de32',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 126, 48, 1.00)',
            'rgba(114, 159, 75, 1.00)',
            'rgba(93, 130, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus hippocastanum 'monstrosa'/aesculus hippocastanum 'monstrosa' (3).jpg",
          width: 576,
          id: 'd87621db4fdb7d139e8510a092d4edea',
          height: 768,
          thumbnail: true,
        },
        espece: 'hippocastanum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(167, 163, 147, 1.00)',
            'rgba(121, 100, 89, 1.00)',
            'rgba(95, 80, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus hippocastanum 'monstrosa'/aesculus hippocastanum 'monstrosa' (2).jpg",
          width: 1024,
          id: 'c78079e9a15230fab24deb95b9b8f2b4',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 158, 55, 1.00)',
            'rgba(127, 166, 52, 1.00)',
            'rgba(75, 109, 31, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus hippocastanum 'monstrosa'/aesculus hippocastanum 'monstrosa' (1).jpg",
          width: 576,
          id: '18c7cca8085755ed5b15357dfde1da14',
          height: 768,
          thumbnail: true,
        },
        location: [47.271372, -1.586655],
        genre: 'Aesculus',
        cultivar: 'Monstrosa',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586655, 47.271372] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '29c272be78529f2b38051c37d01f23f77951928b',
      fields: {
        origine: 'JB.Hokka\u00efdo (Japon)',
        espece: 'arguta',
        localisation: 'A12',
        nom_du_site: 'Jardin des Plantes',
        location: [47.22098, -1.5430278],
        genre: 'Actinidia',
        date_plantation: '1995',
        cultivar: 'platyphyllos',
        famille: 'Actinidiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5430278, 47.22098] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2d65a05109f5fd74c8794a0a24e7300a03ae019e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'farreri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 104, 76, 1.00)',
            'rgba(140, 127, 117, 1.00)',
            'rgba(93, 78, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum farreri/viburnum farreri  (2).jpg',
          width: 576,
          id: '108552271026b6898bd4e03129e68ef4',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 142, 110, 1.00)',
            'rgba(137, 142, 125, 1.00)',
            'rgba(132, 142, 112, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum farreri/viburnum farreri (1).jpg',
          width: 576,
          id: '023c4a094cf2f1a7cbbe822aa2d78f74',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 105, 86, 1.00)',
            'rgba(140, 123, 119, 1.00)',
            'rgba(109, 97, 92, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum farreri/viburnum farreri  (1).jpg',
          width: 576,
          id: '1d77bd386166340a5ef5636dc3195a3d',
          height: 768,
          thumbnail: true,
        },
        location: [47.270308, -1.582537],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582537, 47.270308] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '134cba0e25b1fb29a1064200a6e667840e9286cf',
      fields: {
        espece: 'odoratissimum',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(198, 197, 198, 1.00)',
            'rgba(82, 95, 77, 1.00)',
            'rgba(74, 71, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum odoratissimum/viburnum odoratissimum .jpg',
          width: 512,
          id: '7d28c1b7d95e379bd2f843ae2e8a30ca',
          height: 768,
          thumbnail: true,
        },
        location: [47.270542, -1.581145],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581145, 47.270542] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '94c7d0731278208fc1f91d8bd21f519f8ac52cce',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 86, 54, 1.00)',
            'rgba(157, 161, 137, 1.00)',
            'rgba(144, 149, 124, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum opulus 'roseum'/viburnum opulus 'roseum' .jpg",
          width: 666,
          id: 'c66c37ef55e7249834a0c033e6b7da4c',
          height: 768,
          thumbnail: true,
        },
        espece: 'opulus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 144, 140, 1.00)',
            'rgba(190, 106, 135, 1.00)',
            'rgba(154, 74, 104, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum opulus 'roseum'/viburnum opulus 'roseum' (4).jpg",
          width: 576,
          id: 'cbcca1f45ed8dd997bd139f1e6e1a8c9',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 116, 98, 1.00)',
            'rgba(116, 91, 79, 1.00)',
            'rgba(91, 90, 77, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum opulus 'roseum'/viburnum opulus 'roseum' (2).jpg",
          width: 648,
          id: '66756eeab6a48665e869884ddf1449e7',
          height: 768,
          thumbnail: true,
        },
        location: [47.270483, -1.580578],
        genre: 'Viburnum',
        cultivar: 'Roseum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580578, 47.270483] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '629e64b4e88afdadf3c0558d2b3823974f42152e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'prunifolium',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 96, 142, 1.00)',
            'rgba(113, 77, 98, 1.00)',
            'rgba(99, 73, 95, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum prunifolium/viburnum prunifolium (2).jpg',
          width: 512,
          id: 'e5e1215b3d58b7fae39e90ada543fb4f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(44, 56, 27, 1.00)',
            'rgba(97, 110, 76, 1.00)',
            'rgba(79, 97, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum prunifolium/viburnum prunifolium (20).jpg',
          width: 1024,
          id: 'ec9bbd70cbed8378b77a4934903064a4',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 127, 72, 1.00)',
            'rgba(98, 115, 65, 1.00)',
            'rgba(51, 64, 34, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum prunifolium/viburnum prunifolium (17).jpg',
          width: 1024,
          id: '1810bc6abb8f42d3ecbb8838fcea8505',
          height: 683,
          thumbnail: true,
        },
        location: [47.270559, -1.58093],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58093, 47.270559] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '87cf49c148168e9433676b78e6c76feda98905fe',
      fields: {
        espece: 'x juddii',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 162, 144, 1.00)',
            'rgba(91, 99, 57, 1.00)',
            'rgba(88, 88, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x juddii/viburnum x juddii (5).jpg',
          width: 576,
          id: '8daddbe64bf01ce5ac364fada292a585',
          height: 768,
          thumbnail: true,
        },
        location: [47.271078, -1.585422],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585422, 47.271078] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd5a5023ffa5650b8ac927aafc04acecff06e131b',
      fields: {
        origine: 'Goteborg Botanical Garten,Goteborg,Su\u00e8de',
        espece: 'cantabricus',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Narcissus',
        date_plantation: '2013',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9dc23870656fc136b4d81bcd49a50e152cebc2f6',
      fields: {
        origine: 'JB G\u00f6teborg',
        espece: 'bulbocodium L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Narcissus',
        date_plantation: '2010',
        cultivar: 'var.pallidus Gattef.&Weiller',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f0fd6469a72ff2b929a1c9ff8668cab999831a0d',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'altaicum  Pall.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Allium',
        date_plantation: '2008',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '670d868b49a9e308ca37d83a1d42a3732547070d',
      fields: {
        origine: 'JB.Sverdlovsk (URSS)',
        espece: 'altaicum Pallas',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Allium',
        date_plantation: '1987',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b2d18c4d8852ec4954ebc73c393b0346f72da4d6',
      fields: {
        origine: 'JBU.Vitebsk (Bielorussie)',
        espece: 'sibericum L.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Allium',
        date_plantation: '2006',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ddef77dcc8533132e5cb30bd5026ba3d522e888f',
      fields: {
        origine: "Soci\u00e9t\u00e9 d'horticulture Graz (Autriche)",
        espece: 'assoanus Dufour',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Narcissus',
        date_plantation: '2010',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7481526ece85927da6af29cca325f5e39365a37b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'obovatus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 118, 78, 1.00)',
            'rgba(175, 120, 95, 1.00)',
            'rgba(149, 120, 95, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cotinus [anacardiaceae]/cotinus obovatus/cotinus obovatus (2).jpg',
          width: 576,
          id: '3f9e8fa1e2ce7d9d28f0487136abc389',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 177, 63, 1.00)',
            'rgba(124, 137, 42, 1.00)',
            'rgba(93, 113, 24, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cotinus [anacardiaceae]/cotinus obovatus/cotinus obovatus (4).jpg',
          width: 576,
          id: '66671e23468b5e07b80d0f752fcef949',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 166, 73, 1.00)',
            'rgba(123, 157, 51, 1.00)',
            'rgba(112, 140, 32, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cotinus [anacardiaceae]/cotinus obovatus/cotinus obovatus  (1).jpg',
          width: 576,
          id: '17c57c626f03bb1fd95c276501694606',
          height: 768,
          thumbnail: true,
        },
        location: [47.271283, -1.582433],
        genre: 'Cotinus',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582433, 47.271283] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0b40bde1bccb4289527c7039a1d42594c01affc2',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'lentiscus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 160, 109, 1.00)',
            'rgba(139, 140, 80, 1.00)',
            'rgba(116, 118, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pistacia [anacardiaceae]/pistacia lentiscus/pistacia lentiscus (1).jpg',
          width: 576,
          id: '8e28e153e817a20c0f17df5c2b8a55a6',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 145, 99, 1.00)',
            'rgba(134, 148, 90, 1.00)',
            'rgba(123, 124, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pistacia [anacardiaceae]/pistacia lentiscus/pistacia lentiscus (2).jpg',
          width: 576,
          id: 'ce4b5c995ac24c3edc2d485e4d5ca986',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 118, 51, 1.00)',
            'rgba(131, 126, 56, 1.00)',
            'rgba(109, 126, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pistacia [anacardiaceae]/pistacia lentiscus/pistacia lentiscus  (2).jpg',
          width: 576,
          id: 'be9cbc93588b3468273596e6d633555f',
          height: 768,
          thumbnail: true,
        },
        location: [47.271188, -1.584637],
        genre: 'Pistacia',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584637, 47.271188] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9a05f05f99b1ed44efca15ffb1bff02008e4f908',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'terebenthifolius',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 150, 63, 1.00)',
            'rgba(118, 155, 53, 1.00)',
            'rgba(106, 144, 41, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/schinus [anacardiaceae]/schinus terebenthifolius/schinus terebenthifolius (2).jpg",
          width: 576,
          id: '42ee4f35525792cfd3e078a9b4565431',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 135, 74, 1.00)',
            'rgba(103, 141, 67, 1.00)',
            'rgba(133, 147, 102, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/schinus [anacardiaceae]/schinus terebenthifolius/schinus terebenthifolius (3).jpg",
          width: 1024,
          id: '8fa603c6f149f9f15515eee1e4d6c123',
          height: 736,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 154, 63, 1.00)',
            'rgba(104, 149, 67, 1.00)',
            'rgba(84, 128, 49, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/schinus [anacardiaceae]/schinus terebenthifolius/schinus terebenthifolius (1).jpg",
          width: 576,
          id: '24a9df1def7a7337abf6f0cf24449e75',
          height: 768,
          thumbnail: true,
        },
        location: [47.226597, -1.51208],
        genre: 'Schinus',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.51208, 47.226597] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6872dbb9a503e239907086ca1b357202b47adced',
      fields: {
        espece: 'triloba',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(197, 204, 181, 1.00)',
            'rgba(118, 131, 94, 1.00)',
            'rgba(62, 67, 45, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/asimina [annonaceae]/asimina triloba/asimina triloba.jpg",
          width: 576,
          id: '106e0a6ca5332c7d33da22c1a0a977bd',
          height: 768,
          thumbnail: true,
        },
        location: [47.226745, -1.51282],
        genre: 'Asimina',
        famille: 'Annonaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.51282, 47.226745] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e90e626a33fcb3840b95ac955b0a74287c3ec82b',
      fields: {
        origine: 'Botanischer Garten,Friedrich Jena, Jena, Allemagne',
        espece: 'bourgatii Gouan',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Eryngium',
        date_plantation: '2012',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '860050da67a2634b17d87acaa3f26504be3cc89a',
      fields: {
        origine: 'Botanischer Garten,Friedrich Jena, Jena, Allemagne',
        espece: 'pyrenaica Bourg.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Libanotis',
        date_plantation: '2012',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7144681331dca7e011dd6832274e6b847a77b2c2',
      fields: {
        origine: 'Im Eichholz B.G. Gruningen (Suisse)',
        espece: 'caucasicum Trautv.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Eryngium',
        date_plantation: '2014',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e5be1dccae67341d558498718a734a91bf66f10d',
      fields: {
        origine: 'J.Alp.U.Insbruck (Autriche)',
        espece: 'major L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Astrantia',
        date_plantation: '2006',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c9f86df3de63c86a0f1b239f2c53d1cff8807cb9',
      fields: {
        origine: 'Jardin botanique universit\u00e9 de Marie Curie - Lublin',
        espece: 'communis L.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Ferula',
        date_plantation: '2010',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9d85a8772b0c054bf12fb2c6ca46f5cb9aa8d719',
      fields: {
        origine: 'JB.Berkeley (USA)',
        espece: 'marilandica L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Sanicula',
        date_plantation: '2006',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c9b94b16f78d7e9a8ccdc72a4b729704d0c076d6',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'hultenii Fernald',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Ligusticum',
        date_plantation: '2009',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e21f02eae989d469d724c71cd79f1f74f9bdede3',
      fields: {
        origine: 'JBU.de Martin-Luther Amkirchtor (All.)',
        espece: 'lucidum Mill.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Ligusticum',
        date_plantation: '2004',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cda531bcd0249022191b21ae6fac56c03b75dbc4',
      fields: {
        espece: 'tricuspidatum L.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Eryngium',
        date_plantation: '1973',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd728f6f223a7a107761f0af32659ff9b12c5d19e',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 122, 65, 1.00)',
            'rgba(124, 140, 97, 1.00)',
            'rgba(146, 140, 128, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/nerium [apocynaceae]/nerium oleander 'rose soutenu'/nerium oleander 'rose soutenu' (3).jpg",
          width: 576,
          id: '2d3adc90e388d87e946312530ba3938b',
          height: 768,
          thumbnail: true,
        },
        espece: 'oleander',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 97, 63, 1.00)',
            'rgba(131, 121, 115, 1.00)',
            'rgba(58, 71, 37, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/nerium [apocynaceae]/nerium oleander 'rose soutenu'/nerium oleander 'rose soutenu' (2).jpg",
          width: 576,
          id: '01230dbbf9769a98ef6a449a4579e6fe',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 148, 87, 1.00)',
            'rgba(103, 130, 86, 1.00)',
            'rgba(126, 135, 100, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/nerium [apocynaceae]/nerium oleander 'rose soutenu'/nerium oleander 'rose soutenu' (1).jpg",
          width: 576,
          id: '21caeea870a7e1f9d8a052f55bcfb982',
          height: 768,
          thumbnail: true,
        },
        location: [47.271313, -1.584762],
        genre: 'Nerium',
        cultivar: 'Rose Soutenu',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584762, 47.271313] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e5717e0817b69bb0c9581967ac41633a41e08b71',
      fields: {
        espece: 'aquifolium',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 117, 98, 1.00)',
            'rgba(102, 115, 92, 1.00)',
            'rgba(117, 123, 101, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ilex [aquifoliaceae]/ilex aquifolium 'hastata'/ilex aquifolium 'hastata'.jpg",
          width: 1024,
          id: 'dfc5e4839bb26b295925312e53b06617',
          height: 683,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Ilex',
        cultivar: 'Hastata',
        famille: 'Aquifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd2b22ae397943b2755a9c8c4082a4968eb10031c',
      fields: {
        espece: 'aquifolium',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 166, 157, 1.00)',
            'rgba(87, 89, 65, 1.00)',
            'rgba(108, 98, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ilex [aquifoliaceae]/ilex aquifolium 'pendula'/ilex aquifolium 'pendula'.jpg",
          width: 1024,
          id: '21ec1a7c934e39faf8bb2518095234b1',
          height: 683,
          thumbnail: true,
        },
        location: [47.270533, -1.584826],
        genre: 'Ilex',
        cultivar: 'Pendula',
        famille: 'Aquifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584826, 47.270533] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd23fc858289dea7818d13bc1da91774ec7000ba0',
      fields: {
        espece: 'crenata',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 146, 99, 1.00)',
            'rgba(136, 144, 103, 1.00)',
            'rgba(123, 118, 89, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ilex [aquifoliaceae]/ilex crenata 'shiro-fukurin'/ilex crenata 'shiro-fukurin' (2).jpg",
          width: 576,
          id: '26d96bf1ba6d9dabdf8f8822130754b6',
          height: 768,
          thumbnail: true,
        },
        location: [47.270647, -1.58613],
        genre: 'Ilex',
        cultivar: 'Shiro-fukurin',
        famille: 'Aquifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58613, 47.270647] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '391f42ce7929f7644308ef0a8334ad7678438862',
      fields: {
        espece: 'verticillata',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 104, 93, 1.00)',
            'rgba(93, 103, 83, 1.00)',
            'rgba(100, 92, 81, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ilex [aquifoliaceae]/ilex verticillata/lex verticillata.jpg',
          width: 1024,
          id: '6529de33201833f1744c06e23d489e69',
          height: 683,
          thumbnail: true,
        },
        location: [47.270467, -1.585408],
        genre: 'Ilex',
        famille: 'Aquifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585408, 47.270467] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '818220add7137bf7504826884422953df44bc867',
      fields: {
        origine: 'B.G.Utrecht,Utrecht,Pays Bas',
        espece: 'ciliatum H.Li',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Arisaema',
        date_plantation: '2012',
        famille: 'Araceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '572b63c703ca9e5b12cd328ff0ac39e9acf85a81',
      fields: {
        origine: 'Crug farm (UK)',
        espece: 'leschenaultii',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Aralia',
        date_plantation: '2015',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '82ac2937e5d8928fdf4e156a5269b57b5bc107bd',
      fields: {
        origine: 'Mr Christian Monnet / Mr Franklin Picard',
        espece: 'decaisneana',
        localisation: 'B5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202019, -1.5440256],
        genre: 'Aralia',
        date_plantation: '2017',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440256, 47.2202019] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '215340d27d7411a75e42c942b00ebc50d3e0a15c',
      fields: {
        espece: 'humilis',
        localisation: 'B1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2204652, -1.544656],
        genre: 'Chamaerops',
        date_plantation: '1973',
        famille: 'Arecaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544656, 47.2204652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'edf01968e756f0c1b25611cc686767d3a4091055',
      fields: {
        origine: 'Arboretum,Univer.,Seoul,Cor\u00e9e du Sud',
        espece: 'longipes Franch.& Stearn',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Hosta',
        date_plantation: '2014',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b45731be90f9dceb5dbafa4a74f96ab2db2dda39',
      fields: {
        origine: 'Botanischer Garten Univ.Wurzburg,Wurzburg,All.',
        espece: 'melaina Speta',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Scilla',
        date_plantation: '2013',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '92f1b5a39475551693c959c83c0b3a4b03df8265',
      fields: {
        origine: 'Goteborg Botanical Garten,Goteborg,Su\u00e8de',
        espece: 'aucheri Baker',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Muscari',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cadd3d2417ecc599e1b74cf62cf79e10bf919dc3',
      fields: {
        origine: 'J.B.Friedrich Jena,Jena,All.',
        espece: 'turkewiczii Losinsk',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Muscari',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8f7beddd6475397fdf4a173d27a7da6a5caea044',
      fields: {
        origine: 'JB.Nanjingensis (Chine)',
        espece: 'ventricosa Stearn',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Hosta',
        date_plantation: '1991',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '984ca5a9f6b4b47a01594057b7800431a6e24bfa',
      fields: {
        origine: 'JBU.Marburg (Allemagne)',
        espece: 'liliago L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Anthericum',
        date_plantation: '2001',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e387ce00b8588f8f85eb3410538072d450d7596f',
      fields: {
        origine: 'Mr.Boff B.',
        espece: 'texana S. Wats.',
        localisation: 'A2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2208871, -1.5444631],
        genre: 'Nolina',
        date_plantation: '1995',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444631, 47.2208871] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a77a0941cbf1c7766db38510a69e7fde040aa600',
      fields: {
        espece: 'elatior Blume.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Aspidistra',
        date_plantation: '1973',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4d246ee52bfb80e2c51888814a8a4a4b4b34125a',
      fields: {
        espece: 'carnea Kunth.',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Reineckea',
        date_plantation: '1973',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e28a0f45d25673dcea398b30d29a25f251924b82',
      fields: {
        origine: 'Botanische Garten (Meckenheimer), Bonn, Allemagne',
        espece: 'glabellus Nutt.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Erigeron',
        date_plantation: '2012',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd0dfc80b4863c3384c6dc1455c51a0bf97723e8f',
      fields: {
        origine: 'J.B. Zurich (Suisse)',
        espece: 'speciosa Baumg.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Telekia',
        date_plantation: '2011',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f0eaa306db1a951da3b4f3ae4b15066b08a009b3',
      fields: {
        origine: 'J.B. Zurich (Suisse)',
        espece: 'dalechampii F.W.Schmidt',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Urospermum',
        date_plantation: '2011',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e68fcba9d47a1638aea3b7dee41795a0560c806c',
      fields: {
        origine: 'JB. Hermannshof, Wheinheim (Allemagne)',
        espece: 'paradoxa Britton',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Echinacea',
        date_plantation: '2011',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c1d910ddf512aeddfcb467f2f3a1183e966abc37',
      fields: {
        origine: 'JB. Leipzig, Leipzig (Allemagne)',
        espece: 'persicus Steven ex Fisch.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Echinops',
        date_plantation: '2011',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0e729afd1c3c26b5eb0b5946bab93c053aece617',
      fields: {
        origine: "JB.d'Akureyri ( Islande)",
        espece: 'magnifica Lipsky',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Inula',
        date_plantation: '1997',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a9811a006ed7c5243102f6ee0009de27607dfa2e',
      fields: {
        origine: 'JB.Hiroshima (Japon)',
        espece: 'nipponicum Franch.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Chrysanthemum',
        date_plantation: '1998',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '941537985d8159d50cb5f7353ac6000334ac3d6f',
      fields: {
        origine: 'JB.Lausanne (Suisse)',
        espece: 'lapponica  With.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Solidago',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2caad38428e234a04933e4348d85b4dd4371f91d',
      fields: {
        origine: 'JB.Meise 1860 (Belgique)',
        espece: 'ligustica All.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Achillea',
        date_plantation: '1998',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1ac892efed9961ac013519659fece831a1c72874',
      fields: {
        origine: 'JB.Seattle (USA)',
        espece: 'palmata  Nutt.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Coreopsis',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '12669b20f1c938b582fca316318ef9bf1ffa978c',
      fields: {
        origine: 'JB.Seattle (USA)',
        espece: 'pulchellus Michx.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Erigeron',
        date_plantation: '2009',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '077877c1777d03a0935a70cc83cfd2bb0d39935b',
      fields: {
        origine: 'JBN.Chapel Hill',
        espece: 'autumnale L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Helenium',
        date_plantation: '1997',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1dc9ba6f78c46e21d5ebc9f25d13fb52bfaa98c6',
      fields: {
        origine: 'JBU.Friedrich-Jena (Allemagne)',
        espece: 'chamissonis Less.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Arnica',
        date_plantation: '2004',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4fb649551685c4b14b5c3b379d13821d42ef570f',
      fields: {
        origine: 'JBU.Graz (Autriche)',
        espece: 'grandifolia Maxim.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Saussurea',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cab499f1105923b2b1b1d6a47ec7aff3d18cc361',
      fields: {
        origine: 'Madame Augustin',
        espece: 'arborescens L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Artemisia',
        date_plantation: '1993',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e37dc5f1f30f61a0565fe89a21e0da4fcc972057',
      fields: {
        origine: 'Mr.Figureau C.',
        espece: 'sp.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Aster',
        date_plantation: '2004',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0fcc2e03e14b76aefab2d11739c1f561762ff9a8',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes 71290 La Gen\u00eate',
        espece: 'albescens Hook. f & Thomson',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Saussurea',
        date_plantation: '2015',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd4a3048dec3807bf7a6649a7daf5878dea5672f1',
      fields: {
        origine: 'Univ.Marie Curie Lublin (Pologne)',
        espece: 'diplostephioides Benth. & Hook.f.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Aster',
        date_plantation: '2010',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'eaa72a579d4afdf0c8c6c5ef4fd3b7977e9036a9',
      fields: {
        espece: 'verticillata L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Coreopsis',
        date_plantation: '1973',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3a58efdd141a24ff8cc6a1820bf6008d593d4b43',
      fields: {
        espece: 'x media',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 105, 101, 1.00)',
            'rgba(101, 86, 44, 1.00)',
            'rgba(126, 112, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/mahonia [berberidaceae]/mahonia x media 'winter sun'/mahonia x media 'winter sun'.jpg",
          width: 1024,
          id: 'dbaf37851dc86955e18f178d159021b8',
          height: 683,
          thumbnail: true,
        },
        location: [47.270953, -1.586375],
        genre: 'Mahonia',
        cultivar: 'Winter Sun',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586375, 47.270953] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bd13a2355f1d2bd64d4de4342eae50e622ca6808',
      fields: {
        origine: 'P\u00e9pini\u00e8re Ville de Nantes',
        espece: 'utilis',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Betula',
        date_plantation: '2018',
        cultivar: 'jacquemontii',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd65fc0ba59f379511a858cad4b9db26af44808e2',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'alleghaniensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 115, 50, 1.00)',
            'rgba(116, 138, 84, 1.00)',
            'rgba(121, 135, 90, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/betula [betulaceae]/betula alleghaniensis/betula alleghaniensis  (2).jpg',
          width: 576,
          id: 'e349fdf4a9cebb0015bb3e2d139f46c9',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 184, 151, 1.00)',
            'rgba(85, 110, 47, 1.00)',
            'rgba(66, 80, 39, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/betula [betulaceae]/betula alleghaniensis/betula alleghaniensis  (3).jpg',
          width: 576,
          id: '07af9b819dd8a3b91c1d31d6543bda8f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 139, 67, 1.00)',
            'rgba(116, 158, 71, 1.00)',
            'rgba(107, 130, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/betula [betulaceae]/betula alleghaniensis/betula alleghaniensis  (1).jpg',
          width: 576,
          id: '26fd0fcaa7938ac93c8d19513a9b0230',
          height: 768,
          thumbnail: true,
        },
        location: [47.271038, -1.585647],
        genre: 'Betula',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585647, 47.271038] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '83c4f3ec6712258c223a33c632436496f43a191b',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 126, 117, 1.00)',
            'rgba(123, 118, 112, 1.00)',
            'rgba(111, 104, 103, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/betula [betulaceae]/betula nigra 'vast'/betula nigra 'vast' (3).jpg",
          width: 576,
          id: 'dc4db4de28b1534b4ad95fccf196abe2',
          height: 768,
          thumbnail: true,
        },
        espece: 'nigra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 110, 64, 1.00)',
            'rgba(127, 155, 103, 1.00)',
            'rgba(84, 102, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/betula [betulaceae]/betula nigra 'vast'/betula nigra 'vast' (2).jpg",
          width: 576,
          id: 'a4e880e516e13eb9299663bbca6ec012',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 147, 99, 1.00)',
            'rgba(120, 151, 105, 1.00)',
            'rgba(107, 126, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/betula [betulaceae]/betula nigra 'vast'/betula nigra 'vast' (1).jpg",
          width: 576,
          id: 'f9c7080841d27b969cc8989262531dd1',
          height: 768,
          thumbnail: true,
        },
        location: [47.271847, -1.582097],
        genre: 'Betula',
        cultivar: 'Vast',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582097, 47.271847] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '39cde793358ed2e13e13bf3828fbaf44fc11e9eb',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'avellana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 114, 139, 1.00)',
            'rgba(110, 114, 128, 1.00)',
            'rgba(108, 111, 125, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylus [betulaceae]/corylus avellana/corylus avellana (2).jpg',
          width: 1024,
          id: '4cd8441ebc061ca9be8dd67f5f375f28',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 118, 178, 1.00)',
            'rgba(98, 113, 140, 1.00)',
            'rgba(97, 99, 108, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylus [betulaceae]/corylus avellana/corylus avellana (3).jpg',
          width: 1024,
          id: 'f80c8c491a14310d1bdb82d5cb197de6',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 134, 144, 1.00)',
            'rgba(119, 116, 94, 1.00)',
            'rgba(103, 100, 49, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylus [betulaceae]/corylus avellana/corylus avellana (1).jpg',
          width: 1024,
          id: '85fd88d8685dcc2f56ac8efa97eb169c',
          height: 683,
          thumbnail: true,
        },
        location: [47.273052, -1.582362],
        genre: 'Corylus',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582362, 47.273052] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7e3b19d9213f941c2fe4320e3794677a683c7fc9',
      fields: {
        espece: 'sieboldiana var. mandshurica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 156, 145, 1.00)',
            'rgba(139, 132, 122, 1.00)',
            'rgba(125, 123, 117, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corylus [betulaceae]/corylus sieboldiana var. mandshurica/corylus sieboldiana var. mandshurica (2).jpg',
          width: 576,
          id: 'c833e190807d7f58c7d873d68a59ca48',
          height: 768,
          thumbnail: true,
        },
        location: [47.271008, -1.582305],
        genre: 'Corylus',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582305, 47.271008] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9ff1b55f75bd0735ee24ff06038cd3dcbcb25bba',
      fields: {
        espece: 'carpinifolia',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 104, 75, 1.00)',
            'rgba(125, 146, 88, 1.00)',
            'rgba(116, 139, 56, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/ostrya [betulaceae]/ostrya carpinifolia/ostrya carpinifolia.jpg',
          width: 576,
          id: '37989b3b7a9c36d12029f58a9cf3d64d',
          height: 768,
          thumbnail: true,
        },
        location: [47.230005, -1.506183],
        genre: 'Ostrya',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.506183, 47.230005] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd8fe142bd018b7eb1e3f61625c1428d75c408308',
      fields: {
        origine: 'JB.Jean Michel Spas (France)',
        espece: 'olgae Regel.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Incarvillea',
        date_plantation: '2006',
        famille: 'Bignoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7e4eeec1f84af0add1914e10e2d6e4fec38feab5',
      fields: {
        origine: 'Arboretum de Bolestraszyce (Pologne)',
        espece: 'mollis Wulfen',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Pulmonaria',
        date_plantation: '2009',
        famille: 'Boraginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6941e6c025b5de2c248d58c18465839d0c4e0b7a',
      fields: {
        origine: 'B.G.Munchen (All.)',
        espece: 'apenninus Fischer & Meyer',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Solenanthus',
        date_plantation: '2015',
        famille: 'Boraginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '583a52877ea315d6c6233834f263fddfedcfbb48',
      fields: {
        origine: 'JB.Utrecht (Hollande)',
        espece: 'echioides  L.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Onosma',
        date_plantation: '2008',
        famille: 'Boraginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '54b341e4f6daee801f97c9ae42c33c3463440a49',
      fields: {
        origine: 'OGG Graz (Autriche)',
        espece: 'petraea Boiss.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Moltkia',
        date_plantation: '2015',
        famille: 'Boraginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a94c81bdc788d983ef42cba7ffbd4eaa6747f618',
      fields: {
        origine: 'B.G. Munchen (All.)',
        espece: 'aubrietioides Boiss.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Arabis',
        date_plantation: '2014',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd1cc95da7ed5d9f0eb907476e79163098fe28954',
      fields: {
        origine: 'Experimenteller B.G. Gottingen (All.)',
        espece: 'caucasica Willd.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Arabis',
        date_plantation: '2015',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a69fe124af65b0ca86015478927d6aba376ead22',
      fields: {
        origine: 'J.B.Ringve,Trondheim,Norv\u00e8ge',
        espece: 'daurica DC.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Draba',
        date_plantation: '2014',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '67ed196c4e6b58a498959d7a9386ce815613a880',
      fields: {
        origine: 'JB.Lautaret (France)',
        espece: 'magellanica Pers.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Thlaspi',
        date_plantation: '2008',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '36a715e409226dfaa1dc7c96f0f032ad5a150745',
      fields: {
        origine: 'JB.Reykjavik (Islande)',
        espece: 'altaicum G.A.Mey.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Alyssum',
        date_plantation: '2009',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8e9f4deb1b1f8323b0acb6d0ed1525c4d2884586',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes 71290 La Gen\u00eate',
        espece: 'macrophylla Willd.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Cardamine',
        date_plantation: '2015',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5747363a5e678622c01a0b5f35599e76cdc5f08a',
      fields: {
        origine: 'Universita degli studi de Catania',
        espece: 'bonannianum C.Presl.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Erysimum',
        date_plantation: '2010',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a91138e66661a5797d4fcc5a32b4a529a5442d97',
      fields: {
        espece: 'gilliesii',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 162, 106, 1.00)',
            'rgba(125, 143, 90, 1.00)',
            'rgba(135, 135, 90, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/caesalpinia [caesalpiniaceae]/caesalpinia gilliesii/caesalpinia gilliesii.jpg",
          width: 576,
          id: '0de41ee066b6d2db3901f3330accc61f',
          height: 768,
          thumbnail: true,
        },
        location: [47.22673, -1.512805],
        genre: 'Caesalpinia',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512805, 47.22673] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '55e9b2011043300d6e7f917840a5c367244b2974',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 156, 101, 1.00)',
            'rgba(129, 126, 50, 1.00)',
            'rgba(109, 113, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/gleditsia [caesalpiniaceae]/gleditsia triacanthos 'rubylace'/gleditsia triacanthos 'rubylace' (3).jpg",
          width: 576,
          id: '2c833942f6686f989ddfd0f760dcaaaf',
          height: 768,
          thumbnail: true,
        },
        espece: 'triacanthos',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 133, 72, 1.00)',
            'rgba(136, 132, 76, 1.00)',
            'rgba(127, 131, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/gleditsia [caesalpiniaceae]/gleditsia triacanthos 'rubylace'/gleditsia triacanthos 'rubylace' (2).jpg",
          width: 576,
          id: '4da6ed05f2ec1e0e03fc8ba5574a3d1a',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 133, 59, 1.00)',
            'rgba(128, 134, 59, 1.00)',
            'rgba(136, 143, 84, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/gleditsia [caesalpiniaceae]/gleditsia triacanthos 'rubylace'/gleditsia triacanthos 'rubylace' (1).jpg",
          width: 576,
          id: '769a5de29510a96768863f330f6bd290',
          height: 768,
          thumbnail: true,
        },
        location: [47.270495, -1.58273],
        genre: 'Gleditsia',
        cultivar: 'Rubylace',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58273, 47.270495] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7d035898113d5a8d994cb1884b8cfa851a94c30c',
      fields: {
        espece: 'triacanthos f. inermis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 184, 226, 1.00)',
            'rgba(129, 137, 128, 1.00)',
            'rgba(89, 86, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/gleditsia [caesalpiniaceae]/gleditsia triacanthos f. inermis/gleditsia triacanthos f. inermis (2).jpg',
          width: 576,
          id: '462194c31a2ad2ea6e4a86aa44288853',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 141, 75, 1.00)',
            'rgba(118, 134, 78, 1.00)',
            'rgba(152, 151, 140, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/gleditsia [caesalpiniaceae]/gleditsia triacanthos f. inermis/gleditsia triacanthos f. inermis (1).jpg',
          width: 576,
          id: 'fa9e75e2ecd18278d31e628299e0431e',
          height: 768,
          thumbnail: true,
        },
        location: [47.271038, -1.587025],
        genre: 'Gleditsia',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587025, 47.271038] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7824731bb4027f2c945ad9223ee88fa74f04fd97',
      fields: {
        espece: 'nitens',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 128, 117, 1.00)',
            'rgba(134, 134, 127, 1.00)',
            'rgba(123, 118, 114, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chimonanthus [calycanthaceae]/chimonanthus nitens/chimonanthus nitens (2).jpg',
          width: 576,
          id: '3df03b631594935e548e267af1f626d9',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 149, 89, 1.00)',
            'rgba(117, 141, 80, 1.00)',
            'rgba(120, 127, 91, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/chimonanthus [calycanthaceae]/chimonanthus nitens/chimonanthus nitens (1).jpg',
          width: 576,
          id: 'adddcbe2ac53d595b5aa685154fd8168',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Chimonanthus',
        famille: 'Calycanthaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6255b668c5b196c7967b71dc5854cc9a409f5d13',
      fields: {
        origine: 'Emmanuel LEPAGE',
        espece: 'latifolia L.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Campanula',
        date_plantation: '2015',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8ccffbf7091154cc044afc8f0e450986d411bc2c',
      fields: {
        origine: 'J.B. Klagenfurt (Autriche)',
        espece: 'dalmaticus A. D.C.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Edraianthus',
        date_plantation: '2011',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c6d7105be4e5efb1dae5ab8783517e190bd746d5',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'australis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 135, 45, 1.00)',
            'rgba(118, 140, 55, 1.00)',
            'rgba(118, 128, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/celtis [cannabaceae]/celtis australis/celtis australis (2).jpg',
          width: 576,
          id: 'e300c9a0579d0011cb39c2c03d45859c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(204, 226, 221, 1.00)',
            'rgba(117, 135, 83, 1.00)',
            'rgba(61, 68, 34, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/celtis [cannabaceae]/celtis australis/celtis australis (3).jpg',
          width: 576,
          id: '110702fa342d2a97c3a9e4761ad60039',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 165, 78, 1.00)',
            'rgba(119, 147, 52, 1.00)',
            'rgba(105, 128, 37, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/celtis [cannabaceae]/celtis australis/celtis australis (1).jpg',
          width: 576,
          id: '5f3dafd052183d01ae1591c63b861870',
          height: 768,
          thumbnail: true,
        },
        location: [47.270775, -1.581812],
        genre: 'Celtis',
        famille: 'Cannabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581812, 47.270775] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '215eae63bc0abbe3b26b83cc6c23d2bc692ddba5',
      fields: {
        espece: 'amabilis',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Kolkwitzia',
        date_plantation: '1973',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8e29941db8f8e1f73986d99dcd8e847b42542e01',
      fields: {
        espece: 'tatarica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 151, 128, 1.00)',
            'rgba(121, 119, 77, 1.00)',
            'rgba(128, 117, 83, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera tatarica 'hack's red'/lonicera tatarica 'hack's red' .jpg",
          width: 576,
          id: 'bcb875392bb82675efbcf92d04dd8a9f',
          height: 768,
          thumbnail: true,
        },
        location: [47.271105, -1.581488],
        genre: 'Lonicera',
        cultivar: "Hack's Red",
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581488, 47.271105] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9a1b53060c20e4abd92edab1e38d73efee90a0ae',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 142, 87, 1.00)',
            'rgba(146, 121, 96, 1.00)',
            'rgba(113, 113, 77, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera tatarica 'hack's red'/lonicera tatarica 'hack's red' (3).jpg",
          width: 670,
          id: '0d670960dd636b20631cfe789b63ef62',
          height: 768,
          thumbnail: true,
        },
        espece: 'tatarica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(181, 193, 198, 1.00)',
            'rgba(118, 110, 73, 1.00)',
            'rgba(105, 102, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera tatarica 'hack's red'/lonicera tatarica 'hack's red' (2).jpg",
          width: 691,
          id: 'ad3c23172b6ca7c7604de7ba54366e01',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 152, 98, 1.00)',
            'rgba(143, 123, 87, 1.00)',
            'rgba(103, 125, 65, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera tatarica 'hack's red'/lonicera tatarica 'hack's red' (1).jpg",
          width: 576,
          id: '5d8c3cfc59c6ea2b5e68ceda952bb1e9',
          height: 768,
          thumbnail: true,
        },
        location: [47.270772, -1.582155],
        genre: 'Lonicera',
        cultivar: "Hack's Red",
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582155, 47.270772] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '055066c6d659f433fca011cdf456498fecb1de70',
      fields: {
        origine: 'B.G. de Kosice (Slovaquie)',
        espece: 'gerardii Hayek.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Minuartia',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6bb2f55ebd03e9c1d976c1faf8cdb694afbe7878',
      fields: {
        origine: 'B.G. de St Gallen (Suisse)',
        espece: 'juniperina Maire & Petitm.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Minuartia',
        date_plantation: '2013',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '44e3486b6404fb7ed1939bc2c1b1f73009fdd6a1',
      fields: {
        origine: 'B.G. Oslo (Norv\u00e8ge)',
        espece: 'alpina G.Don',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Viscaria',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2d3e182792409b406765d2b65b65ec7938e1b603',
      fields: {
        origine: 'Botanische Garten Universitat Bonn, Bonn, Allemagne',
        espece: 'saxifraga L.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Silene',
        date_plantation: '2013',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '73de5e763313e15a063cd93dfc37f1c30c505c7d',
      fields: {
        origine: 'Botanischer Garten,Mainz,Allamagne',
        espece: 'coronaria Desr.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Lychnis',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e604dbef0b471af4308b18997319a0b6751cb928',
      fields: {
        origine: 'J. Alpin du Lautaret        (France)',
        espece: 'imperatii L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Telephium',
        date_plantation: '2010',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b5966f71f9496ffbaa735c4de1f40e83f28b6f04',
      fields: {
        origine: 'J.Alp.Belvedere Wien (Autriche)',
        espece: 'lumnitzeri Wiesb.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Dianthus',
        date_plantation: '1999',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c0d91b9d320673090922f83891a5a426cc7611be',
      fields: {
        origine: 'Jardin botanico Real Juan Carlos - Madrid',
        espece: 'struthium Loefl.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Gypsophila',
        date_plantation: '2010',
        cultivar: 'struthium',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'da5046752ef04aee6b47c7b7ed996110d1d7c7cf',
      fields: {
        origine: 'JB.Bern (Suisse)',
        espece: 'vallesia L.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Silene',
        date_plantation: '2006',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '81c5211e1cf80a5401a39a8a75da07eaa79e67c0',
      fields: {
        origine: 'K\u00e4rntner Botanikzentrum, Klagenfurt, Autriche',
        espece: 'muscosa L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Moehringia',
        date_plantation: '2012',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8d029e40585491cd0d7bc78a76ab84f90a64f350',
      fields: {
        origine: 'origine perdue,culture enclo bota pour AO',
        espece: 'viscaria Borkh.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Silene',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c883f3edc76df2d92a00d5c3632136f0fac86c1d',
      fields: {
        origine: 'Plantentuin Gent, Belgique',
        espece: 'preobrazhenskii Klokov',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Dianthus',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e3ae73e289a70279197e086539dd8c535119c3c5',
      fields: {
        origine: 'Station de recherche env. Marijampole (Lituanie)',
        espece: 'chinensis L.',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Dianthus',
        date_plantation: '2011',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2e6afac4455b07cd795dd49de33ce78926563044',
      fields: {
        origine: 'Teheran BG',
        espece: 'bicolor Freyn.& Sint.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Gypsophila',
        date_plantation: '2010',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e0225f8f16f68fd227017d4dd7d0e457999e44e9',
      fields: {
        origine: 'Universit\u00e9 de Postdam (Allemagne)',
        espece: 'sedoides Hiern',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Minuartia',
        date_plantation: '2011',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dde7c54d7768bbe09913db5fe2df2aeedf37a619',
      fields: {
        origine: 'Arb.et JBU.Bergen  Hjellestad (Norv\u00e8ge)',
        espece: 'magnificum',
        localisation: 'B7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198817, -1.5442188],
        genre: 'Cercidiphyllum',
        date_plantation: '2000',
        famille: 'Cercidiphyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442188, 47.2198817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '002c8757f491f0d5e9d4925e1b2b39873fc857cc',
      fields: {
        espece: 'japonicum',
        localisation: 'B7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198817, -1.5442188],
        genre: 'Cercidiphyllum',
        date_plantation: '1988',
        famille: 'Cercidiphyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442188, 47.2198817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6b28041c7f5ea6b1ea85c62e9504884614267b27',
      fields: {
        origine: 'JB.Leipzig (Allemagne)',
        espece: 'virgatum Pers.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Helianthemum',
        date_plantation: '2009',
        famille: 'Cistaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7a4635186ae6278b7bfc7cabfd96b644ef2f1bac',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'fargesii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 147, 128, 1.00)',
            'rgba(143, 154, 115, 1.00)',
            'rgba(88, 107, 51, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/clethra [clethraceae]/clethra fargesii/clethra fargesii  (3).jpg',
          width: 576,
          id: '782114ee8629e3869245e536d5df675d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 98, 46, 1.00)',
            'rgba(119, 134, 86, 1.00)',
            'rgba(66, 89, 39, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/clethra [clethraceae]/clethra fargesii/clethra fargesii  (5).jpg',
          width: 576,
          id: '09f38609dea2b1099e883b1dda84d859',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 154, 65, 1.00)',
            'rgba(117, 144, 76, 1.00)',
            'rgba(103, 113, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/clethra [clethraceae]/clethra fargesii/clethra fargesii  (2).jpg',
          width: 576,
          id: 'f5bcdc0b1aba90f6e361bff613fe3bff',
          height: 768,
          thumbnail: true,
        },
        location: [47.271533, -1.582108],
        genre: 'Clethra',
        famille: 'Clethraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582108, 47.271533] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'aaf0ee103163fe86efd5f6c8ff6d59bfe60f3988',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 139, 123, 1.00)',
            'rgba(106, 99, 81, 1.00)',
            'rgba(120, 112, 94, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida 'rainbow'/cornus florida 'rainbow' (3).jpg",
          width: 576,
          id: 'de8486a3b7c8b9581be37d4b36aeb8d1',
          height: 768,
          thumbnail: true,
        },
        espece: 'florida',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 135, 101, 1.00)',
            'rgba(140, 145, 96, 1.00)',
            'rgba(96, 97, 41, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida 'rainbow'/cornus florida 'rainbow' (2).jpg",
          width: 576,
          id: 'a9b8c2b380cd7505dabf00685eb1d480',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 150, 48, 1.00)',
            'rgba(147, 151, 35, 1.00)',
            'rgba(99, 99, 25, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida 'rainbow'/cornus florida 'rainbow' (1).jpg",
          width: 576,
          id: 'ef357aa84c316bc3e03369703d0f6102',
          height: 768,
          thumbnail: true,
        },
        location: [47.271422, -1.582483],
        genre: 'Cornus',
        cultivar: 'Rainbow',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582483, 47.271422] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '24241eb4f8ac8b2db2c4eb11b3c3bffd8610781d',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 98, 68, 1.00)',
            'rgba(131, 134, 109, 1.00)',
            'rgba(81, 83, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida 'white cloud'/cornus florida 'white cloud' (3).jpg",
          width: 576,
          id: 'b885d15568020a86e1a21bce262a6abe',
          height: 768,
          thumbnail: true,
        },
        espece: 'florida',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 87, 49, 1.00)',
            'rgba(135, 144, 97, 1.00)',
            'rgba(96, 99, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida 'white cloud'/cornus florida 'white cloud' (2).jpg",
          width: 576,
          id: '144ac0639e29b54783c8ae69b9708bbe',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 153, 75, 1.00)',
            'rgba(126, 155, 41, 1.00)',
            'rgba(114, 138, 38, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida 'white cloud'/cornus florida 'white cloud' (1).jpg",
          width: 576,
          id: '0936783ddcba6785bfaf4963691d0684',
          height: 768,
          thumbnail: true,
        },
        location: [47.270867, -1.586358],
        genre: 'Cornus',
        cultivar: 'White Cloud',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586358, 47.270867] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b6bc1124e30f562a904b6d2e92abb0219588fa06',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 122, 98, 1.00)',
            'rgba(139, 145, 130, 1.00)',
            'rgba(112, 116, 101, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'autumn rose'/cornus kousa 'autumn rose' (11).jpg",
          width: 576,
          id: '47edb2948a436379e04398e5f948068c',
          height: 768,
          thumbnail: true,
        },
        espece: 'kousa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 93, 59, 1.00)',
            'rgba(137, 143, 108, 1.00)',
            'rgba(87, 115, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'autumn rose'/cornus kousa 'autumn rose' (10).jpg",
          width: 576,
          id: '96ca5f2afd9f58bd26cf5b9c6086c354',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 160, 105, 1.00)',
            'rgba(101, 127, 46, 1.00)',
            'rgba(99, 109, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'autumn rose'/cornus kousa 'autumn rose' (1).jpg",
          width: 576,
          id: '059a299f5ea7f5bd91532f4e0628c36e',
          height: 768,
          thumbnail: true,
        },
        location: [47.270595, -1.581883],
        genre: 'Cornus',
        cultivar: 'Autumn Rose',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581883, 47.270595] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6b8acd7a4b4be62d1ebdf93984c20f830ea02637',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 122, 98, 1.00)',
            'rgba(113, 123, 57, 1.00)',
            'rgba(172, 175, 145, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'constellation'/cornus kousa 'constellation'  (3).jpg",
          width: 576,
          id: '0c4eaadee8a460f6d3f67c8450233b23',
          height: 768,
          thumbnail: true,
        },
        espece: 'kousa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 129, 89, 1.00)',
            'rgba(151, 147, 117, 1.00)',
            'rgba(115, 101, 82, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'constellation'/cornus kousa 'constellation'  (2).jpg",
          width: 967,
          id: 'fb8bb436d2f8b6ca17b24876de5c3efc',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 137, 129, 1.00)',
            'rgba(159, 150, 145, 1.00)',
            'rgba(142, 139, 133, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'constellation'/cornus kousa 'constellation'  (1).jpg",
          width: 576,
          id: 'f8f4e1b027ff00858ed7c6758d339231',
          height: 768,
          thumbnail: true,
        },
        location: [47.27157, -1.58708],
        genre: 'Cornus',
        cultivar: 'Constellation',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58708, 47.27157] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '999701324775737b8e15f2c272332151351fcee8',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 113, 91, 1.00)',
            'rgba(82, 89, 73, 1.00)',
            'rgba(93, 95, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'ed mezitt'/cornus kousa 'ed mezitt' (7).jpg",
          width: 1024,
          id: 'c3e2983b987e1f9e2d691ac69a6858e6',
          height: 683,
          thumbnail: true,
        },
        espece: 'kousa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 117, 85, 1.00)',
            'rgba(87, 99, 73, 1.00)',
            'rgba(78, 89, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'ed mezitt'/cornus kousa 'ed mezitt' (11).jpg",
          width: 1024,
          id: 'b3cc9fb75f6ee1e356e52ffc1561cafe',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 81, 66, 1.00)',
            'rgba(80, 89, 69, 1.00)',
            'rgba(68, 70, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'ed mezitt'/cornus kousa 'ed mezitt' (10).jpg",
          width: 1024,
          id: '8b4d233ec20412ed07e84f2768b5f10e',
          height: 683,
          thumbnail: true,
        },
        location: [47.270297, -1.581378],
        genre: 'Cornus',
        cultivar: 'Ed Mezitt',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581378, 47.270297] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '53ca93142d4967d83477f3a637633f08a83768c7',
      fields: {
        espece: 'kousa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 112, 92, 1.00)',
            'rgba(113, 129, 110, 1.00)',
            'rgba(114, 121, 112, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'schmetterling'/cornus kousa 'schmetterling' (2).jpg",
          width: 576,
          id: '04f180c3840c9007044e30ec6a6c7e20',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 117, 105, 1.00)',
            'rgba(129, 118, 126, 1.00)',
            'rgba(103, 113, 93, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'schmetterling'/cornus kousa 'schmetterling' (1).jpg",
          width: 576,
          id: '8013a7d0985e923db5e26bb88ced96c0',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Cornus',
        cultivar: 'Schmetterling',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e5d7b359649ccde256fdbc73271bdcd9abb88776',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(185, 114, 115, 1.00)',
            'rgba(180, 97, 92, 1.00)',
            'rgba(141, 113, 100, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'summer star'/cornus kousa 'summer star'   (3).jpg",
          width: 576,
          id: '66c285fa8deaa28ba069179bc237a638',
          height: 768,
          thumbnail: true,
        },
        espece: 'kousa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 139, 68, 1.00)',
            'rgba(123, 127, 61, 1.00)',
            'rgba(164, 167, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'summer star'/cornus kousa 'summer star'   (2).jpg",
          width: 576,
          id: 'd878c8808ef315df912d9261334c382b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 125, 89, 1.00)',
            'rgba(140, 144, 94, 1.00)',
            'rgba(130, 136, 89, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'summer star'/cornus kousa 'summer star'   (1).jpg",
          width: 1024,
          id: 'd86ae6d23fbe5539eb5e58aa7ced465f',
          height: 768,
          thumbnail: true,
        },
        location: [47.269775, -1.582088],
        genre: 'Cornus',
        cultivar: 'Summer Star',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582088, 47.269775] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7c4bb35dba42ef2f7c03b62adf8ae4c338c243d3',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'officinalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 121, 62, 1.00)',
            'rgba(134, 161, 39, 1.00)',
            'rgba(111, 135, 27, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus officinalis/cornus officinalis (2).jpg',
          width: 576,
          id: '39c6ec0effba9da404d6eaf818f5bae4',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 118, 108, 1.00)',
            'rgba(133, 113, 90, 1.00)',
            'rgba(133, 116, 104, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus officinalis/cornus officinalis (3).jpg',
          width: 576,
          id: 'bc76afe9f789cc23b4bec8419092a046',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 130, 54, 1.00)',
            'rgba(138, 149, 81, 1.00)',
            'rgba(117, 128, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus officinalis/cornus officinalis (1).jpg',
          width: 576,
          id: '870f954dade284fb5c102b497bb5cf0d',
          height: 768,
          thumbnail: true,
        },
        location: [47.2712, -1.582405],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582405, 47.2712] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a6d0d11d2ae75bc120d3c59b9752b6d9186901d4',
      fields: {
        espece: 'sanguinea',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 116, 106, 1.00)',
            'rgba(140, 122, 98, 1.00)',
            'rgba(121, 107, 91, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus sanguinea 'winter beauty'/cornus sanguinea 'winter beauty' (3).jpg",
          width: 576,
          id: '110b7c4db30961fe09010945fc030590',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Cornus',
        cultivar: 'Winter Beauty',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '70fdfb6b9b3acdae07ce2ac1cba9c0887bb2aa43',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 151, 81, 1.00)',
            'rgba(112, 148, 77, 1.00)',
            'rgba(101, 130, 63, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus sericea 'flaviramea'/cornus sericea 'flaviramea'  (5).jpg",
          width: 576,
          id: 'ac36eea9c610b55aa9bd4facf07556dc',
          height: 768,
          thumbnail: true,
        },
        espece: 'sericea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(61, 79, 37, 1.00)',
            'rgba(115, 123, 87, 1.00)',
            'rgba(83, 94, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus sericea 'flaviramea'/cornus sericea 'flaviramea'  (4).jpg",
          width: 576,
          id: '97655bb5333e4987332d43e339e8f94c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 157, 91, 1.00)',
            'rgba(116, 141, 76, 1.00)',
            'rgba(90, 111, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus sericea 'flaviramea'/cornus sericea 'flaviramea'  (3).jpg",
          width: 1024,
          id: '45ff452c79fa1adbc7540a3493dd0610',
          height: 768,
          thumbnail: true,
        },
        location: [47.271913, -1.582455],
        genre: 'Cornus',
        cultivar: 'Flaviramea',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582455, 47.271913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b6482fdc58e1541ed567918e1a178db99fd77a4e',
      fields: {
        origine: 'BG Matsudo, Chiba Pref.',
        espece: 'kamtchaticum  Fisch. & Mey.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Sedum',
        date_plantation: '2006',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b82c811adbb73bc2ba283c534a9a9eeb4f7d2995',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'turbinata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 146, 121, 1.00)',
            'rgba(135, 140, 58, 1.00)',
            'rgba(133, 123, 51, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus turbinata/aesculus turbinata  (2).jpg',
          width: 576,
          id: 'e86bbea28d124fb171b6874b0d4a01c1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(188, 200, 173, 1.00)',
            'rgba(83, 103, 56, 1.00)',
            'rgba(77, 86, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus turbinata/aesculus turbinata (1).jpg',
          width: 1024,
          id: '2876d9c4d36c06c582f4e7819dfb58a8',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 151, 112, 1.00)',
            'rgba(124, 130, 56, 1.00)',
            'rgba(112, 116, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus turbinata/aesculus turbinata  (1).jpg',
          width: 1024,
          id: 'd0b36af521329f49e1950e435be4f1e3',
          height: 768,
          thumbnail: true,
        },
        location: [47.270378, -1.582245],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582245, 47.270378] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '27e482c43f96ca1c7181b996a449518596b14c52',
      fields: {
        espece: 'turbinata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(179, 199, 190, 1.00)',
            'rgba(94, 88, 37, 1.00)',
            'rgba(57, 57, 28, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus turbinata/aesculus turbinata (13).jpg',
          width: 512,
          id: '4f6a5ada8470dcb43140cbd551ad818c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 116, 110, 1.00)',
            'rgba(113, 105, 69, 1.00)',
            'rgba(100, 94, 51, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus turbinata/aesculus turbinata (12).jpg',
          width: 512,
          id: '9e5eafe7079e69c8a11f6a870d49984c',
          height: 768,
          thumbnail: true,
        },
        location: [47.2704, -1.58223],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58223, 47.2704] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c9ea8295652b2c24015e678360f66057cc2e647b',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'glabra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 103, 141, 1.00)',
            'rgba(80, 102, 129, 1.00)',
            'rgba(98, 132, 176, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/aesculus [sapindaceae]/aesculus glabra/aesculus glabra (10).jpg',
          width: 1024,
          id: '1e7ca29fc2734b3d2e06e13037e5c03d',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(53, 67, 45, 1.00)',
            'rgba(83, 95, 72, 1.00)',
            'rgba(130, 144, 135, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/aesculus [sapindaceae]/aesculus glabra/aesculus glabra (11).jpg',
          width: 1024,
          id: 'ab09292de55030714d468b596ac4f023',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 148, 71, 1.00)',
            'rgba(123, 138, 50, 1.00)',
            'rgba(76, 95, 24, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/aesculus [sapindaceae]/aesculus glabra/aesculus glabra (1).jpg',
          width: 576,
          id: '76ee3ccef05c19f1c9685dcac493ba7a',
          height: 768,
          thumbnail: true,
        },
        location: [47.261925, -1.53478],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53478, 47.261925] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2a2c69cd526195546b3afe4408484fe8bf496c17',
      fields: {
        espece: 'africana',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 145, 54, 1.00)',
            'rgba(103, 120, 46, 1.00)',
            'rgba(97, 113, 42, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/tieghemella [sapotaceae]/tieghemella africana/tieghemella africana.jpg",
          width: 576,
          id: '3882a0edf7639027e401b073a70fb5bc',
          height: 768,
          thumbnail: true,
        },
        location: [47.227175, -1.512108],
        genre: 'Tieghemella',
        famille: 'Sapotaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512108, 47.227175] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '42a71b58583ac14a838634bf5d3810fd718897c0',
      fields: {
        origine: 'Jardin botanique alpin Murmansk',
        espece: 'crassifolia Fritsch',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Bergenia',
        date_plantation: '2010',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6008f60266b918666085de570ada282d23e0a6d6',
      fields: {
        origine: 'Les Ponts de C\u00e9_p\u00e9pini\u00e8re Lepage',
        espece: 'japonica A.Gray',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Astilbe',
        date_plantation: '2016',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9ba0ef42abd8eb3338d7a0a0819aba204b2dca9f',
      fields: {
        origine: 'P\u00e9pini\u00e8res E.Lepage',
        espece: 'purpurascens Engl.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Bergenia',
        date_plantation: '2015',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '89617e01fd18a72a39f113439bb9882d14da41e5',
      fields: {
        origine:
          'r\u00e9colte de Philippe F\u00e9rard,Pyr\u00e9n\u00e9es,26/07/09',
        espece: 'rotundifolia L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Saxifraga',
        date_plantation: '2014',
        famille: 'Saxifragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2cd6363754f2ba5363f5e5b1adad2a20ac26c107',
      fields: {
        origine: 'JB Universit\u00e9 de Potsdam',
        espece: 'umbrosa Dumort.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Scrophularia',
        date_plantation: '2010',
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e7d8626329b566fabd8bb5a8127b0f4b4f328fe0',
      fields: {
        origine: 'JB.Chemnitz (Allemagne)',
        espece: 'phoeniceum L.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Verbascum',
        date_plantation: '2004',
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ee3b70bdfd7ac26eb25fe1795a84144b0105400f',
      fields: {
        origine: 'JB.Porto (Portugal)',
        espece: 'grandiflora DC.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Scrophularia',
        date_plantation: '2009',
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6da2b94c6b7b2c05c722ff0d169b42d4f5755da9',
      fields: {
        espece: 'vilmoriniana',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Ailanthus',
        date_plantation: '1973',
        famille: 'Simaroubaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e4da047e428e30dfa1e8b470fcced156180a2616',
      fields: {
        origine:
          'Honorable Municipalidad de Cochabamba - origine nature\u00a0:Parotani cbb, alt. 2515M',
        espece: 'sp.',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Lycium',
        date_plantation: '2003',
        famille: 'Solanaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'aedad057e305d70da0cd48563766506a971cf650',
      fields: {
        origine: 'Remi Legros - Les Sorini\u00e8res',
        espece: 'australe',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Iochroma',
        date_plantation: '2015',
        famille: 'Solanaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5bdc5bbb1c4fce4b6a2d8802f733fe546e2c8d06',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'dasystemum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 146, 83, 1.00)',
            'rgba(145, 140, 86, 1.00)',
            'rgba(154, 134, 87, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lycium [solanaceae]/lycium dasystemum/lycium dasystemum (2).jpg',
          width: 576,
          id: '844d25ea1ffa9fb8922d32ea26206d58',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 141, 83, 1.00)',
            'rgba(127, 146, 76, 1.00)',
            'rgba(125, 145, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lycium [solanaceae]/lycium dasystemum/lycium dasystemum (3).jpg',
          width: 576,
          id: 'cfde248c2beca9bd5ad5c6e116e0ee1f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 146, 86, 1.00)',
            'rgba(143, 130, 77, 1.00)',
            'rgba(156, 131, 85, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lycium [solanaceae]/lycium dasystemum/lycium dasystemum (1).jpg',
          width: 576,
          id: '0a75167e31a6141e7becdc25d650ef2c',
          height: 768,
          thumbnail: true,
        },
        location: [47.271139, -1.582783],
        genre: 'Lycium',
        famille: 'Solanaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582783, 47.271139] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '16f424629eadaa391ad235afd3d2a0eff796fc82',
      fields: {
        espece: 'corymbosa',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(168, 184, 172, 1.00)',
            'rgba(100, 112, 51, 1.00)',
            'rgba(99, 105, 49, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pterostyrax [styracaceae]/pterostyrax corymbosa/pterostyrax corymbosa  (6).jpg',
          width: 512,
          id: 'cc8bb28cc87635c45b7ccfdb85197594',
          height: 768,
          thumbnail: true,
        },
        location: [47.271067, -1.584813],
        genre: 'Pterostyrax',
        famille: 'Styracaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584813, 47.271067] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '551369c56786e5ecb7a17310b6a47fc28dfae0e6',
      fields: {
        espece: 'tetrandra',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 131, 84, 1.00)',
            'rgba(141, 137, 104, 1.00)',
            'rgba(103, 104, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tamarix [tamaricaceae]/tamarix tetrandra/tamarix tetrandra.jpg',
          width: 576,
          id: 'ff0fd6b65dc01ab8b1c88cd69a8330e9',
          height: 768,
          thumbnail: true,
        },
        location: [47.271122, -1.584537],
        genre: 'Tamarix',
        famille: 'Tamaricaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584537, 47.271122] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '90b7746372b6a79e6e3aef21323a08a828221c92',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 169, 135, 1.00)',
            'rgba(110, 138, 95, 1.00)',
            'rgba(91, 106, 67, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'inspiration'/camellia 'inspiration' (3).jpg",
          width: 576,
          id: 'fd123a47ed9839ab0fa2e6066c3e9c13',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 168, 166, 1.00)',
            'rgba(89, 99, 81, 1.00)',
            'rgba(69, 72, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'inspiration'/camellia 'inspiration' (4).jpg",
          width: 1024,
          id: 'd71a223d3bd7258ca0e9d616bddcd930',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(31, 47, 33, 1.00)',
            'rgba(112, 82, 97, 1.00)',
            'rgba(96, 72, 82, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'inspiration'/camellia 'inspiration' (2).jpg",
          width: 1024,
          id: 'ab96b4bf6baab5d507d8be3d7eed1b58',
          height: 683,
          thumbnail: true,
        },
        location: [47.27003, -1.583742],
        genre: 'Camellia',
        cultivar: 'Inspiration',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583742, 47.27003] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2fb026ab695f1e933cd4434f8cc64d6cbe2dfe3f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 94, 65, 1.00)',
            'rgba(139, 138, 119, 1.00)',
            'rgba(79, 80, 63, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'scentuous'/camellia 'scentuous' (1).jpg",
          width: 576,
          id: '9999f97da78ace553908a949444030bf',
          height: 768,
          thumbnail: true,
        },
        location: [47.269688, -1.583667],
        genre: 'Camellia',
        cultivar: 'Scentuous',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583667, 47.269688] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '62b726867cc52105872ae7024ab1ca9ba10cef34',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 64, 59, 1.00)',
            'rgba(134, 74, 105, 1.00)',
            'rgba(67, 50, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'show girl'/camellia 'show girl' (2).jpg",
          width: 1024,
          id: '8f0f7db33ecdd47c793d76411670e778',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(57, 45, 41, 1.00)',
            'rgba(111, 66, 74, 1.00)',
            'rgba(72, 55, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'show girl'/camellia 'show girl' (3).jpg",
          width: 1024,
          id: '9c69f06a4d1ec2c0514e26a5217eb194',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 132, 121, 1.00)',
            'rgba(88, 81, 57, 1.00)',
            'rgba(97, 91, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'show girl'/camellia 'show girl' (1).jpg",
          width: 1024,
          id: 'f3bd41f20346fe8eb6cb3adfc2678005',
          height: 695,
          thumbnail: true,
        },
        location: [47.269337, -1.584372],
        genre: 'Camellia',
        cultivar: 'Show Girl',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584372, 47.269337] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0babd6bfca5b6542a26bf0541915686f107c8e3c',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(37, 43, 24, 1.00)',
            'rgba(119, 113, 70, 1.00)',
            'rgba(76, 84, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'showa-wabisuke'/camellia 'showa-wabisuke' (5).jpg",
          width: 1024,
          id: '68f7b3cbf97baada8452936a06a556d1',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(60, 77, 34, 1.00)',
            'rgba(100, 116, 50, 1.00)',
            'rgba(111, 107, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'showa-wabisuke'/camellia 'showa-wabisuke' (4).jpg",
          width: 1024,
          id: '64e894e3b9c8bc921fcdf33154a391d1',
          height: 683,
          thumbnail: true,
        },
        location: [47.269695, -1.58165],
        genre: 'Camellia',
        cultivar: 'Sh\u00f4wa-wabisuke',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58165, 47.269695] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a7499f4e5a39669aed8ce0ff2d863e08d17b6328',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(59, 69, 48, 1.00)',
            'rgba(113, 116, 110, 1.00)',
            'rgba(50, 65, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'winton'/camellia 'winton' (10).jpg",
          width: 512,
          id: 'a9ebaa00631a80754184704c7b8ae472',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 156, 141, 1.00)',
            'rgba(106, 115, 86, 1.00)',
            'rgba(123, 119, 77, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'winton'/camellia 'winton' (2).jpg",
          width: 1024,
          id: 'b09d6d74fc5dab637cde8059fc5abff0',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 115, 109, 1.00)',
            'rgba(105, 115, 103, 1.00)',
            'rgba(75, 91, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'winton'/camellia 'winton' (1).jpg",
          width: 512,
          id: '2f14093e397d5060f9c5eba0b8f91a35',
          height: 768,
          thumbnail: true,
        },
        location: [47.27022, -1.58388],
        genre: 'Camellia',
        cultivar: 'Winton',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58388, 47.27022] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8f3fa18cd8593cb2d7daf91143877b158c4f6ed1',
      fields: {
        espece: 'grijsii',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 114, 59, 1.00)',
            'rgba(123, 136, 65, 1.00)',
            'rgba(119, 136, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia grijsii 'zhenzhu cha'/camellia grijsii 'zhenzhu cha' (3).jpg",
          width: 576,
          id: '6b3b54475bd69c0fc4aaf6bb11e48aab',
          height: 768,
          thumbnail: true,
        },
        location: [47.269918, -1.586144],
        genre: 'Camellia',
        cultivar: 'Zhenzhu Cha',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586144, 47.269918] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '13bebfec58f02b41b7598ebc50b76ac093a065b4',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 168, 152, 1.00)',
            'rgba(94, 97, 93, 1.00)',
            'rgba(93, 81, 77, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia hiemalis 'kanjiro'/camellia hiemalis 'kanjiro' (2).jpg",
          width: 1024,
          id: '2cc3f428a0b7aa3f21ecba5a20d1da1b',
          height: 683,
          thumbnail: true,
        },
        espece: 'hiemalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 82, 87, 1.00)',
            'rgba(123, 46, 70, 1.00)',
            'rgba(69, 35, 44, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia hiemalis 'kanjiro'/camellia hiemalis 'kanjiro' (1).jpg",
          width: 1024,
          id: '4df9396e88450f0ef8a114092311f187',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 87, 68, 1.00)',
            'rgba(113, 83, 77, 1.00)',
            'rgba(72, 63, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia hiemalis 'kanjiro'/camellia hiemalis 'kanjiro'  (2).jpg",
          width: 1024,
          id: 'f5f5a86776ca168315ee45c97da9f93b',
          height: 683,
          thumbnail: true,
        },
        location: [47.27026, -1.586547],
        genre: 'Camellia',
        cultivar: 'Kanjir\u00f4',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586547, 47.27026] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6b9089fdd4e711b70037a0689db08c173bafd2d6',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(29, 52, 44, 1.00)',
            'rgba(75, 83, 65, 1.00)',
            'rgba(46, 51, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia hiemalis 'kasane-ogi'/camellia hiemalis 'kasane-ogi' (5).jpg",
          width: 1024,
          id: '27700951df899106c34d4802813518be',
          height: 683,
          thumbnail: true,
        },
        espece: 'hiemalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(36, 54, 48, 1.00)',
            'rgba(88, 94, 78, 1.00)',
            'rgba(52, 64, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia hiemalis 'kasane-ogi'/camellia hiemalis 'kasane-ogi' (4).jpg",
          width: 1024,
          id: '9ad7ec662f86d9873b1321f03d4dac65',
          height: 681,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 149, 138, 1.00)',
            'rgba(91, 102, 94, 1.00)',
            'rgba(93, 83, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia hiemalis 'kasane-ogi'/camellia hiemalis 'kasane-ogi' (2).jpg",
          width: 1024,
          id: '951c9d354e44939404c8d88ff752bbfd',
          height: 683,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Kasane-\u00f4gi',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0d07166b2c7d9f6c802134ee8f06b7c2bdf626ba',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 66, 61, 1.00)',
            'rgba(110, 89, 83, 1.00)',
            'rgba(48, 51, 37, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'berenice boddy'/camellia japonica 'berenice boddy' (5).jpg",
          width: 1024,
          id: '11c80ddf626a68ca195b0f2a81c5fde7',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 65, 62, 1.00)',
            'rgba(92, 86, 82, 1.00)',
            'rgba(82, 89, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'berenice boddy'/camellia japonica 'berenice boddy' (3).jpg",
          width: 1024,
          id: '93e18827e20eb3250deb6fae4a608630',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 110, 92, 1.00)',
            'rgba(78, 87, 64, 1.00)',
            'rgba(118, 114, 96, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'berenice boddy'/camellia japonica 'berenice boddy' (2).jpg",
          width: 1024,
          id: 'a0c5d03f2cb7efb0a89f3d6e2e37790c',
          height: 683,
          thumbnail: true,
        },
        location: [47.27026, -1.586547],
        genre: 'Camellia',
        cultivar: 'Berenice Boddy',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586547, 47.27026] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '23f37e03e5ccc55e1165136e492286729c7a6998',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 81, 59, 1.00)',
            'rgba(108, 64, 76, 1.00)',
            'rgba(102, 55, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'betty sheffield pink'/camellia japonica 'betty sheffield pink'.jpg",
          width: 1024,
          id: 'bd6a4b9d2e71b8ab6d22884d3d18ae88',
          height: 683,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Camellia',
        cultivar: 'Betty Sheffield Pink',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '04cc614aebb6a14531b0831b45dc589c14a99579',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 149, 146, 1.00)',
            'rgba(109, 86, 91, 1.00)',
            'rgba(80, 73, 87, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'castille'/camellia japonica 'castille'.jpg",
          width: 1024,
          id: '4f02b718f6f4273bd88e9acd452a3b7e',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 91, 74, 1.00)',
            'rgba(119, 61, 49, 1.00)',
            'rgba(78, 48, 35, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'castille'/camellia japonica 'castille' (2).jpg",
          width: 1024,
          id: '2ac07f12cbed7201bf521603aa655d71',
          height: 711,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 167, 162, 1.00)',
            'rgba(98, 105, 87, 1.00)',
            'rgba(92, 88, 74, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'castille'/camellia japonica 'castille' (1).jpg",
          width: 1024,
          id: '5968700e2258387c7dbae1e0c5bce558',
          height: 683,
          thumbnail: true,
        },
        location: [47.27026, -1.586547],
        genre: 'Camellia',
        cultivar: 'Castille',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586547, 47.27026] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5bcd3fa30a6afd3e8ef0246c4153904537cb3ffb',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 83, 68, 1.00)',
            'rgba(170, 156, 151, 1.00)',
            'rgba(137, 126, 130, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'destiny'/camellia japonica 'destiny'.jpg",
          width: 1024,
          id: 'aa79cea7e4cf163d7f807c9713b6805a',
          height: 697,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Destiny',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9f6025c7c1cc4e3f2cf9d83934881efba76269a0',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 67, 56, 1.00)',
            'rgba(121, 105, 90, 1.00)',
            'rgba(64, 63, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'flamingo'/camellia japonica 'flamingo' (5).jpg",
          width: 1024,
          id: 'abdefc7986469a91eabbc87c39a7f9f1',
          height: 660,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 78, 60, 1.00)',
            'rgba(118, 106, 85, 1.00)',
            'rgba(64, 70, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'flamingo'/camellia japonica 'flamingo' (4).jpg",
          width: 1024,
          id: '1d92f8fc14fdb54f8c1d1bbd1851d5b7',
          height: 705,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 128, 126, 1.00)',
            'rgba(148, 119, 84, 1.00)',
            'rgba(109, 97, 90, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'flamingo'/camellia japonica 'flamingo' (3).jpg",
          width: 1024,
          id: 'fbd30fa130f745bfd17c097f2c4a2969',
          height: 682,
          thumbnail: true,
        },
        location: [47.270464, -1.584528],
        genre: 'Camellia',
        cultivar: 'Flamingo',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584528, 47.270464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5624fe93fd76d684d5a9a98d87a79dc706e457ff',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 85, 88, 1.00)',
            'rgba(140, 115, 127, 1.00)',
            'rgba(79, 74, 83, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'fleur dipater'/camellia japonica 'fleur dipater'.jpg",
          width: 1024,
          id: '82736c2dfdaeda8f3f02a27a5e9b49d5',
          height: 625,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 78, 68, 1.00)',
            'rgba(116, 109, 103, 1.00)',
            'rgba(75, 75, 63, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'fleur dipater'/camellia japonica 'fleur dipater' (2).jpg",
          width: 1024,
          id: 'a0dc5f1459d91ab85a2a688bba889786',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 130, 121, 1.00)',
            'rgba(93, 99, 91, 1.00)',
            'rgba(109, 100, 97, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'fleur dipater'/camellia japonica 'fleur dipater' (1).jpg",
          width: 1024,
          id: '0b1bfb0c879b0433183feb78d466c5ba',
          height: 683,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Fleur Dipater',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '786b1259788e1ec52807a79c57617dd577486535',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(60, 56, 49, 1.00)',
            'rgba(166, 126, 123, 1.00)',
            'rgba(83, 70, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'furo-an'/camellia japonica 'furo-an'.jpg",
          width: 576,
          id: '0ffd84d18747b0050f9c46d35c668600',
          height: 768,
          thumbnail: true,
        },
        location: [47.27018, -1.586022],
        genre: 'Camellia',
        cultivar: 'Fur\u00f4-an',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586022, 47.27018] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '46a066a8f48498246e4b408d0552d944f8019b9b',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 119, 79, 1.00)',
            'rgba(104, 81, 62, 1.00)',
            'rgba(68, 64, 36, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'hakuhan-kujaku'/camellia japonica 'hakuhan-kujaku'.jpg",
          width: 1024,
          id: '4a2ef8eb7df95b5ba4245eee6fc43661',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 120, 88, 1.00)',
            'rgba(115, 111, 76, 1.00)',
            'rgba(70, 80, 38, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'hakuhan-kujaku'/camellia japonica 'hakuhan-kujaku' (4).jpg",
          width: 1024,
          id: 'c564444163e46ec713ba8ccd20a8a8a5',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 156, 117, 1.00)',
            'rgba(103, 119, 78, 1.00)',
            'rgba(92, 96, 65, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'hakuhan-kujaku'/camellia japonica 'hakuhan-kujaku' (3).jpg",
          width: 1024,
          id: 'd5044003e2b2a6f85c6c1aebb7fb4755',
          height: 683,
          thumbnail: true,
        },
        location: [47.270528, -1.581275],
        genre: 'Camellia',
        cultivar: 'Hakuhan-kujaku',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581275, 47.270528] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5e93ffe54f74584eef60aeffd8aefe1801508eaa',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 144, 104, 1.00)',
            'rgba(94, 110, 72, 1.00)',
            'rgba(100, 107, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'kingyo-tsubaki'/camellia japonica 'kingyo-tsubaki' (9).jpg",
          width: 1024,
          id: '55c3cb615c7ef2dadd0e993a605093b3',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 111, 74, 1.00)',
            'rgba(105, 124, 85, 1.00)',
            'rgba(88, 111, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'kingyo-tsubaki'/camellia japonica 'kingyo-tsubaki' (8).jpg",
          width: 1024,
          id: '64567f25b28258c3a083171e6841c247',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 67, 48, 1.00)',
            'rgba(145, 80, 73, 1.00)',
            'rgba(94, 60, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'kingyo-tsubaki'/camellia japonica 'kingyo-tsubaki' (6).jpg",
          width: 1024,
          id: '5c9c329f8e33a476b219cd3a574365ef',
          height: 738,
          thumbnail: true,
        },
        location: [47.26983, -1.584308],
        genre: 'Camellia',
        cultivar: 'Kingyo-tsubaki',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584308, 47.26983] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f16a03b1a89889a002773cac254d15c52d3aef66',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 86, 61, 1.00)',
            'rgba(145, 75, 70, 1.00)',
            'rgba(84, 49, 36, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'latifolia'/camellia japonica 'latifolia' (3).jpg",
          width: 1024,
          id: '62c0cba6e3076e7dc3d889ec103f5e4d',
          height: 698,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 144, 115, 1.00)',
            'rgba(86, 100, 63, 1.00)',
            'rgba(87, 83, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'latifolia'/camellia japonica 'latifolia' (2).jpg",
          width: 1024,
          id: 'c9eabc908a7290d78da975e9802c7f44',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(69, 78, 54, 1.00)',
            'rgba(134, 81, 82, 1.00)',
            'rgba(116, 74, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'latifolia'/camellia japonica 'latifolia' (1).jpg",
          width: 1024,
          id: '5c1ed0954cda146b2c8e46ee732602ed',
          height: 643,
          thumbnail: true,
        },
        location: [47.270428, -1.584117],
        genre: 'Camellia',
        cultivar: 'Latifolia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584117, 47.270428] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9985187dff05ffbdc8d83a315900a615a3051166',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 169, 127, 1.00)',
            'rgba(79, 96, 60, 1.00)',
            'rgba(96, 88, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'little slam'/camellia japonica 'little slam'.jpg",
          width: 512,
          id: 'fde48990fb5e16036fa526c0554a1a48',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 85, 67, 1.00)',
            'rgba(136, 59, 66, 1.00)',
            'rgba(98, 58, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'little slam'/camellia japonica 'little slam' (3).jpg",
          width: 1024,
          id: '5e21fb5ceaa7b607e8911418755e7d37',
          height: 577,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 140, 128, 1.00)',
            'rgba(119, 84, 76, 1.00)',
            'rgba(86, 71, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'little slam'/camellia japonica 'little slam' (1).jpg",
          width: 1024,
          id: 'cf6817b9994c61ff6d57eb36f2a8a5f3',
          height: 683,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Camellia',
        cultivar: 'Little Slam',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '38bbd911f222aa2af93376a1e25af5c5e073123a',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 145, 85, 1.00)',
            'rgba(131, 150, 76, 1.00)',
            'rgba(109, 123, 39, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'maria bagnasco'/camellia japonica 'maria bagnasco' (2).jpg",
          width: 576,
          id: 'b0ebfe102bac6c7cfe8e9a8bc2d58340',
          height: 768,
          thumbnail: true,
        },
        location: [47.271408, -1.58442],
        genre: 'Camellia',
        cultivar: 'Maria Bagnasco',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58442, 47.271408] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8965ea6c881bf02349c7a129d55548a7d2eb5fa4',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 128, 128, 1.00)',
            'rgba(175, 140, 109, 1.00)',
            'rgba(165, 138, 121, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'moonlight bay'/camellia japonica 'moonlight bay' (3).jpg",
          width: 1024,
          id: '97436b15bf1569c61c81d972f29f6f31',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(62, 64, 53, 1.00)',
            'rgba(126, 117, 116, 1.00)',
            'rgba(99, 98, 102, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'moonlight bay'/camellia japonica 'moonlight bay' (2).jpg",
          width: 1024,
          id: '606583d9a893197b499eade5a3c9907b',
          height: 655,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 97, 69, 1.00)',
            'rgba(123, 131, 94, 1.00)',
            'rgba(126, 121, 101, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'moonlight bay'/camellia japonica 'moonlight bay' (1).jpg",
          width: 1024,
          id: 'c4a368368526d1759a8b57a615bfd76c',
          height: 683,
          thumbnail: true,
        },
        location: [47.269578, -1.5838],
        genre: 'Camellia',
        cultivar: 'Moonlight Bay',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5838, 47.269578] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2a14183c955ac6638a7c6682f33fdf85f8961682',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 61, 48, 1.00)',
            'rgba(135, 62, 71, 1.00)',
            'rgba(89, 61, 52, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'mrs tingley'/camellia japonica 'mrs tingley' (3).jpg",
          width: 1024,
          id: 'b5eacf8c5f5ac52599c6f5121cd6605f',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 124, 120, 1.00)',
            'rgba(106, 96, 76, 1.00)',
            'rgba(90, 78, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'mrs tingley'/camellia japonica 'mrs tingley' (2).jpg",
          width: 1024,
          id: '624b05d6e8d47af3dd052bb2d268b101',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 91, 82, 1.00)',
            'rgba(122, 83, 71, 1.00)',
            'rgba(104, 68, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'mrs tingley'/camellia japonica 'mrs tingley' (1).jpg",
          width: 512,
          id: '529fb17ee432c93db0eb50e70dfcfe1c',
          height: 768,
          thumbnail: true,
        },
        location: [47.27026, -1.586547],
        genre: 'Camellia',
        cultivar: 'Mrs Tingley',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586547, 47.27026] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8523c8db723a9d4dc6821c439367a5789faee004',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(69, 58, 47, 1.00)',
            'rgba(132, 57, 68, 1.00)',
            'rgba(75, 40, 33, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'niobe'/camellia japonica 'niobe' (4).jpg",
          width: 1024,
          id: 'b26236b96263365ab16849601a3b39cb',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 123, 85, 1.00)',
            'rgba(87, 106, 72, 1.00)',
            'rgba(67, 89, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'niobe'/camellia japonica 'niobe' (3).jpg",
          width: 1024,
          id: '7bf3494211d514e7157395fbe948ea9f',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 91, 69, 1.00)',
            'rgba(114, 45, 48, 1.00)',
            'rgba(81, 41, 35, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'niobe'/camellia japonica 'niobe' (2).jpg",
          width: 1024,
          id: '1fd743f4d289c4428930c7d26816d370',
          height: 683,
          thumbnail: true,
        },
        location: [47.271445, -1.58205],
        genre: 'Camellia',
        cultivar: 'Niob\u00e9',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58205, 47.271445] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8e21d0b3eacb0e0ff768a9775390710e73ee4895',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 94, 66, 1.00)',
            'rgba(80, 92, 63, 1.00)',
            'rgba(104, 101, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'nuccio's gem'/camellia japonica 'nuccio's gem' (3).jpg",
          width: 1024,
          id: '344c0ee040e4b01ec4ae8ab32aebe938',
          height: 683,
          thumbnail: true,
        },
        location: [47.26957, -1.585517],
        genre: 'Camellia',
        cultivar: "Nuccio's Gem",
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585517, 47.26957] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f94fb60475389cefc16d738af6e9159c58e8dc77',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 70, 47, 1.00)',
            'rgba(117, 83, 83, 1.00)',
            'rgba(59, 52, 43, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'prosper vial'/camellia japonica 'prosper vial' (3).jpg",
          width: 1024,
          id: '6e7efadbe685c6eba45ed0249e06c2ef',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 157, 124, 1.00)',
            'rgba(54, 83, 43, 1.00)',
            'rgba(37, 61, 30, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'prosper vial'/camellia japonica 'prosper vial' (2).jpg",
          width: 657,
          id: '726cfb776c3558103f1ef4f7cb3ff8b2',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 126, 118, 1.00)',
            'rgba(136, 116, 103, 1.00)',
            'rgba(48, 56, 36, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'prosper vial'/camellia japonica 'prosper vial' (1).jpg",
          width: 1024,
          id: 'fefe83f6167003681b98f32e581d7c52',
          height: 683,
          thumbnail: true,
        },
        location: [47.269467, -1.5851],
        genre: 'Camellia',
        cultivar: 'Prosper Vial',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5851, 47.269467] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7aadff75f1f649b4df0489dd7d1ccd4f3dac782c',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 69, 72, 1.00)',
            'rgba(166, 43, 66, 1.00)',
            'rgba(77, 41, 35, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'red ensign'/camellia japonica 'red ensign' (4).jpg",
          width: 1024,
          id: 'e71a9d11c5e6ce390c689d4c6c8ffdf1',
          height: 673,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 146, 138, 1.00)',
            'rgba(77, 87, 57, 1.00)',
            'rgba(75, 81, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'red ensign'/camellia japonica 'red ensign' (3).jpg",
          width: 1024,
          id: '555a87e064ce7ec9bf8248df49a417c6',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 85, 70, 1.00)',
            'rgba(117, 50, 42, 1.00)',
            'rgba(84, 58, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'red ensign'/camellia japonica 'red ensign' (1).jpg",
          width: 1024,
          id: 'f18120d2fa2d8ebd21b41c62235035e3',
          height: 683,
          thumbnail: true,
        },
        location: [47.27052, -1.585378],
        genre: 'Camellia',
        cultivar: 'Red Ensign',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585378, 47.27052] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '20db7226da22f44b947677f7b68e02b30c6ac253',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 140, 127, 1.00)',
            'rgba(111, 128, 113, 1.00)',
            'rgba(79, 89, 74, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'shokoshi'/camellia japonica 'shokoshi' (1).jpg",
          width: 1024,
          id: '27e0dac74369aa2d7d57410549d41f4e',
          height: 683,
          thumbnail: true,
        },
        location: [47.269537, -1.58548],
        genre: 'Camellia',
        cultivar: 'Sh\u00f4k\u00f4shi',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58548, 47.269537] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9926a4567a7028e4b0aacc0990fdbddac6b8ab74',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(25, 46, 33, 1.00)',
            'rgba(89, 89, 98, 1.00)',
            'rgba(95, 86, 94, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'tamagasumi'/camellia japonica 'tamagasumi' (3).jpg",
          width: 1024,
          id: '16363ab3f7893bb21601af953e43ce9a',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(37, 53, 46, 1.00)',
            'rgba(125, 113, 116, 1.00)',
            'rgba(71, 77, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'tamagasumi'/camellia japonica 'tamagasumi' (2).jpg",
          width: 1024,
          id: 'e49d24c9d55d1c913fd4d83935cddfc5',
          height: 671,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(34, 42, 48, 1.00)',
            'rgba(137, 115, 145, 1.00)',
            'rgba(94, 77, 93, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'tamagasumi'/camellia japonica 'tamagasumi' (1).jpg",
          width: 1008,
          id: '1a076e4ef5bf2682bb04e4126b589e34',
          height: 768,
          thumbnail: true,
        },
        location: [47.271437, -1.58303],
        genre: 'Camellia',
        cultivar: 'Tamagasumi',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58303, 47.271437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3529ed26868c8d6acf96a9846ca2bb615327cbaa',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 74, 51, 1.00)',
            'rgba(109, 85, 82, 1.00)',
            'rgba(93, 60, 67, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'wakanoura'/camellia japonica 'wakanoura' (2).jpg",
          width: 1024,
          id: 'c02729fead12c4238696df8072486a83',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 60, 54, 1.00)',
            'rgba(115, 75, 79, 1.00)',
            'rgba(97, 75, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'wakanoura'/camellia japonica 'wakanoura' (1).jpg",
          width: 1024,
          id: '544b9c0dabb7b54aec7ac8c09acb6de1',
          height: 683,
          thumbnail: true,
        },
        location: [47.267822, -1.58385],
        genre: 'Camellia',
        cultivar: 'Wakanoura',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58385, 47.267822] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'de9b69a89c9ce57a12c0d69c1186d7755f08c2cf',
      fields: {
        espece: 'sasanqua',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 110, 88, 1.00)',
            'rgba(94, 96, 86, 1.00)',
            'rgba(106, 101, 94, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'duffy allan'/camellia sasanqua 'duffy allan'.jpg",
          width: 1024,
          id: '5b223413c4b47ca143663bfe13a8af37',
          height: 683,
          thumbnail: true,
        },
        location: [47.26817, -1.584355],
        genre: 'Camellia',
        cultivar: 'Duffy Allan',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584355, 47.26817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '47da415af7df033c5ece96280bb92bcb0d5c27a1',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(63, 70, 54, 1.00)',
            'rgba(105, 73, 75, 1.00)',
            'rgba(77, 70, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'hugh evans'/camellia sasanqua 'hugh evans' (3).jpg",
          width: 1024,
          id: 'e53e584c0cda8a83afe82cef0f78c40f',
          height: 683,
          thumbnail: true,
        },
        espece: 'sasanqua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 70, 54, 1.00)',
            'rgba(101, 83, 78, 1.00)',
            'rgba(77, 76, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'hugh evans'/camellia sasanqua 'hugh evans' (2).jpg",
          width: 1024,
          id: 'c40f1722ff51392114f3ef0e41fac742',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 144, 123, 1.00)',
            'rgba(93, 100, 81, 1.00)',
            'rgba(92, 85, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'hugh evans'/camellia sasanqua 'hugh evans' (1).jpg",
          width: 1024,
          id: '32de4a8b4b5990a0fa9e81fd978be3b9',
          height: 683,
          thumbnail: true,
        },
        location: [47.269845, -1.581958],
        genre: 'Camellia',
        cultivar: 'Hugh Evans',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581958, 47.269845] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6056b889a53ab214c0df8eecd57499738661b05b',
      fields: {
        espece: 'sasanqua',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 89, 70, 1.00)',
            'rgba(108, 105, 97, 1.00)',
            'rgba(75, 79, 71, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'maiden's blush'/camellia sasanqua 'maiden's blush' (3).jpg",
          width: 1024,
          id: 'c35e04851fb781efa4311192e55c8fcb',
          height: 647,
          thumbnail: true,
        },
        location: [47.270583, -1.585706],
        genre: 'Camellia',
        cultivar: "Maiden's Blush",
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585706, 47.270583] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c63cb3c5ed5eb1bb2f5d120285eb18a38f72241d',
      fields: {
        espece: 'sasanqua',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(54, 60, 69, 1.00)',
            'rgba(107, 81, 119, 1.00)',
            'rgba(75, 64, 90, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'new dawn'/camellia sasanqua 'new dawn'.jpg",
          width: 1024,
          id: 'e914b5fa0e756ee8ad49355b397ed9dd',
          height: 683,
          thumbnail: true,
        },
        location: [47.27026, -1.586547],
        genre: 'Camellia',
        cultivar: 'New Dawn',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586547, 47.27026] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f96505bf5a49290407ac17ead5af49f6523fa4a9',
      fields: {
        espece: 'sasanqua',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(37, 43, 36, 1.00)',
            'rgba(123, 119, 107, 1.00)',
            'rgba(76, 77, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'versicolor'/camellia sasanqua 'versicolor' (4).jpg",
          width: 576,
          id: '6705dd08c5ca4e0a1751501b1a4c95eb',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Camellia',
        cultivar: 'Versicolor',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '699071df3ab01d7575227804f53ab692861aac85',
      fields: {
        espece: 'x williamsii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 68, 89, 1.00)',
            'rgba(144, 74, 83, 1.00)',
            'rgba(126, 69, 95, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'bowen bryant'/camellia x williamsii 'bowen bryant' (2).jpg",
          width: 1024,
          id: 'bcc4b9870d84da28670b343e6524f274',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 78, 73, 1.00)',
            'rgba(102, 84, 89, 1.00)',
            'rgba(77, 66, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'bowen bryant'/camellia x williamsii 'bowen bryant' (1).jpg",
          width: 1024,
          id: '475daf11e6570f00cdfbd6a9a48e4efe',
          height: 683,
          thumbnail: true,
        },
        location: [47.270362, -1.585333],
        genre: 'Camellia',
        cultivar: 'Bowen Bryant',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585333, 47.270362] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6babf2e997c0d86b21419674b860768398954ef7',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'chrysantha',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 122, 105, 1.00)',
            'rgba(117, 123, 108, 1.00)',
            'rgba(92, 107, 67, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/edgeworthia [thymelaeaceae]/edgeworthia chrysantha/edgeworthia chrysantha  (2).jpg',
          width: 576,
          id: 'e02db809a11095cd0fbdd951e4e9c012',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 134, 114, 1.00)',
            'rgba(128, 138, 110, 1.00)',
            'rgba(111, 122, 101, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/edgeworthia [thymelaeaceae]/edgeworthia chrysantha/edgeworthia chrysantha  (3).jpg',
          width: 576,
          id: 'ef49faef2ea1c9acb4a11aa132b5b5fd',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 117, 111, 1.00)',
            'rgba(127, 139, 108, 1.00)',
            'rgba(128, 138, 120, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/edgeworthia [thymelaeaceae]/edgeworthia chrysantha/edgeworthia chrysantha  (1).jpg',
          width: 576,
          id: 'd550be04fff43f61a1341a9db13294ee',
          height: 768,
          thumbnail: true,
        },
        location: [47.27097, -1.5844],
        genre: 'Edgeworthia',
        famille: 'Thymelaeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5844, 47.27097] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c723705f2676c3ab0f875dc451594b063dfe0b5b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'serrata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 62, 65, 1.00)',
            'rgba(116, 72, 74, 1.00)',
            'rgba(75, 57, 48, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/zelkova [ulmaceae]/zelkova serrata/zelkova serrata  (10).jpg',
          width: 512,
          id: '19d4287b071c31947c0bfa77d5d3e2f4',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 126, 65, 1.00)',
            'rgba(127, 142, 88, 1.00)',
            'rgba(101, 109, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/zelkova [ulmaceae]/zelkova serrata/zelkova serrata  (2).jpg',
          width: 576,
          id: 'dadcb3b45ad85abfc9c1e483a9c59d79',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 107, 51, 1.00)',
            'rgba(105, 121, 56, 1.00)',
            'rgba(100, 129, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/zelkova [ulmaceae]/zelkova serrata/zelkova serrata  (1).jpg',
          width: 576,
          id: 'b01c1ccb17d8df1714ea2612141fc015',
          height: 768,
          thumbnail: true,
        },
        location: [47.269975, -1.581728],
        genre: 'Zelkova',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581728, 47.269975] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a6fc6cdf047f11fa7009c355d6280edf6186d0e8',
      fields: {
        origine: 'JB. Jerusalem (Israel)',
        espece: 'brevicaulis J.Gay',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Asphodeline',
        date_plantation: '2010',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3cbd0736965306e640654acc5ba850b4c9bd042a',
      fields: {
        origine: 'JB.Barcelone (Espagne)',
        espece: 'cerasiferus J.Gay.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Asphodelus',
        date_plantation: '1998',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3da46ae70c245023e53f190f30841c6fa1aaf82a',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'narcissifolia Salm-Dyck',
        localisation: 'G2A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2197208, -1.5414609],
        genre: 'Bulbine',
        date_plantation: '2008',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5414609, 47.2197208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '53c8e684ab09425d4e45582e531fd869ade49d0b',
      fields: {
        origine: 'JB.Sydeny (Australie)',
        espece: 'revoluta R. Br.',
        localisation: 'G2A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2197208, -1.5414609],
        genre: 'Dianella',
        date_plantation: '1989',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5414609, 47.2197208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b73d0fa813fe01db5e569539ac092c7cbccf4fda',
      fields: {
        origine: 'Emmanuel LEPAGE',
        espece: 'purpurea Sm.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Roscoea',
        date_plantation: '2015',
        famille: 'Zingiberaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8123b8ff45d67d34a921bd6028a954cfba930b42',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'officinale',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(190, 195, 192, 1.00)',
            'rgba(108, 101, 79, 1.00)',
            'rgba(51, 72, 23, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/guaiacum [zygophyllaceae]/guaiacum officinale/guaiacum officinale (2).jpg",
          width: 576,
          id: '2d2fe2657f9ddfeb7365087b7adc6ea5',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 149, 93, 1.00)',
            'rgba(123, 151, 55, 1.00)',
            'rgba(101, 118, 48, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/guaiacum [zygophyllaceae]/guaiacum officinale/guaiacum officinale (3).jpg",
          width: 576,
          id: 'c1eaed9ca5397952b2713587a7e0ad50',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 173, 95, 1.00)',
            'rgba(118, 150, 42, 1.00)',
            'rgba(101, 126, 25, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/guaiacum [zygophyllaceae]/guaiacum officinale/guaiacum officinale (1).jpg",
          width: 576,
          id: 'a227903b5e780d338368a2c00b2605a0',
          height: 768,
          thumbnail: true,
        },
        location: [47.226962, -1.511888],
        genre: 'Guaiacum',
        famille: 'Zygophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.511888, 47.226962] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '267f0d5d65f33fe85c7c36dd2a2abd725463e8b8',
      fields: {
        espece: 'distichum',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 74, 64, 1.00)',
            'rgba(142, 126, 106, 1.00)',
            'rgba(140, 120, 98, 1.00)',
          ],
          filename:
            'ip parc de proce/abeliophyllum/abeliophyllum distichum/abeliophyllum distichum (2).jpg',
          width: 1016,
          id: 'dd024c01aa9295a289e3744241addab9',
          height: 768,
          thumbnail: true,
        },
        location: [47.225903, -1.581917],
        genre: 'Abeliophyllum',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581917, 47.225903] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e42a58a13c2ea68bd8c51736b5a612b7e6a7a2c4',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'campbellii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 170, 83, 1.00)',
            'rgba(120, 141, 41, 1.00)',
            'rgba(112, 126, 37, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/acer/acer campbellii/acer campbellii (1).jpg',
          width: 576,
          id: '57a82dc1f4250cdb21c5ed17d009be16',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 137, 65, 1.00)',
            'rgba(123, 144, 52, 1.00)',
            'rgba(106, 144, 33, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/acer/acer campbellii/acer campbellii (2).jpg',
          width: 576,
          id: 'ae94d1103bbe5c828662732dc7646d85',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(183, 195, 163, 1.00)',
            'rgba(102, 110, 43, 1.00)',
            'rgba(79, 95, 37, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/acer/acer campbellii/acer campbellii  (2).jpg',
          width: 576,
          id: 'd7c34e73e4f56cc98b54c88d4c56cbf8',
          height: 768,
          thumbnail: true,
        },
        location: [47.220667, -1.543162],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543162, 47.220667] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5e7fcbdeffb551d6abccc935434a805f558d4a89',
      fields: {
        espece: 'henryi',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 119, 70, 1.00)',
            'rgba(110, 120, 68, 1.00)',
            'rgba(96, 106, 57, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/acer/acer henryi/acer henryi (4).jpg',
          width: 1024,
          id: '6feae550431106dbeac35f5e75a9f5cb',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 175, 169, 1.00)',
            'rgba(81, 94, 46, 1.00)',
            'rgba(95, 103, 60, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/acer/acer henryi/acer henryi (1).jpg',
          width: 884,
          id: '7840b285cbcaea85ba93cdb45b679583',
          height: 768,
          thumbnail: true,
        },
        location: [47.22062, -1.543472],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543472, 47.22062] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '508e6be8ad796382a1b697aea2470061ef501a90',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'triflorum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 143, 182, 1.00)',
            'rgba(129, 132, 89, 1.00)',
            'rgba(118, 122, 88, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/acer/acer triflorum/acer triflorum (3).jpg',
          width: 576,
          id: 'd89918e920b3230565d4a89db868e02d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(167, 185, 198, 1.00)',
            'rgba(132, 123, 89, 1.00)',
            'rgba(100, 91, 66, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/acer/acer triflorum/acer triflorum (4).jpg',
          width: 576,
          id: '4981831ff590ffedce99ab914236f27d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 122, 81, 1.00)',
            'rgba(136, 137, 106, 1.00)',
            'rgba(114, 120, 90, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/acer/acer triflorum/acer triflorum (1).jpg',
          width: 576,
          id: 'f6a5e55a5a2015ef5951cdfd67bb2e0d',
          height: 768,
          thumbnail: true,
        },
        location: [47.220883, -1.544075],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544075, 47.220883] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '49d036fc6865f905619dd0d87de486d93b62435b',
      fields: {
        espece: 'palmatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 135, 53, 1.00)',
            'rgba(120, 134, 54, 1.00)',
            'rgba(112, 122, 50, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer palmatum 'linearilobum'/acer palmatum 'linearilobum' (2).jpg",
          width: 576,
          id: 'ed1008be68df7d61f152a4ece04f1e48',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 108, 70, 1.00)',
            'rgba(120, 136, 69, 1.00)',
            'rgba(121, 134, 77, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer palmatum 'linearilobum'/acer palmatum 'linearilobum' (1).jpg",
          width: 1024,
          id: 'e48fc116b8f79d7e8ab8801fa8a8cdcc',
          height: 768,
          thumbnail: true,
        },
        location: [47.222958, -1.579672],
        genre: 'Acer',
        cultivar: 'Linearilobum',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.579672, 47.222958] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e0255a5185a121d4058647def07f6173ec91cd5d',
      fields: {
        espece: 'saccharinum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 142, 101, 1.00)',
            'rgba(135, 102, 54, 1.00)',
            'rgba(102, 82, 23, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/acer/acer saccharinum/acer saccharinum (2).jpg',
          width: 576,
          id: '62ba40ee1e039322ec8282afe0f4991b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 184, 205, 1.00)',
            'rgba(106, 112, 81, 1.00)',
            'rgba(84, 95, 48, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/acer/acer saccharinum/acer saccharinum (1).jpg',
          width: 1024,
          id: 'fabeb6630cf2ce1dc72acbcbcef79c2c',
          height: 768,
          thumbnail: true,
        },
        location: [47.227342, -1.510213],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.510213, 47.227342] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8efdacbabd92b0c11041b846cceb9e17906cd4f5',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'californica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 137, 193, 1.00)',
            'rgba(91, 111, 118, 1.00)',
            'rgba(80, 95, 88, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/aesculus/aesculus californica/aesculus californica (1).jpg',
          width: 512,
          id: '9a8e0c14ad40d149973da83f5e327439',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 144, 96, 1.00)',
            'rgba(126, 148, 100, 1.00)',
            'rgba(152, 149, 98, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/aesculus/aesculus californica/aesculus californica (2).jpg',
          width: 576,
          id: '646b8f0fd873bd85b1a90875d5784613',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 127, 81, 1.00)',
            'rgba(132, 147, 108, 1.00)',
            'rgba(146, 144, 99, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/aesculus/aesculus californica/aesculus californica  (1).jpg',
          width: 576,
          id: 'b15edb18e667d9957928960ab3255c61',
          height: 768,
          thumbnail: true,
        },
        location: [47.220997, -1.542617],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542617, 47.220997] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4043bfdd40333737ca522e841907388dc8c30f4b',
      fields: {
        espece: 'x woerlitzensis',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 144, 170, 1.00)',
            'rgba(99, 96, 85, 1.00)',
            'rgba(146, 128, 97, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/aesculus/aesculus x woerlitzensis/aesculus x woerlitzensis.jpg',
          width: 576,
          id: 'a041bf6575c8c30043a7c02244f41e7c',
          height: 768,
          thumbnail: true,
        },
        location: [47.219537, -1.541337],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541337, 47.219537] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6fb6c7a72840ae0b1a84a497b15db747dac407fc',
      fields: {
        espece: 'julibrissin',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 183, 155, 1.00)',
            'rgba(105, 124, 73, 1.00)',
            'rgba(80, 99, 56, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/albizia/albizia julibrissin/albizia julibrissin.jpg',
          width: 1024,
          id: 'ed417470c6dc8eaced656bf528d7eb0f',
          height: 752,
          thumbnail: true,
        },
        location: [47.219563, -1.543328],
        genre: 'Albizia',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543328, 47.219563] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4054747954b34e31aff4e768b1cc3837b0fa28f9',
      fields: {
        espece: 'julibrissin',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(187, 190, 168, 1.00)',
            'rgba(83, 93, 46, 1.00)',
            'rgba(54, 64, 25, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/albizia/albizia julibrissin/albizia julibrissin .jpg',
          width: 922,
          id: 'ec9e19ed6c8d7cf4315759e22b7d1f66',
          height: 768,
          thumbnail: true,
        },
        location: [47.26165, -1.533305],
        genre: 'Albizia',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533305, 47.26165] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '304cde187b5033241bf3eb98c3bc5c00436c12d2',
      fields: {
        espece: 'x reyorum',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 109, 75, 1.00)',
            'rgba(105, 108, 72, 1.00)',
            'rgba(84, 90, 54, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/arbutus/arbutus x reyorum 'marina'/arbutus x reyorum 'marina'.jpg",
          width: 512,
          id: '2623edc26c47cf3d3fb369ffe838d38e',
          height: 768,
          thumbnail: true,
        },
        location: [47.228003, -1.508228],
        genre: 'Arbutus',
        cultivar: 'Marina',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508228, 47.228003] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e84d2914cdafac4782bf2ecf66d7345d71cf24b2',
      fields: {
        espece: 'serrata',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 111, 53, 1.00)',
            'rgba(107, 124, 59, 1.00)',
            'rgba(121, 144, 75, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/azara/azara serrata/azara serrata .jpg',
          width: 1024,
          id: '3fb14626c1d6af14a8bd50f8ecf2f8e0',
          height: 768,
          thumbnail: true,
        },
        location: [47.21898, -1.542983],
        genre: 'Azara',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542983, 47.21898] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a46e22885b6871c53bc1472ff20af012360f9691',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 160, 101, 1.00)',
            'rgba(128, 140, 65, 1.00)',
            'rgba(127, 137, 61, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/buddleja/buddleja japonica/buddleja japonica (1).jpg',
          width: 642,
          id: 'e14f6db2a52e5633db95b39a096a7491',
          height: 768,
          thumbnail: true,
        },
        location: [47.2205, -1.542633],
        genre: 'Buddleja',
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542633, 47.2205] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a2c47b40d621ffcbc9bf676cc7577849b99b58df',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 181, 76, 1.00)',
            'rgba(136, 116, 92, 1.00)',
            'rgba(103, 132, 66, 1.00)',
          ],
          filename:
            "ip parc de proce/calycanthus/calycanthus x raulstonii 'hartlage wine'/calycanthus x raulstonii 'hartlage wine'  (3).jpg",
          width: 576,
          id: '133c7a8c1577733cf1f82704317d0d05',
          height: 768,
          thumbnail: true,
        },
        espece: 'x raulstonii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 181, 92, 1.00)',
            'rgba(124, 117, 65, 1.00)',
            'rgba(107, 149, 65, 1.00)',
          ],
          filename:
            "ip parc de proce/calycanthus/calycanthus x raulstonii 'hartlage wine'/calycanthus x raulstonii 'hartlage wine'  (2).jpg",
          width: 576,
          id: 'd95a5ee4a8a3f27eae67feb63a965143',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 127, 80, 1.00)',
            'rgba(100, 141, 58, 1.00)',
            'rgba(79, 120, 44, 1.00)',
          ],
          filename:
            "ip parc de proce/calycanthus/calycanthus x raulstonii 'hartlage wine'/calycanthus x raulstonii 'hartlage wine'  (1).jpg",
          width: 576,
          id: '769d8f8ab4c285ccd61454d37b8d756e',
          height: 768,
          thumbnail: true,
        },
        location: [47.225603, -1.581388],
        genre: 'Calycanthus',
        cultivar: 'Hartlage Wine',
        famille: 'Calycanthaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581388, 47.225603] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'df6d87b520673b26c4d3c5c1cf04652db0576966',
      fields: {
        espece: 'fraterna',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 160, 145, 1.00)',
            'rgba(83, 95, 84, 1.00)',
            'rgba(82, 85, 75, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia fraterna/camellia fraterna (3).jpg',
          width: 1024,
          id: '754742856f3a424971b911c5d1357569',
          height: 683,
          thumbnail: true,
        },
        location: [47.220247, -1.54168],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54168, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3e8644be9b444e884d77fbfbabbd9ca31a732364',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'irrawadiensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 124, 110, 1.00)',
            'rgba(92, 105, 93, 1.00)',
            'rgba(53, 65, 57, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia irrawadiensis/camellia irrawadiensis (2).jpg',
          width: 659,
          id: '92fad43e7e388196353e7f1b1d5b845f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 152, 149, 1.00)',
            'rgba(122, 118, 107, 1.00)',
            'rgba(43, 61, 45, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia irrawadiensis/camellia irrawadiensis (3).jpg',
          width: 1022,
          id: '8d7fdce1c42e962bad0aaf0950547c79',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 86, 81, 1.00)',
            'rgba(108, 109, 101, 1.00)',
            'rgba(76, 83, 78, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia irrawadiensis/camellia irrawadiensis (1).jpg',
          width: 1024,
          id: '249821dd6d5fa7eb8128596be2312ff4',
          height: 676,
          thumbnail: true,
        },
        location: [47.220247, -1.541681],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541681, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '99ea1e304d39ab6e26954af4b791be4aa70b0ab8',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 83, 89, 1.00)',
            'rgba(141, 78, 71, 1.00)',
            'rgba(84, 52, 52, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia sasanqua 'yuletide'/camellia sasanqua 'yuletide' (3).jpg",
          width: 910,
          id: '0c3902f5925ea0aab19540f2ad7755bd',
          height: 768,
          thumbnail: true,
        },
        espece: 'sasanqua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 123, 119, 1.00)',
            'rgba(107, 116, 104, 1.00)',
            'rgba(107, 109, 102, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia sasanqua 'yuletide'/camellia sasanqua 'yuletide' (2).jpg",
          width: 1024,
          id: '6acffff1a2abf8b061f7d7a4c1058083',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 123, 115, 1.00)',
            'rgba(100, 96, 80, 1.00)',
            'rgba(101, 81, 82, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia sasanqua 'yuletide'/camellia sasanqua 'yuletide' (1).jpg",
          width: 1024,
          id: '8861c3c5fa90b8dbb8daccd4217c7187',
          height: 683,
          thumbnail: true,
        },
        location: [47.220388, -1.54458],
        genre: 'Camellia',
        cultivar: 'Yuletide',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54458, 47.220388] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a40817d496d5ea5113113e14a03e87c1fa499d29',
      fields: {
        espece: 'sinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(33, 48, 29, 1.00)',
            'rgba(105, 112, 89, 1.00)',
            'rgba(82, 88, 66, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia sinensis/camellia sinensis (2).jpg',
          width: 1024,
          id: '300b9b8a5c92d1522bd2c3d52ef26b09',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(185, 186, 179, 1.00)',
            'rgba(93, 101, 92, 1.00)',
            'rgba(72, 71, 75, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia sinensis/camellia sinensis (1).jpg',
          width: 512,
          id: '35e64c33a132848d4e441496ff836eea',
          height: 768,
          thumbnail: true,
        },
        location: [47.220247, -1.54168],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54168, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3fd8f2d23509dd6c8cc66536fb9d8811ecf89a23',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 99, 71, 1.00)',
            'rgba(125, 157, 124, 1.00)',
            'rgba(131, 141, 117, 1.00)',
          ],
          filename:
            "ip parc de proce/camellia/camellia 'grace bunton'/camellia 'grace bunton' (2).jpg",
          width: 576,
          id: '557d8e93be7a902ec61cb92f51da0017',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(61, 58, 49, 1.00)',
            'rgba(144, 117, 125, 1.00)',
            'rgba(56, 62, 49, 1.00)',
          ],
          filename:
            "ip parc de proce/camellia/camellia 'grace bunton'/camellia 'grace bunton' (3).jpg",
          width: 576,
          id: '9c7ff8b9074cae16e77388d66dc550b0',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 68, 52, 1.00)',
            'rgba(135, 117, 116, 1.00)',
            'rgba(63, 71, 51, 1.00)',
          ],
          filename:
            "ip parc de proce/camellia/camellia 'grace bunton'/camellia 'grace bunton' (1).jpg",
          width: 576,
          id: 'eb0d68c1e7e80fc1fe624500efd15b2f',
          height: 768,
          thumbnail: true,
        },
        location: [47.223092, -1.580833],
        genre: 'Camellia',
        cultivar: 'Grace Bunton',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580833, 47.223092] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5942f0428c625aa157537087259869af23627d91',
      fields: {
        espece: 'tsaii',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 127, 118, 1.00)',
            'rgba(99, 96, 68, 1.00)',
            'rgba(74, 82, 50, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/camellia/camellia tsaii/camellia tsaii  (2).jpg',
          width: 1024,
          id: '18196ee3f1a258de755179283900849f',
          height: 723,
          thumbnail: true,
        },
        location: [47.261717, -1.53477],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53477, 47.261717] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '67016b212c5af22bd95db1f87926210078442caf',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'acuminata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 133, 56, 1.00)',
            'rgba(106, 142, 61, 1.00)',
            'rgba(97, 126, 46, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camptotheca/camptotheca acuminata/camptotheca acuminata (3).jpg',
          width: 576,
          id: '5d5160969b492fca47d68505363ff217',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 126, 111, 1.00)',
            'rgba(117, 131, 86, 1.00)',
            'rgba(111, 136, 49, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camptotheca/camptotheca acuminata/camptotheca acuminata (4).jpg',
          width: 576,
          id: 'f719d7bee3ae156561f31382f64d51d2',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 112, 38, 1.00)',
            'rgba(113, 143, 67, 1.00)',
            'rgba(101, 132, 74, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camptotheca/camptotheca acuminata/camptotheca acuminata (1).jpg',
          width: 576,
          id: '8764a09f29644bf251d1e0076e75c6a4',
          height: 768,
          thumbnail: true,
        },
        location: [47.219358, -1.541537],
        genre: 'Camptotheca',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541537, 47.219358] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '682f207bfbce26b37b9a2e16cd82c87fd9e6ea92',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 150, 106, 1.00)',
            'rgba(111, 145, 79, 1.00)',
            'rgba(99, 133, 64, 1.00)',
          ],
          filename:
            "ip parc de proce/carpinus/carpinus betulus 'quercifolia'/carpinus betulus 'quercifolia' (3).jpg",
          width: 576,
          id: '0720174a3569703a459d9abb6951a398',
          height: 768,
          thumbnail: true,
        },
        espece: 'betulus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 126, 102, 1.00)',
            'rgba(133, 140, 124, 1.00)',
            'rgba(151, 151, 145, 1.00)',
          ],
          filename:
            "ip parc de proce/carpinus/carpinus betulus 'quercifolia'/carpinus betulus 'quercifolia' (2).jpg",
          width: 576,
          id: '7a6d63934e4c5b3191fece520651acf3',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 134, 96, 1.00)',
            'rgba(131, 143, 107, 1.00)',
            'rgba(122, 147, 99, 1.00)',
          ],
          filename:
            "ip parc de proce/carpinus/carpinus betulus 'quercifolia'/carpinus betulus 'quercifolia' (1).jpg",
          width: 576,
          id: 'd5cb6056f33e998fb2c568fe7a82c8b2',
          height: 768,
          thumbnail: true,
        },
        location: [47.222295, -1.581167],
        genre: 'Carpinus',
        cultivar: 'Quercifolia',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581167, 47.222295] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ff41cde26eec2c28597038190af549798d996859',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 127, 66, 1.00)',
            'rgba(111, 135, 69, 1.00)',
            'rgba(97, 122, 69, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/castanea/castanea sativa 'albomarginata'/castanea sativa 'albomarginata' (3).jpg",
          width: 576,
          id: '6c27b71e43c2bb8f401dc8e3cfacc4cd',
          height: 768,
          thumbnail: true,
        },
        espece: 'sativa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 104, 82, 1.00)',
            'rgba(131, 140, 123, 1.00)',
            'rgba(110, 120, 100, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/castanea/castanea sativa 'albomarginata'/castanea sativa 'albomarginata' (2).jpg",
          width: 576,
          id: 'dc13b02198625fc9cc64ad28f9418d98',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 119, 149, 1.00)',
            'rgba(99, 109, 102, 1.00)',
            'rgba(89, 98, 93, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/castanea/castanea sativa 'albomarginata'/castanea sativa 'albomarginata' (1).jpg",
          width: 1024,
          id: '05602eaf441ab2c47bd017e83f1caf75',
          height: 683,
          thumbnail: true,
        },
        location: [47.218817, -1.54143],
        genre: 'Castanea',
        cultivar: 'Albomarginata',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54143, 47.218817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a69b26efc6153fe663ecb0a9fc5bf347b716f1bb',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'cuspidata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 122, 74, 1.00)',
            'rgba(116, 143, 61, 1.00)',
            'rgba(136, 154, 76, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/castanopsis/castanopsis cuspidata/castanopsis cuspidata (2).jpg',
          width: 576,
          id: '3436b6bdc5e3041af0af6acec4183c36',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 190, 171, 1.00)',
            'rgba(81, 95, 55, 1.00)',
            'rgba(97, 108, 63, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/castanopsis/castanopsis cuspidata/castanopsis cuspidata (3).jpg',
          width: 946,
          id: '6ffa54426fa0e3db71e384c2e771966d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 134, 51, 1.00)',
            'rgba(126, 145, 58, 1.00)',
            'rgba(81, 102, 38, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/castanopsis/castanopsis cuspidata/castanopsis cuspidata (1).jpg',
          width: 576,
          id: '7b56e4f3922daeda8ce653f3e23ef158',
          height: 768,
          thumbnail: true,
        },
        location: [47.21948, -1.544122],
        genre: 'Castanopsis',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544122, 47.21948] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5eb1e2cc9b3f8ea760f21064bc759b3a6f47df50',
      fields: {
        espece: 'speciosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 103, 37, 1.00)',
            'rgba(92, 116, 53, 1.00)',
            'rgba(110, 122, 85, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/catalpa/catalpa speciosa/catalpa speciosa (2).jpg',
          width: 576,
          id: '5394dccd19b6e35a2b1f076de1691041',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 117, 42, 1.00)',
            'rgba(91, 114, 58, 1.00)',
            'rgba(90, 116, 51, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/catalpa/catalpa speciosa/catalpa speciosa (1).jpg',
          width: 576,
          id: 'f70b8e1aba927c8024feb6c32ad8661d',
          height: 768,
          thumbnail: true,
        },
        location: [47.220567, -1.5424],
        genre: 'Catalpa',
        famille: 'Bignoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5424, 47.220567] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4cfb6028aba1fd6950fcde8fcdb8900ae4257aba',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'koraiensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(189, 199, 184, 1.00)',
            'rgba(73, 95, 47, 1.00)',
            'rgba(52, 80, 29, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/celtis/celtis koraiensis/celtis koraiensis  (2).jpg',
          width: 1024,
          id: '9251907f49a869b848e696cea66ec803',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 135, 75, 1.00)',
            'rgba(113, 140, 70, 1.00)',
            'rgba(100, 131, 46, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/celtis/celtis koraiensis/celtis koraiensis  (3).jpg',
          width: 776,
          id: '23d0610695a602b4b606536017f1f1ab',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 138, 115, 1.00)',
            'rgba(101, 135, 91, 1.00)',
            'rgba(91, 114, 84, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/celtis/celtis koraiensis/celtis koraiensis  (1).jpg',
          width: 512,
          id: 'a75d338943d51049f1e56e50d0eb71a0',
          height: 768,
          thumbnail: true,
        },
        location: [47.230197, -1.507937],
        genre: 'Celtis',
        famille: 'Cannabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507937, 47.230197] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b210c0817283759a70b15a577492e65a158f4873',
      fields: {
        espece: 'occidentalis',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 90, 47, 1.00)',
            'rgba(117, 110, 64, 1.00)',
            'rgba(127, 130, 136, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cephalanthus/cephalanthus occidentalis/cephalanthus occidentalis .jpg',
          width: 580,
          id: '6300f3ab4d23c14840d260424536db59',
          height: 768,
          thumbnail: true,
        },
        location: [47.219087, -1.543253],
        genre: 'Cephalanthus',
        famille: 'Rubiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543253, 47.219087] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '20e6a92c65bc309cfb9748d6d09b13ff4825af08',
      fields: {
        espece: 'plumbaginoides',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 103, 90, 1.00)',
            'rgba(139, 125, 142, 1.00)',
            'rgba(143, 123, 125, 1.00)',
          ],
          filename:
            'ip parc de proce/ceratostigma/ceratostigma plumbaginoides/ceratostigma plumbaginoides (4).jpg',
          width: 1024,
          id: 'e46298db7072581a63398c1dbf0f6d08',
          height: 683,
          thumbnail: true,
        },
        location: [47.225975, -1.582872],
        genre: 'Ceratostigma',
        famille: 'Plumbaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582872, 47.225975] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd104ee98ea54c1b5987219ca1a83dce394bcf380',
      fields: {
        espece: 'japonicum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(168, 191, 172, 1.00)',
            'rgba(104, 131, 78, 1.00)',
            'rgba(85, 102, 50, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cercidiphyllum/cercidiphyllum japonicum/cercidiphyllum japonicum.jpg',
          width: 1024,
          id: '2a880fa4d543c193525b44e26badb624',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(182, 171, 152, 1.00)',
            'rgba(127, 117, 67, 1.00)',
            'rgba(70, 67, 19, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cercidiphyllum/cercidiphyllum japonicum/cercidiphyllum japonicum (3).jpg',
          width: 600,
          id: '0190b3fe5f71d4a775ddb0c2b7ce7b23',
          height: 768,
          thumbnail: true,
        },
        location: [47.220025, -1.544155],
        genre: 'Cercidiphyllum',
        famille: 'Cercidiphyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544155, 47.220025] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b442fe2287f68c60417a8f0dea99bb8eb38816f0',
      fields: {
        espece: 'mas',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 154, 196, 1.00)',
            'rgba(142, 139, 121, 1.00)',
            'rgba(96, 82, 55, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cornus/cornus mas/cornus mas .jpg',
          width: 576,
          id: 'd3bee778c5663e2ecc32c62b27befe0f',
          height: 768,
          thumbnail: true,
        },
        location: [47.21893, -1.541555],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541555, 47.21893] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f00826715d0e91814ee620d76f8a03d4f09c95ed',
      fields: {
        espece: 'controversa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 125, 92, 1.00)',
            'rgba(124, 127, 83, 1.00)',
            'rgba(88, 96, 51, 1.00)',
          ],
          filename:
            "ip parc de proce/cornus/cornus controversa 'variegata'/cornus controversa 'variegata' (3).jpg",
          width: 1024,
          id: '5960a56f405f70803c4a919a09f8413b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 106, 55, 1.00)',
            'rgba(132, 135, 51, 1.00)',
            'rgba(123, 109, 65, 1.00)',
          ],
          filename:
            "ip parc de proce/cornus/cornus controversa 'variegata'/cornus controversa 'variegata' (2).jpg",
          width: 576,
          id: '3f262b3a9153af276ac83f8479f68ec9',
          height: 768,
          thumbnail: true,
        },
        location: [47.222667, -1.584122],
        genre: 'Cornus',
        cultivar: 'Variegata',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584122, 47.222667] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '573543d50cb4a0cc440b36bdfa507039ea843b3d',
      fields: {
        espece: 'florida f. rubra',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(186, 184, 170, 1.00)',
            'rgba(113, 104, 93, 1.00)',
            'rgba(92, 90, 78, 1.00)',
          ],
          filename:
            'ip parc de proce/cornus/cornus florida f. rubra/cornus florida f. rubra (4).jpg',
          width: 576,
          id: '3cca90bd035065176b9046419ba63706',
          height: 768,
          thumbnail: true,
        },
        location: [47.222817, -1.578117],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.578117, 47.222817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a7cc4f510e019fe7ba67f49f98e2ebd651aa62af',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'officinalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 118, 89, 1.00)',
            'rgba(120, 127, 108, 1.00)',
            'rgba(101, 113, 97, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/cornus/cornus officinalis/cornus officinalis (2).jpg',
          width: 512,
          id: 'b40515d3af601f6cec31c218e097f2d9',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(198, 200, 198, 1.00)',
            'rgba(84, 88, 67, 1.00)',
            'rgba(70, 88, 46, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/cornus/cornus officinalis/cornus officinalis (3).jpg',
          width: 1024,
          id: '7ca16ef92a469b99ac959013dd2d6d95',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 154, 147, 1.00)',
            'rgba(96, 111, 75, 1.00)',
            'rgba(87, 102, 74, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/cornus/cornus officinalis/cornus officinalis (1).jpg',
          width: 512,
          id: 'f24f438a437f7801af9da72014bd09fb',
          height: 768,
          thumbnail: true,
        },
        location: [47.230162, -1.508122],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508122, 47.230162] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '558386dd6144c636a93a6567ac041b1dd14695ad',
      fields: {
        espece: 'spicata',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 115, 115, 1.00)',
            'rgba(136, 128, 81, 1.00)',
            'rgba(89, 89, 59, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/corylopsis/corylopsis spicata/corylopsis spicata.jpg',
          width: 574,
          id: '0a8017f89d40f067db0a55ffe845f625',
          height: 768,
          thumbnail: true,
        },
        location: [47.219087, -1.541183],
        genre: 'Corylopsis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541183, 47.219087] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f69a32c5d58ce271bb858000be9e6c4c8f166574',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(183, 195, 174, 1.00)',
            'rgba(95, 111, 75, 1.00)',
            'rgba(76, 87, 63, 1.00)',
          ],
          filename:
            "ip parc de proce/corylus/corylus avellana 'heterophylla'/corylus avellana 'heterophylla' .jpg",
          width: 1024,
          id: '366d869089361f3f73ea117ca7615452',
          height: 768,
          thumbnail: true,
        },
        espece: 'avellana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 116, 84, 1.00)',
            'rgba(120, 143, 103, 1.00)',
            'rgba(77, 104, 83, 1.00)',
          ],
          filename:
            "ip parc de proce/corylus/corylus avellana 'heterophylla'/corylus avellana 'heterophylla' (2).jpg",
          width: 576,
          id: 'fb8f7752a8a71293bad97df52fe4ac03',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(183, 198, 194, 1.00)',
            'rgba(106, 119, 90, 1.00)',
            'rgba(81, 88, 63, 1.00)',
          ],
          filename:
            "ip parc de proce/corylus/corylus avellana 'heterophylla'/corylus avellana 'heterophylla' (1).jpg",
          width: 1024,
          id: '9cba8fa494541e48fd06be1fca788135',
          height: 768,
          thumbnail: true,
        },
        location: [47.222987, -1.584838],
        genre: 'Corylus',
        cultivar: 'Heterophylla',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584838, 47.222987] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5d0b93169f51eadb7bc1d8dad1d64512f9145196',
      fields: {
        espece: 'macropodum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 91, 46, 1.00)',
            'rgba(121, 128, 69, 1.00)',
            'rgba(148, 131, 109, 1.00)',
          ],
          filename:
            'ip parc de proce/daphniphyllum/daphniphyllum macropodum/daphniphyllum macropodum (2).jpg',
          width: 1024,
          id: '98e136c45891bbadeec0d0ec6c6d2350',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 120, 43, 1.00)',
            'rgba(150, 158, 55, 1.00)',
            'rgba(115, 127, 36, 1.00)',
          ],
          filename:
            'ip parc de proce/daphniphyllum/daphniphyllum macropodum/daphniphyllum macropodum (1).jpg',
          width: 576,
          id: 'a59bcf1c40b1bb2bcaa7321685ee24cb',
          height: 768,
          thumbnail: true,
        },
        location: [47.225675, -1.582853],
        genre: 'Daphniphyllum',
        famille: 'Daphniphyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582853, 47.225675] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '66a9db11cabde02af12f9cc72c1f3e1f9eab7307',
      fields: {
        espece: 'lotus',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 135, 120, 1.00)',
            'rgba(141, 125, 89, 1.00)',
            'rgba(135, 116, 83, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/diospyros/diospyros lotus/diospyros lotus (2).jpg',
          width: 1024,
          id: '97cd4556c4bca688383ebbc5c93e9f50',
          height: 683,
          thumbnail: true,
        },
        location: [47.262888, -1.53503],
        genre: 'Diospyros',
        famille: 'Ebenaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53503, 47.262888] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'afa70ba499c6dc57fd7b42dd299424ee209364ff',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'virginiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 140, 73, 1.00)',
            'rgba(129, 158, 99, 1.00)',
            'rgba(109, 149, 90, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/diospyros/diospyros virginiana/diospyros virginiana (10).jpg',
          width: 1024,
          id: '069d64630c19789db7608f8679e1f9db',
          height: 729,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 107, 70, 1.00)',
            'rgba(90, 114, 66, 1.00)',
            'rgba(103, 130, 67, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/diospyros/diospyros virginiana/diospyros virginiana (11).jpg',
          width: 1024,
          id: '013d0eda3c94ce382af01580bdf86bf1',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 104, 49, 1.00)',
            'rgba(139, 154, 77, 1.00)',
            'rgba(131, 140, 70, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/diospyros/diospyros virginiana/diospyros virginiana (1).jpg',
          width: 576,
          id: 'de1ad095765201feadf41327c760dafb',
          height: 768,
          thumbnail: true,
        },
        location: [47.262087, -1.535112],
        genre: 'Diospyros',
        famille: 'Ebenaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535112, 47.262087] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '472c9622a6fec4cd691ca0b192235e0c746e4062',
      fields: {
        espece: 'bifida',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 123, 78, 1.00)',
            'rgba(133, 139, 100, 1.00)',
            'rgba(88, 91, 56, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/escallonia/escallonia bifida/escallonia bifida (2).jpg',
          width: 576,
          id: '20c82ccee109d2964c1fe377af677cce',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 107, 80, 1.00)',
            'rgba(112, 127, 80, 1.00)',
            'rgba(98, 110, 62, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/escallonia/escallonia bifida/escallonia bifida (1).jpg',
          width: 1024,
          id: '61bad82f29a3f3341a4264adffdd8c9a',
          height: 768,
          thumbnail: true,
        },
        location: [47.228995, -1.507705],
        genre: 'Escallonia',
        famille: 'Escalloniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507705, 47.228995] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6bc121a7255e71c81169142fc1a06a5be9bedec7',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'ornus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 126, 79, 1.00)',
            'rgba(143, 151, 87, 1.00)',
            'rgba(131, 137, 82, 1.00)',
          ],
          filename:
            'ip parc de proce/fraxinus/fraxinus ornus/fraxinus ornus (2).jpg',
          width: 564,
          id: 'b1cf3350b89cfaebe9fa9c5b778a9d0c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 144, 77, 1.00)',
            'rgba(148, 157, 90, 1.00)',
            'rgba(152, 157, 92, 1.00)',
          ],
          filename:
            'ip parc de proce/fraxinus/fraxinus ornus/fraxinus ornus (3).jpg',
          width: 576,
          id: '870d5646384392c0760da9c5c9453b33',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 151, 122, 1.00)',
            'rgba(138, 144, 110, 1.00)',
            'rgba(99, 106, 63, 1.00)',
          ],
          filename:
            'ip parc de proce/fraxinus/fraxinus ornus/fraxinus ornus (1).jpg',
          width: 1024,
          id: '9df9ff923c45d7182141f907d56d7d1a',
          height: 768,
          thumbnail: true,
        },
        location: [47.225455, -1.581225],
        genre: 'Fraxinus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581225, 47.225455] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3d7183865f2a207af0fddc6c560d60c1ea42fd40',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'californicum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 150, 111, 1.00)',
            'rgba(129, 128, 102, 1.00)',
            'rgba(138, 142, 125, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/fremontodendron/fremontodendron californicum/fremontodendron californicum (2).jpg',
          width: 1024,
          id: '72680085cc0cd255acdafed2d98ee3e4',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 147, 116, 1.00)',
            'rgba(120, 146, 96, 1.00)',
            'rgba(124, 134, 92, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/fremontodendron/fremontodendron californicum/fremontodendron californicum (3).jpg',
          width: 576,
          id: '8623a505234f3eeaea259a3e6ab1925e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 90, 34, 1.00)',
            'rgba(163, 138, 34, 1.00)',
            'rgba(119, 106, 36, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/fremontodendron/fremontodendron californicum/fremontodendron californicum (1).jpg',
          width: 576,
          id: '64aa6d7910c7560d53bc769a5d9c6726',
          height: 768,
          thumbnail: true,
        },
        location: [47.228225, -1.508092],
        genre: 'Fremontodendron',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508092, 47.228225] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'edbefffca56454695a641e35dcb752048ff58e09',
      fields: {
        espece: 'triacanthos',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 137, 206, 1.00)',
            'rgba(98, 122, 161, 1.00)',
            'rgba(47, 52, 39, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/gleditsia/gleditsia triacanthos/gleditsia triacanthos.jpg',
          width: 512,
          id: '0454a731671ff6bdb5d0f2c78fa5e982',
          height: 768,
          thumbnail: true,
        },
        location: [47.262778, -1.531697],
        genre: 'Gleditsia',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531697, 47.262778] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b7a92daa23d68dfdabae9b0e9467a704f0a45c0c',
      fields: {
        espece: 'triacanthos',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(187, 198, 164, 1.00)',
            'rgba(109, 124, 68, 1.00)',
            'rgba(96, 101, 69, 1.00)',
          ],
          filename:
            'ip ville de nantes/gleditsia/gleditsia triacanthos/gleditsia triacanthos.jpg',
          width: 1024,
          id: '599408c4339a49104a29b7c43c89fa05',
          height: 768,
          thumbnail: true,
        },
        location: [47.233267, -1.548767],
        genre: 'Gleditsia',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.548767, 47.233267] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b8af23784f77e6bb16e8eb25eefbb50f3c6e145c',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'juniperina f. sulphurea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 127, 72, 1.00)',
            'rgba(143, 139, 85, 1.00)',
            'rgba(135, 121, 84, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/grevillea/grevillea juniperina f. sulphurea/grevillea juniperina f. sulphurea (2).jpg',
          width: 576,
          id: 'f8b2f1055c1fc7337b14495d258a9b18',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 140, 95, 1.00)',
            'rgba(139, 146, 64, 1.00)',
            'rgba(134, 137, 58, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/grevillea/grevillea juniperina f. sulphurea/grevillea juniperina f. sulphurea (3).jpg',
          width: 576,
          id: 'c29872ab7ca3944a2242928f9d412da5',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 107, 59, 1.00)',
            'rgba(140, 136, 70, 1.00)',
            'rgba(122, 115, 65, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/grevillea/grevillea juniperina f. sulphurea/grevillea juniperina f. sulphurea (1).jpg',
          width: 576,
          id: 'f9fd5d70f6f253366665b56eec70d0e7',
          height: 768,
          thumbnail: true,
        },
        location: [47.261742, -1.534697],
        genre: 'Grevillea',
        famille: 'Proteaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534697, 47.261742] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2e167ee6be3d370a5380aa1d4b00252670b359a3',
      fields: {
        nom_du_site: 'Foyer des Anciens',
        espece: 'mollis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 111, 52, 1.00)',
            'rgba(119, 163, 75, 1.00)',
            'rgba(56, 86, 22, 1.00)',
          ],
          filename:
            'ip foyer des anciens/hamamelis/hamamelis mollis/hamamelis mollis (2).jpg',
          width: 576,
          id: 'cfe4b847d65a616e782fad7928b87a7e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(186, 184, 157, 1.00)',
            'rgba(157, 148, 92, 1.00)',
            'rgba(121, 110, 77, 1.00)',
          ],
          filename:
            'ip foyer des anciens/hamamelis/hamamelis mollis/hamamelis mollis (3).jpg',
          width: 1024,
          id: '08d44ee28d11ccd40cb84ccce7ca28c2',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 171, 108, 1.00)',
            'rgba(101, 128, 70, 1.00)',
            'rgba(64, 88, 44, 1.00)',
          ],
          filename:
            'ip foyer des anciens/hamamelis/hamamelis mollis/hamamelis mollis (1).jpg',
          width: 1024,
          id: 'd82bf8b8aa3e04a8cb7b54e969ec7bb0',
          height: 768,
          thumbnail: true,
        },
        location: [47.231753, -1.582458],
        genre: 'Hamamelis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582458, 47.231753] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e936d56b7fbf4825507f3bf06aefec4a9f2b7e01',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 132, 76, 1.00)',
            'rgba(138, 154, 84, 1.00)',
            'rgba(115, 126, 53, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/hamamelis/hamamelis japonica/hamamelis japonica (2).jpg',
          width: 576,
          id: 'c6c49d0d89c76bedb294a74bcb5505c0',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 131, 118, 1.00)',
            'rgba(117, 129, 125, 1.00)',
            'rgba(107, 108, 97, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/hamamelis/hamamelis japonica/hamamelis japonica (3).jpg',
          width: 576,
          id: 'bcc6b1fd0060fac0141a07fcc27a11f7',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 163, 82, 1.00)',
            'rgba(129, 163, 50, 1.00)',
            'rgba(123, 150, 38, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/hamamelis/hamamelis japonica/hamamelis japonica (1).jpg',
          width: 647,
          id: '420b22b8eda036d6cc9dce14eb946a59',
          height: 768,
          thumbnail: true,
        },
        location: [47.218938, -1.541222],
        genre: 'Hamamelis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541222, 47.218938] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9b4affc6ccb8af3bcbe39886d02a8e245467f396',
      fields: {
        espece: 'mollis',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 124, 91, 1.00)',
            'rgba(102, 143, 108, 1.00)',
            'rgba(87, 112, 84, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/hamamelis/hamamelis mollis/hamamelis mollis.jpg',
          width: 576,
          id: 'c4ffe707d7fd9e235f383a021ac6b7ee',
          height: 768,
          thumbnail: true,
        },
        location: [47.218922, -1.54122],
        genre: 'Hamamelis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54122, 47.218922] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'de7624785a94388f14e2e87c0d9d0841475f1c60',
      fields: {
        espece: 'miconioides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 127, 100, 1.00)',
            'rgba(125, 130, 92, 1.00)',
            'rgba(101, 104, 60, 1.00)',
          ],
          filename:
            'ip ville de nantes/heptacodium/heptacodium miconioides/heptacodium miconioides (2).jpg',
          width: 576,
          id: '751c3b170bd700efcbb847fe6c3f826c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 185, 182, 1.00)',
            'rgba(139, 144, 113, 1.00)',
            'rgba(86, 107, 35, 1.00)',
          ],
          filename:
            'ip ville de nantes/heptacodium/heptacodium miconioides/heptacodium miconioides (1).jpg',
          width: 1024,
          id: '7042ed44eca0449dd769745561a16e1f',
          height: 768,
          thumbnail: true,
        },
        location: [47.219312, -1.535783],
        genre: 'Heptacodium',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535783, 47.219312] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f334b59d2042032016ac73d6b5851021c7dba920',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'floridanum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 131, 52, 1.00)',
            'rgba(117, 142, 55, 1.00)',
            'rgba(136, 151, 71, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/illicium/illicium floridanum/illicium floridanum (2).jpg',
          width: 610,
          id: '3961619b346d24d28ece972c2075c024',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 145, 64, 1.00)',
            'rgba(131, 120, 44, 1.00)',
            'rgba(145, 148, 50, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/illicium/illicium floridanum/illicium floridanum (3).jpg',
          width: 576,
          id: '42c620d24b735e01cc04fd246492f05b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 129, 56, 1.00)',
            'rgba(129, 110, 44, 1.00)',
            'rgba(119, 121, 32, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/illicium/illicium floridanum/illicium floridanum (1).jpg',
          width: 1024,
          id: 'bd6fb6901ead68f1b7d32ba5b3d07872',
          height: 683,
          thumbnail: true,
        },
        location: [47.219289, -1.542136],
        genre: 'Illicium',
        famille: 'Schisandraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542136, 47.219289] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd007b591a856dec24801e43993e3e6abc613f798',
      fields: {
        espece: 'septemlobus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 136, 101, 1.00)',
            'rgba(151, 149, 123, 1.00)',
            'rgba(140, 136, 134, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/kalopanax/kalopanax septemlobus/kalopanax septemlobus (2).jpg',
          width: 576,
          id: '2a05eff0d343c79d1127eba508061c21',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 141, 77, 1.00)',
            'rgba(125, 145, 65, 1.00)',
            'rgba(122, 136, 62, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/kalopanax/kalopanax septemlobus/kalopanax septemlobus (1).jpg',
          width: 576,
          id: '5611126c5117825bbe58dfa13dc8af4b',
          height: 768,
          thumbnail: true,
        },
        location: [47.219933, -1.544175],
        genre: 'Kalopanax',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544175, 47.219933] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0945bd8ccda93ab1b7496c76a6170d74df88e4a0',
      fields: {
        genre: 'Liquidambar',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 172, 205, 1.00)',
            'rgba(134, 128, 82, 1.00)',
            'rgba(87, 96, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/liquidambar hamamelidaceae/liquidambar formosana/liquidambar formosana (4).jpg',
          width: 576,
          id: 'd786372a48c28b34c75ec59dbb649d5d',
          height: 768,
          thumbnail: true,
        },
        location: [47.271612, -1.584597],
        famille: 'Altingiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584597, 47.271612] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '505896b3187d45079b282ae589b3c28eb00306f0',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 117, 179, 1.00)',
            'rgba(118, 85, 88, 1.00)',
            'rgba(113, 84, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/liquidambar hamamelidaceae/liquidambar styraciflua 'burgundy'/liquidambar styraciflua 'burgundy' .jpg",
          width: 512,
          id: '07794fb02565db1c483a2c5731285ac3',
          height: 768,
          thumbnail: true,
        },
        location: [47.2713, -1.584662],
        genre: 'Liquidambar',
        cultivar: 'Burgundy',
        famille: 'Altingiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584662, 47.2713] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2ac4f8a39ebd22bc4cc88e39ee8e8fa2daffa118',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'tulipifera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 184, 207, 1.00)',
            'rgba(106, 132, 124, 1.00)',
            'rgba(104, 110, 62, 1.00)',
          ],
          filename:
            'ip parc de proce/liriodendron/liriodendron tulipifera/liriodendron tulipifera (1).jpg',
          width: 1011,
          id: 'bf3c24e5608123b2892f6fff693c045d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(197, 215, 201, 1.00)',
            'rgba(129, 145, 117, 1.00)',
            'rgba(86, 100, 63, 1.00)',
          ],
          filename:
            'ip parc de proce/liriodendron/liriodendron tulipifera/liriodendron tulipifera (10).jpg',
          width: 642,
          id: 'd93025d9143a6b82e736bf7ddc5d045b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 143, 167, 1.00)',
            'rgba(122, 123, 127, 1.00)',
            'rgba(58, 54, 39, 1.00)',
          ],
          filename:
            'ip parc de proce/liriodendron/liriodendron tulipifera/liriodendron tulipifera (.jpg',
          width: 512,
          id: '27a57e0aa131c9a3ed9260a99a5f531c',
          height: 768,
          thumbnail: true,
        },
        location: [47.222847, -1.581028],
        genre: 'Liriodendron',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581028, 47.222847] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f66a82251d4dd12d71d015362539bf94dd81d876',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 110, 62, 1.00)',
            'rgba(170, 152, 67, 1.00)',
            'rgba(88, 99, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/loropetalum hamamelidaceae/loropetalum chinense/loropetalum chinense (1).jpg',
          width: 532,
          id: '1816853d4f34b51d33ce9466dd1b6171',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(69, 91, 27, 1.00)',
            'rgba(107, 127, 69, 1.00)',
            'rgba(82, 97, 39, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/loropetalum hamamelidaceae/loropetalum chinense/loropetalum chinense (3).jpg',
          width: 576,
          id: 'ca0d91c2cb5438db3eeb2e46d3b53168',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 153, 71, 1.00)',
            'rgba(120, 146, 48, 1.00)',
            'rgba(81, 108, 31, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/loropetalum hamamelidaceae/loropetalum chinense/loropetalum chinense  (1).jpg',
          width: 1024,
          id: '0f6ae2dde1d5842e175750759be97ef7',
          height: 768,
          thumbnail: true,
        },
        location: [47.270783, -1.5825],
        genre: 'Loropetalum',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5825, 47.270783] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6d5af574e896891ac099f86bc84e6e45de87f2b5',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'pomifera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 149, 133, 1.00)',
            'rgba(113, 102, 65, 1.00)',
            'rgba(43, 42, 23, 1.00)',
          ],
          filename:
            'ip parc de proce/maclura/maclura pomifera/maclura pomifera (2).jpg',
          width: 1024,
          id: '6884db61920ad89e16a0700b638ce096',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 136, 142, 1.00)',
            'rgba(122, 107, 86, 1.00)',
            'rgba(67, 59, 43, 1.00)',
          ],
          filename:
            'ip parc de proce/maclura/maclura pomifera/maclura pomifera (3).jpg',
          width: 512,
          id: 'cdc3b53db594600acbe52423a2f81349',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 156, 152, 1.00)',
            'rgba(110, 94, 45, 1.00)',
            'rgba(66, 62, 40, 1.00)',
          ],
          filename:
            'ip parc de proce/maclura/maclura pomifera/maclura pomifera (1).jpg',
          width: 512,
          id: '72535c28043cc1b280dcf5915d07449c',
          height: 768,
          thumbnail: true,
        },
        location: [47.222728, -1.580737],
        genre: 'Maclura',
        famille: 'Moraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580737, 47.222728] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '18c59d524cf2026cbc28a9408fcc519d5db5740d',
      fields: {
        espece: 'grandiflora',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 144, 148, 1.00)',
            'rgba(77, 80, 82, 1.00)',
            'rgba(47, 54, 27, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/magnolia/magnolia grandiflora 'maillardiensis'/magnolia grandiflora 'maillardiensis' (1).jpg",
          width: 582,
          id: '92e0c7ae2db9c9a4ced346750990daa4',
          height: 768,
          thumbnail: true,
        },
        location: [47.219642, -1.542797],
        genre: 'Magnolia',
        cultivar: 'Maillardiensis',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542797, 47.219642] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b796cbdffc39e02fa412a46405f182e61e17b75a',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'virginiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(62, 88, 26, 1.00)',
            'rgba(102, 122, 61, 1.00)',
            'rgba(80, 105, 41, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia virginiana/magnolia virginiana  (2).jpg',
          width: 576,
          id: 'b5a6120aae58d3471cf416a8ee3c5f50',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 103, 65, 1.00)',
            'rgba(96, 112, 65, 1.00)',
            'rgba(65, 83, 26, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia virginiana/magnolia virginiana  (3).jpg',
          width: 1024,
          id: 'fb39fdca703d9f631b38367d807a6d44',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 153, 67, 1.00)',
            'rgba(121, 154, 78, 1.00)',
            'rgba(139, 156, 92, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia virginiana/magnolia virginiana  (1).jpg',
          width: 576,
          id: 'bf63e13f4525b3bc667bb43fc1de335c',
          height: 768,
          thumbnail: true,
        },
        location: [47.219553, -1.544142],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544142, 47.219553] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7169d4e53f591eae633d84997018a16a2ae63c70',
      fields: {
        espece: 'virginiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 135, 66, 1.00)',
            'rgba(101, 124, 50, 1.00)',
            'rgba(75, 96, 29, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia virginiana/magnolia virginiana.jpg',
          width: 632,
          id: 'f95b3cede74a5113ccc4714f57de53bb',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(187, 196, 173, 1.00)',
            'rgba(78, 96, 48, 1.00)',
            'rgba(70, 81, 46, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia virginiana/magnolia virginiana (2).jpg',
          width: 676,
          id: 'b9c28ca5b3660ca2426b927560f082a3',
          height: 768,
          thumbnail: true,
        },
        location: [47.22068, -1.542713],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542713, 47.22068] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ee768286c20438845cfd5a3057527b7812685cc3',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'acuminata var. subcordata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 113, 48, 1.00)',
            'rgba(119, 142, 48, 1.00)',
            'rgba(100, 126, 32, 1.00)',
          ],
          filename:
            'ip parc de proce/magnolia/magnolia acuminata var. subcordata/magnolia acuminata var. subcordata (10).jpg',
          width: 1024,
          id: 'e739d6febeb2bc309892e586a87bf1e6',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(181, 190, 156, 1.00)',
            'rgba(132, 139, 47, 1.00)',
            'rgba(79, 90, 30, 1.00)',
          ],
          filename:
            'ip parc de proce/magnolia/magnolia acuminata var. subcordata/magnolia acuminata var. subcordata (11).jpg',
          width: 576,
          id: '0947f70aca4ca181d43dd5fac10b1c66',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 146, 66, 1.00)',
            'rgba(103, 125, 58, 1.00)',
            'rgba(92, 111, 44, 1.00)',
          ],
          filename:
            'ip parc de proce/magnolia/magnolia acuminata var. subcordata/magnolia acuminata var. subcordata (1).jpg',
          width: 576,
          id: '370688ff7c5c5bf4924c8b187ac1ff57',
          height: 768,
          thumbnail: true,
        },
        location: [47.225867, -1.582867],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582867, 47.225867] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b2bfdf57e3e8e86cffd9132ba19a48f50a820d91',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 139, 69, 1.00)',
            'rgba(145, 159, 93, 1.00)',
            'rgba(105, 121, 82, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/magnolia/magnolia 'sunburst'/magnolia 'sunburst' (3).jpg",
          width: 576,
          id: '5338c6c638a74c924e621ee638b444a6',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(64, 80, 53, 1.00)',
            'rgba(140, 144, 82, 1.00)',
            'rgba(87, 103, 34, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/magnolia/magnolia 'sunburst'/magnolia 'sunburst' (2).jpg",
          width: 576,
          id: '884509b109affd713513c42f0de694b1',
          height: 768,
          thumbnail: true,
        },
        location: [47.229133, -1.508862],
        genre: 'Magnolia',
        cultivar: 'Sunburst',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508862, 47.229133] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8442ba6d5c389e62f4f9fcb4a00e8c0d3be258b3',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 139, 189, 1.00)',
            'rgba(113, 125, 131, 1.00)',
            'rgba(58, 66, 33, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'franck gladney'/magnolia 'franck gladney'.jpg",
          width: 512,
          id: '2d01a946c4c0242651449456f3c02d59',
          height: 768,
          thumbnail: true,
        },
        location: [47.262045, -1.533328],
        genre: 'Magnolia',
        cultivar: 'Franck Gladney',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533328, 47.262045] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a227d43986c31ca3341571f97477b4f48f8e89fe',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 92, 124, 1.00)',
            'rgba(105, 121, 139, 1.00)',
            'rgba(85, 95, 90, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'ivory chalice'/magnolia 'ivory chalice' (2).jpg",
          width: 1024,
          id: '9f5f966fada75367e6e505053d4b4e2d',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 93, 114, 1.00)',
            'rgba(115, 121, 119, 1.00)',
            'rgba(78, 86, 79, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'ivory chalice'/magnolia 'ivory chalice' (1).jpg",
          width: 1024,
          id: 'de31ccf6784877972b1e070ece9d01b8',
          height: 683,
          thumbnail: true,
        },
        location: [47.261737, -1.53117],
        genre: 'Magnolia',
        cultivar: 'Ivory Chalice',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53117, 47.261737] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '86ce73cdebd6a42b01da438b96705429e41c8460',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(51, 56, 26, 1.00)',
            'rgba(143, 145, 127, 1.00)',
            'rgba(93, 93, 78, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'milky way'/magnolia 'milky way'.jpg",
          width: 576,
          id: 'c7a233fdab12ca271b24106993d610b8',
          height: 768,
          thumbnail: true,
        },
        location: [47.261587, -1.530463],
        genre: 'Magnolia',
        cultivar: 'Milky Way',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530463, 47.261587] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b22f0714358d5c39e074b7af38d87579623067b2',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(63, 83, 22, 1.00)',
            'rgba(109, 123, 78, 1.00)',
            'rgba(69, 82, 27, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'moondance'/magnolia 'moondance'.jpg",
          width: 576,
          id: '67133576b61ce16570672d52d1b61880',
          height: 768,
          thumbnail: true,
        },
        location: [47.261167, -1.532217],
        genre: 'Magnolia',
        cultivar: 'Moondance',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532217, 47.261167] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f1eea41b838ba65627d23a1e3895dcd8959fb596',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(174, 172, 156, 1.00)',
            'rgba(171, 168, 150, 1.00)',
            'rgba(86, 84, 49, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'pat's delight'/magnolia 'pat's delight' (4).jpg",
          width: 576,
          id: '86100a8e1dd1fc764e3340ad5ec7b942',
          height: 768,
          thumbnail: true,
        },
        location: [47.26262, -1.532505],
        genre: 'Magnolia',
        cultivar: "Pat's Delight",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532505, 47.26262] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '456dbd9d19dd9a2d21993c4495a23eed3b195679',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 97, 69, 1.00)',
            'rgba(111, 88, 40, 1.00)',
            'rgba(103, 97, 56, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia grandiflora 'gallissoniere nana'/magnolia grandiflora 'gallissoniere nana' (3).jpg",
          width: 512,
          id: '11d073a29c72c75cd976b8d9787f9216',
          height: 768,
          thumbnail: true,
        },
        espece: 'grandiflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(190, 185, 173, 1.00)',
            'rgba(75, 67, 43, 1.00)',
            'rgba(73, 77, 44, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia grandiflora 'gallissoniere nana'/magnolia grandiflora 'gallissoniere nana' (2).jpg",
          width: 512,
          id: 'e44ca6cca039fda9ef0c6588aabcd89f',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 86, 56, 1.00)',
            'rgba(102, 88, 39, 1.00)',
            'rgba(98, 117, 48, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia grandiflora 'gallissoniere nana'/magnolia grandiflora 'gallissoniere nana' (1).jpg",
          width: 1024,
          id: '53eb31dcafbda4712cddfb66ed0b37b5',
          height: 683,
          thumbnail: true,
        },
        location: [47.26263, -1.532022],
        genre: 'Magnolia',
        cultivar: 'Gallissoniere Nana',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532022, 47.26263] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a5b2ab1773feda157eee20cd5f0e6aeeb2e0d293',
      fields: {
        espece: 'liliiflora',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 153, 159, 1.00)',
            'rgba(100, 91, 66, 1.00)',
            'rgba(81, 94, 68, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia liliiflora 'nigra'/magnolia liliiflora 'nigra' (2).jpg",
          width: 1024,
          id: 'eb2c2d7315bc5387f6d899cb76bbfd15',
          height: 683,
          thumbnail: true,
        },
        location: [47.262317, -1.530617],
        genre: 'Magnolia',
        cultivar: 'Nigra',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530617, 47.262317] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '53de72cb2ca5a6fa607b6cce2b48a6892235a609',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'macrophylla',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(59, 73, 39, 1.00)',
            'rgba(104, 113, 86, 1.00)',
            'rgba(63, 75, 46, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia macrophylla/magnolia macrophylla (13).jpg',
          width: 1024,
          id: '628b054313c1c9cdf5fae78310ded0b3',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(61, 67, 53, 1.00)',
            'rgba(126, 128, 106, 1.00)',
            'rgba(142, 146, 126, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia macrophylla/magnolia macrophylla (14).jpg',
          width: 1024,
          id: '17fab923b7cd88a9e19ff01044bdfcd5',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(185, 201, 154, 1.00)',
            'rgba(98, 120, 61, 1.00)',
            'rgba(64, 75, 39, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia macrophylla/magnolia macrophylla (12).jpg',
          width: 1024,
          id: '01de646befd9e64ca252fc2d4e0d476f',
          height: 691,
          thumbnail: true,
        },
        location: [47.261922, -1.52862],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.52862, 47.261922] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8b39e54be9d1e91dedfd5f4f8e126b4348089776',
      fields: {
        espece: 'salicifolia',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 131, 169, 1.00)',
            'rgba(155, 140, 152, 1.00)',
            'rgba(94, 83, 71, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia salicifolia 'van veen'/magnolia salicifolia 'van veen'.jpg",
          width: 576,
          id: 'a160a33c3e0661f9cc812af06fa3d44c',
          height: 768,
          thumbnail: true,
        },
        location: [47.263375, -1.531613],
        genre: 'Magnolia',
        cultivar: 'Van Veen',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531613, 47.263375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c8ecfec170ab1d32ada7304b69e7297946e543df',
      fields: {
        espece: 'sprengeri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 109, 117, 1.00)',
            'rgba(140, 136, 116, 1.00)',
            'rgba(64, 64, 40, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia sprengeri/magnolia sprengeri (2).jpg',
          width: 576,
          id: '4e7e2d457af9cd87ed628710350d8782',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 165, 198, 1.00)',
            'rgba(118, 119, 105, 1.00)',
            'rgba(80, 70, 52, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia sprengeri/magnolia sprengeri (1).jpg',
          width: 576,
          id: 'c87107878d4c89500d31cd6435d1b778',
          height: 768,
          thumbnail: true,
        },
        location: [47.26207, -1.530133],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530133, 47.26207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '74233db59d60a3ddb69451afe9fb3297530dd235',
      fields: {
        espece: 'stellata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 81, 74, 1.00)',
            'rgba(118, 115, 113, 1.00)',
            'rgba(116, 111, 112, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'wada's arboreal form'/magnolia stellata 'wada's arboreal form'.jpg",
          width: 576,
          id: '51f6f3141a54b7422804575dd1b89be7',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 105, 92, 1.00)',
            'rgba(113, 97, 84, 1.00)',
            'rgba(91, 77, 50, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia stellata 'wada's arboreal form'/magnolia stellata 'wada's arboreal form' (1).jpg",
          width: 576,
          id: 'd0d9c3e929667de5f32f9864e8c45a2b',
          height: 768,
          thumbnail: true,
        },
        location: [47.262455, -1.530728],
        genre: 'Magnolia',
        cultivar: "Wada's Arboreal Form",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530728, 47.262455] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0ef28c63fca17e358773a702482c2bf0247aa7fd',
      fields: {
        espece: 'virginiana',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 187, 197, 1.00)',
            'rgba(135, 149, 129, 1.00)',
            'rgba(88, 96, 45, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia virginiana 'white side largest'/magnolia virginiana 'white side largest' (1).jpg",
          width: 1020,
          id: '548132bc294e614eeebd6abe32787586',
          height: 768,
          thumbnail: true,
        },
        location: [47.26245, -1.533942],
        genre: 'Magnolia',
        cultivar: 'White Side Largest',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533942, 47.26245] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3f63691e0f9a4d2153d699b20feb9aeac70e10b7',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 101, 100, 1.00)',
            'rgba(112, 110, 107, 1.00)',
            'rgba(108, 104, 101, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'donna'/magnolia x loebneri 'donna' (3).jpg",
          width: 576,
          id: '626cd5e36ab4bb92e5c3ffd4bb08af22',
          height: 768,
          thumbnail: true,
        },
        espece: 'x loebneri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 113, 115, 1.00)',
            'rgba(139, 132, 133, 1.00)',
            'rgba(81, 73, 60, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'donna'/magnolia x loebneri 'donna' (2).jpg",
          width: 576,
          id: '2f293be7fd59163c75000f51d513a97b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 103, 106, 1.00)',
            'rgba(109, 108, 101, 1.00)',
            'rgba(93, 92, 60, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x loebneri 'donna'/magnolia x loebneri 'donna' (1).jpg",
          width: 576,
          id: '1a18066cf675597776845202f0e35494',
          height: 768,
          thumbnail: true,
        },
        location: [47.262978, -1.53172],
        genre: 'Magnolia',
        cultivar: 'Donna',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53172, 47.262978] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'df4f8e1e17f59f9f6c77ba229140e806deeceef2',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(65, 70, 56, 1.00)',
            'rgba(104, 92, 99, 1.00)',
            'rgba(89, 97, 82, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'dorsopurpurea'/magnolia x soulangeana 'dorsopurpurea'.jpg",
          width: 1024,
          id: '570fea3071cf9511ccd67bb3f23bbb80',
          height: 683,
          thumbnail: true,
        },
        espece: 'x soulangeana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(56, 64, 36, 1.00)',
            'rgba(108, 98, 96, 1.00)',
            'rgba(89, 87, 62, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'dorsopurpurea'/magnolia x soulangeana 'dorsopurpurea' (2).jpg",
          width: 1024,
          id: '31753eba080635a8a9a9ff26c7c3ca1b',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 153, 138, 1.00)',
            'rgba(84, 92, 62, 1.00)',
            'rgba(65, 67, 41, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'dorsopurpurea'/magnolia x soulangeana 'dorsopurpurea' (1).jpg",
          width: 1024,
          id: '3d054dab90e5a154d53d5f4f8e968b7a',
          height: 683,
          thumbnail: true,
        },
        location: [47.262655, -1.53103],
        genre: 'Magnolia',
        cultivar: 'Dorsopurpurea',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53103, 47.262655] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ba41dfe1d73b3b746948af0a6f4a6d5c4ddf6231',
      fields: {
        espece: 'x soulangeana',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 160, 174, 1.00)',
            'rgba(154, 151, 145, 1.00)',
            'rgba(60, 56, 33, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'pickard's crystal'/magnolia x soulangeana 'pickard's crystal' (1).jpg",
          width: 512,
          id: 'acddcba9743749365e265237805fe5ba',
          height: 768,
          thumbnail: true,
        },
        location: [47.261688, -1.532063],
        genre: 'Magnolia',
        cultivar: "Pickard's Crystal",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532063, 47.261688] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '136dd73a55542fdf3851c17e3d0ed89497c079ea',
      fields: {
        espece: 'x soulangeana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 81, 83, 1.00)',
            'rgba(111, 80, 80, 1.00)',
            'rgba(114, 106, 83, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'pickard's firefly'/magnolia x soulangeana 'pickard's firefly' (2).jpg",
          width: 1024,
          id: '713bdf6b856111b125a4cdfcb0a1e9a6',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 130, 163, 1.00)',
            'rgba(104, 91, 87, 1.00)',
            'rgba(109, 106, 69, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'pickard's firefly'/magnolia x soulangeana 'pickard's firefly' (1).jpg",
          width: 512,
          id: '72a52752a67d888932934149f51c323d',
          height: 768,
          thumbnail: true,
        },
        location: [47.261422, -1.5329],
        genre: 'Magnolia',
        cultivar: "Pickard's Firefly",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5329, 47.261422] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'de55e741d7b012db5ba7af3aad6b0433874dea47',
      fields: {
        espece: 'x soulangeana',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 81, 75, 1.00)',
            'rgba(128, 124, 111, 1.00)',
            'rgba(82, 75, 60, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'pickard's opal'/magnolia x soulangeana 'pickard's opal' .jpg",
          width: 1024,
          id: '00b88ea60db4e78e5f9aa716707ae134',
          height: 683,
          thumbnail: true,
        },
        location: [47.261883, -1.534678],
        genre: 'Magnolia',
        cultivar: "Pickard's Opal",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534678, 47.261883] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f1c536ce0dff2a1a4b2da91fa6954aa1ed29ba04',
      fields: {
        espece: 'x soulangeana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 135, 177, 1.00)',
            'rgba(111, 102, 107, 1.00)',
            'rgba(86, 84, 46, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'picture'/magnolia x soulangeana 'picture' (4).jpg",
          width: 1024,
          id: '87ff47a2b9033d0dcacdadddca8c93e8',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 81, 94, 1.00)',
            'rgba(143, 89, 116, 1.00)',
            'rgba(116, 70, 75, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'picture'/magnolia x soulangeana 'picture' (2).jpg",
          width: 1024,
          id: 'cfa0c2f80b65f76e09495eb2e15a7477',
          height: 683,
          thumbnail: true,
        },
        location: [47.262688, -1.531538],
        genre: 'Magnolia',
        cultivar: 'Picture',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531538, 47.262688] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '42845b7f39116ee06b8b7e53b1b307e9e930ea03',
      fields: {
        espece: 'x soulangeana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 114, 136, 1.00)',
            'rgba(121, 107, 110, 1.00)',
            'rgba(100, 88, 59, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'rustica rubra'/magnolia x soulangeana 'rustica rubra' (2).jpg",
          width: 1024,
          id: '1efc1dc0a0d06c8b4df37f7fc90a0341',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 131, 184, 1.00)',
            'rgba(122, 122, 144, 1.00)',
            'rgba(81, 79, 59, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'rustica rubra'/magnolia x soulangeana 'rustica rubra' (1).jpg",
          width: 1024,
          id: '2104a2e5aba0a4ad1a00d0ac27de08e0',
          height: 683,
          thumbnail: true,
        },
        location: [47.262245, -1.53363],
        genre: 'Magnolia',
        cultivar: 'Rustica Rubra',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53363, 47.262245] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '043564eb601f93e86deb0f0666a59c884db800fc',
      fields: {
        espece: 'x soulangeana',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 99, 86, 1.00)',
            'rgba(102, 103, 86, 1.00)',
            'rgba(62, 61, 49, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'speciosa'/magnolia x soulangeana 'speciosa' (2).jpg",
          width: 576,
          id: '94f9ac7223fbde056c05023dbad8d0b9',
          height: 768,
          thumbnail: true,
        },
        location: [47.262717, -1.529425],
        genre: 'Magnolia',
        cultivar: 'Speciosa',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529425, 47.262717] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4015255a73888f14704d97fdfd76b5258c316ddf',
      fields: {
        espece: 'hybrids/Magnolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 97, 122, 1.00)',
            'rgba(94, 105, 117, 1.00)',
            'rgba(100, 99, 80, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/unnamed hybrids/magnolia 'jg 21' (gresham)/magnolia 'jg 21' (gresham) (3).jpg",
          width: 1024,
          id: 'c2572866105c245c5ee5d78c5a69fb18',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 104, 128, 1.00)',
            'rgba(116, 122, 126, 1.00)',
            'rgba(63, 64, 42, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/unnamed hybrids/magnolia 'jg 21' (gresham)/magnolia 'jg 21' (gresham) (1).jpg",
          width: 1024,
          id: '9fc42050036fe274382859fd940dc70e',
          height: 683,
          thumbnail: true,
        },
        location: [47.261792, -1.529947],
        genre: 'Magnolia',
        cultivar: 'JG 21 (Gresham)',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529947, 47.261792] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8f816571a201c6836041341f43c0ef6d82252ac1',
      fields: {
        espece: 'germanica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 110, 84, 1.00)',
            'rgba(97, 104, 76, 1.00)',
            'rgba(95, 110, 87, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/mespilus/mespilus germanica/mespilus germanica (2).jpg',
          width: 1024,
          id: '614ec81592b062b7c242f447b88e6fef',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 160, 121, 1.00)',
            'rgba(83, 107, 66, 1.00)',
            'rgba(42, 59, 34, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/mespilus/mespilus germanica/mespilus germanica (1).jpg',
          width: 1024,
          id: '177fe9ba814a4e756f15b499f4a67978',
          height: 741,
          thumbnail: true,
        },
        location: [47.262257, -1.535489],
        genre: 'Mespilus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535489, 47.262257] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c13f13755ad6d2620eb04f67a4d66a9025f4447b',
      fields: {
        espece: 'domestica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 101, 60, 1.00)',
            'rgba(88, 109, 69, 1.00)',
            'rgba(51, 74, 41, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/nandina/nandina domestica/nandina domestica (2).jpg',
          width: 576,
          id: '83d4806730784097e3750928891545bb',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 120, 71, 1.00)',
            'rgba(94, 139, 83, 1.00)',
            'rgba(83, 130, 71, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/nandina/nandina domestica/nandina domestica (1).jpg',
          width: 576,
          id: '2463b8c99300e199278870cfacaee039',
          height: 768,
          thumbnail: true,
        },
        location: [47.263375, -1.531613],
        genre: 'Nandina',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531613, 47.263375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '052755b95a89beb64d948f346b0591e06ed088f0',
      fields: {
        nom_du_site: 'Foyer des Anciens',
        espece: 'yunnanensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 145, 125, 1.00)',
            'rgba(108, 121, 90, 1.00)',
            'rgba(77, 96, 66, 1.00)',
          ],
          filename:
            'ip foyer des anciens/osmanthus/osmanthus yunnanensis/osmanthus yunnanensis (2).jpg',
          width: 1024,
          id: 'c4ea78043a8ab3a662eb6318ec3149c5',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 124, 100, 1.00)',
            'rgba(110, 127, 100, 1.00)',
            'rgba(79, 97, 76, 1.00)',
          ],
          filename:
            'ip foyer des anciens/osmanthus/osmanthus yunnanensis/osmanthus yunnanensis (4).jpg',
          width: 1024,
          id: '11d0e38e3e8ce834fbbdf465a08f3829',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 159, 137, 1.00)',
            'rgba(112, 128, 102, 1.00)',
            'rgba(89, 101, 71, 1.00)',
          ],
          filename:
            'ip foyer des anciens/osmanthus/osmanthus yunnanensis/osmanthus yunnanensis (1).jpg',
          width: 512,
          id: '2ce3bfc9da87d36b0f7a8d390324e95c',
          height: 768,
          thumbnail: true,
        },
        location: [47.231437, -1.582305],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582305, 47.231437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '40bb02fbbc6af2eda8a430a860d363052b2e8f03',
      fields: {
        espece: 'anthyllidifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 112, 84, 1.00)',
            'rgba(105, 105, 78, 1.00)',
            'rgba(78, 80, 51, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/osteomeles/osteomeles anthyllidifolia/osteomeles anthyllidifolia (2).jpg',
          width: 1024,
          id: '8641ed38d4aa1dc5da973081c9930cae',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 144, 101, 1.00)',
            'rgba(106, 115, 71, 1.00)',
            'rgba(73, 82, 39, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/osteomeles/osteomeles anthyllidifolia/osteomeles anthyllidifolia (1).jpg',
          width: 1024,
          id: 'baae49f748cf8aaecb208f262033ddde',
          height: 683,
          thumbnail: true,
        },
        location: [47.228267, -1.508322],
        genre: 'Osteomeles',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508322, 47.228267] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '52cd5c3c3da4be82060351695d01c5de86c4ca1a',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 139, 176, 1.00)',
            'rgba(142, 143, 148, 1.00)',
            'rgba(119, 114, 98, 1.00)',
          ],
          filename:
            "ip ville de nantes/paulownia/paulownia fortunei fast blue 'minfast'/paulownia fortunei fast blue 'minfast' (3).jpg",
          width: 895,
          id: 'd49e490b356e03ad06a0ddb0317a218f',
          height: 768,
          thumbnail: true,
        },
        espece: 'fortunei Fast Blue',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 137, 141, 1.00)',
            'rgba(128, 131, 125, 1.00)',
            'rgba(96, 92, 66, 1.00)',
          ],
          filename:
            "ip ville de nantes/paulownia/paulownia fortunei fast blue 'minfast'/paulownia fortunei fast blue 'minfast' (2).jpg",
          width: 576,
          id: '8c78875fc8e174a13906f0a7bd970759',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 122, 130, 1.00)',
            'rgba(140, 135, 136, 1.00)',
            'rgba(106, 105, 102, 1.00)',
          ],
          filename:
            "ip ville de nantes/paulownia/paulownia fortunei fast blue 'minfast'/paulownia fortunei fast blue 'minfast' (1).jpg",
          width: 576,
          id: 'bb069388e35f6668da224a2f9ce269db',
          height: 768,
          thumbnail: true,
        },
        location: [47.216047, -1.546713],
        genre: 'Paulownia',
        cultivar: 'Minfast',
        famille: 'Paulowniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.546713, 47.216047] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c7d3a0662592bd5402e75c66f33a47d4a4803c06',
      fields: {
        espece: 'angustifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 132, 128, 1.00)',
            'rgba(132, 140, 129, 1.00)',
            'rgba(121, 127, 124, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/phillyrea/phillyrea angustifolia/phillyrea angustifolia (2).jpg',
          width: 576,
          id: '80ee82e00a3f8e001c3e36a479059e37',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 156, 141, 1.00)',
            'rgba(102, 107, 76, 1.00)',
            'rgba(93, 93, 74, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/phillyrea/phillyrea angustifolia/phillyrea angustifolia (1).jpg',
          width: 576,
          id: 'be69d07a0c05af53d12d16ea0a248153',
          height: 768,
          thumbnail: true,
        },
        location: [47.219692, -1.542045],
        genre: 'Phillyrea',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542045, 47.219692] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '62a2e97786407337b3f41d06a2c979d9adceb6bb',
      fields: {
        espece: 'latifolia',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 133, 127, 1.00)',
            'rgba(98, 96, 66, 1.00)',
            'rgba(115, 102, 68, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/phillyrea/phillyrea latifolia/phillyrea latifolia.jpg',
          width: 1024,
          id: 'bc5446a5bdc65552bfd3128ff4213100',
          height: 683,
          thumbnail: true,
        },
        location: [47.262175, -1.528605],
        genre: 'Phillyrea',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.528605, 47.262175] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a8f88d35775fa3ce591430e1f62996eee202058f',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'macrophyllus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 129, 55, 1.00)',
            'rgba(103, 129, 39, 1.00)',
            'rgba(96, 121, 46, 1.00)',
          ],
          filename:
            'ip parc de proce/podocarpus/podocarpus macrophyllus/podocarpus macrophyllus (3).jpg',
          width: 1024,
          id: 'da3932b44b77d6c499e7feeb44a098ec',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 138, 58, 1.00)',
            'rgba(112, 143, 48, 1.00)',
            'rgba(127, 154, 59, 1.00)',
          ],
          filename:
            'ip parc de proce/podocarpus/podocarpus macrophyllus/podocarpus macrophyllus (4).jpg',
          width: 576,
          id: '63b6bef3426398cf58b8e3a30d61d356',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 136, 50, 1.00)',
            'rgba(130, 143, 55, 1.00)',
            'rgba(122, 129, 51, 1.00)',
          ],
          filename:
            'ip parc de proce/podocarpus/podocarpus macrophyllus/podocarpus macrophyllus (2).jpg',
          width: 576,
          id: '615359f6dde25e99e415cfd30a10e8b3',
          height: 768,
          thumbnail: true,
        },
        location: [47.223362, -1.584413],
        genre: 'Podocarpus',
        famille: 'Podocarpaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584413, 47.223362] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f5e549d633ad68d7d823eda7a27d1febec260b32',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 87, 89, 1.00)',
            'rgba(120, 85, 77, 1.00)',
            'rgba(103, 70, 62, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/prunus/prunus mume 'beni-chidori'/prunus mume 'beni-chidori'  (3).jpg",
          width: 512,
          id: '9332ee8f6595f5db4ba56a73d2ac1525',
          height: 768,
          thumbnail: true,
        },
        espece: 'mume',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 113, 113, 1.00)',
            'rgba(127, 95, 84, 1.00)',
            'rgba(120, 89, 77, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/prunus/prunus mume 'beni-chidori'/prunus mume 'beni-chidori'  (2).jpg",
          width: 1024,
          id: 'a51c11f84bb87ad3b65846dc631fb7aa',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 104, 99, 1.00)',
            'rgba(121, 97, 83, 1.00)',
            'rgba(103, 83, 68, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/prunus/prunus mume 'beni-chidori'/prunus mume 'beni-chidori'  (1).jpg",
          width: 1024,
          id: '4b77014bd97eaf437515971c8d07324e',
          height: 758,
          thumbnail: true,
        },
        location: [47.228005, -1.508192],
        genre: 'Prunus',
        cultivar: 'Beni-chidori',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508192, 47.228005] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '92025046a4fb04eeae4cdaec4717b0d9c255d0c2',
      fields: {
        espece: 'sinensis',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 109, 67, 1.00)',
            'rgba(108, 118, 75, 1.00)',
            'rgba(65, 81, 26, 1.00)',
          ],
          filename:
            'ip parc de proce/pseudocydonia/pseudocydonia sinensis/pseudocydonia sinensis.jpg',
          width: 576,
          id: 'dba930db17b1e205a6fc10c158a1fe63',
          height: 768,
          thumbnail: true,
        },
        location: [47.225775, -1.583125],
        genre: 'Pseudocydonia',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583125, 47.225775] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0977dae7ff060dab37236c799210dcca0eac58f2',
      fields: {
        espece: 'rubra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 152, 133, 1.00)',
            'rgba(153, 149, 107, 1.00)',
            'rgba(152, 160, 156, 1.00)',
          ],
          filename:
            "ip parc de proce/quercus/quercus rubra 'aurea'/quercus rubra 'aurea' (2).jpg",
          width: 576,
          id: 'd679bb66fe2bde253b569b8ce69baded',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(174, 179, 176, 1.00)',
            'rgba(168, 166, 143, 1.00)',
            'rgba(98, 99, 90, 1.00)',
          ],
          filename:
            "ip parc de proce/quercus/quercus rubra 'aurea'/quercus rubra 'aurea' (1).jpg",
          width: 576,
          id: 'f2712cc4ce7aa331389809da4441459b',
          height: 768,
          thumbnail: true,
        },
        location: [47.225105, -1.582395],
        genre: 'Quercus',
        cultivar: 'Aurea',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582395, 47.225105] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f329eb6f7dd3faee2c73f59c1add254a002a9844',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'acutissima',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(188, 188, 170, 1.00)',
            'rgba(109, 112, 69, 1.00)',
            'rgba(78, 72, 19, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/quercus/quercus acutissima/quercus acutissima  (2).jpg',
          width: 636,
          id: 'c5a062ad88740d96b9b7fae919abaddf',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 117, 23, 1.00)',
            'rgba(123, 147, 56, 1.00)',
            'rgba(139, 142, 65, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/quercus/quercus acutissima/quercus acutissima  (3).jpg',
          width: 576,
          id: 'b22eacec7b6586965407cd021af4ba09',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 134, 114, 1.00)',
            'rgba(138, 135, 112, 1.00)',
            'rgba(141, 134, 114, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/quercus/quercus acutissima/quercus acutissima  (1).jpg',
          width: 576,
          id: '176e7375e364486c1dba44181fa1ac0a',
          height: 768,
          thumbnail: true,
        },
        location: [47.230172, -1.507587],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507587, 47.230172] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2f954edb55d2d47be55e60391b6575263efd7df4',
      fields: {
        espece: 'myrsinifolia',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 198, 211, 1.00)',
            'rgba(112, 123, 88, 1.00)',
            'rgba(83, 107, 38, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/quercus/quercus myrsinifolia/quercus myrsinifolia.jpg',
          width: 630,
          id: 'c717f9f53e612327faa68a16df535fa9',
          height: 768,
          thumbnail: true,
        },
        location: [47.230092, -1.508113],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508113, 47.230092] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c667dba96f4fd144d852c2957480bcefb1068c4b',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'variabilis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 107, 68, 1.00)',
            'rgba(116, 118, 85, 1.00)',
            'rgba(128, 121, 97, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/quercus/quercus variabilis/quercus variabilis (2).jpg',
          width: 576,
          id: '057a1158faf07782e75f8771bb0e6324',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 103, 76, 1.00)',
            'rgba(124, 141, 69, 1.00)',
            'rgba(134, 139, 88, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/quercus/quercus variabilis/quercus variabilis (3).jpg',
          width: 576,
          id: 'c5ef2d594ecd22c8fc2e376a3867b36f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 132, 109, 1.00)',
            'rgba(139, 129, 104, 1.00)',
            'rgba(144, 133, 111, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/quercus/quercus variabilis/quercus variabilis (1).jpg',
          width: 576,
          id: '0f8d6b777f33da9831c444dc91c23592',
          height: 768,
          thumbnail: true,
        },
        location: [47.230012, -1.506695],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.506695, 47.230012] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9e0d32f4b03bfba9a64fecff554480cb46dd2a2d',
      fields: {
        espece: 'coccifera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 110, 45, 1.00)',
            'rgba(97, 110, 42, 1.00)',
            'rgba(83, 97, 35, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus coccifera/quercus coccifera (4).jpg',
          width: 1024,
          id: '1409cd3a47f2af5f79b49db2e205d11a',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 149, 114, 1.00)',
            'rgba(101, 113, 57, 1.00)',
            'rgba(76, 91, 44, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus coccifera/quercus coccifera (3).jpg',
          width: 1024,
          id: '78b61014769aa245ec1e58bc72de98af',
          height: 683,
          thumbnail: true,
        },
        location: [47.261753, -1.534758],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534758, 47.261753] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9785a9327bc7c981a4448bcdb6f96f1447912ba3',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'phillyreoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(204, 206, 196, 1.00)',
            'rgba(105, 117, 67, 1.00)',
            'rgba(78, 91, 45, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus phillyreoides/quercus phillyreoides  (2).jpg',
          width: 1024,
          id: '24a92a9293e79deee451416c6aff7aba',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 138, 53, 1.00)',
            'rgba(122, 143, 41, 1.00)',
            'rgba(125, 134, 56, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus phillyreoides/quercus phillyreoides  (3).jpg',
          width: 576,
          id: '831cd9e2407ae98ab0dc1c33c7d799a7',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 150, 70, 1.00)',
            'rgba(127, 129, 48, 1.00)',
            'rgba(106, 118, 51, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus phillyreoides/quercus phillyreoides  (1).jpg',
          width: 576,
          id: 'fb68f612afe0b3ffe7740a8a4e8d4d5d',
          height: 768,
          thumbnail: true,
        },
        location: [47.26208, -1.535472],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535472, 47.26208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f8ee58108d9e0d554231e6cfb55393fc1f68de17',
      fields: {
        espece: 'robur',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 90, 101, 1.00)',
            'rgba(116, 116, 120, 1.00)',
            'rgba(82, 75, 50, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus robur/quercus robur.jpg',
          width: 512,
          id: '2d4be4fdd4e541f48203107aee7ab6d7',
          height: 768,
          thumbnail: true,
        },
        location: [47.262233, -1.529942],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529942, 47.262233] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3445f0fb86ef18d4412afbf1f4cc13b4e621e6d5',
      fields: {
        espece: 'rubra',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 149, 179, 1.00)',
            'rgba(145, 155, 169, 1.00)',
            'rgba(76, 68, 54, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/quercus/quercus rubra 'aurea'/quercus rubra 'aurea' (2).jpg",
          width: 512,
          id: 'a5c72fbea4b3870d36b5759fe259e5c7',
          height: 768,
          thumbnail: true,
        },
        location: [47.262163, -1.535738],
        genre: 'Quercus',
        cultivar: 'Aurea',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535738, 47.262163] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b5dff8feb8874746c795151e3027b763b9c01357',
      fields: {
        espece: 'mucronulatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(175, 70, 125, 1.00)',
            'rgba(188, 77, 140, 1.00)',
            'rgba(132, 58, 93, 1.00)',
          ],
          filename:
            'ip parc de la gaudiniere/rhododendron/rhododendron mucronulatum/rhododendron mucronulatum (3).jpg',
          width: 576,
          id: '6b58454d75abce75c173ca9a55dca2df',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de la Gaudini\u00e8re',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 151, 153, 1.00)',
            'rgba(133, 88, 104, 1.00)',
            'rgba(103, 80, 68, 1.00)',
          ],
          filename:
            'ip parc de la gaudiniere/rhododendron/rhododendron mucronulatum/rhododendron mucronulatum (2).jpg',
          width: 1024,
          id: 'e39bdc9a2d6500cbcc3df7a000d70456',
          height: 768,
          thumbnail: true,
        },
        location: [47.244483, -1.581722],
        genre: 'Rhododendron',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581722, 47.244483] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd19aea89d1cab80c089b16ff1e56cccfe241303e',
      fields: {
        espece: 'chinensis',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 147, 122, 1.00)',
            'rgba(139, 120, 84, 1.00)',
            'rgba(116, 125, 79, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/rhus/rhus chinensis/rhus chinensis.jpg',
          width: 576,
          id: '3976ded01efe654fb20a0ccf9c6cd297',
          height: 768,
          thumbnail: true,
        },
        location: [47.219933, -1.542086],
        genre: 'Rhus',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542086, 47.219933] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd623f51a758f17be881d845f3ec65c7a5544b087',
      fields: {
        espece: 'trilobata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 110, 79, 1.00)',
            'rgba(141, 144, 100, 1.00)',
            'rgba(111, 126, 72, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/rhus/rhus trilobata/rhus trilobata.jpg',
          width: 576,
          id: '2ba1a0ce45374aa0c3d8ed649a27e1d7',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 146, 60, 1.00)',
            'rgba(109, 146, 52, 1.00)',
            'rgba(111, 153, 48, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/rhus/rhus trilobata/rhus trilobata (2).jpg',
          width: 576,
          id: '642be4e5f4d55bc6e3fe4b313ebc012e',
          height: 768,
          thumbnail: true,
        },
        location: [47.219958, -1.542075],
        genre: 'Rhus',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542075, 47.219958] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '51d609be7d7e030fcd8876b8ad56bb4920039316',
      fields: {
        espece: 'x margaretta',
        nom_du_site: 'Parc de la Gaudini\u00e8re',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(176, 180, 151, 1.00)',
            'rgba(124, 131, 94, 1.00)',
            'rgba(66, 74, 48, 1.00)',
          ],
          filename:
            "ip parc de la gaudiniere/robinia/robinia x margaretta 'pink cascade'/robinia x margaretta 'pink cascade'.jpg",
          width: 585,
          id: 'f156d7c5f3d79a96760dadab8b5ffa5b',
          height: 768,
          thumbnail: true,
        },
        location: [47.243867, -1.577188],
        genre: 'Robinia',
        cultivar: 'Pink Cascade',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.577188, 47.243867] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0a17bc9fe4ec1e6453d3761aeef7ef2bd89063af',
      fields: {
        espece: 'pseudoacacia',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(200, 220, 241, 1.00)',
            'rgba(142, 156, 152, 1.00)',
            'rgba(100, 100, 77, 1.00)',
          ],
          filename:
            'ip ville de nantes/robinia/robinia pseudoacacia/robinia pseudoacacia (2).jpg',
          width: 774,
          id: '8178c3c8a28f7781d50c52ee5ac3b7d2',
          height: 768,
          thumbnail: true,
        },
        location: [47.235547, -1.548122],
        genre: 'Robinia',
        famille: 'Papilionaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.548122, 47.235547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '320f38941a05f777ccfe8c91cbdb3cf3cec66e22',
      fields: {
        espece: 'chamaedryfolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 125, 36, 1.00)',
            'rgba(108, 143, 43, 1.00)',
            'rgba(102, 133, 37, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/spiraea/spiraea chamaedryfolia/spiraea chamaedryfolia (2).jpg',
          width: 576,
          id: '4f8046834be4ff4dffbf4c8d918d3b5a',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(39, 57, 10, 1.00)',
            'rgba(124, 134, 98, 1.00)',
            'rgba(114, 122, 87, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/spiraea/spiraea chamaedryfolia/spiraea chamaedryfolia (1).jpg',
          width: 576,
          id: '42678f7eeb3e8ef3c5d0b09284920505',
          height: 768,
          thumbnail: true,
        },
        location: [47.220705, -1.54292],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54292, 47.220705] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd65e0924e521babfde48a487062b928725d5bbcf',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'incisa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 81, 36, 1.00)',
            'rgba(142, 135, 90, 1.00)',
            'rgba(126, 130, 46, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/stephanandra/stephanandra incisa/stephanandra incisa (3).jpg',
          width: 576,
          id: 'fcacbbfc92e685998c6d02c28b2f5aa1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 133, 118, 1.00)',
            'rgba(151, 125, 110, 1.00)',
            'rgba(149, 119, 108, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/stephanandra/stephanandra incisa/stephanandra incisa (4).jpg',
          width: 1024,
          id: '95530674463749ca2c9cf44fa080b155',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 157, 74, 1.00)',
            'rgba(134, 143, 61, 1.00)',
            'rgba(110, 115, 62, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/stephanandra/stephanandra incisa/stephanandra incisa (2).jpg',
          width: 576,
          id: '4ff85c64d2e33ee1169e7c9576deb9c0',
          height: 768,
          thumbnail: true,
        },
        location: [47.219733, -1.541433],
        genre: 'Stephanandra',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541433, 47.219733] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '84f1786d88ee68ca43b4156e717d8431b85c2446',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 108, 61, 1.00)',
            'rgba(120, 102, 59, 1.00)',
            'rgba(120, 101, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sycopsis hamamelidaceae/sycopsis sinensis/sycopsis sinensis (11).jpg',
          width: 940,
          id: 'dd1665b36046fa87672601291ba86190',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 160, 133, 1.00)',
            'rgba(121, 144, 107, 1.00)',
            'rgba(91, 113, 78, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sycopsis hamamelidaceae/sycopsis sinensis/sycopsis sinensis (2).jpg',
          width: 576,
          id: '27bd24fac018c90ea67aa1a494e95026',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 156, 122, 1.00)',
            'rgba(105, 121, 77, 1.00)',
            'rgba(81, 99, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/sycopsis hamamelidaceae/sycopsis sinensis/sycopsis sinensis (10).jpg',
          width: 512,
          id: '6d7c6b039a3dc87c32086fdbadcd8deb',
          height: 768,
          thumbnail: true,
        },
        location: [47.270708, -1.585872],
        genre: 'Sycopsis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585872, 47.270708] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e96cdd092a24cd175c3331f6e1b1c2b679aaf3bf',
      fields: {
        espece: 'distichum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(175, 202, 208, 1.00)',
            'rgba(110, 136, 92, 1.00)',
            'rgba(79, 101, 48, 1.00)',
          ],
          filename:
            'ip parc de proce/taxodium/taxodium distichum/taxodium distichum.jpg',
          width: 576,
          id: '9d651ff6ae21ffb9305cac22698d771e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 178, 190, 1.00)',
            'rgba(157, 139, 139, 1.00)',
            'rgba(112, 97, 49, 1.00)',
          ],
          filename:
            'ip parc de proce/taxodium/taxodium distichum/taxodium distichum (2).jpg',
          width: 1024,
          id: 'dc690b790393b5b3e4244e28f207ac52',
          height: 768,
          thumbnail: true,
        },
        location: [47.223095, -1.583297],
        genre: 'Taxodium',
        famille: 'Cupressaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583297, 47.223095] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9c6c538b5e00ae39cea5449aceba40ca1943f9ac',
      fields: {
        espece: 'distichum',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 138, 81, 1.00)',
            'rgba(110, 126, 73, 1.00)',
            'rgba(98, 116, 61, 1.00)',
          ],
          filename:
            'ip parc de proce/taxodium/taxodium distichum/taxodium distichum (3).jpg',
          width: 576,
          id: 'a162179ca8d1a27a82e9771a29cc9a48',
          height: 768,
          thumbnail: true,
        },
        location: [47.223037, -1.584622],
        genre: 'Taxodium',
        famille: 'Cupressaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584622, 47.223037] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6f5aafbbac62348570fd9f4cdcfb3300bf49112a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 124, 78, 1.00)',
            'rgba(101, 126, 83, 1.00)',
            'rgba(105, 126, 98, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ternstroemia pentaphylacaceae/ternstroemia gymnanthera/ternstroemia gymnanthera (3).jpg',
          width: 1024,
          id: '9f4af0ac3806f33dda25a43f1f9ae725',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 133, 104, 1.00)',
            'rgba(105, 121, 74, 1.00)',
            'rgba(85, 101, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ternstroemia pentaphylacaceae/ternstroemia gymnanthera/ternstroemia gymnanthera (4).jpg',
          width: 1024,
          id: 'd5bbde2064fee8401cc3e0680f0c5c82',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 148, 97, 1.00)',
            'rgba(98, 125, 73, 1.00)',
            'rgba(71, 100, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ternstroemia pentaphylacaceae/ternstroemia gymnanthera/ternstroemia gymnanthera (1).jpg',
          width: 1024,
          id: '5748629f571ba9f775e2cdb8c99460dc',
          height: 683,
          thumbnail: true,
        },
        location: [47.27078, -1.585105],
        genre: 'Ternstroemia',
        famille: 'Pentaphylacaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585105, 47.27078] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'be781026fd2946af62f945180e77e97dfd2ef7b7',
      fields: {
        espece: 'cacao',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 106, 100, 1.00)',
            'rgba(104, 104, 92, 1.00)',
            'rgba(80, 73, 68, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/theobroma/theobroma cacao/theobroma cacao (2).jpg",
          width: 1024,
          id: '166357872e20f1dca7f5a237efa94d5d',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 120, 94, 1.00)',
            'rgba(120, 108, 92, 1.00)',
            'rgba(78, 69, 62, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/theobroma/theobroma cacao/theobroma cacao (1).jpg",
          width: 512,
          id: '0339e04d8ced04907b1824566024258c',
          height: 768,
          thumbnail: true,
        },
        location: [47.227122, -1.512038],
        genre: 'Theobroma',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512038, 47.227122] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6e0e6b8de85f243cf5281d9ac431dc431817fda8',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'henryana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 154, 112, 1.00)',
            'rgba(140, 137, 72, 1.00)',
            'rgba(90, 85, 41, 1.00)',
          ],
          filename:
            'ip parc de proce/tilia/tilia henryana/tilia henryana (2).jpg',
          width: 576,
          id: '66b392941ea6cf2ed5d2044578e7627b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 181, 207, 1.00)',
            'rgba(132, 148, 88, 1.00)',
            'rgba(81, 90, 51, 1.00)',
          ],
          filename:
            'ip parc de proce/tilia/tilia henryana/tilia henryana (4).jpg',
          width: 868,
          id: '1129ea129517736dcc424c8e33d4bebd',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 138, 103, 1.00)',
            'rgba(140, 129, 87, 1.00)',
            'rgba(136, 120, 83, 1.00)',
          ],
          filename:
            'ip parc de proce/tilia/tilia henryana/tilia henryana (1).jpg',
          width: 576,
          id: '2c3032181e864f5e1789e96627b66d36',
          height: 768,
          thumbnail: true,
        },
        location: [47.222647, -1.581472],
        genre: 'Tilia',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581472, 47.222647] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8acb475b1de997de7bb8fef50211afa0c5ac7495',
      fields: {
        genre: 'x Sycoparrotia',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(177, 158, 127, 1.00)',
            'rgba(157, 121, 97, 1.00)',
            'rgba(143, 110, 92, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/x sycoparrotia hamamelidaceae/x sycoparrotia semidecidua/x sycoparrotia semidecidua (3).jpg',
          width: 576,
          id: 'ed8f36a33ce2a1cfda53e052b897508b',
          height: 768,
          thumbnail: true,
        },
        location: [47.271122, -1.582058],
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582058, 47.271122] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3719117ddb0a8ca0d1995718e32ff0ed782f0908',
      fields: {
        espece: 'triflora',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 134, 93, 1.00)',
            'rgba(92, 117, 63, 1.00)',
            'rgba(39, 67, 20, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/zabelia/zabelia triflora/zabelia triflora.jpg',
          width: 576,
          id: '87e56af8e11f36cade7a6c68ceb39e72',
          height: 768,
          thumbnail: true,
        },
        location: [47.261555, -1.532167],
        genre: 'Zabelia',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532167, 47.261555] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b5fd5a2746abc6b273cecc0c27fb1d6107830d1e',
      fields: {
        espece: 'triflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 153, 89, 1.00)',
            'rgba(113, 135, 54, 1.00)',
            'rgba(106, 128, 53, 1.00)',
          ],
          filename:
            'ip ville de nantes/zabelia/zabelia triflora/zabelia triflora (2).jpg',
          width: 797,
          id: '85087cd3926e4c4202d865d94d39344d',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 194, 159, 1.00)',
            'rgba(94, 114, 55, 1.00)',
            'rgba(74, 88, 51, 1.00)',
          ],
          filename:
            'ip ville de nantes/zabelia/zabelia triflora/zabelia triflora (1).jpg',
          width: 1024,
          id: '46d1c7091de11b9b7217f7ba592d6c6d',
          height: 768,
          thumbnail: true,
        },
        location: [47.258842, -1.557105],
        genre: 'Zabelia',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.557105, 47.258842] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '201330ebd24ea1865b6eed9e7dcd4c3d5638029a',
      fields: {
        espece: 'serrata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 127, 73, 1.00)',
            'rgba(143, 123, 57, 1.00)',
            'rgba(106, 91, 62, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/zelkova/zelkova serrata/zelkova serrata (6).jpg',
          width: 1024,
          id: '79bbd369d48d574309466424e14a8df3',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(186, 151, 58, 1.00)',
            'rgba(179, 140, 60, 1.00)',
            'rgba(126, 101, 66, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/zelkova/zelkova serrata/zelkova serrata (5).jpg',
          width: 622,
          id: '86c64a4f5622f3c90ce0fbdfeba52f2e',
          height: 768,
          thumbnail: true,
        },
        location: [47.229858, -1.506622],
        genre: 'Zelkova',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.506622, 47.229858] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9e9ecb2920bf84c54b4d4893b130f7060d488ce7',
      fields: {
        origine: 'JBU.Li\u00e8ge (Belgique)',
        espece: 'monregalense Balb.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Sedum',
        date_plantation: '1985',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ccbf9000314dbd31ebe648d077e4e50965eb1e92',
      fields: {
        origine: "Universit\u00e9 des sciences Cappito, l'Aquila (Italie)",
        espece: 'magellense Tenore',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Sedum',
        date_plantation: '2006',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f310de3ad680dd7600c630d41d26d8c24b6a1635',
      fields: {
        origine: 'Universit\u00e9 Marie Curie JB. Lublin (Pologne)',
        espece: 'caucasicum Boriss.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Sedum',
        date_plantation: '2011',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '65cb1044e90f2092e97a54f51b0ae76a7984db2e',
      fields: {
        espece: 'dipsaceus',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 108, 76, 1.00)',
            'rgba(123, 142, 69, 1.00)',
            'rgba(84, 95, 55, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/cucumis [cucurbitaceae]/cucumis dipsaceus/cucumis dipsaceus.jpg",
          width: 576,
          id: '2eda420cf2b4d74c1ce3622a1d12cbf8',
          height: 768,
          thumbnail: true,
        },
        location: [47.226588, -1.512412],
        genre: 'Cucumis',
        famille: 'Cucurbitaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512412, 47.226588] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e9a5b133133658984861bda6167847a6d4c96986',
      fields: {
        espece: 'scabra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 153, 64, 1.00)',
            'rgba(126, 152, 68, 1.00)',
            'rgba(116, 132, 63, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/melothria [cucurbitaceae]/melothria scabra/melothria scabra (2).jpg",
          width: 576,
          id: '1267c19dadc7b074c79a0dc98a1c43ba',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 159, 80, 1.00)',
            'rgba(136, 140, 102, 1.00)',
            'rgba(106, 130, 48, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/melothria [cucurbitaceae]/melothria scabra/melothria scabra (1).jpg",
          width: 576,
          id: 'dd656f66b7e509a68b8ac93a68ac6b0d',
          height: 768,
          thumbnail: true,
        },
        location: [47.226588, -1.512412],
        genre: 'Melothria',
        famille: 'Cucurbitaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512412, 47.226588] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '63625f6198a74d13b4e906080d6842e396c7feb3',
      fields: {
        origine: 'JB.Regensburg (Allemagne)',
        espece: 'panicea L.',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Carex',
        date_plantation: '1999',
        famille: 'Cyperaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '200ca01deebca44c6c0767f09a2e4f65241e432c',
      fields: {
        origine: 'JB.Timaru (N-Z\u00e9lande)',
        espece: 'dissita Tim.',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Carex',
        date_plantation: '2006',
        famille: 'Cyperaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '33d29bff653a2e5ed6f4ec9aa630eb140df819ec',
      fields: {
        espece: 'sp.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Cyperus',
        date_plantation: '1998',
        famille: 'Cyperaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '66ab7fb7729e7d6d633868d05229c104a033c3d3',
      fields: {
        origine: "jardins d'\u00e9coute s'il pleut",
        espece: 'neolobatum Nakai',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Polystichum',
        date_plantation: '2015',
        famille: 'Dryopteridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'db8f4f3c5fc64e109f058db2d731fa15aed12434',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'sylvestris',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 142, 79, 1.00)',
            'rgba(114, 145, 70, 1.00)',
            'rgba(112, 132, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/elaeocarpus [elaeocarpaceae]/elaeocarpus sylvestris/elaeocarpus sylvestris  (11).jpg',
          width: 576,
          id: '1d557e25efc60e6ef8602135a9825772',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 173, 194, 1.00)',
            'rgba(138, 131, 96, 1.00)',
            'rgba(94, 85, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/elaeocarpus [elaeocarpaceae]/elaeocarpus sylvestris/elaeocarpus sylvestris  (2).jpg',
          width: 678,
          id: 'c0d36d90aca1c4ccc850de230186d577',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 148, 63, 1.00)',
            'rgba(119, 148, 67, 1.00)',
            'rgba(120, 137, 70, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/elaeocarpus [elaeocarpaceae]/elaeocarpus sylvestris/elaeocarpus sylvestris  (1).jpg',
          width: 576,
          id: 'a43658e620a71ae3052122de55f4431f',
          height: 768,
          thumbnail: true,
        },
        location: [47.271158, -1.586755],
        genre: 'Elaeocarpus',
        famille: 'Elaeocarpaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586755, 47.271158] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '352c186cb6eef811848970ea330b935e3955c389',
      fields: {
        origine: 'Institut de recherhe Forestier Taiwan',
        espece: 'oldbami',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Rhododendron',
        date_plantation: '1998',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2d7781da48e82e4ebe1ad1b75162e4940429b2d4',
      fields: {
        origine: 'JB.Rhodo.Park Bremen',
        espece: 'yunnanense',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Rhododendron',
        date_plantation: '1997',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0838f333c8a93c2e6bd3497361986facd33e5d49',
      fields: {
        espece: 'unedo',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 189, 195, 1.00)',
            'rgba(108, 109, 85, 1.00)',
            'rgba(92, 97, 50, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/arbutus [ericaceae]/arbutus unedo/arbutus unedo (2).jpg',
          width: 1024,
          id: 'd6bdf607655174197ea3f76f6759cfa7',
          height: 683,
          thumbnail: true,
        },
        location: [47.263042, -1.53448],
        genre: 'Arbutus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53448, 47.263042] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '028b3f7c81fa9e35de2d2e35814225f0e19bc2ec',
      fields: {
        espece: 'x obtusum',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Rhododendron',
        date_plantation: '1973',
        cultivar: 'Arabesk',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6257921ff13d3194f8ef795991532bb3477119c7',
      fields: {
        origine: 'p\u00e9pini\u00e8re Ellebore',
        espece: 'donii Oudejans',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Euphorbia',
        date_plantation: '2015',
        famille: 'Euphorbiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e4d37af20f2b3668ebba47be2f57ed9b5425e482',
      fields: {
        espece: 'polyandra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 98, 52, 1.00)',
            'rgba(147, 142, 80, 1.00)',
            'rgba(153, 155, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euptelea [eupteleaceae]/euptelea polyandra/euptelea polyandra (6).jpg',
          width: 576,
          id: '5aac3abf201174e7e54395053c3a412a',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 165, 112, 1.00)',
            'rgba(100, 119, 52, 1.00)',
            'rgba(116, 122, 64, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euptelea [eupteleaceae]/euptelea polyandra/euptelea polyandra  (4).jpg',
          width: 854,
          id: '1911c9a57111897fd155ac17823cce87',
          height: 768,
          thumbnail: true,
        },
        location: [47.270575, -1.581988],
        genre: 'Euptelea',
        famille: 'Eupteleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581988, 47.270575] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ab5b524f7289a11db5bc83f8f73938209eb7a29d',
      fields: {
        origine: 'JB.Bolestraszyce (Pologne)',
        espece: 'arenaria DC.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Onobrychis',
        date_plantation: '2009',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '766a0b80a8d4ba2ef1cd69880faf2a22ea2ee0cb',
      fields: {
        espece: 'floribunda',
        localisation: 'B2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201934, -1.5449557],
        genre: 'Wisteria',
        date_plantation: '1973',
        cultivar: 'Alba',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449557, 47.2201934] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b1b9a0f45f314ca8680df882f6fa0de94ef4ae49',
      fields: {
        espece: 'sinensis',
        localisation: 'B1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2204652, -1.544656],
        genre: 'Wisteria',
        date_plantation: '1973',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544656, 47.2204652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5ec32602d7af880b5e2a08e033b59a0f5dae18e5',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'engleriana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 153, 131, 1.00)',
            'rgba(108, 124, 56, 1.00)',
            'rgba(83, 83, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus engleriana/fagus engleriana (27).jpg',
          width: 893,
          id: '0f800b25f3530e810895ca86ef02252f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 96, 73, 1.00)',
            'rgba(112, 105, 75, 1.00)',
            'rgba(135, 116, 99, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus engleriana/fagus engleriana (29).jpg',
          width: 576,
          id: '4996448633cbcd6fb99453509e7f5cfa',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(168, 171, 153, 1.00)',
            'rgba(137, 144, 89, 1.00)',
            'rgba(125, 126, 108, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fagus [fagaceae]/fagus engleriana/fagus engleriana (24).jpg',
          width: 802,
          id: 'de6dc24d5b916dfd14d809a48e806b4c',
          height: 768,
          thumbnail: true,
        },
        location: [47.270697, -1.581753],
        genre: 'Fagus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581753, 47.270697] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5d03d7140549f1721c392f01189b9b12faca0a17',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 118, 112, 1.00)',
            'rgba(126, 104, 63, 1.00)',
            'rgba(102, 85, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fagus [fagaceae]/fagus sylvatica 'aspleniifolia'/fagus sylvatica 'aspleniifolia' (14).jpg",
          width: 1024,
          id: 'a103399ebba9405cc5657953be0ef14b',
          height: 683,
          thumbnail: true,
        },
        espece: 'sylvatica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 125, 132, 1.00)',
            'rgba(117, 120, 81, 1.00)',
            'rgba(111, 107, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fagus [fagaceae]/fagus sylvatica 'aspleniifolia'/fagus sylvatica 'aspleniifolia' (13).jpg",
          width: 512,
          id: 'f4c166f135953cab2ebdc4e7eb7aeb6e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 154, 171, 1.00)',
            'rgba(117, 117, 78, 1.00)',
            'rgba(67, 63, 33, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fagus [fagaceae]/fagus sylvatica 'aspleniifolia'/fagus sylvatica 'aspleniifolia' (12).jpg",
          width: 1024,
          id: '55802e6523cb6d0bda9b6d8a79e75d2e',
          height: 683,
          thumbnail: true,
        },
        location: [47.270613, -1.584803],
        genre: 'Fagus',
        cultivar: 'Aspleniifolia',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584803, 47.270613] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fb7ccd60c77b0481d1baab4c52714565a07d21ee',
      fields: {
        espece: 'myrsinifolia',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 163, 121, 1.00)',
            'rgba(95, 105, 67, 1.00)',
            'rgba(61, 64, 47, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus myrsinifolia/quercus myrsinifolia  (3).jpg',
          width: 1024,
          id: '74d72aa3d76dcfdf6d08bd2da8c6314d',
          height: 728,
          thumbnail: true,
        },
        location: [47.269872, -1.581408],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581408, 47.269872] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '52c39813c4710c0847d822fdafa0cc7831e825a6',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 177, 133, 1.00)',
            'rgba(108, 114, 32, 1.00)',
            'rgba(45, 55, 24, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/quercus [fagaceae]/quercus robur 'concordia'/quercus robur 'concordia'.jpg",
          width: 1024,
          id: 'a94278ad9932c5c8ccb5219746f7276b',
          height: 683,
          thumbnail: true,
        },
        espece: 'robur',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 138, 77, 1.00)',
            'rgba(101, 100, 18, 1.00)',
            'rgba(40, 48, 18, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/quercus [fagaceae]/quercus robur 'concordia'/quercus robur 'concordia' (4).jpg",
          width: 1024,
          id: '04d90871ae5bc771ba374c4ab9a09658',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(55, 93, 149, 1.00)',
            'rgba(103, 109, 95, 1.00)',
            'rgba(129, 106, 22, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/quercus [fagaceae]/quercus robur 'concordia'/quercus robur 'concordia' (3).jpg",
          width: 512,
          id: '20545b55d6df5c045edb8c860ccbdd43',
          height: 768,
          thumbnail: true,
        },
        location: [47.270655, -1.586238],
        genre: 'Quercus',
        cultivar: 'Concordia',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586238, 47.270655] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3afe497e6480a68a775528e88cacce9931290461',
      fields: {
        origine: 'JB.Gr\u00fcningen (Suisse)',
        espece: 'robusta Kiche',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Gentiana',
        date_plantation: '2006',
        famille: 'Gentianaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '93f712e5158f1885c2c8688a5779a913ee727ad3',
      fields: {
        origine: 'Jardin Botanique du Tourmalet, Bar\u00e8ges, France',
        espece: 'manescavi Coss.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Erodium',
        date_plantation: '2012',
        famille: 'Geraniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '95af4cce6b95e649749af2a8a34822b0b660b706',
      fields: {
        origine: 'Jardin botanique universit\u00e9 de Marie Curie - Lublin',
        espece: 'phaeum L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Geranium',
        date_plantation: '2010',
        famille: 'Geraniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '584b6ed991b22384f1a8cf6d4f2a03843d739659',
      fields: {
        origine: 'JB. Wuppertal, Wuppertal (Allemagne)',
        espece: 'himalayense Klotzsch',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Geranium',
        date_plantation: '2011',
        famille: 'Geraniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f8554622aea1b1fe925492b602075dac444927cc',
      fields: {
        origine: 'P\u00e9pini\u00e8res Emmanuel LEPAGE',
        espece: 'himalayense Klotzsch',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Geranium',
        date_plantation: '2015',
        famille: 'Geraniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ca7cf25b6ca93c297ff3bd3c9965d1c7d372fd57',
      fields: {
        origine: 'JB.Prague (R\u00e9p.Tch\u00e8que)',
        espece: 'sp.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Globularia',
        date_plantation: '2006',
        famille: 'Globulariacae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e0e5a72a82b5ab7ada4ecde3744cc03d2279d308',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x beatonii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 131, 95, 1.00)',
            'rgba(203, 159, 141, 1.00)',
            'rgba(219, 185, 158, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ribes [grossulariaceae]/ribes x beatonii/ribes x beatonii (2).jpg',
          width: 656,
          id: 'e336df9a699d6eedff174979696c6c02',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(168, 157, 127, 1.00)',
            'rgba(127, 143, 85, 1.00)',
            'rgba(154, 147, 116, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ribes [grossulariaceae]/ribes x beatonii/ribes x beatonii (3).jpg',
          width: 576,
          id: '3749b3d01867b87c329fa83e2550233e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 139, 103, 1.00)',
            'rgba(201, 156, 140, 1.00)',
            'rgba(194, 161, 137, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ribes [grossulariaceae]/ribes x beatonii/ribes x beatonii (1).jpg',
          width: 647,
          id: '6bc36e1894d4ab1798a284fcd1f8db4d',
          height: 768,
          thumbnail: true,
        },
        location: [47.270908, -1.584712],
        genre: 'Ribes',
        famille: 'Grossulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584712, 47.270908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '062e00d1222ef82dcf37f17b07eed07d6968a541',
      fields: {
        espece: 'manicata Lindl.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Gunnera',
        date_plantation: '1973',
        famille: 'Gunneraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6de88ed6b412786a3191081490abd7824741a20d',
      fields: {
        origine: 'J.B. de Christchurch,New Z\u00e9land',
        espece: 'erecta Schindl.',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Haloragis',
        date_plantation: '2014',
        famille: 'Haloragaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '36138d5162b50347899c650e534c4f7120a0cd68',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'californica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 75, 54, 1.00)',
            'rgba(140, 142, 107, 1.00)',
            'rgba(66, 80, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/carpenteria [hydrangeaceae]/carpenteria californica/carpenteria californica (3).jpg',
          width: 576,
          id: '134ebd2cbd9289fa9ba33144c542c1ff',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 137, 99, 1.00)',
            'rgba(97, 131, 82, 1.00)',
            'rgba(84, 129, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/carpenteria [hydrangeaceae]/carpenteria californica/carpenteria californica (4).jpg',
          width: 576,
          id: '5035075a4ae3c1c0842e8cbe2f9c35c2',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 154, 126, 1.00)',
            'rgba(99, 116, 67, 1.00)',
            'rgba(90, 111, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/carpenteria [hydrangeaceae]/carpenteria californica/carpenteria californica (1).jpg',
          width: 1024,
          id: '3d1327d25ddd4a81ab5af304ccb76f3c',
          height: 768,
          thumbnail: true,
        },
        location: [47.271425, -1.581963],
        genre: 'Carpenteria',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581963, 47.271425] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '730b034ccce3ceee1d3779d339279fc5eee2aea0',
      fields: {
        espece: 'scabra',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 87, 53, 1.00)',
            'rgba(110, 123, 103, 1.00)',
            'rgba(87, 101, 74, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia scabra 'candidissima'/deutzia scabra 'candidissima'.jpg",
          width: 729,
          id: 'dec51b70321949c7aa45da87ea6fd73e',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Deutzia',
        cultivar: 'Candidissima',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '78d1186e11228125a2a9596aeef24df4a630037f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(50, 74, 34, 1.00)',
            'rgba(94, 116, 82, 1.00)',
            'rgba(62, 92, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'belle etoile'/philadelphus 'belle etoile' (3).jpg",
          width: 1024,
          id: '928f964f0db1df4e5a364b9c206aa07b',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 140, 47, 1.00)',
            'rgba(94, 150, 48, 1.00)',
            'rgba(115, 171, 74, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'belle etoile'/philadelphus 'belle etoile' (6).jpg",
          width: 576,
          id: '79b76e7265b4de93b373db08e345e2f4',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 135, 91, 1.00)',
            'rgba(94, 118, 68, 1.00)',
            'rgba(60, 84, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'belle etoile'/philadelphus 'belle etoile' (2).jpg",
          width: 1024,
          id: '60d292b851f6cda25375c3a7705f70aa',
          height: 683,
          thumbnail: true,
        },
        location: [47.271305, -1.586203],
        genre: 'Philadelphus',
        cultivar: 'Belle Etoile',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586203, 47.271305] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cc43ddf91296a3220e43fabb07d707e6996e2f46',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'viburnoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 119, 79, 1.00)',
            'rgba(138, 142, 104, 1.00)',
            'rgba(80, 90, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pileostegia [hydrangeaceae]/pileostegia viburnoides/pileostegia viburnoides (2).jpg',
          width: 576,
          id: '831916f35405df4a9170bd98be938058',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 121, 70, 1.00)',
            'rgba(125, 133, 87, 1.00)',
            'rgba(97, 109, 64, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pileostegia [hydrangeaceae]/pileostegia viburnoides/pileostegia viburnoides (3).jpg',
          width: 576,
          id: '0b05b59b7fd26cdd76282fd0b3e4c0cc',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 123, 96, 1.00)',
            'rgba(92, 124, 84, 1.00)',
            'rgba(86, 106, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pileostegia [hydrangeaceae]/pileostegia viburnoides/pileostegia viburnoides (1).jpg',
          width: 576,
          id: 'bc39eeabb7bb36fadd6effae7130f28c',
          height: 768,
          thumbnail: true,
        },
        location: [47.271445, -1.586978],
        genre: 'Pileostegia',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586978, 47.271445] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4162c4e60da5784a0936dbe0a318dc72dbbeeaca',
      fields: {
        origine: 'B.G.Albert Freiburg,Allemagne',
        espece: 'caucasica Hoffm.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Iris',
        date_plantation: '2014',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fa0f39e93e1565f6ddda62979ae3cdaa2bb7a3e9',
      fields: {
        origine: 'BG Washington Park arboretum',
        espece: 'tenax Douglas',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Iris',
        date_plantation: '2006',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6d8d4e2787170393072ef331c9b7a7c2839f1ac5',
      fields: {
        origine: 'Botanischen Garten,Linz,Autriche',
        espece: 'chinensis DC.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Belamcanda',
        date_plantation: '2013',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c80ac74e6ee2e135e953b29f7dbcf0737bf11cdf',
      fields: {
        origine: 'Cruickshank B.G. Aberdeen (Ecosse)',
        espece: 'igneum Klatt',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Dierama',
        date_plantation: '2015',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5d369d69bb26a7174e9b9ad0bcf674ed200a573d',
      fields: {
        origine: 'J.B. Utrecht (Allemagne)',
        espece: 'ensata Thunb.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Iris',
        date_plantation: '2011',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '524ec36b83b24d1c1ba9672dab4e83d45a924425',
      fields: {
        origine: 'JB. Klagenfurt (Australie)',
        espece: 'exiguus Schur. =vernus',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Crocus',
        date_plantation: '2010',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4d66d6b2500e9fc342999e5d5f04dbd884e8bf8f',
      fields: {
        origine: 'Palmen Garten,Frankfurt,Allemagne',
        espece: 'ixioides Spreng.',
        localisation: 'I2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185657, -1.5426599],
        genre: 'Libertia',
        date_plantation: '2012',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426599, 47.2185657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6a53d1e0c33a77d1baa65cb76dd71b30169003fd',
      fields: {
        origine: 'P\u00e9pini\u00e8re Arven',
        espece: 'pillansii L.Bolus',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Watsonia',
        date_plantation: '2015',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5dbe06412bc8cc68adc4c32c7c8ffab52b46fdbb',
      fields: {
        origine: 'Sichtungsgartens Hermannshof, Weinheim, Allemagne',
        espece: 'striatum Sm.',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Sisyrinchium',
        date_plantation: '2012',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2daa6dcd0dc912f15b2ce216b3fc842c67da9ad4',
      fields: {
        espece: 'kaempferi Siebold. ex Mem.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Iris',
        date_plantation: '1973',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a937bb0f209d2f80fae89a21a1c62539daf24eea',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'yunnanensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 157, 58, 1.00)',
            'rgba(113, 132, 41, 1.00)',
            'rgba(106, 113, 48, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/itea [iteaceae]/itea yunnanensis/itea yunnanensis  (2).jpg',
          width: 576,
          id: '0ababb20bb0cf78af37c643187912f15',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 134, 79, 1.00)',
            'rgba(104, 141, 64, 1.00)',
            'rgba(74, 104, 35, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/itea [iteaceae]/itea yunnanensis/itea yunnanensis (2).jpg',
          width: 556,
          id: 'b621057a7578219148842a3c2906d583',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 127, 57, 1.00)',
            'rgba(132, 146, 58, 1.00)',
            'rgba(128, 120, 92, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/itea [iteaceae]/itea yunnanensis/itea yunnanensis  (1).jpg',
          width: 838,
          id: '92f31e8978a99c62ecde96f9fd4c2541',
          height: 768,
          thumbnail: true,
        },
        location: [47.27107, -1.584613],
        genre: 'Itea',
        famille: 'Iteaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584613, 47.27107] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e379930b569e68cc0ba44467eaef10fd7af01bf9',
      fields: {
        origine: 'Botanischer Garten Bielefeld, Bielefeld, Allemagne',
        espece: 'japonicum Kitam. & Murata',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Leucosceptrum',
        date_plantation: '2012',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6d9176e9d97d67da5b135f73ba1c1e93827abb71',
      fields: {
        origine: 'Botanischer Garten Bielefeld, Bielefeld, Allemagne',
        espece: 'fruticosa Druce',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Micromeria',
        date_plantation: '2014',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9513d9d9af934c3181619e2afa675df445fb954b',
      fields: {
        origine: 'Grugapark Essen (Allemagne)',
        espece: 'byzantina C.Koch',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Stachys',
        date_plantation: '1987',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cb48ae0be91d7cfb164616f2cff6753450f6b71c',
      fields: {
        origine: 'Huesca (Espagne)',
        espece: 'pyrenaicum L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Horminium',
        date_plantation: '1998',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5b5d53b14fd5cd98259c95690e244469a3417d29',
      fields: {
        origine: 'J.B. Nitra (Slovaquie)',
        espece: 'virginiana Benth',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Physostegia',
        date_plantation: '2011',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f316d4a2f3d70f82f1fe5daeb939990c69c7db8e',
      fields: {
        origine: 'Jardin botanique de la ville de Lushan (Chine)',
        espece: 'chinense O.Kuntze',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Clinopodium',
        date_plantation: '2006',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9765caba6e83d540a93e8d053cba8913d98c358d',
      fields: {
        origine: 'Jardin botanique Utrecht',
        espece: 'pyrenaicum L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Horminum',
        date_plantation: '2010',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6c1603de50b8694a25a340c205f19fccb46a8e18',
      fields: {
        origine: 'JB.Northampton (USA)',
        espece: 'canadense L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Collinsonia',
        date_plantation: '2008',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1163f233ea4c790a4796cccab64ef157cccde6b9',
      fields: {
        origine: 'JB.Trieste (Italie)',
        espece: 'thymifolia  Silic',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Micromeria',
        date_plantation: '2008',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'be93041a80b0ffccc532a6ac74e6e07a6588551c',
      fields: {
        origine: 'JBU.Riga (Lettonie)',
        espece: 'woronowii Juzepczuk',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Scutellaria',
        date_plantation: '1990',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b53cb77d91a2a016bd6cce9ab463b613ce003e48',
      fields: {
        origine: 'Mr Henri Besan\u00e7on',
        espece: 'angustifolia',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Lavandula',
        date_plantation: '1997',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f33b859bc211ff99a8c0b332b4b5c3ab4e737925',
      fields: {
        origine:
          'r\u00e9colte de Philippe F\u00e9rard,Pyr\u00e9n\u00e9es,26/07/09',
        espece: 'chamaedrys L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Teucrium',
        date_plantation: '2014',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ac0c4a47bcf2713eac4ba652ce8f8818fddfd16f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'dichotoma',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(64, 88, 48, 1.00)',
            'rgba(110, 153, 78, 1.00)',
            'rgba(107, 146, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/callicarpa [lamiaceae]/callicarpa dichotoma/callicarpa dichotoma (2).jpg',
          width: 576,
          id: 'c7c14f177f9ed11404ff471648c22efc',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 81, 52, 1.00)',
            'rgba(130, 155, 107, 1.00)',
            'rgba(106, 129, 69, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/callicarpa [lamiaceae]/callicarpa dichotoma/callicarpa dichotoma (3).jpg',
          width: 576,
          id: '7ab2e1f65e9512c58689bd6b13b96aec',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 150, 83, 1.00)',
            'rgba(114, 147, 68, 1.00)',
            'rgba(74, 114, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/callicarpa [lamiaceae]/callicarpa dichotoma/callicarpa dichotoma (1).jpg',
          width: 576,
          id: 'ecda1299f9d856101403d8aba5c4251f',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Callicarpa',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a13924337991244388031a476204004937ca7e60',
      fields: {
        espece: 'japonica var. luxurians',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 107, 63, 1.00)',
            'rgba(121, 148, 77, 1.00)',
            'rgba(94, 117, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/callicarpa [lamiaceae]/callicarpa japonica var. luxurians/callicarpa japonica var. luxurians (2).jpg',
          width: 576,
          id: '8fbf21d63863cbe1deeafb527c0fdf11',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 142, 48, 1.00)',
            'rgba(107, 138, 68, 1.00)',
            'rgba(67, 90, 37, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/callicarpa [lamiaceae]/callicarpa japonica var. luxurians/callicarpa japonica var. luxurians (1).jpg',
          width: 576,
          id: '90761f195f74b29b112fecee4809e7c9',
          height: 768,
          thumbnail: true,
        },
        location: [47.270728, -1.58497],
        genre: 'Callicarpa',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58497, 47.270728] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4b07b158279ba3ac831d039511579f658d142fb9',
      fields: {
        espece: 'camphora',
        localisation: 'A12',
        nom_du_site: 'Jardin des Plantes',
        location: [47.22098, -1.5430278],
        genre: 'Cinnamomum',
        date_plantation: '1995',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5430278, 47.22098] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '480849a98134bd04e02214b4436b77e7edc9a0bc',
      fields: {
        origine: 'JB.Hangzhou (Chine)',
        espece: 'limii',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Lagerstroemia',
        date_plantation: '1999',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '08d492fa955f06909cf8767a44838f48964b9fb6',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 144, 87, 1.00)',
            'rgba(81, 118, 54, 1.00)',
            'rgba(79, 103, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/punica [lythraceae]/punica granatum 'luteum plenum'/punica granatum 'luteum plenum' (3).jpg",
          width: 1024,
          id: '346930c50c11f52ef68317209c73569c',
          height: 683,
          thumbnail: true,
        },
        espece: 'granatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(28, 53, 21, 1.00)',
            'rgba(74, 91, 61, 1.00)',
            'rgba(49, 66, 37, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/punica [lythraceae]/punica granatum 'luteum plenum'/punica granatum 'luteum plenum' (2).jpg",
          width: 1024,
          id: '2509abd478946acbb72b0bca48f473a9',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 171, 113, 1.00)',
            'rgba(100, 130, 45, 1.00)',
            'rgba(56, 88, 17, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/punica [lythraceae]/punica granatum 'luteum plenum'/punica granatum 'luteum plenum' (1).jpg",
          width: 576,
          id: '239464bd07affb3b84e29431f15fa4c7',
          height: 768,
          thumbnail: true,
        },
        location: [47.271272, -1.584763],
        genre: 'Punica',
        cultivar: 'Luteum Plenum',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584763, 47.271272] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '42d21e36aa39f6bd24cbe978109e1288004f1611',
      fields: {
        espece: 'tulipifera',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Liriodendron',
        date_plantation: '1973',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ea539f4bcf978d86e1e8063acbef84ec4ca2b557',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'tulipifera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(62, 82, 50, 1.00)',
            'rgba(121, 122, 37, 1.00)',
            'rgba(69, 74, 18, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/liriodendron [magnoliaceae]/liriodendron tulipifera/liriodendron tulipifera (3).jpg',
          width: 699,
          id: '134a390de779c28de5354559639eab09',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(69, 106, 26, 1.00)',
            'rgba(130, 150, 53, 1.00)',
            'rgba(131, 149, 77, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/liriodendron [magnoliaceae]/liriodendron tulipifera/liriodendron tulipifera (5).jpg',
          width: 576,
          id: 'ad7b3e3c1f19cab9630c0922c3c21273',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 83, 69, 1.00)',
            'rgba(172, 156, 60, 1.00)',
            'rgba(83, 78, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/liriodendron [magnoliaceae]/liriodendron tulipifera/liriodendron tulipifera (2).jpg',
          width: 739,
          id: 'b51ffe1dece9489b23ca43ac0170a49a',
          height: 768,
          thumbnail: true,
        },
        location: [47.269372, -1.584355],
        genre: 'Liriodendron',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584355, 47.269372] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '14fa0b92c796c46c6206116b522830f065766448',
      fields: {
        espece: 'grandiflora',
        localisation: 'A12',
        nom_du_site: 'Jardin des Plantes',
        location: [47.22098, -1.5430278],
        genre: 'Magnolia',
        date_plantation: '1973',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5430278, 47.22098] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd7d63db0e2d89654867bbfc8833f590d98c0994b',
      fields: {
        espece: 'grandiflora',
        localisation: 'B1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2204652, -1.544656],
        genre: 'Magnolia',
        date_plantation: '1973',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544656, 47.2204652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6e3f4ad710f66a318afa70a412bfe102a509ae28',
      fields: {
        espece: 'stellata',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Magnolia',
        date_plantation: '1973',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c17e61e72217482d421701d18453e7ac2bd68e15',
      fields: {
        espece: 'x soulangiana',
        localisation: 'B7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198817, -1.5442188],
        genre: 'Magnolia',
        date_plantation: '1973',
        cultivar: 'Speciosa',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442188, 47.2198817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '285191181bf062a373faf26b36f3c77c6977c1f9',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(223, 164, 196, 1.00)',
            'rgba(158, 96, 125, 1.00)',
            'rgba(181, 156, 182, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'eleanor may'/magnolia 'eleanor may' (2).jpg",
          width: 576,
          id: '79d0630dc52b0e15b64cc13d53aec0a2',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 159, 151, 1.00)',
            'rgba(103, 97, 85, 1.00)',
            'rgba(95, 82, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'eleanor may'/magnolia 'eleanor may' (3).jpg",
          width: 576,
          id: '31a9ff6bdda5f7347d6e9529e1dce2c2',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 85, 81, 1.00)',
            'rgba(142, 115, 133, 1.00)',
            'rgba(83, 67, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'eleanor may'/magnolia 'eleanor may' (1).jpg",
          width: 576,
          id: '00fd5bd29549cfd0006974f27137e6e6',
          height: 768,
          thumbnail: true,
        },
        location: [47.270095, -1.583847],
        genre: 'Magnolia',
        cultivar: 'Eleanor May',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583847, 47.270095] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7b4d30ade6ea87a6a6e32266878984ac5de57fbc',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 118, 116, 1.00)',
            'rgba(136, 116, 135, 1.00)',
            'rgba(90, 78, 81, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia stellata 'keiskei plena'/magnolia stellata 'keiskei plena'  (2).jpg",
          width: 576,
          id: '7f425fe5437dacf57e54428152797c9f',
          height: 768,
          thumbnail: true,
        },
        espece: 'stellata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 112, 106, 1.00)',
            'rgba(155, 125, 145, 1.00)',
            'rgba(126, 103, 114, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia stellata 'keiskei plena'/magnolia stellata 'keiskei plena'   (3).jpg",
          width: 576,
          id: '403b2ea277c3e808d415027d9536a6f3',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 94, 88, 1.00)',
            'rgba(134, 126, 122, 1.00)',
            'rgba(94, 83, 81, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia stellata 'keiskei plena'/magnolia stellata 'keiskei plena'   (1).jpg",
          width: 576,
          id: '2eff184d3f1d6fc73ee4efd2ab6281d7',
          height: 768,
          thumbnail: true,
        },
        location: [47.270392, -1.586245],
        genre: 'Magnolia',
        cultivar: 'Keiskei Plena',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586245, 47.270392] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a2eb7f2b9ade058384050aa8d7de7497f596f4fa',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 179, 207, 1.00)',
            'rgba(135, 138, 130, 1.00)',
            'rgba(98, 86, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia x soulangeana 'white giant'/magnolia x soulangeana 'white giant' (5).jpg",
          width: 875,
          id: '37d972f4754e16a44e44968302ffad28',
          height: 768,
          thumbnail: true,
        },
        espece: 'x soulangeana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(176, 169, 150, 1.00)',
            'rgba(186, 170, 144, 1.00)',
            'rgba(80, 65, 32, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia x soulangeana 'white giant'/magnolia x soulangeana 'white giant' (3).jpg",
          width: 576,
          id: '53ffbed98c0f9c567a78b0f1d462ebab',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(191, 185, 163, 1.00)',
            'rgba(141, 121, 106, 1.00)',
            'rgba(150, 149, 145, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia x soulangeana 'white giant'/magnolia x soulangeana 'white giant' (1).jpg",
          width: 576,
          id: '84f4ac1a410984ddbb8ee3b0b3b6baee',
          height: 768,
          thumbnail: true,
        },
        location: [47.270962, -1.585403],
        genre: 'Magnolia',
        cultivar: 'White Giant',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585403, 47.270962] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'def58b98fca3f0aba42ced042ffc6eb86cc75ced',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'biloba var. parviflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 91, 55, 1.00)',
            'rgba(90, 103, 63, 1.00)',
            'rgba(91, 106, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/grewia [malvaceae]/grewia biloba var. parviflora/grewia biloba var. parviflora (2).jpg',
          width: 1024,
          id: 'd55d3a00f094d5aae7ca29ece5459f13',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 146, 54, 1.00)',
            'rgba(106, 146, 50, 1.00)',
            'rgba(99, 141, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/grewia [malvaceae]/grewia biloba var. parviflora/grewia biloba var. parviflora (3).jpg',
          width: 576,
          id: 'a613f5f8a5bfd8ef6abb8951a15305e9',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 117, 61, 1.00)',
            'rgba(77, 98, 56, 1.00)',
            'rgba(75, 110, 51, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/grewia [malvaceae]/grewia biloba var. parviflora/grewia biloba var. parviflora (1).jpg',
          width: 1024,
          id: 'f40f519c6edad7e71fbf62341aa98137',
          height: 683,
          thumbnail: true,
        },
        location: [47.271222, -1.58632],
        genre: 'Grewia',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58632, 47.271222] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '16247ce66f72eb6f5efa1694d9aecfccbac8cca5',
      fields: {
        espece: 'syriacus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 72, 58, 1.00)',
            'rgba(137, 141, 132, 1.00)',
            'rgba(56, 63, 41, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hibiscus [malvaceae]/hibiscus syriacus 'diana'/hibiscus syriacus 'diana' (2).jpg",
          width: 576,
          id: '7897ec9e75d6e4dcba44c8b5481eef2d',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 115, 85, 1.00)',
            'rgba(89, 106, 72, 1.00)',
            'rgba(101, 98, 71, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hibiscus [malvaceae]/hibiscus syriacus 'diana'/hibiscus syriacus 'diana' (1).jpg",
          width: 576,
          id: '1d94b66ffcc97a9d4b3cd7ef449e6586',
          height: 768,
          thumbnail: true,
        },
        location: [47.27132, -1.581505],
        genre: 'Hibiscus',
        cultivar: 'Diana',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581505, 47.27132] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '13805ba56939492a24bababe8f621b32a1959345',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 138, 47, 1.00)',
            'rgba(114, 148, 44, 1.00)',
            'rgba(77, 105, 23, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hoheria [malvaceae]/hoheria 'glory of amlwch'/hoheria 'glory of amlwch' (2).jpg",
          width: 576,
          id: '3576c7158ecb0e59c27c1f069b0db08c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 147, 58, 1.00)',
            'rgba(122, 148, 54, 1.00)',
            'rgba(120, 154, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hoheria [malvaceae]/hoheria 'glory of amlwch'/hoheria 'glory of amlwch' (3).jpg",
          width: 576,
          id: '9ab876e8e09ae69fb5069aecb1cc95db',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 94, 43, 1.00)',
            'rgba(118, 134, 96, 1.00)',
            'rgba(69, 82, 52, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hoheria [malvaceae]/hoheria 'glory of amlwch'/hoheria 'glory of amlwch' (1).jpg",
          width: 576,
          id: 'b9eca2e72ebd5fe83645288075794936',
          height: 768,
          thumbnail: true,
        },
        location: [47.271233, -1.58468],
        genre: 'Hoheria',
        cultivar: 'Glory of Amlwch',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58468, 47.271233] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fb930dbdcd2a5c3afba1aff43acf02edc8a1daa5',
      fields: {
        espece: 'africana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 106, 62, 1.00)',
            'rgba(144, 146, 110, 1.00)',
            'rgba(91, 87, 52, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/sparmannia [malvaceae]/sparmannia africana/sparmannia africana (2).jpg",
          width: 576,
          id: 'b994974c10495374e3f861ac90f456a6',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 150, 136, 1.00)',
            'rgba(135, 139, 97, 1.00)',
            'rgba(67, 75, 23, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/sparmannia [malvaceae]/sparmannia africana/sparmannia africana (1).jpg",
          width: 576,
          id: '9f27528551f1690ffaab51f406712ccc',
          height: 768,
          thumbnail: true,
        },
        location: [47.22678, -1.512637],
        genre: 'Sparmannia',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512637, 47.22678] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd0d02db494112e4832a1496996681f52eb05654b',
      fields: {
        espece: 'tomentosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 137, 89, 1.00)',
            'rgba(121, 149, 112, 1.00)',
            'rgba(106, 132, 97, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tilia [malvaceae]/tilia tomentosa/tilia tomentosa (2).jpg',
          width: 576,
          id: '150d36db238b87e27bc94132c4ee86ea',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 141, 116, 1.00)',
            'rgba(129, 145, 115, 1.00)',
            'rgba(107, 124, 92, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tilia [malvaceae]/tilia tomentosa/tilia tomentosa (1).jpg',
          width: 576,
          id: '6dfd8decb0e156ac793285b6a186b191',
          height: 768,
          thumbnail: true,
        },
        location: [47.271305, -1.582325],
        genre: 'Tilia',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582325, 47.271305] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '87d94011c5d2a20664fbb30ea184bedf82d85082',
      fields: {
        origine: 'JB.et Museum de Berolino-Dahlem (Allemagne)',
        espece: 'major L.',
        localisation: 'G2A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2197208, -1.5414609],
        genre: 'Melianthus',
        date_plantation: '2006',
        famille: 'Melianthaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5414609, 47.2197208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '57f0b999524dffc70818f1e993d4aa425ac9f099',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'pravissima',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 131, 165, 1.00)',
            'rgba(105, 124, 104, 1.00)',
            'rgba(98, 112, 93, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acacia [mimosaceae]/acacia pravissima/acacia pravissima (2).jpg',
          width: 576,
          id: 'bd781962dc7c1c50d5cff80848d23abb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 119, 105, 1.00)',
            'rgba(105, 119, 107, 1.00)',
            'rgba(86, 91, 78, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acacia [mimosaceae]/acacia pravissima/acacia pravissima.jpg',
          width: 576,
          id: '287e57dfbeebf428d5ed66a7160227e3',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 104, 71, 1.00)',
            'rgba(134, 135, 97, 1.00)',
            'rgba(137, 136, 95, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acacia [mimosaceae]/acacia pravissima/acacia pravissima  (2).jpg',
          width: 1024,
          id: '99076c0f00889039466caf16880388b1',
          height: 768,
          thumbnail: true,
        },
        location: [47.2701, -1.584742],
        genre: 'Acacia',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584742, 47.2701] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1927dcad7bab7ca625fd11d6678938834d8b37fb',
      fields: {
        espece: 'saman',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 161, 83, 1.00)',
            'rgba(96, 131, 65, 1.00)',
            'rgba(92, 121, 60, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/albizia [mimosaceae]/albizia saman/albizia saman.jpg",
          width: 1024,
          id: '7b911f5ca050899bcdfef05e45813677',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 121, 74, 1.00)',
            'rgba(98, 136, 57, 1.00)',
            'rgba(100, 128, 55, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/albizia [mimosaceae]/albizia saman/albizia saman (1).jpg",
          width: 576,
          id: '148e383ba992c7ef98e676dfcbdc0669',
          height: 768,
          thumbnail: true,
        },
        location: [47.227175, -1.512058],
        genre: 'Albizia',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512058, 47.227175] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4825502b1d405c03ce63dad3b1e90b71110c90ad',
      fields: {
        espece: 'rigidus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 102, 73, 1.00)',
            'rgba(157, 113, 105, 1.00)',
            'rgba(141, 112, 93, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/callistemon [myrtaceae]/callistemon rigidus 'beaujoire'/callistemon rigidus 'beaujoire' (2).jpg",
          width: 576,
          id: '746a6afde18f41930ccea18ae32331be',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 121, 71, 1.00)',
            'rgba(121, 146, 80, 1.00)',
            'rgba(128, 144, 87, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/callistemon [myrtaceae]/callistemon rigidus 'beaujoire'/callistemon rigidus 'beaujoire' (1).jpg",
          width: 576,
          id: 'bc7923222e9375fc33c692cf6482ea64',
          height: 768,
          thumbnail: true,
        },
        location: [47.271312, -1.58662],
        genre: 'Callistemon',
        cultivar: 'Beaujoire',
        famille: 'Myrtaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58662, 47.271312] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4ed0c12fc495f89b11f7bd3d0944cdd31532cb33',
      fields: {
        origine: 'INH Angers',
        espece: 'sp.',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Jasminum',
        date_plantation: '2013',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8155fcfb23423aed3bd42c2bbce834c2d727602b',
      fields: {
        espece: 'x intermedia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 108, 17, 1.00)',
            'rgba(146, 127, 24, 1.00)',
            'rgba(119, 96, 11, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/forsythia [oleaceae]/forsythia x intermedia 'spring glory'/forsythia x intermedia 'spring glory' (2).jpg",
          width: 576,
          id: '07a93e7775bfb912e4027ffa8653d8b9',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 105, 85, 1.00)',
            'rgba(129, 117, 39, 1.00)',
            'rgba(116, 94, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/forsythia [oleaceae]/forsythia x intermedia 'spring glory'/forsythia x intermedia 'spring glory' (1).jpg",
          width: 1024,
          id: '03a0181c24b81cbb439f1ac5f3fcb6b7',
          height: 768,
          thumbnail: true,
        },
        location: [47.269975, -1.585697],
        genre: 'Forsythia',
        cultivar: 'Spring Glory',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585697, 47.269975] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bb6a059646fc1cd18597b966052bed523f3a717f',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(202, 202, 209, 1.00)',
            'rgba(126, 118, 93, 1.00)',
            'rgba(89, 87, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus angustifolia 'raywood'/fraxinus angustifolia 'raywood' (4).jpg",
          width: 576,
          id: 'e176c7bfc2d4b183a6b6badea97e82d6',
          height: 768,
          thumbnail: true,
        },
        espece: 'angustifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 151, 143, 1.00)',
            'rgba(109, 90, 61, 1.00)',
            'rgba(120, 104, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus angustifolia 'raywood'/fraxinus angustifolia 'raywood' (3).jpg",
          width: 608,
          id: '55ca04ee36cd571893a1b33e4ccd111f',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 126, 113, 1.00)',
            'rgba(121, 123, 111, 1.00)',
            'rgba(114, 116, 118, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus angustifolia 'raywood'/fraxinus angustifolia 'raywood' (2).jpg",
          width: 617,
          id: '4c108a025e6fd4eda58a0570c4400d1b',
          height: 768,
          thumbnail: true,
        },
        location: [47.268858, -1.584878],
        genre: 'Fraxinus',
        cultivar: 'Raywood',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584878, 47.268858] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9f78907b9409ced03cdc8d9866d5d00e4526fd26',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(189, 205, 167, 1.00)',
            'rgba(133, 138, 69, 1.00)',
            'rgba(75, 81, 36, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus excelsior 'jaspidea'/fraxinus excelsior 'jaspidea' .jpg",
          width: 1024,
          id: '49402cf4ea4be9c550fbba44a696bbfc',
          height: 768,
          thumbnail: true,
        },
        espece: 'excelsior',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(217, 233, 231, 1.00)',
            'rgba(114, 134, 93, 1.00)',
            'rgba(88, 101, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus excelsior 'jaspidea'/fraxinus excelsior 'jaspidea' (4).jpg",
          width: 1024,
          id: '31a29a8914a3c8088162b3ec4127b4ab',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 123, 74, 1.00)',
            'rgba(147, 148, 94, 1.00)',
            'rgba(112, 127, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus excelsior 'jaspidea'/fraxinus excelsior 'jaspidea' (3).jpg",
          width: 576,
          id: '9ae457ba9afb5e3fe84ac525706b6833',
          height: 768,
          thumbnail: true,
        },
        location: [47.26978, -1.582263],
        genre: 'Fraxinus',
        cultivar: 'Jaspidea',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582263, 47.26978] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c480d79afb271f24ce398badc304bf4f6db53cbc',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'profunda',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 134, 89, 1.00)',
            'rgba(143, 136, 86, 1.00)',
            'rgba(120, 117, 102, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus profunda/fraxinus profunda (2).jpg',
          width: 576,
          id: 'c7318062027b901f44de7c28d5125208',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 122, 73, 1.00)',
            'rgba(149, 137, 84, 1.00)',
            'rgba(137, 126, 77, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus profunda/fraxinus profunda (3).jpg',
          width: 576,
          id: '33a2348c72d5437ad7b8f1faeb670b8d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 137, 83, 1.00)',
            'rgba(135, 140, 90, 1.00)',
            'rgba(119, 111, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus profunda/fraxinus profunda (1).jpg',
          width: 576,
          id: 'ee67145321b6e9e6c7dd40267931bdea',
          height: 768,
          thumbnail: true,
        },
        location: [47.270942, -1.585083],
        genre: 'Fraxinus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585083, 47.270942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4fbc19c5fe72526283602c993a669a7574793b6c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x burkwoodii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(179, 187, 186, 1.00)',
            'rgba(91, 91, 68, 1.00)',
            'rgba(74, 74, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus x burkwoodii/osmanthus x burkwoodii (2).jpg',
          width: 976,
          id: '670d7da8833c1e3f2b8bee42df3eb21d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 104, 74, 1.00)',
            'rgba(111, 128, 100, 1.00)',
            'rgba(91, 114, 81, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus x burkwoodii/osmanthus x burkwoodii (fleur).jpg',
          width: 576,
          id: 'fd686dd7f9747cb6ed4eaa566c5c54c6',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 147, 101, 1.00)',
            'rgba(123, 143, 86, 1.00)',
            'rgba(116, 141, 70, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus x burkwoodii/osmanthus x burkwoodii  (1).jpg',
          width: 576,
          id: 'e0beae84e76f30f26fb72243efdeb807',
          height: 768,
          thumbnail: true,
        },
        location: [47.271725, -1.582597],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582597, 47.271725] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '16513d598cf28f92a867538395163006ae1c2dec',
      fields: {
        espece: 'x fortunei',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(54, 65, 29, 1.00)',
            'rgba(91, 95, 57, 1.00)',
            'rgba(117, 120, 70, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus x fortunei/osmanthus x fortunei  (8).jpg',
          width: 1024,
          id: 'ad332f01c5f143dd4fa5b0730f5aa230',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 146, 112, 1.00)',
            'rgba(87, 98, 50, 1.00)',
            'rgba(93, 97, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus x fortunei/osmanthus x fortunei  (7).jpg',
          width: 512,
          id: '926fa6f48467da10672be4740db5bc33',
          height: 768,
          thumbnail: true,
        },
        location: [47.271145, -1.582122],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582122, 47.271145] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9abf0b154bfefe4fe1ad6edb837ac15153e24866',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'angustifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 130, 73, 1.00)',
            'rgba(133, 136, 96, 1.00)',
            'rgba(166, 158, 141, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/phillyrea [oleaceae]/phillyrea angustifolia/phillyrea angustifolia (2).jpg',
          width: 686,
          id: '29e1b423e34174262e2818fe114afa80',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(167, 167, 142, 1.00)',
            'rgba(113, 119, 72, 1.00)',
            'rgba(98, 95, 70, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/phillyrea [oleaceae]/phillyrea angustifolia/phillyrea angustifolia (3).jpg',
          width: 576,
          id: '068f701ba6feb900c4a976b3107f4a35',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 132, 69, 1.00)',
            'rgba(128, 130, 78, 1.00)',
            'rgba(121, 120, 86, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/phillyrea [oleaceae]/phillyrea angustifolia/phillyrea angustifolia (1).jpg',
          width: 576,
          id: 'c59008576f505f38e3cb6b2e4f5b04c4',
          height: 768,
          thumbnail: true,
        },
        location: [47.271453, -1.587245],
        genre: 'Phillyrea',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587245, 47.271453] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a9ba4c63d76b90896e829e830677b203c225dfa6',
      fields: {
        espece: 'reticulata ssp. pekinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(188, 204, 186, 1.00)',
            'rgba(58, 86, 45, 1.00)',
            'rgba(62, 81, 33, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/syringa [oleaceae]/syringa reticulata ssp. pekinensis/syringa reticulata ssp. pekinensis (1).jpg',
          width: 537,
          id: 'ff88a16d88773cdea8c9939155f425cb',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 136, 52, 1.00)',
            'rgba(119, 140, 77, 1.00)',
            'rgba(57, 85, 22, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/syringa [oleaceae]/syringa reticulata ssp. pekinensis/syringa reticulata ssp. pekinensis  (2).jpg',
          width: 576,
          id: 'f36e1923e8dc0bb968e2a2ea04596c81',
          height: 768,
          thumbnail: true,
        },
        location: [47.271217, -1.582272],
        genre: 'Syringa',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582272, 47.271217] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '101ea8090b8523d24dcfa9be81837fb3144a7162',
      fields: {
        origine: 'Botanischer Garten Bielefeld, Bielefeld, Allemagne',
        espece: 'fruticosa L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Oenothera',
        date_plantation: '2012',
        famille: 'Onagraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0bc0c3baecaa52a8db3199abafb6b6d2e604bd57',
      fields: {
        origine: 'Botanischer Garten, Tubingen, Allemagne',
        espece: 'organensis Munz',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Oenothera',
        date_plantation: '2012',
        famille: 'Onagraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '842f61b1d0cc1133f77b72aca721afaff8da6a39',
      fields: {
        origine: 'p\u00e9pini\u00e8re Ellebore',
        espece: 'reginae Walter',
        localisation: 'B5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202019, -1.5440256],
        genre: 'Cypripedium',
        date_plantation: '2015',
        famille: 'Orchidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440256, 47.2202019] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '816a579bf96e7abb88b138cb0dabbec576d6292d',
      fields: {
        origine: 'Ets.Lepage',
        espece: 'regalis L.',
        localisation: 'G1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193375, -1.5415093],
        genre: 'Osmunda',
        date_plantation: '1986',
        famille: 'Osmundaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5415093, 47.2193375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c7495dd046240eae61bce55029d54d5476723251',
      fields: {
        origine: "jardins d'\u00e9coute s'il pleut",
        espece: 'claytoniana L.',
        localisation: 'B5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202019, -1.5440256],
        genre: 'Osmunda',
        date_plantation: '2015',
        famille: 'Osmundaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440256, 47.2202019] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '433e29d0157b50e9e2d6129db408dc31cd840977',
      fields: {
        origine: 'JBU.of Tartu (Estonie)',
        espece: 'mascula Miller',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Paeonia',
        date_plantation: '2001',
        famille: 'Paeoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '61c2d1d81ce166b9d0be389789ed652da53d85f4',
      fields: {
        origine: "P\u00e9pini\u00e8re Val d'Erdre",
        espece: 'nigra',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Pinus',
        date_plantation: '2015',
        cultivar: 'laricio',
        famille: 'Pinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '220565f6f25ebbdf668371b5813e4d2309a9c450',
      fields: {
        espece: 'strobus',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(215, 225, 207, 1.00)',
            'rgba(83, 108, 62, 1.00)',
            'rgba(52, 66, 36, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pinus [pinaceae]/pinus strobus/pinus strobus.jpg',
          width: 576,
          id: '222a5a035af2dd29e86eb587e776e866',
          height: 768,
          thumbnail: true,
        },
        location: [47.271345, -1.585667],
        genre: 'Pinus',
        famille: 'Pinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585667, 47.271345] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3473ca1b93daf274a5630a75a66927378e2c143e',
      fields: {
        espece: 'brevicalyx',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 98, 40, 1.00)',
            'rgba(116, 116, 54, 1.00)',
            'rgba(130, 134, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pittosporum [pittosporaceae]/pittosporum brevicalyx/pittosporum brevicalyx.jpg',
          width: 1024,
          id: '3ee752e226a88b6760891b152c9ace05',
          height: 683,
          thumbnail: true,
        },
        location: [47.270805, -1.585503],
        genre: 'Pittosporum',
        famille: 'Pittosporaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585503, 47.270805] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '577e135f290bc505c4e8336e60219e1595419426',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'tobira',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 165, 47, 1.00)',
            'rgba(100, 163, 19, 1.00)',
            'rgba(72, 121, 22, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pittosporum [pittosporaceae]/pittosporum tobira/pittosporum tobira (3).jpg',
          width: 416,
          id: 'a13a1b882a2a4733cc790afce88af21a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(62, 85, 26, 1.00)',
            'rgba(105, 122, 72, 1.00)',
            'rgba(49, 70, 26, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pittosporum [pittosporaceae]/pittosporum tobira/pittosporum tobira (4).jpg',
          width: 576,
          id: 'd4fc7d068b2fe6a401ddc5c09217350f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 174, 54, 1.00)',
            'rgba(103, 157, 29, 1.00)',
            'rgba(67, 108, 22, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pittosporum [pittosporaceae]/pittosporum tobira/pittosporum tobira (1).jpg',
          width: 576,
          id: '8b2438540d0beca6197e5c75db7cd377',
          height: 768,
          thumbnail: true,
        },
        location: [47.270488, -1.582575],
        genre: 'Pittosporum',
        famille: 'Pittosporaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582575, 47.270488] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '711e4139758ebbd973efb7fe041a911a59683d4c',
      fields: {
        espece: 'tobira',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(50, 67, 19, 1.00)',
            'rgba(86, 108, 41, 1.00)',
            'rgba(67, 84, 26, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pittosporum [pittosporaceae]/pittosporum tobira/pittosporum tobira (2).jpg',
          width: 1024,
          id: 'eafbea63f02f827398c22166b3d2b0b2',
          height: 683,
          thumbnail: true,
        },
        location: [47.270489, -1.582575],
        genre: 'Pittosporum',
        famille: 'Pittosporaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582575, 47.270489] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4a36ec1d7093b45e06ade00c344324c990415c5b',
      fields: {
        origine: 'Friedrich Alexander B.G. Erlangen (All.)',
        espece: 'obscura L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Digitalis',
        date_plantation: '2014',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5b0481b58d6fa0d0d85d5b58a128570774f5ca5c',
      fields: {
        origine: 'J. alpin la Ramberta, Montreux (Suisse)',
        espece: 'incanescens Viv.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Globularia',
        date_plantation: '2011',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c71d8ac31e3fda212fa3b019edb704f9b3b4484e',
      fields: {
        origine: 'J.Alp.Meyrin (Suisse)',
        espece: 'alpinus L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Erinus',
        date_plantation: '1999',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '42c63ce95d0734f50bc719f96c9334cd45de6084',
      fields: {
        origine: 'JB. des Olfacties, Coex (France)',
        espece: 'lutea L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Digitalis',
        date_plantation: '2011',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a4d4241c1f055d97e926f6d35cc2ff9c4e3f34d2',
      fields: {
        origine: 'JB.Chemnitz (Allemagne)',
        espece: 'ciliata Traurt.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Digitalis',
        date_plantation: '2006',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '95a00f6405b877429e0f797b80a4f61e1e576553',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'ferruginea L.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Digitalis',
        date_plantation: '2006',
        cultivar: 'schisckinii',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '48a7fbae8885f9cd3d0d6e16adf23501990bfe3a',
      fields: {
        origine: 'P\u00e9pini\u00e8re Akebia',
        espece: 'villosulum T.Yamaz',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Veronicastrum',
        date_plantation: '2015',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b55bc3c271979f57b5b772b3208281938ed13fcf',
      fields: {
        origine: 'Real Jardin Botanico Juan Carlos, Alcala de Henares, Espagne',
        espece: 'erectum Erben',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Limonium',
        date_plantation: '2012',
        famille: 'Plumbaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '387524cdb94574ef19e263c65c4bd22f47faf4ed',
      fields: {
        origine: 'Universita degli studi de Catania',
        espece: 'secundirameum Brullo',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Limonium',
        date_plantation: '2010',
        famille: 'Plumbaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9c0b54311fe6d56b9227603da4dfac4af0633b39',
      fields: {
        origine: 'J.Alp.U.Insbruck (Autriche)',
        espece: 'badensis Haenke ex Wild',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Poa',
        date_plantation: '2006',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '15da0911ceb2525e7cf454c54f1dfb9b776782b3',
      fields: {
        origine: 'JB.Budapest (Hongrie)',
        espece: 'transsilvanica Schur.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Melica',
        date_plantation: '2009',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f98fef0790412408c7fac8a9953d8712868d8993',
      fields: {
        origine: 'JB.Rostov ad Donum (Russie)',
        espece: 'ucrainica P.Smirn.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Stipa',
        date_plantation: '2009',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4226caa336402b83ee224337fb3ac239b9ea9b24',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'racemosum Kitam',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Polemonium',
        date_plantation: '2008',
        famille: 'Polemoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b3c3eaf384221ce60720f86863d344795cda01b6',
      fields: {
        origine: 'B.G. Kiel (All.)',
        espece: 'jamesii Benth.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Eriogonum',
        date_plantation: '2014',
        famille: 'Polygonaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1c591acc83084091c58f2d32c4aa73f194eeb1f9',
      fields: {
        origine: 'J. alpin Viotte, Trento (Italie)',
        espece: 'palmatum L.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Rheum',
        date_plantation: '2011',
        famille: 'Polygonaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e6898c96067d2a2c4e2bd66a63d73230a163e785',
      fields: {
        origine: 'JB.Montr\u00e9al (Canada)',
        espece: 'virginianum L.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Polygonum',
        date_plantation: '2006',
        famille: 'Polygonaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dbd2c93d67521ca8ee34c5451bd828a77be997ba',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'tinctoria',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 141, 58, 1.00)',
            'rgba(121, 143, 68, 1.00)',
            'rgba(90, 113, 45, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lomatia [proteaceae]/lomatia tinctoria/lomatia tinctoria (2).jpg',
          width: 576,
          id: '4f122aa86900ba13e80837990f892776',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 178, 104, 1.00)',
            'rgba(120, 149, 77, 1.00)',
            'rgba(101, 119, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lomatia [proteaceae]/lomatia tinctoria/lomatia tinctoria (3).jpg',
          width: 1024,
          id: 'a1d7ddc4e5b9922b6db87c0fe495329d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 175, 103, 1.00)',
            'rgba(121, 154, 73, 1.00)',
            'rgba(97, 133, 45, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lomatia [proteaceae]/lomatia tinctoria/lomatia tinctoria (1).jpg',
          width: 576,
          id: '9f5be989163cdcaaab696ff94055cb67',
          height: 768,
          thumbnail: true,
        },
        location: [47.27165, -1.582195],
        genre: 'Lomatia',
        famille: 'Proteaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582195, 47.27165] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '63916686a8679d08392580c48181a9be5ce2cafb',
      fields: {
        origine: 'Botanic Garden of Siauliai University, Siauliai, Lithuanie',
        espece: 'zimmermannii Soo',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Pulsatilla',
        date_plantation: '2012',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cdc3201e667d3cd7d4294b323b6a39fee2371a51',
      fields: {
        origine: 'Im Eichholz B.G. Gruningen (Suisse)',
        espece: 'chinensis Bunge',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Trollius',
        date_plantation: '2014',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b8aa7208a2a783cb6eb4de34a11cff2e905f953b',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'ottonis Orph.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Aquilegia',
        date_plantation: '2006',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b9df90650842271a1f7a40007f71a4dbc0ff8140',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'vaginatus',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Trollius',
        date_plantation: '2006',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3f53384ba6cfe71fe6308d938861473a1608fd4c',
      fields: {
        origine: 'JB.Helsinki (Finlande)',
        espece: 'sp.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Thalictrum',
        date_plantation: '2009',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '236e11cc8623624ce2d63c4fa170c5db179988c0',
      fields: {
        origine: 'JB.Hokkaido (Japon)',
        espece: 'flabellata',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Aquilegia',
        date_plantation: '2009',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b7df0bb0f5a48ce5cc1a4747cc2696c495a0ba5a',
      fields: {
        origine: 'JB.P\u00e9kin (Chine)',
        espece: 'thumbergii  DC.',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Thalictrum',
        date_plantation: '2008',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '33b48d04ba52e868a8d440aa42161f706fba09f2',
      fields: {
        origine: 'JBU.Berkeley (USA)',
        espece: 'formosa Fisch.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Aquilegia',
        date_plantation: '2003',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cfbfe56ceeb49eceb082e613d1e8f99d51097d0c',
      fields: {
        origine: 'JBU.Tartuensis (Norv\u00e9ge)',
        espece: 'europaea Schipez.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Cimicifuga',
        date_plantation: '2004',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd42ed89051b0bdcf1abb974b416eb418d0175ae6',
      fields: {
        origine: 'JB.P\u00e9kin (Chine)',
        espece: 'dahurica Huth.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Cimicifuga',
        date_plantation: '1992',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e0ba02b4a9c1032ca2dd260916ab5501481f5dda',
      fields: {
        origine: 'Universit\u00e9 Bot. Toronto (Canada)',
        espece: 'canadensis L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Aquilegia',
        date_plantation: '1990',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9ecd11401daf1d9e2d5d473ca18f49a1e342a1fb',
      fields: {
        origine: 'Rog\u00f3w Arboretum of Warsaw University of Life Sciences',
        espece: 'costata',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Rhamnus',
        date_plantation: '2012',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b5d535310d81f6658bdcceec27d76f964de2619d',
      fields: {
        origine: 'Acad\u00e9mie des sciences Sofia (Bulgarie)',
        espece: 'spina-christii',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Paliurus',
        date_plantation: '2003',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8a9dc14db0c55d701c4b8648725b7d7c58835f94',
      fields: {
        origine: 'JB Tashkent (Uzbekistan)',
        espece: 'jujuba',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Ziziphus',
        date_plantation: '2008',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9bf8459c88caca536771a15677e8ead8d72f9dc5',
      fields: {
        origine: 'JB Tubigen',
        espece: 'paradoxa',
        localisation: 'A2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2208871, -1.5444631],
        genre: 'Colletia',
        date_plantation: '2011',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444631, 47.2208871] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ca4d409b74f0b07603c82afe8551410fcf10cca9',
      fields: {
        origine:
          "Station de recherche et d'\u00e9ducation \u00e0 l'environnement de Marijampol\u00e8 - Lituanie",
        espece: 'triflorum Pursh.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Geum',
        date_plantation: '2011',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '810dae3f61d5357d9bbce3041188840095150689',
      fields: {
        origine: 'Arb.Chinense Academy of Sciences Shenyang (Chine)',
        espece: 'pubescens',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2004',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7553f63870470157e645f6e01aacbf86771f5c65',
      fields: {
        origine: 'Arboretum  Universit\u00e9e de Seoul-Suwon (Cor\u00e9e)',
        espece: 'hakisanensis Makino',
        localisation: 'D3B',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202573, -1.5419327],
        genre: 'Sanguisorba',
        date_plantation: '2009',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5419327, 47.2202573] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8ef3cbc67fb1569e98e82069287541eed0c8d940',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'japonica',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        cultivar: 'Fastigiata',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '62f5711962c2991d8f9090bc2aa9fff41311c2ee',
      fields: {
        origine: 'Conservatoire & Arboretum des Barres',
        espece: 'chamaedryfolia',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2009',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '820dafa4bf822350d24397ce85d89770c3698b17',
      fields: {
        origine: 'Ets.Lepage',
        espece: 'novae-zelandiae T.Kirk.',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Acaena',
        date_plantation: '1986',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5aca77d71a66f4b761a82a65ed8ebb96d5fe616e',
      fields: {
        origine: 'I.N.R.A. Station de Botanique Villa Thuret Antibles (France)',
        espece: 'nussia',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Photinia',
        date_plantation: '1986',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6b3a60f0ef1fdd28909616bd9ff7f1c50f273e26',
      fields: {
        origine: 'J. alpin la Ramberta, Montreux (Suisse)',
        espece: 'japonicum Thunb.',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Geum',
        date_plantation: '2011',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bedf8b0a7f72ba350389748a21a3d3d784f11f44',
      fields: {
        origine: 'J.B. Bergen (Norv\u00e8ge)',
        espece: 'argentea Ruiz & Pav.',
        localisation: 'G2A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2197208, -1.5414609],
        genre: 'Acaena',
        date_plantation: '2011',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5414609, 47.2197208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a5a5a68669174f6cbb49872cdb2c89ba0148e1e4',
      fields: {
        origine: 'JB.Alp.Kirovsk (Russie)',
        espece: 'macrophyllum Willd.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Geum',
        date_plantation: '1990',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '026015b8187c976a3cf05a78bb9cf4dc559dfa0d',
      fields: {
        origine: 'JB.Gewurz (Allemagne)',
        espece: 'chiloense  Balb.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Geum',
        date_plantation: '2008',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7d397c3a6639dfb439efaf7bd93dae829bb6fc4a',
      fields: {
        origine: 'JB.Lautaret (France)',
        espece: 'magellanica  Vahl',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Acaena',
        date_plantation: '2008',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4fbbdf656a40bcd0b5c735b996069abda811f91c',
      fields: {
        origine: 'JB.Long Wu Road Shangha\u00ef (Chine)',
        espece: 'arborea',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Sorbaria',
        date_plantation: '2003',
        cultivar: 'glabrata',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3a38897c6b23c14338e24f420f2f6693245218e0',
      fields: {
        origine: 'JB.Montr\u00e9al (Canada)',
        espece: 'allepicum',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Geum',
        date_plantation: '2008',
        cultivar: 'strictum R.T.Clausen',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '29dc2a2c931e70168a01f4ae1a443a95b1acfef5',
      fields: {
        origine: 'JB.Mount holyoke',
        espece: 'virginiana Duchesne',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Fragaria',
        date_plantation: '1998',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6d87d956ed0937da902fb32ddae8859e84673f3d',
      fields: {
        origine: 'P\u00e9pini\u00e8re Municipale du Grand Blottereau',
        espece: 'japonica',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '1996',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'eb4e06ed578b381a92cc223de96454cb3a6ae959',
      fields: {
        espece: 'speciosa',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(180, 177, 182, 1.00)',
            'rgba(122, 118, 106, 1.00)',
            'rgba(69, 74, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/chaenomeles [rosaceae]/chaenomeles speciosa 'nivalis'/chaenomeles speciosa 'nivalis' (1).jpg",
          width: 576,
          id: 'e8cbaca694e2d40fd718ce74cb4e27f4',
          height: 768,
          thumbnail: true,
        },
        location: [47.27147, -1.586003],
        genre: 'Chaenomeles',
        cultivar: 'Nivalis',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586003, 47.27147] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd43677d9593e94219434ff4ae106dfde8e00548b',
      fields: {
        espece: 'speciosa',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 96, 87, 1.00)',
            'rgba(114, 101, 69, 1.00)',
            'rgba(82, 71, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/chaenomeles [rosaceae]/chaenomeles speciosa 'nivalis'/chaenomeles speciosa 'nivalis' (3).jpg",
          width: 1024,
          id: '863dc7f93a6f9642e2c7077f56d02b4d',
          height: 683,
          thumbnail: true,
        },
        location: [47.27147, -1.585998],
        genre: 'Chaenomeles',
        cultivar: 'Nivalis',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585998, 47.27147] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '122794ba9766a31324e2451322f4ace0f96f1863',
      fields: {
        espece: 'speciosa',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 93, 90, 1.00)',
            'rgba(166, 112, 117, 1.00)',
            'rgba(125, 103, 99, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/chaenomeles [rosaceae]/chaenomeles speciosa 'umbilicata'/chaenomeles speciosa 'umbilicata'.jpg",
          width: 576,
          id: '74ed245268b02dfae2a8b2a1f8ee9714',
          height: 768,
          thumbnail: true,
        },
        location: [47.270292, -1.586067],
        genre: 'Chaenomeles',
        cultivar: 'Umbilicata',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586067, 47.270292] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6083fc263c12798b4629725754274bea1132519f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(192, 194, 180, 1.00)',
            'rgba(123, 114, 99, 1.00)',
            'rgba(88, 98, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'royalty'/malus 'royalty' .jpg",
          width: 841,
          id: '67029a810b56aadf825bf531f9f5be30',
          height: 768,
          thumbnail: true,
        },
        location: [47.271328, -1.586697],
        genre: 'Malus',
        cultivar: 'Royalty',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586697, 47.271328] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bc714954374c8e8f9989901ca73c14086620a34b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'tschonoskii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 94, 51, 1.00)',
            'rgba(181, 107, 45, 1.00)',
            'rgba(164, 111, 71, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/malus [rosaceae]/malus tschonoskii/malus tschonoskii  (2).jpg',
          width: 576,
          id: '58cc871720a7d8da95c0b6369785044a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(194, 186, 188, 1.00)',
            'rgba(132, 102, 74, 1.00)',
            'rgba(62, 61, 22, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/malus [rosaceae]/malus tschonoskii/malus tschonoskii  (3).jpg',
          width: 576,
          id: '385970131226d1c2c0b853fb9e9a418b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 176, 198, 1.00)',
            'rgba(139, 106, 73, 1.00)',
            'rgba(78, 75, 30, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/malus [rosaceae]/malus tschonoskii/malus tschonoskii  (1).jpg',
          width: 576,
          id: 'f3d0171419f89bf027415d2b0cff4a2a',
          height: 768,
          thumbnail: true,
        },
        location: [47.269892, -1.585637],
        genre: 'Malus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585637, 47.269892] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '731890f068c2f269141741b0379165895c518e4c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 114, 132, 1.00)',
            'rgba(117, 111, 104, 1.00)',
            'rgba(76, 72, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'sunset boulevard'/prunus 'sunset boulevard' (3).jpg",
          width: 1024,
          id: 'd45175b962b3c40df2012e82d14af9b9',
          height: 732,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 109, 123, 1.00)',
            'rgba(132, 123, 119, 1.00)',
            'rgba(94, 90, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'sunset boulevard'/prunus 'sunset boulevard' (4).jpg",
          width: 1024,
          id: 'e8fa2bd77dda83652cc8f924fc63aa98',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 157, 185, 1.00)',
            'rgba(120, 121, 134, 1.00)',
            'rgba(79, 75, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'sunset boulevard'/prunus 'sunset boulevard' (2).jpg",
          width: 1024,
          id: '65608f5ef0e74bf270d942209ee59314',
          height: 683,
          thumbnail: true,
        },
        location: [47.270988, -1.585197],
        genre: 'Prunus',
        cultivar: 'Sunset Boulevard',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585197, 47.270988] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '909cb7d9332b46a7f4605d650086a4ce860eba61',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 93, 86, 1.00)',
            'rgba(114, 107, 97, 1.00)',
            'rgba(116, 105, 94, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus incisa 'diva'/prunus incisa 'diva' (7).jpg",
          width: 1024,
          id: 'b3e8dd2660c4eaea836b241dee542880',
          height: 683,
          thumbnail: true,
        },
        espece: 'incisa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(186, 182, 188, 1.00)',
            'rgba(134, 116, 108, 1.00)',
            'rgba(83, 77, 48, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus incisa 'diva'/prunus incisa 'diva' (6).jpg",
          width: 512,
          id: 'ddda39251a9cd2ecdaeb0760c84106a4',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(211, 208, 212, 1.00)',
            'rgba(112, 102, 87, 1.00)',
            'rgba(82, 79, 46, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus incisa 'diva'/prunus incisa 'diva' (5).jpg",
          width: 1024,
          id: '91dee2c19515d7e5d8da744c85943f23',
          height: 683,
          thumbnail: true,
        },
        location: [47.271092, -1.584588],
        genre: 'Prunus',
        cultivar: 'Diva',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584588, 47.271092] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bd49e39ba1b2bc3547eab52c1594aafef62dbb74',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 130, 123, 1.00)',
            'rgba(152, 145, 146, 1.00)',
            'rgba(130, 119, 118, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus mume 'omoi-no-mama'/prunus mume 'omoi-no-mama' (2).jpg",
          width: 576,
          id: 'f22b02c093e45426c54c03bba39192a9',
          height: 768,
          thumbnail: true,
        },
        espece: 'mume',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 130, 120, 1.00)',
            'rgba(134, 127, 118, 1.00)',
            'rgba(142, 139, 132, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus mume 'omoi-no-mama'/prunus mume 'omoi-no-mama' (1).jpg",
          width: 576,
          id: '0f973f7d2142675af59f007cd5d4f40c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 118, 115, 1.00)',
            'rgba(109, 112, 100, 1.00)',
            'rgba(99, 100, 101, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus mume 'omoi-no-mama'/prunus mume 'omoi-no-mama'  (1).jpg",
          width: 512,
          id: 'bb91396304edc8adcceddc638d85f99d',
          height: 768,
          thumbnail: true,
        },
        location: [47.27012, -1.585817],
        genre: 'Prunus',
        cultivar: 'Omoi-no-mama',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585817, 47.27012] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7eaa9e5820a6aecd3755c859880d3657840d957e',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 142, 124, 1.00)',
            'rgba(122, 123, 96, 1.00)',
            'rgba(112, 107, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/pyrus [rosaceae]/pyrus calleryana 'chanticleer'/pyrus calleryana 'chanticleer' (2).jpg",
          width: 576,
          id: '1fd9d54b0623814ae0e9658fbae889cf',
          height: 768,
          thumbnail: true,
        },
        espece: 'calleryana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 162, 192, 1.00)',
            'rgba(127, 138, 140, 1.00)',
            'rgba(115, 103, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/pyrus [rosaceae]/pyrus calleryana 'chanticleer'/pyrus calleryana 'chanticleer'  (2).jpg",
          width: 576,
          id: '08e3de47e69a61248f399e67d411f796',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 144, 162, 1.00)',
            'rgba(137, 145, 145, 1.00)',
            'rgba(92, 88, 67, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/pyrus [rosaceae]/pyrus calleryana 'chanticleer'/pyrus calleryana 'chanticleer'  (1).jpg",
          width: 576,
          id: '672c2bd2c924c6ec9eb6bda9d7347ca1',
          height: 768,
          thumbnail: true,
        },
        location: [47.269888, -1.581908],
        genre: 'Pyrus',
        cultivar: 'Chanticleer',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581908, 47.269888] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '95840ba1ced8c30111c43d5999cc110fe8391793',
      fields: {
        espece: 'henryi',
        localisation: 'A11',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2211256, -1.5428042],
        genre: 'Rosa',
        date_plantation: '1973',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428042, 47.2211256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '147439dc5cb6ee67f5f9c3526ee0cec43ce19c70',
      fields: {
        espece: 'fritschiana',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c8b15a6966a8ca5d24b8575009578d708da7af94',
      fields: {
        espece: 'canescens var. glaucophylla',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 139, 65, 1.00)',
            'rgba(103, 145, 81, 1.00)',
            'rgba(105, 142, 82, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea canescens var. glaucophylla/spiraea canescens var. glaucophylla (2).jpg',
          width: 576,
          id: '4179e8f3710690dd9bf1230a4fbad4a6',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 167, 94, 1.00)',
            'rgba(102, 156, 86, 1.00)',
            'rgba(96, 142, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea canescens var. glaucophylla/spiraea canescens var. glaucophylla (1).jpg',
          width: 576,
          id: '70a7184644fe8bc2f5d9472f7124143c',
          height: 768,
          thumbnail: true,
        },
        location: [47.270342, -1.581792],
        genre: 'Spiraea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581792, 47.270342] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '101f697273726e78c3189eab6e07befd6460ccaa',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'occidentalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 98, 48, 1.00)',
            'rgba(100, 127, 88, 1.00)',
            'rgba(50, 73, 35, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cephalanthus [rubiaceae]/cephalanthus occidentalis/cephalanthus occidentalis (4).jpg',
          width: 1024,
          id: '4ebb6bc4d51a9d9c6078c0265f2a98b5',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 109, 52, 1.00)',
            'rgba(96, 135, 76, 1.00)',
            'rgba(77, 122, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cephalanthus [rubiaceae]/cephalanthus occidentalis/cephalanthus occidentalis (5).jpg',
          width: 1024,
          id: 'ec35e4b28738a4e50e9c624e86a89428',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 147, 102, 1.00)',
            'rgba(94, 121, 66, 1.00)',
            'rgba(92, 116, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cephalanthus [rubiaceae]/cephalanthus occidentalis/cephalanthus occidentalis (2).jpg',
          width: 1024,
          id: '859f91a44da7003823ffa41a7eb88bcc',
          height: 683,
          thumbnail: true,
        },
        location: [47.27087, -1.584737],
        genre: 'Cephalanthus',
        famille: 'Rubiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584737, 47.27087] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '45c5a19b2e8a4ec1255a56121d1a03f0e58afc22',
      fields: {
        espece: 'jasminoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(167, 160, 158, 1.00)',
            'rgba(131, 150, 116, 1.00)',
            'rgba(98, 132, 64, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/gardenia [rubiaceae]/gardenia jasminoides/gardenia jasminoides (2).jpg',
          width: 576,
          id: '1a8460ec199621cfe79eff36134a94fa',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(56, 69, 34, 1.00)',
            'rgba(104, 112, 82, 1.00)',
            'rgba(68, 63, 51, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/gardenia [rubiaceae]/gardenia jasminoides/gardenia jasminoides (1).jpg',
          width: 576,
          id: 'b6668a063b0c9794a65b102230a77f35',
          height: 768,
          thumbnail: true,
        },
        location: [47.2709, -1.58453],
        genre: 'Gardenia',
        famille: 'Rubiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58453, 47.2709] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6299e57267d6f4ef8ed7c3d1984ac19a2a0793d8',
      fields: {
        espece: 'ternata Sundance (Lich)',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 109, 37, 1.00)',
            'rgba(97, 118, 52, 1.00)',
            'rgba(45, 72, 17, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/choisya [rutaceae]/choisya ternata sundance ('lich')/choisya ternata sundance ('lich') (1).jpg",
          width: 576,
          id: '9d68101ad03b7f3752a751155ee76c46',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Choisya',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd9c995430910856bcb8f42b87f3dd68d888ac175',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Gd Blottereau',
        espece: 'sorbifolium',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Xanthoceras',
        date_plantation: '2016',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ed501b314ad9285d54ec512ed6667d45fbb38250',
      fields: {
        origine: 'P\u00e9pini\u00e8res Arven',
        espece: 'bipinnata',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Koelreuteria',
        date_plantation: '2018',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c0bf4f0dff38826b165dba4c1736c05c8ebde632',
      fields: {
        espece: 'platanoides',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Acer',
        date_plantation: '1973',
        cultivar: 'Schwelderi',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0879549647f54fc86e9971a3c35b51e3c13dad70',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 133, 127, 1.00)',
            'rgba(143, 131, 112, 1.00)',
            'rgba(138, 152, 156, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer 'silver cardinal'/acer 'silver cardinal' (10).jpg",
          width: 1024,
          id: '760bfe0f46da201ea033654b76b51b97',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 128, 144, 1.00)',
            'rgba(110, 95, 63, 1.00)',
            'rgba(94, 80, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer 'silver cardinal'/acer 'silver cardinal' (11).jpg",
          width: 1024,
          id: '2ee8ea37954a6e7919bd23d941d8bd5c',
          height: 673,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 109, 134, 1.00)',
            'rgba(102, 111, 125, 1.00)',
            'rgba(97, 105, 120, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer 'silver cardinal'/acer 'silver cardinal' (1).jpg",
          width: 1024,
          id: '7ff6415bfcb27fbfbeeee8ca61dafde3',
          height: 624,
          thumbnail: true,
        },
        location: [47.27098, -1.584397],
        genre: 'Acer',
        cultivar: 'Silver Cardinal',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584397, 47.27098] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3903c78c63b1394358b18dd8d0a36aae9e434aef',
      fields: {
        espece: 'henryi',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(60, 101, 171, 1.00)',
            'rgba(83, 96, 127, 1.00)',
            'rgba(85, 88, 101, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer henryi/acer henryi (15).jpg',
          width: 512,
          id: '247be04c359fb814d23e256ea072fb2f',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 145, 204, 1.00)',
            'rgba(117, 95, 70, 1.00)',
            'rgba(74, 54, 13, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer henryi/acer henryi (14).jpg',
          width: 1024,
          id: '11e965278e6d44b044a3eb8b6cdaa1c0',
          height: 683,
          thumbnail: true,
        },
        location: [47.269844, -1.584064],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584064, 47.269844] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '10616bd94fb815de7e5f2218c2323ac26add4da4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'palmatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 141, 46, 1.00)',
            'rgba(122, 135, 30, 1.00)',
            'rgba(83, 90, 28, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer palmatum/acer palmatum (2).jpg',
          width: 576,
          id: 'a4662f65c81614b09491dcd238e538f2',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 120, 84, 1.00)',
            'rgba(154, 113, 68, 1.00)',
            'rgba(113, 76, 39, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer palmatum/acer palmatum (3).jpg',
          width: 576,
          id: '2a80a3b2c6b883a9c05ef36b402d7367',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 161, 75, 1.00)',
            'rgba(132, 126, 63, 1.00)',
            'rgba(103, 117, 42, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer palmatum/acer palmatum (1).jpg',
          width: 576,
          id: 'e87291185d11f897dbde6833bd6b1ef8',
          height: 768,
          thumbnail: true,
        },
        location: [47.27083, -1.584117],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584117, 47.27083] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ed9a9e035933978870fe85abd3b88bcf9726fe9f',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 126, 107, 1.00)',
            'rgba(154, 110, 87, 1.00)',
            'rgba(121, 87, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer rubrum 'autumn flame'/acer rubrum 'autumn flame' (5).jpg",
          width: 576,
          id: '5d872a85d6ee47e274017287215f2c93',
          height: 768,
          thumbnail: true,
        },
        espece: 'rubrum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 133, 185, 1.00)',
            'rgba(83, 110, 165, 1.00)',
            'rgba(124, 140, 161, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer rubrum 'autumn flame'/acer rubrum 'autumn flame'  (3).jpg",
          width: 544,
          id: '8a65fc3c2d17f4147c8c976775e2a0be',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 138, 188, 1.00)',
            'rgba(120, 131, 156, 1.00)',
            'rgba(79, 79, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer rubrum 'autumn flame'/acer rubrum 'autumn flame'  (2).jpg",
          width: 512,
          id: '121cd378644805f3aa7444fa0d70e830',
          height: 768,
          thumbnail: true,
        },
        location: [47.271853, -1.582075],
        genre: 'Acer',
        cultivar: 'Autumn Flame',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582075, 47.271853] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '463fa7f04967bc4388c213a0cadd5fc077a5b0e0',
      fields: {
        espece: 'hippocastanum',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Aesculus',
        date_plantation: '1973',
        cultivar: 'Baumanii',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4b43f281d2768a081bdee17e9f8e6f13568d53ea',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'californica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 156, 135, 1.00)',
            'rgba(128, 112, 57, 1.00)',
            'rgba(125, 109, 35, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus californica/aesculus californica (1).jpg',
          width: 576,
          id: 'cc9ca72608944219b70005e68ed48a62',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 142, 115, 1.00)',
            'rgba(139, 121, 63, 1.00)',
            'rgba(114, 102, 19, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus californica/aesculus californica (2).jpg',
          width: 576,
          id: '1c67f303024ccc20d46451cb9a8fd5e2',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(224, 239, 250, 1.00)',
            'rgba(128, 143, 105, 1.00)',
            'rgba(73, 86, 32, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus californica/aesculus californica  (2).jpg',
          width: 1024,
          id: '75a3a3f4c92227793c1c76fb009fa5d4',
          height: 768,
          thumbnail: true,
        },
        location: [47.270225, -1.582233],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582233, 47.270225] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '72217bde3e53d7e42e681e96b73ae14d87df57df',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 109, 86, 1.00)',
            'rgba(83, 91, 52, 1.00)',
            'rgba(128, 126, 102, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum 'pragense'/viburnum 'pragens' (2).jpg",
          width: 1024,
          id: '56fab09a853ca39bab029ed18e1a4248',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(62, 83, 35, 1.00)',
            'rgba(88, 120, 44, 1.00)',
            'rgba(79, 110, 46, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum 'pragense'/viburnum 'pragens' (3).jpg",
          width: 576,
          id: 'e00c95c3e3a1da9bdb0b8ae4f06411e3',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 85, 64, 1.00)',
            'rgba(116, 119, 99, 1.00)',
            'rgba(103, 104, 87, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum 'pragense'/viburnum 'pragens' (1).jpg",
          width: 576,
          id: 'bc88e3f573e63853e06c8950a13ad860',
          height: 768,
          thumbnail: true,
        },
        location: [47.271495, -1.580767],
        genre: 'Viburnum',
        cultivar: 'Pragense',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580767, 47.271495] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '51adb9bf0f1848411193b9c37e87172b7cd9791f',
      fields: {
        espece: 'dentatum',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 123, 90, 1.00)',
            'rgba(139, 117, 106, 1.00)',
            'rgba(94, 119, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum dentatum/viburnum dentatum (10).jpg',
          width: 576,
          id: '30bd47600a4fb531993f8f115f67ea9b',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6529430c860b422f56310ee5867704ce88473046',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'nudum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 136, 119, 1.00)',
            'rgba(151, 129, 119, 1.00)',
            'rgba(152, 123, 122, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum nudum/viburnum nudum (4).jpg',
          width: 576,
          id: '051f6e36f15c89fae0cb07edf62b548b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(65, 81, 39, 1.00)',
            'rgba(126, 137, 100, 1.00)',
            'rgba(91, 101, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum nudum/viburnum nudum (5).jpg',
          width: 576,
          id: '79d601babfcccbfaa8300dc1f61ec409',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 118, 72, 1.00)',
            'rgba(123, 144, 91, 1.00)',
            'rgba(128, 137, 84, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum nudum/viburnum nudum (1).jpg',
          width: 1024,
          id: 'c6d43eb28839111904095debd10ac67a',
          height: 768,
          thumbnail: true,
        },
        location: [47.270903, -1.581542],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581542, 47.270903] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '407d50ee422e019a323c46663212aa0329809d74',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'opulus var. americanum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 133, 56, 1.00)',
            'rgba(115, 136, 32, 1.00)',
            'rgba(125, 144, 48, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum opulus var. americanum/viburnum opulus var. americanum (2).jpg',
          width: 576,
          id: '88a90d836edaf6429406b38f6a3940b9',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 179, 153, 1.00)',
            'rgba(89, 105, 48, 1.00)',
            'rgba(107, 112, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum opulus var. americanum/viburnum opulus var. americanum (3).jpg',
          width: 1024,
          id: 'b1c43225405ec445ab0336632a5359d2',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 143, 109, 1.00)',
            'rgba(115, 127, 81, 1.00)',
            'rgba(64, 83, 34, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum opulus var. americanum/viburnum opulus var. americanum (1).jpg',
          width: 576,
          id: '6459157260a37a7844c7690196369a62',
          height: 768,
          thumbnail: true,
        },
        location: [47.271137, -1.587192],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587192, 47.271137] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5146c913f8ffeefe473f6330c87ddbd2e02f7e98',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'setigerum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 135, 77, 1.00)',
            'rgba(122, 126, 80, 1.00)',
            'rgba(120, 122, 79, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum setigerum/viburnum setigerum (10).jpg',
          width: 552,
          id: 'ef8485ae9b4e72ebd58e551e99bf4a2b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 117, 102, 1.00)',
            'rgba(123, 124, 104, 1.00)',
            'rgba(85, 83, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum setigerum/viburnum setigerum (17).jpg',
          width: 576,
          id: '6810e477cbd204034aaad9f7b673d569',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 113, 82, 1.00)',
            'rgba(125, 125, 90, 1.00)',
            'rgba(96, 99, 49, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum setigerum/viburnum setigerum (1).jpg',
          width: 576,
          id: 'e7405bee570095d3d0c23c47c99b74f6',
          height: 768,
          thumbnail: true,
        },
        location: [47.270595, -1.584145],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584145, 47.270595] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1a6ef7dc94a992e6911035b50b0604d36f76b9a9',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 121, 76, 1.00)',
            'rgba(78, 101, 75, 1.00)',
            'rgba(76, 84, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum tinus 'gwenllian'/viburnum tinus 'gwenllian' (7).jpg",
          width: 576,
          id: '4ecf2c2025e73a7333029f1e0c89bd6b',
          height: 768,
          thumbnail: true,
        },
        espece: 'tinus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 128, 94, 1.00)',
            'rgba(121, 149, 105, 1.00)',
            'rgba(108, 123, 90, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum tinus 'gwenllian'/viburnum tinus 'gwenllian (4).jpg",
          width: 576,
          id: '684f53fc83036c6ea24f46f30b48f44c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(173, 172, 174, 1.00)',
            'rgba(95, 99, 80, 1.00)',
            'rgba(96, 96, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum tinus 'gwenllian'/viburnum tinus 'gwenllian (2).jpg",
          width: 1024,
          id: '00b8d2574b306d8df405f101ecb8580e',
          height: 768,
          thumbnail: true,
        },
        location: [47.26932, -1.584447],
        genre: 'Viburnum',
        cultivar: 'Gwenllian',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584447, 47.26932] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9dd99d4c99134ae8c376a3cf0b8e78caeb009d29',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 143, 130, 1.00)',
            'rgba(89, 131, 100, 1.00)',
            'rgba(75, 99, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum tinus 'macrophyllum'/viburnum tinus 'macrophyllum'  (3).jpg",
          width: 572,
          id: '7a4200e65825c797c6a7714cb1110759',
          height: 768,
          thumbnail: true,
        },
        espece: 'tinus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 79, 64, 1.00)',
            'rgba(100, 112, 87, 1.00)',
            'rgba(70, 81, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum tinus 'macrophyllum'/viburnum tinus 'macrophyllum'  (2).jpg",
          width: 512,
          id: '9d0fb3545a7ee41a2fb953c55c2deed9',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 148, 141, 1.00)',
            'rgba(91, 98, 81, 1.00)',
            'rgba(106, 89, 84, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum tinus 'macrophyllum'/viburnum tinus 'macrophyllum'  (1).jpg",
          width: 1024,
          id: '919c5e1d067b56012c03b193bb3cebfe',
          height: 683,
          thumbnail: true,
        },
        location: [47.270725, -1.585797],
        genre: 'Viburnum',
        cultivar: 'Macrophyllum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585797, 47.270725] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '857aa4503d5fa93f2d91e9a9bfc657b47ecf8e0f',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 151, 76, 1.00)',
            'rgba(119, 150, 72, 1.00)',
            'rgba(92, 115, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x carlcephalum 'cayuga'/viburnum x carlcephalum 'cayuga' (3).jpg",
          width: 1024,
          id: '57d18064562bb097ba24d6749ba040ca',
          height: 768,
          thumbnail: true,
        },
        espece: 'x carlcephalum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 97, 53, 1.00)',
            'rgba(172, 144, 128, 1.00)',
            'rgba(129, 96, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x carlcephalum 'cayuga'/viburnum x carlcephalum 'cayuga' (2).jpg",
          width: 576,
          id: '9d996623520f3db32edc7e166a26d7f9',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 85, 54, 1.00)',
            'rgba(135, 137, 126, 1.00)',
            'rgba(50, 62, 29, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x carlcephalum 'cayuga'/viburnum x carlcephalum 'cayuga' (1).jpg",
          width: 576,
          id: '753b103ec9f3287713374df24916af0c',
          height: 768,
          thumbnail: true,
        },
        location: [47.270872, -1.586208],
        genre: 'Viburnum',
        cultivar: 'Cayuga',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586208, 47.270872] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '71aa863583338857b084a3340f6fc427aa33516c',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 134, 81, 1.00)',
            'rgba(117, 132, 81, 1.00)',
            'rgba(47, 70, 28, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x hillieri 'winton'/viburnum x hillieri 'winton'  (4).jpg",
          width: 576,
          id: '30c3a38edd03cd2baabe27612d45be82',
          height: 768,
          thumbnail: true,
        },
        espece: 'x hillieri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 91, 58, 1.00)',
            'rgba(121, 121, 90, 1.00)',
            'rgba(33, 38, 27, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x hillieri 'winton'/viburnum x hillieri 'winton'  (3).jpg",
          width: 576,
          id: 'fb67ef53df5bba3ac846ef1f5d973885',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(163, 199, 239, 1.00)',
            'rgba(114, 124, 87, 1.00)',
            'rgba(85, 91, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x hillieri 'winton'/viburnum x hillieri 'winton'  (1).jpg",
          width: 576,
          id: '99551d4356e975a1586c7c1fdc1754af',
          height: 768,
          thumbnail: true,
        },
        location: [47.270658, -1.582513],
        genre: 'Viburnum',
        cultivar: 'Winton',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582513, 47.270658] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3faf005ebf9088c99b3704d8d9a2e88d2f64e79b',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 123, 107, 1.00)',
            'rgba(118, 121, 116, 1.00)',
            'rgba(86, 111, 94, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x hillieri 'winton'/viburnum x hillieri 'winton' (5).jpg",
          width: 576,
          id: 'b7698c15cc88e7813f84c0a2c88071d0',
          height: 768,
          thumbnail: true,
        },
        espece: 'x hillieri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 152, 84, 1.00)',
            'rgba(119, 148, 61, 1.00)',
            'rgba(96, 113, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x hillieri 'winton'/viburnum x hillieri 'winton' (2).jpg",
          width: 576,
          id: '3b3c8185e4463fb12e12894fc2b0299c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 122, 103, 1.00)',
            'rgba(94, 102, 64, 1.00)',
            'rgba(98, 109, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x hillieri 'winton'/viburnum x hillieri 'winton'  (5).jpg",
          width: 1024,
          id: '8f4dccc7a623cf02b86ac7e55867be95',
          height: 768,
          thumbnail: true,
        },
        location: [47.270983, -1.58277],
        genre: 'Viburnum',
        cultivar: 'Winton',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58277, 47.270983] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9bed12426a3d8deaf7acc378dcd43367ab588879',
      fields: {
        origine: 'Botanique garden univer. Agricultre - Batumi',
        espece: 'woronowii Los.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Galanthus',
        date_plantation: '2010',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'afb9934939818394b9b770ccc7e3b4cf47064424',
      fields: {
        origine: 'Botanischer Garten St.Gallen,St.Gallen,Autriche',
        espece: 'rosea Sweet',
        localisation: 'C2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2194084, -1.5437532],
        genre: 'Acis',
        date_plantation: '2013',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5437532, 47.2194084] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '771b65a679f2d8fcb758bc98919d3ec0f835138f',
      fields: {
        origine: 'J.B. Prague (Rep. Tch\u00e8que)',
        espece: 'papyraceus subsp. polyanthus (Loisel.) Asch. & Graebn.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Narcissus',
        date_plantation: '2011',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fd37b465efc4e98e6e0eb2d274757b20ca202518',
      fields: {
        origine: 'JB. Prague (Rep. Tch\u00e8que)',
        espece: 'calcicola L.',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Narcissus',
        date_plantation: '2010',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9a42af00156d593496beb430f909d54639b1b7ca',
      fields: {
        origine: 'JB.Bratislava (Slovakie)',
        espece: 'flavum L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Allium',
        date_plantation: '2009',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '61f0eb31ed62e8709abfdba1209f18a0dd227e1d',
      fields: {
        origine: 'JBU.Friedrich-Jena (Allemagne)',
        espece: 'cernuum Roth.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Allium',
        date_plantation: '2003',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5b7fbacd0202d98b70bc3268d38094700013145a',
      fields: {
        origine: 'JBU.Vitebsk (Bielorussie)',
        espece: 'senescens L.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Allium',
        date_plantation: '2006',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5fafccf12aee1feb37915806571bbfbf7af84314',
      fields: {
        espece: 'powellii Hort. x',
        localisation: 'B7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198817, -1.5442188],
        genre: 'Crinum',
        date_plantation: '1973',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442188, 47.2198817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e60eb7509806d19be3bf9b23108bd0d3e89de005',
      fields: {
        espece: 'nivalis L.',
        localisation: 'A9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2212566, -1.5434775],
        genre: 'Galanthus',
        date_plantation: '1973',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5434775, 47.2212566] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b76be54d3522ff95b189eafb335932d877ce005b',
      fields: {
        origine:
          'Honorable Municipalidad de Cochabamba - origine nature\u00a0:Tipa Tipa Mizque Cochabamba, alt. 2390M',
        espece: 'molleoides',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Lithraea',
        date_plantation: '2003',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e720fe1f3a2f51457de59e450b0d598b1bd3cb5c',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(173, 170, 138, 1.00)',
            'rgba(139, 125, 74, 1.00)',
            'rgba(118, 109, 74, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cotinus [anacardiaceae]/cotinus coggygria 'red spirit'/cotinus coggygria 'red spirit' (3).jpg",
          width: 1024,
          id: '2b9ff295d0acce790bae36aeb2c21914',
          height: 768,
          thumbnail: true,
        },
        espece: 'coggygria',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(198, 168, 146, 1.00)',
            'rgba(166, 115, 91, 1.00)',
            'rgba(105, 83, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cotinus [anacardiaceae]/cotinus coggygria 'red spirit'/cotinus coggygria 'red spirit' (2).jpg",
          width: 576,
          id: '007e488c9bc2a0a2ccbf0625a9cfbb75',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(177, 166, 137, 1.00)',
            'rgba(126, 102, 64, 1.00)',
            'rgba(114, 96, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cotinus [anacardiaceae]/cotinus coggygria 'red spirit'/cotinus coggygria 'red spirit' (1).jpg",
          width: 576,
          id: '0e50d4e507bfef07d78edfcccb55709a',
          height: 768,
          thumbnail: true,
        },
        location: [47.271622, -1.586975],
        genre: 'Cotinus',
        cultivar: 'Red Spirit',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586975, 47.271622] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f275521610cfaa7d28cc66f57c1ad728b8d2610e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'obovatus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 100, 52, 1.00)',
            'rgba(95, 129, 69, 1.00)',
            'rgba(69, 117, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cotinus [anacardiaceae]/cotinus obovatus/cotinus obovatus (10).jpg',
          width: 1024,
          id: '069daf319ca5522a28745d9b817903a7',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 156, 54, 1.00)',
            'rgba(115, 135, 47, 1.00)',
            'rgba(110, 127, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cotinus [anacardiaceae]/cotinus obovatus/cotinus obovatus (11).jpg',
          width: 1024,
          id: 'cef159c470cebbbc23c054e625345beb',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 149, 104, 1.00)',
            'rgba(97, 120, 60, 1.00)',
            'rgba(83, 105, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cotinus [anacardiaceae]/cotinus obovatus/cotinus obovatus (1).jpg',
          width: 1024,
          id: '50097f07c35728890db193894837efed',
          height: 683,
          thumbnail: true,
        },
        location: [47.271292, -1.582438],
        genre: 'Cotinus',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582438, 47.271292] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '90eeaeb302d04d12388073ae9ddbda0ca661a107',
      fields: {
        espece: 'vera',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 144, 105, 1.00)',
            'rgba(118, 146, 89, 1.00)',
            'rgba(89, 107, 67, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/pistacia [anacardiaceae]/pistacia vera/pistacia vera.jpg",
          width: 1024,
          id: 'a026ddb2c279d8d11ee6b016192e7197',
          height: 768,
          thumbnail: true,
        },
        location: [47.226417, -1.512437],
        genre: 'Pistacia',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512437, 47.226417] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c23124dbb3467e14e08fe24432548e93f58ff5cc',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'polyganum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 101, 45, 1.00)',
            'rgba(93, 110, 53, 1.00)',
            'rgba(131, 148, 79, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/schinus [anacardiaceae]/schinus polyganum/schinus polyganum(2).jpg',
          width: 576,
          id: 'd3f541881beee0644023c0fbb545491f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(202, 211, 223, 1.00)',
            'rgba(105, 107, 89, 1.00)',
            'rgba(99, 93, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/schinus [anacardiaceae]/schinus polyganum/schinus polyganum.jpg',
          width: 576,
          id: '5a2bbbdc2c6e542f9baf44d64197101a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(57, 73, 33, 1.00)',
            'rgba(99, 123, 67, 1.00)',
            'rgba(163, 176, 95, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/schinus [anacardiaceae]/schinus polyganum/schinus polyganum(1).jpg',
          width: 576,
          id: '7cd5cd223853b17b6b1f330c04277597',
          height: 768,
          thumbnail: true,
        },
        location: [47.27108, -1.58583],
        genre: 'Schinus',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58583, 47.27108] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4ff94757fa0320c03e2e6213ba24cf5839956c33',
      fields: {
        origine: 'J.Alp.Arras (France)',
        espece: 'tricuspidatum L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Eryngium',
        date_plantation: '2001',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '547bfaa332338bb8207e1a731ff249f370f7c392',
      fields: {
        origine: 'JB.Kyoto (Japon)',
        espece: 'keiskei  Koidz.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Angelica',
        date_plantation: '2008',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8fd4c4809f259aaecc92df3a7df3030595ddc28f',
      fields: {
        origine: 'Universit\u00e9 de Postdam (Allemagne)',
        espece: 'osseum Crantz',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Seseli',
        date_plantation: '2011',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '08a6199faaa8fadd8622938789a201e266cf5fbf',
      fields: {
        espece: 'aquifolium',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Ilex',
        date_plantation: '1973',
        cultivar: 'Watereriana',
        famille: 'Aquifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3f45e36f639551d880cbe4ef74084992f73f64f7',
      fields: {
        origine: 'B.G. der Universitat,Erlangen-Nurnberg,Allemagne',
        espece: 'candidissimum W.W.Sm.',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Arisaema',
        date_plantation: '2012',
        famille: 'Araceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '827fc5e21b9a57f453e63d7c8b541bd0b3288d4b',
      fields: {
        origine: 'Crug Farm (UK)',
        espece: 'leschenaultii',
        localisation: 'B7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198817, -1.5442188],
        genre: 'Aralia',
        date_plantation: '2015',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442188, 47.2198817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2ab2050968fcb57d7a389c698259fdee7a0b4a7d',
      fields: {
        origine: 'P\u00e9pin\u00e8res Arven - Poullan-Sur-Mer (29)',
        espece: 'laetus',
        localisation: 'B7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198817, -1.5442188],
        genre: 'Neopanax',
        date_plantation: '2015',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442188, 47.2198817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '763f3a4cbe82ea083b943860910cf9f20d5c4fe1',
      fields: {
        origine: 'P\u00e9pin\u00e8res Arven - Poullan-Sur-Mer (29)',
        espece: 'rhododendrifolia',
        localisation: 'B7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198817, -1.5442188],
        genre: 'Schefflera',
        date_plantation: '2015',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442188, 47.2198817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '505665883e8f1d3f907c04c999867a75ac1cf80c',
      fields: {
        origine: 'JBN.La Havane (Cuba)',
        espece: 'minor Pers.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Sabal',
        date_plantation: '1985',
        famille: 'Arecaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4f86fc9199ef14d7877efd0a6462d601f40e7b91',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'capitata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(175, 181, 178, 1.00)',
            'rgba(84, 92, 72, 1.00)',
            'rgba(96, 95, 64, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/butia [arecaceae]/butia capitata/butia capitata (2).jpg",
          width: 1024,
          id: 'f57ebd26af4c21b7c12b5035c315e2b4',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 121, 105, 1.00)',
            'rgba(150, 106, 48, 1.00)',
            'rgba(121, 98, 60, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/butia [arecaceae]/butia capitata/butia capitata (3).jpg",
          width: 576,
          id: '4aa8972b8cb2a251b316c50bb7b3fe49',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 145, 137, 1.00)',
            'rgba(116, 107, 78, 1.00)',
            'rgba(137, 118, 92, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/butia [arecaceae]/butia capitata/butia capitata (1).jpg",
          width: 576,
          id: '0d3886b725b9eeddeda792e3b4f0b5af',
          height: 768,
          thumbnail: true,
        },
        location: [47.227228, -1.512337],
        genre: 'Butia',
        famille: 'Arecaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512337, 47.227228] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bf59f6034221caac3de0cc42578bc022d4da0b30',
      fields: {
        espece: 'filifera',
        localisation: 'A2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2208871, -1.5444631],
        genre: 'Washingtonia',
        date_plantation: '1973',
        famille: 'Arecaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444631, 47.2208871] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c70395435c2964db624b09b5836c3fbf70fcb99e',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Grand Blottereau',
        espece: 'x virgata',
        localisation: 'A5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2207668, -1.5440149],
        genre: 'Corokia',
        date_plantation: '2015',
        cultivar: 'Froted Chocolate',
        famille: 'Argophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440149, 47.2207668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2c0ab75fdf1cf4ea1b798b631060a7a1f85cc3ca',
      fields: {
        origine: 'Emmanuel LEPAGE',
        espece: 'multiflorum All.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Polygonatum',
        date_plantation: '2015',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dbca1e37e9584b854a75a9b3f93d9f341b176267',
      fields: {
        origine: 'Goteborg Botanical Garten (Su\u00e8de)',
        espece: 'sivrihisardaghlarensis Yild.& B.Selvi',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Muscari',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6497c6d8fc1e783bf9d6786c572d1037cdcbe18c',
      fields: {
        origine: 'Goteborg Botanical Garten,Goteborg,Su\u00e8de',
        espece: 'litardierei Breistr.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Scilla',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '28924274783f9221dbe7cba3a18a71272ce62fb1',
      fields: {
        origine: 'J.B.Friedrich Jena,Jena,All.',
        espece: 'muscari L.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Hyacinthus',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a9b372256dc8fcb2c9c4ef3688b52d0ac193ac30',
      fields: {
        origine: 'JB.Dunedin (N-Z\u00e9lande)',
        espece: 'banksii Hook. f.',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Cordyline',
        date_plantation: '2006',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '11196de9460eb95e7874941a672411982c7e377e',
      fields: {
        origine: 'JB.Hangzhou (Chine)',
        espece: 'platyphylla F.T.Wang & T.Tang',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Liriope',
        date_plantation: '1993',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4b51e72403cb5ec617182bf1b89e7120c8e9ead0',
      fields: {
        origine: 'JB.Johannesburg (Afrique du Sud)',
        espece: 'pole-evansii N.E.Br.',
        localisation: 'G2A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2197208, -1.5414609],
        genre: 'Eucomis',
        date_plantation: '2006',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5414609, 47.2197208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bd70a35e2ae0956f4785fcdc5dec98ffb2d3dff9',
      fields: {
        origine: 'JB.Tbilisi (G\u00e9orgie)',
        espece: 'szovitsianum Baker',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Muscari',
        date_plantation: '2006',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9bf87fa6c4d29a40bfc7e48201ac7c658e5f6128',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes 71290 La Gen\u00eate',
        espece: 'nepalensis N.Tanaka',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Rohdea',
        date_plantation: '2015',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4148cb46b6a62597fec06e1cf446f3550885348c',
      fields: {
        origine: 'Botanische Garten (Meckenheimer), Bonn, Allemagne',
        espece: 'aplolepa Moretti',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Centaurea',
        date_plantation: '2012',
        cultivar: 'carueliana Dost\u00e0l',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bce89e8f29e352629b52060511bccd3ab849cea0',
      fields: {
        origine: 'Hort.Botanicus Reykjavikensis,Islande',
        espece: 'nepalensis Kitam',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Leibnitzia',
        date_plantation: '2014',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '41a9299ad03f1e17f946ee755119749ef955aa0a',
      fields: {
        origine: 'J.Alp.Meyrin (Suisse)',
        espece: 'ritro L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Echinops',
        date_plantation: '1999',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b31dc4fcbb497bd333b400d8efa6e77f9cfb9b3c',
      fields: {
        origine: 'J.B. Marie Curie, Lublin (Pologne)',
        espece: 'souliei Franch.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Aster',
        date_plantation: '2011',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c3e42abd0e676d276eb4efbd979f3d9e9ab43711',
      fields: {
        origine: 'Jardin botanique de Lausane',
        espece: 'longifolia Boiss.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Swertia',
        date_plantation: '2010',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7b02c6ea501312d91c84126eee07a491c1f246d6',
      fields: {
        origine: 'Jardin botanique de Michele Tenore (Italie)',
        espece: 'arborescens L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Artemisia',
        date_plantation: '2001',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c8d78641cfb5420d48caf61394e0702c6a7a0202',
      fields: {
        origine: 'JB de Nantes (Remi Legros)',
        espece: 'hybride',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Artemisia',
        date_plantation: '2014',
        cultivar: 'Powis Castle',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7fbe077fa3486e7e67c862b1f71f3edcb2bd7021',
      fields: {
        origine: 'JB.Bern (Suisse)',
        espece: 'villosum Jacq.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Hieracium',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5da6b8174ac59e4baa26c1ca5a90f4e24dbe584a',
      fields: {
        origine: 'JB.Krefeld (Allemagne)',
        espece: 'scariosa Wild.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Liatris',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dcf48f7b611ebc13fc151bb998df16de3732972e',
      fields: {
        origine: 'JB.Ljubljani (Slov\u00e9nie)',
        espece: 'ensifolia  L.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Inula',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4e6727cf6d6631f379be5bd80fbbf38f1f309b4d',
      fields: {
        origine: 'JB.Olomouc (R\u00e9publique Tch\u00e8que)',
        espece: 'riddellii Frank.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Solidago',
        date_plantation: '2000',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2898ef1e7bd98eedd89108e82ca9b1e88f522323',
      fields: {
        origine: 'JB.Stadt Krefeld (Allemagne)',
        espece: 'sphaerocephalus L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Echinops',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2580589ea1277affe4206187e5de830e998240e0',
      fields: {
        origine: 'JB.Washington (USA)',
        espece: 'juncea Ait.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Solidago',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '355884ef49b6a7693985f3eb6079dbeaf2097ca6',
      fields: {
        origine: 'JBU.Besan\u00e7on (France)',
        espece: 'salicifolium L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Buphtalmum',
        date_plantation: '2004',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd91ca24ad1e3968e38c3a6b48337555743d07954',
      fields: {
        origine: 'Zoo and BG.of the Plzen(R\u00e9p.Tch\u00e8que)',
        espece: 'cirsifolia Roessller',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Berkheya',
        date_plantation: '2014',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b2de0b403e98e408ae07e70acf66bac9c0cbfd35',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 126, 84, 1.00)',
            'rgba(120, 140, 85, 1.00)',
            'rgba(106, 116, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/brachyglottis [asteraceae]/brachyglottis 'sunshine'/brachyglottis 'sunshine' (4).jpg",
          width: 1024,
          id: 'fea52c4fe65528f0a49698ec28288e16',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 104, 42, 1.00)',
            'rgba(123, 135, 43, 1.00)',
            'rgba(70, 90, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/brachyglottis [asteraceae]/brachyglottis 'sunshine'/brachyglottis 'sunshine' (5).jpg",
          width: 576,
          id: '4bbb1d849213a579895973aea2e77ccc',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 109, 55, 1.00)',
            'rgba(158, 149, 19, 1.00)',
            'rgba(125, 118, 13, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/brachyglottis [asteraceae]/brachyglottis 'sunshine'/brachyglottis 'sunshine' (3).jpg",
          width: 576,
          id: 'f5412a254be4a8491034387be65f2c9d',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Brachyglottis',
        cultivar: 'Sunshine',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b9e0eb42c1bf3f76619861a39c4c61dd88b8603c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x haastii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 130, 86, 1.00)',
            'rgba(129, 132, 107, 1.00)',
            'rgba(97, 101, 70, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/olearia [asteraceae]/olearia x haastii/olearia x haastii  (3).jpg',
          width: 576,
          id: '687a7a54f4c449b12457f598f21623a6',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 125, 86, 1.00)',
            'rgba(126, 130, 99, 1.00)',
            'rgba(94, 85, 70, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/olearia [asteraceae]/olearia x haastii/olearia x haastii  .jpg',
          width: 1024,
          id: '240c39baef10d4c834f0330e4738eb1a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 124, 95, 1.00)',
            'rgba(97, 127, 88, 1.00)',
            'rgba(85, 107, 64, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/olearia [asteraceae]/olearia x haastii/olearia x haastii  (1).jpg',
          width: 576,
          id: 'a856f57b2280db83d0105c5f55c30b25',
          height: 768,
          thumbnail: true,
        },
        location: [47.270195, -1.586112],
        genre: 'Olearia',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586112, 47.270195] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '32b3b8d28e7b250d7d51536e36dd211dc459a213',
      fields: {
        origine: 'B.G. & Arboretum Brno (R\u00e8p.Tch\u00e8qhe)',
        espece: 'hexandrum Royle',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Podophyllum',
        date_plantation: '2012',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '08f60b8e75309e7f291b4464aa25311553bd658e',
      fields: {
        espece: 'domestica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 115, 70, 1.00)',
            'rgba(160, 122, 68, 1.00)',
            'rgba(121, 99, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/nandina [berberidaceae]/nandina domestica 'fire power'/nandina domestica 'fire power' (4).jpg",
          width: 1024,
          id: '8278bfcfad9267019685e766c785ec7e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(176, 104, 71, 1.00)',
            'rgba(179, 124, 65, 1.00)',
            'rgba(149, 105, 42, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/nandina [berberidaceae]/nandina domestica 'fire power'/nandina domestica 'fire power' (3).jpg",
          width: 576,
          id: 'be406ba59262446065175455c2b009f5',
          height: 768,
          thumbnail: true,
        },
        location: [47.2711, -1.584187],
        genre: 'Nandina',
        cultivar: 'Fire Power',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584187, 47.2711] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '16588b64bb21945383e8f535a5e53a4bbfb47fd0',
      fields: {
        origine: 'P\u00e9pini\u00e8re Ville de Nantes',
        espece: 'pendula',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Betula',
        date_plantation: '2017',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f8107cca0d40a9ffc39858c55f81cd8a907d6e84',
      fields: {
        espece: 'glutinosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 128, 67, 1.00)',
            'rgba(99, 124, 58, 1.00)',
            'rgba(86, 116, 52, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/alnus [betulaceae]/alnus glutinosa 'imperialis'/alnus glutinosa 'imperialis' (2).jpg",
          width: 1024,
          id: 'b9308c58d07c8638858d1d35b6b4e3f5',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 127, 45, 1.00)',
            'rgba(107, 142, 61, 1.00)',
            'rgba(105, 139, 67, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/alnus [betulaceae]/alnus glutinosa 'imperialis'/alnus glutinosa 'imperialis' (1).jpg",
          width: 576,
          id: '87059cdbc867e38e433594e97a6363ea',
          height: 768,
          thumbnail: true,
        },
        location: [47.271408, -1.582828],
        genre: 'Alnus',
        cultivar: 'Imperialis',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582828, 47.271408] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '15d88683e4bedcdff5e3fa2bcfde7f8dfeabf32c',
      fields: {
        espece: 'papyrifera',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 117, 113, 1.00)',
            'rgba(121, 114, 99, 1.00)',
            'rgba(97, 93, 77, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/betula [betulaceae]/betula papyrifera 'commutata'/betula papyrifera 'commutata'.jpg",
          width: 576,
          id: '420ad22361add70b27828fad1036450f',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Betula',
        cultivar: 'Commutata',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '932df9822f3c458e5ff4748e55cf9904f46d95a7',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'papyrifera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 134, 92, 1.00)',
            'rgba(130, 155, 96, 1.00)',
            'rgba(134, 137, 85, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/betula [betulaceae]/betula papyrifera/betula papyrifera (2).jpg',
          width: 576,
          id: '036a951a899c1e3f17f476ba77520935',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 133, 79, 1.00)',
            'rgba(151, 165, 137, 1.00)',
            'rgba(105, 117, 84, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/betula [betulaceae]/betula papyrifera/betula papyrifera (3).jpg',
          width: 918,
          id: '28c33a0d0e961d757f1ddee8ce09ddfd',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 142, 81, 1.00)',
            'rgba(137, 161, 111, 1.00)',
            'rgba(100, 116, 64, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/betula [betulaceae]/betula papyrifera/betula papyrifera (1).jpg',
          width: 576,
          id: '975aca235da9ccfff91368376954158e',
          height: 768,
          thumbnail: true,
        },
        location: [47.269872, -1.583817],
        genre: 'Betula',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583817, 47.269872] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c0051040a46ef2b9b4b8e599290395a636035aa2',
      fields: {
        espece: 'capreolata',
        localisation: 'A11',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2211256, -1.5428042],
        genre: 'Bignonia',
        date_plantation: '1973',
        famille: 'Bignoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428042, 47.2211256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '54603997dbc52929d41490d508c9ced435a52d54',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'bignonioides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 88, 39, 1.00)',
            'rgba(142, 149, 128, 1.00)',
            'rgba(72, 86, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/catalpa [bignoniaceae]/catalpa bignonioides/catalpa bignonioides (2).jpg',
          width: 576,
          id: 'b5d9cc94a4f8c5ac0da071f0bc57f544',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 117, 33, 1.00)',
            'rgba(118, 139, 80, 1.00)',
            'rgba(99, 114, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/catalpa [bignoniaceae]/catalpa bignonioides/catalpa bignonioides (3).jpg',
          width: 576,
          id: '9cd026a4d34838a2054d2b93a19a3435',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 134, 43, 1.00)',
            'rgba(109, 150, 47, 1.00)',
            'rgba(54, 74, 21, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/catalpa [bignoniaceae]/catalpa bignonioides/catalpa bignonioides (1).jpg',
          width: 576,
          id: 'bdd7ec0afa49bdfd98c08daa67b46fbe',
          height: 768,
          thumbnail: true,
        },
        location: [47.269172, -1.584783],
        genre: 'Catalpa',
        famille: 'Bignoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584783, 47.269172] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6db6605d13e65a7b37670a7689c0ca2e631bdacf',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'fargesii f. duclouxii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 161, 126, 1.00)',
            'rgba(85, 104, 58, 1.00)',
            'rgba(73, 86, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/catalpa [bignoniaceae]/catalpa fargesii f. duclouxii/catalpa fargesii f. duclouxii (2).jpg',
          width: 1024,
          id: '9608817cb5b4f3c1d4752bea9c539689',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 121, 89, 1.00)',
            'rgba(98, 112, 78, 1.00)',
            'rgba(83, 100, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/catalpa [bignoniaceae]/catalpa fargesii f. duclouxii/catalpa fargesii f. duclouxii (3).jpg',
          width: 1024,
          id: '4e36a4d85df1875f2e8b2f73fa7f229d',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 135, 98, 1.00)',
            'rgba(102, 129, 65, 1.00)',
            'rgba(103, 123, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/catalpa [bignoniaceae]/catalpa fargesii f. duclouxii/catalpa fargesii f. duclouxii (1).jpg',
          width: 1018,
          id: '59169b03b231ab061b6713d01176900b',
          height: 768,
          thumbnail: true,
        },
        location: [47.269575, -1.584822],
        genre: 'Catalpa',
        famille: 'Bignoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584822, 47.269575] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd8b9d0ad3beb72d946d56c4227a7ab0971d99e58',
      fields: {
        origine: 'Friedrich Alexander B.G. Erlangen (All.)',
        espece: 'arenaria Waldst.& Kit.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Onosma',
        date_plantation: '2014',
        famille: 'Boraginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c219e80c6fad47916c973f65f0ceff8304df216f',
      fields: {
        origine: 'Botanischer Garten,Friedrich Jena, Jena, Allemagne',
        espece: 'aubrietoides Boiss.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Arabis',
        date_plantation: '2012',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '16cd754c34a7ddb6669703a5ebc61723ebf7bcae',
      fields: {
        origine: 'JB. Alpin Viotte, Trento (Italie)',
        espece: 'argenteum All.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Alyssum',
        date_plantation: '2011',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a398dfde6ef99b4333fd7b02e5348f8b7db8fa80',
      fields: {
        origine: 'JB.M.N.H.N. (Paris)',
        espece: 'tenuifolia DC.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Diplotaxis',
        date_plantation: '2008',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8527e65df5236f79b7d50ea01cc3c590c01d954a',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'pulchellum J.Gay',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Erysimum',
        date_plantation: '2009',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd3552ac7932222dd81c4cd2e1cb85911a8735ebc',
      fields: {
        origine: 'JB.Rome (Italie)',
        espece: 'pseudorhaeticum Polastchek',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Erysimum',
        date_plantation: '2006',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fb7633d84a460644c85d380c48331a18a683db10',
      fields: {
        origine: 'JB.Huntington (USA)',
        espece: 'sp.',
        localisation: 'A2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2208871, -1.5444631],
        genre: 'Puya',
        date_plantation: '1992',
        famille: 'Bromeliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444631, 47.2208871] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '584f676a669721ffc913862218955bc304ec64da',
      fields: {
        origine: 'Ets.Lepage',
        espece: 'terminalis Sieb. & Zucc.',
        localisation: 'G1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193375, -1.5415093],
        genre: 'Pachysandra',
        date_plantation: '1986',
        famille: 'Buxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5415093, 47.2193375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a7bc37e88284c3a6e887685448f804058deb8840',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 225, 238, 1.00)',
            'rgba(115, 145, 116, 1.00)',
            'rgba(71, 90, 43, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/gleditsia [caesalpiniaceae]/gleditsia triacanthos 'skyline'/gleditsia triacanthos 'skyline'.jpg",
          width: 576,
          id: '2c14d35ddce2fdab74dd640e3230c1cc',
          height: 768,
          thumbnail: true,
        },
        espece: 'triacanthos',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 180, 203, 1.00)',
            'rgba(130, 139, 86, 1.00)',
            'rgba(85, 88, 31, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/gleditsia [caesalpiniaceae]/gleditsia triacanthos 'skyline'/gleditsia triacanthos 'skyline' .jpg",
          width: 576,
          id: '1a8929935f77992f0f5a8afd23546e80',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 83, 21, 1.00)',
            'rgba(128, 112, 26, 1.00)',
            'rgba(119, 118, 36, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/gleditsia [caesalpiniaceae]/gleditsia triacanthos 'skyline'/gleditsia triacanthos 'skyline' (2).jpg",
          width: 576,
          id: 'f21e6b2acb11768fcf4ea79d4513c8b2',
          height: 768,
          thumbnail: true,
        },
        location: [47.271237, -1.585753],
        genre: 'Gleditsia',
        cultivar: 'Skyline',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585753, 47.271237] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8796b134d3ba69897cf3768ac068b85650cb291c',
      fields: {
        origine: 'B.G. Karelia (Russie)',
        espece: 'persicifolia L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Campanula',
        date_plantation: '2014',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bd066d800c3436a33d29d87db2cd4e9a1fa858e5',
      fields: {
        origine: 'JB.Jean Michel Spas (France)',
        espece: 'celsii A.DC',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Campanula',
        date_plantation: '2006',
        cultivar: 'celsii',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '32747e85035299ff6affd75fdeba4d5fa1b88943',
      fields: {
        origine: "JB.L'Aquilla (Italie)",
        espece: 'foliosa  Ten.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Campanula',
        date_plantation: '2008',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'efbb60e0f08d59b9a8c70ed69459ab1d378c7d6d',
      fields: {
        origine: 'JB.Sverdlovsk (URSS)',
        espece: 'pyramidalis L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Campanula',
        date_plantation: '1987',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b3fbc8971c53b3ac038b3767561060e142d2871e',
      fields: {
        origine: 'JBU.G\u00f6ethe de Frankf\u00fcrt am Main (Allemagne)',
        espece: 'grossekii Heuff.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Campanula',
        date_plantation: '2006',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '12d63049b6bdb4dfcb0d62b4ddd27c1f7032af62',
      fields: {
        origine: 'JB. Takashi Nishinchi, Konan city (Japon)',
        espece: 'scabiosifolia Fisch.',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Patrinia',
        date_plantation: '2011',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e0400e57fd90191ee858b33f9f2d378cd168d60a',
      fields: {
        origine: 'JB.Graz (Autriche)',
        espece: 'graminifolia L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Scabiosa',
        date_plantation: '2009',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4f58e9d5d1ef02d77d27c19b4d0e4d8b9ff710e8',
      fields: {
        origine: 'JB.Sofia (Bulgarie)',
        espece: 'midzorensis Form.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Knautia',
        date_plantation: '2009',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '74a5f5bdad0a100d0d46893a1d39ab8b877cf901',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 124, 70, 1.00)',
            'rgba(99, 133, 78, 1.00)',
            'rgba(100, 130, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/leycesteria [caprifoliaceae]/leycesteria formosa 'purple rain'/leycesteria formosa 'purple rain' (4).jpg",
          width: 1024,
          id: 'fb8c1a6dee1048aece3208b0bb0bb004',
          height: 683,
          thumbnail: true,
        },
        espece: 'formosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 129, 59, 1.00)',
            'rgba(83, 124, 56, 1.00)',
            'rgba(89, 133, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/leycesteria [caprifoliaceae]/leycesteria formosa 'purple rain'/leycesteria formosa 'purple rain' (2).jpg",
          width: 1024,
          id: '3b0167b8fb0dec117927139907bd6d26',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 158, 126, 1.00)',
            'rgba(108, 109, 70, 1.00)',
            'rgba(83, 95, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/leycesteria [caprifoliaceae]/leycesteria formosa 'purple rain'/leycesteria formosa 'purple rain' (1).jpg",
          width: 1024,
          id: 'b8775842e4c36c38dc3768ea4aabae30',
          height: 683,
          thumbnail: true,
        },
        location: [47.271645, -1.586842],
        genre: 'Leycesteria',
        cultivar: 'Purple Rain',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586842, 47.271645] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '767fab71c1c9f075d55fc2e913d30e9cc5b40b2a',
      fields: {
        origine: 'B.G. de Bielefeld (All.)',
        espece: 'kingii M.E.Jones',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Arenaria',
        date_plantation: '2016',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '042810712e4d6cd8d7ab946c947f457b993e8986',
      fields: {
        origine: 'B.G. Rostock (All.)',
        espece: 'saxifraga L.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Silene',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ee798d78358685307dec8fc8e90d0ce0084b60aa',
      fields: {
        origine: 'Botanic Garden Oslo-Norv\u00e8ge',
        espece: 'illyrica P.W.Ball & Heywood',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Petrorhagia',
        date_plantation: '2014',
        cultivar: 'subsp.haynaldiana P.W.Ball & Heywood',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '15df9e9387c05168e4ebefda1c0092d65f956fe9',
      fields: {
        origine: 'Botanischer Garten Karl-Franzens, Graz, Autriche',
        espece: 'pendula L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Silene',
        date_plantation: '2012',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6b4f28091fb9069460ed94552c097b4a2923ff1b',
      fields: {
        origine: 'Conservatoire et J.B. de Nancy,France',
        espece: 'compacta Fischer',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Silene',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '97cae5aca31c7d02f91ac77f260192770beeb7fa',
      fields: {
        origine: 'Friedrich Alexander B.G. Erlangen (All.)',
        espece: 'kashmirica Mattf.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Minuartia',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ba661544ed349a752100ed1451e5518c925eef23',
      fields: {
        origine: 'J.B.ST.Andrews,Ecosse',
        espece: 'roemeri Friv.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Silene',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3cca29c5fe9f268e0789410b6215bb15787a9612',
      fields: {
        origine: 'JB. Hongrois, V\u00e0cr\u00e0tot ( Hongrie)',
        espece: 'coronaria Desr.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Lychnis',
        date_plantation: '2011',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2bbcc6a837d5d5859a2e74ebc490915953a2e794',
      fields: {
        origine: 'JB.Budapest (Hongrie)',
        espece: 'pontederae  A.Kern.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Dianthus',
        date_plantation: '2008',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '57485d1fdddc6a6cbb9c89c63ec293b7cc7b6875',
      fields: {
        origine: "JB.d'Aquila (Italie)",
        espece: 'arvense L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Cerastium',
        date_plantation: '2006',
        cultivar: 'suffruticosum Cesati',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c03d964e340ec91c2dbaa46e398e397cd528e792',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'petraeus Waldst & Kit.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Dianthus',
        date_plantation: '2006',
        cultivar: 'petraeus',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0a4315449f2bd065b945afb1b28c969ac754fdb3',
      fields: {
        origine: 'JBU.Aegaensis (Turquie)',
        espece: 'pubescens Sibth. & Sm.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Dianthus',
        date_plantation: '1990',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4f75da4e63b4d2909ab9f178620bef1170c527e1',
      fields: {
        origine: 'JBU.Vitebsk (Bielorussie)',
        espece: 'deltoides L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Dianthus',
        date_plantation: '2006',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6df2dde972412cdc36f32afbb9bfaca2521c2e33',
      fields: {
        origine: 'Rennsteiggarten Oberhof (All.)',
        espece: 'saxifraga L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Silene',
        date_plantation: '2015',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '87973d3ecca6726a31397accb75f7c66b4e7c644',
      fields: {
        origine: 'Universit\u00e9 de Gent (Belgique)',
        espece: 'sp.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Silene',
        date_plantation: '2011',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '04a4f945bfdae388ebca989d5d93ae8405fbee84',
      fields: {
        origine: 'Universit\u00e9 de Postdam (Allemagne)',
        espece: 'myrtinervius Griseb.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Dianthus',
        date_plantation: '2011',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '778bc61684d2a5f27413956b186ce26257159952',
      fields: {
        origine: 'Zoo and BG.of the Plzen(R\u00e9p.Tch\u00e8que)',
        espece: 'suksdorfii B.L.Rob.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Silene',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fe0138af4af45927907440ccab589d4d77330574',
      fields: {
        espece: 'phellomanus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 76, 49, 1.00)',
            'rgba(92, 136, 56, 1.00)',
            'rgba(93, 129, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus phellomanus/euonymus phellomanus (3).jpg',
          width: 576,
          id: '8645a1754dc43a5bdddd7bf23559ed65',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 89, 81, 1.00)',
            'rgba(107, 105, 92, 1.00)',
            'rgba(92, 82, 77, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus phellomanus/euonymus phellomanus (1).jpg',
          width: 576,
          id: '8fb0795c5dd80eb02c9c3893fd547617',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Euonymus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3eb60cf5ebc9d0e58fc47c342ab0ab3b933282b9',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'verrucosus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 153, 75, 1.00)',
            'rgba(119, 151, 73, 1.00)',
            'rgba(98, 122, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus verrucosus/euonymus verrucosus (1).jpg',
          width: 576,
          id: '075729f9f161d8b908b5c144a2953c6c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 129, 108, 1.00)',
            'rgba(92, 115, 80, 1.00)',
            'rgba(131, 128, 107, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus verrucosus/euonymus verrucosus (4).jpg',
          width: 576,
          id: '8d5b7048e24eb3ef6599af9d12a98e1f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 105, 47, 1.00)',
            'rgba(135, 122, 68, 1.00)',
            'rgba(123, 114, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus verrucosus/euonymus verrucosus  (2).jpg',
          width: 576,
          id: 'e939f06a01fbb520034e4c3be3062baf',
          height: 768,
          thumbnail: true,
        },
        location: [47.270047, -1.584205],
        genre: 'Euonymus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584205, 47.270047] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4866119684769016006a86d8ffda4f904986a166',
      fields: {
        origine: 'JB.Alp.Belverdere Wien. (Autriche)',
        espece: 'ovatum Dun.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Helianthemum',
        date_plantation: '1999',
        famille: 'Cistaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8a6458c1d949d807da0fd9814774a1e913872534',
      fields: {
        origine: 'Orto Botanico di Sienna (Italie)',
        espece: 'procumbens Gren.& Godr.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Fumana',
        date_plantation: '2015',
        famille: 'Cistaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1034ab04f6f6078d0315a34b4475576cd8f25517',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 83, 53, 1.00)',
            'rgba(170, 176, 160, 1.00)',
            'rgba(82, 94, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus 'ormonde'/cornus 'ormonde' (1).jpg",
          width: 576,
          id: '4d39d0428dbf82dc334a89f0388a3781',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 171, 51, 1.00)',
            'rgba(122, 153, 40, 1.00)',
            'rgba(111, 139, 36, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus 'ormonde'/cornus 'ormonde' (2).jpg",
          width: 576,
          id: '8580eadc02004d3493eb2c7dc36c6aa7',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 134, 116, 1.00)',
            'rgba(145, 115, 102, 1.00)',
            'rgba(133, 109, 102, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus 'ormonde'/cornus 'omonde' (3).jpg",
          width: 576,
          id: 'c15f112c5a1388baa50c6b187ed61224',
          height: 768,
          thumbnail: true,
        },
        location: [47.271642, -1.584433],
        genre: 'Cornus',
        cultivar: 'Ormonde',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584433, 47.271642] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a55594a4086e633bf92b19cc386ca915a50e3ebb',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 149, 67, 1.00)',
            'rgba(121, 142, 76, 1.00)',
            'rgba(102, 116, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus alba 'gauchaultii'/cornus alba 'gouchaultii'  (3).jpg",
          width: 576,
          id: 'f1245f757dfde18f2605d7806165ad4e',
          height: 768,
          thumbnail: true,
        },
        espece: 'alba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 121, 46, 1.00)',
            'rgba(132, 142, 81, 1.00)',
            'rgba(86, 100, 32, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus alba 'gauchaultii'/cornus alba 'gouchaultii'  (2).jpg",
          width: 576,
          id: '062bd4a7034370d491f2d64045bd73fc',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 136, 53, 1.00)',
            'rgba(136, 148, 66, 1.00)',
            'rgba(108, 120, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus alba 'gauchaultii'/cornus alba 'gouchaultii'  (1).jpg",
          width: 1024,
          id: 'e34b1103786ddab849f6897651dac532',
          height: 768,
          thumbnail: true,
        },
        location: [47.271363, -1.584612],
        genre: 'Cornus',
        cultivar: 'Gauchaultii',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584612, 47.271363] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4aea3949ca1e38bc1bba7e7bc3b77e55c30b31ea',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 117, 80, 1.00)',
            'rgba(110, 117, 71, 1.00)',
            'rgba(85, 98, 42, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus alternifolia 'argentea'/cornus alternifolia 'argentea' (3).jpg",
          width: 851,
          id: '4ef0d5c1490a613b39623c85a0fd3064',
          height: 768,
          thumbnail: true,
        },
        espece: 'alternifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 142, 72, 1.00)',
            'rgba(121, 136, 65, 1.00)',
            'rgba(107, 125, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus alternifolia 'argentea'/cornus alternifolia 'argentea' (2).jpg",
          width: 576,
          id: '18aad50618af60b940940e9a2d3d3a0b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 160, 80, 1.00)',
            'rgba(130, 160, 63, 1.00)',
            'rgba(130, 159, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus alternifolia 'argentea'/cornus alternifolia 'argentea' (1).jpg",
          width: 576,
          id: '1e8746e1c5388c5ce1fdf2bb8e635c94',
          height: 768,
          thumbnail: true,
        },
        location: [47.26993, -1.582022],
        genre: 'Cornus',
        cultivar: 'Argentea',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582022, 47.26993] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '97915ec5870e7c78329b03d072a6e663d7acdb46',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 123, 79, 1.00)',
            'rgba(117, 134, 83, 1.00)',
            'rgba(79, 95, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'autumn rose'/cornus kousa 'autumn rose' (14).jpg",
          width: 1024,
          id: '31fe05fd3b9790b97d140c844341da39',
          height: 683,
          thumbnail: true,
        },
        espece: 'kousa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 144, 94, 1.00)',
            'rgba(80, 104, 53, 1.00)',
            'rgba(58, 76, 35, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'autumn rose'/cornus kousa 'autumn rose' (13).jpg",
          width: 1024,
          id: '32900f70b672cfac755db1971ec120da',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(55, 79, 40, 1.00)',
            'rgba(85, 111, 63, 1.00)',
            'rgba(66, 89, 42, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'autumn rose'/cornus kousa 'autumn rose' (12).jpg",
          width: 1024,
          id: '17505deb3f7f19439f519f0785aa5394',
          height: 683,
          thumbnail: true,
        },
        location: [47.270625, -1.581872],
        genre: 'Cornus',
        cultivar: 'Autumn Rose',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581872, 47.270625] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2f0ecbdb95738a31d6dda3bbdec494ebf29ef73f',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 143, 61, 1.00)',
            'rgba(125, 136, 51, 1.00)',
            'rgba(71, 79, 24, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'gold star'/cornus kousa 'gold star'.jpg",
          width: 576,
          id: 'd6f0a9aac4e74bc7263f6283d36e515c',
          height: 768,
          thumbnail: true,
        },
        espece: 'kousa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 128, 74, 1.00)',
            'rgba(151, 109, 92, 1.00)',
            'rgba(121, 107, 91, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'gold star'/cornus kousa 'gold star' (7).jpg",
          width: 576,
          id: '620d29581a036c6c2418eb33bfed8bdd',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 101, 49, 1.00)',
            'rgba(107, 123, 60, 1.00)',
            'rgba(53, 61, 23, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'gold star'/cornus kousa 'gold star' (4).jpg",
          width: 576,
          id: '2883d360633d6606035a91695e7f8882',
          height: 768,
          thumbnail: true,
        },
        location: [47.269858, -1.581087],
        genre: 'Cornus',
        cultivar: 'Gold Star',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581087, 47.269858] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3c57e1484c592dbc2a3924232b3ea1ebc05b5288',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'kousa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(174, 118, 80, 1.00)',
            'rgba(182, 105, 89, 1.00)',
            'rgba(110, 66, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa/cornus kousa (2).jpg',
          width: 576,
          id: '9ca11ea26fa3ac254a0c1c46641370bd',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 150, 129, 1.00)',
            'rgba(98, 109, 82, 1.00)',
            'rgba(55, 54, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa/cornus kousa (3).jpg',
          width: 1024,
          id: '4fe57f82ed62d633ad73044fd415fd1c',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(186, 176, 150, 1.00)',
            'rgba(136, 96, 56, 1.00)',
            'rgba(97, 72, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa/cornus kousa (1).jpg',
          width: 576,
          id: '4d09fd4be95fb5f3ba41d1ad348c2602',
          height: 768,
          thumbnail: true,
        },
        location: [47.270542, -1.582755],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582755, 47.270542] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9228853854e03bfc65405c1c078518ad9a4f69e6',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'sericea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 143, 123, 1.00)',
            'rgba(110, 154, 92, 1.00)',
            'rgba(106, 131, 78, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus sericea/cornus sericea  (2).jpg',
          width: 587,
          id: 'cf78dfa5ca0127950a68e15733b79251',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 102, 79, 1.00)',
            'rgba(120, 127, 103, 1.00)',
            'rgba(61, 73, 42, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus sericea/cornus sericea  (3).jpg',
          width: 576,
          id: '2c2a7cff7c35775a260a704c9d299274',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 118, 99, 1.00)',
            'rgba(134, 88, 99, 1.00)',
            'rgba(105, 95, 88, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus sericea/cornus sericea  (1).jpg',
          width: 576,
          id: '2afbe48d0e85d05f4ff06cb6b3b2b089',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9750cf0183c4e603505db1814ec07f63fba80a21',
      fields: {
        espece: 'pavia',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 155, 119, 1.00)',
            'rgba(80, 95, 49, 1.00)',
            'rgba(65, 77, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus pavia/aesculus pavia.jpg',
          width: 1024,
          id: '8b40f5d7a946e610e57f40c7157e6d65',
          height: 683,
          thumbnail: true,
        },
        location: [47.270989, -1.586164],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586164, 47.270989] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '47b10b4421973d5b35d9d3173f70bd963308c338',
      fields: {
        espece: 'spinosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 155, 136, 1.00)',
            'rgba(132, 145, 94, 1.00)',
            'rgba(106, 119, 75, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/argania [sapotaceae]/argania spinosa/argania spinosa (2).jpg",
          width: 576,
          id: '70f412642997d7e48b7c231e6f69351c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 150, 150, 1.00)',
            'rgba(130, 136, 113, 1.00)',
            'rgba(115, 115, 79, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/argania [sapotaceae]/argania spinosa/argania spinosa (1).jpg",
          width: 576,
          id: '7a75d8729be2008059ec50fc3e7f4112',
          height: 768,
          thumbnail: true,
        },
        location: [47.226695, -1.512678],
        genre: 'Argania',
        famille: 'Sapotaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512678, 47.226695] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8aef321085d3321bc62016eb61a8740f3ee14f6a',
      fields: {
        origine:
          'P\u00e9pini\u00e8res botaniques armoricaines - Saint-Adrien (22)',
        espece: 'verticillata',
        localisation: 'B1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2204652, -1.544656],
        genre: 'Sciadopitys',
        date_plantation: '2015',
        famille: 'Sciadopityaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544656, 47.2204652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '17d1bad64d5082e955a21cd8411c1459137d8df0',
      fields: {
        origine: 'Jardin botanique de T\u00fcbingen',
        espece: 'aquatica',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Scrophularia',
        date_plantation: '2006',
        famille: 'Scrophulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b7a19aabbd60459992a0e6c5b03b60279d6f361c',
      fields: {
        origine:
          'Honorable Municipalidad de Cochabamba - origine nature\u00a0: Montepunco "B" Pocona Provincia, alt. 2530M',
        espece: 'sp.',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Solanacae',
        date_plantation: '2003',
        famille: 'Solanaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd34c1fde05fcfc9ace20f5b0cdbb57aaee34120e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'colchica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 135, 82, 1.00)',
            'rgba(98, 125, 54, 1.00)',
            'rgba(125, 140, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/staphylea [staphyleaceae]/staphylea colchica/staphylea colchica (2).jpg',
          width: 1024,
          id: '62a06a0eaad8e31183e09e49bba077c7',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 133, 84, 1.00)',
            'rgba(134, 145, 82, 1.00)',
            'rgba(126, 136, 74, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/staphylea [staphyleaceae]/staphylea colchica/staphylea colchica (3).jpg',
          width: 576,
          id: '484042ef04c702201a635e115540181b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 121, 36, 1.00)',
            'rgba(120, 146, 54, 1.00)',
            'rgba(89, 96, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/staphylea [staphyleaceae]/staphylea colchica/staphylea colchica (1).jpg',
          width: 576,
          id: '9af6e365e5da8f99f9e8dcafc32ac5af',
          height: 768,
          thumbnail: true,
        },
        location: [47.270045, -1.585555],
        genre: 'Staphylea',
        famille: 'Staphyleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585555, 47.270045] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a83f8ade9fd9cb15492474dfd97f49c373218855',
      fields: {
        espece: 'trifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 149, 70, 1.00)',
            'rgba(126, 148, 69, 1.00)',
            'rgba(121, 142, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/staphylea [staphyleaceae]/staphylea trifolia/staphylea trifolia (2).jpg',
          width: 576,
          id: '77f3f5bc32aa5bc5aee3aec819aadf90',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 123, 41, 1.00)',
            'rgba(125, 133, 69, 1.00)',
            'rgba(111, 104, 64, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/staphylea [staphyleaceae]/staphylea trifolia/staphylea trifolia (1).jpg',
          width: 576,
          id: 'd2164380117b87e6c774904e725cbcf9',
          height: 768,
          thumbnail: true,
        },
        location: [47.269428, -1.585138],
        genre: 'Staphylea',
        famille: 'Staphyleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585138, 47.269428] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0df71928d7649097844ef6431a56f82e9a34660e',
      fields: {
        espece: 'carolina',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 136, 114, 1.00)',
            'rgba(108, 116, 85, 1.00)',
            'rgba(83, 81, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/halesia [styracaceae]/halesia carolina/halesia carolina (15).jpg',
          width: 1024,
          id: 'cbd8fa349840ac516219192d265d3d6f',
          height: 683,
          thumbnail: true,
        },
        location: [47.270297, -1.581378],
        genre: 'Halesia',
        famille: 'Styracaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581378, 47.270297] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f34a93ccae54bb6ceed8032fc3533a6d16f45a5f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 84, 64, 1.00)',
            'rgba(114, 58, 58, 1.00)',
            'rgba(87, 49, 48, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'freedom bell'/camellia 'freedom bell'  (3).jpg",
          width: 1024,
          id: '6210fffaa88a142728030449b56802ca',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 176, 154, 1.00)',
            'rgba(100, 111, 80, 1.00)',
            'rgba(102, 99, 81, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'freedom bell'/camellia 'freedom bell'  (4).jpg",
          width: 1024,
          id: '6de3848231c28f2c4f7e230178b2ab92',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 138, 127, 1.00)',
            'rgba(107, 62, 51, 1.00)',
            'rgba(89, 70, 48, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'freedom bell'/camellia 'freedom bell'  (2).jpg",
          width: 1024,
          id: 'e625fdc6a397d2a62df7d2edc85dd0d8',
          height: 683,
          thumbnail: true,
        },
        location: [47.269562, -1.584592],
        genre: 'Camellia',
        cultivar: 'Freedom Bell',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584592, 47.269562] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5cf4b06fafcf445e05c8f18c23df23c6ca57b1cd',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(45, 52, 49, 1.00)',
            'rgba(95, 94, 102, 1.00)',
            'rgba(62, 61, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'high fragrance'/camellia 'high fragrance'.jpg",
          width: 1024,
          id: 'c532d0fe7f8d41c534d2ee4e85723eb6',
          height: 683,
          thumbnail: true,
        },
        location: [47.27053, -1.581302],
        genre: 'Camellia',
        cultivar: 'High Fragrance',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581302, 47.27053] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fca6bd77908d3f83f5ed8755fe32d144ed614144',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 66, 57, 1.00)',
            'rgba(127, 73, 81, 1.00)',
            'rgba(107, 63, 71, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'leonard messel'/camellia 'leonard messel'.jpg",
          width: 1024,
          id: '33f4863e4ed9a7a12e9c648691a776c3',
          height: 683,
          thumbnail: true,
        },
        location: [47.26952, -1.584487],
        genre: 'Camellia',
        cultivar: 'Leonard Messel',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584487, 47.26952] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7a0feb1902f9c4f5b2f1052cb996e8b9bb28b8fc',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(64, 76, 62, 1.00)',
            'rgba(99, 94, 88, 1.00)',
            'rgba(78, 84, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'magali'/camellia 'magali' (5).jpg",
          width: 1024,
          id: '4e72ed2db723b8da0296b9c4f8376108',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 94, 89, 1.00)',
            'rgba(102, 100, 91, 1.00)',
            'rgba(100, 110, 110, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'magali'/camellia 'magali' (6).jpg",
          width: 1024,
          id: '762e07174cae4a0bbceb410242c02263',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 156, 147, 1.00)',
            'rgba(77, 88, 67, 1.00)',
            'rgba(58, 67, 44, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'magali'/camellia 'magali' (4).jpg",
          width: 1024,
          id: 'e969e5b0670d55454455e105b1af494e',
          height: 683,
          thumbnail: true,
        },
        location: [47.27022, -1.58388],
        genre: 'Camellia',
        cultivar: 'Magali',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58388, 47.27022] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '71ea17898c6ac61f1717a8f10ee55e297158589d',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 115, 109, 1.00)',
            'rgba(108, 83, 79, 1.00)',
            'rgba(81, 77, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'show girl'/camellia 'show girl' (7).jpg",
          width: 1024,
          id: '9e1d06bb7d8ef56eb9b0bce5f757d0dc',
          height: 683,
          thumbnail: true,
        },
        location: [47.269333, -1.584372],
        genre: 'Camellia',
        cultivar: 'Show Girl',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584372, 47.269333] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '65ff389463d57eecb2d86036b822eba5be992c3e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(168, 163, 137, 1.00)',
            'rgba(104, 120, 67, 1.00)',
            'rgba(103, 105, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia 'spring festival'/camellia 'spring festival' (3).jpg",
          width: 576,
          id: 'fcc7e76f36702343db8e15a7d6ff91dd',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Camellia',
        cultivar: 'Spring Festival',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9ee2eaec2f5d7c951e6c7029f70f6be495eb210e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'cuspidata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 157, 105, 1.00)',
            'rgba(123, 130, 77, 1.00)',
            'rgba(112, 133, 82, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia cuspidata/camellia cuspidata (2).jpg',
          width: 576,
          id: '82eff1f46bdf8863ccd1952005709b76',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 117, 74, 1.00)',
            'rgba(108, 114, 69, 1.00)',
            'rgba(82, 96, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia cuspidata/camellia cuspidata (4).jpg',
          width: 576,
          id: '231f3b08f77578d152ed278a127310bf',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 155, 101, 1.00)',
            'rgba(116, 134, 75, 1.00)',
            'rgba(129, 141, 87, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia cuspidata/camellia cuspidata (1).jpg',
          width: 576,
          id: '2f9cb6f2f99facaab94223c1ab71ed9c',
          height: 768,
          thumbnail: true,
        },
        location: [47.270238, -1.582572],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582572, 47.270238] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '551fd47d143dde2915786c304f49d8aa225f9784',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'forrestii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 126, 104, 1.00)',
            'rgba(93, 105, 81, 1.00)',
            'rgba(75, 86, 70, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia forrestii/camellia forrestii (2).jpg',
          width: 1024,
          id: '087d22cfab70302a3897bd2aa615fa99',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(53, 72, 57, 1.00)',
            'rgba(106, 110, 86, 1.00)',
            'rgba(93, 98, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia forrestii/camellia forrestii (3).jpg',
          width: 1024,
          id: 'c2cd812e9a1067671b957c6d3a51ea2e',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 81, 67, 1.00)',
            'rgba(105, 114, 91, 1.00)',
            'rgba(80, 88, 60, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/camellia [theaceae]/camellia forrestii/camellia forrestii (1).jpg',
          width: 1024,
          id: '58da35dbf10588a9bedf72fff7fdc533',
          height: 683,
          thumbnail: true,
        },
        location: [47.270442, -1.58408],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58408, 47.270442] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ffed983ff8de389c3820a8d547d79742eccc4d2f',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 99, 80, 1.00)',
            'rgba(101, 111, 89, 1.00)',
            'rgba(40, 55, 41, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'aki-no-yama'/camellia japonica 'aki-no-yama' (2).jpg",
          width: 512,
          id: '369f70c2e433ae932df913cc5662b94a',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 141, 119, 1.00)',
            'rgba(106, 118, 97, 1.00)',
            'rgba(90, 77, 65, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'aki-no-yama'/camellia japonica 'aki-no-yama' (10).jpg",
          width: 512,
          id: '4582578a834f32c78e66f2b68fc7fd11',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(62, 71, 41, 1.00)',
            'rgba(105, 105, 81, 1.00)',
            'rgba(35, 37, 29, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'aki-no-yama'/camellia japonica 'aki-no-yama' (1).jpg",
          width: 1024,
          id: '1a87cfab65673d7eb49bfc6f57a778e6',
          height: 683,
          thumbnail: true,
        },
        location: [47.27042, -1.581333],
        genre: 'Camellia',
        cultivar: 'Aki-no-yama',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581333, 47.27042] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '60931201e042e1c2384edfc2f96c8e0af9071b04',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 87, 73, 1.00)',
            'rgba(113, 88, 87, 1.00)',
            'rgba(75, 78, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'antares'/camellia japonica 'antares' (3).jpg",
          width: 1024,
          id: '12e1aa6452e4e77bf4d4c44ac29af8c0',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 115, 98, 1.00)',
            'rgba(104, 104, 97, 1.00)',
            'rgba(78, 57, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'antares'/camellia japonica 'antares' (2).jpg",
          width: 1024,
          id: '4ee96a36e32313a36ab30202fb9e8cc3',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(176, 189, 176, 1.00)',
            'rgba(97, 109, 88, 1.00)',
            'rgba(65, 68, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'antares'/camellia japonica 'antares' (1).jpg",
          width: 512,
          id: 'f7c2e3bf09f2848fe7192e421521dc51',
          height: 768,
          thumbnail: true,
        },
        location: [47.271542, -1.58263],
        genre: 'Camellia',
        cultivar: 'Antar\u00e8s',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58263, 47.271542] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '48a59fae0a5cb5195c13c53f37bc379df57f76d1',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 85, 74, 1.00)',
            'rgba(176, 62, 81, 1.00)',
            'rgba(130, 75, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'bob's tinsie'/camellia japonica 'bob's tinsie' (3).jpg",
          width: 576,
          id: '49bb6bc2c076558d97c13839540907a0',
          height: 768,
          thumbnail: true,
        },
        location: [47.269822, -1.58197],
        genre: 'Camellia',
        cultivar: "Bob's Tinsie",
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58197, 47.269822] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '722da9cbf3092576cd888397f18e37c07511ad0e',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 136, 116, 1.00)',
            'rgba(133, 143, 136, 1.00)',
            'rgba(100, 109, 94, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'de bugny'/camellia japonica 'de bugny' (3).jpg",
          width: 1024,
          id: 'e9b12ba043137e0ba96aeab819d998ab',
          height: 676,
          thumbnail: true,
        },
        location: [47.269709, -1.580985],
        genre: 'Camellia',
        cultivar: 'De Bugny',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580985, 47.269709] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c1ef56a5f06392736cadce0b91f42f8d16e43a8d',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 115, 89, 1.00)',
            'rgba(112, 96, 82, 1.00)',
            'rgba(98, 95, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'egeria'/camellia japonica 'egeria' (2).jpg",
          width: 1024,
          id: '5e455f70cd0a26add3d52a0a7dcbed28',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 93, 81, 1.00)',
            'rgba(101, 81, 89, 1.00)',
            'rgba(47, 48, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'egeria'/camellia japonica 'egeria' (1).jpg",
          width: 1024,
          id: '313f9e2f697baef160d9554a2b6d78ce',
          height: 683,
          thumbnail: true,
        },
        location: [47.270512, -1.586128],
        genre: 'Camellia',
        cultivar: 'Egeria',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586128, 47.270512] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a69a566f317c66b5761b9841cdd1e6b4151d2748',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 72, 49, 1.00)',
            'rgba(112, 83, 69, 1.00)',
            'rgba(102, 75, 63, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'francois ii'/camellia japonica 'francois ii'.jpg",
          width: 1024,
          id: '0806cad5876cac19230fa96bc5d5697d',
          height: 683,
          thumbnail: true,
        },
        location: [47.267692, -1.584283],
        genre: 'Camellia',
        cultivar: 'Fran\u00e7ois II',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584283, 47.267692] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2dca6f189e8b73471d2202dc2324eac6058ac801',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(169, 175, 156, 1.00)',
            'rgba(105, 115, 92, 1.00)',
            'rgba(65, 67, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'fukurin-wabisuke'/camellia japonica 'fukurin-wabisuke' (3).jpg",
          width: 512,
          id: '0b1133a409661e4f88c1c3814db0ebe6',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 126, 90, 1.00)',
            'rgba(101, 123, 81, 1.00)',
            'rgba(146, 130, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'fukurin-wabisuke'/camellia japonica 'fukurin-wabisuke' (2).jpg",
          width: 576,
          id: '58d5e5c2b3672e8a9b12027a8e71beb3',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 77, 66, 1.00)',
            'rgba(142, 123, 119, 1.00)',
            'rgba(78, 76, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'fukurin-wabisuke'/camellia japonica 'fukurin-wabisuke' (1).jpg",
          width: 576,
          id: '79ecf483f5d45ed3107b1b1e782398ed',
          height: 768,
          thumbnail: true,
        },
        location: [47.270131, -1.581456],
        genre: 'Camellia',
        cultivar: 'Fukurin-wabisuke',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581456, 47.270131] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5d6c3bf023011292e2b09bdcc0d2afabc4854333',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 101, 68, 1.00)',
            'rgba(127, 63, 47, 1.00)',
            'rgba(74, 51, 30, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'grand prix'/camellia japonica 'grand prix' (4).jpg",
          width: 1024,
          id: 'a0fbecb55e74adf898e24570ea8cb1c4',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 140, 123, 1.00)',
            'rgba(114, 113, 75, 1.00)',
            'rgba(102, 106, 67, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'grand prix'/camellia japonica 'grand prix' (2).jpg",
          width: 1024,
          id: 'e1e7d4767254576d3a38ff352dbcacdb',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 64, 47, 1.00)',
            'rgba(133, 64, 39, 1.00)',
            'rgba(80, 68, 29, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'grand prix'/camellia japonica 'grand prix' (1).jpg",
          width: 1024,
          id: 'ae86d473dabdaaf4c2ee2fd85e95b130',
          height: 683,
          thumbnail: true,
        },
        location: [47.269372, -1.583928],
        genre: 'Camellia',
        cultivar: 'Grand Prix',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583928, 47.269372] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '05040349787b58c6a93605ddede30d2437a89b87',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 65, 70, 1.00)',
            'rgba(105, 65, 77, 1.00)',
            'rgba(59, 49, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'guichard soeurs'/camellia japonica 'guichard soeurs'.jpg",
          width: 1024,
          id: '1a3ccf6fc29c0d25fdfff066c5b851ab',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 68, 57, 1.00)',
            'rgba(118, 71, 73, 1.00)',
            'rgba(84, 58, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'guichard soeurs'/camellia japonica 'guichard soeurs' (2).jpg",
          width: 1024,
          id: 'a3376619e2d9e54586a7d66ca9b24ba4',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 129, 116, 1.00)',
            'rgba(89, 94, 75, 1.00)',
            'rgba(113, 100, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'guichard soeurs'/camellia japonica 'guichard soeurs' (1).jpg",
          width: 1024,
          id: 'c251319ae3b71c2aa616aeb112784913',
          height: 683,
          thumbnail: true,
        },
        location: [47.269669, -1.581428],
        genre: 'Camellia',
        cultivar: 'Guichard Soeurs',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581428, 47.269669] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '72597b303af14a824b2fd4e90171a0622f53e529',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 87, 61, 1.00)',
            'rgba(106, 110, 89, 1.00)',
            'rgba(58, 74, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'hagoromo'/camellia japonica 'hagoromo' (3).jpg",
          width: 1024,
          id: '10ad9cab0f78de9f1df1c73ee6ed78ff',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 165, 142, 1.00)',
            'rgba(73, 89, 61, 1.00)',
            'rgba(41, 56, 35, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'hagoromo'/camellia japonica 'hagoromo' (2).jpg",
          width: 1024,
          id: 'c88b1edac57ae26d0a5fb7af244fbade',
          height: 681,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 147, 129, 1.00)',
            'rgba(75, 90, 57, 1.00)',
            'rgba(70, 86, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'hagoromo'/camellia japonica 'hagoromo' (1).jpg",
          width: 1024,
          id: '51cb17d52a0fead810006439e35708c8',
          height: 683,
          thumbnail: true,
        },
        location: [47.26933, -1.58398],
        genre: 'Camellia',
        cultivar: 'Hagoromo',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58398, 47.26933] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f1c72378077a56f260a675ee6b6f1f6b9c75cbd0',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 124, 110, 1.00)',
            'rgba(111, 104, 80, 1.00)',
            'rgba(56, 67, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'ichiko-wabisuke'/camellia japonica 'ichiko-wabisuke'  (4).jpg",
          width: 1024,
          id: 'cccf8289fa4e6400417b97efdcaf63bc',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 171, 148, 1.00)',
            'rgba(103, 98, 65, 1.00)',
            'rgba(73, 78, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'ichiko-wabisuke'/camellia japonica 'ichiko-wabisuke'  (2).jpg",
          width: 1024,
          id: 'b7d3df4bf3d12927ec25e9f1f3b9ad6a',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(55, 79, 43, 1.00)',
            'rgba(89, 79, 59, 1.00)',
            'rgba(80, 93, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'ichiko-wabisuke'/camellia japonica 'ichiko-wabisuke'  (1).jpg",
          width: 1024,
          id: '6a1fa18a8ed89bb0b23ea2254e2ce94c',
          height: 683,
          thumbnail: true,
        },
        location: [47.270517, -1.581347],
        genre: 'Camellia',
        cultivar: 'Ichiko-wabisuke',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581347, 47.270517] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e6603a11f6105cdc633ad68524c8177aaf4448f4',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 78, 56, 1.00)',
            'rgba(125, 80, 87, 1.00)',
            'rgba(126, 81, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'imperator'/camellia japonica 'imperator'.jpg",
          width: 1024,
          id: '3478a2a73e9873773177212239607983',
          height: 683,
          thumbnail: true,
        },
        location: [47.270717, -1.585267],
        genre: 'Camellia',
        cultivar: 'Imperator',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585267, 47.270717] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0fed0df4800bbeb70c1414fc04590a0632aab598',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(56, 45, 37, 1.00)',
            'rgba(105, 69, 73, 1.00)',
            'rgba(104, 74, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'kenny'/camellia japonica 'kenny' (3).jpg",
          width: 1024,
          id: '494be3a9727e3840c39a7915d1e268a2',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 126, 117, 1.00)',
            'rgba(90, 94, 66, 1.00)',
            'rgba(76, 83, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'kenny'/camellia japonica 'kenny' (2).jpg",
          width: 512,
          id: 'd6b5f53f90a04f55a794fa316648b565',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(41, 53, 29, 1.00)',
            'rgba(114, 75, 74, 1.00)',
            'rgba(107, 76, 72, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'kenny'/camellia japonica 'kenny' (1).jpg",
          width: 1024,
          id: '177aceaa123e0543ecf72d31b2481e5e',
          height: 683,
          thumbnail: true,
        },
        location: [47.269345, -1.583938],
        genre: 'Camellia',
        cultivar: 'Kenny',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583938, 47.269345] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3f674dc359e61a9650f39fbeecb809308ac1a9ca',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(69, 81, 67, 1.00)',
            'rgba(95, 96, 79, 1.00)',
            'rgba(73, 88, 65, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'kingyo-tsubaki'/camellia japonica 'kingyo-tsubaki' (3).jpg",
          width: 1024,
          id: '5910e55aa0f6532cb5f183b0562a5832',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 151, 138, 1.00)',
            'rgba(81, 98, 73, 1.00)',
            'rgba(104, 99, 82, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'kingyo-tsubaki'/camellia japonica 'kingyo-tsubaki' (2).jpg",
          width: 1024,
          id: '9a20723ac63181d0b8e84596208e4a58',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 125, 109, 1.00)',
            'rgba(108, 82, 64, 1.00)',
            'rgba(83, 82, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'kingyo-tsubaki'/camellia japonica 'kingyo-tsubaki' (1).jpg",
          width: 1024,
          id: '906d19473b439cbf8b53aa732c1858a9',
          height: 683,
          thumbnail: true,
        },
        location: [47.26902, -1.585137],
        genre: 'Camellia',
        cultivar: 'Kingyo-tsubaki',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585137, 47.26902] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'eb9b924d86747352cdc970c11f5f56303b3a7775',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 156, 150, 1.00)',
            'rgba(104, 97, 88, 1.00)',
            'rgba(105, 99, 90, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'kossuth'/camellia japonica 'kossuth'.jpg",
          width: 1024,
          id: 'b10f05fcc79bec9679e3bdb25aadcbef',
          height: 683,
          thumbnail: true,
        },
        location: [47.269578, -1.585137],
        genre: 'Camellia',
        cultivar: 'Kossuth',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585137, 47.269578] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a600dddcdaac8540b37275713e8c00fba6e1b7c9',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 137, 113, 1.00)',
            'rgba(112, 136, 106, 1.00)',
            'rgba(109, 123, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'lemon drop'/camellia japonica 'lemon drop' (1).jpg",
          width: 576,
          id: '24a345ba2f8dbac8974f0bce69c83272',
          height: 768,
          thumbnail: true,
        },
        location: [47.271553, -1.58202],
        genre: 'Camellia',
        cultivar: 'Lemon Drop',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58202, 47.271553] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bf0cbcb826fada53c7cf448426540b29e733aa0f',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 121, 108, 1.00)',
            'rgba(103, 119, 100, 1.00)',
            'rgba(92, 107, 85, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'merry christmas'/camellia japonica 'merry christmas' (3).jpg",
          width: 1024,
          id: '0303ba87a452e5bd22b7d9b7104d3a36',
          height: 683,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 76, 65, 1.00)',
            'rgba(97, 55, 44, 1.00)',
            'rgba(79, 54, 46, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'merry christmas'/camellia japonica 'merry christmas' (2).jpg",
          width: 1024,
          id: 'a396f300f0745489ee1448e956fa091d',
          height: 677,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 132, 115, 1.00)',
            'rgba(95, 108, 93, 1.00)',
            'rgba(103, 89, 84, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'merry christmas'/camellia japonica 'merry christmas' (1).jpg",
          width: 1024,
          id: '6ec1dc3b13b7168d9f7202a52f536544',
          height: 723,
          thumbnail: true,
        },
        location: [47.270717, -1.585267],
        genre: 'Camellia',
        cultivar: 'Merry Christmas',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585267, 47.270717] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ade11bae5dc3b82471f0f7031cf7b67b329d2b47',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(58, 64, 62, 1.00)',
            'rgba(120, 126, 121, 1.00)',
            'rgba(62, 69, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'mont blanc'/camellia japonica 'mont blanc' .jpg",
          width: 1024,
          id: '0e2cb365ca7a34e4dc2be3bf27e75297',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 144, 132, 1.00)',
            'rgba(83, 100, 81, 1.00)',
            'rgba(93, 93, 78, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'mont blanc'/camellia japonica 'mont blanc' (1).jpg",
          width: 512,
          id: '8da3244ed6a782edff5c4a1c6863c23e',
          height: 768,
          thumbnail: true,
        },
        location: [47.27026, -1.586547],
        genre: 'Camellia',
        cultivar: 'Mont Blanc',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586547, 47.27026] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '38913771197a6f2a569f5a8ab4272da357e7395d',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 96, 55, 1.00)',
            'rgba(143, 106, 110, 1.00)',
            'rgba(84, 75, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'mrs lyman clarke'/camellia japonica 'mrs lyman clarke' (2).jpg",
          width: 576,
          id: '588e0599f631fab6c07631f0f3d3fe3c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 130, 77, 1.00)',
            'rgba(120, 150, 95, 1.00)',
            'rgba(125, 135, 91, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'mrs lyman clarke'/camellia japonica 'mrs lyman clarke' (1).jpg",
          width: 576,
          id: 'ab37af837c76ab0d26b04b8119a048b7',
          height: 768,
          thumbnail: true,
        },
        location: [47.268275, -1.584858],
        genre: 'Camellia',
        cultivar: 'Mrs Lyman Clarke',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584858, 47.268275] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '82f38bf5e8ee94bd5559fca1ce375c8316ad780e',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 78, 67, 1.00)',
            'rgba(107, 111, 107, 1.00)',
            'rgba(60, 67, 64, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'nobilissima'/camellia japonica 'nobilissima' (3).jpg",
          width: 576,
          id: '668def7617c214f86a908b532209711d',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 149, 145, 1.00)',
            'rgba(108, 117, 112, 1.00)',
            'rgba(79, 82, 75, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'nobilissima'/camellia japonica 'nobilissima' (2).jpg",
          width: 1024,
          id: '78c905bec9674e7031922a7f0703ef30',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(63, 60, 50, 1.00)',
            'rgba(110, 112, 105, 1.00)',
            'rgba(40, 39, 31, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'nobilissima'/camellia japonica 'nobilissima' (1).jpg",
          width: 576,
          id: '21f366a44c4ab81e69cf6d9c45ffc59f',
          height: 768,
          thumbnail: true,
        },
        location: [47.269172, -1.58502],
        genre: 'Camellia',
        cultivar: 'Nobilissima',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58502, 47.269172] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '585b052d4eecd48f418c7119bee3ec6940f6cdbd',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 145, 145, 1.00)',
            'rgba(141, 56, 62, 1.00)',
            'rgba(111, 66, 63, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'saint philibert'/camellia japonica 'saint philibert' (3).jpg",
          width: 1024,
          id: '168ec0c0f41225e20873247f5d82eb4a',
          height: 650,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 131, 116, 1.00)',
            'rgba(108, 125, 109, 1.00)',
            'rgba(95, 108, 92, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'saint philibert'/camellia japonica 'saint philibert' (2).jpg",
          width: 1024,
          id: '2a2475090c2572cef4fac1fb399f9662',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 99, 87, 1.00)',
            'rgba(132, 45, 46, 1.00)',
            'rgba(115, 64, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'saint philibert'/camellia japonica 'saint philibert' (1).jpg",
          width: 1024,
          id: 'a30327b6dbe785a895257e0d18aab71c',
          height: 768,
          thumbnail: true,
        },
        location: [47.270372, -1.584062],
        genre: 'Camellia',
        cultivar: 'Saint Philibert',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584062, 47.270372] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '07b37b2538fd544189760c6e203f98ba2f88bb3f',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 102, 89, 1.00)',
            'rgba(95, 92, 71, 1.00)',
            'rgba(96, 92, 74, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'temple incense'/camellia japonica 'temple incense' (5).jpg",
          width: 512,
          id: '4df351dcbe4b1f1c852c7212a8c8058a',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 106, 87, 1.00)',
            'rgba(101, 127, 101, 1.00)',
            'rgba(69, 91, 65, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'temple incense'/camellia japonica 'temple incense' (2).jpg",
          width: 1024,
          id: '7c233803f757c87b15d62f9b5acceea5',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(62, 39, 40, 1.00)',
            'rgba(135, 52, 64, 1.00)',
            'rgba(82, 44, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'temple incense'/camellia japonica 'temple incense' (1).jpg",
          width: 1024,
          id: 'd76aa3a3d3b2e190b93572f9ffc2fad0',
          height: 762,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Temple Incense',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e942dc906fd376af5bb7b11a80cb10abddca9a2e',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 82, 74, 1.00)',
            'rgba(117, 74, 89, 1.00)',
            'rgba(80, 59, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'tiffany'/camellia japonica 'tiffany' (2).jpg",
          width: 1024,
          id: 'cf4741b96ee78dd8c6d1ebeeba454bf7',
          height: 753,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 101, 124, 1.00)',
            'rgba(143, 97, 142, 1.00)',
            'rgba(78, 62, 87, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia japonica 'tiffany'/camellia japonica 'tiffany' (1).jpg",
          width: 1024,
          id: '125a5377fc004593f08248ab7a7728e1',
          height: 673,
          thumbnail: true,
        },
        location: [47.269908, -1.585993],
        genre: 'Camellia',
        cultivar: 'Tiffany',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585993, 47.269908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fd58476ed41c119ec62acd9c2438abd9b4352b02',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 128, 91, 1.00)',
            'rgba(179, 100, 126, 1.00)',
            'rgba(134, 122, 116, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'dazzler'/camellia sasanqua 'dazzler' (4).jpg",
          width: 576,
          id: '7dab15f592005eece71ea4aeae6e5d5f',
          height: 768,
          thumbnail: true,
        },
        espece: 'sasanqua',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 96, 83, 1.00)',
            'rgba(115, 83, 80, 1.00)',
            'rgba(80, 82, 65, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'dazzler'/camellia sasanqua 'dazzler' (3).jpg",
          width: 1024,
          id: 'a47fa5d16cfd9a50fc05b03d6df6c747',
          height: 710,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 137, 133, 1.00)',
            'rgba(118, 122, 106, 1.00)',
            'rgba(102, 90, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'dazzler'/camellia sasanqua 'dazzler' (1).jpg",
          width: 1024,
          id: 'cd57955ad0d10c9958cb7162cc50157f',
          height: 683,
          thumbnail: true,
        },
        location: [47.270395, -1.585303],
        genre: 'Camellia',
        cultivar: 'Dazzler',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585303, 47.270395] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5b94d4954cde1a075eb4968db29774105e6b6d7f',
      fields: {
        espece: 'sasanqua',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(32, 38, 27, 1.00)',
            'rgba(98, 46, 55, 1.00)',
            'rgba(81, 53, 52, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'dazzler'/camellia sasanqua 'dazzler' (2).jpg",
          width: 1024,
          id: 'a8904e6fdd865f707f41a84b6f87f7cb',
          height: 683,
          thumbnail: true,
        },
        location: [47.270388, -1.585303],
        genre: 'Camellia',
        cultivar: 'Dazzler',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585303, 47.270388] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6edd2a3cdc93d7a1b750fc8261c0c9f7b4b2a73e',
      fields: {
        espece: 'sasanqua',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 69, 56, 1.00)',
            'rgba(104, 98, 82, 1.00)',
            'rgba(81, 84, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia sasanqua 'rainbow'/camellia sasanqua 'rainbow'  (2).jpg",
          width: 1024,
          id: '341845a0bb940af161d0b6f792477fba',
          height: 683,
          thumbnail: true,
        },
        location: [47.268187, -1.584492],
        genre: 'Camellia',
        cultivar: 'Rainbow',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584492, 47.268187] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '91697608960dfbc29db9c4cceea58dfb7770e3cd',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 132, 123, 1.00)',
            'rgba(125, 125, 112, 1.00)',
            'rgba(103, 107, 98, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'elegant beauty'/camellia x williamsii 'elegant beauty' (4).jpg",
          width: 1024,
          id: '1580caa4634cf4f850d04a03df22347e',
          height: 683,
          thumbnail: true,
        },
        espece: 'x williamsii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 123, 112, 1.00)',
            'rgba(137, 110, 121, 1.00)',
            'rgba(87, 79, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'elegant beauty'/camellia x williamsii 'elegant beauty' (3).jpg",
          width: 1024,
          id: '7a927d94e58054819007edbdbf36ba0e',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 145, 132, 1.00)',
            'rgba(110, 119, 100, 1.00)',
            'rgba(91, 91, 82, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'elegant beauty'/camellia x williamsii 'elegant beauty' (2).jpg",
          width: 512,
          id: '73118f4507121b0c848e0f797adf5e8a',
          height: 768,
          thumbnail: true,
        },
        location: [47.27026, -1.586547],
        genre: 'Camellia',
        cultivar: 'Elegant Beauty',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586547, 47.27026] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '17f51084f84186f3bf2fc4c8b58075037f145bf9',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(65, 63, 53, 1.00)',
            'rgba(133, 111, 115, 1.00)',
            'rgba(85, 87, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'flirtation'/camellia x williamsii 'flirtation' (3).jpg",
          width: 1024,
          id: '935afef184ce39b8c314ee34dff162cf',
          height: 629,
          thumbnail: true,
        },
        espece: 'x williamsii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(64, 75, 44, 1.00)',
            'rgba(125, 124, 111, 1.00)',
            'rgba(70, 73, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'flirtation'/camellia x williamsii 'flirtation' (2).jpg",
          width: 1016,
          id: '0fbfa70d1b9c16f28d31d2d9e1eb5a25',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 103, 68, 1.00)',
            'rgba(105, 118, 94, 1.00)',
            'rgba(93, 105, 83, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'flirtation'/camellia x williamsii 'flirtation' (1).jpg",
          width: 1024,
          id: '16c7a954f63b01699be5035f2e4ff652',
          height: 683,
          thumbnail: true,
        },
        location: [47.270503, -1.585613],
        genre: 'Camellia',
        cultivar: 'Flirtation',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585613, 47.270503] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b0791e82e956a5f63ec4a1b9ad527c7837e03633',
      fields: {
        espece: 'x williamsii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 70, 47, 1.00)',
            'rgba(119, 67, 67, 1.00)',
            'rgba(85, 61, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'joe nuccio'/camellia x williamsii 'joe nuccio'.jpg",
          width: 1024,
          id: 'b15596c848efbd0b4ced5f8f41e5b09c',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 123, 104, 1.00)',
            'rgba(98, 106, 77, 1.00)',
            'rgba(77, 83, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'joe nuccio'/camellia x williamsii 'joe nuccio' (2).jpg",
          width: 512,
          id: '866f822e2ab83438aef4fca98844be50',
          height: 768,
          thumbnail: true,
        },
        location: [47.27026, -1.586547],
        genre: 'Camellia',
        cultivar: 'Joe Nuccio',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586547, 47.27026] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a0536815d0a7f7a9c0e5642552a441c21578b013',
      fields: {
        espece: 'x williamsii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 111, 87, 1.00)',
            'rgba(106, 142, 105, 1.00)',
            'rgba(76, 109, 77, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'mary christian'/camellia x williamsii 'mary christian' (2).jpg",
          width: 607,
          id: 'd99d34d571610571a084c66a2179552c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 99, 69, 1.00)',
            'rgba(132, 90, 97, 1.00)',
            'rgba(67, 72, 48, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'mary christian'/camellia x williamsii 'mary christian' (1).jpg",
          width: 1024,
          id: '9203c358121fe0b7233ec28344587b76',
          height: 713,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Camellia',
        cultivar: 'Mary Christian',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2f163fdd59c50d3f9954bc0092ab8577c91364fb',
      fields: {
        espece: 'x williamsii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 143, 123, 1.00)',
            'rgba(102, 125, 87, 1.00)',
            'rgba(85, 99, 74, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'mary christian'/camellia x williamsii 'mary christian' .jpg",
          width: 1024,
          id: 'ccb5276e41bb807a1c43cbafadda68ae',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 113, 87, 1.00)',
            'rgba(108, 94, 75, 1.00)',
            'rgba(71, 79, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/camellia [theaceae]/camellia x williamsii 'mary christian'/camellia x williamsii 'mary christian' (3).jpg",
          width: 1024,
          id: '19458f69fce1f4aebbce8bb63922562d',
          height: 683,
          thumbnail: true,
        },
        location: [47.270662, -1.584017],
        genre: 'Camellia',
        cultivar: 'Mary Christian',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584017, 47.270662] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b970a25aa8f3055a9ae4a4a07e3b79989164a0a2',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'pseudocamellia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 148, 233, 1.00)',
            'rgba(137, 158, 170, 1.00)',
            'rgba(96, 99, 47, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stewartia [theaceae]/stewartia pseudocamellia/stewartia pseudocamellia  (3).jpg',
          width: 576,
          id: '228abc583322f2f26487da1bb951893f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 143, 94, 1.00)',
            'rgba(117, 130, 57, 1.00)',
            'rgba(124, 134, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stewartia [theaceae]/stewartia pseudocamellia/stewartia pseudocamellia (1).jpg',
          width: 576,
          id: '82e81d108e975d5b9da4fb9669c78d2b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 97, 80, 1.00)',
            'rgba(119, 99, 85, 1.00)',
            'rgba(92, 66, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stewartia [theaceae]/stewartia pseudocamellia/stewartia pseudocamellia  (2).jpg',
          width: 576,
          id: '5316e5da57d393ed87672908a1ea1ae3',
          height: 768,
          thumbnail: true,
        },
        location: [47.271525, -1.5815],
        genre: 'Stewartia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5815, 47.271525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ada6f82dd69126f1d52a1c4f0ff5b8ff1121ea46',
      fields: {
        origine: 'JB.Fast Lansing (U.S.A.)',
        espece: 'cylindrica Sw.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Boehemeria',
        date_plantation: '1987',
        famille: 'Urticaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '81f79ea71e140895283bbfb6bf94d5eedfc3b749',
      fields: {
        origine: 'J.B.Hermmanshof-Wheinheim,Allemagne',
        espece: 'himalaicus W.H.Baker',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Eremurus',
        date_plantation: '2011',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c5fcc26812bad0c331a09cdfe99b71806cd405a8',
      fields: {
        origine: 'JB.Pruhonice (Rep.Tch\u00e8que)',
        espece: 'uvaria Oken',
        localisation: 'G2A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2197208, -1.5414609],
        genre: 'Kniphofia',
        date_plantation: '2009',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5414609, 47.2197208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '213024b90a9fed6d5824042f582fc4be52a45f93',
      fields: {
        origine: 'Mr.Boff B.',
        espece: 'pumila Kunth',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Kniphofia',
        date_plantation: '1998',
        famille: 'Asphodelaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '95eb207f1f19bf1635d9009c7ef8fdcd8dd08ef6',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes 71290 La Gen\u00eate',
        espece: 'sp',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Hedychium',
        date_plantation: '2015',
        famille: 'Zingiberaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8383830d8fd4f4be8714c5c4440ca3547d3c8b43',
      fields: {
        espece: 'henryi',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 169, 175, 1.00)',
            'rgba(95, 88, 69, 1.00)',
            'rgba(92, 95, 73, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/acer/acer henryi/acer henryi (3).jpg',
          width: 576,
          id: '54d9dd046a1a21af314b2631b46ed686',
          height: 768,
          thumbnail: true,
        },
        location: [47.220697, -1.543163],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543163, 47.220697] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4b265ca03904577aff6459dcfe531da184bd4fe4',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(201, 172, 164, 1.00)',
            'rgba(118, 88, 61, 1.00)',
            'rgba(65, 64, 36, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer palmatum 'atropurpureum'/acer palmatum 'atropurpureum' (3).jpg",
          width: 576,
          id: '7992bdbeee9737f75bce7031503125a4',
          height: 768,
          thumbnail: true,
        },
        espece: 'palmatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 116, 78, 1.00)',
            'rgba(161, 141, 106, 1.00)',
            'rgba(128, 145, 81, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer palmatum 'atropurpureum'/acer palmatum 'atropurpureum' (2).jpg",
          width: 576,
          id: '5542f7e64307fdb9bb82b2eb2320e5f6',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 142, 111, 1.00)',
            'rgba(150, 131, 93, 1.00)',
            'rgba(148, 131, 95, 1.00)',
          ],
          filename:
            "ip parc de proce/acer/acer palmatum 'atropurpureum'/acer palmatum 'atropurpureum' (1).jpg",
          width: 576,
          id: 'c1f872beb5833f923a1d31a9ea90b143',
          height: 768,
          thumbnail: true,
        },
        location: [47.222745, -1.580447],
        genre: 'Acer',
        cultivar: 'Atropurpureum',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580447, 47.222745] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4d584e3ebc5b112cf047311da8d35d504bd161dd',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 142, 56, 1.00)',
            'rgba(115, 137, 77, 1.00)',
            'rgba(120, 131, 99, 1.00)',
          ],
          filename:
            "ip parc de proce/aesculus/aesculus hippocastanum 'baumannii'/aesculus hippocastanum 'baumannii' (3).jpg",
          width: 576,
          id: '840eb6c87c5fb58a0e0cb59ea7f3b6c9',
          height: 768,
          thumbnail: true,
        },
        espece: 'hippocastanum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 104, 66, 1.00)',
            'rgba(102, 119, 77, 1.00)',
            'rgba(156, 151, 139, 1.00)',
          ],
          filename:
            "ip parc de proce/aesculus/aesculus hippocastanum 'baumannii'/aesculus hippocastanum 'baumannii' (2).jpg",
          width: 576,
          id: 'bf4f96eaff4cbf36063759d1106b8f1f',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(195, 200, 181, 1.00)',
            'rgba(89, 102, 72, 1.00)',
            'rgba(81, 95, 55, 1.00)',
          ],
          filename:
            "ip parc de proce/aesculus/aesculus hippocastanum 'baumannii'/aesculus hippocastanum 'baumannii' (1).jpg",
          width: 576,
          id: 'a64f67c50833baf8a3d203962f71e833',
          height: 768,
          thumbnail: true,
        },
        location: [47.2228, -1.584367],
        genre: 'Aesculus',
        cultivar: 'Baumannii',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584367, 47.2228] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '609cdb25ecdef8eeb4e6397ab6e1f92d1cedcb4f',
      fields: {
        espece: 'hippocastanum',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(205, 222, 216, 1.00)',
            'rgba(106, 128, 84, 1.00)',
            'rgba(80, 94, 52, 1.00)',
          ],
          filename:
            'ip parc de proce/aesculus/aesculus hippocastanum/aesculus hippocastanum (2).jpg',
          width: 576,
          id: 'ae409296a4e1160d2c551aeeb1e5c48f',
          height: 768,
          thumbnail: true,
        },
        location: [47.225967, -1.582953],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582953, 47.225967] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7f5010e0f14980dfc53ead3fa411a91cb9839b45',
      fields: {
        espece: 'ligustrina',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 124, 71, 1.00)',
            'rgba(118, 139, 72, 1.00)',
            'rgba(88, 106, 38, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/ageratina/ageratina ligustrina/ageratina ligustrina (2).jpg',
          width: 576,
          id: '270c95772c0e13dddb8d8c8cd867e364',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 163, 137, 1.00)',
            'rgba(105, 116, 82, 1.00)',
            'rgba(92, 99, 72, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/ageratina/ageratina ligustrina/ageratina ligustrina (1).jpg',
          width: 576,
          id: '95d9932cc3dbfc5111711e487e2561aa',
          height: 768,
          thumbnail: true,
        },
        location: [47.262678, -1.53103],
        genre: 'Ageratina',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53103, 47.262678] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '885a78dcfa64160b4b95728e34dcb5cfc5ba54f6',
      fields: {
        espece: 'x prunifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 119, 88, 1.00)',
            'rgba(124, 115, 83, 1.00)',
            'rgba(109, 115, 64, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/aronia/aronia x prunifolia 'viking'/aronia x prunifolia 'viking' (2).jpg",
          width: 576,
          id: 'f69b704607ab78caf0c20b3459f3dad7',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 129, 107, 1.00)',
            'rgba(90, 117, 66, 1.00)',
            'rgba(110, 116, 89, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/aronia/aronia x prunifolia 'viking'/aronia x prunifolia 'viking' (1).jpg",
          width: 1024,
          id: '81a1cb0d590995a3cd3f22d2c6f01ad0',
          height: 768,
          thumbnail: true,
        },
        location: [47.227847, -1.508828],
        genre: 'Aronia',
        cultivar: 'Viking',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508828, 47.227847] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7a061f80b1b96a47b7ebf94f8f3ede3839684103',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'petiolaris',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 109, 61, 1.00)',
            'rgba(105, 118, 50, 1.00)',
            'rgba(129, 128, 90, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/azara/azara petiolaris/azara petiolaris (9).jpg',
          width: 850,
          id: '44db53516e1887d94ef441f386b953df',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 148, 113, 1.00)',
            'rgba(108, 144, 95, 1.00)',
            'rgba(120, 138, 103, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/azara/azara petiolaris/azara petiolaris.jpg',
          width: 576,
          id: 'e4e74ebf66883d4fddcadc0632c8adf3',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 110, 46, 1.00)',
            'rgba(140, 134, 23, 1.00)',
            'rgba(126, 117, 20, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/azara/azara petiolaris/azara petiolaris (6).jpg',
          width: 576,
          id: '6e9baf4a89f386d8b717d45396d4812a',
          height: 768,
          thumbnail: true,
        },
        location: [47.218517, -1.54238],
        genre: 'Azara',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54238, 47.218517] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4dd8a9aa50d671c2e16061be7ff7b0e610ee3e61',
      fields: {
        espece: 'sapida',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 140, 62, 1.00)',
            'rgba(104, 130, 54, 1.00)',
            'rgba(44, 71, 18, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/blighia/blighia sapida/blighia sapida.jpg",
          width: 1024,
          id: 'd25081a934140a2374bda632727c650f',
          height: 683,
          thumbnail: true,
        },
        location: [47.227092, -1.512038],
        genre: 'Blighia',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512038, 47.227092] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2941cf047c37ef5b4fab1b16f5d647194d56a4fb',
      fields: {
        espece: 'japonica',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 89, 84, 1.00)',
            'rgba(131, 107, 115, 1.00)',
            'rgba(76, 69, 67, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'ballet dancer'/camellia japonica 'ballet dancer'.jpg",
          width: 1024,
          id: '7f35d123a8649add0ac9a5685be29cac',
          height: 667,
          thumbnail: true,
        },
        location: [47.220247, -1.541681],
        genre: 'Camellia',
        cultivar: 'Ballet Dancer',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541681, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ac5589450db63d219e4054666813def52d84f3ab',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 82, 86, 1.00)',
            'rgba(146, 96, 123, 1.00)',
            'rgba(90, 71, 77, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'mary j. wheeler'/camellia japonica 'mary j. wheeler' (2).jpg",
          width: 1024,
          id: '22e40419f98c820955042669babd7aca',
          height: 709,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 113, 89, 1.00)',
            'rgba(100, 106, 87, 1.00)',
            'rgba(80, 88, 72, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'mary j. wheeler'/camellia japonica 'mary j. wheeler' (1).jpg",
          width: 1024,
          id: '866ad500c9f6a88d9c51969651ffa4fc',
          height: 683,
          thumbnail: true,
        },
        location: [47.219225, -1.541025],
        genre: 'Camellia',
        cultivar: 'Mary J. Wheeler',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541025, 47.219225] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7032ca56b2281ef4a37337be8619d6d0d59c9c90',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 108, 110, 1.00)',
            'rgba(109, 104, 93, 1.00)',
            'rgba(84, 91, 77, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'wakanoura'/camellia japonica 'wakanoura' (2).jpg",
          width: 1024,
          id: '2d365f6b43916d80f673881d9175714d',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(45, 53, 45, 1.00)',
            'rgba(99, 71, 80, 1.00)',
            'rgba(71, 66, 61, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia japonica 'wakanoura'/camellia japonica 'wakanoura' (1).jpg",
          width: 1024,
          id: '299ccb106aa86c8b3f5d4522fe3b694d',
          height: 683,
          thumbnail: true,
        },
        location: [47.220247, -1.54168],
        genre: 'Camellia',
        cultivar: 'Wakanoura',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54168, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0831476ea97dbb444ab5561fae89144f3c5b3e21',
      fields: {
        espece: 'rosiflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 100, 79, 1.00)',
            'rgba(98, 114, 103, 1.00)',
            'rgba(78, 95, 78, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia rosiflora 'rosaeflora cascade'/camellia rosiflora 'rosaeflora cascade' (2).jpg",
          width: 1024,
          id: 'c8d1838625cdf4551e96c1c29bd9c325',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 87, 65, 1.00)',
            'rgba(109, 110, 95, 1.00)',
            'rgba(56, 71, 58, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia rosiflora 'rosaeflora cascade'/camellia rosiflora 'rosaeflora cascade' (1).jpg",
          width: 1024,
          id: '36331072adeffc7a22db9af14b7b1e4b',
          height: 683,
          thumbnail: true,
        },
        location: [47.219225, -1.541025],
        genre: 'Camellia',
        cultivar: 'Rosaeflora Cascade',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541025, 47.219225] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7a5b249786f4c65f7330df7c34e3029bccf37614',
      fields: {
        espece: 'sasanqua',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 46, 57, 1.00)',
            'rgba(118, 48, 68, 1.00)',
            'rgba(80, 36, 48, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/camellia/camellia sasanqua 'crimson king'/camellia sasanqua 'crimson king'.jpg",
          width: 1024,
          id: 'b6a35cbee923a48f535bd2f6570d1e6d',
          height: 683,
          thumbnail: true,
        },
        location: [47.220247, -1.54168],
        genre: 'Camellia',
        cultivar: 'Crimson King',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54168, 47.220247] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '45a15bee0357bcb8614a9f93ce7205c1adc2e18c',
      fields: {
        espece: 'tsaii',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 132, 120, 1.00)',
            'rgba(82, 100, 77, 1.00)',
            'rgba(87, 87, 72, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/camellia/camellia tsaii/camellia tsaii.jpg',
          width: 906,
          id: 'a27fe0f4eb0f89c77597e7954525038a',
          height: 768,
          thumbnail: true,
        },
        location: [47.220483, -1.544337],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544337, 47.220483] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '428d79d0d92533b3aba82fda89c0ef6f99fbb016',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'fraterna',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 105, 94, 1.00)',
            'rgba(109, 113, 108, 1.00)',
            'rgba(75, 80, 75, 1.00)',
          ],
          filename:
            'ip parc de proce/camellia/camellia fraterna/camellia fraterna (3).jpg',
          width: 1024,
          id: 'd6179bae29974d45e58b5cd6cb1bb8a2',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 153, 130, 1.00)',
            'rgba(122, 129, 96, 1.00)',
            'rgba(102, 106, 74, 1.00)',
          ],
          filename:
            'ip parc de proce/camellia/camellia fraterna/camellia fraterna (5).jpg',
          width: 1024,
          id: 'f50dbcc4aca6e93b6ee1476b643dd016',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 107, 78, 1.00)',
            'rgba(132, 137, 118, 1.00)',
            'rgba(94, 105, 101, 1.00)',
          ],
          filename:
            'ip parc de proce/camellia/camellia fraterna/camellia fraterna (2).jpg',
          width: 576,
          id: '59fbcda41d7fbfa1818a7a7abc3b4fcb',
          height: 768,
          thumbnail: true,
        },
        location: [47.224528, -1.583788],
        genre: 'Camellia',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583788, 47.224528] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd3566d450791700d7548559513c0507b16d73390',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 145, 138, 1.00)',
            'rgba(80, 98, 77, 1.00)',
            'rgba(117, 123, 102, 1.00)',
          ],
          filename:
            "ip parc de proce/camellia/camellia japonica 'rubescens major'/camellia japonica 'rubescens major' (3).jpg",
          width: 576,
          id: '6a8d97b0e2f6d97220eab53572a849f2',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 79, 62, 1.00)',
            'rgba(162, 92, 112, 1.00)',
            'rgba(86, 71, 69, 1.00)',
          ],
          filename:
            "ip parc de proce/camellia/camellia japonica 'rubescens major'/camellia japonica 'rubescens major' (2).jpg",
          width: 576,
          id: '8f8a4c826e5a2bd100a0293d626aa88b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 114, 56, 1.00)',
            'rgba(115, 137, 100, 1.00)',
            'rgba(93, 115, 74, 1.00)',
          ],
          filename:
            "ip parc de proce/camellia/camellia japonica 'rubescens major'/camellia japonica 'rubescens major' (1).jpg",
          width: 576,
          id: '15d45096d02e9fa0b5708a1fd3624e8c',
          height: 768,
          thumbnail: true,
        },
        location: [47.222705, -1.579733],
        genre: 'Camellia',
        cultivar: 'Rubescens Major',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.579733, 47.222705] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '41955d6e1244545eda0091a039849ef0ae41aa3e',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(52, 57, 51, 1.00)',
            'rgba(129, 117, 99, 1.00)',
            'rgba(62, 59, 47, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/camellia/camellia japonica 'furo-an'/camellia japonica 'furo-an' (2).jpg",
          width: 576,
          id: '24a80debd9fcad93033c3c736ef6fdf9',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 114, 93, 1.00)',
            'rgba(105, 125, 112, 1.00)',
            'rgba(124, 132, 111, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/camellia/camellia japonica 'furo-an'/camellia japonica 'furo-an' (1).jpg",
          width: 576,
          id: '6dbe20efb2adb12209b0b08a599b424a',
          height: 768,
          thumbnail: true,
        },
        location: [47.227367, -1.508417],
        genre: 'Camellia',
        cultivar: 'Fur\u00f4-an',
        famille: 'Theaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508417, 47.227367] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a2060727612ce0c6195563dfb65d16fb6b52b191',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'ovata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 106, 21, 1.00)',
            'rgba(164, 120, 20, 1.00)',
            'rgba(152, 99, 10, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/carya/carya ovata/carya ovata  (2).jpg',
          width: 633,
          id: '187c7364a68dd188417cef468c4ca801',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 161, 87, 1.00)',
            'rgba(109, 157, 53, 1.00)',
            'rgba(108, 155, 37, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/carya/carya ovata/carya ovata (1).jpg',
          width: 576,
          id: '3646e4d5a3bbd410f87921ca799d66b9',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 100, 10, 1.00)',
            'rgba(182, 122, 14, 1.00)',
            'rgba(159, 97, 11, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/carya/carya ovata/carya ovata  (1).jpg',
          width: 576,
          id: '73012175c7fabb58b18abb3217675c5a',
          height: 768,
          thumbnail: true,
        },
        location: [47.2191, -1.541292],
        genre: 'Carya',
        famille: 'Juglandaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541292, 47.2191] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a589cba1770d09e1b51c9aba486851198be55168',
      fields: {
        espece: 'sinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 142, 66, 1.00)',
            'rgba(124, 135, 62, 1.00)',
            'rgba(113, 127, 50, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/celtis/celtis sinensis/celtis sinensis (2).jpg',
          width: 576,
          id: '80d2e27c3fa69be860d3c72f7a5218fe',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 137, 88, 1.00)',
            'rgba(126, 151, 57, 1.00)',
            'rgba(82, 125, 16, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/celtis/celtis sinensis/celtis sinensis (1).jpg',
          width: 576,
          id: 'b3d58cdb42cd5cabeee3406924d132b5',
          height: 768,
          thumbnail: true,
        },
        location: [47.220358, -1.544825],
        genre: 'Celtis',
        famille: 'Cannabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544825, 47.220358] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'baf86bc0a13c28588034a4ed007e664634b99a12',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'praecox',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 137, 145, 1.00)',
            'rgba(124, 119, 113, 1.00)',
            'rgba(81, 81, 75, 1.00)',
          ],
          filename:
            'ip parc de proce/chimonanthus/chimonanthus praecox/chimonanthus praecox (2).jpg',
          width: 576,
          id: '2b037e99082526aac8eef2d4a693dabc',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(233, 232, 235, 1.00)',
            'rgba(129, 126, 101, 1.00)',
            'rgba(74, 74, 44, 1.00)',
          ],
          filename:
            'ip parc de proce/chimonanthus/chimonanthus praecox/chimonanthus praecox.jpg',
          width: 576,
          id: 'e338dd7e435e272230a46a83ee654470',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(226, 224, 230, 1.00)',
            'rgba(126, 121, 113, 1.00)',
            'rgba(67, 67, 57, 1.00)',
          ],
          filename:
            'ip parc de proce/chimonanthus/chimonanthus praecox/chimonanthus praecox (1).jpg',
          width: 576,
          id: '5bb1920195259c8efd759ff9d3c55c32',
          height: 768,
          thumbnail: true,
        },
        location: [47.221812, -1.57867],
        genre: 'Chimonanthus',
        famille: 'Calycanthaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.57867, 47.221812] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd9d592338500f3324ae30a9ffcbf51a2a013cfec',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'trifoliata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 140, 177, 1.00)',
            'rgba(90, 96, 87, 1.00)',
            'rgba(95, 112, 62, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/citrus/citrus trifoliata/citrus trifoliata  (2).jpg',
          width: 1024,
          id: 'e4e216e0b8718161f331bd00100925d4',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 202, 202, 1.00)',
            'rgba(85, 90, 55, 1.00)',
            'rgba(69, 92, 48, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/citrus/citrus trifoliata/citrus trifoliata (1).jpg',
          width: 908,
          id: '9c2188c62cb40a170f67d767c58a2b76',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(62, 96, 151, 1.00)',
            'rgba(94, 114, 139, 1.00)',
            'rgba(81, 91, 94, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/citrus/citrus trifoliata/citrus trifoliata  (1).jpg',
          width: 512,
          id: 'aaddd03ceb5847e995c0800e77687577',
          height: 768,
          thumbnail: true,
        },
        location: [47.227003, -1.511488],
        genre: 'Citrus',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.511488, 47.227003] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9b15fd74d34f6e802fa5375e5290e5cde1dfa387',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 123, 107, 1.00)',
            'rgba(131, 111, 92, 1.00)',
            'rgba(134, 103, 89, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cleyera pentaphylacaceae/cleyera japonica/cleyera japonica (6).jpg',
          width: 1024,
          id: 'fa760c9a12a9c2ab671be37add298a2a',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 136, 120, 1.00)',
            'rgba(114, 107, 83, 1.00)',
            'rgba(120, 97, 81, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cleyera pentaphylacaceae/cleyera japonica/cleyera japonica (3).jpg',
          width: 1024,
          id: '2854df9cf40c4ff29b738c65c211fa48',
          height: 683,
          thumbnail: true,
        },
        location: [47.270356, -1.5848],
        genre: 'Cleyera',
        famille: 'Pentaphylacaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5848, 47.270356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ca78ecb8d3ed77a659f696f1e717d01e9deb605c',
      fields: {
        espece: 'alternifolia',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 136, 98, 1.00)',
            'rgba(112, 123, 91, 1.00)',
            'rgba(76, 91, 59, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/cornus/cornus alternifolia 'argentea'/cornus alternifolia 'argentea'.jpg",
          width: 1024,
          id: '79b22ee07ac64d8195820cb414066e7b',
          height: 768,
          thumbnail: true,
        },
        location: [47.218995, -1.541495],
        genre: 'Cornus',
        cultivar: 'Argentea',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541495, 47.218995] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3a45ac803d525a2c1b3352553626829de252c03d',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'kousa var. chinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 130, 104, 1.00)',
            'rgba(114, 105, 84, 1.00)',
            'rgba(80, 107, 73, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cornus/cornus kousa var. chinensis/cornus kousa var. chinensis (4).jpg',
          width: 668,
          id: '1aed9160f71b422951fcff96912ab780',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 92, 53, 1.00)',
            'rgba(122, 136, 111, 1.00)',
            'rgba(74, 88, 66, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cornus/cornus kousa var. chinensis/cornus kousa var. chinensis (6).jpg',
          width: 576,
          id: '182b3ee8b6c414f72d5cb317e82c0bce',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 88, 58, 1.00)',
            'rgba(136, 160, 121, 1.00)',
            'rgba(99, 122, 85, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/cornus/cornus kousa var. chinensis/cornus kousa var. chinensis (1).jpg',
          width: 576,
          id: '708663f853f7fcee8ddcc3412374ff1f',
          height: 768,
          thumbnail: true,
        },
        location: [47.218903, -1.541653],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541653, 47.218903] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e4d386c6e8ae2789479dafc53e91a2fbf4c03438',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 175, 124, 1.00)',
            'rgba(107, 129, 67, 1.00)',
            'rgba(82, 103, 56, 1.00)',
          ],
          filename:
            "ip parc de proce/cornus/cornus florida 'welchii'/cornus florida 'welchii'.jpg",
          width: 1024,
          id: '4695ada60e7833410df20dadd1ac274e',
          height: 768,
          thumbnail: true,
        },
        espece: 'florida',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 103, 72, 1.00)',
            'rgba(150, 149, 123, 1.00)',
            'rgba(131, 132, 99, 1.00)',
          ],
          filename:
            "ip parc de proce/cornus/cornus florida 'welchii'/cornus florida 'welchii' (3).jpg",
          width: 576,
          id: '7190d59c08f890e9d166e18189a5f56c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 132, 77, 1.00)',
            'rgba(124, 144, 96, 1.00)',
            'rgba(101, 122, 72, 1.00)',
          ],
          filename:
            "ip parc de proce/cornus/cornus florida 'welchii'/cornus florida 'welchii' (2).jpg",
          width: 576,
          id: '5634c2469ad865f614dc4708de14379c',
          height: 768,
          thumbnail: true,
        },
        location: [47.225525, -1.581558],
        genre: 'Cornus',
        cultivar: 'Welchii',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581558, 47.225525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6009d1befc9a46b7875a9bb3abf1d2e81f246b4b',
      fields: {
        espece: 'mas',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(158, 168, 142, 1.00)',
            'rgba(91, 100, 58, 1.00)',
            'rgba(59, 65, 41, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/cornus/cornus mas/cornus mas (2).jpg',
          width: 1024,
          id: '4f42d99c54c4adeb4a8020ad5664b0a3',
          height: 683,
          thumbnail: true,
        },
        location: [47.261717, -1.52995],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.52995, 47.261717] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0605d4a2969376cf3f61a961d199db1af37e56fc',
      fields: {
        espece: 'coggygria',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(180, 177, 171, 1.00)',
            'rgba(51, 52, 42, 1.00)',
            'rgba(43, 54, 26, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/cotinus/cotinus coggygria 'royal purple'/cotinus coggygria 'royal purple'.jpg",
          width: 784,
          id: '229d08049b06c777dddcc932a40f2cdb',
          height: 768,
          thumbnail: true,
        },
        location: [47.261142, -1.532372],
        genre: 'Cotinus',
        cultivar: 'Royal Purple',
        famille: 'Anacardiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532372, 47.261142] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6864be314ced3e9b3a5f79af37f710cab4189696',
      fields: {
        espece: 'involucrata',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 165, 140, 1.00)',
            'rgba(88, 98, 58, 1.00)',
            'rgba(41, 46, 20, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/davidia/davidia involucrata/davidia involucrata (2).jpg',
          width: 512,
          id: 'c2e1f567a8a805b9152cea8796fb05fa',
          height: 768,
          thumbnail: true,
        },
        location: [47.261478, -1.531183],
        genre: 'Davidia',
        famille: 'Nyssaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531183, 47.261478] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c8d73d41503383ffb18b822fe8a93724da2a26ae',
      fields: {
        espece: 'lotus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 158, 158, 1.00)',
            'rgba(117, 125, 72, 1.00)',
            'rgba(102, 106, 52, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/diospyros/diospyros lotus/diospyros lotus.jpg',
          width: 576,
          id: '42c6ef6f655c52f7e62cecc8a871b61a',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 128, 55, 1.00)',
            'rgba(104, 132, 60, 1.00)',
            'rgba(87, 108, 52, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/diospyros/diospyros lotus/diospyros lotus (3).jpg',
          width: 1024,
          id: '302ce8e9914fc490e62525de5cd3c637',
          height: 652,
          thumbnail: true,
        },
        location: [47.262888, -1.535033],
        genre: 'Diospyros',
        famille: 'Ebenaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535033, 47.262888] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ac707cff44e6f63292fd28650df06255d2738f63',
      fields: {
        espece: 'chrysantha',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 128, 161, 1.00)',
            'rgba(113, 99, 85, 1.00)',
            'rgba(71, 66, 59, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/edgeworthia/edgeworthia chrysantha 'red dragon'/edgeworthia chrysantha 'red dragon'.jpg",
          width: 892,
          id: 'aa9db4bdba8f5d952e11bfafb590648a',
          height: 768,
          thumbnail: true,
        },
        location: [47.228258, -1.507767],
        genre: 'Edgeworthia',
        cultivar: 'Red Dragon',
        famille: 'Thymelaeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507767, 47.228258] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd0b6c26681f2fc5ae3e92d898bcf815bb394e6e4',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'acuminata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 155, 70, 1.00)',
            'rgba(125, 129, 40, 1.00)',
            'rgba(120, 136, 59, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ehretia/ehretia acuminata/ehretia acuminata (2).jpg',
          width: 576,
          id: 'c9f07f95141936eadd38e0c2fadd4cb6',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 151, 141, 1.00)',
            'rgba(82, 97, 68, 1.00)',
            'rgba(94, 108, 61, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ehretia/ehretia acuminata/ehretia acuminata .jpg',
          width: 576,
          id: 'e997c87a780cdce7f9019c81f70cc57c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(197, 201, 186, 1.00)',
            'rgba(87, 101, 61, 1.00)',
            'rgba(73, 87, 39, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/ehretia/ehretia acuminata/ehretia acuminata (1).jpg',
          width: 576,
          id: 'e84066154087e914242e1609f107db5f',
          height: 768,
          thumbnail: true,
        },
        location: [47.21933, -1.543072],
        genre: 'Ehretia',
        famille: 'Boraginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543072, 47.21933] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a62e983da698deb43321d4121ed106cc9ec08998',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 118, 109, 1.00)',
            'rgba(81, 91, 83, 1.00)',
            'rgba(75, 82, 75, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/eriobotrya/eriobotrya japonica/eriobotrya japonica (2).jpg',
          width: 1024,
          id: 'a2897263ffaf4f3e8346236e6360e17f',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 115, 102, 1.00)',
            'rgba(92, 100, 84, 1.00)',
            'rgba(113, 125, 121, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/eriobotrya/eriobotrya japonica/eriobotrya japonica (3).jpg',
          width: 1024,
          id: 'b462a05c6b7f5f87648c3570333a36de',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 126, 114, 1.00)',
            'rgba(109, 116, 110, 1.00)',
            'rgba(102, 106, 106, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/eriobotrya/eriobotrya japonica/eriobotrya japonica (1).jpg',
          width: 1024,
          id: 'bf767217c8010d2ed48d34c59228d774',
          height: 683,
          thumbnail: true,
        },
        location: [47.221278, -1.543517],
        genre: 'Eriobotrya',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543517, 47.221278] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dd028473e9fa3b0f5c0b8f4a874ce4ec0b170d6c',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(180, 202, 227, 1.00)',
            'rgba(123, 140, 110, 1.00)',
            'rgba(67, 82, 29, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/eucryphia/eucryphia x nymansensis 'nymansay'/eucryphia x nymansensis 'nymansay' (2).jpg",
          width: 576,
          id: '066c5c49d7ac557f0493b17b92471399',
          height: 768,
          thumbnail: true,
        },
        espece: 'x nymansensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 115, 70, 1.00)',
            'rgba(88, 122, 72, 1.00)',
            'rgba(80, 126, 66, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/eucryphia/eucryphia x nymansensis 'nymansay'/eucryphia x nymansensis 'nymansay' (1).jpg",
          width: 576,
          id: '4097af8e67e03c962a08f38c89771e2c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 115, 76, 1.00)',
            'rgba(104, 118, 81, 1.00)',
            'rgba(75, 90, 52, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/eucryphia/eucryphia x nymansensis 'nymansay'/eucryphia x nymansensis 'nymansay'  (2).jpg",
          width: 576,
          id: 'e9fca9d0499a9b47926a7c4a18e5ad0d',
          height: 768,
          thumbnail: true,
        },
        location: [47.263375, -1.531613],
        genre: 'Eucryphia',
        cultivar: 'Nymansay',
        famille: 'Cunoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531613, 47.263375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0ea7f6854cfb4a0a3ee4b3895567da84b7a6849a',
      fields: {
        espece: 'sylvatica Atropurpurea Group',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 172, 194, 1.00)',
            'rgba(124, 117, 74, 1.00)',
            'rgba(91, 102, 51, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/fagus/fagus sylvatica atropurpurea group/fagus sylvatica atropurpurea group.jpg',
          width: 576,
          id: '2c97d44052edce909fb45bf0a9fe63c8',
          height: 768,
          thumbnail: true,
        },
        location: [47.218533, -1.542128],
        genre: 'Fagus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542128, 47.218533] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '33fb8976b5a5b783971c1982770db4b64b290fa2',
      fields: {
        espece: 'sylvatica Atropurpurea Group',
        nom_du_site: 'Parc de la Gaudini\u00e8re',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(169, 145, 137, 1.00)',
            'rgba(136, 113, 99, 1.00)',
            'rgba(96, 87, 45, 1.00)',
          ],
          filename:
            'ip parc de la gaudiniere/fagus/fagus sylvatica atropurpurea group/fagus sylvatica atropurpurea group.jpg',
          width: 576,
          id: '57961f8d54f85d434dacf1aa0a0f8a71',
          height: 768,
          thumbnail: true,
        },
        location: [47.24657, -1.577483],
        genre: 'Fagus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.577483, 47.24657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c28f2a057f17bcae3498c0be35fd0171cb7314a3',
      fields: {
        espece: 'simplex',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 167, 200, 1.00)',
            'rgba(65, 74, 50, 1.00)',
            'rgba(96, 91, 63, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/firmiana/firmiana simplex/firmiana simplex (3).jpg',
          width: 1024,
          id: 'ac5cb283d43dd22b94ac789045b2d602',
          height: 747,
          thumbnail: true,
        },
        location: [47.230053, -1.509888],
        genre: 'Firmiana',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.509888, 47.230053] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '45aae1ffab80fcc9566a47030dfafaaecf9a90d5',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'major',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 175, 115, 1.00)',
            'rgba(134, 142, 85, 1.00)',
            'rgba(69, 78, 34, 1.00)',
          ],
          filename:
            'ip parc de proce/fothergilla/fothergilla major/fothergilla major (2).jpg',
          width: 576,
          id: '935c54d13e22c10e094a0f6d97998828',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(204, 207, 192, 1.00)',
            'rgba(94, 104, 54, 1.00)',
            'rgba(43, 45, 27, 1.00)',
          ],
          filename:
            'ip parc de proce/fothergilla/fothergilla major/fothergilla major (3).jpg',
          width: 576,
          id: '784d1fc5a65d9c113bbf7023b0fdd2c5',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 177, 155, 1.00)',
            'rgba(123, 134, 78, 1.00)',
            'rgba(101, 114, 55, 1.00)',
          ],
          filename:
            'ip parc de proce/fothergilla/fothergilla major/fothergilla major (1).jpg',
          width: 1024,
          id: '3aad328cc9aebeef9a2dcb48412a20ea',
          height: 690,
          thumbnail: true,
        },
        location: [47.225817, -1.583162],
        genre: 'Fothergilla',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583162, 47.225817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5534a4fd898a02fe7b73f7c6de8f9e4144e1aa16',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(176, 193, 196, 1.00)',
            'rgba(85, 83, 33, 1.00)',
            'rgba(63, 62, 29, 1.00)',
          ],
          filename:
            "ip parc de proce/fraxinus/fraxinus excelsior 'jaspidea'/fraxinus excelsior 'jaspidea' (8).jpg",
          width: 1024,
          id: '7337f7a6cd8c81ed9e840a5c4bc44d25',
          height: 683,
          thumbnail: true,
        },
        espece: 'excelsior',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 124, 131, 1.00)',
            'rgba(131, 126, 49, 1.00)',
            'rgba(101, 97, 14, 1.00)',
          ],
          filename:
            "ip parc de proce/fraxinus/fraxinus excelsior 'jaspidea'/fraxinus excelsior 'jaspidea' (7).jpg",
          width: 512,
          id: 'dfc5122ad05dd2887626264d3e23636d',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 169, 121, 1.00)',
            'rgba(102, 101, 30, 1.00)',
            'rgba(58, 56, 25, 1.00)',
          ],
          filename:
            "ip parc de proce/fraxinus/fraxinus excelsior 'jaspidea'/fraxinus excelsior 'jaspidea' (6).jpg",
          width: 1024,
          id: '23198496c2f3d2b83bc5eae9c9af7ac8',
          height: 683,
          thumbnail: true,
        },
        location: [47.223038, -1.582675],
        genre: 'Fraxinus',
        cultivar: 'Jaspidea',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582675, 47.223038] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fec7143817dfad5cb3e2a0f1639792a4acba8916',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'californicum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(50, 51, 30, 1.00)',
            'rgba(133, 113, 32, 1.00)',
            'rgba(116, 96, 22, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/fremontodendron/fremontodendron californicum/fremontodendron californicum (5).jpg',
          width: 1024,
          id: 'cce573a4baafc603e019395cc60c3e1e',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(176, 183, 180, 1.00)',
            'rgba(115, 103, 55, 1.00)',
            'rgba(88, 75, 32, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/fremontodendron/fremontodendron californicum/fremontodendron californicum (6).jpg',
          width: 1024,
          id: 'dfb2ad41d4a60b3a9a989629d6ad6b1d',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(178, 164, 130, 1.00)',
            'rgba(128, 121, 86, 1.00)',
            'rgba(90, 90, 50, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/fremontodendron/fremontodendron californicum/fremontodendron californicum (4).jpg',
          width: 1024,
          id: '019b3fa5df33ddccda376cbf2fe68eed',
          height: 683,
          thumbnail: true,
        },
        location: [47.22903, -1.511042],
        genre: 'Fremontodendron',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.511042, 47.22903] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dbbdf919fd323d9a5331ee327b2bb59d964be51b',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 128, 112, 1.00)',
            'rgba(135, 111, 58, 1.00)',
            'rgba(102, 80, 64, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/hamamelis/hamamelis 'brevipetala'/hamamelis 'brevipetala' (2).jpg",
          width: 576,
          id: '55ed8f2abd7f175818d1407e4ac8074e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(167, 161, 155, 1.00)',
            'rgba(128, 111, 101, 1.00)',
            'rgba(109, 85, 82, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/hamamelis/hamamelis 'brevipetala'/hamamelis 'brevipetala' (1).jpg",
          width: 576,
          id: '9ddae6b4fe37a1ddbfbbe094f9418c9a',
          height: 768,
          thumbnail: true,
        },
        location: [47.219105, -1.541112],
        genre: 'Hamamelis',
        cultivar: 'Brevipetala',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541112, 47.219105] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '19654c343ee2653743e6a1223a8b6d33f0bb745c',
      fields: {
        espece: 'virginiana',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 129, 93, 1.00)',
            'rgba(125, 118, 90, 1.00)',
            'rgba(108, 110, 95, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/hamamelis/hamamelis virginiana/hamamelis virginiana (1).jpg',
          width: 576,
          id: 'b0842e154487ea364b65320c8506a1de',
          height: 768,
          thumbnail: true,
        },
        location: [47.218922, -1.54122],
        genre: 'Hamamelis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54122, 47.218922] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '681596769b248f7ae1bd3910267eb92ebc544d61',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 161, 153, 1.00)',
            'rgba(131, 104, 59, 1.00)',
            'rgba(110, 82, 46, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/hamamelis/hamamelis 'brevipetala'/hamamelis 'brevipetala'.jpg",
          width: 576,
          id: 'b868e05313f7dc4dd86110657705ec09',
          height: 768,
          thumbnail: true,
        },
        location: [47.22817, -1.508403],
        genre: 'Hamamelis',
        cultivar: 'Brevipetala',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508403, 47.22817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '99cd36e4d72d55a04e6fd31e8c15391d14980520',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(174, 178, 180, 1.00)',
            'rgba(111, 107, 71, 1.00)',
            'rgba(102, 97, 65, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/hamamelis/hamamelis 'brevipetala'/hamamelis 'brevipetala' .jpg",
          width: 1024,
          id: 'a4767834984d583db4427a18d53a864e',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 105, 85, 1.00)',
            'rgba(117, 116, 71, 1.00)',
            'rgba(129, 116, 80, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/hamamelis/hamamelis 'brevipetala'/hamamelis 'brevipetala' (1).jpg",
          width: 691,
          id: 'bb91dfec425ffb73328c217c0a9bb8de',
          height: 768,
          thumbnail: true,
        },
        location: [47.261583, -1.5344],
        genre: 'Hamamelis',
        cultivar: 'Brevipetala',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5344, 47.261583] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '522934b3c06e194d85f396d30e82ea4387ab63ff',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 86, 51, 1.00)',
            'rgba(115, 119, 44, 1.00)',
            'rgba(105, 120, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis mollis/hamamelis mollis (1).jpg',
          width: 1024,
          id: 'd6be2c63c8356808f07570609863efd8',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 108, 59, 1.00)',
            'rgba(99, 131, 63, 1.00)',
            'rgba(106, 141, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis mollis/hamamelis mollis (2).jpg',
          width: 1024,
          id: 'b62f5e31a599c484e03d1c3df06fb56c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 110, 102, 1.00)',
            'rgba(131, 125, 108, 1.00)',
            'rgba(116, 112, 104, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis mollis/hamamelis mollis  (1).jpg',
          width: 1024,
          id: '3b8f8a7ae737c5b6abb760cdffd182f2',
          height: 768,
          thumbnail: true,
        },
        location: [47.271475, -1.582788],
        genre: 'Hamamelis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582788, 47.271475] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1f8734c61274306c0e9b4a6cb2dff8ca02d73edb',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(182, 176, 161, 1.00)',
            'rgba(130, 110, 80, 1.00)',
            'rgba(88, 80, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis vernalis/hamamelis vernalis (2).jpg',
          width: 1024,
          id: '3312af54634b498e376b4aea639b37c1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 130, 121, 1.00)',
            'rgba(124, 108, 87, 1.00)',
            'rgba(121, 103, 86, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis vernalis/hamamelis vernalis (3).jpg',
          width: 1024,
          id: '84673f273d2524d7e58f12f592f1c6d4',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 146, 117, 1.00)',
            'rgba(154, 124, 95, 1.00)',
            'rgba(119, 103, 74, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis vernalis/hamamelis vernalis (1).jpg',
          width: 576,
          id: '1745d434352e7b17fcd5db54752ad272',
          height: 768,
          thumbnail: true,
        },
        location: [47.271455, -1.586692],
        genre: 'Hamamelis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586692, 47.271455] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '70d1ead92bece6645bf86aaf4414743be4c4d64c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 109, 96, 1.00)',
            'rgba(109, 114, 104, 1.00)',
            'rgba(104, 100, 100, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hamamelis hamamelidaceae/hamamelis x intermedia 'primavera'/hamamelis x intermedia 'primavera'.jpg",
          width: 1024,
          id: '6f1dc895b54fa9c0363551fae3441597',
          height: 683,
          thumbnail: true,
        },
        location: [47.2693, -1.585233],
        genre: 'Hamamelis',
        cultivar: 'Primavera',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585233, 47.2693] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '92056f629c994e220eb0712381935d07ccd6fd93',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'calycinum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 92, 68, 1.00)',
            'rgba(90, 128, 103, 1.00)',
            'rgba(88, 107, 86, 1.00)',
          ],
          filename:
            'ip parc de proce/hypericum/hypericum calycinum/hypericum calycinum (3).jpg',
          width: 576,
          id: '50de2a24cfbc1cd6b6669a9d59d85ebe',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 103, 37, 1.00)',
            'rgba(138, 134, 27, 1.00)',
            'rgba(80, 92, 28, 1.00)',
          ],
          filename:
            'ip parc de proce/hypericum/hypericum calycinum/hypericum calycinum.jpg',
          width: 576,
          id: '31635bff370db48cc8fdfd22078982a0',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 110, 51, 1.00)',
            'rgba(104, 127, 62, 1.00)',
            'rgba(107, 133, 75, 1.00)',
          ],
          filename:
            'ip parc de proce/hypericum/hypericum calycinum/hypericum calycinum (2).jpg',
          width: 1024,
          id: '311d6150698e1e8c3ef3e2f578536705',
          height: 768,
          thumbnail: true,
        },
        location: [47.22298, -1.57927],
        genre: 'Hypericum',
        famille: 'Hypericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.57927, 47.22298] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4eabe4087f32da8287cfc987cc6d40fef5a57ddb',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'anisatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 96, 71, 1.00)',
            'rgba(116, 133, 98, 1.00)',
            'rgba(81, 94, 67, 1.00)',
          ],
          filename:
            'ip parc de proce/illicium/illicium anisatum/illicium anisatum (2).jpg',
          width: 576,
          id: 'dedda8a08c35d892252cdb33bf889c24',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 148, 98, 1.00)',
            'rgba(136, 144, 86, 1.00)',
            'rgba(107, 132, 73, 1.00)',
          ],
          filename:
            'ip parc de proce/illicium/illicium anisatum/illicium anisatum (3).jpg',
          width: 576,
          id: '7287f0a1728acc8a10edd4deb290079e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 146, 107, 1.00)',
            'rgba(117, 140, 92, 1.00)',
            'rgba(100, 126, 90, 1.00)',
          ],
          filename:
            'ip parc de proce/illicium/illicium anisatum/illicium anisatum (1).jpg',
          width: 576,
          id: '80c48558291d2a0c50ae87a8973590cc',
          height: 768,
          thumbnail: true,
        },
        location: [47.225633, -1.581055],
        genre: 'Illicium',
        famille: 'Schisandraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581055, 47.225633] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a64c87d07d60bec3fa3f182d4f6c0854fc5ba3a0',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'hindsii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 166, 123, 1.00)',
            'rgba(85, 105, 41, 1.00)',
            'rgba(110, 132, 58, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/juglans/juglans hindsii/juglans hindsii (2).jpg',
          width: 576,
          id: '7e2d53d5ef79e4768d22f71c5c232dc2',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 130, 74, 1.00)',
            'rgba(128, 156, 47, 1.00)',
            'rgba(105, 136, 29, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/juglans/juglans hindsii/juglans hindsii (3).jpg',
          width: 576,
          id: 'ce1ed99aeb1cdb55b586ceef2a43e322',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 148, 58, 1.00)',
            'rgba(107, 131, 45, 1.00)',
            'rgba(142, 167, 70, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/juglans/juglans hindsii/juglans hindsii (1).jpg',
          width: 576,
          id: 'bc7a8ac7088a4746ca0a03ed2ef13ca0',
          height: 768,
          thumbnail: true,
        },
        location: [47.219288, -1.541258],
        genre: 'Juglans',
        famille: 'Juglandaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541258, 47.219288] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '33f47b934c60d69bf8032157e794ad44f87910b1',
      fields: {
        espece: 'indica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 70, 51, 1.00)',
            'rgba(132, 64, 44, 1.00)',
            'rgba(88, 49, 24, 1.00)',
          ],
          filename:
            'ip parc de proce/lagerstroemia/lagerstroemia indica/lagerstroemia indica (2).jpg',
          width: 1024,
          id: '5e5d69ac8c51776bdb64793322562178',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 93, 110, 1.00)',
            'rgba(124, 51, 53, 1.00)',
            'rgba(148, 92, 98, 1.00)',
          ],
          filename:
            'ip parc de proce/lagerstroemia/lagerstroemia indica/lagerstroemia indica (1).jpg',
          width: 512,
          id: '0b45b877e8fe7149438b30080d3a1828',
          height: 768,
          thumbnail: true,
        },
        location: [47.222795, -1.58038],
        genre: 'Lagerstroemia',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58038, 47.222795] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '55d90123f9661598663115d38f590b664cc4fb0f',
      fields: {
        espece: 'indica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 157, 195, 1.00)',
            'rgba(114, 107, 82, 1.00)',
            'rgba(65, 63, 24, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/lagerstroemia/lagerstroemia indica/lagerstroemia indica (2).jpg',
          width: 1024,
          id: '868774f5aef6ae5bf8ddce4cafa3ceaa',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 143, 132, 1.00)',
            'rgba(103, 91, 46, 1.00)',
            'rgba(71, 66, 31, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/lagerstroemia/lagerstroemia indica/lagerstroemia indica (1).jpg',
          width: 1024,
          id: 'a619d5408db9e4c48869ef0a3f9d434d',
          height: 683,
          thumbnail: true,
        },
        location: [47.262258, -1.533547],
        genre: 'Lagerstroemia',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533547, 47.262258] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1f681b0fc4a94e57ecd3c58a52922fad77af2044',
      fields: {
        espece: 'tulipifera',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(168, 158, 130, 1.00)',
            'rgba(150, 120, 56, 1.00)',
            'rgba(104, 90, 38, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/liriodendron/liriodendron tulipifera/liriodendron tulipifera (1).jpg',
          width: 576,
          id: 'a14700ff617eaa6c646a19a855a42e35',
          height: 768,
          thumbnail: true,
        },
        location: [47.219105, -1.542475],
        genre: 'Liriodendron',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542475, 47.219105] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1d10cdeda7e698ca70f9c64e29e9b49d2f4d2143',
      fields: {
        espece: 'tulipifera',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 161, 144, 1.00)',
            'rgba(122, 102, 46, 1.00)',
            'rgba(69, 66, 36, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/liriodendron/liriodendron tulipifera/liriodendron tulipifera (2).jpg',
          width: 576,
          id: '19dab518f839eccafce49f7cd45d62ab',
          height: 768,
          thumbnail: true,
        },
        location: [47.218733, -1.542517],
        genre: 'Liriodendron',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542517, 47.218733] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e295464fa99c906b522c921788e632b899fc5f88',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 148, 56, 1.00)',
            'rgba(115, 146, 27, 1.00)',
            'rgba(112, 140, 30, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/lithocarpus/lithocarpus edulis 'variegata'/lithocarpus edulis 'variegata' (3).jpg",
          width: 576,
          id: '32891632db676057198f7eea8b11c42b',
          height: 768,
          thumbnail: true,
        },
        espece: 'edulis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 130, 54, 1.00)',
            'rgba(119, 133, 61, 1.00)',
            'rgba(108, 132, 41, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/lithocarpus/lithocarpus edulis 'variegata'/lithocarpus edulis 'variegata' (2).jpg",
          width: 576,
          id: '22478358ef8a0df298231100b7229062',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 128, 36, 1.00)',
            'rgba(121, 146, 39, 1.00)',
            'rgba(110, 144, 45, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/lithocarpus/lithocarpus edulis 'variegata'/lithocarpus edulis 'variegata' (1).jpg",
          width: 576,
          id: '1778feea9c3227c759a461efa9897617',
          height: 768,
          thumbnail: true,
        },
        location: [47.228245, -1.508488],
        genre: 'Lithocarpus',
        cultivar: 'Variegata',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508488, 47.228245] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e6a70c1d080e3e7fd10fe146dc2fd3d1c2dc031f',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 89, 72, 1.00)',
            'rgba(106, 137, 78, 1.00)',
            'rgba(77, 103, 57, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/litsea/litsea japonica/litsea japonica (2).jpg',
          width: 512,
          id: '5e8378bcc4245b87c5abc3d0699e0196',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 117, 90, 1.00)',
            'rgba(118, 117, 82, 1.00)',
            'rgba(80, 95, 63, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/litsea/litsea japonica/litsea japonica (1).jpg',
          width: 512,
          id: 'a104fba8ea3db7b02add8eef834c627c',
          height: 768,
          thumbnail: true,
        },
        location: [47.219542, -1.544163],
        genre: 'Litsea',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544163, 47.219542] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c849bcb516ca928769117dffa2fea6e901721e93',
      fields: {
        espece: 'chinense',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(178, 188, 150, 1.00)',
            'rgba(103, 117, 62, 1.00)',
            'rgba(71, 70, 46, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/loropetalum/loropetalum chinense/loropetalum chinense (2).jpg',
          width: 576,
          id: '56794c93426dffaf5c0f70b71f5e877a',
          height: 768,
          thumbnail: true,
        },
        location: [47.218842, -1.541266],
        genre: 'Loropetalum',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541266, 47.218842] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2a96b955743a8ece7e3c4c9746615648e0e0c141',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'chinense',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 138, 77, 1.00)',
            'rgba(122, 140, 80, 1.00)',
            'rgba(87, 100, 52, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/loropetalum/loropetalum chinense/loropetalum chinense .jpg',
          width: 1024,
          id: 'abbffbb6956a8663bdf4f23935de61e2',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 123, 79, 1.00)',
            'rgba(101, 117, 76, 1.00)',
            'rgba(85, 87, 69, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/loropetalum/loropetalum chinense/loropetalum chinense.jpg',
          width: 959,
          id: '5b2b13332a2923d91174702ffb29254d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 131, 89, 1.00)',
            'rgba(104, 133, 78, 1.00)',
            'rgba(77, 98, 55, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/loropetalum/loropetalum chinense/loropetalum chinense (3).jpg',
          width: 576,
          id: '9b3fcb8d3a1cc40a7d1d8a90a8347201',
          height: 768,
          thumbnail: true,
        },
        location: [47.218995, -1.541638],
        genre: 'Loropetalum',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541638, 47.218995] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e31f6c2332cfcb9cd73e9f896b7752a741a13b2e',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'tricuspidata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 113, 37, 1.00)',
            'rgba(127, 129, 57, 1.00)',
            'rgba(85, 104, 29, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/maclura/maclura tricuspidata/maclura tricuspidata  (2).jpg',
          width: 576,
          id: '2be66b7a4799c147fd1e9f42695ec0fc',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 164, 147, 1.00)',
            'rgba(91, 115, 63, 1.00)',
            'rgba(89, 98, 71, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/maclura/maclura tricuspidata/maclura tricuspidata  .jpg',
          width: 1024,
          id: '9ea4f10ed3095698126db6f9ed38a3de',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 148, 56, 1.00)',
            'rgba(85, 136, 40, 1.00)',
            'rgba(126, 164, 70, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/maclura/maclura tricuspidata/maclura tricuspidata  (1).jpg',
          width: 576,
          id: '1f5786490b410c7dcee0da96f98e52de',
          height: 768,
          thumbnail: true,
        },
        location: [47.218453, -1.542117],
        genre: 'Maclura',
        famille: 'Moraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542117, 47.218453] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b9efb789ed945530d04de945174bfe9c26219188',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'pomifera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(185, 205, 186, 1.00)',
            'rgba(114, 134, 78, 1.00)',
            'rgba(71, 94, 35, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/maclura/maclura pomifera/maclura pomifera (10).jpg',
          width: 1024,
          id: '48c8eafa89056b30deb37792d7106c36',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(195, 203, 200, 1.00)',
            'rgba(148, 143, 105, 1.00)',
            'rgba(86, 79, 43, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/maclura/maclura pomifera/maclura pomifera (11).jpg',
          width: 1024,
          id: '546a7c8167b7b4a14ca878ea39eed02a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(197, 190, 165, 1.00)',
            'rgba(134, 122, 62, 1.00)',
            'rgba(80, 72, 27, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/maclura/maclura pomifera/maclura pomifera (1).jpg',
          width: 1024,
          id: '57c02b439ff4b2c23edf53e9ad044ff2',
          height: 768,
          thumbnail: true,
        },
        location: [47.229933, -1.506692],
        genre: 'Maclura',
        famille: 'Moraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.506692, 47.229933] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '634bc0ad5e9d1466def6eabe355d48b4014a058a',
      fields: {
        espece: 'pomifera',
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 169, 180, 1.00)',
            'rgba(115, 127, 90, 1.00)',
            'rgba(73, 78, 44, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/maclura/maclura pomifera/maclura pomifera (21).jpg',
          width: 1024,
          id: '8e280ec0ca14055fcc55a374f27ef24e',
          height: 768,
          thumbnail: true,
        },
        location: [47.227913, -1.508887],
        genre: 'Maclura',
        famille: 'Moraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.508887, 47.227913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f6d1773cc46ce0bb146cce0e00842eea85e66894',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'grandiflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 103, 79, 1.00)',
            'rgba(95, 112, 88, 1.00)',
            'rgba(93, 108, 84, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia grandiflora/magnolia grandiflora (2).jpg',
          width: 982,
          id: '6185028decd08046f0d82babd7f65231',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 92, 71, 1.00)',
            'rgba(89, 100, 83, 1.00)',
            'rgba(85, 108, 89, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia grandiflora/magnolia grandiflora (3).jpg',
          width: 512,
          id: 'c1322cd2f2c555ee82ed3f4708409deb',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(182, 193, 161, 1.00)',
            'rgba(77, 97, 70, 1.00)',
            'rgba(52, 76, 58, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia grandiflora/magnolia grandiflora (1).jpg',
          width: 1024,
          id: 'a77943eb63f90126420663ce2b2b2731',
          height: 683,
          thumbnail: true,
        },
        location: [47.219983, -1.54457],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54457, 47.219983] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6675f152e21e6fe0dd982e7fcbae3e0b4e4fd7e1',
      fields: {
        espece: 'laevifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(189, 161, 125, 1.00)',
            'rgba(133, 133, 85, 1.00)',
            'rgba(112, 105, 69, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/magnolia/magnolia laevifolia 'summer snowflake'/magnolia laevifolia 'summer snowflake' (2).jpg",
          width: 576,
          id: 'cef19ea47c2c2688e59dec88dd2ac222',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 124, 96, 1.00)',
            'rgba(138, 131, 104, 1.00)',
            'rgba(60, 55, 41, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/magnolia/magnolia laevifolia 'summer snowflake'/magnolia laevifolia 'summer snowflake' (1).jpg",
          width: 576,
          id: '3083495a694ddd09a4d5cfd977df44e7',
          height: 768,
          thumbnail: true,
        },
        location: [47.21872, -1.542697],
        genre: 'Magnolia',
        cultivar: 'Summer Snowflake',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542697, 47.21872] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f1c619ba531d7ff58f36179872bad7a67602bb49',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'tripetala',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 157, 74, 1.00)',
            'rgba(99, 138, 50, 1.00)',
            'rgba(89, 122, 55, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia tripetala/magnolia tripetala  (2).jpg',
          width: 576,
          id: '16239def8558f8e96644474b02111568',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(40, 69, 6, 1.00)',
            'rgba(118, 132, 75, 1.00)',
            'rgba(119, 140, 90, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia tripetala/magnolia tripetala  (3).jpg',
          width: 576,
          id: '670c03a2be781787b9f7bb06494dc7a5',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(169, 190, 138, 1.00)',
            'rgba(95, 122, 64, 1.00)',
            'rgba(80, 94, 60, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/magnolia/magnolia tripetala/magnolia tripetala  (1).jpg',
          width: 576,
          id: '02ef27bcfba3ea0a24a43c476bcef5be',
          height: 768,
          thumbnail: true,
        },
        location: [47.219613, -1.544153],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544153, 47.219613] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ded616f836023fab660213d9f0eaf52651494f89',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 90, 72, 1.00)',
            'rgba(147, 121, 117, 1.00)',
            'rgba(126, 107, 91, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia 'judy'/magnolia 'judy' (2).jpg",
          width: 576,
          id: '5a59f8d8ce5c921ce27ae3f74c123a8b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 150, 184, 1.00)',
            'rgba(136, 130, 118, 1.00)',
            'rgba(134, 125, 91, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia 'judy'/magnolia 'judy' (1).jpg",
          width: 1024,
          id: '4b961221f96ed51d48ea44c52da059f0',
          height: 768,
          thumbnail: true,
        },
        location: [47.225683, -1.58168],
        genre: 'Magnolia',
        cultivar: 'Judy',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58168, 47.225683] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '56095f76afdd4f66c45c19ad90113d759eabfaee',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 114, 99, 1.00)',
            'rgba(114, 125, 99, 1.00)',
            'rgba(70, 85, 44, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia 'pickard's crystal'/magnolia 'pickard's crystal' (2).jpg",
          width: 576,
          id: '2e0ecd608ec77a24509668aff2a47af8',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(37, 44, 40, 1.00)',
            'rgba(118, 119, 114, 1.00)',
            'rgba(65, 63, 48, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia 'pickard's crystal'/magnolia 'pickard's crystal'.jpg",
          width: 576,
          id: '7d21bd419ba0f3343be62ee8755054e8',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 136, 127, 1.00)',
            'rgba(101, 111, 74, 1.00)',
            'rgba(73, 87, 48, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia 'pickard's crystal'/magnolia 'pickard's crystal' (1).jpg",
          width: 576,
          id: '4654bccdccc0347ce31e10a53fc2a168',
          height: 768,
          thumbnail: true,
        },
        location: [47.22342, -1.580313],
        genre: 'Magnolia',
        cultivar: "Pickard's Crystal",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580313, 47.22342] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fd388944e531b13cc885a4bfe1f01957c920b10e',
      fields: {
        espece: 'campbellii Alba Group',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 167, 171, 1.00)',
            'rgba(113, 112, 105, 1.00)',
            'rgba(51, 52, 35, 1.00)',
          ],
          filename:
            "ip parc de proce/magnolia/magnolia campbellii alba group 'ethel hillier'/magnolia campbellii alba group 'ethel hillier' (6).jpg",
          width: 1024,
          id: '4aa61075fcbad858f1c29e5ea675109d',
          height: 683,
          thumbnail: true,
        },
        location: [47.22253, -1.579775],
        genre: 'Magnolia',
        cultivar: 'Ethel Hillier',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.579775, 47.22253] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fb571c03f6184b1cb2fe8442ee7db07886986c87',
      fields: {
        espece: 'grandiflora',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(39, 43, 34, 1.00)',
            'rgba(104, 112, 94, 1.00)',
            'rgba(42, 54, 27, 1.00)',
          ],
          filename:
            'ip parc de proce/magnolia/magnolia grandiflora/magnolia grandiflora (2).jpg',
          width: 576,
          id: '65b969af10e389b74854449a17032af9',
          height: 768,
          thumbnail: true,
        },
        location: [47.223897, -1.581342],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581342, 47.223897] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '895ff693344eb48dde3b6ca5c94ed8068a9d3f60',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 171, 201, 1.00)',
            'rgba(125, 122, 100, 1.00)',
            'rgba(106, 111, 38, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'atlas'/magnolia 'atlas' (6).jpg",
          width: 666,
          id: 'fffdc681574b3f4655d580da4b12c11f',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 113, 157, 1.00)',
            'rgba(145, 133, 137, 1.00)',
            'rgba(85, 78, 42, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'atlas'/magnolia 'atlas' (1).jpg",
          width: 546,
          id: '6eafdf71830ef88387369a430b01339c',
          height: 768,
          thumbnail: true,
        },
        location: [47.263442, -1.535442],
        genre: 'Magnolia',
        cultivar: 'Atlas',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535442, 47.263442] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2a581959f4c5fa01109bdcc57270cd7cda27cd4b',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 119, 190, 1.00)',
            'rgba(111, 118, 143, 1.00)',
            'rgba(86, 89, 52, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'big dude'/magnolia 'big dude' (2).jpg",
          width: 1024,
          id: '99710f15d28cbdd68bbdb6bbb9061a36',
          height: 683,
          thumbnail: true,
        },
        location: [47.26307, -1.53255],
        genre: 'Magnolia',
        cultivar: 'Big Dude',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53255, 47.26307] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c246afd6dbcf9b424ea9af971e2f40b58e57a9ba',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 115, 129, 1.00)',
            'rgba(149, 119, 131, 1.00)',
            'rgba(124, 95, 97, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'early rose'/magnolia 'early rose' (1).jpg",
          width: 576,
          id: '862d02869c9cab9d52b8caae5b1d4844',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 137, 128, 1.00)',
            'rgba(117, 100, 100, 1.00)',
            'rgba(74, 67, 55, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'early rose'/magnolia 'early rose' .jpg",
          width: 1024,
          id: '3c12c7d7ec26eeaaf5472afe81b35451',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 130, 161, 1.00)',
            'rgba(111, 99, 92, 1.00)',
            'rgba(48, 51, 32, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'early rose'/magnolia 'early rose'  (2).jpg",
          width: 1024,
          id: '6205f96179e413f32c9eb3fb2dce2662',
          height: 683,
          thumbnail: true,
        },
        location: [47.262117, -1.531628],
        genre: 'Magnolia',
        cultivar: 'Early Rose',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531628, 47.262117] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0d45ec023c988084a4d60d75ccec43170d7309a6',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 121, 90, 1.00)',
            'rgba(126, 149, 57, 1.00)',
            'rgba(132, 155, 66, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'jane'/magnolia 'jane' (2).jpg",
          width: 1024,
          id: 'faaded64b80c66d954bb90dc8254ae07',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 88, 60, 1.00)',
            'rgba(130, 137, 93, 1.00)',
            'rgba(79, 97, 18, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'jane'/magnolia 'jane' (1).jpg",
          width: 576,
          id: '22d3abab04d9e92a27e3198fe1479476',
          height: 768,
          thumbnail: true,
        },
        location: [47.261878, -1.529528],
        genre: 'Magnolia',
        cultivar: 'Jane',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529528, 47.261878] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4d95ff844b709400c4ea30d23724d45ca9f7c033',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 137, 153, 1.00)',
            'rgba(116, 115, 119, 1.00)',
            'rgba(106, 104, 106, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'jon jon'/magnolia 'jon jon' (2).jpg",
          width: 1024,
          id: '696fba0563bac9e8d27ca4a55f4de3f7',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 109, 137, 1.00)',
            'rgba(116, 119, 135, 1.00)',
            'rgba(96, 99, 104, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'jon jon'/magnolia 'jon jon' (3).jpg",
          width: 1024,
          id: 'e64816bb671425262dbe5e51e6c5c6ca',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 169, 195, 1.00)',
            'rgba(127, 127, 122, 1.00)',
            'rgba(51, 57, 38, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'jon jon'/magnolia 'jon jon' (1).jpg",
          width: 1024,
          id: '8626e9d1ec213d213407ecfd66b64417',
          height: 683,
          thumbnail: true,
        },
        location: [47.261513, -1.530513],
        genre: 'Magnolia',
        cultivar: 'Jon Jon',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530513, 47.261513] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1dda2c57c9eb49485a69bb482e3d59ce80503b41',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 103, 79, 1.00)',
            'rgba(141, 130, 124, 1.00)',
            'rgba(72, 75, 23, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'lileny'/magnolia 'lileny' (2).jpg",
          width: 576,
          id: '31d7eb934ddc4eaa5aeb12f6b2a412ab',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 150, 106, 1.00)',
            'rgba(104, 114, 74, 1.00)',
            'rgba(96, 111, 57, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'lileny'/magnolia 'lileny' (1).jpg",
          width: 576,
          id: 'dc5cd51e54c2063efd6abb106b3db50e',
          height: 768,
          thumbnail: true,
        },
        location: [47.261888, -1.532087],
        genre: 'Magnolia',
        cultivar: 'Lileny',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532087, 47.261888] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd48f4abe42c4e2dadf8ec2ada5d2086fc4b27514',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 122, 126, 1.00)',
            'rgba(155, 109, 130, 1.00)',
            'rgba(99, 88, 68, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'marillyn'/magnolia 'marillyn'.jpg",
          width: 576,
          id: '28bff8bcbea240f66e10e3fe69ee5a82',
          height: 768,
          thumbnail: true,
        },
        location: [47.262175, -1.531387],
        genre: 'Magnolia',
        cultivar: 'Marillyn',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531387, 47.262175] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '838b27a16750dd9d740d2956a5c74843f990efdb',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(40, 45, 19, 1.00)',
            'rgba(112, 106, 87, 1.00)',
            'rgba(66, 63, 36, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'marjorie gossler'/magnolia 'marjorie gossler'.jpg",
          width: 576,
          id: '2136e3bd7c304d74dcf083fff851395d',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 151, 189, 1.00)',
            'rgba(118, 125, 122, 1.00)',
            'rgba(100, 100, 63, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'marjorie gossler'/magnolia 'marjorie gossler' (2).jpg",
          width: 576,
          id: '29eb4305ffd594ccd2dbac9844241e86',
          height: 768,
          thumbnail: true,
        },
        location: [47.262097, -1.530142],
        genre: 'Magnolia',
        cultivar: 'Marjorie Gossler',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530142, 47.262097] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd30a4c9ea223b937d5ce8b6d779da9e5b8fe94bd',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 95, 91, 1.00)',
            'rgba(126, 124, 116, 1.00)',
            'rgba(100, 99, 87, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'mary nell'/magnolia 'mary nell' (2).jpg",
          width: 1024,
          id: 'f2f428ba85e1202e08bca6d49cb91880',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 84, 75, 1.00)',
            'rgba(88, 83, 62, 1.00)',
            'rgba(99, 104, 57, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'mary nell'/magnolia 'mary nell' (3).jpg",
          width: 1024,
          id: '2ee937f9fb70019f8f0866a77d432605',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 70, 67, 1.00)',
            'rgba(120, 115, 105, 1.00)',
            'rgba(92, 90, 76, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'mary nell'/magnolia 'mary nell' (1).jpg",
          width: 1024,
          id: 'f41bb9c3e7aea60731fafef1606d1547',
          height: 683,
          thumbnail: true,
        },
        location: [47.262455, -1.528667],
        genre: 'Magnolia',
        cultivar: 'Mary Nell',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.528667, 47.262455] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1429638ff46418f9c54f68f488599e1f06d4b240',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 173, 200, 1.00)',
            'rgba(130, 124, 114, 1.00)',
            'rgba(87, 73, 42, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'mossman's giant'/magnolia 'mossman's giant' (2).jpg",
          width: 1024,
          id: '3bf475319bd4b3112a26b6e522176bfb',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 105, 109, 1.00)',
            'rgba(141, 129, 123, 1.00)',
            'rgba(91, 84, 71, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'mossman's giant'/magnolia 'mossman's giant' (1).jpg",
          width: 576,
          id: '3f7582f6d7b83e7b5dc52a9c050de97c',
          height: 768,
          thumbnail: true,
        },
        location: [47.26305, -1.532233],
        genre: 'Magnolia',
        cultivar: "Mossman's Giant",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532233, 47.26305] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a41d97bc48138abd7f7921218ad1b5a72460a0ca',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 117, 180, 1.00)',
            'rgba(123, 139, 154, 1.00)',
            'rgba(75, 79, 45, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'pat's delight'/magnolia 'pat's delight' (2).jpg",
          width: 1024,
          id: '56b4ec09cf4ac042ee36c01f58475464',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 118, 138, 1.00)',
            'rgba(103, 108, 95, 1.00)',
            'rgba(76, 79, 56, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'pat's delight'/magnolia 'pat's delight' (1).jpg",
          width: 1024,
          id: 'a462e1f1aaa046664e2b8e962658a28f',
          height: 683,
          thumbnail: true,
        },
        location: [47.262622, -1.532505],
        genre: 'Magnolia',
        cultivar: "Pat's Delight",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532505, 47.262622] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1655b25aec8a3b978e27eee028bb5979aec00c64',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 65, 71, 1.00)',
            'rgba(111, 94, 95, 1.00)',
            'rgba(85, 67, 57, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'pickard's sundew'/magnolia 'pickard's sundew'  (2).jpg",
          width: 1024,
          id: '8117043909b977a45d893a60cb0d82c5',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 81, 79, 1.00)',
            'rgba(111, 96, 86, 1.00)',
            'rgba(94, 78, 57, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'pickard's sundew'/magnolia 'pickard's sundew'  (3).jpg",
          width: 1024,
          id: '055dac1f4c5890e5b34a90e12c27e8ad',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 145, 195, 1.00)',
            'rgba(106, 107, 106, 1.00)',
            'rgba(76, 65, 40, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'pickard's sundew'/magnolia 'pickard's sundew'  (1).jpg",
          width: 1024,
          id: 'fdc9bdc100a4f325261e396dc388e947',
          height: 683,
          thumbnail: true,
        },
        location: [47.262705, -1.53452],
        genre: 'Magnolia',
        cultivar: "Pickard's Sundew",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53452, 47.262705] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9bcf81f4f7a983e2ca79b4c6584f4f80562c81f9',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 140, 85, 1.00)',
            'rgba(119, 132, 68, 1.00)',
            'rgba(116, 126, 55, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'randy'/magnolia 'randy' (2).jpg",
          width: 1024,
          id: '18b27c8bd359f7e21e2e132e34b1807a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 132, 176, 1.00)',
            'rgba(127, 92, 110, 1.00)',
            'rgba(83, 82, 46, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'randy'/magnolia 'randy'.jpg",
          width: 1024,
          id: 'f91266da0b524fcc200cc96d9cba23db',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 133, 79, 1.00)',
            'rgba(142, 130, 112, 1.00)',
            'rgba(95, 95, 45, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'randy'/magnolia 'randy' (1).jpg",
          width: 576,
          id: '5dd7b06539d1a600a20f771bbbbd783f',
          height: 768,
          thumbnail: true,
        },
        location: [47.261767, -1.529088],
        genre: 'Magnolia',
        cultivar: 'Randy',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529088, 47.261767] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3b8089e7d46636a9144bba0130b5c878a1ae0229',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 93, 91, 1.00)',
            'rgba(94, 98, 83, 1.00)',
            'rgba(79, 81, 60, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'sayonara'/magnolia 'sayonara' (2).jpg",
          width: 1024,
          id: '4b7aa92f42c09e7d40a9ee5ad7fab196',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 160, 192, 1.00)',
            'rgba(109, 117, 106, 1.00)',
            'rgba(45, 48, 30, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'sayonara'/magnolia 'sayonara' (1).jpg",
          width: 1024,
          id: 'a1eace057d83476d0b865b8b8104ee69',
          height: 683,
          thumbnail: true,
        },
        location: [47.261503, -1.534397],
        genre: 'Magnolia',
        cultivar: 'Sayonara',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534397, 47.261503] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a15f52305d6f68d23864690eda9b4fe321d090c3',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 72, 67, 1.00)',
            'rgba(103, 80, 68, 1.00)',
            'rgba(104, 93, 71, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'spectrum'/magnolia 'spectrum' (2).jpg",
          width: 1024,
          id: 'c97ae62e8085cc1b4e7db99d0257a091',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 155, 195, 1.00)',
            'rgba(128, 99, 119, 1.00)',
            'rgba(81, 68, 53, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'spectrum'/magnolia 'spectrum' (3).jpg",
          width: 1024,
          id: '8a88d21b07c0c52059b1b46485ec0869',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 96, 84, 1.00)',
            'rgba(115, 91, 77, 1.00)',
            'rgba(96, 83, 53, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'spectrum'/magnolia 'spectrum' (1).jpg",
          width: 1024,
          id: 'a22c39c49ae6417050f41f72e1dce0c7',
          height: 683,
          thumbnail: true,
        },
        location: [47.261622, -1.5332],
        genre: 'Magnolia',
        cultivar: 'Spectrum',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5332, 47.261622] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '43e7b08f2246230ee26cba6a710d3c93e4b840ca',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(172, 164, 177, 1.00)',
            'rgba(146, 108, 98, 1.00)',
            'rgba(98, 68, 40, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'todd gresham'/magnolia 'todd gresham'.jpg",
          width: 576,
          id: 'bde382c2638642f2eb8a65840a446e26',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 166, 223, 1.00)',
            'rgba(130, 123, 129, 1.00)',
            'rgba(96, 83, 61, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'todd gresham'/magnolia 'todd gresham' (2).jpg",
          width: 576,
          id: 'f411e5d53305d7482784d86aae0c0960',
          height: 768,
          thumbnail: true,
        },
        location: [47.26318, -1.532738],
        genre: 'Magnolia',
        cultivar: 'Todd Gresham',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532738, 47.26318] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f0cc8924f3a706d993de188503bc22ba1134096e',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(40, 57, 18, 1.00)',
            'rgba(62, 72, 27, 1.00)',
            'rgba(65, 85, 27, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'yellow bird'/magnolia 'yellow bird' (6).jpg",
          width: 1024,
          id: '8c2840ce9c0a839243249089f3148877',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 184, 183, 1.00)',
            'rgba(69, 91, 44, 1.00)',
            'rgba(96, 110, 58, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia 'yellow bird'/magnolia 'yellow bird' (5).jpg",
          width: 512,
          id: '206ec6d0c3d8e70b67f1fd3d7c2eecf9',
          height: 768,
          thumbnail: true,
        },
        location: [47.261553, -1.530542],
        genre: 'Magnolia',
        cultivar: 'Yellow Bird',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530542, 47.261553] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '75acea29c755178f46ea131bb126f5126852781b',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 101, 113, 1.00)',
            'rgba(117, 129, 52, 1.00)',
            'rgba(96, 104, 43, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia acuminata 'koban dori'/magnolia acuminata 'koban dori' (3).jpg",
          width: 512,
          id: 'dfb0d7e8a1d763b590598e325d930b3f',
          height: 768,
          thumbnail: true,
        },
        espece: 'acuminata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(62, 71, 41, 1.00)',
            'rgba(119, 118, 61, 1.00)',
            'rgba(61, 68, 20, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia acuminata 'koban dori'/magnolia acuminata 'koban dori' (2).jpg",
          width: 1024,
          id: 'b62b27fd8d7b566b3a0eb47adf07d4f8',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 112, 54, 1.00)',
            'rgba(122, 125, 64, 1.00)',
            'rgba(102, 109, 41, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia acuminata 'koban dori'/magnolia acuminata 'koban dori' (1).jpg",
          width: 1024,
          id: '0ee439861c565e1af621c452f531b007',
          height: 683,
          thumbnail: true,
        },
        location: [47.263203, -1.533233],
        genre: 'Magnolia',
        cultivar: 'Koban Dori',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533233, 47.263203] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '779e18c8cabd1d9e06ac7da295799bcbe595f304',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 136, 109, 1.00)',
            'rgba(151, 139, 104, 1.00)',
            'rgba(135, 129, 86, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia acuminata 'large yellow'/magnolia acuminata 'large yellow' (3).jpg",
          width: 576,
          id: '95f97f6430fc31976dbff47a95951266',
          height: 768,
          thumbnail: true,
        },
        espece: 'acuminata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 163, 100, 1.00)',
            'rgba(103, 127, 40, 1.00)',
            'rgba(107, 118, 70, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia acuminata 'large yellow'/magnolia acuminata 'large yellow' (2).jpg",
          width: 576,
          id: '41c55af5c244f8978fd37eedbbfa1876',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 128, 80, 1.00)',
            'rgba(169, 167, 99, 1.00)',
            'rgba(82, 93, 25, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia acuminata 'large yellow'/magnolia acuminata 'large yellow' (1).jpg",
          width: 616,
          id: 'c85970701f5ab8dd7258e9906ca927d6',
          height: 768,
          thumbnail: true,
        },
        location: [47.262395, -1.532375],
        genre: 'Magnolia',
        cultivar: 'Large Yellow',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532375, 47.262395] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dea2d2e79793530e38762ccae5adb532261647f4',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(72, 108, 167, 1.00)',
            'rgba(100, 94, 143, 1.00)',
            'rgba(86, 116, 166, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia campbellii 'hendrick's park'/magnolia campbellii 'hendrick's park' (3).jpg",
          width: 512,
          id: '10abf79e3360df97cc0853c7b9f4f086',
          height: 768,
          thumbnail: true,
        },
        espece: 'campbellii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(49, 68, 110, 1.00)',
            'rgba(107, 110, 152, 1.00)',
            'rgba(89, 90, 100, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia campbellii 'hendrick's park'/magnolia campbellii 'hendrick's park' (2).jpg",
          width: 512,
          id: 'aabcbca91f5072f656e0b1da1cd5184f',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 98, 156, 1.00)',
            'rgba(90, 98, 147, 1.00)',
            'rgba(86, 110, 157, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia campbellii 'hendrick's park'/magnolia campbellii 'hendrick's park' (1).jpg",
          width: 512,
          id: '95dd11a3ad8ff064f078bdf7c63bddda',
          height: 768,
          thumbnail: true,
        },
        location: [47.263937, -1.535362],
        genre: 'Magnolia',
        cultivar: "Hendrick's Park",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535362, 47.263937] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c4724ee833b5015c8fbb436f079ee400101d450f',
      fields: {
        espece: 'dawsoniana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 139, 181, 1.00)',
            'rgba(142, 121, 128, 1.00)',
            'rgba(78, 68, 43, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia dawsoniana 'valley splendour'/magnolia dawsoniana 'valley splendour'.jpg",
          width: 576,
          id: 'd8b50a2a1335d1ce6d5238cecf16fde8',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 162, 163, 1.00)',
            'rgba(95, 96, 85, 1.00)',
            'rgba(56, 54, 39, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia dawsoniana 'valley splendour'/magnolia dawsoniana 'valley splendour' (2).jpg",
          width: 576,
          id: 'a5060945140f4238eb0ace44979a3e08',
          height: 768,
          thumbnail: true,
        },
        location: [47.262063, -1.530192],
        genre: 'Magnolia',
        cultivar: 'Valley Splendour',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.530192, 47.262063] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '76fe1eae3553a4b590ab9aeeeee807a7ae49430b',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'dawsoniana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 169, 107, 1.00)',
            'rgba(106, 145, 67, 1.00)',
            'rgba(127, 133, 98, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia dawsoniana/magnolia dawsoniana  (2).jpg',
          width: 576,
          id: '0b4a9ebc3ec302412ad996138839fd78',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 152, 215, 1.00)',
            'rgba(106, 121, 131, 1.00)',
            'rgba(44, 47, 22, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia dawsoniana/magnolia dawsoniana  (3).jpg',
          width: 512,
          id: '1121e32b8981ca502326dc9b62007a68',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 146, 63, 1.00)',
            'rgba(117, 148, 99, 1.00)',
            'rgba(111, 118, 84, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia dawsoniana/magnolia dawsoniana  (1).jpg',
          width: 576,
          id: 'db2eadd1b45f1c17a1c904519513f6b9',
          height: 768,
          thumbnail: true,
        },
        location: [47.261908, -1.532367],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532367, 47.261908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '733abc96ca2c56c9461df0107016ed3ccf76e05c',
      fields: {
        espece: 'fraseri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(195, 206, 179, 1.00)',
            'rgba(81, 102, 56, 1.00)',
            'rgba(56, 78, 42, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia fraseri/magnolia fraseri (2).jpg',
          width: 576,
          id: '1d03f90fa8fadda51888a02c8e9ac51e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(190, 196, 200, 1.00)',
            'rgba(131, 136, 94, 1.00)',
            'rgba(75, 82, 40, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia fraseri/magnolia fraseri (1).jpg',
          width: 576,
          id: '41717f36602cb4a5a17a6d47a3534131',
          height: 768,
          thumbnail: true,
        },
        location: [47.264575, -1.535303],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535303, 47.264575] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '56448f4bca5864a6cdcda07fbe2fef6415ab3f4d',
      fields: {
        espece: 'liliiflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 125, 54, 1.00)',
            'rgba(118, 116, 92, 1.00)',
            'rgba(95, 119, 74, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia liliiflora 'lyons'/magnolia liliiflora 'lyons (2).jpg",
          width: 1024,
          id: '8f5bdc44895c0863ec3100caac93767b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 164, 121, 1.00)',
            'rgba(139, 131, 111, 1.00)',
            'rgba(90, 116, 60, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia liliiflora 'lyons'/magnolia liliiflora 'lyons (1).jpg",
          width: 576,
          id: '556d78f69feb81e14eb8d550c9e0b900',
          height: 768,
          thumbnail: true,
        },
        location: [47.262947, -1.536045],
        genre: 'Magnolia',
        cultivar: 'Lyons',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.536045, 47.262947] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1b7e6c3b1d2c49e6c6ca1b6411a52915e5c6966f',
      fields: {
        espece: 'sieboldii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(175, 187, 153, 1.00)',
            'rgba(113, 125, 81, 1.00)',
            'rgba(68, 86, 41, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sieboldii 'tetraploid nr. 2'/magnolia sieboldii 'tetraploid nr. 2' (2).jpg",
          width: 1024,
          id: '66a252b12dd6c57be523b0076d24b095',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 160, 134, 1.00)',
            'rgba(91, 104, 54, 1.00)',
            'rgba(89, 97, 52, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sieboldii 'tetraploid nr. 2'/magnolia sieboldii 'tetraploid nr. 2' (1).jpg",
          width: 1024,
          id: 'e7ef59ce8effe2885fdaf90bbd033d84',
          height: 683,
          thumbnail: true,
        },
        location: [47.262715, -1.532341],
        genre: 'Magnolia',
        cultivar: 'Tetraploid Nr. 2',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532341, 47.262715] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'aacdb4ba087ade5305f79f25d837773eb89c9f78',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 98, 75, 1.00)',
            'rgba(101, 107, 85, 1.00)',
            'rgba(64, 79, 51, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sieboldii 'yellow stamens'/magnolia sieboldii 'yellow stamens' (13).jpg",
          width: 1024,
          id: '82cc4fb0ada64396b66e2439219908a2',
          height: 571,
          thumbnail: true,
        },
        espece: 'sieboldii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 103, 55, 1.00)',
            'rgba(105, 112, 63, 1.00)',
            'rgba(97, 113, 59, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sieboldii 'yellow stamens'/magnolia sieboldii 'yellow stamens' (12).jpg",
          width: 1024,
          id: '5d0a9f575f587e7ca99e0f94f2b07c8d',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 122, 64, 1.00)',
            'rgba(102, 137, 73, 1.00)',
            'rgba(101, 123, 72, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sieboldii 'yellow stamens'/magnolia sieboldii 'yellow stamens' (10).jpg",
          width: 1024,
          id: '593f3aed6631448d67b80bccf60f2705',
          height: 683,
          thumbnail: true,
        },
        location: [47.261597, -1.534881],
        genre: 'Magnolia',
        cultivar: 'Yellow Stamens',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534881, 47.261597] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '16e1b8c7639663da7b05a329fa95e50c6c9c364e',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 122, 145, 1.00)',
            'rgba(100, 98, 80, 1.00)',
            'rgba(87, 88, 64, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sprengeri var. diva 'lanhydrock'/magnolia sprengeri var. diva 'lanhydrock'  (3).jpg",
          width: 1024,
          id: 'd6474e50d6e0d2a171f6c04b6da80314',
          height: 683,
          thumbnail: true,
        },
        espece: 'sprengeri var. diva',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 160, 204, 1.00)',
            'rgba(94, 99, 108, 1.00)',
            'rgba(55, 67, 28, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sprengeri var. diva 'lanhydrock'/magnolia sprengeri var. diva 'lanhydrock'  (2).jpg",
          width: 512,
          id: '40aae5e3f863cce75d23085d36801a61',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(53, 84, 139, 1.00)',
            'rgba(94, 111, 148, 1.00)',
            'rgba(103, 85, 84, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia sprengeri var. diva 'lanhydrock'/magnolia sprengeri var. diva 'lanhydrock'  (1).jpg",
          width: 1024,
          id: 'd2d589d509d4f0695f6698e48102b258',
          height: 683,
          thumbnail: true,
        },
        location: [47.262255, -1.53238],
        genre: 'Magnolia',
        cultivar: 'Lanhydrock',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53238, 47.262255] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '095bcbcfb32d7d056cd29eddca475292fcfd1c45',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 115, 69, 1.00)',
            'rgba(138, 135, 76, 1.00)',
            'rgba(139, 164, 109, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x foggii 'picotee'/magnolia x foggii 'picotee' (11).jpg",
          width: 576,
          id: '44b9afdd55ce9a3f2f0126187ad7df38',
          height: 768,
          thumbnail: true,
        },
        espece: 'x foggii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 113, 67, 1.00)',
            'rgba(95, 113, 75, 1.00)',
            'rgba(52, 67, 29, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x foggii 'picotee'/magnolia x foggii 'picotee' (10).jpg",
          width: 1024,
          id: '1dba679e4f593d710fd7e3e02b13e414',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 104, 68, 1.00)',
            'rgba(128, 132, 105, 1.00)',
            'rgba(64, 77, 27, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x foggii 'picotee'/magnolia x foggii 'picotee' (1).jpg",
          width: 576,
          id: 'f719d9ca629ed7a96487dfdfc26683af',
          height: 768,
          thumbnail: true,
        },
        location: [47.261787, -1.53478],
        genre: 'Magnolia',
        cultivar: 'Picotee',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.53478, 47.261787] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1b1c724cd15c75a8aa053d98c34a8056a74b8b41',
      fields: {
        espece: 'x soulangeana',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 101, 15, 1.00)',
            'rgba(102, 133, 97, 1.00)',
            'rgba(100, 142, 154, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'brozzonii'/magnolia x soulangeana 'brozzonii' (2).jpg",
          width: 661,
          id: 'df95d184d2d53c97a137a436effa92b3',
          height: 768,
          thumbnail: true,
        },
        location: [47.26268, -1.529183],
        genre: 'Magnolia',
        cultivar: 'Brozzonii',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529183, 47.26268] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3211d4672ddfeaf3c9bcd0f0ed7a1d3c680520b4',
      fields: {
        espece: 'x soulangeana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 132, 192, 1.00)',
            'rgba(111, 115, 130, 1.00)',
            'rgba(85, 74, 59, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'pickard's pearl'/magnolia x soulangeana 'pickard's pearl' (2).jpg",
          width: 1024,
          id: '9c628bfbaf5e04f78f1fbb966950fee8',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 76, 79, 1.00)',
            'rgba(120, 110, 109, 1.00)',
            'rgba(93, 80, 68, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x soulangeana 'pickard's pearl'/magnolia x soulangeana 'pickard's pearl' (1).jpg",
          width: 1024,
          id: 'f2083c85a966ae9381459744a18ca7c5',
          height: 683,
          thumbnail: true,
        },
        location: [47.262972, -1.532528],
        genre: 'Magnolia',
        cultivar: "Pickard's Pearl",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532528, 47.262972] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '349accf4ec56c68d1f046cdff3174b37e147fff0',
      fields: {
        espece: 'x veitchii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 100, 137, 1.00)',
            'rgba(118, 121, 143, 1.00)',
            'rgba(81, 74, 66, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia x veitchii/magnolia x veitchii  (2).jpg',
          width: 1024,
          id: 'd84fb470799a21b162ce5f9acf563bf3',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 148, 193, 1.00)',
            'rgba(124, 120, 129, 1.00)',
            'rgba(71, 69, 47, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/magnolia/magnolia x veitchii/magnolia x veitchii  (1).jpg',
          width: 1024,
          id: 'e7a1e0ad091ac98ee497e00191b42b6e',
          height: 683,
          thumbnail: true,
        },
        location: [47.261253, -1.533878],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533878, 47.261253] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '85ac5e4aa6a7ea641d672c1ba7f7744d4f45baac',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 149, 147, 1.00)',
            'rgba(97, 113, 79, 1.00)',
            'rgba(78, 71, 34, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x wiesneri 'watsonii seedling c'/magnolia x wiesneri 'watsonii seedling c' (3).jpg",
          width: 512,
          id: 'de77a53fe3ab04ab3a1c34837a75cf2b',
          height: 768,
          thumbnail: true,
        },
        espece: 'x wiesneri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(69, 86, 68, 1.00)',
            'rgba(105, 105, 82, 1.00)',
            'rgba(57, 58, 35, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x wiesneri 'watsonii seedling c'/magnolia x wiesneri 'watsonii seedling c' (2).jpg",
          width: 1024,
          id: 'd9a495d213315b5fec95c78a8ed02a80',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 103, 78, 1.00)',
            'rgba(108, 109, 82, 1.00)',
            'rgba(89, 88, 60, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/magnolia/magnolia x wiesneri 'watsonii seedling c'/magnolia x wiesneri 'watsonii seedling c' (1).jpg",
          width: 1024,
          id: 'bfa718dcbfaeb75e7406a0033b88c824',
          height: 683,
          thumbnail: true,
        },
        location: [47.262517, -1.532417],
        genre: 'Magnolia',
        cultivar: 'Watsonii Seedling C',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.532417, 47.262517] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e2cd35067979bba2e359c4021d0575617d98fecf',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'lomariifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 133, 114, 1.00)',
            'rgba(84, 85, 45, 1.00)',
            'rgba(112, 96, 36, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/mahonia/mahonia lomariifolia/mahonia lomariifolia (2).jpg',
          width: 623,
          id: '4b9c2a392301f3a8d9c70d139b38f6c3',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(108, 128, 102, 1.00)',
            'rgba(133, 137, 59, 1.00)',
            'rgba(96, 112, 56, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/mahonia/mahonia lomariifolia/mahonia lomariifolia (3).jpg',
          width: 576,
          id: '2433635c3ee4643d853bf94f914f2c75',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 95, 62, 1.00)',
            'rgba(111, 130, 83, 1.00)',
            'rgba(81, 104, 60, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/mahonia/mahonia lomariifolia/mahonia lomariifolia (1).jpg',
          width: 576,
          id: '62a887f559bf4dc3acc1afc1a051f0da',
          height: 768,
          thumbnail: true,
        },
        location: [47.219775, -1.542605],
        genre: 'Mahonia',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542605, 47.219775] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e0743351d41e4a604ecbcfb5a1152ddee0f12c56',
      fields: {
        espece: 'azedarach var. toosendan',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 183, 206, 1.00)',
            'rgba(111, 122, 101, 1.00)',
            'rgba(109, 107, 98, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/melia/melia azedarach var. toosendan/melia azedarach var. toosendan.jpg',
          width: 1024,
          id: '77b70f579f1f2db2fe0bbb6fd6baa827',
          height: 768,
          thumbnail: true,
        },
        location: [47.22118, -1.54387],
        genre: 'Melia',
        famille: 'Meliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54387, 47.22118] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '25daec9e3ee0c23d5644239cdd7822e54fe9bc82',
      fields: {
        espece: 'bombycis',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(169, 173, 122, 1.00)',
            'rgba(125, 128, 57, 1.00)',
            'rgba(108, 114, 58, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/morus/morus bombycis/morus bombycis.jpg',
          width: 576,
          id: 'd32df53bb93491292fc0f0e5570a9b33',
          height: 768,
          thumbnail: true,
        },
        location: [47.218638, -1.542438],
        genre: 'Morus',
        famille: 'Moraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542438, 47.218638] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e45cd0a308aced37fb26b72159840a68f220fcbb',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'sericea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 139, 126, 1.00)',
            'rgba(87, 99, 60, 1.00)',
            'rgba(76, 91, 50, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/neolitsea/neolitsea sericea/neolitsea sericea  (10).jpg',
          width: 512,
          id: '8322d213c23faa7511d37bc123585713',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 107, 81, 1.00)',
            'rgba(96, 104, 81, 1.00)',
            'rgba(99, 103, 77, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/neolitsea/neolitsea sericea/neolitsea sericea  (11).jpg',
          width: 1024,
          id: 'ece67d60866560c0f16dfcb7bfaea438',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 151, 108, 1.00)',
            'rgba(132, 128, 80, 1.00)',
            'rgba(76, 86, 27, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/neolitsea/neolitsea sericea/neolitsea sericea  (1).jpg',
          width: 576,
          id: 'abcf3cb9de4f601a6187a4870ddd7453',
          height: 768,
          thumbnail: true,
        },
        location: [47.219505, -1.544162],
        genre: 'Neolitsea',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544162, 47.219505] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '22257d011834a7040a152786734e58cd638db499',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(189, 195, 211, 1.00)',
            'rgba(151, 152, 154, 1.00)',
            'rgba(116, 99, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/parrotia hamamelidaceae/parrotia persica 'vanessa'/parrotia persica 'vanessa' (2).jpg",
          width: 576,
          id: 'b1c1baccbe3fb77d5c84173f1c3ac23b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 112, 47, 1.00)',
            'rgba(155, 111, 57, 1.00)',
            'rgba(127, 92, 84, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/parrotia hamamelidaceae/parrotia persica 'vanessa'/parrotia persica 'vanessa' (5).jpg",
          width: 576,
          id: 'fad8e8880d09be6e0f54d3f474269aed',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 134, 175, 1.00)',
            'rgba(149, 87, 63, 1.00)',
            'rgba(62, 33, 10, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/parrotia hamamelidaceae/parrotia persica 'vanessa'/parrotia persica 'vanessa'  (3).jpg",
          width: 512,
          id: 'eed9d53b5657fec6338479ee4fabb64d',
          height: 768,
          thumbnail: true,
        },
        location: [47.270147, -1.586053],
        genre: 'Parrotia',
        cultivar: 'Vanessa',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586053, 47.270147] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8c6f8c3a6f7e4cdfa6e06dfdafe4d33d8e9f9210',
      fields: {
        espece: 'amurense',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(107, 127, 160, 1.00)',
            'rgba(149, 161, 170, 1.00)',
            'rgba(92, 91, 46, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/phellodendron/phellodendron amurense/phellodendron amurense.jpg',
          width: 576,
          id: '9083f60348dee7209676c45b4ca7c2b9',
          height: 768,
          thumbnail: true,
        },
        location: [47.262762, -1.534063],
        genre: 'Phellodendron',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.534063, 47.262762] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3a717200a60689cd6cef14becb8211e7e6212255',
      fields: {
        espece: 'latifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 151, 145, 1.00)',
            'rgba(123, 136, 121, 1.00)',
            'rgba(128, 135, 119, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/phillyrea/phillyrea latifolia/phillyrea latifolia (2).jpg',
          width: 576,
          id: 'ab217dcca566609d8b762d005dcbec92',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 133, 108, 1.00)',
            'rgba(123, 138, 119, 1.00)',
            'rgba(86, 94, 75, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/phillyrea/phillyrea latifolia/phillyrea latifolia (1).jpg',
          width: 576,
          id: 'dff648db403b9fca276c25d43efa61f3',
          height: 768,
          thumbnail: true,
        },
        location: [47.219733, -1.541933],
        genre: 'Phillyrea',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541933, 47.219733] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fa9645de78585662d6cb0f85124a518338e31b0d',
      fields: {
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 144, 128, 1.00)',
            'rgba(110, 107, 59, 1.00)',
            'rgba(95, 96, 57, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/pieris/pieris japonica 'variegata'/pieris japonica 'variegata' (2).jpg",
          width: 1024,
          id: '0b00511606684cfef625148cac7be849',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 86, 34, 1.00)',
            'rgba(130, 132, 64, 1.00)',
            'rgba(107, 106, 55, 1.00)',
          ],
          filename:
            "ip jardin des plantes de nantes/pieris/pieris japonica 'variegata'/pieris japonica 'variegata' (1).jpg",
          width: 576,
          id: 'a5cdfcf64864d9f5f21487839b601fc2',
          height: 768,
          thumbnail: true,
        },
        location: [47.219263, -1.542745],
        genre: 'Pieris',
        cultivar: 'Variegata',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542745, 47.219263] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '56ca3b645bbdfb469a8e6644dcca550fc834555d',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'x canescens',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 154, 65, 1.00)',
            'rgba(125, 159, 113, 1.00)',
            'rgba(94, 121, 59, 1.00)',
          ],
          filename:
            'ip parc de proce/populus/populus x canescens/populus x canescens (2).jpg',
          width: 576,
          id: '91a39db4f3b8267bd2a680b4e08f5b23',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(182, 190, 178, 1.00)',
            'rgba(86, 100, 82, 1.00)',
            'rgba(109, 128, 69, 1.00)',
          ],
          filename:
            'ip parc de proce/populus/populus x canescens/populus x canescens (3).jpg',
          width: 576,
          id: '2022e02ec1a70b81a913a5002554982e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 115, 51, 1.00)',
            'rgba(133, 162, 107, 1.00)',
            'rgba(79, 104, 60, 1.00)',
          ],
          filename:
            'ip parc de proce/populus/populus x canescens/populus x canescens (1).jpg',
          width: 576,
          id: '1186ce2c4ce48c2db9df95be06db27fd',
          height: 768,
          thumbnail: true,
        },
        location: [47.224567, -1.581817],
        genre: 'Populus',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581817, 47.224567] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6372127c3e4f1d66c69cdf5c13745249b25cb0f2',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(82, 106, 119, 1.00)',
            'rgba(124, 133, 102, 1.00)',
            'rgba(106, 119, 51, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/prunus/prunus maackii 'amber beauty'/prunus maackii 'amber beauty' (5).jpg",
          width: 576,
          id: '3412a7067eb8811247204b94e25824c2',
          height: 768,
          thumbnail: true,
        },
        espece: 'maackii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(168, 183, 210, 1.00)',
            'rgba(122, 120, 95, 1.00)',
            'rgba(74, 79, 40, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/prunus/prunus maackii 'amber beauty'/prunus maackii 'amber beauty' (4).jpg",
          width: 576,
          id: 'b88326f5a6f2ea5f0d653329ca743ca0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 171, 218, 1.00)',
            'rgba(114, 137, 104, 1.00)',
            'rgba(102, 114, 55, 1.00)',
          ],
          filename:
            "ip parc exotique du grand-blottereau/prunus/prunus maackii 'amber beauty'/prunus maackii 'amber beauty' (1).jpg",
          width: 576,
          id: '85971c18f8eb58b567a83b88076c3b12',
          height: 768,
          thumbnail: true,
        },
        location: [47.230212, -1.506588],
        genre: 'Prunus',
        cultivar: 'Amber Beauty',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.506588, 47.230212] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd5e5a51f79fc02f8898c70194e25e386f39d0544',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 155, 144, 1.00)',
            'rgba(129, 107, 108, 1.00)',
            'rgba(113, 114, 108, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/prunus/prunus mume 'beni-chidori'/prunus mume 'beni-chidori' (4).jpg",
          width: 576,
          id: 'ccf5c8fb0b15c65e40da9a4803252364',
          height: 768,
          thumbnail: true,
        },
        espece: 'mume',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 113, 119, 1.00)',
            'rgba(130, 85, 113, 1.00)',
            'rgba(82, 70, 70, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/prunus/prunus mume 'beni-chidori'/prunus mume 'beni-chidori' (2).jpg",
          width: 549,
          id: '2ef6e7dac9f9085eb2364395e4fb4b17',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 133, 94, 1.00)',
            'rgba(109, 135, 73, 1.00)',
            'rgba(94, 116, 65, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/prunus/prunus mume 'beni-chidori'/prunus mume 'beni-chidori' (1).jpg",
          width: 576,
          id: '0b90fabf2f79de2211da393af7acb401',
          height: 768,
          thumbnail: true,
        },
        location: [47.260928, -1.533338],
        genre: 'Prunus',
        cultivar: 'Beni-chidori',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533338, 47.260928] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7d7915315d0568e6343ac090a9c1f2457c601c03',
      fields: {
        espece: 'sinensis',
        nom_du_site: 'Jardin des Plantes',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(191, 207, 214, 1.00)',
            'rgba(123, 114, 103, 1.00)',
            'rgba(52, 58, 28, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/pseudocydonia/pseudocydonia sinensis/pseudocydonia sinensis (2).jpg',
          width: 1024,
          id: '9795cfafd2d8855e170ffcf56d2c7e8f',
          height: 768,
          thumbnail: true,
        },
        location: [47.220592, -1.542247],
        genre: 'Pseudocydonia',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542247, 47.220592] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3b4ff12ff5c2810785dc52199c9c2d91d8a97af6',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'pyrifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 115, 41, 1.00)',
            'rgba(127, 144, 63, 1.00)',
            'rgba(90, 104, 54, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/pyrus/pyrus pyrifolia/pyrus pyrifolia (2).jpg',
          width: 576,
          id: '8b0a9fe78a42fb22c2390bcced4df988',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 140, 35, 1.00)',
            'rgba(135, 146, 39, 1.00)',
            'rgba(118, 128, 28, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/pyrus/pyrus pyrifolia/pyrus pyrifolia (3).jpg',
          width: 603,
          id: '62c4a423412f4f131538ba6e6a676b44',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(194, 202, 186, 1.00)',
            'rgba(79, 94, 56, 1.00)',
            'rgba(109, 110, 73, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/pyrus/pyrus pyrifolia/pyrus pyrifolia (1).jpg',
          width: 576,
          id: 'a6ec346c72314babe90c30bb04868c88',
          height: 768,
          thumbnail: true,
        },
        location: [47.230392, -1.507047],
        genre: 'Pyrus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507047, 47.230392] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bca8dd712684226e727df4fc884e473990e87912',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'mongolica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 153, 64, 1.00)',
            'rgba(115, 152, 73, 1.00)',
            'rgba(100, 135, 58, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/quercus/quercus mongolica/quercus mongolica (2).jpg',
          width: 576,
          id: '1e7a5886b02dcf91d6cde752a38431a0',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 169, 103, 1.00)',
            'rgba(110, 151, 87, 1.00)',
            'rgba(101, 129, 73, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/quercus/quercus mongolica/quercus mongolica (3).jpg',
          width: 576,
          id: 'b52efa3c9579efd567831351e52afff1',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 168, 113, 1.00)',
            'rgba(114, 158, 93, 1.00)',
            'rgba(109, 134, 79, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/quercus/quercus mongolica/quercus mongolica (1).jpg',
          width: 576,
          id: 'f2dfc36e171fbc68ac3b4e0faaadd994',
          height: 768,
          thumbnail: true,
        },
        location: [47.21963, -1.541358],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541358, 47.21963] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6bf7323e9f303cf1d9936bd1372218540b23cf22',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'stenophylloides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 156, 138, 1.00)',
            'rgba(138, 149, 127, 1.00)',
            'rgba(113, 117, 88, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/quercus/quercus stenophylloides/quercus stenophylloides (2).jpg',
          width: 576,
          id: '696a9a8bfe904bafd41139ea5abcbad3',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 145, 94, 1.00)',
            'rgba(135, 153, 92, 1.00)',
            'rgba(111, 131, 57, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/quercus/quercus stenophylloides/quercus stenophylloides (3).jpg',
          width: 576,
          id: '04bd62248b7c6062ad57c6de9bb0bfe3',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 134, 74, 1.00)',
            'rgba(127, 145, 85, 1.00)',
            'rgba(147, 140, 99, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/quercus/quercus stenophylloides/quercus stenophylloides (1).jpg',
          width: 576,
          id: '03f6bfeb2e68bb07da9a9c427521f30a',
          height: 768,
          thumbnail: true,
        },
        location: [47.219188, -1.54115],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.54115, 47.219188] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5edd39ad687afb486b51fecefd88f5e8763532e9',
      fields: {
        espece: 'ilicifolia',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 131, 137, 1.00)',
            'rgba(86, 75, 51, 1.00)',
            'rgba(87, 86, 50, 1.00)',
          ],
          filename:
            'ip parc de proce/quercus/quercus ilicifolia/quercus ilicifolia.jpg',
          width: 1024,
          id: '04216b91e72135962896e6491732aea6',
          height: 683,
          thumbnail: true,
        },
        location: [47.224525, -1.581505],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581505, 47.224525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fb8aa7bf8bd8b67dd467bb147a6304e2bbe7af8d',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'libani',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 142, 104, 1.00)',
            'rgba(143, 146, 86, 1.00)',
            'rgba(132, 135, 69, 1.00)',
          ],
          filename:
            'ip parc de proce/quercus/quercus libani/quercus libani (3).jpg',
          width: 576,
          id: '0896020987e67a181bc2c81e6c7ca0da',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(162, 151, 122, 1.00)',
            'rgba(153, 144, 114, 1.00)',
            'rgba(137, 131, 102, 1.00)',
          ],
          filename:
            'ip parc de proce/quercus/quercus libani/quercus libani (4).jpg',
          width: 576,
          id: '1c0a92780b4d3b8916a35d50a3195f16',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 132, 98, 1.00)',
            'rgba(141, 144, 83, 1.00)',
            'rgba(120, 120, 57, 1.00)',
          ],
          filename:
            'ip parc de proce/quercus/quercus libani/quercus libani (1).jpg',
          width: 576,
          id: '5c23587f237d88dc9ea89256db6311e8',
          height: 768,
          thumbnail: true,
        },
        location: [47.224372, -1.583737],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583737, 47.224372] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '546a6e6414007dcc3d30e110493678930ff2c5ba',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'palustris',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 176, 210, 1.00)',
            'rgba(129, 118, 110, 1.00)',
            'rgba(79, 77, 50, 1.00)',
          ],
          filename:
            'ip parc de proce/quercus/quercus palustris/quercus palustris (2).jpg',
          width: 512,
          id: 'd0291b8b073807a587db08264223b55f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 146, 156, 1.00)',
            'rgba(130, 126, 113, 1.00)',
            'rgba(96, 86, 68, 1.00)',
          ],
          filename:
            'ip parc de proce/quercus/quercus palustris/quercus palustris (4).jpg',
          width: 1024,
          id: '7a53011a255b7796e3497f9c38823fea',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 132, 129, 1.00)',
            'rgba(102, 97, 78, 1.00)',
            'rgba(32, 32, 21, 1.00)',
          ],
          filename:
            'ip parc de proce/quercus/quercus palustris/quercus palustris (1).jpg',
          width: 512,
          id: '02ee12682fdc35c3923e12d8b7353c82',
          height: 768,
          thumbnail: true,
        },
        location: [47.223417, -1.584637],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584637, 47.223417] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e8adccf2f55d789abb73b1d20fdba3b4c3375f66',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'petraea subsp. iberica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 126, 68, 1.00)',
            'rgba(107, 113, 59, 1.00)',
            'rgba(107, 113, 70, 1.00)',
          ],
          filename:
            'ip parc de proce/quercus/quercus petraea subsp. iberica/quercus petraea subsp. iberica (2).jpg',
          width: 1024,
          id: '4d88eb810dd14d78ca7d8358879f6180',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 150, 108, 1.00)',
            'rgba(95, 118, 70, 1.00)',
            'rgba(106, 123, 71, 1.00)',
          ],
          filename:
            'ip parc de proce/quercus/quercus petraea subsp. iberica/quercus petraea subsp. iberica .jpg',
          width: 1024,
          id: '25eef138d95052ccee32688f514ddddd',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 108, 64, 1.00)',
            'rgba(128, 132, 74, 1.00)',
            'rgba(122, 129, 76, 1.00)',
          ],
          filename:
            'ip parc de proce/quercus/quercus petraea subsp. iberica/quercus petraea subsp. iberica (1).jpg',
          width: 576,
          id: '3e32617af2e026eb81f8764f66867119',
          height: 768,
          thumbnail: true,
        },
        location: [47.22262, -1.579617],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.579617, 47.22262] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1dd576d355713ce44640c59034d35564374a4e04',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'x vilmoriana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(183, 188, 173, 1.00)',
            'rgba(88, 98, 66, 1.00)',
            'rgba(99, 102, 59, 1.00)',
          ],
          filename:
            'ip parc de proce/quercus/quercus x vilmoriana/quercus x vilmoriana (3).jpg',
          width: 1024,
          id: 'add466002b33785e61d128f54b3afffd',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 142, 42, 1.00)',
            'rgba(124, 137, 56, 1.00)',
            'rgba(112, 131, 46, 1.00)',
          ],
          filename:
            'ip parc de proce/quercus/quercus x vilmoriana/quercus x vilmoriana (4).jpg',
          width: 576,
          id: '8b054c9fbe3a98cdd881e30d4d8c1a98',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 179, 141, 1.00)',
            'rgba(109, 144, 86, 1.00)',
            'rgba(83, 115, 52, 1.00)',
          ],
          filename:
            'ip parc de proce/quercus/quercus x vilmoriana/quercus x vilmoriana (1).jpg',
          width: 576,
          id: '46c5f0e3ef78f2d55636f50b9d72616a',
          height: 768,
          thumbnail: true,
        },
        location: [47.222747, -1.583603],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583603, 47.222747] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '85805dd1fc17cf7cc14650a70a4b933dcc8520c7',
      fields: {
        espece: 'myrsinifolia',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(147, 168, 117, 1.00)',
            'rgba(94, 118, 64, 1.00)',
            'rgba(63, 78, 47, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/quercus/quercus myrsinifolia/quercus myrsinifolia (2).jpg',
          width: 1024,
          id: '970caf657458663f85606834a03c7cad',
          height: 683,
          thumbnail: true,
        },
        location: [47.262013, -1.535561],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535561, 47.262013] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f4be7fc2d967d3657d2e383ea7c73658cda257bb',
      fields: {
        nom_du_site: 'Parc de la Gaudini\u00e8re',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 130, 119, 1.00)',
            'rgba(129, 124, 106, 1.00)',
            'rgba(128, 130, 104, 1.00)',
          ],
          filename:
            "ip parc de la gaudiniere/rhododendron/rhododendron 'seta'/rhododendron 'seta' (2).jpg",
          width: 576,
          id: '04d5356bb902e1f006962ddff856d617',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 100, 94, 1.00)',
            'rgba(145, 108, 118, 1.00)',
            'rgba(63, 59, 45, 1.00)',
          ],
          filename:
            "ip parc de la gaudiniere/rhododendron/rhododendron 'seta'/rhododendron 'seta' (3).jpg",
          width: 1024,
          id: 'fa462fbb67bba5b0790c3c51329ac490',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 90, 85, 1.00)',
            'rgba(150, 120, 123, 1.00)',
            'rgba(81, 71, 64, 1.00)',
          ],
          filename:
            "ip parc de la gaudiniere/rhododendron/rhododendron 'seta'/rhododendron 'seta' (1).jpg",
          width: 576,
          id: '5b722155402776accbac674d68b15f53',
          height: 768,
          thumbnail: true,
        },
        location: [47.24433, -1.580892],
        genre: 'Rhododendron',
        cultivar: 'Seta',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580892, 47.24433] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c022e755164e73efc7907caa4232f47ca37b1140',
      fields: {
        espece: 'mucronulatum',
        nom_du_site: 'Parc de la Gaudini\u00e8re',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 80, 72, 1.00)',
            'rgba(134, 131, 91, 1.00)',
            'rgba(138, 122, 90, 1.00)',
          ],
          filename:
            'ip parc de la gaudiniere/rhododendron/rhododendron mucronulatum/rhododendron mucronulatum (1).jpg',
          width: 576,
          id: '47e086d888fe934cf5ed0ca9034d1de0',
          height: 768,
          thumbnail: true,
        },
        location: [47.244488, -1.58172],
        genre: 'Rhododendron',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58172, 47.244488] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '66273a81c988e39f24dcc4161f3155c00819c66f',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 127, 108, 1.00)',
            'rgba(100, 117, 86, 1.00)',
            'rgba(138, 125, 122, 1.00)',
          ],
          filename:
            "ip parc de proce/rhododendron/rhododendron 'pink cherub'/rhododendron 'pink cherub' (2).jpg",
          width: 576,
          id: 'a40c44dfd132ead05bce86e320b68440',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 133, 111, 1.00)',
            'rgba(123, 114, 109, 1.00)',
            'rgba(111, 101, 96, 1.00)',
          ],
          filename:
            "ip parc de proce/rhododendron/rhododendron 'pink cherub'/rhododendron 'pink cherub' (3).jpg",
          width: 1024,
          id: '4d6c014fc1fa213f4aa3cca040f25238',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 93, 90, 1.00)',
            'rgba(190, 105, 143, 1.00)',
            'rgba(160, 111, 137, 1.00)',
          ],
          filename:
            "ip parc de proce/rhododendron/rhododendron 'pink cherub'/rhododendron 'pink cherub' (1).jpg",
          width: 576,
          id: 'd6035c3af66f55e9193e91e77d106770',
          height: 768,
          thumbnail: true,
        },
        location: [47.22593, -1.582083],
        genre: 'Rhododendron',
        cultivar: 'Pink Cherub',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582083, 47.22593] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd0edb440284597a5d5009fb668f6c875be19d184',
      fields: {
        espece: 'viburnifolium',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 105, 65, 1.00)',
            'rgba(90, 94, 46, 1.00)',
            'rgba(114, 112, 67, 1.00)',
          ],
          filename:
            'ip parc de proce/ribes/ribes viburnifolium/ribes viburnifolium (2).jpg',
          width: 1024,
          id: 'ddaef13fa6fff62dc3b504f07cb6c426',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 127, 90, 1.00)',
            'rgba(119, 120, 55, 1.00)',
            'rgba(114, 118, 46, 1.00)',
          ],
          filename:
            'ip parc de proce/ribes/ribes viburnifolium/ribes viburnifolium (1).jpg',
          width: 1024,
          id: '3f74bcff85f1c1ae1bb19cc6aa51f68c',
          height: 683,
          thumbnail: true,
        },
        location: [47.224756, -1.581287],
        genre: 'Ribes',
        famille: 'Grossulariaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581287, 47.224756] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f8711a6570d7999d9f52453a2ba7ddb3feb424a6',
      fields: {
        nom_du_site: 'Jardin des Plantes',
        espece: 'kamtschatica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 110, 113, 1.00)',
            'rgba(135, 133, 93, 1.00)',
            'rgba(134, 135, 125, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/sambucus/sambucus kamtschatica/sambucus kamtschatica (2).jpg',
          width: 576,
          id: '6aeaeba411544d43f8b8fcdd0650dbdf',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 149, 143, 1.00)',
            'rgba(145, 139, 124, 1.00)',
            'rgba(133, 135, 118, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/sambucus/sambucus kamtschatica/sambucus kamtschatica (3).jpg',
          width: 576,
          id: '4793ba469d6b255cb0bb38129864ff66',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 150, 115, 1.00)',
            'rgba(132, 147, 105, 1.00)',
            'rgba(126, 133, 103, 1.00)',
          ],
          filename:
            'ip jardin des plantes de nantes/sambucus/sambucus kamtschatica/sambucus kamtschatica (1).jpg',
          width: 576,
          id: 'e5b19609fdc6c3b7f0737d5603b0b2d3',
          height: 768,
          thumbnail: true,
        },
        location: [47.220442, -1.542045],
        genre: 'Sambucus',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542045, 47.220442] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b5ecb8e04b3d79fe5a83d532e10c2fb42f310246',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'albidum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 141, 112, 1.00)',
            'rgba(116, 136, 56, 1.00)',
            'rgba(93, 111, 39, 1.00)',
          ],
          filename:
            'ip parc de proce/sassafras/sassafras albidum/sassafras albidum (2).jpg',
          width: 576,
          id: '9ae747029b9dee782cb72191a250e917',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 152, 207, 1.00)',
            'rgba(125, 136, 135, 1.00)',
            'rgba(125, 134, 75, 1.00)',
          ],
          filename:
            'ip parc de proce/sassafras/sassafras albidum/sassafras albidum (3).jpg',
          width: 576,
          id: '05135bcd97334c3f0c71ed0e623fa73b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 114, 116, 1.00)',
            'rgba(128, 141, 112, 1.00)',
            'rgba(136, 144, 90, 1.00)',
          ],
          filename:
            'ip parc de proce/sassafras/sassafras albidum/sassafras albidum (1).jpg',
          width: 576,
          id: '43d514d848abc8fff85a1b1ac750b410',
          height: 768,
          thumbnail: true,
        },
        location: [47.222908, -1.581447],
        genre: 'Sassafras',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581447, 47.222908] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2410ab862cab319c7589270cfa59bef2956e27ef',
      fields: {
        espece: 'japonicum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 176, 159, 1.00)',
            'rgba(98, 114, 86, 1.00)',
            'rgba(77, 91, 50, 1.00)',
          ],
          filename:
            'ip parc de proce/styphnolobium/styphnolobium japonicum/styphnolobium japonicum (2).jpg',
          width: 1024,
          id: '7a145dc9b2353e96131d960c37529b24',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(91, 119, 58, 1.00)',
            'rgba(109, 132, 81, 1.00)',
            'rgba(110, 126, 72, 1.00)',
          ],
          filename:
            'ip parc de proce/styphnolobium/styphnolobium japonicum/styphnolobium japonicum (1).jpg',
          width: 691,
          id: '04cbd2c2365aad240bef80005324432d',
          height: 768,
          thumbnail: true,
        },
        location: [47.225597, -1.582003],
        genre: 'Styphnolobium',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582003, 47.225597] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2f7de25962a0bb6080e2afc5702c796a1a527fa9',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        espece: 'sinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 122, 89, 1.00)',
            'rgba(134, 129, 92, 1.00)',
            'rgba(81, 87, 43, 1.00)',
          ],
          filename:
            'ip parc de proce/sycopsis/sycopsis sinensis/sycopsis sinensis (3).jpg',
          width: 1024,
          id: 'b7968c606a87427cf356e0f41b90ae49',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 115, 89, 1.00)',
            'rgba(106, 113, 76, 1.00)',
            'rgba(113, 110, 87, 1.00)',
          ],
          filename:
            'ip parc de proce/sycopsis/sycopsis sinensis/sycopsis sinensis.jpg',
          width: 610,
          id: '4f2e903d8f78398bdfd753b90d3bd0f3',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 139, 119, 1.00)',
            'rgba(150, 133, 120, 1.00)',
            'rgba(109, 117, 100, 1.00)',
          ],
          filename:
            'ip parc de proce/sycopsis/sycopsis sinensis/sycopsis sinensis (2).jpg',
          width: 576,
          id: 'f508d3f80c7fa9aa2956010d195cbe86',
          height: 768,
          thumbnail: true,
        },
        location: [47.224697, -1.581253],
        genre: 'Sycopsis',
        famille: 'Hamamelidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581253, 47.224697] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '000ac499315e31c3c6368da883779dd9cdbb457d',
      fields: {
        espece: 'tetrandra',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 120, 88, 1.00)',
            'rgba(138, 133, 112, 1.00)',
            'rgba(84, 96, 53, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/tamarix/tamarix tetrandra/tamarix tetrandra.jpg',
          width: 1024,
          id: '992fb46bc9a59877db52edc818e04771',
          height: 768,
          thumbnail: true,
        },
        location: [47.26188, -1.535005],
        genre: 'Tamarix',
        famille: 'Tamaricaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.535005, 47.26188] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '52d7e2c47552423acfb785640a73b48a0c09e932',
      fields: {
        espece: 'mongolica',
        nom_du_site: 'Autre site',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(192, 199, 188, 1.00)',
            'rgba(83, 97, 79, 1.00)',
            'rgba(111, 113, 89, 1.00)',
          ],
          filename:
            'ip ville de nantes/tilia/tilia mongolica/tilia mongolica (4).jpg',
          width: 1024,
          id: '324075ffe634b52a41289792ef3385eb',
          height: 683,
          thumbnail: true,
        },
        location: [47.193638, -1.533278],
        genre: 'Tilia',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.533278, 47.193638] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'defdcad7d9fe1793e60125fafd329afd7a2be1ed',
      fields: {
        espece: 'x hollandica',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 99, 88, 1.00)',
            'rgba(104, 111, 98, 1.00)',
            'rgba(83, 93, 79, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/ulmus/ulmus x hollandica 'jacqueline hillier'/ulmus x hollandica 'jacqueline hillier' (1).jpg",
          width: 1024,
          id: '385c481bc7b9855366e96ee796381143',
          height: 683,
          thumbnail: true,
        },
        location: [47.261987, -1.529856],
        genre: 'Ulmus',
        cultivar: 'Jacqueline Hillier',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.529856, 47.261987] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ff4e6b7d7fc536dead4d3de93d698f913b828717',
      fields: {
        espece: 'x hollandica',
        nom_du_site: 'Parc floral de la Beaujoire',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(168, 178, 166, 1.00)',
            'rgba(73, 89, 62, 1.00)',
            'rgba(82, 102, 64, 1.00)',
          ],
          filename:
            "ip parc floral de la beaujoire/ulmus/ulmus x hollandica 'jacqueline hillier'/ulmus x hollandica 'jacqueline hillier' (2).jpg",
          width: 1024,
          id: 'edbb035e0ad4e49b2007c0faf1b58f21',
          height: 683,
          thumbnail: true,
        },
        location: [47.261976, -1.52987],
        genre: 'Ulmus',
        cultivar: 'Jacqueline Hillier',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.52987, 47.261976] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3904538672d900d17e7a2a4d683da58c0cf852ea',
      fields: {
        nom_du_site: 'Parc de Proc\u00e9',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 123, 100, 1.00)',
            'rgba(119, 129, 90, 1.00)',
            'rgba(136, 138, 105, 1.00)',
          ],
          filename:
            "ip parc de proce/x rhaphiobotrya/x rhaphiobotrya 'coppertone'/x rhaphiobotrya 'coppertone' (2).jpg",
          width: 1024,
          id: 'dc349d900500117c8956dbb07e5bc2f2',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(48, 51, 36, 1.00)',
            'rgba(114, 111, 88, 1.00)',
            'rgba(140, 135, 99, 1.00)',
          ],
          filename:
            "ip parc de proce/x rhaphiobotrya/x rhaphiobotrya 'coppertone'/x rhaphiobotrya 'coppertone' (3).jpg",
          width: 576,
          id: '7f7d3aaebb8596610c817b4ae1be201e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 87, 61, 1.00)',
            'rgba(140, 126, 92, 1.00)',
            'rgba(78, 82, 45, 1.00)',
          ],
          filename:
            "ip parc de proce/x rhaphiobotrya/x rhaphiobotrya 'coppertone'/x rhaphiobotrya 'coppertone' (1).jpg",
          width: 576,
          id: '14c268546bc04095c5a8804392559b1d',
          height: 768,
          thumbnail: true,
        },
        location: [47.22295, -1.580788],
        genre: 'x Rhaphiobotrya',
        cultivar: 'Coppertone',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580788, 47.22295] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a88a3ad61c2a10600e5643c168cda21fde149cca',
      fields: {
        espece: 'serrata',
        nom_du_site: 'Parc de Proc\u00e9',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 160, 149, 1.00)',
            'rgba(100, 117, 81, 1.00)',
            'rgba(103, 121, 80, 1.00)',
          ],
          filename:
            'ip parc de proce/zelkova/zelkova serrata/zelkova serrata (2).jpg',
          width: 1024,
          id: '187fd80e439ce3e99503f7768ae165a0',
          height: 768,
          thumbnail: true,
        },
        location: [47.223122, -1.581567],
        genre: 'Zelkova',
        famille: 'Ulmaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581567, 47.223122] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dfd397cc6972dbe1db58583a917d65f238cc4788',
      fields: {
        origine: 'J.B. Bayreuth (Allemagne)',
        espece: 'hyperaizoon Komarov',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Sedum',
        date_plantation: '2011',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e8eb0c5bfb0c4ffa3dc6280a0ef82054efcd4a93',
      fields: {
        origine: 'J.B. Munchen (Allemagne)',
        espece: 'sempervivum (M.Bieb.) A.Berger',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Rosularia',
        date_plantation: '2011',
        cultivar: 'libanotica (Labill.) Eggli',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5144cfda64a82c0bfb5a81c2d46dbb51dac7f495',
      fields: {
        origine: 'JB. Osterr-garten, Graz (Autriche)',
        espece: 'ishidae Miyabe & Kud\u00f4',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Sedum',
        date_plantation: '2011',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5a41f8e9c9e8721bbc4c17bedf890ec702c9e202',
      fields: {
        origine: 'JB.Al Pietra Corva (Italie)',
        espece: 'rupestre L.',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Sedum',
        date_plantation: '2004',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'be2a35ac53420c0a174c462bc5a9b4b44db9ed95',
      fields: {
        origine: 'Universit\u00e9 de Bayreuth (Allemagne)',
        espece: 'caucasicum Boriss.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Sedum',
        date_plantation: '2011',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '356eca4fb20bc66e30ba6d3e60d03f9de12f902c',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'elaterium',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 143, 75, 1.00)',
            'rgba(98, 139, 95, 1.00)',
            'rgba(99, 135, 92, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/ecballium [cucurbitaceae]/ecballium elaterium/ecballium elaterium (2).jpg",
          width: 576,
          id: '031feae215177a9b1ee4d7e68e1eb625',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 124, 80, 1.00)',
            'rgba(98, 131, 89, 1.00)',
            'rgba(72, 111, 59, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/ecballium [cucurbitaceae]/ecballium elaterium/ecballium elaterium (3).jpg",
          width: 576,
          id: '70c6c52b31185b3700973c857a9ed8ac',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(60, 89, 62, 1.00)',
            'rgba(93, 114, 60, 1.00)',
            'rgba(89, 113, 74, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/ecballium [cucurbitaceae]/ecballium elaterium/ecballium elaterium (1).jpg",
          width: 576,
          id: 'effdc445360985309f68f729a4e237ee',
          height: 768,
          thumbnail: true,
        },
        location: [47.226937, -1.512488],
        genre: 'Ecballium',
        famille: 'Cucurbitaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512488, 47.226937] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b2dcddb9324b30cfad688eb72313261af83ac5c3',
      fields: {
        espece: 'cashmeriana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(191, 195, 194, 1.00)',
            'rgba(90, 88, 49, 1.00)',
            'rgba(95, 84, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cupressus [cupressaceae]/cupressus cashmeriana 'blue wave'/cupressus cashmeriana 'blue wave' (2).jpg",
          width: 576,
          id: 'c31dab442795516e86e5f09dc6f46344',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 151, 106, 1.00)',
            'rgba(147, 146, 111, 1.00)',
            'rgba(155, 141, 112, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cupressus [cupressaceae]/cupressus cashmeriana 'blue wave'/cupressus cashmeriana 'blue wave' (1).jpg",
          width: 576,
          id: '49e8bbb8a1cfe40d281f677d7586e0d2',
          height: 768,
          thumbnail: true,
        },
        location: [47.271958, -1.582528],
        genre: 'Cupressus',
        cultivar: 'Blue Wave',
        famille: 'Cupressaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582528, 47.271958] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '001276764e6d79141a22a4992f5a4b83b5aee9fd',
      fields: {
        espece: 'glyptostroboides',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Metasequoia',
        date_plantation: '1955',
        famille: 'Cupressaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '765dca8e2168a351a7898727513b161caa83de35',
      fields: {
        origine: "Museum National d'Histoire de Paris",
        espece: 'sylvatica Huds.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Carex',
        date_plantation: '2006',
        famille: 'Cyperaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '592fd6a6dde1ff0fce1864797fb3492458a47bc4',
      fields: {
        origine: 'p\u00e9pini\u00e8re Ellebore',
        espece: 'rubra Colenso',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Uncinia',
        date_plantation: '2015',
        famille: 'Cyperaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c79476bc47274fe96ca94d42fb34fa88e821703f',
      fields: {
        espece: 'setiferum Woynar',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Polystichium',
        date_plantation: '1973',
        famille: 'Dryopteridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f22e07daa373a39b9f99a84a11d45269d52857ee',
      fields: {
        espece: 'unedo f. rubra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 151, 82, 1.00)',
            'rgba(131, 126, 84, 1.00)',
            'rgba(82, 91, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus unedo f. rubra/arbutus unedo f. rubra (2).jpg',
          width: 576,
          id: '248c81991db0ca259b18af5884ec3ae6',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 130, 99, 1.00)',
            'rgba(109, 130, 113, 1.00)',
            'rgba(47, 97, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus unedo f. rubra/arbutus unedo f. rubra (1).jpg',
          width: 576,
          id: 'd66e5528963abcef99d80fa4f80cd055',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Arbutus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ad0a4508c0bc520fde20ef1825f4a9459463ee9d',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 137, 75, 1.00)',
            'rgba(102, 118, 55, 1.00)',
            'rgba(120, 121, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus x reyorum 'marina'/arbutus x reyorum 'marina' (4).jpg",
          width: 576,
          id: '7893f00c7b20334f62e1bcb41910e9a9',
          height: 768,
          thumbnail: true,
        },
        espece: 'x reyorum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(121, 150, 73, 1.00)',
            'rgba(95, 143, 30, 1.00)',
            'rgba(105, 145, 36, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus x reyorum 'marina'/arbutus x reyorum 'marina' (2).jpg",
          width: 576,
          id: '17afef6e6747c362c149b0f65a95df30',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 131, 82, 1.00)',
            'rgba(155, 140, 97, 1.00)',
            'rgba(161, 136, 107, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus x reyorum 'marina'/arbutus x reyorum 'marina' (1).jpg",
          width: 576,
          id: 'c37952c256aa4aa854f82ad3b7035f4f',
          height: 768,
          thumbnail: true,
        },
        location: [47.270812, -1.582238],
        genre: 'Arbutus',
        cultivar: 'Marina',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582238, 47.270812] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8efa77409573ce9da7468a7f0c3cd7139146e902',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x thuretiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 144, 147, 1.00)',
            'rgba(80, 83, 66, 1.00)',
            'rgba(101, 92, 81, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus x thuretiana/arbutus x thuretiana (2).jpg',
          width: 1024,
          id: '121a3aa01578e68c1b527b748bfc6a50',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 90, 80, 1.00)',
            'rgba(117, 107, 95, 1.00)',
            'rgba(104, 88, 82, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus x thuretiana/arbutus x thuretiana (3).jpg',
          width: 1024,
          id: 'a6b059b971d484661f9a72b497825a6b',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 93, 76, 1.00)',
            'rgba(99, 112, 83, 1.00)',
            'rgba(75, 90, 64, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/arbutus [ericaceae]/arbutus x thuretiana/arbutus x thuretiana (1).jpg',
          width: 1024,
          id: '6af7d1dc8a9e69579b3d8204297d5180',
          height: 683,
          thumbnail: true,
        },
        location: [47.270246, -1.586047],
        genre: 'Arbutus',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586047, 47.270246] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1101075f7c710751dd0b087cb1291c724cd62152',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'fontanesiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 82, 48, 1.00)',
            'rgba(96, 114, 79, 1.00)',
            'rgba(98, 106, 71, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/leucothoe [ericaceae]/leucothoe fontanesiana/leucothoe fontanesiana (2).jpg',
          width: 576,
          id: '83fb3b54d61b567d36834cad55908359',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 93, 47, 1.00)',
            'rgba(86, 98, 63, 1.00)',
            'rgba(57, 61, 40, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/leucothoe [ericaceae]/leucothoe fontanesiana/leucothoe fontanesiana (3).jpg',
          width: 576,
          id: '66266270e5e3081572a71402241da625',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 107, 104, 1.00)',
            'rgba(147, 104, 111, 1.00)',
            'rgba(128, 100, 93, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/leucothoe [ericaceae]/leucothoe fontanesiana/leucothoe fontanesiana (1).jpg',
          width: 576,
          id: '6132ea57d562a40b92e2f415c1173b29',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Leucothoe',
        famille: 'Ericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8b0a67f0cb021a63c48b711f20d0ff8226edff7c',
      fields: {
        espece: 'coca',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 138, 27, 1.00)',
            'rgba(124, 134, 40, 1.00)',
            'rgba(116, 134, 44, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/erythroxylum [erythroxylaceae]/erythroxylum coca/erythroxylum coca.jpg",
          width: 576,
          id: '28c0ad85cc23d9c0211d678b426482c5',
          height: 768,
          thumbnail: true,
        },
        location: [47.226925, -1.511897],
        genre: 'Erythroxylum',
        famille: 'Erythroxylaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.511897, 47.226925] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '73940f05833fac0f07fadb67cf937fde708ebcda',
      fields: {
        origine: 'Jardin botanique alpin Murmansk',
        espece: 'frolovii Rupr.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Lathyrus',
        date_plantation: '2010',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5261ca9b097aeeada5c7a94d024240742e757a9d',
      fields: {
        origine: 'Conservatoire botanique de Gen\u00e8ve (Suisse)',
        espece: 'vesicarius L.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Astragalus',
        date_plantation: '2009',
        cultivar: 'carniolicus Chater',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c388b12ff8c54d40969b01befd09a321be9948ed',
      fields: {
        origine: 'JB.Bern (Suisse)',
        espece: 'vulneraria L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Anthyllis',
        date_plantation: '2006',
        cultivar: 'alpestris Ascherson & Graebner',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '18a47362b92469777b3f4f387a137624fdcef456',
      fields: {
        origine: 'Sichtungsgartens Hermannshof Weinheim (All.)',
        espece: 'purpurea Vent.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Dalea',
        date_plantation: '2014',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3e1ba86a6be3484f7ca19709204d42dbc6a0c2f0',
      fields: {
        espece: 'sinensis',
        localisation: 'A5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2207668, -1.5440149],
        genre: 'Wisteria',
        date_plantation: '1973',
        famille: 'Fabaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440149, 47.2207668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9519b82b76df2543fe9b77053cb9fb5e187315e4',
      fields: {
        origine: 'Arb.The Morton Lisle (U.S.A.)',
        espece: 'imbricaria',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Quercus',
        date_plantation: '2005',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd51ee542575dd49e47d5e665819ab4fa4355698f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'sativa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 143, 95, 1.00)',
            'rgba(105, 146, 87, 1.00)',
            'rgba(99, 137, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/castanea [fagaceae]/castanea sativa/castanea sativa (2).jpg',
          width: 576,
          id: '6dbaf0d7b8a5d2bacfd84b6e9e3d3bdc',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 122, 104, 1.00)',
            'rgba(55, 75, 49, 1.00)',
            'rgba(62, 75, 45, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/castanea [fagaceae]/castanea sativa/castanea sativa (3).jpg',
          width: 680,
          id: 'f267d1579250b62e2efe8ebf13708dbf',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 120, 68, 1.00)',
            'rgba(108, 138, 61, 1.00)',
            'rgba(100, 123, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/castanea [fagaceae]/castanea sativa/castanea sativa (1).jpg',
          width: 576,
          id: 'e0d8f5c21d9c1f848d31cdb2b89064d5',
          height: 768,
          thumbnail: true,
        },
        location: [47.269372, -1.582475],
        genre: 'Castanea',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582475, 47.269372] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '187a1bcfe83f785d4bd30b15a2e03b7d19ea75e0',
      fields: {
        espece: 'sylvatica',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 140, 101, 1.00)',
            'rgba(106, 97, 53, 1.00)',
            'rgba(68, 66, 41, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fagus [fagaceae]/fagus sylvatica 'aspleniifolia'/fagus sylvatica 'aspleniifolia'.jpg",
          width: 953,
          id: '4118743770121cadc8b06316fa74742e',
          height: 768,
          thumbnail: true,
        },
        location: [47.27005, -1.585033],
        genre: 'Fagus',
        cultivar: 'Aspleniifolia',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585033, 47.27005] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ea8c6c76d4ccf8365578ad74d13ce30f40637238',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'agrifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 161, 156, 1.00)',
            'rgba(125, 141, 126, 1.00)',
            'rgba(100, 121, 91, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus agrifolia/quercus agrifolia (3).jpg',
          width: 576,
          id: '62eb76fd130b98bd02a0aa6120c59c93',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 124, 117, 1.00)',
            'rgba(127, 130, 122, 1.00)',
            'rgba(117, 118, 109, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus agrifolia/quercus agrifolia (6).jpg',
          width: 576,
          id: 'b39be249c0823713fc02c778f203f549',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 128, 117, 1.00)',
            'rgba(126, 138, 127, 1.00)',
            'rgba(130, 123, 115, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus agrifolia/quercus agrifolia (2).jpg',
          width: 576,
          id: '55dca1ae7dc7fa6bb556d323ce34a547',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '59dbb166c28a4aa39481f138ddd95852e9d55256',
      fields: {
        espece: 'arkansana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 148, 145, 1.00)',
            'rgba(113, 117, 100, 1.00)',
            'rgba(125, 126, 113, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus arkansana/quercus arkansana (3).jpg',
          width: 670,
          id: '1149ad57688e329c8778f9efc288ffdf',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 148, 141, 1.00)',
            'rgba(126, 131, 116, 1.00)',
            'rgba(85, 90, 79, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus arkansana/quercus arkansana (2).jpg',
          width: 576,
          id: '62077cec1d354ecc00f8460895b59bc5',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3748986b589a3acfc5952f64b691179473b258e3',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'canariensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 95, 71, 1.00)',
            'rgba(111, 123, 111, 1.00)',
            'rgba(98, 96, 80, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus canariensis/quercus canariensis (12).jpg',
          width: 576,
          id: 'fdca25428b7311202592362c81ecefae',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 150, 169, 1.00)',
            'rgba(111, 116, 105, 1.00)',
            'rgba(64, 62, 42, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus canariensis/quercus canariensis (2).jpg',
          width: 1024,
          id: '519821b24cd57283873e2d73fe6a1252',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 124, 93, 1.00)',
            'rgba(99, 127, 105, 1.00)',
            'rgba(93, 104, 80, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus canariensis/quercus canariensis (11).jpg',
          width: 576,
          id: '41f448d7ada5e4395aa93dc8be08b7db',
          height: 768,
          thumbnail: true,
        },
        location: [47.27, -1.581928],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581928, 47.27] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c2e7b2f7bc082a984dab28fc2229a439f00e86ae',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'glauca',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 112, 51, 1.00)',
            'rgba(111, 148, 47, 1.00)',
            'rgba(88, 114, 27, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus glauca/quercus glauca (2).jpg',
          width: 576,
          id: '0ce78c54b96d55bd3c86c7fa7d580011',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 128, 121, 1.00)',
            'rgba(137, 140, 135, 1.00)',
            'rgba(128, 131, 125, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus glauca/quercus glauca (3).jpg',
          width: 576,
          id: '79670985367df80359d60da9d97e1d99',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 139, 119, 1.00)',
            'rgba(119, 127, 91, 1.00)',
            'rgba(91, 109, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus glauca/quercus glauca  (2).jpg',
          width: 576,
          id: '9e892de473c1005b0632c974f7c1ab3d',
          height: 768,
          thumbnail: true,
        },
        location: [47.270363, -1.582067],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582067, 47.270363] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '38fed60ab8bf41778ee9bc38bfd15df5445a6703',
      fields: {
        espece: 'rubra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 117, 98, 1.00)',
            'rgba(113, 115, 115, 1.00)',
            'rgba(108, 113, 105, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/quercus [fagaceae]/quercus rubra 'aurea'/quercus rubra 'aurea' (5).jpg",
          width: 512,
          id: '652eb42545e1c598c9b6b6432200870e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 125, 111, 1.00)',
            'rgba(120, 122, 105, 1.00)',
            'rgba(114, 120, 116, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/quercus [fagaceae]/quercus rubra 'aurea'/quercus rubra 'aurea' (4).jpg",
          width: 512,
          id: 'f76247c59b8be0edbffffd064a54e3c2',
          height: 768,
          thumbnail: true,
        },
        location: [47.271217, -1.581072],
        genre: 'Quercus',
        cultivar: 'Aurea',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581072, 47.271217] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9a678bfd08027bc7d0c27f8246b75c5e32d39506',
      fields: {
        espece: 'variabilis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 149, 168, 1.00)',
            'rgba(142, 143, 138, 1.00)',
            'rgba(88, 77, 47, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus variabilis/quercus variabilis (2).jpg',
          width: 576,
          id: '09a138070c2e4fcd989379acdfa49e51',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 123, 106, 1.00)',
            'rgba(139, 130, 111, 1.00)',
            'rgba(150, 140, 120, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/quercus [fagaceae]/quercus variabilis/quercus variabilis (1).jpg',
          width: 621,
          id: 'ac76cdb5c6b8d9eb2168478f02d2ddb3',
          height: 768,
          thumbnail: true,
        },
        location: [47.27002, -1.584695],
        genre: 'Quercus',
        famille: 'Fagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584695, 47.27002] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '53b3314419a3d68e937d0684edac73704114fa74',
      fields: {
        origine: "P\u00e9pini\u00e8res du Val d'Erdre",
        espece: 'biloba',
        localisation: 'B1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2204652, -1.544656],
        genre: 'Ginkgo',
        date_plantation: '2015',
        famille: 'Ginkgoaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544656, 47.2204652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '46e15ec82dba6638a0d9549c60824a19655566ea',
      fields: {
        origine: 'JB.Helsinki (Finlande)',
        espece: 'schrenkii',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Philadelphus',
        date_plantation: '1995',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1a099cad036f971f7f76efd9b14e27f4fc1db258',
      fields: {
        origine: 'JBU.Berkeley (U.S.A.)',
        espece: 'lewisii',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Philadelphus',
        date_plantation: '2004',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'edcf5559d3e5255270e6c0807fd1b3e373c1845b',
      fields: {
        origine: 'JBU.Chiba Matsudo (Japon)',
        espece: 'satsumi',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Philadelphus',
        date_plantation: '2006',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c7295e233199cefa52454b6af4d60b9014025839',
      fields: {
        espece: 'gracilis',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 132, 103, 1.00)',
            'rgba(139, 144, 121, 1.00)',
            'rgba(96, 106, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia gracilis/deutzia gracilis.jpg',
          width: 1024,
          id: '43f2a8127b02d53e19af44c683d243b1',
          height: 768,
          thumbnail: true,
        },
        location: [47.271037, -1.585072],
        genre: 'Deutzia',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585072, 47.271037] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '787b7715137005bbc5d009c432c2482782a16d76',
      fields: {
        espece: 'scabra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 105, 78, 1.00)',
            'rgba(109, 125, 91, 1.00)',
            'rgba(101, 114, 82, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia scabra 'azaleiflora'/deutzia scabra 'azaleiflora' (2).jpg",
          width: 576,
          id: 'b6da700e1d49c3bdc0e00c801d45fb04',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 82, 38, 1.00)',
            'rgba(108, 137, 71, 1.00)',
            'rgba(145, 149, 111, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/deutzia [hydrangeaceae]/deutzia scabra 'azaleiflora'/deutzia scabra 'azaleiflora' (1).jpg",
          width: 1024,
          id: 'ee05e267d610439d1069778c85f7187e',
          height: 768,
          thumbnail: true,
        },
        location: [47.27073, -1.586597],
        genre: 'Deutzia',
        cultivar: 'Azaleiflora',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586597, 47.27073] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '51692282b3aef4b7a33650a250c5d7b01e0f3882',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'quercifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 140, 93, 1.00)',
            'rgba(126, 145, 71, 1.00)',
            'rgba(93, 108, 43, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hydrangea [hydrangeaceae]/hydrangea quercifolia/hydrangea quercifolia (4).jpg',
          width: 1024,
          id: '4437d4fdc60bd56cbc6ac28b5089554f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(78, 94, 46, 1.00)',
            'rgba(142, 147, 115, 1.00)',
            'rgba(68, 77, 33, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hydrangea [hydrangeaceae]/hydrangea quercifolia/hydrangea quercifolia (5).jpg',
          width: 1024,
          id: '1a83c9d36c71dbfd0f0b7314ac71d578',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(45, 70, 18, 1.00)',
            'rgba(90, 127, 37, 1.00)',
            'rgba(91, 123, 29, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hydrangea [hydrangeaceae]/hydrangea quercifolia/hydrangea quercifolia (3).jpg',
          width: 576,
          id: 'fd5c9279b117f00fc25cf68acb908639',
          height: 768,
          thumbnail: true,
        },
        location: [47.270805, -1.582345],
        genre: 'Hydrangea',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582345, 47.270805] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dc59d32f70c208901a5fb913aa06a06ba3132991',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 132, 87, 1.00)',
            'rgba(77, 105, 60, 1.00)',
            'rgba(76, 107, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus 'belle etoile'/philadelphus 'belle etoile' (1).jpg",
          width: 1024,
          id: '977def51c6275405a0003849c5767792',
          height: 683,
          thumbnail: true,
        },
        location: [47.271306, -1.586203],
        genre: 'Philadelphus',
        cultivar: 'Belle Etoile',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586203, 47.271306] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b9a34c285140aebe22ecf7a87638ee56a4b5be0b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'rosiflorus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 91, 54, 1.00)',
            'rgba(81, 123, 57, 1.00)',
            'rgba(76, 111, 51, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus rosiflorus/philadelphus rosiflorus (2).jpg',
          width: 576,
          id: '0714da7fabd538c204e0eb9062ecfd94',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(52, 73, 52, 1.00)',
            'rgba(75, 97, 65, 1.00)',
            'rgba(69, 90, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus rosiflorus/philadelphus rosiflorus.jpg',
          width: 624,
          id: '4d6713ae3f24e2cbffec9ca1ab0bad8a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(45, 70, 36, 1.00)',
            'rgba(110, 131, 99, 1.00)',
            'rgba(65, 90, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/philadelphus [hydrangeaceae]/philadelphus rosiflorus/philadelphus rosiflorus (1).jpg',
          width: 576,
          id: 'cc976b7f590fdd2e10b400c916a8f2bb',
          height: 768,
          thumbnail: true,
        },
        location: [47.271338, -1.5852],
        genre: 'Philadelphus',
        famille: 'Hydrangeaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5852, 47.271338] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a55ed3b61713af82297a2a4b739e18251e65ced4',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 118, 43, 1.00)',
            'rgba(122, 131, 51, 1.00)',
            'rgba(126, 134, 62, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hypericum [hypericaceae]/hypericum x hidcoteense 'hidcote'/hypericum x hidcoteense 'hidcote'.jpg",
          width: 1024,
          id: '949e7aefa519ab909bc5ac6c792c1780',
          height: 768,
          thumbnail: true,
        },
        espece: 'x hidcoteense',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 88, 51, 1.00)',
            'rgba(72, 99, 63, 1.00)',
            'rgba(88, 108, 63, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hypericum [hypericaceae]/hypericum x hidcoteense 'hidcote'/hypericum x hidcoteense 'hidcote' (3).jpg",
          width: 713,
          id: '3235cfc648357a2d8558103145a82657',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 131, 77, 1.00)',
            'rgba(170, 146, 14, 1.00)',
            'rgba(103, 106, 13, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hypericum [hypericaceae]/hypericum x hidcoteense 'hidcote'/hypericum x hidcoteense 'hidcote' (1).jpg",
          width: 576,
          id: 'f1e59c8e079052a56bab025bda666984',
          height: 768,
          thumbnail: true,
        },
        location: [47.270578, -1.584587],
        genre: 'Hypericum',
        cultivar: 'Hidcote',
        famille: 'Hypericaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584587, 47.270578] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c57dbf08b3914345bb35afd806b4bb7f4dfeb64f',
      fields: {
        origine: 'Jardin botanique G\u00f6teborg',
        espece: 'vernus All.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Crocus',
        date_plantation: '2010',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c47e8a91b94e9d967bea4e18cc69b31f7b505285',
      fields: {
        origine: 'Jardin botanique universit\u00e9 Kawauchi Sendai',
        espece: 'sanguinea Hornem.',
        localisation: 'I2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185657, -1.5426599],
        genre: 'Iris',
        date_plantation: '2010',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426599, 47.2185657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cc05334bf4e38b247fe0866bee6feb0ddb56576e',
      fields: {
        origine: 'B.G. Zurich (Suise)',
        espece: 'dracomontanum Hilliard',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Dierama',
        date_plantation: '2014',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0579d855005aae81cd180bf2b67212b23cf4984b',
      fields: {
        origine: 'J.B. Zurich (Suisse)',
        espece: 'multiflorus Sweet',
        localisation: 'G2A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2197208, -1.5414609],
        genre: 'Orthrosanthus',
        date_plantation: '2011',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5414609, 47.2197208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '32f6f26b98a10c0c4d1dea6ee227db6c7519ce8f',
      fields: {
        origine: 'Jardin Botanique Porrentruy, Porrentruy, Suisse',
        espece: 'bellum S.Watson',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Sisyrinchium',
        date_plantation: '2012',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '76d9115fff5c9dcf7a3f685f06943305ad2b9083',
      fields: {
        origine: 'Jardin botanique Prague',
        espece: 'magnifica Vved.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Iris',
        date_plantation: '2010',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e5e41bf7f6e0fec78f38395dfee6211932fc4616',
      fields: {
        origine: 'p\u00e9pini\u00e8re Ellebore',
        espece: 'pulcherrimum Baker',
        localisation: 'I2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185657, -1.5426599],
        genre: 'Dierama',
        date_plantation: '2015',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426599, 47.2185657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8234ee8df56cdf37f2b0cd7a5fbbfe58453ae274',
      fields: {
        origine: 'Universitatea de Stiinte Agricole,Cluj-Napoca,Roumanie',
        espece: 'delavayi M.Micheli',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Iris',
        date_plantation: '2013',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '560a92c0e89e8ad9afca0cc496a77d3c1d8835d5',
      fields: {
        origine: 'Universitatea de Stiinte Agricole,Cluj-Napoca,Roumanie',
        espece: 'missouriensis Nutt.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Iris',
        date_plantation: '2013',
        famille: 'Iridaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '77516fb5c8968801932ed66e8a75a0f9018bd7e9',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'strobilacea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 139, 126, 1.00)',
            'rgba(129, 130, 104, 1.00)',
            'rgba(125, 128, 117, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/platycarya [juglandaceae]/platycarya strobilacea/platycarya strobilacea (15).jpg',
          width: 512,
          id: 'dfcda57f9265c8651bc2185fa4bce411',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 166, 163, 1.00)',
            'rgba(125, 134, 101, 1.00)',
            'rgba(95, 98, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/platycarya [juglandaceae]/platycarya strobilacea/platycarya strobilacea (18).jpg',
          width: 1024,
          id: 'c421cbc9ad8edaef4c351e8dbac27c5e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 165, 87, 1.00)',
            'rgba(115, 129, 52, 1.00)',
            'rgba(98, 120, 36, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/platycarya [juglandaceae]/platycarya strobilacea/platycarya strobilacea (1).jpg',
          width: 576,
          id: '2e56b6440e2e91b7818121365fdb5042',
          height: 768,
          thumbnail: true,
        },
        location: [47.270838, -1.585972],
        genre: 'Platycarya',
        famille: 'Juglandaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585972, 47.270838] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fd0ee3ae6f01e922ebbab12bf50c78c5cabdf6ea',
      fields: {
        espece: 'strobilacea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(176, 187, 173, 1.00)',
            'rgba(132, 137, 79, 1.00)',
            'rgba(64, 67, 28, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/platycarya [juglandaceae]/platycarya strobilacea/platycarya strobilacea (9).jpg',
          width: 1024,
          id: 'fbbcf5a8f6d995d2bb60d389434a318d',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 144, 175, 1.00)',
            'rgba(122, 116, 109, 1.00)',
            'rgba(76, 63, 40, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/platycarya [juglandaceae]/platycarya strobilacea/platycarya strobilacea (10).jpg',
          width: 1024,
          id: '51272f06c021a693db55c72ce9460d30',
          height: 683,
          thumbnail: true,
        },
        location: [47.271172, -1.586092],
        genre: 'Platycarya',
        famille: 'Juglandaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586092, 47.271172] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ab05e89dbece683a45779876a30e3b8accf54b99',
      fields: {
        origine: 'JB. de la Chanousia, Torino seez (Italie/France)',
        espece: 'alpinopilosa Breistr.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Luzula',
        date_plantation: '2011',
        famille: 'Juncaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '88352c04b8edbcbd6baed9442d042f5e615badac',
      fields: {
        origine: 'Ets.Lepage',
        espece: 'samia L.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Phlomis',
        date_plantation: '1986',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '705a17275e324d621f97c59f9e22173f888cede7',
      fields: {
        origine: 'J.Alp.U.Insbruck (Autriche)',
        espece: 'rotundifolium Boiss.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Origanum',
        date_plantation: '2006',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '26e10c8b69c4804b1d9458f1e480afdf68f52a8e',
      fields: {
        origine: 'JB. Greifswald (Allemagne)',
        espece: 'officinalis L.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Betonica',
        date_plantation: '2011',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ddcc95f44875df5d9d3f4e9a0c39c09958065888',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'tesquicola  Klokov et Pobed',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Salvia',
        date_plantation: '2008',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '55f7c1efb65e968796edd36f747651c1a1a2e3b9',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'montanum L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Teucrium',
        date_plantation: '2006',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '16dcb949d90236cdc86ec896a980464ef93cc5e9',
      fields: {
        origine: 'JB.Przemyl (Pologne)',
        espece: 'montana  L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Satureja',
        date_plantation: '2008',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b1eacd9bfa5cb4cce841b22eca3a0ea72cc65497',
      fields: {
        origine: 'JB.Yeomjii (Cor\u00e9e)',
        espece: 'multicaule Kuntze',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Clinopodium',
        date_plantation: '2008',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f93d61059192dac70ad6bb68062becb7e5a83605',
      fields: {
        origine: 'JBU.East Lansing (USA)',
        espece: 'virginianum Pers.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Pycnanthemum',
        date_plantation: '2001',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5c59ad8ba91729e04acff5f733ef9aa6a305eb66',
      fields: {
        espece: 'galeobdolon Crantz',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Lamium',
        date_plantation: '1973',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '93cc1cbaf3f5cb2c7bd3ae128c3cafc4ba143451',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'elegans',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 135, 74, 1.00)',
            'rgba(133, 144, 71, 1.00)',
            'rgba(119, 139, 62, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/salvia [lamiaceae]/salvia elegans/salvia elegans (2).jpg",
          width: 576,
          id: '1cabf10c10eb9d0a5db98299c2847e04',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(199, 183, 180, 1.00)',
            'rgba(142, 128, 90, 1.00)',
            'rgba(113, 99, 55, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/salvia [lamiaceae]/salvia elegans/salvia elegans (3).jpg",
          width: 820,
          id: '27216a5cc3c1eb7b88fa1610ab8e7336',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(178, 160, 162, 1.00)',
            'rgba(150, 108, 85, 1.00)',
            'rgba(103, 104, 52, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/salvia [lamiaceae]/salvia elegans/salvia elegans (1).jpg",
          width: 576,
          id: 'e76de49a3d2bec5dcbeab99871f82f53',
          height: 768,
          thumbnail: true,
        },
        location: [47.226437, -1.512467],
        genre: 'Salvia',
        famille: 'Lamiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512467, 47.226437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '02a7c93363689cf7bb2a6c9da25b53823567eaf8',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'aciculata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 81, 43, 1.00)',
            'rgba(132, 131, 71, 1.00)',
            'rgba(109, 109, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/neolitsea [lauraceae]/neolitsea aciculata/neolitsea aciculata  (2).jpg',
          width: 1024,
          id: '423757d39979bac3d6edcbcbb9999ad9',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(171, 152, 103, 1.00)',
            'rgba(159, 117, 74, 1.00)',
            'rgba(128, 125, 51, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/neolitsea [lauraceae]/neolitsea aciculata/neolitsea aciculata (2).jpg',
          width: 576,
          id: 'd369fe29ed359242f7f1e663930062b9',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(42, 57, 27, 1.00)',
            'rgba(130, 133, 78, 1.00)',
            'rgba(154, 146, 116, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/neolitsea [lauraceae]/neolitsea aciculata/neolitsea aciculata  (1).jpg',
          width: 512,
          id: '2771d6070b470214ff40c62f9c7348cb',
          height: 768,
          thumbnail: true,
        },
        location: [47.270637, -1.580803],
        genre: 'Neolitsea',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580803, 47.270637] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b60c8b7cc70c39fcdbc34bb708d3608c50ceaac6',
      fields: {
        espece: 'californica',
        localisation: 'A5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2207668, -1.5440149],
        genre: 'Umbellularia',
        date_plantation: '1973',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440149, 47.2207668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c77bddbe158633b6ba7bc61ffe4d9e930dea27ce',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'californica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 140, 101, 1.00)',
            'rgba(123, 140, 99, 1.00)',
            'rgba(139, 141, 121, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/umbellularia [lauraceae]/umbellularia californica/umbellularia californica (2).jpg',
          width: 576,
          id: 'ba2d781c56f6a8bdaa2025d6c0f9f896',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 129, 83, 1.00)',
            'rgba(106, 140, 78, 1.00)',
            'rgba(130, 157, 109, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/umbellularia [lauraceae]/umbellularia californica/umbellularia californica (3).jpg',
          width: 576,
          id: '411fcb0a8d6e546780444a7b7a9bb426',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 143, 112, 1.00)',
            'rgba(117, 137, 83, 1.00)',
            'rgba(97, 113, 77, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/umbellularia [lauraceae]/umbellularia californica/umbellularia californica (1).jpg',
          width: 576,
          id: 'd8bb0f5b35fb2a204c026e66e48c5f66',
          height: 768,
          thumbnail: true,
        },
        location: [47.270183, -1.584133],
        genre: 'Umbellularia',
        famille: 'Lauraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584133, 47.270183] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6d2e4c951eddd1b46eddf757f182ec7c5a03b414',
      fields: {
        origine: 'Amur Branch of B.G. (Russie)',
        espece: 'pumilum Delile',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Lilium',
        date_plantation: '2014',
        famille: 'Liliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cb9bdadee0d96a685b5dd5db59358b0eeee69d5d',
      fields: {
        origine: 'J.B. Alpin Di Pietra Corva,Pavia,Italie',
        espece: 'montana Hoppe & Koch.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Fritillaria',
        date_plantation: '2010',
        famille: 'Liliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f6379e76b7ed60156eadbb1e7218616cf24b157f',
      fields: {
        origine: 'Jardin botanique-Institut FEB RASVladivostok (Russie)',
        espece: 'pensylvanicum Ker.Gawl.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Lilium',
        date_plantation: '2010',
        famille: 'Liliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8e6e70cf8a67cf3b208409f767b2aa669515976f',
      fields: {
        origine: 'p\u00e9pini\u00e8re Ellebore',
        espece: 'giganteum Makino',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Cardiocrinum',
        date_plantation: '2015',
        famille: 'Liliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4469c94114e651399f82e9afb2dc8ca67f753bd5',
      fields: {
        origine: 'Grugapark Essen (Allemagne)',
        espece: 'virgatum L.',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Lythrum',
        date_plantation: '1987',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '40fbaffc85988cf51da03e956703544f70ba1c56',
      fields: {
        origine: 'R\u00e9colte nature (WLG-PF)',
        espece: 'salicaria L.',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Lythrum',
        date_plantation: '2016',
        famille: 'Lythraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e961865b04840aff8175daa50c895204ef6174c6',
      fields: {
        origine:
          'P\u00e9pini\u00e8res botaniques armoricaines - St Adrien (22)',
        espece: 'laevifolia',
        localisation: 'B1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2204652, -1.544656],
        genre: 'Magnolia',
        date_plantation: '2015',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544656, 47.2204652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '314e61f040c1b58ac96b22304861a743a688d81f',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Gd Blottereau',
        espece: 'stellata',
        localisation: 'B1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2204652, -1.544656],
        genre: 'Magnolia',
        date_plantation: '2015',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.544656, 47.2204652] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '56530fc6bfad948deb87ec01aac8386b871c61d2',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Grand Blottereau',
        espece: 'stellata',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Magnolia',
        date_plantation: '2015',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7258bf824ea231063b02e6131c16451ad099b7c1',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Grand Blottereau',
        espece: 'x grescham',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Magnolia',
        date_plantation: '2015',
        cultivar: 'Heaven scent',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4d95976bc0ae5edf089081961b72eba7ae7e1060',
      fields: {
        espece: 'tulipifera',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Liriodendron',
        date_plantation: '1973',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '68ff274e32c9ebacf6ab059fd6fc87fcafdc8405',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 127, 147, 1.00)',
            'rgba(127, 104, 44, 1.00)',
            'rgba(70, 61, 32, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/liriodendron [magnoliaceae]/liriodendron tulipifera 'jackson'/liriodendron tulipifera 'jackson'  (3).jpg",
          width: 512,
          id: 'dd63e854886f831260fe3001303fcc37',
          height: 768,
          thumbnail: true,
        },
        espece: 'tulipifera',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 146, 112, 1.00)',
            'rgba(124, 140, 74, 1.00)',
            'rgba(105, 118, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/liriodendron [magnoliaceae]/liriodendron tulipifera 'jackson'/liriodendron tulipifera 'jackson'  (2).jpg",
          width: 1024,
          id: '4901f730f6c633126bf66e94f919b7e0',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 138, 39, 1.00)',
            'rgba(150, 163, 34, 1.00)',
            'rgba(131, 148, 25, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/liriodendron [magnoliaceae]/liriodendron tulipifera 'jackson'/liriodendron tulipifera 'jackson'  (1).jpg",
          width: 632,
          id: 'c8a94b3f1492f6afb83cefc38045f274',
          height: 768,
          thumbnail: true,
        },
        location: [47.271397, -1.584567],
        genre: 'Liriodendron',
        cultivar: 'Jackson',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584567, 47.271397] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8f75beaba90d40982efdaed8d5eef5bb57b5a189',
      fields: {
        espece: 'x soulangiana',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Magnolia',
        date_plantation: '1973',
        cultivar: 'Speciosa',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd950809f637f3c124c773cb067824c9bec46b682',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(234, 236, 233, 1.00)',
            'rgba(95, 98, 84, 1.00)',
            'rgba(66, 61, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'crimson stipple'/magnolia 'crimson stipple' (4).jpg",
          width: 576,
          id: '5288e7c53378fb42e04620de3462c380',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 128, 129, 1.00)',
            'rgba(133, 136, 130, 1.00)',
            'rgba(77, 78, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'crimson stipple'/magnolia 'crimson stipple'.jpg",
          width: 576,
          id: 'bc82418350559dc1826602a1418916ef',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 126, 112, 1.00)',
            'rgba(137, 139, 128, 1.00)',
            'rgba(90, 87, 53, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'crimson stipple'/magnolia 'crimson stipple' (3).jpg",
          width: 576,
          id: '62ec61fda1c2c63939905623fc4693c0',
          height: 768,
          thumbnail: true,
        },
        location: [47.269797, -1.581492],
        genre: 'Magnolia',
        cultivar: 'Crimson Stipple',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581492, 47.269797] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '230da57dfe4d2a088d6083aad9107d140a4e0327',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(180, 178, 185, 1.00)',
            'rgba(137, 130, 121, 1.00)',
            'rgba(68, 70, 35, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'floppy'/magnolia 'floppy' (6).jpg",
          width: 1024,
          id: '54846b16a8de616d5156b6027c4d8d5a',
          height: 683,
          thumbnail: true,
        },
        location: [47.271362, -1.584788],
        genre: 'Magnolia',
        cultivar: 'Floppy',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584788, 47.271362] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1fd27b5b1ffa11c811080715a7034c525823716b',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(231, 237, 248, 1.00)',
            'rgba(147, 142, 129, 1.00)',
            'rgba(103, 94, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'peppermint stick'/magnolia 'peppermint stick'   (2).jpg",
          width: 576,
          id: 'cd8c0226dcff65dc3d58e8d380f4a173',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(171, 202, 235, 1.00)',
            'rgba(144, 149, 147, 1.00)',
            'rgba(92, 80, 50, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'peppermint stick'/magnolia 'peppermint stick'  (1).jpg",
          width: 576,
          id: 'dc8aac85bf4835ebd1ccc93ab3e977a3',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 119, 107, 1.00)',
            'rgba(150, 138, 133, 1.00)',
            'rgba(81, 74, 60, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia 'peppermint stick'/magnolia 'peppermint stick'   (1).jpg",
          width: 576,
          id: 'b89cfd8da61701854fb7c0fcb6bd8f5d',
          height: 768,
          thumbnail: true,
        },
        location: [47.271745, -1.582558],
        genre: 'Magnolia',
        cultivar: 'Peppermint Stick',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582558, 47.271745] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd8e8b464f84ede5f17e8f9a6154e0fbd705a3c54',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'denudata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 97, 85, 1.00)',
            'rgba(140, 137, 119, 1.00)',
            'rgba(89, 96, 98, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia denudata/magnolia denudata (3).jpg',
          width: 576,
          id: 'a3db754746f85d0bc7aa936febaafe79',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 99, 138, 1.00)',
            'rgba(123, 111, 58, 1.00)',
            'rgba(63, 57, 26, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia denudata/magnolia denudata (4).jpg',
          width: 512,
          id: 'eb3c8d05028747e6649ae388a4d6ff23',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 83, 61, 1.00)',
            'rgba(143, 135, 122, 1.00)',
            'rgba(144, 147, 143, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia denudata/magnolia denudata (1).jpg',
          width: 576,
          id: '61934c7342803f8a1aed15b3fc940250',
          height: 768,
          thumbnail: true,
        },
        location: [47.270712, -1.58193],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58193, 47.270712] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b4cdd94a2852fd0394bb0053e279424ef254d384',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'Fairy Blush (Micjur01)',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 101, 61, 1.00)',
            'rgba(122, 127, 93, 1.00)',
            'rgba(110, 118, 83, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia fairy blush ('micjur01')/magnolia fairy blush ('micjur01') (4).jpg",
          width: 1024,
          id: '16a9666cc003456bf5da4e2ef76459a2',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 86, 49, 1.00)',
            'rgba(130, 132, 106, 1.00)',
            'rgba(136, 129, 107, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia fairy blush ('micjur01')/magnolia fairy blush ('micjur01') (5).jpg",
          width: 1024,
          id: 'd6a41e3ab43120bda4cfd075f7799bbd',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 116, 84, 1.00)',
            'rgba(120, 132, 88, 1.00)',
            'rgba(111, 122, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia fairy blush ('micjur01')/magnolia fairy blush ('micjur01') (3).jpg",
          width: 1024,
          id: '86103fa4d915c71784aa89baf9e5e171',
          height: 683,
          thumbnail: true,
        },
        location: [47.27051, -1.581145],
        genre: 'Magnolia',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581145, 47.27051] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '357c1cbb4040f0a478e41a9baa3c2063154c4987',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 55, 40, 1.00)',
            'rgba(140, 127, 99, 1.00)',
            'rgba(94, 77, 57, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia kobus 'esveld select'/magnolia kobus 'esveld select' (3).jpg",
          width: 1024,
          id: 'ef8f64789ec36630ae808cbb2b067ca1',
          height: 768,
          thumbnail: true,
        },
        espece: 'kobus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 98, 83, 1.00)',
            'rgba(152, 145, 127, 1.00)',
            'rgba(85, 68, 52, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia kobus 'esveld select'/magnolia kobus 'esveld select' (2).jpg",
          width: 624,
          id: '77d978bdf3324df8215f1de5bfc3e565',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(189, 204, 225, 1.00)',
            'rgba(148, 140, 129, 1.00)',
            'rgba(75, 65, 45, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia kobus 'esveld select'/magnolia kobus 'esveld select' (1).jpg",
          width: 576,
          id: '6c9b86ea724192d8d24233130cd7357c',
          height: 768,
          thumbnail: true,
        },
        location: [47.271692, -1.5829],
        genre: 'Magnolia',
        cultivar: 'Esveld Select',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5829, 47.271692] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '81e394e0dcf65319b9e83ddbfd8ef879b6e2e359',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 138, 97, 1.00)',
            'rgba(121, 124, 93, 1.00)',
            'rgba(105, 106, 78, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia laevifolia 'guillemineau'/magnolia laevifolia 'guillemineau' (1).jpg",
          width: 952,
          id: 'ed08fb2c4c1d85c82075f5fda16cd47e',
          height: 768,
          thumbnail: true,
        },
        espece: 'laevifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 109, 72, 1.00)',
            'rgba(103, 102, 64, 1.00)',
            'rgba(140, 139, 123, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia laevifolia 'guillemineau'/magnolia laevifolia 'guillemineau'  (2).jpg",
          width: 1024,
          id: '012aff3c0b1337ce9a6b3785018d322a',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(88, 95, 56, 1.00)',
            'rgba(101, 95, 55, 1.00)',
            'rgba(142, 129, 91, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia laevifolia 'guillemineau'/magnolia laevifolia 'guillemineau'  (1).jpg",
          width: 1024,
          id: '3c4e508bd564250227992f5fc912fee9',
          height: 683,
          thumbnail: true,
        },
        location: [47.2706, -1.581055],
        genre: 'Magnolia',
        cultivar: 'Guillemineau',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581055, 47.2706] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5c8ad8031ff0bf5b2991bf3d030064d2bc77dd03',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(129, 138, 153, 1.00)',
            'rgba(118, 121, 123, 1.00)',
            'rgba(68, 68, 51, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia salicifolia 'wada's memory'/magnolia salicifolia 'wada's memory' (5).jpg",
          width: 512,
          id: 'b7c11cb30ec43dfe94c2d591df503fa0',
          height: 768,
          thumbnail: true,
        },
        espece: 'salicifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 160, 175, 1.00)',
            'rgba(116, 116, 96, 1.00)',
            'rgba(78, 74, 69, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia salicifolia 'wada's memory'/magnolia salicifolia 'wada's memory' (4).jpg",
          width: 1024,
          id: 'c693a43a8086b4a4e8948b0e4b30e49a',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 118, 104, 1.00)',
            'rgba(145, 146, 138, 1.00)',
            'rgba(82, 86, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia salicifolia 'wada's memory'/magnolia salicifolia 'wada's memory' (3).jpg",
          width: 576,
          id: '7faef345a7b25a14df469e18336a9845',
          height: 768,
          thumbnail: true,
        },
        location: [47.271437, -1.58083],
        genre: 'Magnolia',
        cultivar: "Wada's Memory",
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58083, 47.271437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6a9edce46e1a10ce563182d1bf55324b47774406',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(63, 60, 57, 1.00)',
            'rgba(112, 102, 104, 1.00)',
            'rgba(93, 92, 78, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia stellata 'rubra'/magnolia stellata 'rubra' (3).jpg",
          width: 576,
          id: 'af11f945ece31e4618e09894738f37d7',
          height: 768,
          thumbnail: true,
        },
        espece: 'stellata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 133, 143, 1.00)',
            'rgba(164, 144, 140, 1.00)',
            'rgba(127, 121, 118, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia stellata 'rubra'/magnolia stellata 'rubra' (2).jpg",
          width: 576,
          id: '522122edd7747ac4781ae3e06c235922',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 66, 57, 1.00)',
            'rgba(144, 133, 137, 1.00)',
            'rgba(84, 84, 71, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia stellata 'rubra'/magnolia stellata 'rubra' (1).jpg",
          width: 576,
          id: '57359ec4e022176cd4f8f9174c2cdc64',
          height: 768,
          thumbnail: true,
        },
        location: [47.270312, -1.582675],
        genre: 'Magnolia',
        cultivar: 'Rubra',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582675, 47.270312] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e0de7e6f9152a7de503d1bd46a80facc317ea66c',
      fields: {
        espece: 'x soulangeana',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 90, 91, 1.00)',
            'rgba(148, 126, 144, 1.00)',
            'rgba(84, 75, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/magnolia [magnoliaceae]/magnolia x soulangeana 'lennei'/magnolia x soulangeana 'lennei' .jpg",
          width: 576,
          id: 'bc09d5271c76fa0e0fd672bdf663bb66',
          height: 768,
          thumbnail: true,
        },
        location: [47.270767, -1.585417],
        genre: 'Magnolia',
        cultivar: 'Lennei',
        famille: 'Magnoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585417, 47.270767] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '353e45349525dd2f0cc26dca94969d7e3f8ac743',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'pentandra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 164, 79, 1.00)',
            'rgba(109, 157, 65, 1.00)',
            'rgba(91, 139, 61, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/ceiba [malvaceae]/ceiba pentandra/ceiba pentandra (2).jpg",
          width: 1024,
          id: '412738b4b4dd8792e44bece815eefda5',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 157, 92, 1.00)',
            'rgba(108, 156, 76, 1.00)',
            'rgba(101, 131, 66, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/ceiba [malvaceae]/ceiba pentandra/ceiba pentandra (3).jpg",
          width: 576,
          id: '57a65b8296b24576715add9e9f0641ce',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 135, 93, 1.00)',
            'rgba(104, 148, 81, 1.00)',
            'rgba(95, 127, 68, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/ceiba [malvaceae]/ceiba pentandra/ceiba pentandra (1).jpg",
          width: 576,
          id: 'f46f38c787691285c093cbc6b283a381',
          height: 768,
          thumbnail: true,
        },
        location: [47.226903, -1.512062],
        genre: 'Ceiba',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512062, 47.226903] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a41e92641d2657dae9c3e0b5e614081973dda8fe',
      fields: {
        espece: 'speciosa',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 154, 141, 1.00)',
            'rgba(123, 124, 114, 1.00)',
            'rgba(86, 92, 76, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/ceiba [malvaceae]/ceiba speciosa/ceiba speciosa.jpg",
          width: 576,
          id: 'c8eed0cc61bdc80cfb84eb221691b057',
          height: 768,
          thumbnail: true,
        },
        location: [47.22698, -1.511905],
        genre: 'Ceiba',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.511905, 47.22698] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2b626f8c83e54aaa03b83b61efcd7b95bd6f0e07',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'acuminata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(84, 116, 29, 1.00)',
            'rgba(105, 155, 24, 1.00)',
            'rgba(82, 108, 33, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/cola [malvaceae]/cola acuminata/cola acuminata (2).jpg",
          width: 576,
          id: 'ae48b9af0f43a48990cf8d22b6424219',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 181, 43, 1.00)',
            'rgba(103, 145, 45, 1.00)',
            'rgba(97, 98, 60, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/cola [malvaceae]/cola acuminata/cola acuminata (3).jpg",
          width: 576,
          id: '824ec714dc5155364943f6aca19f4844',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 170, 37, 1.00)',
            'rgba(108, 144, 50, 1.00)',
            'rgba(99, 104, 65, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/cola [malvaceae]/cola acuminata/cola acuminata (1).jpg",
          width: 576,
          id: '6571117c3eee0b3e4cbcba8a6ed6ca0f',
          height: 768,
          thumbnail: true,
        },
        location: [47.226958, -1.511858],
        genre: 'Cola',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.511858, 47.226958] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd46920bb4f4ca107c137ae65e5becb382a7a5a6c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'angustifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 132, 70, 1.00)',
            'rgba(118, 146, 65, 1.00)',
            'rgba(110, 129, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hoheria [malvaceae]/hoheria angustifolia/hoheria angustifolia (4).jpg',
          width: 576,
          id: '1e68b8066c012e8a46ae11d863d835d7',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 150, 86, 1.00)',
            'rgba(136, 150, 78, 1.00)',
            'rgba(120, 149, 54, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hoheria [malvaceae]/hoheria angustifolia/hoheria angustifolia (5).jpg',
          width: 576,
          id: 'a5ebf1c625a4809212b3b5a99d19c8ce',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 107, 60, 1.00)',
            'rgba(118, 134, 86, 1.00)',
            'rgba(74, 89, 33, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hoheria [malvaceae]/hoheria angustifolia/hoheria angustifolia (3).jpg',
          width: 576,
          id: 'bcf39f2e745f3224b075167a24ae7ad4',
          height: 768,
          thumbnail: true,
        },
        location: [47.271687, -1.582945],
        genre: 'Hoheria',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582945, 47.271687] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a09b7512bd14222c567b3b644aa93e263df54d82',
      fields: {
        espece: 'sexstylosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 127, 40, 1.00)',
            'rgba(122, 149, 47, 1.00)',
            'rgba(132, 154, 56, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hoheria [malvaceae]/hoheria sexstylosa 'stardust'/hoheria sexstylosa 'stardust' (3).jpg",
          width: 576,
          id: '8b77de4a1db47598562dfbbdd6746ae7',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 135, 84, 1.00)',
            'rgba(128, 136, 94, 1.00)',
            'rgba(78, 90, 30, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/hoheria [malvaceae]/hoheria sexstylosa 'stardust'/hoheria sexstylosa 'stardust' (1).jpg",
          width: 576,
          id: '582425ccb43ca436ee522ce482e31f41',
          height: 768,
          thumbnail: true,
        },
        location: [47.271238, -1.584712],
        genre: 'Hoheria',
        cultivar: 'Stardust',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584712, 47.271238] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9efe31a8e345a01f3eb57a96aa140470349c8043',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'kiusiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 144, 72, 1.00)',
            'rgba(107, 142, 68, 1.00)',
            'rgba(115, 138, 69, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tilia [malvaceae]/tilia kiusiana/tilia kiusiana  (2).jpg',
          width: 576,
          id: 'cffdca5efbcbcf269a5692926bb8fd2b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 107, 51, 1.00)',
            'rgba(121, 136, 69, 1.00)',
            'rgba(54, 72, 19, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tilia [malvaceae]/tilia kiusiana/tilia kiusiana  (3).jpg',
          width: 576,
          id: '0403812d58e297e6fd97ab6da2147933',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(177, 196, 176, 1.00)',
            'rgba(112, 122, 63, 1.00)',
            'rgba(77, 81, 36, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tilia [malvaceae]/tilia kiusiana/tilia kiusiana  (1).jpg',
          width: 576,
          id: '52faf4ee16803b88af897d915979f3cb',
          height: 768,
          thumbnail: true,
        },
        location: [47.270619, -1.581261],
        genre: 'Tilia',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581261, 47.270619] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '78e2f7d737740a9bd56f192ca9997ef11cfa53c7',
      fields: {
        nom_du_site: 'Parc exotique du Grand-Blottereau',
        espece: 'amurensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 155, 96, 1.00)',
            'rgba(127, 149, 78, 1.00)',
            'rgba(93, 126, 56, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/tilia [malvaceae]/tilia amurensis/tilia amurensis (3).jpg',
          width: 576,
          id: '1361994e3258eaef84fdd0e0e2f3306f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(216, 215, 209, 1.00)',
            'rgba(98, 100, 61, 1.00)',
            'rgba(74, 80, 25, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/tilia [malvaceae]/tilia amurensis/tilia amurensis (4).jpg',
          width: 576,
          id: '41f3998ea6c7c865c4dedbd4fcc9b631',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 144, 93, 1.00)',
            'rgba(136, 123, 78, 1.00)',
            'rgba(125, 123, 67, 1.00)',
          ],
          filename:
            'ip parc exotique du grand-blottereau/tilia [malvaceae]/tilia amurensis/tilia amurensis (2).jpg',
          width: 576,
          id: '5116d296a1b9c53b623713c59cf6e9e5',
          height: 768,
          thumbnail: true,
        },
        location: [47.230253, -1.507983],
        genre: 'Tilia',
        famille: 'Malvaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.507983, 47.230253] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b991489608f135242ff151ebd0dcfa102f5c26d1',
      fields: {
        espece: 'odorata',
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 126, 61, 1.00)',
            'rgba(119, 139, 52, 1.00)',
            'rgba(137, 137, 76, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/aglaia [meliaceae]/aglaia odorata/aglaia odorata.jpg",
          width: 576,
          id: '3cd42ef0eeda2211aea916f5875ec435',
          height: 768,
          thumbnail: true,
        },
        location: [47.2271, -1.512203],
        genre: 'Aglaia',
        famille: 'Meliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512203, 47.2271] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fc93059b2715606b71993084ccd8b9dfd824de7f',
      fields: {
        origine: "La boite \u00e0 graines - 85 L'Herbergement",
        espece: 'villosus',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Melianthus',
        date_plantation: '2012',
        famille: 'Melianthaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3fdc2fb79b7bbf488d47ff7347281c510c66971f',
      fields: {
        origine: 'JB.Montr\u00e9al (Canada)',
        espece: 'caroliniana Michx.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Claytonia',
        date_plantation: '1986',
        famille: 'Montiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c01ecd84fa6b1b3fa1278b0d0bf54c35ce855028',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'rubiginosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 119, 91, 1.00)',
            'rgba(134, 114, 82, 1.00)',
            'rgba(118, 96, 70, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/ficus [moraceae]/ficus rubiginosa/ficus rubiginosa (2).jpg",
          width: 576,
          id: '849d526d6bef9d5fd8c4df307f9d091e',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 71, 43, 1.00)',
            'rgba(131, 141, 111, 1.00)',
            'rgba(92, 93, 70, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/ficus [moraceae]/ficus rubiginosa/ficus rubiginosa (3).jpg",
          width: 576,
          id: 'f654f34d03238e3462bf28091f789001',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 140, 87, 1.00)',
            'rgba(153, 136, 68, 1.00)',
            'rgba(128, 115, 73, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/ficus [moraceae]/ficus rubiginosa/ficus rubiginosa (1).jpg",
          width: 576,
          id: 'bd04f6784955be6ace077707008266e4',
          height: 768,
          thumbnail: true,
        },
        location: [47.226662, -1.512638],
        genre: 'Ficus',
        famille: 'Moraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512638, 47.226662] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4dcf80b6a34362a836ff0208fcec7da07258dee4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'rubra',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 147, 82, 1.00)',
            'rgba(114, 127, 67, 1.00)',
            'rgba(139, 135, 120, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/morus [moraceae]/morus rubra/morus rubra  (2).jpg',
          width: 576,
          id: '88d974cb2a6da11c31fcbd09b15179fc',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 113, 110, 1.00)',
            'rgba(131, 129, 126, 1.00)',
            'rgba(149, 153, 156, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/morus [moraceae]/morus rubra/morus rubra  (3).jpg',
          width: 576,
          id: '5fbef9ca2bc8a5550d03658fc1565958',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 151, 59, 1.00)',
            'rgba(104, 153, 54, 1.00)',
            'rgba(139, 151, 102, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/morus [moraceae]/morus rubra/morus rubra  (1).jpg',
          width: 576,
          id: 'be69d3c776f9526263192822ac269864',
          height: 768,
          thumbnail: true,
        },
        location: [47.270845, -1.58227],
        genre: 'Morus',
        famille: 'Moraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58227, 47.270845] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '39bbc0fadabb7d2d125554a5e6fb48bd8a67069b',
      fields: {
        espece: 'sellowiana',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(51, 59, 39, 1.00)',
            'rgba(116, 93, 77, 1.00)',
            'rgba(90, 100, 78, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acca [myrtaceae]/acca sellowiana/acca sellowiana (3).jpg',
          width: 960,
          id: '84cdf13dbc7166339fe5e55f6b493c81',
          height: 768,
          thumbnail: true,
        },
        location: [47.271563, -1.584658],
        genre: 'Acca',
        famille: 'Myrtaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584658, 47.271563] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b0cd25a644621bc88a9c216e8ddd66a4d9ba9036',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'sellowiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 82, 51, 1.00)',
            'rgba(93, 98, 70, 1.00)',
            'rgba(93, 93, 70, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/acca [myrtaceae]/acca sellowiana/acca sellowiana (2).jpg",
          width: 1024,
          id: '0cdadd3f90706c76ea61671c48a1d13c',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 124, 107, 1.00)',
            'rgba(138, 128, 111, 1.00)',
            'rgba(130, 125, 107, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/acca [myrtaceae]/acca sellowiana/acca sellowiana (3).jpg",
          width: 1024,
          id: '072accf5132d1407ea384f631e5104a1',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 96, 62, 1.00)',
            'rgba(99, 129, 83, 1.00)',
            'rgba(101, 118, 86, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/acca [myrtaceae]/acca sellowiana/acca sellowiana (1).jpg",
          width: 1024,
          id: '75b134f849182b4f42aa2bd606da25e3',
          height: 683,
          thumbnail: true,
        },
        location: [47.226688, -1.51228],
        genre: 'Acca',
        famille: 'Myrtaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.51228, 47.226688] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e67b7a073febcb77165d8f7bb957678250e29089',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 139, 122, 1.00)',
            'rgba(134, 139, 112, 1.00)',
            'rgba(154, 151, 136, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/leptospermum [myrtaceae]/leptospermum 'silver sheen'/leptospermum 'silver sheen' (2).jpg",
          width: 576,
          id: '3796eb695c845266d5f2054cb71e131f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 129, 109, 1.00)',
            'rgba(129, 131, 120, 1.00)',
            'rgba(88, 94, 76, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/leptospermum [myrtaceae]/leptospermum 'silver sheen'/leptospermum 'silver sheen' (3).jpg",
          width: 576,
          id: 'af6169a02224d63568ad52b3327bdda2',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 132, 102, 1.00)',
            'rgba(147, 148, 140, 1.00)',
            'rgba(115, 119, 108, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/leptospermum [myrtaceae]/leptospermum 'silver sheen'/leptospermum 'silver sheen' (1).jpg",
          width: 576,
          id: '431f58ff145c6bf7ee0afa4799216d8e',
          height: 768,
          thumbnail: true,
        },
        location: [47.271855, -1.582578],
        genre: 'Leptospermum',
        cultivar: 'Silver Sheen',
        famille: 'Myrtaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582578, 47.271855] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c5b95ca7664743374b91cd0957b489a91643b1a2',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'guajava',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 118, 57, 1.00)',
            'rgba(133, 152, 75, 1.00)',
            'rgba(124, 118, 75, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/psidium [myrtaceae]/psidium guajava/psidium guajava (2).jpg",
          width: 576,
          id: 'd5190888493320a7fd971661e75773fe',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 109, 58, 1.00)',
            'rgba(148, 157, 51, 1.00)',
            'rgba(116, 145, 39, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/psidium [myrtaceae]/psidium guajava/psidium guajava (3).jpg",
          width: 576,
          id: '3b7ef9e3d11abf814471f2fb9824a696',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 161, 71, 1.00)',
            'rgba(130, 145, 66, 1.00)',
            'rgba(102, 131, 39, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/psidium [myrtaceae]/psidium guajava/psidium guajava (1).jpg",
          width: 576,
          id: '77dd378a5125a817b7c1690a32529d1b',
          height: 768,
          thumbnail: true,
        },
        location: [47.226888, -1.512522],
        genre: 'Psidium',
        famille: 'Myrtaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512522, 47.226888] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0a8569dbc9a1c261d0e8971b24fa5af602a0a74b',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes 71290 La Gen\u00eate',
        espece: 'parkeri Dunn',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Jasminum',
        date_plantation: '2015',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '05b9ed409700dc53f973ec3d940b1ed44b47f6ea',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'distichum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 112, 106, 1.00)',
            'rgba(140, 125, 120, 1.00)',
            'rgba(121, 106, 103, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abeliophyllum [oleaceae]/abeliophyllum distichum/abeliophyllum distichum (2).jpg',
          width: 576,
          id: '605f816191241c32af9f5e6867b0e5bb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(76, 89, 40, 1.00)',
            'rgba(125, 137, 57, 1.00)',
            'rgba(159, 146, 99, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abeliophyllum [oleaceae]/abeliophyllum distichum/abeliophyllum distichum (3).jpg',
          width: 576,
          id: 'b973c456f42104502650eacf7eb08cd5',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 143, 122, 1.00)',
            'rgba(143, 122, 101, 1.00)',
            'rgba(111, 82, 70, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abeliophyllum [oleaceae]/abeliophyllum distichum/abeliophyllum distichum (1).jpg',
          width: 576,
          id: 'f94b35cae445c63baec7d8a205d07ec4',
          height: 768,
          thumbnail: true,
        },
        location: [47.27063, -1.586267],
        genre: 'Abeliophyllum',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586267, 47.27063] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '65b5055020d6d6fb39b6f5a320f99116067d7f17',
      fields: {
        espece: 'excelsior',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 164, 169, 1.00)',
            'rgba(141, 133, 86, 1.00)',
            'rgba(60, 63, 25, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus excelsior 'jaspidea'/fraxinus excelsior 'jaspidea'  (4).jpg",
          width: 1024,
          id: '7dbb86544ee79e85db4558cf6c01f64f',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(153, 166, 178, 1.00)',
            'rgba(132, 124, 62, 1.00)',
            'rgba(72, 76, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus excelsior 'jaspidea'/fraxinus excelsior 'jaspidea'  (3).jpg",
          width: 576,
          id: '2d99804cafaa77328d55180f6e21ad92',
          height: 768,
          thumbnail: true,
        },
        location: [47.269783, -1.582262],
        genre: 'Fraxinus',
        cultivar: 'Jaspidea',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582262, 47.269783] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a2073fd588eb45898178924f6c3f93ef58a94403',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'ornus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(200, 208, 192, 1.00)',
            'rgba(89, 102, 62, 1.00)',
            'rgba(80, 81, 45, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus ornus/fraxinus ornus (2).jpg',
          width: 704,
          id: 'a9946a31ed19e3bcbba19b64fbbc93ce',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 180, 210, 1.00)',
            'rgba(129, 120, 94, 1.00)',
            'rgba(118, 100, 80, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus ornus/fraxinus ornus.jpg',
          width: 576,
          id: 'f6cda9db8fccff9f971ebb426602829f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 130, 45, 1.00)',
            'rgba(122, 140, 49, 1.00)',
            'rgba(134, 129, 84, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/fraxinus [oleaceae]/fraxinus ornus/fraxinus ornus (1).jpg',
          width: 576,
          id: '81491266aed4f2375d14f6e183ca53a9',
          height: 768,
          thumbnail: true,
        },
        location: [47.270745, -1.585808],
        genre: 'Fraxinus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585808, 47.270745] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '979a1dab9188d06eff861a70e6386fe8cfb634eb',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 114, 73, 1.00)',
            'rgba(131, 140, 20, 1.00)',
            'rgba(73, 91, 12, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/jasminum [oleaceae]/jasminum humile 'revolutum'/jasminum humile 'revolutum' (2).jpg",
          width: 576,
          id: 'af4efffff153d9975c869541d6a9fbf5',
          height: 768,
          thumbnail: true,
        },
        espece: 'humile',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 131, 81, 1.00)',
            'rgba(101, 141, 64, 1.00)',
            'rgba(74, 114, 33, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/jasminum [oleaceae]/jasminum humile 'revolutum'/jasminum humile 'revolutum' (1).jpg",
          width: 576,
          id: '15f2020a280ce433de520f44ee714280',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 132, 66, 1.00)',
            'rgba(115, 143, 58, 1.00)',
            'rgba(120, 133, 63, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/jasminum [oleaceae]/jasminum humile 'revolutum'/jasminum humile 'revolutum'  (1).jpg",
          width: 1024,
          id: '537d17a97ebb7bdf8f0ab3828c22eb76',
          height: 768,
          thumbnail: true,
        },
        location: [47.271233, -1.581547],
        genre: 'Jasminum',
        cultivar: 'Revolutum',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581547, 47.271233] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a12141184826c752b459f0a33373161bc75dad68',
      fields: {
        espece: 'lucidum',
        localisation: 'A12',
        nom_du_site: 'Jardin des Plantes',
        location: [47.22098, -1.5430278],
        genre: 'Ligustrum',
        date_plantation: '1973',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5430278, 47.22098] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8ad15af4f1a3f2aa22c977264acd12450b5e735e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'lucidum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 95, 44, 1.00)',
            'rgba(103, 112, 67, 1.00)',
            'rgba(81, 90, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum lucidum/ligustrum lucidum (2).jpg',
          width: 716,
          id: '9ce1de472b64eb2a9aff6d0366a24c58',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(48, 58, 23, 1.00)',
            'rgba(123, 127, 85, 1.00)',
            'rgba(97, 102, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum lucidum/ligustrum lucidum (3).jpg',
          width: 576,
          id: 'd87b09710517be91ee1f732f18560af6',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 152, 60, 1.00)',
            'rgba(117, 163, 65, 1.00)',
            'rgba(108, 137, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum lucidum/ligustrum lucidum (1).jpg',
          width: 576,
          id: '511cb0905188f50f88d46d9e65c9c5bc',
          height: 768,
          thumbnail: true,
        },
        location: [47.271088, -1.58498],
        genre: 'Ligustrum',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58498, 47.271088] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c9c278f97ecd40194437026ccc9a91cae9696176',
      fields: {
        espece: 'ovalifolium',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(97, 121, 41, 1.00)',
            'rgba(129, 156, 54, 1.00)',
            'rgba(113, 136, 36, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum ovalifolium 'variegatum'/ligustrum ovalifolium 'variegatum' (2).jpg",
          width: 576,
          id: '20b9727e61bd2399065d4f02780541bc',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(59, 79, 63, 1.00)',
            'rgba(117, 140, 71, 1.00)',
            'rgba(112, 141, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ligustrum [oleaceae]/ligustrum ovalifolium 'variegatum'/ligustrum ovalifolium 'variegatum' (1).jpg",
          width: 576,
          id: 'c6060a56c6c02672575029d0f600fa07',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Ligustrum',
        cultivar: 'Variegatum',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1e78e144f40744cfcc63225a9ff248682d78855f',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'serrulatus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 143, 88, 1.00)',
            'rgba(100, 134, 80, 1.00)',
            'rgba(85, 119, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus serrulatus/osmanthus serrulatus (2).jpg',
          width: 576,
          id: '1cc576ebb4a62e0cb4f15b859614dde8',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 106, 73, 1.00)',
            'rgba(98, 117, 81, 1.00)',
            'rgba(84, 108, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus serrulatus/osmanthus serrulatus.jpg',
          width: 576,
          id: 'b1d6b76ec8368d10c84f769f747a2c7e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(113, 138, 87, 1.00)',
            'rgba(108, 141, 84, 1.00)',
            'rgba(125, 142, 94, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osmanthus [oleaceae]/osmanthus serrulatus/osmanthus serrulatus (1).jpg',
          width: 1024,
          id: '1f429345625e90c21f28ba3ca9340fae',
          height: 768,
          thumbnail: true,
        },
        location: [47.27133, -1.581172],
        genre: 'Osmanthus',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581172, 47.27133] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a8f0ac02acedf6713589277266e3ff11e48c8325',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'reticulata ssp. pekinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 135, 77, 1.00)',
            'rgba(111, 132, 84, 1.00)',
            'rgba(44, 73, 24, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/syringa [oleaceae]/syringa reticulata ssp. pekinensis/syringa reticulata ssp. pekinensis (3).jpg',
          width: 576,
          id: '3ac45d1378cf3e91d07467dc75608712',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 146, 138, 1.00)',
            'rgba(128, 128, 119, 1.00)',
            'rgba(102, 120, 106, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/syringa [oleaceae]/syringa reticulata ssp. pekinensis/syringa reticulata ssp. pekinensis (4).jpg',
          width: 576,
          id: '9b28a96cab8315c25b1dee4fd70b40bb',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(182, 159, 136, 1.00)',
            'rgba(142, 101, 83, 1.00)',
            'rgba(113, 92, 86, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/syringa [oleaceae]/syringa reticulata ssp. pekinensis/syringa reticulata ssp. pekinensis (2).jpg',
          width: 576,
          id: 'f5cb3054f7715417dc7c01b302ae2dde',
          height: 768,
          thumbnail: true,
        },
        location: [47.27162, -1.582922],
        genre: 'Syringa',
        famille: 'Oleaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582922, 47.27162] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '820ac97528bb8ca355577ec208865e78f94d85be',
      fields: {
        origine: 'Botanischer Garten, Tubingen, Allemagne',
        espece: 'kunthiana Munz',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Oenothera',
        date_plantation: '2012',
        famille: 'Onagraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bb6c9c9bf2feb5781987f5442702bc230b25e896',
      fields: {
        espece: 'clandestina L.',
        localisation: 'I4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2186346, -1.541674],
        genre: 'Lathraea',
        date_plantation: '1973',
        famille: 'Orobanchaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.541674, 47.2186346] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e7f7519def208f3b63708bc01d9c9375bf1291f0',
      fields: {
        origine: 'JB.Arhus (Danemark)',
        espece: 'delavayi Franch.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Paeonia',
        date_plantation: '2006',
        famille: 'Paeoniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b2269b4dd607c8464f3e572885a32c834ad2f613',
      fields: {
        espece: 'smithiana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 161, 175, 1.00)',
            'rgba(98, 109, 93, 1.00)',
            'rgba(60, 63, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/picea [pinaceae]/picea smithiana/picea smithiana.jpg',
          width: 512,
          id: '44b66fbb21816c616f7a9999e51bad97',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 109, 93, 1.00)',
            'rgba(93, 108, 79, 1.00)',
            'rgba(94, 96, 64, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/picea [pinaceae]/picea smithiana/picea smithiana (2).jpg',
          width: 1024,
          id: 'cb2ab7c47f5c9b1cab5b5ee75a4c7a9a',
          height: 683,
          thumbnail: true,
        },
        location: [47.2705, -1.581258],
        genre: 'Picea',
        famille: 'Pinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581258, 47.2705] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '56d93188811cf125de848344b31babf3358e9ffc',
      fields: {
        espece: 'smithiana',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(117, 134, 117, 1.00)',
            'rgba(86, 105, 72, 1.00)',
            'rgba(133, 135, 110, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/picea [pinaceae]/picea smithiana/picea smithiana (4).jpg',
          width: 512,
          id: '3aa5c3fd0643df4aa80acfcb60e9bfe6',
          height: 768,
          thumbnail: true,
        },
        location: [47.270528, -1.581275],
        genre: 'Picea',
        famille: 'Pinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581275, 47.270528] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e1e7a80a3cc006ee2b6a2eb0eeba6f93a240cc2c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'heterophyllum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 145, 82, 1.00)',
            'rgba(114, 151, 64, 1.00)',
            'rgba(88, 134, 28, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pittosporum [pittosporaceae]/pittosporum heterophyllum/pittosporum heterophyllum (2).jpg',
          width: 576,
          id: '260d99177cc8a5053890c4af08dcb3dc',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 128, 103, 1.00)',
            'rgba(115, 130, 99, 1.00)',
            'rgba(109, 119, 94, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pittosporum [pittosporaceae]/pittosporum heterophyllum/pittosporum heterophyllum (3).jpg',
          width: 1024,
          id: '31d6faa2045a1b686a1994afaf4d7f02',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 113, 60, 1.00)',
            'rgba(108, 130, 65, 1.00)',
            'rgba(113, 127, 67, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/pittosporum [pittosporaceae]/pittosporum heterophyllum/pittosporum heterophyllum (1).jpg',
          width: 576,
          id: 'b6f83327281b5577cad353c749f77a7e',
          height: 768,
          thumbnail: true,
        },
        location: [47.271408, -1.58598],
        genre: 'Pittosporum',
        famille: 'Pittosporaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58598, 47.271408] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '93a89e8491634cea85e8f1dc7c26fc2db293592a',
      fields: {
        origine: 'B.G.Brno (Rep.Tch\u00e8que)',
        espece: 'caucasica M.Bieb',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Veronica',
        date_plantation: '2014',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '98d3603f9e51127ab6b5995d594c2dcb631cd00d',
      fields: {
        origine: 'JB.Framingham (USA)',
        espece: 'digitalis Nutt.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Penstemon',
        date_plantation: '1988',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3ea692ccc3afd994287838a7d05cdb46ca85e1a9',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'baldaccii Degen',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Wulfenia',
        date_plantation: '1998',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd28382ecfbcb1a752952cac1e1f7f4f28f124e86',
      fields: {
        origine: 'JB.Pavia (Italie)',
        espece: 'punctata Lapeyr.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Globularia',
        date_plantation: '2006',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd3d3b089eb70f206a7b94058474fe3ddb6368963',
      fields: {
        origine: 'Universit\u00e9 de Postdam (Allemagne)',
        espece: 'baldaccii Degen',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Wulfenia',
        date_plantation: '2011',
        famille: 'Plantaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bd620b290be31ce921b1f7e09f4f2e9b8466e2a2',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x hispanica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 159, 86, 1.00)',
            'rgba(127, 154, 58, 1.00)',
            'rgba(130, 151, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/platanus [platanaceae]/platanus x hispanica/platanus x hispanica (3).jpg',
          width: 576,
          id: '7a4499db9e10de7c99383bc5b434cb16',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 127, 151, 1.00)',
            'rgba(110, 94, 47, 1.00)',
            'rgba(72, 65, 31, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/platanus [platanaceae]/platanus x hispanica/platanus x hispanica (4).jpg',
          width: 512,
          id: '642855706a889e06e7fc3f5282924c71',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(105, 129, 55, 1.00)',
            'rgba(104, 121, 49, 1.00)',
            'rgba(120, 136, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/platanus [platanaceae]/platanus x hispanica/platanus x hispanica (2).jpg',
          width: 576,
          id: '02db71388ed232710e39f702788365e2',
          height: 768,
          thumbnail: true,
        },
        location: [47.271263, -1.58207],
        genre: 'Platanus',
        famille: 'Platanaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58207, 47.271263] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5a1d5f9e7f74215eb3ef8273f4616980a81191e4',
      fields: {
        origine: 'J. alpin Viotte, Trento (Italie)',
        espece: 'maritima Willd.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Armeria',
        date_plantation: '2011',
        cultivar: 'alpina P.Silva',
        famille: 'Plumbaginaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'eac98cf03fb4e9ea97c05ca1f135d426500775bb',
      fields: {
        origine: 'JB.Chemnitz (Allemagne)',
        espece: 'ternarius  Michx.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Andropogon',
        date_plantation: '2008',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '305ad9178c4cf5836d90aa79f0e7e613145e9e67',
      fields: {
        origine: 'JBU.Vancouver (Canada)',
        espece: 'saximontana Rydb.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Festuca',
        date_plantation: '2004',
        famille: 'Poaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2a9c64ae3a71df9f07180b40e1f678676dd32797',
      fields: {
        origine: 'JB.Leiden (Pays- Bas)',
        espece: 'arifolius All.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Rumex',
        date_plantation: '2009',
        famille: 'Polygonaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0a14db876fa88f9af8f2d537c501cc12ae8d9f9f',
      fields: {
        origine: 'JB. Brno ( Rep. Tch\u00e8que)',
        espece: 'zambalensis Petitm.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Primula',
        date_plantation: '2010',
        famille: 'Primulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ba2d2df30075f85d7a4b8ff227affb2c4069838d',
      fields: {
        origine: 'Les Ponts de C\u00e9_p\u00e9pini\u00e8re Lepage',
        espece: 'japonica A.Gray',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Primula',
        date_plantation: '2016',
        famille: 'Primulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd0c991bf21f9f8d7f7cdb7dba5e6a123fb78a58e',
      fields: {
        espece: 'robusta',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 150, 58, 1.00)',
            'rgba(151, 133, 48, 1.00)',
            'rgba(143, 123, 41, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/grevillea [proteaceae]/grevillea robusta/grevillea robusta (2).jpg",
          width: 576,
          id: '6555ab5d840dd52e2a3ce3ee7fd48421',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 139, 40, 1.00)',
            'rgba(128, 137, 27, 1.00)',
            'rgba(126, 121, 37, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/grevillea [proteaceae]/grevillea robusta/grevillea robusta (1).jpg",
          width: 576,
          id: '5127c747501992dee3c38a92483e2808',
          height: 768,
          thumbnail: true,
        },
        location: [47.226505, -1.512308],
        genre: 'Grevillea',
        famille: 'Proteaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512308, 47.226505] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '54e0910bb415e9cf9b74693132d65fd816544a96',
      fields: {
        espece: 'salicifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 139, 102, 1.00)',
            'rgba(126, 130, 56, 1.00)',
            'rgba(115, 123, 42, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hakea [proteaceae]/hakea salicifolia/hakea salicifolia (2).jpg',
          width: 512,
          id: '0880e937eb0b2681623c8125d5d6f6ec',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 98, 59, 1.00)',
            'rgba(104, 105, 63, 1.00)',
            'rgba(162, 156, 124, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/hakea [proteaceae]/hakea salicifolia/hakea salicifolia (1).jpg',
          width: 1024,
          id: '7e8778a492224e86447f87f7da7b11e2',
          height: 683,
          thumbnail: true,
        },
        location: [47.271388, -1.586638],
        genre: 'Hakea',
        famille: 'Proteaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586638, 47.271388] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '70ebb8e76647af9fe61915aef1f6bb1e8ab6c568',
      fields: {
        origine: 'Amur Branch of B.G. (Russie)',
        espece: 'contortum L.',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Thalictrum',
        date_plantation: '2014',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b963047a1cb9ea031a11c731a8be3f5fe08a2ced',
      fields: {
        origine: 'Arboretum Universit\u00e9e de Berlin (Allemagne)',
        espece: 'rochebrunianum Sav.',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Thalictrum',
        date_plantation: '2009',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '36eed2727d35bfe117ade8ce3f95e82036a7c51b',
      fields: {
        origine: 'J.Alp.U.Insbruck (Autriche)',
        espece: 'chrysantha  A.Gray',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Aquilegia',
        date_plantation: '2008',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8084fced1934d0bf5d67f3dbf1d0629badf2e9c5',
      fields: {
        origine: 'J.B. Klagenfurt (Autriche)',
        espece: 'bungeana C.A. Mey.',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Pulsatilla',
        date_plantation: '2011',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3070e4f4110c9562206473a988b48c23a99290b3',
      fields: {
        origine: 'JB.Royal Zoological (Rotterdam)',
        espece: 'transsivanica Schur.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Aquilegia',
        date_plantation: '1990',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bda6ed39c330580151aa22e575b1cafd08617f43',
      fields: {
        origine: 'JB.Udine (Italie)',
        espece: 'galioides Borza',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Thalictrum',
        date_plantation: '2009',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b1332dd4f4ad7908971ed3e219f9aa35250f5f92',
      fields: {
        origine: 'Publik Park and B.G. Akureyri (Iceland)',
        espece: 'caucasicum C.A.Mey.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Delphinium',
        date_plantation: '2015',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ff203fb807d0a92558e68aa0538d13914c378f80',
      fields: {
        origine: 'R\u00e9colte JB Nantes',
        espece: 'palustris L.',
        localisation: 'E3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2187942, -1.5432752],
        genre: 'Caltha',
        date_plantation: '2016',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432752, 47.2187942] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e7e2a24d164a74ae2356bbb8495b5f56d500cbeb',
      fields: {
        origine: 'Rennsteiggarten Oberhof (All.)',
        espece: 'regeliana Krylov',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Pulsatilla',
        date_plantation: '2015',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '03d03da52f68c3b8b93f166426e6e6bb6e252246',
      fields: {
        origine: 'Stavanger Botanic Garden,Norv\u00e8ge',
        espece: 'koreana T.Mori',
        localisation: 'D3C',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202547, -1.5418546],
        genre: 'Pulsatilla',
        date_plantation: '2014',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418546, 47.2202547] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3d2bf0bb3dc27f1d918504e000dc0a21e450c811',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes 71290 La Gen\u00eate',
        espece: 'oxysepala Trautv. & C.A.Mey.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Aquilegia',
        date_plantation: '2015',
        famille: 'Ranunculaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8ca539ae7f13eb145ce89dd2ba72c43af9e4460e',
      fields: {
        origine: 'Arboretum univ. Seoul',
        espece: 'yoshinoi',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Rhamnus',
        date_plantation: '2007',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c6a181af53a8198428d31d95e8533ef018e29b01',
      fields: {
        origine: 'JB.Bornova Izmir (Turquie)',
        espece: 'spina-christii',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Paliurus',
        date_plantation: '2002',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '22bcc8d2ac11acdb9e01a94e76697b845841f87c',
      fields: {
        espece: 'x pallidus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 98, 60, 1.00)',
            'rgba(133, 133, 87, 1.00)',
            'rgba(164, 155, 114, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus x pallidus 'marie simon'/ceanothus x pallidus 'marie simon' .jpg",
          width: 1024,
          id: 'e073961936a62d1712bad68f74c58d46',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 149, 83, 1.00)',
            'rgba(125, 139, 68, 1.00)',
            'rgba(118, 132, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/ceanothus [rhamnaceae]/ceanothus x pallidus 'marie simon'/ceanothus x pallidus 'marie simon' (6).jpg",
          width: 891,
          id: '59e6ba3c2aa2ea8d4ef2368f075c3c13',
          height: 768,
          thumbnail: true,
        },
        location: [47.271142, -1.585805],
        genre: 'Ceanothus',
        cultivar: 'Marie Simon',
        famille: 'Rhamnaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585805, 47.271142] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '06cafd099ec66f6a8a7f40f7b42ce67c1913366c',
      fields: {
        origine: 'BG Michigan State Univ. - East Lansing',
        espece: 'canadense Jacq.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Geum',
        date_plantation: '2006',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '127d2cef5915ad3434fb3399856af2c383ea7582',
      fields: {
        origine: 'collect. Pascal Prieur',
        espece: 'betulifolia',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7cab628d4dfe500326bacd9ec07a9d97b481d873',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'salicifolia',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd7c602df8acfabd8a725b4621df2a07f125a62f0',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'thunbergii',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b8279ce0aa980f01d36c8bbab4f8d509b7de83de',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'X brumalis',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'abcb4bce537949995146bb619c8c8c05aac61767',
      fields: {
        origine: 'collection Pascal Prieur',
        espece: 'X nivea',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '2016',
        cultivar: 'Alba carnea',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ab593833a26feffd1436134e9151bcf9f4e5e004',
      fields: {
        origine: 'Jardin Universit\u00e9 de Hohenheim,Stuttgart,All.',
        espece: 'myriophylla Lindl.',
        localisation: 'C9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201723, -1.5423876],
        genre: 'Acaena',
        date_plantation: '2014',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5423876, 47.2201723] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '325a2222808610b7decde44cd1948ebeff5f663e',
      fields: {
        origine: 'JB. Bremen (Allemagne)',
        espece: 'rupestris L.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Potentilla',
        date_plantation: '2010',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '05c8fd73056349a895f29264ff46a2509dbf4e2f',
      fields: {
        origine: 'JB. Leipzig, Leipzig (Allemagne)',
        espece: 'glabra Buchanan',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Acaena',
        date_plantation: '2011',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9c7172c5c9e52245aa34572ccdad7abc0ac99d78',
      fields: {
        origine: 'JB. Wuppertal, Wuppertal (Allemagne)',
        espece: 'fissistipula Bitter',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Acaena',
        date_plantation: '2011',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '40eaa9effb01ef8a7c3a60158005f53c31cd5656',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'magellanicum Pers.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Geum',
        date_plantation: '2006',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6682bdf66ab75f53e85f91882d87487af8ccdcbe',
      fields: {
        origine: 'JB.Salaspils (Lettonie)',
        espece: 'sorbifolia',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Sorbaria',
        date_plantation: '1986',
        cultivar: 'stellipila',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7bd21c42dbe601b4c5adb1fc0345e124fd98b362',
      fields: {
        origine: 'JB.Steborice',
        espece: 'alba (ex. S. latifolia)',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '1992',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4aa5931fe9c1897690de86c87a95598cf9c76d66',
      fields: {
        origine: 'JBU.Berkeley (USA)',
        espece: 'gryposepala Wallr.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Agrimonia',
        date_plantation: '2003',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c424187bd93cd20da04ae02d0a0f53361b38ac48',
      fields: {
        origine: 'P. F\u00e9rard - nature, Pyr\u00e9n\u00e9es',
        espece: 'pyrenaicum Miller',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Geum',
        date_plantation: '2014',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1a3ee2d1fc78da58bba880dcd098b102ed7bdc54',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes 71290 La Gen\u00eate',
        espece: 'x nobilis',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Rubus',
        date_plantation: '2015',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6b49a55b224aacaa9203837513929caf597803c8',
      fields: {
        espece: 'x prunifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 165, 171, 1.00)',
            'rgba(108, 75, 51, 1.00)',
            'rgba(104, 89, 63, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/aronia [rosaceae]/aronia x prunifolia 'brilliant'/aronia x prunifolia 'brilliant' (5).jpg",
          width: 1024,
          id: 'f36a96a508ce4ff167af030d3a517c43',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 126, 119, 1.00)',
            'rgba(139, 65, 52, 1.00)',
            'rgba(128, 61, 52, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/aronia [rosaceae]/aronia x prunifolia 'brilliant'/aronia x prunifolia 'brilliant' (4).jpg",
          width: 1024,
          id: 'e6453077d48d2a6028fbb27c8f28d855',
          height: 683,
          thumbnail: true,
        },
        location: [47.272005, -1.582133],
        genre: 'Aronia',
        cultivar: 'Brilliant',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582133, 47.272005] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ad134ba8c9a71d830f256119311bf23b09095dcf',
      fields: {
        espece: 'x prunifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 126, 68, 1.00)',
            'rgba(142, 156, 94, 1.00)',
            'rgba(134, 141, 87, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aronia [rosaceae]/aronia x prunifolia/aronia x prunifolia (4).jpg',
          width: 576,
          id: '7dab0a42791b92375f00f5cacfab97b1',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 98, 42, 1.00)',
            'rgba(124, 129, 93, 1.00)',
            'rgba(105, 105, 67, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aronia [rosaceae]/aronia x prunifolia/aronia x prunifolia (3).jpg',
          width: 576,
          id: '9a8ecb5e7f35640af944985673b4b84d',
          height: 768,
          thumbnail: true,
        },
        location: [47.270925, -1.5854],
        genre: 'Aronia',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5854, 47.270925] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '06a43b7fd5bafb01bc94f43da02833385ab78854',
      fields: {
        espece: 'x mordenensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 131, 96, 1.00)',
            'rgba(155, 134, 126, 1.00)',
            'rgba(62, 76, 35, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/crataegus [rosaceae]/crataegus x mordenensis 'toba'/crataegus x mordenensis 'toba' (2).jpg",
          width: 576,
          id: 'dcd20eb7e2ab43987ae047c2262aacf5',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(166, 176, 124, 1.00)',
            'rgba(114, 152, 60, 1.00)',
            'rgba(62, 101, 23, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/crataegus [rosaceae]/crataegus x mordenensis 'toba'/crataegus x mordenensis 'toba' (1).jpg",
          width: 576,
          id: 'b6eababb2fe3b0116190ada51c3ffb3a',
          height: 768,
          thumbnail: true,
        },
        location: [47.271458, -1.581763],
        genre: 'Crataegus',
        cultivar: 'Toba',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581763, 47.271458] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '96ef8e520706d1ed8f7c20a9e305d44c36e5e920',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(174, 178, 169, 1.00)',
            'rgba(81, 92, 72, 1.00)',
            'rgba(84, 81, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/eriobotrya [rosaceae]/eriobotrya japonica/eriobotrya japonica (2).jpg',
          width: 1024,
          id: '85fca7063f3d76642bd024fc396fbd26',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 133, 118, 1.00)',
            'rgba(146, 133, 123, 1.00)',
            'rgba(114, 99, 94, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/eriobotrya [rosaceae]/eriobotrya japonica/eriobotrya japonica (3).jpg',
          width: 576,
          id: '60c3dd6f250738d80e5f1dac4fea612a',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(98, 119, 91, 1.00)',
            'rgba(98, 126, 96, 1.00)',
            'rgba(96, 106, 80, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/eriobotrya [rosaceae]/eriobotrya japonica/eriobotrya japonica (1).jpg',
          width: 576,
          id: 'ff7b55cb7dd61ea95c88bbbf7591fae6',
          height: 768,
          thumbnail: true,
        },
        location: [47.27018, -1.583912],
        genre: 'Eriobotrya',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583912, 47.27018] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f1e9b917a9459b7f42ab8068cd6e90511ca26151',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 156, 101, 1.00)',
            'rgba(149, 152, 91, 1.00)',
            'rgba(101, 124, 46, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/kerria [rosaceae]/kerria japonica 'kin kan'/kerria japonica 'kin kan' (3).jpg",
          width: 576,
          id: '0a6f0fa9fbfb996b7c36da1b8b2f88be',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 124, 69, 1.00)',
            'rgba(151, 133, 36, 1.00)',
            'rgba(80, 87, 31, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/kerria [rosaceae]/kerria japonica 'kin kan'/kerria japonica 'kin kan' (2).jpg",
          width: 576,
          id: '12fc3c96cfb99dacd7ddedc0cccaccbd',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(149, 160, 94, 1.00)',
            'rgba(119, 146, 62, 1.00)',
            'rgba(121, 131, 71, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/kerria [rosaceae]/kerria japonica 'kin kan'/kerria japonica 'kin kan' (1).jpg",
          width: 576,
          id: '0e1c82b818ed73844ac1a7261f38eff0',
          height: 768,
          thumbnail: true,
        },
        location: [47.270825, -1.586122],
        genre: 'Kerria',
        cultivar: 'Kin Kan',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586122, 47.270825] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'de5e71ef5055db7881988580a6deffab0acacedc',
      fields: {
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 92, 63, 1.00)',
            'rgba(87, 98, 71, 1.00)',
            'rgba(62, 81, 55, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'lancelot'/malus 'lancelot' (5).jpg",
          width: 1024,
          id: 'b6fe09f9eb787a635ed8cec336a4a526',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(142, 158, 139, 1.00)',
            'rgba(77, 90, 64, 1.00)',
            'rgba(65, 66, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'lancelot'/malus 'lancelot' (4).jpg",
          width: 570,
          id: '2cedf7efcc8af0a706b41e6e3e374966',
          height: 768,
          thumbnail: true,
        },
        location: [47.269975, -1.585697],
        genre: 'Malus',
        cultivar: 'Lancelot',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585697, 47.269975] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bd2b507f7aa7231e818b2a60fc7bbec0c06d0a01',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 109, 76, 1.00)',
            'rgba(148, 91, 102, 1.00)',
            'rgba(110, 110, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/malus [rosaceae]/malus 'red sentinel'/malus 'red sentinel'.jpg",
          width: 576,
          id: '0fb5282af06f973a512e59d348dfea27',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Malus',
        cultivar: 'Red Sentinel',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ffb2dbff29296fa9b551ee8cbc04dab8b9a0c6dd',
      fields: {
        espece: 'anthyllidifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 167, 119, 1.00)',
            'rgba(128, 159, 81, 1.00)',
            'rgba(102, 129, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osteomeles [rosaceae]/osteomeles anthyllidifolia/osteomeles anthyllidifolia (3).jpg',
          width: 686,
          id: '3524f8dda685db829509e4e16fd45ba2',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 135, 95, 1.00)',
            'rgba(113, 127, 89, 1.00)',
            'rgba(76, 96, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/osteomeles [rosaceae]/osteomeles anthyllidifolia/osteomeles anthyllidifolia (2).jpg',
          width: 576,
          id: '96c5461479f0103085e21c59d10ed5ed',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Osteomeles',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4dd073b3b911c9fe9d24338cb35d5b44f0ed94b1',
      fields: {
        espece: 'x fraseri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(173, 176, 165, 1.00)',
            'rgba(100, 100, 84, 1.00)',
            'rgba(75, 73, 46, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/photinia [rosaceae]/photinia x fraseri 'red robin'/photinia x fraseri 'red robin' (5).jpg",
          width: 1024,
          id: 'bd583df5379d813c59a9505fb9e7fd90',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(204, 197, 184, 1.00)',
            'rgba(83, 77, 41, 1.00)',
            'rgba(76, 72, 37, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/photinia [rosaceae]/photinia x fraseri 'red robin'/photinia x fraseri 'red robin' (3).jpg",
          width: 512,
          id: '101fc1bcb4d46730e7063e6222392a80',
          height: 768,
          thumbnail: true,
        },
        location: [47.270763, -1.584903],
        genre: 'Photinia',
        cultivar: 'Red Robin',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584903, 47.270763] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cfc03f109cef6e7aa03dd48b564271480b41c383',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 120, 105, 1.00)',
            'rgba(119, 100, 84, 1.00)',
            'rgba(103, 94, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/physocarpus [rosaceae]/physocarpus opulifolius 'diabolo'/physocarpus opulifolius 'diabolo' (3).jpg",
          width: 576,
          id: 'adf0076ce9395809b1a564946bd8c878',
          height: 768,
          thumbnail: true,
        },
        espece: 'opulifolius',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 119, 115, 1.00)',
            'rgba(147, 106, 108, 1.00)',
            'rgba(112, 107, 103, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/physocarpus [rosaceae]/physocarpus opulifolius 'diabolo'/physocarpus opulifolius 'diabolo' (2).jpg",
          width: 576,
          id: 'f053ff9a7005fc19da68aafa8a8739b5',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 115, 114, 1.00)',
            'rgba(139, 115, 115, 1.00)',
            'rgba(132, 109, 112, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/physocarpus [rosaceae]/physocarpus opulifolius 'diabolo'/physocarpus opulifolius 'diabolo' (1).jpg",
          width: 576,
          id: '22b2f7144ef2da20396d68654d8d2e10',
          height: 768,
          thumbnail: true,
        },
        location: [47.271067, -1.582437],
        genre: 'Physocarpus',
        cultivar: 'Diabolo',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582437, 47.271067] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4fff19e1258679754da5a08057867e7728553ecd',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'opulifolius',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(81, 102, 42, 1.00)',
            'rgba(113, 141, 59, 1.00)',
            'rgba(83, 120, 36, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/physocarpus [rosaceae]/physocarpus opulifolius/physocarpus opulifolius (3).jpg',
          width: 576,
          id: '9471ef31827a203020167559843f1dbb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 101, 48, 1.00)',
            'rgba(131, 146, 99, 1.00)',
            'rgba(78, 99, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/physocarpus [rosaceae]/physocarpus opulifolius/physocarpus opulifolius (5).jpg',
          width: 576,
          id: 'dd15c4c3949749e47197bd2e094c315e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 132, 47, 1.00)',
            'rgba(98, 142, 38, 1.00)',
            'rgba(79, 115, 30, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/physocarpus [rosaceae]/physocarpus opulifolius/physocarpus opulifolius (2).jpg',
          width: 576,
          id: 'b50c684b6e457b2a0127f3217c44c956',
          height: 768,
          thumbnail: true,
        },
        location: [47.270605, -1.580997],
        genre: 'Physocarpus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580997, 47.270605] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '20253afc0d06c97e18d39c8e9a7eb1b3fb13013c',
      fields: {
        espece: 'opulifolius',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 104, 59, 1.00)',
            'rgba(108, 127, 61, 1.00)',
            'rgba(85, 112, 48, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/physocarpus [rosaceae]/physocarpus opulifolius/physocarpus opulifolius (4).jpg',
          width: 1024,
          id: 'ec294cf5efba4c6f5c037a1e98c57583',
          height: 768,
          thumbnail: true,
        },
        location: [47.27125, -1.586178],
        genre: 'Physocarpus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586178, 47.27125] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c3d2ad174901b0bc056c6bba5903cacf24976956',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(189, 186, 193, 1.00)',
            'rgba(152, 132, 140, 1.00)',
            'rgba(110, 92, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'accolade'/prunus 'accolade' (3).jpg",
          width: 576,
          id: 'a977b8c6e1dfe2cfde58e058987260ca',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(131, 127, 111, 1.00)',
            'rgba(155, 120, 123, 1.00)',
            'rgba(136, 117, 96, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'accolade'/prunus 'accolade' (4).jpg",
          width: 576,
          id: 'e87575ff77aefcb03bf8af26e5e1a1ee',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 146, 153, 1.00)',
            'rgba(140, 130, 129, 1.00)',
            'rgba(80, 77, 49, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'accolade'/prunus 'accolade' (1).jpg",
          width: 1024,
          id: 'c3f77e542860c73e848869e4e57ae5dc',
          height: 683,
          thumbnail: true,
        },
        location: [47.271133, -1.581603],
        genre: 'Prunus',
        cultivar: 'Accolade',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581603, 47.271133] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2693f452135f94c0a36c915b93a7692a484b3b46',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 147, 187, 1.00)',
            'rgba(134, 106, 116, 1.00)',
            'rgba(91, 82, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'shosar'/prunus 'shosar'  (2).jpg",
          width: 512,
          id: 'b171d0569055c17ffa352145165f29bd',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(179, 133, 141, 1.00)',
            'rgba(150, 96, 97, 1.00)',
            'rgba(147, 117, 109, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'shosar'/prunus 'shosar' (2).jpg",
          width: 576,
          id: '649ab4fc7646a8bdb52da42f33a68b47',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(99, 87, 92, 1.00)',
            'rgba(158, 111, 120, 1.00)',
            'rgba(104, 79, 81, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/prunus [rosaceae]/prunus 'shosar'/prunus 'shosar'  (1).jpg",
          width: 1024,
          id: '3857611e4c37d48eb03906a53f6ed4a3',
          height: 764,
          thumbnail: true,
        },
        location: [47.271233, -1.585228],
        genre: 'Prunus',
        cultivar: 'Shosar',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585228, 47.271233] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6ab1bd882488e311f158cd3bf3e12280b81b133a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'incisa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 114, 114, 1.00)',
            'rgba(134, 131, 126, 1.00)',
            'rgba(86, 80, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/prunus [rosaceae]/prunus incisa/prunus incisa (2).jpg',
          width: 576,
          id: '68196a0c0b3949b6c413a6f3de518012',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(157, 154, 151, 1.00)',
            'rgba(134, 129, 121, 1.00)',
            'rgba(68, 65, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/prunus [rosaceae]/prunus incisa/prunus incisa (3).jpg',
          width: 1024,
          id: '458dbe71458d5232e6693c0c5be26c6e',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 157, 173, 1.00)',
            'rgba(130, 130, 128, 1.00)',
            'rgba(133, 127, 120, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/prunus [rosaceae]/prunus incisa/prunus incisa (1).jpg',
          width: 576,
          id: '24f20c4dc95b67b2aebd719f6cc6bcd7',
          height: 768,
          thumbnail: true,
        },
        location: [47.271392, -1.586128],
        genre: 'Prunus',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586128, 47.271392] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '33672a7f146b32fd583e32c38476f86d216705d2',
      fields: {
        espece: 'alba (ex. S. latifolia)',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '1986',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e01e4e978820b1193222cb33ccabcaae337f2ab6',
      fields: {
        espece: 'betulifolia',
        localisation: 'B8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206356, -1.543206],
        genre: 'Spiraea',
        date_plantation: '1999',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.543206, 47.2206356] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '060fb1e3b9563dfd972f18c47f78a16a8a687f2b',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 125, 107, 1.00)',
            'rgba(117, 147, 112, 1.00)',
            'rgba(89, 123, 66, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea japonica 'genpei'/spiraea japonica 'genpei' (3).jpg",
          width: 576,
          id: '2165d9cbdc09276ee56a424b1f2ba31a',
          height: 768,
          thumbnail: true,
        },
        espece: 'japonica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 115, 77, 1.00)',
            'rgba(118, 127, 88, 1.00)',
            'rgba(64, 89, 38, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea japonica 'genpei'/spiraea japonica 'genpei' (2).jpg",
          width: 576,
          id: '26cb8da9731e563978b3e14edef9a84f',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 108, 89, 1.00)',
            'rgba(107, 129, 100, 1.00)',
            'rgba(110, 125, 100, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea japonica 'genpei'/spiraea japonica 'genpei' (1).jpg",
          width: 1024,
          id: 'a7b79deb527e5a28ec44e7e853ee99dc',
          height: 768,
          thumbnail: true,
        },
        location: [47.269533, -1.583995],
        genre: 'Spiraea',
        cultivar: 'Genpei',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583995, 47.269533] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e4e43f0c45a14926e85893288ea15e7ee8a8c707',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 105, 65, 1.00)',
            'rgba(129, 140, 77, 1.00)',
            'rgba(135, 151, 77, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea x semperflorens 'syringiflora'/spiraea x semperflorens 'syringiflora' (3).jpg",
          width: 1024,
          id: 'cd54bd95e0595a4166f0c554a2ed913e',
          height: 768,
          thumbnail: true,
        },
        espece: 'x semperflorens',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(92, 129, 40, 1.00)',
            'rgba(114, 149, 65, 1.00)',
            'rgba(146, 156, 93, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea x semperflorens 'syringiflora'/spiraea x semperflorens 'syringiflora'  (2).jpg",
          width: 576,
          id: '0ec573c3f110952b333d1f2f007ad625',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 126, 79, 1.00)',
            'rgba(149, 135, 118, 1.00)',
            'rgba(104, 111, 63, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/spiraea [rosaceae]/spiraea x semperflorens 'syringiflora'/spiraea x semperflorens 'syringiflora'  (1).jpg",
          width: 576,
          id: 'd6e5e4afbd3e067fb5e6d9786b26e808',
          height: 768,
          thumbnail: true,
        },
        location: [47.270695, -1.586212],
        genre: 'Spiraea',
        cultivar: 'Syringiflora',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586212, 47.270695] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '07ae1e8c32b8e935fff5664bad6ddb003d6f9ada',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'tanakae',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(120, 157, 74, 1.00)',
            'rgba(101, 130, 58, 1.00)',
            'rgba(79, 103, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stephanandra [rosaceae]/stephanandra tanakae/stephanandra tanakae (8).jpg',
          width: 1024,
          id: '49c1713e3e29d6f875ffa8ac1bca816a',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(62, 93, 40, 1.00)',
            'rgba(90, 121, 55, 1.00)',
            'rgba(84, 83, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stephanandra [rosaceae]/stephanandra tanakae/stephanandra tanakae (9).jpg',
          width: 1024,
          id: '91da4823e98eca1dc8e8c34d21037884',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(59, 87, 48, 1.00)',
            'rgba(92, 110, 73, 1.00)',
            'rgba(83, 98, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stephanandra [rosaceae]/stephanandra tanakae/stephanandra tanakae (1).jpg',
          width: 1024,
          id: '2f71a693c405d89fff625b03f0a0a786',
          height: 683,
          thumbnail: true,
        },
        location: [47.270378, -1.582245],
        genre: 'Stephanandra',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582245, 47.270378] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a239d15341a0667ae14f9bfa5d386a7f27d3a117',
      fields: {
        espece: 'tanakae',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(67, 95, 36, 1.00)',
            'rgba(101, 131, 64, 1.00)',
            'rgba(113, 144, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stephanandra [rosaceae]/stephanandra tanakae/stephanandra tanakae (7).jpg',
          width: 1024,
          id: 'e7f01cf325df94cc1062e15a7f166bc2',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 133, 51, 1.00)',
            'rgba(119, 143, 74, 1.00)',
            'rgba(86, 106, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/stephanandra [rosaceae]/stephanandra tanakae/stephanandra tanakae (6).jpg',
          width: 1024,
          id: 'fc26b1245c475fdce74b7240f3b669d4',
          height: 683,
          thumbnail: true,
        },
        location: [47.270397, -1.582258],
        genre: 'Stephanandra',
        famille: 'Rosaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582258, 47.270397] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7f9dc960257bb5468bfdc480b6258751d3247bed',
      fields: {
        espece: 'occidentalis',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 199, 169, 1.00)',
            'rgba(101, 130, 69, 1.00)',
            'rgba(86, 92, 64, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cephalanthus [rubiaceae]/cephalanthus occidentalis/cephalanthus occidentalis (12).jpg',
          width: 949,
          id: 'e645b59d9fbaf5880567f1fffe8e8d22',
          height: 768,
          thumbnail: true,
        },
        location: [47.271622, -1.584408],
        genre: 'Cephalanthus',
        famille: 'Rubiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584408, 47.271622] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9d6eb93add4e58149004a220edc7e2bd70fb1f23',
      fields: {
        espece: 'tahitensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(175, 196, 187, 1.00)',
            'rgba(78, 122, 78, 1.00)',
            'rgba(53, 92, 51, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/gardenia [rubiaceae]/gardenia tahitensis/gardenia tahitensis.jpg",
          width: 576,
          id: '10bbe2cfa23ec74ca67f2d45843b09e9',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 160, 170, 1.00)',
            'rgba(110, 121, 116, 1.00)',
            'rgba(65, 76, 66, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/gardenia [rubiaceae]/gardenia tahitensis/gardenia tahitensis (1).jpg",
          width: 576,
          id: '406a8d9336d5893c6d054725203e5086',
          height: 768,
          thumbnail: true,
        },
        location: [47.227142, -1.512125],
        genre: 'Gardenia',
        famille: 'Rubiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512125, 47.227142] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '01ddd3e70fd0c15536feb152ef8c698e191ae2ee',
      fields: {
        origine: 'P\u00e9pini\u00e8re Arven',
        espece: 'japonica',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Orixa',
        date_plantation: '2014',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f99124e0ed408997b1568d4f012742e8d96d5281',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Gd Blottereau',
        espece: 'japonica',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Skimmia',
        date_plantation: '2017',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a01ee115f8d3838e249f7eb79eeb9a3f38c0ca38',
      fields: {
        espece: 'amurense',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(132, 137, 120, 1.00)',
            'rgba(141, 141, 118, 1.00)',
            'rgba(135, 133, 121, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/phellodendron [rutaceae]/phellodendron amurense/phellodendron amurense (9).jpg',
          width: 576,
          id: 'c4ccd9e066a9378270c68e7f81b857d5',
          height: 768,
          thumbnail: true,
        },
        location: [47.27023, -1.582617],
        genre: 'Phellodendron',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582617, 47.27023] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b0d6e7f53bd61b8a82306cbec1eb8444e3a46dd5',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'daniellii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 194, 202, 1.00)',
            'rgba(76, 89, 48, 1.00)',
            'rgba(81, 84, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tetradium [rutaceae]/tetradium daniellii/tetradium daniellii (14).jpg',
          width: 1024,
          id: 'adf87d690a283e2bde52311fb3217e0e',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(60, 86, 45, 1.00)',
            'rgba(87, 106, 65, 1.00)',
            'rgba(68, 83, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tetradium [rutaceae]/tetradium daniellii/tetradium daniellii (15).jpg',
          width: 1024,
          id: '4d88404ac10e819097251e224017ce2d',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(54, 76, 44, 1.00)',
            'rgba(110, 123, 83, 1.00)',
            'rgba(79, 93, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/tetradium [rutaceae]/tetradium daniellii/tetradium daniellii (13).jpg',
          width: 1024,
          id: '85242b982a9b8a0564c2a567b22b6266',
          height: 683,
          thumbnail: true,
        },
        location: [47.270945, -1.5848],
        genre: 'Tetradium',
        famille: 'Rutaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5848, 47.270945] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4adbab8eb47d1f87f1fd91dd8fe41d58262879c4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'serrata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 142, 36, 1.00)',
            'rgba(166, 141, 13, 1.00)',
            'rgba(97, 96, 17, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/azara [salicaceae]/azara serrata/azara serrata  (2).jpg',
          width: 576,
          id: 'e982645201bdd79cb2729aaa00df7990',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 109, 73, 1.00)',
            'rgba(109, 119, 85, 1.00)',
            'rgba(113, 132, 86, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/azara [salicaceae]/azara serrata/azara serrata (1).jpg',
          width: 576,
          id: '5857dc9373348a6289e37191ce517214',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(194, 195, 150, 1.00)',
            'rgba(131, 128, 50, 1.00)',
            'rgba(103, 106, 57, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/azara [salicaceae]/azara serrata/azara serrata  (1).jpg',
          width: 1024,
          id: '5ded1db0d28706cf069093f9660edee6',
          height: 768,
          thumbnail: true,
        },
        location: [47.271545, -1.586747],
        genre: 'Azara',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586747, 47.271545] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c3bd5d7c7dc1e50eb798663f192b26d15e2f8dd6',
      fields: {
        nom_du_site: 'Parc floral de la Beaujoire',
        espece: 'dentata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 169, 100, 1.00)',
            'rgba(109, 121, 46, 1.00)',
            'rgba(93, 108, 38, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/azara [salicaceae]/azara dentata/azara dentata (2).jpg',
          width: 1024,
          id: 'f5c7ffe12be136134430755b7f0839ec',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(64, 73, 21, 1.00)',
            'rgba(116, 118, 21, 1.00)',
            'rgba(124, 131, 36, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/azara [salicaceae]/azara dentata/azara dentata (3).jpg',
          width: 576,
          id: '89852263ce796c846e026f0da7f75753',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(86, 111, 14, 1.00)',
            'rgba(131, 151, 45, 1.00)',
            'rgba(170, 167, 63, 1.00)',
          ],
          filename:
            'ip parc floral de la beaujoire/azara [salicaceae]/azara dentata/azara dentata (1).jpg',
          width: 576,
          id: 'cca6f22809b0f10ac70cb9b647c22bc1',
          height: 768,
          thumbnail: true,
        },
        location: [47.262075, -1.531747],
        genre: 'Azara',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.531747, 47.262075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1a7c288161748f1bce198fab3ba49f872c36830d',
      fields: {
        nom_du_site: "Jardin d'agronomie tropicale du Grand-Blottereau",
        espece: 'sinensis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(169, 157, 110, 1.00)',
            'rgba(132, 106, 38, 1.00)',
            'rgba(115, 83, 15, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/poliothyrsis [salicaceae]/poliothyrsis sinensis/poliothyrsis sinensis (3).jpg",
          width: 576,
          id: '220b908d5971f592a523b525958a758d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(144, 163, 159, 1.00)',
            'rgba(129, 134, 99, 1.00)',
            'rgba(56, 62, 33, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/poliothyrsis [salicaceae]/poliothyrsis sinensis/poliothyrsis sinensis.jpg",
          width: 647,
          id: '4faf59507e2bd561269f7febd33aedca',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(145, 160, 127, 1.00)',
            'rgba(113, 118, 67, 1.00)',
            'rgba(62, 75, 26, 1.00)',
          ],
          filename:
            "ip jardin d'agronomie tropicale du grand-blottereau/poliothyrsis [salicaceae]/poliothyrsis sinensis/poliothyrsis sinensis (2).jpg",
          width: 576,
          id: '6cfbd60e7a09e4e6256cfbd069363002',
          height: 768,
          thumbnail: true,
        },
        location: [47.226895, -1.512758],
        genre: 'Poliothyrsis',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.512758, 47.226895] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '88e8473bb8304a120b22c4663699c885f9c30fc8',
      fields: {
        espece: 'vinimalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(178, 134, 113, 1.00)',
            'rgba(175, 110, 80, 1.00)',
            'rgba(177, 110, 73, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/salix [salicaceae]/salix vinimalis 'rouge ardennais'/salix vinimalis 'rouge ardennais' (2).jpg",
          width: 576,
          id: '163427b4bb0ead5d9ae8c95e63864006',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(215, 215, 216, 1.00)',
            'rgba(144, 100, 76, 1.00)',
            'rgba(108, 83, 58, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/salix [salicaceae]/salix vinimalis 'rouge ardennais'/salix vinimalis 'rouge ardennais' (1).jpg",
          width: 604,
          id: 'd883bce30b6cf8f9df3dbed5e1f68291',
          height: 768,
          thumbnail: true,
        },
        location: [47.271662, -1.58688],
        genre: 'Salix',
        cultivar: 'Rouge Ardennais',
        famille: 'Salicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58688, 47.271662] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '994406655e6e0d69a287ea506cbf2e9bc56497ca',
      fields: {
        origine: 'P\u00e9pini\u00e8res Dauguet - 53 Larchamp',
        espece: 'griseum',
        localisation: 'A5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2207668, -1.5440149],
        genre: 'Acer',
        date_plantation: '2012',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5440149, 47.2207668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'df9d0892179451c35eb7c042edf27a179220a25a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'circinatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 101, 33, 1.00)',
            'rgba(109, 146, 64, 1.00)',
            'rgba(105, 131, 64, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer circinatum/acer circinatum  (2).jpg',
          width: 576,
          id: '2177b32182524e0a324469f7c071307f',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 140, 85, 1.00)',
            'rgba(147, 142, 75, 1.00)',
            'rgba(137, 139, 75, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer circinatum/acer circinatum (1).jpg',
          width: 576,
          id: '579e6713c4a0eb46b134a7d7ede067df',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(189, 202, 164, 1.00)',
            'rgba(70, 94, 39, 1.00)',
            'rgba(54, 71, 27, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer circinatum/acer circinatum  (1).jpg',
          width: 787,
          id: 'dadf1a74dada3d759c0f52473d2f471f',
          height: 768,
          thumbnail: true,
        },
        location: [47.271103, -1.586012],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586012, 47.271103] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '543b967c1bfc4f5ef24fdb93624914ea33f038ff',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'cissifolium',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(134, 133, 103, 1.00)',
            'rgba(147, 159, 104, 1.00)',
            'rgba(118, 138, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer cissifolium/acer cissifolium  (4).jpg',
          width: 576,
          id: '019efa7455d721c678f2923974ff880b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 166, 119, 1.00)',
            'rgba(133, 155, 72, 1.00)',
            'rgba(107, 131, 48, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer cissifolium/acer cissifolium  (5).jpg',
          width: 576,
          id: '95f53d35402f59b7853d90eb101e9e63',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 147, 46, 1.00)',
            'rgba(115, 145, 42, 1.00)',
            'rgba(94, 112, 32, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer cissifolium/acer cissifolium  (1).jpg',
          width: 576,
          id: '74129ee719149d0039b7337af65ed998',
          height: 768,
          thumbnail: true,
        },
        location: [47.27088, -1.58157],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58157, 47.27088] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e4df85ec09f1c4b5ee70aa2142438b5c39684d10',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'grosseri var. hersii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 114, 123, 1.00)',
            'rgba(91, 78, 44, 1.00)',
            'rgba(47, 43, 23, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer grosseri var. hersii/acer grosseri var.hersii  (10).jpg',
          width: 1024,
          id: '5122eea0941c871c53c79eb30b592479',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(33, 75, 143, 1.00)',
            'rgba(102, 86, 91, 1.00)',
            'rgba(136, 89, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer grosseri var. hersii/acer grosseri var.hersii  (14).jpg',
          width: 512,
          id: '10df1581d73146d7784106a77ba1ae41',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(89, 115, 22, 1.00)',
            'rgba(113, 137, 39, 1.00)',
            'rgba(125, 132, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer grosseri var. hersii/acer grosseri var.hersii  (1).jpg',
          width: 576,
          id: '923bba54f4d26d86c6e27eac0b8f287d',
          height: 768,
          thumbnail: true,
        },
        location: [47.271062, -1.586063],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586063, 47.271062] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1bf70e944c2a9859aa5cbfeeeb47b8daa2758eb1',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 124, 89, 1.00)',
            'rgba(173, 119, 80, 1.00)',
            'rgba(153, 109, 79, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer palmatum 'shishi-gashira'/acer palmatum 'shishi-gashira'  (3).jpg",
          width: 1024,
          id: '0403320f3270071610f9a1ddaff17ac7',
          height: 768,
          thumbnail: true,
        },
        espece: 'palmatum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 130, 108, 1.00)',
            'rgba(147, 125, 82, 1.00)',
            'rgba(112, 112, 86, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer palmatum 'shishi-gashira'/acer palmatum 'shishi-gashira'  (2).jpg",
          width: 576,
          id: '0da5c3fd0c19866d283d9544619b0ade',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 123, 107, 1.00)',
            'rgba(119, 136, 122, 1.00)',
            'rgba(96, 109, 89, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer palmatum 'shishi-gashira'/acer palmatum 'shishi-gashira'  (1).jpg",
          width: 576,
          id: '0f9315e0105b483d69a7f9321f4065e1',
          height: 768,
          thumbnail: true,
        },
        location: [47.270078, -1.582403],
        genre: 'Acer',
        cultivar: 'Shishi-gashira',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582403, 47.270078] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e0fda75a63b16029f4a5cf1f7ec64ced20c0d588',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'platanoides',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 130, 54, 1.00)',
            'rgba(103, 142, 90, 1.00)',
            'rgba(141, 145, 118, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer platanoides/acer platanoides (4).jpg',
          width: 576,
          id: '1260781ea49e9f0e5050f716504ea233',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(85, 108, 44, 1.00)',
            'rgba(119, 153, 92, 1.00)',
            'rgba(121, 124, 87, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer platanoides/acer platanoides (5).jpg',
          width: 576,
          id: '25f2694530e4ad867a7b268b1ed890d7',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 127, 106, 1.00)',
            'rgba(129, 128, 107, 1.00)',
            'rgba(134, 132, 114, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer platanoides/acer platanoides (10).jpg',
          width: 576,
          id: '2df9bf109e5afe01602bdbb658bb7e87',
          height: 768,
          thumbnail: true,
        },
        location: [47.271053, -1.581178],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581178, 47.271053] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '478b717ed4cfad624b1b7c6a963599d10aa72b56',
      fields: {
        espece: 'pseudoplatanus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(186, 194, 205, 1.00)',
            'rgba(125, 118, 76, 1.00)',
            'rgba(65, 69, 26, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer pseudoplatanus 'nizetii'/acer pseudoplatanus 'nizetii' (2).jpg",
          width: 1024,
          id: 'ce4d89c4742c7af38772363f1b3414ac',
          height: 764,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 102, 55, 1.00)',
            'rgba(131, 84, 48, 1.00)',
            'rgba(100, 85, 40, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer pseudoplatanus 'nizetii'/acer pseudoplatanus 'nizetii' (1).jpg",
          width: 576,
          id: '6729edbcb5f316d52cecf4b540ef1f7a',
          height: 768,
          thumbnail: true,
        },
        location: [47.271163, -1.585128],
        genre: 'Acer',
        cultivar: 'Nizetii',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585128, 47.271163] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd075b76e06a74c2e9f5b595906f9edbdc784569c',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(136, 123, 106, 1.00)',
            'rgba(147, 141, 125, 1.00)',
            'rgba(142, 141, 128, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer saccharinum 'born's graciosa'/acer saccharinum 'born's graciosa' (6).jpg",
          width: 630,
          id: '184c53bf7d06b1c3281b7726e977ebf4',
          height: 768,
          thumbnail: true,
        },
        espece: 'saccharinum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 102, 85, 1.00)',
            'rgba(112, 124, 95, 1.00)',
            'rgba(108, 108, 83, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer saccharinum 'born's graciosa'/acer saccharinum 'born's graciosa' (5).jpg",
          width: 576,
          id: 'b9b5b9cd892ab449059ca5eacd04dd70',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 133, 130, 1.00)',
            'rgba(135, 128, 119, 1.00)',
            'rgba(122, 115, 101, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer saccharinum 'born's graciosa'/acer saccharinum 'born's graciosa' (3).jpg",
          width: 576,
          id: 'c46bbd130d007cdad98911f8b4d2adea',
          height: 768,
          thumbnail: true,
        },
        location: [47.268858, -1.584878],
        genre: 'Acer',
        cultivar: "Born's Graciosa",
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584878, 47.268858] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '88bf490629103d9f495e10f4460ecbb90acf447c',
      fields: {
        espece: 'triflorum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 112, 66, 1.00)',
            'rgba(188, 104, 57, 1.00)',
            'rgba(177, 95, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer triflorum/acer triflorum (7).jpg',
          width: 576,
          id: '2d871f41e3ba9a30b3987d5c0e3b179e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(190, 95, 51, 1.00)',
            'rgba(172, 98, 53, 1.00)',
            'rgba(190, 114, 66, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/acer [sapindaceae]/acer triflorum/acer triflorum (4).jpg',
          width: 576,
          id: '69fb957a461fc0b1ddf704286152c971',
          height: 768,
          thumbnail: true,
        },
        location: [47.270467, -1.581875],
        genre: 'Acer',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581875, 47.270467] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1fff0c8243f51c731034b4959c38ecdac529d55f',
      fields: {
        espece: 'x freemanii',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 152, 142, 1.00)',
            'rgba(126, 161, 142, 1.00)',
            'rgba(90, 128, 111, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/acer [sapindaceae]/acer x freemanii 'marmo'/acer x freemanii 'marmo' (3).jpg",
          width: 576,
          id: '9affbcabf24a7b9569478860353aadf7',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Acer',
        cultivar: 'Marmo',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c8125e1f62c552a401228c398f32f698bd1f4108',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'hippocastanum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 121, 74, 1.00)',
            'rgba(117, 124, 76, 1.00)',
            'rgba(105, 108, 67, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus hippocastanum/aesculus hippocastanum (3).jpg',
          width: 576,
          id: '420f030f519ac289be1e1623bb3ac8af',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(160, 194, 231, 1.00)',
            'rgba(121, 143, 105, 1.00)',
            'rgba(84, 93, 45, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus hippocastanum/aesculus hippocastanum (4).jpg',
          width: 576,
          id: '56204e9025f30fbdff4e010998d941d1',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(102, 109, 50, 1.00)',
            'rgba(115, 126, 69, 1.00)',
            'rgba(101, 112, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/aesculus [sapindaceae]/aesculus hippocastanum/aesculus hippocastanum (1).jpg',
          width: 600,
          id: '35cc9b007b075886070abadddf70cd02',
          height: 768,
          thumbnail: true,
        },
        location: [47.270778, -1.582033],
        genre: 'Aesculus',
        famille: 'Sapindaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582033, 47.270778] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '370c06dd9fa46280ca09b62a8da3f58092cac961',
      fields: {
        origine: 'P\u00e9pini\u00e8re des Avettes 71290 La Gen\u00eate',
        espece: 'sp',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Strobilanthes',
        date_plantation: '2015',
        famille: 'Acanthaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4a150d07ed28905ad186ad084973939727deee9a',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'bitchiuense',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 147, 97, 1.00)',
            'rgba(125, 139, 82, 1.00)',
            'rgba(135, 133, 92, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum bitchiuense/viburnum bitchiuense (2).jpg',
          width: 576,
          id: 'be9eafc6c15955a18aa145441baed61a',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 120, 76, 1.00)',
            'rgba(135, 114, 75, 1.00)',
            'rgba(115, 106, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum bitchiuense/viburnum bitchiuense (3).jpg',
          width: 576,
          id: '0bcaa8537b03be432412f50646b38986',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(80, 76, 59, 1.00)',
            'rgba(142, 133, 133, 1.00)',
            'rgba(84, 80, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum bitchiuense/viburnum bitchiuense (1).jpg',
          width: 576,
          id: 'd75706617971dd4a6eec856d8f0d1e31',
          height: 768,
          thumbnail: true,
        },
        location: [47.270842, -1.58425],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58425, 47.270842] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a7ca82aad342010f96512a7037e423de908107a0',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'melanocarpum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(128, 145, 102, 1.00)',
            'rgba(78, 102, 40, 1.00)',
            'rgba(73, 91, 32, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum melanocarpum/viburnum melanocarpum (3).jpg',
          width: 596,
          id: '718cc1e5f6fcfa7a950a7bc98b6fdb4b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 163, 76, 1.00)',
            'rgba(114, 149, 57, 1.00)',
            'rgba(89, 117, 36, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum melanocarpum/viburnum melanocarpum (4).jpg',
          width: 576,
          id: '03c25946035cc8cc4c7c10e8af11d12e',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(106, 144, 35, 1.00)',
            'rgba(107, 149, 32, 1.00)',
            'rgba(85, 119, 22, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum melanocarpum/viburnum melanocarpum (1).jpg',
          width: 576,
          id: '4f355fdbdee4c199973173eec4cf11e6',
          height: 768,
          thumbnail: true,
        },
        location: [47.270588, -1.582647],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582647, 47.270588] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7c9bac99082d23cafac62be51e01bacfd7cf5c2a',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(123, 152, 81, 1.00)',
            'rgba(98, 126, 59, 1.00)',
            'rgba(94, 121, 54, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum opulus 'lady marmelade'/viburnum opulus 'lady marmelade' (3).jpg",
          width: 1024,
          id: '9ed7bd72f9f12a649a02a5554d48ae0b',
          height: 768,
          thumbnail: true,
        },
        espece: 'opulus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(65, 85, 35, 1.00)',
            'rgba(110, 124, 70, 1.00)',
            'rgba(92, 113, 59, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum opulus 'lady marmelade'/viburnum opulus 'lady marmelade' (2).jpg",
          width: 576,
          id: '4d2a58a3fe198b2105058cda228943bd',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(101, 130, 61, 1.00)',
            'rgba(110, 139, 52, 1.00)',
            'rgba(97, 126, 46, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum opulus 'lady marmelade'/viburnum opulus 'lady marmelade' (1).jpg",
          width: 576,
          id: '6bc3ec154ca2cee0dac5b7537c16444d',
          height: 768,
          thumbnail: true,
        },
        location: [47.271292, -1.582272],
        genre: 'Viburnum',
        cultivar: 'Lady Marmelade',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582272, 47.271292] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4b6ca4f046d7add8f19528ec16a3b0460a1b441e',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'rhytidophyllum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 182, 131, 1.00)',
            'rgba(102, 116, 66, 1.00)',
            'rgba(63, 79, 32, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum rhytidophyllum/viburnum rhytidophyllum  (2).jpg',
          width: 576,
          id: 'e8bffcc410c51e901685068d348caeb8',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 142, 86, 1.00)',
            'rgba(115, 136, 81, 1.00)',
            'rgba(77, 99, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum rhytidophyllum/viburnum rhytidophyllum  (4).jpg',
          width: 576,
          id: '601985d7ea13baa4a938fd2c9cdfe98c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(96, 103, 64, 1.00)',
            'rgba(101, 111, 70, 1.00)',
            'rgba(89, 99, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum rhytidophyllum/viburnum rhytidophyllum  (1).jpg',
          width: 576,
          id: '8964d0d2df7c90ec66b33bb864d09e3c',
          height: 768,
          thumbnail: true,
        },
        location: [47.271638, -1.582863],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582863, 47.271638] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '0b4f5520785b2fccc763e4294c0c5565a1264405',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x burkwoodii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(143, 143, 98, 1.00)',
            'rgba(133, 136, 94, 1.00)',
            'rgba(130, 122, 94, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x burkwoodii/viburnum x burkwoodii (4).jpg',
          width: 540,
          id: 'e45229c3d74c928f9a9940d183e60610',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 91, 70, 1.00)',
            'rgba(134, 127, 109, 1.00)',
            'rgba(85, 75, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x burkwoodii/viburnum x burkwoodii (5).jpg',
          width: 576,
          id: '641a56c9fbff95477bb854c3f622c7a4',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 170, 115, 1.00)',
            'rgba(134, 144, 91, 1.00)',
            'rgba(98, 118, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x burkwoodii/viburnum x burkwoodii (3).jpg',
          width: 576,
          id: '0064a0025b6f381a43034ed7e65b0dde',
          height: 768,
          thumbnail: true,
        },
        location: [47.270958, -1.584167],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584167, 47.270958] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'af33eced9861ac308d4790a3a5c543557989b239',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x carlcephalum',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(70, 90, 32, 1.00)',
            'rgba(115, 143, 76, 1.00)',
            'rgba(112, 134, 77, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x carlcephalum/viburnum x carlcephalum (2).jpg',
          width: 576,
          id: '8c06ca4004b4d480a8450f77700653bc',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 124, 32, 1.00)',
            'rgba(123, 140, 87, 1.00)',
            'rgba(82, 109, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x carlcephalum/viburnum x carlcephalum (3).jpg',
          width: 576,
          id: '3814f378ced204f8298e7c51b9d10f3f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(122, 146, 76, 1.00)',
            'rgba(103, 136, 80, 1.00)',
            'rgba(82, 114, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x carlcephalum/viburnum x carlcephalum (1).jpg',
          width: 576,
          id: 'e5934d6926cc5d03ad8d143791da4e5c',
          height: 768,
          thumbnail: true,
        },
        location: [47.271028, -1.586533],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586533, 47.271028] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1775d7ac7304662280a5e825a211c3c1becbc9a4',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x juddii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(159, 98, 75, 1.00)',
            'rgba(186, 95, 81, 1.00)',
            'rgba(148, 87, 62, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x juddii/viburnum x juddii  (2).jpg',
          width: 576,
          id: 'ab0b14bd896c2618e1264b46f6fc9bcb',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(90, 93, 70, 1.00)',
            'rgba(129, 125, 119, 1.00)',
            'rgba(84, 79, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x juddii/viburnum x juddii (1).jpg',
          width: 576,
          id: '292e33c0a06ed7b0b17e0d6608fb68e7',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(179, 163, 145, 1.00)',
            'rgba(142, 108, 70, 1.00)',
            'rgba(121, 105, 78, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/viburnum [adoxaceae]/viburnum x juddii/viburnum x juddii  (1).jpg',
          width: 1024,
          id: 'd5753fced22e607771f9e197401e44a0',
          height: 768,
          thumbnail: true,
        },
        location: [47.271928, -1.586495],
        genre: 'Viburnum',
        famille: 'Adoxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586495, 47.271928] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '397c55b9b117d44f2f91b79461d2f691e27e41f4',
      fields: {
        origine: 'Alpengarten im Belvederegarten,Wien,Autriche',
        espece: 'obesus Salisb.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Narcissus',
        date_plantation: '2012',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '572cb98b0893fa259a044eee2affe92988743bd2',
      fields: {
        origine: 'JB. Prague (Rep. Tch\u00e8que)',
        espece: 'cantabricus DC.',
        localisation: 'A3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2209791, -1.5442857],
        genre: 'Narcissus',
        date_plantation: '2010',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442857, 47.2209791] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a3d62d3292770f42a41b56277c9481b7ad7839ed',
      fields: {
        origine: 'JB.Goteborg  (Suede)',
        espece: 'siculum Ucria',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Allium',
        date_plantation: '2010',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2ea22cfa21682ec3570f56c33f1723be7e3c31cb',
      fields: {
        origine: 'JBU.Kosice (Slovaquie)',
        espece: 'pulchellum Don.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Allium',
        date_plantation: '2001',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5fb1f803836c4a9ea1d0a009d2301b77adde9b60',
      fields: {
        espece: "umbellatus L'Herit.",
        localisation: 'B7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198817, -1.5442188],
        genre: 'Agapanthus',
        date_plantation: '1973',
        famille: 'Amaryllidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442188, 47.2198817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '598a8f252a9735bd2eb11db223f2b818b0b1edc6',
      fields: {
        origine: 'JB.Ljubljani (Slov\u00e9nie)',
        espece: 'sibirica  C.A.Mey.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Libanotis',
        date_plantation: '2008',
        cultivar: 'montana P.W.Ball',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3d0992ca3fa440c34fafc5c2e28f8dcddfaff0c6',
      fields: {
        origine: 'JB.Vacatrot (Hongrie)',
        espece: 'vulgaris  Bernh.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Falcaria',
        date_plantation: '2008',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ed7bed8dcecbe60cec0f6f68c29526d7d4a0cede',
      fields: {
        origine: 'JBU.de Fribourg (Suisse)',
        espece: 'austriacum Koch',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Peucedanum',
        date_plantation: '2004',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '37b0c910a7e687b022cf49d21106b7f07dca3e6b',
      fields: {
        origine: 'Les Ponts de C\u00e9_p\u00e9pini\u00e8re Lepage',
        espece: 'gigas Nakai',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Angelica',
        date_plantation: '2016',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '45c93bc6463f94e299809963f4bc9d74d29c5a11',
      fields: {
        origine: 'Sichtungs garten Weinheim (Allemagne)',
        espece: 'agavifolium Griseb.',
        localisation: 'I2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185657, -1.5426599],
        genre: 'Eryngium',
        date_plantation: '2011',
        famille: 'Apiaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426599, 47.2185657] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fd5168270186fb94ed686512ea24e662a1c1111f',
      fields: {
        origine: 'Botanischer Garten,Friedrich Jena, Jena, Allemagne',
        espece: 'latifolia M.E.Jones',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Amsonia',
        date_plantation: '2012',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'decc12246cae02118fd16f3974698c86bfc798fd',
      fields: {
        origine: 'JB. Hermannshof, Wheinheim (Allemagne)',
        espece: 'illustris Woodson',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Amsonia',
        date_plantation: '2011',
        famille: 'Apocynaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '35ec9238e74af7bd85d1e1109ce1cd092dccfb61',
      fields: {
        origine:
          'Botanischer Garten der Justus-Liebig-Universit\u00e4t, Giessen, Allemagne',
        espece: 'consanguineum Schott',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Arisaema',
        date_plantation: '2013',
        famille: 'Araceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cfe1a67992d59395ded2ca838ee039a014102010',
      fields: {
        espece: 'aethiopica Sprengel',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Zantedeschia',
        date_plantation: '1973',
        famille: 'Araceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '21832bd492efcae4b2ecc988c443f42bbd8f80f6',
      fields: {
        espece: 'septemlobus',
        localisation: 'B7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198817, -1.5442188],
        genre: 'Kalopanax',
        date_plantation: '1995',
        famille: 'Araliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5442188, 47.2198817] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fe301d0c5cd3cb5ae50d2487f26e44139d988b47',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'x virgata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 132, 41, 1.00)',
            'rgba(133, 136, 46, 1.00)',
            'rgba(126, 126, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corokia [argophyllaceae]/corokia x virgata/corokia x virgata (2).jpg',
          width: 576,
          id: 'afdc21b68a7962a5fcbcfb806df64832',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 126, 59, 1.00)',
            'rgba(122, 124, 40, 1.00)',
            'rgba(85, 90, 24, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corokia [argophyllaceae]/corokia x virgata/corokia x virgata (3).jpg',
          width: 576,
          id: '65df69dd16fda970a635cb12f5d45bf5',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 148, 87, 1.00)',
            'rgba(137, 134, 63, 1.00)',
            'rgba(144, 143, 87, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/corokia [argophyllaceae]/corokia x virgata/corokia x virgata (1).jpg',
          width: 788,
          id: '57ff4f17526fde5685e878047ca8615e',
          height: 768,
          thumbnail: true,
        },
        location: [47.271138, -1.584842],
        genre: 'Corokia',
        famille: 'Argophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584842, 47.271138] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4207299b84de3243692b22c8478339c5ffe64c64',
      fields: {
        origine: 'Botanischer Garten,Dresden,All.',
        espece: 'litardierei Breistr.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Scilla',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '81080a14a3615dc36089a740d00d927d28e04ac9',
      fields: {
        origine: 'Goteborg Botanical Garden,Goteborg,Su\u00e8de',
        espece: 'prattii Baker',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Polygonatum',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '58b2c2e3583ba7412301c857466b121b4a4ede65',
      fields: {
        origine: 'Hortus Botanico Vindobanensis Wien (Autriche)',
        espece: 'ramosum L.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Anthericum',
        date_plantation: '2014',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '514553663f25f1805cacada92d0993a44b6f3c4a',
      fields: {
        origine:
          'Inst de botanique et arboretum de Komarovii Perkallksky (Russie)',
        espece: 'tenuiflora Heldr.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Leopoldia',
        date_plantation: '2010',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '943cfdfc2d92e2746f898f4abef6068373f17b37',
      fields: {
        origine: 'JB.Samouns',
        espece: 'ramosum  Lam.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Anthericum',
        date_plantation: '1999',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '62a162c94702deea39f77b02f2a87a4828c2670e',
      fields: {
        origine: 'JB.Vancouver (Canada)',
        espece: 'rupestris Hilliard',
        localisation: 'G2A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2197208, -1.5414609],
        genre: 'Albuca',
        date_plantation: '2009',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5414609, 47.2197208] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e997fa3b07c0f8e4ae45ca9f8f4c82d7d33b8e4b',
      fields: {
        origine: 'JBU.Komensk\u00e9o (Slovaquie)',
        espece: 'bifolia L.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Scilla',
        date_plantation: '2006',
        cultivar: 'danubialis Speta',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '376282acbb89eb83503af692e6754d5b9ccbd5a0',
      fields: {
        origine: 'JBU.Z\u00fcrich (Suisse)',
        espece: 'pole-evansii N.E.Br.',
        localisation: 'I1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2185256, -1.5421325],
        genre: 'Eucomis',
        date_plantation: '2004',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5421325, 47.2185256] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd574f123d864f6bae709ce7c08c8e0b7ffeb162e',
      fields: {
        origine: 'Sichtungsgartens Hermannshof,Weienheim,All.',
        espece: 'hispanica L.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Hyacinthoides',
        date_plantation: '2012',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9e0b9c2468f95b7e0f04e97fbcd1567fdb489957',
      fields: {
        origine: 'The Morton Arb. Lisle (U.S.A.)',
        espece: 'virginica Salisb.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Manfreda',
        date_plantation: '2000',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e1dc48ef999a6548474bd42131b95e187f1ec6b1',
      fields: {
        espece: 'spicata Lour.',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Liriope',
        date_plantation: '1973',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2431339ed18e5ae512b98a1994235c2dc0e4f4bb',
      fields: {
        origine: 'JB.Brooklin (USA)',
        espece: 'maculosa Lam',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Centaurea',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '153b1019c777b87776bde30b69f97bf502d966da',
      fields: {
        origine: 'Conservatoire Botanique Pierre Fabre',
        espece: 'monspeliense Coste',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Leucanthemum',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '960bdb0c880d3a9d14813022dd9df292886b02bb',
      fields: {
        origine: 'Ets.Lepage',
        espece: 'albus Gaertn.',
        localisation: 'G1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193375, -1.5415093],
        genre: 'Petasites',
        date_plantation: '1986',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5415093, 47.2193375] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b191f07403d4f7ec02c8c5e23680ae733dbb048a',
      fields: {
        origine: 'Grugapark Essen (Allemagne)',
        espece: 'alpina Wallr.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Cicerbita',
        date_plantation: '1987',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '32063a5d10d43ceb560ef111ef3125238037dfb1',
      fields: {
        origine: 'J.B. Marie Curie, Lublin (Pologne)',
        espece: 'acaulis L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Carlina',
        date_plantation: '2011',
        cultivar: 'acaulis',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '43966ecf6c1061abbe71272962f6a65d6e1bbc07',
      fields: {
        origine: 'J.B.de Bern,Suisse',
        espece: 'montanum DC.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Taraxacum',
        date_plantation: '2014',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '913bf0aa6fa861f00e8fd47d2c063edbb43ba2ea',
      fields: {
        origine: 'JB. Leipzig, Leipzig (Allemagne)',
        espece: 'exaltatus Schrad.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Echinops',
        date_plantation: '2011',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '99e60fd009b733ce6c40cc500a28e0c07a042629',
      fields: {
        origine: 'JB.Chanonsia (Italie)',
        espece: 'uniflora Turra.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Centaurea',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1cd1f64a44073ecaa1b709046e714a7aab6d12c0',
      fields: {
        origine: 'JB.Meyrin (Suisse)',
        espece: 'ritro  L.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Echinops',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ccfe02b963bd9beaa46ddcea2952ec14bad16ef0',
      fields: {
        origine: 'JB.Montr\u00e9al (Canada)',
        espece: 'flexicaulis L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Solidago',
        date_plantation: '2009',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2d929ca5586ed2b02560e49a5fa46b4a7fe395bb',
      fields: {
        origine: 'JB.Municipal de Graz (Autriche)',
        espece: 'corymbosum Schultz Bip.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Tanacetum',
        date_plantation: '2003',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4ad09241f184ec5521ead843db8b1f51d18fd59c',
      fields: {
        origine: 'JB.Niagara Parks (Canada)',
        espece: 'purpurea Moench.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Echinacea',
        date_plantation: '2001',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '92a1aee93ec96891172b9a70603c9b2e01856477',
      fields: {
        origine: 'JB.Peligni (Italie)',
        espece: 'tenorii  Grande',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Achillea',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f356ae54a5619ae02811cebe11f9f10bb72d6b5e',
      fields: {
        origine: 'JB.Vladivostok (Russie)',
        espece: 'ageratoides Turcz.',
        localisation: 'D3D',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201668, -1.5418243],
        genre: 'Aster',
        date_plantation: '2009',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418243, 47.2201668] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'abb2fdb35b034f0f5a2333a5c3fb0bf29930fd50',
      fields: {
        origine: 'JB.Weinheim (Allemagne)',
        espece: 'integrifolium L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Parthenium',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4dd9d4d10337586e68ddcc3367510e2f1799566c',
      fields: {
        origine: 'JB.Weinheim (Allemagne)',
        espece: 'flexicaulis L.',
        localisation: 'C6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195286, -1.542453],
        genre: 'Solidago',
        date_plantation: '2008',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542453, 47.2195286] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '95bb5fd826111056fa44f700738f86d5c8a61632',
      fields: {
        origine: 'Kunming Botanical Garden',
        espece: 'hodgsoni Hook.f.',
        localisation: 'D1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2200207, -1.542118],
        genre: 'Ligularia',
        date_plantation: '2006',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.542118, 47.2200207] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd309fd72069bcb857a0e8ef2caaf4bda289b4159',
      fields: {
        origine: 'Remi Legros - Les Sorini\u00e8res',
        espece: 'leptophyllus',
        localisation: 'A4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2210889, -1.5441084],
        genre: 'Ozothamnus',
        date_plantation: '2014',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5441084, 47.2210889] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '627bf8c8f9f79371e941469dffc5c284d44e6041',
      fields: {
        origine: "R\u00e9serve Bowman's Hill (U.S.A.)",
        espece: 'fistulosum Barrat.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Eupatorium',
        date_plantation: '1990',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fde1195013723e817da5058f100113efb5d23979',
      fields: {
        origine: 'Sichtungs garten Weinheim (Allemagne)',
        espece: 'arkansana DC',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Vernonia',
        date_plantation: '2011',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1f118181b2cfe50dea9fdcc645c1e7166c4e7549',
      fields: {
        origine: 'Universit\u00e9e de Lublin (Pologne)',
        espece: 'pannonica Scheele',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Achillea',
        date_plantation: '2009',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'fad971a22173d5be42badb9ed1731625fc84e5c2',
      fields: {
        espece: 'montana L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Centaurea',
        date_plantation: '1973',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7e4624528842e906d4149a30909ce99b2f3af58e',
      fields: {
        espece: 'solandri',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(118, 126, 116, 1.00)',
            'rgba(116, 118, 100, 1.00)',
            'rgba(100, 104, 87, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/olearia [asteraceae]/olearia solandri 'aurea'/olearia solandri 'aurea'  (2).jpg",
          width: 1024,
          id: 'd5778b6511390cf8178e6fd334737c61',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(104, 106, 101, 1.00)',
            'rgba(101, 105, 103, 1.00)',
            'rgba(92, 98, 93, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/olearia [asteraceae]/olearia solandri 'aurea'/olearia solandri 'aurea'  (1).jpg",
          width: 1024,
          id: '8f04927d5fd0df6892acbc4eaf3682dd',
          height: 683,
          thumbnail: true,
        },
        location: [47.271367, -1.58093],
        genre: 'Olearia',
        cultivar: 'Aurea',
        famille: 'Asteraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58093, 47.271367] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'cccc0222209e560023579fbd06ecaa20c5fd9dc8',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'pruinosa var. longifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(156, 166, 119, 1.00)',
            'rgba(95, 112, 57, 1.00)',
            'rgba(104, 117, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/berberis [berberidaceae]/berberis pruinosa var. longifolia/berberis pruinosa var. longifolia (1).jpg',
          width: 576,
          id: 'f7197f13f255214d6ed44570c3839b1b',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(116, 124, 71, 1.00)',
            'rgba(126, 140, 91, 1.00)',
            'rgba(90, 113, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/berberis [berberidaceae]/berberis pruinosa var. longifolia/berberis pruinosa var. longifolia (2).jpg',
          width: 576,
          id: '48a5141f3f62e8bd7bf3885888036f9d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 153, 113, 1.00)',
            'rgba(120, 132, 86, 1.00)',
            'rgba(68, 83, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/berberis [berberidaceae]/berberis pruinosa var. longifolia/berberis pruinosa var. longifolia  (1).jpg',
          width: 576,
          id: '6112ae4a07257889b9e8d94da01013ee',
          height: 768,
          thumbnail: true,
        },
        location: [47.270555, -1.584928],
        genre: 'Berberis',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584928, 47.270555] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4a74f9afd689deefe8d9301bae553439e654f8ae',
      fields: {
        espece: 'thunbergii',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 137, 125, 1.00)',
            'rgba(142, 133, 121, 1.00)',
            'rgba(111, 112, 89, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/berberis [berberidaceae]/berberis thunbergii 'atropurpurea'/berberis thunbergii 'atropurpurea'.jpg",
          width: 576,
          id: 'b4a56e4ada0e7a5217eb437f4463a28c',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Berberis',
        cultivar: 'Atropurpurea',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bc2f25facb3ccf6f80d52adfad70bc9012b039c2',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(133, 105, 97, 1.00)',
            'rgba(182, 71, 103, 1.00)',
            'rgba(126, 64, 70, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/mahonia [berberidaceae]/mahonia x media 'charity'/mahonia x media 'charity' (3).jpg",
          width: 1024,
          id: '8602c998596a4873c06f9fa0bedc5dfa',
          height: 768,
          thumbnail: true,
        },
        espece: 'x media',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(152, 156, 125, 1.00)',
            'rgba(91, 108, 49, 1.00)',
            'rgba(111, 114, 80, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/mahonia [berberidaceae]/mahonia x media 'charity'/mahonia x media 'charity' (2).jpg",
          width: 576,
          id: 'c631d400b86f5633358d805e2b7f644c',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(109, 120, 40, 1.00)',
            'rgba(103, 115, 34, 1.00)',
            'rgba(79, 103, 26, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/mahonia [berberidaceae]/mahonia x media 'charity'/mahonia x media 'charity' (1).jpg",
          width: 576,
          id: 'a93c7c24acbd816fcec5042f9b8437c2',
          height: 768,
          thumbnail: true,
        },
        location: [47.271433, -1.587255],
        genre: 'Mahonia',
        cultivar: 'Charity',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587255, 47.271433] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6b6dd67b91d2aec3d56ef7f761e5392b3462dddd',
      fields: {
        espece: 'domestica',
        localisation: 'B6',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202904, -1.5436506],
        genre: 'Nandina',
        date_plantation: '1973',
        famille: 'Berberidaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436506, 47.2202904] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b67525b73fbb46a61acf9e5aa2bb96116ec89819',
      fields: {
        origine: 'P\u00e9pini\u00e8re Ville de Nantes',
        espece: 'nigra',
        localisation: 'A1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2206331, -1.5449399],
        genre: 'Betula',
        date_plantation: '2017',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5449399, 47.2206331] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'eedfca3be0d8fc91baa33438d8d94f011ca27a11',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'cordata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 130, 179, 1.00)',
            'rgba(122, 124, 131, 1.00)',
            'rgba(69, 65, 46, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/alnus [betulaceae]/alnus cordata/alnus cordata  (3).jpg',
          width: 537,
          id: 'a8adc1d619a02f3545d9b5c3c98fe195',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(87, 114, 156, 1.00)',
            'rgba(114, 127, 145, 1.00)',
            'rgba(63, 65, 63, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/alnus [betulaceae]/alnus cordata/alnus cordata  (4).jpg',
          width: 512,
          id: '544cbc6279509a910dbadfbb59185b9c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 130, 139, 1.00)',
            'rgba(128, 128, 124, 1.00)',
            'rgba(128, 134, 145, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/alnus [betulaceae]/alnus cordata/alnus cordata  (2).jpg',
          width: 576,
          id: 'e6b00182041559bdf8725f277f0981a9',
          height: 768,
          thumbnail: true,
        },
        location: [47.27, -1.58208],
        genre: 'Alnus',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58208, 47.27] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '9a764157cc9430418adc7c7ad68aae820616d578',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'maritima',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(119, 137, 114, 1.00)',
            'rgba(126, 147, 112, 1.00)',
            'rgba(107, 142, 101, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/alnus [betulaceae]/alnus maritima/alnus maritima (2).jpg',
          width: 576,
          id: '782297251d402445706dfb5e8aef4214',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 146, 102, 1.00)',
            'rgba(117, 141, 86, 1.00)',
            'rgba(98, 118, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/alnus [betulaceae]/alnus maritima/alnus maritima (3).jpg',
          width: 576,
          id: '5bc06bf65b1b5df71bff155ca327573c',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(126, 151, 107, 1.00)',
            'rgba(122, 148, 98, 1.00)',
            'rgba(110, 140, 83, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/alnus [betulaceae]/alnus maritima/alnus maritima (1).jpg',
          width: 576,
          id: '2f488c0305dadf64fbcf75ffe84e7d7c',
          height: 768,
          thumbnail: true,
        },
        location: [47.270492, -1.584038],
        genre: 'Alnus',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584038, 47.270492] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e19f07472903fec3e67b6195cf81962ce3c5b599',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'betulus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 182, 131, 1.00)',
            'rgba(135, 135, 94, 1.00)',
            'rgba(81, 82, 50, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/carpinus [betulaceae]/carpinus betulus/carpinus betulus (2).jpg',
          width: 576,
          id: '4f0a7b93680d1901694eaf1c98a5424d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(127, 131, 118, 1.00)',
            'rgba(127, 134, 120, 1.00)',
            'rgba(131, 124, 108, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/carpinus [betulaceae]/carpinus betulus/carpinus betulus (4).jpg',
          width: 576,
          id: '5bb6c4f38c416ecec5e08f98e169f531',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(138, 140, 111, 1.00)',
            'rgba(104, 106, 55, 1.00)',
            'rgba(71, 73, 38, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/carpinus [betulaceae]/carpinus betulus/carpinus betulus (1).jpg',
          width: 576,
          id: '7bba7dc76542e7700cd4ba06920aa83a',
          height: 768,
          thumbnail: true,
        },
        location: [47.269095, -1.584908],
        genre: 'Carpinus',
        famille: 'Betulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584908, 47.269095] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e9cead192d7fffd99984f3a5a5dbf00e412c4222',
      fields: {
        origine: 'B.G. Kiel (All.)',
        espece: 'sphaeroides Payson',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Draba',
        date_plantation: '2015',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4c60e00ff222ba49b46cdc1d690b3724cf7dfd0c',
      fields: {
        origine: 'Botanischer Garten Kiel (All.)',
        espece: 'paysonii J.F.Macbr.',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Draba',
        date_plantation: '2015',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4456cf1832ba4d83e12d1ec82f0fe06168b7b53b',
      fields: {
        origine: 'Botanischer Garten,Friedrich Jena, Jena, Allemagne',
        espece: 'sudetica Tausch',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Arabis',
        date_plantation: '2012',
        famille: 'Brassicaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '85005efbc3aabe31ba25632b628d7ef94d386eba',
      fields: {
        espece: 'sempervirens',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 153, 98, 1.00)',
            'rgba(103, 145, 79, 1.00)',
            'rgba(82, 123, 71, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/buxus [buxaceae]/buxus sempervirens/buxus sempervirens (2).jpg',
          width: 576,
          id: '963b8843d8e1dcb341ea923e88f50790',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 115, 38, 1.00)',
            'rgba(76, 129, 54, 1.00)',
            'rgba(87, 148, 59, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/buxus [buxaceae]/buxus sempervirens/buxus sempervirens (1).jpg',
          width: 576,
          id: 'a90647059ddfebc20928d4a78237fc04',
          height: 768,
          thumbnail: true,
        },
        location: [47.269805, -1.584453],
        genre: 'Buxus',
        famille: 'Buxaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584453, 47.269805] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3dc46741a68154ddd418c7410ee132c3d7dba041',
      fields: {
        espece: 'siliquastrum f. albida',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(83, 77, 54, 1.00)',
            'rgba(125, 116, 100, 1.00)',
            'rgba(101, 94, 77, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cercis [caesalpiniaceae]/cercis siliquastrum f. albida/cercis siliquastrum f. albida (1).jpg',
          width: 576,
          id: '37099687b978724af0476ae2ad761f8f',
          height: 768,
          thumbnail: true,
        },
        location: [47.270903, -1.585395],
        genre: 'Cercis',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585395, 47.270903] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4d2b49e20287b243c9c9a1945969381c6c96f911',
      fields: {
        espece: 'siliquastrum',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(115, 120, 97, 1.00)',
            'rgba(154, 112, 141, 1.00)',
            'rgba(97, 90, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cercis [caesalpiniaceae]/cercis siliquastrum/cercis siliquastrum.jpg',
          width: 576,
          id: '36fb940a2a1bfb1c7cffd33c1c3473ca',
          height: 768,
          thumbnail: true,
        },
        location: [47.2697, -1.584842],
        genre: 'Cercis',
        famille: 'Caesalpiniaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584842, 47.2697] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c0ee8f29ecd6409f5b0809186b24de6e9b8359f5',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'occidentalis',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(79, 112, 67, 1.00)',
            'rgba(124, 108, 76, 1.00)',
            'rgba(126, 102, 77, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/calycanthus [calycanthaceae]/calycanthus occidentalis/calycanthus occidentalis (10).jpg',
          width: 1024,
          id: 'a88ef9ec3b55b2688e833469a7928a10',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(111, 143, 80, 1.00)',
            'rgba(99, 121, 72, 1.00)',
            'rgba(75, 117, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/calycanthus [calycanthaceae]/calycanthus occidentalis/calycanthus occidentalis (11).jpg',
          width: 1024,
          id: 'c770671ed41e22fe2c5cde9b9b2047d6',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(95, 130, 66, 1.00)',
            'rgba(89, 110, 66, 1.00)',
            'rgba(90, 115, 75, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/calycanthus [calycanthaceae]/calycanthus occidentalis/calycanthus occidentalis (1).jpg',
          width: 1024,
          id: '1cb1b60adff99447af44ad9e52af81a1',
          height: 683,
          thumbnail: true,
        },
        location: [47.271478, -1.583],
        genre: 'Calycanthus',
        famille: 'Calycanthaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.583, 47.271478] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '8f3b8a379d73cad65f785fbd63f6afa786d819c7',
      fields: {
        origine: 'B.G.Munchen (All.)',
        espece: 'zangezura Lipsky',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Symphyandra',
        date_plantation: '2014',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a0dc217fba069849b02746d9e4d5a5f11f8eee11',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'limonifolium Janchen',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Asyneuma',
        date_plantation: '2009',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a53f5605dfb30543853e5e1bd0a938ba6253a8af',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'graminifolius A.DC.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Edraianthus',
        date_plantation: '2006',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '68c3726150f699e30b748b90e2dac331895c27f3',
      fields: {
        origine: 'JB.Nantes',
        espece: 'canescens Griseb.et Schenk.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Asyneuma',
        date_plantation: '2001',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a6ec1150447d44c0ed5773f1b2116a1252b23cc8',
      fields: {
        origine: 'JBU.Sheffied (Angleterre)',
        espece: 'latifolia L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Campanula',
        date_plantation: '1989',
        famille: 'Campanulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '5307ad34649327a4ff977802c211e4279cbebb26',
      fields: {
        origine: 'JB.Copenhage (Danemark)',
        espece: 'graminifolia  L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Scabiosa',
        date_plantation: '2008',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '84210d940fc0a871a7e69701fc14b1b1bb34cbbf',
      fields: {
        origine: 'JB.Olomouc (R\u00e9publique Tch\u00e8que)',
        espece: 'lucida Vill.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Scabiosa',
        date_plantation: '2009',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'bf66850ff69e8443cddc7f56da0443dbf36aa062',
      fields: {
        origine: 'P\u00e9pini\u00e8re municipale du Gd Blottereau',
        espece: 'amabilis',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Kolkwitzia',
        date_plantation: '2016',
        cultivar: 'Pink cloud',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'f66503615f57730eb69d3afe055fd76a2eff30d2',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'engleriana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 135, 88, 1.00)',
            'rgba(130, 132, 84, 1.00)',
            'rgba(76, 99, 27, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia engleriana/abelia engleriana (2).jpg',
          width: 576,
          id: '27f210da2dbe71582a6c80db363950ec',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(140, 151, 102, 1.00)',
            'rgba(112, 132, 70, 1.00)',
            'rgba(92, 115, 56, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia engleriana/abelia engleriana (3).jpg',
          width: 576,
          id: '38ae091937dcd0b43bd5ec9c57611860',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(139, 157, 86, 1.00)',
            'rgba(122, 147, 73, 1.00)',
            'rgba(116, 123, 72, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/abelia [caprifoliaceae]/abelia engleriana/abelia engleriana (1).jpg',
          width: 576,
          id: '96b0960b2a9191125984284dc3a01d6c',
          height: 768,
          thumbnail: true,
        },
        location: [47.271445, -1.587158],
        genre: 'Abelia',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.587158, 47.271445] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '26f43eda45c8d2dc3903bf23659485965a93731f',
      fields: {
        espece: 'formosa',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(170, 187, 142, 1.00)',
            'rgba(85, 113, 56, 1.00)',
            'rgba(88, 102, 61, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/leycesteria [caprifoliaceae]/leycesteria formosa 'purple rain'/leycesteria formosa 'purple rain' (7).jpg",
          width: 1024,
          id: 'c901035213ab9273f3ea67d546e88014',
          height: 683,
          thumbnail: true,
        },
        location: [47.271662, -1.58688],
        genre: 'Leycesteria',
        cultivar: 'Purple Rain',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.58688, 47.271662] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a7900849e015de55083d64ca93669b189cf0b5d5',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'altaica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 158, 109, 1.00)',
            'rgba(115, 139, 81, 1.00)',
            'rgba(79, 112, 48, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera altaica/lonicera altaica (2).jpg',
          width: 576,
          id: '259a2ad6c1bcdec2e90558f17d6bd9f1',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(112, 139, 82, 1.00)',
            'rgba(110, 151, 87, 1.00)',
            'rgba(93, 130, 73, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera altaica/lonicera altaica (3).jpg',
          width: 576,
          id: 'e3e02039707a388b33f235adb78c089f',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(164, 175, 140, 1.00)',
            'rgba(106, 131, 74, 1.00)',
            'rgba(98, 108, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera altaica/lonicera altaica (1).jpg',
          width: 576,
          id: '1121bd3fb92bb1d0560bac486d682356',
          height: 768,
          thumbnail: true,
        },
        location: [47.269931, -1.584553],
        genre: 'Lonicera',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584553, 47.269931] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2c95adeb08b139ec7622a76dbc37f42850757780',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'standishii',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 156, 90, 1.00)',
            'rgba(131, 141, 93, 1.00)',
            'rgba(116, 105, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera standishii/lonicera standishii  (2).jpg',
          width: 576,
          id: 'a655b22d820a4646897437af10b62bab',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(150, 153, 160, 1.00)',
            'rgba(94, 100, 71, 1.00)',
            'rgba(111, 116, 76, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera standishii/lonicera standishii  (3).jpg',
          width: 1024,
          id: 'ad73a9d89ad54d6dd10dd9939f937107',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(184, 174, 161, 1.00)',
            'rgba(133, 118, 90, 1.00)',
            'rgba(94, 81, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/lonicera [caprifoliaceae]/lonicera standishii/lonicera standishii  (1).jpg',
          width: 576,
          id: '6b413462d45496531376f35848d250f2',
          height: 768,
          thumbnail: true,
        },
        location: [47.270163, -1.582613],
        genre: 'Lonicera',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582613, 47.270163] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3bf86586ecd5f0117e3052d69934bd6856035d66',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'triflora',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(93, 110, 66, 1.00)',
            'rgba(97, 115, 66, 1.00)',
            'rgba(63, 84, 32, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/zabelia [caprifoliaceae]/zabelia triflora/zabelia triflora (2).jpg',
          width: 553,
          id: '0b8ee2409c75f1381980343057d980ba',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(161, 153, 98, 1.00)',
            'rgba(152, 118, 42, 1.00)',
            'rgba(122, 106, 37, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/zabelia [caprifoliaceae]/zabelia triflora/zabelia triflora (3).jpg',
          width: 576,
          id: '585397b9742fa89fa797d3a81064bca5',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 151, 106, 1.00)',
            'rgba(130, 140, 71, 1.00)',
            'rgba(106, 128, 58, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/zabelia [caprifoliaceae]/zabelia triflora/zabelia triflora (1).jpg',
          width: 576,
          id: 'f809cc2257d27e38d22a86573293e73a',
          height: 768,
          thumbnail: true,
        },
        location: [47.271255, -1.584878],
        genre: 'Zabelia',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584878, 47.271255] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '81e8f49de6aa076b4c360d566b558bdb7dc349b4',
      fields: {
        espece: 'triflora',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(213, 219, 205, 1.00)',
            'rgba(114, 122, 67, 1.00)',
            'rgba(97, 105, 44, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/zabelia [caprifoliaceae]/zabelia triflora/zabelia triflora (6).jpg',
          width: 1024,
          id: 'b87a230e3cbb07695a2290b8fc4b7796',
          height: 768,
          thumbnail: true,
        },
        location: [47.271317, -1.586833],
        genre: 'Zabelia',
        famille: 'Caprifoliaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586833, 47.271317] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '1581d73f89990c0950dc42e839866eaed5f47daf',
      fields: {
        origine: 'Botanische Garten Universitat Bonn, Bonn, Allemagne',
        espece: 'chungtienensis W.W.Sm.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Silene',
        date_plantation: '2013',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'c9930579445b73851074b010ca2e60cf37f919b7',
      fields: {
        origine: 'Botanische Garten Universitat Bonn, Bonn, Allemagne',
        espece: 'italica Pers.',
        localisation: 'B4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205218, -1.5436966],
        genre: 'Silene',
        date_plantation: '2013',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436966, 47.2205218] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3cb3015a524a7cd165967fde8373f88f1751d132',
      fields: {
        origine: 'Botanischer Garten Graz (Autriche)',
        espece: 'pendula L.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Silene',
        date_plantation: '2015',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3cd8eb8330d4d4465c8eca87ea45a94bd91fdd7a',
      fields: {
        origine: 'Botanischer Garten,Mainz,Allamagne',
        espece: 'capillacae Graebn.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Minuartia',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '96c28897f016caec92ba9de2b79893fddce18a47',
      fields: {
        origine: 'Botanischer Garten,Stuttgart,Allemagne',
        espece: 'arenarius Pall.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Dianthus',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '95cca86961774700cd8ba082ac6651807eb84942',
      fields: {
        origine: 'Devonian BG Alberta (Canada)',
        espece: 'krascheninnikavii Schirchk.',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Minuartia',
        date_plantation: '2014',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '6f38f9ea30f938c944c886a5e90cd4593109c758',
      fields: {
        origine: 'Experimenteller B.G. Gottingen (All.)',
        espece: 'armeria L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Dianthus',
        date_plantation: '2015',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'e442e9794b88812f2f7170a7cdf8a57295f6bd69',
      fields: {
        origine: 'Experimenteller B.G. Gottingen (All.)',
        espece: 'cachemirica Mattf.',
        localisation: 'E1',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190459, -1.5436715],
        genre: 'Minuartia',
        date_plantation: '2015',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5436715, 47.2190459] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '3766555d93a825d49f1beb0a4f773342afdcc16b',
      fields: {
        origine: 'Grugapark Essen (Allemagne)',
        espece: 'allwoodii Hort. (x)',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Dianthus',
        date_plantation: '1987',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '306f5dd51164951bcc346b9a38cf2939ace5035c',
      fields: {
        origine: 'J.Alp.Belvedere Wien (Autriche)',
        espece: 'giganteus',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Dianthus',
        date_plantation: '2005',
        cultivar: 'banaticus',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '37f0c87add6a0fa8b9d66d793baa1cdefabf678a',
      fields: {
        origine: 'JB.G\u00f6teborg (Su\u00e8de)',
        espece: 'saxifraga L.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Silene',
        date_plantation: '2006',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'effa69bb49ab67fcff8d9144a4f9f00997f480d3',
      fields: {
        origine: 'JB.Leipzig (Allemagne)',
        espece: 'anatolicus Boiss.',
        localisation: 'C5',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2193141, -1.5428001],
        genre: 'Dianthus',
        date_plantation: '2009',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5428001, 47.2193141] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '11d9f84a7bb7f5733aa1d95069622ba9ff47b550',
      fields: {
        origine: 'JB.Munich (Allemagne)',
        espece: 'spinosum L.',
        localisation: 'C3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198464, -1.5432582],
        genre: 'Alyssum',
        date_plantation: '2009',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5432582, 47.2198464] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '7a9c777591da5de27ae23088fb671595ab218390',
      fields: {
        origine: 'JB.Sofia (Bulgarie)',
        espece: 'trichotoma Wend.',
        localisation: 'B9',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2205226, -1.5429769],
        genre: 'Gypsophila',
        date_plantation: '2009',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429769, 47.2205226] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'b59b876b3bd30854ed5e35ede54b826264dd1704',
      fields: {
        origine: 'JBU.et Arbor\u00e9tum Brno (R\u00e9p.Tch\u00e8que)',
        espece: 'hungaricus Pers.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Dianthus',
        date_plantation: '1989',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4528bb8513c6bf6c3913c5f78cb307644d74b4ff',
      fields: {
        origine: 'JBU.G\u00f6d\u00f6ll\u00f6 (Hongrie)',
        espece: 'serotinus Waldst. et Kit.',
        localisation: 'C8',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202227, -1.5426922],
        genre: 'Dianthus',
        date_plantation: '1998',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5426922, 47.2202227] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '4a15612a6d98c0e26a7d355a4766b62139feca90',
      fields: {
        origine: "Universita degli Studi dell'Aquila",
        espece: 'saxifraga P.W.Ball & Heyw.',
        localisation: 'B3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.220075, -1.5444508],
        genre: 'Petrorhagia',
        date_plantation: '2006',
        famille: 'Caryophyllaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5444508, 47.220075] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '82a280ea1e7c8bc5d48f53cf0fdf43142bff2da6',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'americanus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(174, 176, 168, 1.00)',
            'rgba(106, 93, 72, 1.00)',
            'rgba(90, 94, 68, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus americanus/euonymus americanus (2).jpg',
          width: 576,
          id: 'de4bfa62987ebda1a2684bb43030dab0',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(103, 119, 99, 1.00)',
            'rgba(120, 137, 127, 1.00)',
            'rgba(121, 135, 115, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus americanus/euonymus americanus (6).jpg',
          width: 576,
          id: '3aa0027d73d8b9d44691485c698acb15',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 149, 120, 1.00)',
            'rgba(145, 124, 100, 1.00)',
            'rgba(112, 123, 96, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus americanus/euonymus americanus (1).jpg',
          width: 1024,
          id: 'ca67fb9b897e321a92d9e8b2e3cac627',
          height: 768,
          thumbnail: true,
        },
        location: [47.271253, -1.580597],
        genre: 'Euonymus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.580597, 47.271253] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '556ebd7393fea4f33185592cef728ddcafc73c81',
      fields: {
        espece: 'europaeus',
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 134, 116, 1.00)',
            'rgba(75, 91, 67, 1.00)',
            'rgba(83, 95, 61, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus europaeus/euonymus europaeus  (2).jpg',
          width: 1024,
          id: 'c94d202b93a5ff34692fe3219b02a0b9',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Euonymus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a2af45b9969bab9ebf85511a6cbc63cd304a0e37',
      fields: {
        espece: 'hamiltonianus',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 158, 136, 1.00)',
            'rgba(97, 110, 92, 1.00)',
            'rgba(64, 101, 75, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus hamiltonianus/euonymus hamiltonianus (3).jpg',
          width: 576,
          id: 'e64f2a0334dfa8011539b4ba77bf865a',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(66, 66, 53, 1.00)',
            'rgba(122, 135, 96, 1.00)',
            'rgba(126, 156, 90, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/euonymus [celastraceae]/euonymus hamiltonianus/euonymus hamiltonianus (1).jpg',
          width: 576,
          id: 'cba5649e0c8f1eece8b84c3b7a26782e',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Euonymus',
        famille: 'Celastraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '857a627adbef8807d1ca9f2d49161177625b06ca',
      fields: {
        origine: 'Universit\u00e9 Giessen (Allemagne)',
        espece: 'apenninum Mill.',
        localisation: 'E2',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2190146, -1.5427585],
        genre: 'Helianthemum',
        date_plantation: '2011',
        famille: 'Cistaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5427585, 47.2190146] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2208da7da47d7f4ca92714873a7c2491ce385e8a',
      fields: {
        espece: 'alnifolia',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(137, 132, 93, 1.00)',
            'rgba(126, 124, 85, 1.00)',
            'rgba(78, 81, 42, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/clethra [clethraceae]/clethra alnifolia 'hummingbird'/clethra alnifolia 'hummingbird'   (2).jpg",
          width: 576,
          id: '1e17bb2e0c9575bf1e7805d7d57ef6e8',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(73, 81, 53, 1.00)',
            'rgba(128, 128, 96, 1.00)',
            'rgba(140, 133, 118, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/clethra [clethraceae]/clethra alnifolia 'hummingbird'/clethra alnifolia 'hummingbird'   (1).jpg",
          width: 846,
          id: '21c93cb99570d321309df2350b0da560',
          height: 768,
          thumbnail: true,
        },
        location: [47.271967, -1.582637],
        genre: 'Clethra',
        cultivar: 'Hummingbird',
        famille: 'Clethraceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582637, 47.271967] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'd7a570cbeac87a4c40cbf3170bda842742d1b049',
      fields: {
        espece: 'virginiana L.',
        localisation: 'C4',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2195866, -1.5429564],
        genre: 'Tradescantia',
        date_plantation: '1973',
        famille: 'Commelinaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5429564, 47.2195866] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '20134a2367d622b658ed8dfb269a88d5f45a82a4',
      fields: {
        origine: 'Takashi Nishiuchi, Konan City (Japon)',
        espece: 'japonicus',
        localisation: 'D3A',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2201437, -1.5418754],
        genre: 'Ophiopogon',
        date_plantation: '2011',
        famille: 'Asparagaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5418754, 47.2201437] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '65222fb0a1a865eb23d3604c3b14356ddfc7b1d6',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(165, 169, 104, 1.00)',
            'rgba(128, 130, 34, 1.00)',
            'rgba(86, 88, 29, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus alba 'aurea'/cornus alba 'aurea' (2).jpg",
          width: 1024,
          id: '3ac7bed9011f55baddc9485682d5aab5',
          height: 768,
          thumbnail: true,
        },
        espece: 'alba',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(155, 133, 93, 1.00)',
            'rgba(155, 114, 99, 1.00)',
            'rgba(152, 120, 119, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus alba 'aurea'/cornus alba 'aurea' (14).jpg",
          width: 576,
          id: '7d5c356b1cee086540e39a47079aca6a',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(179, 170, 154, 1.00)',
            'rgba(162, 162, 147, 1.00)',
            'rgba(138, 148, 127, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus alba 'aurea'/cornus alba 'aurea' (12).jpg",
          width: 576,
          id: 'f8e2788ef221f5ef284882032f14b831',
          height: 768,
          thumbnail: true,
        },
        location: [47.271397, -1.584653],
        genre: 'Cornus',
        cultivar: 'Aurea',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.584653, 47.271397] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'dacdac1feb8f0ced17bcee1c81bf35e2cbf22e43',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'capitata',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(203, 217, 219, 1.00)',
            'rgba(102, 111, 64, 1.00)',
            'rgba(86, 93, 39, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus capitata/cornus capitata (1).jpg',
          width: 576,
          id: '70fe073c364cd5a381f4441602efed3d',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(130, 158, 54, 1.00)',
            'rgba(113, 146, 40, 1.00)',
            'rgba(102, 122, 40, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus capitata/cornus capitata (2).jpg',
          width: 576,
          id: '6d6801db24e35aa42b089f4bf3395f5d',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(191, 207, 214, 1.00)',
            'rgba(105, 120, 81, 1.00)',
            'rgba(89, 97, 55, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus capitata/cornus capitata  (2).jpg',
          width: 576,
          id: 'acfb320bab893714ba050bb3e587ee70',
          height: 768,
          thumbnail: true,
        },
        location: [47.269753, -1.581847],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581847, 47.269753] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '815a1b89fbeefa37859c1154c762321fd239980c',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'elliptica',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(110, 123, 102, 1.00)',
            'rgba(88, 104, 70, 1.00)',
            'rgba(62, 74, 45, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus elliptica/cornus elliptica (6).jpg',
          width: 1024,
          id: '83096740276bcc302fbc44447d1d3439',
          height: 683,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(100, 112, 82, 1.00)',
            'rgba(100, 112, 84, 1.00)',
            'rgba(98, 109, 84, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus elliptica/cornus elliptica (9).jpg',
          width: 1024,
          id: '37b104f882a0bce232af81cda27fb1b3',
          height: 683,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(124, 159, 59, 1.00)',
            'rgba(116, 154, 34, 1.00)',
            'rgba(126, 144, 65, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus elliptica/cornus elliptica (5).jpg',
          width: 576,
          id: 'c370131fc59b81e7166407d83111ef73',
          height: 768,
          thumbnail: true,
        },
        location: [47.271005, -1.586533],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586533, 47.271005] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '42dbdb8c221cea6c61cdcfbca24cc31e2ba72904',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'florida ssp. urbiniana',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 160, 145, 1.00)',
            'rgba(156, 160, 143, 1.00)',
            'rgba(86, 84, 53, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida ssp. urbiniana/cornus florida ssp. urbiniana (5).jpg',
          width: 576,
          id: 'b23e62ce788e162bee6d64e86b7bdd8c',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(148, 147, 122, 1.00)',
            'rgba(134, 125, 98, 1.00)',
            'rgba(124, 113, 95, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida ssp. urbiniana/cornus florida ssp. urbiniana (7).jpg',
          width: 576,
          id: '0f60a8d7845c162da9e0fff61efd814b',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(94, 108, 83, 1.00)',
            'rgba(101, 132, 107, 1.00)',
            'rgba(92, 100, 74, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida ssp. urbiniana/cornus florida ssp. urbiniana (1).jpg',
          width: 576,
          id: '6ad53b0eb3886d249d45efa3f112214b',
          height: 768,
          thumbnail: true,
        },
        location: [47.270538, -1.581417],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.581417, 47.270538] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'df0f9cd082769e16d09ba80a5d010de5376345f7',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'florida',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(196, 209, 209, 1.00)',
            'rgba(105, 112, 68, 1.00)',
            'rgba(89, 81, 51, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida/cornus florida (3).jpg',
          width: 1024,
          id: '5f22e1b44e06357ede6ddbe7e1cc7390',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(212, 212, 211, 1.00)',
            'rgba(115, 101, 76, 1.00)',
            'rgba(81, 81, 52, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida/cornus florida (4).jpg',
          width: 576,
          id: 'daa037e50ac37ba27f41dbe91f865333',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(74, 76, 64, 1.00)',
            'rgba(152, 152, 145, 1.00)',
            'rgba(110, 104, 99, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus florida/cornus florida (2).jpg',
          width: 576,
          id: '58c96715df0741394ab6e0bcc6617682',
          height: 768,
          thumbnail: true,
        },
        location: [47.270842, -1.586142],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.586142, 47.270842] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'a8a214f606951bc837bd1d46b0c2a5fb49d87b91',
      fields: {
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(71, 91, 16, 1.00)',
            'rgba(110, 127, 34, 1.00)',
            'rgba(110, 133, 20, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'rasen'/cornus kousa 'rasen' (3).jpg",
          width: 576,
          id: '12e6ae59c72ad26413b48f6df88cfb59',
          height: 768,
          thumbnail: true,
        },
        espece: 'kousa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(151, 162, 44, 1.00)',
            'rgba(144, 164, 37, 1.00)',
            'rgba(116, 137, 36, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'rasen'/cornus kousa 'rasen' (2).jpg",
          width: 576,
          id: 'd64ca96c7eb8523911bfbc938271e02e',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(141, 142, 59, 1.00)',
            'rgba(144, 145, 57, 1.00)',
            'rgba(119, 148, 32, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'rasen'/cornus kousa 'rasen' (1).jpg",
          width: 576,
          id: '97b071d9f0ac8607f30ca2eb73c91981',
          height: 768,
          thumbnail: true,
        },
        location: [47.271555, -1.5869],
        genre: 'Cornus',
        cultivar: 'Rasen',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5869, 47.271555] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ec5779c250ad2236653796d420191541349828c1',
      fields: {
        espece: 'kousa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(125, 122, 94, 1.00)',
            'rgba(119, 100, 70, 1.00)',
            'rgba(64, 70, 37, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'wielings'/cornus kousa 'wielings' (2).jpg",
          width: 576,
          id: '5e7256a7d8ab66e8de4ba73b51fd210b',
          height: 768,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(135, 144, 109, 1.00)',
            'rgba(117, 136, 93, 1.00)',
            'rgba(95, 105, 68, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus kousa 'wielings'/cornus kousa 'wielings' (1).jpg",
          width: 576,
          id: '7754511c65d4abc28fdea06264038c81',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Cornus',
        cultivar: 'Wielings',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '636c78de455271da7c8c4bd8bf23c48e9c1bf0d9',
      fields: {
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        espece: 'rugosa',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(68, 95, 27, 1.00)',
            'rgba(112, 132, 62, 1.00)',
            'rgba(95, 118, 45, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus rugosa/cornus rugosa  (2).jpg',
          width: 576,
          id: '906177a1f8df00cc91e489adb5818ec5',
          height: 768,
          thumbnail: true,
        },
        photo3: {
          format: 'JPEG',
          color_summary: [
            'rgba(114, 127, 107, 1.00)',
            'rgba(99, 141, 107, 1.00)',
            'rgba(104, 113, 98, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus rugosa/cornus rugosa  (3).jpg',
          width: 564,
          id: '16faa311457651d2ceeb5ced6524ebf0',
          height: 768,
          thumbnail: true,
        },
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(77, 99, 41, 1.00)',
            'rgba(96, 132, 45, 1.00)',
            'rgba(80, 106, 41, 1.00)',
          ],
          filename:
            'ip arboretum cimetiere parc/cornus [cornaceae]/cornus rugosa/cornus rugosa  (1).jpg',
          width: 576,
          id: 'd9e3a78ed9ff0ccb88b587c24c480bba',
          height: 768,
          thumbnail: true,
        },
        location: [47.269525, -1.585142],
        genre: 'Cornus',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.585142, 47.269525] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '85d23147f50a287e1e9c1da9fda5ed7cbbfef483',
      fields: {
        espece: 'sericea',
        photo2: {
          format: 'JPEG',
          color_summary: [
            'rgba(154, 146, 117, 1.00)',
            'rgba(154, 132, 64, 1.00)',
            'rgba(129, 107, 47, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus sericea 'flaviramea'/cornus sericea 'flaviramea' (5).jpg",
          width: 1024,
          id: 'ec2344dc87eac8779003893935eb8244',
          height: 683,
          thumbnail: true,
        },
        nom_du_site: 'Arboretum Cimeti\u00e8re Parc',
        photo1: {
          format: 'JPEG',
          color_summary: [
            'rgba(146, 148, 141, 1.00)',
            'rgba(131, 109, 55, 1.00)',
            'rgba(89, 72, 41, 1.00)',
          ],
          filename:
            "ip arboretum cimetiere parc/cornus [cornaceae]/cornus sericea 'flaviramea'/cornus sericea 'flaviramea' (3).jpg",
          width: 1024,
          id: '07314fecd9447d096183a9d625ddf288',
          height: 683,
          thumbnail: true,
        },
        location: [47.27185, -1.582168],
        genre: 'Cornus',
        cultivar: 'Flaviramea',
        famille: 'Cornaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.582168, 47.27185] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: '2101f560f460eaf4532043cebb145bbde8b78081',
      fields: {
        origine: 'Botanical Garden Klagenfurt',
        espece: 'semenovii Boriss.',
        localisation: 'D3',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2202913, -1.5420155],
        genre: 'Rhodiola',
        date_plantation: '2014',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5420155, 47.2202913] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
    {
      datasetid: '244400404_collection-vegetale-nantes',
      recordid: 'ff31e80e48a213299f7a25949777286cc6535c97',
      fields: {
        origine: 'Botanische Garten Universitat Bonn, Bonn, Allemagne',
        espece: 'spatholifolium',
        localisation: 'C7',
        nom_du_site: 'Jardin des Plantes',
        location: [47.2198481, -1.5425883],
        genre: 'Sedum',
        date_plantation: '2013',
        cultivar: 'subsp.pruinosum R.T.Clausen & C.H.Uhl',
        famille: 'Crassulaceae',
      },
      geometry: { type: 'Point', coordinates: [-1.5425883, 47.2198481] },
      record_timestamp: '2019-12-06T15:32:35.140000+00:00',
    },
  ],
  facet_groups: [
    {
      facets: [
        { count: 306, path: 'Camellia', state: 'displayed', name: 'Camellia' },
        { count: 297, path: 'Magnolia', state: 'displayed', name: 'Magnolia' },
        { count: 114, path: 'Acer', state: 'displayed', name: 'Acer' },
        { count: 90, path: 'Cornus', state: 'displayed', name: 'Cornus' },
        { count: 81, path: 'Quercus', state: 'displayed', name: 'Quercus' },
        { count: 81, path: 'Viburnum', state: 'displayed', name: 'Viburnum' },
        { count: 76, path: 'Spiraea', state: 'displayed', name: 'Spiraea' },
        { count: 47, path: 'Prunus', state: 'displayed', name: 'Prunus' },
        { count: 38, path: 'Iris', state: 'displayed', name: 'Iris' },
        { count: 36, path: 'Dianthus', state: 'displayed', name: 'Dianthus' },
        { count: 35, path: 'Aesculus', state: 'displayed', name: 'Aesculus' },
        { count: 34, path: 'Fagus', state: 'displayed', name: 'Fagus' },
        { count: 34, path: 'Sedum', state: 'displayed', name: 'Sedum' },
        { count: 33, path: 'Silene', state: 'displayed', name: 'Silene' },
        { count: 30, path: 'Allium', state: 'displayed', name: 'Allium' },
        { count: 27, path: 'Campanula', state: 'displayed', name: 'Campanula' },
        {
          count: 26,
          path: 'Philadelphus',
          state: 'displayed',
          name: 'Philadelphus',
        },
        { count: 24, path: 'Fraxinus', state: 'displayed', name: 'Fraxinus' },
        { count: 24, path: 'Osmanthus', state: 'displayed', name: 'Osmanthus' },
        { count: 23, path: 'Euonymus', state: 'displayed', name: 'Euonymus' },
        {
          count: 23,
          path: 'Liriodendron',
          state: 'displayed',
          name: 'Liriodendron',
        },
        { count: 19, path: 'Arbutus', state: 'displayed', name: 'Arbutus' },
        { count: 19, path: 'Betula', state: 'displayed', name: 'Betula' },
        { count: 19, path: 'Lonicera', state: 'displayed', name: 'Lonicera' },
        {
          count: 19,
          path: 'Rhododendron',
          state: 'displayed',
          name: 'Rhododendron',
        },
        { count: 18, path: 'Aquilegia', state: 'displayed', name: 'Aquilegia' },
        { count: 18, path: 'Ilex', state: 'displayed', name: 'Ilex' },
        { count: 17, path: 'Digitalis', state: 'displayed', name: 'Digitalis' },
        { count: 17, path: 'Hamamelis', state: 'displayed', name: 'Hamamelis' },
        { count: 17, path: 'Tilia', state: 'displayed', name: 'Tilia' },
        { count: 17, path: 'Zelkova', state: 'displayed', name: 'Zelkova' },
        { count: 16, path: 'Malus', state: 'displayed', name: 'Malus' },
        {
          count: 16,
          path: 'Thalictrum',
          state: 'displayed',
          name: 'Thalictrum',
        },
        { count: 15, path: 'Gleditsia', state: 'displayed', name: 'Gleditsia' },
        { count: 14, path: 'Geranium', state: 'displayed', name: 'Geranium' },
        { count: 14, path: 'Narcissus', state: 'displayed', name: 'Narcissus' },
        { count: 14, path: 'Paeonia', state: 'displayed', name: 'Paeonia' },
        { count: 14, path: 'Parrotia', state: 'displayed', name: 'Parrotia' },
        { count: 14, path: 'Rhamnus', state: 'displayed', name: 'Rhamnus' },
        { count: 14, path: 'Salvia', state: 'displayed', name: 'Salvia' },
        { count: 13, path: 'Buddleja', state: 'displayed', name: 'Buddleja' },
        { count: 13, path: 'Scilla', state: 'displayed', name: 'Scilla' },
        { count: 12, path: 'Acaena', state: 'displayed', name: 'Acaena' },
        { count: 12, path: 'Carpinus', state: 'displayed', name: 'Carpinus' },
        { count: 12, path: 'Centaurea', state: 'displayed', name: 'Centaurea' },
        { count: 12, path: 'Corylus', state: 'displayed', name: 'Corylus' },
        { count: 12, path: 'Diospyros', state: 'displayed', name: 'Diospyros' },
        { count: 12, path: 'Eryngium', state: 'displayed', name: 'Eryngium' },
        { count: 12, path: 'Geum', state: 'displayed', name: 'Geum' },
        { count: 12, path: 'Ligustrum', state: 'displayed', name: 'Ligustrum' },
        { count: 12, path: 'Muscari', state: 'displayed', name: 'Muscari' },
        { count: 11, path: 'Abelia', state: 'displayed', name: 'Abelia' },
        { count: 11, path: 'Arisaema', state: 'displayed', name: 'Arisaema' },
        { count: 11, path: 'Carex', state: 'displayed', name: 'Carex' },
        { count: 11, path: 'Deutzia', state: 'displayed', name: 'Deutzia' },
        { count: 11, path: 'Ginkgo', state: 'displayed', name: 'Ginkgo' },
        {
          count: 11,
          path: 'Liquidambar',
          state: 'displayed',
          name: 'Liquidambar',
        },
        { count: 11, path: 'Pinus', state: 'displayed', name: 'Pinus' },
        { count: 10, path: 'Amsonia', state: 'displayed', name: 'Amsonia' },
        { count: 10, path: 'Aster', state: 'displayed', name: 'Aster' },
        { count: 10, path: 'Firmiana', state: 'displayed', name: 'Firmiana' },
        { count: 10, path: 'Gentiana', state: 'displayed', name: 'Gentiana' },
        { count: 10, path: 'Hieracium', state: 'displayed', name: 'Hieracium' },
        { count: 10, path: 'Hovenia', state: 'displayed', name: 'Hovenia' },
        { count: 10, path: 'Illicium', state: 'displayed', name: 'Illicium' },
        { count: 10, path: 'Minuartia', state: 'displayed', name: 'Minuartia' },
        {
          count: 10,
          path: 'Potentilla',
          state: 'displayed',
          name: 'Potentilla',
        },
        { count: 10, path: 'Punica', state: 'displayed', name: 'Punica' },
        {
          count: 10,
          path: 'Sisyrinchium',
          state: 'displayed',
          name: 'Sisyrinchium',
        },
        { count: 10, path: 'Solidago', state: 'displayed', name: 'Solidago' },
        { count: 9, path: 'Anemone', state: 'displayed', name: 'Anemone' },
        { count: 9, path: 'Azara', state: 'displayed', name: 'Azara' },
        {
          count: 9,
          path: 'Callicarpa',
          state: 'displayed',
          name: 'Callicarpa',
        },
        {
          count: 9,
          path: 'Chaenomeles',
          state: 'displayed',
          name: 'Chaenomeles',
        },
        {
          count: 9,
          path: 'Chimonanthus',
          state: 'displayed',
          name: 'Chimonanthus',
        },
        { count: 9, path: 'Cotinus', state: 'displayed', name: 'Cotinus' },
        { count: 9, path: 'Euphorbia', state: 'displayed', name: 'Euphorbia' },
        {
          count: 9,
          path: 'Gypsophila',
          state: 'displayed',
          name: 'Gypsophila',
        },
        { count: 9, path: 'Kniphofia', state: 'displayed', name: 'Kniphofia' },
        { count: 9, path: 'Photinia', state: 'displayed', name: 'Photinia' },
        {
          count: 9,
          path: 'Pittosporum',
          state: 'displayed',
          name: 'Pittosporum',
        },
        { count: 8, path: 'Achillea', state: 'displayed', name: 'Achillea' },
        { count: 8, path: 'Arabis', state: 'displayed', name: 'Arabis' },
        { count: 8, path: 'Ceanothus', state: 'displayed', name: 'Ceanothus' },
        {
          count: 8,
          path: 'Cercidiphyllum',
          state: 'displayed',
          name: 'Cercidiphyllum',
        },
        { count: 8, path: 'Cercis', state: 'displayed', name: 'Cercis' },
        {
          count: 8,
          path: 'Cladrastis',
          state: 'displayed',
          name: 'Cladrastis',
        },
        { count: 8, path: 'Crocus', state: 'displayed', name: 'Crocus' },
        { count: 8, path: 'Daphne', state: 'displayed', name: 'Daphne' },
        {
          count: 8,
          path: 'Globularia',
          state: 'displayed',
          name: 'Globularia',
        },
        {
          count: 8,
          path: 'Koelreuteria',
          state: 'displayed',
          name: 'Koelreuteria',
        },
        { count: 8, path: 'Lilium', state: 'displayed', name: 'Lilium' },
        { count: 8, path: 'Maclura', state: 'displayed', name: 'Maclura' },
        { count: 8, path: 'Onosma', state: 'displayed', name: 'Onosma' },
        {
          count: 8,
          path: 'Physocarpus',
          state: 'displayed',
          name: 'Physocarpus',
        },
        { count: 8, path: 'Primula', state: 'displayed', name: 'Primula' },
        { count: 8, path: 'Ribes', state: 'displayed', name: 'Ribes' },
        { count: 8, path: 'Ulmus', state: 'displayed', name: 'Ulmus' },
        {
          count: 8,
          path: 'Zanthoxylum',
          state: 'displayed',
          name: 'Zanthoxylum',
        },
        { count: 7, path: 'Aralia', state: 'displayed', name: 'Aralia' },
      ],
      name: 'genre',
    },
    {
      facets: [
        {
          count: 1867,
          path: 'Jardin des Plantes',
          state: 'displayed',
          name: 'Jardin des Plantes',
        },
        {
          count: 1264,
          path: 'Arboretum Cimeti\u00e8re Parc',
          state: 'displayed',
          name: 'Arboretum Cimeti\u00e8re Parc',
        },
        {
          count: 341,
          path: 'Parc floral de la Beaujoire',
          state: 'displayed',
          name: 'Parc floral de la Beaujoire',
        },
        {
          count: 180,
          path: 'Parc de Proc\u00e9',
          state: 'displayed',
          name: 'Parc de Proc\u00e9',
        },
        {
          count: 116,
          path: 'Parc exotique du Grand-Blottereau',
          state: 'displayed',
          name: 'Parc exotique du Grand-Blottereau',
        },
        {
          count: 81,
          path: "Jardin d'agronomie tropicale du Grand-Blottereau",
          state: 'displayed',
          name: "Jardin d'agronomie tropicale du Grand-Blottereau",
        },
        {
          count: 51,
          path: 'Autre site',
          state: 'displayed',
          name: 'Autre site',
        },
        {
          count: 12,
          path: 'Parc de la Gaudini\u00e8re',
          state: 'displayed',
          name: 'Parc de la Gaudini\u00e8re',
        },
        {
          count: 8,
          path: 'Foyer des Anciens',
          state: 'displayed',
          name: 'Foyer des Anciens',
        },
        {
          count: 3,
          path: 'Cimeti\u00e8re de la Bouteillerie',
          state: 'displayed',
          name: 'Cimeti\u00e8re de la Bouteillerie',
        },
      ],
      name: 'nom_du_site',
    },
    {
      facets: [
        { count: 221, path: 'japonica', state: 'displayed', name: 'japonica' },
        { count: 36, path: 'sasanqua', state: 'displayed', name: 'sasanqua' },
        {
          count: 29,
          path: 'x soulangeana',
          state: 'displayed',
          name: 'x soulangeana',
        },
        { count: 24, path: 'stellata', state: 'displayed', name: 'stellata' },
        { count: 23, path: 'sylvatica', state: 'displayed', name: 'sylvatica' },
        { count: 21, path: 'sinensis', state: 'displayed', name: 'sinensis' },
        {
          count: 20,
          path: 'tulipifera',
          state: 'displayed',
          name: 'tulipifera',
        },
        { count: 18, path: 'kousa', state: 'displayed', name: 'kousa' },
        { count: 17, path: 'serrata', state: 'displayed', name: 'serrata' },
        {
          count: 17,
          path: 'x williamsii',
          state: 'displayed',
          name: 'x williamsii',
        },
        {
          count: 15,
          path: 'grandiflora',
          state: 'displayed',
          name: 'grandiflora',
        },
        { count: 15, path: 'japonicum', state: 'displayed', name: 'japonicum' },
        {
          count: 15,
          path: 'salicifolia',
          state: 'displayed',
          name: 'salicifolia',
        },
        { count: 14, path: 'sp.', state: 'displayed', name: 'sp.' },
        {
          count: 14,
          path: 'x loebneri',
          state: 'displayed',
          name: 'x loebneri',
        },
        {
          count: 13,
          path: 'californica',
          state: 'displayed',
          name: 'californica',
        },
        { count: 13, path: 'latifolia', state: 'displayed', name: 'latifolia' },
        { count: 13, path: 'palmatum', state: 'displayed', name: 'palmatum' },
        {
          count: 13,
          path: 'platanoides',
          state: 'displayed',
          name: 'platanoides',
        },
        { count: 12, path: 'acuminata', state: 'displayed', name: 'acuminata' },
        {
          count: 12,
          path: 'angustifolia',
          state: 'displayed',
          name: 'angustifolia',
        },
        { count: 11, path: 'biloba', state: 'displayed', name: 'biloba' },
        {
          count: 11,
          path: 'hippocastanum',
          state: 'displayed',
          name: 'hippocastanum',
        },
        {
          count: 11,
          path: 'saccharinum',
          state: 'displayed',
          name: 'saccharinum',
        },
        { count: 10, path: 'henryi', state: 'displayed', name: 'henryi' },
        { count: 10, path: 'nigra', state: 'displayed', name: 'nigra' },
        { count: 10, path: 'simplex', state: 'displayed', name: 'simplex' },
        { count: 9, path: 'dulcis', state: 'displayed', name: 'dulcis' },
        { count: 9, path: 'excelsior', state: 'displayed', name: 'excelsior' },
        { count: 9, path: 'japonicus', state: 'displayed', name: 'japonicus' },
        {
          count: 9,
          path: 'occidentalis',
          state: 'displayed',
          name: 'occidentalis',
        },
        { count: 9, path: 'robur', state: 'displayed', name: 'robur' },
        { count: 9, path: 'rubra', state: 'displayed', name: 'rubra' },
        {
          count: 9,
          path: 'triacanthos',
          state: 'displayed',
          name: 'triacanthos',
        },
        {
          count: 9,
          path: 'virginiana',
          state: 'displayed',
          name: 'virginiana',
        },
        {
          count: 9,
          path: 'x andrachnoides',
          state: 'displayed',
          name: 'x andrachnoides',
        },
        {
          count: 9,
          path: 'x burkwoodii',
          state: 'displayed',
          name: 'x burkwoodii',
        },
        { count: 8, path: 'chinensis', state: 'displayed', name: 'chinensis' },
        {
          count: 8,
          path: 'chrysantha',
          state: 'displayed',
          name: 'chrysantha',
        },
        {
          count: 8,
          path: 'controversa',
          state: 'displayed',
          name: 'controversa',
        },
        { count: 8, path: 'florida', state: 'displayed', name: 'florida' },
        { count: 8, path: 'granatum', state: 'displayed', name: 'granatum' },
        { count: 8, path: 'incisa', state: 'displayed', name: 'incisa' },
        { count: 8, path: 'kentukea', state: 'displayed', name: 'kentukea' },
        { count: 8, path: 'lutea L.', state: 'displayed', name: 'lutea L.' },
        {
          count: 8,
          path: 'macrophylla',
          state: 'displayed',
          name: 'macrophylla',
        },
        { count: 8, path: 'mas', state: 'displayed', name: 'mas' },
        { count: 8, path: 'persica', state: 'displayed', name: 'persica' },
        { count: 8, path: 'praecox', state: 'displayed', name: 'praecox' },
        {
          count: 8,
          path: 'pseudoplatanus',
          state: 'displayed',
          name: 'pseudoplatanus',
        },
        {
          count: 8,
          path: 'thunbergii',
          state: 'displayed',
          name: 'thunbergii',
        },
        { count: 8, path: 'tomentosa', state: 'displayed', name: 'tomentosa' },
        {
          count: 8,
          path: 'yunnanensis',
          state: 'displayed',
          name: 'yunnanensis',
        },
        { count: 7, path: 'alba', state: 'displayed', name: 'alba' },
        {
          count: 7,
          path: 'alternifolia',
          state: 'displayed',
          name: 'alternifolia',
        },
        {
          count: 7,
          path: 'carpinifolia',
          state: 'displayed',
          name: 'carpinifolia',
        },
        { count: 7, path: 'coggygria', state: 'displayed', name: 'coggygria' },
        { count: 7, path: 'distichum', state: 'displayed', name: 'distichum' },
        { count: 7, path: 'domestica', state: 'displayed', name: 'domestica' },
        { count: 7, path: 'elliptica', state: 'displayed', name: 'elliptica' },
        { count: 7, path: 'hiemalis', state: 'displayed', name: 'hiemalis' },
        { count: 7, path: 'mume', state: 'displayed', name: 'mume' },
        {
          count: 7,
          path: 'myrsinifolia',
          state: 'displayed',
          name: 'myrsinifolia',
        },
        { count: 7, path: 'opulus', state: 'displayed', name: 'opulus' },
        { count: 7, path: 'speciosa', state: 'displayed', name: 'speciosa' },
        { count: 6, path: 'anisatum', state: 'displayed', name: 'anisatum' },
        { count: 6, path: 'avellana', state: 'displayed', name: 'avellana' },
        {
          count: 6,
          path: 'campbellii',
          state: 'displayed',
          name: 'campbellii',
        },
        {
          count: 6,
          path: 'engleriana',
          state: 'displayed',
          name: 'engleriana',
        },
        {
          count: 6,
          path: 'heterophyllus',
          state: 'displayed',
          name: 'heterophyllus',
        },
        { count: 6, path: 'indica', state: 'displayed', name: 'indica' },
        {
          count: 6,
          path: 'montana L.',
          state: 'displayed',
          name: 'montana L.',
        },
        {
          count: 6,
          path: 'opulifolius',
          state: 'displayed',
          name: 'opulifolius',
        },
        {
          count: 6,
          path: 'orientalis',
          state: 'displayed',
          name: 'orientalis',
        },
        { count: 6, path: 'pomifera', state: 'displayed', name: 'pomifera' },
        {
          count: 6,
          path: 'saxifraga L.',
          state: 'displayed',
          name: 'saxifraga L.',
        },
        {
          count: 6,
          path: 'septemlobus',
          state: 'displayed',
          name: 'septemlobus',
        },
        { count: 6, path: 'sericea', state: 'displayed', name: 'sericea' },
        { count: 6, path: 'sieboldii', state: 'displayed', name: 'sieboldii' },
        {
          count: 6,
          path: 'trifoliata',
          state: 'displayed',
          name: 'trifoliata',
        },
        {
          count: 6,
          path: 'x prunifolia',
          state: 'displayed',
          name: 'x prunifolia',
        },
        { count: 5, path: 'albidum', state: 'displayed', name: 'albidum' },
        { count: 5, path: 'alpina L.', state: 'displayed', name: 'alpina L.' },
        {
          count: 5,
          path: 'alpinus L.',
          state: 'displayed',
          name: 'alpinus L.',
        },
        { count: 5, path: 'americana', state: 'displayed', name: 'americana' },
        { count: 5, path: 'apiculata', state: 'displayed', name: 'apiculata' },
        { count: 5, path: 'azedarach', state: 'displayed', name: 'azedarach' },
        { count: 5, path: 'betulus', state: 'displayed', name: 'betulus' },
        {
          count: 5,
          path: 'buergerianum',
          state: 'displayed',
          name: 'buergerianum',
        },
        {
          count: 5,
          path: 'cantoniensis',
          state: 'displayed',
          name: 'cantoniensis',
        },
        { count: 5, path: 'capitata', state: 'displayed', name: 'capitata' },
        { count: 5, path: 'cordata', state: 'displayed', name: 'cordata' },
        { count: 5, path: 'daniellii', state: 'displayed', name: 'daniellii' },
        { count: 5, path: 'davidii', state: 'displayed', name: 'davidii' },
        { count: 5, path: 'delavayi', state: 'displayed', name: 'delavayi' },
        {
          count: 5,
          path: 'florida f. rubra',
          state: 'displayed',
          name: 'florida f. rubra',
        },
        { count: 5, path: 'frainetto', state: 'displayed', name: 'frainetto' },
        {
          count: 5,
          path: 'laevifolia',
          state: 'displayed',
          name: 'laevifolia',
        },
        {
          count: 5,
          path: 'microphylla',
          state: 'displayed',
          name: 'microphylla',
        },
        { count: 5, path: 'mongolica', state: 'displayed', name: 'mongolica' },
      ],
      name: 'espece',
    },
    {
      facets: [
        {
          count: 320,
          path: 'Magnoliaceae',
          state: 'displayed',
          name: 'Magnoliaceae',
        },
        { count: 309, path: 'Theaceae', state: 'displayed', name: 'Theaceae' },
        { count: 281, path: 'Rosaceae', state: 'displayed', name: 'Rosaceae' },
        {
          count: 160,
          path: 'Asteraceae',
          state: 'displayed',
          name: 'Asteraceae',
        },
        {
          count: 160,
          path: 'Sapindaceae',
          state: 'displayed',
          name: 'Sapindaceae',
        },
        { count: 122, path: 'Fagaceae', state: 'displayed', name: 'Fagaceae' },
        {
          count: 112,
          path: 'Caryophyllaceae',
          state: 'displayed',
          name: 'Caryophyllaceae',
        },
        {
          count: 105,
          path: 'Lamiaceae',
          state: 'displayed',
          name: 'Lamiaceae',
        },
        {
          count: 95,
          path: 'Asparagaceae',
          state: 'displayed',
          name: 'Asparagaceae',
        },
        { count: 92, path: 'Cornaceae', state: 'displayed', name: 'Cornaceae' },
        { count: 91, path: 'Oleaceae', state: 'displayed', name: 'Oleaceae' },
        { count: 83, path: 'Adoxaceae', state: 'displayed', name: 'Adoxaceae' },
        {
          count: 77,
          path: 'Ranunculaceae',
          state: 'displayed',
          name: 'Ranunculaceae',
        },
        { count: 74, path: 'Iridaceae', state: 'displayed', name: 'Iridaceae' },
        {
          count: 64,
          path: 'Caprifoliaceae',
          state: 'displayed',
          name: 'Caprifoliaceae',
        },
        {
          count: 62,
          path: 'Hamamelidaceae',
          state: 'displayed',
          name: 'Hamamelidaceae',
        },
        {
          count: 57,
          path: 'Amaryllidaceae',
          state: 'displayed',
          name: 'Amaryllidaceae',
        },
        { count: 55, path: 'Ericaceae', state: 'displayed', name: 'Ericaceae' },
        { count: 55, path: 'Fabaceae', state: 'displayed', name: 'Fabaceae' },
        {
          count: 53,
          path: 'Hydrangeaceae',
          state: 'displayed',
          name: 'Hydrangeaceae',
        },
        {
          count: 51,
          path: 'Betulaceae',
          state: 'displayed',
          name: 'Betulaceae',
        },
        { count: 49, path: 'Malvaceae', state: 'displayed', name: 'Malvaceae' },
        {
          count: 49,
          path: 'Rhamnaceae',
          state: 'displayed',
          name: 'Rhamnaceae',
        },
        {
          count: 48,
          path: 'Plantaginaceae',
          state: 'displayed',
          name: 'Plantaginaceae',
        },
        { count: 47, path: 'Rutaceae', state: 'displayed', name: 'Rutaceae' },
        { count: 42, path: 'Apiaceae', state: 'displayed', name: 'Apiaceae' },
        {
          count: 42,
          path: 'Campanulaceae',
          state: 'displayed',
          name: 'Campanulaceae',
        },
        {
          count: 42,
          path: 'Crassulaceae',
          state: 'displayed',
          name: 'Crassulaceae',
        },
        {
          count: 38,
          path: 'Asphodelaceae',
          state: 'displayed',
          name: 'Asphodelaceae',
        },
        {
          count: 33,
          path: 'Brassicaceae',
          state: 'displayed',
          name: 'Brassicaceae',
        },
        { count: 28, path: 'Poaceae', state: 'displayed', name: 'Poaceae' },
        {
          count: 26,
          path: 'Saxifragaceae',
          state: 'displayed',
          name: 'Saxifragaceae',
        },
        {
          count: 25,
          path: 'Celastraceae',
          state: 'displayed',
          name: 'Celastraceae',
        },
        {
          count: 25,
          path: 'Salicaceae',
          state: 'displayed',
          name: 'Salicaceae',
        },
        { count: 25, path: 'Ulmaceae', state: 'displayed', name: 'Ulmaceae' },
        {
          count: 24,
          path: 'Apocynaceae',
          state: 'displayed',
          name: 'Apocynaceae',
        },
        {
          count: 23,
          path: 'Araliaceae',
          state: 'displayed',
          name: 'Araliaceae',
        },
        {
          count: 23,
          path: 'Caesalpiniaceae',
          state: 'displayed',
          name: 'Caesalpiniaceae',
        },
        { count: 23, path: 'Lauraceae', state: 'displayed', name: 'Lauraceae' },
        {
          count: 22,
          path: 'Lythraceae',
          state: 'displayed',
          name: 'Lythraceae',
        },
        {
          count: 21,
          path: 'Berberidaceae',
          state: 'displayed',
          name: 'Berberidaceae',
        },
        {
          count: 21,
          path: 'Papilionaceae',
          state: 'displayed',
          name: 'Papilionaceae',
        },
        {
          count: 20,
          path: 'Anacardiaceae',
          state: 'displayed',
          name: 'Anacardiaceae',
        },
        {
          count: 20,
          path: 'Scrophulariaceae',
          state: 'displayed',
          name: 'Scrophulariaceae',
        },
        { count: 19, path: 'Myrtaceae', state: 'displayed', name: 'Myrtaceae' },
        {
          count: 18,
          path: 'Aquifoliaceae',
          state: 'displayed',
          name: 'Aquifoliaceae',
        },
        { count: 18, path: 'Liliaceae', state: 'displayed', name: 'Liliaceae' },
        { count: 18, path: 'Moraceae', state: 'displayed', name: 'Moraceae' },
        { count: 18, path: 'Pinaceae', state: 'displayed', name: 'Pinaceae' },
        {
          count: 18,
          path: 'Primulaceae',
          state: 'displayed',
          name: 'Primulaceae',
        },
        {
          count: 17,
          path: 'Boraginaceae',
          state: 'displayed',
          name: 'Boraginaceae',
        },
        {
          count: 17,
          path: 'Euphorbiaceae',
          state: 'displayed',
          name: 'Euphorbiaceae',
        },
        {
          count: 17,
          path: 'Geraniaceae',
          state: 'displayed',
          name: 'Geraniaceae',
        },
        {
          count: 17,
          path: 'Styracaceae',
          state: 'displayed',
          name: 'Styracaceae',
        },
        { count: 16, path: 'Buxaceae', state: 'displayed', name: 'Buxaceae' },
        {
          count: 16,
          path: 'Cupressaceae',
          state: 'displayed',
          name: 'Cupressaceae',
        },
        {
          count: 16,
          path: 'Plumbaginaceae',
          state: 'displayed',
          name: 'Plumbaginaceae',
        },
        {
          count: 15,
          path: 'Bignoniaceae',
          state: 'displayed',
          name: 'Bignoniaceae',
        },
        {
          count: 15,
          path: 'Calycanthaceae',
          state: 'displayed',
          name: 'Calycanthaceae',
        },
        {
          count: 15,
          path: 'Cyperaceae',
          state: 'displayed',
          name: 'Cyperaceae',
        },
        {
          count: 15,
          path: 'Thymelaeaceae',
          state: 'displayed',
          name: 'Thymelaeaceae',
        },
        { count: 14, path: 'Araceae', state: 'displayed', name: 'Araceae' },
        {
          count: 14,
          path: 'Juglandaceae',
          state: 'displayed',
          name: 'Juglandaceae',
        },
        {
          count: 14,
          path: 'Paeoniaceae',
          state: 'displayed',
          name: 'Paeoniaceae',
        },
        { count: 12, path: 'Ebenaceae', state: 'displayed', name: 'Ebenaceae' },
        {
          count: 12,
          path: 'Solanaceae',
          state: 'displayed',
          name: 'Solanaceae',
        },
        {
          count: 11,
          path: 'Altingiaceae',
          state: 'displayed',
          name: 'Altingiaceae',
        },
        {
          count: 11,
          path: 'Gentianaceae',
          state: 'displayed',
          name: 'Gentianaceae',
        },
        {
          count: 11,
          path: 'Ginkgoaceae',
          state: 'displayed',
          name: 'Ginkgoaceae',
        },
        { count: 11, path: 'Meliaceae', state: 'displayed', name: 'Meliaceae' },
        { count: 11, path: 'Nyssaceae', state: 'displayed', name: 'Nyssaceae' },
        {
          count: 11,
          path: 'Pentaphylacaceae',
          state: 'displayed',
          name: 'Pentaphylacaceae',
        },
        { count: 11, path: 'Rubiaceae', state: 'displayed', name: 'Rubiaceae' },
        { count: 10, path: 'Cistaceae', state: 'displayed', name: 'Cistaceae' },
        {
          count: 10,
          path: 'Onagraceae',
          state: 'displayed',
          name: 'Onagraceae',
        },
        {
          count: 10,
          path: 'Schisandraceae',
          state: 'displayed',
          name: 'Schisandraceae',
        },
        {
          count: 9,
          path: 'Pittosporaceae',
          state: 'displayed',
          name: 'Pittosporaceae',
        },
        {
          count: 9,
          path: 'Polygonaceae',
          state: 'displayed',
          name: 'Polygonaceae',
        },
        {
          count: 8,
          path: 'Cercidiphyllaceae',
          state: 'displayed',
          name: 'Cercidiphyllaceae',
        },
        {
          count: 8,
          path: 'Dryopteridaceae',
          state: 'displayed',
          name: 'Dryopteridaceae',
        },
        {
          count: 8,
          path: 'Grossulariaceae',
          state: 'displayed',
          name: 'Grossulariaceae',
        },
        { count: 7, path: 'Arecaceae', state: 'displayed', name: 'Arecaceae' },
        {
          count: 7,
          path: 'Clethraceae',
          state: 'displayed',
          name: 'Clethraceae',
        },
        {
          count: 7,
          path: 'Escalloniaceae',
          state: 'displayed',
          name: 'Escalloniaceae',
        },
        {
          count: 7,
          path: 'Papaveraceae',
          state: 'displayed',
          name: 'Papaveraceae',
        },
        {
          count: 7,
          path: 'Paulowniaceae',
          state: 'displayed',
          name: 'Paulowniaceae',
        },
        { count: 7, path: 'Violaceae', state: 'displayed', name: 'Violaceae' },
        { count: 7, path: 'Vitaceae', state: 'displayed', name: 'Vitaceae' },
        {
          count: 6,
          path: 'Annonaceae',
          state: 'displayed',
          name: 'Annonaceae',
        },
        {
          count: 6,
          path: 'Garryaceae',
          state: 'displayed',
          name: 'Garryaceae',
        },
        {
          count: 6,
          path: 'Hypericaceae',
          state: 'displayed',
          name: 'Hypericaceae',
        },
        { count: 6, path: 'Juncaceae', state: 'displayed', name: 'Juncaceae' },
        {
          count: 6,
          path: 'Nothofagaceae',
          state: 'displayed',
          name: 'Nothofagaceae',
        },
        {
          count: 6,
          path: 'Podocarpaceae',
          state: 'displayed',
          name: 'Podocarpaceae',
        },
        {
          count: 6,
          path: 'Proteaceae',
          state: 'displayed',
          name: 'Proteaceae',
        },
        {
          count: 5,
          path: 'Cannabaceae',
          state: 'displayed',
          name: 'Cannabaceae',
        },
        {
          count: 5,
          path: 'Elaeagnaceae',
          state: 'displayed',
          name: 'Elaeagnaceae',
        },
        {
          count: 5,
          path: 'Platanaceae',
          state: 'displayed',
          name: 'Platanaceae',
        },
        {
          count: 5,
          path: 'Polemoniaceae',
          state: 'displayed',
          name: 'Polemoniaceae',
        },
        {
          count: 5,
          path: 'Sapotaceae',
          state: 'displayed',
          name: 'Sapotaceae',
        },
      ],
      name: 'famille',
    },
  ],
};
